webpackJsonp([3],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = formattedLabelToSeconds;
/* harmony export (immutable) */ __webpack_exports__["e"] = secondsToFormattedLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = secondsToFormattedLabel2;
/* harmony export (immutable) */ __webpack_exports__["b"] = differenceFormattedAsDurationLabel;
/* unused harmony export toDateTimeString */
/* harmony export (immutable) */ __webpack_exports__["a"] = adjustBroadcastDatesForCrossingMidnight;
/* harmony export (immutable) */ __webpack_exports__["g"] = unreplaceDateTokens;
/* harmony export (immutable) */ __webpack_exports__["d"] = getDatesForClonedBroadcast;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
 // Given a time label (01:12:30), turn it into seconds

function formattedLabelToSeconds(label) {
  var parts = (label || '').split(':');

  if (parts.length == 1) {
    return parseInt(parts[0], 10);
  } else if (parts.length == 2) {
    return 60 * parseInt(parts[0], 10) + parseInt(parts[1], 10);
  } else if (parts.length == 3) {
    return 3600 * parseInt(parts[0], 10) + 60 * parseInt(parts[1], 10) + parseInt(parts[2], 10);
  } else {
    return undefined;
  }
} // Generate a nice time label from the given amount of seconds (H:mm:ss)

function secondsToFormattedLabel(seconds) {
  var showSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var showHoursIfZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var ss = _.padLeft(parseInt(Math.round(seconds % 60)).toString(), 2, '0');

  if (ss == '60') {
    ss = '59'; //rounding above, but 59.75 should not be displayed as 60.
  }

  var mins = seconds / 60 || 0;

  var mm = _.padLeft(parseInt(Math.floor(mins % 60)).toString(), 2, '0');

  var h = parseInt(Math.floor(mins / 60)).toString();
  var hStr = h > 0 || showHoursIfZero ? "".concat(h, ":") : '';

  if (showSeconds) {
    return "".concat(hStr).concat(mm, ":").concat(ss);
  } else {
    return "".concat(hStr).concat(mm);
  }
} // Generate a nice time label from the given amount of seconds in the format XdXhXmXs

function secondsToFormattedLabel2(s) {
  var totalSeconds = parseInt(Math.round(s || 0));
  var secondsPart = totalSeconds % 60;
  var totalMinutes = (totalSeconds - secondsPart) / 60;
  var minutesPart = totalMinutes % 60;
  var totalHours = (totalMinutes - minutesPart) / 60;
  var hoursPart = totalHours % 24;
  var daysPart = (totalHours - hoursPart) / 24;
  var secondsString = '';
  var minutesString = '';
  var hoursString = '';
  var daysString = '';

  if (daysPart == 0) {
    if (hoursPart == 0) {
      if (minutesPart == 0) {
        secondsString = "".concat(secondsPart.toString(), "s");
      } else {
        minutesString = "".concat(minutesPart.toString(), "m");
        secondsString = "".concat(secondsPart.toString(), "s");
      }
    } else {
      hoursString = "".concat(hoursPart.toString(), "h");
      minutesString = "".concat(minutesPart.toString(), "m");
      secondsString = "".concat(secondsPart.toString(), "s");
    }
  } else {
    daysString = "".concat(daysPart.toString(), "d");
    hoursString = "".concat(hoursPart.toString(), "h");
    minutesString = "".concat(minutesPart.toString(), "m");
    secondsString = "".concat(secondsPart.toString(), "s");
  }

  return "".concat(daysString).concat(hoursString).concat(minutesString).concat(secondsString);
} // Generate a nice duration label from the difference between the two dates

function differenceFormattedAsDurationLabel(start, end) {
  var showSeconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  end = !end || __WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(end) ? end : __WEBPACK_IMPORTED_MODULE_0_moment___default()(end);

  if (!end || end.year() >= 9999) {
    return ''; // XXX: Some broadcasts (specifically, simulated live) do not have an end time
  }

  var durationSecs = __WEBPACK_IMPORTED_MODULE_0_moment___default()(end).diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(start)) / 1000;

  if (durationSecs < 0) {
    return ''; // XXX: some broadcasts have a stops_at before starts_at
  }

  return secondsToFormattedLabel(durationSecs, showSeconds);
} // Use the date part of the given date object and the time part of the given time object
// and return a ISO 8601 formatted date/time in UTC.

function toDateTimeString(date, time) {
  var dateStr = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD');
  var timeStr = __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('HH:mm:00');
  var combined = __WEBPACK_IMPORTED_MODULE_0_moment___default()("".concat(dateStr, " ").concat(timeStr));
  return combined.toISOString(true);
} // Given a start date and start/end time objects, make sure they all
// line up with business rules around crossing midnight. Return a
// valid starts_at and stops_at string.

function adjustBroadcastDatesForCrossingMidnight(startDate, startTime, endTime, maxBroadcastDurationHours) {
  var endDate = startDate;

  if (!endTime) {
    endTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startTime).add(maxBroadcastDurationHours, 'hours').toDate();
  }

  if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(endTime).format('HH:mm') <= __WEBPACK_IMPORTED_MODULE_0_moment___default()(startTime).format('HH:mm')) {
    endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate).add(1, 'days');
  }

  return {
    startDate: startDate,
    startTime: startTime,
    endDate: endDate,
    endTime: endTime,
    starts_at: toDateTimeString(startDate, startTime),
    stops_at: toDateTimeString(endDate, endTime)
  };
} // Look for the nicely formatted version (localized) of the start date and
// replace with the string "[date]"

function unreplaceDateTokens(text, date) {
  var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).local();
  var regExpWithoutSpace = new RegExp(now.format('LL'), 'g');
  var month = now.format('MMMM');
  var dayOfMonth = now.format('D');
  var year = now.format('YYYY');
  var extraSpace = dayOfMonth.length < 2 ? ' ' : '';
  var regExpWithSpace = new RegExp("".concat(month, " ").concat(extraSpace).concat(dayOfMonth, ", ").concat(year), 'g');
  return text.replace(regExpWithoutSpace, '[date]').replace(regExpWithSpace, '[date]');
}
function getDatesForClonedBroadcast(broadcast, now) {
  var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.starts_at).clone();
  var stop = __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.stops_at).clone();
  var duration = stop.diff(start, 'minutes');

  if (broadcast.timeframe == 'future') {
    // If copying a future broadcast, keep broadcast.starts_at/stops_at from clone
    return {
      starts_at: broadcast.starts_at,
      stops_at: broadcast.stops_at
    };
  } else {
    // Otherwise, try to keep same start/stop time but advance the date to today
    // and always keep the same duration as the original broadcast.
    // If the start time has already elapsed for the day, bump the start to now.
    start.set({
      year: now.get('year'),
      month: now.get('month'),
      date: now.get('date')
    });

    if (start < now) {
      start = now;
    }

    stop = start.clone().add(duration, 'minutes');
    return {
      starts_at: start.format(),
      stops_at: stop.format()
    };
  }
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wire;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_ui_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_ui_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_ui_router__);
// Helper method to wire a simple top-level component. This will do the following:
//  1. Register as new angular module
//  2. Add simple UI router State
//  3. Return reference to angular module
//
// TODO: consider expansion to nontrivial use cases:
// (extra module deps, sub-router-states, ...)


function wire(moduleName, template, controller, controllerName) {
  var url = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  // Unless a custom URL is specified, use the module name
  if (url == null) {
    url = "/".concat(moduleName);
  }

  return __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module(moduleName, [__WEBPACK_IMPORTED_MODULE_1_angular_ui_router___default.a]).controller(controllerName, controller).config(function ($stateProvider) {
    'ngInject';

    $stateProvider.state(moduleName, {
      url: url,
      template: template,
      controller: controller,
      controllerAs: 'vm'
    });
  });
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateutil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(7);

/**
 * General date-related utilities.
 * Also handles several incompatibilities between JavaScript and Python
 *
 */
var dateutil;
(function (dateutil) {
    dateutil.MONTH_DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    /**
     * Number of milliseconds of one day
     */
    dateutil.ONE_DAY = 1000 * 60 * 60 * 24;
    /**
     * @see: <http://docs.python.org/library/datetime.html#datetime.MAXYEAR>
     */
    dateutil.MAXYEAR = 9999;
    /**
     * Python uses 1-Jan-1 as the base for calculating ordinals but we don't
     * want to confuse the JS engine with milliseconds > Number.MAX_NUMBER,
     * therefore we use 1-Jan-1970 instead
     */
    dateutil.ORDINAL_BASE = new Date(Date.UTC(1970, 0, 1));
    /**
     * Python: MO-SU: 0 - 6
     * JS: SU-SAT 0 - 6
     */
    dateutil.PY_WEEKDAYS = [6, 0, 1, 2, 3, 4, 5];
    /**
     * py_date.timetuple()[7]
     */
    dateutil.getYearDay = function (date) {
        var dateNoTime = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
        return (Math.ceil((dateNoTime.valueOf() -
            new Date(date.getUTCFullYear(), 0, 1).valueOf()) /
            dateutil.ONE_DAY) + 1);
    };
    dateutil.isLeapYear = function (year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    };
    dateutil.isDate = function (value) {
        return value instanceof Date;
    };
    dateutil.isValidDate = function (value) {
        return dateutil.isDate(value) && !isNaN(value.getTime());
    };
    /**
     * @return {Number} the date's timezone offset in ms
     */
    dateutil.tzOffset = function (date) {
        return date.getTimezoneOffset() * 60 * 1000;
    };
    /**
     * @see: <http://www.mcfedries.com/JavaScript/DaysBetween.asp>
     */
    dateutil.daysBetween = function (date1, date2) {
        // The number of milliseconds in one day
        // Convert both dates to milliseconds
        var date1ms = date1.getTime() - dateutil.tzOffset(date1);
        var date2ms = date2.getTime() - dateutil.tzOffset(date2);
        // Calculate the difference in milliseconds
        var differencems = date1ms - date2ms;
        // Convert back to days and return
        return Math.round(differencems / dateutil.ONE_DAY);
    };
    /**
     * @see: <http://docs.python.org/library/datetime.html#datetime.date.toordinal>
     */
    dateutil.toOrdinal = function (date) {
        return dateutil.daysBetween(date, dateutil.ORDINAL_BASE);
    };
    /**
     * @see - <http://docs.python.org/library/datetime.html#datetime.date.fromordinal>
     */
    dateutil.fromOrdinal = function (ordinal) {
        return new Date(dateutil.ORDINAL_BASE.getTime() + ordinal * dateutil.ONE_DAY);
    };
    dateutil.getMonthDays = function (date) {
        var month = date.getUTCMonth();
        return month === 1 && dateutil.isLeapYear(date.getUTCFullYear())
            ? 29
            : dateutil.MONTH_DAYS[month];
    };
    /**
     * @return {Number} python-like weekday
     */
    dateutil.getWeekday = function (date) {
        return dateutil.PY_WEEKDAYS[date.getUTCDay()];
    };
    /**
     * @see: <http://docs.python.org/library/calendar.html#calendar.monthrange>
     */
    dateutil.monthRange = function (year, month) {
        var date = new Date(Date.UTC(year, month, 1));
        return [dateutil.getWeekday(date), dateutil.getMonthDays(date)];
    };
    /**
     * @see: <http://docs.python.org/library/datetime.html#datetime.datetime.combine>
     */
    dateutil.combine = function (date, time) {
        time = time || date;
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds()));
    };
    dateutil.clone = function (date) {
        var dolly = new Date(date.getTime());
        return dolly;
    };
    dateutil.cloneDates = function (dates) {
        var clones = [];
        for (var i = 0; i < dates.length; i++) {
            clones.push(dateutil.clone(dates[i]));
        }
        return clones;
    };
    /**
     * Sorts an array of Date or dateutil.Time objects
     */
    dateutil.sort = function (dates) {
        dates.sort(function (a, b) {
            return a.getTime() - b.getTime();
        });
    };
    dateutil.timeToUntilString = function (time, utc) {
        if (utc === void 0) { utc = true; }
        var date = new Date(time);
        return [
            Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["i" /* padStart */])(date.getUTCFullYear().toString(), 4, '0'),
            Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["i" /* padStart */])(date.getUTCMonth() + 1, 2, '0'),
            Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["i" /* padStart */])(date.getUTCDate(), 2, '0'),
            'T',
            Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["i" /* padStart */])(date.getUTCHours(), 2, '0'),
            Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["i" /* padStart */])(date.getUTCMinutes(), 2, '0'),
            Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["i" /* padStart */])(date.getUTCSeconds(), 2, '0'),
            utc ? 'Z' : ''
        ].join('');
    };
    dateutil.untilStringToDate = function (until) {
        var re = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z?)?$/;
        var bits = re.exec(until);
        if (!bits)
            throw new Error("Invalid UNTIL value: " + until);
        return new Date(Date.UTC(parseInt(bits[1], 10), parseInt(bits[2], 10) - 1, parseInt(bits[3], 10), parseInt(bits[5], 10) || 0, parseInt(bits[6], 10) || 0, parseInt(bits[7], 10) || 0));
    };
})(dateutil || (dateutil = {}));
/* harmony default export */ __webpack_exports__["b"] = (dateutil);
//# sourceMappingURL=dateutil.js.map

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isPresent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isWeekdayStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return range; });
/* unused harmony export clone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return repeat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return toArray; });
/* harmony export (immutable) */ __webpack_exports__["i"] = padStart;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return split; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pymod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return divmod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return notEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return includes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__weekday__ = __webpack_require__(20);
// =============================================================================
// Helper functions
// =============================================================================

var isPresent = function (value) {
    return value !== null && value !== undefined;
};
var isNumber = function (value) {
    return typeof value === 'number';
};
var isWeekdayStr = function (value) {
    return __WEBPACK_IMPORTED_MODULE_0__weekday__["a" /* ALL_WEEKDAYS */].indexOf(value) >= 0;
};
var isArray = Array.isArray;
/**
 * Simplified version of python's range()
 */
var range = function (start, end) {
    if (end === void 0) { end = start; }
    if (arguments.length === 1) {
        end = start;
        start = 0;
    }
    var rang = [];
    for (var i = start; i < end; i++)
        rang.push(i);
    return rang;
};
var clone = function (array) {
    return [].concat(array);
};
var repeat = function (value, times) {
    var i = 0;
    var array = [];
    if (isArray(value)) {
        for (; i < times; i++)
            array[i] = [].concat(value);
    }
    else {
        for (; i < times; i++)
            array[i] = value;
    }
    return array;
};
var toArray = function (item) {
    if (isArray(item)) {
        return item;
    }
    return [item];
};
function padStart(item, targetLength, padString) {
    if (padString === void 0) { padString = ' '; }
    var str = String(item);
    targetLength = targetLength >> 0;
    if (str.length > targetLength) {
        return String(str);
    }
    targetLength = targetLength - str.length;
    if (targetLength > padString.length) {
        padString += repeat(padString, targetLength / padString.length);
    }
    return padString.slice(0, targetLength) + String(str);
}
/**
 * Python like split
 */
var split = function (str, sep, num) {
    var splits = str.split(sep);
    return num
        ? splits.slice(0, num).concat([splits.slice(num).join(sep)])
        : splits;
};
/**
 * closure/goog/math/math.js:modulo
 * Copyright 2006 The Closure Library Authors.
 * The % operator in JavaScript returns the remainder of a / b, but differs from
 * some other languages in that the result will have the same sign as the
 * dividend. For example, -1 % 8 == -1, whereas in some other languages
 * (such as Python) the result would be 7. This function emulates the more
 * correct modulo behavior, which is useful for certain applications such as
 * calculating an offset index in a circular list.
 *
 * @param {number} a The dividend.
 * @param {number} b The divisor.
 * @return {number} a % b where the result is between 0 and b (either 0 <= x < b
 *     or b < x <= 0, depending on the sign of b).
 */
var pymod = function (a, b) {
    var r = a % b;
    // If r and b differ in sign, add b to wrap the result to the correct sign.
    return r * b < 0 ? r + b : r;
};
/**
 * @see: <http://docs.python.org/library/functions.html#divmod>
 */
var divmod = function (a, b) {
    return { div: Math.floor(a / b), mod: pymod(a, b) };
};
var empty = function (obj) {
    return !isPresent(obj) || obj.length === 0;
};
/**
 * Python-like boolean
 * @return {Boolean} value of an object/primitive, taking into account
 * the fact that in Python an empty list's/tuple's
 * boolean value is False, whereas in JS it's true
 */
var notEmpty = function (obj) {
    return !empty(obj);
};
/**
 * Return true if a value is in an array
 */
var includes = function (arr, val) {
    return notEmpty(arr) && arr.indexOf(val) !== -1;
};
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isStreamMonkey;
function isStreamMonkey() {
  var migrationId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!migrationId) return false;
  var migrationIdChunks = migrationId.split(':');
  return migrationIdChunks[0].toLowerCase() === 'sm';
}

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Days; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defaultKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterresult__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__callbackiterresult__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nlp_index__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parseoptions__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parsestring__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__optionstostring__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cache__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__weekday__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__iter_index__ = __webpack_require__(223);











// =============================================================================
// RRule
// =============================================================================
var Days = {
    MO: new __WEBPACK_IMPORTED_MODULE_9__weekday__["b" /* Weekday */](0),
    TU: new __WEBPACK_IMPORTED_MODULE_9__weekday__["b" /* Weekday */](1),
    WE: new __WEBPACK_IMPORTED_MODULE_9__weekday__["b" /* Weekday */](2),
    TH: new __WEBPACK_IMPORTED_MODULE_9__weekday__["b" /* Weekday */](3),
    FR: new __WEBPACK_IMPORTED_MODULE_9__weekday__["b" /* Weekday */](4),
    SA: new __WEBPACK_IMPORTED_MODULE_9__weekday__["b" /* Weekday */](5),
    SU: new __WEBPACK_IMPORTED_MODULE_9__weekday__["b" /* Weekday */](6)
};
var DEFAULT_OPTIONS = {
    freq: __WEBPACK_IMPORTED_MODULE_4__types__["a" /* Frequency */].YEARLY,
    dtstart: null,
    interval: 1,
    wkst: Days.MO,
    count: null,
    until: null,
    tzid: null,
    bysetpos: null,
    bymonth: null,
    bymonthday: null,
    bynmonthday: null,
    byyearday: null,
    byweekno: null,
    byweekday: null,
    bynweekday: null,
    byhour: null,
    byminute: null,
    bysecond: null,
    byeaster: null
};
var defaultKeys = Object.keys(DEFAULT_OPTIONS);
/**
 *
 * @param {Options?} options - see <http://labix.org/python-dateutil/#head-cf004ee9a75592797e076752b2a889c10f445418>
 *        The only required option is `freq`, one of RRule.YEARLY, RRule.MONTHLY, ...
 * @constructor
 */
var RRule = /** @class */ (function () {
    function RRule(options, noCache) {
        if (options === void 0) { options = {}; }
        if (noCache === void 0) { noCache = false; }
        // RFC string
        this._cache = noCache ? null : new __WEBPACK_IMPORTED_MODULE_8__cache__["a" /* Cache */]();
        // used by toString()
        this.origOptions = Object(__WEBPACK_IMPORTED_MODULE_5__parseoptions__["b" /* initializeOptions */])(options);
        var parsedOptions = Object(__WEBPACK_IMPORTED_MODULE_5__parseoptions__["c" /* parseOptions */])(options).parsedOptions;
        this.options = parsedOptions;
    }
    RRule.parseText = function (text, language) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__nlp_index__["c" /* parseText */])(text, language);
    };
    RRule.fromText = function (text, language) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__nlp_index__["a" /* fromText */])(text, language);
    };
    RRule.fromString = function (str) {
        return new RRule(RRule.parseString(str) || undefined);
    };
    RRule.prototype._iter = function (iterResult) {
        return Object(__WEBPACK_IMPORTED_MODULE_10__iter_index__["a" /* iter */])(iterResult, this.options);
    };
    RRule.prototype._cacheGet = function (what, args) {
        if (!this._cache)
            return false;
        return this._cache._cacheGet(what, args);
    };
    RRule.prototype._cacheAdd = function (what, value, args) {
        if (!this._cache)
            return;
        return this._cache._cacheAdd(what, value, args);
    };
    /**
     * @param {Function} iterator - optional function that will be called
     *                   on each date that is added. It can return false
     *                   to stop the iteration.
     * @return Array containing all recurrences.
     */
    RRule.prototype.all = function (iterator) {
        if (iterator) {
            return this._iter(new __WEBPACK_IMPORTED_MODULE_2__callbackiterresult__["a" /* default */]('all', {}, iterator));
        }
        var result = this._cacheGet('all');
        if (result === false) {
            result = this._iter(new __WEBPACK_IMPORTED_MODULE_1__iterresult__["a" /* default */]('all', {}));
            this._cacheAdd('all', result);
        }
        return result;
    };
    /**
     * Returns all the occurrences of the rrule between after and before.
     * The inc keyword defines what happens if after and/or before are
     * themselves occurrences. With inc == True, they will be included in the
     * list, if they are found in the recurrence set.
     * @return Array
     */
    RRule.prototype.between = function (after, before, inc, iterator) {
        if (inc === void 0) { inc = false; }
        if (!__WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].isValidDate(after) || !__WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].isValidDate(before))
            throw new Error('Invalid date passed in to RRule.between');
        var args = {
            before: before,
            after: after,
            inc: inc
        };
        if (iterator) {
            return this._iter(new __WEBPACK_IMPORTED_MODULE_2__callbackiterresult__["a" /* default */]('between', args, iterator));
        }
        var result = this._cacheGet('between', args);
        if (result === false) {
            result = this._iter(new __WEBPACK_IMPORTED_MODULE_1__iterresult__["a" /* default */]('between', args));
            this._cacheAdd('between', result, args);
        }
        return result;
    };
    /**
     * Returns the last recurrence before the given datetime instance.
     * The inc keyword defines what happens if dt is an occurrence.
     * With inc == True, if dt itself is an occurrence, it will be returned.
     * @return Date or null
     */
    RRule.prototype.before = function (dt, inc) {
        if (inc === void 0) { inc = false; }
        if (!__WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].isValidDate(dt))
            throw new Error('Invalid date passed in to RRule.before');
        var args = { dt: dt, inc: inc };
        var result = this._cacheGet('before', args);
        if (result === false) {
            result = this._iter(new __WEBPACK_IMPORTED_MODULE_1__iterresult__["a" /* default */]('before', args));
            this._cacheAdd('before', result, args);
        }
        return result;
    };
    /**
     * Returns the first recurrence after the given datetime instance.
     * The inc keyword defines what happens if dt is an occurrence.
     * With inc == True, if dt itself is an occurrence, it will be returned.
     * @return Date or null
     */
    RRule.prototype.after = function (dt, inc) {
        if (inc === void 0) { inc = false; }
        if (!__WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].isValidDate(dt))
            throw new Error('Invalid date passed in to RRule.after');
        var args = { dt: dt, inc: inc };
        var result = this._cacheGet('after', args);
        if (result === false) {
            result = this._iter(new __WEBPACK_IMPORTED_MODULE_1__iterresult__["a" /* default */]('after', args));
            this._cacheAdd('after', result, args);
        }
        return result;
    };
    /**
     * Returns the number of recurrences in this set. It will have go trough
     * the whole recurrence, if this hasn't been done before.
     */
    RRule.prototype.count = function () {
        return this.all().length;
    };
    /**
     * Converts the rrule into its string representation
     * @see <http://www.ietf.org/rfc/rfc2445.txt>
     * @return String
     */
    RRule.prototype.toString = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_7__optionstostring__["a" /* optionsToString */])(this.origOptions);
    };
    /**
     * Will convert all rules described in nlp:ToText
     * to text.
     */
    RRule.prototype.toText = function (gettext, language, dateFormatter) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__nlp_index__["d" /* toText */])(this, gettext, language, dateFormatter);
    };
    RRule.prototype.isFullyConvertibleToText = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3__nlp_index__["b" /* isFullyConvertible */])(this);
    };
    /**
     * @return a RRule instance with the same freq and options
     *          as this one (cache is not cloned)
     */
    RRule.prototype.clone = function () {
        return new RRule(this.origOptions);
    };
    // RRule class 'constants'
    RRule.FREQUENCIES = [
        'YEARLY',
        'MONTHLY',
        'WEEKLY',
        'DAILY',
        'HOURLY',
        'MINUTELY',
        'SECONDLY'
    ];
    RRule.YEARLY = __WEBPACK_IMPORTED_MODULE_4__types__["a" /* Frequency */].YEARLY;
    RRule.MONTHLY = __WEBPACK_IMPORTED_MODULE_4__types__["a" /* Frequency */].MONTHLY;
    RRule.WEEKLY = __WEBPACK_IMPORTED_MODULE_4__types__["a" /* Frequency */].WEEKLY;
    RRule.DAILY = __WEBPACK_IMPORTED_MODULE_4__types__["a" /* Frequency */].DAILY;
    RRule.HOURLY = __WEBPACK_IMPORTED_MODULE_4__types__["a" /* Frequency */].HOURLY;
    RRule.MINUTELY = __WEBPACK_IMPORTED_MODULE_4__types__["a" /* Frequency */].MINUTELY;
    RRule.SECONDLY = __WEBPACK_IMPORTED_MODULE_4__types__["a" /* Frequency */].SECONDLY;
    RRule.MO = Days.MO;
    RRule.TU = Days.TU;
    RRule.WE = Days.WE;
    RRule.TH = Days.TH;
    RRule.FR = Days.FR;
    RRule.SA = Days.SA;
    RRule.SU = Days.SU;
    RRule.parseString = __WEBPACK_IMPORTED_MODULE_6__parsestring__["b" /* parseString */];
    RRule.optionsToString = __WEBPACK_IMPORTED_MODULE_7__optionstostring__["a" /* optionsToString */];
    return RRule;
}());
/* harmony default export */ __webpack_exports__["c"] = (RRule);
//# sourceMappingURL=rrule.js.map

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isSwitcherStudioAppShell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return storage; });
/* harmony export (immutable) */ __webpack_exports__["b"] = gotoLogin;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAuthToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basil_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basil_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_basil_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_sha256__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



 // Track a cookie (yes, always a cookie, not localStorage) to detect whether
// the user has ever logged in.  This is used by src/auth-xd/index.html as
// required by Safari tracking protections.

var EVER_LOGGED_IN_COOKIE = 'bxcauth'; // Export a variable that lets us know if we are inside Switcher Studio

var isSwitcherStudioAppShell = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.switcher; // The Storage class wraps localStorage and cookies to protect against Private Mode on Safari shenanigans

var Storage = /*#__PURE__*/function () {
  function Storage() {
    _classCallCheck(this, Storage);

    if (isSwitcherStudioAppShell) {
      console.warn('localStorage will not work; falling back to custom Switcher Studio strategy');
      this.strategy = new SwitcherStudioStorageStrategy();
    } else {
      try {
        this.strategy = __WEBPACK_IMPORTED_MODULE_0_basil_js___default.a.localStorage;
        this.set('__sentinel__', 'SENTINEL');

        if (this.get('__sentinel__') != 'SENTINEL') {
          throw 'localStorage non functional';
        }
      } catch (e) {
        console.warn('localStorage not working; falling back to cookies', e);
        this.strategy = __WEBPACK_IMPORTED_MODULE_0_basil_js___default.a.cookie;
      } finally {
        this.remove('__sentinel__');
      }
    }
  }

  _createClass(Storage, [{
    key: "get",
    value: function get(key) {
      return this.strategy.get(key);
    }
  }, {
    key: "getPromise",
    value: function getPromise(key) {
      var _this = this;

      if (this.strategy.getPromise) {
        return this.strategy.getPromise(key);
      } else {
        return new Promise(function (resolve, _) {
          return resolve(_this.strategy.get(key));
        });
      }
    }
  }, {
    key: "set",
    value: function set(key, value) {
      return this.strategy.set(key, value);
    }
  }, {
    key: "setPromise",
    value: function setPromise(key, value) {
      var _this2 = this;

      if (this.strategy.setPromise) {
        return this.strategy.setPromise(key, value);
      } else {
        return new Promise(function (resolve, _) {
          return resolve(_this2.strategy.set(key, value));
        });
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      return this.strategy.remove(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._clearLoggedInCookie();

      return this.strategy.reset();
    }
  }, {
    key: "bumpLoggedInCookie",
    value: function bumpLoggedInCookie() {
      __WEBPACK_IMPORTED_MODULE_0_basil_js___default.a.cookie.set(EVER_LOGGED_IN_COOKIE, '1', {
        expireDays: 365,
        sameSite: 'none',
        secure: true,
        domain: 'boxcast.com'
      });
    }
  }, {
    key: "_clearLoggedInCookie",
    value: function _clearLoggedInCookie() {
      __WEBPACK_IMPORTED_MODULE_0_basil_js___default.a.cookie.remove(EVER_LOGGED_IN_COOKIE);
    }
  }]);

  return Storage;
}(); // The SwitcherStudioStorageStrategy implements a special type of storage layer
// that can mostly work inside their nested webview+iframe implementation.  Note
// that syncronous storage operations are not permitted.


var SwitcherStudioStorageStrategy = /*#__PURE__*/function () {
  function SwitcherStudioStorageStrategy() {
    _classCallCheck(this, SwitcherStudioStorageStrategy);
  }

  _createClass(SwitcherStudioStorageStrategy, [{
    key: "get",
    value: function get(key) {
      console.warn('Switcher Studio does not support a synchronous storage.get implementation');
      return null;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      console.warn('Switcher Studio does not support a synchronous storage.set implementation');
      this.setPromise(key, value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      console.warn('Switcher Studio does not support removing from storage');
      return __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default.a.send(window.parent, 'ui', {
        method: 'setItem',
        params: {
          key: key,
          value: ''
        }
      }, {
        timeout: 2500
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      console.warn('Switcher Studio does not support clearing storage');
      this.remove('oauthState');
      this.remove('oauthVerifier');
      this.remove('oauthPath');
      this.remove('oauthToken');
    }
  }, {
    key: "getPromise",
    value: function getPromise(key) {
      return __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default.a.send(window.parent, 'ui', {
        method: 'getItem',
        params: {
          key: key
        }
      }, {
        timeout: 2500
      }).then(function (r) {
        return r.data;
      });
    }
  }, {
    key: "setPromise",
    value: function setPromise(key, value) {
      return __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default.a.send(window.parent, 'ui', {
        method: 'setItem',
        params: {
          key: key,
          value: value
        }
      }, {
        timeout: 2500
      });
    }
  }]);

  return SwitcherStudioStorageStrategy;
}(); // Export an instance of the storage class to be used throughout this page lifecycle


var storage = new Storage(); // Export a helper method for immediately redirecting to the login page

function gotoLogin() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  //$('body > app').hide();
  //$('body').append(`<h1 class="text-center">Redirecting in 5 sec ${message}</h1>`);
  //setTimeout(() => {
  var state = generateRandomString(8);
  var verifier = generateRandomString(48);
  var challenge = b64(__WEBPACK_IMPORTED_MODULE_1_js_sha256___default.a.array(verifier));
  var promises = [storage.setPromise('oauthState', state), storage.setPromise('oauthVerifier', verifier), storage.setPromise('oauthPath', window.location.href)];
  Promise.all(promises).then(function () {
    var authUrl = isSwitcherStudioAppShell ? SWITCHER_AUTH_URL : AUTH_URL;
    window.location.replace(authUrl + '&state=' + state + '&code_challenge_method=S256&code_challenge=' + challenge);
  }); //}, 5000)

  throw new Error('halt');
} // Export a function to retrieve the current auth token

function getAuthToken() {
  // XXX: The Switcher Studio app may inject the OAuth token into the document. Prefer that,
  // but resort to localStorage for all other requests.
  return document.switcherStudioAccessToken || storage.get('oauthToken');
}

function generateRandomString(n) {
  var bytes = new Uint8Array((n * 3 + 3) / 4);

  if (window.msCrypto) {
    msCrypto.getRandomValues(bytes);
  } else {
    crypto.getRandomValues(bytes);
  }

  return b64(bytes).substring(0, n);
}

function b64(bytes) {
  return btoa(String.fromCharCode.apply(null, bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* harmony export (immutable) */ __webpack_exports__["c"] = __spreadArrays;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Frequency; });
/* harmony export (immutable) */ __webpack_exports__["b"] = freqIsDailyOrGreater;
var Frequency;
(function (Frequency) {
    Frequency[Frequency["YEARLY"] = 0] = "YEARLY";
    Frequency[Frequency["MONTHLY"] = 1] = "MONTHLY";
    Frequency[Frequency["WEEKLY"] = 2] = "WEEKLY";
    Frequency[Frequency["DAILY"] = 3] = "DAILY";
    Frequency[Frequency["HOURLY"] = 4] = "HOURLY";
    Frequency[Frequency["MINUTELY"] = 5] = "MINUTELY";
    Frequency[Frequency["SECONDLY"] = 6] = "SECONDLY";
})(Frequency || (Frequency = {}));
function freqIsDailyOrGreater(freq) {
    return freq < Frequency.HOURLY;
}
//# sourceMappingURL=types.js.map

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = errorDescriptionFromResponse;
// Generate an error message from the server response
function errorDescriptionFromResponse(response) {
  var details = response.data ? response.data : response;

  if (details.error_hint || details.error_description || details.invalid_fields) {
    return "".concat(details.error_hint || details.error_description, " ").concat(invalidFieldsToSentence(details.invalid_fields));
  }

  return details;
}

function invalidFieldsToSentence(fields) {
  if (!fields) {
    return '';
  }

  var sentence = '';
  Object.keys(fields).forEach(function (k) {
    sentence += "".concat(cleanSlugKey(k), " ").concat(fields[k], ". ");
  });
  return sentence;
}

function cleanSlugKey(key) {
  key = key.replace(/_/g, ' ');
  return key[0].toUpperCase() + key.substr(1).toLowerCase();
}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_WEEKDAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Weekday; });
// =============================================================================
// Weekday
// =============================================================================
var ALL_WEEKDAYS = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
var Weekday = /** @class */ (function () {
    function Weekday(weekday, n) {
        if (n === 0)
            throw new Error("Can't create weekday with n == 0");
        this.weekday = weekday;
        this.n = n;
    }
    Weekday.fromStr = function (str) {
        return new Weekday(ALL_WEEKDAYS.indexOf(str));
    };
    // __call__ - Cannot call the object directly, do it through
    // e.g. RRule.TH.nth(-1) instead,
    Weekday.prototype.nth = function (n) {
        return this.n === n ? this : new Weekday(this.weekday, n);
    };
    // __eq__
    Weekday.prototype.equals = function (other) {
        return this.weekday === other.weekday && this.n === other.n;
    };
    // __repr__
    Weekday.prototype.toString = function () {
        var s = ALL_WEEKDAYS[this.weekday];
        if (this.n)
            s = (this.n > 0 ? '+' : '') + String(this.n) + s;
        return s;
    };
    Weekday.prototype.getJsWeekday = function () {
        return this.weekday === 6 ? 0 : this.weekday + 1;
    };
    return Weekday;
}());

//# sourceMappingURL=weekday.js.map

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getUISports;
/* harmony export (immutable) */ __webpack_exports__["b"] = getUIConnections;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateSportFromPrefix;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreScoreboardUIConfiguration;
/* harmony export (immutable) */ __webpack_exports__["d"] = mapScoreboardUIConfigurationToAPI;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearScoreboardConfig;
// The scoreboard utilities in here deal with a mismatch between the API
// configuration and how the UI wants to present the configuration.
//
// Starting with the standard `broadcast.scoreboard_configuration` object
// from the API, we introduce or change the following attributes:
//  * Split `sport` into `sport_prefix` and `sport_variation` in the UI to allow
//    a dependent selection between Basketball 4Q/2H
//  * Remove the idea of "Manual" as a scoreboard_make and flatten into a
//    top-level boolean option.
//  * Use a new notion of `connection` to switch between the 2 types of BoxCast
//    adapters as well as Sportzcast.
function getUISports() {
  return [{
    label: 'Baseball / Softball',
    value: 'Baseball/Softball',
    icon: '/img/sports/baseball.svg'
  }, {
    label: 'Basketball',
    value: 'Basketball',
    icon: '/img/sports/basketball.svg'
  }, {
    label: 'Football',
    value: 'Football',
    icon: '/img/sports/football.svg'
  }, {
    label: 'Hockey',
    value: 'Hockey',
    icon: '/img/sports/hockey.svg'
  }, {
    label: 'Lacrosse',
    value: 'Lacrosse',
    icon: '/img/sports/lacrosse.svg'
  }, {
    label: 'Soccer',
    value: 'Soccer',
    icon: '/img/sports/soccer.svg'
  }, {
    label: 'Volleyball',
    value: 'Volleyball',
    icon: '/img/sports/volleyball.svg'
  }, {
    label: 'Wrestling',
    value: 'Wrestling',
    icon: '/img/sports/wrestling.svg'
  }];
}
function getUIConnections(account) {
  var result = [];

  if (account.feature_flags.automated_scoreboard) {
    if (account.has_scoreboard_assists) {
      result.push({
        label: 'BoxCast Scoreboard Assist',
        value: 'scoreboard_assist',
        icon: '/img/sports/BoxCastScoreboardAssist.png',
        description: 'Supports Trans-Lux Fair-Play, Daktronics, and OES',
        is_new: true
      });
    }

    result.push({
      label: 'BoxCast Scoreboard Adapter',
      value: 'scoreboard_adapter',
      icon: '/img/sports/BoxCastScoreBug.png',
      description: '(Legacy) Supports Trans-Lux Fair-Play, Daktronics, and OES'
    });
  }

  if (account.feature_flags.sportzcast) {
    result.push({
      label: 'ScoreBot',
      value: 'scorebot',
      icon: '/img/sports/SportzCastLogo.png',
      description: 'Requires Sportzcast log in'
    });
  }

  return result;
}
function updateSportFromPrefix(scoreboard_configuration, sport_prefix) {
  scoreboard_configuration.sport_prefix = sport_prefix;

  if (sport_prefix == 'Basketball') {
    if (!scoreboard_configuration.sport_variation) {
      scoreboard_configuration.sport_variation = ' (4 Quarters)';
    }

    scoreboard_configuration.sport = scoreboard_configuration.sport_prefix + scoreboard_configuration.sport_variation;
  } else {
    scoreboard_configuration.sport = scoreboard_configuration.sport_prefix;
  }

  return scoreboard_configuration;
}
function restoreScoreboardUIConfiguration(sc) {
  if (sc.scoreboard_make == 'Manual') {
    sc.manual = true;
  } else if (sc.scoreboard_make == 'BoxCast') {
    sc.manual = false;
    sc.connection = 'scoreboard_assist';
  } else if (sc.scoreboard_make == 'Sportzcast') {
    sc.manual = false;
    sc.connection = 'scorebot';
  } else if (sc.scoreboard_make) {
    sc.manual = false;
    sc.connection = 'scoreboard_adapter';
  }

  if (sc.sport) {
    if (sc.sport.startsWith('Basketball')) {
      sc.sport_prefix = 'Basketball';
      sc.sport_variation = sc.sport.replace('Basketball', '');
    } else {
      sc.sport_prefix = sc.sport;
      sc.sport_variation = '';
    }
  }
}
function mapScoreboardUIConfigurationToAPI(sc) {
  if (sc.manual) {
    delete sc.manual;
    delete sc.connection;
    delete sc.sportzcast_bot_number;
    sc.scoreboard_make = 'Manual';
    sc.scoreboard_model = 'Manual Input';
  } else if (sc.connection == 'scoreboard_assist') {
    delete sc.manual;
    delete sc.connection;
    delete sc.sportzcast_bot_number;
    sc.scoreboard_make = 'BoxCast';
    sc.scoreboard_model = 'Scoreboard Assist';
  } else if (sc.connection == 'scorebot') {
    delete sc.manual;
    delete sc.connection;
    sc.scoreboard_make = 'Sportzcast';
    sc.scoreboard_model = 'ScoreBOT';
  } else if (sc.connection == 'scoreboard_adapter') {
    delete sc.manual;
    delete sc.connection;
    delete sc.sportzcast_bot_number;
  }

  if (sc.sport) {
    if (sc.sport_prefix == 'Basketball') {
      sc.sport = sc.sport_prefix + sc.sport_variation;
    } else {
      sc.sport = sc.sport_prefix;
    }
  }

  delete sc.sport_prefix;
  delete sc.sport_variation;
}
function clearScoreboardConfig(sc) {
  sc.sport = null;
  sc.sport_prefix = null;
  sc.sport_variation = null;
  sc.scoreboard_make = null;
  sc.scoreboard_model = null;
  delete sc.connection;
  delete sc.manual;
}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IsRtmpURLValid;
/* harmony export (immutable) */ __webpack_exports__["b"] = SanitizeRTMPURL;
/* harmony export (immutable) */ __webpack_exports__["c"] = TransformRTMPPushChannelAPIToClient;
/* harmony export (immutable) */ __webpack_exports__["d"] = TransformRTMPPushChannelClientToAPI;
var rtmpUrlIsValidRE = /^rtmps?:\/\/[^\s\/]+\/[^\s]+$/;
var rtmpUserInfoRE = /^rtmps?:\/\/([^:]+):([^@]+)@[^\s\/]+\/[^\s]+$/;
function IsRtmpURLValid(url) {
  return rtmpUrlIsValidRE.test(url);
} // Remove user info (username/password) from an RTMP URL.

function SanitizeRTMPURL(url) {
  var matches = url.match(rtmpUserInfoRE);

  if (matches && matches.length == 3) {
    var usernameEncoded = matches[1];
    var passwordEncoded = matches[2];
    return url.replace("://".concat(usernameEncoded, ":").concat(passwordEncoded, "@"), '://');
  }

  return url;
} // Modifies the object that is returned from the API into a format used by the client-side
// dashboard code. Specifically, it parses authentication information from the RTMP URL and
// places it in separate fields.

function TransformRTMPPushChannelAPIToClient(rtmpPushChannel) {
  var streamUrl = rtmpPushChannel.stream_url;
  var matches = streamUrl.match(rtmpUserInfoRE);

  if (matches && matches.length == 3) {
    var usernameEncoded = matches[1];
    var passwordEncoded = matches[2];
    rtmpPushChannel.stream_url = streamUrl.replace("://".concat(usernameEncoded, ":").concat(passwordEncoded, "@"), '://');
    rtmpPushChannel.username = decodeURIComponent(usernameEncoded);
    rtmpPushChannel.password = decodeURIComponent(passwordEncoded);
  }

  return rtmpPushChannel;
} // Modifies the object that is used by the client-side dashboard code into a format to be sent to
// the API. Specifically, it puts any authentication information kept in separate fields into the
// RTMP URL.

function TransformRTMPPushChannelClientToAPI(rtmpPushChannel) {
  if (rtmpPushChannel.username && rtmpPushChannel.password) {
    var usernameEncoded = encodeURIComponent(rtmpPushChannel.username);
    var passwordEncoded = encodeURIComponent(rtmpPushChannel.password);
    rtmpPushChannel.stream_url = rtmpPushChannel.stream_url.replace('://', "://".concat(usernameEncoded, ":").concat(passwordEncoded, "@"));
    delete rtmpPushChannel.username;
    delete rtmpPushChannel.password;
  }

  return rtmpPushChannel;
}

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = forceBrowserDownload;
function forceBrowserDownload(uri, filename) {
  var encodedUri = encodeURI(uri);
  var link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', filename);

  if (navigator.userAgent.indexOf('Firefox') >= 0) {
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    link.click();
  }
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoAudioConfig; });
var commonVideoBitrates = [{
  label: 'Audio Only',
  value: 10000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '300 kbps',
  value: 300000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '500 kbps',
  value: 500000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '700 kbps',
  value: 700000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '900 kbps',
  value: 900000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '1.2 Mbps',
  value: 1200000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '1.5 Mbps',
  value: 1572864,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '2.0 Mbps',
  value: 2000000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '2.5 Mbps',
  value: 2500000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '3.0 Mbps',
  value: 3000000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '4.0 Mbps',
  value: 4000000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '4.8 Mbps',
  value: 4800000,
  serial_prefixes: ['l', 'n', 'o']
}, {
  label: '5.0 Mbps',
  value: 5000000,
  serial_prefixes: ['p']
}, {
  label: '6.0 Mbps',
  value: 6000000,
  serial_prefixes: ['p']
}, {
  label: '7.0 Mbps',
  value: 7000000,
  serial_prefixes: ['p']
}, {
  label: '8.0 Mbps',
  value: 8000000,
  serial_prefixes: ['p']
}, {
  label: '9.0 Mbps',
  value: 9000000,
  serial_prefixes: ['p']
}, {
  label: '10.0 Mbps',
  value: 10000000,
  serial_prefixes: ['p']
}, {
  label: '11.0 Mbps',
  value: 11000000,
  serial_prefixes: ['p']
}, {
  label: '12.0 Mbps',
  value: 12000000,
  serial_prefixes: ['p']
}, {
  label: '13.0 Mbps',
  value: 13000000,
  serial_prefixes: ['p']
}, {
  label: '14.0 Mbps',
  value: 14000000,
  serial_prefixes: ['p']
}, {
  label: '15.0 Mbps',
  value: 15000000,
  serial_prefixes: ['p']
}, {
  label: '16.0 Mbps',
  value: 16000000,
  serial_prefixes: ['p']
}, {
  label: '17.0 Mbps',
  value: 17000000,
  serial_prefixes: ['p']
}, {
  label: '18.0 Mbps',
  value: 18000000,
  serial_prefixes: ['p']
}];
var boxcasterVideoBitrates = [{
  label: 'Auto-detect',
  value: 'default',
  serial_prefixes: ['l', 'n', 'o', 'p']
}].concat(commonVideoBitrates);
var streamVideoBitrates = [{
  label: 'Default',
  value: 'default',
  serial_prefixes: ['l', 'n', 'o', 'p']
}].concat(commonVideoBitrates);
var commonAudioBitrates = [{
  label: '48 kbps',
  value: 48000,
  serial_prefixes: ['l', 'n', 'o']
}, {
  label: '64 kbps',
  value: 64000,
  serial_prefixes: ['l', 'n', 'o']
}, {
  label: '96 kbps',
  value: 96000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '128 kbps',
  value: 128000,
  serial_prefixes: ['l', 'n', 'o', 'p']
}, {
  label: '192 kbps',
  value: 192000,
  serial_prefixes: ['p']
}, {
  label: '256 kbps',
  value: 256000,
  serial_prefixes: ['p']
}, {
  label: '320 kbps',
  value: 320000,
  serial_prefixes: ['p']
}];
var boxcasterAudioBitrates = [{
  label: 'Auto-detect',
  value: 'default',
  serial_prefixes: ['l', 'n', 'o', 'p']
}].concat(commonAudioBitrates);
var streamAudioBitrates = [{
  label: 'Default',
  value: 'default',
  serial_prefixes: ['l', 'n', 'o', 'p']
}].concat(commonAudioBitrates);
var VideoAudioConfig = {
  boxcaster: {
    video_bitrates: boxcasterVideoBitrates,
    audio_bitrates: boxcasterAudioBitrates
  },
  stream: {
    video_bitrates: streamVideoBitrates,
    audio_bitrates: streamAudioBitrates
  }
};

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inferVisiblityOptionFromPriceSettings;
/* harmony export (immutable) */ __webpack_exports__["b"] = updatePriceSettingsFromVisibilityOption;
// BoxCast pricing helper methods
function inferVisiblityOptionFromPriceSettings(obj) {
  if (obj.is_ticketed) {
    if (obj.free_variant == 'none') {
      return 'ticketed';
    } else {
      return 'flex';
    }
  } else if (obj.is_private) {
    return 'private';
  } else {
    return 'public';
  }
} // FUTURE: it's debatable whether it should be split by type or combinations of
// is_private, is_ticketed, free_variant, etc. --  we should discuss this more
// when we talk through updating/simplifying the pricing model

function updatePriceSettingsFromVisibilityOption(obj, visibility) {
  var isChannel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // Note: `obj` could be a channel or a broadcast
  // NOTE: We don't support ticketed channels in Video Portals (yet).
  // We don't mess with the validation here, because it should never reach that state.
  // If there are errors, it should show them during channel validation when creating/editing a channel.
  switch (visibility) {
    case 'public':
      obj.is_ticketed = false;
      if (!isChannel) obj.is_private = false;
      obj.ticket_price = null;
      obj.free_variant = null;
      break;

    case 'private':
      obj.is_ticketed = false;
      obj.is_private = true;
      obj.ticket_price = null;
      obj.free_variant = null;
      break;

    case 'ticketed':
      obj.is_ticketed = true;
      obj.is_private = isChannel ? true : false; // don't support ticketed channels in video portal yet

      obj.free_variant = 'none';
      break;

    case 'flex':
      obj.is_ticketed = true;
      obj.is_private = isChannel ? true : false; // don't support ticketed channels in video portal yet

      obj.free_variant = 'low';
      break;
  }

  return obj;
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmbedCodeGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base64__ = __webpack_require__(422);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var EmbedCodeGenerator = /*#__PURE__*/function () {
  function EmbedCodeGenerator() {
    _classCallCheck(this, EmbedCodeGenerator);
  }

  _createClass(EmbedCodeGenerator, null, [{
    key: "v2WidgetEmbed",
    value: function v2WidgetEmbed(channelId, title, description, related) {
      var template = "\n      <div id=\"boxcast-widget-".concat(channelId, "\">\n      <script type=\"text/javascript\">\n      var s = document.createElement('script');\n      var a = String.fromCharCode;\n      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');\n      s.setAttribute('data-action', 'boxcast-widget-load');\n      s.setAttribute('data-handle', '").concat(channelId, "');\n      s.setAttribute('data-options', 'version=3").concat(title ? '&title=1' : '').concat(description ? '&description=1' : '').concat(related ? '&history=1' : '', "');\n      s.src = h + '").concat(WIDGET_JS, "';\n      document.getElementsByTagName('head')[0].appendChild(s);\n      </script>\n      </div>\n    "); // XXX: boxcastiframe.com requires a space

      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, ' ').trim();
      return cleaned;
    }
  }, {
    key: "v2IframeEmbed",
    value: function v2IframeEmbed(channelId, title, description, related) {
      var params = __WEBPACK_IMPORTED_MODULE_0__base64__["a" /* default */].encode("'version=3".concat(title ? '&title=1' : '').concat(description ? '&description=1' : '').concat(related ? '&history=1' : '', "'"));
      var url = "http://boxcastiframe.com/index2.php/?id=".concat(channelId, "&widget_params=").concat(params);
      var template = "\n      <iframe width=\"720\" height=\"800\" src=\"".concat(url, "\" frameBorder=\"0\" scrolling=\"auto\" allowfullscreen=\"true\"></iframe>\n    ");
      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '');
      return cleaned;
    }
  }, {
    key: "v3WidgetEmbed",
    value: function v3WidgetEmbed(channelId, args) {
      var embedUrl = BOXCAST_JS_EMBED_URL;

      if (args.version) {
        embedUrl = embedUrl.replace('/v3', "/".concat(args.version, "/v3"));
      }

      args = mungeArgs(args);
      var argString = JSON.stringify(args);
      var template = "\n      <div id=\"boxcast-widget-".concat(channelId, "\"></div>\n      <script type=\"text/javascript\" charset=\"utf-8\">\n      (function(d, s, c, o) {\n      var js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];\n      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');\n      js.src = h + '").concat(embedUrl, "';\n      js.onload = function() { boxcast.noConflict()('#boxcast-widget-'+c).loadChannel(c, o); };\n      js.charset = 'utf-8';\n      fjs.parentNode.insertBefore(js, fjs);\n      }(document, 'script', '").concat(channelId, "', ").concat(argString, "));\n      </script>\n    ");
      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
      return cleaned;
    }
  }, {
    key: "v3Highlights",
    value: function v3Highlights(channelId, args) {
      var embedUrl = BOXCAST_JS_EMBED_URL;

      if (args.version) {
        embedUrl = embedUrl.replace('/v3', "/".concat(args.version, "/v3"));
      }

      args = mungeArgs(args);
      var argString = JSON.stringify(args);
      var template = "\n      <div id=\"boxcast-widget-".concat(channelId, "\"></div>\n      <script type=\"text/javascript\" charset=\"utf-8\">\n      (function(d, s, c, o) {\n      var js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];\n      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');\n      js.src = h + '").concat(embedUrl, "';\n      js.onload = function() { boxcast.noConflict()('#boxcast-widget-'+c).loadHighlights(c, o); };\n      js.charset = 'utf-8';\n      fjs.parentNode.insertBefore(js, fjs);\n      }(document, 'script', '").concat(channelId, "', ").concat(argString, "));\n      </script>\n    ");
      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
      return cleaned;
    }
  }, {
    key: "v3IframeEmbed",
    value: function v3IframeEmbed(channelId, args) {
      var autoResize = args.iframeResize;
      args = mungeArgs(args);
      var params = [];

      for (var p in args) {
        if (args.hasOwnProperty(p)) {
          var val = args[p];

          if (typeof val !== 'undefined' && val !== null) {
            if (typeof val == 'boolean') {
              val = val ? '1' : '0';
            }

            params.push(encodeURIComponent(p) + '=' + encodeURIComponent(val));
          }
        }
      }

      params = params.join('&');
      var url = "".concat(BOXCAST_JS_IFRAME_URL, "/").concat(encodeURIComponent(channelId), "?").concat(params);
      var template;

      if (autoResize) {
        // NOTE: the problem with using a script to write the iframe is that CMS's prevent script tags
        // often, which is the usual driver for using iframe embed method.
        template = "\n        <script src=\"https://js.boxcast.com/libs/iframeResizer-3.5.2.min.js\"></script>\n        <script>(function(p,c,q){\n          document.write('<iframe width=\"100%\" id=\"'+p+c+'\" src=\"".concat(BOXCAST_JS_IFRAME_URL, "/'+c+'?'+q+'\" frameBorder=\"0\" scrolling=\"auto\" allowfullscreen=\"true\" allow=\"autoplay; fullscreen\"></iframe>');\n          iFrameResize({}, '#'+p+c);\n        })('boxcast-iframe-', '").concat(channelId, "', '").concat(params, "&hostname='+encodeURIComponent(location.hostname));\n        </script>\n      ");
      } else {
        // XXX: TODO: sometimes, the user may just need the `src` value without the <iframe> tag, depending
        // on their web site software. Not sure how we decide when/how to present that option.
        template = "\n        <iframe width=\"720\" height=\"800\" src=\"".concat(url, "\" frameBorder=\"0\" scrolling=\"auto\" allowfullscreen=\"true\" allow=\"autoplay; fullscreen\"></iframe>\n      ");
      }

      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
      return cleaned;
    }
  }, {
    key: "v3Link",
    value: function v3Link(channelId, args) {
      var url = BOXCAST_TV_SHOW_URL + channelId; // Per Josh M, it's more likely that they just want the link URL and not a fully-formatted
      // anchor tag
      //var template = `
      //  <a href="${url}">View on BoxCast.tv</a>
      //`;

      args = mungeArgs(args);
      var params = args.applyBrandColor === false ? '?applyBrandColor=0' : '';
      var template = "\n      ".concat(url).concat(params, "\n    ");
      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
      return cleaned;
    }
  }, {
    key: "v3App",
    value: function v3App(channelId, args) {
      args = mungeArgs(args);
      var params = [];

      for (var p in args) {
        if (args.hasOwnProperty(p)) {
          var val = args[p];

          if (typeof val !== 'undefined' && val !== null) {
            if (typeof val == 'boolean') {
              val = val ? '1' : '0';
            }

            params.push(encodeURIComponent(p) + '=' + encodeURIComponent(val));
          }
        }
      }

      params = params.join('&');
      var url = "".concat(BOXCAST_JS_APP_EMBED_URL, "#").concat(encodeURIComponent(channelId), "?").concat(params);
      return url;
    }
  }, {
    key: "v3Rss",
    value: function v3Rss(channelId, args) {
      var template = "".concat(SYNDICATION_SERVICE_BASE_URL, "/rss/").concat(channelId, ".rss");
      return template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
    }
  }, {
    key: "v3MRSS",
    value: function v3MRSS(channelId, media, args) {
      var template = "".concat(SYNDICATION_SERVICE_BASE_URL, "/mrss/").concat(media, "/").concat(channelId, ".rss");
      return template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
    }
  }, {
    key: "rokuDirectPublisher",
    value: function rokuDirectPublisher(channelId, args) {
      var template = "".concat(SYNDICATION_SERVICE_BASE_URL, "/direct-publisher/").concat(channelId, ".json");
      return template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
    }
  }, {
    key: "v3Podcast",
    value: function v3Podcast(channelId, media, args) {
      var template = "".concat(SYNDICATION_SERVICE_BASE_URL, "/podcasts/").concat(media, "/").concat(channelId, ".rss");
      return template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
    }
  }, {
    key: "highlightClipEmbed",
    value: function highlightClipEmbed(highlightId, args) {
      var embedUrl = BOXCAST_JS_EMBED_URL;
      args = mungeArgs(args);
      var argString = JSON.stringify(args);
      var template = "\n      <div id=\"boxcast-widget-".concat(highlightId, "\"></div>\n      <script type=\"text/javascript\" charset=\"utf-8\">\n      (function(d, s, c, o) {\n      var js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];\n      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');\n      js.src = h + '").concat(embedUrl, "';\n      js.onload = function() { boxcast.noConflict()('#boxcast-widget-'+c).loadHighlight(c, o); };\n      js.charset = 'utf-8';\n      fjs.parentNode.insertBefore(js, fjs);\n      }(document, 'script', '").concat(highlightId, "', ").concat(argString, "));\n      </script>\n    ");
      var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '').trim();
      return cleaned;
    }
  }]);

  return EmbedCodeGenerator;
}();



function mungeArgs(options) {
  // Transform the UI options into the ones the player needs
  var args = angular.copy(options);

  if (args.showTitleAndDescription) {
    args.showTitle = 1;
    args.showDescription = 1;
    args.showHighlights = 1;
  } else {
    args.showTitle = 0;
    args.showDescription = 0;
    args.showHighlights = 0;
  }

  if (args.playlistOnRight) {
    args.layout = 'playlist-to-right';
  } // Convert string-y truth-y/false-y autoplay options to boolean


  if (args.autoplay === 'true') {
    args.autoplay = true;
  } else if (args.autoplay === 'false') {
    args.autoplay = false;
  } // Only pass along the brand color param if it's to disable it


  if (args.applyBrandColor) {
    delete args.applyBrandColor;
  } else {
    args.applyBrandColor = false;
  } // Some variables are used by UI but should never be passed along


  delete args.showTitleAndDescription;
  delete args.iframeResize;
  delete args.version;
  delete args.playlistOnRight;

  if (BOXCAST_JS_ENV != 'prod') {
    args.env = BOXCAST_JS_ENV;
  }

  return args;
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStripeCard;
/* harmony export (immutable) */ __webpack_exports__["b"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["d"] = parseBilling;
/* harmony export (immutable) */ __webpack_exports__["c"] = hasRMAItem;
// only create 1 per app but re-mount it as necessary
var stripe;
var stripeCard;
var INVOICE_DAYS_UNTIL_DUE = 30;
var RMA_SKU_INDICATOR = 'return-label';
var PREMIUM_PLAN_PRODUCT = 'prod_GphxV14RtoEZnx';
function getStripeCard() {
  if (!stripe && !stripeCard) {
    stripe = Stripe(STRIPE_KEY);
    stripeCard = stripe.elements().create('card');
  }

  return stripeCard;
}
function getToken(card) {
  return stripe.createToken(card).then(function (result) {
    if (result.error) {
      throw result.error.message;
    } else {
      return result.token;
    }
  });
}
function parseBilling(billing) {
  var result = {
    billing: billing,
    bankOnFile: null,
    cardOnFile: null,
    paidInvoices: [],
    outstandingInvoices: [],
    trialSub: null,
    daysUntilSuspend: 0,
    subscriptions: [],
    isBilledMonthly: false,
    formattedAddress: '',
    isPremiumPlan: false
  }; // Parse cards

  if (billing.stripe_token) {
    var cardId = billing.stripe_token;
    var cards = billing.sources.data;

    var card = _.find(cards, {
      id: cardId
    });

    if (card.object == 'card') {
      result.cardOnFile = card;
    } else if (card.object == 'bank_account') {
      result.bankOnFile = card;
    }
  } // Parse Invoices


  var maxDaysPastDue = 0;

  if (billing.invoices && billing.invoices.data.length) {
    billing.invoices.data.forEach(function (inv) {
      if (inv.status == 'void') {// Skip void invoices
      } else if (inv.status == 'draft' && !inv.closed) {// Skip invoices that are not yet viewable
      } else {
        inv.usage = [];

        if (inv.lines) {
          _.forEach(inv.lines.data, function (line) {
            if (line.plan && line.plan.usage_type == 'metered') {
              inv.usage.push({
                type: line.plan.metadata.usage_type,
                periodStart: line.period.start,
                periodEnd: line.period.end,
                subscriptionItemId: line.subscription_item,
                plan: line.plan
              });
            }
          });
        }

        if (inv.status == 'paid') {
          result.paidInvoices.push(inv);
          return;
        }

        inv.due_date = inv.due_date || inv.date;

        if (inv.due_date < new Date() && inv.billing == 'send_invoice') {
          inv.days_past_due = moment(new Date()).diff(inv.due_date * 1000, 'days');
          maxDaysPastDue = Math.max(maxDaysPastDue, inv.days_past_due);
        }

        if (inv.billing == 'charge_automatically') {
          if (inv.attempted && (inv.attempt_count > 1 || inv.next_payment_attempt)) {
            inv.detailedStatus = 'failed';
          } else if (!inv.attempted) {
            inv.detailedStatus = 'awaiting_payment';
          } else {
            inv.detailedStatus = 'pending';
          }
        } else {
          inv.detailedStatus = 'awaiting_payment';
        }

        result.outstandingInvoices.push(inv);
      }
    });
  }

  if (maxDaysPastDue > 0) {
    result.daysUntilSuspend = Math.max(INVOICE_DAYS_UNTIL_DUE - maxDaysPastDue, 0);
  } // Parse subscriptions


  result.subscriptions = [];

  if (billing.subscriptions && billing.subscriptions.total_count) {
    billing.subscriptions.data.forEach(function (sub) {
      sub.total_amount = 0;

      if (sub.items.data[0] && sub.items.data[0].plan.interval == 'year') {
        sub.annual_renewal = new Date(sub.current_period_end * 1000);
      } else if (sub.items.data[0] && sub.items.data[0].plan.interval == 'month') {
        result.isBilledMonthly = true;
      }

      sub.items.data.forEach(function (item) {
        item.plan.name = item.plan.metadata.display_name || item.plan.nickname || item.plan.id;
        item.plan.quantity = item.quantity || sub.quantity || 1;
        sub.total_amount += item.plan.amount * item.plan.quantity;

        if (item.plan.usage_type == 'metered') {
          sub.hasUsage = true;
        }

        if (item.plan.product == PREMIUM_PLAN_PRODUCT) {
          result.isPremiumPlan = true;
        }
      });

      if (sub.discount && sub.discount.coupon) {
        if (sub.discount.coupon.percent_off) {
          sub.discount.coupon.amount_off = sub.total_amount * sub.discount.coupon.percent_off / 100;
        }

        sub.total_amount -= sub.discount.coupon.amount_off;
      }

      result.subscriptions.push(sub);

      if (sub.status == 'trialing') {
        result.trialSub = sub;
      }
    });
  } // Other utilies


  cleanAddress(result.billing);

  if (billing.address != '' && billing.city != '' && billing.state != '' && billing.postal_code != '') {
    result.formattedAddress = "".concat(billing.address, "\n").concat(billing.city, ", ").concat(billing.state, " ").concat(billing.postal_code, " ").concat(billing.country);
  } else {
    result.formattedAddress = 'No Billing Address';
  }

  return result;
}
function hasRMAItem(proposal) {
  var hasRMA = false;

  _.forEach(proposal.products.invoice_items, function (item) {
    if (item.stripe_price.lookup_key.toLowerCase().indexOf(RMA_SKU_INDICATOR) >= 0) {
      hasRMA = true;
    }
  });

  return hasRMA;
}

function cleanAddress(addressObj) {
  if (!addressObj) return;
  if (addressObj.address == 'Unknown') addressObj.address = '';
  if (addressObj.city == 'Unknown') addressObj.city = '';
  if (addressObj.state == 'Unknown') addressObj.state = '';
  if (addressObj.postal_code == 'Unknown') addressObj.postal_code = '';
  if (addressObj.country == 'Unknown') addressObj.country = '';
  return addressObj;
}

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = decodeGeohash;
/* harmony export (immutable) */ __webpack_exports__["a"] = countCountries;
var BITS = [16, 8, 4, 2, 1];
var BASE32 = '0123456789bcdefghjkmnpqrstuvwxyz';
function decodeGeohash(geohash) {
  var even = true;
  var lat = [-90.0, 90.0];
  var lon = [-180.0, 180.0];
  var lat_err = 90.0;
  var lon_err = 180.0;
  var i, j;

  for (i = 0; i < geohash.length; i++) {
    var c = geohash[i];
    var cd = BASE32.indexOf(c);

    for (j = 0; j < 5; j++) {
      var mask = BITS[j];

      if (even) {
        lon_err /= 2;
        refineInterval(lon, cd, mask);
      } else {
        lat_err /= 2;
        refineInterval(lat, cd, mask);
      }

      even = !even;
    }
  }

  lat[2] = (lat[0] + lat[1]) / 2;
  lon[2] = (lon[0] + lon[1]) / 2;
  return {
    latitude: lat,
    longitude: lon
  };
}

function refineInterval(interval, cd, mask) {
  if (cd & mask) {
    interval[0] = (interval[0] + interval[1]) / 2;
  } else {
    interval[1] = (interval[0] + interval[1]) / 2;
  }
}

function countCountries(view_counts_by_region_code) {
  var map = {};

  _.each(view_counts_by_region_code, function (_, code) {
    var parts = code.split('-');
    map[parts[1]] = true;
  });

  return _.keys(map).length;
}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AllowSocial;
/**
 * Returns whether or not the user is allowed to share a broadcast (or highlight from a broadcast)
 * to social media. Based on a combination of the feature flags, account and broadcast settings.
 *
 * @param  {Object}    featureFlags A "feature flags" object
 * @param  {Account}   account The current account
 * @param  {Broadcast} broadcast The broadcast in question (or the broadcast to which the highlight belongs)
 * @return {bool}      True if the user can share to social media; false otherwise
 */
function AllowSocial(featureFlags, account, broadcast) {
  // Make a feature flags const that looks like an object no matter what
  var ff = featureFlags || {}; // Account content settings an extra features that look like an object no matter what

  var a = account || {};
  var accountContentSettings = a.content_settings || {};
  var accountExtraFeatures = a.extra_features || {}; // Broadcast content settings that looks like an object no matter what

  var b = broadcast || {};
  var broadcastContentSettings = b.content_settings || {}; // If media_token_restrictions, then flat-out "no".

  if (accountExtraFeatures.media_token_restrictions) {
    return false;
  } // No media token restrictions and no host restrictions feature -- good to go.


  if (!ff.host_restrictions) {
    return true;
  } // If we get here, the user has no media token restrictions, but they do have the host restrictions _feature_.
  // We need to see if it's actually configured, starting at the most specific level (broadcast) and moving up
  // to the account-level. We don't bother checking any channels because any social promotion would use the
  // single-broadcast channel.


  var hostRestrictionsAllowsSocial = function hostRestrictionsAllowsSocial(hostRestrictions) {
    // If there IS a redirect URL, we can allow social because we can send folks there.
    // If there's no redirect URL, we can't allow social because they'd be stranded on boxcast.tv and
    // we don't know where else to send them.
    return !!hostRestrictions.redirectUrl;
  };

  if (broadcastContentSettings.hostRestrictions) {
    return hostRestrictionsAllowsSocial(broadcastContentSettings.hostRestrictions);
  } else if (a.content_settings.hostRestrictions) {
    return hostRestrictionsAllowsSocial(accountContentSettings.hostRestrictions);
  } // By default, return true to allow social sharing


  return true;
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = enterpriseLastMileDelivery;
function enterpriseLastMileDelivery(entity) {
  var cs = (entity || {}).content_settings || {};

  if (cs.hasOwnProperty('enterprise_last_mile_delivery')) {
    return !!cs.enterprise_last_mile_delivery;
  } else {
    return true;
  }
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export salt */
/* unused harmony export hash */
/* unused harmony export check */
/* harmony export (immutable) */ __webpack_exports__["a"] = checkContentSettingsForChangesOnSave;
var sha512 = __webpack_require__(190);

function salt() {
  return Math.random().toString(36).substring(2);
}
function hash(password, salt) {
  var digest = (password || '') + (salt || '');

  for (var i = 0; i < 20; i++) {
    digest = sha512(digest);
  }

  return digest;
}
function check(password, crypt, salt) {
  return hash(password, salt) == crypt;
}
function checkContentSettingsForChangesOnSave(data) {
  // This method works against the UI's implementation of content_settings for
  // storing the cryptblock.
  if (data.cryptblock && data.cryptblock.__password__) {
    // Password changed; regenerate salt/hash
    var s = salt();
    data.cryptblock = {
      salt: s,
      crypt: hash(data.cryptblock.__password__, s)
    };
  } else if (data.cryptblock && data.cryptblock.crypt && data.cryptblock.salt) {// Keep existing password block as-is
  } else {
    delete data.cryptblock;
  }

  return data;
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FindTimeZone;
/* harmony export (immutable) */ __webpack_exports__["c"] = JstzToTzInfo;
/* harmony export (immutable) */ __webpack_exports__["b"] = JstzMatchesTzInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jstz__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jstz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jstz__);
// Timezone support needs to map between different systems' naming conventions:
// * Browsers are all different.  JSTZ is a library that helps normalize them into a format that
//   Ruby on Rails also happens to enjoy.
// * The BoxCast API Config returns a list of "TZInfo" formatted values.

function FindTimeZone() {
  var oldIntl = window.Intl;
  var tz = '';

  try {
    window.Intl = undefined;
    tz = __WEBPACK_IMPORTED_MODULE_0_jstz___default.a.determine().name();
  } catch (e) {
    // sometimes (on android) you can't override intl
    tz = __WEBPACK_IMPORTED_MODULE_0_jstz___default.a.determine().name();
  } finally {
    try {
      window.Intl = oldIntl;
    } catch (ee) {}
  }

  return tz;
}
function JstzToTzInfo(jstz) {
  return _.invert(TZ_INFO_TO_JSTZ_MAP)[jstz];
}
function JstzMatchesTzInfo(jstz, tzInfo) {
  return JstzToTzInfo(jstz) == tzInfo;
} // Generated from https://github.com/rails/rails/blob/v4.1.15/activesupport/lib/active_support/values/time_zone.rb#L37

var TZ_INFO_TO_JSTZ_MAP = {
  'International Date Line West': 'Pacific/Midway',
  'Midway Island': 'Pacific/Midway',
  'American Samoa': 'Pacific/Pago_Pago',
  Hawaii: 'Pacific/Honolulu',
  Alaska: 'America/Juneau',
  'Pacific Time (US & Canada)': 'America/Los_Angeles',
  Tijuana: 'America/Tijuana',
  'Mountain Time (US & Canada)': 'America/Denver',
  Arizona: 'America/Phoenix',
  Chihuahua: 'America/Chihuahua',
  Mazatlan: 'America/Mazatlan',
  'Central Time (US & Canada)': 'America/Chicago',
  Saskatchewan: 'America/Regina',
  Guadalajara: 'America/Mexico_City',
  'Mexico City': 'America/Mexico_City',
  Monterrey: 'America/Monterrey',
  'Central America': 'America/Guatemala',
  'Eastern Time (US & Canada)': 'America/New_York',
  'Indiana (East)': 'America/Indiana/Indianapolis',
  Bogota: 'America/Bogota',
  Lima: 'America/Lima',
  Quito: 'America/Lima',
  'Atlantic Time (Canada)': 'America/Halifax',
  Caracas: 'America/Caracas',
  'La Paz': 'America/La_Paz',
  Santiago: 'America/Santiago',
  Newfoundland: 'America/St_Johns',
  Brasilia: 'America/Sao_Paulo',
  'Buenos Aires': 'America/Argentina/Buenos_Aires',
  Montevideo: 'America/Montevideo',
  Georgetown: 'America/Guyana',
  Greenland: 'America/Godthab',
  'Mid-Atlantic': 'Atlantic/South_Georgia',
  Azores: 'Atlantic/Azores',
  'Cape Verde Is.': 'Atlantic/Cape_Verde',
  Dublin: 'Europe/Dublin',
  Edinburgh: 'Europe/London',
  Lisbon: 'Europe/Lisbon',
  London: 'Europe/London',
  Casablanca: 'Africa/Casablanca',
  Monrovia: 'Africa/Monrovia',
  UTC: 'Etc/UTC',
  Belgrade: 'Europe/Belgrade',
  Bratislava: 'Europe/Bratislava',
  Budapest: 'Europe/Budapest',
  Ljubljana: 'Europe/Ljubljana',
  Prague: 'Europe/Prague',
  Sarajevo: 'Europe/Sarajevo',
  Skopje: 'Europe/Skopje',
  Warsaw: 'Europe/Warsaw',
  Zagreb: 'Europe/Zagreb',
  Brussels: 'Europe/Brussels',
  Copenhagen: 'Europe/Copenhagen',
  Madrid: 'Europe/Madrid',
  Paris: 'Europe/Paris',
  Amsterdam: 'Europe/Amsterdam',
  Berlin: 'Europe/Berlin',
  Bern: 'Europe/Berlin',
  Rome: 'Europe/Rome',
  Stockholm: 'Europe/Stockholm',
  Vienna: 'Europe/Vienna',
  'West Central Africa': 'Africa/Algiers',
  Bucharest: 'Europe/Bucharest',
  Cairo: 'Africa/Cairo',
  Helsinki: 'Europe/Helsinki',
  Kyiv: 'Europe/Kiev',
  Riga: 'Europe/Riga',
  Sofia: 'Europe/Sofia',
  Tallinn: 'Europe/Tallinn',
  Vilnius: 'Europe/Vilnius',
  Athens: 'Europe/Athens',
  Istanbul: 'Europe/Istanbul',
  Minsk: 'Europe/Minsk',
  Jerusalem: 'Asia/Jerusalem',
  Harare: 'Africa/Harare',
  Pretoria: 'Africa/Johannesburg',
  Kaliningrad: 'Europe/Kaliningrad',
  Moscow: 'Europe/Moscow',
  'St. Petersburg': 'Europe/Moscow',
  Volgograd: 'Europe/Volgograd',
  Samara: 'Europe/Samara',
  Kuwait: 'Asia/Kuwait',
  Riyadh: 'Asia/Riyadh',
  Nairobi: 'Africa/Nairobi',
  Baghdad: 'Asia/Baghdad',
  Tehran: 'Asia/Tehran',
  'Abu Dhabi': 'Asia/Muscat',
  Muscat: 'Asia/Muscat',
  Baku: 'Asia/Baku',
  Tbilisi: 'Asia/Tbilisi',
  Yerevan: 'Asia/Yerevan',
  Kabul: 'Asia/Kabul',
  Ekaterinburg: 'Asia/Yekaterinburg',
  Islamabad: 'Asia/Karachi',
  Karachi: 'Asia/Karachi',
  Tashkent: 'Asia/Tashkent',
  Chennai: 'Asia/Kolkata',
  Kolkata: 'Asia/Kolkata',
  Mumbai: 'Asia/Kolkata',
  'New Delhi': 'Asia/Kolkata',
  Kathmandu: 'Asia/Kathmandu',
  Astana: 'Asia/Dhaka',
  Dhaka: 'Asia/Dhaka',
  'Sri Jayawardenepura': 'Asia/Colombo',
  Almaty: 'Asia/Almaty',
  Novosibirsk: 'Asia/Novosibirsk',
  Rangoon: 'Asia/Rangoon',
  Bangkok: 'Asia/Bangkok',
  Hanoi: 'Asia/Bangkok',
  Jakarta: 'Asia/Jakarta',
  Krasnoyarsk: 'Asia/Krasnoyarsk',
  Beijing: 'Asia/Shanghai',
  Chongqing: 'Asia/Chongqing',
  'Hong Kong': 'Asia/Hong_Kong',
  Urumqi: 'Asia/Urumqi',
  'Kuala Lumpur': 'Asia/Kuala_Lumpur',
  Singapore: 'Asia/Singapore',
  Taipei: 'Asia/Taipei',
  Perth: 'Australia/Perth',
  Irkutsk: 'Asia/Irkutsk',
  Ulaanbaatar: 'Asia/Ulaanbaatar',
  Seoul: 'Asia/Seoul',
  Osaka: 'Asia/Tokyo',
  Sapporo: 'Asia/Tokyo',
  Tokyo: 'Asia/Tokyo',
  Yakutsk: 'Asia/Yakutsk',
  Darwin: 'Australia/Darwin',
  Adelaide: 'Australia/Adelaide',
  Canberra: 'Australia/Melbourne',
  Melbourne: 'Australia/Melbourne',
  Sydney: 'Australia/Sydney',
  Brisbane: 'Australia/Brisbane',
  Hobart: 'Australia/Hobart',
  Vladivostok: 'Asia/Vladivostok',
  Guam: 'Pacific/Guam',
  'Port Moresby': 'Pacific/Port_Moresby',
  Magadan: 'Asia/Magadan',
  Srednekolymsk: 'Asia/Srednekolymsk',
  'Solomon Is.': 'Pacific/Guadalcanal',
  'New Caledonia': 'Pacific/Noumea',
  Fiji: 'Pacific/Fiji',
  Kamchatka: 'Asia/Kamchatka',
  'Marshall Is.': 'Pacific/Majuro',
  Auckland: 'Pacific/Auckland',
  Wellington: 'Pacific/Auckland',
  "Nuku'alofa": 'Pacific/Tongatapu',
  'Tokelau Is.': 'Pacific/Fakaofo',
  'Chatham Is.': 'Pacific/Chatham',
  Samoa: 'Pacific/Apia'
};

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = splitRtmpUrl;
/* harmony export (immutable) */ __webpack_exports__["b"] = resolutionForBroadcast;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BroadcastWithRtmpController; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Regex for splitting an RTMP URL into base and stream key
var rtmpUrlRE = /(rtmp:\/\/[^\/]+\/[^\/]+)\/(.+)/; // Splits a complete RTMP URL (with stream key) into an array with base and stream key

function splitRtmpUrl(url) {
  var m = url.match(rtmpUrlRE);

  if (m && m.length == 3) {
    return [m[1], m[2]];
  } else {
    console.warn('Unable to parse RTMP URL into components:', url);
    return ['', ''];
  }
}
var validResolutions = [{
  width: 864,
  height: 480
}, {
  width: 1280,
  height: 720
}, {
  width: 1920,
  height: 1080
}];
function resolutionForBroadcast(broadcast) {
  var height;

  if (broadcast.target_video_resolution && broadcast.target_video_resolution != 'default') {
    height = parseInt(broadcast.target_video_resolution);
  } else {
    height = 720;
  }

  var width = 0;

  if (height != 0) {
    var deltas = validResolutions.map(function (v) {
      return Math.abs(v.height - height);
    }),
        bestFit = validResolutions[deltas.indexOf(Math.min.apply(Math, _toConsumableArray(deltas)))];
    width = bestFit.width;
    height = bestFit.height;
  }

  return {
    width: width,
    height: height
  };
}

var BroadcastWithRtmpController = /*#__PURE__*/function () {
  function BroadcastWithRtmpController($uibModalInstance, $interpolate, $scope, $timeout, $window, $q, $rootScope, JSZip, BandwidthTestClient, StaticRTMP, availableBandwidth, broadcast, encoderType) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, BroadcastWithRtmpController);

    this.$uibModalInstance = $uibModalInstance;
    this.$interpolate = $interpolate;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$window = $window;
    this.BandwidthTestClient = BandwidthTestClient;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.broadcast = broadcast;
    this.encoderType = encoderType;
    this.availableBandwidth = availableBandwidth;

    if (this.encoderType == 'TriCaster') {
      this.activeTab = 'tricaster';
    } else {
      this.activeTab = null;
    }

    this.loadingPromise = $q.all([JSZip.init()]).then(function (result) {
      var j = result[0];
      _this.JSZip = j;

      _this.selectTab(_this.activeTab);
    });
  }

  _createClass(BroadcastWithRtmpController, [{
    key: "selectTab",
    value: function selectTab(encoder) {
      this.activeTab = encoder;

      var _resolutionForBroadca = resolutionForBroadcast(this.broadcast),
          width = _resolutionForBroadca.width,
          height = _resolutionForBroadca.height,
          frameRate = this._getFramerate(),
          codec = this._getCodec(height),
          _this$_getBitrates = this._getBitrates(this.availableBandwidth, height, frameRate),
          videoBitrate = _this$_getBitrates.videoBitrate,
          audioBitrate = _this$_getBitrates.audioBitrate,
          minVideoBitrate = _this$_getBitrates.minVideoBitrate,
          maxVideoBitrate = _this$_getBitrates.maxVideoBitrate,
          rtmpUrl = this.broadcast.rtmp_ingestion_url,
          params = {
        width: width,
        height: height,
        videoBitrate: videoBitrate,
        audioBitrate: audioBitrate,
        rtmpUrl: rtmpUrl,
        codec: codec,
        frameRate: frameRate
      };

      this.minVideoBitrate = minVideoBitrate;
      this.maxVideoBitrate = maxVideoBitrate;

      switch (this.activeTab) {
        case 'tricaster': // fallthrough

        case 'fmle':
          this._constructTriCasterFMLE(params);

          break;

        case 'obs':
          this._constructObs(params);

          break;

        case 'wirecast':
          this._constructWirecast({
            videoBitrate: videoBitrate,
            audioBitrate: audioBitrate
          });

          break;

        default:
          this._constructGeneric(params);

          break;
      }
    }
  }, {
    key: "_constructTriCasterFMLE",
    value: function _constructTriCasterFMLE(params) {
      var _this2 = this;

      ['width', 'height', 'rtmpUrl'].forEach(function (p) {
        return _this2[p] = params[p];
      });
      this.videoBitrateKbps = params.videoBitrateKbps = Math.round(params.videoBitrate / 1000);
      this.audioBitrateKbps = params.audioBitrateKbps = Math.round(params.audioBitrate / 1000);
      var parts = splitRtmpUrl(params.rtmpUrl);
      this.rtmpUrl = params.rtmpUrl = parts[0];
      this.streamKey = params.streamKey = parts[1];
      this.streamName = params.streamName = this.broadcast.name;
      this.xmlDownloadName = this.encoderType == 'TriCaster' ? 'tricaster.xml' : 'fmle.xml';
      this.xmlUrl = "".concat(INTEGRATIONS_ROOT, "/").concat(this.xmlDownloadName, "?height=").concat(params.height, "&width=").concat(params.width, "&video_bitrate_kbps=").concat(params.videoBitrateKbps, "&audio_bitrate_kbps=").concat(params.audioBitrateKbps, "&rtmp_url=").concat(encodeURIComponent(params.rtmpUrl), "&stream_key=").concat(encodeURIComponent(params.streamKey), "&stream_name=").concat(encodeURIComponent(params.streamName));

      if (this.encoderType == 'TriCaster') {
        window.location.replace(this.xmlUrl);
      }
    }
  }, {
    key: "_constructObs",
    value: function _constructObs(params) {
      var _this3 = this;

      params.streamName = this.broadcast.channel_id;
      params.audioBitrateKbps = Math.round(params.audioBitrate / 1000);
      var parts = splitRtmpUrl(params.rtmpUrl);
      params.rtmpUrl = parts[0];
      params.streamKey = parts[1];
      var basicInfo = this.$interpolate(__webpack_require__(434))(params),
          serviceInfo = {
        type: 'rtmp_custom',
        settings: {
          key: params.streamKey,
          server: params.rtmpUrl
        }
      },
          streamEncoderInfo = {
        bitrate: Math.round(params.videoBitrate / 1000),
        keyint_sec: 2,
        profile: 'high',
        rate_control: 'CBR',
        use_bufsize: false,
        vfr: false
      },
          zip = new this.JSZip(),
          folder = zip.folder(this.broadcast.channel_id);
      folder.file('basic.ini', basicInfo);
      folder.file('service.json', JSON.stringify(serviceInfo));
      folder.file('streamEncoder.json', JSON.stringify(streamEncoderInfo));
      zip.generateAsync({
        type: 'blob'
      }).then(function (b) {
        _this3.$scope.$apply(function () {
          _this3.zipUrl = _this3.$window.URL.createObjectURL(b);
          _this3.zipDownloadName = _this3.broadcast.channel_id;
        });
      });
    }
  }, {
    key: "_constructGeneric",
    value: function _constructGeneric(params) {
      var _this4 = this;

      ['width', 'height', 'rtmpUrl', 'codec', 'frameRate'].forEach(function (p) {
        return _this4[p] = params[p];
      });
      this.videoBitrateKbps = Math.round(params.videoBitrate / 1000);
      this.audioBitrateKbps = Math.round(params.audioBitrate / 1000);
      this.streamName = this.broadcast.name;
      var parts = splitRtmpUrl(this.rtmpUrl);
      this.rtmpUrl = parts[0];
      this.streamKey = parts[1];
    }
  }, {
    key: "_constructWirecast",
    value: function _constructWirecast(params) {
      // These are meant to match https://github.com/boxcast/origin_server/blob/master/stream/variant.go#L4-L6
      // and https://github.com/boxcast/boxcast_api/blob/master/app/controllers/integrations/wirecast_controller.rb#L10-L136.
      var defaultBitrates = {
        480: 1128000,
        // 1 Mbps video + 128 kbps audio
        720: 2692000,
        // 2.5 Mbps video + 192 kbps audio
        1080: 4928000 // 4.8 Mbps video + 128 kbps audio

      };
      var totalChosenBitrate = params.videoBitrate + params.audioBitrate;
      var recommendedHeight = Object.keys(defaultBitrates).map(function (k) {
        return parseInt(k);
      }).sort(function (a, b) {
        return b - a;
      }).find(function (r) {
        return totalChosenBitrate >= defaultBitrates[r];
      });
      var encodings = {
        480: 'BoxCast: 480p 3:2',
        720: 'BoxCast: 720p 16:9',
        1080: 'BoxCast: 1080p 16:9'
      };
      this.encodingSelection = encodings[recommendedHeight || 480];
      this.streamName = this.broadcast.name;
    }
  }, {
    key: "_getBitrates",
    value: function _getBitrates(bandwidth, height, frameRate) {
      var videoBitrate, audioBitrate;

      if (this.broadcast.target_video_bitrate && this.broadcast.target_video_bitrate != 'default') {
        videoBitrate = parseInt(this.broadcast.target_video_bitrate);
      }

      if (this.broadcast.target_audio_bitrate && this.broadcast.target_audio_bitrate != 'default') {
        audioBitrate = parseInt(this.broadcast.target_audio_bitrate);
      }

      return this.BandwidthTestClient.getBitrates(bandwidth, videoBitrate, audioBitrate, height, frameRate);
    }
  }, {
    key: "_getCodec",
    value: function _getCodec(height) {
      // NOTE that RTMP doesn't support UHD resolutions so they're not accounted for here.
      switch (height) {
        case 1080:
          return 'h.264, high 10 profile, level 4.2';

        case 720:
          return 'h.264, high profile, level 4';

        default:
          return 'h.264, main profile, level 3.1';
      }
    }
  }, {
    key: "_getFramerate",
    value: function _getFramerate() {
      if (this.FeatureFlags.high_frame_rate && this.broadcast.target_high_frame_rate == 'default') {
        return 60;
      } else if (this.broadcast.target_high_frame_rate === true) {
        return 60;
      } else {
        return 30;
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.$uibModalInstance.dismiss('cancel');
    }
  }]);

  return BroadcastWithRtmpController;
}();



/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This class helps us to emulate python's generators, sorta.
 */
var IterResult = /** @class */ (function () {
    function IterResult(method, args) {
        this.minDate = null;
        this.maxDate = null;
        this._result = [];
        this.total = 0;
        this.method = method;
        this.args = args;
        if (method === 'between') {
            this.maxDate = args.inc
                ? args.before
                : new Date(args.before.getTime() - 1);
            this.minDate = args.inc ? args.after : new Date(args.after.getTime() + 1);
        }
        else if (method === 'before') {
            this.maxDate = args.inc ? args.dt : new Date(args.dt.getTime() - 1);
        }
        else if (method === 'after') {
            this.minDate = args.inc ? args.dt : new Date(args.dt.getTime() + 1);
        }
    }
    /**
     * Possibly adds a date into the result.
     *
     * @param {Date} date - the date isn't necessarly added to the result
     *                      list (if it is too late/too early)
     * @return {Boolean} true if it makes sense to continue the iteration
     *                   false if we're done.
     */
    IterResult.prototype.accept = function (date) {
        ++this.total;
        var tooEarly = this.minDate && date < this.minDate;
        var tooLate = this.maxDate && date > this.maxDate;
        if (this.method === 'between') {
            if (tooEarly)
                return true;
            if (tooLate)
                return false;
        }
        else if (this.method === 'before') {
            if (tooLate)
                return false;
        }
        else if (this.method === 'after') {
            if (tooEarly)
                return true;
            this.add(date);
            return false;
        }
        return this.add(date);
    };
    /**
     *
     * @param {Date} date that is part of the result.
     * @return {Boolean} whether we are interested in more values.
     */
    IterResult.prototype.add = function (date) {
        this._result.push(date);
        return true;
    };
    /**
     * 'before' and 'after' return only one date, whereas 'all'
     * and 'between' an array.
     * @return {Date,Array?}
     */
    IterResult.prototype.getValue = function () {
        var res = this._result;
        switch (this.method) {
            case 'all':
            case 'between':
                return res;
            case 'before':
            case 'after':
            default:
                return (res.length ? res[res.length - 1] : null);
        }
    };
    IterResult.prototype.clone = function () {
        return new IterResult(this.method, this.args);
    };
    return IterResult;
}());
/* harmony default export */ __webpack_exports__["a"] = (IterResult);
//# sourceMappingURL=iterresult.js.map

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// =============================================================================
// i18n
// =============================================================================
var ENGLISH = {
    dayNames: [
        'Sunday', 'Monday', 'Tuesday', 'Wednesday',
        'Thursday', 'Friday', 'Saturday'
    ],
    monthNames: [
        'January', 'February', 'March', 'April', 'May',
        'June', 'July', 'August', 'September', 'October',
        'November', 'December'
    ],
    tokens: {
        'SKIP': /^[ \r\n\t]+|^\.$/,
        'number': /^[1-9][0-9]*/,
        'numberAsText': /^(one|two|three)/i,
        'every': /^every/i,
        'day(s)': /^days?/i,
        'weekday(s)': /^weekdays?/i,
        'week(s)': /^weeks?/i,
        'hour(s)': /^hours?/i,
        'minute(s)': /^minutes?/i,
        'month(s)': /^months?/i,
        'year(s)': /^years?/i,
        'on': /^(on|in)/i,
        'at': /^(at)/i,
        'the': /^the/i,
        'first': /^first/i,
        'second': /^second/i,
        'third': /^third/i,
        'nth': /^([1-9][0-9]*)(\.|th|nd|rd|st)/i,
        'last': /^last/i,
        'for': /^for/i,
        'time(s)': /^times?/i,
        'until': /^(un)?til/i,
        'monday': /^mo(n(day)?)?/i,
        'tuesday': /^tu(e(s(day)?)?)?/i,
        'wednesday': /^we(d(n(esday)?)?)?/i,
        'thursday': /^th(u(r(sday)?)?)?/i,
        'friday': /^fr(i(day)?)?/i,
        'saturday': /^sa(t(urday)?)?/i,
        'sunday': /^su(n(day)?)?/i,
        'january': /^jan(uary)?/i,
        'february': /^feb(ruary)?/i,
        'march': /^mar(ch)?/i,
        'april': /^apr(il)?/i,
        'may': /^may/i,
        'june': /^june?/i,
        'july': /^july?/i,
        'august': /^aug(ust)?/i,
        'september': /^sep(t(ember)?)?/i,
        'october': /^oct(ober)?/i,
        'november': /^nov(ember)?/i,
        'december': /^dec(ember)?/i,
        'comma': /^(,\s*|(and|or)\s*)+/i
    }
};
/* harmony default export */ __webpack_exports__["a"] = (ENGLISH);
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Time; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dateutil__ = __webpack_require__(6);




var Time = /** @class */ (function () {
    function Time(hour, minute, second, millisecond) {
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond || 0;
    }
    Time.prototype.getHours = function () {
        return this.hour;
    };
    Time.prototype.getMinutes = function () {
        return this.minute;
    };
    Time.prototype.getSeconds = function () {
        return this.second;
    };
    Time.prototype.getMilliseconds = function () {
        return this.millisecond;
    };
    Time.prototype.getTime = function () {
        return ((this.hour * 60 * 60 + this.minute * 60 + this.second) * 1000 +
            this.millisecond);
    };
    return Time;
}());

var DateTime = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DateTime, _super);
    function DateTime(year, month, day, hour, minute, second, millisecond) {
        var _this = _super.call(this, hour, minute, second, millisecond) || this;
        _this.year = year;
        _this.month = month;
        _this.day = day;
        return _this;
    }
    DateTime.fromDate = function (date) {
        return new this(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.valueOf() % 1000);
    };
    DateTime.prototype.getWeekday = function () {
        return __WEBPACK_IMPORTED_MODULE_3__dateutil__["a" /* dateutil */].getWeekday(new Date(this.getTime()));
    };
    DateTime.prototype.getTime = function () {
        return new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond)).getTime();
    };
    DateTime.prototype.getDay = function () {
        return this.day;
    };
    DateTime.prototype.getMonth = function () {
        return this.month;
    };
    DateTime.prototype.getYear = function () {
        return this.year;
    };
    DateTime.prototype.addYears = function (years) {
        this.year += years;
    };
    DateTime.prototype.addMonths = function (months) {
        this.month += months;
        if (this.month > 12) {
            var yearDiv = Math.floor(this.month / 12);
            var monthMod = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["j" /* pymod */])(this.month, 12);
            this.month = monthMod;
            this.year += yearDiv;
            if (this.month === 0) {
                this.month = 12;
                --this.year;
            }
        }
    };
    DateTime.prototype.addWeekly = function (days, wkst) {
        if (wkst > this.getWeekday()) {
            this.day += -(this.getWeekday() + 1 + (6 - wkst)) + days * 7;
        }
        else {
            this.day += -(this.getWeekday() - wkst) + days * 7;
        }
        this.fixDay();
    };
    DateTime.prototype.addDaily = function (days) {
        this.day += days;
        this.fixDay();
    };
    DateTime.prototype.addHours = function (hours, filtered, byhour) {
        if (filtered) {
            // Jump to one iteration before next day
            this.hour += Math.floor((23 - this.hour) / hours) * hours;
        }
        while (true) {
            this.hour += hours;
            var _a = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* divmod */])(this.hour, 24), dayDiv = _a.div, hourMod = _a.mod;
            if (dayDiv) {
                this.hour = hourMod;
                this.addDaily(dayDiv);
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* empty */])(byhour) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* includes */])(byhour, this.hour))
                break;
        }
    };
    DateTime.prototype.addMinutes = function (minutes, filtered, byhour, byminute) {
        if (filtered) {
            // Jump to one iteration before next day
            this.minute +=
                Math.floor((1439 - (this.hour * 60 + this.minute)) / minutes) * minutes;
        }
        while (true) {
            this.minute += minutes;
            var _a = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* divmod */])(this.minute, 60), hourDiv = _a.div, minuteMod = _a.mod;
            if (hourDiv) {
                this.minute = minuteMod;
                this.addHours(hourDiv, false, byhour);
            }
            if ((Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* empty */])(byhour) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* includes */])(byhour, this.hour)) &&
                (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* empty */])(byminute) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* includes */])(byminute, this.minute))) {
                break;
            }
        }
    };
    DateTime.prototype.addSeconds = function (seconds, filtered, byhour, byminute, bysecond) {
        if (filtered) {
            // Jump to one iteration before next day
            this.second +=
                Math.floor((86399 - (this.hour * 3600 + this.minute * 60 + this.second)) / seconds) * seconds;
        }
        while (true) {
            this.second += seconds;
            var _a = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* divmod */])(this.second, 60), minuteDiv = _a.div, secondMod = _a.mod;
            if (minuteDiv) {
                this.second = secondMod;
                this.addMinutes(minuteDiv, false, byhour, byminute);
            }
            if ((Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* empty */])(byhour) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* includes */])(byhour, this.hour)) &&
                (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* empty */])(byminute) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* includes */])(byminute, this.minute)) &&
                (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* empty */])(bysecond) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* includes */])(bysecond, this.second))) {
                break;
            }
        }
    };
    DateTime.prototype.fixDay = function () {
        if (this.day <= 28) {
            return;
        }
        var daysinmonth = __WEBPACK_IMPORTED_MODULE_3__dateutil__["a" /* dateutil */].monthRange(this.year, this.month - 1)[1];
        if (this.day <= daysinmonth) {
            return;
        }
        while (this.day > daysinmonth) {
            this.day -= daysinmonth;
            ++this.month;
            if (this.month === 13) {
                this.month = 1;
                ++this.year;
                if (this.year > __WEBPACK_IMPORTED_MODULE_3__dateutil__["a" /* dateutil */].MAXYEAR) {
                    return;
                }
            }
            daysinmonth = __WEBPACK_IMPORTED_MODULE_3__dateutil__["a" /* dateutil */].monthRange(this.year, this.month - 1)[1];
        }
    };
    DateTime.prototype.add = function (options, filtered) {
        var freq = options.freq, interval = options.interval, wkst = options.wkst, byhour = options.byhour, byminute = options.byminute, bysecond = options.bysecond;
        switch (freq) {
            case __WEBPACK_IMPORTED_MODULE_1__types__["a" /* Frequency */].YEARLY: return this.addYears(interval);
            case __WEBPACK_IMPORTED_MODULE_1__types__["a" /* Frequency */].MONTHLY: return this.addMonths(interval);
            case __WEBPACK_IMPORTED_MODULE_1__types__["a" /* Frequency */].WEEKLY: return this.addWeekly(interval, wkst);
            case __WEBPACK_IMPORTED_MODULE_1__types__["a" /* Frequency */].DAILY: return this.addDaily(interval);
            case __WEBPACK_IMPORTED_MODULE_1__types__["a" /* Frequency */].HOURLY: return this.addHours(interval, filtered, byhour);
            case __WEBPACK_IMPORTED_MODULE_1__types__["a" /* Frequency */].MINUTELY: return this.addMinutes(interval, filtered, byhour, byminute);
            case __WEBPACK_IMPORTED_MODULE_1__types__["a" /* Frequency */].SECONDLY: return this.addSeconds(interval, filtered, byhour, byminute, bysecond);
        }
    };
    return DateTime;
}(Time));

//# sourceMappingURL=datetime.js.map

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateWithZone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);


var DateWithZone = /** @class */ (function () {
    function DateWithZone(date, tzid) {
        this.date = date;
        this.tzid = tzid;
    }
    Object.defineProperty(DateWithZone.prototype, "isUTC", {
        get: function () {
            return !this.tzid || this.tzid.toUpperCase() === 'UTC';
        },
        enumerable: true,
        configurable: true
    });
    DateWithZone.prototype.toString = function () {
        var datestr = __WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].timeToUntilString(this.date.getTime(), this.isUTC);
        if (!this.isUTC) {
            return ";TZID=" + this.tzid + ":" + datestr;
        }
        return ":" + datestr;
    };
    DateWithZone.prototype.getTime = function () {
        return this.date.getTime();
    };
    DateWithZone.prototype.rezonedDate = function () {
        if (this.isUTC) {
            return this.date;
        }
        try {
            var datetime = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"]
                .fromJSDate(this.date);
            var rezoned = datetime.setZone(this.tzid, { keepLocalTime: true });
            return rezoned.toJSDate();
        }
        catch (e) {
            if (e instanceof TypeError) {
                console.error('Using TZID without Luxon available is unsupported. Returned times are in UTC, not the requested time zone');
            }
            return this.date;
        }
    };
    return DateWithZone;
}());

//# sourceMappingURL=datewithzone.js.map

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n\n<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">{{vm.mode == 'edit' ? 'Edit' : 'Add'}} Multi-Use RTMP Destination</h3>\n</div>\n<div class=\"modal-body\">\n  <div style=\"margin:0 0 15px 0\">\n    <label>Name</label>\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.config.name\" id=\"name\" name=\"name\" ng-maxlength=\"::vm.limits.name\" placeholder=\"e.g. Destination Name\" required>\n    <p ng-show=\"(form.name.$dirty || form.name.$touched) && !vm.config.name\">\n      <span class=\"text-danger\" ng-if=\"form.name.$error.maxlength\">The name is too long.</span>\n      <span class=\"text-danger\" ng-if=\"form.name.$error.required\">The name cannot be blank.</span>\n    </p>\n  </div>\n  <div style=\"margin:0 0 15px 0\">\n    <label>Server URL</label>\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.config.stream_url\" id=\"stream_url\" name=\"stream_url\" not-boxcast placeholder=\"e.g. rtmp://rtmp.service.com/live\" required>\n    <p>\n      <span class=\"text-danger\" ng-if=\"form.stream_url.$error.notBoxcast\">The stream URL cannot point to BoxCast.</span>\n    </p>\n  </div>\n  <div style=\"margin:0 0 15px 0\">\n    <label>Stream Key</label>\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.config.stream_key\" id=\"stream_key\" name=\"stream_key\" ng-maxlength=\"::vm.limits.stream_key\" required>\n    <p ng-show=\"(form.stream_key.$dirty || form.stream_key.$touched) && !vm.config.stream_key\">\n      <span class=\"text-danger\" ng-if=\"form.stream_key.$error.maxlength\">The stream key is too long.</span>\n      <span class=\"text-danger\" ng-if=\"form.stream_key.$error.required\">The stream key cannot be blank.</span>\n    </p>\n  </div>\n  <div style=\"margin:0 0 10px 0\">\n    <span id=\"use_authentication\" ng-click=\"vm.useAuthentication = !vm.useAuthentication;\" style=\"cursor:pointer;opacity:0.8\">\n      <i class=\"fa\" ng-class=\"vm.useAuthentication ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n    </span>\n    <label for=\"use_authentication\">Use Authentication (Username and Password)</label>\n  </div>\n  <div style=\"margin:0 15px\" ng-if=\"vm.useAuthentication\">\n    <div style=\"margin:0 0 15px 0\">\n      <label>Username</label>\n      <input type=\"text\" class=\"form-control\" ng-model=\"vm.config.username\" required>\n    </div>\n    <div style=\"margin:0 0 15px 0\">\n      <label>Password</label>\n      <input type=\"password\" class=\"form-control\" ng-model=\"vm.config.password\" required>\n    </div>\n  </div>\n  <div style=\"margin:0 0 10px 0\">\n    <label>Max Resolution</label>\n    <select class=\"form-control\"\n            ng-model=\"vm.config.max_resolution\"\n            ng-options=\"+(o.id) as o.text for o in [\n              {id: 0, text: 'None (use highest)'},\n              {id: 1080, text: '1080p'},\n              {id: 720, text: '720p'},\n              {id: 480, text: '480p'}\n            ]\">\n    </select>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Close</button>\n  <button class=\"btn btn-primary\" ng-click=\"vm.submit()\" ng-disabled=\"vm.submitting\">\n    <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n    Save Changes\n  </button>\n</div>\n\n</form>\n"

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalAddMultiUseRTMPChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_rtmp__ = __webpack_require__(24);


function validateStreamKey(key) {
  return !(!key || /^\s*$/.test(key));
}

function ModalAddMultiUseRTMPChannel(mode, config, RTMPPushChannel, toaster, $rootScope, $uibModalInstance) {
  'ngInject'; // passed in via `resolve`

  var _this = this;

  this.mode = mode;
  this.config = angular.copy(config);
  this.useAuthentication = this.config.username && this.config.password;
  this.limits = $rootScope.ApiConfig.modelFieldLimits('rtmp_push_channel', 'maximum');

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.submit = function () {
    if (!_this.config.name || !Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["a" /* IsRtmpURLValid */])(_this.config.stream_url) || !validateStreamKey(_this.config.stream_key)) {
      alert('Please enter a valid name, stream URL, and stream key.');
      return;
    }

    if (!_this.useAuthentication) {
      delete _this.config.username;
      delete _this.config.password;
    }

    _this.submitting = true;
    RTMPPushChannel[_this.mode == 'add' ? 'create' : 'update'](_this.config, function (r) {
      $uibModalInstance.close(r);
    }, function (e) {
      console.error(e);
      toaster.pop('warning', 'Unable to save RTMP configuration. Please refresh and try again.');
      _this.submitting = false;
    });
  };
}

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = sourceType;
/* harmony export (immutable) */ __webpack_exports__["b"] = sourceRtmpStatus;
/* harmony export (immutable) */ __webpack_exports__["a"] = sortSources;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

/**
 * Determines whether a source should be broadcasting or not.
 *
 * @param  {Object} source An object representing the source (a BoxCaster, Broadcaster app, or RTMP
 *                         channel). BoxCaster and RTMP sources will have a `next_broadcast_at`
 *                         member; Broadcaster sources will have `details.starts_at`.
 * @return {Boolean}       `true` if the source should be broadcasting; `false` if it should not
 *                         (or the parameters don't make sense).
 */

function sourceShouldBeBroadcasting(source) {
  if (source.next_broadcast_at) {
    return Date.now() > __WEBPACK_IMPORTED_MODULE_0_moment___default()(source.next_broadcast_at);
  } else if (source.details && source.details.starts_at) {
    return Date.now() > __WEBPACK_IMPORTED_MODULE_0_moment___default()(source.details.starts_at);
  } else {
    return false;
  }
}
/**
 * Returns a string describing the source type.
 *
 * @param  {Object} source An object representing the source (a BoxCaster, Broadcaster app, RTMP
 *                         channel, or Producer). RTMP sources will have a `server_url` member; Broadcaster
 *                         sources will have `is_broadcaster`. Producer will have `is_producer`. All others
 *                         are assumed to be BoxCasters.
 * @return {String}        `'rtmp'` for RTMP sources; `'broadcaster'` for Broadcaster sources;
 *                         `'boxcaster'` for BoxCaster sources; `null` if the parameters don't make
 *                         sense. `'producer'` for producer
 */


function sourceType(source) {
  if (!source) {
    return null;
  } else if (source.server_url) {
    return 'rtmp';
  } else if (source.is_broadcaster) {
    return 'broadcaster';
  } else if (source.is_producer) {
    return 'producer';
  } else {
    return 'boxcaster';
  }
}
/**
 * Returns a string describing the source status (if it is an RTMP source).
 *
 * @param  {Object} source                 An object representing the RTMP source.
 * @param  {Object} broadcastsByStaticRTMP A hash of broadcasts from static RTMP sources, keyed by
 *                                         static RTMP ID (used to determine if an RTMP source is
 *                                         actually broadcasting or simply streaming to the proxy).
 * @return {String}                        `'offline'` if there are no diagnostics, or the
 *                                         diagnostics indicate the source is not connected;
 *                                         `'connected'` if the source is connected and
 *                                         broadcasting, but there doesn't appear to be an active
 *                                         broadcast using that source ID; `'broadcasting'` in all
 *                                         other cases.
 */

function sourceRtmpStatus(source, broadcastsByStaticRTMP) {
  // broadcastsByStaticRTMP may not be provided, e.g., in unit tests. In that case, initialize it
  // to an empty object.
  if (!broadcastsByStaticRTMP) {
    broadcastsByStaticRTMP = {};
  }

  if (source.diagnostics === undefined || !source.diagnostics.connected) {
    return 'offline';
  }

  if (!source.diagnostics.broadcasting || broadcastsByStaticRTMP[source.id] === undefined) {
    return 'connected';
  }

  return 'broadcasting';
}

function isAlphanum(charCode) {
  // 46 == '.'
  // 48-57 == '0'-'9'
  return charCode == 46 || charCode >= 48 && charCode <= 57;
}
/**
 * Sorts an array of sources in a sensible, human-readable way. Generally, sources with somehting
 * important going on (should be broadcasting, is broadcasting, etc.) are elevated to the top,
 * while the rest are sorted alphanumerically and case-insensitively. The sources are sorted in
 * place.
 *
 * The algorithm used here is loosely based on the one described at
 * http://www.davekoelle.com/alphanum.html, but modified for this specific use case.
 *
 * @param  {Object} sources                A list of sources to be sorted.
 * @param  {Object} broadcastsByStaticRTMP A hash of broadcasts from static RTMP sources, keyed by
 *                                         static RTMP ID (used to determine if an RTMP source is
 *                                         actually broadcasting or simply streaming to the proxy).
 */


function sortSources(sources, broadcastsByStaticRTMP) {
  // broadcastsByStaticRTMP may not be provided, e.g., in unit tests. In that case, initialize it
  // to an empty object.
  if (!broadcastsByStaticRTMP) {
    broadcastsByStaticRTMP = {};
  } // First, chunk source names into a new property on each source


  for (var z = 0, t; t = sources[z]; z++) {
    t._chunkedName = new Array();
    var x = 0,
        y = -1,
        n = 0,
        i = void 0,
        j = void 0;

    while (i = (j = t.name.charAt(x++)).charCodeAt(0)) {
      var m = isAlphanum(i);

      if (m !== n) {
        t._chunkedName[++y] = '';
        n = m;
      }

      t._chunkedName[y] += j;
    }
  } // (De-)escalate as needed by putting a new chunk in front of the chunked name


  for (var _z = 0, source; source = sources[_z]; _z++) {
    if (sourceType(source) == 'boxcaster') {
      var order = ['broadcasting', 'preparing_broadcast', 'ready'].indexOf(source.status);

      if (order >= 0) {
        source._chunkedName.unshift("AAA-".concat(order + 1));
      } else if (sourceShouldBeBroadcasting(source)) {
        source._chunkedName.unshift('AAA-0'); // error state, bubble it up

      } else {
        source._chunkedName.unshift('ZZZ');
      }
    } else if (sourceType(source) == 'rtmp') {
      var s = sourceRtmpStatus(source, broadcastsByStaticRTMP);

      if (s == 'broadcasting') {
        source._chunkedName.unshift('AAA-1');
      } else if (s == 'connected') {
        source._chunkedName.unshift('AAA-3');
      } else {
        source._chunkedName.unshift('ZZZ');
      }
    } else if (sourceType(source) == 'broadcaster') {
      if (sourceShouldBeBroadcasting(source)) {
        source._chunkedName.unshift('AAA-0'); // push Broadcaster up when it should be broadcasting

      } else {
        source._chunkedName.unshift('ZZZ');
      }
    }
  } // Now sort by the chunked name (alphanumeric portions are compared as numbers)


  sources.sort(function (a, b) {
    for (var _x = 0, aa, bb; (aa = a._chunkedName[_x]) && (bb = b._chunkedName[_x]); _x++) {
      aa = aa.toLowerCase();
      bb = bb.toLowerCase();

      if (aa !== bb) {
        var c = Number(aa),
            d = Number(bb);

        if (c == aa && d == bb) {
          return c - d;
        } else {
          return aa > bb ? 1 : -1;
        }
      }
    }

    return a._chunkedName.length - b._chunkedName.length;
  }); // Now delete our temporary property

  for (var _z2 = 0; _z2 < sources.length; _z2++) {
    delete sources[_z2]._chunkedName;
  }
}

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (e, r) {
  'object' == ( false ? "undefined" : _typeof(exports)) && 'object' == ( false ? "undefined" : _typeof(module)) ? module.exports = r() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (r),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 'object' == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.postRobot = r() : e.postRobot = r();
}(this, function () {
  return function (e) {
    function r(t) {
      if (n[t]) return n[t].exports;
      var o = n[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    var n = {};
    return r.m = e, r.c = n, r.i = function (e) {
      return e;
    }, r.d = function (e, n, t) {
      r.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: t
      });
    }, r.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return r.d(n, 'a', n), n;
    }, r.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, r.p = '', r(r.s = 26);
  }([function (e, r, n) {
    'use strict';

    var t = n(22);
    n.d(r, 'a', function () {
      return t.a;
    });
    var o = n(11);
    n.d(r, 'b', function () {
      return o.a;
    }), n.d(r, 'c', function () {
      return o.b;
    });
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      var r = e.location;
      if (!r) throw new Error('Can not read window location');
      var n = r.protocol;
      if (!n) throw new Error('Can not read window protocol');
      if (n === A.FILE_PROTOCOL) return A.FILE_PROTOCOL + '//';
      var t = r.host;
      if (!t) throw new Error('Can not read window host');
      return n + '//' + t;
    }

    function o(e) {
      e = e || window;
      var r = t(e);
      return r && e.mockDomain && 0 === e.mockDomain.indexOf(A.MOCK_PROTOCOL) ? e.mockDomain : r;
    }

    function i(e) {
      try {
        if (!e.location.href) return !0;
        if ('about:blank' === e.location.href) return !0;
      } catch (e) {}

      return !1;
    }

    function a(e) {
      try {
        var r = Object.getOwnPropertyDescriptor(e, 'location');
        if (r && !1 === r.enumerable) return !1;
      } catch (e) {}

      try {
        if (i(e)) return !0;
        if (t(e) === t(window)) return !0;
      } catch (e) {}

      return !1;
    }

    function u(e) {
      if (!a(e)) return !1;

      try {
        if (i(e)) return !0;
        if (o(window) === o(e)) return !0;
      } catch (e) {}

      return !1;
    }

    function c(e) {
      if (e) try {
        if (e.parent && e.parent !== e) return e.parent;
      } catch (e) {
        return;
      }
    }

    function s(e) {
      if (e && !c(e)) try {
        return e.opener;
      } catch (e) {
        return;
      }
    }

    function f(e) {
      var r = [];

      try {
        for (; e.parent !== e;) {
          r.push(e.parent), e = e.parent;
        }
      } catch (e) {}

      return r;
    }

    function d(e, r) {
      if (!e || !r) return !1;
      var n = c(r);
      return n ? n === e : -1 !== f(r).indexOf(e);
    }

    function l(e) {
      var r = [],
          n = void 0;

      try {
        n = e.frames;
      } catch (r) {
        n = e;
      }

      var t = void 0;

      try {
        t = n.length;
      } catch (e) {}

      if (0 === t) return r;

      if (t) {
        for (var o = 0; o < t; o++) {
          var i = void 0;

          try {
            i = n[o];
          } catch (e) {
            continue;
          }

          r.push(i);
        }

        return r;
      }

      for (var a = 0; a < 100; a++) {
        var u = void 0;

        try {
          u = n[a];
        } catch (e) {
          return r;
        }

        if (!u) return r;
        r.push(u);
      }

      return r;
    }

    function w(e) {
      for (var r = [], n = l(e), t = Array.isArray(n), o = 0, n = t ? n : n[Symbol.iterator]();;) {
        var i;

        if (t) {
          if (o >= n.length) break;
          i = n[o++];
        } else {
          if (o = n.next(), o.done) break;
          i = o.value;
        }

        var a = i;
        r.push(a);

        for (var u = w(a), c = Array.isArray(u), s = 0, u = c ? u : u[Symbol.iterator]();;) {
          var f;

          if (c) {
            if (s >= u.length) break;
            f = u[s++];
          } else {
            if (s = u.next(), s.done) break;
            f = s.value;
          }

          var d = f;
          r.push(d);
        }
      }

      return r;
    }

    function h(e) {
      if (e) {
        try {
          if (e.top) return e.top;
        } catch (e) {}

        if (c(e) === e) return e;

        try {
          if (d(window, e) && window.top) return window.top;
        } catch (e) {}

        try {
          if (d(e, window) && window.top) return window.top;
        } catch (e) {}

        for (var r = w(e), n = Array.isArray(r), t = 0, r = n ? r : r[Symbol.iterator]();;) {
          var o;

          if (n) {
            if (t >= r.length) break;
            o = r[t++];
          } else {
            if (t = r.next(), t.done) break;
            o = t.value;
          }

          var i = o;

          try {
            if (i.top) return i.top;
          } catch (e) {}

          if (c(i) === i) return i;
        }
      }
    }

    function p(e) {
      if (!e.contentWindow) return !0;
      if (!e.parentNode) return !0;
      var r = e.ownerDocument;
      return !(!r || !r.body || r.body.contains(e));
    }

    function v(e, r) {
      for (var n = 0; n < e.length; n++) {
        try {
          if (e[n] === r) return n;
        } catch (e) {}
      }

      return -1;
    }

    function y(e) {
      var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

      try {
        if (e === window) return !1;
      } catch (e) {
        return !0;
      }

      try {
        if (!e) return !0;
      } catch (e) {
        return !0;
      }

      try {
        if (e.closed) return !0;
      } catch (e) {
        return !e || e.message !== P;
      }

      if (r && u(e)) try {
        if (e.mockclosed) return !0;
      } catch (e) {}

      try {
        if (!e.parent || !e.top) return !0;
      } catch (e) {}

      try {
        n.i(g.a)(e === e);
      } catch (e) {
        return !0;
      }

      var t = v(T, e);

      if (-1 !== t) {
        var o = R[t];
        if (o && p(o)) return !0;
      }

      return !1;
    }

    function m(e) {
      e = e || window;
      var r = s(e);
      if (r) return r;
      var n = c(e);
      return n || void 0;
    }

    function b(e, r) {
      var n = m(r);
      if (n) return n === e;
      if (r === e) return !1;
      if (h(r) === r) return !1;

      for (var t = l(e), o = Array.isArray(t), i = 0, t = o ? t : t[Symbol.iterator]();;) {
        var a;

        if (o) {
          if (i >= t.length) break;
          a = t[i++];
        } else {
          if (i = t.next(), i.done) break;
          a = i.value;
        }

        if (a === r) return !0;
      }

      return !1;
    }

    function E() {
      return Boolean(s(window));
    }

    function _() {
      return Boolean(c(window));
    }

    function S(e, r) {
      if ('string' == typeof e) {
        if ('string' == typeof r) return e === A.WILDCARD || r === e;
        if (n.i(g.b)(r)) return !1;
        if (Array.isArray(r)) return !1;
      }

      return n.i(g.b)(e) ? n.i(g.b)(r) ? e.toString() === r.toString() : !Array.isArray(r) && Boolean(r.match(e)) : !!Array.isArray(e) && (Array.isArray(r) ? JSON.stringify(e) === JSON.stringify(r) : !n.i(g.b)(r) && e.some(function (e) {
        return S(e, r);
      }));
    }

    function O(e) {
      try {
        if (e === window) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        if ('[object Window]' === Object.prototype.toString.call(e)) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        if (window.Window && e instanceof window.Window) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        if (e && e.self === e) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        if (e && e.parent === e) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        if (e && e.top === e) return !0;
      } catch (e) {
        if (e && e.message === P) return !0;
      }

      try {
        n.i(g.a)(e === e);
      } catch (e) {
        return !0;
      }

      try {
        n.i(g.a)(e && e.__cross_domain_utils_window_check__);
      } catch (e) {
        return !0;
      }

      return !1;
    }

    r.i = t, r.g = o, r.h = a, r.f = y, r.a = m, r.j = b, r.c = E, r.d = _, r.b = S, r.e = O;
    var g = n(17),
        A = {
      MOCK_PROTOCOL: 'mock:',
      FILE_PROTOCOL: 'file:',
      WILDCARD: '*'
    },
        P = 'Call was rejected by callee.\r\n',
        T = [],
        R = [];
  }, function (e, r, n) {
    'use strict';

    var t = n(19);
    n.d(r, 'a', function () {
      return t.a;
    });
  }, function (e, r, n) {
    'use strict';

    n.d(r, 'a', function () {
      return o;
    });
    var t = n(0),
        o = window[t.b.WINDOW_PROPS.POSTROBOT] = window[t.b.WINDOW_PROPS.POSTROBOT] || {};

    o.registerSelf = function () {};
  }, function (e, r, n) {
    'use strict';

    var t = n(8);
    n.d(r, 'c', function () {
      return t.a;
    }), n.d(r, 'd', function () {
      return t.f;
    }), n.d(r, 'e', function () {
      return t.d;
    }), n.d(r, 'h', function () {
      return t.c;
    }), n.d(r, 'i', function () {
      return t.b;
    }), n.d(r, 'j', function () {
      return t.h;
    }), n.d(r, 'l', function () {
      return t.i;
    }), n.d(r, 'm', function () {
      return t.j;
    }), n.d(r, 'n', function () {
      return t.e;
    }), n.d(r, 'o', function () {
      return t.k;
    });
    var o = n(9);
    n.d(r, 'g', function () {
      return o.a;
    });
    var i = n(28);
    n.d(r, 'b', function () {
      return i.a;
    }), n.d(r, 'f', function () {
      return i.b;
    }), n.d(r, 'k', function () {
      return i.c;
    });
    var a = n(27);
    n.d(r, 'a', function () {
      return a.a;
    }), n.d(r, 'p', function () {
      return a.b;
    });
  }, function (e, r, n) {
    'use strict';

    var t = n(23);
    n.d(r, 'a', function () {
      return t.a;
    }), n.d(r, 'b', function () {
      return t.b;
    });
    var o = n(13);
    n.d(r, 'e', function () {
      return o.a;
    });
    var i = n(12);
    n.d(r, 'c', function () {
      return i.e;
    }), n.d(r, 'd', function () {
      return i.f;
    }), n.d(r, 'f', function () {
      return i.g;
    }), n.d(r, 'g', function () {
      return i.d;
    });
  }, function (e, r, n) {
    'use strict';

    function t() {
      a.a.initialized || (n.i(i.a)(), n.i(o.a)(), n.i(o.b)()), a.a.initialized = !0;
    }

    Object.defineProperty(r, '__esModule', {
      value: !0
    }), r.init = t, n.d(r, 'bridge', function () {
      return f;
    });
    var o = n(4),
        i = n(5),
        a = n(3),
        u = n(21);
    n.d(r, 'cleanUpWindow', function () {
      return u.a;
    });
    var c = n(31);
    n.d(r, 'parent', function () {
      return c.a;
    }), n.d(r, 'send', function () {
      return c.b;
    }), n.d(r, 'request', function () {
      return c.c;
    }), n.d(r, 'sendToParent', function () {
      return c.d;
    }), n.d(r, 'client', function () {
      return c.e;
    }), n.d(r, 'on', function () {
      return c.f;
    }), n.d(r, 'listen', function () {
      return c.g;
    }), n.d(r, 'once', function () {
      return c.h;
    }), n.d(r, 'listener', function () {
      return c.i;
    }), n.d(r, 'CONFIG', function () {
      return c.j;
    }), n.d(r, 'CONSTANTS', function () {
      return c.k;
    }), n.d(r, 'disable', function () {
      return c.l;
    });
    var s = n(2);
    n.d(r, 'Promise', function () {
      return s.a;
    }), t();
    var f = null;
  }, function (e, r, n) {
    'use strict';

    var t = n(10);
    n.d(r, 'a', function () {
      return t.WeakMap;
    });
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
      if (r >= 3) return 'stringifyError stack overflow';

      try {
        if (!e) return '<unknown error: ' + Object.prototype.toString.call(e) + '>';
        if ('string' == typeof e) return e;

        if (e instanceof Error) {
          var n = e && e.stack,
              o = e && e.message;
          if (n && o) return -1 !== n.indexOf(o) ? n : o + '\n' + n;
          if (n) return n;
          if (o) return o;
        }

        return 'function' == typeof e.toString ? e.toString() : Object.prototype.toString.call(e);
      } catch (e) {
        return 'Error while stringifying error: ' + t(e, r + 1);
      }
    }

    function o() {}

    function i(e, r, n) {
      return e.addEventListener ? e.addEventListener(r, n) : e.attachEvent('on' + r, n), {
        cancel: function cancel() {
          e.removeEventListener ? e.removeEventListener(r, n) : e.detachEvent('on' + r, n);
        }
      };
    }

    function a() {
      var e = '0123456789abcdef';
      return 'xxxxxxxxxx'.replace(/./g, function () {
        return e.charAt(Math.floor(Math.random() * e.length));
      });
    }

    function u(e, r) {
      for (var n = 0; n < e.length; n++) {
        r(e[n], n);
      }
    }

    function c(e, r) {
      for (var n in e) {
        e.hasOwnProperty(n) && r(e[n], n);
      }
    }

    function s(e, r) {
      Array.isArray(e) ? u(e, r) : 'object' === (void 0 === e ? 'undefined' : m(e)) && null !== e && c(e, r);
    }

    function f(e, r) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
      if (n >= 100) throw new Error('Self-referential object passed, or object contained too many layers');
      var t = void 0;

      if ('object' !== (void 0 === e ? 'undefined' : m(e)) || null === e || Array.isArray(e)) {
        if (!Array.isArray(e)) throw new Error('Invalid type: ' + (void 0 === e ? 'undefined' : m(e)));
        t = [];
      } else t = {};

      return s(e, function (e, o) {
        var i = r(e, o);
        void 0 !== i ? t[o] = i : 'object' === (void 0 === e ? 'undefined' : m(e)) && null !== e ? t[o] = f(e, r, n + 1) : t[o] = e;
      }), t;
    }

    function d(e, r) {
      function n() {
        t = setTimeout(n, r), e.call();
      }

      var t = void 0;
      return t = setTimeout(n, r), {
        cancel: function cancel() {
          clearTimeout(t);
        }
      };
    }

    function l(e) {
      return '[object RegExp]' === Object.prototype.toString.call(e);
    }

    function w() {
      return n.i(v.c)() ? y.b.WINDOW_TYPES.POPUP : n.i(v.d)() ? y.b.WINDOW_TYPES.IFRAME : y.b.WINDOW_TYPES.FULLPAGE;
    }

    function h(e, r, n) {
      var t = void 0,
          o = void 0;

      try {
        if ('{}' !== JSON.stringify({}) && (t = Object.prototype.toJSON, delete Object.prototype.toJSON), '{}' !== JSON.stringify({})) throw new Error('Can not correctly serialize JSON objects');
        if ('[]' !== JSON.stringify([]) && (o = Array.prototype.toJSON, delete Array.prototype.toJSON), '[]' !== JSON.stringify([])) throw new Error('Can not correctly serialize JSON objects');
      } catch (e) {
        throw new Error('Can not repair JSON.stringify: ' + e.message);
      }

      var i = JSON.stringify.call(this, e, r, n);

      try {
        t && (Object.prototype.toJSON = t), o && (Array.prototype.toJSON = o);
      } catch (e) {
        throw new Error('Can not repair JSON.stringify: ' + e.message);
      }

      return i;
    }

    function p(e) {
      return JSON.parse(e);
    }

    r.b = t, n.d(r, 'e', function () {
      return b;
    }), r.j = o, r.i = i, r.f = a, r.g = f, r.k = d, r.a = l, r.d = w, r.c = h, r.h = p;

    var v = (n(7), n(1)),
        y = n(0),
        m = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
    },
        b = function b(e) {
      if (!e) return e;
      var r = !1;
      return function () {
        if (!r) return r = !0, e.apply(this, arguments);
      };
    };
  }, function (e, r, n) {
    'use strict';

    n.d(r, 'a', function () {
      return u;
    });
    var t = n(8),
        o = n(0),
        i = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
    },
        a = ['debug', 'info', 'warn', 'error'];
    Function.prototype.bind && window.console && 'object' === i(console.log) && ['log', 'info', 'warn', 'error'].forEach(function (e) {
      console[e] = this.bind(console[e], console);
    }, Function.prototype.call);
    var u = {
      clearLogs: function clearLogs() {
        if (window.console && window.console.clear && window.console.clear(), o.a.LOG_TO_PAGE) {
          var e = document.getElementById('postRobotLogs');
          e && e.parentNode && e.parentNode.removeChild(e);
        }
      },
      writeToPage: function writeToPage(e, r) {
        setTimeout(function () {
          var o = document.getElementById('postRobotLogs');
          o || (o = document.createElement('div'), o.id = 'postRobotLogs', o.style.cssText = 'width: 800px; font-family: monospace; white-space: pre-wrap;', document.body && document.body.appendChild(o));
          var i = document.createElement('div'),
              a = new Date().toString().split(' ')[4],
              u = Array.prototype.slice.call(r).map(function (e) {
            if ('string' == typeof e) return e;
            if (!e) return Object.prototype.toString.call(e);
            var r = void 0;

            try {
              r = n.i(t.c)(e, null, 2);
            } catch (e) {
              r = '[object]';
            }

            return '\n\n' + r + '\n\n';
          }).join(' '),
              c = a + ' ' + e + ' ' + u;
          i.innerHTML = c;
          var s = {
            log: '#ddd',
            warn: 'orange',
            error: 'red',
            info: 'blue',
            debug: '#aaa'
          }[e];
          i.style.cssText = 'margin-top: 10px; color: ' + s + ';', o.childNodes.length ? o.insertBefore(i, o.childNodes[0]) : o.appendChild(i);
        });
      },
      logLevel: function logLevel(e, r) {
        setTimeout(function () {
          try {
            var i = window.LOG_LEVEL || o.a.LOG_LEVEL;
            if (a.indexOf(e) < a.indexOf(i)) return;
            if (r = Array.prototype.slice.call(r), r.unshift('' + window.location.host + window.location.pathname), r.unshift('::'), r.unshift('' + n.i(t.d)().toLowerCase()), r.unshift('[post-robot]'), o.a.LOG_TO_PAGE && u.writeToPage(e, r), !window.console) return;
            if (window.console[e] || (e = 'log'), !window.console[e]) return;
            window.console[e].apply(window.console, r);
          } catch (e) {}
        }, 1);
      },
      debug: function debug() {
        for (var e = arguments.length, r = Array(e), n = 0; n < e; n++) {
          r[n] = arguments[n];
        }

        u.logLevel('debug', r);
      },
      info: function info() {
        for (var e = arguments.length, r = Array(e), n = 0; n < e; n++) {
          r[n] = arguments[n];
        }

        u.logLevel('info', r);
      },
      warn: function warn() {
        for (var e = arguments.length, r = Array(e), n = 0; n < e; n++) {
          r[n] = arguments[n];
        }

        u.logLevel('warn', r);
      },
      error: function error() {
        for (var e = arguments.length, r = Array(e), n = 0; n < e; n++) {
          r[n] = arguments[n];
        }

        u.logLevel('error', r);
      }
    };
  }, function (e, r, n) {
    'use strict';

    Object.defineProperty(r, '__esModule', {
      value: !0
    });
    var t = n(16);
    n.d(r, 'WeakMap', function () {
      return t.a;
    });
  }, function (e, r, n) {
    'use strict';

    n.d(r, 'a', function () {
      return t;
    }), n.d(r, 'b', function () {
      return o;
    });
    var t = {
      POST_MESSAGE_TYPE: {
        REQUEST: 'postrobot_message_request',
        RESPONSE: 'postrobot_message_response',
        ACK: 'postrobot_message_ack'
      },
      POST_MESSAGE_ACK: {
        SUCCESS: 'success',
        ERROR: 'error'
      },
      POST_MESSAGE_NAMES: {
        METHOD: 'postrobot_method',
        READY: 'postrobot_ready',
        OPEN_TUNNEL: 'postrobot_open_tunnel'
      },
      WINDOW_TYPES: {
        FULLPAGE: 'fullpage',
        POPUP: 'popup',
        IFRAME: 'iframe'
      },
      WINDOW_PROPS: {
        POSTROBOT: '__postRobot__'
      },
      SERIALIZATION_TYPES: {
        METHOD: 'postrobot_method',
        ERROR: 'postrobot_error',
        PROMISE: 'postrobot_promise',
        ZALGO_PROMISE: 'postrobot_zalgo_promise',
        REGEX: 'regex'
      },
      SEND_STRATEGIES: {
        POST_MESSAGE: 'postrobot_post_message',
        BRIDGE: 'postrobot_bridge',
        GLOBAL: 'postrobot_global'
      },
      MOCK_PROTOCOL: 'mock:',
      FILE_PROTOCOL: 'file:',
      BRIDGE_NAME_PREFIX: '__postrobot_bridge__',
      POSTROBOT_PROXY: '__postrobot_proxy__',
      WILDCARD: '*'
    },
        o = Object.keys(t.POST_MESSAGE_NAMES).map(function (e) {
      return t.POST_MESSAGE_NAMES[e];
    });
  }, function (e, r, n) {
    'use strict';

    function t(e, r) {
      l.a.responseListeners[e] = r;
    }

    function o(e) {
      return l.a.responseListeners[e];
    }

    function i(e) {
      delete l.a.responseListeners[e];
    }

    function a(e) {
      l.a.erroredResponseListeners[e] = !0;
    }

    function u(e) {
      return Boolean(l.a.erroredResponseListeners[e]);
    }

    function c(e) {
      var r = e.name,
          t = e.win,
          o = e.domain;
      if (t === h.b.WILDCARD && (t = null), o === h.b.WILDCARD && (o = null), !r) throw new Error('Name required to get request listener');
      var i = l.a.requestListeners[r];
      if (i) for (var a = [t, l.a.WINDOW_WILDCARD], u = 0; u < a.length; u++) {
        var c = a[u],
            s = c && i.get(c);

        if (s) {
          if (o && 'string' == typeof o) {
            if (s[o]) return s[o];
            if (s[p]) for (var f = s[p], w = Array.isArray(f), v = 0, f = w ? f : f[Symbol.iterator]();;) {
              var y;

              if (w) {
                if (v >= f.length) break;
                y = f[v++];
              } else {
                if (v = f.next(), v.done) break;
                y = v.value;
              }

              var m = y,
                  b = m.regex,
                  E = m.listener;
              if (n.i(d.b)(b, o)) return E;
            }
          }

          if (s[h.b.WILDCARD]) return s[h.b.WILDCARD];
        }
      }
    }

    function s(e, r) {
      var t = e.name,
          o = e.win,
          i = e.domain;
      if (!t || 'string' != typeof t) throw new Error('Name required to add request listener');

      if (Array.isArray(o)) {
        for (var a = [], u = o, d = Array.isArray(u), v = 0, u = d ? u : u[Symbol.iterator]();;) {
          var y;

          if (d) {
            if (v >= u.length) break;
            y = u[v++];
          } else {
            if (v = u.next(), v.done) break;
            y = v.value;
          }

          var m = y;
          a.push(s({
            name: t,
            domain: i,
            win: m
          }, r));
        }

        return {
          cancel: function cancel() {
            for (var e = a, r = Array.isArray(e), n = 0, e = r ? e : e[Symbol.iterator]();;) {
              var t;

              if (r) {
                if (n >= e.length) break;
                t = e[n++];
              } else {
                if (n = e.next(), n.done) break;
                t = n.value;
              }

              t.cancel();
            }
          }
        };
      }

      if (Array.isArray(i)) {
        for (var b = [], E = i, _ = Array.isArray(E), S = 0, E = _ ? E : E[Symbol.iterator]();;) {
          var O;

          if (_) {
            if (S >= E.length) break;
            O = E[S++];
          } else {
            if (S = E.next(), S.done) break;
            O = S.value;
          }

          var g = O;
          b.push(s({
            name: t,
            win: o,
            domain: g
          }, r));
        }

        return {
          cancel: function cancel() {
            for (var e = b, r = Array.isArray(e), n = 0, e = r ? e : e[Symbol.iterator]();;) {
              var t;

              if (r) {
                if (n >= e.length) break;
                t = e[n++];
              } else {
                if (n = e.next(), n.done) break;
                t = n.value;
              }

              t.cancel();
            }
          }
        };
      }

      var A = c({
        name: t,
        win: o,
        domain: i
      });
      if (o && o !== h.b.WILDCARD || (o = l.a.WINDOW_WILDCARD), i = i || h.b.WILDCARD, A) throw o && i ? new Error('Request listener already exists for ' + t + ' on domain ' + i.toString() + ' for ' + (o === l.a.WINDOW_WILDCARD ? 'wildcard' : 'specified') + ' window') : o ? new Error('Request listener already exists for ' + t + ' for ' + (o === l.a.WINDOW_WILDCARD ? 'wildcard' : 'specified') + ' window') : i ? new Error('Request listener already exists for ' + t + ' on domain ' + i.toString()) : new Error('Request listener already exists for ' + t);
      var P = l.a.requestListeners,
          T = P[t];
      T || (T = new f.a(), P[t] = T);
      var R = T.get(o);
      R || (R = {}, T.set(o, R));
      var L = i.toString(),
          I = R[p],
          k = void 0;
      return n.i(w.c)(i) ? (I || (I = [], R[p] = I), k = {
        regex: i,
        listener: r
      }, I.push(k)) : R[L] = r, {
        cancel: function cancel() {
          R && (delete R[L], o && 0 === Object.keys(R).length && T["delete"](o), k && I.splice(I.indexOf(k, 1)));
        }
      };
    }

    r.f = t, r.b = o, r.d = i, r.g = a, r.a = u, r.c = c, r.e = s;
    var f = (n(2), n(7)),
        d = n(1),
        l = n(3),
        w = n(4),
        h = n(0);
    l.a.responseListeners = l.a.responseListeners || {}, l.a.requestListeners = l.a.requestListeners || {}, l.a.WINDOW_WILDCARD = l.a.WINDOW_WILDCARD || new function () {}(), l.a.erroredResponseListeners = l.a.erroredResponseListeners || {};
    var p = '__domain_regex__';
  }, function (e, r, n) {
    'use strict';

    function t(e, r, n) {
      return r in e ? Object.defineProperty(e, r, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = n, e;
    }

    function o(e, r) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = n.i(s.d)(),
          i = n.i(s.e)(),
          u = n.i(a.g)(window);
      return d({}, r, t, {
        sourceDomain: u,
        id: r.id || o,
        windowType: i
      });
    }

    function i(e, r, i) {
      return u.a["try"](function () {
        r = o(e, r, {
          data: n.i(s.f)(e, i, r.data),
          domain: i
        });
        var d = void 0;
        if (d = -1 !== c.c.indexOf(r.name) || r.type === c.b.POST_MESSAGE_TYPE.ACK ? 'debug' : 'error' === r.ack ? 'error' : 'info', s.g.logLevel(d, ['\n\n\t', '#send', r.type.replace(/^postrobot_message_/, ''), '::', r.name, '::', i || c.b.WILDCARD, '\n\n', r]), e === window && !c.a.ALLOW_SAME_ORIGIN) throw new Error('Attemping to send message to self');
        if (n.i(a.f)(e)) throw new Error('Window is closed');
        s.g.debug('Running send message strategies', r);
        var l = [],
            w = n.i(s.h)(t({}, c.b.WINDOW_PROPS.POSTROBOT, r), null, 2);
        return u.a.map(Object.keys(f.a), function (r) {
          return u.a["try"](function () {
            if (!c.a.ALLOWED_POST_MESSAGE_METHODS[r]) throw new Error('Strategy disallowed: ' + r);
            return f.a[r](e, w, i);
          }).then(function () {
            return l.push(r + ': success'), !0;
          }, function (e) {
            return l.push(r + ': ' + n.i(s.i)(e) + '\n'), !1;
          });
        }).then(function (e) {
          var n = e.some(Boolean),
              t = r.type + ' ' + r.name + ' ' + (n ? 'success' : 'error') + ':\n  - ' + l.join('\n  - ') + '\n';
          if (s.g.debug(t), !n) throw new Error(t);
        });
      });
    }

    r.a = i;

    var a = n(1),
        u = n(2),
        c = n(0),
        s = n(4),
        f = n(25),
        d = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var n = arguments[r];

        for (var t in n) {
          Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
      }

      return e;
    };
  }, function (e, r, n) {
    'use strict';

    function t() {
      if (!window.WeakMap) return !1;
      if (!window.Object.freeze) return !1;

      try {
        var e = new window.WeakMap(),
            r = {};
        return window.Object.freeze(r), e.set(r, '__testvalue__'), '__testvalue__' === e.get(r);
      } catch (e) {
        return !1;
      }
    }

    r.a = t;
  }, function (e, r, n) {
    'use strict';

    function t(e, r) {
      for (var n = 0; n < e.length; n++) {
        try {
          if (e[n] === r) return n;
        } catch (e) {}
      }

      return -1;
    }

    function o() {}

    r.b = t, r.a = o;
  }, function (e, r, n) {
    'use strict';

    function t(e, r) {
      if (!(e instanceof r)) throw new TypeError('Cannot call a class as a function');
    }

    n.d(r, 'a', function () {
      return f;
    });

    var o = n(1),
        i = n(14),
        a = n(15),
        u = function () {
      function e(e, r) {
        for (var n = 0; n < r.length; n++) {
          var t = r[n];
          t.enumerable = t.enumerable || !1, t.configurable = !0, 'value' in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
        }
      }

      return function (r, n, t) {
        return n && e(r.prototype, n), t && e(r, t), r;
      };
    }(),
        c = Object.defineProperty,
        s = Date.now() % 1e9,
        f = function () {
      function e() {
        if (t(this, e), s += 1, this.name = '__weakmap_' + (1e9 * Math.random() >>> 0) + '__' + s, n.i(i.a)()) try {
          this.weakmap = new window.WeakMap();
        } catch (e) {}
        this.keys = [], this.values = [];
      }

      return u(e, [{
        key: '_cleanupClosedWindows',
        value: function value() {
          for (var e = this.weakmap, r = this.keys, t = 0; t < r.length; t++) {
            var i = r[t];

            if (n.i(o.e)(i) && n.i(o.f)(i)) {
              if (e) try {
                e["delete"](i);
              } catch (e) {}
              r.splice(t, 1), this.values.splice(t, 1), t -= 1;
            }
          }
        }
      }, {
        key: 'isSafeToReadWrite',
        value: function value(e) {
          if (n.i(o.e)(e)) return !1;

          try {
            n.i(a.a)(e && e.self), n.i(a.a)(e && e[this.name]);
          } catch (e) {
            return !1;
          }

          return !0;
        }
      }, {
        key: 'set',
        value: function value(e, r) {
          if (!e) throw new Error('WeakMap expected key');
          var t = this.weakmap;
          if (t) try {
            t.set(e, r);
          } catch (e) {
            delete this.weakmap;
          }

          if (this.isSafeToReadWrite(e)) {
            var o = this.name,
                i = e[o];
            i && i[0] === e ? i[1] = r : c(e, o, {
              value: [e, r],
              writable: !0
            });
          } else {
            this._cleanupClosedWindows();

            var u = this.keys,
                s = this.values,
                f = n.i(a.b)(u, e);
            -1 === f ? (u.push(e), s.push(r)) : s[f] = r;
          }
        }
      }, {
        key: 'get',
        value: function value(e) {
          if (!e) throw new Error('WeakMap expected key');
          var r = this.weakmap;
          if (r) try {
            if (r.has(e)) return r.get(e);
          } catch (e) {
            delete this.weakmap;
          }

          if (!this.isSafeToReadWrite(e)) {
            this._cleanupClosedWindows();

            var t = this.keys,
                o = n.i(a.b)(t, e);
            if (-1 === o) return;
            return this.values[o];
          }

          var i = e[this.name];
          if (i && i[0] === e) return i[1];
        }
      }, {
        key: 'delete',
        value: function value(e) {
          if (!e) throw new Error('WeakMap expected key');
          var r = this.weakmap;
          if (r) try {
            r["delete"](e);
          } catch (e) {
            delete this.weakmap;
          }

          if (this.isSafeToReadWrite(e)) {
            var t = e[this.name];
            t && t[0] === e && (t[0] = t[1] = void 0);
          } else {
            this._cleanupClosedWindows();

            var o = this.keys,
                i = n.i(a.b)(o, e);
            -1 !== i && (o.splice(i, 1), this.values.splice(i, 1));
          }
        }
      }, {
        key: 'has',
        value: function value(e) {
          if (!e) throw new Error('WeakMap expected key');
          var r = this.weakmap;
          if (r) try {
            return r.has(e);
          } catch (e) {
            delete this.weakmap;
          }

          if (this.isSafeToReadWrite(e)) {
            var t = e[this.name];
            return !(!t || t[0] !== e);
          }

          return this._cleanupClosedWindows(), -1 !== n.i(a.b)(this.keys, e);
        }
      }]), e;
    }();
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      return '[object RegExp]' === Object.prototype.toString.call(e);
    }

    function o() {}

    r.b = t, r.a = o;
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      if (-1 === a.indexOf(e)) {
        a.push(e), setTimeout(function () {
          throw e;
        }, 1);

        for (var r = 0; r < i.length; r++) {
          i[r](e);
        }
      }
    }

    function o(e) {
      return i.push(e), {
        cancel: function cancel() {
          i.splice(i.indexOf(e), 1);
        }
      };
    }

    r.a = t, r.b = o;
    var i = [],
        a = [];
  }, function (e, r, n) {
    'use strict';

    function t(e, r) {
      if (!(e instanceof r)) throw new TypeError('Cannot call a class as a function');
    }

    n.d(r, 'a', function () {
      return c;
    });

    var o = n(20),
        i = n(18),
        a = function () {
      function e(e, r) {
        for (var n = 0; n < r.length; n++) {
          var t = r[n];
          t.enumerable = t.enumerable || !1, t.configurable = !0, 'value' in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
        }
      }

      return function (r, n, t) {
        return n && e(r.prototype, n), t && e(r, t), r;
      };
    }(),
        u = window.__zalgopromise__ = window.__zalgopromise__ || {
      flushPromises: [],
      activeCount: 0
    },
        c = function () {
      function e(r) {
        var n = this;

        if (t(this, e), this.resolved = !1, this.rejected = !1, this.errorHandled = !1, this.handlers = [], r) {
          var o = void 0,
              i = void 0,
              a = !1,
              u = !1,
              c = !1;

          try {
            r(function (e) {
              c ? n.resolve(e) : (a = !0, o = e);
            }, function (e) {
              c ? n.reject(e) : (u = !0, i = e);
            });
          } catch (e) {
            return void this.reject(e);
          }

          c = !0, a ? this.resolve(o) : u && this.reject(i);
        }
      }

      return a(e, [{
        key: 'resolve',
        value: function value(e) {
          if (this.resolved || this.rejected) return this;
          if (n.i(o.a)(e)) throw new Error('Can not resolve promise with another promise');
          return this.resolved = !0, this.value = e, this.dispatch(), this;
        }
      }, {
        key: 'reject',
        value: function value(e) {
          var r = this;
          if (this.resolved || this.rejected) return this;
          if (n.i(o.a)(e)) throw new Error('Can not reject promise with another promise');

          if (!e) {
            var t = e && 'function' == typeof e.toString ? e.toString() : Object.prototype.toString.call(e);
            e = new Error('Expected reject to be called with Error, got ' + t);
          }

          return this.rejected = !0, this.error = e, this.errorHandled || setTimeout(function () {
            r.errorHandled || n.i(i.a)(e);
          }, 1), this.dispatch(), this;
        }
      }, {
        key: 'asyncReject',
        value: function value(e) {
          this.errorHandled = !0, this.reject(e);
        }
      }, {
        key: 'dispatch',
        value: function value() {
          var r = this,
              t = this.dispatching,
              i = this.resolved,
              a = this.rejected,
              c = this.handlers;

          if (!t && (i || a)) {
            this.dispatching = !0, u.activeCount += 1;

            for (var s = 0; s < c.length; s++) {
              (function (t) {
                var u = c[t],
                    s = u.onSuccess,
                    f = u.onError,
                    d = u.promise,
                    l = void 0;
                if (i) try {
                  l = s ? s(r.value) : r.value;
                } catch (e) {
                  return d.reject(e), 'continue';
                } else if (a) {
                  if (!f) return d.reject(r.error), 'continue';

                  try {
                    l = f(r.error);
                  } catch (e) {
                    return d.reject(e), 'continue';
                  }
                }
                l instanceof e && (l.resolved || l.rejected) ? (l.resolved ? d.resolve(l.value) : d.reject(l.error), l.errorHandled = !0) : n.i(o.a)(l) ? l instanceof e && (l.resolved || l.rejected) ? l.resolved ? d.resolve(l.value) : d.reject(l.error) : l.then(function (e) {
                  d.resolve(e);
                }, function (e) {
                  d.reject(e);
                }) : d.resolve(l);
              })(s);
            }

            c.length = 0, this.dispatching = !1, u.activeCount -= 1, 0 === u.activeCount && e.flushQueue();
          }
        }
      }, {
        key: 'then',
        value: function value(r, n) {
          if (r && 'function' != typeof r && !r.call) throw new Error('Promise.then expected a function for success handler');
          if (n && 'function' != typeof n && !n.call) throw new Error('Promise.then expected a function for error handler');
          var t = new e();
          return this.handlers.push({
            promise: t,
            onSuccess: r,
            onError: n
          }), this.errorHandled = !0, this.dispatch(), t;
        }
      }, {
        key: 'catch',
        value: function value(e) {
          return this.then(void 0, e);
        }
      }, {
        key: 'finally',
        value: function value(r) {
          return this.then(function (n) {
            return e["try"](r).then(function () {
              return n;
            });
          }, function (n) {
            return e["try"](r).then(function () {
              throw n;
            });
          });
        }
      }, {
        key: 'timeout',
        value: function value(e, r) {
          var n = this;
          if (this.resolved || this.rejected) return this;
          var t = setTimeout(function () {
            n.resolved || n.rejected || n.reject(r || new Error('Promise timed out after ' + e + 'ms'));
          }, e);
          return this.then(function (e) {
            return clearTimeout(t), e;
          });
        }
      }, {
        key: 'toPromise',
        value: function value() {
          if (!window.Promise) throw new Error('Could not find window.Promise');
          return window.Promise.resolve(this);
        }
      }], [{
        key: 'resolve',
        value: function value(r) {
          return r instanceof e ? r : n.i(o.a)(r) ? new e(function (e, n) {
            return r.then(e, n);
          }) : new e().resolve(r);
        }
      }, {
        key: 'reject',
        value: function value(r) {
          return new e().reject(r);
        }
      }, {
        key: 'all',
        value: function value(r) {
          var t = new e(),
              i = r.length,
              a = [];
          if (!i) return t.resolve(a), t;

          for (var u = 0; u < r.length; u++) {
            (function (u) {
              var c = r[u];

              if (c instanceof e) {
                if (c.resolved) return a[u] = c.value, i -= 1, 'continue';
              } else if (!n.i(o.a)(c)) return a[u] = c, i -= 1, 'continue';

              e.resolve(c).then(function (e) {
                a[u] = e, 0 === (i -= 1) && t.resolve(a);
              }, function (e) {
                t.reject(e);
              });
            })(u);
          }

          return 0 === i && t.resolve(a), t;
        }
      }, {
        key: 'hash',
        value: function value(r) {
          var n = {};
          return e.all(Object.keys(r).map(function (t) {
            return e.resolve(r[t]).then(function (e) {
              n[t] = e;
            });
          })).then(function () {
            return n;
          });
        }
      }, {
        key: 'map',
        value: function value(r, n) {
          return e.all(r.map(n));
        }
      }, {
        key: 'onPossiblyUnhandledException',
        value: function value(e) {
          return n.i(i.b)(e);
        }
      }, {
        key: 'try',
        value: function value(r, n, t) {
          var o = void 0;

          try {
            o = r.apply(n, t || []);
          } catch (r) {
            return e.reject(r);
          }

          return e.resolve(o);
        }
      }, {
        key: 'delay',
        value: function value(r) {
          return new e(function (e) {
            setTimeout(e, r);
          });
        }
      }, {
        key: 'isPromise',
        value: function value(r) {
          return !!(r && r instanceof e) || n.i(o.a)(r);
        }
      }, {
        key: 'flush',
        value: function value() {
          var r = new e();
          return u.flushPromises.push(r), 0 === u.activeCount && e.flushQueue(), r;
        }
      }, {
        key: 'flushQueue',
        value: function value() {
          var e = u.flushPromises;
          u.flushPromises = [];

          for (var r = e, n = Array.isArray(r), t = 0, r = n ? r : r[Symbol.iterator]();;) {
            var o;

            if (n) {
              if (t >= r.length) break;
              o = r[t++];
            } else {
              if (t = r.next(), t.done) break;
              o = t.value;
            }

            o.resolve();
          }
        }
      }]), e;
    }();
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      try {
        if (!e) return !1;
        if (window.Promise && e instanceof window.Promise) return !0;
        if (window.Window && e instanceof window.Window) return !1;
        if (window.constructor && e instanceof window.constructor) return !1;

        if (o) {
          var r = o.call(e);
          if ('[object Window]' === r || '[object global]' === r || '[object DOMWindow]' === r) return !1;
        }

        if ('function' == typeof e.then) return !0;
      } catch (e) {
        return !1;
      }

      return !1;
    }

    r.a = t;
    var o = {}.toString;
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      var r = o.a.requestPromises.get(e);
      if (r) for (var n = r, t = Array.isArray(n), i = 0, n = t ? n : n[Symbol.iterator]();;) {
        var a;

        if (t) {
          if (i >= n.length) break;
          a = n[i++];
        } else {
          if (i = n.next(), i.done) break;
          a = i.value;
        }

        var u = a;
        u.reject(new Error('No response from window - cleaned up'));
      }
      o.a.popupWindowsByWin && o.a.popupWindowsByWin["delete"](e), o.a.remoteWindows && o.a.remoteWindows["delete"](e), o.a.requestPromises["delete"](e), o.a.methods["delete"](e), o.a.readyPromises["delete"](e);
    }

    r.a = t;
    var o = n(3);
  }, function (e, r, n) {
    'use strict';

    function t(e, r, n) {
      return r in e ? Object.defineProperty(e, r, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = n, e;
    }

    n.d(r, 'a', function () {
      return a;
    });
    var o,
        i = n(11),
        a = {
      ALLOW_POSTMESSAGE_POPUP: !('__ALLOW_POSTMESSAGE_POPUP__' in window) || window.__ALLOW_POSTMESSAGE_POPUP__,
      LOG_LEVEL: 'info',
      BRIDGE_TIMEOUT: 5e3,
      ACK_TIMEOUT: -1 !== window.navigator.userAgent.match(/MSIE/i) ? 2e3 : 1e3,
      RES_TIMEOUT: 1 / 0,
      LOG_TO_PAGE: !1,
      ALLOWED_POST_MESSAGE_METHODS: (o = {}, t(o, i.a.SEND_STRATEGIES.POST_MESSAGE, !0), t(o, i.a.SEND_STRATEGIES.BRIDGE, !0), t(o, i.a.SEND_STRATEGIES.GLOBAL, !0), o),
      ALLOW_SAME_ORIGIN: !1
    };
    0 === window.location.href.indexOf(i.a.FILE_PROTOCOL) && (a.ALLOW_POSTMESSAGE_POPUP = !0);
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      var r = void 0;

      try {
        r = n.i(s.j)(e);
      } catch (e) {
        return;
      }

      if (r && 'object' === (void 0 === r ? 'undefined' : l(r)) && null !== r && (r = r[c.b.WINDOW_PROPS.POSTROBOT]) && 'object' === (void 0 === r ? 'undefined' : l(r)) && null !== r && r.type && 'string' == typeof r.type && d.a[r.type]) return r;
    }

    function o(e) {
      if (!window || window.closed) throw new Error('Message recieved in closed window');

      try {
        if (!e.source) return;
      } catch (e) {
        return;
      }

      var r = e.source,
          o = e.origin,
          i = e.data,
          a = t(i);

      if (a) {
        if (!a.sourceDomain || 'string' != typeof a.sourceDomain) throw new Error('Expected message to have sourceDomain');

        if (0 !== a.sourceDomain.indexOf(c.b.MOCK_PROTOCOL) && 0 !== a.sourceDomain.indexOf(c.b.FILE_PROTOCOL) || (o = a.sourceDomain), -1 === f.a.receivedMessages.indexOf(a.id)) {
          f.a.receivedMessages.push(a.id);
          var l = void 0;
          if (l = -1 !== c.c.indexOf(a.name) || a.type === c.b.POST_MESSAGE_TYPE.ACK ? 'debug' : 'error' === a.ack ? 'error' : 'info', s.g.logLevel(l, ['\n\n\t', '#receive', a.type.replace(/^postrobot_message_/, ''), '::', a.name, '::', o, '\n\n', a]), n.i(u.f)(r)) return void s.g.debug('Source window is closed - can not send ' + a.type + ' ' + a.name);
          a.data && (a.data = n.i(s.k)(r, o, a.data)), d.a[a.type](r, o, a);
        }
      }
    }

    function i(e) {
      try {
        e.source;
      } catch (e) {
        return;
      }

      var r = {
        source: e.source || e.sourceElement,
        origin: e.origin || e.originalEvent && e.originalEvent.origin,
        data: e.data
      };
      o(r);
    }

    function a() {
      n.i(s.l)(window, 'message', i);
    }

    r.b = i, r.a = a;
    var u = n(1),
        c = n(0),
        s = n(4),
        f = n(3),
        d = n(24),
        l = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
    };
    f.a.receivedMessages = f.a.receivedMessages || [];
  }, function (e, r, n) {
    'use strict';

    function t(e, r, n) {
      return r in e ? Object.defineProperty(e, r, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = n, e;
    }

    n.d(r, 'a', function () {
      return l;
    });

    var o,
        i = n(2),
        a = n(1),
        u = n(0),
        c = n(4),
        s = n(13),
        f = n(12),
        d = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var n = arguments[r];

        for (var t in n) {
          Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
      }

      return e;
    },
        l = (o = {}, t(o, u.b.POST_MESSAGE_TYPE.ACK, function (e, r, t) {
      if (!n.i(f.a)(t.hash)) {
        var o = n.i(f.b)(t.hash);
        if (!o) throw new Error('No handler found for post message ack for message: ' + t.name + ' from ' + r + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
        if (!n.i(a.b)(o.domain, r)) throw new Error('Ack origin ' + r + ' does not match domain ' + o.domain.toString());
        o.ack = !0;
      }
    }), t(o, u.b.POST_MESSAGE_TYPE.REQUEST, function (e, r, t) {
      function o(o) {
        return t.fireAndForget || n.i(a.f)(e) ? i.a.resolve() : n.i(s.a)(e, d({
          target: t.originalSource,
          hash: t.hash,
          name: t.name
        }, o), r);
      }

      var l = n.i(f.c)({
        name: t.name,
        win: e,
        domain: r
      });
      return i.a.all([o({
        type: u.b.POST_MESSAGE_TYPE.ACK
      }), i.a["try"](function () {
        if (!l) throw new Error('No handler found for post message: ' + t.name + ' from ' + r + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
        if (!n.i(a.b)(l.domain, r)) throw new Error('Request origin ' + r + ' does not match domain ' + l.domain.toString());
        var o = t.data;
        return l.handler({
          source: e,
          origin: r,
          data: o
        });
      }).then(function (e) {
        return o({
          type: u.b.POST_MESSAGE_TYPE.RESPONSE,
          ack: u.b.POST_MESSAGE_ACK.SUCCESS,
          data: e
        });
      }, function (e) {
        var r = n.i(c.i)(e).replace(/^Error: /, '');
        return o({
          type: u.b.POST_MESSAGE_TYPE.RESPONSE,
          ack: u.b.POST_MESSAGE_ACK.ERROR,
          error: r
        });
      })]).then(c.m)["catch"](function (e) {
        if (l && l.handleError) return l.handleError(e);
        c.g.error(n.i(c.i)(e));
      });
    }), t(o, u.b.POST_MESSAGE_TYPE.RESPONSE, function (e, r, t) {
      if (!n.i(f.a)(t.hash)) {
        var o = n.i(f.b)(t.hash);
        if (!o) throw new Error('No handler found for post message response for message: ' + t.name + ' from ' + r + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
        if (!n.i(a.b)(o.domain, r)) throw new Error('Response origin ' + r + ' does not match domain ' + o.domain);
        if (n.i(f.d)(t.hash), t.ack === u.b.POST_MESSAGE_ACK.ERROR) return o.respond(new Error(t.error), null);

        if (t.ack === u.b.POST_MESSAGE_ACK.SUCCESS) {
          var i = t.data || t.response;
          return o.respond(null, {
            source: e,
            origin: r,
            data: i
          });
        }
      }
    }), o);
  }, function (e, r, n) {
    'use strict';

    n.d(r, 'a', function () {
      return i;
    });
    var t = n(1),
        o = n(0),
        i = {};

    i[o.b.SEND_STRATEGIES.POST_MESSAGE] = function (e, r, i) {
      var a = void 0;
      a = Array.isArray(i) ? i : i ? [i] : [o.b.WILDCARD], a = a.map(function (r) {
        if (0 === r.indexOf(o.b.MOCK_PROTOCOL)) {
          if (window.location.protocol === o.b.FILE_PROTOCOL) return o.b.WILDCARD;
          if (!n.i(t.h)(e)) throw new Error('Attempting to send messsage to mock domain ' + r + ', but window is actually cross-domain');
          return n.i(t.i)(e);
        }

        return 0 === r.indexOf(o.b.FILE_PROTOCOL) ? o.b.WILDCARD : r;
      }), a.forEach(function (n) {
        return e.postMessage(r, n);
      });
    };
  }, function (e, r, n) {
    'use strict';

    Object.defineProperty(r, '__esModule', {
      value: !0
    });
    var t = n(6);
    n.d(r, 'cleanUpWindow', function () {
      return t.cleanUpWindow;
    }), n.d(r, 'init', function () {
      return t.init;
    }), n.d(r, 'bridge', function () {
      return t.bridge;
    }), n.d(r, 'Promise', function () {
      return t.Promise;
    }), n.d(r, 'parent', function () {
      return t.parent;
    }), n.d(r, 'send', function () {
      return t.send;
    }), n.d(r, 'request', function () {
      return t.request;
    }), n.d(r, 'sendToParent', function () {
      return t.sendToParent;
    }), n.d(r, 'client', function () {
      return t.client;
    }), n.d(r, 'on', function () {
      return t.on;
    }), n.d(r, 'listen', function () {
      return t.listen;
    }), n.d(r, 'once', function () {
      return t.once;
    }), n.d(r, 'listener', function () {
      return t.listener;
    }), n.d(r, 'CONFIG', function () {
      return t.CONFIG;
    }), n.d(r, 'CONSTANTS', function () {
      return t.CONSTANTS;
    }), n.d(r, 'disable', function () {
      return t.disable;
    }), r["default"] = t;
  }, function (e, r, n) {
    'use strict';

    function t() {
      n.i(s.on)(c.b.POST_MESSAGE_NAMES.READY, {
        domain: c.b.WILDCARD
      }, function (e) {
        var r = e.source,
            n = d.a.readyPromises.get(r);
        n ? n.resolve(e) : (n = new u.a().resolve(e), d.a.readyPromises.set(r, n));
      });
      var e = n.i(a.a)();
      e && n.i(s.send)(e, c.b.POST_MESSAGE_NAMES.READY, {}, {
        domain: c.b.WILDCARD,
        timeout: 1 / 0
      })["catch"](function (e) {
        f.a.debug(n.i(l.b)(e));
      });
    }

    function o(e) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5e3,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 'Window',
          t = d.a.readyPromises.get(e);
      return t || (t = new u.a(), d.a.readyPromises.set(e, t), setTimeout(function () {
        return t.reject(new Error(n + ' did not load after ' + r + 'ms'));
      }, r), t);
    }

    r.a = t, r.b = o;
    var i = n(7),
        a = n(1),
        u = n(2),
        c = n(0),
        s = n(6),
        f = n(9),
        d = n(3),
        l = n(8);
    d.a.readyPromises = d.a.readyPromises || new i.a();
  }, function (e, r, n) {
    'use strict';

    function t(e, r) {
      return 'object' === (void 0 === e ? 'undefined' : g(e)) && null !== e && e.__type__ === r;
    }

    function o(e, r, t, o) {
      var i = n.i(E.f)(),
          a = O.a.methods.get(e);
      return a || (a = {}, O.a.methods.set(e, a)), a[i] = {
        domain: r,
        method: t
      }, {
        __type__: b.b.SERIALIZATION_TYPES.METHOD,
        __id__: i,
        __name__: o
      };
    }

    function i(e) {
      return {
        __type__: b.b.SERIALIZATION_TYPES.ERROR,
        __message__: n.i(E.b)(e)
      };
    }

    function a(e, r, n, t) {
      return {
        __type__: b.b.SERIALIZATION_TYPES.PROMISE,
        __then__: o(e, r, function (e, r) {
          return n.then(e, r);
        }, t + '.then')
      };
    }

    function u(e, r, n, t) {
      return {
        __type__: b.b.SERIALIZATION_TYPES.ZALGO_PROMISE,
        __then__: o(e, r, function (e, r) {
          return n.then(e, r);
        }, t + '.then')
      };
    }

    function c(e) {
      return {
        __type__: b.b.SERIALIZATION_TYPES.REGEX,
        __source__: e.source
      };
    }

    function s(e, r, t) {
      return n.i(E.g)({
        obj: t
      }, function (t, s) {
        return 'function' == typeof t ? o(e, r, t, s.toString()) : t instanceof Error ? i(t) : window.Promise && t instanceof window.Promise ? a(e, r, t, s.toString()) : m.a.isPromise(t) ? u(e, r, t, s.toString()) : n.i(E.a)(t) ? c(t) : void 0;
      }).obj;
    }

    function f(e, r, t) {
      function o() {
        var o = Array.prototype.slice.call(arguments);
        return S.a.debug('Call foreign method', t.__name__, o), n.i(_.send)(e, b.b.POST_MESSAGE_NAMES.METHOD, {
          id: t.__id__,
          name: t.__name__,
          args: o
        }, {
          domain: r,
          timeout: 1 / 0
        }).then(function (e) {
          var r = e.data;
          return S.a.debug('Got foreign method result', t.__name__, r.result), r.result;
        }, function (e) {
          throw S.a.debug('Got foreign method error', n.i(E.b)(e)), e;
        });
      }

      return o.__name__ = t.__name__, o.__xdomain__ = !0, o.source = e, o.origin = r, o;
    }

    function d(e, r, n) {
      return new Error(n.__message__);
    }

    function l(e, r, n) {
      return new m.a(function (t, o) {
        return f(e, r, n.__then__)(t, o);
      });
    }

    function w(e, r, n) {
      return window.Promise ? new window.Promise(function (t, o) {
        return f(e, r, n.__then__)(t, o);
      }) : l(e, r, n);
    }

    function h(e, r, n) {
      return new RegExp(n.__source__);
    }

    function p(e, r, o) {
      return n.i(E.g)({
        obj: o
      }, function (n, o) {
        if ('object' === (void 0 === n ? 'undefined' : g(n)) && null !== n) return t(n, b.b.SERIALIZATION_TYPES.METHOD) ? f(e, r, n) : t(n, b.b.SERIALIZATION_TYPES.ERROR) ? d(e, r, n) : t(n, b.b.SERIALIZATION_TYPES.PROMISE) ? w(e, r, n) : t(n, b.b.SERIALIZATION_TYPES.ZALGO_PROMISE) ? l(e, r, n) : t(n, b.b.SERIALIZATION_TYPES.REGEX) ? h(e, r, n) : void 0;
      }).obj;
    }

    n.d(r, 'a', function () {
      return A;
    }), r.b = s, r.c = p;

    var v = n(7),
        y = n(1),
        m = n(2),
        b = n(0),
        E = n(8),
        _ = n(6),
        S = n(9),
        O = n(3),
        g = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
    };

    O.a.methods = O.a.methods || new v.a();
    var A = n.i(E.e)(function () {
      n.i(_.on)(b.b.POST_MESSAGE_NAMES.METHOD, {
        origin: b.b.WILDCARD
      }, function (e) {
        var r = e.source,
            t = e.origin,
            o = e.data,
            i = O.a.methods.get(r);
        if (!i) throw new Error('Could not find any methods this window has privileges to call');
        var a = i[o.id];
        if (!a) throw new Error('Could not find method with id: ' + o.id);
        if (!n.i(y.b)(a.domain, t)) throw new Error('Method domain ' + a.domain + ' does not match origin ' + t);
        return S.a.debug('Call local method', o.name, o.args), m.a["try"](function () {
          return a.method.apply({
            source: r,
            origin: t,
            data: o
          }, o.args);
        }).then(function (e) {
          return {
            result: e,
            id: o.id,
            name: o.name
          };
        });
      });
    });
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      return c.a["try"](function () {
        if (!e.name) throw new Error('Expected options.name');
        var r = e.name,
            t = void 0,
            o = void 0;

        if ('string' == typeof e.window) {
          var i = document.getElementById(e.window);
          if (!i) throw new Error('Expected options.window ' + Object.prototype.toString.call(e.window) + ' to be a valid element id');
          if ('iframe' !== i.tagName.toLowerCase()) throw new Error('Expected options.window ' + Object.prototype.toString.call(e.window) + ' to be an iframe');
          if (!i.contentWindow) throw new Error('Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.');
          t = i.contentWindow;
        } else if (e.window instanceof HTMLIFrameElement) {
          if ('iframe' !== e.window.tagName.toLowerCase()) throw new Error('Expected options.window ' + Object.prototype.toString.call(e.window) + ' to be an iframe');
          if (e.window && !e.window.contentWindow) throw new Error('Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.');
          e.window && e.window.contentWindow && (t = e.window.contentWindow);
        } else t = e.window;

        if (!t) throw new Error('Expected options.window to be a window object, iframe, or iframe element id.');
        var a = t;
        o = e.domain || f.b.WILDCARD;
        var u = e.name + '_' + n.i(l.d)();
        if (n.i(s.f)(a)) throw new Error('Target window is closed');
        var h = !1,
            p = w.a.requestPromises.get(a);
        p || (p = [], w.a.requestPromises.set(a, p));
        var v = c.a["try"](function () {
          if (n.i(s.j)(window, a)) return c.a.resolve(n.i(l.p)(a));
        }).then(function () {
          return new c.a(function (t, i) {
            var c = void 0;
            if (e.fireAndForget || (c = {
              name: r,
              window: a,
              domain: o,
              respond: function respond(e, r) {
                e || (h = !0, p.splice(p.indexOf(v, 1))), e ? i(e) : t(r);
              }
            }, n.i(d.d)(u, c)), n.i(d.e)(a, {
              type: f.b.POST_MESSAGE_TYPE.REQUEST,
              hash: u,
              name: r,
              data: e.data,
              fireAndForget: e.fireAndForget
            }, o)["catch"](i), e.fireAndForget) return t();

            var l = f.a.ACK_TIMEOUT,
                w = e.timeout || f.a.RES_TIMEOUT,
                y = 100,
                m = function t() {
              if (!h) {
                if (n.i(s.f)(a)) return i(c.ack ? new Error('Window closed for ' + r + ' before response') : new Error('Window closed for ' + r + ' before ack'));
                l -= y, w -= y;

                if (c.ack) {
                  if (w === 1 / 0) return;
                  y = Math.min(w, 2e3);
                } else {
                  if (l <= 0) return i(new Error('No ack for postMessage ' + r + ' in ' + n.i(s.g)() + ' in ' + f.a.ACK_TIMEOUT + 'ms'));
                  if (w <= 0) return i(new Error('No response for postMessage ' + r + ' in ' + n.i(s.g)() + ' in ' + (e.timeout || f.a.RES_TIMEOUT) + 'ms'));
                }

                setTimeout(t, y);
              }
            };

            setTimeout(m, y);
          });
        });
        return v["catch"](function () {
          n.i(d.f)(u), n.i(d.g)(u);
        }), p.push(v), v;
      });
    }

    function o(e, r, n, o) {
      return o = o || {}, o.window = e, o.name = r, o.data = n, t(o);
    }

    function i(e, r, t) {
      var i = n.i(s.a)();
      return i ? o(i, e, r, t) : new c.a(function (e, r) {
        return r(new Error('Window does not have a parent'));
      });
    }

    function a() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      if (!e.window) throw new Error('Expected options.window');
      var r = e.window;
      return {
        send: function send(n, t) {
          return o(r, n, t, e);
        }
      };
    }

    n.d(r, 'a', function () {
      return o;
    }), r.b = t, r.c = i, r.d = a;
    var u = n(7),
        c = n(2),
        s = n(1),
        f = n(0),
        d = n(5),
        l = n(4),
        w = n(3);
    w.a.requestPromises = w.a.requestPromises || new u.a();
  }, function (e, r, n) {
    'use strict';

    function t() {
      delete window[o.b.WINDOW_PROPS.POSTROBOT], window.removeEventListener('message', i.b);
    }

    r.c = t;
    var o = n(0),
        i = n(5);
    n.d(r, 'a', function () {
      return o.a;
    }), n.d(r, 'b', function () {
      return o.b;
    });
  }, function (e, r, n) {
    'use strict';

    n.d(r, 'a', function () {
      return u;
    });
    var t = n(1),
        o = n(29);
    n.d(r, 'b', function () {
      return o.a;
    }), n.d(r, 'c', function () {
      return o.b;
    }), n.d(r, 'd', function () {
      return o.c;
    }), n.d(r, 'e', function () {
      return o.d;
    });
    var i = n(32);
    n.d(r, 'f', function () {
      return i.a;
    }), n.d(r, 'g', function () {
      return i.b;
    }), n.d(r, 'h', function () {
      return i.c;
    }), n.d(r, 'i', function () {
      return i.d;
    });
    var a = n(30);
    n.d(r, 'j', function () {
      return a.a;
    }), n.d(r, 'k', function () {
      return a.b;
    }), n.d(r, 'l', function () {
      return a.c;
    });
    var u = n.i(t.a)();
  }, function (e, r, n) {
    'use strict';

    function t(e) {
      if (!e.name) throw new Error('Expected options.name');
      if (!e.handler) throw new Error('Expected options.handler');
      var r = e.name,
          t = e.window,
          o = e.domain,
          i = {
        handler: e.handler,
        handleError: e.errorHandler || function (e) {
          throw e;
        },
        window: t,
        domain: o || d.b.WILDCARD,
        name: r
      },
          a = n.i(f.c)({
        name: r,
        win: t,
        domain: o
      }, i);

      if (e.once) {
        var c = i.handler;
        i.handler = n.i(s.n)(function () {
          return a.cancel(), c.apply(this, arguments);
        });
      }

      if (i.window && e.errorOnClose) var w = n.i(s.o)(function () {
        t && 'object' === (void 0 === t ? 'undefined' : l(t)) && n.i(u.f)(t) && (w.cancel(), i.handleError(new Error('Post message target window is closed')));
      }, 50);
      return {
        cancel: function cancel() {
          a.cancel();
        }
      };
    }

    function o(e, r, n) {
      return 'function' == typeof r && (n = r, r = {}), r = r || {}, r.name = e, r.handler = n || r.handler, t(r);
    }

    function i(e) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments[2];
      'function' == typeof r && (n = r, r = {}), r = r || {}, n = n || r.handler;
      var o = r.errorHandler,
          i = new c.a(function (t, i) {
        r = r || {}, r.name = e, r.once = !0, r.handler = function (e) {
          if (t(e), n) return n(e);
        }, r.errorHandler = function (e) {
          if (i(e), o) return o(e);
        };
      }),
          a = t(r);
      return i.cancel = a.cancel, i;
    }

    function a() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return {
        on: function on(r, n) {
          return o(r, e, n);
        }
      };
    }

    n.d(r, 'a', function () {
      return o;
    }), r.b = t, r.c = i, r.d = a;
    var u = n(1),
        c = n(2),
        s = n(4),
        f = n(5),
        d = n(0),
        l = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
    };
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)(module)))

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeBrowser */
/* unused harmony export normalizeOS */
/* unused harmony export isTVApp */
/* unused harmony export isMobile */
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeBrowsers;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeOSs;
/* harmony export (immutable) */ __webpack_exports__["e"] = normalizePlatform;
/* harmony export (immutable) */ __webpack_exports__["f"] = regionNameFromCode;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeHostData;
/* harmony export (immutable) */ __webpack_exports__["a"] = computeInsights;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geo__ = __webpack_require__(38);

function normalizeBrowser(b) {
  b = b || '';

  if (b.indexOf('Edg') >= 0) {
    // Microsoft Edge, Edg/XX, EdgiOS, EdgA)
    return 'Edge';
  } else if (b.indexOf('IE') >= 0) {
    return 'Internet Explorer';
  } else if (b.indexOf('Chrome Mobile') >= 0) {
    return 'Chrome Mobile';
  } else if (b.indexOf('Chrome') >= 0 && b.indexOf('Mobile Safari') >= 0) {
    return 'Chrome Mobile';
  } else if (b.indexOf('Mobile') >= 0 && b.indexOf('Safari') >= 0) {
    return 'Safari Mobile';
  } else if (b.indexOf('Safari') >= 0) {
    return 'Safari';
  } else if (b.indexOf('Chrome') >= 0) {
    return 'Chrome';
  } else if (b.indexOf('Firefox') >= 0) {
    return 'Firefox';
  } else {
    return 'Other';
  }
}
function normalizeOS(o) {
  if (!o || !o.trim()) {
    return 'Not reported';
  } else if (o.indexOf('Windows') >= 0) {
    return 'Windows';
  } else if (o.indexOf('Chrome OS') >= 0) {
    return 'Chrome OS';
  } else if (o.indexOf('OS X') >= 0 || o.indexOf('macOS') >= 0) {
    return 'macOS';
  } else if (o.indexOf('iOS') >= 0) {
    return 'iOS';
  } else if (o.indexOf('Android') >= 0) {
    return 'Android';
  } else if (o.indexOf('Linux') >= 0 || o.indexOf('Ubuntu') >= 0) {
    return 'Linux';
  } else {
    return 'Other';
  }
}
function isTVApp(o) {
  if (!o || !o.trim()) {
    return false;
  } else if (o.indexOf('Roku') >= 0) {
    return true;
  } else if (o.indexOf('AppleTV') >= 0) {
    return true;
  } else if (o.indexOf('Apple TV') >= 0) {
    return true;
  } else if (o.indexOf('Chromecast') >= 0) {
    return true;
  } else if (o.indexOf('ChromeCast') >= 0) {
    return true;
  } else if (o.indexOf('Fire TV') >= 0) {
    return true;
  } else if (o.indexOf('FireTV') >= 0) {
    return true;
  } else {
    return false;
  }
}
function isMobile(o) {
  if (!o || !o.trim()) {
    return false;
  } else if (o.indexOf('iOS') >= 0) {
    return true;
  } else if (o.indexOf('Android') >= 0) {
    return true;
  } else if (o.indexOf('Mobile') >= 0) {
    return true;
  } else if (o.indexOf('Phone') >= 0) {
    return true;
  } else if (o.indexOf('Tablet') >= 0) {
    return true;
  } else {
    return false;
  }
}
function normalizeBrowsers(map) {
  var result = {};

  _.each(map, function (count, label) {
    if (!result[normalizeBrowser(label)]) {
      result[normalizeBrowser(label)] = 0;
    }

    result[normalizeBrowser(label)] += count;
  });

  return result;
}
function normalizeOSs(map) {
  var result = {};

  _.each(map, function (count, label) {
    if (!result[normalizeOS(label)]) {
      result[normalizeOS(label)] = 0;
    }

    result[normalizeOS(label)] += count;
  });

  return result;
}
function normalizePlatform(osMap, browserMap) {
  var result = {
    Mobile: 0,
    Desktop: 0,
    'TV App': 0
  };

  _.each(osMap, function (count, label) {
    if (isMobile(label)) {
      result.Mobile += count;
    } else {
      result.Desktop += count;
    }
  }); // XXX: Roku doesn't send the `os` field, so we need to infer it from the browser field
  // and subtract those out of otherwise desktop views.


  _.each(browserMap, function (count, label) {
    if (isTVApp(label)) {
      console.log('detected tv app', label);
      result['TV App'] += count;
      result['Desktop'] -= count;
    }
  });

  return result;
}
function regionNameFromCode(code, regionDict) {
  var parts = code.split('-');
  if (parts.length != 2 || parts[0] == '' && parts[1] == '') return;
  var labelData = regionDict && regionDict["".concat(parts[1], "-").concat(parts[0])];
  var label = labelData && labelData.join(', ') || code || 'Unknown Location';

  if (code.startsWith('-')) {
    code = code.replace('-', '');

    _.each(regionDict, function (v, k) {
      if (k.startsWith(code)) {
        label = "".concat(v[0], " (unknown state)");
      }
    });
  }

  return label;
}
function normalizeHostData(analytics) {
  var totalViewCountForDestinationPercent = analytics.total_view_count;
  var hostData = [];

  _.keys(analytics.view_counts_by_host).forEach(function (l) {
    var viewCount = analytics.view_counts_by_host[l]; // Clean up some names

    if (!l || l == 'boxcastiframe.com') {
      l = 'Inline Frame (host not reported)';
    }

    if (!l || l == 'BoxCast.tv for AppleTV') {
      l = 'BoxCast.tv for Apple TV';
    } // Some special destinations get icons


    var icon = 'icon_website@30px.png';

    if (l == 'twitter.com') {
      icon = 'icon_twitter@30px.png';
    }

    if (l == 'BoxCast.tv for Roku') {
      icon = 'icon_roku@30px.png';
    }

    if (l == 'BoxCast.tv for Apple TV') {
      icon = 'icon_appletv@30px.png';
    }

    if (l == 'BoxCast.tv for Fire TV') {
      icon = 'icon_firetv@30px.png';
    }

    hostData.push({
      label: l,
      value: viewCount,
      percent: 100 * viewCount / totalViewCountForDestinationPercent,
      icon: icon
    });
  });

  return _.sortByOrder(hostData, ['value', 'label'], ['desc', 'asc']);
}
function computeInsights(broadcast, analytics) {
  var insights = {
    watchPercent: 0,
    geo: {
      countries: 0,
      states: 0
    },
    device: ''
  }; // Insight: watch percentage

  if (broadcast && broadcast.total_minutes_viewed > 0) {
    var durationSec = broadcast.recording_duration_seconds || (moment(broadcast.stops_at) - moment(broadcast.starts_at)) / 1000;
    var durationMin = Math.max(1, durationSec / 60);
    var avgViewDurationMin = broadcast.total_minutes_viewed / analytics.unique_viewer_count;
    insights.watchPercent = 100 * (avgViewDurationMin / durationMin);
  } // Insight: geo


  if (analytics.view_counts_by_region_code) {
    insights.geo.countries = Object(__WEBPACK_IMPORTED_MODULE_0__geo__["a" /* countCountries */])(analytics.view_counts_by_region_code);
    insights.geo.states = _.keys(analytics.view_counts_by_region_code).length;
  } // Insight: device


  if (analytics.view_counts_by_os) {
    var os = normalizePlatform(analytics.view_counts_by_os, analytics.view_counts_by_browser);
    var counts = {
      'desktop computers': os.Desktop,
      'mobile devices': os.Mobile,
      'TV apps': os['TV App']
    };
    insights.device = _.keys(counts).reduce(function (a, b) {
      return counts[a] > counts[b] ? a : b;
    });
  }

  return insights;
}

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\" style=\"border-bottom:0;padding-bottom:0;\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span\n      aria-hidden=\"true\">&times;</span></button>\n\n  <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li ng-class=\"!vm.activeTab ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = ''\">Overview</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'schedule' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = 'schedule'\">Schedule</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'scoreboard' ? 'active' : ''\" ng-if=\"vm.service.showAnyScoreboards\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = 'scoreboard'\">Scoreboard</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'publish' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = 'publish'\">Publish</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'advanced' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = 'advanced'\">Advanced</a>\n    </li>\n  </ol>\n</div>\n<div class=\"modal-body\">\n\n  <main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n    <form name=\"form\" role=\"form\">\n\n      <div>\n        <div ng-if=\"vm.showError\">\n          <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n            {{vm.service.errors.join('. ') || 'Please fill out all required fields before proceeding.'}}\n          </div>\n        </div>\n\n        <div\n          ng-if=\"vm.service.broadcast.stream_source == 'recording' && vm.service.broadcast.timeframe != 'past' && vm.service.sourceBroadcastProblem\">\n          <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n            The source recording for this simulated live broadcast {{ vm.service.sourceBroadcastProblem }}.\n            Please delete the broadcast, or edit it to choose a new source broadcast.\n          </div>\n        </div>\n\n\n        <div ng-if=\"!vm.activeTab\">\n          <div class=\"form-group\">\n            <label for=\"eventName\">Broadcast Name <i class=\"fa fa-asterisk text-danger\" \n                style=\"font-size:10px;vertical-align:top\"></i></label>\n            <input type=\"text\" class=\"form-control\" id=\"eventName\" name=\"eventName\" ng-model=\"vm.service.broadcast.name\" \n              ng-maxlength=\"::vm.service.limits.name\" required>\n            <p ng-show=\"!vm.service.broadcast.name\">\n              <span class=\"text-danger\" ng-if=\"form.eventName.$error.maxlength\">The broadcast name is too long.</span>\n              <span class=\"text-danger\" ng-if=\"form.eventName.$error.required\">The broadcast name cannot be blank.</span>\n            </p>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group col-xs-12 col-sm-8\">\n              <label for=\"eventDescription\">Broadcast Description</label>\n              <textarea rows=\"3\" class=\"form-control\" id=\"eventDescription\"\n                ng-model=\"vm.service.broadcast.description\"></textarea>\n            </div>\n            <div class=\"form-group col-xs-12 col-sm-4\" ng-hide=\"vm.service.simulcastOnly\">\n              <div ng-if=\"vm.service.broadcast.content_settings.preview\" class=\"text-center\">\n                <img ng-src=\"{{vm.service.broadcast.content_settings.preview | trustedUrl}}\" class=\"img\"\n                  style=\"max-width:100%\">\n                <div><a href ng-click=\"vm.service.broadcast.content_settings.preview = null\">Change</a></div>\n              </div>\n              <div ng-if=\"!vm.service.broadcast.content_settings.preview\">\n                <upload-slot ng-model=\"vm.file\" ng-change=\"vm.service.uploadPreviewImage(vm.file)\" slot-name=\"'preview'\"\n                  allow-image=\"true\" allow-video=\"false\" compact=\"true\"></upload-slot>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"boxcaster\" ng-if=\"vm.service.broadcast.stream_source != 'imported'\">Source<i \n                class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <source-chooser edit-or-create-event-service=\"vm.service\"></source-chooser>\n            <label ng-if=\"vm.service.isSimulatedLive\" style=\"margin-top: 5px;\">Source Broadcast<i \n                class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <recording-source-chooser ng-if=\"vm.service.isSimulatedLive\" edit-or-create-event-service=\"vm.service\">\n            </recording-source-chooser>\n          </div>\n\n\n          <div class=\"row\" ng-show=\"vm.service.isRTMPBasedSource\">\n            <div class=\"form-group col-sm-6\" ng-hide=\"vm.service.hideOptionVideoResolution\">\n              <label for=\"video_resolution\">Video Resolution</label>\n              <div class=\"btn-group btn-group-justified\">\n                <label class=\"btn btn-default btn-sm\" ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n                  ng-model=\"vm.service.broadcast.target_video_resolution\" uib-btn-radio=\"480\"\n                  ng-if=\"vm.service.resolutionLimit >= 480\">480p</label>\n                <label class=\"btn btn-default btn-sm\" ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n                  ng-model=\"vm.service.broadcast.target_video_resolution\" uib-btn-radio=\"720\"\n                  ng-if=\"vm.service.resolutionLimit >= 720\">720p</label>\n                <label class=\"btn btn-default btn-sm\" ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n                  ng-model=\"vm.service.broadcast.target_video_resolution\" uib-btn-radio=\"1080\"\n                  ng-if=\"vm.service.resolutionLimit >= 1080\">1080p</label>\n              </div>\n            </div>\n            <div class=\"form-group col-sm-6\" ng-hide=\"vm.service.hideHighFrameRate\">\n              <label for=\"target_high_frame_rate\">Frame Rate</label>\n              <div class=\"btn-group btn-group-justified btn-group-flex\">\n                <label class=\"btn btn-default btn-sm font-bold\" ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n                  ng-model=\"vm.service.broadcast.target_high_frame_rate\" uib-btn-radio=\"false\">Standard&nbsp; <small\n                    style=\"font-weight: 400\">30fps max</small></label>\n                <label class=\"btn btn-default btn-sm font-bold\" ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n                  ng-model=\"vm.service.broadcast.target_high_frame_rate\" uib-btn-radio=\"true\">High&nbsp; <small\n                    style=\"font-weight: 400\">60fps max</small></label>\n              </div>\n            </div>\n          </div>\n\n        </div>\n\n        <div ng-if=\"vm.activeTab == 'schedule'\">\n\n          <!-- allow full date editing for future events -->\n          <div class=\"row\" ng-if=\"vm.canEditStart\">\n            <div class=\"col-xs-12\" style=\"margin:0 0 15px 0\">\n              <div style=\"display:flex; flex-wrap:wrap;\">\n                <div style=\"width:290px;\">\n                  <div class=\"form-group\">\n                    <div class=\"datepicker\">\n                      <!-- hack: need wrapper class to target custom styles -->\n                      <uib-datepicker ng-model=\"vm.service.startDate\" ng-change=\"vm.service.getConflictingEvents(true)\"\n                        datepicker-options=\"vm.service.datepickerOptions\"></uib-datepicker>\n                    </div>\n                  </div>\n                </div>\n\n\n                <div style=\"width:225px;flex:1;\">\n                  <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\" \n                    ng-if=\"vm.service.broadcast.timeframe != 'past' && vm.service.account.max_simultaneous_streams > 0 && vm.service.worstCaseSimultaneousStreams >= vm.service.account.max_simultaneous_streams\">\n                    <h5 style=\"margin-top:0;font-weight:bold;\">\n                      Stream Limits\n                    </h5>\n                    <p>\n                      Your account is only able to stream {{ vm.service.account.max_simultaneous_streams }}\n                      simultaneous broadcast{{ vm.service.account.max_simultaneous_streams > 1 ? 's' : '' }}. This\n                      broadcast will not start if that count is exceeded. If you would like to add additional\n                      simultaneous broadcasts to your account, please <a href=\"mailto:questions@boxcast.com\" \n                      target=\"_blank\">contact customer support</a>.\n                    </p>\n                  </div>\n                  <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\" \n                    ng-if=\"vm.service.conflictingEvents.length > 0\">\n                    <h5 style=\"margin-top:0;font-weight:bold;\">\n                      Conflicting Broadcasts\n                    </h5>\n                    <ul class=\"list-unstyled\" style=\"margin:0\">\n                      <li ng-repeat=\"broadcast in vm.service.conflictingEvents track by broadcast.id\">\n                        {{::broadcast.name}}\n                        <span>({{::broadcast.starts_at | date:'h:mm a'}} - {{::broadcast.stops_at | date:'shortTime'}})</span>\n                      </li>\n                    </ul>\n                  </div>\n                  <div ng-if=\"vm.service.otherEvents.length > 0\">\n                    <h5 style=\"margin-top:0;font-weight:bold;\">\n                      Other Broadcasts on {{vm.service.startDate | date}}\n                    </h5>\n                    <ul class=\"list-unstyled\" style=\"margin:0\">\n                      <li class=\"text-muted\" ng-repeat=\"broadcast in vm.service.otherEvents track by broadcast.id\">\n                        {{::broadcast.name}}\n                        <span class=\"\"> -- ({{::broadcast.starts_at | date:'h:mm a'}}</span>\n                        <span class=\"\" ng-if=\"broadcast.stops_at && !broadcast.stops_at.startsWith('9999-12-31')\">\n                          - {{::broadcast.stops_at | date:'shortTime'}})\n                        </span>\n                      </li>\n                    </ul>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n          </div>\n\n          <!-- no date editing for non-future events (only stop time if current) -->\n          <div class=\"row\" ng-if=\"!vm.canEditStart\">\n            <div class=\"col-xs-12\">\n              <div class=\"form-group\">\n                <label>Start Date</label>\n                <input class=\"form-control\" disabled value=\"{{vm.service.startDate | date:'mediumDate'}}\"\n                  style=\"max-width:360px\">\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12\">\n              <div class=\"form-group pull-left\" style=\"max-width:200px;padding-right:15px;\">\n                <label>Start Time</label>\n                <time-picker ng-if=\"vm.canEditStart\" ng-model=\"vm.service.startTime\" start-time=\"vm.minStartTime\"\n                  scroll-item-into-focus=\"true\" ng-change=\"vm.service.getConflictingEvents()\"></time-picker>\n                <input ng-if=\"!vm.canEditStart\" class=\"form-control\" disabled\n                  value=\"{{vm.service.startTime | date:'shortTime'}}\">\n                <p class=\"text-warning\" ng-show=\"vm.service.recordingStorageExpires\">\n                  <i class=\"fa fa-warning\"></i>\n                  The source recording for this simulated live broadcast will be purged before the broadcast's start\n                  time.\n                </p>\n              </div>\n              <div class=\"form-group pull-left\" style=\"max-width:200px;padding-right:15px;\">\n                <label>End Time</label>\n                <time-picker ng-if=\"vm.canEditStop\" ng-hide=\"vm.service.isSimulatedLive\" ng-model=\"vm.service.endTime\"\n                  start-time=\"vm.service.startTime\" show-duration=\"true\" ng-change=\"vm.service.getConflictingEvents()\">\n                </time-picker>\n                <input ng-if=\"!vm.canEditStop && !vm.service.isSimulatedLive\" class=\"form-control\" disabled\n                  value=\"{{vm.service.endTime | date:'shortTime'}}\">\n                <p class=\"help-block\" ng-if=\"vm.canEditStop\"\n                  ng-show=\"vm.service.isSimulatedLive && !vm.service.simulatedLiveEndTime\">\n                  <i class=\"fa fa-clock-o\" style=\"width:15px;\"></i>\n                  End time will be calculated from the recording duration.\n                </p>\n                <input ng-if=\"vm.service.isSimulatedLive && vm.service.simulatedLiveEndTime\" class=\"form-control\"\n                  disabled value=\"{{vm.service.simulatedLiveEndTime | date:'shortTime' | lowercase}}\">\n              </div>\n              <div class=\"form-group pull-left\" ng-if=\"!vm.service.isSimulatedLive\">\n                <p class=\"help-block\">\n                  <i class=\"fa fa-clock-o\"></i>\n                  Duration: {{ vm.service.startTime | dateDuration : vm.service.endTime : false :\n                  vm.service.maxBroadcastDurationHours+':00' }} hours\n                </p>\n              </div>\n            </div>\n            <div class=\"col-xs-12\">\n              <p class=\"text-warning\"\n                ng-show=\"!vm.service.isSimulatedLive && vm.service.endTime.toTimeString() < vm.service.startTime.toTimeString()\">\n                <i class=\"fa fa-warning\"></i>\n                The end time is <em>before</em> the start time, so the broadcast will continue until the following day\n              </p>\n              <p class=\"text-danger\"\n                ng-show=\"!vm.service.isSimulatedLive && vm.service.endTime.toTimeString() == vm.service.startTime.toTimeString()\">\n                <i class=\"fa fa-warning\"></i>\n                A broadcast must have a non-zero duration\n              </p>\n              <p class=\"text-danger\"\n                ng-show=\"vm.service.broadcast.stream_source != 'imported' && vm.service.isInThePast && vm.canEditStart && vm.canEditStop\">\n                <i class=\"fa fa-warning\"></i>\n                A broadcast may not be scheduled in the past\n              </p>\n              <p class=\"help-block\">\n                <i class=\"fa fa-info-circle\"></i>\n                All times {{vm.currentTimezone}}\n              </p>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.activeTab == 'scoreboard'\">\n          <div ng-init=\"sc = vm.service.broadcast.scoreboard_configuration\"></div>\n          <div ng-if=\"vm.service.broadcast.timeframe != 'past'\" style=\"margin-top:-15px\">\n            <scoreboard-tab-config vm=\"vm\" sc=\"sc\" show-clear=\"true\"></scoreboard-tab-config>\n          </div>\n          <div ng-if=\"vm.service.broadcast.timeframe == 'past'\">\n            <div ng-if=\"!sc.sport\" class=\"form-group clearfix\">\n              <p><em>Scoreboard overlay not configured.</em></p>\n            </div>\n            <div ng-if=\"sc.sport\" class=\"form-group clearfix\">\n              <div class=\"col-sm-12\">\n                <scoreboard-config-summary service=\"vm.service\"\n                  scoreboard-configuration=\"vm.service.broadcast.scoreboard_configuration\" label-suffix=\"\"\n                  bold-labels=\"true\" bold-values=\"false\"></scoreboard-config-summary>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.activeTab == 'publish'\">\n\n          <div class=\"form-group\" ng-hide=\"vm.service.simulcastOnly\">\n            <label>Broadcast Type:<i class=\"fa fa-asterisk text-danger\" \n              style=\"font-size:10px;vertical-align:top\"></i></label>\n            <div>\n              <div class=\"btn-group\">\n                <label class=\"btn btn-default\"                                 ng-model=\"vm.service.visibility\" uib-btn-radio=\"'private'\"> Private</label>\n                <label class=\"btn btn-default\" ng-if=\"vm.service.showPublic\"   ng-model=\"vm.service.visibility\" uib-btn-radio=\"'public'\"> Public</label>\n                <label class=\"btn btn-default\" ng-if=\"vm.service.showFlex\"     ng-model=\"vm.service.visibility\" uib-btn-radio=\"'flex'\"> Flex (Ticketed HD)</label>\n                <label class=\"btn btn-default\" ng-if=\"vm.service.showTicketed\" ng-model=\"vm.service.visibility\" uib-btn-radio=\"'ticketed'\"> Ticketed</label>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"vm.service.showScrambleOption\">\n            <span ng-click=\"vm.service.scrambleChannelId = !vm.service.scrambleChannelId\"\n              style=\"cursor:pointer;opacity:0.8\">\n              <i class=\"fa\" ng-class=\"vm.service.scrambleChannelId ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Remove the existing boxcast.tv link\n            </span>\n            <i class=\"fa fa-question-circle\" uib-tooltip=\"Since you are toggling the visibility to private, we recommend\n                regenerating the boxcast.tv link in case it was ever shared. If the link was never shared, you can leave\n                the link as-is by unchecking this box.\"></i>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"vm.service.visibility == 'ticketed' || vm.service.visibility == 'flex'\">\n            <label for=\"ticket_price\">Ticket Price <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <div class=\"input-group display-flex align-items-center\">\n              <div class=\"input-group-addon\">$</div>\n              <input type=\"number\" step=\"0.01\" min=\"4\" class=\"form-control\" style=\"max-width: 100px\" id=\"ticket_price\" ng-model=\"vm.service.broadcast.ticket_price\">\n              <div ng-if=\"vm.service.visibility == 'flex'\">\n                <div style=\"padding: 0.5rem 1rem; display: inline-block;\">\n                  <i class=\"fa fa-info-circle\"></i>\n                  Viewers will receive a low-quality stream for free\n                </div>\n              </div>\n            </div>\n            <p class=\"help-block\"><i class=\"fa fa-info-circle\"></i> The minimum ticket price is $4.00</p>\n          </div>\n\n          <div class=\"form-group\" ng-show=\"vm.service.showChannelSelector\">\n            <label>Channels</label>\n            <div>\n              <select selectize config=\"{\n                valueField: 'id',\n                labelField: 'name',\n                placeholder: 'Select Channels...',\n                highlight: true,\n                searchField: 'name',\n                selectOnTab: true,\n                plugins: ['remove_button']\n              }\" options=\"vm.service.channels\" ng-model=\"vm.service.broadcast.in_channel_ids\"></select>\n            </div>\n            <p class=\"text-warning\" ng-if=\"vm.service.visibility == 'private'\">\n              <i class=\"fa fa-warning\"></i> Channels are not applicable to private broadcasts.\n            </p>\n          </div>\n\n          <div class=\"form-group\" ng-show=\"vm.service.showFeatured\">\n            <label>Tags</label>\n            <div>\n              <select id=\"tagSelect\" selectize config=\"{\n                valueField: 'name',\n                labelField: 'name',\n                placeholder: 'Select Tags...',\n                highlight: true,\n                searchField: 'name',\n                selectOnTab: true,\n                plugins: ['remove_button'],\n                create: true\n              }\" options=\"vm.service.tags\" ng-model=\"vm.service.broadcast.tags\"></select>\n            </div>\n          </div>\n\n          <div\n            ng-if=\"vm.service.broadcast.stream_source != 'imported' &&\n              (vm.service.broadcast.timeframe != 'past' || vm.service.broadcast.simulcast_configurations.length) &&\n              (vm.service.allowFacebookLive || vm.service.allowYoutubeLive || vm.service.allowGenericRtmpPush || vm.service.allowTwitter)\">\n            <div ng-if=\"vm.service.broadcast.timeframe == 'past'\">\n              <div class=\"form-group clearfix\" ng-repeat=\"s in vm.service.broadcast.simulcast_configurations\">\n                <label ng-if=\"s.destination == 'facebook'\">Facebook Live</label>\n                <div ng-if=\"s.destination == 'facebook'\">\n                  Streamed by FB user \"{{s.fb_user_name}}\"\n                  <span ng-if=\"s.fb_feed_id == 'user:me'\">to a timeline</span>\n                  <span ng-if=\"s.fb_feed_id != 'user:me'\">to {{ vm.facebookLiveSimulcastFeedType(s) }} {{\n                    vm.facebookLiveSimulcastFeedID(s) }}</span>\n                  with visibility \"{{s.fb_privacy}}\".\n                </div>\n                <label ng-if=\"s.destination == 'youtube'\">YouTube Live</label>\n                <div ng-if=\"s.destination == 'youtube'\">\n                  Streamed by YT user \"{{s.youtube_display_name}}\"\n                  with visibility \"{{s.privacy}}\".\n                </div>\n                <label ng-if=\"s.destination == 'periscope'\">Periscope</label>\n                <div ng-if=\"s.destination == 'periscope'\">\n                  Streamed by Periscope user \"{{s.periscope_display_name}}\".\n                </div>\n                <label ng-if=\"s.destination == 'twitter'\">Twitter</label>\n                <div ng-if=\"s.destination == 'twitter'\">\n                  Streamed by Twitter user \"{{s.twitter_display_name}}\".\n                </div>\n                <label ng-if=\"s.destination == 'generic' || s.destination == 'rtmp_push_channel'\">Other RTMP</label>\n                <div ng-if=\"s.destination == 'generic'\">\n                  Streamed to <code>{{s.stream_url}}/{{s.stream_key}}</code>\n                </div>\n                <div ng-if=\"s.destination == 'rtmp_push_channel'\">\n                  Streamed to <code>{{s.name}}</code>\n                </div>\n              </div>\n            </div>\n            <div ng-if=\"vm.service.broadcast.timeframe != 'past'\" class=\"row\">\n              <simulcast-configuration-editor vm=\"vm\" vertical-form=\"true\"></simulcast-configuration-editor>\n            </div>\n          </div>\n          <!--/ social simulcast wrapper-->\n\n        </div>\n\n        <div ng-if=\"vm.activeTab == 'advanced'\">\n\n          <div class=\"form-group\" ng-hide=\"vm.service.hideOptionRecord\">\n            <label ng-click=\"vm.toggleDoNotRecord()\" ng-style=\"vm.styleDoNotRecord\">\n              <i class=\"fa\" ng-class=\"vm.service.broadcast.do_not_record ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Enable Live-Only\n              <i class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\"\n                uib-tooltip=\"Enabling this option means viewers can only watch the broadcast while it is live. Disabling this option will record the broadcast and offer on-demand playback when the broadcast is over.\"\n                tooltip-placement=\"bottom\" style=\"opacity:0.5\"></i>\n            </label>\n          </div>\n\n          <div class=\"form-group\"\n            ng-hide=\"!vm.service.FeatureFlags.automated_captioning || vm.service.FeatureFlags.live_automated_captioning || vm.service.broadcast.timeframe == 'past' || vm.service.broadcast.do_not_record || vm.service.isSimulatedLive\">\n            <label ng-click=\"vm.service.broadcast.requests_captioning = !vm.service.broadcast.requests_captioning\"\n              style=\"cursor:pointer\">\n              <i class=\"fa\" ng-class=\"vm.service.broadcast.requests_captioning ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Request Automated Captioning When Recorded\n            </label>\n          </div>\n\n          <div class=\"form-group\"\n            ng-hide=\"!vm.service.FeatureFlags.live_automated_captioning || vm.service.broadcast.timeframe != 'future' || vm.service.isSimulatedLive\">\n            <label ng-click=\"vm.service.broadcast.requests_captioning = !vm.service.broadcast.requests_captioning\"\n              style=\"cursor:pointer\">\n              <i class=\"fa\" ng-class=\"vm.service.broadcast.requests_captioning ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Automated Live Captioning\n            </label>\n          </div>\n\n          <div ng-if=\"::vm.service.FeatureFlags.password\" class=\"form-group\">\n            <label\n              ng-click=\"vm.service.broadcast.content_settings.cryptblock = vm.service.broadcast.content_settings.cryptblock ? null : {}\"\n              style=\"cursor:pointer\">\n              <i class=\"fa\"\n                ng-class=\"vm.service.broadcast.content_settings.cryptblock ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Enable Password Protection\n            </label>\n            <div ng-if=\"vm.service.broadcast.content_settings.cryptblock\" style=\"margin-top:5px\">\n              <div>\n                <span ng-show=\"vm.service.broadcast.content_settings.cryptblock.crypt\">Change Password</span>\n                <span ng-hide=\"vm.service.broadcast.content_settings.cryptblock.crypt\">Enter Password</span>\n              </div>\n              <input type=\"password\" autocomplete=\"hi-browser-plz-dont-autofill-this\" class=\"form-control\"\n                ng-model=\"vm.service.broadcast.content_settings.cryptblock.__password__\">\n            </div>\n          </div>\n\n          <div ng-if=\"::vm.service.FeatureFlags.enterprise_last_mile_delivery\" class=\"form-group\">\n            <label\n              ng-click=\"vm.service.broadcast.content_settings.enterprise_last_mile_delivery = !vm.service.enterpriseLastMileDelivery\"\n              style=\"cursor:pointer\">\n              <i class=\"fa\" ng-class=\"vm.service.enterpriseLastMileDelivery ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Enable Enterprise Last-Mile Delivery\n            </label>\n          </div>\n\n          <div ng-if=\"::vm.service.FeatureFlags.host_restrictions\" class=\"form-group\">\n            <host-restrictions-settings content-settings=\"vm.service.broadcast.content_settings\">\n            </host-restrictions-settings>\n          </div>\n\n          <div ng-if=\"::vm.service.FeatureFlags.podcast\">\n            <p style=\"font-weight:bold;\">\n              <a ng-click=\"vm.showPodcast = !vm.showPodcast\" href>\n                <i class=\"fa\" ng-class=\"vm.showPodcast ? 'fa-caret-down' : 'fa-caret-right'\"></i>\n                {{vm.showPodcast ? 'Hide' : 'Show'}} Podcast-Specific Settings\n              </a>\n            </p>\n            <div ng-show=\"vm.showPodcast\">\n              <podcast-settings broadcast=\"vm.service.broadcast\"\n                on-upload-preview-image=\"vm.service.uploadPodcastPreviewImage\"></podcast-settings>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-show=\"vm.service.showOptionTargetBufferLatency\">\n            <label for=\"target_buffer_latency\">\n              BoxCast Flow Control\n              <i class=\"fa fa-question-circle\" style=\"opacity:0.5\"\n                uib-tooltip-html=\"vm.service.targetBufferLatencyTooltip\" tooltip-append-to-body=\"true\"></i>\n            </label>\n            <select class=\"form-control\" id=\"target_buffer_latency\"\n              ng-disabled=\"vm.service.broadcast.timeframe != 'future'\"\n              ng-model=\"vm.service.broadcast.target_buffer_latency\"\n              ng-options=\"e.value as e.label for e in vm.service.bufferLatencies\">\n            </select>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.hideOptionTargetVideoBitRate\">\n            <label for=\"target_video_bitrate\">Target Video Bitrate</label>\n            <select class=\"form-control\" id=\"target_video_bitrate\" ng-disabled=\"vm.service.disableVideoBitrate\"\n              ng-model=\"vm.service.broadcast.target_video_bitrate\" ng-options=\"\n                        e.value as e.label\n                        disable when (\n                          (e.label == 'Audio Only' && vm.service.disableAudioOnlyOption)\n                          || (e.label == 'Default' && vm.service.disableDefaultVideoBitrateOption)\n                          || (e.label == 'Auto-detect' && vm.service.disableDefaultVideoBitrateOption)\n                        )\n                        for e in vm.service.videoBitrates\n                      \">\n            </select>\n            <p ng-if=\"vm.service.broadcast.timeframe == 'current' && vm.service.isAudioOnly\" class=\"help-block\">\n              <i class=\"fa fa-info-circle\"></i> Audio-only broadcasts cannot be changed to display video once started.\n            </p>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.hideOptionTargetAudioBitRate\">\n            <label for=\"target_audio_bitrate\">Target Audio Bitrate</label>\n            <select class=\"form-control\" id=\"target_audio_bitrate\"\n              ng-disabled=\"vm.service.broadcast.timeframe == 'past'\"\n              ng-model=\"vm.service.broadcast.target_audio_bitrate\"\n              ng-options=\"e.value as e.label for e in vm.service.audioBitrates\">\n            </select>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.hideOptionAudioSource\">\n            <label for=\"audio_source\">Audio Source</label>\n            <select class=\"form-control\" id=\"audio_source\" ng-disabled=\"vm.service.broadcast.timeframe == 'past'\"\n              ng-model=\"vm.service.broadcast.audio_source\"\n              ng-options=\"e.value as e.label for e in vm.service.audioSources\">\n            </select>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.isRTMPBasedSource || vm.service.hideOptionVideoResolution\">\n            <label for=\"video_resolution\">Video Resolution</label>\n            <select class=\"form-control\" id=\"video_resolution\"\n              ng-disabled=\"vm.service.broadcast.timeframe != 'future' || vm.service.isAudioOnly\"\n              ng-model=\"vm.service.broadcast.target_video_resolution\"\n              ng-options=\"e.value as e.label for e in vm.service.videoResolutions\">\n            </select>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.isRTMPBasedSource || vm.service.hideHighFrameRate\">\n            <label for=\"target_high_frame_rate\">High Frame Rate</label>\n            <select class=\"form-control\" id=\"target_high_frame_rate\"\n              ng-disabled=\"vm.service.broadcast.timeframe != 'future' || vm.service.isAudioOnly\"\n              ng-model=\"vm.service.broadcast.target_high_frame_rate\"\n              ng-options=\"e.value as e.label for e in vm.service.highFrameRates\">\n            </select>\n          </div>\n          <div class=\"form-group\" ng-hide=\"vm.service.hideOptionDSCPValue\">\n            <label for=\"dscp\">DSCP Value</label>\n            <select class=\"form-control\" id=\"dscp\" ng-disabled=\"vm.service.broadcast.timeframe == 'past'\"\n              ng-model=\"vm.service.broadcast.dscp_value\"\n              ng-options=\"e.value as e.label for e in ::vm.service.dscpValues\">\n            </select>\n          </div>\n        </div>\n\n\n      </div>\n</div>\n</form>\n</main>\n\n</div>\n<div class=\"modal-footer\" ng-if=\"vm.service.broadcast.id\">\n  <ul class=\"list-inline pull-left\">\n    <li ng-if=\"::vm.service.canDelete\">\n      <a href=\"javascript://\" ng-click=\"vm.delete()\" class=\"action-link\">\n        <i class=\"fa fa-trash\"></i>\n        Delete\n      </a>\n    </li>\n    <li>\n      <a href=\"javascript://\" ng-click=\"vm.clone()\" class=\"action-link\">\n        <i class=\"fa fa-copy\"></i>\n        Duplicate\n      </a>\n    </li>\n  </ul>\n\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Close</button>\n  <button class=\"btn btn-primary\" ng-click=\"vm.submit()\" ng-disabled=\"vm.submitting\">\n    <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n    Save Changes\n  </button>\n</div>"

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["uploadImageToOverlay"] = uploadImageToOverlay;
// overlay image directive
//
//   <overlay-image overlay="{...}" on-change="..." />
//
// works closely with the draggable and resizable directives
//
var module = angular.module('app.directives');
module.directive('overlayPreview', function () {
  'ngInject';

  return {
    scope: {
      overlay: '='
    },
    template: "\n      <div class=\"fixed-16-9 transparent-grid-bg\">\n        <div class=\"upload-image\" ng-style=\"{\n          'background-image': 'url(&quot;'+overlay.url+'&quot;)',\n          'background-repeat': 'no-repeat',\n          'background-position': '0% 0%',\n          'background-size': 'contain',\n        }\">\n        </div>\n      </div>\n    "
  };
});
module.directive('overlayImage', function () {
  'ngInject';

  return {
    scope: {
      overlay: '=',
      onChange: '='
    },
    template: "\n      <div class=\"overlay-image\"\n           ng-style=\"style\"\n           draggable=\"\"\n           resizable=\"\"\n           aspect-ratio=\"overlay.height / overlay.width\"\n           on-drag=\"onDrag\"\n           on-resize=\"onResize\"\n           ></div>\n    ",
    controller: function controller($scope) {
      'ngInject';

      var overlay = $scope.overlay;
      $scope.style = {
        position: 'absolute',
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(overlay.url, "\")"),
        top: 100 * overlay.offsetY + '%',
        left: 100 * overlay.offsetX + '%',
        width: 100 * overlay.scaleWidth + '%',
        height: 100 * overlay.scaleHeight + '%'
      };

      $scope.onDrag = function (xPct, yPct) {
        $scope.onChange(overlay, {
          offsetX: roundFloatTo5Decimals(xPct / 100),
          offsetY: roundFloatTo5Decimals(yPct / 100)
        });
      };

      $scope.onResize = function (wPct, hPct) {
        $scope.onChange(overlay, {
          scaleWidth: roundFloatTo5Decimals(wPct / 100),
          scaleHeight: roundFloatTo5Decimals(hPct / 100)
        });
      };
    }
  };
});
function uploadImageToOverlay(upload, width, height) {
  var scaleW = width / 1920.0; //simulated canvas assumes 1920x1080

  var scaleH = height / 1080.0; //simulated canvas assumes 1920x1080

  if (scaleW > 1) {
    scaleW = 1;
    scaleH = height / width * (1920 / 1080);
  }

  if (scaleH > 1) {
    scaleH = 1;
    scaleW = width / height * (1080 / 1920);
  }

  return {
    url: upload.view_url,
    width: width,
    height: height,
    scaleWidth: roundFloatTo5Decimals(scaleW),
    scaleHeight: roundFloatTo5Decimals(scaleH),
    offsetX: 0,
    offsetY: 0
  };
}

function roundFloatTo5Decimals(val) {
  // api/origin doesn't deal with long floating point well
  return Math.round(val * 100000) / 100000;
}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = "<div cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...'}\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n    <h3 class=\"modal-title\">{{vm.modalTitle}}</h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"pull-right\" style=\"width:200px\">\n      <form ng-submit=\"vm.search()\">\n        <div class=\"form-group\" style=\"margin-bottom:0;\">\n          <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"Search\" ng-model=\"vm.searchText\">\n            <span class=\"input-group-btn\">\n              <button class=\"btn btn-default btn-secondary\" type=\"submit\">\n                <i ng-hide=\"vm.searching\" class=\"fa fa-search\"></i>\n                <i ng-show=\"vm.searching\" class=\"fa fa-spin fa-spinner\"></i>\n              </button>\n            </span>\n          </div>\n        </div>\n      </form>\n    </div>\n\n    <uib-tabset active=\"vm.activeTab\">\n\n      <uib-tab select=\"vm.changeTab('current')\" index=\"0\"\n               ng-if=\"vm.broadcasts.current.data.length > 0\">\n        <uib-tab-heading>\n          <i class=\"fa fa-dot-circle-o text-danger\"></i> Current <span class=\"hidden-xs\">Broadcasts</span>\n        </uib-tab-heading>\n        <div class=\"tab-container clearfix\">\n          <p ng-if=\"vm.currentSearchText\" class=\"help-block\">\n            <i class=\"fa fa-info-circle\"></i> Search terms are not applied to current broadcasts.\n          </p>\n          <div>\n            <ul class=\"list-unstyled\" style=\"margin-top:15px\">\n              <li ng-repeat=\"broadcast in vm.broadcasts.current.data track by broadcast.id\">\n                <broadcast-card broadcast=\"broadcast\" show-view-count=\"false\" extra-css-classes=\"'col-lg-3 col-sm-6 col-xs-12'\" prevent-edit=\"true\" on-select=\"vm.select(broadcast)\"></broadcast-card>\n              </li>\n            </ul>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n      </uib-tab>\n\n      <uib-tab select=\"vm.changeTab('upcoming')\" index=\"1\">\n        <uib-tab-heading>\n          Upcoming <span class=\"hidden-xs\">Broadcasts</span>\n          <span class=\"label label-primary label-as-badge\">{{vm.eventCount(vm.broadcasts.upcoming)}}</span>\n        </uib-tab-heading>\n        <div class=\"tab-container\">\n          <p class=\"help-block\" ng-if=\"vm.broadcasts.upcoming.data.length\">\n            <i class=\"fa fa-search\"></i>\n            Showing results\n            {{vm.broadcasts.upcoming.pagination.resultMin}} -\n            {{vm.broadcasts.upcoming.pagination.resultMax}}\n            of {{vm.broadcasts.upcoming.pagination.total}}\n            <span ng-if=\"vm.currentSearchText\">\n              for search term \"{{vm.currentSearchText}}\"\n              (<a href=\"javascript://\" ng-click=\"((vm.searchText = '') || true) && vm.search()\" style=\"color:#aaa\" class=\"action-link\">clear search</a>)\n            </span>\n          </p>\n          <div>\n            <ul class=\"list-unstyled\" style=\"margin-top:15px\">\n              <li ng-repeat=\"broadcast in vm.broadcasts.upcoming.data track by broadcast.id\">\n                <broadcast-card broadcast=\"broadcast\" show-view-count=\"false\" extra-css-classes=\"'col-lg-3 col-sm-6 col-xs-12'\" prevent-edit=\"true\" on-select=\"vm.select(broadcast)\"></broadcast-card>\n              </li>\n            </ul>\n          </div>\n          <div class=\"clearfix\"></div>\n          <div ng-if=\"!vm.broadcasts.upcoming.data.length\" class=\"text-center\" style=\"padding-bottom:30px\">\n            <!-- empty state in upcoming tab -->\n            <div ng-if=\"!vm.currentSearchText\">\n              <h4 class=\"help-block\" style=\"margin:30px auto;\">\n                There are no scheduled broadcasts.\n              </h4>\n            </div>\n            <div ng-if=\"vm.currentSearchText\">\n              <h4 class=\"help-block\" style=\"margin:30px auto;\">\n                There are no scheduled broadcasts that match your search term \"{{vm.currentSearchText}}\".\n              </h4>\n              <a href ng-click=\"((vm.searchText = '') || true) && vm.search()\" class=\"btn btn-lg btn-default\">\n                <i class=\"fa fa-times\"></i> Clear Search\n              </a>\n            </div>\n          </div>\n          <uib-pagination ng-if=\"vm.broadcasts.upcoming.pagination.total > 12\"\n                          total-items=\"vm.eventCount(vm.broadcasts.upcoming)\"\n                          items-per-page=\"12\"\n                          max-size=\"10\"\n                          rotate=\"false\"\n                          class=\"pagination-sm\"\n                          ng-model=\"vm.broadcasts.upcoming.pagination.current\"\n                          ng-change=\"vm.loadBroadcast('upcoming')\"></uib-pagination>\n        </div>\n      </uib-tab>\n\n      <uib-tab select=\"vm.changeTab('past')\" index=\"2\">\n        <uib-tab-heading>\n          Past <span class=\"hidden-xs\">Broadcasts</span>\n          <span class=\"label label-default label-as-badge\">{{vm.eventCount(vm.broadcasts.past)}}</span>\n        </uib-tab-heading>\n        <div class=\"tab-container\">\n          <p class=\"help-block\" ng-if=\"vm.broadcasts.past.data.length\">\n            <i class=\"fa fa-search\"></i>\n            Showing results\n            {{vm.broadcasts.past.pagination.resultMin}} -\n            {{vm.broadcasts.past.pagination.resultMax}}\n            of {{vm.broadcasts.past.pagination.total}}\n            <span ng-if=\"vm.currentSearchText\">\n              for search term \"{{vm.currentSearchText}}\"\n              (<a href=\"javascript://\" ng-click=\"((vm.searchText = '') || true) && vm.search()\" style=\"color:#aaa\" class=\"action-link\">clear search</a>)\n            </span>\n          </p>\n          <div>\n            <ul class=\"list-unstyled\" style=\"margin-top:15px\">\n              <li ng-repeat=\"broadcast in vm.broadcasts.past.data track by broadcast.id\">\n                <broadcast-card broadcast=\"broadcast\" show-view-count=\"true\" extra-css-classes=\"'col-lg-3 col-sm-6 col-xs-12'\" prevent-edit=\"true\" on-select=\"vm.select(broadcast)\"></broadcast-card>\n              </li>\n            </ul>\n          </div>\n          <div class=\"clearfix\"></div>\n          <div ng-if=\"!vm.broadcasts.past.data.length\" class=\"text-center\" style=\"padding-bottom:30px\">\n            <!-- empty state in past tab -->\n            <div ng-if=\"!vm.currentSearchText\">\n              <h4 class=\"help-block\" style=\"margin:30px auto;\">\n                There are no past broadcasts.\n              </h4>\n            </div>\n            <div ng-if=\"vm.currentSearchText\">\n              <h4 class=\"help-block\" style=\"margin:30px auto;\">\n                There are no past broadcasts that match your search term \"{{vm.currentSearchText}}\".\n              </h4>\n              <a href ng-click=\"((vm.searchText = '') || true) && vm.search()\" class=\"btn btn-lg btn-default\">\n                <i class=\"fa fa-times\"></i> Clear Search\n              </a>\n            </div>\n          </div>\n\n          <uib-pagination ng-if=\"vm.broadcasts.past.pagination.total > 12\"\n                          total-items=\"vm.eventCount(vm.broadcasts.past)\"\n                          items-per-page=\"12\"\n                          max-size=\"10\"\n                          rotate=\"false\"\n                          class=\"pagination-sm\"\n                          ng-model=\"vm.broadcasts.past.pagination.current\"\n                          ng-change=\"vm.loadBroadcast('past')\"></uib-pagination>\n        </div>\n      </uib-tab>\n\n    </uib-tabset>\n  </div>\n</div>\n"

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = RecordingSourceChooserBrowseController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_search_query_builder__ = __webpack_require__(358);

var PAGE_SIZE = 12;
function RecordingSourceChooserBrowseController($uibModalInstance, $q, $http, Broadcast, Recording, toaster, options) {
  'ngInject'; // Parse options passed in from `resolve`

  var _this = this;

  this.skipRecordingSourceValidation = options.skipRecordingSourceValidation;
  this.modalTitle = options.modalTitle || 'Choose Source Broadcast';
  this.activeTab = options.activeTabIndex || 0;
  this.currentSearchText = '';
  this.searchText = '';
  this.searching = false;
  this.broadcasts = {
    upcoming: {
      $promise: null,
      data: [],
      pagination: {
        current: 1,
        resultMin: 0,
        resultMax: 0
      }
    },
    current: {
      $promise: null,
      data: [],
      pagination: {
        current: 1,
        resultMin: 0,
        resultMax: 0
      }
    },
    past: {
      $promise: null,
      data: [],
      pagination: {
        current: 1,
        resultMin: 0,
        resultMax: 0
      }
    }
  };

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.eventCount = function (broadcast) {
    if (broadcast.pagination && broadcast.pagination.total) {
      return "".concat(broadcast.pagination.total);
    } else {
      return broadcast.data.length;
    }
  };

  this.loadBroadcast = function (timeframe) {
    // Load the next page of events for the given broadcast set, and populate
    // the `this.broadcasts` data structure accordingly.
    // @param timeframe: one of 'upcoming', 'current', or 'past'
    var broadcast = _this.broadcasts[timeframe];
    var q = new __WEBPACK_IMPORTED_MODULE_0__utils_search_query_builder__["a" /* default */]();
    var s = 'starts_at'; //default sort order

    switch (timeframe) {
      case 'upcoming':
        q.append('timeframe:future');
        break;

      case 'current':
        q.append('timeframe:preroll').append('timeframe:current');
        break;

      case 'past':
        q.append('timeframe:past');
        s = '-starts_at'; //reverse sort

        break;
    } // NOTE: Current events tab is never filtered, as it's not expected to have
    // more than a handful ongoing and you wouldn't want to hide them anyway


    if (_this.searchText && timeframe != 'current') {
      q.appendSearchText(_this.searchText);
    }

    var query = Broadcast.query({
      q: q.toString(),
      s: s,
      p: broadcast.pagination.current - 1,
      l: PAGE_SIZE
    }, function (data, headers) {
      _this.currentSearchText = _this.searchText;
      broadcast.data = data;
      var pagination = JSON.parse(headers('x-pagination'));
      broadcast.pagination.total = pagination && pagination.total;
      broadcast.pagination.resultMin = PAGE_SIZE * (broadcast.pagination.current - 1) + 1;
      broadcast.pagination.resultMax = broadcast.pagination.resultMin + data.length - 1; // If current tab is selected but there's nothing in there, need to kick
      // user somewhere else (it's the only one that disappears)

      if (timeframe == 'current' && _this.activeTab === 0 && !data.length) {
        //console.log('Switching from current tab to upcoming since no more data', this.broadcasts);
        _this.activeTab = 1;
      }
    }, function (e) {
      console.error(e);
      toaster.pop('warning', 'Unable to load broadcasts. Please refresh the page and try again');
    });
    broadcast.$promise = query.$promise;
    _this.loadingPromises = [query.$promise];
  };

  this.reload = function () {
    _.each(_this.broadcasts, function (n, key) {
      _this.loadBroadcast(key);
    });

    _this.loadingPromises = [_this.broadcasts.upcoming.$promise, _this.broadcasts.current.$promise, _this.broadcasts.past.$promise];
  };

  this.search = function () {
    // Reset pagination and data
    _.each(_this.broadcasts, function (n, key) {
      var broadcast = _this.broadcasts[key];
      broadcast.pagination.current = 1;
      broadcast.pagination.total = 0;
    }); // Apply search term


    _this.reload(); // Handle loading spinner


    _this.searching = true;
    $q.all([_this.broadcasts.upcoming.$promise, _this.broadcasts.current.$promise, _this.broadcasts.past.$promise])["finally"](function () {
      return _this.searching = false;
    });
  };

  this.select = function (broadcast) {
    _this.loadingPromises = [Broadcast.get({
      id: broadcast.id
    }, function (b) {
      if (options.broadcastValidator) {
        try {
          options.broadcastValidator(b);
          $uibModalInstance.close(b);
        } catch (e) {
          toaster.pop('warning', e.toString());
        }
      } else if (_this.skipRecordingSourceValidation) {
        $uibModalInstance.close(b);
      } else if (b.timeframe != 'past') {
        if (b.stream_source == 'recording') {
          toaster.pop('warning', 'Please choose a non-simulated live broadcast.');
        } else {
          $uibModalInstance.close(b);
        }
      } else if (b.recording_duration_seconds > 0) {
        var segments = Recording.segments({
          id: b.recording_id
        });
        _this.loadingPromises = [segments.$promise];
        segments.$promise.then(function () {
          if (_.some(segments, function (s) {
            return s.byte_ranges;
          })) {
            $uibModalInstance.close(b);
          } else {
            toaster.pop('warning', "This broadcast's recording is not in the correct format. Please choose a newer broadcast, or upload a recording.");
          }
        })["catch"](function (e) {
          console.error(e);
          toaster.pop('warning', "This broadcast's recording could not be found, or is not in the correct format.");
        });
      } else {
        // Check to see if this is being uploaded
        if (!b.recording_id && b.stream_source == 'imported') {
          toaster.pop('warning', 'This broadcast is currently being uploaded; please try again when processing is complete.');
          return;
        }

        var uploadsPromise = $http.get("".concat(API_ROOT, "/account/broadcasts/").concat(broadcast.id, "/uploads"));
        _this.loadingPromises = [uploadsPromise];
        uploadsPromise.then(function (response) {
          if (!response || !response.data || !response.data.length) {
            toaster.pop('warning', 'Please choose a broadcast with a valid recording.');
            return;
          }

          var upload = response.data[0] || {};

          if (b.recording_id && ['created', 'uploaded', 'assigned', 'processing', 'failed'].indexOf(upload.status) >= 0) {
            toaster.pop('warning', 'This broadcast is currently being uploaded; please try again when processing is complete.');
            return;
          }

          toaster.pop('warning', 'Please choose a broadcast with a valid recording.');
        })["catch"](function (e) {
          console.error(e);
          toaster.pop('warning', "This broadcast's uploads could not be found.");
        });
      }
    }, function (e) {
      console.error(e);
      toaster.pop('warning', 'Unable to load broadcast. Please refresh the page and try again');
    }).$promise]; // This method returns true to let <broadcast-card/> know that we dealt with the selection and
    // it doesn't need to navigate / change state.

    return true;
  };

  this.reload();
}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = ComputeBroadcastStatus;
/* harmony export (immutable) */ __webpack_exports__["d"] = ComputePastBroadcastStarRating;
/* harmony export (immutable) */ __webpack_exports__["c"] = ComputePastBroadcastRecommendations;
/* harmony export (immutable) */ __webpack_exports__["f"] = GetBitrateLimitsForBroadcast;
/* harmony export (immutable) */ __webpack_exports__["k"] = V3Timestamps;
/* harmony export (immutable) */ __webpack_exports__["l"] = V3Values;
/* harmony export (immutable) */ __webpack_exports__["j"] = V3PlaceholderTimestamps;
/* harmony export (immutable) */ __webpack_exports__["g"] = HasIntegratedScoreboard;
/* harmony export (immutable) */ __webpack_exports__["i"] = V3HasAnyScoreboardData;
/* harmony export (immutable) */ __webpack_exports__["h"] = ParseScoreboardEvents;
/* harmony export (immutable) */ __webpack_exports__["e"] = FilterRSSIForLinkStatus;
/* harmony export (immutable) */ __webpack_exports__["a"] = BaselineIngestLatency;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var viewErrorMessages = {
  offline_title: 'The BoxCaster Is Offline',
  offline_subtitle: ' ',
  busy_title: 'BoxCaster Is Busy Streaming Another Broadcast',
  busy_subtitle: 'Once the other is finished, this broadcast will begin.',
  no_video_input_title: 'BoxCaster Cannot Detect an Audio/Video Signal',
  no_video_input_subtitle: ' ',
  updating_firmware_title: 'BoxCaster Is Busy Updating Firmware',
  updating_firmware_subtitle: 'Once finished, this broadcast will begin.'
};
var progressDescription = {
  rtmp: {
    1: 'Waiting to create a stream.',
    5: 'Waiting to allocate a server.',
    20: 'Preparing for your broadcast.',
    60: 'Stream settings configured.',
    90: ' '
  },
  boxcaster: {
    1: 'Waiting to allocate stream.',
    5: {
      title: 'Waiting for Your BoxCaster'
    },
    10: 'Preparing for your broadcast.',
    20: 'Testing your bandwidth.',
    40: 'Configuring your stream settings.',
    60: 'Stream settings configured.',
    90: ' '
  },
  app: {
    1: 'Waiting to allocate stream.',
    5: {
      title: 'Open the Broadcaster App to Start Streaming'
    },
    10: 'Preparing for your broadcast.',
    20: 'Testing your bandwidth.',
    40: 'Configuring your stream settings.',
    60: 'Stream settings configured.',
    90: ' '
  },
  recording: {
    1: 'Waiting to create a stream.',
    5: 'Waiting to allocate a server.',
    20: 'Preparing for your broadcast.',
    90: ' '
  },
  misc: {
    busy_another: {
      title: 'BoxCaster is Busy Streaming Another Broadcast'
    },
    simultaneous: {
      title: 'Waiting on Simultaneous Broadcast'
    }
  }
};
progressDescription.switcher = progressDescription.rtmp;
function ComputeBroadcastStatus(broadcast, view, boxcaster, streamDiagnostics, staticRTMPDiagnostics) {
  if (!view) {
    // wait for player to have _something_ to show
    return null;
  } else if (broadcast.timeframe != 'preroll' && broadcast.timeframe != 'current') {
    // only care during preroll+live
    return null;
  }

  var status = view.status,
      reason = view.reason,
      progress = view.progress;
  var stream_source = broadcast.stream_source,
      timeframe = broadcast.timeframe;
  var progressMsg = (progressDescription[stream_source] || {})[progress];

  var activeAlerts = _.pluck(_.where((streamDiagnostics || {}).alerts || [], {
    is_active: true
  }), 'message');

  var streamSourceName = 'BoxCaster';

  if (stream_source == 'rtmp') {
    streamSourceName = 'RTMP Encoder';
  } else if (stream_source == 'app') {
    streamSourceName = 'Broadcaster App';
  } else if (stream_source == 'switcher') {
    streamSourceName = 'Switcher Studio';
  } else if (stream_source == 'recording') {
    streamSourceName = 'Re-Broadcast (Simulated Live)';
  } // Special case of "busy broadcasting a different stream", which can't be
  // inferred from the broadcast/view directly.  Instead we assume if it's stuck at 1%
  // but the BoxCaster is reporting OK, it's caught in that scenario.


  if (boxcaster && boxcaster.status == 'broadcasting' && progress == 1) {
    progressMsg = progressDescription.misc.busy_another;
  }

  if (broadcast.is_limited_by_active_stream_count) {
    return angular.extend({
      status: 'error'
    }, progressDescription.misc.simultaneous);
  } // If the view has a specific reason or status that we've defined, those take
  // precedence over everything else, as they're very specific.


  if (viewErrorMessages["".concat(reason, "_title")]) {
    return {
      status: 'error',
      title: viewErrorMessages["".concat(reason, "_title")],
      subtitle: viewErrorMessages["".concat(reason, "_subtitle")]
    };
  } else if (viewErrorMessages["".concat(status, "_title")]) {
    return {
      status: 'error',
      title: viewErrorMessages["".concat(status, "_title")],
      subtitle: viewErrorMessages["".concat(status, "_subtitle")]
    };
  } // Take into account the static RTMP diagnostics when using RTMP.


  if (stream_source == 'rtmp' || stream_source == 'switcher') {
    if (!staticRTMPDiagnostics || !staticRTMPDiagnostics.connected) {
      return {
        status: 'error',
        title: 'The RTMP Source Is Not Connected'
      };
    }
  } // If we're supposed to be live and the view says we're live, let's
  // dig a little deeper into diagnostics.


  if (timeframe == 'current' && status == 'live') {
    if (activeAlerts.indexOf('Streaming interrupted') >= 0 || activeAlerts.indexOf('Waiting to receive data') >= 0) {
      return {
        status: 'error',
        title: "Connection from ".concat(streamSourceName, " Was Lost"),
        subtitle: ''
      };
    } else if (streamDiagnostics && streamDiagnostics.status == 'Critical') {
      return {
        status: 'error',
        title: 'Live (Broadcast Health Warning)',
        subtitle: activeAlerts.join(', ')
      };
    } else if (streamDiagnostics && streamDiagnostics.status == 'Warning') {
      return {
        status: 'warning',
        title: 'Live',
        subtitle: activeAlerts.join(', ')
      };
    } else {
      return {
        status: 'ok',
        title: 'Live',
        subtitle: ''
      };
    }
  } // Pre-roll states need to look at diagnostics and progress %


  if (timeframe == 'preroll') {
    if (streamDiagnostics && streamDiagnostics.status == 'OK') {
      return {
        status: 'ok',
        title: 'Ready To Go Live',
        subtitle: ''
      };
    } else {
      if (progressMsg && progressMsg.title) {
        return {
          status: 'warning',
          title: progressMsg.title,
          subtitle: progressMsg.subtitle || ''
        };
      } else {
        return {
          status: 'warning',
          title: 'Getting Ready',
          subtitle: progressMsg || "Catching up at ".concat(progress, "%")
        };
      }
    }
  } // Finally, if we're supposed to be live but aren't yet, let's look
  // at how much we know based on diagnostics/progress


  if ((streamDiagnostics || {}).status == 'OK' && progress == 90) {
    return {
      status: 'ok',
      title: 'Live',
      subtitle: 'Preparing the stream for viewers.'
    };
  } else if (progressMsg && progressMsg.title) {
    return {
      status: 'error',
      title: progressMsg.title,
      subtitle: progressMsg.subtitle || ''
    };
  } else {
    return {
      status: 'error',
      title: 'The Stream Has Not Yet Started',
      subtitle: progressMsg || "Catching up at ".concat(progress, "%")
    };
  }
}
function ComputePastBroadcastStarRating(streamDiagnostics) {
  var status = streamDiagnostics.summary_status;

  if (!status) {
    return 0;
  }

  var hasCritical = _.find(streamDiagnostics.alerts, {
    level: 'Critical'
  });

  var hasWarning = _.find(streamDiagnostics.alerts, {
    level: 'Warning'
  });

  if (status == 'OK' && (streamDiagnostics.alerts || []).length == 0) {
    return 5;
  }

  if (status == 'OK' && !hasCritical) {
    return 4.5;
  }

  if (status == 'OK') {
    return 4;
  }

  if (status == 'Warning') {
    return 3;
  }

  var avgTotalBitrate = streamDiagnostics.average_total_bitrate || streamDiagnostics.avg_bitrate;

  if (status == 'Critical' && avgTotalBitrate > 300) {
    return 2;
  }

  if (status == 'Critical' && avgTotalBitrate > 10) {
    return 1;
  }

  if (status == 'Critical' && avgTotalBitrate == 0) {
    return 0;
  }
}
function ComputePastBroadcastRecommendations(broadcast, streamDiagnostics) {
  var result = [];

  if (!streamDiagnostics.summary_status) {
    return result;
  }

  if (streamDiagnostics.packet_loss_per_minute > 5) {
    result.push({
      text: "Packet loss detected. This can be due to an unstable internet connection.",
      link: 'https://support.boxcast.com/en/articles/4235089',
      linkText: 'See tips for reducing packet loss.'
    });
  }

  if (findAlert(streamDiagnostics, 'Transcode delayed')) {
    result.push({
      text: "Transcode delay detected. Ensure proper RTMP encoder settings to avoid viewer buffering.",
      link: 'https://support.boxcast.com/en/articles/4235181',
      linkText: 'Learn how to configure your RTMP encoder.'
    });
  }

  if (findAlert(streamDiagnostics, 'Ingest latency too high')) {
    result.push({
      text: "High ingest latency detected; your encoder or network can't keep up.",
      link: 'https://support.boxcast.com/en/articles/4235181',
      linkText: 'Learn how to configure your RTMP encoder.'
    });
  }

  if (findAlert(streamDiagnostics, 'Ingest latency too low')) {
    result.push({
      text: "Negative ingest latency detected; your encoder is sending data too fast.",
      link: 'https://support.boxcast.com/en/articles/4235181',
      linkText: 'Learn how to configure your RTMP encoder.'
    });
  }

  if (findAlert(streamDiagnostics, 'Streaming interrupted')) {
    var x = findAlert(streamDiagnostics, 'Streaming interrupted'); // check if it only appears at the end of the broadcast; sign that you unplugged
    // early (probably intentionally), so different than losing internet mid-stream

    if (x.is_active || x.inactive_at >= broadcast.stops_at) {
      result.push({
        text: "Stream interruption detected at end of broadcast. Use the stop broadcast button on the dashboard before disconnecting your encoder to avoid viewer buffering.",
        link: '',
        linkText: ''
      });
    } else {
      result.push({
        text: "Stream interruption detected. This can be due to an unstable internet connection.",
        link: 'https://www.boxcast.com/blog/what-upload-speed-do-i-need-to-stream',
        linkText: 'Read about recommended upload speeds.'
      });
    }
  }

  return result;
}

function findAlert(streamDiagnostics, t) {
  var alerts = streamDiagnostics.alerts || [];

  for (var i = 0; i < alerts.length; i++) {
    if (alerts[i].message.toUpperCase().indexOf(t.toUpperCase()) >= 0) {
      return alerts[i];
    }
  }

  return null;
}

function GetBitrateLimitsForBroadcast(apiConfig, broadcast) {
  var ret = {}; // Pick off limits based on the stream source

  switch (broadcast.stream_source) {
    case 'boxcaster':
      switch ((broadcast.boxcaster_id || '')[0]) {
        // HDSD2 and friends
        case 'l': // fall-through

        case 'n': // fall-through

        case 'o':
          ret.video = ((apiConfig.boxcaster || {}).video_bitrate_limits || {}).hdsd2 || {};
          ret.audio = ((apiConfig.boxcaster || {}).audio_bitrate_limits || {}).hdsd2 || {};
          break;
        // BoxCaster Pro

        case 'p':
          ret.video = ((apiConfig.boxcaster || {}).video_bitrate_limits || {}).pro || {};
          ret.audio = ((apiConfig.boxcaster || {}).audio_bitrate_limits || {}).pro || {};
          break;

        default:
          return ret;
      }

      break;
    // Broadcaster

    case 'app':
      ret.video = ((apiConfig.boxcaster || {}).video_bitrate_limits || {}).broadcaster || {};
      ret.audio = ((apiConfig.boxcaster || {}).audio_bitrate_limits || {}).broadcaster || {};
      break;
    // RTMP and Switcher

    case 'rtmp': // fall-through

    case 'switcher':
      ret.video = ((apiConfig.boxcaster || {}).video_bitrate_limits || {}).rtmp || {};
      ret.audio = ((apiConfig.boxcaster || {}).audio_bitrate_limits || {}).rtmp || {};
      break;

    default:
      return ret;
  } // Now narrow down video based on transcoder profile


  var transcoderProfile = broadcast.transcoder_profile || '';

  if (transcoderProfile == 'audio') {
    delete ret.video;
  } else {
    var resolutionKey = parseInt(transcoderProfile).toString();
    var frameRateKey = transcoderProfile.match(/p60/) ? 'high_frame_rate' : 'low_frame_rate';
    var videoCodecKey = transcoderProfile.match(/:hevc/) ? 'hevc' : 'avc';
    ret.video = ((ret.video[resolutionKey] || {})[frameRateKey] || {})[videoCodecKey] || {};
  }

  return ret;
} // V3Timestamps plucks timestamps off of a data version 3 stream diagnostics result

function V3Timestamps(s) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  while (args.length > 0) {
    s = s[args.shift()] || {};
  }

  return _.pluck(s, 0);
} // V3Values plucks values off of a data version 3 stream diagnostics result

function V3Values(s) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  while (args.length > 0) {
    s = s[args.shift()] || {};
  }

  return _.pluck(s, 1);
} // V3PlaceholderTimestamps fills a data series (data values in `datas`, timestamps in `timestamps`) with a placeholder
// (currently `null`) for any missing timestamps. The full set of timestamps is passed in `fullTimestamps`.

function V3PlaceholderTimestamps(data, timestamps, fullTimestamps) {
  var newData = [];
  var PLACEHOLDER = null; // data and timestamps should have the same length; if they don't, yell loudly and
  // use the smaller value

  var dataLen = data.length;

  if (timestamps.length != dataLen) {
    console.error("placeholderTimestamps: data.length (".concat(dataLen, ") does not match timestamps.length (").concat(timestamps.length, ")!"));

    if (timestamps.length < dataLen) {
      dataLen = timestamps.length;
    }
  }

  var idx = 0;
  var fullIdx = 0;

  while (true) {
    if (fullIdx >= fullTimestamps.length) break;
    var nextData = data[idx];
    var nextTimestamp = timestamps[idx];
    var nextFullTimestamp = fullTimestamps[fullIdx];

    if (nextTimestamp == nextFullTimestamp) {
      // Timestamps match; emit data and advance both indices
      newData.push(nextData);
      idx++;
      fullIdx++;
    } else if (!nextTimestamp || nextFullTimestamp < nextTimestamp) {
      // Emit the placeholder and advance the full index
      newData.push(PLACEHOLDER);
      fullIdx++;
    } else {
      // This is unexpected, as all the timestamps should be included in fullTimestamps. Yell loudly,
      // omit this data from newData, and advance idx.
      console.error("placeholderTimestamps: timestamp ".concat(nextTimestamp, " was present in timestamps, but not in fullTimestamps!"));
      idx++;
    }
  }

  return newData;
}
function HasIntegratedScoreboard(scoreboardConfiguration) {
  if (scoreboardConfiguration && scoreboardConfiguration.scoreboard_make) {
    var m = scoreboardConfiguration.scoreboard_make;

    if (m == 'BoxCast' || m == 'Daktronics' || m == 'Trans-Lux Fair-Play' || m == 'OES') {
      return true;
    }
  }

  return false;
}

function hasAnyNonZeroData(data) {
  return _.some(data, function (d) {
    return d != 0;
  });
}

function V3HasAnyScoreboardData(streamDiagnostics) {
  if (!streamDiagnostics) return false;
  var scoreboardInformation = streamDiagnostics.scoreboard;

  if (scoreboardInformation) {
    if (!!scoreboardInformation.events && scoreboardInformation.events.length) return true;
    var scoreboardAssist = scoreboardInformation.scoreboard_assist;

    if (scoreboardAssist) {
      if (!!scoreboardAssist.events && scoreboardAssist.events.length) return true;
      if (scoreboardAssist.operation_mode) return true;
      var identity = scoreboardAssist.identity;
      if (!!identity && (!!identity.box || identity.scoreboard)) return true;
    }
  }

  var stats = streamDiagnostics.raw_stats || streamDiagnostics.raw_stats_coarse;

  if (stats) {
    var scoreBitrateData = V3Values(stats, 'bitrate', 'score');
    if (!!scoreBitrateData && hasAnyNonZeroData(scoreBitrateData)) return true;
    var scorePacketLossData = V3Values(stats, 'packet_loss', 'score');
    if (!!scorePacketLossData && hasAnyNonZeroData(scorePacketLossData)) return true;
  }

  var scoreboardStats = streamDiagnostics.raw_scoreboard_stats || streamDiagnostics.raw_scoreboard_stats_coarse;

  if (scoreboardStats) {
    var rssi = ((scoreboardStats || {}).scoreboard_assist || {}).rssi;

    if (rssi) {
      var boxRSSIData = V3Values(rssi, 'box');
      if (!!boxRSSIData && hasAnyNonZeroData(boxRSSIData)) return true;
      var scoreboardRSSIData = V3Values(rssi, 'scoreboard');
      if (!!scoreboardRSSIData && hasAnyNonZeroData(scoreboardRSSIData)) return true;
    }

    var linkStatus = ((scoreboardStats || {}).scoreboard_assist || {}).link_status;

    if (linkStatus) {
      var boxLinkStatusData = V3Values(linkStatus, 'box');
      if (!!boxLinkStatusData && hasAnyNonZeroData(boxLinkStatusData)) return true;
      var scoreboardLinkStatusData = V3Values(linkStatus, 'scoreboard');
      if (!!scoreboardLinkStatusData && hasAnyNonZeroData(scoreboardLinkStatusData)) return true;
    }
  }

  return false;
} // ParseScoreboardEvents walks through scoreboard events and scoreboard assist events, formatting them into objects
// suitable for listing/display in the scoreboard events section and sorting them by timestamp.

function ParseScoreboardEvents(streamDiagnostics, scoreboardConfiguration) {
  var scoreboardEvents = [];

  _.each(((streamDiagnostics || {}).scoreboard || {}).events || [], function (e) {
    switch (e.code) {
      case 'sport_change':
        var detectedSport = e.data.to;

        if (detectedSport.startsWith('Basketball')) {
          detectedSport = 'Basketball';
        }

        scoreboardEvents.push({
          timestamp: moment(e.timestamp).toDate(),
          message: "Detected sport ".concat(detectedSport)
        });
        break;

      case 'serial_port_state_change':
        var deviceName = 'Scoreboard adapter';
        if ((scoreboardConfiguration || {}).scoreboard_make == 'BoxCast') deviceName = 'Scoreboard Assist';
        var whatHappened = 'connected to';
        if (!e.data.to) whatHappened = 'disconnected from';
        scoreboardEvents.push({
          timestamp: moment(e.timestamp).toDate(),
          message: "".concat(deviceName, " ").concat(whatHappened, " BoxCaster")
        });
        break;
    }
  });

  _.each((((streamDiagnostics || {}).scoreboard || {}).scoreboard_assist || {}).events || [], function (e) {
    var side = {
      box: 'BoxCaster',
      scoreboard: 'Scoreboard',
      '': ''
    }[(e.data || {}).side || ''];

    switch (e.code) {
      case 'link_state':
        if (side) {
          scoreboardEvents.push({
            timestamp: moment(e.timestamp).toDate(),
            message: "".concat(side, " side link is now ").concat(e.data.to)
          });
        }

        break;

      case 'interface':
        var iface = {
          nevco: 'Nevco',
          'rs-232': 'RS-232',
          'rs-422': 'RS-422',
          '': ''
        }[e.data.to || ''];

        if (iface) {
          scoreboardEvents.push({
            timestamp: moment(e.timestamp).toDate(),
            message: "Switching to the ".concat(iface, " interface")
          });
        }

        break;

      case 'make_model':
        var make = e.data.to.make;
        var model = e.data.to.model;

        if (make != 'none' && model != 'none') {
          var startsWithVowel = false;
          if ('aeiou'.indexOf(make.toLowerCase()[0]) != -1) startsWithVowel = true;
          scoreboardEvents.push({
            timestamp: moment(e.timestamp).toDate(),
            message: "Detected a".concat(startsWithVowel ? 'n' : '', " ").concat(make, " ").concat(model)
          });
        }

        break;

      case 'rs422_jack_inserted':
        scoreboardEvents.push({
          timestamp: moment(e.timestamp).toDate(),
          message: "RS-422 jack inserted"
        });
        break;

      case 'rs422_jack_removed':
        scoreboardEvents.push({
          timestamp: moment(e.timestamp).toDate(),
          message: "RS-422 jack removed"
        });
        break;

      case 'pairing_mode_entered':
        if (side) {
          scoreboardEvents.push({
            timestamp: moment(e.timestamp).toDate(),
            message: "".concat(side, " side entered pairing mode")
          });
        }

        break;

      case 'pairing_mode_exited':
        if (side) {
          scoreboardEvents.push({
            timestamp: moment(e.timestamp).toDate(),
            message: "".concat(side, " side exited pairing mode")
          });
        }

        break;

      case 'rs422_termination_set':
        scoreboardEvents.push({
          timestamp: moment(e.timestamp).toDate(),
          message: "RS-422 termination turned ".concat(e.data.termination ? 'on' : 'off')
        });
        break;
      // IGNORING FOR NOW:
      // ScoreboardAssistEventCodeBaudRate  = ScoreboardAssistEventCode("baud_rate")
      // ScoreboardAssistEventCodeMiscellaneousFailure = ScoreboardAssistEventCode("miscellaneous_failure")
      // ScoreboardAssistEventCodeNevcoDetected        = ScoreboardAssistEventCode("nevco_detected")
      // ScoreboardAssistEventCodeNevcoSignalLost      = ScoreboardAssistEventCode("nevco_signal_lost")
      // ScoreboardAssistEventCodeUARTDetected         = ScoreboardAssistEventCode("uart_detected")
      // ScoreboardAssistEventCodeAutobaudLocked       = ScoreboardAssistEventCode("autobaud_locked")
      // ScoreboardAssistEventCodeAutobaudFailed       = ScoreboardAssistEventCode("autobaud_failed")
    }
  });

  return _.sortBy(scoreboardEvents, function (e) {
    return e.timestamp;
  });
} // FilterRSSIForLinkStatus filters the RSSI values to remove values when the pair was unlinked.

function FilterRSSIForLinkStatus(scoreboardAssistStats) {
  var rssi = (scoreboardAssistStats || {}).rssi || {};
  var boxRSSI = rssi.box || [];
  var scoreboardRSSI = rssi.scoreboard || [];
  var boxLinkStatus = ((scoreboardAssistStats || {}).link_status || {}).box || [];
  if (!boxRSSI.length || !scoreboardRSSI.length || !boxLinkStatus.length) return;
  var idxBoxRSSI = 0;
  var idxScoreboardRSSI = 0;

  for (var idxBoxLinkStatus = 0; idxBoxLinkStatus < boxLinkStatus.length; idxBoxLinkStatus++) {
    // Get the link status timestamp
    var linkStatusTimestamp = boxLinkStatus[idxBoxLinkStatus][0]; // Advance the other indices until we get to a matching timestamp

    var boxRSSITimestamp = (boxRSSI[idxBoxRSSI] || [])[0];

    while (idxBoxRSSI < boxRSSI.length && boxRSSITimestamp < linkStatusTimestamp) {
      idxBoxRSSI++;
      boxRSSITimestamp = (boxRSSI[idxBoxRSSI] || [])[0];
    }

    var scoreboardRSSITimestamp = (scoreboardRSSI[idxScoreboardRSSI] || [])[0];

    while (idxScoreboardRSSI < scoreboardRSSI.length && scoreboardRSSITimestamp < linkStatusTimestamp) {
      idxScoreboardRSSI++;
      scoreboardRSSITimestamp = (scoreboardRSSI[idxScoreboardRSSI] || [])[0];
    } // If the pair is not linked at this timestamp, set any values to null


    var linkValue = (boxLinkStatus[idxBoxLinkStatus] || [])[1];

    if (linkValue != 3) {
      if (idxBoxRSSI < boxRSSI.length && boxRSSITimestamp == linkStatusTimestamp) {
        boxRSSI[idxBoxRSSI][1] = null;
      }

      if (idxScoreboardRSSI < scoreboardRSSI.length && scoreboardRSSITimestamp == linkStatusTimestamp) {
        scoreboardRSSI[idxScoreboardRSSI][1] = null;
      }
    }
  }
} // baselineStats accepts an array of fine or coarse stats and baselines the values such that all
// values are greater than or equal to zero. It also returns the minimum value.

function baselineStats(stats) {
  if (!stats || stats.length == 0) {
    return 0;
  }

  var min = Math.min.apply(Math, _toConsumableArray(V3Values(stats)));
  stats.forEach(function (e) {
    return e[1] -= min;
  });
  return min;
} // maxFineStatTimeRange is the maximum broadcast duration under which the "fine" stats will be used
// for calculating ingest latency. Broadcasts longer than this will use the coarse stats.


var maxFineStatTimeRange = 60 * 60 * 1000; // BaselineIngestLatency baselines the fine and coarse RTMP ingest latency stats such that all
// values are greater than or equal to zero. It also adjusts the last, average, and max ingest
// latency (when present) to take into account the minimum recorded value.

function BaselineIngestLatency(streamDiagnostics, broadcast) {
  if (!streamDiagnostics) {
    return;
  }

  var fineLatencyMin = 0;

  if (streamDiagnostics.raw_stats && streamDiagnostics.raw_stats.ingest_latency) {
    fineLatencyMin = baselineStats(streamDiagnostics.raw_stats.ingest_latency);
  }

  var coarseLatencyMin = 0;

  if (streamDiagnostics.raw_stats_coarse && streamDiagnostics.raw_stats_coarse.ingest_latency) {
    coarseLatencyMin = baselineStats(streamDiagnostics.raw_stats_coarse.ingest_latency);
  } // last_ingest_latency should be adjusted by the fine results


  if (_.isNumber(streamDiagnostics.last_ingest_latency) && _.isNumber(fineLatencyMin)) {
    streamDiagnostics.last_ingest_latency -= fineLatencyMin;
  } // if broadcast duration > 1 hour, max_ingest_latency and average_ingest_latency use coarse results; otherwise they use fine results.


  var broadcastDuration = moment(broadcast.stops_at) - moment(broadcast.starts_at);
  var adjustmentLatency = broadcastDuration > maxFineStatTimeRange ? coarseLatencyMin : fineLatencyMin;

  if (_.isNumber(streamDiagnostics.max_ingest_latency) && _.isNumber(adjustmentLatency)) {
    streamDiagnostics.max_ingest_latency -= adjustmentLatency;
  }

  if (_.isNumber(streamDiagnostics.average_ingest_latency) && _.isNumber(adjustmentLatency)) {
    streamDiagnostics.average_ingest_latency -= adjustmentLatency;
  } // There was a bug in stream diagnostics service that took the max absolute value for
  // max_ingest_latency rather than the max value. So here we just sanity-check max_ingest_latency
  // in case average_ingest_latency or last_ingest_latency is higher.


  var maxFineLatency = 0;

  if (streamDiagnostics.raw_stats && streamDiagnostics.raw_stats.ingest_latency) {
    maxFineLatency = Math.max.apply(Math, _toConsumableArray(V3Values(streamDiagnostics.raw_stats.ingest_latency)));
  }

  var maxCoarseLatency = 0;

  if (streamDiagnostics.raw_stats_coarse && streamDiagnostics.raw_stats_coarse.ingest_latency) {
    maxCoarseLatency = Math.max.apply(Math, _toConsumableArray(V3Values(streamDiagnostics.raw_stats_coarse.ingest_latency)));
  }

  var maxLatency = Math.max(maxFineLatency, maxCoarseLatency, streamDiagnostics.last_ingest_latency || 0, streamDiagnostics.average_ingest_latency || 0);

  if (!streamDiagnostics.max_ingest_latency || maxLatency > streamDiagnostics.max_ingest_latency) {
    streamDiagnostics.max_ingest_latency = maxLatency;
  }
}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">{{vm.params.heading}}</h3>\n</div>\n<div class=\"modal-body text-center\">\n  <upload-slot ng-model=\"vm.file\"\n                slot-name=\"vm.params.slotName\"\n                allow-image=\"vm.params.allowImage\"\n                allow-video=\"vm.params.allowVideo\"\n                hide-stock-browse=\"true\"\n                hide-recent-browse=\"true\"\n                compact=\"false\">\n  </upload-slot>\n</div>\n<div class=\"modal-footer text-right\">\n  <a class=\"btn btn-primary\" ng-disabled=\"!vm.file || vm.uploading\" ng-click=\"vm.upload()\">\n      <i ng-if=\"vm.uploading\" class=\"fa fa-spin fa-spinner\"></i> Upload\n  </a>\n  <a class=\"btn btn-default\" ng-disabled=\"vm.uploading\" ng-click=\"vm.cancel()\">\n    Cancel\n  </a>\n</div>"

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var WebVTTParser = function WebVTTParser() {
  this.parse = function (input, mode) {
    //XXX need global search and replace for \0
    var NEWLINE = /\r\n|\r|\n/,
        startTime = Date.now(),
        linePos = 0,
        lines = input.split(NEWLINE),
        alreadyCollected = false,
        cues = [],
        errors = [];

    function err(message, col) {
      errors.push({
        message: message,
        line: linePos + 1,
        col: col
      });
    }

    var line = lines[linePos],
        lineLength = line.length,
        signature = 'WEBVTT',
        bom = 0,
        signature_length = signature.length;
    /* Byte order mark */

    if (line[0] === "\uFEFF") {
      bom = 1;
      signature_length += 1;
    }
    /* SIGNATURE */


    if (lineLength < signature_length || line.indexOf(signature) !== 0 + bom || lineLength > signature_length && line[signature_length] !== ' ' && line[signature_length] !== '\t') {
      err('No valid signature. (File needs to start with "WEBVTT".)');
    }

    linePos++;
    /* HEADER */

    while (lines[linePos] != '' && lines[linePos] != undefined) {
      err('No blank line after the signature.');

      if (lines[linePos].indexOf('-->') != -1) {
        alreadyCollected = true;
        break;
      }

      linePos++;
    }
    /* CUE LOOP */


    while (lines[linePos] != undefined) {
      var cue;

      while (!alreadyCollected && lines[linePos] == '') {
        linePos++;
      }

      if (!alreadyCollected && lines[linePos] == undefined) break;
      /* CUE CREATION */

      cue = {
        id: '',
        startTime: 0,
        endTime: 0,
        pauseOnExit: false,
        direction: 'horizontal',
        snapToLines: true,
        linePosition: 'auto',
        textPosition: 50,
        size: 100,
        alignment: 'middle',
        text: ''
      };
      var parseTimings = true;

      if (lines[linePos].indexOf('-->') == -1) {
        cue.id = lines[linePos];
        /* COMMENTS
             Not part of the specification's parser as these would just be ignored. However,
             we want them to be conforming and not get "Cue identifier cannot be standalone".
             */

        if (/^NOTE($|[ \t])/.test(cue.id)) {
          // .startsWith fails in Chrome
          linePos++;

          while (lines[linePos] != '' && lines[linePos] != undefined) {
            if (lines[linePos].indexOf('-->') != -1) err('Cannot have timestamp in a comment.');
            linePos++;
          }

          continue;
        }

        linePos++;

        if (lines[linePos] == '' || lines[linePos] == undefined) {
          err('Cue identifier cannot be standalone.');
          continue;
        }

        if (lines[linePos].indexOf('-->') == -1) {
          parseTimings = false;
          err('Cue identifier needs to be followed by timestamp.');
        }
      }
      /* TIMINGS */


      alreadyCollected = false;
      var timings = new WebVTTCueTimingsAndSettingsParser(lines[linePos], err);
      var previousCueStart = 0;

      if (cues.length > 0) {
        previousCueStart = cues[cues.length - 1].startTime;
      }

      if (parseTimings && !timings.parse(cue, previousCueStart)) {
        /* BAD CUE */
        cue = null;
        linePos++;
        /* BAD CUE LOOP */

        while (lines[linePos] != '' && lines[linePos] != undefined) {
          if (lines[linePos].indexOf('-->') != -1) {
            alreadyCollected = true;
            break;
          }

          linePos++;
        }

        continue;
      }

      linePos++;
      /* CUE TEXT LOOP */

      while (lines[linePos] != '' && lines[linePos] != undefined) {
        if (lines[linePos].indexOf('-->') != -1) {
          err('Blank line missing before cue.');
          alreadyCollected = true;
          break;
        }

        if (cue.text != '') cue.text += '\n';
        cue.text += lines[linePos];
        linePos++;
      }
      /* CUE TEXT PROCESSING */


      var cuetextparser = new WebVTTCueTextParser(cue.text, err, mode);
      cuetextparser.parse(cue.startTime, cue.endTime);
      cues.push(cue);
    }

    cues.sort(function (a, b) {
      if (a.startTime < b.startTime) return -1;
      if (a.startTime > b.startTime) return 1;
      if (a.endTime > b.endTime) return -1;
      if (a.endTime < b.endTime) return 1;
      return 0;
    });
    /* END */

    return {
      cues: cues,
      errors: errors,
      time: Date.now() - startTime
    };
  };
};

var WebVTTCueTimingsAndSettingsParser = function WebVTTCueTimingsAndSettingsParser(line, errorHandler) {
  var SPACE = /[\u0020\t\f]/,
      NOSPACE = /[^\u0020\t\f]/,
      line = line,
      pos = 0,
      err = function err(message) {
    errorHandler(message, pos + 1);
  },
      spaceBeforeSetting = true;

  function skip(pattern) {
    while (line[pos] != undefined && pattern.test(line[pos])) {
      pos++;
    }
  }

  function collect(pattern) {
    var str = '';

    while (line[pos] != undefined && pattern.test(line[pos])) {
      str += line[pos];
      pos++;
    }

    return str;
  }
  /* http://dev.w3.org/html5/webvtt/#collect-a-webvtt-timestamp */


  function timestamp() {
    var units = 'minutes',
        val1,
        val2,
        val3,
        val4; // 3

    if (line[pos] == undefined) {
      err('No timestamp found.');
      return;
    } // 4


    if (!/\d/.test(line[pos])) {
      err('Timestamp must start with a character in the range 0-9.');
      return;
    } // 5-7


    val1 = collect(/\d/);

    if (val1.length > 2 || parseInt(val1, 10) > 59) {
      units = 'hours';
    } // 8


    if (line[pos] != ':') {
      err('No time unit separator found.');
      return;
    }

    pos++; // 9-11

    val2 = collect(/\d/);

    if (val2.length != 2) {
      err('Must be exactly two digits.');
      return;
    } // 12


    if (units == 'hours' || line[pos] == ':') {
      if (line[pos] != ':') {
        err('No seconds found or minutes is greater than 59.');
        return;
      }

      pos++;
      val3 = collect(/\d/);

      if (val3.length != 2) {
        err('Must be exactly two digits.');
        return;
      }
    } else {
      val3 = val2;
      val2 = val1;
      val1 = '0';
    } // 13


    if (line[pos] != '.') {
      err('No decimal separator (".") found.');
      return;
    }

    pos++; // 14-16

    val4 = collect(/\d/);

    if (val4.length != 3) {
      err('Milliseconds must be given in three digits.');
      return;
    } // 17


    if (parseInt(val2, 10) > 59) {
      err('You cannot have more than 59 minutes.');
      return;
    }

    if (parseInt(val3, 10) > 59) {
      err('You cannot have more than 59 seconds.');
      return;
    }

    return parseInt(val1, 10) * 60 * 60 + parseInt(val2, 10) * 60 + parseInt(val3, 10) + parseInt(val4, 10) / 1000;
  }
  /* http://dev.w3.org/html5/webvtt/#parse-the-webvtt-settings */


  function parseSettings(input, cue) {
    var settings = input.split(SPACE),
        seen = [];

    for (var i = 0; i < settings.length; i++) {
      if (settings[i] == '') continue;
      var index = settings[i].indexOf(':'),
          setting = settings[i].slice(0, index),
          value = settings[i].slice(index + 1);

      if (seen.indexOf(setting) != -1) {
        err('Duplicate setting.');
      }

      seen.push(setting);

      if (value == '') {
        err('No value for setting defined.');
        return;
      }

      if (setting == 'vertical') {
        // writing direction
        if (value != 'rl' && value != 'lr') {
          err("Writing direction can only be set to 'rl' or 'rl'.");
          continue;
        }

        cue.direction = value;
      } else if (setting == 'line') {
        // line position
        if (!/\d/.test(value)) {
          err('Line position takes a number or percentage.');
          continue;
        }

        if (value.indexOf('-', 1) != -1) {
          err("Line position can only have '-' at the start.");
          continue;
        }

        if (value.indexOf('%') != -1 && value.indexOf('%') != value.length - 1) {
          err("Line position can only have '%' at the end.");
          continue;
        }

        if (value[0] == '-' && value[value.length - 1] == '%') {
          err('Line position cannot be a negative percentage.');
          continue;
        }

        if (value[value.length - 1] == '%') {
          if (parseInt(value, 10) > 100) {
            err('Line position cannot be >100%.');
            continue;
          }

          cue.snapToLines = false;
        }

        cue.linePosition = parseInt(value, 10);
      } else if (setting == 'position') {
        // text position
        if (value[value.length - 1] != '%') {
          err('Text position must be a percentage.');
          continue;
        }

        if (parseInt(value, 10) > 100) {
          err('Size cannot be >100%.');
          continue;
        }

        cue.textPosition = parseInt(value, 10);
      } else if (setting == 'size') {
        // size
        if (value[value.length - 1] != '%') {
          err('Size must be a percentage.');
          continue;
        }

        if (parseInt(value, 10) > 100) {
          err('Size cannot be >100%.');
          continue;
        }

        cue.size = parseInt(value, 10);
      } else if (setting == 'align') {
        // alignment
        var alignValues = ['start', 'middle', 'end', 'left', 'right'];

        if (alignValues.indexOf(value) == -1) {
          err('Alignment can only be set to one of ' + alignValues.join(', ') + '.');
          continue;
        }

        cue.alignment = value;
      } else {
        err('Invalid setting.');
      }
    }
  }

  this.parse = function (cue, previousCueStart) {
    skip(SPACE);
    cue.startTime = timestamp();

    if (cue.startTime == undefined) {
      return;
    }

    if (cue.startTime < previousCueStart) {
      err('Start timestamp is not greater than or equal to start timestamp of previous cue.');
    }

    if (NOSPACE.test(line[pos])) {
      err("Timestamp not separated from '-->' by whitespace.");
    }

    skip(SPACE); // 6-8

    if (line[pos] != '-') {
      err('No valid timestamp separator found.');
      return;
    }

    pos++;

    if (line[pos] != '-') {
      err('No valid timestamp separator found.');
      return;
    }

    pos++;

    if (line[pos] != '>') {
      err('No valid timestamp separator found.');
      return;
    }

    pos++;

    if (NOSPACE.test(line[pos])) {
      err("'-->' not separated from timestamp by whitespace.");
    }

    skip(SPACE);
    cue.endTime = timestamp();

    if (cue.endTime == undefined) {
      return;
    }

    if (cue.endTime <= cue.startTime) {
      err('End timestamp is not greater than start timestamp.');
    }

    if (NOSPACE.test(line[pos])) {
      spaceBeforeSetting = false;
    }

    skip(SPACE);
    parseSettings(line.substring(pos), cue);
    return true;
  };

  this.parseTimestamp = function () {
    var ts = timestamp();

    if (line[pos] != undefined) {
      err('Timestamp must not have trailing characters.');
      return;
    }

    return ts;
  };
};

var WebVTTCueTextParser = function WebVTTCueTextParser(line, errorHandler, mode) {
  var line = line,
      pos = 0,
      err = function err(message) {
    if (mode == 'metadata') return;
    errorHandler(message, pos + 1);
  };

  this.parse = function (cueStart, cueEnd) {
    var result = {
      children: []
    },
        current = result,
        timestamps = [];

    function attach(token) {
      current.children.push({
        type: 'object',
        name: token[1],
        classes: token[2],
        children: [],
        parent: current
      });
      current = current.children[current.children.length - 1];
    }

    function inScope(name) {
      var node = current;

      while (node) {
        if (node.name == name) return true;
        node = node.parent;
      }

      return;
    }

    while (line[pos] != undefined) {
      var token = nextToken();

      if (token[0] == 'text') {
        current.children.push({
          type: 'text',
          value: token[1],
          parent: current
        });
      } else if (token[0] == 'start tag') {
        if (mode == 'chapters') err('Start tags not allowed in chapter title text.');
        var name = token[1];

        if (name != 'v' && name != 'lang' && token[3] != '') {
          err('Only <v> and <lang> can have an annotation.');
        }

        if (name == 'c' || name == 'i' || name == 'b' || name == 'u' || name == 'ruby') {
          attach(token);
        } else if (name == 'rt' && current.name == 'ruby') {
          attach(token);
        } else if (name == 'v') {
          if (inScope('v')) {
            err('<v> cannot be nested inside itself.');
          }

          attach(token);
          current.value = token[3]; // annotation

          if (!token[3]) {
            err('<v> requires an annotation.');
          }
        } else if (name == 'lang') {
          attach(token);
          current.value = token[3]; // language
        } else {
          err('Incorrect start tag.');
        }
      } else if (token[0] == 'end tag') {
        if (mode == 'chapters') err('End tags not allowed in chapter title text.'); // XXX check <ruby> content

        if (token[1] == current.name) {
          current = current.parent;
        } else if (token[1] == 'ruby' && current.name == 'rt') {
          current = current.parent.parent;
        } else {
          err('Incorrect end tag.');
        }
      } else if (token[0] == 'timestamp') {
        if (mode == 'chapters') err('Timestamp not allowed in chapter title text.');
        var timings = new WebVTTCueTimingsAndSettingsParser(token[1], err),
            timestamp = timings.parseTimestamp();

        if (timestamp != undefined) {
          if (timestamp <= cueStart || timestamp >= cueEnd) {
            err('Timestamp must be between start timestamp and end timestamp.');
          }

          if (timestamps.length > 0 && timestamps[timestamps.length - 1] >= timestamp) {
            err('Timestamp must be greater than any previous timestamp.');
          }

          current.children.push({
            type: 'timestamp',
            value: timestamp,
            parent: current
          });
          timestamps.push(timestamp);
        }
      }
    }

    while (current.parent) {
      if (current.name != 'v') {
        err('Required end tag missing.');
      }

      current = current.parent;
    }

    return result;
  };

  function nextToken() {
    var state = 'data',
        result = '',
        buffer = '',
        classes = [];

    while (line[pos - 1] != undefined || pos == 0) {
      var c = line[pos];

      if (state == 'data') {
        if (c == '&') {
          buffer = c;
          state = 'escape';
        } else if (c == '<' && result == '') {
          state = 'tag';
        } else if (c == '<' || c == undefined) {
          return ['text', result];
        } else {
          result += c;
        }
      } else if (state == 'escape') {
        if (c == '&') {
          err('Incorrect escape.');
          result += buffer;
          buffer = c;
        } else if (/[abglmnsprt]/.test(c)) {
          buffer += c;
        } else if (c == ';') {
          if (buffer == '&amp') {
            result += '&';
          } else if (buffer == '&lt') {
            result += '<';
          } else if (buffer == '&gt') {
            result += '>';
          } else if (buffer == '&lrm') {
            result += "\u200E";
          } else if (buffer == '&rlm') {
            result += "\u200F";
          } else if (buffer == '&nbsp') {
            result += "\xA0";
          } else {
            err('Incorrect escape.');
            result += buffer + ';';
          }

          state = 'data';
        } else if (c == '<' || c == undefined) {
          err('Incorrect escape.');
          result += buffer;
          return ['text', result];
        } else {
          err('Incorrect escape.');
          result += buffer + c;
          state = 'data';
        }
      } else if (state == 'tag') {
        if (c == '\t' || c == '\n' || c == '\f' || c == ' ') {
          state = 'start tag annotation';
        } else if (c == '.') {
          state = 'start tag class';
        } else if (c == '/') {
          state = 'end tag';
        } else if (/\d/.test(c)) {
          result = c;
          state = 'timestamp tag';
        } else if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          return ['start tag', '', [], ''];
        } else {
          result = c;
          state = 'start tag';
        }
      } else if (state == 'start tag') {
        if (c == '\t' || c == '\f' || c == ' ') {
          state = 'start tag annotation';
        } else if (c == '\n') {
          buffer = c;
          state = 'start tag annotation';
        } else if (c == '.') {
          state = 'start tag class';
        } else if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          return ['start tag', result, [], ''];
        } else {
          result += c;
        }
      } else if (state == 'start tag class') {
        if (c == '\t' || c == '\f' || c == ' ') {
          classes.push(buffer);
          buffer = '';
          state = 'start tag annotation';
        } else if (c == '\n') {
          classes.push(buffer);
          buffer = c;
          state = 'start tag annotation';
        } else if (c == '.') {
          classes.push(buffer);
          buffer = '';
        } else if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          classes.push(buffer);
          return ['start tag', result, classes, ''];
        } else {
          buffer += c;
        }
      } else if (state == 'start tag annotation') {
        if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          buffer = buffer.split(/[\u0020\t\f\r\n]+/).filter(function (item) {
            if (item) return true;
          }).join(' ');
          return ['start tag', result, classes, buffer];
        } else {
          buffer += c;
        }
      } else if (state == 'end tag') {
        if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          return ['end tag', result];
        } else {
          result += c;
        }
      } else if (state == 'timestamp tag') {
        if (c == '>' || c == undefined) {
          if (c == '>') {
            pos++;
          }

          return ['timestamp', result];
        } else {
          result += c;
        }
      } else {
        err('Never happens.'); // The joke is it might.
      } // 8


      pos++;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (WebVTTParser);

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Overlapping Broadcast Detected</h3>\n</div>\n<div class=\"modal-body\">\n  <p>This broadcast conflicts with:</p>\n  <ul>\n    <li ng-repeat=\"b in ::conflictingEvents\"><strong>{{::b.name}}</strong> ({{::b.starts_at | date:'h:mm a'}} - {{::b.stops_at | date:'shortTime'}})</li>\n  </ul>\n  <p>\n    If this was an accident, tap Edit and fix the scheduled times.\n    If you wish to proceed with the conflict, tap Schedule below, but\n    understand you may need to stop one broadcast before the other can proceed.\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-default\" ng-click=\"close()\">Edit</button>\n  <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Schedule</button>\n</div>\n"

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CaptureOrEditHighlightController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_error__ = __webpack_require__(19);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var CaptureOrEditHighlightController = /*#__PURE__*/function () {
  function CaptureOrEditHighlightController($state, $scope, $uibModalInstance, Broadcast, Recording, Highlight, $q, $rootScope, $timeout, $uibModal, toaster, ConfirmDialog, highlightObj, recordingId) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, CaptureOrEditHighlightController);

    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;
    this.toaster = toaster;
    this.ConfirmDialog = ConfirmDialog;
    this.Highlight = Highlight;
    this.limits = $rootScope.ApiConfig.modelFieldLimits('highlight', 'maximum');

    this.cancel = function () {
      return $uibModalInstance.dismiss('cancel');
    };

    this.maxMonetizedHighlightTimeS = MAX_MONETIZED_HIGHLIGHT_TIME_S;
    this.broadcastIsMonetized = false;
    this.broadcast = Broadcast.get({
      id: $state.params.id
    }, function (b) {
      _this.broadcastIsMonetized = !b.is_private && b.is_ticketed;
    });
    this.recording = Recording.get({
      id: recordingId
    }); // Highlight is passed via modal `resolve`

    if (highlightObj) {
      this.title = "Edit ".concat(highlightObj.name);
      this.highlight = Highlight.get({
        id: highlightObj.id,
        broadcastId: $state.params.id
      }, function () {
        if (_this.highlight.start_segment !== '') {
          _this.startSegment = _this.highlight.start_segment;
          _this.stopSegment = _this.highlight.stop_segment;
        } else if (_this.highlight.start_seconds !== '') {
          _this.startSeconds = _this.highlight.start_seconds;
          _this.stopSeconds = _this.highlight.stop_seconds;
        }
      });
    } else {
      this.title = 'Capture New Highlight';
      this.highlight = {
        name: '',
        description: '',
        start_segment: '',
        stop_segment: '',
        start_seconds: 0,
        stop_seconds: 0
      };
    }

    this.startSeconds = 0;
    this.stopSeconds = 0;

    this.onChangeBounds = function (startSeconds, stopSeconds) {
      _this.startSeconds = Math.ceil(startSeconds);
      _this.stopSeconds = Math.floor(stopSeconds);
      _this.duration = stopSeconds - startSeconds;
    };

    this.loadingPromises = [this.broadcast.$promise, this.recording.$promise, this.highlight.$promise];
  }

  _createClass(CaptureOrEditHighlightController, [{
    key: "showPreviewModal",
    value: function showPreviewModal() {
      var _this2 = this;

      var $uibModal = this.$uibModal,
          $timeout = this.$timeout;
      $uibModal.open({
        template: __webpack_require__(206),
        controller: function controller($scope, $uibModalInstance) {
          'ngInject';

          $scope.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };

          $scope.title = 'Preview Highlight Clip';
          $scope.broadcast = _this2.broadcast;
          $scope.options = {
            autostart: true,
            // TODO: ticketId = admin_token?
            //ticketId: BROADCAST_TICKET,
            trimSeconds: {
              start: _this2.startSeconds,
              stop: _this2.stopSeconds
            }
          };
        }
      });
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _this3 = this;

      var Highlight = this.Highlight,
          ConfirmDialog = this.ConfirmDialog,
          $state = this.$state;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Delete Highlight',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to permanently delete this highlight?'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        Highlight["delete"]({
          id: _this3.highlight.id,
          broadcastId: _this3.broadcast.id
        }, function () {
          _this3.toaster.pop('warning', 'Successfully deleted highlight');

          _this3.cancel();

          _this3.$state.go('events.highlights', {
            id: _this3.broadcast.id,
            recording: _this3.recording.id
          }, {
            reload: true
          });
        }, function () {
          return alert('Error deleting highlight. Please reload this page and try again.');
        });
      });
    }
  }, {
    key: "saveChanges",
    value: function saveChanges() {
      var _this4 = this;

      this.isSaving = true;
      var startSeconds = this.startSeconds;
      var stopSeconds = this.stopSeconds;
      var promise;

      if (this.highlight.id) {
        promise = this.Highlight.update({
          broadcastId: this.broadcast.id,
          id: this.highlight.id
        }, {
          name: this.highlight.name,
          description: this.highlight.description,
          start_segment: '',
          stop_segment: '',
          start_seconds: startSeconds,
          stop_seconds: stopSeconds
        }).$promise;
      } else {
        promise = this.Highlight.create({
          broadcastId: this.broadcast.id
        }, {
          name: this.highlight.name,
          description: this.highlight.description,
          start_segment: '',
          stop_segment: '',
          start_seconds: startSeconds,
          stop_seconds: stopSeconds
        }).$promise;
      }

      promise.then(function () {
        _this4.isSaving = false;

        _this4.toaster.pop('success', 'Successfully created highlight');

        _this4.cancel();

        _this4.$state.go('events.highlights', {
          id: _this4.broadcast.id,
          recording: _this4.recording.id
        }, {
          reload: true
        });
      })["catch"](function (error) {
        console.error(error);
        _this4.isSaving = false;
        var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_0__utils_error__["a" /* errorDescriptionFromResponse */])(error);

        _this4.toaster.pop('warning', 'Unable to create highlight', errorDetails);
      });
    }
  }]);

  return CaptureOrEditHighlightController;
}();



/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">{{title}}</h3>\n</div>\n<div class=\"modal-body\">\n  <div id=\"trim-preview-placeholder\"></div>\n  <div ng-if=\"broadcast.channel_id\">\n    <boxcast-player channel-id=\"broadcast.channel_id\" options=\"options\"></boxcast-player>\n  </div>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Close</button>\n    <button ng-if=\"showSave\" class=\"btn btn-primary\" type=\"button\" ng-click=\"save()\">Save</button>\n</div>\n"

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HighlightPreviewController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_embed__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_allow_social__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_broadcast__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_download_or_export_highlight__ = __webpack_require__(209);




function HighlightPreviewController(
/* injected via normal angular DI */
$uibModal, $uibModalInstance, Highlight, ConfirmDialog, toaster, $rootScope, $timeout,
/* injected via `resolve` arguments to modal */
broadcast, highlightDetails, showSave) {
  'ngInject';

  var _this = this;

  this.FeatureFlags = $rootScope.account.feature_flags;
  this.Highlight = Highlight;
  this.ConfirmDialog = ConfirmDialog;
  this.toaster = toaster;
  this.highlight = highlightDetails;
  this.mediaTokenRestrictions = $rootScope.account.extra_features.media_token_restrictions;
  this.broadcast = broadcast;
  this.broadcastIsMonetized = !broadcast.is_private && broadcast.is_ticketed;
  this.highlightCanBeShared = !this.mediaTokenRestrictions && (!this.broadcastIsMonetized || this.highlight.duration <= MAX_MONETIZED_HIGHLIGHT_TIME_S);
  this.showSave = showSave;
  this.showPlayer = true;
  this.showEmbed = false;
  this.embedCode = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].highlightClipEmbed(this.highlight.id, {});
  this.showSocialShare = this.highlightCanBeShared && Object(__WEBPACK_IMPORTED_MODULE_1__utils_allow_social__["a" /* AllowSocial */])(this.FeatureFlags, $rootScope.account, this.broadcast);
  this.limits = $rootScope.ApiConfig.modelFieldLimits('highlight', 'maximum');

  if (highlightDetails.id) {
    this.channelId = highlightDetails.id;
    this.mode = 'highlight';
    this.options = {
      autoplay: true,
      showSocialShare: this.showSocialShare,
      selectedBroadcastId: broadcast.id,
      ticketId: broadcast.admin_token
    };
  } else {
    this.channelId = broadcast.channel_id;
    this.mode = 'channel';
    this.options = {
      autoplay: true,
      showSocialShare: false,
      //disable built-in sharing bc we're faking the highlight
      trimSeconds: {
        start: highlightDetails.start_seconds,
        stop: highlightDetails.stop_seconds
      },
      ticketId: broadcast.admin_token
    };
  }

  this.save = function () {
    return $uibModalInstance.close({
      name: _this.highlight.name,
      start_seconds: _this.options.trimSeconds.start,
      stop_seconds: _this.options.trimSeconds.stop
    });
  };

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this.link = "".concat(BOXCAST_TV_HIGHLIGHT_URL).concat(this.broadcast.channel_id, "/").concat(this.broadcast.id, "/").concat(this.highlight.id);
  var broadcastAbbrev = broadcast.name || '';

  if (broadcastAbbrev.length > 15) {
    broadcastAbbrev = broadcastAbbrev.substring(0, 12) + '...';
  }

  var description = highlightDetails.description || "Highlight from ".concat(broadcastAbbrev);

  this.tweet = function () {
    var url = escape(_this.link);
    var text = escape("Watch ".concat(highlightDetails.name, " (").concat(description, ") at "));
    window.open('http://twitter.com/share?url=' + url + '&text=' + text, 'Promote on Twitter', 'dependent=1,height=400,width=600,resizable=1');
  };

  this.facebook = function () {
    // Use the graph API directly since we don't have proper opengraph
    // headers on our show page.
    // https://developers.facebook.com/docs/graph-api/reference/v2.4/post
    var previewImg = highlightDetails.preview;

    if (!previewImg) {
      previewImg = "".concat(IMG_ROOT, "boxcast_social_play_square.png");
    }

    FB.ui({
      method: 'share',
      href: _this.link,
      title: highlightDetails.name,
      name: highlightDetails.name,
      description: description,
      picture: Object(__WEBPACK_IMPORTED_MODULE_2__utils_broadcast__["a" /* ensureHttpOnProtocolRelativeUrl */])(previewImg),
      caption: 'BoxCast :: a smarter way to stream',
      type: 'video'
    }, function (response) {});
  };

  this.nudge = function (side, offset) {
    var seconds = Math.max(_this.options.trimSeconds[side] + offset, 0); // Need to leave at least a 1-second gap so the bounds are valid.

    if (side === 'stop') {
      seconds = Math.max(seconds, _this.options.trimSeconds['start'] + 1);
    } else if (side === 'start') {
      seconds = Math.min(seconds, _this.options.trimSeconds['stop'] - 1);
    }

    _this.options.trimSeconds[side] = seconds;
    _this.showPlayer = false;
    $timeout(function () {
      return _this.showPlayer = true;
    }, 10);
  };

  this["delete"] = function () {
    var Highlight = _this.Highlight,
        ConfirmDialog = _this.ConfirmDialog;
    var modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Delete Highlight',
      actionButtonClass: 'danger',
      headerText: 'Please Confirm',
      bodyText: 'Are you sure you want to permanently delete this highlight?'
    };
    ConfirmDialog.show(modalOptions).then(function () {
      Highlight["delete"]({
        id: _this.highlight.id,
        broadcastId: _this.broadcast.id
      }, function () {
        _this.toaster.pop('warning', 'Successfully deleted highlight');

        _this.cancel();
      }, function () {
        return alert('Error deleting highlight. Please reload this page and try again.');
      });
    });
  };

  this.download = function () {
    $uibModal.open({
      template: __webpack_require__(210),
      controllerAs: 'vm',
      controller: __WEBPACK_IMPORTED_MODULE_3__modal_download_or_export_highlight__["a" /* default */],
      resolve: {
        broadcast: function broadcast() {
          return _this.broadcast;
        },
        highlight: function highlight() {
          return _this.highlight;
        }
      }
    });
  };
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export broadcastListToCSVString */
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureHttpOnProtocolRelativeUrl;
function e(input) {
  // shortcut to escape the input string for csv encoding
  if (input === true) {
    return 'Y';
  }

  if (input === false) {
    return 'N';
  }

  if (input === null || input === undefined) {
    return '';
  }

  if (typeof input.indexOf == 'function') {
    if (input.indexOf('"') >= 0) {
      input = input.replace(/"/g, '""');
    }

    if (input.search(/("|,|\n)/g) >= 0) {
      input = '"' + input + '"';
    }
  }

  return input;
} // searialize the list of broadcasts as a CSV string


function broadcastListToCSVString(broadcasts) {
  var csvContent = 'Name,Channel,Start,Stop,Private,Ticketed,Flex,Ticket Price,BoxCaster,Total Views,Total Minutes Viewed\n';
  broadcasts.forEach(function (b, index) {
    var dataString = [e(b.name), e(b.channel_id), e(b.starts_at), e(b.stops_at), e(b.is_private), e(b.is_ticketed), e(b.is_ticketed && b.free_variant != 'none'), e(b.ticket_price), e(b.boxcaster_name), e(b.total_view_count), e(b.total_minutes_viewed)].join(',');
    csvContent += index < broadcasts.length ? dataString + '\n' : dataString;
  });
  return csvContent;
} // if a url is passed as a protocol-relative url (e.g. "//uploads.boxcast.com/foo.jpg"), make
// sure to preprend a protocol. this is required for some 3rd party application integrations.

function ensureHttpOnProtocolRelativeUrl(url) {
  if (url.startsWith('//')) {
    url = 'http:' + url;
  }

  return url;
}

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DownloadOrExportHighlightController;
function DownloadOrExportHighlightController($uibModalInstance, $scope, $timeout, $rootScope, toaster, Highlight, VimeoUser, YouTubeUser, $analytics, broadcast, highlight) {
  'ngInject';

  var _this = this;

  this.hasVideo = broadcast.transcoder_profile !== 'audio';
  this.activeTab = this.hasVideo ? 'mp4' : 'm4a';
  this.unlock = {};
  this.allowKaltura = false;
  this.allowYoutube = false;
  this.allowVimeo = false;
  this.youtubeUsers = [];
  this.youtubeUserId = null;
  this.youtubeLicense = 'youtube';
  this.youtubePrivacy = 'private';
  this.vimeoUsers = [];
  this.vimeoUserId = null;
  this.allowKaltura = $rootScope.account.extra_features.kaltura;
  this.allowYoutube = !!$rootScope.account.feature_flags.youtube_export;
  this.allowVimeo = !!$rootScope.account.feature_flags.vimeo_export;

  if (this.allowYoutube) {
    this.youtubeUsers = YouTubeUser.query();
    this.youtubeUsers.$promise.then(function () {
      _this.youtubeUserId = (_.first(_this.youtubeUsers) || {}).id;
    });
  }

  if (this.allowVimeo) {
    this.vimeoUsers = VimeoUser.query();
    this.vimeoUsers.$promise.then(function () {
      _this.vimeoUserId = (_.first(_this.vimeoUsers) || {}).id;
    });
  }

  this.recording = {};
  this.$reloadRecordingTimeout = null;

  this.reloadRecording = function () {
    $timeout.cancel(_this.$reloadRecordingTimeout);
    Highlight.get({
      broadcastId: broadcast.id,
      id: highlight.id
    }, function (recording) {
      // On completion of an export, make sure we re-lock
      _.each(['kaltura', 'vimeo', 'youtube'], function (e) {
        if (_this.recording["".concat(e, "_export_status")] !== 'ready' && recording["".concat(e, "_export_status")] == 'ready') {
          delete _this.unlock[e];
        }
      });

      _this.recording = recording;
      _this.$reloadRecordingTimeout = $timeout(_this.reloadRecording, 5000);
    }, function (error) {
      console.error(error);
      toaster.pop('warning', 'Unable to fetch highlight. Please try again.');

      _this.cancel();
    });
  };

  this.reloadRecording();
  $scope.$on('$destroy', function () {
    return $timeout.cancel(_this.$reloadRecordingTimeout);
  });

  this.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  this.canStart = function () {
    var processingStatuses = ['requesting', 'requested', 'awaiting_conversion'];

    var mp4DownloadInFlight = function mp4DownloadInFlight() {
      return _.contains(processingStatuses, _this.recording.download_status) || _.startsWith(_this.recording.download_status, 'processing:');
    };

    var m4aDownloadInFlight = function m4aDownloadInFlight() {
      return _.contains(processingStatuses, _this.recording.audio_download_status) || _.startsWith(_this.recording.audio_download_status, 'processing:');
    };

    var kalturaExportInFlight = function kalturaExportInFlight() {
      return _.contains(processingStatuses, _this.recording.kaltura_export_status) || _.startsWith(_this.recording.kaltura_export_status, 'processing:');
    };

    var vimeoExportInFlight = function vimeoExportInFlight() {
      return _.contains(processingStatuses, _this.recording.vimeo_export_status) || _.startsWith(_this.recording.vimeo_export_status, 'processing:');
    };

    var youtubeExportInFlight = function youtubeExportInFlight() {
      return _.contains(processingStatuses, _this.recording.youtube_export_status) || _.startsWith(_this.recording.youtube_export_status, 'processing:');
    };

    var exportInFlight = function exportInFlight() {
      return kalturaExportInFlight() || vimeoExportInFlight() || youtubeExportInFlight();
    };

    if (_this.activeTab === 'mp4') {
      return (!_this.recording.download_url || _this.recording.download_status == 'expired') && !mp4DownloadInFlight() && !exportInFlight();
    } else if (_this.activeTab === 'm4a') {
      return (!_this.recording.audio_download_url || _this.recording.audio_download_status == 'expired') && !m4aDownloadInFlight();
    } else if (_this.activeTab === 'kaltura') {
      return !mp4DownloadInFlight() && !kalturaExportInFlight();
    } else if (_this.activeTab === 'vimeo') {
      return !mp4DownloadInFlight() && !vimeoExportInFlight();
    } else if (_this.activeTab === 'youtube') {
      return !mp4DownloadInFlight() && !youtubeExportInFlight();
    }
  };

  this.changeTab = function (tabId) {
    _this.activeTab = tabId;
    _this.unlock = {};
  };

  this.start = function () {
    // the debounce in angular is dubious; just double-check here that we can start, and get out if we can't.
    if (!_this.canStart()) return;

    if (_this.activeTab === 'mp4') {
      _this.recording.download_status = 'requesting';
      Highlight.prepareDownload({
        id: highlight.id
      }, function (response) {
        _this.recording.download_status = 'requested';
        console.log('Submitted request to download mp4...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.download_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to prepare mp4 download. Please try again.');
        $analytics.eventTrack('highlight-download', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'm4a') {
      _this.recording.audio_download_status = 'requesting';
      Highlight.prepareDownload({
        id: highlight.id,
        audio_only: true
      }, function (response) {
        _this.recording.audio_download_status = 'requested';
        console.log('Submitted request to m4a download...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.audio_download_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to prepare m4a download. Please try again.');
        $analytics.eventTrack('highlight-download-audio', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'kaltura') {
      _this.recording.kaltura_export_status = 'requesting';
      Highlight.startKalturaExport({
        id: highlight.id
      }, function (response) {
        _this.recording.kaltura_export_status = 'requested';
        console.log('Submitted request to export to kaltura...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.kaltura_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('highlight-kaltura-export', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'vimeo') {
      // This isn't documented, but Vimeo limits the name to 128 characters (PLATFORM-6277)
      var videoInfo = {
        name: highlight.name.substr(0, 128),
        description: highlight.description
      };
      _this.recording.vimeo_export_status = 'requesting';
      Highlight.startVimeoExport({
        id: highlight.id,
        vimeo_user_id: _this.vimeoUserId,
        video_info: videoInfo
      }, function (response) {
        _this.recording.vimeo_export_status = 'requested';
        console.log('Submitted request to export to vimeo...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.vimeo_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('highlight-vimeo-export', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'youtube') {
      // https://developers.google.com/youtube/v3/docs/videos
      //
      // title (string): The video's title. The property value has a maximum length of 100 characters
      // and may contain all valid UTF-8 characters except < and >.
      //
      // description (string): The video's description. The property value has a maximum length of
      // 5000 bytes and may contain all valid UTF-8 characters except < and >.
      var _videoInfo = {
        snippet: {
          title: highlight.name.replace(/</g, '[').replace(/>/g, ']').substr(0, 100),
          description: highlight.description.replace(/</g, '[').replace(/>/g, ']').substr(0, 5000)
        },
        status: {
          privacyStatus: _this.youtubePrivacy,
          license: _this.youtubeLicense
        }
      };
      _this.recording.youtube_export_status = 'requesting';
      Highlight.startYoutubeExport({
        id: highlight.id,
        youtube_user_id: _this.youtubeUserId,
        video_info: _videoInfo
      }, function (response) {
        _this.recording.youtube_export_status = 'requested';
        console.log('Submitted request to export to youtube...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.youtube_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('highlight-youtube-export', {
          category: 'error'
        });
      });
    }
  };

  this.status = function () {
    var s = null;

    if (_this.activeTab === 'mp4') {
      s = _this.recording.download_status;
    } else if (_this.activeTab === 'm4a') {
      s = _this.recording.audio_download_status;
    } else if (_this.activeTab === 'kaltura') {
      s = _this.recording.kaltura_export_status;
    } else if (_this.activeTab === 'vimeo') {
      s = _this.recording.vimeo_export_status;
    } else if (_this.activeTab === 'youtube') {
      s = _this.recording.youtube_export_status;
    }

    if (_.startsWith(s, 'processing:')) {
      s = 'processing';
    }

    return s;
  };

  this.statusPercent = function () {
    var p = 0;

    if (_this.activeTab === 'mp4' || _this.activeTab === 'm4a') {
      var s = null;

      if (_this.activeTab === 'mp4') {
        s = _this.recording.download_status;
      } else if (_this.activeTab === 'm4a') {
        s = _this.recording.audio_download_status;
      }

      if (s === 'ready') {
        p = 100;
      } else if (_.startsWith(s, 'processing:')) {
        p = parseInt(s.replace('processing:', ''), 10) || 0;
      }
    } else {
      // Compensate for fact that download-preparation is only first half of the battle.
      // Now that we have an MP4 in S3, we need to get it over to the social provider.
      var _s = null;

      if (_this.activeTab === 'kaltura') {
        _s = _this.recording.kaltura_export_status;
      } else if (_this.activeTab === 'vimeo') {
        _s = _this.recording.vimeo_export_status;
      } else if (_this.activeTab === 'youtube') {
        _s = _this.recording.youtube_export_status;
      }

      if (_s === 'ready') {
        p = 100;
      } else if (_.contains(['awaiting_conversion', 'requested'], _s)) {
        if (_this.recording.download_status === 'ready') {
          p = 50;
        } else if (_.startsWith(_this.recording.download_status, 'processing:')) {
          p = Math.round((parseInt(_this.recording.download_status.replace('processing:', ''), 10) || 0) / 2);
        }
      } else if (_.startsWith(_s, 'processing:')) {
        p = 50 + Math.round((parseInt(_s.replace('processing:', ''), 10) || 0) / 2);
      }
    }

    return p;
  };
}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\" style=\"border-bottom:0;padding-bottom:0;\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n\n  <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li ng-class=\"vm.activeTab == 'mp4' ? 'active' : ''\" ng-if=\"vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('mp4')\">Download</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'youtube' ? 'active' : ''\" ng-if=\"vm.allowYoutube && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('youtube')\">YouTube</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'vimeo' ? 'active' : ''\" ng-if=\"vm.allowVimeo && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('vimeo')\">Vimeo</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'kaltura' ? 'active' : ''\" ng-if=\"vm.allowKaltura && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('kaltura')\">Kaltura</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'm4a' ? 'active' : ''\">\n      <a href ng-click=\"vm.changeTab('m4a')\">Audio</a>\n    </li>\n  </ol>\n\n</div>\n<div class=\"modal-body\" style=\"padding-top:0\" ng-show=\"vm.recording.id\">\n\n  <!-- download mp4 -->\n  <div ng-if=\"vm.activeTab == 'mp4'\">\n    <p class=\"help-block\">\n      <small>\n        Highlights can be downloaded in MP4 (video+audio) format. This process can take a few minutes while we convert your highlight to the proper format.\n      </small>\n    </p>\n    <div class=\"form-group text-center\">\n      <button class=\"btn btn-default\"\n        ng-hide=\"vm.recording.download_url && vm.status() != 'expired'\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Generate Download\n      </button>\n      <a class=\"btn btn-success\"\n        download\n        ng-show=\"vm.recording.download_url && vm.status() != 'expired'\"\n        ng-href=\"{{vm.recording.download_url}}\">\n        <i class=\"fa fa-download\"></i>\n        Download Video\n      </a>\n      <button type=\"button\" class=\"btn btn-link\"\n        ng-if=\"clipboard.supported\"\n        ng-show=\"vm.recording.download_url && vm.status() != 'expired'\"\n        clipboard\n        text=\"vm.recording.download_url\"\n        on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n        on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n        uib-tooltip=\"Copy the MP4 link to your clipboard\" tooltip-placement=\"bottom\">\n        <i class=\"fa fa-copy\" style=\"width:20px\"></i>\n        Copy Video Link\n      </button>\n    </div>\n  </div>\n\n  <!-- download m4a -->\n  <div ng-if=\"vm.activeTab == 'm4a'\">\n    <p class=\"help-block\">\n      <small>\n        Highlights can be downloaded in M4A (audio-only) format. This process can take a few minutes while we convert your highlight to the proper format.\n      </small>\n    </p>\n    <div class=\"form-group text-center\">\n      <button class=\"btn btn-default\"\n        ng-hide=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Generate Download\n      </button>\n      <a class=\"btn btn-success\"\n        download\n        ng-show=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        ng-href=\"{{vm.recording.audio_download_url}}\">\n        <i class=\"fa fa-download\"></i>\n        Download Audio\n      </a>\n      <button type=\"button\" class=\"btn btn-link\"\n        ng-if=\"clipboard.supported\"\n        ng-show=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        clipboard\n        text=\"vm.recording.audio_download_url\"\n        on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n        on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n        uib-tooltip=\"Copy the M4A link to your clipboard\" tooltip-placement=\"bottom\">\n        <i class=\"fa fa-copy\" style=\"width:20px\"></i>\n        Copy Audio Link\n      </button>\n    </div>\n  </div>\n\n  <!-- youtube -->\n  <div ng-if=\"vm.activeTab == 'youtube'\">\n    <p class=\"help-block\">\n      <small>\n        Highlights can be exported to YouTube. This process can take a few minutes while we convert your highlight\n        to the proper format and then send it to YouTube.\n      </small>\n    </p>\n    <div ng-hide=\"vm.youtubeUsers.length\">\n      <p>\n        There are no linked YouTube accounts.\n        Please <a ui-sref=\"settings.youtube\" ng-click=\"vm.cancel()\">link your YouTube account</a> before attempting to export.\n      </p>\n    </div>\n    <div ng-show=\"vm.youtubeUsers.length && (vm.recording.youtube_export_status != 'ready' || vm.unlock.youtube)\">\n      <div class=\"form-group\">\n        <label for=\"youtube_user\">Export As User</label>\n        <select class=\"form-control\" id=\"youtube_user\" ng-model=\"vm.youtubeUserId\" ng-disabled=\"!vm.canStart()\" required>\n          <option ng-repeat=\"u in vm.youtubeUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"youtube_license\">License</label>\n        <select class=\"form-control\" id=\"youtube_license\" ng-model=\"vm.youtubeLicense\" ng-disabled=\"!vm.canStart()\" required>\n          <option value=\"youtube\" ng-selected=\"true\">YouTube</option>\n          <option value=\"creativeCommon\">Creative Commons</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"youtube_privacy\">Privacy Status</label>\n        <select class=\"form-control\" id=\"youtube_privacy\" ng-model=\"vm.youtubePrivacy\" ng-disabled=\"!vm.canStart()\" required>\n          <option value=\"private\" ng-selected=\"true\">private</option>\n          <option value=\"public\">public</option>\n          <option value=\"unlisted\">unlisted</option>\n        </select>\n      </div>\n      <div class=\"form-group text-center\">\n        <button class=\"btn btn-default overflow-ellipse\"\n          ng-disabled=\"!vm.canStart()\"\n          ng-click=\"vm.start()\"\n          analytics-on analytics-event=\"event-edit\" analytics-category=\"youtube-export\" analytics-label=\"\">\n          <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n          <i class=\"fa fa-youtube-play\" style=\"width:20px\"></i>\n          Export To YouTube\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <!-- vimeo -->\n  <div ng-if=\"vm.activeTab == 'vimeo'\">\n    <p class=\"help-block\">\n      <small>\n        Highlights can be exported to Vimeo. This process can take a few minutes while we convert your highlight\n        to the proper format and then send it to Vimeo.\n      </small>\n    </p>\n    <div ng-hide=\"vm.vimeoUsers.length\">\n      <p>\n        There are no linked Vimeo accounts.\n        Please <a ui-sref=\"settings.vimeo\" ng-click=\"vm.cancel()\">link your Vimeo account</a> before attempting to export.\n      </p>\n    </div>\n    <div ng-show=\"vm.vimeoUsers.length && (vm.recording.vimeo_export_status != 'ready' || vm.unlock.vimeo)\">\n      <div class=\"form-group\">\n        <label for=\"vimeo_user\">Export As User</label>\n        <select class=\"form-control\" id=\"vimeo_user\" ng-model=\"vm.vimeoUserId\" ng-disabled=\"!vm.canStart()\" required>\n          <option ng-repeat=\"u in vm.vimeoUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n        </select>\n      </div>\n      <div class=\"form-group text-center\">\n        <button class=\"btn btn-default overflow-ellipse\"\n          ng-disabled=\"!vm.canStart()\"\n          ng-click=\"vm.start()\"\n          analytics-on analytics-event=\"event-edit\" analytics-category=\"vimeo-export\" analytics-label=\"\">\n          <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n          <i class=\"fa fa-vimeo\" style=\"width:20px\"></i>\n          Export To Vimeo\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <!-- kaltura -->\n  <div ng-if=\"vm.activeTab == 'kaltura'\">\n    <p class=\"help-block\">\n      <small>\n        Highlights can be exported to Kaltura. This process can take a few minutes while we convert your highlight\n        to the proper format and then send it to Kaltura.\n      </small>\n    </p>\n    <div class=\"form-group text-center\" ng-show=\"(vm.recording.kaltura_export_status != 'ready' || vm.unlock.kaltura)\">\n      <button class=\"btn btn-default overflow-ellipse\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\"\n        analytics-on analytics-event=\"event-edit\" analytics-category=\"kaltura-export\" analytics-label=\"\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Export To Kaltura\n      </button>\n    </div>\n  </div>\n\n  <!-- status messaging -->\n  <div ng-switch=\"vm.status()\">\n    <div ng-switch-when=\"expired|unprocessed\" ng-switch-when-separator=\"|\">\n      <!-- nobody has requested this yet, or the previous one expired -->\n    </div>\n    <div ng-switch-when=\"requesting\">\n      <p class=\"text-center\">\n        <em>Loading...</em>\n      </p>\n    </div>\n    <div ng-switch-when=\"awaiting_conversion|processing|requested\" ng-switch-when-separator=\"|\">\n      <p class=\"text-center\">\n        Your request is processing. Feel free to close this window and come back later.\n      </p>\n      <uib-progressbar value=\"vm.statusPercent()\" max=\"100\">\n        {{vm.statusPercent()}}% Complete\n      </uib-progressbar>\n      <p class=\"text-center\">\n        <em><random-waiting-message interval=\"5000\"></random-waiting-message></em>\n      </p>\n    </div>\n    <div ng-switch-when=\"ready\">\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'mp4' || vm.activeTab == 'm4a'\">\n        Your download is ready!\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'kaltura' && !vm.unlock.kaltura\">\n        The video has been successfully exported to Kaltura.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.kaltura = true\"><small>Export this video again.</small></button>\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'vimeo' && !vm.unlock.vimeo\">\n        The video has been successfully exported to Vimeo.<br>\n        Look for an email from Vimeo or visit <a href=\"https://vimeo.com/home/myvideos\" target=\"_blank\">My Videos</a> for next steps.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.vimeo = true\"><small>Export this video again.</small></button>\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'youtube' && !vm.unlock.youtube\">\n        The video has been successfully exported to YouTube.<br>\n        Look for an email from YouTube or visit your <a href=\"https://www.youtube.com/my_videos\" target=\"_blank\">Video Manager</a> for next steps.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.youtube = true\"><small>Export this video again.</small></button>\n      </p>\n    </div>\n    <div ng-switch-when=\"failed\">\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'mp4' || vm.activeTab == 'm4a'\">\n        <i class=\"fa fa-warning\"></i>\n        The download request failed.\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'kaltura'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.overview\">Kaltura Configuration Settings</a> correct?\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'vimeo'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.vimeo\">Vimeo Configuration Settings</a> correct?\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'youtube'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.youtube\">YouTube Configuration Settings</a> correct?\n      </p>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ModalUploadEventController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
// State machine for creating a new broadcast from upload:
// 1. create backdated broadcast with stream_source: imported
// 2. POST to create new placeholder for upload slot on the broadcast
// 3. upload into the presigned URL given by #2
// 4. monitor progress of upload
// 5. poke API to update status of broadcast upload and initiate transcode
// 6. redirect to broadcast page to monitor transcode status

function ModalUploadEventController($uibModalInstance, $scope, $http, toaster, $timeout, $q, BandwidthTestClient, Broadcast, $rootScope, broadcast, highlights) {
  'ngInject';

  var _this = this;

  this.FeatureFlags = $rootScope.account.feature_flags;
  this.error = null;
  this.highlights = highlights;

  if (broadcast == null) {
    this.mode = 'new';
    broadcast = {
      name: ''
    };
  } else {
    this.mode = 'replacement';
  }

  this.maxDate = new Date(); // Fake the EditOrCreateEventService for this context

  this.yesterday = moment().add(-1, 'day').set({
    hour: 0,
    minute: 0,
    second: 0
  }).toDate();
  this.service = {
    broadcast: broadcast,
    startDate: moment(this.yesterday).clone().toDate(),
    startTime: moment(this.yesterday).clone().set({
      hour: 12,
      minute: 0,
      second: 0
    }).toDate(),
    maxBroadcastDurationHours: $rootScope.account.max_broadcast_duration_hrs,
    resolutionLimit: $rootScope.account.resolution_limit
  };
  this.file = null;

  var estimateUploadAndProcessingTime = function estimateUploadAndProcessingTime() {
    $timeout.cancel(_this._videoDurationPoll); // If we don't have an available bandwidth yet, clear the estimates and return

    if (!_this.availableBandwidth) {
      delete _this.uploadEstimateMs;
      delete _this.processingEstimateMs;
      return;
    }

    var bandwidth = _this.availableBandwidth; // If we don't have a file or size/duration yet, clear the estimates and return

    if (!_this.file || !_this.file.file || !_this.file.file.size) {
      delete _this.uploadEstimateMs;
      delete _this.processingEstimateMs;
      return;
    }

    var uploadSize = _this.file.file.size;

    if (!_this.file.videoDuration) {
      // Unfortunately it seems like $scope.$watch doesn't always fire when the videoDuration
      // property gets added. This is a little dirty, but kind of "polls" for the presence of that property
      delete _this.uploadEstimateMs;
      delete _this.processingEstimateMs;
      _this._videoDurationPoll = $timeout(estimateUploadAndProcessingTime, 250);
      return;
    }

    var videoDurationSeconds = _this.file.videoDuration; // bandwidth is in bps (bits per second), but uploadSize is bytes, so do math; also convert seconds to ms

    _this.uploadEstimateMs = uploadSize * 8.0 / bandwidth * 1000.0; // XXX: Here is where we could replace this logic with actual calls to the upload service to
    // get more accurate estimates. But for now, assume a couple minutes of overhead for task
    // assignment, spin-up, shutdown, daemon polling, etc.; and assume that processing duration
    // matches video duration.

    _this.processingEstimateMs = 2 * 60 * 1000 + // overhead
    videoDurationSeconds * 1000; // video duration
  };

  $scope.$on('$destroy', function () {
    return $timeout.cancel(_this._videoDurationPoll);
  }); // Start a bandwidth test in the background when this dialog opens

  BandwidthTestClient.runTestOrUseRecentCached().then(function (result) {
    if (result && result.success && result.availableBandwidth) {
      _this.availableBandwidth = result.availableBandwidth;
      estimateUploadAndProcessingTime();
    }
  });
  $scope.$on('$destroy', BandwidthTestClient.cancelIfInFlight); // Watch for file changes to estimate upload duration

  $scope.$watch(function () {
    return _this.file;
  }, estimateUploadAndProcessingTime);

  this.submit = function () {
    if (!_this.file) {
      _this.error = 'Please select a file.';
      return;
    }

    if (_this.mode == 'new' && (!_this.service.broadcast.name || !_this.service.startDate || !_this.service.startTime)) {
      _this.error = 'Please enter all required fields.';
      return;
    }

    var startDateTime = moment(_this.service.startDate).clone();
    startDateTime.set({
      hour: moment(_this.service.startTime).get('hour'),
      minute: moment(_this.service.startTime).get('minute'),
      second: 0
    });

    if (startDateTime.toDate() > _this.maxDate) {
      _this.error = 'Future dated broadcasts are not allowed';
      return;
    }

    _this.error = null;
    _this.submitting = true;
    var promise;

    if (_this.mode == 'new') {
      // Use <video> duration, rounded up to nearest minute, for at least 1 minute.
      var videoDurationSeconds = _this.file.videoDuration || 60 * 60; //assume 1hr

      var videoDurationMinutes = Math.max(1, Math.ceil(videoDurationSeconds / 60));
      _this.service.endTime = moment(_this.service.startTime).clone().add(videoDurationMinutes, 'minutes').toDate();

      if (_this.service.endTime > _this.maxDate) {
        _this.service.endTime = _this.maxDate;
      }

      var dates = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(_this.service.startDate, _this.service.startTime, _this.service.endTime, _this.service.maxBroadcastDurationHours);

      if (moment(dates.stops_at).toDate() > _this.maxDate) {
        _this.submitting = false;
        _this.error = "Invalid broadcast date/time. Please set the start time earlier to avoid having the end in the future (computed video duration of ".concat(videoDurationMinutes, " minutes).");
        return;
      }

      var newBroadcast = Broadcast.save({
        name: _this.service.broadcast.name,
        starts_at: dates.starts_at,
        stops_at: dates.stops_at,
        stream_source: 'imported',
        is_private: true
      });
      promise = newBroadcast.$promise.then(function () {
        console.log('Broadcast saved, now uploading video', newBroadcast);
        return newBroadcast;
      });
    } else if (_this.mode == 'replacement') {
      // Replacement is much simpler; no need to create a new broadcast.
      promise = $q(function (res, _) {
        return res(broadcast);
      });
    } else {
      throw Error("Unsupported mode: ".concat(_this.mode));
    }

    promise.then(function (b) {
      broadcast = b;
      return _this.file.upload({
        broadcast_id: broadcast.id
      });
    }).then(function (response) {
      console.log('Upload completed', response);
      toaster.pop('success', 'Successfully uploaded broadcast');
      $uibModalInstance.close(broadcast);
    })["catch"](function (err) {
      _this.submitting = false;
      _this.error = 'An error occurred while trying to upload the broadcast.';
      console.error(err);
      toaster.pop('warning', 'An error occurred while trying to save the broadcast.', 'Please refresh and try again.', 0 //don't auto-timeout
      );
    });
  };

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClapprUtils; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var ClapprUtils = /*#__PURE__*/function () {
  function ClapprUtils(player) {
    var _this = this;

    _classCallCheck(this, ClapprUtils);

    this.player = player;
    var hls = this.getCurrentHlsJsInstance();

    if (hls) {
      hls.on('hlsLevelLoaded', function (evt, levelDetails) {
        return _this.onHlsLevelLoaded(evt, levelDetails);
      });
    }
  }

  _createClass(ClapprUtils, [{
    key: "onHlsLevelLoaded",
    value: function onHlsLevelLoaded(evt, levelDetails) {
      var _this2 = this;

      // XXX: there's an odd behavior in hls.js where it fires 2 levelLoaded events in quick
      // succession; the first is the one we want because the 2nd has a mutated "start" to be the
      // startPTS.  so ignore the subsequent one but keep the first.
      if (this._avoidDoubleLevel) {
        //console.log('hlsLevelLoaded - ignoring ',levelDetails.details.fragments.length,' framents');
        return;
      } else {
        this._avoidDoubleLevel = true;
        setTimeout(function () {
          return _this2._avoidDoubleLevel = false;
        }, 2000);
        var mediaOffset = 0.0;
        var mediaSN = levelDetails.details.startSN;
        var firstSN = -1;

        if (levelDetails.details.initSegment !== null) {
          var tagList = levelDetails.details.initSegment.tagList;

          for (var i = 0; i < tagList.length; i++) {
            if (tagList[i][0] == 'EXT-X-BOXCAST-OFFSET') {
              mediaOffset = parseFloat(tagList[i][1]);
              break;
            }
          }
        }

        this._levelFragments = _.map(levelDetails.details.fragments, function (data) {
          for (var i = 0; i < data.tagList.length; i++) {
            if (data.tagList[i][0] == 'EXT-X-BOXCAST-OFFSET') {
              mediaOffset = parseFloat(data.tagList[i][1]);
              break;
            }
          }

          var position = data.relurl.indexOf('.ts');
          var sn = parseInt(data.relurl.substring(position - 8, position), 10);

          if (firstSN == -1) {
            firstSN = sn;
          }

          return {
            start: data.start,
            duration: data.duration,
            sn: mediaSN + (sn - firstSN)
          };
        });
        this._mediaOffset = mediaOffset; //console.log('hlsLevelLoaded - loaded ',this._levelFragments.length,' fragments');
      }
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      // XXX: skip the clappr player.getCurrentTime nonsense that attempts to track itself on events,
      // and instead hit the <video> element
      return this.player.core.$el.find('video, audio').get(0).currentTime;
    }
  }, {
    key: "getCurrentHlsJsInstance",
    value: function getCurrentHlsJsInstance() {
      if (!this.player) return null;
      var playback = this.player.core.getCurrentPlayback();
      return playback._hls;
    }
  }, {
    key: "isUsingHlsJs",
    value: function isUsingHlsJs() {
      try {
        return this.getCurrentHlsJsInstance();
      } catch (e) {
        return false;
      }
    }
  }, {
    key: "getPlayerSegmentAndOffsetForTime",
    value: function getPlayerSegmentAndOffsetForTime(time) {
      var fragments = this._levelFragments;
      var currentSN = -1;
      var startTime = 0.0;

      for (var i = 0; i < fragments.length; i++) {
        var data = fragments[i]; // Multiple fragments can belong to the same MPEG-TS file so this captures the start time of
        // the very first fragment of an MPEG-TS file.

        if (currentSN != data.sn) {
          currentSN = data.sn;
          startTime = data.start;
        }

        if (data.start <= time && data.start + data.duration >= time) {
          console.log('Found segment for time [', time, ']: ', data);
          return [data.sn, time - startTime];
        }
      }

      console.warn('Unable to find segment matching time [', time, '] in list: ', fragments);
      return null;
    }
  }, {
    key: "getMediaAbsoluteTimeForTime",
    value: function getMediaAbsoluteTimeForTime(time) {
      return time + this._mediaOffset;
    }
  }]);

  return ClapprUtils;
}();



/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body upload-modal\" style=\"padding:0\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"row\">\n      <div class=\"col-sm-6 left-col\" style=\"padding:35px;\">\n        <upload-slot ng-model=\"vm.file\"\n                     slot-name=\"'broadcast'\"\n                     allow-image=\"false\"\n                     allow-video=\"true\"\n                     hide-stock-browse=\"true\"\n                     hide-recent-browse=\"true\"></upload-slot>\n        <span ng-if=\"vm.file.file && !vm.submitting\">\n          <p class=\"text-center text-info\" ng-hide=\"vm.uploadEstimateMs && vm.processingEstimateMs\">\n            Estimating uploading and processing time...\n          </p>\n          <p class=\"text-center text-info\" ng-show=\"vm.uploadEstimateMs && vm.processingEstimateMs\">\n            Estimated time to upload and process this file:<br>\n            {{ (vm.uploadEstimateMs + vm.processingEstimateMs) | remainingTime }}\n          </p>\n        </span>\n      </div>\n      <div class=\"col-sm-6 right-col\">\n        <div ng-hide=\"vm.submitting\">\n          <div style=\"position:absolute;right:30px;top:15px\">\n            <a href ng-click=\"vm.cancel()\"><i class=\"fa fa-times\"></i></a>\n          </div>\n          <h3 class=\"text-center\" style=\"margin-top:0\" ng-show=\"vm.mode == 'new'\">\n            Upload Broadcast\n          </h3>\n          <h3 class=\"text-center\" style=\"margin-top:0\" ng-show=\"vm.mode == 'replacement'\">\n            Broadcast Replacement\n          </h3>\n\n          <p style=\"font-weight:bold;margin-bottom:0\">\n            Recommended Upload Settings &nbsp;\n            <a title=\"Help documentation\" href=\"https://support.boxcast.com/en/articles/4235131\" target=\"_blank\"><i class=\"fa fa-question-circle help-block\"></i></a>\n          </p>\n          <table class=\"text-sm\" style=\"width:100%;;margin-bottom:15px;\">\n            <tr>\n              <th>Format:</th>\n              <td>MP4 or MOV</td>\n            </tr>\n            <tr>\n              <th>Quality:</th>\n              <td>\n                <span ng-show=\"vm.service.resolutionLimit >= 1080\">1080p at 7 Mbps</span>\n                <span ng-hide=\"vm.service.resolutionLimit >= 720\">720p at 3 Mbps</span>\n              </td>\n            </tr>\n            <tr>\n              <th>Video Codec:</th>\n              <td>H.264/AVC (High Profile) or H.265/HEVC.<br>Progressive scan (no interlacing).</td>\n            </tr>\n            <tr>\n              <th>Keyframe Interval:</th>\n              <td>One keyframe at least every 2s-10s</td>\n            </tr>\n            <tr>\n              <th>Audio Codec:</th>\n              <td>AAC, 44.1kHz or 48kHz</td>\n            </tr>\n          </table>\n\n          <div ng-if=\"vm.error\">\n            <div class=\"bg-danger text-danger text-center text-xs\" style=\"padding:5px;margin-bottom:15px;border:1px solid;\">\n              {{vm.error}}\n            </div>\n          </div>\n\n          <div ng-if=\"vm.mode != 'new'\">\n            <p class=\"help-block\">Once you click upload below, the video will begin processing.  The original\n            video will remain available until this replacement has been fully processed. Once the replacement\n            is fully processed, the original video\n            <span ng-show=\"vm.highlights.length > 0\">(and any highlight clips from it)</span> will be deleted\n            and the uploaded video will become active.</p>\n          </div>\n          <div ng-if=\"vm.mode == 'new'\">\n            <div class=\"form-group\" ng-class=\"(form.eventName.$invalid && vm.error ? 'has-error' : '')\">\n              <label for=\"eventName\">Broadcast Name</label>\n              <input type=\"text\" class=\"form-control\" name=\"eventName\" id=\"eventName\" ng-model=\"vm.service.broadcast.name\" required>\n            </div>\n            \n            <div class=\"row\">\n              <div class=\"col-sm-6\">\n                <div class=\"form-group\">\n                  <label>Broadcast Date</label>\n                  <p class=\"input-group\">\n                    <input type=\"text\" class=\"form-control\"\n                          uib-datepicker-popup\n                          ng-model=\"vm.service.startDate\"\n                          is-open=\"startDateOpened\"\n                          datepicker-options=\"{maxDate: vm.maxDate, showWeeks: false}\"\n                          ng-required=\"true\"\n                          close-text=\"Close\" />\n                    <span class=\"input-group-btn\">\n                      <button type=\"button\" class=\"btn btn-default\" ng-click=\"startDateOpened = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                  </p>\n                </div>\n              </div>\n              <div class=\"col-sm-6\">\n                <div class=\"form-group\">\n                  <label>Start Time</label>\n                  <time-picker ng-model=\"vm.service.startTime\"\n                               start-time=\"vm.yesterday\"\n                               scroll-item-into-focus=\"true\"></time-picker>\n                </div>\n              </div>\n\n              <div class=\"col-sm-12\" ng-show=\"vm.mode == 'new' && vm.FeatureFlags.simulated_live\">\n                <div class=\"text-info bg-info text-sm\" style=\"padding:10px; margin:15px 0; border:1px solid;\">\n                  <i class=\"fa fa-info-circle\"></i>\n                  If you are uploading this for a simulated live broadcast, choose an arbitrary date in the past;\n                  once the upload has been processed, you'll be able to use it as a \"source\" for a future simulated live broadcast.\n                </div>\n              </div>\n\n            </div>\n          </div>\n\n          <div class=\"row\" style=\"margin-top:15px\">\n            <div class=\"form-group col-sm-10\">\n              <button class=\"btn btn-block btn-success\" ng-click=\"vm.submit()\" ng-disabled=\"vm.submitting || !vm.file\">\n                <i class=\"fa fa-spin fa-spinner\" ng-show=\"vm.submitting\"></i>\n                Upload and Save Broadcast\n              </button>\n            </div>\n            <div class=\"col-sm-2 text-right\" style=\"line-height:34px\">\n              <a href ng-click=\"vm.cancel()\">Cancel</a>\n            </div>\n          </div>\n\n        </div>\n\n        <div ng-show=\"vm.submitting\">\n          <div class=\"text-info bg-info\" style=\"margin:50px 15px; padding:30px; border:1px solid\">\n            <h3>The broadcast is uploading...</h3>\n            <p>Please do not close this window.  You will be redirected to the broadcast details page once the upload\n            has completed.</p>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = "<form name=\"highlightForm\" role=\"form\">\n\n<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">{{vm.title}}</h3>\n</div>\n<div class=\"modal-body\">\n\n  <div class=\"row\" style=\"position:relative\">\n\n    <div class=\"col-xs-12\">\n      <recording-trimmer broadcast-id=\"vm.broadcast.id\"\n                         recording-id=\"vm.recording.id\"\n                         start-segment=\"vm.startSegment\"\n                         stop-segment=\"vm.stopSegment\"\n                         start-seconds=\"vm.startSeconds\"\n                         stop-seconds=\"vm.stopSeconds\"\n                         on-change-bounds=\"vm.onChangeBounds\"></recording-trimmer>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"well\" style=\"margin-top:15px\">\n        <p>\n          <strong>Selected Clip Duration:</strong>\n          {{vm.duration | secondsFormatted:true:false}}\n        </p>\n        <div ng-show=\"vm.broadcastIsMonetized && vm.duration > vm.maxMonetizedHighlightTimeS\">\n          <p class=\"text-warning\">\n            <i class=\"fa fa-warning\"></i>\n            This broadcast is ticketed. Highlights longer than {{vm.maxMonetizedHighlightTimeS | secondsFormatted:true:false}} will not be shown to viewers.\n          </p>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"name\">\n            Highlight Name\n            <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i>\n          </label>\n          <input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" ng-model=\"vm.highlight.name\" ng-maxlength=\"::vm.limits.name\" required>\n          <p ng-show=\"(highlightForm.name.$dirty || highlightForm.name.$touched) && !vm.highlight.name\">\n            <span class=\"text-danger\" ng-if=\"highlightForm.name.$error.maxlength\">The name is too long.</span>\n            <span class=\"text-danger\" ng-if=\"highlightForm.name.$error.required\">The name cannot be blank.</span>\n          </p>\n        </div>\n        <div class=\"form-group\">\n          <label>\n            Highlight Description\n          </label>\n          <textarea class=\"form-control\" ng-model=\"vm.highlight.description\"></textarea>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n<div class=\"modal-footer\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <a href=\"javascript://\" ng-if=\"vm.highlight.id\" ng-click=\"vm.delete()\" class=\"action-link pull-left\">\n        <i class=\"fa fa-trash\"></i>\n        Delete Highlight\n      </a>\n      <div class=\"pull-right\">\n        <div class=\"form-group\">\n          <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">\n            Cancel\n          </button>\n          <button class=\"btn btn-primary\" ng-click=\"vm.showPreviewModal()\">\n            Preview Highlight Clip\n          </button>\n          <button ng-click=\"vm.saveChanges()\" ng-disabled=\"!highlightForm.$valid || vm.isSaving\" class=\"btn btn-success\">\n            <i ng-show=\"vm.isSaving\" class=\"fa fa-cog fa-spin\"></i>\n            Save Highlight Clip\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n</form>"

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = "<form name=\"highlightForm\" role=\"form\">\n\n<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\" ng-if=\"!vm.showSave\">{{vm.highlight.name || '(No description provided)'}}</h3>\n  <h3 class=\"modal-title\" ng-if=\"vm.showSave\">Highlight Preview</h3>\n</div>\n<div class=\"modal-body\">\n  <div id=\"trim-preview-placeholder\"></div>\n  <div ng-if=\"vm.broadcast.channel_id\">\n\n    <boxcast-player ng-if=\"vm.showPlayer\" channel-id=\"vm.channelId\" mode=\"vm.mode\" options=\"vm.options\"></boxcast-player>\n\n    <div class=\"row\" style=\"margin-top:15px\" ng-if=\"vm.showSave\">\n      <div class=\"col-xs-6 text-left\">\n        <button class=\"btn btn-xs btn-default\"\n                ng-click=\"vm.nudge('start', -10)\"\n                ng-disabled=\"vm.options.trimSeconds.start == 0\"\n                uib-tooltip=\"Adjust start to 10 seconds earlier\" tooltip-append-to-body=\"true\"><i class=\"fa fa-step-backward\"></i></button>&nbsp;\n        <button class=\"btn btn-xs btn-default\"\n                ng-click=\"vm.nudge('start', 10)\"\n                ng-disabled=\"vm.options.trimSeconds.start == vm.options.trimSeconds.stop - 1\"\n                uib-tooltip=\"Adjust start to 10 seconds later\" tooltip-append-to-body=\"true\"><i class=\"fa fa-step-forward\"></i></button>&nbsp;\n        <small>Adjust start</small>\n      </div>\n      <div class=\"col-xs-6 text-right\">\n        <small>Adjust stop</small>&nbsp;\n        <button class=\"btn btn-xs btn-default\"\n                ng-click=\"vm.nudge('stop', -10)\"\n                ng-disabled=\"vm.options.trimSeconds.start == vm.options.trimSeconds.stop - 1\"\n                uib-tooltip=\"Adjust stop to 10 seconds earlier\" tooltip-append-to-body=\"true\"><i class=\"fa fa-step-backward\"></i></button>&nbsp;\n        <button class=\"btn btn-xs btn-default\"\n                ng-click=\"vm.nudge('stop', 10)\"\n                uib-tooltip=\"Adjust stop to 10 seconds later\" tooltip-append-to-body=\"true\"><i class=\"fa fa-step-forward\"></i></button>\n      </div>\n    </div>\n\n    <div class=\"form-group\" style=\"margin: 15px 0 30px\" ng-if=\"vm.showSave\">\n      <label for=\"eventName\">Description <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n      <input type=\"text\" class=\"form-control\" id=\"eventName\" name=\"eventName\" ng-model=\"vm.highlight.name\" ng-maxlength=\"::vm.limits.name\" required placeholder=\"Enter a name for this clip...\">\n      <p ng-show=\"(highlightForm.eventName.$dirty || highlightForm.eventName.$touched) && !vm.highlight.name\">\n        <span class=\"text-danger\" ng-if=\"highlightForm.eventName.$error.maxlength\">The description is too long.</span>\n        <span class=\"text-danger\" ng-if=\"highlightForm.eventName.$error.required\">The description cannot be blank.</span>\n      </p>\n    </div>\n\n    <p class=\"text-center\" style=\"margin:15px 0 30px\" ng-if=\"!vm.showSave\">\n      {{vm.highlight.description}}\n      <span ng-if=\"vm.highlight.duration\">({{vm.highlight.duration | secondsFormatted:true:false}})</span>\n    </p>\n\n    <ol class=\"list-inline text-center\" ng-if=\"vm.highlight.id\">\n      <li ng-if=\"vm.showSocialShare\">\n        <button class=\"btn btn-default\"\n                ng-click=\"vm.tweet()\"\n                analytics-on analytics-event=\"highlight-preview\" analytics-category=\"\" analytics-label=\"twitter\"\n                uib-tooltip=\"Tweet a link to your Twitter followers\" tooltip-placement=\"bottom\">\n          <i class=\"fa fa-twitter\" style=\"width:20px\"></i> Share on Twitter\n        </button>\n      </li>\n      <li ng-if=\"vm.showSocialShare\">\n        <button class=\"btn btn-default\"\n                ng-click=\"vm.facebook()\"\n                analytics-on analytics-event=\"highlight-preview\" analytics-category=\"\" analytics-label=\"facebook\"\n                uib-tooltip=\"Post a link on your Facebook timeline\" tooltip-placement=\"bottom\">\n          <i class=\"fa fa-facebook\" style=\"width:20px\"></i> Share on Facebook\n        </button>\n      </li>\n      <li ng-if=\"clipboard.supported && vm.highlightCanBeShared\">\n        <button class=\"btn btn-default\"\n          clipboard\n          text=\"vm.link\"\n          on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n          on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n          analytics-on analytics-event=\"highlight-preview\" analytics-category=\"\" analytics-label=\"copy\"\n          uib-tooltip=\"Copy the BoxCast.tv event link to your clipboard\" tooltip-placement=\"bottom\">\n          <i class=\"fa fa-copy\" style=\"width:20px\"></i> Copy Link\n        </button>\n      </li>\n      <li>\n        <button class=\"btn btn-default\" ng-if=\"vm.highlightCanBeShared\"\n                ng-click=\"vm.showEmbed = !vm.showEmbed\"\n                analytics-on analytics-event=\"highlight-preview\" analytics-category=\"\" analytics-label=\"embed\"\n                uib-tooltip=\"Embed this clip on your web site\" tooltip-placement=\"bottom\">\n          <i class=\"fa fa-code\" style=\"width:20px\"></i> Embed\n        </button>\n      </li>\n      <li>\n        <button class=\"btn btn-default\"\n                ng-click=\"vm.download()\"\n                analytics-on analytics-event=\"highlight-preview\" analytics-category=\"\" analytics-label=\"download\"\n                uib-tooltip=\"Download this highlight\" tooltip-placement=\"bottom\">\n          <i class=\"fa fa-download\" style=\"width:20px\"></i> Download\n        </button>\n      </li>\n    </ol>\n\n    <div ng-if=\"vm.showEmbed\" style=\"position:relative\">\n      <textarea readonly class=\"form-control\" rows=\"7\" style=\"font-size:9pt\">{{vm.embedCode}}</textarea>\n      <button ng-if=\"clipboard.supported\"\n              class=\"btn btn-sm\"\n              style=\"padding:2px 5px; font-size: 8pt; position: absolute; right: 5px; bottom: 5px;\"\n              clipboard\n              text=\"vm.embedCode\"\n              on-copied=\"toaster.pop('success', 'Embed code successfully copied')\"\n              on-error=\"toaster.pop('warning', 'Embed code could not be copied')\"\n              >Copy to Clipboard <i class=\"fa fa-copy\"></i></button>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <a href=\"javascript://\" ng-click=\"vm.delete()\" class=\"action-link pull-left\" ng-if=\"vm.highlight.id\">\n        <i class=\"fa fa-trash\"></i>\n        Delete Highlight\n      </a>\n      <div class=\"pull-right\">\n        <div class=\"form-group\">\n          <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">Close</button>\n          <button ng-if=\"vm.showSave\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.save()\" ng-disabled=\"!vm.highlight.name\">Save Highlight</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n</form>\n"

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ModalCheckoutController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_stripe__ = __webpack_require__(30);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function ModalCheckoutController(Account, Checkout, MeetingsService, Broadcast, $rootScope, $scope, $uibModalInstance, $timeout, $http, $q, $uibModal, params, isStreamMonkeyMode) {
  'ngInject'; // check for passed-in

  var _this = this;

  var _params = params,
      pd_did = _params.pd_did,
      pd_sid = _params.pd_sid,
      is_upgrade = _params.is_upgrade;
  this.loadingPromises = [];
  this.isUpgrade = is_upgrade;
  this.$timeout = $timeout;
  this.account = $rootScope.account;
  this.Account = Account;
  this.user = $rootScope.user;
  this.stripeCard = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["a" /* getStripeCard */])();
  this.$http = $http;
  this.$uibModal = $uibModal;
  this.method = 'cc';
  this.currentUpgrade = null;
  this.upgradeWaitInterval = 2000;
  this.submittingCard = false;
  this.disallowCheckout = false;
  this.disallowCheckoutReason = null;
  this.isLoading = true;
  this.allowMonthlyChecks = this.account.extra_features.allow_monthly_checks;
  this.step = 1;
  var STEP_FINAL = 6,
      STEP_AGREE = 4,
      ALLOW_ADDONS = true;

  if (isStreamMonkeyMode) {
    STEP_FINAL = 4;
    STEP_AGREE = 1;
    ALLOW_ADDONS = false;
  }

  remoteLogger.info('Opened trial self-service checkout modal', params);

  this.dismiss = function () {
    if (_this.step >= STEP_FINAL) {
      // Wipe onboarding metadata, refresh app and go back to home
      Account.get(function (a) {
        var newMeta = a.metadata;
        delete newMeta.onboarding_step;
        Account.update({
          metadata: newMeta
        }, function () {
          window.location.href = '/';
        });
      });
    } else {
      $uibModalInstance.dismiss('cancel');
    }
  }; // don't let user use this dialog once they're off their trial


  if (this.account.contract == 'recurring' && !this.isUpgrade) {
    this.disallowCheckout = true;
    this.disallowCheckoutReason = 'already_converted';
    return;
  }

  this.storagePolicy = this.account.storage_policy;
  this.salesTaxCents = 0;
  this.shipping = {
    country: 'US'
  };
  this.addOns = [];

  if (ALLOW_ADDONS) {
    this.$http.get('/assets/add-ons.json').then(function (response) {
      _this.addOns = response.data;
    });
  }

  this.stripeProducts = [];
  Account.getProducts().$promise.then(function (response) {
    _this.stripeProducts = response;
    _this.boxcasterProduct = _.find(_this.stripeProducts, {
      id: 'BXC-HDSD2'
    }) || {};
    _this.boxcasterProProduct = _.find(_this.stripeProducts, {
      id: 'BXC-PRO-2995'
    }) || {};
    _this.scoreboardAssistProduct = _.find(_this.stripeProducts, {
      id: 'BXC-SB-ASSIST'
    }) || {};
  })["catch"](function (err) {
    console.error(err);
    _this.stripeProducts = [];
  });
  this.selectedBasePlan = 'experience';
  this.selectedInterval = 'annual';
  this.selectedEncoder = 'app';

  this.selectPlan = function (plan) {
    _this.selectedBasePlan = plan;

    _this.checkPlanCompatibility();
  };

  this.selectedPlans = function () {
    return Checkout.stripePlanIDs(_this.selectedBasePlan, _this.selectedInterval, _this.selectedAddOns);
  };

  this.oneTimeAddOnCharges = [];

  this.selectedSkus = function () {
    return Checkout.stripeSKUs(_this.selectedEncoder, _this.oneTimeAddOnCharges, {
      shure_promo: _this.shurePromoApplied
    });
  };

  this.selectedBasePlanAmount = function () {
    return {
      essential: 99,
      growth: 149,
      experience: 199
    }[_this.selectedBasePlan] * (_this.selectedInterval == 'annual' ? 12 : 1);
  };

  this.checkAddOnPrice = function (addOn) {
    var quantity = _this.addOns[addOn.varName].quantity;

    if (quantity === 0) {
      quantity += 1;
    }

    var concurrentBroadcasts = _this.addOns.concurrentBroadcasts;

    if (addOn.costPerStream && concurrentBroadcasts.selected) {
      quantity = quantity * (concurrentBroadcasts.quantity + _this.account.max_simultaneous_streams);
    } else if (addOn.costPerStream && !concurrentBroadcasts.selected) {
      quantity = quantity * _this.account.max_simultaneous_streams;
    }

    return quantity * addOn.monthlyCost * (_this.selectedInterval == 'annual' ? 12 : 1);
  };

  this.scoreboardAssistPrice = function (quantity) {
    quantity -= 1;
    return quantity * 599;
  }; // Get account upgrades


  this.loadingUpgrades = true;
  this.upgrades = Account.getUpgrades();
  this.loadingPromises.push($q(function (resolve, reject) {
    _this.upgrades.$promise.then(function () {
      _this.loadingUpgrades = false; // For each upgrade, append the actual proposal data

      $q.all(_this.upgrades.map(function (u) {
        return $http.get("".concat(INTEGRATIONS_ROOT, "/pandadoc/document?pandadoc_id=").concat(u.pandadoc_id)).then(function (r) {
          u.proposal = r.data;
        });
      })).then(function () {
        resolve();
      })["catch"](function (e) {
        reject(e);
      });
    })["catch"](function (e) {
      reject(e);
    });
  }));

  this.checkPreviousSelectedPayment = function () {
    var paymentException = _this.account.payment_method === 'check' || _this.account.payment_method === 'po';

    if (Checkout.currentInterval(_this.billing) === 'month' && paymentException) {
      _this.showAllPaymentOptions = true;
    }
  }; // Get account billing information from Stripe


  this.planName = '';
  this.loadingPromises.push(Checkout.getBilling().then(function (r) {
    if (_this.account.isTrialing() && (_this.account.payment_method == 'po' || _this.account.payment_method == 'check')) {
      // PO/Check customers will be stuck in "trial" contract until they actually
      // complete payment.  Don't let them check out again.
      if (r.outstandingInvoices.length) {
        _this.disallowCheckout = true;
        _this.disallowCheckoutReason = 'outstanding_invoice';
      }
    }

    _this.billing = r.billing;
    _this.cardOnFile = r.cardOnFile;
    _this.bankOnFile = r.bankOnFile;
    _this.planName = Checkout.stripeBasePlanNameShortFromBillingResult(_this.billing);
    _this.planAmount = Checkout.stripeBasePlanAmountFromBillingResult(_this.billing);
    _this.interval = Checkout.currentInterval(_this.billing);
    _this.planLookupKey = Checkout.stripeBasePlanLookupKeyFromBillingResult(_this.billing); // TODO: consider if we should be creating add-ons for the other plans in their Stream Monkey trial

    _this.method = Checkout.paymentMethodFromAccount(_this.account);

    _this.checkPreviousSelectedPayment();
  })["catch"](function (err) {
    console.error(err);
    _this.billing = {};
  })); // Load the current pandadoc if we have one

  this.loadProposal = function () {
    return $q.all(_this.loadingPromises).then(function () {
      // See if account already has an upgrade created for them
      // Load the most recent one
      if (_this.upgrades.length > 0) {
        _this.currentUpgrade = _this.upgrades[0];

        if (pd_did) {
          _this.upgrades.forEach(function (u) {
            if (u.pandadoc_id == pd_did) {
              _this.currentUpgrade = u;
            }
          });
        }

        _this.processDocument();

        _this.restoreSelectionFromUpgradeDoc();

        _this.step = STEP_AGREE;
      } else if (_this.isUpgrade) {
        // If a customer is trying to view an upgrade proposal but has no upgrades on
        // their account, the upgrade they're trying to view no longer exists.
        // Skip to step 4 so a proper error message can be displayed.
        _this.step = STEP_AGREE;
      }
    });
  }; // Check on eligibility for promotion


  this.shurePromoAvailable = false;
  this.shurePromoEligible = false;
  this.shurePromoApplied = false;

  if (this.account.has_streamed) {
    this.loadingPromises.push(Broadcast.query({
      'filter.stream_source': 'app',
      'filter.include_archived': 'true',
      l: 50
    }).$promise.then(function (r) {
      _.each(r, function (broadcast) {
        if (broadcast.recording_duration_seconds > 0) {
          _this.shurePromoEligible = true;
        }
      });
    }));
  }

  $q.all(this.loadingPromises).then(function () {
    // Only allow promo for accounts created after 2020-04-01
    var stripeSubCreatedAt = moment();

    if (_this.billing && _this.billing.subscriptions && _this.billing.subscriptions.data.length) {
      stripeSubCreatedAt = moment(_this.billing.subscriptions.data[0].created * 1000);
    }

    _this.shurePromoAvailable = _this.account.isTrialing() && stripeSubCreatedAt.isAfter('2020-04-01');
  });

  this.restoreSelectionFromUpgradeDoc = function () {
    try {
      var subscriptionItems = _this.currentUpgrade.proposal.products.subscription_items.map(function (item) {
        return {
          id: item.stripe_price.lookup_key,
          qty: item.qty
        };
      });

      var baseItem = subscriptionItems.filter(function (item) {
        return !_.contains(item.id, 'addon');
      });
      var parts = baseItem[0].id.split(':'); // set base plan and interval

      if (parts.length > 1) {
        _this.selectedBasePlan = parts[0].toString();
        _this.selectedInterval = parts[1].toString();
      } // set add-on plan selections and quantities


      var _loop = function _loop(prop) {
        matchingPlan = _.find(subscriptionItems, function (p) {
          return _this.addOns[prop].sku[_this.selectedInterval] == p.id;
        });

        if (matchingPlan) {
          _this.addOns[prop].selected = true;
          _this.addOns[prop].quantity = matchingPlan.qty;
        }
      };

      for (var prop in _this.addOns) {
        var matchingPlan;

        _loop(prop);
      } //  set scoreboard assist quantity


      var invoiceItems = _this.currentUpgrade.proposal.products.invoice_items.map(function (item) {
        return {
          id: item.stripe_price.lookup_key,
          qty: item.qty
        };
      });

      var assists = invoiceItems.filter(function (item) {
        return _.contains(item.id, 'BXC-SB-ASSIST');
      });

      if (assists) {
        _this.addOns.scoreboard.oneTimeCost.quantity = assists[0].qty;
      } // set encoder


      var encoder = invoiceItems.filter(function (item) {
        return _.contains(item.id, 'HDSD');
      });

      if (encoder[0].id == Checkout.BOXCASTER_SKU) {
        _this.selectedEncoder = 'boxcaster';
      } else if (encoder[0].id == Checkout.BOXCASTER_PRO_SKU) {
        _this.selectedEncoder = 'pro';
      }
    } catch (e) {}
  };

  this.loadProposalPromise = this.loadProposal();
  $q.all(this.loadingPromises).then(function () {
    return _this.isLoading = false;
  }); // Watch and wait for Pandadoc messages

  Checkout.registerPandadocWatcher($scope, function (evt, data) {
    if (evt == 'session_view.document.completed') {
      _this.pandadocCompleted = true;

      if (_this.step == STEP_AGREE) {
        _this.next(); // auto-advance once finalizing agreement

      }
    }
  });
  Checkout.getLocations().then(function (r) {
    _this.states = r.states;
    _this.countries = r.countries;
  });

  this["goto"] = function (step) {
    if (_this.step <= step) {
      // cannot use direct clicking to go forward
      return;
    }

    if (_this.currentUpgrade && !Checkout.isDocumentSelfServiceGenerated(_this.currentUpgrade)) {
      // cannot go backward at all on a seller-generated document
      return;
    }

    _this.step = step;
  };

  this.finalizeAddOns = function () {
    // clearing out these arrays each time someone clicks past step 3 to ensure no duplication
    _this.oneTimeAddOnCharges = [];
    _this.selectedAddOns = [];

    for (var prop in _this.addOns) {
      var addOn = _this.addOns[prop];

      if (addOn.quantity === 0) {
        addOn.quantity += 1;
      } // make sure they'll be charged the same price reflected on order summary by checking max streams and if they added concurrent broadcasts and adjusting quantity accordingly


      var concurrentBroadcasts = _this.addOns.concurrentBroadcasts;

      if (addOn.costPerStream && concurrentBroadcasts.selected) {
        addOn.quantity = addOn.quantity * (concurrentBroadcasts.quantity + _this.account.max_simultaneous_streams);
      } else if (addOn.costPerStream && !concurrentBroadcasts.selected) {
        addOn.quantity = addOn.quantity * _this.account.max_simultaneous_streams;
      } // add set quantity of addOns to array for recurring charges


      if (addOn.selected) {
        for (var i = 0; i < addOn.quantity; i++) {
          _this.selectedAddOns.push(addOn.sku[_this.selectedInterval]);
        }
      } // add set quantity of one time charges associated with Add-Ons to array for one time charges


      if (addOn.selected && addOn.oneTimeCost !== '') {
        for (var _i = 0; _i < addOn.oneTimeCost.quantity; _i++) {
          _this.oneTimeAddOnCharges.push(addOn.sku.oneTime);
        }
      }
    }

    if (_this.addOns.scoreboard.selected && _this.addOns.scoreboard.oneTimeCost.quantity > 0) {
      _this.oneTimeAddOnCharges.push('coupon:one-time:SB-ASSIST:59900');
    }
  };

  this.planCompatibleWithSelections = true;
  this.encoderCompatibleWithSelections = true;

  this.checkPlanCompatibility = function () {
    _this.planCompatibleWithSelections = true;

    if (_this.addOns.extendedDuration.selected || _this.addOns.captioning.selected || _this.addOns.smartTVApps.selected || _this.addOns.scoreboard.selected) {
      if (_this.selectedBasePlan !== 'experience') {
        _this.planCompatibleWithSelections = false;
      }
    }
  };

  this.checkEncoderCompatibility = function () {
    _this.encoderCompatibleWithSelections = true;

    if (_this.addOns.scoreboard.selected && _this.selectedEncoder == 'app') {
      _this.encoderCompatibleWithSelections = false;
    }
  };

  this.resetAddOnsIfNeeded = function () {
    if (!_this.planCompatibleWithSelections || !_this.encoderCompatibleWithSelections) {
      for (var prop in _this.addOns) {
        _this.addOns[prop].selected = false;
      }

      _this.planCompatibleWithSelections = true;
      _this.encoderCompatibleWithSelections = true;
    }
  };

  this.next = function () {
    if (ALLOW_ADDONS) {
      if (_this.step == 1 || _this.step == 2) {
        _this.resetAddOnsIfNeeded();
      }

      if (_this.step == 3) {
        _this.finalizeAddOns();
      }
    }

    _this.step += 1;
  };

  this.prev = function () {
    _this.step -= 1;
  };

  this.completeCheckout = function () {
    if (_this.requiresPaymentSource()) {
      _this.checkoutError = 'You must select a payment method before proceeding.';
      remoteLogger.info('Checkout no payment method');
      return;
    }

    if (!Checkout.validateBillingAddress(_this.billing)) {
      _this.checkoutError = 'Please complete your billing address before proceeding.';
      remoteLogger.info('Checkout invalid billing address');
      return;
    }

    if (_this.needsShipping && !_this.shippingSameAsBilling && !Checkout.validateShippingAddress(_this.shipping)) {
      _this.checkoutError = 'Please complete you shipping address before proceeding.';
      remoteLogger.info('Checkout invalid shipping address');
      return;
    }

    if (_this.method == 'cc') {
      if (_this.cardOnFile || _this.stripeCard) {// all good
      } else {
        _this.checkoutError = 'Please enter a valid credit card before proceeding.';
        remoteLogger.info('Checkout invalid credit card');
        return;
      }
    }

    if (_this.method == 'ach') {
      if (_this.bankOnFile) {// all good
      } else if (_this.addNewBankAccount && _this.newBankOnFile) {// all good
      } else {
        _this.checkoutError = 'Please link your bank account before proceeding.';
        remoteLogger.info('Checkout missing bank account');
        return;
      }
    }

    _this.checkoutError = null;

    if (_this.method == 'cc' && (_this.addNewCard || !_this.cardOnFile)) {
      _this.submittingCard = true;
      Checkout.submitCard(_this.stripeCard).then(function (token) {
        remoteLogger.info('Checkout got token for card');
        _this.stripeToken = token.id;
        _this.submittingCard = false;

        _this.doPost();
      })["catch"](function (err) {
        console.error(err);
        _this.checkoutError = 'Unable to process credit card. ' + err;
        _this.submittingCard = false;
        remoteLogger.info('Checkout error submitting card', {
          error: err
        });
      });
    } else {
      _this.doPost();
    }
  };

  this.currentUpgradeMatchesSelection = function () {
    var proposalPlanIDs = [];

    _this.currentUpgrade.proposal.products.subscription_items.forEach(function (item) {
      for (var i = 0; i < item.qty; i++) {
        proposalPlanIDs.push(item.stripe_price.lookup_key);
      }
    });

    var proposalItemIDs = [];

    _this.currentUpgrade.proposal.products.invoice_items.forEach(function (item) {
      for (var i = 0; i < item.qty; i++) {
        proposalItemIDs.push(item.stripe_price.lookup_key);
      }
    });

    proposalPlanIDs = proposalPlanIDs.sort();
    proposalItemIDs = proposalItemIDs.sort();
    return _.isEqual(proposalPlanIDs, _this.selectedPlans().sort()) && _.isEqual(proposalItemIDs, _this.selectedSkus().sort());
  };

  this.streamMonkeyTotalPriceEstimate = function () {
    if (!isStreamMonkeyMode) return null;
    if (!_this.billing) return null;
    var result = 0;

    _this.billing.subscriptions.data.forEach(function (sub) {
      sub.items.data.forEach(function (item) {
        result += item.plan.amount;
      });
    });

    return result / 100;
  };

  this.selectedPlanFeatureSummaryList = function () {
    if (!isStreamMonkeyMode) return null;
    if (!_this.billing) return null;
    var result = [];

    if (_this.planName == 'Experience Plan') {
      result = ['1080p60 video resolution', 'Automated Scheduling', 'Viewer Chat', 'Unlimited Viewers', 'Unlimited Streaming', 'Unlimited Destinations', 'Priority Support', 'Adaptive Bitrate Playback', 'Cloud Transcoding', 'Simulated Live', 'Two Concurrent Broadcast', 'One-year of Storage', 'Automated-Captioning', 'API Documentation'];
    } else if (_this.planName == 'Growth Plan') {
      result = ['1080p video resolution', 'Automated Scheduling', 'Viewer Chat', 'Unlimited Viewers', 'Unlimited Streaming', 'Unlimited Destinations', 'Priority Support', 'Adaptive Bitrate Playback', 'Cloud Transcoding', 'Simulated Live', 'One Concurrent Broadcast', 'One-year of Storage'];
    } else if (_this.planName == 'Essential Plan') {
      result = ['1080p video resolution', 'Automated Scheduling', 'Viewer Chat', 'Unlimited Viewers', 'Unlimited Streaming', 'Unlimited Destinations', 'Priority Support', 'Adaptive Bitrate Playback', 'Cloud Transcoding', 'One Concurrent Broadcast', '30 Days of Storage'];
    }

    _this.billing.subscriptions.data.forEach(function (sub) {
      sub.items.data.forEach(function (item) {
        function planNameContains(str) {
          if (item.plan.id.toLowerCase().indexOf(str) >= 0) {
            return true;
          }

          if (((item.plan.metadata || {}).display_name || '').toLowerCase().indexOf(str) >= 0) {
            return true;
          }

          return false;
        }

        if (planNameContains('captioning')) {
          result.push('Live Closed Captioning');
        }

        if (planNameContains('simultaneous')) {
          result.push('Additional Concurrent Streams');
        }

        if (planNameContains('24hours')) {
          result.push('Extended Broadcast Duration');
        }

        if (planNameContains('ticketing')) {
          result.push('Ticketing');
        }
      });
    });

    return result;
  };

  this.createProposalIfNecessary = function () {
    _this.isLoadingProposal = true;
    _this.pandadocError = null;

    _this.loadProposalPromise.then(function () {
      if (isStreamMonkeyMode && _this.pandadocCompleted || _this.currentUpgrade && _this.currentUpgradeMatchesSelection()) {
        _this.isLoadingProposal = false;
        return;
      } // Create new upgrade and wait for it to be processed


      var params = {
        stripe_plan_ids: _this.selectedPlans(),
        stripe_sku_ids: _this.selectedSkus()
      };

      if (isStreamMonkeyMode) {
        // XXX: Note that Stream Monkey trial conversion customers use different
        // logic; we simply map their existing trial plans over, and we never
        // deal with hardware SKUs
        params = {
          stripe_plan_ids: []
        };

        _this.billing.subscriptions.data.forEach(function (sub) {
          sub.items.data.forEach(function (item) {
            params.stripe_plan_ids.push(item.price.lookup_key);
          });
        });
      }

      if (_this.shurePromoApplied) {
        params.pandadoc_template = Checkout.PANDADOC_TEMPLATE_FREE_TRIAL_WITH_PROMO;
      } else {
        params.pandadoc_template = Checkout.PANDADOC_TEMPLATE_FREE_TRIAL;
      }

      _this.currentUpgrade = null;
      Account.createUpgrade(params, function (upgrade) {
        _this.waitForNewUpgrade(upgrade.id, true);

        remoteLogger.info('Trial self-service checkout created new upgrade', {
          upgrade_id: upgrade.id
        });
      }, function (err) {
        remoteLogger.error('Unable to create pandadoc', {
          error: err
        });
        _this.pandadocError = 'could_not_create_upgrade';
        _this.isLoadingProposal = false;
      });
    });
  };

  this.isPandadocCompleted = function () {
    if (_this.pandadocCompleted) {
      return true;
    } else if (!_this.currentUpgrade || !_this.currentUpgrade.proposal) {
      return false;
    } else {
      return _this.currentUpgrade.proposal.status == 'document.completed';
    }
  };

  this.waitForNewUpgrade = function (upgrade_id, reset) {
    if (reset) {
      _this.waitCounter = 0;
    }

    if (_this.waitCounter++ > 10) {
      _this.pandadocError = 'could_not_create_upgrade';
      _this.isLoadingProposal = false;
      remoteLogger.error('Trial self-service checkout timeout waiting for upgrade', {
        upgrade_id: upgrade_id
      });
      return;
    }

    Account.getUpgrades().$promise.then(function (upgrades) {
      upgrades.forEach(function (u) {
        if (u.pandadoc_id == upgrade_id) {
          _this.currentUpgrade = u;
          $http.get("".concat(INTEGRATIONS_ROOT, "/pandadoc/document?pandadoc_id=").concat(_this.currentUpgrade.pandadoc_id)).then(function (r) {
            _this.currentUpgrade.proposal = r.data;

            _this.upgrades.push(_this.currentUpgrade);

            _this.processDocument();
          });
          _this.isLoadingProposal = false;
          return;
        }
      });

      if (!_this.currentUpgrade) {
        _this.$timeout(function () {
          return _this.waitForNewUpgrade(upgrade_id, false);
        }, _this.upgradeWaitInterval);
      }
    });
  };

  this.processDocument = function () {
    _this.needsShipping = false;
    _this.hasNewBasePlan = !!_.find(_this.currentUpgrade.proposal.products.subscription_items, function (item) {
      return !item.is_addon;
    });
    _this.hasSubscription = Checkout.isPurchasingSubscription(_this.currentUpgrade.proposal);
    _this.isRMA = false;
    _this.needsShipping = false;

    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["c" /* hasRMAItem */])(_this.currentUpgrade.proposal)) {
      _this.isRMA = true;
      _this.needsShipping = true;
    }

    _this.loadingPromises.push(_this.preview(_this.currentUpgrade.pandadoc_id));
  };

  this.billingParams = function () {
    var billing = _this.billing,
        shipping = _this.shipping;

    if (!billing || !shipping) {
      return {};
    }

    params = {
      address: billing.address,
      city: billing.city,
      state: billing.state,
      zip: billing.postal_code,
      country: billing.country
    };

    if (_this.needsShipping) {
      params = angular.extend(params, {
        ship_address: _this.shippingSameAsBilling ? billing.address : shipping.address,
        ship_city: _this.shippingSameAsBilling ? billing.city : shipping.city,
        ship_state: _this.shippingSameAsBilling ? billing.state : shipping.state,
        ship_zip: _this.shippingSameAsBilling ? billing.postal_code : shipping.postal_code,
        ship_country: _this.shippingSameAsBilling ? billing.country : shipping.country
      });
    }

    return params;
  };

  this.preview = function (pandadocID) {
    var params = _objectSpread({
      pandadoc_id: pandadocID
    }, _this.billingParams());

    return $http.put("".concat(API_ROOT, "/account/upgrades/").concat(_this.currentUpgrade.pandadoc_id, "/preview"), params).then(function (resp) {
      var data = resp.data;
      _this.prorationDate = data.proration_date;
      _this.totalNextDueCents = data.total_next_due_cents;
      _this.nextDueOn = data.next_due_on;
      _this.dueNow = data.due_now || [];
      _this.appliedCredit = data.applied_credit;
      _this.salesTaxCents = data.total_tax_cents;
      _this.newInterval = data.new_interval;
      _this.needsShipping = _this.needsShipping || data.needs_shipping;
      _this.now = Date.now();
      _this.remainingCredit = 0;
    })["catch"](function (err) {
      _this.pandadocError = 'could_not_preview_upgrade';
      _this.isLoadingProposal = false;
      remoteLogger.error('Error previewing upgrade proration in trial self service checkout', {
        error: err
      });
    });
  };

  this.previewDebounced = _.throttle(this.preview, 500, {
    leading: false
  });
  $scope.$watch(this.billingParams, function () {
    if (!Checkout.validateBillingAddress(_this.billing)) {
      return;
    }

    if (_this.needsShipping && !_this.shippingSameAsBilling && !Checkout.validateShippingAddress(_this.shipping)) {
      return;
    }

    _this.previewDebounced(_this.currentUpgrade.pandadoc_id);
  }, true);

  this.calculateNextDue = function () {
    _this.calculateTotalToday();

    return Math.max((_this.totalNextDueCents - _this.remainingCredit) / 100, 0);
  };

  this.onSelectPaymentMethod = function (m) {
    // Clear any tokens that may have been added
    _this.stripeToken = null;

    if (m == 'ach' && !_this.bankOnFile) {
      _this.openPlaid();
    } else {
      _this.method = m;
    }
  };

  this.calculateTotalToday = function () {
    var total = 0;

    _.forEach(_this.dueNow, function (d) {
      return total += d.amount_cents;
    });

    total += _this.salesTaxCents;
    total -= _this.appliedCredit;

    if (total < 0) {
      _this.remainingCredit = 0 - total;
      _this.appliedCredit -= _this.remainingCredit;
      total = 0;
    }

    return (total / 100).toFixed(2);
  };

  this.openPlaid = function () {
    Checkout.openPlaidLink().then(function (r) {
      _this.method = 'ach';
      _this.stripeToken = r.tokenResponse.data.stripe_bank_account_token;
      _this.newBankOnFile = {
        bank_name: r.metadata.institution.name,
        last4: '****'
      };
      _this.addNewBankAccount = true;
    });
  };

  this.doPost = function () {
    var $http = _this.$http;
    var params = {
      pandadoc_id: _this.currentUpgrade.pandadoc_id,
      firstname: _this.user.name.split(' ')[0],
      lastname: _this.user.name.split(' ')[1],
      organization_name: _this.account.name,
      proration_date: _this.prorationDate
    };

    if (Checkout.isDocumentSelfServiceGenerated(_this.currentUpgrade)) {
      params.transaction_type = 'upgrade_self_service';
    } else {
      params.transaction_type = 'upgrade_direct';
    }

    if (_this.stripeToken) {
      params.stripe_token = _this.stripeToken;
    } // If they have a stripe token, decide whether to use the new source for only this
    // transaction or everything going forward.


    if (_this.stripeToken && !_this.changeDefaultPaymentSource && _this.allowDefaultPaymentSourceOverride()) {
      params.payment_option = 'single_use';
    } else {
      params.payment_method = _this.method;
    }

    params = angular.extend(params, _this.billingParams());
    _this.submitting = true;
    $http.put("".concat(API_ROOT, "/account/upgrades/").concat(_this.currentUpgrade.pandadoc_id), params).then(function (r) {
      _this.submitting = false;
      _this.step = STEP_FINAL;

      _this.waitForFinalization();

      remoteLogger.info('Successfully submitted trial self service checkout');
    })["catch"](function (err) {
      remoteLogger.error('Error submitting trial self service checkout', {
        error: err
      });
      var error;

      if (err && err.data && err.data.error_hint) {
        error = "Unable to complete the transition. ".concat(err.data.error_hint);
      } else if (err && err.data && err.data.error_description) {
        error = "Unable to complete the transition: ".concat(err.data.error_description);
      } else {
        error = "An unknown error occurred while applying the changes to your account.  Please reach out to BoxCast customer support via questions@boxcast.com for assistance.";
      }

      _this.checkoutError = error;
      _this.stripeToken = null; //cannot re-use

      _this.submitting = false;
    });
  };

  var MAX_WAIT_FOR_FINALIZATION_MS = 60 * 1000;
  var WAIT_FOR_FINALIZATION_INTERVAL_MS = 5000;
  var startWaitForFinalization = null;

  this.waitForFinalization = function () {
    // For PO/Check, we need to poll asynchronously until the Stripe webhook
    // notifies us that the invoice was created; at that point, we'll have
    // advanced the account.contract to recurring and we can safely tell the
    // user to reload the page.
    _this.waitingForFinalization = true;

    if (_this.method == 'cc' || _this.method == 'ach') {
      _this.waitingForFinalization = false;
      return;
    }

    if (startWaitForFinalization === null) {
      startWaitForFinalization = Date.now();
    }

    if (Date.now() - startWaitForFinalization > MAX_WAIT_FOR_FINALIZATION_MS) {
      console.warn('Timed out waiting for account finalization');
      _this.waitingForFinalization = false;
      return;
    }

    _this.account.refresh().then(function () {
      if (_this.account.contract == 'recurring') {
        _this.waitingForFinalization = false;
      } else {
        $timeout(function () {
          return _this.waitForFinalization();
        }, WAIT_FOR_FINALIZATION_INTERVAL_MS);
      }
    })["catch"](function (err) {
      console.warn('Error reloading account while waiting for finalization', err);
      $timeout(function () {
        return _this.waitForFinalization();
      }, WAIT_FOR_FINALIZATION_INTERVAL_MS);
    });
  };

  this.chatOrScheduleText = function () {
    if (window.Intercom) {
      return "Let's chat";
    } else {
      return 'Schedule a meeting';
    }
  };

  this.popChatOrSchedule = function () {
    if (window.Intercom) {
      window.Intercom('show');
    } else {
      _this.dismiss();

      MeetingsService.scheduleMeeting('Schedule time to discuss other plan options');
    }
  };

  this.schedule = function () {
    _this.dismiss();

    MeetingsService.scheduleMeeting('Schedule time to discuss other plan options');
  };

  this.validateCheckout = function () {
    var valid = true;
    valid = valid || Checkout.validateBillingAddress(_this.billing);

    if (_this.needsShipping) {
      valid = valid || Checkout.validateShippingAddress(_this.shipping);
    }

    return valid;
  };

  this.changeInterval = function (interval) {
    _this.selectedInterval = interval;

    if (interval == 'monthly') {
      _this.method = 'cc';
      _this.showAllPaymentOptions = false;
    } else {
      _this.showAllPaymentOptions = false;
    }
  };

  this.allowDefaultPaymentSourceOverride = function () {
    // `single_use` sources are only applicable to invoice-item-inly orders (no subscription plan changes)
    return !_this.hasSubscription && !_this.account.isTrialing();
  };

  this.requiresPaymentSource = function () {
    // Verify either card/bank on file, or they've created a new source, or they're manual billing
    if (_this.method == 'cc') {
      return false; //validation will be handled during submit if they explicitly opted to change to a credit card
    }

    return !(_this.cardOnFile || _this.bankOnFile || _this.stripeToken || _this.isPayingManually());
  };

  this.isChangingPaymentSource = function () {
    return _this.addNewCard || _this.addNewBankAccount || _this.method != _this.account.payment_method;
  };

  this.isPayingManually = function () {
    return _this.method == 'check' || _this.method == 'po';
  };

  this.checkPlanRequirements = function (requiredPlan) {
    if (requiredPlan == '' || requiredPlan == _this.selectedBasePlan) {
      return true;
    } else {
      return false;
    }
  };

  this.checkEncoderRequirements = function (requiredEncoder) {
    if (requiredEncoder.length < 1) {
      return true;
    } else if (_.contains(requiredEncoder, _this.selectedEncoder)) {
      return true;
    } else {
      return false;
    }
  };

  this.updateStoragePolicy = function () {
    if (_this.storagePolicy == _this.account.storage_policy) {
      _this.next();
    } else {
      Account.update({
        storage_policy: _this.storagePolicy
      }, function () {
        _this.next();
      });
    }
  };

  this.finishMigration = function () {
    var newAccountData = {
      status: 'active'
    };

    if (_this.storagePolicy != _this.account.storage_policy) {
      newAccountData.storage_policy = _this.storagePolicy;
    }

    Account.update(newAccountData, function (r) {
      $uibModalInstance.close(newAccountData);
      $rootScope.$emit('account-migrated', newAccountData);
    });
  };

  this.showDetails = false;
  this.togglePlan = 'essential';

  this.showPlanDetails = function (plan, isShowing) {
    if (_this.togglePlan == plan && isShowing) {
      _this.showDetails = false;
    } else {
      _this.showDetails = true;
    }

    _this.togglePlan = plan;
  };
}

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .btn-breadcrumb {\n      width: 100%;\n    }\n    .btn-breadcrumb .btn {\n      width: 25%;\n    }\n    .btn-breadcrumb .fa-check-circle {\n      font-size: 19px;\n      margin-right: 10px;\n      color: #1AA8A1;\n    }\n    .btn-smgreen{\n        background-color: #5CB85B;\n        color: #FFFFFF;\n    }\n    .btn-smgreen:hover{\n        color: #FFFFFF;\n    }\n    .btn-smgreen:active{\n        color: #FFFFFF;\n    }\n</style>\n\n    <div class=\"modal-header modal-checkout\">\n      <button type=\"button\" class=\"close\" ng-hide=\"vm.waitingForFinalization || vm.submittingCard || vm.submitting\" ng-click=\"vm.dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n      <h3 ng-hide=\"vm.isUpgrade\">Sign Up for BoxCast</h3>\n      <h3 ng-show=\"vm.isUpgrade && vm.step == 3\">Review Your Agreement</h3>\n      <h3 ng-show=\"vm.isUpgrade && vm.step == 4\">Confirm and Submit</h3>\n    </div>\n    \n    <div class=\"checkout-complete\">\n    <main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n    \n    <div class=\"modal-body modal-checkout row\" ng-if=\"vm.disallowCheckout\">\n      <div class=\"col-xs-12\" ng-if=\"vm.disallowCheckoutReason == 'outstanding_invoice'\">\n        <strong>You have an outstanding invoice<br></strong>\n        <div style=\"font-size:10pt\">\n          Please finalize payment for all outstanding invoices.\n          <a ng-click=\"vm.dismiss()\" ui-sref=\"settings.payment\">Visit the billing page for details</a>.\n        </div>\n      </div>\n      <div ng-if=\"vm.disallowCheckoutReason == 'already_converted'\">\n        <strong>Your account has already transitioned<br></strong>\n        <div style=\"font-size:10pt\">\n          It looks like your account has already transitioned to BoxCast.  Happy streaming!\n        </div>\n      </div>\n    </div>\n    \n    <div class=\"modal-body modal-checkout row\" ng-if=\"!vm.disallowCheckout\">\n        <div class=\"col-xs-12\" style=\"margin-bottom:15px\" ng-if=\"vm.step != 5\">\n          <div class=\"btn-group btn-breadcrumb\">\n                <button ng-hide=\"vm.isUpgrade\" type=\"button\" class=\"btn btn-lg btn-default\" ng-class=\"{active: vm.step == 1}\" ng-click=\"vm.goto(1)\"><i class=\"fa fa-check-circle\" ng-show=\"vm.step > 1\"></i>Plan</button>\n                <button ng-hide=\"vm.isUpgrade\" type=\"button\" class=\"btn btn-lg btn-default\" ng-class=\"{active: vm.step == 2}\" ng-click=\"vm.goto(2)\"><i class=\"fa fa-check-circle\" ng-show=\"vm.step > 2\"></i>Agreement</button>\n                <button type=\"button\" class=\"btn btn-lg btn-default\" ng-class=\"{active: vm.step == 3}\" ng-click=\"\"><i class=\"fa fa-check-circle\" ng-show=\"vm.step > 3\"></i>Payment</button>\n                <button ng-hide=\"vm.isUpgrade\" type=\"button\" class=\"btn btn-lg btn-default\" ng-class=\"{active: vm.step == 4}\" ng-click=\"vm.goto(4)\"><i class=\"fa fa-check-circle\" ng-show=\"vm.step > 4\"></i>Storage</button>\n            </div>\n        </div>\n    \n      <div ng-if=\"vm.step == 1\" class=\"col-xs-12\">\n        <p class=\"help-block\">\n          Each plan requires an annual commitment and includes our free Broadcaster app for iOS.\n        </p>\n\n        <div ng-hide=\"vm.isLoading\" class=\"pricing-table-row\">\n          <div class=\"pricing-col\">\n              <!-- What vm.selectedBasePlan will be for streammoneky users?-->\n            <div style=\"overflow: hidden;\">\n              <!--What plan name for stream monkey users?-->\n              <h3>Your Customized Plan</h3>\n              <div class=\"price\" style=\"font-weight:100; font-size: 12pt; margin-top:0px; border-top:0px;\">\n                ${{vm.streamMonkeyTotalPriceEstimate() | number:0}}/{{vm.interval}}\n              </div>\n              <div class=\"subtitle text-left\">Based on your Stream Monkey plan, we've crafted a custom package just for you!</div>\n\n              <div class=\"row text-left\" ng-if=\"vm.planName\">\n                <div ng-repeat=\"label in ::vm.selectedPlanFeatureSummaryList()\" class=\"col-sm-4\">{{label}}</div>\n              </div>\n          </div>\n        <div class=\"subtext alert alert-danger\" ng-if=\"!vm.planCompatibleWithSelections\" role=\"alert\">\n          <div>The <span style=\"text-transform: capitalize\">{{ vm.selectedBasePlan }}</span> Plan is incompatible with 1 or more selected Add-Ons. Clicking the Continue button will reset your Add-On selections.</div>\n        </div>\n          </div>\n        </div>\n      </div><!--/step 1-->\n    \n      <!-- step 2 -->\n      <div ng-if=\"vm.step == 2\">\n        <div class=\"col-sm-12\">\n          <div class=\"row\">\n            <div class=\"col-sm-10 col-sm-offset-1\">\n              <div ng-if=\"vm.isLoadingProposal\" style=\"margin-top:30px;height:400px\">\n                <i class=\"fa fa-spin fa-spinner\"></i> One moment while we finalize your quote...\n              </div>\n              <div ng-if=\"!vm.isLoadingProposal && vm.pandadocError\">\n                <div class=\"bg-warning text-warning\" style=\"margin:15px 0;padding:10px;border:1px solid;\">\n                  <span>\n                    An unknown error occurred while attempting to finalize your quote.\n                    Please contact <a href=\"mailto:questions@boxcast.com\">questions@boxcast.com</a> for assistance in completing\n                    your account setup.\n                  </span>\n                </div>\n              </div>\n              <div ng-if=\"!vm.pandadocError && !vm.isLoadingProposal && vm.currentUpgrade && vm.currentUpgrade.share_id\">\n                <iframe ng-src=\"{{'https://app.pandadoc.com/s/' + vm.currentUpgrade.share_id | trustedUrl}}\"\n                  frameBorder=\"0\"\n                  style=\"height:800px;max-height:calc(65vh);width:800px;max-width:100%;\">\n                </iframe>\n              </div>\n              <div ng-show=\"!vm.pandadocError && !vm.isLoadingProposal && !vm.currentUpgrade\">\n                <div class=\"bg-warning text-warning\" style=\"margin:15px 0;padding:10px;border:1px solid;\">\n                  <p>This proposal has already been completed or no longer exists.</p>\n                  <p><a href=\"javascript://\" ng-click=\"vm.dismiss()\">Return to Billing Settings</a></p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div><!--/step 2-->\n    \n      <div ng-if=\"vm.step == 3\">\n        <div class=\"col-xs-12\">\n          <div class=\"row\">\n            <div class=\"col-xs-7\" style=\"padding:0 25px 0 50px;\">\n              <h3>Payment Method</h3>\n              <checkout-payment-method vm=\"vm\"></checkout-payment-method>\n    \n              <h3>Billing Address</h3>\n              <checkout-billing-address vm=\"vm\"></checkout-billing-address>\n    \n              <div ng-if=\"vm.needsShipping\">\n                <p>&nbsp;</p>\n                <h3>Shipping Address</h3>\n                <checkout-shipping-address vm=\"vm\"></checkout-shipping-address>\n              </div>\n            </div>\n            <div class=\"col-xs-5\" style=\"padding-right:50px;border-left: 6px #eee solid;\">\n              <h3>Payment Details</h3>\n              <div style=\"border: 1px #ddd solid; border-radius:4px;padding:10px;margin-top:10px\">\n              <h4>Due Today</h4>\n              <table class=\"table\" style=\"margin-bottom:0\">\n                <tbody>\n                  <tr ng-repeat=\"item in vm.dueNow\">\n                    <th>\n                      {{item.name}}\n                      <br><small class=\"text-bx-accessible-grey\" ng-if=\"item.description\" style=\"font-weight:normal; font-size:12px;\">\n                        {{item.description}}\n                      </small>\n                    </th>\n                    <td class=\"text-right\" ng-class=\"item.amount_cents < 0 ? 'text-success' : ''\">\n                      {{item.amount_cents / 100 | currency}}\n                    </td>\n                  </tr>\n                  <tr ng-if=\"vm.salesTaxCents > 0\">\n                    <th>Sales Tax</th>\n                    <td class=\"text-right\">{{ vm.salesTaxCents / 100 | currency }}</td>\n                  </tr>\n                  <tr ng-if=\"vm.appliedCredit > 0\">\n                    <th>\n                      Account Credit\n                    </th>\n                    <td class=\"text-right text-success\">\n                      -{{(vm.appliedCredit / 100) | currency}}\n                    </td>\n                  </tr>\n                </tbody>\n                <tfoot>\n                  <tr>\n                    <th>Total Due Today</th>\n                    <td class=\"text-right\" ng-class=\"vm.calculateTotalToday() == 0 ? 'text-success' : ''\">\n                      <b>{{vm.calculateTotalToday() | currency }}</b>\n                    </td>\n                  </tr>\n                </tfoot>\n              </table>\n              </div>\n              <div ng-show=\"vm.newInterval\" class=\"bg-info text-info\" style=\"padding:15px;border-radius:4px;margin-top:20px;\">\n                <div ng-show=\"vm.remainingCredit > 0\">\n                  Your BoxCast account will be credited with <strong>{{vm.remainingCredit / 100 | currency}}</strong>. This credit is not refundable and will be\n                  applied to future charges.\n                </div>\n                <span ng-hide=\"vm.newInterval == 'year'\">\n                  Your next monthly payment will be\n                </span>\n                <span ng-show=\"vm.newInterval == 'year'\">\n                  Your subscription will automatically renew\n                </span>\n                on <span style=\"white-space:nowrap;\"><strong>{{vm.nextDueOn | date}}</strong></span> for\n                <strong>{{vm.calculateNextDue() | currency}}</strong>.\n              </div>\n              <div class=\"text-center\" style=\"margin-top:50px\">\n                <div ng-if=\"vm.checkoutError\" class=\"bg-danger text-danger\" style=\"border-radius:4px;padding:15px;margin-bottom:15px\">\n                  {{vm.checkoutError}}\n                </div>\n                <button type=\"button\" style=\"font-weight:bold\"\n                        ng-disabled=\"vm.submittingCard || vm.submitting\"\n                        ng-click=\"vm.completeCheckout()\"\n                        class=\"btn btn-block btn-smgreen btn-lg\"\n                                            analytics-on analytics-category=\"free-trial-convert\" analytics-event=\"submit\" analytics-label=\"\"\n                                            >\n                  <span ng-hide=\"vm.submittingCard || vm.submitting\">Submit</span>\n                  <span ng-show=\"vm.submittingCard || vm.submitting\"><i class=\"fa fa-spin fa-spinner\"></i> Submitting</span>\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div><!--/step 3-->\n\n      <!-- step 4 -->\n      <div ng-if=\"vm.step == 4\" class=\"col-xs-12\">\n        <p class=\"help-block\">\n          Choose Storage Policy <a href=\"https://support.boxcast.com/en/articles/4235217-storage-billing-policy\" target=\"_blank\">(storage billing policy)</a>\n        </p>\n        \n        <label for=\"storagePolicyRadio1\" class=\"sm-storagePolicy\">\n          <div class=\"sm-storagePolicy__input\">\n            <input\n                class=\"form-check-input\"\n                type=\"radio\"\n                name=\"storagePolicy\"\n                id=\"storagePolicyRadio1\"\n                ng-value=\"'auto-bill'\"\n                ng-model=\"vm.storagePolicy\">\n          </div>\n          <div class=\"sm-storagePolicy__message\">\n            <p><strong>Auto-Bill</strong></p>\n            <p>Automatically store all recordings and charge for recordings kept longer than 1 year</p>\n          </div>\n          <div class=\"sm-storagePolicy__price\">\n            <p><strong>$0.49/hr.</strong></p>\n          </div>\n        </label>\n        \n        <label for=\"storagePolicyRadio2\" class=\"sm-storagePolicy\">\n          <div class=\"sm-storagePolicy__input\">\n            <input\n              class=\"form-check-input\"\n              type=\"radio\"\n              name=\"storagePolicy\"\n              id=\"storagePolicyRadio2\"\n              ng-value=\"'auto-delete'\"\n              ng-model=\"vm.storagePolicy\">\n          </div>\n          <div class=\"sm-storagePolicy__message\">\n            <p><strong>Auto-Delete</strong></p>\n            <p>Automatically delete all recordings stored longer than 1 year</p>\n          </div>\n        </label>\n      </div><!--/step 4-->\n    \n    \n    </div><!--/.modal-body-->\n    \n    <div class=\"modal-footer\">\n      <p ng-show=\"vm.step == 1 && !vm.disallowCheckout\" class=\"text-left pull-left\">\n        Need more than these plans offer? <a href=\"javascript://\" ng-click=\"vm.popChatOrSchedule()\" analytics-on analytics-category=\"free-trial-convert\" analytics-event=\"click-help\" analytics-label=\"step1\">{{vm.chatOrScheduleText()}}.</a>\n      </p>\n      <p ng-show=\"vm.step == 2\" class=\"text-left pull-left\">\n        Have a question about your agreement? <a href=\"javascript://\" ng-click=\"vm.popChatOrSchedule()\" analytics-on analytics-category=\"free-trial-convert\" analytics-event=\"click-help\" analytics-label=\"step2\">{{vm.chatOrScheduleText()}}.</a>\n      </p>\n      <p ng-show=\"vm.step == 3\" class=\"text-left pull-left\">\n        Have a question about payment? <a href=\"javascript://\" ng-click=\"vm.popChatOrSchedule()\" analytics-on analytics-category=\"free-trial-convert\" analytics-event=\"click-help\" analytics-label=\"step2\">{{vm.chatOrScheduleText()}}.</a>\n      </p>\n    \n      <span class=\"text-right\" ng-hide=\"vm.step >= 4\">\n        <button style=\"padding: 6px 15px\" ng-show=\"vm.step !== 1 && vm.step < 6\" type=\"button\" ng-click=\"vm.prev();\" class=\"btn btn-default back-button\"><i class=\"fa fa-caret-left\"></i> Back</button>\n      </span>\n      <span class=\"text-right\" ng-hide=\"vm.step == 2 && !vm.isPandadocCompleted()\">\n        <button style=\"font-weight:bold; padding: 6px 55px\" ng-show=\"vm.step == 1 && !vm.disallowCheckout\" type=\"button\" ng-click=\"vm.next(); vm.createProposalIfNecessary();\" class=\"btn btn-smgreen\" analytics-on analytics-category=\"free-trial-convert\" analytics-event=\"continue\" analytics-label=\"step1\">Continue</button>\n        <button style=\"font-weight:bold; padding: 6px 55px\" ng-show=\"vm.step == 2\" type=\"button\" ng-click=\"vm.next();\" class=\"btn btn-smgreen\" analytics-on analytics-category=\"free-trial-convert\" analytics-event=\"continue\" analytics-label=\"step2\">Continue</button>\n        <button style=\"font-weight:bold; padding: 6px 55px\" ng-show=\"!vm.disallowCheckout && vm.step == 4 && !vm.pandadocError\" type=\"button\" ng-click=\"vm.finishMigration()\" class=\"btn btn-smgreen\" analytics-on analytics-category=\"free-trial-convert\" analytics-event=\"continue\" analytics-label=\"step4\">Finish</button>\n        <button style=\"font-weight:bold; padding: 6px 55px\" ng-show=\"vm.disallowCheckout\" type=\"button\"  ng-click=\"vm.dismiss()\" class=\"btn btn-smgreen\">Exit</button>\n      </span>\n    </div>\n    \n    </main>\n    </div><!--/.checkout-complete-->\n    "

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3>Order Status</h3>\n</div>\n<div class=\"modal-body row order-status-modal\" style=\"text-align:center\">\n  <div class=\"col-xs-12\" ng-show=\"vm.error\" style=\"padding:20px;\">\n    There was an error retrieving your order status. Please contact <a href=\"mailto:questions@boxcast.com\">questions@boxcast.com</a>\n    for assistance with checking your order status. \n  </div>\n\n  <div class=\"col-xs-12\" ng-show=\"vm.loading\" style=\"height:200px;margin-top:100px\">\n    <i class=\"fa fa-spin fa-spinner\"></i> Loading...\n  </div>\n\n  <div class=\"col-xs-12\" ng-if=\"!vm.error && !vm.loading\">\n    <table class=\"order-status\" align=\"center\">\n      <tr>\n        <td class=\"icon\">\n          <img src=\"/img/green_order_placed_icon.png\">\n        </td>\n        <td class=\"line\" >\n          <img ng-hide=\"vm.orderShipped\" src=\"/img/blue_dashed_line.png\">\n          <div ng-show=\"vm.orderShipped\">\n        </td>\n        <td class=\"icon\">\n          <img ng-hide=\"vm.orderShipped\" src=\"/img/blue_est_order_shipped_icon.png\">\n          <img ng-show=\"vm.orderShipped\" src=\"/img/green_order_shipped_icon.png\"\n        </td>\n        <td class=\"line\" >\n          <img src=\"/img/blue_dashed_line.png\">\n        </td>\n        <td class=\"icon\">\n          <img src=\"/img/blue_est_delivery_icon.png\">\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"form-group\">\n            <label>Order Placed</label><br>\n            {{vm.order.created_at | date}}\n          <div class=\"form-group\">\n        </td>\n        <td></td>\n        <td>\n          <div class=\"form-group\">\n            <label ng-hide=\"vm.orderShipped\">Shipping</label>\n            <label ng-show=\"vm.orderShipped\">Order Shipped</label><br>\n            <span ng-if=\"vm.orderShipped\">{{vm.order.ship_date | date}}</span>\n          </div>\n        </td>\n        <td></td>\n        <td>\n          <div class=\"form-group\">\n            <label>Delivery</label><br>\n            <a ng-if=\"vm.orderShipped\" ng-href=\"{{vm.trackingLink()}}\" target=\"_blank\">Track Package</a>\n          </div>\n        </td>\n      </tr>\n    </table>\n\n    <div class=\"row order-info\" style=\"margin-top:30px;padding-left:20px\">\n      <div class=\"col-xs-3\">\n        <div class=\"form-group\">\n          <label>Payment</label><br>\n          <span ng-show=\"vm.paid\" class=\"label label-success\">Payment Received</span>\n          <span ng-hide=\"vm.paid\" class=\"label label-warning\">\n            Awaiting Payment\n            <i ng-show=\"vm.account.payment_method == 'check'\" class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\" uib-tooltip=\"We are waiting on your check payment\"></i>\n            <i ng-show=\"vm.account.payment_method == 'po'\" class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\" uib-tooltip=\"We are waiting on your purchase order\"></i>\n            <i ng-show=\"vm.account.payment_method == 'ach'\" class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\" uib-tooltip=\"We are waiting for your ACH payment to clear\"></i>\n          </span>\n        </div>\n        <div ng-show=\"vm.orderShipped\" class=\"form-group\" style=\"margin-top:20px;word-wrap: break-word;\">\n          <label>Tracking Number</label>\n          <a ng-if=\"vm.orderShipped\" ng-href=\"{{vm.trackingLink()}}\" target=\"_blank\">{{vm.order.tracking_number}}</a>\n        </div>\n      </div>\n      <div class=\"col-xs-3\">\n        <div class=\"form-group\">\n          <label>Order Status</label><br>\n          <span ng-show=\"vm.backordered\" class=\"label label-danger\">\n            Backordered\n            <i class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\" uib-tooltip=\"You are currently on our waitlist\"></i>\n          </span>\n          <span ng-show=\"!vm.backordered && vm.paid\" class=\"label label-success\">Filled</span>\n        </div>\n        <div ng-if=\"vm.orderShipped\" class=\"form-group\" style=\"margin-top:20px;text-transform:capitalize;\">\n          <label>Service</label><br>\n          {{vm.order.service_code}}\n        </div>\n      </div>\n      <div class=\"col-xs-3\" style=\"text-align:left;\">\n        <div class=\"form-group\">\n          <label ng-hide=\"vm.orderShipped\">Shipping Address</label>\n          <label ng-show=\"vm.orderShipped\">Shipped To</label>\n          <small>\n            <div style=\"margin-bottom:5px\">{{vm.order.ship_to.name}}</div>\n            <div ng-show=\"vm.order.ship_to.company\" style=\"margin-bottom:5px\">{{vm.order.ship_to.company}}</div>\n            <div>{{vm.order.ship_to.line1}}</div>\n            <div>{{vm.order.ship_to.city}}, {{vm.order.ship_to.state}} {{vm.order.ship_to.postal_code}}</div>\n          </small>\n        </div>\n      </div>\n      <div class=\"col-xs-3\" style=\"text-align:left;padding-left:5px\">\n        <div class=\"form-group\">\n          <label ng-hide=\"vm.orderShipped\">Order Items</label>\n          <label ng-show=\"vm.orderShipped\">Items Shipped</label>\n          <div ng-repeat=\"item in vm.order.items\">\n            <small>{{item.quantity}} &#8212; {{item.name}}</small>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div ng-show=\"vm.showOrdersLink\" style=\"margin-top:25px\">\n      <a href=\"javascript://\" ng-click=\"vm.viewAllOrders()\">View all orders <i class=\"fa fa-caret-right\"></i></a>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalOrderStatus;
function ModalOrderStatus($uibModalInstance, $analytics, $state, Order, order, account, showOrdersLink) {
  'ngInject';

  var _this = this;

  this.orderId = order.id;
  this.account = account;
  this.showOrdersLink = showOrdersLink;
  this.$analytics = $analytics;
  this.loading = true;
  Order.get({
    id: this.orderId
  }).$promise.then(function (result) {
    _this.order = result;
  })["catch"](function (err) {
    console.error(err);
    _this.error = true;
  })["finally"](function () {
    _this.paid = false;
    _this.backordered = false;
    _this.orderShipped = false;
    _this.error = false;

    if (_this.order.status == 'awaiting_payment') {// no changes
    } else if (_this.order.status == 'on_hold') {
      _this.paid = true;
      _this.backordered = true;
    } else if (_this.order.status == 'awaiting_shipment') {
      _this.paid = true;
    } else if (_this.order.status == 'shipped') {
      _this.paid = true;
      _this.orderShipped = true;
      _this.order.service_code = _this.order.service_code.replace(/_/g, ' ');
    } else {
      _this.error = true;
    }

    _this.loading = false;
  });

  this.trackingLink = function () {
    switch (_this.order.carrier_code) {
      case 'fedex':
        return "https://www.fedex.com/apps/fedextrack/index.html?tracknumbers=".concat(_this.order.tracking_number);

      case 'stamps_com':
        return "https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=".concat(_this.order.tracking_number);

      case 'dhl_express':
        return "https://www.dhl.com/content/g0/en/express/tracking.shtml?AWB=".concat(_this.order.tracking_number, "&brand=DHL");
    }
  };

  this.viewAllOrders = function () {
    $uibModalInstance.dismiss('cancel');
    $state.go('settings.payment', {
      show_orders: true
    });

    _this.$analytics.eventTrack("view-all-orders", {
      category: 'open',
      label: ''
    });
  };

  this.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = initializeOptions;
/* harmony export (immutable) */ __webpack_exports__["c"] = parseOptions;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTimeset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rrule__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__weekday__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datetime__ = __webpack_require__(46);







function initializeOptions(options) {
    var invalid = [];
    var keys = Object.keys(options);
    // Shallow copy for options and origOptions and check for invalid
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* includes */])(__WEBPACK_IMPORTED_MODULE_3__rrule__["d" /* defaultKeys */], key))
            invalid.push(key);
        if (__WEBPACK_IMPORTED_MODULE_4__dateutil__["b" /* default */].isDate(options[key]) && !__WEBPACK_IMPORTED_MODULE_4__dateutil__["b" /* default */].isValidDate(options[key]))
            invalid.push(key);
    }
    if (invalid.length) {
        throw new Error('Invalid options: ' + invalid.join(', '));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options);
}
function parseOptions(options) {
    var opts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, __WEBPACK_IMPORTED_MODULE_3__rrule__["a" /* DEFAULT_OPTIONS */]), initializeOptions(options));
    if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.byeaster))
        opts.freq = __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].YEARLY;
    if (!(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.freq) && __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].FREQUENCIES[opts.freq])) {
        throw new Error("Invalid frequency: " + opts.freq + " " + options.freq);
    }
    if (!opts.dtstart)
        opts.dtstart = new Date(new Date().setMilliseconds(0));
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.wkst)) {
        opts.wkst = __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].MO.weekday;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["e" /* isNumber */])(opts.wkst)) {
        // cool, just keep it like that
    }
    else {
        opts.wkst = opts.wkst.weekday;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.bysetpos)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["e" /* isNumber */])(opts.bysetpos))
            opts.bysetpos = [opts.bysetpos];
        for (var i = 0; i < opts.bysetpos.length; i++) {
            var v = opts.bysetpos[i];
            if (v === 0 || !(v >= -366 && v <= 366)) {
                throw new Error('bysetpos must be between 1 and 366,' + ' or between -366 and -1');
            }
        }
    }
    if (!(Boolean(opts.byweekno) ||
        Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["h" /* notEmpty */])(opts.byweekno) ||
        Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["h" /* notEmpty */])(opts.byyearday) ||
        Boolean(opts.bymonthday) ||
        Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["h" /* notEmpty */])(opts.bymonthday) ||
        Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.byweekday) ||
        Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.byeaster))) {
        switch (opts.freq) {
            case __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].YEARLY:
                if (!opts.bymonth)
                    opts.bymonth = opts.dtstart.getUTCMonth() + 1;
                opts.bymonthday = opts.dtstart.getUTCDate();
                break;
            case __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].MONTHLY:
                opts.bymonthday = opts.dtstart.getUTCDate();
                break;
            case __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].WEEKLY:
                opts.byweekday = [__WEBPACK_IMPORTED_MODULE_4__dateutil__["b" /* default */].getWeekday(opts.dtstart)];
                break;
        }
    }
    // bymonth
    if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.bymonth) && !Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* isArray */])(opts.bymonth)) {
        opts.bymonth = [opts.bymonth];
    }
    // byyearday
    if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.byyearday) &&
        !Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* isArray */])(opts.byyearday) &&
        Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["e" /* isNumber */])(opts.byyearday)) {
        opts.byyearday = [opts.byyearday];
    }
    // bymonthday
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.bymonthday)) {
        opts.bymonthday = [];
        opts.bynmonthday = [];
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* isArray */])(opts.bymonthday)) {
        var bymonthday = [];
        var bynmonthday = [];
        for (var i = 0; i < opts.bymonthday.length; i++) {
            var v = opts.bymonthday[i];
            if (v > 0) {
                bymonthday.push(v);
            }
            else if (v < 0) {
                bynmonthday.push(v);
            }
        }
        opts.bymonthday = bymonthday;
        opts.bynmonthday = bynmonthday;
    }
    else if (opts.bymonthday < 0) {
        opts.bynmonthday = [opts.bymonthday];
        opts.bymonthday = [];
    }
    else {
        opts.bynmonthday = [];
        opts.bymonthday = [opts.bymonthday];
    }
    // byweekno
    if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.byweekno) && !Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* isArray */])(opts.byweekno)) {
        opts.byweekno = [opts.byweekno];
    }
    // byweekday / bynweekday
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.byweekday)) {
        opts.bynweekday = null;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["e" /* isNumber */])(opts.byweekday)) {
        opts.byweekday = [opts.byweekday];
        opts.bynweekday = null;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["g" /* isWeekdayStr */])(opts.byweekday)) {
        opts.byweekday = [__WEBPACK_IMPORTED_MODULE_5__weekday__["b" /* Weekday */].fromStr(opts.byweekday).weekday];
        opts.bynweekday = null;
    }
    else if (opts.byweekday instanceof __WEBPACK_IMPORTED_MODULE_5__weekday__["b" /* Weekday */]) {
        if (!opts.byweekday.n || opts.freq > __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].MONTHLY) {
            opts.byweekday = [opts.byweekday.weekday];
            opts.bynweekday = null;
        }
        else {
            opts.bynweekday = [[opts.byweekday.weekday, opts.byweekday.n]];
            opts.byweekday = null;
        }
    }
    else {
        var byweekday = [];
        var bynweekday = [];
        for (var i = 0; i < opts.byweekday.length; i++) {
            var wday = opts.byweekday[i];
            if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["e" /* isNumber */])(wday)) {
                byweekday.push(wday);
                continue;
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["g" /* isWeekdayStr */])(wday)) {
                byweekday.push(__WEBPACK_IMPORTED_MODULE_5__weekday__["b" /* Weekday */].fromStr(wday).weekday);
                continue;
            }
            if (!wday.n || opts.freq > __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].MONTHLY) {
                byweekday.push(wday.weekday);
            }
            else {
                bynweekday.push([wday.weekday, wday.n]);
            }
        }
        opts.byweekday = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["h" /* notEmpty */])(byweekday) ? byweekday : null;
        opts.bynweekday = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["h" /* notEmpty */])(bynweekday) ? bynweekday : null;
    }
    // byhour
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.byhour)) {
        opts.byhour =
            opts.freq < __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].HOURLY ? [opts.dtstart.getUTCHours()] : null;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["e" /* isNumber */])(opts.byhour)) {
        opts.byhour = [opts.byhour];
    }
    // byminute
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.byminute)) {
        opts.byminute =
            opts.freq < __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].MINUTELY ? [opts.dtstart.getUTCMinutes()] : null;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["e" /* isNumber */])(opts.byminute)) {
        opts.byminute = [opts.byminute];
    }
    // bysecond
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(opts.bysecond)) {
        opts.bysecond =
            opts.freq < __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].SECONDLY ? [opts.dtstart.getUTCSeconds()] : null;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["e" /* isNumber */])(opts.bysecond)) {
        opts.bysecond = [opts.bysecond];
    }
    return { parsedOptions: opts };
}
function buildTimeset(opts) {
    var millisecondModulo = opts.dtstart.getTime() % 1000;
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__types__["b" /* freqIsDailyOrGreater */])(opts.freq)) {
        return [];
    }
    var timeset = [];
    opts.byhour.forEach(function (hour) {
        opts.byminute.forEach(function (minute) {
            opts.bysecond.forEach(function (second) {
                timeset.push(new __WEBPACK_IMPORTED_MODULE_6__datetime__["b" /* Time */](hour, minute, second, millisecondModulo));
            });
        });
    });
    return timeset;
}
//# sourceMappingURL=parseoptions.js.map

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseString;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseDtstart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__weekday__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rrule__ = __webpack_require__(11);





function parseString(rfcString) {
    var options = rfcString.split('\n').map(parseLine).filter(function (x) { return x !== null; });
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options[0]), options[1]);
}
function parseDtstart(line) {
    var options = {};
    var dtstartWithZone = /DTSTART(?:;TZID=([^:=]+?))?(?::|=)([^;\s]+)/i.exec(line);
    if (!dtstartWithZone) {
        return options;
    }
    var _ = dtstartWithZone[0], tzid = dtstartWithZone[1], dtstart = dtstartWithZone[2];
    if (tzid) {
        options.tzid = tzid;
    }
    options.dtstart = __WEBPACK_IMPORTED_MODULE_3__dateutil__["b" /* default */].untilStringToDate(dtstart);
    return options;
}
function parseLine(rfcString) {
    rfcString = rfcString.replace(/^\s+|\s+$/, '');
    if (!rfcString.length)
        return null;
    var header = /^([A-Z]+?)[:;]/.exec(rfcString.toUpperCase());
    if (!header) {
        return parseRrule(rfcString);
    }
    var _ = header[0], key = header[1];
    switch (key.toUpperCase()) {
        case 'RRULE':
        case 'EXRULE':
            return parseRrule(rfcString);
        case 'DTSTART':
            return parseDtstart(rfcString);
        default:
            throw new Error("Unsupported RFC prop " + key + " in " + rfcString);
    }
}
function parseRrule(line) {
    var strippedLine = line.replace(/^RRULE:/i, '');
    var options = parseDtstart(strippedLine);
    var attrs = line.replace(/^(?:RRULE|EXRULE):/i, '').split(';');
    attrs.forEach(function (attr) {
        var _a = attr.split('='), key = _a[0], value = _a[1];
        switch (key.toUpperCase()) {
            case 'FREQ':
                options.freq = __WEBPACK_IMPORTED_MODULE_1__types__["a" /* Frequency */][value.toUpperCase()];
                break;
            case 'WKST':
                options.wkst = __WEBPACK_IMPORTED_MODULE_4__rrule__["b" /* Days */][value.toUpperCase()];
                break;
            case 'COUNT':
            case 'INTERVAL':
            case 'BYSETPOS':
            case 'BYMONTH':
            case 'BYMONTHDAY':
            case 'BYYEARDAY':
            case 'BYWEEKNO':
            case 'BYHOUR':
            case 'BYMINUTE':
            case 'BYSECOND':
                var num = parseNumber(value);
                var optionKey = key.toLowerCase();
                // @ts-ignore
                options[optionKey] = num;
                break;
            case 'BYWEEKDAY':
            case 'BYDAY':
                options.byweekday = parseWeekday(value);
                break;
            case 'DTSTART':
            case 'TZID':
                // for backwards compatibility
                var dtstart = parseDtstart(line);
                options.tzid = dtstart.tzid;
                options.dtstart = dtstart.dtstart;
                break;
            case 'UNTIL':
                options.until = __WEBPACK_IMPORTED_MODULE_3__dateutil__["b" /* default */].untilStringToDate(value);
                break;
            case 'BYEASTER':
                options.byeaster = Number(value);
                break;
            default:
                throw new Error("Unknown RRULE property '" + key + "'");
        }
    });
    return options;
}
function parseNumber(value) {
    if (value.indexOf(',') !== -1) {
        var values = value.split(',');
        return values.map(parseIndividualNumber);
    }
    return parseIndividualNumber(value);
}
function parseIndividualNumber(value) {
    if (/^[+-]?\d+$/.test(value)) {
        return Number(value);
    }
    return value;
}
function parseWeekday(value) {
    var days = value.split(',');
    return days.map(function (day) {
        if (day.length === 2) {
            // MO, TU, ...
            return __WEBPACK_IMPORTED_MODULE_4__rrule__["b" /* Days */][day]; // wday instanceof Weekday
        }
        // -1MO, +3FR, 1SO, 13TU ...
        var parts = day.match(/^([+-]?\d{1,2})([A-Z]{2})$/);
        var n = Number(parts[1]);
        var wdaypart = parts[2];
        var wday = __WEBPACK_IMPORTED_MODULE_4__rrule__["b" /* Days */][wdaypart].weekday;
        return new __WEBPACK_IMPORTED_MODULE_2__weekday__["b" /* Weekday */](wday, n);
    });
}
//# sourceMappingURL=parsestring.js.map

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optionsToString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rrule__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__weekday__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datewithzone__ = __webpack_require__(47);





function optionsToString(options) {
    var rrule = [];
    var dtstart = '';
    var keys = Object.keys(options);
    var defaultKeys = Object.keys(__WEBPACK_IMPORTED_MODULE_0__rrule__["a" /* DEFAULT_OPTIONS */]);
    for (var i = 0; i < keys.length; i++) {
        if (keys[i] === 'tzid')
            continue;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* includes */])(defaultKeys, keys[i]))
            continue;
        var key = keys[i].toUpperCase();
        var value = options[keys[i]];
        var outValue = '';
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["f" /* isPresent */])(value) || (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* isArray */])(value) && !value.length))
            continue;
        switch (key) {
            case 'FREQ':
                outValue = __WEBPACK_IMPORTED_MODULE_0__rrule__["c" /* default */].FREQUENCIES[options.freq];
                break;
            case 'WKST':
                if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["e" /* isNumber */])(value)) {
                    outValue = new __WEBPACK_IMPORTED_MODULE_2__weekday__["b" /* Weekday */](value).toString();
                }
                else {
                    outValue = value.toString();
                }
                break;
            case 'BYWEEKDAY':
                /*
                NOTE: BYWEEKDAY is a special case.
                RRule() deconstructs the rule.options.byweekday array
                into an array of Weekday arguments.
                On the other hand, rule.origOptions is an array of Weekdays.
                We need to handle both cases here.
                It might be worth change RRule to keep the Weekdays.
      
                Also, BYWEEKDAY (used by RRule) vs. BYDAY (RFC)
      
                */
                key = 'BYDAY';
                outValue = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["n" /* toArray */])(value).map(function (wday) {
                    if (wday instanceof __WEBPACK_IMPORTED_MODULE_2__weekday__["b" /* Weekday */]) {
                        return wday;
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* isArray */])(wday)) {
                        return new __WEBPACK_IMPORTED_MODULE_2__weekday__["b" /* Weekday */](wday[0], wday[1]);
                    }
                    return new __WEBPACK_IMPORTED_MODULE_2__weekday__["b" /* Weekday */](wday);
                }).toString();
                break;
            case 'DTSTART':
                dtstart = buildDtstart(value, options.tzid);
                break;
            case 'UNTIL':
                outValue = __WEBPACK_IMPORTED_MODULE_3__dateutil__["b" /* default */].timeToUntilString(value, !options.tzid);
                break;
            default:
                if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* isArray */])(value)) {
                    var strValues = [];
                    for (var j = 0; j < value.length; j++) {
                        strValues[j] = String(value[j]);
                    }
                    outValue = strValues.toString();
                }
                else {
                    outValue = String(value);
                }
        }
        if (outValue) {
            rrule.push([key, outValue]);
        }
    }
    var rules = rrule.map(function (_a) {
        var key = _a[0], value = _a[1];
        return key + "=" + value.toString();
    }).join(';');
    var ruleString = '';
    if (rules !== '') {
        ruleString = "RRULE:" + rules;
    }
    return [dtstart, ruleString].filter(function (x) { return !!x; }).join('\n');
}
function buildDtstart(dtstart, tzid) {
    if (!dtstart) {
        return '';
    }
    return 'DTSTART' + new __WEBPACK_IMPORTED_MODULE_4__datewithzone__["a" /* DateWithZone */](new Date(dtstart), tzid).toString();
}
//# sourceMappingURL=optionstostring.js.map

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iterinfo_index__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rrule__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parseoptions__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datewithzone__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__poslist__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__datetime__ = __webpack_require__(46);









function iter(iterResult, options) {
    var dtstart = options.dtstart, freq = options.freq, interval = options.interval, until = options.until, bysetpos = options.bysetpos;
    var count = options.count;
    if (count === 0 || interval === 0) {
        return emitResult(iterResult);
    }
    var counterDate = __WEBPACK_IMPORTED_MODULE_8__datetime__["a" /* DateTime */].fromDate(dtstart);
    var ii = new __WEBPACK_IMPORTED_MODULE_2__iterinfo_index__["a" /* default */](options);
    ii.rebuild(counterDate.year, counterDate.month);
    var timeset = makeTimeset(ii, counterDate, options);
    while (true) {
        var _a = ii.getdayset(freq)(counterDate.year, counterDate.month, counterDate.day), dayset = _a[0], start = _a[1], end = _a[2];
        var filtered = removeFilteredDays(dayset, start, end, ii, options);
        if (Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* notEmpty */])(bysetpos)) {
            var poslist = Object(__WEBPACK_IMPORTED_MODULE_7__poslist__["a" /* buildPoslist */])(bysetpos, timeset, start, end, ii, dayset);
            for (var j = 0; j < poslist.length; j++) {
                var res = poslist[j];
                if (until && res > until) {
                    return emitResult(iterResult);
                }
                if (res >= dtstart) {
                    var rezonedDate = rezoneIfNeeded(res, options);
                    if (!iterResult.accept(rezonedDate)) {
                        return emitResult(iterResult);
                    }
                    if (count) {
                        --count;
                        if (!count) {
                            return emitResult(iterResult);
                        }
                    }
                }
            }
        }
        else {
            for (var j = start; j < end; j++) {
                var currentDay = dayset[j];
                if (!Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["f" /* isPresent */])(currentDay)) {
                    continue;
                }
                var date = __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].fromOrdinal(ii.yearordinal + currentDay);
                for (var k = 0; k < timeset.length; k++) {
                    var time = timeset[k];
                    var res = __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].combine(date, time);
                    if (until && res > until) {
                        return emitResult(iterResult);
                    }
                    if (res >= dtstart) {
                        var rezonedDate = rezoneIfNeeded(res, options);
                        if (!iterResult.accept(rezonedDate)) {
                            return emitResult(iterResult);
                        }
                        if (count) {
                            --count;
                            if (!count) {
                                return emitResult(iterResult);
                            }
                        }
                    }
                }
            }
        }
        if (options.interval === 0) {
            return emitResult(iterResult);
        }
        // Handle frequency and interval
        counterDate.add(options, filtered);
        if (counterDate.year > __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].MAXYEAR) {
            return emitResult(iterResult);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* freqIsDailyOrGreater */])(freq)) {
            timeset = ii.gettimeset(freq)(counterDate.hour, counterDate.minute, counterDate.second, 0);
        }
        ii.rebuild(counterDate.year, counterDate.month);
    }
}
function isFiltered(ii, currentDay, options) {
    var bymonth = options.bymonth, byweekno = options.byweekno, byweekday = options.byweekday, byeaster = options.byeaster, bymonthday = options.bymonthday, bynmonthday = options.bynmonthday, byyearday = options.byyearday;
    return ((Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* notEmpty */])(bymonth) && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(bymonth, ii.mmask[currentDay])) ||
        (Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* notEmpty */])(byweekno) && !ii.wnomask[currentDay]) ||
        (Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* notEmpty */])(byweekday) && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(byweekday, ii.wdaymask[currentDay])) ||
        (Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* notEmpty */])(ii.nwdaymask) && !ii.nwdaymask[currentDay]) ||
        (byeaster !== null && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(ii.eastermask, currentDay)) ||
        ((Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* notEmpty */])(bymonthday) || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* notEmpty */])(bynmonthday)) &&
            !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(bymonthday, ii.mdaymask[currentDay]) &&
            !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(bynmonthday, ii.nmdaymask[currentDay])) ||
        (Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* notEmpty */])(byyearday) &&
            ((currentDay < ii.yearlen &&
                !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(byyearday, currentDay + 1) &&
                !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(byyearday, -ii.yearlen + currentDay)) ||
                (currentDay >= ii.yearlen &&
                    !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(byyearday, currentDay + 1 - ii.yearlen) &&
                    !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(byyearday, -ii.nextyearlen + currentDay - ii.yearlen)))));
}
function rezoneIfNeeded(date, options) {
    return new __WEBPACK_IMPORTED_MODULE_6__datewithzone__["a" /* DateWithZone */](date, options.tzid).rezonedDate();
}
function emitResult(iterResult) {
    return iterResult.getValue();
}
function removeFilteredDays(dayset, start, end, ii, options) {
    var filtered = false;
    for (var dayCounter = start; dayCounter < end; dayCounter++) {
        var currentDay = dayset[dayCounter];
        filtered = isFiltered(ii, currentDay, options);
        if (filtered)
            dayset[currentDay] = null;
    }
    return filtered;
}
function makeTimeset(ii, counterDate, options) {
    var freq = options.freq, byhour = options.byhour, byminute = options.byminute, bysecond = options.bysecond;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* freqIsDailyOrGreater */])(freq)) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__parseoptions__["a" /* buildTimeset */])(options);
    }
    if ((freq >= __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].HOURLY &&
        Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* notEmpty */])(byhour) &&
        !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(byhour, counterDate.hour)) ||
        (freq >= __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].MINUTELY &&
            Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* notEmpty */])(byminute) &&
            !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(byminute, counterDate.minute)) ||
        (freq >= __WEBPACK_IMPORTED_MODULE_3__rrule__["c" /* default */].SECONDLY &&
            Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* notEmpty */])(bysecond) &&
            !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* includes */])(bysecond, counterDate.second))) {
        return [];
    }
    return ii.gettimeset(freq)(counterDate.hour, counterDate.minute, counterDate.second, counterDate.millisecond);
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rrule__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__iterset__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rrulestr__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__optionstostring__ = __webpack_require__(222);







function createGetterSetter(fieldName) {
    var _this = this;
    return function (field) {
        if (field !== undefined) {
            _this["_" + fieldName] = field;
        }
        if (_this["_" + fieldName] !== undefined) {
            return _this["_" + fieldName];
        }
        for (var i = 0; i < _this._rrule.length; i++) {
            var field_1 = _this._rrule[i].origOptions[fieldName];
            if (field_1) {
                return field_1;
            }
        }
    };
}
var RRuleSet = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(RRuleSet, _super);
    /**
     *
     * @param {Boolean?} noCache
     *  The same stratagy as RRule on cache, default to false
     * @constructor
     */
    function RRuleSet(noCache) {
        if (noCache === void 0) { noCache = false; }
        var _this = _super.call(this, {}, noCache) || this;
        _this.dtstart = createGetterSetter.apply(_this, ['dtstart']);
        _this.tzid = createGetterSetter.apply(_this, ['tzid']);
        _this._rrule = [];
        _this._rdate = [];
        _this._exrule = [];
        _this._exdate = [];
        return _this;
    }
    RRuleSet.prototype._iter = function (iterResult) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__iterset__["a" /* iterSet */])(iterResult, this._rrule, this._exrule, this._rdate, this._exdate, this.tzid());
    };
    /**
     * Adds an RRule to the set
     *
     * @param {RRule}
     */
    RRuleSet.prototype.rrule = function (rrule) {
        _addRule(rrule, this._rrule);
    };
    /**
     * Adds an EXRULE to the set
     *
     * @param {RRule}
     */
    RRuleSet.prototype.exrule = function (rrule) {
        _addRule(rrule, this._exrule);
    };
    /**
     * Adds an RDate to the set
     *
     * @param {Date}
     */
    RRuleSet.prototype.rdate = function (date) {
        _addDate(date, this._rdate);
    };
    /**
     * Adds an EXDATE to the set
     *
     * @param {Date}
     */
    RRuleSet.prototype.exdate = function (date) {
        _addDate(date, this._exdate);
    };
    /**
     * Get list of included rrules in this recurrence set.
     *
     * @return List of rrules
     */
    RRuleSet.prototype.rrules = function () {
        return this._rrule.map(function (e) { return Object(__WEBPACK_IMPORTED_MODULE_5__rrulestr__["a" /* rrulestr */])(e.toString()); });
    };
    /**
     * Get list of excluded rrules in this recurrence set.
     *
     * @return List of exrules
     */
    RRuleSet.prototype.exrules = function () {
        return this._exrule.map(function (e) { return Object(__WEBPACK_IMPORTED_MODULE_5__rrulestr__["a" /* rrulestr */])(e.toString()); });
    };
    /**
     * Get list of included datetimes in this recurrence set.
     *
     * @return List of rdates
     */
    RRuleSet.prototype.rdates = function () {
        return this._rdate.map(function (e) { return new Date(e.getTime()); });
    };
    /**
     * Get list of included datetimes in this recurrence set.
     *
     * @return List of exdates
     */
    RRuleSet.prototype.exdates = function () {
        return this._exdate.map(function (e) { return new Date(e.getTime()); });
    };
    RRuleSet.prototype.valueOf = function () {
        var result = [];
        if (!this._rrule.length && this._dtstart) {
            result = result.concat(Object(__WEBPACK_IMPORTED_MODULE_6__optionstostring__["a" /* optionsToString */])({ dtstart: this._dtstart }));
        }
        this._rrule.forEach(function (rrule) {
            result = result.concat(rrule.toString().split('\n'));
        });
        this._exrule.forEach(function (exrule) {
            result = result.concat(exrule.toString().split('\n')
                .map(function (line) { return line.replace(/^RRULE:/, 'EXRULE:'); })
                .filter(function (line) { return !/^DTSTART/.test(line); }));
        });
        if (this._rdate.length) {
            result.push(rdatesToString('RDATE', this._rdate, this.tzid()));
        }
        if (this._exdate.length) {
            result.push(rdatesToString('EXDATE', this._exdate, this.tzid()));
        }
        return result;
    };
    /**
     * to generate recurrence field such as:
     *   DTSTART:19970902T010000Z
     *   RRULE:FREQ=YEARLY;COUNT=2;BYDAY=TU
     *   RRULE:FREQ=YEARLY;COUNT=1;BYDAY=TH
     */
    RRuleSet.prototype.toString = function () {
        return this.valueOf().join('\n');
    };
    /**
     * Create a new RRuleSet Object completely base on current instance
     */
    RRuleSet.prototype.clone = function () {
        var rrs = new RRuleSet(!!this._cache);
        this._rrule.forEach(function (rule) { return rrs.rrule(rule.clone()); });
        this._exrule.forEach(function (rule) { return rrs.exrule(rule.clone()); });
        this._rdate.forEach(function (date) { return rrs.rdate(new Date(date.getTime())); });
        this._exdate.forEach(function (date) { return rrs.exdate(new Date(date.getTime())); });
        return rrs;
    };
    return RRuleSet;
}(__WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (RRuleSet);
function _addRule(rrule, collection) {
    if (!(rrule instanceof __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */])) {
        throw new TypeError(String(rrule) + ' is not RRule instance');
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["c" /* includes */])(collection.map(String), String(rrule))) {
        collection.push(rrule);
    }
}
function _addDate(date, collection) {
    if (!(date instanceof Date)) {
        throw new TypeError(String(date) + ' is not Date instance');
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["c" /* includes */])(collection.map(Number), Number(date))) {
        collection.push(date);
        __WEBPACK_IMPORTED_MODULE_2__dateutil__["b" /* default */].sort(collection);
    }
}
function rdatesToString(param, rdates, tzid) {
    var isUTC = !tzid || tzid.toUpperCase() === 'UTC';
    var header = isUTC ? param + ":" : param + ";TZID=" + tzid + ":";
    var dateString = rdates
        .map(function (rdate) { return __WEBPACK_IMPORTED_MODULE_2__dateutil__["b" /* default */].timeToUntilString(rdate.valueOf(), isUTC); })
        .join(',');
    return "" + header + dateString;
}
//# sourceMappingURL=rruleset.js.map

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseInput */
/* harmony export (immutable) */ __webpack_exports__["a"] = rrulestr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rrule__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rruleset__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parsestring__ = __webpack_require__(221);






/**
 * RRuleStr
 *  To parse a set of rrule strings
 */
var DEFAULT_OPTIONS = {
    dtstart: null,
    cache: false,
    unfold: false,
    forceset: false,
    compatible: false,
    tzid: null
};
function parseInput(s, options) {
    var rrulevals = [];
    var rdatevals = [];
    var exrulevals = [];
    var exdatevals = [];
    var _a = Object(__WEBPACK_IMPORTED_MODULE_5__parsestring__["a" /* parseDtstart */])(s), dtstart = _a.dtstart, tzid = _a.tzid;
    var lines = splitIntoLines(s, options.unfold);
    lines.forEach(function (line) {
        if (!line)
            return;
        var _a = breakDownLine(line), name = _a.name, parms = _a.parms, value = _a.value;
        switch (name.toUpperCase()) {
            case 'RRULE':
                if (parms.length) {
                    throw new Error("unsupported RRULE parm: " + parms.join(','));
                }
                rrulevals.push(Object(__WEBPACK_IMPORTED_MODULE_5__parsestring__["b" /* parseString */])(line));
                break;
            case 'RDATE':
                var _b = /RDATE(?:;TZID=([^:=]+))?/i.exec(line), _ = _b[0], rdateTzid = _b[1];
                if (rdateTzid && !tzid) {
                    tzid = rdateTzid;
                }
                rdatevals = rdatevals.concat(parseRDate(value, parms));
                break;
            case 'EXRULE':
                if (parms.length) {
                    throw new Error("unsupported EXRULE parm: " + parms.join(','));
                }
                exrulevals.push(Object(__WEBPACK_IMPORTED_MODULE_5__parsestring__["b" /* parseString */])(value));
                break;
            case 'EXDATE':
                exdatevals = exdatevals.concat(parseRDate(value, parms));
                break;
            case 'DTSTART':
                break;
            default:
                throw new Error('unsupported property: ' + name);
        }
    });
    return {
        dtstart: dtstart,
        tzid: tzid,
        rrulevals: rrulevals,
        rdatevals: rdatevals,
        exrulevals: exrulevals,
        exdatevals: exdatevals
    };
}
function buildRule(s, options) {
    var _a = parseInput(s, options), rrulevals = _a.rrulevals, rdatevals = _a.rdatevals, exrulevals = _a.exrulevals, exdatevals = _a.exdatevals, dtstart = _a.dtstart, tzid = _a.tzid;
    var noCache = options.cache === false;
    if (options.compatible) {
        options.forceset = true;
        options.unfold = true;
    }
    if (options.forceset ||
        rrulevals.length > 1 ||
        rdatevals.length ||
        exrulevals.length ||
        exdatevals.length) {
        var rset_1 = new __WEBPACK_IMPORTED_MODULE_2__rruleset__["a" /* default */](noCache);
        rset_1.dtstart(dtstart);
        rset_1.tzid(tzid || undefined);
        rrulevals.forEach(function (val) {
            rset_1.rrule(new __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */](groomRruleOptions(val, dtstart, tzid), noCache));
        });
        rdatevals.forEach(function (date) {
            rset_1.rdate(date);
        });
        exrulevals.forEach(function (val) {
            rset_1.exrule(new __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */](groomRruleOptions(val, dtstart, tzid), noCache));
        });
        exdatevals.forEach(function (date) {
            rset_1.exdate(date);
        });
        if (options.compatible && options.dtstart)
            rset_1.rdate(dtstart);
        return rset_1;
    }
    var val = rrulevals[0] || {};
    return new __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */](groomRruleOptions(val, val.dtstart || options.dtstart || dtstart, val.tzid || options.tzid || tzid), noCache);
}
function rrulestr(s, options) {
    if (options === void 0) { options = {}; }
    return buildRule(s, initializeOptions(options));
}
function groomRruleOptions(val, dtstart, tzid) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, val), { dtstart: dtstart,
        tzid: tzid });
}
function initializeOptions(options) {
    var invalid = [];
    var keys = Object.keys(options);
    var defaultKeys = Object.keys(DEFAULT_OPTIONS);
    keys.forEach(function (key) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["c" /* includes */])(defaultKeys, key))
            invalid.push(key);
    });
    if (invalid.length) {
        throw new Error('Invalid options: ' + invalid.join(', '));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, DEFAULT_OPTIONS), options);
}
function extractName(line) {
    if (line.indexOf(':') === -1) {
        return {
            name: 'RRULE',
            value: line
        };
    }
    var _a = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["m" /* split */])(line, ':', 1), name = _a[0], value = _a[1];
    return {
        name: name,
        value: value
    };
}
function breakDownLine(line) {
    var _a = extractName(line), name = _a.name, value = _a.value;
    var parms = name.split(';');
    if (!parms)
        throw new Error('empty property name');
    return {
        name: parms[0].toUpperCase(),
        parms: parms.slice(1),
        value: value
    };
}
function splitIntoLines(s, unfold) {
    if (unfold === void 0) { unfold = false; }
    s = s && s.trim();
    if (!s)
        throw new Error('Invalid empty string');
    // More info about 'unfold' option
    // Go head to http://www.ietf.org/rfc/rfc2445.txt
    if (!unfold) {
        return s.split(/\s/);
    }
    var lines = s.split('\n');
    var i = 0;
    while (i < lines.length) {
        // TODO
        var line = (lines[i] = lines[i].replace(/\s+$/g, ''));
        if (!line) {
            lines.splice(i, 1);
        }
        else if (i > 0 && line[0] === ' ') {
            lines[i - 1] += line.slice(1);
            lines.splice(i, 1);
        }
        else {
            i += 1;
        }
    }
    return lines;
}
function validateDateParm(parms) {
    parms.forEach(function (parm) {
        if (!/(VALUE=DATE(-TIME)?)|(TZID=)/.test(parm)) {
            throw new Error('unsupported RDATE/EXDATE parm: ' + parm);
        }
    });
}
function parseRDate(rdateval, parms) {
    validateDateParm(parms);
    return rdateval
        .split(',')
        .map(function (datestr) { return __WEBPACK_IMPORTED_MODULE_3__dateutil__["b" /* default */].untilStringToDate(datestr); });
}
//# sourceMappingURL=rrulestr.js.map

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EnhancedBoxCastFlowControlTooltipHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MaximumBoxCastFlowControlTooltipHTML; });
// EnhancedBoxCastFlowControlTooltipHTML is the HTML of the tooltip that explains standard and enhanced
// BoxCast flow control. It is used for creating/editing broadcasts and editing BoxCaster sources.
var EnhancedBoxCastFlowControlTooltipHTML = "<b>Standard:</b> Minimizes viewer latency; recovers lost data for up to 2 seconds.\n  <br/>\n  <b>Enhanced:</b> Recovers lost data for up to 15s (and adds 15 seconds to viewer latency)."; // MaximumBoxCastFlowControlTooltipHTML is the HTML of the tooltip that explains standard, enhanced, and
// maximum BoxCast flow control. It is used for creating/editing broadcasts and editing BoxCaster sources.

var MaximumBoxCastFlowControlTooltipHTML = EnhancedBoxCastFlowControlTooltipHTML + "<br/><b>Maximum:</b> Recovers lost data for up to 45-90 seconds (and adds 45-90 seconds to viewer latency).";

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalAddSource;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__source_config__ = __webpack_require__(546);

function ModalAddSource($uibModalInstance, $rootScope, BoxCaster, toaster, StaticRTMP, MeetingsService, $state, $http, $timeout, parentVM, sourceToAdd, onlyShowEncoderGuides, params) {
  'ngInject';

  var _this = this;

  this.StaticRTMP = StaticRTMP;
  this.BoxCaster = BoxCaster;
  this.sourceToAdd = sourceToAdd;
  this.onlyShowEncoderGuides = onlyShowEncoderGuides;
  this.staticRTMPChannels = parentVM.staticRTMPs;
  this.allowRtmp = parentVM.allowRtmp;
  this.allowBroadcaster = parentVM.allowBroadcaster;
  this.staticRTMPChannelLimit = parentVM.account.static_rtmps_channel_limit;
  this.account = parentVM.account;
  this.user = parentVM.user;
  this.limits = $rootScope.ApiConfig.modelFieldLimits('static_rtmp', 'maximum');
  this.downloadBroadcasterURL = 'https://itunes.apple.com/us/app/broadcaster-smarter-way-to/id1105581053'; // XXX; $http is presenting CORS issues reading from assets.boxcast.com, but
  // neither fetch nor XMLHttpRequest do.  I attempted to remove the auth
  // interceptor code for this, and even that does not change the behavior.
  // After fighting for too long with it, I'm just giving up and using
  // XMLHttpRequest

  this.backorderMessages = {};
  var req = new XMLHttpRequest();
  var self = this;
  req.addEventListener('load', function () {
    var data = JSON.parse(this.responseText);
    $timeout(function () {
      self.backorderMessages = data.backorder_messages || {};
    });
  });
  req.open('GET', 'https://assets.boxcast.com/inventory.json');
  req.send();

  if (params && params.name) {
    this.rtmpChannelName = params.name;
  }

  this.refresh = function () {
    _this.boxcaster = {};
    _this.detectedBox = _this.BoxCaster.getRegistration(function () {
      if (_this.detectedBox.id[0] == 'p' && _this.sourceToAdd == 'boxcaster-pro' || _this.detectedBox.id[0] == 'o' && _this.sourceToAdd == 'boxcaster' || !_this.sourceToAdd) {
        _this.boxcaster.id = _this.detectedBox.id;
      }
    });
  };

  this.refresh();

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this.registerBoxCaster = function () {
    if (!_this.boxcaster.id) {
      toaster.pop('warning', 'Please enter the BoxCaster serial number');
      return;
    }

    _this.saving = true;

    _this.BoxCaster.postRegistration({}, {
      id: _this.boxcaster.id
    }, function () {
      _this.saving = false;
      $uibModalInstance.dismiss();
      parentVM.refresh();
    }, function () {
      _this.saving = false;
      toaster.pop('warning', 'There was an error trying to register your BoxCaster. Please double-check the serial number and try again.');
    });
  };

  this.createRtmpChannel = function () {
    if (!_this.rtmpChannelName) {
      toaster.pop('warning', 'Please enter a name for your RTMP source.');
      return;
    }

    _this.saving = true;

    _this.StaticRTMP.create({
      name: _this.rtmpChannelName
    }, function (r) {
      _this.saving = false;
      $uibModalInstance.dismiss(); // insert the new source into the list of sources

      parentVM.allSources.push(r); // re-sort the list so the newly added source is in the correct position in the list

      parentVM.sortSources(parentVM.allSources, parentVM.broadcastsByStaticRTMP); // Ideally, we would update the query params here to keep the new source active in case they refresh the page, or want to link someone to the page at this point in time
      // Changing query params through $location and window.location both cause this controller to make fresh API calls to the server...
      // **IN PRODUCTION ONLY**, those responses do not contain this newly created source so we need to make sure those API calls to not get sent
      // $location.search('static_rtmp_id', r.id);

      parentVM.toggleDetails(r);
    }, function (err) {
      _this.saving = false;
      console.log(err);
      toaster.pop('warning', 'There was an error creating your RTMP source.');
    });
  };

  this.onContactUs = function () {
    if (_this.account.contract == 'trial') {
      MeetingsService.openPreferredMethod();
    } else {
      MeetingsService.scheduleMeeting('Schedule time to discuss purchasing a BoxCaster');
    }
  };

  this.select = function (name) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (params && params.action) {
      if (params.action == 'downloadBroadcasterApp') {
        window.open(_this.downloadBroadcasterURL, '_blank');
        return false;
      }
    } else {
      _this.sourceToAdd = name;

      if (name.startsWith('boxcaster')) {
        _this.refresh();
      }

      if (name == 'rtmp' && params.name) {
        _this.rtmpChannelName = params.name;
      }
    }
  };

  this.RTMP_ENCODER_GUIDES = __WEBPACK_IMPORTED_MODULE_0__source_config__["a" /* ENCODER_GUIDES */];
}

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_angular_angular__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_angular_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_expose_loader_angular_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_expose_loader_lodash__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_expose_loader_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_expose_loader_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_expose_loader_moment_moment__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_expose_loader_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_expose_loader_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_polyfill__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_hacks__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_hacks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__browser_hacks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_bootstrap__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_index__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_index__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters_index__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_index__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__resources_index__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_index__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__thirdparty__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_main_scss__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_main_scss__);
// Expose core modules on the window scope to avoid importing them everywhere




 // Throw config on window scope as well
// eslint-disable-next-line no-unused-vars

 // Check authentication token from OAuth redirect straight away



var tokenPromise = Object(__WEBPACK_IMPORTED_MODULE_6__auth_bootstrap__["a" /* bootstrapOAuthTokenExchange */])(); // Inject Bootstrap CSS via webpack loaders

 // Create the core app angular module, depending on our sub-modules








var app = angular.module('app', [__WEBPACK_IMPORTED_MODULE_9__auth_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__directives_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11__filters_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_12__pages_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_13__resources_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_14__services_index__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_15__thirdparty__["a" /* default */].name]); // Main app layout


app.directive('app', function () {
  'ngInject';

  return {
    restrict: 'E',
    template: __webpack_require__(645),
    controllerAs: 'vm',
    controller: function controller(Capabilities, $rootScope, $timeout) {
      'ngInject'; // Handle race condition of double feature flags initialization (we don't want $stateChangeStart
      // to fire until *after* its handler's Capabilities are initialized)

      var _this = this;

      this.loading = true;
      Capabilities.then(function () {
        $timeout(function () {
          // Prevent Go plan users from accessing the dashboard
          // TODO: This is fragile. We should use a feature flag or explicit
          //       plan names to determine Dashboard access.
          var isFreePlan = Capabilities.account.contract === 'free';
          var maxMinutes = Capabilities.account.max_streamed_minutes_per_month;
          var isGoPlan = isFreePlan && maxMinutes > 0 && maxMinutes <= 3 * 60;

          if (isGoPlan) {
            window.location.href = 'https://www.boxcast.com/go-plan/gated';
            return;
          } // Account and User were already retrieved by way of Capabilities
          // Pluck them from there to avoid double-requesting.


          _this.account = Capabilities.account;
          _this.user = Capabilities.user;
          _this.Capabilities = Capabilities; // Initialize DataDog logging

          remoteLogger.addContext('service', 'dashboard');
          remoteLogger.addContext('env', BOXCAST_JS_ENV);
          remoteLogger.addContext('account_id', _this.account.id);
          remoteLogger.addContext('user_id', _this.user.id); // Load the chat widget

          if (_this.account.chat_support && !_this.user.is_impersonating) {
            $rootScope.hasChat = true;
            loadChatWidget(_this.user, _this.account);
          } // use feature flag product_tour [UA-1023]


          if (_this.account.extra_features.product_tour) {
            initializeAppcues(_this.user, _this.account);
            initializeMixpanel(_this.user);
          }

          _this.loading = false;
        }, 10);
      }); // App layout depends on whether the eyebrow is shown or not

      $rootScope.$on('show-eyebrow', function () {
        _this.showEyebrow = true;
      });
      $rootScope.$on('hide-eyebrow', function () {
        _this.showEyebrow = false;
      });
    }
  };
});

function loadChatWidget(user, account) {
  if (!window.Intercom) {
    console.warn('Intercom not properly loaded');
    return;
  }

  var convertToSeconds = function convertToSeconds(date) {
    if (date) {
      var newDate = new Date(date);
      return Math.floor(newDate / 1000);
    }

    return null;
  };

  window.Intercom('boot', {
    app_id: INTERCOM_APP_ID,
    user_id: user.id,
    email: user.email,
    name: user.name,
    company: {
      company_id: account.id,
      name: account.name
    },
    trial_milestone_stage: account.metadata.onboarding_step || null,
    trial_expiration_at: convertToSeconds(account.expires_on),
    account_status: account.status,
    can_stream: account.can_stream,
    has_streamed: account.has_streamed,
    market: account.market || null,
    contract_status: account.contract
  });
}

function initializeAppcues(user, account) {
  if (!window.Appcues) {
    console.warn('Appcues not properly loaded');
    return;
  }

  window.Appcues.identify(user.id, {
    email: user.email,
    name: user.name,
    can_stream: account.can_stream,
    has_streamed: account.has_streamed,
    trial_milestone_stage: account.metadata.onboarding_step || null,
    company_name: account.name,
    company_id: account.id,
    market: account.market || null,
    contract_status: account.contract,
    account_status: account.status
  });
  window.Appcues.group(account.id, {
    company_name: account.name
  });
}

function initializeMixpanel(_ref) {
  var id = _ref.id;

  if (!window.mixpanel) {
    console.warn('mixpanel not properly loaded');
    return;
  }

  window.mixpanel.init('0ab50e682300f5e06a239867570871a1', {
    debug: true
  });
  window.mixpanel.identify(id);
}

app.config(function ($urlRouterProvider, $stateProvider, $analyticsProvider, $compileProvider, ChartJsProvider) {
  'ngInject'; // Init UI-router

  $urlRouterProvider.otherwise('/?p=1,1,1&tab=current'); // go to home if route not found
  // Google Analytics

  $analyticsProvider.virtualPageviews(false); // explicitly track pages

  $analyticsProvider.firstPageview(false); // necessary for manual bootstrapping code

  $analyticsProvider.trackExceptions(true); // White-list blobs and other friendly URLs

  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|tel|blob):/); // Configure all charts

  ChartJsProvider.setOptions({
    chartColors: [// Based on Stephen Few’s book, Show Me the Numbers
    '#5DA5DA', //blue
    '#4D4D4D', //gray
    '#FAA43A', //orange
    '#60BD68', //green
    '#F17CB0', //pink
    '#B2912F', //brown
    '#B276B2', //purple
    '#DECF3F', //yellow
    '#F15854' //red
    ],
    responsive: true,
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        boxWidth: 10,
        fontSize: 10
      }
    }
  });
  ChartJsProvider.setOptions('Line', {
    datasetFill: false
  });
});
var alreadyRan = false;
app.run(function ($rootScope, $urlRouter, toaster, $state, $q, $analytics, clipboard, ApiConfig, Capabilities) {
  'ngInject'; // Attach some template helpers so we don't have to go through a controller/directive injection

  $rootScope.$state = $state;
  $rootScope._ = _;
  $rootScope.toaster = toaster;
  $rootScope.clipboard = clipboard;
  $rootScope.browser = {
    iPhone: navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)
  };
  $rootScope.vueDashboardRoot = '';

  if (window.location.hostname === 'localhost') {
    $rootScope.vueDashboardRoot = 'http://localhost:8001';
  } // Dealing with a little bit of a race condition here in the app startup lifecycle


  var loaded = false;
  Capabilities.then(function () {
    // Let other templates access a few important instances directly
    $rootScope.ApiConfig = ApiConfig;
    $rootScope.account = Capabilities.account;
    $rootScope.reseller = Capabilities.reseller;
    $rootScope.user = Capabilities.user;
    $rootScope.$state = $state;
    loaded = true; // Google Analytics custom dimensions are registered in GA Settings > Custom Variables

    try {
      ga('set', 'dimension1', $rootScope.account.market);
      ga('set', 'dimension2', $rootScope.account.contract);
    } catch (e) {
      console.log('Unable to set GA dimensions: ', e);
    }
  });

  if (!alreadyRan) {
    alreadyRan = true;
    $rootScope.$on('$locationChangeSuccess', function (evt, newUrl, oldUrl) {
      // Any time user succesfully navigates, scroll up and close mobile menu
      if (allowAutoScrollOnPageTransition(oldUrl, newUrl)) {
        window.scrollTo(0, 0);
      }

      $('left-navbar').parent().removeClass('nav-open');
      $('body').css({
        overflow: 'auto'
      }); // Also log the event in GA according to the route name rather than full URL

      $analytics.pageTrack($state.$current.name); // Also update Intercom

      window.Intercom && window.Intercom('update'); // Also update Appcues [UA-1023]

      if (window.Appcues) {
        window.Appcues.page();
      }
    });
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      if ($state.current.confirmOnExit && !confirm('There are unsaved changes. Are you sure you wish to leave this page?')) {
        console.log('Unsaved changes; preventing default');
        event.preventDefault();
      }

      if (!loaded) {
        // Flags not fully loaded, need to wait a tick and try again
        event.preventDefault();
        Capabilities.then(function () {
          $state.go(toState.name, toParams);
        });
      } else if (!Capabilities.canUserVisitState(toState)) {
        console.log('User blocked from visiting state');
        event.preventDefault();

        if (!Capabilities.account.authorized()) {
          // Redirect unauthorized users to home page
          $state.go('home');
        }
      }
    });
  }
});

function allowAutoScrollOnPageTransition(fromUrl, toUrl) {
  // By default, we always want to autoscroll.  There may be specific cases
  // where we don't (e.g. navigating in-page between channels and updating IDs)
  if (fromUrl.match(/\/channels/) && toUrl.match(/\/channels\?id=/)) {
    return false;
  }

  return true;
} // Custom bootstrapping code so we can wait on required network resources before
// spinning up any angular code at all.


function loadTheApp() {
  var rootElement = angular.element(document);
  app.provider({
    $rootElement: function $rootElement() {
      this.$get = function () {
        return rootElement;
      };
    }
  });
  var preBootstrapInjector = angular.injector(['ng', 'app']);
  var $q = preBootstrapInjector.get('$q');
  var ApiConfig = preBootstrapInjector.get('ApiConfig');
  var Capabilities = preBootstrapInjector.get('Capabilities');
  $q.all([ApiConfig.verifyResolved(), Capabilities.verifyResolved()]).then(function () {
    angular.bootstrap(rootElement, ['app']);
  })["catch"](function (err) {
    showGlobalError(err);
  });
}

function showGlobalError(err) {
  console.error(err);
  $('body > app').hide();
  setTimeout(function () {
    $('#global-error-message').fadeIn();
    remoteLogger.error("unable to load dashboard: ".concat(err), {
      err: err,
      isSwitcherStudioAppShell: __WEBPACK_IMPORTED_MODULE_7__auth_utils__["c" /* isSwitcherStudioAppShell */]
    });
  }, 1000); // delay a bit in case the error is masked by redirect for auth logic
}

if (tokenPromise) {
  tokenPromise.then(loadTheApp)["catch"](function (err) {
    showGlobalError(err);
  });
} else {
  loadTheApp();
}

/* harmony default export */ __webpack_exports__["default"] = (app);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["angular"] = __webpack_require__(15);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["_"] = __webpack_require__(37);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["moment"] = __webpack_require__(0);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 288 */
/***/ (function(module, exports) {

if (typeof String.prototype.startsWith !== 'function') {
  String.prototype.startsWith = function (str) {
    return this.indexOf(str) === 0;
  };
}

if (typeof String.prototype.endsWith !== 'function') {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();

    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }

    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    'use strict';

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    }

    if (start === undefined) {
      start = 0;
    }

    return this.indexOf(search, start) !== -1;
  };
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// Prevent the backspace key from navigating back.
$(document).unbind('keydown').bind('keydown', function (event) {
  var doPrevent = false;

  if (event.keyCode === 8) {
    var d = event.srcElement || event.target,
        tag = d.tagName.toUpperCase(),
        type = (d.type || '').toUpperCase();

    if (tag === 'INPUT' && (type === 'TEXT' || type === 'PASSWORD' || type === 'FILE' || type === 'SEARCH' || type === 'EMAIL' || type === 'NUMBER' || type === 'DATE') || tag === 'TEXTAREA') {
      doPrevent = d.readOnly || d.disabled;
    } else {
      doPrevent = true;
    }
  }

  if (doPrevent) {
    event.preventDefault();
  }
}); // Prevent drag/drop image from navigating page (unless
// it's over an explicit upload drop target we want)

window.addEventListener('dragover', function (e) {
  e = e || event;
  e.preventDefault();
}, false);
window.addEventListener('drop', function (e) {
  e = e || event;
  e.preventDefault();
}, false);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
// The config module loads the appropriate configuration based on the URL being
// visited and attaches variables to the window scope.
 // Use the _shared as a base, but allow overriding in each environment

var _shared = __webpack_require__(291);

var configMap = {
  dev: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.extend({}, _shared, __webpack_require__(292)),
  localhost: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.extend({}, _shared, __webpack_require__(293)),
  prod: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.extend({}, _shared, __webpack_require__(294))
};
var ENV;

switch (location.hostname) {
  case 'localhost':
    ENV = 'localhost';
    break;

  case 'dashboard.dev.boxcast.com':
    ENV = 'dev';
    break;

  default:
    ENV = 'prod';
} // Throw variables on window


__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(configMap[ENV], function (value, key) {
  var override = localStorage.getItem(key);

  if (override) {
    console.warn('Overriding', key, 'with', override, 'instead of', value);
    value = override;
  }

  window[key] = value;
});

/* unused harmony default export */ var _unused_webpack_default_export = (ENV);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REFRESH_INTERVAL_MS", function() { return REFRESH_INTERVAL_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_POLL_INTERVAL_MS", function() { return WIFI_POLL_INTERVAL_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_POLL_TIMEOUT_MS", function() { return WIFI_POLL_TIMEOUT_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_RECURRING_EVENTS", function() { return MAX_RECURRING_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PREROLL_TIME", function() { return PREROLL_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_MONETIZED_HIGHLIGHT_TIME_S", function() { return MAX_MONETIZED_HIGHLIGHT_TIME_S; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUDIO_ONLY_BITRATE_HINT", function() { return AUDIO_ONLY_BITRATE_HINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_ENV", function() { return BOXCAST_JS_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_EMBED_URL", function() { return BOXCAST_JS_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_IFRAME_URL", function() { return BOXCAST_JS_IFRAME_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_APP_EMBED_URL", function() { return BOXCAST_JS_APP_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYNDICATION_SERVICE_BASE_URL", function() { return SYNDICATION_SERVICE_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GOOGLE_ANALYTICS_KEY", function() { return GOOGLE_ANALYTICS_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GOOGLE_ANALYTICS_DOMAIN", function() { return GOOGLE_ANALYTICS_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_SCOPE", function() { return YOUTUBE_SCOPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_ANALYTICS_SCOPE", function() { return YOUTUBE_ANALYTICS_SCOPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNSPLASH_APP_ID", function() { return UNSPLASH_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIMEO_CLIENT_ID", function() { return VIMEO_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIMEO_SCOPE", function() { return VIMEO_SCOPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TWITTER_CLIENT_ID", function() { return TWITTER_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPECTRUM_COLOR_PALETTE", function() { return SPECTRUM_COLOR_PALETTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STANDARD_COLOR_PALETTE", function() { return STANDARD_COLOR_PALETTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROTECTED_CONTENT_SETTINGS_KEYS", function() { return PROTECTED_CONTENT_SETTINGS_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HUBSPOT_MEETINGS_BASE_URL", function() { return HUBSPOT_MEETINGS_BASE_URL; });
var REFRESH_INTERVAL_MS = 60000; //refresh event list and details once per minute

var WIFI_POLL_INTERVAL_MS = 2500;
var WIFI_POLL_TIMEOUT_MS = 60000; //stop trying after 60sec

var MAX_RECURRING_EVENTS = 100;
var PREROLL_TIME = 10 * 60 * 1000; // 10 minutes in milliseconds
// 5 minutes -- see https://github.com/boxcast/boxcast_api/blob/master/app/models/highlight.rb for Highlight::MAX_DURATION

var MAX_MONETIZED_HIGHLIGHT_TIME_S = 300;
var AUDIO_ONLY_BITRATE_HINT = 10000;
var BOXCAST_JS_ENV = 'prod';
var BOXCAST_JS_EMBED_URL = '//js.boxcast.com/v3.min.js';
var BOXCAST_JS_IFRAME_URL = 'https://boxcast.tv/view-embed';
var BOXCAST_JS_APP_EMBED_URL = 'https://boxcast.tv/embed-app.html';
var SYNDICATION_SERVICE_BASE_URL = 'https://syndication.boxcast.com';
var GOOGLE_ANALYTICS_KEY = 'UA-15394876-6';
var GOOGLE_ANALYTICS_DOMAIN = null;
var YOUTUBE_SCOPE = 'https://www.googleapis.com/auth/youtube';
var YOUTUBE_ANALYTICS_SCOPE = 'https://www.googleapis.com/auth/yt-analytics.readonly';
var UNSPLASH_APP_ID = 'd95c25c1553e8c7e9a6177c9a6a04f6d107fda686347b65e15bd347f11810cec';
var VIMEO_CLIENT_ID = 'e4ac1782f4cbfa854a3f90c6ee955fb641c0db37';
var VIMEO_SCOPE = 'public private upload';
var TWITTER_CLIENT_ID = 'aspcGbqPb6k2SVLYLfwU57JpF';
var SPECTRUM_COLOR_PALETTE = {
  '#000000': 'Black',
  '#0496D4': 'Teal',
  '#99BFE5': 'Blue Light',
  '#648FCC': 'Blue Medium',
  '#002D73': 'Blue',
  '#0C2238': 'Navy',
  '#005F61': 'Aqua',
  '#3A7728': 'Green Light',
  '#00583D': 'Green',
  '#004438': 'Green Dark',
  '#FF3333': 'Red Light',
  '#C8141E': 'Red',
  '#990000': 'Maroon',
  '#FC4E04': 'Orange',
  '#E06F1F': 'Orange Burnt',
  '#6633CC': 'Purple Light',
  '#410F73': 'Purple',
  '#4E3227': 'Brown',
  '#9B8449': 'Gold Old',
  '#CC9933': 'Gold',
  '#969798': 'Silver'
};
var STANDARD_COLOR_PALETTE = SPECTRUM_COLOR_PALETTE;
var PROTECTED_CONTENT_SETTINGS_KEYS = ['app', 'boxcast_viewer_promotion', 'cryptblock', 'customPreroll', 'defaultVideo', 'donateContactEmail', 'donateMessage', 'enterprise_last_mile_delivery', 'geoblock', 'hostRestrictions', 'language', 'podcast', 'poster', 'preview', 'showCountdown', 'showDonations', 'website'];
var HUBSPOT_MEETINGS_BASE_URL = 'https://app.hubspot.com/meetings';

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "API_ROOT", function() { return API_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTEGRATIONS_ROOT", function() { return INTEGRATIONS_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_URL", function() { return LOGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTH_URL", function() { return AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWITCHER_AUTH_URL", function() { return SWITCHER_AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOKEN_URL", function() { return TOKEN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT_URL", function() { return LOGOUT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GEO_URL", function() { return GEO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS", function() { return BOXCAST_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_ENV", function() { return BOXCAST_JS_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_EMBED_URL", function() { return BOXCAST_JS_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_IFRAME_URL", function() { return BOXCAST_JS_IFRAME_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_APP_EMBED_URL", function() { return BOXCAST_JS_APP_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYNDICATION_SERVICE_BASE_URL", function() { return SYNDICATION_SERVICE_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BANDWIDTH_TEST_URL", function() { return BANDWIDTH_TEST_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIDGET_JS", function() { return WIDGET_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_SHOW_URL", function() { return BOXCAST_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_SHOW_URL", function() { return BOXCAST_TV_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_HIGHLIGHT_URL", function() { return BOXCAST_TV_HIGHLIGHT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_VIDEO_PORTAL_URL", function() { return BOXCAST_TV_VIDEO_PORTAL_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMG_ROOT", function() { return IMG_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FACEBOOK_APP_ID", function() { return FACEBOOK_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLAID_ENV", function() { return PLAID_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLAID_KEY", function() { return PLAID_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STRIPE_KEY", function() { return STRIPE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_CLIENT_ID", function() { return YOUTUBE_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_OAUTH_REDIRECT", function() { return YOUTUBE_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIMEO_OAUTH_REDIRECT", function() { return VIMEO_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TWITTER_OAUTH_REDIRECT", function() { return TWITTER_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATADOG_LOGS_CLIENT_TOKEN", function() { return DATADOG_LOGS_CLIENT_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERCOM_APP_ID", function() { return INTERCOM_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VUE_DASHBOARD_ROOT", function() { return VUE_DASHBOARD_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_DASHBOARD_ROOT", function() { return NG_DASHBOARD_ROOT; });
var API_ROOT = 'https://rest.dev.boxcast.com';
var INTEGRATIONS_ROOT = 'https://integration.dev.boxcast.com';
var LOGIN_URL = 'https://login.dev.boxcast.com';
var AUTH_URL = 'https://rest.dev.boxcast.com/oauth2/auth?response_type=code&client_id=fabmaqloe4wokqzincep&redirect_uri=https%3A%2F%2Fdashboard.dev.boxcast.com%2F&scope=dashboard';
var SWITCHER_AUTH_URL = 'https://rest.dev.boxcast.com/oauth2/auth?response_type=code&client_id=glolh40ngfpuvh84jzc4&redirect_uri=https%3A%2F%2Fdashboard.dev.boxcast.com%2F&scope=owner';
var TOKEN_URL = 'https://rest.dev.boxcast.com/oauth2/token';
var LOGOUT_URL = 'https://rest.dev.boxcast.com/oauth2/auth/sessions/login/revoke';
var GEO_URL = 'https://geo.dev.boxcast.com/json/'; // boxcast_js v3

var BOXCAST_JS = "//js.dev.boxcast.com/v3.min.js";
var BOXCAST_JS_ENV = 'dev';
var BOXCAST_JS_EMBED_URL = '//js.dev.boxcast.com/v3.min.js';
var BOXCAST_JS_IFRAME_URL = 'https://dev.boxcast.tv/view-embed';
var BOXCAST_JS_APP_EMBED_URL = 'https://dev.boxcast.tv/embed-app.html';
var SYNDICATION_SERVICE_BASE_URL = 'https://syndication.dev.boxcast.com';
var BANDWIDTH_TEST_URL = 'https://w35c8wpq1bdd4z59brit.dev.boxcast.com';
var WIDGET_JS = '//js.dev.boxcast.com/v2.widget.js';
var BOXCAST_SHOW_URL = 'https://dev.boxcast.tv/channel/';
var BOXCAST_TV_SHOW_URL = 'https://dev.boxcast.tv/channel/';
var BOXCAST_TV_HIGHLIGHT_URL = 'https://dev.boxcast.tv/highlights/';
var BOXCAST_TV_VIDEO_PORTAL_URL = 'https://dev.boxcast.tv/video-portal/';
var IMG_ROOT = 'https://dashboard.dev.boxcast.com/img/';
var FACEBOOK_APP_ID = '252291028958723';
var PLAID_ENV = 'sandbox';
var PLAID_KEY = 'd9d6e3622f442cf5a33073a50e3425';
var STRIPE_KEY = 'pk_test_jJXNd6tHTMtwyQWWHE4lGQvJ';
var YOUTUBE_CLIENT_ID = '272935062177-t44tv0ss9scbhseoajt0ie36ucgt5gcv.apps.googleusercontent.com';
var YOUTUBE_OAUTH_REDIRECT = 'https://dashboard.dev.boxcast.com?oauth_reply_from=youtube';
var VIMEO_OAUTH_REDIRECT = 'https://dashboard.dev.boxcast.com?oauth_reply_from=vimeo';
var TWITTER_OAUTH_REDIRECT = 'https://dashboard.dev.boxcast.com/#/settings/twitter';
var DATADOG_LOGS_CLIENT_TOKEN = 'pubd6bf579ae45e618194ddc4138bd04efb';
var INTERCOM_APP_ID = 'qjlz07dd';
var VUE_DASHBOARD_ROOT = 'https://dashboard.dev.boxcast.com';
var NG_DASHBOARD_ROOT = 'https://dashboard.dev.boxcast.com';

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "API_ROOT", function() { return API_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTEGRATIONS_ROOT", function() { return INTEGRATIONS_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_URL", function() { return LOGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTH_URL", function() { return AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWITCHER_AUTH_URL", function() { return SWITCHER_AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOKEN_URL", function() { return TOKEN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT_URL", function() { return LOGOUT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GEO_URL", function() { return GEO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_ENV", function() { return BOXCAST_JS_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS", function() { return BOXCAST_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_EMBED_URL", function() { return BOXCAST_JS_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_IFRAME_URL", function() { return BOXCAST_JS_IFRAME_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_APP_EMBED_URL", function() { return BOXCAST_JS_APP_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYNDICATION_SERVICE_BASE_URL", function() { return SYNDICATION_SERVICE_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_SHOW_URL", function() { return BOXCAST_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_SHOW_URL", function() { return BOXCAST_TV_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_HIGHLIGHT_URL", function() { return BOXCAST_TV_HIGHLIGHT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_VIDEO_PORTAL_URL", function() { return BOXCAST_TV_VIDEO_PORTAL_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIDGET_JS", function() { return WIDGET_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMG_ROOT", function() { return IMG_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BANDWIDTH_TEST_URL", function() { return BANDWIDTH_TEST_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GOOGLE_ANALYTICS_DOMAIN", function() { return GOOGLE_ANALYTICS_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FACEBOOK_APP_ID", function() { return FACEBOOK_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLAID_ENV", function() { return PLAID_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLAID_KEY", function() { return PLAID_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STRIPE_KEY", function() { return STRIPE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_CLIENT_ID", function() { return YOUTUBE_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_OAUTH_REDIRECT", function() { return YOUTUBE_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIMEO_OAUTH_REDIRECT", function() { return VIMEO_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TWITTER_OAUTH_REDIRECT", function() { return TWITTER_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATADOG_LOGS_CLIENT_TOKEN", function() { return DATADOG_LOGS_CLIENT_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERCOM_APP_ID", function() { return INTERCOM_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VUE_DASHBOARD_ROOT", function() { return VUE_DASHBOARD_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_DASHBOARD_ROOT", function() { return NG_DASHBOARD_ROOT; });
var API_ROOT = 'https://rest.dev.boxcast.com'; //try {
//  localStorage.setItem('oauthToken', 'user');
//}catch(e){}
//export const API_ROOT = 'http://localhost:3000';

var INTEGRATIONS_ROOT = 'https://integration.dev.boxcast.com';
var LOGIN_URL = 'https://login.dev.boxcast.com';
var AUTH_URL = 'https://rest.dev.boxcast.com/oauth2/auth?response_type=code&client_id=nofi891dxx1qgy8rlpox&redirect_uri=http%3A%2F%2Flocalhost%3A8000%2F&scope=dashboard';
var SWITCHER_AUTH_URL = 'https://rest.dev.boxcast.com/oauth2/auth?response_type=code&client_id=glolh40ngfpuvh84jzc4&redirect_uri=https%3A%2F%2Fdashboard.dev.boxcast.com%2F&scope=owner';
var TOKEN_URL = 'https://rest.dev.boxcast.com/oauth2/token';
var LOGOUT_URL = 'https://rest.dev.boxcast.com/oauth2/auth/sessions/login/revoke';
var GEO_URL = 'https://geo.boxcast.com/json/';
var BOXCAST_JS_ENV = 'dev'; //export const BOXCAST_JS = `http://localhost:8000/build/v3.js`;

var BOXCAST_JS = "https://js.dev.boxcast.com/v3.min.js";
var BOXCAST_JS_EMBED_URL = '//js.dev.boxcast.com/v3.min.js';
var BOXCAST_JS_IFRAME_URL = 'https://dev.boxcast.tv/view-embed';
var BOXCAST_JS_APP_EMBED_URL = 'https://dev.boxcast.tv/embed-app.html';
var SYNDICATION_SERVICE_BASE_URL = 'https://syndication.dev.boxcast.com';
var BOXCAST_SHOW_URL = 'https://dev.boxcast.tv/channel/';
var BOXCAST_TV_SHOW_URL = 'https://dev.boxcast.tv/channel/';
var BOXCAST_TV_HIGHLIGHT_URL = 'https://dev.boxcast.tv/highlights/';
var BOXCAST_TV_VIDEO_PORTAL_URL = 'https://dev.boxcast.tv/video-portal/';
var WIDGET_JS = '//js.dev.boxcast.com/v2.widget.js';
var IMG_ROOT = 'https://dashboard.dev.boxcast.com/img/';
var BANDWIDTH_TEST_URL = 'https://w35c8wpq1bdd4z59brit.dev.boxcast.com';
var GOOGLE_ANALYTICS_DOMAIN = 'none'; // hack for testing localhost
//export const FACEBOOK_APP_ID = '1748352278729649'; // test app id

var FACEBOOK_APP_ID = '252291028958723';
var PLAID_ENV = 'sandbox'; //sandbox, development, or production

var PLAID_KEY = 'd9d6e3622f442cf5a33073a50e3425';
var STRIPE_KEY = 'pk_test_jJXNd6tHTMtwyQWWHE4lGQvJ';
var YOUTUBE_CLIENT_ID = '272935062177-t44tv0ss9scbhseoajt0ie36ucgt5gcv.apps.googleusercontent.com';
var YOUTUBE_OAUTH_REDIRECT = 'http://localhost:8000?oauth_reply_from=youtube';
var VIMEO_OAUTH_REDIRECT = 'http://localhost:8000?oauth_reply_from=vimeo';
var TWITTER_OAUTH_REDIRECT = 'http://localhost:8000/#/settings/twitter';
var DATADOG_LOGS_CLIENT_TOKEN = 'pubd6bf579ae45e618194ddc4138bd04efb';
var INTERCOM_APP_ID = 'qjlz07dd';
var VUE_DASHBOARD_ROOT = 'http://localhost:8001';
var NG_DASHBOARD_ROOT = 'http://localhost:8000';

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "API_ROOT", function() { return API_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTEGRATIONS_ROOT", function() { return INTEGRATIONS_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_URL", function() { return LOGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTH_URL", function() { return AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWITCHER_AUTH_URL", function() { return SWITCHER_AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOKEN_URL", function() { return TOKEN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT_URL", function() { return LOGOUT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GEO_URL", function() { return GEO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS", function() { return BOXCAST_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_JS_EMBED_URL", function() { return BOXCAST_JS_EMBED_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIDGET_JS", function() { return WIDGET_JS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_SHOW_URL", function() { return BOXCAST_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_SHOW_URL", function() { return BOXCAST_TV_SHOW_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_HIGHLIGHT_URL", function() { return BOXCAST_TV_HIGHLIGHT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOXCAST_TV_VIDEO_PORTAL_URL", function() { return BOXCAST_TV_VIDEO_PORTAL_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMG_ROOT", function() { return IMG_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BANDWIDTH_TEST_URL", function() { return BANDWIDTH_TEST_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLAID_ENV", function() { return PLAID_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLAID_KEY", function() { return PLAID_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STRIPE_KEY", function() { return STRIPE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FACEBOOK_APP_ID", function() { return FACEBOOK_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_CLIENT_ID", function() { return YOUTUBE_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YOUTUBE_OAUTH_REDIRECT", function() { return YOUTUBE_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIMEO_OAUTH_REDIRECT", function() { return VIMEO_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TWITTER_OAUTH_REDIRECT", function() { return TWITTER_OAUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATADOG_LOGS_CLIENT_TOKEN", function() { return DATADOG_LOGS_CLIENT_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERCOM_APP_ID", function() { return INTERCOM_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VUE_DASHBOARD_ROOT", function() { return VUE_DASHBOARD_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_DASHBOARD_ROOT", function() { return NG_DASHBOARD_ROOT; });
var API_ROOT = 'https://rest.boxcast.com';
var INTEGRATIONS_ROOT = 'https://integration.boxcast.com';
var LOGIN_URL = 'https://login.boxcast.com';
var AUTH_URL = 'https://rest.boxcast.com/oauth2/auth?response_type=code&client_id=kgsyfw5lrhvrzu89gsaj&redirect_uri=https%3A%2F%2Fdashboard.boxcast.com%2F&scope=dashboard';
var SWITCHER_AUTH_URL = 'https://rest.boxcast.com/oauth2/auth?response_type=code&client_id=izon8vdwo6n9fvlrydfn&redirect_uri=https%3A%2F%2Fdashboard.boxcast.com%2F&scope=owner';
var TOKEN_URL = 'https://rest.boxcast.com/oauth2/token';
var LOGOUT_URL = 'https://rest.boxcast.com/oauth2/auth/sessions/login/revoke';
var GEO_URL = 'https://geo.boxcast.com/json/';
var BOXCAST_JS = '//js.boxcast.com/v3.min.js';
var BOXCAST_JS_EMBED_URL = '//js.boxcast.com/v3.min.js';
var WIDGET_JS = '//js.boxcast.com/v2.widget.js';
var BOXCAST_SHOW_URL = 'https://boxcast.tv/channel/';
var BOXCAST_TV_SHOW_URL = 'https://boxcast.tv/channel/';
var BOXCAST_TV_HIGHLIGHT_URL = 'https://boxcast.tv/highlights/';
var BOXCAST_TV_VIDEO_PORTAL_URL = 'https://boxcast.tv/video-portal/';
var IMG_ROOT = 'https://dashboard.boxcast.com/img/';
var BANDWIDTH_TEST_URL = 'https://w35c8wpq1bdd4z59brit.boxcast.com';
var PLAID_ENV = 'production';
var PLAID_KEY = 'd9d6e3622f442cf5a33073a50e3425';
var STRIPE_KEY = 'pk_live_UJ0NcpFDJTsAbVzzYkcohioj';
var FACEBOOK_APP_ID = '1748343348730542';
var YOUTUBE_CLIENT_ID = '272935062177-4207ghd9v3a0ldpuo4o4a35meu9duvfc.apps.googleusercontent.com';
var YOUTUBE_OAUTH_REDIRECT = 'https://dashboard.boxcast.com?oauth_reply_from=youtube';
var VIMEO_OAUTH_REDIRECT = 'https://dashboard.boxcast.com?oauth_reply_from=vimeo';
var TWITTER_OAUTH_REDIRECT = 'https://dashboard.boxcast.com/#/settings/twitter';
var DATADOG_LOGS_CLIENT_TOKEN = 'puba616154f05271b073ae9c7b73917e92c';
var INTERCOM_APP_ID = 'n4ioj8zx';
var VUE_DASHBOARD_ROOT = 'https://dashboard.boxcast.com';
var NG_DASHBOARD_ROOT = 'https://dashboard.boxcast.com';

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = bootstrapOAuthTokenExchange;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(13);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }


var AUTOLOGIN_STATE = 'autologin';
function bootstrapOAuthTokenExchange() {
  // Decode query string
  var query = window.location.search.substring(1);
  var params = {};
  query.split('&').forEach(function (v) {
    var pair = v.split('=');
    params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }); // Look to see if we're being redirected here by a third-party oauth response

  if (params['oauth_reply_from']) {
    return handleThirdPartyResponse(params);
  } // Look to see if we're being redirected here by the BoxCast login redirect


  if (params['code'] && params['state']) {
    var authUrl = __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* isSwitcherStudioAppShell */] ? SWITCHER_AUTH_URL : AUTH_URL;
    authUrl.substring(authUrl.indexOf('?') + 1).split('&').forEach(function (v) {
      var pair = v.split('=');
      params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    });
    return handleLoginServerResponse(params);
  } else if (params['error']) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].clear();
    var error_url = LOGIN_URL + '/error?error=' + params['error'];
    if (params['error_description']) error_url += '&error_description=' + params['error_description'];
    if (params['error_hint']) error_url += '&error_hint=' + params['error_hint'];
    window.location.replace(error_url);
    throw new Error('halt');
    return $.Deferred();
  } // Utilize redirect-dance and localStorage to authenticate a user via OAuth
  // In some cases, we are embedded inside the Switcher Studio app; look there for a token as well.


  var token = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* getAuthToken */])(); // If we've gotten a token in the URL, grab it then kill the URL to remove visibilty of the token.

  var hashParams = _.object(_.map(window.location.hash.replace(/^#/, '').split('&'), function (e) {
    return e.split('=');
  }));

  if (hashParams['token_type'] == 'bearer') {
    token = hashParams['access_token'];

    if (token && token.length > 0) {
      console.log('Token captured; resuming normal activity');

      if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* isSwitcherStudioAppShell */]) {
        document.switcherStudioAccessToken = token;
        __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].setPromise('oauthToken', token).then(function () {
          window.location.replace('/#/switcher-studio');
        });
        return;
      } else {
        __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].set('oauthToken', token);
        var path = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].get('oauthPath') || hashParams['path'] && decodeURIComponent(hashParams['path']) || '/';
        __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].remove('oauthPath');
        window.location.replace(path);
      }
    }
  }

  if (token) {
    // all good, move along
    __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].bumpLoggedInCookie();
    return;
  } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* isSwitcherStudioAppShell */]) {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].getPromise('oauthToken').then(function (token) {
      if (token) {
        document.switcherStudioAccessToken = token;
        window.location.replace('/#/switcher-studio');
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* gotoLogin */])('from storage lookup but missing token');
      }
    })["catch"](function (err) {
      console.error('Error looking for token', err);
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* gotoLogin */])('from token error: ' + err);
      throw err;
    });
  } else {
    // token not found, redirect over to login
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* gotoLogin */])('from token now found and not identified as switcher');
  }
}

function handleLoginServerResponse(params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].getPromise('oauthState').then(function (state) {
    if (params['state'] !== state && params['state'] != AUTOLOGIN_STATE) {
      console.error('Returned state', params['state'], 'does not match stored state', state);
      __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].remove('oauthState');
      __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].remove('oauthVerifier');
      __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].remove('oauthPath');
      throw new Error('Unable to complete login due to mismatched state.');
    }

    return __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].getPromise('oauthVerifier');
  }).then(function (verifier) {
    var code = params['code'];
    var data = 'grant_type=authorization_code&client_id=' + params['client_id'] + '&redirect_uri=' + params['redirect_uri'] + '&code=' + code;

    if (params['state'] != AUTOLOGIN_STATE) {
      data += '&code_verifier=' + verifier;
    }

    var post = $.ajax(TOKEN_URL, {
      method: 'POST',
      data: data
    });
    post.done(function (resp) {
      if (resp.token_type === 'bearer') {
        var token = resp.access_token;

        if (token && token.length > 0) {
          __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].set('oauthToken', token);
          __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].bumpLoggedInCookie();

          if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* isSwitcherStudioAppShell */]) {
            window.location.replace('/#/switcher-studio');
          } else {
            var path = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].get('oauthPath') || '/';
            __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].remove('oauthPath');
            window.location.replace(path);
          }

          throw new Error('halt');
        }
      }
    });
    post.fail(function (resp) {
      console.error('Error processing authorization callback: ', resp);
      var error = 'unknown_error';
      var error_description = 'An unknown error occurred; network status code ' + resp.status;
      var error_hint = '';
      var err = $.parseJSON(resp.responseText);

      if (_typeof(err) === 'object') {
        if (err['error']) error = err['error'];
        if (err['error_description']) error_description = err['error_description'];
        if (err['error_hint']) error_hint = err['error_hint'];
      }

      __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].clear();
      window.location.replace(LOGIN_URL + '/error?error=' + encodeURIComponent(error) + '&error_description=' + encodeURIComponent(error_description) + '&error_hint=' + encodeURIComponent(error_hint) + '&link=' + encodeURIComponent('Return to BoxCast Dashboard') + '&href=' + encodeURIComponent(window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')));
      throw new Error('halt');
    });
    return post;
  });
}

function handleThirdPartyResponse(params) {
  var thirdParty = params['oauth_reply_from'];

  switch (thirdParty) {
    case 'youtube':
      if (params['code']) {
        // Go to /settings/youtube with code
        var code = params['code'],
            l = window.location;
        window.location.replace("".concat(l.protocol, "//").concat(l.host).concat(l.pathname, "#/settings/youtube?code=").concat(code));
        throw 'halt';
      } else if (params['error']) {
        var error = params['error'],
            _l = window.location;
        window.location.replace("".concat(_l.protocol, "//").concat(_l.host).concat(_l.pathname, "#/settings/youtube?error=").concat(error));
        throw 'halt';
      } else {
        console.log("Missing 'code' parameter for YouTube oauth; going home.");
        window.location.replace('/');
        throw 'halt';
      }

      break;

    case 'vimeo':
      if (params['code']) {
        // Go to /settings/vimeo with code
        var _code = params['code'],
            _l2 = window.location;
        window.location.replace("".concat(_l2.protocol, "//").concat(_l2.host).concat(_l2.pathname, "#/settings/vimeo?code=").concat(_code));
        throw 'halt';
      } else {
        console.log("Missing 'code' parameter for Vimeo oauth; going home.");
        window.location.replace('/');
        throw 'halt';
      }

      break;

    default:
      console.log("Unknown thirdParty oauth provider: ".concat(thirdParty, "; going home."));
      window.location.replace('/');
      throw 'halt';
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(297);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!../postcss-loader/index.js!./normalize.css", function() {
			var newContent = require("!!../css-loader/index.js!../postcss-loader/index.js!./normalize.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */\n\n/**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */\n\nhtml {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n  margin: 0;\n}\n\n/* HTML5 display definitions\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */\n\narticle,\naside,\ndetails, /* 1 */\nfigcaption,\nfigure,\nfooter,\nheader,\nmain, /* 2 */\nmenu,\nnav,\nsection,\nsummary { /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */\n\ntemplate, /* 1 */\n[hidden] {\n  display: none;\n}\n\n/* Links\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */\n\na:active,\na:hover {\n  outline-width: 0;\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\n\nb,\nstrong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Restore the font weight unset by the previous rule.\n */\n\noptgroup {\n  font-weight: bold;\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\nhtml [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */\n\n::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n", ""]);

// exports


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var authModule = angular.module('app.auth', []);

__webpack_require__(299);

__webpack_require__(300);

/* harmony default export */ __webpack_exports__["a"] = (authModule);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basil_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basil_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_basil_js__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var AuthService = /*#__PURE__*/function () {
  // Interfaces with the API OAuth provider and utilizes localStorage
  // to persist the username/token on the client.
  // https://assets.boxcast.com/api/reference/#authentication
  function AuthService($http, $rootScope, Facebook) {
    'ngInject';

    _classCallCheck(this, AuthService);

    this.$http = $http;
    this.user = $rootScope.user;
    this.Facebook = Facebook;
  }

  _createClass(AuthService, [{
    key: "testAccessToken",
    value: function testAccessToken() {
      // The access token is limited in time, so we need to be able to check if
      // when it's no longer good. Hit the /account API endpoint to see if it's
      // expired.
      return this.$http.get(API_ROOT + '/account').then(function () {
        return true;
      })["catch"](function () {
        return false;
      });
    }
  }, {
    key: "initHttpAuthorzation",
    value: function initHttpAuthorzation() {
      // Stuff the auth header in the $http service so all other requests are automagically authorized
      this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.getAuthToken();
    }
  }, {
    key: "logout",
    value: function logout() {
      this.Facebook.logout();
      __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* storage */].clear();
      __WEBPACK_IMPORTED_MODULE_1_basil_js___default.a.cookie.set('bxe-logged-out', '1', {
        expireDays: 365,
        sameSite: 'none',
        secure: true,
        domain: 'boxcast.com'
      });
      location.replace(LOGOUT_URL);
      throw new Error('halt');
    }
  }]);

  return AuthService;
}(); // Register the service with angular


angular.module('app.auth').service('AuthService', AuthService);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(13);

angular.module('app.auth').config(function ($httpProvider) {
  'ngInject';

  $httpProvider.interceptors.push(function ($q, $window, $injector) {
    return {
      request: function request(config) {
        var token = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* getAuthToken */])();

        if (!token) {
          Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* gotoLogin */])('from interceptor missing token');
        }

        if (config.url.startsWith('http://localhost:3000')) {
          config.headers['Authorization'] = "Bearer user";
        } else if (config.headers['Ignore-Http-Interceptor-Auth'] || config.url.match('^https?://.*s3.amazonaws.com/.*')) {// Some requests need to be in public scope, use this header
          // to indiciate request to ignore the auto-injection
        } else {
          config.headers['Authorization'] = "Bearer ".concat(token);
        }

        return config;
      },
      responseError: function responseError(rejection) {
        if (rejection.status == 401 && rejection.data && rejection.data.error == 'invalid_token') {
          Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* gotoLogin */])('from interceptor 401');
        }

        return $q.reject(rejection);
      }
    };
  });
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__(302);

__webpack_require__(309); // create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons


var module = angular.module('app.directives', ['app.directives.checkout', 'app.directives.schedule']); // The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.

__webpack_require__(336);

__webpack_require__(337);

__webpack_require__(338);

__webpack_require__(339);

__webpack_require__(340);

__webpack_require__(342);

__webpack_require__(343);

__webpack_require__(344);

__webpack_require__(345);

__webpack_require__(346);

__webpack_require__(347);

__webpack_require__(348);

__webpack_require__(349);

__webpack_require__(350);

__webpack_require__(351);

__webpack_require__(352);

__webpack_require__(353);

__webpack_require__(354);

__webpack_require__(198);

__webpack_require__(355);

__webpack_require__(356);

__webpack_require__(357);

__webpack_require__(359);

__webpack_require__(361);

__webpack_require__(363);

__webpack_require__(365);

__webpack_require__(366);

__webpack_require__(367);

__webpack_require__(368);

__webpack_require__(369);

__webpack_require__(371);

__webpack_require__(372);

__webpack_require__(373);

__webpack_require__(374);

__webpack_require__(378);

__webpack_require__(379);

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.directives.checkout', []);

__webpack_require__(303);

__webpack_require__(304);

__webpack_require__(305);

__webpack_require__(306);

__webpack_require__(307);

__webpack_require__(308);

/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 303 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutAddOns', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: ["$scope", function controller($scope) {
      $scope.scoreboardAssistQuantity = 0;
    }],
    template: "\n        <div class=\"pricing-col encoder-options\" style=\"margin-bottom: 15px;\">\n          <div class=\"add-on-container\">\n            <div ng-repeat=\"addOn in vm.addOns\">\n              <p class=\"price\" style=\"text-align: right;\" ng-hide=\"addOn.monthlyCost == 0\">{{ addOn.monthlyCost | currency }}/mo.\n              <span ng-hide=\"addOn.priceSubtext == ''\" style=\"font-size:12px; font-weight:normal\"><br>{{ addOn.priceSubtext }}</span></p>\n              <div class=\"checkbox\" style=\"margin-bottom:25px\" ng-if=\"vm.checkPlanRequirements(addOn.requirements.plan) && vm.checkEncoderRequirements(addOn.requirements.encoder)\">\n              <label ng-if=\"addOn.enabled\">\n                    <input type=\"checkbox\" name=\"{{ addOn.title }}\" ng-model=\"addOn.selected\" ng-value=\"addOn.title\">\n                    {{ addOn.title }}\n                </label>\n                <label ng-if=\"!addOn.enabled\" style=\"cursor: not-allowed\">\n                  <input type=\"checkbox\" name=\"{{ addOn.title }}\" ng-model=\"addOn.selected\" ng-value=\"addOn.title\" ng-disabled=\"true\">\n                  {{ addOn.title }}\n                </label>\n                <div class=\"subtext\" ng-if=\"addOn.enabled\">{{ addOn.description }}</div>\n                <div class=\"subtext\" ng-if=\"!addOn.enabled\">{{ addOn.description }} <br>                  \n                  <a href=\"javascript://\" ng-click=\"vm.popChatOrSchedule()\">Contact sales for help getting this add-on.</a>\n                </div>\n                <div class=\"subtext\" style=\"font-weight: bold; margin-top:8px;\" ng-if=\"addOn.costPerStream\">This add-on applies to all streams in a plan.</div>\n                <div ng-if=\"addOn.selected && addOn.quantityInput \" class=\"subtext add-on-quantity\">\n                  <input type=\"number\" name=\"{{ addOn.varName }}_quantity\" step=\"1\" ng-model=\"addOn.quantity\" min=\"1\" max=\"10\">\n                  <div class=\"small-text\"><span style=\"font-weight:bold;\">{{addOn.quantityInputHeadline}}</span><br>\n                  {{addOn.quantityInputText[vm.selectedBasePlan]}}</div>\n                </div>\n                <div ng-if=\"addOn.selected && addOn.varName == 'scoreboard'\">\n                  <div class=\"subtext add-on-quantity\">\n                    <input type=\"number\" name=\"{{ addOn.varName }}_quantity\" step=\"1\" ng-model=\"addOn.oneTimeCost.quantity\" min=\"1\" max=\"10\">\n                    <div class=\"small-text\">\n                      <span style=\"font-weight:bold;\">{{addOn.quantityInputHeadline}}</span><br>\n                      {{addOn.quantityInputText[vm.selectedBasePlan]}}<br>\n                      <div class=\"text-danger\" style=\"padding-left:0;\">{{vm.scoreboardAssistProduct.checkout_message}}</div>\n                    </div>\n                  </div>\n                </div>\n                <div ng-if=\"addOn.varName == 'scoreboard'\" class=\"subtext add-on-alert\">\n                  <div>Sign up for BoxCast\u2019s Automatic Scoreboard Overlays and receive your first Scoreboard Assist free! Additional devices are $599 each.</div>\n                </div>\n              </div>\n                <div class=\"checkbox\" style=\"margin-bottom:25px\" ng-if=\"!vm.checkPlanRequirements(addOn.requirements.plan) || !vm.checkEncoderRequirements(addOn.requirements.encoder)\">\n                  <label>\n                  <input type=\"checkbox\" name=\"add_scoreboard\" ng-model=\"vm.addScoreboard\" value=\"add_scoreboard\" ng-disabled=\"true\" disabled=\"disabled\">\n                  {{ addOn.title }}\n                  </label>\n                <div class=\"subtext\">{{ addOn.description }}</div>\n                <div class=\"subtext text-danger\">{{addOn.title}} requires:</div>\n                <ul class=\"text-danger\">\n                    <li class=\"subtext\" ng-if=\"!vm.checkPlanRequirements(addOn.requirements.plan)\">The Experience Plan <span ng-click=\"vm.goto(1)\"><a href=\"javascript://\">Switch to The Experience Plan</a></span></li>\n                    <li class=\"subtext\" ng-if=\"!vm.checkEncoderRequirements(addOn.requirements.encoder)\">A BoxCaster or BoxCaster Pro <span ng-click=\"vm.goto(2)\"><a href=\"javascript://\">Add a BoxCaster</a></span></li>\n                </ul>\n              </div>\n            </div>\n          </div>\n        </div> "
  };
});

/***/ }),
/* 304 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutBillingAddress', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    template: "\n<div class=\"form-group\">\n  <label for=\"address\" class=\"control-label\">Street Address</label>\n  <input ng-model=\"vm.billing.address\" id=\"bill_address\" name=\"address\" type=\"text\" class=\"form-control\" autocomplete=\"address\" placeholder=\"\" required>\n</div>\n<div class=\"row\">\n  <div class=\"col-md-6\">\n    <div class=\"form-group\">\n      <label for=\"city\" class=\"control-label\">City</label>\n      <input ng-model=\"vm.billing.city\" id=\"city\" name=\"city\" type=\"text\" class=\"form-control\" autocomplete=\"city\" placeholder=\"\" required>\n    </div>\n  </div>\n  <div class=\"col-md-6\">\n    <div class=\"form-group\">\n      <label for=\"state\" class=\"control-label\">State/Region</label>\n      <input ng-if=\"vm.billing.country != 'US'\"\n              ng-model=\"vm.billing.state\" id=\"state\" name=\"state\" type=\"text\" class=\"form-control\" autocomplete=\"state\" placeholder=\"\" required>\n      <select ng-if=\"vm.billing.country == 'US'\"\n              ng-model=\"vm.billing.state\"\n              ng-options=\"c.code as c.name for c in vm.states\"\n              id=\"state\" name=\"state\" class=\"form-control\" required>\n      </select>\n    </div>\n  </div>\n</div>\n<div class=\"row\">\n  <div class=\"col-md-6\">\n    <div class=\"form-group\">\n      <label for=\"zip\" class=\"control-label\">Postal Code</label>\n      <input ng-model=\"vm.billing.postal_code\"\n             id=\"zip\" name=\"zip\" type=\"text\" class=\"form-control\" autocomplete=\"zip\" placeholder=\"\" required>\n      <p ng-show=\"vm.salesTaxCents > 0\" class=\"help-block\">\n        Sales tax on the hardware purchase is required for this zip code. Your total has been updated to reflect this charge.\n      </p>\n    </div>\n  </div>\n  <div class=\"col-md-6\">\n    <div class=\"form-group\">\n      <label for=\"country\" class=\"control-label\">Country</label>\n      <select ng-model=\"vm.billing.country\"\n              ng-init=\"vm.billing.country = vm.billing.country || 'US'\"\n              ng-options=\"c.code as c.name for c in vm.countries\"\n              id=\"country\" name=\"country\" class=\"form-control\" required>\n      </select>\n    </div>\n  </div>\n</div>\n      "
  };
});

/***/ }),
/* 305 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutFinal', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: ["$scope", function controller($scope) {}],
    template: "\n    <div class=\"col-xs-12 text-center\" ng-show=\"vm.waitingForFinalization\">\n      <h3 style=\"margin-bottom:20px\">Please wait while we finalize your account</h3>\n      <p class=\"help-block\" style=\"font-size:1.4em;margin:40px 0;\">\n        <i class=\"fa fa-spin fa-spinner\"></i> Finalizing\n      </p>\n      <p class=\"help-block\" style=\"font-size:16px;margin-bottom:50px\">\n        Sit tight. It should only take a few more moments while we put the finishing touches on your account...\n      </p>\n    </div>\n    <div class=\"col-xs-12 text-center\" ng-hide=\"vm.waitingForFinalization\">\n      <div ng-show=\"vm.method == 'check' || vm.method == 'po'\">\n        <h3 style=\"margin-bottom:20px\">Thank you for completing your account setup.</h3>\n        <div class=\"bg-info text-info\" style=\"padding:10px;border-radius:4px;font-size:15px;margin:15px auto;max-width:300px;\">\n          <p ng-if=\"vm.method == 'check'\">Make checks payable to <strong>BoxCast</strong> and mail to:</p>\n          <p ng-if=\"vm.method == 'po'\">\n            Send in your purchase order by email to\n            <strong><a href=\"mailto:billing@boxcast.com\" target=\"_blank\">billing@boxcast.com</a></strong> or mail to:</p>\n            <strong>\n              BoxCast<br>\n              Attn: Payments Dept<br>\n              2401 Superior Viaduct<br>\n              Cleveland, OH 44113\n            </strong>\n          </p>\n        </div>\n        <p style=\"font-size:16px\">Once your payment is received, your account will be fully activated.</p>\n      </div>\n\n      <div ng-hide=\"vm.method == 'check' || vm.method == 'po'\">\n        <h3 style=\"margin-bottom:20px\">Welcome to BoxCast! You're now ready to stream!</h3>\n        <img src=\"/img/onboarding-celebrate.png\" style=\"width:40%\">\n      </div>\n\n      <p style=\"font-size:16px;margin:15px 100px 30px 100px;\">\n        If you have any questions, visit our\n        <a href=\"https://support.boxcast.com\" target=\"_blank\" style=\"border-bottom:1px solid;\">Support Center</a>\n        or connect with one of our live streaming experts. We're always here to help!\n      </p>\n\n      <a class=\"btn btn-primary btn-lg\" ng-click=\"vm.dismiss()\" style=\"margin-bottom:20px\">\n        Let's Go!\n      </a>\n    </div>\n"
  };
});

/***/ }),
/* 306 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutOrderSummary', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: ["$scope", function controller($scope) {
      var orderSummaryContainer = document.getElementById('order-summary-container');
      var SUMMARY_CONTAINER_CSS_MAX_HEIGHT = 182;

      $scope.scrollUp = function () {
        orderSummaryContainer.scrollBy(0, -20);
      };

      $scope.scrollDown = function () {
        orderSummaryContainer.scrollBy(0, 20);
      };

      $scope.scrollDownDisabled = function () {
        if (orderSummaryContainer.scrollHeight - orderSummaryContainer.scrollTop === orderSummaryContainer.clientHeight) {
          return true;
        }

        return false;
      };

      $scope.scrollUpDisabled = function () {
        $scope.summaryScrollTop = orderSummaryContainer.scrollTop;

        if ($scope.summaryScrollTop > 0) {
          return false;
        }

        return true;
      };

      $scope.scrollDisabled = function () {
        if (orderSummaryContainer.scrollHeight < SUMMARY_CONTAINER_CSS_MAX_HEIGHT) {
          return false;
        }

        return true;
      };
    }],
    template: "\n          <div style=\"border: 1px #ddd solid; border-radius:4px;padding:10px;\" class=\"order-summary\">\n            <div class=\"order-summary-head\">\n              <p class=\"text-left\" style=\"font-size:16px\">\n                Order Summary\n              </p>\n              <div class=\"order-summary-scroll btn-group btn-breadcrumb\" ng-if=\"scrollDisabled()\">\n                <button class=\"btn btn-xs btn-default\" ng-click=\"scrollUp()\" ng-disabled=\"scrollUpDisabled()\">\n                  <i class=\"fa fa-caret-up\"></i>\n                </button>\n                <button class=\"btn btn-xs btn-default\" ng-click=\"scrollDown()\" ng-disabled=\"scrollDownDisabled()\">\n                  <i class=\"fa fa-caret-down\"></i>\n                </button>\n              </div>\n            </div>\n            <div id=\"order-summary-container\">\n              <table class=\"table order-summary-table\" style=\"margin-bottom:0\">\n                <tbody>\n                  <tr>\n                    <th>BoxCast <span style=\"text-transform:capitalize\">{{vm.selectedBasePlan}}</span> Plan (Streaming Subscription)</th>\n                    <td class=\"text-right\">\n                      {{vm.selectedBasePlanAmount() | currency}}\n                    </td>\n                  </tr>\n                  <tr ng-if=\"vm.selectedEncoder == 'app'\">\n                    <th>Broadcaster App\n                      <div class=\"checkout-message\">Free download from the App Store</div>\n                    </th>\n                    <td class=\"text-right\">$0.00</td>\n                  </tr>\n                  <tr ng-if=\"vm.selectedEncoder == 'boxcaster'\">\n                    <th>BoxCaster<span ng-if=\"vm.boxcasterProduct.checkout_message\" class=\"checkout-message\"><br>{{vm.boxcasterProduct.checkout_message}}</span></th>\n                    <td class=\"text-right\">$399.00</td>\n                  </tr>\n                  <tr ng-if=\"vm.selectedEncoder == 'pro'\">\n                    <th>BoxCaster Pro<span ng-if=\"vm.boxcasterProProduct.checkout_message\" class=\"checkout-message\"><br>{{vm.boxcasterProProduct.checkout_message}}</span></th>\n                    <td class=\"text-right\">$2,995.00</td>\n                  </tr>\n                  <tr ng-if=\"vm.shurePromoApplied\">\n                    <th>Promo: FREE Shure MV88+ Video Kit</th>\n                    <td class=\"text-right\"><strike>$288.00</strike> FREE</td>\n                  </tr>\n                  <tr ng-repeat=\"addOn in vm.addOns\" ng-if=\"addOn.selected\">\n                    <th>{{ addOn[\"title\"] }}</th>\n                    <td class=\"text-right\">\n                      {{ vm.checkAddOnPrice(addOn) | currency }}\n                    </td>\n                  </tr>\n                  <tr ng-if=\"vm.addOns.scoreboard.selected\">\n                    <th>Scoreboard Assist <br> (First FREE) <span ng-if=\"vm.scoreboardAssistProduct.checkout_message\" class=\"checkout-message\"><br>{{vm.scoreboardAssistProduct.checkout_message}}</span></th>\n                    <td class=\"text-right\" ng-if=\"vm.addOns.scoreboard.oneTimeCost.quantity == 1\"><del>$599</del></td>\n                    <td class=\"text-right\" ng-if=\"vm.addOns.scoreboard.oneTimeCost.quantity > 1\">\n                      {{ vm.scoreboardAssistPrice(vm.addOns.scoreboard.oneTimeCost.quantity) | currency }}</td>\n                  </tr>\n                  <tr ng-if=\"vm.addOns.smartTVApps.selected\">\n                    <th>Smart TV App Setup</th>\n                    <td class=\"text-right\">$1000</td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>"
  };
});

/***/ }),
/* 307 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutPaymentMethod', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: ["$scope", "$rootScope", function controller($scope, $rootScope) {
      $scope.allowMonthlyChecks = $rootScope.account.extra_features.allow_monthly_checks;
    }],
    template: "\n<div class=\"row text-center\">\n  <div class=\"col-xs-6\" style=\"margin-bottom:10px;\">\n    <button type=\"button\"\n            class=\"btn btn-lg btn-default btn-block\"\n            ng-class=\"vm.method == 'cc' ? 'btn-payment-selected' : 'btn-payment'\"\n            ng-click=\"vm.onSelectPaymentMethod('cc')\">\n      <i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i><br>\n      Credit Card\n    </button>\n  </div>\n  <div class=\"col-xs-6\" style=\"margin-bottom:10px\">\n    <button type=\"button\"\n            class=\"btn btn-lg btn-default btn-block\"\n            ng-class=\"vm.method == 'ach' ? 'btn-payment-selected' : 'btn-payment'\"\n            ng-click=\"vm.onSelectPaymentMethod('ach')\">\n      <i class=\"fa fa-university\" aria-hidden=\"true\"></i><br>\n      Bank / ACH\n    </button>\n  </div>\n  <a ng-if=\"!vm.showAllPaymentOptions\" ng-hide=\"vm.selectedInterval == 'monthly' && !allowMonthlyChecks\" href=\"javascript://\"\n    class=\"pull-left\"\n    ng-click=\"vm.showAllPaymentOptions = true\"\n    style=\"font-size:10pt;padding-left:25px\">\n    More Payment Options\n  </a>\n  <div ng-if=\"vm.showAllPaymentOptions\">\n    <div class=\"col-xs-6\" style=\"margin-bottom:10px\">\n      <button type=\"button\"\n              class=\"btn btn-lg btn-default btn-block\"\n              ng-class=\"vm.method == 'po' ? 'btn-payment-selected' : 'btn-payment'\"\n              ng-click=\"vm.onSelectPaymentMethod('po')\">\n        <i class=\"fa fa-envelope-o\" aria-hidden=\"true\"></i><br>\n        Purchase Order\n      </button>\n    </div>\n    <div class=\"col-xs-6\" style=\"margin-bottom:10px\">\n      <button type=\"button\"\n              class=\"btn btn-lg btn-default btn-block\"\n              ng-class=\"vm.method == 'check' ? 'btn-payment-selected' : 'btn-payment'\"\n              ng-click=\"vm.onSelectPaymentMethod('check')\">\n        <i class=\"fa fa-money\" aria-hidden=\"true\"></i><br>\n        Check\n      </button>\n    </div>\n  </div>\n</div>\n<div ng-if=\"vm.method == 'cc'\">\n  <h3>Credit Card Details</h3>\n  <div ng-if=\"!vm.cardOnFile\">\n    <div class=\"form-control\"\n      style=\"height:38px;padding-top:10px;\"\n      ng-init=\"vm.stripeCard.mount('#stripe-elements-card')\">\n      <div id=\"stripe-elements-card\"></div>\n    </div>\n  </div>\n  <div ng-if=\"vm.cardOnFile\" style=\"margin:0 20px\">\n    <radio-button-well heading=\"Use Card On File\"\n                      is-selected=\"!vm.addNewCard\"\n                      on-select=\"vm.addNewCard = false\"\n                      always-show-transclude=\"true\">\n      <i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i> {{vm.cardOnFile.brand}} **** **** **** {{vm.cardOnFile.last4}}\n    </radio-button-well>\n    <radio-button-well heading=\"Add New Card\"\n                      is-selected=\"vm.addNewCard == true\"\n                      on-select=\"vm.addNewCard = true\">\n      <div class=\"form-control\"\n        style=\"height:38px;padding-top:10px;margin-bottom:15px;\"\n        ng-init=\"vm.stripeCard.mount('#stripe-elements-card')\">\n        <div id=\"stripe-elements-card\"></div>\n      </div>\n    </radio-button-well>\n  </div>\n</div>\n\n<div ng-if=\"vm.method == 'ach'\">\n  <h3>Bank Account Details</h3>\n  <div style=\"margin:0 20px\">\n    <div ng-if=\"vm.bankOnFile\">\n      <radio-button-well heading=\"Use Account On File\"\n                      is-selected=\"!vm.addNewBankAccount\"\n                      on-select=\"vm.addNewBankAccount = false\"\n                      always-show-transclude=\"true\">\n        <i class=\"fa fa-university\" aria-hidden=\"true\"></i> {{vm.bankOnFile.bank_name}} **** **** **** {{vm.bankOnFile.last4}}\n      </radio-button-well>\n    </div>\n    <radio-button-well heading=\"Link New Bank (ACH) Account\"\n                      is-selected=\"vm.addNewBankAccount == true\"\n                      on-select=\"vm.openPlaid()\">\n      <div ng-if=\"vm.newBankOnFile\">\n        <i class=\"fa fa-university\" aria-hidden=\"true\"></i> {{vm.newBankOnFile.bank_name}} **** **** **** {{vm.newBankOnFile.last4}}\n      </div>\n    </radio-button-well>\n  </div>\n</div>\n\n<div ng-if=\"vm.isUpgrade && (vm.method == 'cc' || vm.method == 'ach')\">\n  <p ng-if=\"vm.isChangingPaymentSource() && !vm.allowDefaultPaymentSourceOverride()\" style=\"margin:10px 0 0 0\">\n    This source will become your account's default payment source for all future invoices.\n  </p>\n  <p ng-if=\"vm.isChangingPaymentSource() && vm.allowDefaultPaymentSourceOverride()\" style=\"margin:0\">\n    <label style=\"margin-top:10px\">\n      <input name=\"change_default_payment_source\"\n              type=\"checkbox\"\n              ng-model=\"vm.changeDefaultPaymentSource\"\n              ng-init=\"vm.changeDefaultPaymentSource = true\">\n      Make this my default payment source for all future invoices.\n    </label>\n  </p>\n</div>\n\n<div class=\"bg-info text-info\" ng-if=\"vm.method == 'check' || vm.method == 'po' || vm.method == 'ach'\"\n      style=\"padding:15px;border-radius:4px;margin-top:20px;\">\n  <i class=\"fa fa-info-circle\"></i>\n  <span ng-if=\"vm.method == 'ach'\">\n    Bank / ACH payments take up to 7 days to process. \n  </span>\n  <span>\n    Your purchase will not be finalized and any hardware in your order will not be shipped until payment is received. \n  </span>\n  <span ng-if=\"vm.isTrial\">\n    This could result in your account becoming <b>inactive</b> once your trial expires.\n  </span>\n</div>\n      "
  };
});

/***/ }),
/* 308 */
/***/ (function(module, exports) {

angular.module('app.directives.checkout').directive('checkoutShippingAddress', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    template: "\n<div style=\"margin:15px 0;\">\n  <input ng-model=\"vm.shippingSameAsBilling\"\n          ng-init=\"vm.shippingSameAsBilling = true\"\n          type=\"checkbox\"\n          name=\"shipping_same_as_billing\">\n    Shipping address is same as billing.\n</div>\n<div ng-if=\"!vm.shippingSameAsBilling\">\n  <div class=\"form-group\">\n    <label for=\"address\" class=\"control-label\">Street Address</label>\n    <input ng-model=\"vm.shipping.address\" id=\"bill_address\" name=\"address\" type=\"text\" class=\"form-control\" autocomplete=\"address\" placeholder=\"\" required>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-6\">\n      <div class=\"form-group\">\n        <label for=\"city\" class=\"control-label\">City</label>\n        <input ng-model=\"vm.shipping.city\" id=\"city\" name=\"city\" type=\"text\" class=\"form-control\" autocomplete=\"city\" placeholder=\"\" required>\n      </div>\n    </div>\n    <div class=\"col-xs-6\">\n      <div class=\"form-group\">\n        <label for=\"state\" class=\"control-label\">State/Region</label>\n        <input ng-if=\"vm.shipping.country != 'US'\"\n                ng-model=\"vm.shipping.state\" id=\"state\" name=\"state\" type=\"text\" class=\"form-control\" autocomplete=\"state\" placeholder=\"\" required>\n        <select ng-if=\"vm.shipping.country == 'US'\"\n                ng-model=\"vm.shipping.state\"\n                ng-options=\"c.code as c.name for c in vm.states\"\n                id=\"state\" name=\"state\" class=\"form-control\" required>\n        </select>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-6\">\n      <div class=\"form-group\">\n        <label for=\"zip\" class=\"control-label\">Postal Code</label>\n        <input ng-model=\"vm.shipping.postal_code\" id=\"zip\" name=\"zip\" type=\"text\" class=\"form-control\" autocomplete=\"zip\" placeholder=\"\" required>\n      </div>\n    </div>\n    <div class=\"col-xs-6\">\n      <div class=\"form-group\">\n        <label for=\"country\" class=\"control-label\">Country</label>\n        <select ng-model=\"vm.shipping.country\"\n                ng-init=\"vm.shipping.country = vm.shipping.country || 'US'\"\n                ng-options=\"c.code as c.name for c in vm.countries\"\n                id=\"country\" name=\"country\" class=\"form-control\" required>\n        </select>\n      </div>\n    </div>\n  </div>\n</div>\n      "
  };
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.directives.schedule', []);

__webpack_require__(310);

__webpack_require__(312);

__webpack_require__(313);

__webpack_require__(315);

__webpack_require__(317);

__webpack_require__(319);

__webpack_require__(321);

__webpack_require__(323);

__webpack_require__(325);

__webpack_require__(327);

__webpack_require__(329);

__webpack_require__(330);

__webpack_require__(332);

__webpack_require__(334);

/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["controller"] = controller;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__ = __webpack_require__(23);

angular.module('app.directives.schedule').directive('broadcastOverlayConfiguration', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    template: __webpack_require__(311),
    controller: controller
  };
});

function renderSelectizeOption(wrapperCssClass) {
  return function (item, escape) {
    var html = "<div class=\"".concat(wrapperCssClass, "\" style=\"vertical-align: middle;\">");
    html += "<div style=\"display: inline-flex; float: left; width: 32px; height: 32px; margin-right: 6px;\">";

    if (item.value.type == 'scoreboard') {
      html += '<img src="/img/sports/scoreboard_icon.svg">';
    } else if (item.value.type == 'overlay') {
      html += '<img src="/img/sports/overlay_icon.svg">';
    }

    html += "</div>";
    html += "<div class=\"overflow-ellipse\" style=\"line-height:32px;\">".concat(item.name, "</div></div>");
    return html;
  };
}

function controller($scope, $timeout) {
  'ngInject';

  var vm = $scope.vm; // Use `sc` as a shortcut in controller and template

  $scope.sc = vm.service.broadcast.scoreboard_configuration;
  $scope.canDoOverlays = vm.service.FeatureFlags.overlays && vm.service.user.can('update', 'broadcast/*:metadata/overlays');
  $scope.options = {
    dropdown: [],
    selected: null,
    showScoreboardConfiguration: !!$scope.sc.sport,
    showOverlayConfiguration: !!(vm.service.broadcast.metadata.overlays || []).length
  };

  if (vm.service.showAnyScoreboards) {
    $scope.options.dropdown.push({
      name: 'Manual or Automatic Scoring',
      value: {
        type: 'scoreboard'
      }
    });
    $scope.options.dropdown.forEach(function (a) {
      return a.valueJson = JSON.stringify(a.value);
    });
  }

  $scope.$watch(function () {
    return vm.service.allowDefaultOverlay && vm.overlays && vm.overlays.length > 0;
  }, function (allowed) {
    if (allowed) {
      $scope.options.dropdown.push({
        name: 'Default Graphic Overlay (e.g. Logo or Branding)',
        value: {
          type: 'overlay'
        }
      });
      $scope.options.dropdown.forEach(function (a) {
        return a.valueJson = JSON.stringify(a.value);
      });
    }
  });
  var selectizeConfigBase = {
    valueField: 'valueJson',
    labelField: 'name',
    highlight: true,
    searchField: 'name',
    selectOnTab: true,
    closeAfterSelect: true,
    maxItems: 1,
    render: {
      option: renderSelectizeOption('source-chooser--option'),
      item: renderSelectizeOption('source-chooser--selected')
    },
    onInitialize: function onInitialize(selectize) {
      $scope.selectize = selectize;
    },
    onChange: function onChange(value) {
      if (!value) return;
      value = JSON.parse(value);
      $timeout(function () {
        if (value.type == 'scoreboard') {
          $scope.options.showScoreboardConfiguration = true;
        } else if (value.type == 'overlay') {
          $scope.options.showOverlayConfiguration = true;
        } else {
          console.warn('invalid item selected: ', value);
        }
      }, 0);
      $scope.selectize.clear();
      $timeout(function () {
        $scope.options.selected = null;
      }, 500);
    }
  };
  $scope.selectizeConfig = angular.extend({
    placeholder: 'Select Scoreboard and/or Graphic Overlay...'
  }, selectizeConfigBase);

  $scope.clearScoreboardConfig = function () {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__["a" /* clearScoreboardConfig */])($scope.sc);
    $scope.options.showScoreboardConfiguration = false;
  };

  $scope.clearOverlayConfig = function () {
    delete vm.service.broadcast.metadata.overlays;
    $scope.options.showOverlayConfiguration = false;
  };
}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"::canDoOverlays\" class=\"form-group clearfix\">\n  <label class=\"col-sm-4\">\n    Overlays\n    <i class=\"fa fa-question-circle\" style=\"font-size:12px;vertical-align:top\" uib-tooltip=\"Add a scoreboard overlay or default cloud graphic overlay to your broadcast\"></i>\n  </label>\n  <div class=\"col-sm-8 text-left\">\n    <select selectize ng-model=\"options.selected\" options=\"options.dropdown\" config=\"selectizeConfig\"></select>\n  </div>\n</div>\n\n<div ng-if=\"options.showScoreboardConfiguration || options.showOverlayConfiguration\">\n  <div class=\"form-group clearfix\" style=\"border-top:1px solid #eee\"></div>\n</div>\n\n<div ng-if=\"options.showScoreboardConfiguration\" class=\"form-group clearfix\" style=\"padding-bottom:15px; border-bottom:1px solid #eee;\">\n  <div class=\"col-sm-4\" style=\"padding-top:15px;font-weight:bold\">\n    <button type=\"button\" ng-click=\"clearScoreboardConfig()\" aria-label=\"Remove scoreboard configuration\" class=\"btn-link\" style=\"color:#999;font-weight:100;\">\n      <i class=\"fa fa-times\"></i>\n    </button> Scoreboard\n  </div>\n  <div class=\"col-sm-8\">\n    <scoreboard-tab-config vm=\"vm\" sc=\"sc\"></scoreboard-tab-config>\n  </div>\n</div>\n\n<div ng-if=\"options.showOverlayConfiguration\" class=\"form-group clearfix\" style=\"padding-bottom:15px; border-bottom:1px solid #eee;\">\n  <div class=\"col-sm-4\" style=\"padding-top:15px;font-weight:bold\">\n    <button type=\"button\" ng-disabled=\"vm.service.broadcast.id\" ng-click=\"clearOverlayConfig()\" aria-label=\"Remove overlay configuration\" class=\"btn-link\" style=\"color:#999;font-weight:100;\">\n      <i class=\"fa fa-times\"></i>\n    </button> Graphic Overlay\n  </div>\n  <div class=\"col-sm-8\">\n    <div class=\"form-group\" ng-if=\"vm.service.broadcast.id\">\n      <p class=\"help-block\">Please use the Overlays tab on the broadcast details page to edit your graphic overlays</p>\n    </div>\n    <div class=\"form-group\" ng-if=\"!vm.service.broadcast.id\">\n      <select class=\"form-control\"\n              ng-model=\"vm.selectedOverlay\"\n              ng-options=\"o as o.filename for o in vm.overlays\"\n              ng-change=\"vm.selectOverlay(vm.selectedOverlay)\">\n      </select>\n      <p class=\"help-block\" ng-show=\"vm.processingOverlay\">\n        <em>Processing overlay. Please wait...</em>\n      </p>\n      <overlay-preview ng-show=\"vm.service.broadcast.metadata.overlays.length\" overlay=\"vm.service.broadcast.metadata.overlays[0]\"></overlay-preview>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__ = __webpack_require__(23);

angular.module('app.directives.schedule').directive('broadcastSelectScoreboardConnection', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: function controller($scope, $rootScope) {
      'ngInject';

      var vm = $scope.vm;
      $scope.options = __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__["b" /* getUIConnections */]($rootScope.account);
      var selectizeConfigBase = {
        valueField: 'value',
        labelField: 'label',
        highlight: true,
        searchField: 'label',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option'),
          item: renderSelectizeOption('source-chooser--selected')
        }
      };
      $scope.selectizeConfig = angular.extend({
        placeholder: 'Select the Hardware Sending the Score Data...'
      }, selectizeConfigBase);
    },
    template: "\n      <div class=\"form-group\">\n        <label>Scoreboard Connection</label>\n        <select selectize ng-model=\"vm.service.broadcast.scoreboard_configuration.connection\" options=\"options\" config=\"selectizeConfig\"></select>\n      </div>\n      "
  };
});

function renderSelectizeOption(wrapperCssClass) {
  return function (item, escape) {
    var html = "<div class=\"selectize-option ".concat(wrapperCssClass, "\">");
    html += "<div class=\"selectize-option__icon-wrapper\">";

    if (item.icon) {
      html += '<img class="selectize-option__icon" src="' + item.icon + '">';
    }

    html += "</div>";
    html += "<div class=\"selectize-option__content\">";
    html += "<div class=\"selectize-option__label-wrapper\">";
    html += "<strong class=\"selectize-option__label\">".concat(item.label, "</strong>");

    if (item.is_new) {
      html += "<span class=\"selectize-option__label-indicator text-bx-green font-bold\">(NEW)</span>";
    }

    html += "</div>";
    html += "<small class=\"selectize-option__description\">".concat(item.description, "</small>");
    html += "</div>"; // end .selectize-option__content

    html += "</div>";
    return html;
  };
}

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__ = __webpack_require__(23);

angular.module('app.directives.schedule').directive('broadcastSelectSport', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '='
    },
    controller: function controller($scope) {
      'ngInject';

      $scope.scoreboard_configuration = $scope.vm.service.broadcast.scoreboard_configuration;
      $scope.sports = __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__["c" /* getUISports */]();

      $scope.onChange = function (value) {
        __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__["f" /* updateSportFromPrefix */]($scope.scoreboard_configuration, value);
        $scope.vm.service.updateScoreboardMakes();
      };
    },
    template: __webpack_require__(314)
  };
});

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <div class=\"sport-tiles\">\n    <div \n      class=\"sport-tile\"\n      ng-repeat=\"s in ::sports\" ng-if=\"s.value != 'Basketball (4 Quarters)'\"\n    >\n      <button \n        class=\"sport-tile__inner btn btn-default btn-block\"\n        type=\"button\" \n        ng-click=\"onChange(s.value)\"\n        ng-class=\"scoreboard_configuration.sport_prefix == s.value ? 'active' : ''\"\n      >\n        <img class=\"sport-tile__icon\" ng-src=\"{{::s.icon}}\">\n        <small class=\"sport-tile__label\">{{::s.label}}</small>\n      </button>\n    </div>\n  </div>\n  <div class=\"form-group\" ng-if=\"scoreboard_configuration.sport_prefix == 'Basketball'\">\n    <label>Basketball Game Format</label>\n    <div>\n      <div class=\"btn-group\">\n        <label class=\"btn btn-default\" ng-model=\"scoreboard_configuration.sport_variation\" uib-btn-radio=\"' (4 Quarters)'\">4 Quarters</label>\n        <label class=\"btn btn-default\" ng-model=\"scoreboard_configuration.sport_variation\" uib-btn-radio=\"' (2 Halves)'\">2 Halves</label>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('broadcastTeamColorPicker', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      team: '@',
      label: '@'
    },
    template: __webpack_require__(316),
    controller: ["$scope", "$rootScope", function controller($scope, $rootScope) {
      'ngInject';

      var account = $rootScope.account;
      $scope.colors = account.extra_features.scoreboard_spectrum ? SPECTRUM_COLOR_PALETTE : STANDARD_COLOR_PALETTE;

      $scope.select = function (color) {
        $scope.vm.service.broadcast.scoreboard_configuration[$scope.team + '_team_logo'] = color;
      };
    }]
  };
});

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "<label>{{label}}</label>\n\n<div class=\"btn-group btn-block\" style=\"overflow:hidden\" uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body>\n  <button type=\"button\" class=\"btn btn-default btn-block btn-color-picker\" uib-dropdown-toggle\n    style=\"text-shadow: rgb(0, 0, 0) 0px 0px 3px; color: rgb(255, 255, 255);\"\n    ng-style=\"{\n      'background-color': vm.service.broadcast.scoreboard_configuration[team+'_team_logo']\n    }\">\n    <span style=\"white-space:pre;font-family:monospace;\">{{vm.service.broadcast.scoreboard_configuration[team+'_team_name'] | scoreboardTeamName}}</span>\n    <span class=\"caret\"></span>\n  </button>\n  <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-button\"\n                                                          style=\"width:300px;z-index:1060\"><!-- z-index needs to be higher than uib-modal -->\n    <li role=\"menuitem\" class=\"clearfix\">\n      <div class=\"col-xs-6\">\n        <label>Team Name</label>\n        <input class=\"form-control\" ng-model=\"vm.service.broadcast.scoreboard_configuration[team+'_team_name']\">\n      </div>\n      <div class=\"col-xs-6\">\n        <label>Color Code</label> <i class=\"fa fa-pencil\" ng-click=\"allowEditing = !allowEditing\"></i>\n        <input class=\"form-control\" ng-disabled=\"!allowEditing\" ng-model=\"vm.service.broadcast.scoreboard_configuration[team+'_team_logo']\">\n      </div>\n    </li>\n    <li role=\"menuitem\">\n      <div class=\"clearfix\" style=\"padding:5px 0 0 5px; margin-top:15px;\">\n        <div ng-repeat=\"(c, label) in ::colors\" class=\"col-xs-4\" style=\"width:14.28%; padding:0 5px 5px 0\">\n          <a href ng-click=\"select(c)\">\n            <div style=\"background-color:{{c}};height:20px;\"></div>\n          </a>\n        </div>\n      </div>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('fbLiveSimulcastSettings', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '='
    },
    template: __webpack_require__(318),
    controller: ["$scope", "$filter", function controller($scope, $filter) {
      'ngInject';

      function renderSelectizeOption(wrapperCssClass, dateFilter) {
        return function (item, escape) {
          var html = "<div class=\"".concat(wrapperCssClass, "\" style=\"vertical-align: middle;\">");

          if (item.cover) {
            html += "<div style=\"display: inline-flex; float: left; width: 32px; height: 18px; margin-right: 6px; background-size: cover; background-repeat: no-repeat; background-position: center; background-image: url('".concat(item.cover.source, "');\"></div>");
          }

          if (item.start_time) {
            html += "<div class=\"date-range\" style=\"display: inline-flex; float: right; margin-left: 3px;\">(".concat(dateFilter(item.start_time), ")</div>");
          }

          html += "<div class=\"overflow-ellipse\">".concat(item.name, "</div></div>");
          return html;
        };
      }

      var selectizeConfigBase = {
        valueField: 'id',
        labelField: 'name',
        highlight: true,
        searchField: 'name',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option', $filter('date')),
          item: renderSelectizeOption('source-chooser--selected', $filter('date'))
        }
      };
      $scope.pagesSelectizeConfig = angular.extend({
        placeholder: 'Select Page...'
      }, selectizeConfigBase);
      $scope.groupsSelectizeConfig = angular.extend({
        placeholder: 'Select Group...'
      }, selectizeConfigBase);
      $scope.eventsSelectizeConfig = angular.extend({
        placeholder: 'Select Event...'
      }, selectizeConfigBase);
    }]
  };
});

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"(vm.fb.connected || config.fb_feed_id)\" style=\"position:relative\">\n  <div class=\"btn-group\" style=\"display: flex; margin-bottom: 5px;\">\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.feed_type\" ng-change=\"vm.service.facebookFeedTypeChanged(config)\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'user:me'\">My Timeline</label>\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.feed_type\" ng-change=\"vm.service.facebookFeedTypeChanged(config)\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'page'\">Page</label>\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.feed_type\" ng-change=\"vm.service.facebookFeedTypeChanged(config)\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'group'\">Group</label>\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.feed_type\" ng-change=\"vm.service.facebookFeedTypeChanged(config)\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'event'\">Event</label>\n  </div>\n  <select selectize\n    ng-if=\"config.feed_type == 'page' && vm.fb.accounts.length\"\n    ng-disabled=\"config.fb_status\"\n    ng-model=\"config.feed_id\"\n    options=\"vm.fb.accounts\"\n    config=\"pagesSelectizeConfig\"></select>\n  <select selectize\n    ng-if=\"config.feed_type == 'group' && vm.fb.groups.length\"\n    ng-disabled=\"config.fb_status\"\n    ng-model=\"config.feed_id\"\n    options=\"vm.fb.groups\"\n    config=\"groupsSelectizeConfig\"></select>\n  <select selectize\n    ng-if=\"config.feed_type == 'event' && vm.fb.events.length\"\n    ng-disabled=\"config.fb_status\"\n    ng-model=\"config.feed_id\"\n    options=\"vm.fb.events\"\n    config=\"eventsSelectizeConfig\"></select>\n  <div class=\"help-block\" style=\"margin-bottom: 5px;\" ng-if=\"config.feed_type == 'page' && !vm.fb.accounts.length\">\n    No pages available\n    <i class=\"fa fa-question-circle\" uib-tooltip=\"Facebook returned no pages that can be used as a destination for live video.\"></i>\n  </div>\n  <div class=\"help-block\" style=\"margin-bottom: 5px;\" ng-if=\"config.feed_type == 'group' && !vm.fb.groups.length\">\n    No groups available\n    <i class=\"fa fa-question-circle\" uib-tooltip=\"Facebook returned no groups that can be used as a destination for live video.\"></i>\n  </div>\n  <div class=\"help-block\" style=\"margin-bottom: 5px;\" ng-if=\"config.feed_type == 'event' && !vm.fb.events.length\">\n    No events available\n    <i class=\"fa fa-question-circle\" uib-tooltip=\"Facebook returned no events that can be used as a destination for live video.\"></i>\n  </div>\n  <div class=\"btn-group\" style=\"display: flex;\" ng-if=\"config.feed_type == 'user:me'\">\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.fb_privacy\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'SELF'\">Only Me</label>\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.fb_privacy\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'ALL_FRIENDS'\">Friends</label>\n    <label class=\"btn btn-sm btn-default\" ng-model=\"config.fb_privacy\" ng-disabled=\"config.fb_status\" uib-btn-radio=\"'EVERYONE'\">Public</label>\n  </div>\n  <div ng-if=\"vm.fbLiveShowGlass(config)\"\n        class=\"text-center\"\n        style=\"position:absolute;z-index:2;left:0;right:0;top:0;bottom:0;background:rgba(0,0,0,0.5);color:#fff;\">\n    <h4>Connected to Facebook as {{vm.fb.me.name}} but settings were configured by Facebook user ({{config.fb_user_name}}).</h4>\n  </div>\n</div>\n<div ng-if=\"!vm.fb.connected\">\n  <div ng-if=\"vm.fb.loading\">\n    <small>Loading Facebook status... (Stuck? <a href=\"javascript://\" ng-click=\"vm.initFacebook()\">Try again</a>.)</small>\n  </div>\n  <div ng-if=\"!vm.fb.loading && !vm.fb.connected\">\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.loginFacebook()\">\n      <i class=\"fa fa-facebook-official\" style=\"width:20px\"></i> Log in to Facebook\n    </button>\n  </div>\n</div>\n"

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('hostRestrictionsSettings', function () {
  return {
    restrict: 'E',
    scope: {
      contentSettings: '='
    },
    template: __webpack_require__(320)
  };
});

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "<label ng-click=\"contentSettings.hostRestrictions = contentSettings.hostRestrictions ? null : {allowedHosts: [''], redirectUrl: ''}\" style=\"cursor:pointer\">\n  <i class=\"fa\" ng-class=\"contentSettings.hostRestrictions ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n  Enable Embedding Restrictions\n</label>\n<div ng-if=\"contentSettings.hostRestrictions.allowedHosts\">\n  <p>Allow player to be embedded only on the following hosts:</p>\n  <div class=\"form-group\" ng-repeat=\"_ in contentSettings.hostRestrictions.allowedHosts track by $index\">\n    <div class=\"input-group\">\n      <input required type=\"text\" class=\"form-control\" ng-model=\"contentSettings.hostRestrictions.allowedHosts[$index]\" placeholder=\"example.com\">\n      <div class=\"input-group-addon\">\n        <a href class=\"action-link\" ng-click=\"contentSettings.hostRestrictions.allowedHosts.splice($index, 1)\">\n          <i class=\"fa fa-trash\"></i>\n        </a>\n      </div>\n    </div>\n  </div>\n  <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"contentSettings.hostRestrictions.allowedHosts.push('')\">Add Another Host</button>\n  <p style=\"margin-top:15px\">If view attempted on disallowed host, redirect to the following base URL. Note that the broadcast slug will be appended to the URL.</p>\n  <input required type=\"text\" class=\"form-control\" ng-model=\"contentSettings.hostRestrictions.redirectUrl\" placeholder=\"https://www.example.com/watch-live?channel_path=\">\n  <p class=\"help-block\" ng-show=\"contentSettings.hostRestrictions.redirectUrl\" style=\"font-size:10px\">\n    Example redirect: <span>{{contentSettings.hostRestrictions.redirectUrl}}/example-broadcast-9999</span>\n  </p>\n</div>\n"

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('twitterSimulcastSettings', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '='
    },
    template: __webpack_require__(322)
  };
});

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "<div style=\"position:relative\">\n  <div ng-if=\"!config.isHelpRow && vm.service.twitterUsers.length > 0\">\n    <div>\n      <select class=\"form-control\" ng-model=\"config.twitter_account_id\" required ng-disabled=\"config.status\">\n        <option ng-repeat=\"u in vm.service.twitterUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n      </select>\n    </div>\n    <div style=\"margin:15px 0 5px 0\">\n      <span id=\"should_not_tweet\" ng-click=\"config.should_not_tweet = !config.should_not_tweet\" style=\"cursor:pointer;opacity:0.8\">\n        <i class=\"fa\" ng-class=\"config.should_not_tweet ? 'fa-square-o' : 'fa-check-square-o'\" style=\"width:20px\"></i>\n        <label for=\"should_not_tweet\">Tweet?</label>\n      </span>\n    </div>\n  </div>\n  <div ng-if=\"config.isHelpRow\">\n    <p class=\"help-block\"><small>\n      Before adding a Twitter destination, you must link your account in Settings &gt; Integrations.\n      Note: you can finish scheduling this broadcast now and then link your Twitter account by editing the broadcast.\n    </small></p>\n  </div>\n</div>\n"

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('podcastSettings', function () {
  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      onUploadPreviewImage: '&'
    },
    link: function link(scope, element, attrs) {
      // unwrap the function
      scope.onUploadPreviewImage = scope.onUploadPreviewImage();
    },
    template: __webpack_require__(324)
  };
});

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-sm-8\">\n    <div style=\"margin-bottom:10px\">\n      <label for=\"podcastSubtitle\">\n        Subtitle\n        <i class=\"fa fa-question-circle\" uib-tooltip=\"For best results, choose a subtitle that is only a few words long. Leave blank to use the broadcast description.\"></i>\n      </label>\n      <textarea class=\"form-control\" rows=\"2\" class=\"form-control\" id=\"podcastSubtitle\" ng-model=\"broadcast.content_settings.podcast_subtitle\" placeholder=\"{{ broadcast.description }}\"></textarea>\n    </div>\n    <div style=\"margin-bottom:10px\">\n      <label for=\"podcastSummary\">\n        Summary\n        <i class=\"fa fa-question-circle\" uib-tooltip=\"Leave blank to use the broadcast description.\"></i>\n      </label>\n      <textarea class=\"form-control\" rows=\"2\" class=\"form-control\" id=\"podcastSummary\" ng-model=\"broadcast.content_settings.podcast_summary\" placeholder=\"{{ broadcast.description }}\"></textarea>\n    </div>\n    <div style=\"margin-bottom:10px\">\n      <label ng-click=\"broadcast.content_settings.podcast_explicit = !broadcast.content_settings.podcast_explicit\" style=\"cursor:pointer\">\n        <i class=\"fa\" ng-class=\"broadcast.content_settings.podcast_explicit ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n        Explicit?\n      </label>\n    </div>\n  </div>\n  <div class=\"col-sm-4\">\n    <div style=\"margin-bottom:10px\">\n      <label>\n        Preview Image:\n        <i class=\"fa fa-info-circle\"\n            tooltip-append-to-body=\"true\"\n            uib-tooltip=\"Artwork must be a minimum size of 1400 x 1400 pixels and a maximum size of 3000 x 3000 pixels, in JPEG or PNG format, 72 dpi, with appropriate file extensions (.jpg, .png), and in the RGB colorspace.\"></i>\n      </label>\n      <div ng-if=\"broadcast.content_settings.podcast_preview\" class=\"text-center\">\n        <img ng-src=\"{{broadcast.content_settings.podcast_preview | trustedUrl}}\" class=\"img\" style=\"max-width:100%\">\n        <div><a href ng-click=\"broadcast.content_settings.podcast_preview = null\">Change</a></div>\n      </div>\n      <div ng-if=\"!broadcast.content_settings.podcast_preview\">\n        <upload-slot ng-model=\"podcastPreviewfile\"\n                    ng-change=\"onUploadPreviewImage(podcastPreviewfile)\"\n                    slot-name=\"'podcast-preview'\"\n                    allow-image=\"true\"\n                    allow-video=\"false\"\n                    compact=\"true\"></upload-slot>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('recurrencePattern', function () {
  return {
    restrict: 'E',
    template: __webpack_require__(326)
  };
});

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-xs-12\">\n    <div class=\"form-group\" style=\"margin-left:0;margin-right:0\">\n      <span ng-click=\"vm.recurring.enabled = !vm.recurring.enabled\" style=\"cursor:pointer;opacity:0.8\">\n        <i class=\"fa\" ng-class=\"vm.recurring.enabled ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n        Make This a Recurring Broadcast\n      </span>\n    </div>\n  </div>\n</div>\n<div class=\"row\" ng-if=\"vm.recurring.enabled\">\n  <div class=\"col-sm-4\">\n    <div class=\"form-group\" style=\"margin-left:0;margin-right:0\">\n      <select class=\"form-control\" ng-model=\"vm.recurring.pattern\">\n        <option value=\"day\">Daily</option>\n        <option value=\"week\">Weekly ({{vm.service.startDate | date:'EEEE'}}s)</option>\n        <option value=\"weekbyday\">Weekly (Custom)</option>\n        <option value=\"month\">Monthly ({{vm.service.startDate | daySuffix:false}})</option>\n      </select>\n    </div>\n  </div>\n  <div class=\"col-sm-8\" ng-if=\"vm.recurring.pattern == 'weekbyday'\">\n    <label><input type=\"checkbox\" value=\"0\" ng-checked=\"vm.recurring.onDays.indexOf(0) > -1\" ng-click=\"vm.toggleOnDays(0)\"> Sun</label>\n    <label><input type=\"checkbox\" value=\"1\" ng-checked=\"vm.recurring.onDays.indexOf(1) > -1\" ng-click=\"vm.toggleOnDays(1)\"> Mon</label>\n    <label><input type=\"checkbox\" value=\"2\" ng-checked=\"vm.recurring.onDays.indexOf(2) > -1\" ng-click=\"vm.toggleOnDays(2)\"> Tue</label>\n    <label><input type=\"checkbox\" value=\"3\" ng-checked=\"vm.recurring.onDays.indexOf(3) > -1\" ng-click=\"vm.toggleOnDays(3)\"> Wed</label>\n    <label><input type=\"checkbox\" value=\"4\" ng-checked=\"vm.recurring.onDays.indexOf(4) > -1\" ng-click=\"vm.toggleOnDays(4)\"> Thu</label>\n    <label><input type=\"checkbox\" value=\"5\" ng-checked=\"vm.recurring.onDays.indexOf(5) > -1\" ng-click=\"vm.toggleOnDays(5)\"> Fri</label>\n    <label><input type=\"checkbox\" value=\"6\" ng-checked=\"vm.recurring.onDays.indexOf(6) > -1\" ng-click=\"vm.toggleOnDays(6)\"> Sat</label>\n  </div>\n  <div class=\"col-sm-3\">\n    <div class=\"form-group\" style=\"margin-left:0;margin-right:0\">\n      <select class=\"form-control\" ng-model=\"vm.recurring.end\">\n        <option value=\"after\">Ending After</option>\n        <option value=\"on\">Ending On</option>\n      </select>\n    </div>\n  </div>\n  <div class=\"col-sm-2\" ng-show=\"vm.recurring.end == 'after'\">\n    <div class=\"form-group\" ng-class=\"{'has-error':vm.recurring.endCount > vm.MAX_RECURRING_EVENTS || !vm.isRecurringPatternValid()}\" style=\"margin-left:0;margin-right:0\">\n      <input ng-model=\"vm.recurring.endCount\" type=\"number\" class=\"form-control\" placeholder=\"# of occurences\">\n      <small ng-if=\"vm.recurring.endCount > vm.MAX_RECURRING_EVENTS\">\n      Max is 100\n      </small>\n    </div>\n  </div>\n  <div class=\"col-sm-2\" ng-show=\"vm.recurring.end == 'after'\">\n    <div class=\"form-group\" style=\"margin-left:-15px;margin-right:0;line-height:32px;\">\n      <small>Occurences</small>\n    </div>\n  </div>\n  <div class=\"col-sm-5\" ng-if=\"vm.recurring.end == 'on'\">\n    <div class=\"form-group\">\n      <div class=\"datepicker\"><!-- hack: need wrapper class to target custom styles -->\n        <uib-datepicker ng-model=\"vm.recurring.endDate\" datepicker-options=\"vm.service.datepickerOptions\"></uib-datepicker>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-sm-12\" style=\"margin-top:0;margin-bottom:15px;\" ng-if=\"vm.recurring.end == 'after'\">\n    <strong>Final broadcast date: </strong>{{vm.getPatternLastRecurringDate().toDate() | date}}\n  </div>\n  <div class=\"col-sm-12\" style=\"margin-top:0;margin-bottom:15px\" ng-if=\"!vm.isRecurringPatternValid()\">\n    <p class=\"text-danger\">\n      The source broadcast will be auto-deleted on {{vm.service.sourceBroadcast.storage_expires_at | date:'mediumDate'}} at {{vm.service.sourceBroadcast.storage_expires_at | date:'h:mm a'}}, before the final broadcast date.\n    </p>\n    <p class=\"text-danger\">\n      Please adjust your recurring schedule, or, change your <a href=\"/settings/storage\">Storage Policy</a> to \"Auto-Bill\" to retain your recordings for longer than {{vm.service.account.storage_duration_days|storageDuration}}.\n    </p>\n  </div>\n  <div class=\"col-sm-12\">\n    <p class=\"help-block\" style=\"margin-top:0;margin-bottom:15px\">\n      <small ng-if=\"vm.timezoneMatchesAccount === false\" class=\"text-warning\">\n        <i class=\"fa fa-warning\" style=\"width:15px;\"></i>\n        Your browser's time zone does not match your <a ui-sref=\"settings.my_account\">account settings</a>. Check the selection to ensure proper date handling during DST and other cases.<br>\n      </small>\n      <small>\n        <i class=\"fa fa-info-circle\" style=\"width:15px;\"></i>\n        Tip: Add the token <span style=\"font-family:monospace\">[date]</span> to the name or description and it will be filled-in for each broadcast.\n      </small>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('rtmpSimulcastSettings', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '='
    },
    template: __webpack_require__(328)
  };
});

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = "<form name=\"simulcastForm\" role=\"form\">\n\n<div style=\"position:relative\">\n\n  <ol class=\"inline-tabs list-inline\" style=\"margin:0 0 15px 0\">\n    <li ng-class=\"config.destination == 'rtmp_push_channel' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"config.destination = 'rtmp_push_channel'\">\n        Multi-Use &nbsp;\n        <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" uib-tooltip=\"Multi-Use RTMP destinations help if your URL and stream key do not change between multiple broadcasts.\" tooltip-append-to-body=\"true\"></i>\n      </a>\n    </li>\n    <li ng-class=\"config.destination == 'generic' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"config.destination = 'generic'\">\n        Single-Use &nbsp;\n        <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" uib-tooltip=\"Single-Use RTMP destinations are best when you do not plan on reusing the same URL and stream key in the future.\" tooltip-append-to-body=\"true\"></i>\n      </a>\n    </li>\n  </ol>\n\n  <div ng-if=\"config.destination == 'rtmp_push_channel'\">\n    <div ng-if=\"vm.service.rtmpPushChannels.length\">\n      <div style=\"margin:0 0 15px 0\">\n        <label>Select RTMP Destination</label>\n        <select class=\"form-control\" ng-model=\"config.rtmp_push_channel_id\" required>\n          <option ng-repeat=\"c in vm.service.rtmpPushChannels\" value=\"{{c.id}}\">{{c.name}}</option>\n        </select>\n      </div>\n      <div style=\"margin:0 0 15px 0\">\n        <a href ng-click=\"vm.service.addNewMultiUseChannel(config)\">Or, add another multi-use destination...</a>\n      </div>\n    </div>\n    <div style=\"margin:0 0 15px 0\" ng-if=\"!vm.service.rtmpPushChannels.length\">\n      <a href ng-click=\"vm.service.addNewMultiUseChannel(config)\">Add a multi-use destination...</a>\n    </div>\n  </div>\n\n  <div ng-if=\"config.destination == 'generic'\">\n    <div style=\"margin:0 0 15px 0\">\n      <label>Server URL</label>\n      <input type=\"text\" class=\"form-control\" ng-model=\"config.stream_url\" id=\"stream_url\" name=\"stream_url\" not-boxcast placeholder=\"e.g. rtmp://rtmp.service.com/live\" required>\n      <p>\n        <span class=\"text-danger\" ng-if=\"simulcastForm.stream_url.$error.notBoxcast\">The stream URL cannot point to BoxCast.</span>\n      </p>\n    </div>\n    <div style=\"margin:0 0 15px 0\">\n      <label>Stream Key</label>\n      <input type=\"text\" class=\"form-control\" ng-model=\"config.stream_key\" id=\"stream_key\" name=\"stream_key\" maxlength=\"{{ ::vm.service.genericRTMPPushLimits.stream_key }}\" required>\n      <p ng-show=\"(simulcastForm.stream_key.$dirty || simulcastForm.stream_key.$touched) && !config.stream_key\">\n        <span class=\"text-danger\" ng-if=\"simulcastForm.stream_key.$error.maxlength\">The stream key is too long.</span>\n        <span class=\"text-danger\" ng-if=\"simulcastForm.stream_key.$error.required\">The stream key cannot be blank.</span>\n      </p>\n    </div>\n    <div style=\"margin:0 0 10px 0\">\n      <label>Max Resolution</label>\n      <select class=\"form-control\" ng-model=\"config.max_resolution\">\n          <option value=\"0\">None (use highest)</option>\n          <option value=\"1080\">1080p</option>\n          <option value=\"720\">720p</option>\n          <option value=\"480\">480p</option>\n        </select>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 329 */
/***/ (function(module, exports) {

angular.module('app.directives.schedule').directive('scoreboardConfigSummary', function () {
  return {
    restrict: 'E',
    scope: {
      service: '=',
      scoreboardConfiguration: '=',
      labelSuffix: '@',
      boldLabels: '=',
      boldValues: '='
    },
    controller: ["$scope", function controller($scope) {
      'ngInject';

      $scope.labelStyle = {
        'font-weight': $scope.boldLabels ? 'bold' : 'normal'
      };
      $scope.valueStyle = {
        'font-weight': $scope.boldValues ? 'bold' : 'normal'
      };
    }],
    template: "\n      <p ng-style=\"labelStyle\">Sport{{labelSuffix}}<br>\n        <em ng-if=\"!scoreboardConfiguration.sport\">No Sport Selected</em>\n        <span ng-style=\"valueStyle\" ng-if=\"scoreboardConfiguration.sport\">{{service.sports | getById:scoreboardConfiguration.sport:'value':'label'}}</strong>\n      </p>\n      <div ng-if=\"scoreboardConfiguration.sport\">\n        <p ng-style=\"labelStyle\">Scoreboard{{labelSuffix}}<br>\n          <em ng-if=\"scoreboardConfiguration.manual === undefined\">No Scoreboard</em>\n          <span ng-style=\"valueStyle\" ng-if=\"scoreboardConfiguration.manual === true\">Manual</span>\n          <span ng-style=\"valueStyle\" ng-if=\"scoreboardConfiguration.manual === false && scoreboardConfiguration.connection === 'scoreboard_assist'\">Scoreboard Assist</span>\n          <span ng-style=\"valueStyle\" ng-if=\"scoreboardConfiguration.manual === false && scoreboardConfiguration.connection === 'scorebot'\">Sportzcast ScoreBot {{sc.sportzcast_bot_number}}</span>\n          <span ng-style=\"valueStyle\" ng-if=\"scoreboardConfiguration.manual === false && scoreboardConfiguration.connection === 'scoreboard_adapter'\">\n            {{service.scoreboards | getById:scoreboardConfiguration.scoreboard_make:'value':'label'}} /\n            {{service.scoreboardModels | getById:scoreboardConfiguration.scoreboard_model:'value':'label'}}\n          </span>\n        </p>\n        <p ng-style=\"labelStyle\">Team{{labelSuffix}}<br>\n          <button type=\"button\" class=\"btn btn-default btn-sm btn-color-picker\" uib-dropdown-toggle\n            style=\"text-shadow: rgb(0, 0, 0) 0px 0px 3px; color: rgb(255, 255, 255);\"\n            ng-style=\"{'background-color': scoreboardConfiguration.home_team_logo}\">\n            <span style=\"white-space:pre;font-family:monospace;\">{{scoreboardConfiguration.home_team_name | scoreboardTeamName}}</span>\n          </button>\n          vs.\n          <button type=\"button\" class=\"btn btn-default btn-sm btn-color-picker\" uib-dropdown-toggle\n            style=\"text-shadow: rgb(0, 0, 0) 0px 0px 3px; color: rgb(255, 255, 255);\"\n            ng-style=\"{'background-color': scoreboardConfiguration.away_team_logo}\">\n            <span style=\"white-space:pre;font-family:monospace;\">{{scoreboardConfiguration.away_team_name | scoreboardTeamName}}</span>\n          </button>\n        </p>\n        <p ng-style=\"labelStyle\">Video Overlay{{labelSuffix}}<br>\n          <span ng-style=\"valueStyle\" style=\"text-transform:capitalize\">{{scoreboardConfiguration.overlay_location}}</span>\n        </p>\n        </p>\n      </div>\n      "
  };
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__ = __webpack_require__(23);

angular.module('app.directives.schedule').directive('scoreboardTabConfig', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      sc: '=',
      showClear: '@'
    },
    template: __webpack_require__(331),
    controller: function controller($scope) {
      'ngInject';

      $scope.clearScoreboardConfig = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_scoreboard__["a" /* clearScoreboardConfig */])($scope.sc);
      };
    }
  };
});

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports = "<p ng-if=\"showClear\" class=\"pull-right\" style=\"margin:10px 0 0 0;\" ng-show=\"sc.sport || sc.sport_prefix || sc.sport_variation\">\n  <a href=\"javascript://\" ng-click=\"clearScoreboardConfig()\">Reset Scoreboard Configuration</a>\n</p>\n<uib-tabset active=\"sc.manual === false || !vm.service.showManualScoreboard ? 1 : 0\">\n  <uib-tab select=\"sc.manual = true\" index=\"0\" ng-if=\"vm.service.showManualScoreboard\">\n    <uib-tab-heading>\n      Manual\n    </uib-tab-heading>\n    <div class=\"tab-container clearfix\">\n      <broadcast-select-sport vm=\"vm\"></broadcast-select-sport>\n      <div class=\"row\" ng-if=\"sc.sport\" style=\"margin-bottom:15px\">\n        <div class=\"col-sm-3 col-xs-6\"><broadcast-team-color-picker vm=\"vm\" team=\"home\" label=\"Home\"></broadcast-team-color-picker></div>\n        <div class=\"col-sm-3 col-xs-6\"><broadcast-team-color-picker vm=\"vm\" team=\"away\" label=\"Away\"></broadcast-team-color-picker></div>\n        <div class=\"col-sm-6 col-xs-12\">\n          <label>Overlay Placement</label>\n          <div>\n            <div class=\"btn-group\">\n              <label class=\"btn btn-default\" ng-model=\"sc.overlay_location\" uib-btn-radio=\"'top'\">Top</label>\n              <label class=\"btn btn-default\" ng-model=\"sc.overlay_location\" uib-btn-radio=\"'bottom'\">Bottom</label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </uib-tab>\n  <uib-tab select=\"sc.manual = false\" index=\"1\" ng-if=\"vm.service.showAutomatedScoreboard || vm.service.showSportzcast\">\n    <uib-tab-heading>\n      Automated\n    </uib-tab-heading>\n    <div class=\"tab-container clearfix\">\n      <broadcast-select-sport vm=\"vm\"></broadcast-select-sport>\n      <div ng-if=\"sc.sport\">\n        <broadcast-select-scoreboard-connection vm=\"vm\"></broadcast-select-scoreboard-conection>\n      </div>\n      <div ng-if=\"!$root.account.has_scoreboard_assists && sc.connection == 'scoreboard_assist'\">\n        <div class=\"bg-danger text-danger\" style=\"padding:10px; border:1px solid; margin:15px 0\">\n          <small>Your account does not have a registered Scoreboard Assist.</small>\n        </div>\n      </div>\n      <div ng-if=\"!vm.service.isBoxCaster && (sc.connection == 'scoreboard_adapter' || sc.connection == 'scoreboard_assist')\">\n        <div class=\"bg-danger text-danger\" style=\"padding:10px; border:1px solid; margin:15px 0\">\n          <small>The selected scoreboard connection requires a BoxCaster source.</small>\n        </div>\n      </div>\n      <div ng-if=\"sc.connection == 'scorebot' && !vm.service.sportzcast.username\">\n        <div class=\"bg-danger text-danger\" style=\"padding:10px; border:1px solid; margin:15px 0\">\n          <small>\n            Your Sportzcast account has not yet been configured.<br>\n            <a ui-sref=\"settings.integrations\">Configure Scoreboard Integration</a>.\n          </small>\n        </div>\n      </div>\n      <div class=\"form-group\" ng-if=\"sc.connection == 'scorebot'\">\n        <label>ScoreBOT Number</label>\n        <div style=\"max-width:181px\">\n          <input type=\"number\" class=\"form-control\" ng-model=\"sc.sportzcast_bot_number\">\n        </div>\n        <p class=\"help-block\" ng-if=\"vm.service.sportzcast.username\"><small>Linked to Sportzcast account {{vm.service.sportzcast.username}}</small></p>\n      </div>\n      <div class=\"row\" ng-if=\"vm.service.isBoxCaster && sc.connection == 'scoreboard_adapter'\" style=\"margin-bottom:15px\">\n        <div ng-init=\"vm.service.updateScoreboardMakes()\"></div>\n        <div class=\"col-sm-6\">\n          <label for=\"scoreboard_make\">Scoreboard <span ng-show=\"vm.service.showScoreboardModel\">Make</span></label>\n          <select class=\"form-control\" id=\"scoreboard_make\"\n                  ng-model=\"sc.scoreboard_make\"\n                  ng-change=\"vm.service.updateScoreboardModels()\"\n                  ng-options=\"e.value as e.label for e in vm.service.scoreboardMakes\">\n            <option value=\"\">None Selected</option>\n          </select>\n        </div>\n        <div class=\"col-sm-6\" ng-if=\"vm.service.showScoreboardModel\">\n          <label for=\"scoreboard_model\">Scoreboard Model <i ng-show=\"sc.scoreboard_make\" class=\"fa fa-asterisk text-danger\" style=\"font-size:12px;vertical-align:top\"></i></label>\n          <select class=\"form-control\" id=\"scoreboard_model\"\n                  ng-disabled=\"!sc.scoreboard_make\"\n                  ng-model=\"sc.scoreboard_model\"\n                  ng-options=\"e.value as e.label for e in vm.service.scoreboardModels\">\n          </select>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"sc.connection\" style=\"margin-bottom:15px\">\n        <div class=\"col-sm-3 col-xs-6\"><broadcast-team-color-picker vm=\"vm\" team=\"home\" label=\"Home\"></broadcast-team-color-picker></div>\n        <div class=\"col-sm-3 col-xs-6\"><broadcast-team-color-picker vm=\"vm\" team=\"away\" label=\"Away\"></broadcast-team-color-picker></div>\n        <div class=\"col-sm-6 col-xs-12\">\n          <label>Overlay Placement</label>\n          <div>\n            <div class=\"btn-group\">\n              <label class=\"btn btn-default\" ng-model=\"sc.overlay_location\" uib-btn-radio=\"'top'\">Top</label>\n              <label class=\"btn btn-default\" ng-model=\"sc.overlay_location\" uib-btn-radio=\"'bottom'\">Bottom</label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </uib-tab>\n</uib-tabset>\n"

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('simulcastConfigurationEditor', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      verticalForm: '='
    },
    template: __webpack_require__(333),
    controller: ["$scope", "$filter", "$timeout", function controller($scope, $filter, $timeout) {
      'ngInject';

      var service = $scope.vm.service;

      function renderSelectizeOption(wrapperCssClass, dateFilter) {
        return function (item, escape) {
          var html = "<div class=\"".concat(wrapperCssClass, "\" style=\"vertical-align: middle;\">");
          html += "<div style=\"display: inline-flex; float: left; width: 32px; height: 32px; margin-right: 6px;\">";

          if (item.value.type == 'facebook' || item.value.type == 'youtube' || item.value.type == 'twitter') {
            html += "<span style=\"border-radius:0;width:32px;height:32px;\" class=\"integration-badge integration-badge--".concat(item.value.type, "\"></span>");
          } else {
            html += "<span style=\"border-radius:0;width:32px;height:32px;\" class=\"integration-badge integration-badge--rtmp_push\">RTMP</span>";
          }

          html += "</div>";
          html += "<div class=\"overflow-ellipse\" style=\"line-height:32px;\">".concat(item.name, "</div></div>");
          return html;
        };
      }

      var selectizeConfigBase = {
        valueField: 'valueJson',
        labelField: 'name',
        highlight: true,
        searchField: 'name',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option', $filter('date')),
          item: renderSelectizeOption('source-chooser--selected', $filter('date'))
        },
        onInitialize: function onInitialize(selectize) {
          $scope.selectize = selectize;
        },
        onChange: function onChange(value) {
          if (!value) return;
          value = JSON.parse(value);
          $timeout(function () {
            $scope.vm.addSimulcastDestination(value.type, value);
          }, 0);
          $scope.selectize.clear();
          $timeout(function () {
            $scope.selectedAccount = null;
          }, 500);
        }
      };
      $scope.selectizeConfig = angular.extend({
        placeholder: 'Select Social Media and/or RTMP Destinations...'
      }, selectizeConfigBase);
      $scope.selectedAccount = {};
      $scope.allAccounts = [];
      service.destinationPromise.then(function () {
        if (service.allowFacebookLive) {
          // FIXME: consider listing all fb accounts here?
          $scope.allAccounts.push({
            name: 'Facebook',
            value: {
              type: 'facebook'
            }
          });
        }

        if (service.allowYoutubeLive) {
          if (service.youtubeUsers.length) {
            service.youtubeUsers.forEach(function (u) {
              $scope.allAccounts.push({
                name: "YouTube: ".concat(u.display_name),
                value: {
                  type: 'youtube',
                  id: u.id
                }
              });
            });
          } else {
            $scope.allAccounts.push({
              name: 'YouTube',
              value: {
                type: 'youtube',
                isHelpRow: true
              }
            });
          }
        }

        if (service.allowTwitter) {
          if (service.twitterUsers.length) {
            service.twitterUsers.forEach(function (u) {
              $scope.allAccounts.push({
                name: "Twitter: ".concat(u.display_name),
                value: {
                  type: 'twitter',
                  id: u.id
                }
              });
            });
          } else {
            $scope.allAccounts.push({
              name: 'Twitter',
              value: {
                type: 'twitter',
                isHelpRow: true
              }
            });
          }
        }

        if (service.allowGenericRtmpPush && service.rtmpPushChannels.length) {
          service.rtmpPushChannels.forEach(function (u) {
            $scope.allAccounts.push({
              name: "Other RTMP: ".concat(u.name),
              value: {
                type: 'rtmp_push_channel',
                id: u.id
              }
            });
          });
        }

        if (service.allowGenericRtmpPush) {
          $scope.allAccounts.push({
            name: 'Other RTMP (Single-Use)',
            value: {
              type: 'generic'
            }
          });
        }

        $scope.allAccounts.forEach(function (a) {
          a.valueJson = JSON.stringify(a.value);
        });
      });
    }]
  };
});

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"(vm.service.visibility == 'ticketed' || vm.service.visibility == 'flex')\">\n  <p class=\"help-block\">\n    <small>\n      Social media streaming is not allowed for ticketed or flex broadcasts.\n    </small>\n  </p>\n</div>\n\n<div class=\"form-group clearfix\" ng-if=\"verticalForm && vm.service.showAddSimulcast\">\n  <div class=\"col-xs-12\">\n    <label>\n      Destinations\n      <i class=\"fa fa-question-circle\" style=\"font-size:12px;vertical-align:top\" uib-tooltip=\"Simultaneously broadcast to multiple social media and/or RTMP destinations.  Visit Settings > Integrations to add a destination.\"></i>\n    </label>\n    <select selectize\n      ng-model=\"selectedAccount\"\n      options=\"allAccounts\"\n      config=\"selectizeConfig\"></select>\n  </div>\n</div>\n\n<div class=\"form-group clearfix\" ng-if=\"!verticalForm && vm.service.showAddSimulcast\">\n  <label class=\"col-sm-4\">\n    Destinations\n    <i class=\"fa fa-question-circle\" style=\"font-size:12px;vertical-align:top\" uib-tooltip=\"Simultaneously broadcast to multiple social media and/or RTMP destinations.  Visit Settings > Integrations to add a destination.\"></i>\n  </label>\n  <div class=\"col-sm-8 text-left\">\n    <select selectize\n      ng-model=\"selectedAccount\"\n      options=\"allAccounts\"\n      config=\"selectizeConfig\"></select>\n  </div>\n</div>\n\n<div ng-if=\"vm.service.broadcast.simulcast_configurations.length && !(vm.service.visibility == 'ticketed' || vm.service.visibility == 'flex')\" style=\"margin-bottom:15px;\">\n  <div class=\"form-group clearfix\" style=\"border-top:1px solid #eee\"></div>\n  <div class=\"form-group clearfix\"\n      ng-repeat=\"s in vm.service.broadcast.simulcast_configurations | orderBy:'-'\"\n      style=\"margin-top: 15px; padding-top:15px; padding-bottom:15px; border-bottom:1px solid #eee;\">\n    <div class=\"col-sm-4\" style=\"font-weight:bold\">\n      <button type=\"button\"\n              ng-click=\"vm.removeSimulcastDestination(s)\"\n              aria-label=\"Remove simulcast destination\"\n              class=\"btn-link\"\n              style=\"color:#999;font-weight:100;\"\n              >\n        <i class=\"fa fa-times\"></i>\n      </button>\n      {{ s.destination | simulcast_destination }}\n    </div>\n    <div class=\"col-sm-8\">\n      <fb-live-simulcast-settings ng-if=\"s.destination == 'facebook'\" vm=\"vm\" config=\"s\"></fb-live-simulcast-settings>\n      <youtube-live-simulcast-settings ng-if=\"s.destination == 'youtube'\" vm=\"vm\" config=\"s\"></youtube-live-simulcast-settings>\n      <rtmp-simulcast-settings ng-if=\"s.destination == 'generic' || s.destination == 'rtmp_push_channel'\" vm=\"vm\" config=\"s\"></rtmp-simulcast-settings>\n      <twitter-simulcast-settings ng-if=\"s.destination == 'twitter'\" vm=\"vm\" config=\"s\"></twitter-simulcast-settings>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.directives.schedule').directive('youtubeLiveSimulcastSettings', function () {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '='
    },
    template: __webpack_require__(335)
  };
});

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = "<div style=\"position:relative\">\n  <div ng-if=\"!config.isHelpRow && vm.service.youtubeUsers.length > 0\">\n    <div>\n      <select class=\"form-control\" ng-model=\"config.youtube_account_id\" required ng-disabled=\"config.status\">\n        <option ng-repeat=\"u in vm.service.youtubeUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n      </select>\n    </div>\n    <div style=\"margin:15px 0 5px 0\">\n      <div class=\"btn-group\">\n        <label class=\"btn btn-default\" ng-model=\"config.privacy\" ng-disabled=\"config.status\" uib-btn-radio=\"'private'\">Private</label>\n        <label class=\"btn btn-default\" ng-model=\"config.privacy\" ng-disabled=\"config.status\" uib-btn-radio=\"'public'\">Public</label>\n        <label class=\"btn btn-default\" ng-model=\"config.privacy\" ng-disabled=\"config.status\" uib-btn-radio=\"'unlisted'\">Unlisted</label>\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"config.isHelpRow\">\n    <p class=\"help-block\"><small>\n      Before adding a YouTube destination, you must link your account in Settings &gt; Integrations.\n      Note: you can finish scheduling this broadcast now and then link your YouTube account by editing the broadcast.\n    </small></p>\n  </div>\n</div>\n"

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_geo__ = __webpack_require__(38);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }


var REGION_CODES = null;
angular.module('app.directives').directive('analyticsGeoChart', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      analytics: '='
    },
    link: function link(scope, element, attrs, ngModelCtrl) {},
    controller: AnalyticsGeoController,
    controllerAs: 'vm',
    template: "\n        <style>\n        .leaflet-container {\n            width: 100%;\n            height: calc(33vw);\n            max-height: 300px;\n            min-height: 100px;\n        }\n        </style>\n        <link rel=\"stylesheet\" href=\"//cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/leaflet.css\" />\n        <div ng-if=\"!vm.geoPoints\">\n          <i class=\"fa fa-spin fa-spinner\"></i> Loading...\n        </div>\n        <div ng-if=\"vm.geoPoints && !vm.geoPoints.length\">\n          <p style=\"margin-top:15px;opacity:0.8;text-align:center;\">\n            No geographic data is available.\n          </p>\n        </div>\n        <div ng-if=\"vm.geoPoints && vm.geoPoints.length\">\n          <leaflet defaults=\"{scrollWheelZoom: false, maxZoom: 8}\"\n                    bounds=\"vm.bounds\"\n                    paths=\"vm.paths\"\n                    ng-if=\"vm.bounds\"></leaflet>\n        </div>\n      "
  };
});

var AnalyticsGeoController = /*#__PURE__*/function () {
  function AnalyticsGeoController($scope, $http) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, AnalyticsGeoController);

    this.$scope = $scope;
    this.$http = $http;

    if (REGION_CODES) {
      this.regionDict = REGION_CODES;
    } else {
      $http.get('/img/region_codes.json').then(function (response) {
        REGION_CODES = _this.regionDict = response.data;
        _this.analytics && _this.computeGeo();
      });
    }

    __webpack_require__.e/* require.ensure */(1).then((function () {
      window.leaflet = window.L = __webpack_require__(228);
      $scope.$evalAsync(function () {
        _this.analytics = $scope.analytics;
        _this.analytics && _this.computeGeo();
      });
      $scope.$watch('analytics', function (analytics) {
        _this.analytics = analytics;

        if (analytics) {
          _this.computeGeo();
        }
      });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }

  _createClass(AnalyticsGeoController, [{
    key: "computeGeo",
    value: function computeGeo() {
      var _this2 = this;

      this.geoPoints = [];
      var maxCount = 0,
          minCount = 0;

      _.each(this.analytics.view_counts_by_geohash, function (count, geohash) {
        if (!geohash) return;
        var pos = Object(__WEBPACK_IMPORTED_MODULE_0__utils_geo__["b" /* decodeGeohash */])(geohash);

        _this2.geoPoints.push({
          latitude: pos.latitude[0],
          longitude: pos.longitude[0],
          count: count
        });

        if (!count || count > maxCount) maxCount = count;
        if (!count || count < minCount) minCount = count;
      });

      this.geoPoints.forEach(function (p) {
        // compute radius ... linear distribution between 1,000 and 100,000
        // TODO: the min/max bounds should probably account for the average distance
        // between points (e.g. if on 2 sides of globe, make each cluster larger
        // than if just in 3-4 different counties in same state)
        var count = p.count,
            radius = 0;

        if (count == minCount) {
          radius = 1000;
        } else if (count == maxCount) {
          radius = 100000;
        } else {
          radius = (100000 - 1000) / (maxCount - minCount) * count;
        }

        p.geoRadius = Math.round(radius);
      });
      this.geoPoints = _.sortBy(this.geoPoints, 'count');
      this.geoPoints.reverse();
      this.fitMap();
    }
  }, {
    key: "fitMap",
    value: function fitMap() {
      var _this3 = this;

      var geoPoints = this.geoPoints;
      if (!geoPoints) return;
      this.bounds = {
        northEast: {
          lat: _.min(_.pluck(this.geoPoints, 'latitude')),
          lng: _.min(_.pluck(this.geoPoints, 'longitude'))
        },
        southWest: {
          lat: _.max(_.pluck(this.geoPoints, 'latitude')),
          lng: _.max(_.pluck(this.geoPoints, 'longitude'))
        }
      };
      this.paths = {};
      var i = 0;
      this.geoPoints.forEach(function (p) {
        _this3.paths["path".concat(i++)] = {
          type: 'circle',
          color: '#5DA5DA',
          weight: '2',
          radius: parseInt(p.geoRadius, 10),
          latlngs: {
            lat: p.latitude,
            lng: p.longitude
          }
        };
      });
    }
  }]);

  return AnalyticsGeoController;
}();

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// directive
//   <authorize-account-form />
//
// Presented when the account has limited capabilities and needs to be authorized
// in order to proceed. Fires off an API call to begin authorization and presents
// a confirmation.
angular.module('app.directives').component('authorizeAccountForm', {
  restrict: 'E',
  template: "\n    <form>\n      <div class=\"form-group\">\n        <label for=\"eventName\">Organization Name <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"eventName\" ng-model=\"vm.service.broadcast.name\" required>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"eventName\">Organization Phone Number <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"eventName\" ng-model=\"vm.service.broadcast.name\" required>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"eventName\">Organization Web Site <span class=\"text-muted\" style=\"font-weight:normal\">(optional)</span></label>\n        <input type=\"text\" class=\"form-control\" id=\"eventName\" ng-model=\"vm.service.broadcast.name\" required>\n      </div>\n      <div class=\"form-group\" style=\"margin-top:15px\">\n        <span ng-click=\"vm.scheduleAgain = !vm.scheduleAgain\" style=\"cursor:pointer;opacity:0.8;line-height:30px;\">\n          <i class=\"fa fa-2x\" ng-class=\"vm.scheduleAgain ? 'fa-check-square-o' : 'fa-square-o'\"\n            style=\"width:30px;line-height:30px;vertical-align:bottom;\"></i>\n          I am authorized to stream events for this organization.\n        </span>\n      </div>\n      <button type=\"button\" class=\"btn btn-success btn-block\" ng-click=\"vm.submit()\" ng-disabled=\"vm.submitting\">\n        <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n        Authorize Account\n      </button>\n    </form>\n  ",
  controllerAs: 'vm',
  controller: ["Account", "$http", "$timeout", function AuthorizeAccountFormController(Account, $http, $timeout) {
    'ngInject';
  }]
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fixManuallyEnteredColor"] = fixManuallyEnteredColor;
function fixManuallyEnteredColor(color) {
  color = _.trim(color || '');

  if (color) {
    if (color.indexOf('#') != 0) {
      color = '#' + color;
    }

    if (color.length == 4) {
      // convert shorthand hex
      color = color.replace(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i, function (str, m1, m2, m3) {
        return "#".concat(m1).concat(m1).concat(m2).concat(m2).concat(m3).concat(m3);
      });
    }

    if (color.length != 7) {
      // otherwise just pad with black colorspace and trim to length
      color = (color + '000000').substring(0, 7);
    }

    if (!color.match(/^#[0-9a-f]{6}$/i)) {
      throw new Error('invalid color');
    }
  }

  return color;
}
angular.module('app.directives').directive('boxcastColorPicker', function ($rootScope, toaster) {
  'ngInject';

  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      defaultColor: '@'
    },
    link: function link(scope, element, attrs, ngModelCtrl) {
      if (!scope.ngModel) {
        scope.ngModel = scope.defaultColor;
      }

      scope.select = function (value) {
        ngModelCtrl.$modelValue = value;
        ngModelCtrl.$viewValue = value;
        ngModelCtrl.$render();
        scope.ngModel = value;
        scope.isopen = false;
      };

      scope.onBlurColorPicker = function (api, color, $event) {
        // After user input, validate and coerce to sane string prior to selecting
        try {
          scope.select(fixManuallyEnteredColor(color));
        } catch (e) {
          console.error(e);
          toaster.pop('warning', "Invalid color ".concat(color, ". It should be in the format of #ABCDEF."));
        }
      };

      scope.onChangeColorPicker = function (api, color, $event) {
        // Don't validate here; this is fired while typing
        scope.select(color);
      };
    },
    controller: function controller($scope, $rootScope) {
      var account = $rootScope.account;
      $scope.isopen = false;

      if (account.extra_features.scoreboard_spectrum) {
        $scope.useSpectrumPalette = true;
        $scope.colors = SPECTRUM_COLOR_PALETTE;
      }
    },
    template: "\n        <color-picker ng-hide=\"useSpectrumPalette\"\n                      ng-model=\"ngModel\"\n                      options=\"{\n                        format: 'hexString',\n                        alpha: false,\n                        swatch: true,\n                        swatchBootstrap: true,\n                        preserveInputFormat: true,\n                        allowEmpty: true,\n                        inputClass: 'form-control',\n                      }\"\n                      event-api=\"{\n                        onChange: onChangeColorPicker,\n                        onBlur: onBlurColorPicker,\n                      }\"\n        ></color-picker>\n\n        <div ng-show=\"useSpectrumPalette\" class=\"btn-group btn-block\" uib-dropdown is-open=\"isopen\">\n          <button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle style=\"text-align:left\">\n            <color-swatch color=\"ngModel\" label=\"\"></color-swatch>\n            {{colors[ngModel] || ngModel || 'Not Selected'}}\n            <i class=\"pull-right fa fa-caret-down\"></i>\n          </button>\n          <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" style=\"width:100%\">\n            <li role=\"menuitem\" ng-repeat=\"(c, label) in ::colors\">\n              <a href ng-click=\"select(c)\">\n                <color-swatch color=\"c\" label=\"\" style=\"display:inline-block;max-width:50px;margin-right:10px;overflow:hidden\"></color-swatch>\n                {{::label}}\n              </a>\n            </li>\n          </ul>\n        </div>\n      "
  };
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_allow_social__ = __webpack_require__(39);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 // player directive
//
//   <boxcast-player channel-id="channel_id" options="{ autostart: false, ... }" />
//
// makes sure the boxcast.js script (per config) is properly loaded, and then
// initializes the player widget for the specified channel with the specified
// configuration.

var module = angular.module('app.directives');
module.directive('boxcastPlayer', function ($q, $timeout, $rootScope) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      channelId: '=',
      options: '=',
      mode: '='
    },
    template: "<div id=\"{{playerElementId}}\"></div>",
    // XXX: HACK: need custom ID
    link: function link(scope, element, attrs) {
      var options = scope.options || {
        autostart: false
      };
      options.disableMetrics = $rootScope.user.is_impersonating;
      options.disableRedirectRulesOnLoad = true;
      options.playInline = true;

      if (BOXCAST_JS_ENV && !options.env) {
        options.env = BOXCAST_JS_ENV; //options.debug = (options.env == 'dev');
      }

      var showSocialShare = Object(__WEBPACK_IMPORTED_MODULE_0__utils_allow_social__["a" /* AllowSocial */])($rootScope.account.feature_flags, $rootScope.account, null);

      if (!showSocialShare) {
        options.showSocialShare = false;
      } else if (options.showSocialShare === undefined) {
        options.showSocialShare = true;
      }

      if (options.showSocialShare) {
        options.facebookAppId = FACEBOOK_APP_ID;
      } else {
        delete options.facebookAppId;
      } // Disable geoblock and password block (note that `null` doesn't work, we need something truthy)


      options.geoblock = {};
      options.cryptblock = {}; // XXX: passing in an element reference directly barfs when multiple
      // videos on same screen.  Let's generate a random element ID here.

      scope.playerElementId = "player-".concat(Math.random().toString(36).substring(8)); // Wait for the channel to become available; then load the
      // player (could take a few ticks if broadcast is resolved via promise)

      var loaded = false;
      var boxcastElement = null;
      var boxcastPlayer = null;
      scope.$watch('channelId', function (channelId) {
        if (channelId && !loaded) {
          boxcastElement = boxcast("#".concat(scope.playerElementId));

          if (scope.mode == 'highlight') {
            boxcastElement.loadHighlight(channelId, _objectSpread(_objectSpread({}, options), {}, {
              onLoadPlayer: function onLoadPlayer(player) {
                boxcastPlayer = player;
                options.onLoadPlayer && options.onLoadPlayer(player);
              }
            }));
          } else {
            boxcastElement.loadChannel(channelId, _objectSpread(_objectSpread({}, options), {}, {
              onLoadPlayer: function onLoadPlayer(player) {
                boxcastPlayer = player;
                options.onLoadPlayer && options.onLoadPlayer(player);
              }
            }));
          }

          loaded = true;
        }
      });
      scope.$on('player:pause', function () {
        return boxcastPlayer && boxcastPlayer.pause();
      }); // Handle a custom refresh meta event to refresh all our metadata

      scope.$on('boxcast:refreshMeta', function () {
        if (boxcastElement) {
          boxcastElement._boxcast.model.Actions.RefreshSelectedBroadcastMeta();
        }
      }); // Clean up after ourselves

      scope.$on('$destroy', function () {
        if (boxcastElement) {
          boxcastElement.unload();
        }

        element.remove();
      });
    }
  };
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_analytics__ = __webpack_require__(196);
// broadcast basic analytics directive
//
//   <broadcast-basic-analytics broadcast="vm.broadcast" />

var module = angular.module('app.directives');
module.component('broadcastBasicAnalytics', {
  bindings: {
    broadcast: '<'
  },
  template: __webpack_require__(341),
  controllerAs: 'vm',
  controller: function controller($scope, $rootScope, $timeout, AnalyticsResource) {
    'ngInject';

    var _this = this;

    this.hasAnalyticsFeature = !!$rootScope.account.feature_flags.analytics;
    this.canReadViewerAnalyticsReports = !!$rootScope.user.can('read', 'viewer-analytics/*');

    this.scheduleNextReload = function () {
      switch (_this.broadcast.timeframe) {
        case 'future': // fall-through

        case 'preroll':
          // If the broadcast hasn't started yet, reload at the start time (just in case they keep this tab open forever)
          var msUntilStart = moment().valueOf() - moment(_this.broadcast.starts_at).valueOf();
          $timeout.cancel(_this._reloadHandle);
          _this._reloadHandle = $timeout(function () {
            return _this.reloadAnalytics();
          }, msUntilStart);
          break;

        case 'current':
          // If we've already loaded analytics once, use the refresh interval; otherwise load once right away
          var msUntilLoad = _this.analytics ? REFRESH_INTERVAL_MS : 0;
          $timeout.cancel(_this._reloadHandle);
          _this._reloadHandle = $timeout(function () {
            return _this.reloadAnalytics();
          }, msUntilLoad);
          break;

        case 'past':
          // Only load the first time
          if (!_this.analytics) {
            // But if there's an error, delay the retry for the refresh interval
            var _msUntilLoad = _this.error ? REFRESH_INTERVAL_MS : 0;

            $timeout.cancel(_this._reloadHandle);
            _this._reloadHandle = $timeout(function () {
              return _this.reloadAnalytics();
            }, _msUntilLoad);
          } else {
            _this._reloadHandle = null;
          }

          break;
      }
    };

    this.reloadAnalytics = function () {
      AnalyticsResource.get({
        channel_id: _this.broadcast.channel_id,
        since: moment(_this.broadcast.starts_at).local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ'),
        until: moment().add(1, 'day').local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ'),
        include_viewer_timeseries: true
      }).$promise.then(function (a) {
        _this.analytics = a;

        _this.postProcessAnalytics();
      }, function (e) {
        console.error(e);
        _this.error = e;
      })["finally"](function () {
        _this.loading = false;

        _this.scheduleNextReload();
      });
    };

    this.hasViews = function () {
      return _this.broadcast.total_view_count > 0;
    };

    this.postProcessAnalytics = function () {
      // glue on computed fields
      _this.analytics.total_view_count = _this.analytics.live_view_count + _this.analytics.recorded_view_count;
      _this.analytics.total_view_duration = _this.analytics.live_view_seconds + _this.analytics.recorded_view_seconds;
      _this.analytics.avg_view_duration = _this.analytics.total_view_duration / _this.analytics.total_view_count;

      if (_this.analytics.live_buffer_seconds == 0 || _this.analytics.live_view_seconds == 0) {
        _this.analytics.live_rebuffer_pct = 0;
      } else {
        _this.analytics.live_rebuffer_pct = 100 * (_this.analytics.live_buffer_seconds / (_this.analytics.live_buffer_seconds + _this.analytics.live_view_seconds));
      }

      if (_this.analytics.recorded_buffer_seconds == 0 || _this.analytics.recorded_view_seconds == 0) {
        _this.analytics.recorded_rebuffer_pct = 0;
      } else {
        _this.analytics.recorded_rebuffer_pct = 100 * (_this.analytics.recorded_buffer_seconds / (_this.analytics.recorded_buffer_seconds + _this.analytics.recorded_view_seconds));
      } // Better formatting on hosts


      _this.analytics.hostData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_analytics__["c" /* normalizeHostData */])(_this.analytics);
      _this.insights = Object(__WEBPACK_IMPORTED_MODULE_0__utils_analytics__["a" /* computeInsights */])(_this.broadcast, _this.analytics);
      _this.analytics.view_counts_by_os = Object(__WEBPACK_IMPORTED_MODULE_0__utils_analytics__["d" /* normalizeOSs */])(_this.analytics.view_counts_by_os); // Viewer engagement graph

      _this.viewsLabels = _.map(_this.analytics.active_viewer_log, function (l) {
        return moment(l[0] * 1000);
      });
      _this.viewsData = [_.map(_this.analytics.active_viewer_log, function (l) {
        return l[1];
      })];

      if (_this.viewsLabels.length) {
        if (_this.viewsLabels[0].toDate() > moment(_this.broadcast.starts_at).toDate()) {
          // Insert an extra datapoint at exact beginning if it's not already there
          _this.viewsLabels.splice(0, 0, moment(_this.broadcast.starts_at));

          _this.viewsData[0].splice(0, 0, 0);
        }

        while (_.last(_this.viewsLabels).toDate() > moment(_this.broadcast.stops_at).toDate()) {
          // Kill off datapoints after end of broadcast
          _this.viewsLabels.splice(_this.viewsLabels.length - 1, 1);

          _this.viewsData[0].splice(_this.viewsData[0].length - 1, 1);
        }

        if (_this.broadcast.timeframe == 'current') {
          if (moment().toDate() > _.last(_this.viewsLabels).toDate()) {
            // Insert an extra datapoint at exact *now* to stretch the line
            _this.viewsLabels.push(moment());

            _this.viewsData[0].push(_this.broadcast.total_active_viewer_count);
          } // Insert an extra NaN datapoint at end of broadcast (draws no line but keeps x-axis


          _this.viewsLabels.push(moment(_this.broadcast.stops_at));

          _this.viewsData[0].push(null);
        } else {
          if (_.last(_this.viewsLabels).toDate() < moment(_this.broadcast.stops_at).toDate()) {
            // Insert an extra datapoint at exact end if it's not already there
            _this.viewsLabels.push(moment(_this.broadcast.stops_at));

            _this.viewsData[0].push(0);
          }
        }
      }
    };

    this.viewsOptions = {
      lineTension: 0,
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          gridLines: {
            color: '#FFF',
            zeroLineColor: '#FFF',
            drawTicks: false,
            drawBorder: false,
            tickMarkLength: 0
          },
          ticks: {
            suggestedMax: 10,
            beginAtZero: true,
            callback: function callback(value, index, values) {
              return Math.round(value);
            },
            fontFamily: 'Arial, sans-serif',
            fontSize: 11
          },
          stacked: true
        }],
        xAxes: [{
          type: 'time',
          time: {
            unit: 'minute'
          },
          gridLines: {
            display: false
          },
          position: 'bottom',
          ticks: {
            fontSize: 11,
            fontFamily: 'Arial, sans-serif',
            autoSkip: true
          }
        }]
      },
      tooltips: {
        callbacks: {//title: (items, data) => {
          //  return this.viewsLabels[items[0].index].format('ddd MMM Do');
          //}
        }
      },
      animation: {
        duration: 0
      }
    };
    this.datasetOverride = [{
      pointRadius: 0,
      pointHitRadius: 5,
      pointHoverRadius: 4,
      lineTension: 0,
      steppedLine: true
    }]; // Load full analytics data

    if (this.hasAnalyticsFeature) {
      // Only set loading = true the first time to show the loading panel. On refresh, we already have data to show.
      this.loading = true;
      this.scheduleNextReload();
      $scope.$on('$destroy', function () {
        return $timeout.cancel(_this._reloadHandle);
      });
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = "<style>\n.fa-facebook-official {\n  color:#275282;margin-right:5px\n}\n.fa-youtube-play {\n  color:red;margin-right:5px\n}\n</style>\n<div ng-if=\"vm.error\">\n  <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin:15px 0\">\n    There was an error loading the broadcast analytics.  Please refresh and try again.\n  </div>\n</div>\n<div ng-if=\"vm.loading\">\n  <i class=\"fa fa-spin fa-spinner\"></i> Loading analytics...\n</div>\n\n<div ng-if=\"vm.broadcast.id && !vm.loading && !vm.hasViews()\">\n  <div style=\"margin:50px 0;\" class=\"text-center\">\n    <i class=\"fa fa-4x fa-line-chart\" style=\"font-size:175px\"></i>\n    <h2 class=\"text-bx-accessible-grey\">There is no viewership reported for this broadcast yet.</h2>\n    <p><a ui-sref=\"resources\">Check out our resources section to learn how to promote your broadcasts!</a></p>\n  </div>\n</div>\n\n<div ng-if=\"vm.broadcast.id && !vm.loading && vm.hasViews()\">\n  <div class=\"row text-left\">\n    <div class=\"col-md-6 col-lg-3\">\n      <h4 style=\"font-weight:bold\">Live</h4>\n      <table style=\"width:100%\">\n        <tr style=\"font-weight:bold;\">\n          <td class=\"text-bx-accessible-grey text-xs\" style=\"width:50%\">VIEWS</td>\n          <td class=\"text-bx-accessible-grey text-xs\" style=\"width:50%\">AVG DURATION</td>\n        </tr>\n        <tr style=\"font-weight:bold;font-size:1.6em\">\n          <td>{{vm.broadcast.live_view_count|number}}</td>\n          <td>{{((vm.broadcast.live_minutes_viewed*60)/(vm.broadcast.live_view_count||1))|secondsFormatted:true:false}}</td>\n        </tr>\n      </table>\n    </div>\n    <div class=\"col-md-6 col-lg-3\" style=\"border-left:1px solid #eee;border-right:1px solid #eee\">\n      <div style=\"{{vm.broadcast.timeframe != 'past' ? 'opacity:0.2' : ''}}\">\n        <h4 style=\"font-weight:bold\">Recorded</h4>\n        <table style=\"width:100%\">\n          <tr style=\"font-weight:bold;\">\n            <td class=\"text-bx-accessible-grey text-xs\" style=\"width:50%\">VIEWS</td>\n            <td class=\"text-bx-accessible-grey text-xs\" style=\"width:50%\">AVG DURATION</td>\n          </tr>\n          <tr style=\"font-weight:bold;font-size:1.6em\">\n            <td>{{vm.broadcast.recorded_view_count|number}}</td>\n            <td>{{((vm.broadcast.recorded_minutes_viewed*60)/(vm.broadcast.recorded_view_count||1))|secondsFormatted:true:false}}</td>\n          </tr>\n        </table>\n      </div>\n    </div>\n    <div class=\"col-md-12 col-lg-6\">\n      <h4 style=\"font-weight:bold\">Total</h4>\n      <table style=\"width:100%\">\n        <tr style=\"font-weight:bold;\">\n          <td class=\"text-bx-accessible-grey text-xs\" style=\"width:25%\">VIEWS</td>\n          <td class=\"text-bx-accessible-grey text-xs\" ng-if=\"::vm.hasAnalyticsFeature\" style=\"width:25%\">UNIQUE</td>\n          <td class=\"text-bx-accessible-grey text-xs\" style=\"width:25%\">WATCH TIME</td>\n          <td class=\"text-bx-accessible-grey text-xs\" style=\"width:25%\">AVG DURATION</td>\n        </tr>\n        <tr style=\"font-weight:bold;font-size:1.6em\">\n          <td>{{vm.broadcast.total_view_count|number}}</td>\n          <td ng-if=\"::vm.hasAnalyticsFeature\">{{vm.analytics.unique_viewer_count|number}}</td>\n          <td>\n            <span ng-if=\"vm.broadcast.total_minutes_viewed <= 9999\">{{vm.broadcast.total_minutes_viewed|number:0}} <small class=\"text-bx-accessible-grey\">min</small></span>\n            <span ng-if=\"vm.broadcast.total_minutes_viewed > 9999\">{{(vm.broadcast.total_minutes_viewed / 60)|number:1}} <small class=\"text-bx-accessible-grey\">hr</small></span>\n          </td>\n          <td>\n            {{((vm.broadcast.total_minutes_viewed*60)/(vm.broadcast.total_view_count||1))|secondsFormatted:true:false}}\n          </td>\n        </tr>\n      </table>\n    </div>\n\n  </div>\n\n  <hr>\n\n  <div ng-if=\"::vm.hasAnalyticsFeature\">\n    <div ng-if=\"vm.broadcast.live_view_count > 0 && vm.viewsLabels.length\">\n      <h4 style=\"font-weight:bold\">Live Viewer Engagement</h4>\n      <div style=\"margin:0 -15px 15px\">\n        <canvas height=\"50\"\n            class=\"chart chart-line\"\n            chart-data=\"vm.viewsData\"\n            chart-labels=\"vm.viewsLabels\"\n            chart-options=\"vm.viewsOptions\"\n            chart-dataset-override=\"vm.datasetOverride\"></canvas>\n      </div>\n      <p ng-if=\"vm.insights.watchPercent > 0 && vm.broadcast.timeframe == 'past'\" style=\"margin-top:15px\">\n        <strong class=\"text-bx-accessible-grey\">INSIGHT</strong>\n        The average viewer watched <strong>{{vm.insights.watchPercent|number:0}}%</strong> of the broadcast.\n      </p>\n      <hr>\n    </div>\n    <div class=\"row text-left\">\n      <div class=\"col-sm-6\">\n        <h4 style=\"font-weight:bold\">Location</h4>\n        <analytics-geo-chart analytics=\"vm.analytics\" ng-if=\"vm.analytics\"></analytics-geo-chart>\n      </div>\n      <div class=\"col-sm-6\">\n        <h4 style=\"font-weight:bold\">Viewership by Destination</h4>\n        <table style=\"width:100%;line-height:2.0em\">\n          <tr class=\"font-bold text-bx-accessible-grey\">\n            <td>DESTINATION</td>\n            <td colspan=\"2\" class=\"text-right\">VIEWS</td>\n          </tr>\n          <tr ng-repeat=\"h in vm.analytics.hostData\">\n            <td>\n              <img src=\"/img/{{h.icon}}\" style=\"display:inline-block;height:15px;width:15px;margin-right:5px;\">\n              {{h.label}}\n            </td>\n            <td class=\"text-right\"><strong>{{h.value|number}}</strong></td>\n            <td class=\"text-bx-accessible-grey text-right\" style=\"width:1%;padding-left:10px;\">{{h.percent|number:1}}%</td>\n          </tr>\n        </table>\n      </div>\n    </div>\n    <div class=\"row text-left\" style=\"margin-top:15px\">\n      <div class=\"col-sm-6\">\n        <p ng-if=\"vm.insights.geo.states > 1\">\n          <strong class=\"text-bx-accessible-grey\">INSIGHT</strong>\n          You have viewers in\n          <span ng-if=\"vm.insights.geo.countries > 1\"><strong>{{vm.insights.geo.countries}} countries</strong> and</span>\n          <strong>{{vm.insights.geo.states}} states</strong>.\n        </p>\n      </div>\n      <div class=\"col-sm-6\">\n        <p ng-if=\"vm.insights.device\">\n          <strong class=\"text-bx-accessible-grey\">INSIGHT</strong>\n          Most viewers watch on <strong>{{vm.insights.device}}</strong>.\n        </p>\n      </div>\n    </div>\n\n    <hr>\n\n    <a class=\"btn btn-default btn-block overflow-ellipse\" ng-if=\"::vm.canReadViewerAnalyticsReports\" ui-sref=\"reports.viewer({report:'broadcasts',id:vm.broadcast.id})\" style=\"text-align:left\">\n      <i class=\"fa fa-line-chart\" style=\"width:20px\"></i>\n      View Detailed Analytics\n    </a>\n  </div><!--/vm.hasAnalyticsFeature-->\n\n  <div ng-if=\"::!vm.hasAnalyticsFeature\" style=\"position:relative\">\n    <div style=\"filter:blur(2px);padding:2px;\">\n      <h4 style=\"font-weight:bold\">Live Viewer Engagement</h4>\n      <div style=\"margin-botom:15px\">\n        <img class=\"img\" src=\"/img/sample-engagement.jpg\" style=\"width:100%\">\n      </div>\n      <p style=\"margin-top:15px\">\n        <strong style=\"color:#aaa\">INSIGHT</strong> The average viewer watched <strong>23%</strong> of the broadcast.\n      </p>\n      <hr>\n      <div class=\"row text-left\">\n        <div class=\"col-sm-6\">\n          <h4 style=\"font-weight:bold\">Location</h4>\n          <img class=\"img\" src=\"/img/sample-geo-location.jpg\" style=\"width:100%\">\n        </div>\n        <div class=\"col-sm-6\">\n          <h4 style=\"font-weight:bold\">Viewership by Source</h4>\n          <table style=\"width:100%;\">\n            <tr style=\"font-weight:bold;color:#aaa;\">\n              <td>DESTINATION</td>\n              <td>VIEWS</td>\n            </tr>\n            <tr><td>mywebsite.com</td><td><strong>1,000</strong> (60%)</td></tr>\n            <tr><td>boxcast.tv</td><td><strong>7000</strong> (30%)</td></tr>\n            <tr><td>BoxCast.tv for Roku</td><td><strong>200</strong> (10%)</td></tr>\n          </table>\n        </div>\n      </div>\n      <div class=\"row text-left\" style=\"margin-top:15px\">\n        <div class=\"col-sm-6\">\n          <p>\n            <strong style=\"color:#aaa\">INSIGHT</strong> You have viewers in <strong>2 countries</strong> and</span> <strong>25 states</strong>.\n          </p>\n        </div>\n        <div class=\"col-sm-6\">\n          <p>\n            <strong style=\"color:#aaa\">INSIGHT</strong> Most viewers watch on <strong>mobile devices</strong>.\n          </p>\n        </div>\n      </div>\n    </div>\n    <div class=\"text-center\"\n      style=\"position:absolute;z-index:1;top:0;left:0;bottom:0;right:0;background:rgba(255,255,255,0.75);padding-top:100px\">\n\n      <h3>Upgrade to Enhanced Analytics</h3>\n      <p><upgrade-button></upgrade-button></p>\n\n    </div>\n  </div><!--/!vm.hasAnalyticsFeature-->\n\n</div>\n"

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
// directive
//   <broadcast-card broadcast="broadcast" />

var module = angular.module('app.directives');
module.directive('broadcastCard', function ($window, $timeout, $state, $filter, $rootScope) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      showViewCount: '=',
      extraCssClasses: '=',
      preventEdit: '=',
      onSelect: '&'
    },
    controller: BroadcastCardController,
    controllerAs: 'vm',
    template: "\n      <!-- go from 4-across to 2-across to 1-across -->\n      <div class=\"broadcast-card {{extraCssClasses}}\" style=\"padding: 10px 0;\">\n        <div class=\"col-xs-12\">\n          <div class=\"broadcast-card-image-wrapper\">\n            <div ng-click=\"vm.select()\">\n              <div class=\"broadcast-card-image-preview\" ng-style=\"{ 'background-image': 'url(&quot;'+broadcast.preview+'&quot;)' }\"></div>\n              <div class=\"broadcast-card-image-wrapper__message message\" ng-if=\"messageTitle\">\n                  {{messageTitle}}\n                  <div><small>{{messageDetails}}</small></div>\n              </div>\n              <div class=\"broadcast-card__stats view-stats\">\n                <div class=\"broadcast-card__stats__left pull-left\">\n                  <span class=\"broadcast-card__duration\">{{duration}}</span>\n                  <span class=\"broadcast-card__views-count\" ng-if=\"(broadcast.total_view_count !== null && showViewCount)\">\n                    | {{broadcast.total_view_count | number}} view{{ broadcast.total_view_count != 1 ? \"s\" : \"\" }}\n                  </span>\n                </div>\n                <div class=\"broadcast-card__stats__right pull-right\">\n                  <span ng-if=\"broadcast.is_ticketed\" class=\"broadcast-card__ticket-label label label-success\">${{broadcast.ticket_price | number:2}} / ticket</span>\n                  <span ng-if=\"broadcast.is_private\" class=\"broadcast-card__private-label label label-danger\">Private</span>\n                </div>\n                <div class=\"clearfix\"></div>\n              </div>\n            </div>\n            <div style=\"position:absolute;left:5px;top:5px\" ng-if=\"broadcast.timeframe == 'current'\">\n              <label class=\"label label-danger\">LIVE</label>\n            </div>\n            <div class=\"broadcast-card__edit-toggle\" ng-if=\"!preventEdit && vm.canEdit\">\n              <a class=\"action-link\" href=\"javascript://\" ng-click=\"vm.edit()\">\n                <i class=\"fa fa-pencil\"></i> Edit\n              </a>\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n        <div class=\"col-xs-12\">\n          <h4 class=\"broadcast-card--name broadcast-card__name\" style=\"margin:1rem 0 .4rem; white-space:nowrap; text-overflow:ellipsis; overflow:hidden; line-height:1.2;\">\n            <a href=\"javascript://\" ng-click=\"vm.select()\">\n              {{broadcast.name}}\n            </a>\n          </h4>\n          <div class=\"broadcast-card--date broadcast-card__date\" style=\"white-space:nowrap; text-overflow:ellipsis; overflow:hidden\">\n            <date-range start=\"broadcast.starts_at\" end=\"broadcast.stops_at\"></date-range>\n          </div>\n          <div class=\"broadcast-card--description broadcast-card__description\" style=\"white-space:nowrap; text-overflow:ellipsis; overflow:hidden\">\n            <strong><small>{{broadcast.description || '&nbsp;'}}</small></strong>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    ",
    link: function link(scope, element, attrs) {
      var account = $rootScope.account;
      scope.$watch('broadcast', function (broadcast) {
        scope.duration = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["b" /* differenceFormattedAsDurationLabel */])(moment(broadcast.starts_at), moment(broadcast.stops_at));

        if (!broadcast.preview && broadcast.stream_source == 'imported' && broadcast.recording_id) {
          broadcast.preview = '/img/imported-recording.png';
        } // Show message overlay in some special cases. We don't handle all the cases
        // that the actual player widget does, but gets the point across.


        if (broadcast.recording_will_purge_at && new Date() > new Date(broadcast.recording_will_purge_at)) {
          scope.messageTitle = 'Recording was deleted.';
        } else if (broadcast.recording_will_purge_at) {
          scope.messageTitle = 'Recording is scheduled for deletion.';
          scope.messageDetails = "Will be deleted on ".concat($filter('date')(broadcast.recording_will_purge_at));
        } else if (account.storage_policy == 'auto-delete' && broadcast.storage_expires_at && new Date() > new Date(broadcast.storage_expires_at)) {
          scope.messageTitle = 'Recording has expired.';
        } else if (broadcast.recording_requested === false) {
          // This check is explicit, because it could be ''
          if (broadcast.timeframe == 'current') {
            scope.messageTitle = ''; // live badge
          } else if (broadcast.timeframe == 'preroll') {
            scope.messageTitle = 'Starting Soon';
          } else if (broadcast.timeframe == 'past' && broadcast.do_not_record) {
            scope.messageTitle = 'Broadcast was live-only';
          }
        } else if (moment(broadcast.starts_at) > moment()) {
          scope.messageTitle = "Scheduled to begin ".concat($filter('relativeTime')(broadcast.starts_at));
          scope.messageDetails = $filter('streamSourceName')(broadcast);
        } else if (!broadcast.preview) {
          if (broadcast.stream_source == 'imported' && !broadcast.recording_id) {
            scope.messageTitle = 'Recording is processing';
          } else {
            // (preroll, etc. are handled generally on live view by real player widget)
            scope.messageTitle = 'No recording was found';
          }
        }
      });
    }
  };
});

function BroadcastCardController($scope, $uibModal, $rootScope, $state) {
  'ngInject';

  this.videoLoaded = false;
  this.canEdit = $rootScope.user.can('update', 'broadcast/*');

  this.edit = function () {
    $uibModal.open({
      template: __webpack_require__(197),
      controller: 'EditEventController',
      controllerAs: 'vm',
      resolve: {
        broadcastId: function broadcastId() {
          return $scope.broadcast.id;
        },
        activeTab: function activeTab() {
          return null;
        }
      }
    }).result.then(function (broadcast) {
      $scope.broadcast = broadcast;
      $scope.$emit('broadcast:edited', broadcast);
    });
  };

  this.select = function () {
    // XXX: We would love to do something like:
    //   if ($scope.onSelect) { ... } else { ... }
    // here, but Angular _always_ binds $scope.onSelect to _something_, even if it's not bound
    // in the parent controller. So in order to determine if a function _actually_ handled the
    // onSelect event or not, we expect the caller to return true if dealt with, or false if not.
    // And if the function is not bound, it will return undefined, which is falsy.
    var handled = false;

    if ($scope.onSelect) {
      handled = $scope.onSelect({
        broadcast: $scope.broadcast
      });
    }

    if (!handled) {
      $state.go('events.detail', {
        id: $scope.broadcast.id
      });
    }
  };
}

/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// broadcast label list directive
//
//   <broadcast-label-list broadcast="broadcast" />
var module = angular.module('app.directives');
module.directive('broadcastLabelList', function ($rootScope) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcast: '='
    },
    template: "\n      <ul class=\"list-inline\">\n        <li ng-if=\"broadcast.timeframe == 'current'\">\n          <span class=\"label label-danger\">LIVE</span>\n        </li>\n        <li ng-if=\"broadcast.timeframe == 'preroll'\">\n          <span class=\"label label-warning\"><i class=\"fa fa-spin fa-cog\"></i> Preparing to Stream</span>\n        </li>\n        <li ng-if=\"broadcast.timeframe == 'future'\">\n          <span class=\"label label-warning\">Starts <span am-time-ago=\"broadcast.starts_at\"></span></span>\n        </li>\n        <li ng-if=\"broadcast.timeframe == 'past'\">\n          <span class=\"label label-default\">Ended <span am-time-ago=\"broadcast.stops_at\"></span></span>\n        </li>\n        <li ng-if=\"broadcast.is_ticketed\">\n          <span class=\"label label-success\">${{broadcast.ticket_price | number:2}} / ticket</span>\n        </li>\n        <li ng-if=\"broadcast.is_ticketed && broadcast.free_variant != 'none'\">\n          <span class=\"label label-success\">Free {{broadcast.free_variant}}</span>\n        </li>\n        <li ng-if=\"broadcast.is_private\">\n          <span class=\"label label-default\" style=\"background:#000\">Private</span>\n        </li>\n        <li ng-if=\"broadcast.transcoder_profile\">\n          <span ng-if=\"showLimitTranscoder()\" uib-tooltip=\"Limited to {{showLimitTranscoder()}} for viewers\" class=\"label label-default\">{{fixTranscoderProfile(broadcast.transcoder_profile)}}*</span>\n          <span ng-if=\"!showLimitTranscoder()\" class=\"label label-default\">{{fixTranscoderProfile(broadcast.transcoder_profile)}}</span>\n        </li>\n        <li ng-if=\"broadcast.actual_codec == 'hevc'\">\n          <span class=\"label label-default\">HEVC</span>\n        </li>\n      </ul>\n    ",
    link: function link(scope, element, attrs) {
      scope.fixTranscoderProfile = function (transcoder_profile) {
        // :hevc can be removed as it's accounted for elsewhere
        // :us is meaningless to customers
        var tp = transcoder_profile.replace(/:.*/, '');

        if (tp == 'audio') {
          tp = 'Audio';
        }

        return tp;
      };

      scope.showLimitTranscoder = function () {
        var resolution = parseInt(scope.fixTranscoderProfile(scope.broadcast.transcoder_profile || '').replace('p60', '').replace('p', ''), 10);

        if ($rootScope.account.resolution_limit < resolution) {
          return "".concat($rootScope.account.resolution_limit, "p");
        } else {
          return null;
        }
      };
    }
  };
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// color swatch directive
//
//   <color-swatch color="#8a7d0a" label="foo bar" />
var BASE_STYLE = {
  display: 'inline-block',
  width: '100px',
  backgroundColor: '--passed-in--',
  color: '#fff',
  textShadow: '0 0 2px rgba(0,0,0,0.3)',
  padding: '3px',
  textAlign: 'center',
  border: '1px solid #ccc',
  borderRadius: '4px'
};
var module = angular.module('app.directives');
module.directive('colorSwatch', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      color: '=',
      label: '=',
      extraStyle: '='
    },
    template: "\n      <span ng-style=\"style\">{{label}}</span>\n    ",
    link: function link(scope, element) {
      function computeStyle() {
        scope.style = _.extend({}, BASE_STYLE, scope.extraStyle || {}, {
          backgroundColor: scope.color
        });
      }

      computeStyle();
      scope.$watchCollection(function () {
        return [scope.color, scope.label];
      }, computeStyle);
    }
  };
});

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// compare-to-percent directive
//
//   <compare-to-percent base="10" compare="5" />
//
// yields
//
//   <strong class="text-success">
//     <i class="fa fa-caret-up"></i> 100%
//   </strong>
var module = angular.module('app.directives');
module.component('compareToPercent', {
  bindings: {
    base: '<',
    compare: '<'
  },
  template: "\n    <span ng-if=\"$ctrl.base == $ctrl.compare\">\n      <strong class=\"text-success\">-</strong>\n    </span>\n    <span ng-if=\"$ctrl.base != $ctrl.compare && !$ctrl.compare\">\n      <strong class=\"text-success\">\n        <i class=\"fa fa-caret-up\"></i> 1000%\n      </strong>\n    </span>\n    <span ng-if=\"$ctrl.compare && $ctrl.base > $ctrl.compare\">\n      <strong class=\"text-success\">\n        <i class=\"fa fa-caret-up\"></i>\n        {{100*($ctrl.base-$ctrl.compare)/$ctrl.compare|number:1}}%\n      </strong>\n    </span>\n    <span ng-if=\"$ctrl.compare && $ctrl.base < $ctrl.compare\">\n      <strong class=\"text-danger\">\n        <i class=\"fa fa-caret-down\"></i>\n        {{100*($ctrl.compare-$ctrl.base)/$ctrl.compare|number:1}}%\n      </strong>\n    </span>\n  "
});

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// date range directive
//
//   <date-range start="vm.startDate" end="vm.endDate" />
var module = angular.module('app.directives');
module.directive('dateRange', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      start: '=',
      end: '=',
      unstyled: '='
    },
    template: "\n      <span ng-class=\"{'date-range': !unstyled}\">{{start | date:'MMM d, y h:mm a'}}</span>\n      <span ng-if=\"end && !end.startsWith('9999-12-31')\">\n        - <span ng-class=\"{'date-range': !unstyled}\">{{endDateDisplay}}{{end | date:'shortTime'}}</span>\n      </span>\n    ",
    link: function link(scope, element) {
      scope.endDateDisplay = '';
      scope.$watchCollection(function () {
        return [scope.start, scope.end];
      }, function () {
        var startDay = moment(scope.start).format('MMM D'); // XXX: moment date format uses D while angular uses d

        var endDay = moment(scope.end).format('MMM D');

        if (startDay != endDay) {
          scope.endDateDisplay = endDay + ' ';
        } else {
          scope.endDateDisplay = '';
        }
      });
    }
  };
});

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// draggable and resizable directives
//
var module = angular.module('app.directives'); // Support both touch and non-touch interactions based on client type (iOS|Android).
// NOTE: attempting to detect whether using mouse or touch has a race condition,
// because by the time we'd check for first touch or mouse movement, the DOM
// could be filled already (specifically if user loads events page directly)

var events = {
  mousedown: 'mousedown',
  mousemove: 'mousemove',
  mouseup: 'mouseup',
  mouseover: 'mouseover',
  mouseout: 'mouseout'
};

if ((/iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.userAgent.indexOf('Android') >= 0) && 'ontouchstart' in window) {
  events = {
    mousedown: 'touchstart',
    mousemove: 'touchmove',
    mouseup: 'touchend',
    mouseover: 'touchstart',
    mouseout: 'touchcancel'
  };
}

function getX(evt) {
  evt = evt.originalEvent || evt;

  if (evt.touches) {
    return evt.touches[0].clientX;
  } else if (evt.changedTouches) {
    return evt.changedTouches[0].clientX;
  } else {
    return evt.clientX;
  }
}

function getY(evt) {
  evt = evt.originalEvent || evt;

  if (evt.touches) {
    return evt.touches[0].clientY;
  } else if (evt.changedTouches) {
    return evt.changedTouches[0].clientY;
  } else {
    return evt.clientY;
  }
}

module.directive('resizable', ['$document', function ($document) {
  return {
    restrict: 'A',
    scope: {
      aspectRatio: '=aspectRatio',
      onResize: '=onResize',
      onDrag: '=' //<-- to avoid multiple directives requiring isolated scope

    },
    controller: ["$scope", function controller($scope) {
      'ngInject';

      this.onDrag = function () {
        return $scope.onDrag.apply($scope, arguments);
      };
    }],
    link: function link(scope, element, attr) {
      var container = element.parents('.resizable-parent').first();

      if (!container.length) {
        console.warn('Cannot make resizable. Unable to find .resizable-parent from', element);
        return;
      }

      if (!scope.aspectRatio) {
        console.warn('Cannot make resizable without aspect-ratio specified.');
        return;
      }

      var dimension = {};
      var position = {}; //create button for resizing

      var btn = document.createElement('span');
      btn.style.width = '15px';
      btn.style.height = '15px';
      btn.style.bottom = '0px';
      btn.style.right = '0px';
      btn.style.position = 'absolute';
      btn.style.visibility = 'hidden';
      btn.style.cursor = 'nwse-resize';
      btn.innerHTML = "\n          <svg>\n            <circle cx='12.5' cy='2.5' r='2' fill='#777777'></circle>\n            <circle cx='7.5' cy='7.5' r='2' fill='#777777'></circle>\n            <circle cx='12.5' cy='7.5' r='2' fill='#424242'></circle>\n            <circle cx='2.5' cy='12.5' r='2' fill='#777777'></circle>\n            <circle cx='7.5' cy='12.5' r='2' fill='#424242'></circle>\n            <circle cx='12.5' cy='12.5' r='2' fill='#212121'></circle>\n          </svg>";
      element.append(btn); //bind resize function to button;

      btn['on' + events.mousedown] = function ($event) {
        $event.stopImmediatePropagation();
        position.x = getX($event);
        position.y = getY($event);
        var bounds = element[0].getBoundingClientRect();
        dimension.width = bounds.width;
        dimension.height = bounds.height;
        $document.bind(events.mousemove, mousemove);
        $document.bind(events.mouseup, mouseup);
        return false;
      };

      var mousemove = function mousemove($event) {
        var dw = position.x - getX($event);
        var dh = position.y - getY($event);
        var bounds = container[0].getBoundingClientRect();
        var cW = bounds.width;
        var cH = bounds.height; // take smallest axis movement as constraint

        if (dw < dh) {
          var w = dimension.width - dw;
          var h = w * scope.aspectRatio;
        } else {
          var h = dimension.height - dh;
          var w = h / scope.aspectRatio;
        }

        var wPct = 100 * (w / cW);
        var hPct = 100 * (h / cH);

        if (wPct >= 100 || hPct >= 100) {
          if (wPct >= hPct) {
            wPct = 100;
            hPct = wPct * scope.aspectRatio * (cW / cH);
          } else {
            hPct = 100;
            wPct = hPct / scope.aspectRatio * (cH / cW);
          }
        }

        if (wPct < 1 || hPct < 1) {
          return false; // too small, don't let it shrinkify
        }

        element.css({
          width: wPct + '%',
          height: hPct + '%'
        });
        scope.onResize(wPct, hPct);
        return false;
      };

      var mouseup = function mouseup() {
        $document.unbind(events.mousemove, mousemove);
        $document.unbind(events.mouseup, mouseup);
      }; //show button on hover


      element.bind(events.mouseover, function () {
        btn.style.visibility = 'visible';
      });
      element.bind(events.mouseout, function () {
        btn.style.visibility = 'hidden';
      });
    }
  };
}]).directive('draggable', ['$document', function ($document) {
  return {
    restrict: 'A',
    require: 'resizable',
    link: function link(scope, element, attrs, resizableCtrl) {
      var container = element.parents('.draggable-parent').first();

      if (!container.length) {
        console.warn('Cannot make draggable. Unable to find .draggable-parent from', element);
        return;
      }

      var position = {};
      element.bind(events.mousedown, function ($event) {
        position.x = element.position().left;
        position.y = element.position().top;
        position.initialMouseX = getX($event);
        position.initialMouseY = getY($event);
        $document.bind(events.mousemove, mousemove);
        $document.bind(events.mouseup, mouseup);
        return false;
      });

      var mousemove = function mousemove($event) {
        var dx = getX($event) - position.initialMouseX;
        var dy = getY($event) - position.initialMouseY;
        var bounds = container[0].getBoundingClientRect();
        var cW = bounds.width;
        var cH = bounds.height;
        var x = position.x + dx;
        var y = position.y + dy;
        var xPct = 100 * (x / cW);
        var yPct = 100 * (y / cH);
        yPct = Math.min(Math.max(0, yPct), 100);
        xPct = Math.min(Math.max(0, xPct), 100);
        element.css({
          left: xPct + '%',
          top: yPct + '%'
        });
        resizableCtrl.onDrag(xPct, yPct);
        return false;
      };

      var mouseup = function mouseup() {
        $document.unbind(events.mousemove, mousemove);
        $document.unbind(events.mouseup, mouseup);
      };
    }
  };
}]);

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// facebook video directive
//
//   <facebook-video settings="broadcast.simulcast_configurations[0]" />
//
var module = angular.module('app.directives');
module.directive('facebookVideo', ["Facebook", function (Facebook) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      settings: '='
    },
    template: "\n      <div ng-show=\"readyToShow\" class=\"facebook-embed\"></div>\n    ",
    link: function link(scope, element) {
      scope.$watch(function () {
        return scope.settings && scope.settings.fb_id;
      }, function (id) {
        if (!id) return;
        scope.readyToShow = true;
        element.find('.facebook-embed').html("\n          <div class=\"fb-video\"\n               data-href=\"https://www.facebook.com/video.php?v=".concat(id, "\"\n               data-allowfullscreen=\"true\"\n               data-width=\"500\"></div>\n        "));
        setTimeout(function () {
          return window['FB'] && FB.XFBML.parse();
        }, 0);
      });
    }
  };
}]);

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// firmware version directive
//
//   <firmware-version boxcaster="vm.boxcaster" concise="false" />
var module = angular.module('app.directives');
module.component('firmwareVersion', {
  bindings: {
    boxcaster: '=',
    concise: '=?'
  },
  template: "\n    <span ng-if=\"vm.showVersion\">\n      {{vm.boxcaster.firmware_released_at | date:'shortDate'}}\n    </span>\n    <span ng-if=\"!vm.showVersion\">\n      (N/A)\n    </span>\n    &nbsp;|&nbsp;\n    <span ng-switch=\"vm.boxcaster.firmware_status\">\n      <span ng-switch-when=\"current\" class=\"text-success\">\n        <i class=\"fa fa-check\"></i>\n        <span ng-if=\"!vm.concise\">Up to date</span>\n      </span>\n      <a class=\"subtle-link\" href=\"https://support.boxcast.com/en/articles/4533001\" target=\"_blank\"\n          ng-switch-when=\"outdated\" uib-tooltip=\"Updated firmware is available for this BoxCaster. It is not urgent, but you should try to power on the BoxCaster when nothing is scheduled so that the firmware can remain up to date.\">\n        <span class=\"text-info\"><i class=\"fa fa-info-circle\"></i> <span ng-if=\"!vm.concise\">Update Available</span></span>\n      </a>\n      <a class=\"subtle-link\" href=\"https://support.boxcast.com/en/articles/4533001\" target=\"_blank\"\n          ng-switch-when=\"invalid\" uib-tooltip=\"The current BoxCaster firmware is invalid. You should power on the BoxCaster when no broadcasts are scheduled so that it can update to a valid firmware release.\">\n        <span class=\"text-danger\"><i class=\"fa fa-warning\"></i> <span ng-if=\"!vm.concise\">Invalid</span></span>\n      </a>\n    </span>\n  ",
  controllerAs: 'vm',
  controller: ["$scope", function controller($scope) {
    'ngInject';

    var _this = this;

    $scope.$watch(function () {
      return _this.boxcaster && _this.boxcaster.firmware_released_at;
    }, function () {
      if (_this.boxcaster && _this.boxcaster.firmware_released_at) {
        _this.showVersion = !_this.boxcaster.firmware_released_at.startsWith('1970');
      } else {
        _this.showVersion = false;
      }
    });
  }]
});

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// show a preview of an uploaded image in a fixed size container
//
//   <fixed-image-preview src="{...}" width="1280" height="720" />
//
var module = angular.module('app.directives');
module.directive('fixedImagePreview', function () {
  'ngInject';

  return {
    scope: {
      src: '=',
      width: '=',
      height: '=',
      onLoad: '&'
    },
    template: "\n      <div style=\"background:#eee;position:relative\" ng-style=\"{width: width, height: height}\">\n        <div style=\"position:absolute;left:0;top:0;right:0;bottom:0;display:flex;align-items:center;\" ng-style=\"{\n          'background-image': 'url(&quot;'+src+'&quot;)',\n          'background-repeat': 'no-repeat',\n          'background-position': '0% 0%',\n          'background-size': 'contain',\n        }\">\n          <small style=\"flex:1;color:#aaa;text-align:center;\" ng-show=\"!src\">Not Configured</small>\n          <img ng-src=\"{{src}}\" style=\"visibility:hidden;height:1px;width:1px;\" ng-onload=\"onLoad({$event: $event})\">\n        </div>\n      </div>\n    "
  };
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_download__ = __webpack_require__(26);

angular.module('app.directives').directive('lowLatencyPlayer', function ($timeout, $analytics) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcast: '='
    },
    template: "\n        <div>\n          <div ng-show=\"no_op || !dismissed\" style=\"position:absolute; z-index:1; top:50px; left:20px; right:20px; padding:10px 30px 10px 10px; border: 1px solid;\" class=\"bg-warning text-warning text-center\" style=\"border:1px solid;margin:45px 15px 15px 15px;padding:15px;\">\n            <button type=\"button\" class=\"close\" ng-click=\"dismissed = true\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n            Low-Latency Preview requires Flash, which is no longer supported.<br>\n            You can still view the preview in BoxCast Broadcaster on your iOS device or in VLC if it is installed on your computer.\n            <ul class=\"list-inline\" style=\"margin-top:10px\">\n              <li>\n                <button type=\"button\" ng-click=\"openVLC(broadcast)\" class=\"btn btn-default\">\n                <img src=\"/img/icon-vlc.png\" style=\"height:32px\"> Open with VLC\n                </button>\n              </li>\n              <li>\u2022</li>\n              <li>\n                <a href=\"https://www.videolan.org/vlc/\" target=\"_blank\" class=\"subtle-link\">Download VLC</a>\n              </li>\n              <li>\u2022</li>\n              <li>\n                <a href=\"https://support.boxcast.com/en/articles/4235096-troubleshoot-remotely-using-low-latency-preview\" target=\"_blank\" class=\"subtle-link\">Learn More</a>\n              </li>\n            </ul>\n          </div>\n          <div id=\"{{:: id}}\" class=\"player\"></div>\n        </div>\n      ",
    link: function link(scope, element, attrs, ngModel) {
      scope.id = "player-".concat(0 | Math.random() * 1000000);
      scope.no_op = false;
      scope.dismissed = false;
      var ctx = boxcast("#".concat(scope.id));
      scope.$watch(function () {
        return scope.broadcast && scope.broadcast.rtmp_preview_url;
      }, function (rtmp_preview_url) {
        if (rtmp_preview_url) {
          ctx.unload();
          ctx.loadLowLatency(rtmp_preview_url, {
            disableMetrics: true,
            debug: true,
            env: BOXCAST_JS_ENV,
            onLoadPlayer: function onLoadPlayer(p) {
              if (p.core.getCurrentPlayback().name == 'no_op') {
                $analytics.eventTrack('playback-blocked', {
                  category: 'low-latency-player'
                });
                ctx.unload();
                scope.$evalAsync(function () {
                  return scope.no_op = true;
                });

                if (canRequestPermission) {
                  // in case, when flash is not available, try to prompt user to enable it
                  requestFlashPermission(); // Chrome requires user's click in order to allow iframe embeding

                  $(window).one('click', requestFlashPermission);
                }
              }
            }
          });
        } else {
          ctx.unload();
        }
      });

      scope.openVLC = function (broadcast) {
        var vlcPlaylist = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n          <playlist xmlns=\"http://xspf.org/ns/0/\" xmlns:vlc=\"http://www.videolan.org/vlc/playlist/ns/0/\" version=\"1\">\n            <title>BoxCast Preview</title>\n            <trackList>\n              <track>\n                <location>".concat(broadcast.rtmp_preview_url, "</location>\n                <extension application=\"http://www.videolan.org/vlc/playlist/0\">\n                  <vlc:id>0</vlc:id>\n                  <vlc:option>network-caching=1000</vlc:option>\n                </extension>\n              </track>\n            </trackList>\n            <extension application=\"http://www.videolan.org/vlc/playlist/0\">\n              <vlc:item tid=\"0\"/>\n            </extension>\n          </playlist>\n          ");
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_download__["a" /* forceBrowserDownload */])('data:application/octet-stream;charset=utf-8,' + vlcPlaylist, 'boxcast-playlist.xspf');
      };

      scope.$on('$destroy', function () {
        if (ctx) ctx.unload();
      });
      $analytics.eventTrack('playback-requested', {
        category: 'low-latency-player'
      });
    }
  };
});
/**
 * Tries to show browser's promt for enabling flash
 *
 * Chrome starting from 56 version and Edge from 15 are disabling flash
 * by default. To promt user to enable flash, they suggest to send user to
 * flash player download page. Then this browser will catch such request
 * and show a promt to user:
 * https://www.chromium.org/flash-roadmap#TOC-Developer-Recommendations
 * In this method we are forcing such promt by navigating user to adobe
 * site in iframe, instead of top window
 */

function requestFlashPermission() {
  var iframe = document.createElement('iframe');
  iframe.src = 'https://get.adobe.com/flashplayer';
  iframe.sandbox = '';
  document.body.appendChild(iframe);
  document.body.removeChild(iframe);
}

var isNewEdge = navigator.userAgent.match(/Edg\//) || (navigator.userAgent.match(/Edge\/(\d+)/) || [])[1] > 14;
var isNewSafari = (navigator.userAgent.match(/OS X (\d+)/) || [])[1] > 9;
var isNewChrome = (navigator.userAgent.match(/Chrom(e|ium)\/(\d+)/) || [])[2] > 56 && !/Mobile/i.test(navigator.userAgent);
var canRequestPermission = isNewEdge || isNewSafari || isNewChrome;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// onload directive
//
//   <img src="..." ng-onload="vm.onImageLoad($event)" />
var module = angular.module('app.directives');
module.directive('ngOnload', ['$parse', function ($parse) {
  'ngInject';

  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var fn = $parse(attrs.ngOnload);
      elem.on('load', function (event) {
        scope.$apply(function () {
          fn(scope, {
            $event: event
          });
        });
      });
    }
  };
}]);

/***/ }),
/* 353 */
/***/ (function(module, exports) {

var BOXCAST_URL_REGEXP = /boxcast\.com/;
angular.module('app.directives').directive('notBoxcast', function () {
  'ngInject';

  return {
    require: 'ngModel',
    link: function link(scope, elm, attrs, ctrl) {
      ctrl.$validators.notBoxcast = function (modelValue, viewValue) {
        if (ctrl.$isEmpty(modelValue)) {
          // consider empty models to be valid
          return true;
        }

        return !BOXCAST_URL_REGEXP.test(viewValue);
      };
    }
  };
});

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// number spinner directive
//
//   <number-spinner ng-model="vm.myNumber"
//                   min-value="0"
//                   max-value="100" />
var module = angular.module('app.directives');
module.directive('numberSpinner', ["$timeout", function ($timeout) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      minValue: '=',
      maxValue: '=',
      ngChange: '@',
      size: '@',
      width: '@'
    },
    require: 'ngModel',
    template: "\n      <div class=\"input-group\" style=\"width:{{width}}; margin:0 auto;\">\n        <div class=\"input-group-btn\">\n          <button class=\"btn btn-default btn-{{size}}\"\n                  style=\"padding-left:10px;padding-right:10px\"\n                  ng-click=\"decrement()\"\n                  tabindex=\"-1\">\n            <i class=\"fa fa-minus\" style=\"color: #999\"></i>\n          </button>\n        </div>\n        <input type=\"text\"\n               class=\"form-control input-{{size}}\"\n               style=\"min-width:20px; padding-left:0; padding-right:0; text-align:center;\"\n               ng-model=\"ngModel\"\n               onclick=\"this.setSelectionRange(0, this.value.length)\">\n        <div class=\"input-group-btn\">\n          <button class=\"btn btn-default btn-{{size}}\"\n                  style=\"padding-left:10px;padding-right:10px\"\n                  ng-click=\"increment()\"\n                  tabindex=\"-1\">\n            <i class=\"fa fa-plus\" style=\"color: #999\"></i>\n          </button>\n        </div>\n      </div>\n      <!--\n      <a href=\"javascript://\"\n         ng-click=\"decrement()\"><i class=\"fa fa-minus-square\"></i></a>\n      <span style=\"border:1px solid #aaa; padding:0 10px;\">{{ngModel}}</span>\n      <a href=\"javascript://\"\n         ng-click=\"increment()\"><i class=\"fa fa-plus-square\"></i></a>\n      -->\n    ",
    link: function link(scope, element, attrs, ngModelCtrl) {
      scope.minValue = typeof scope.minValue == 'undefined' ? 0 : scope.minValue;
      scope.maxValue = typeof scope.maxValue == 'undefined' ? 999 : scope.maxValue;

      if (attrs.ngChange) {
        ngModelCtrl.$viewChangeListeners.push(function () {
          scope.$eval(attrs.ngChange);
        });
      }

      scope.decrement = function () {
        var newValue = ngModelCtrl.$modelValue - 1;
        update(isNaN(newValue) ? scope.minValue : newValue);
      };

      scope.increment = function () {
        var newValue = ngModelCtrl.$modelValue + 1;
        update(isNaN(newValue) ? scope.minValue : newValue);
      };

      element.find('input.form-control').on('change', function () {
        var _this = this;

        $timeout(function () {
          return update($(_this).val());
        });
      });

      function update(value) {
        if (value === '' || value === null) {
          value = ''; //empty string is a valid state that shouldn't be coerced to 0
        } else {
          value = parseInt(value, 10);
          if (value > scope.maxValue) value = scope.maxValue;
          if (isNaN(value) || value < scope.minValue) value = scope.minValue;
        }

        scope.ngModel = value;
        ngModelCtrl.$setViewValue(value);
        ngModelCtrl.$commitViewValue();

        if (scope.onChange) {
          scope.onChange(value);
        }
      }

      scope.$watch('ngModel', function (newValue) {
        if (isNaN(ngModelCtrl.$modelValue)) {
          scope.increment(); // reset to min value if not defined
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 355 */
/***/ (function(module, exports) {

angular.module('app.directives').component('radioButtonWell', {
  transclude: true,
  controllerAs: 'vm',
  bindings: {
    heading: '@',
    onSelect: '&',
    isSelected: '&',
    alwaysShowTransclude: '<',
    hideCheckbox: '<'
  },
  template: "\n    <div class=\"row\">\n      <div class=\"col-sx-12\">\n        <div class=\"radio-button-well\" ng-class=\"vm.isSelected() ? 'radio-button-well-selected' : ''\">\n          <a href=\"javascript://\" ng-click=\"vm.onSelect()\">\n            <div class=\"row\" style=\"display:flex;align-items:center;\">\n              <div class=\"col-xs-1\" style=\"width:30px;\">\n                <i ng-hide=\"vm.hideCheckbox\" class=\"fa\" ng-class=\"vm.isSelected() ? 'fa-check-circle-o text-success' : 'fa-circle-o'\"\n                  style=\"font-size:16px;\"></i>\n              </div>\n              <div class=\"col-xs-11\">\n                <b>{{vm.heading}}</b>\n                <div ng-if=\"vm.isSelected() || vm.alwaysShowTransclude\">\n                  <div ng-transclude></div>\n                </div>\n              </div>\n            </div>\n          </a>\n        </div>\n      </div>\n    </div>\n    "
});

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// random waiting message directive to entertain your users while they sit
var module = angular.module('app.directives');
var MESSAGES = ['Locating the required gigapixels to render...', 'Spinning up the hamster...', 'Shovelling coal into the server...', 'Programming the flux capacitor...', 'Pay no attention to the man behind the curtain...', 'Enjoy the elevator music...', 'This server must be powered by a lemon and two electrodes...', 'The version I have of this in testing has much funnier waiting messages...', '999 bottles of soda on the wall...', 'Searching for Answer to Life, the Universe, and Everything...'];
module.directive('randomWaitingMessage', ["$interval", function ($interval) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      interval: '@'
    },
    template: "\n      <span>{{message}}</span>\n    ",
    link: function link(scope, element) {
      function changeMessage() {
        scope.message = _.sample(MESSAGES);
      }

      var cancelInterval = $interval(changeMessage, scope.interval);
      scope.$on('$destroy', cancelInterval);
      changeMessage();
    }
  };
}]);

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

// recording source chooser directive
//
//   <recording-source-chooser edit-or-create-event-service="vm.service" />
//
var module = angular.module('app.directives');
module.directive('recordingSourceChooserPreview', function () {
  return {
    restrict: 'E',
    scope: {
      broadcast: '='
    },
    template: "\n      <div>\n        <div style=\"display: inline-flex; float: left; width: 32px; height: 18px; margin-top: 1px; margin-right: 6px;\"\n             ng-style=\"{\n               'background-image': 'url(&quot;' + broadcast.preview + '&quot;)',\n               'background-size': 'contain',\n               'background-repeat': 'no-repeat'\n             }\">\n        </div>\n        <div class=\"date-range\" style=\"display: inline-flex; float: right; margin-left: 6px;\">\n          ({{broadcast.starts_at | date}})\n        </div>\n        <div class=\"overflow-ellipse\">\n          {{broadcast.name}}\n        </div>\n      </div>\n    "
  };
});
module.directive('recordingSourceChooser', function () {
  return {
    restrict: 'E',
    scope: {
      editOrCreateEventService: '=',
      onSelectBroadcast: '=',
      selectSourceTitle: '@',
      skipRecordingSourceValidation: '=',
      modalTitle: '@',
      broadcastValidator: '='
    },
    template: "\n      <div ng-show=\"editOrCreateEventService.sourceBroadcast\"\n           ng-click=\"chooseSource($event)\"\n           style=\"border: 1px solid #ccc; border-radius: 4px; padding: 8px;\"\n           ng-style=\"style\">\n        <recording-source-chooser-preview broadcast=\"editOrCreateEventService.sourceBroadcast\"></recording-source-chooser-preview>\n      </div>\n      <div ng-show=\"!editOrCreateEventService.sourceBroadcast\"\n           ng-click=\"chooseSource($event)\"\n           style=\"border: 1px solid #ccc; color: #757575; border-radius: 4px; padding: 8px;\"\n           ng-style=\"style\">\n        <span ng-show=\"!editOrCreateEventService.sourceBroadcastUnavailable\">\n          {{::(selectSourceTitle || 'Select Source...')}}\n        </span>\n        <span ng-show=\"editOrCreateEventService.sourceBroadcastUnavailable\">\n          Source Broadcast Unavailable\n        </span>\n      </div>\n    ",
    controller: ["$scope", "$uibModal", function controller($scope, $uibModal) {
      'ngInject';

      $scope.style = {};

      if (($scope.editOrCreateEventService.broadcast.timeframe || 'future') == 'future') {
        $scope.style.cursor = 'pointer';
      } else {
        $scope.style.cursor = 'not-allowed';
        $scope.style['background-color'] = '#eee';

        _.each(['-webkit-', '-khtml-', '-moz-', '-o-', ''], function (prefix) {
          return $scope.style["".concat(prefix, "user-select")] = 'none';
        });
      }

      $scope.chooseSource = function ($event) {
        if ($event.cancelable) {
          $event.preventDefault();
        }

        if (($scope.editOrCreateEventService.broadcast.timeframe || 'future') != 'future') return;
        $uibModal.open({
          template: __webpack_require__(199),
          controller: __webpack_require__(200)["default"],
          size: 'lg',
          controllerAs: 'vm',
          resolve: {
            options: function options() {
              return {
                activeTabIndex: 2,
                // start on past broadcast tab
                skipRecordingSourceValidation: $scope.skipRecordingSourceValidation,
                modalTitle: $scope.modalTitle,
                broadcastValidator: $scope.broadcastValidator
              };
            }
          }
        }).result.then(function (broadcast) {
          $scope.editOrCreateEventService.updateSourceBroadcast(broadcast);
          $scope.onSelectBroadcast && $scope.onSelectBroadcast(broadcast);
        });
      };
    }]
  };
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchQueryBuilder; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// Build a query to the API search service
var SearchQueryBuilder = /*#__PURE__*/function () {
  function SearchQueryBuilder() {
    _classCallCheck(this, SearchQueryBuilder);

    this.parts = [];
  }

  _createClass(SearchQueryBuilder, [{
    key: "toString",
    value: function toString() {
      return this.parts.join(' ').trim();
    }
  }, {
    key: "append",
    value: function append(term) {
      this.parts = this.parts.concat(term);
      return this;
    }
  }, {
    key: "appendSearchText",
    value: function appendSearchText(text) {
      var _this = this;

      text = (text || '').trim();

      if (isAdvancedQuery(text)) {
        // advanced mode detected
        this.append(text);
        return this;
      } else {
        splitQuoted(text).forEach(function (term) {
          _this.append(term);
        });
        return this;
      }
    }
  }]);

  return SearchQueryBuilder;
}();



function isAdvancedQuery(text) {
  // check if user is trying an advanced feature.  if so, we won't try
  // to interpret as a simple query
  return text.indexOf('starts_at:') >= 0;
}

function splitSimple(text) {
  return text.split(' ');
}

function splitQuoted(text) {
  var result = [];
  var words = splitSimple(text);
  var phrase = null;
  words.forEach(function (word) {
    if (!phrase && word.startsWith('"')) {
      // start of phrase
      if (word.endsWith('"')) {
        // single-word phrase
        phrase = '+' + word;
        result.push(phrase);
        phrase = null;
      } else {
        // multi-word phrase (need to keep looping)
        phrase = '+' + word;
      }
    } else if (phrase && word.endsWith('"')) {
      // end of current phrase
      phrase += ' ' + word;
      result.push(phrase);
      phrase = null;
    } else if (phrase) {
      // keep building...
      phrase += ' ' + word;
    } else {
      // just a plain word
      word = "+*".concat(word, "*");
      result.push(word);
    }
  });

  if (phrase) {
    // fix unbalanced quote
    phrase += '"';
    result.push(phrase);
  }

  return result;
}

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// directive for trimming a broadcast's recording
//
//    <recording-trimmer broadcast-id="10001"
//                       recording-id="20001"
//                       start-segment="vm.startSegment"
//                       stop-segment="vm.stopSegment"
//                       start-seconds="vm.startSeconds"
//                       stop-seconds="vm.stopSeconds"
//                       on-change-bounds="vm.updateBounds" />
//
//    updateBounds(startSeconds, stopSeconds, startSegment, stopSegment) {
//      ...
//    }

var THUMBNAIL_TIMEOUT = 1000;
var module = angular.module('app.directives');
module.directive('recordingTrimmer', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcastId: '=',
      recordingId: '=',
      onChangeBounds: '=',
      startSegment: '=',
      stopSegment: '=',
      startSeconds: '=',
      stopSeconds: '='
    },
    template: __webpack_require__(360),
    link: function link(scope, element, attrs) {}
  };
});
module.controller('RecordingTrimmerController', /*#__PURE__*/function () {
  function RecordingTrimmerController($scope, Recording, $q, $timeout, toaster) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, RecordingTrimmerController);

    this.$scope = $scope;
    this.Recording = Recording;
    this.$q = $q;
    this.$timeout = $timeout;
    this.toaster = toaster;
    this.zoom = 1.0; // Wait for broadcast and recording to get attached to scope before initializing
    // XXX: work around inability to attach controller directly to directive
    // definition, and instead attaching it via ngController in the template

    var parentScope = $scope.$parent;
    $scope.$watchCollection(function () {
      return [parentScope.broadcastId, parentScope.recordingId];
    }, function (args) {
      return args[0] && args[1] && _this.init.apply(_this, _toConsumableArray(args));
    }); // Watch for external changes to the start/stop segments/seconds if the callee so chooses
    // (dangerous)

    $scope.$watchCollection(function () {
      return [parentScope.startSegment, parentScope.stopSegment];
    }, function (args) {
      return _this.setTrimBoundsFromSegments(args[0], args[1]);
    });
    $scope.$watchCollection(function () {
      return [parentScope.startSeconds, parentScope.stopSeconds];
    }, function (args) {
      return _this.setTrimBoundsFromSeconds(args[0], args[1]);
    });
  }

  _createClass(RecordingTrimmerController, [{
    key: "init",
    value: function init(broadcastId, recordingId) {
      var _this2 = this;

      var Broadcast = this.Broadcast,
          Recording = this.Recording,
          $q = this.$q,
          $timeout = this.$timeout,
          $scope = this.$scope;
      this.showPreviewStartTimer = 0;
      this.showPreviewStopTimer = 0;
      this.trimBounds = [0, 0];
      this.sliderOptsTrim = {
        floor: 0,
        ceil: 1,
        //draggableRange: true,
        onlyBindHandles: true,
        keyboardSupport: false,
        translate: function translate(index, id, what) {
          return _this2.labelFor(index, id, what);
        }
      };
      this.sliderOptsPlayhead = {
        floor: 0,
        ceil: 1,
        hideLimitLabels: true,
        translate: function translate(index, id, what) {
          return _this2.labelFor(index, id, what);
        }
      }; // XXX: there appears to be some sort of race condition, where 2 simultaenous requests to the
      // same URL will cause the the resource to only be resolved once (in the container controller,
      // not this directive).  Adding a `cb` (cachebust) querystring param works around this for now.

      this.recording = Recording.get({
        id: recordingId,
        cb: Math.random()
      });
      var recordingPromise = this.recording.$promise;
      this.segments = Recording.segments({
        id: recordingId,
        cb: Math.random()
      });
      var segmentsPromise = this.segments.$promise;
      $q.all([segmentsPromise, recordingPromise]).then(function (data) {
        _this2.initSegments(data[0]); //segments must come before recording so stopSegments can be populated


        _this2.initRecording(data[1]);

        _this2.sliderOptsTrim.ceil = _this2.stopSegments.length - 1;
        _this2.sliderOptsPlayhead.floor = _this2.trimBounds[0];
        _this2.sliderOptsPlayhead.ceil = _this2.trimBounds[1];
        _this2.playhead = _this2.trimBounds[0];
        _this2.recordingDuration = _this2.stopSegments[_this2.stopSegments.length - 1].label;

        _this2.initWatchers();

        $timeout(function () {
          // Need to kick the rzslider in the teeth a bit
          $scope.$broadcast('reCalcViewDimensions');
          $scope.$broadcast('rzSliderForceRender');
        }, 250);
      }); // XXX: $q.all swallows errors so need to do this individually

      segmentsPromise["catch"](function (e) {
        console.error(e);

        _this2.toaster.pop('warning', 'Unable to load segments. Please refresh the page and try again');
      });
      recordingPromise["catch"](function (e) {
        console.error(e);

        _this2.toaster.pop('warning', 'Unable to load the recording. Please refresh the page and try again');
      });
      this.loadingPromises = [recordingPromise, segmentsPromise];
    }
  }, {
    key: "labelFor",
    value: function labelFor(index, id, what) {
      // Custom angular-slider translate function uses "floor", "ceil", "model", "high" to distinguish
      // which of the 4 labels it's binding to.  We map those to either start segment or stop segment labels.
      if (what == 'floor' || what == 'model') {
        return this.startSegments && this.startSegments[index] && this.startSegments[index].label;
      } else {
        return this.stopSegments && this.stopSegments[index] && this.stopSegments[index].label;
      }
    }
  }, {
    key: "segmentPreviewURL",
    value: function segmentPreviewURL(segmentIdx) {
      if (!this.previewBaseURL || !this.previewQueryString) {
        return null;
      }

      var vodPaths = ((this.segments || [])[segmentIdx] || {}).vod_paths || {};
      var thumbPath = vodPaths.thumbs;

      if (!thumbPath) {
        // Some (older?) recordings don't have a `thumbs` key. So try to grab _any_ value from the
        // VOD paths and turn it into a jpg. If that doesn't work, just try string formatting it.
        var fname = _.find(vodPaths);

        if (fname && fname.match(/\d{8}\.[^\.]+$/)) {
          thumbPath = fname.replace(/\.[^\.]+$/, '.jpg');
        } else {
          thumbPath = ('00000000' + segmentIdx).slice(-8) + '.jpg'; // :shrug:
        }
      }

      return this.previewBaseURL + thumbPath + '?' + this.previewQueryString;
    }
  }, {
    key: "startTimerForPreviewStart",
    value: function startTimerForPreviewStart() {
      var _this3 = this;

      var $timeout = this.$timeout;
      this.showPreviewStartTimer = new Date().getTime();
      this.showPreviewStart = true;
      $timeout(function () {
        if (_this3.showPreviewStartTimer <= new Date().getTime() - THUMBNAIL_TIMEOUT) {
          _this3.showPreviewStart = false;
        }
      }, THUMBNAIL_TIMEOUT);
    }
  }, {
    key: "startTimerForPreviewStop",
    value: function startTimerForPreviewStop() {
      var _this4 = this;

      var $timeout = this.$timeout;
      this.showPreviewStopTimer = new Date().getTime();
      this.showPreviewStop = true;
      $timeout(function () {
        if (_this4.showPreviewStopTimer <= new Date().getTime() - THUMBNAIL_TIMEOUT) {
          _this4.showPreviewStop = false;
        }
      }, THUMBNAIL_TIMEOUT);
    }
  }, {
    key: "setTrimBoundsFromSeconds",
    value: function setTrimBoundsFromSeconds(startSeconds, stopSeconds) {
      if (this.stopSegments === undefined) {
        this.startSeconds = startSeconds;
        this.stopSeconds = stopSeconds;
        return;
      }

      startSeconds = this.numberOr(startSeconds, 0);
      stopSeconds = this.numberOr(stopSeconds, this.stopSegments[this.stopSegments.length - 1].seconds);

      var startIndex = _.findIndex(this.stopSegments, function (segment) {
        return startSeconds < segment.seconds;
      });

      var stopIndex = _.findIndex(this.stopSegments, function (segment) {
        return stopSeconds <= segment.seconds;
      });

      this.setTrimBounds(startIndex, stopIndex);
    }
  }, {
    key: "setTrimBoundsFromSegments",
    value: function setTrimBoundsFromSegments(startSegment, stopSegment) {
      if (this.startSegments === undefined) {
        this.startSegment = startSegment;
        this.stopSegment = stopSegment;
        return;
      }

      startSegment = this.numberOr(startSegment, 0);
      stopSegment = this.numberOr(stopSegment, this.segments.length - 1);

      var startIndex = _.findIndex(this.startSegments, function (segment) {
        return segment.segmentIndex === startSegment;
      });

      var stopIndex = this.startSegments.length - 1;

      _.each(this.stopSegments, function (segment) {
        // There could be multiple segments that have the same segmentIndex, so iterate through
        // all to get the last one.
        if (segment.segmentIndex === stopSegment) {
          stopIndex = segment.segmentIndex;
        } else if (segment.segmentIndex > stopSegment) {
          return false; // Exit early.
        }
      });

      this.setTrimBounds(startIndex, stopIndex);
    }
  }, {
    key: "setTrimBounds",
    value: function setTrimBounds(startIndex, stopIndex) {
      if (startIndex === -1) {
        startIndex = 0;
      }

      if (stopIndex === -1) {
        stopIndex = this.stopSegments.length - 1;
      }

      this.trimBounds = [startIndex, stopIndex];
      this.playhead = this.trimBounds[0];
      this.playheadControl = {};
    }
  }, {
    key: "numberOr",
    value: function numberOr(number, defaultValue) {
      // NOTE: "" or null should return the defaultValue but "0" should stay 0
      if (!isNaN(parseInt(number))) {
        return number;
      } else {
        return defaultValue;
      }
    }
  }, {
    key: "initWatchers",
    value: function initWatchers() {
      var _this5 = this;

      var $scope = this.$scope;
      $scope.$watch(function () {
        return _this5.segments && _this5.previewQueryString && _this5.previewBaseURL && _this5.trimBounds[0];
      }, function (v) {
        v = v || 0;
        var segmentIndex = _this5.startSegments[v].segmentIndex;
        _this5.previewStartUrl = _this5.segmentPreviewURL(segmentIndex) || '/img/recording-start.png';
        _this5.showPreviewStart = true;

        _this5.startTimerForPreviewStart();

        _this5.sliderOptsPlayhead.floor = _this5.trimBounds[0];
      });
      $scope.$watch(function () {
        return _this5.segments && _this5.previewQueryString && _this5.previewBaseURL && _this5.trimBounds[1];
      }, function (v) {
        v = (v || 0) + 1;

        if (_this5.startSegments.length == v) {
          _this5.previewStopUrl = '/img/recording-end.png';
        } else {
          var segmentIndex = _this5.startSegments[v].segmentIndex;
          _this5.previewStopUrl = _this5.segmentPreviewURL(segmentIndex);
        }

        _this5.showPreviewStop = true;

        _this5.startTimerForPreviewStop();

        _this5.sliderOptsPlayhead.ceil = _this5.trimBounds[1];
      });
      $scope.$watch(function () {
        return _this5.segments && _this5.previewQueryString && _this5.previewBaseURL && _this5.playhead;
      }, function (v) {
        v = v || 0;

        if (v == _this5.startSegments.length) {
          _this5.previewUrl = '/img/recording-end.png';
          _this5.previewCaption = _this5.stopSegments[v - 1].label;
        } else {
          var segmentIndex = _this5.startSegments[v].segmentIndex;
          _this5.previewUrl = _this5.segmentPreviewURL(segmentIndex);
          _this5.previewCaption = _this5.startSegments[v || 0].label;
        }
      });
      $scope.$watchCollection(function () {
        return _this5.trimBounds;
      }, function () {
        return _this5.onTrimBoundsChanged();
      });
    }
  }, {
    key: "onTrimBoundsChanged",
    value: function onTrimBoundsChanged() {
      var _this6 = this;

      // user dragged the left/right handles (or they changed externally)
      // show them the preview under their handles
      var $scope = this.$scope,
          $timeout = this.$timeout;
      /*
      * The following logic attempted to smartly keep the playhead where it was
      * when it made sense to do so but had some strange side-effects
      if (this.playhead < this.trimBounds[0]) {
      this.playhead = this.trimBounds[0];
      } else if (this.playhead > (1 + this.trimBounds[1])) {
      this.playhead = (1 + this.trimBounds[1]);
      }
      */
      // Any time you change bounds, reset playhead to start of clip

      this.playhead = this.trimBounds[0];

      if (_.isFunction($scope.onChangeBounds)) {
        $scope.onChangeBounds(this.startSegments[this.trimBounds[0]].seconds, this.stopSegments[this.trimBounds[1]].seconds, this.startSegments[this.trimBounds[0]].segmentIndex, this.stopSegments[this.trimBounds[1]].segmentIndex);
      }

      $timeout(function () {
        return _this6.positionMasks();
      });
    }
  }, {
    key: "positionMasks",
    value: function positionMasks() {
      // position the shaders over the to-be-hidden regions that were clipped
      // position the cut point previews exactly
      var handles = $('.trim .rz-pointer');
      var leftHandle = $(handles.get(0));
      var rightHandle = $(handles.get(1));
      $('.start-point-preview').css({
        left: leftHandle.css('left')
      });
      $('.end-point-preview').css({
        left: rightHandle.css('left')
      });
      $('.start-point-mask').css({
        width: leftHandle.css('left')
      });
      $('.end-point-mask').css({
        left: rightHandle.css('left')
      });
    }
  }, {
    key: "initRecording",
    value: function initRecording(recording) {
      // Initialize to be full length of recording, unless it was set externally already
      if (this.startSegment !== undefined) {
        this.setTrimBoundsFromSegments(this.startSegment, this.stopSegment);
      } else if (this.startSeconds !== undefined) {
        this.setTrimBoundsFromSeconds(this.startSeconds, this.stopSeconds);
      } else if (this.recording.start_segment !== '') {
        this.setTrimBoundsFromSegments(recording.start_segment, recording.stop_segment);
      } else if (this.recording.start_seconds !== '') {
        this.setTrimBoundsFromSeconds(recording.start_seconds, recording.stop_seconds);
      } else {
        this.setTrimBounds(0, this.startSegments.length - 1);
      } // Pick apart recording preview URL so that we can build thumbnail URLs later


      var idxQ = recording.preview.indexOf('?');

      if (idxQ > -1) {
        this.previewQueryString = recording.preview.substring(idxQ + 1);
        var previewWithoutQuery = recording.preview.substring(0, idxQ);

        if (previewWithoutQuery.match(/\/[^\/]+$/)) {
          this.previewBaseURL = previewWithoutQuery.replace(/[^\/]+$/, '');
        }
      }

      this.initPreviewMosaic();
    }
  }, {
    key: "initSegments",
    value: function initSegments(segments) {
      var _this7 = this;

      this.segments = segments;
      this.startSegments = [];
      this.stopSegments = [];
      this.segmentTimes = [0]; // Walk through each of the individual segment durations to build
      // accumlated totals for both starting and stopping at that index.

      var time = '0:00:00';
      var secs = 0.0;

      _.each(this.segments, function (segment, i) {
        if (segment.duration_ts === 0) {
          return;
        }

        var byteranges = segment.byte_ranges;

        if (byteranges !== undefined && Object.keys(byteranges).length > 0 && Object.keys(byteranges)[0].length > 0) {
          _.each(byteranges[Object.keys(byteranges)[0]], function (byterange) {
            var duration = byterange.dur / 90000.0;

            _this7.startSegments.push({
              segmentIndex: i,
              label: time,
              seconds: secs
            });

            secs += duration;

            _this7.segmentTimes.push(secs);

            time = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["e" /* secondsToFormattedLabel */])(secs);

            _this7.stopSegments.push({
              segmentIndex: i,
              label: time,
              seconds: secs
            });
          });
        } else {
          var duration = segment.duration_ts / 90000.0;

          _this7.startSegments.push({
            segmentIndex: i,
            label: time,
            seconds: secs
          });

          secs += duration;

          _this7.segmentTimes.push(secs);

          time = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["e" /* secondsToFormattedLabel */])(secs);

          _this7.stopSegments.push({
            segmentIndex: i,
            label: time,
            seconds: secs
          });
        }
      });
    }
  }, {
    key: "setZoom",
    value: function setZoom(zoom) {
      var _this8 = this;

      var $scope = this.$scope,
          $timeout = this.$timeout; // Force it between 100% and 1000%

      this.zoom = Math.max(1, Math.min(10, zoom));
      this.initPreviewMosaic(); // Attempt to keep left handle in same position before/after resize

      var currentScroll = $('.zoom-scroll-pan-container').get(0).scrollLeft;
      var handles = $('.trim .rz-pointer');
      var currentLeftHandleOffset = handles.get(0).offsetLeft;
      var currentLeftHandlePosInViewport = currentLeftHandleOffset - currentScroll;
      $timeout(function () {
        // Need to kick the rzslider in the teeth a bit
        $scope.$broadcast('reCalcViewDimensions');
        $scope.$broadcast('rzSliderForceRender'); // Wait for rzslider; then reposition window

        $timeout(function () {
          var newLeftHandleOffset = handles.get(0).offsetLeft;
          var newLeftHandlePosInViewport = newLeftHandleOffset - currentScroll;

          if (newLeftHandlePosInViewport != currentLeftHandlePosInViewport) {
            var nudge = currentLeftHandlePosInViewport - newLeftHandlePosInViewport;
            $('.zoom-scroll-pan-container').get(0).scrollLeft = $('.zoom-scroll-pan-container').get(0).scrollLeft - nudge; //console.log('nudged', nudge, 'to the left', $('.zoom-scroll-pan-container').get(0).scrollLeft);
          } else {//console.log('keeping zoom');
          }

          _this8.positionMasks();
        });
      });
    }
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      this.setZoom(this.zoom + 0.5);
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      this.setZoom(this.zoom - 0.5);
    }
  }, {
    key: "panLeft",
    value: function panLeft() {
      var $container = $('.zoom-scroll-pan-container');
      var currentScroll = $container[0].scrollLeft;
      $container[0].scrollLeft = Math.max(0, currentScroll - 50);
    }
  }, {
    key: "panRight",
    value: function panRight() {
      var $container = $('.zoom-scroll-pan-container');
      var $content = $('.zoom-scroll-pan-container > div');
      var currentScroll = $container[0].scrollLeft;
      var padding = 20;
      var maxScroll = $content[0].offsetWidth + padding - $container[0].offsetWidth;
      $container[0].scrollLeft = Math.min(maxScroll, currentScroll + 50);
    }
  }, {
    key: "initPreviewMosaic",
    value: function initPreviewMosaic() {
      var _this9 = this;

      // Pick out N evenly spaced images out of the segments
      // Aim for background images approximately spaced every 75px
      var containerWidth = $('.mosaic').width();
      var numberImages = Math.ceil(containerWidth / 75);
      this.previewMosaic = [];

      if (this.segments.length <= numberImages) {
        // You can't always get what you want...
        numberImages = this.segments.length;
      } // Figure out start points we want
      // 0 sec, time / 8, 2 * time / 8, 3 * time / 8, ... 7 * time / 8
      // Figure out which segment image contains that time, and use it
      //let totalTime = _.last(this.stopSegments).seconds;
      //let cuePoints = _.range(8).map((i) => totalTime * i / 8.0);


      var totalSegments = this.segments.length;

      var cuePoints = _.range(numberImages).map(function (i) {
        return Math.floor(1.0 * totalSegments * i / numberImages);
      });

      _.each(cuePoints, function (frame) {
        return _this9.previewMosaic.push(_this9.segmentPreviewURL(frame));
      }); //console.log('Loaded mosaoic', this.segments, totalSegments, cuePoints, this.previewMosaic);

    }
  }]);

  return RecordingTrimmerController;
}());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recording-trimmer\"\n  ng-controller=\"RecordingTrimmerController as vm\"\n  cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\"\n  >\n\n  <div class=\"form-group\">\n\n    <div style=\"background:#000;\">\n      <div style=\"max-width:640px; margin:0 auto;\">\n        <div class=\"fixed-16-9\"\n            ng-style=\"{\n              'background-image': 'url(&quot;'+vm.previewUrl+'&quot;)',\n              'background-size': 'contain',\n              'background-repeat': 'no-repeat'\n            }\">\n        </div>\n      </div>\n    </div>\n    <div style=\"position:relative;bottom:2em;text-align:center;background:rgba(0,0,0,0.5);color:white;font:bold 150% sans-serif;z-index:1\">\n      {{vm.previewCaption}}\n    </div>\n    <div style=\"position:relative;top:-33px;margin-bottom:-18px;\">\n      <rzslider class=\"playhead\"\n                rz-slider-model=\"vm.playhead\"\n                rz-slider-options=\"vm.sliderOptsPlayhead\"></rzslider>\n    </div>\n\n    <div class=\"zoom-scroll-pan-container\">\n      <div style=\"position:relative; width:{{vm.zoom * 100}}%\">\n        <!--<div class=\"slider-zoom-trapezoid\">&nbsp;</div>-->\n        <div class=\"mosaic\">\n          <div ng-repeat=\"img in vm.previewMosaic track by $index\"\n            ng-style=\"{\n              'background-image': 'url(' + img + ')',\n              'width': (100.0 / vm.previewMosaic.length) + '%'\n            }\">\n            &nbsp;\n          </div>\n        </div>\n        <div>\n          <rzslider class=\"trim\"\n                    rz-slider-model=\"vm.trimBounds[0]\"\n                    rz-slider-high=\"vm.trimBounds[1]\"\n                    rz-slider-options=\"vm.sliderOptsTrim\"></rzslider>\n        </div>\n        <div class=\"clearfix\" style=\"position:relative;height:0px;overflow:visible\">\n          <div class=\"start-point-preview\" ng-show=\"vm.showPreviewStart\">\n            <div>\n              <img ng-src=\"{{vm.previewStartUrl}}\" alt=\"preview start\" />\n            </div>\n          </div>\n          <div class=\"end-point-preview\" ng-show=\"vm.showPreviewStop\">\n            <div>\n              <img ng-src=\"{{vm.previewStopUrl}}\" alt=\"preview stop\" />\n            </div>\n          </div>\n        </div>\n        <div class=\"start-point-mask hidden-region-mask\"></div>\n        <div class=\"end-point-mask hidden-region-mask\"></div>\n      </div>\n    </div>\n    <div class=\"clearfix\">\n      <div class=\"text-center\">\n        <table align=\"center\"><tr>\n          <td>\n            <button ng-show=\"vm.zoom > 1.0\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.panLeft()\">\n              <i class=\"fa fa-caret-left\"></i>\n            </button>&nbsp;\n          </td>\n          <td>\n            <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.zoomOut()\">\n              <i class=\"fa fa-search-minus\"></i>\n            </button>\n          </td>\n          <td style=\"text-align:center; padding:0 10px\"><small>Zoom ({{vm.zoom * 100}}%)</small></td>\n          <td>\n            <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.zoomIn()\">\n              <i class=\"fa fa-search-plus\"></i>\n            </button>\n          </td>\n          <td>\n            &nbsp;<button ng-show=\"vm.zoom > 1.0\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.panRight()\">\n              <i class=\"fa fa-caret-right\"></i>\n            </button>\n          </td>\n        </tr></table>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n\n"

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

// directive
//   <scoreboard-diagnostics-status scoreboard-configuration="scoreboardConfiguration" stream-diagnostics="streamDiagnostics" />
//
angular.module('app.directives').component('scoreboardDiagnosticsStatus', {
  restrict: 'E',
  bindings: {
    scoreboardConfiguration: '=',
    streamDiagnostics: '='
  },
  template: __webpack_require__(362),
  controllerAs: 'vm',
  controller: ["$scope", function ScoreboardDiagnosticsStatusController($scope) {
    'ngInject';

    var _this = this;

    var recalculate = function recalculate() {
      _this.usingScoreboardAssist = (_this.scoreboardConfiguration || {}).scoreboard_make == 'BoxCast';
      _this.scoreboardMode = (((_this.streamDiagnostics || {}).scoreboard || {}).scoreboard_assist || {}).operation_mode;
      _this.serialPortIsOpen = (_this.streamDiagnostics || {}).serial_port_is_open;
      _this.serialPortIsOpenStyle = _this.serialPortIsOpen == undefined ? {
        'font-style': 'italic',
        color: '#848484'
      } : {};
      _this.scoreboardAssistLinked = (_this.streamDiagnostics || {}).scoreboard_assist_linked;
      _this.scoreboardAssistLinkedStyle = _this.scoreboardAssistLinked == undefined ? {
        'font-style': 'italic',
        color: '#848484'
      } : {};
      _this.scoreboardAssistConnected = (_this.streamDiagnostics || {}).scoreboard_assist_connected;
      _this.scoreboardAssistConnectedStyle = _this.scoreboardAssistConnected == undefined ? {
        'font-style': 'italic',
        color: '#848484'
      } : {};
      _this.receivingScoreboardData = (_this.streamDiagnostics || {}).receiving_scoreboard_data;
      _this.receivingScoreboardDataStyle = _this.receivingScoreboardData == undefined ? {
        'font-style': 'italic',
        color: '#848484'
      } : {};
      _this.decodeErrors = (_this.streamDiagnostics || {}).scoreboard_data_decode_errors;
      _this.decodeErrorsStyle = _this.decodeErrors == undefined ? {
        'font-style': 'italic',
        color: '#848484'
      } : {};
    };

    $scope.$watchGroup(['scoreboardConfiguration', 'streamDiagnostics'], recalculate);
    recalculate();
  }]
});

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = "<div style=\"position:relative\">\n  <div style=\"position:absolute; top:13px; border-bottom: 1px solid #eee; width: 100%; z-index:0;\"></div>\n<table class=\"scoreboard-diagnostics-status\"\n       ng-class=\"{\n        'five-wide': (vm.usingScoreboardAssist && vm.scoreboardMode == 'pair'),\n        'four-wide': (vm.usingScoreboardAssist && !vm.scoreboardMode == 'pair'),\n        'three-wide': (!vm.usingScoreboardAssist)\n       }\" style=\"position: relative; z-index: 1\">\n  <tr>\n\n    <!-- Is my scoreboard adapter / scoreboard assist connected to my BoxCaster? [legacy, pair/single] -->\n    <td>\n      <div ng-style=\"vm.serialPortIsOpenStyle\">\n        <i class=\"fa fa-check-circle\" style=\"color:#13640E\" ng-show=\"vm.serialPortIsOpen == true\"></i>\n        <i class=\"fa fa-times-circle\" style=\"color:#CE3D3E\" ng-show=\"vm.serialPortIsOpen == false\"></i>\n        <i class=\"fa fa-circle-thin\" ng-show=\"vm.serialPortIsOpen == undefined\"></i>\n        Scoreboard\n        <span ng-show=\"vm.usingScoreboardAssist\">Assist</span>\n        <span ng-hide=\"vm.usingScoreboardAssist\">adapter</span>\n        connected to BoxCaster\n      </div>\n\n    </td>\n\n    <!-- Is my scoreboard assist box side linked to the scoreboard side? [pair] -->\n    <td ng-if=\"vm.usingScoreboardAssist && vm.scoreboardMode == 'pair'\">\n      <div ng-style=\"vm.scoreboardAssistLinkedStyle\">\n        <i class=\"fa fa-check-circle\" style=\"color:#13640E\" ng-show=\"vm.scoreboardAssistLinked == true\"></i>\n        <i class=\"fa fa-times-circle\" style=\"color:#CE3D3E\" ng-show=\"vm.scoreboardAssistLinked == false\"></i>\n        <i class=\"fa fa-circle-thin\" ng-show=\"vm.scoreboardAssistLinked == undefined\"></i>\n        Scoreboard Assist pair linked\n      </div>\n    </td>\n\n    <!-- Is my scoreboard assist connected to a scoreboard controller? [pair/single] -->\n    <td ng-if=\"vm.usingScoreboardAssist\">\n      <div ng-style=\"vm.scoreboardAssistConnectedStyle\">\n        <i class=\"fa fa-check-circle\" style=\"color:#13640E\" ng-show=\"vm.scoreboardAssistConnected == true\"></i>\n        <i class=\"fa fa-times-circle\" style=\"color:#CE3D3E\" ng-show=\"vm.scoreboardAssistConnected == false\"></i>\n        <i class=\"fa fa-circle-thin\" ng-show=\"vm.scoreboardAssistConnected == undefined\"></i>\n        Scoreboard Assist connected to scoreboard controller\n      </div>\n    </td>\n\n    <!-- Is the server receiving scoreboard data? [legacy, pair/single] -->\n    <td>\n      <div ng-style=\"vm.receivingScoreboardDataStyle\">\n        <i class=\"fa fa-check-circle\" style=\"color:#13640E\" ng-show=\"vm.receivingScoreboardData == true\"></i>\n        <i class=\"fa fa-times-circle\" style=\"color:#CE3D3E\" ng-show=\"vm.receivingScoreboardData == false\"></i>\n        <i class=\"fa fa-circle-thin\" ng-show=\"vm.receivingScoreboardData == undefined\"></i>\n        Receiving data from\n        <span ng-show=\"vm.usingScoreboardAssist\">Scoreboard Assist</span>\n        <span ng-hide=\"vm.usingScoreboardAssist\">scoreboard adapter</span>\n\n    </td>\n\n    <!-- Is the server successfully decoding the scoreboard data? [legacy, pair/single] -->\n    <td>\n      <div ng-style=\"vm.decodeErrorsStyle\">\n        <i class=\"fa fa-check-circle\" style=\"color:#13640E\" ng-show=\"vm.decodeErrors == false\"></i>\n        <i class=\"fa fa-times-circle\" style=\"color:#CE3D3E\" ng-show=\"vm.decodeErrors == true\"></i>\n        <i class=\"fa fa-circle-thin\" ng-show=\"vm.decodeErrors == undefined\"></i>\n        Decoding data from\n        <span ng-show=\"vm.usingScoreboardAssist\">Scoreboard Assist</span>\n        <span ng-hide=\"vm.usingScoreboardAssist\">scoreboard adapter</span>\n      </div>\n    </td>\n\n  </tr>\n</table>\n</div>"

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// directive
//   <scoreboard-link-status linked="linked" rssi="rssi" />
//
angular.module('app.directives').component('scoreboardLinkStatus', {
  restrict: 'E',
  bindings: {
    linked: '=',
    rssi: '='
  },
  template: __webpack_require__(364),
  controllerAs: 'vm',
  controller: ["$scope", "$sce", function ScoreboardDiagnosticsStatusController($scope, $sce) {
    'ngInject'; // convert dBm to a number between 0 and 1. This is based on some BoxCaster code:
    // https://github.com/boxcast/boxcaster/blob/master/lib/platform-specific/bc4k/wifi_config.rb#L250-L258

    var _this = this;

    var dbmToPercent = function dbmToPercent(dbm) {
      return dbm >= 0.0 ? 1.0 : _.min([_.max([0.982 - 0.00379 * dbm + -0.000154 * Math.pow(dbm, 2), 0.0]), 1.0]);
    };

    var recalculate = function recalculate() {
      _this.signalStrengthPercent = dbmToPercent(_this.rssi);

      if (_this.signalStrengthPercent < 0.25) {
        _this.faClass = 'text-danger';
      } else if (_this.signalStrengthPercent < 0.5) {
        _this.faClass = 'text-warning';
      } else if (_this.signalStrengthPercent < 0.75) {
        _this.faClass = 'text-success opacity-80';
      } else {
        _this.faClass = 'text-success';
      }

      _this.tooltipHTML = $sce.trustAsHtml("".concat(Math.round(100 * _this.signalStrengthPercent), "%<br/>(").concat(Math.round(_this.rssi), " dBm)"));
    };

    $scope.$watchGroup(['linked', 'rssi'], recalculate);
    recalculate();
  }]
});

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = "<div class=\"text-center\">\n  <div>\n    <div ng-show=\"vm.linked\" uib-tooltip-html=\"vm.tooltipHTML\" tooltip-append-to-body=\"true\">\n      <i class=\"fa fa-3x fa-signal {{vm.faClass}}\"></i>\n    </div>\n    <div ng-hide=\"vm.linked\" style=\"position:relative\" uib-tooltip=\"Not connected\" tooltip-append-to-body=\"true\">\n      <!--span class=\"fa-stack fa-3x\">\n        <i class=\"fa fa-signal fa-stack-1x\"></i>\n        <i class=\"fa fa-ban fa-stack-2x\"></i>\n      </span-->\n      <!--\n      <i class=\"fa fa-3x fa-signal opacity-40\"></i>\n      <div class=\"scoreboard-link-status--strike\"></div>\n      -->\n      <i class=\"fa fa-3x fa-ban opacity-40\"></i>\n    </div>\n  </div>\n  <div style=\"margin-top:10px\">\n    Link Status\n  </div>\n</div>"

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// show-password directive
// <input type=password show-password="showPassword" ng-model="thePassword">
var module = angular.module('app.directives');
module.directive('showPassword', function () {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      scope.$watch(attrs.showPassword, function (newValue) {
        if (newValue) {
          elem.attr('type', 'text');
        } else {
          elem.attr('type', 'password');
        }
      });
    }
  };
});

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// source chooser directive
//
//   <source-chooser edit-or-create-event-service="vm.service" />
//
var module = angular.module('app.directives');
module.directive('sourceChooser', function () {
  return {
    restrict: 'E',
    scope: {
      editOrCreateEventService: '='
    },
    template: "\n      <div ng-if=\"(editOrCreateEventService.broadcast.timeframe||'future') != 'future'\">\n        {{editOrCreateEventService.broadcast | streamSourceName}}\n      </div>\n      <div ng-if=\"(editOrCreateEventService.broadcast.timeframe||'future') == 'future'\">\n        <select selectize\n              ng-model=\"editOrCreateEventService.broadcast.boxcaster_id\"\n              ng-change=\"editOrCreateEventService.updateScoreboardMakes(); editOrCreateEventService.getConflictingEvents()\"\n              options=\"editOrCreateEventService.sources\"\n              config=\"selectizeConfig\"></select>\n        <div style=\"margin:5px 0 0 0\" ng-if=\"firmwareIssue || firmwareUpdate\">\n          <a ng-if=\"firmwareIssue\" href=\"{{vueDashboardRoot}}/sources?boxcaster_id={{editOrCreateEventService.broadcast.boxcaster_id}}\" class=\"label label-warning\">\n            Firmware Issue\n          </a>\n          <a ng-if=\"firmwareUpdate\" href=\"{{vueDashboardRoot}}/sources?boxcaster_id={{editOrCreateEventService.broadcast.boxcaster_id}}\" class=\"label label-info\">\n            Firmware Update Available\n          </a>\n        </div>\n      </div>\n    ",
    controller: ["$scope", function controller($scope) {
      'ngInject';

      $scope.$watch(function () {
        return $scope.editOrCreateEventService.selectedBoxCaster;
      }, function (boxcaster) {
        $scope.shouldBeBroadcasting = shouldBeBroadcasting(boxcaster);
        $scope.firmwareIssue = boxcaster && boxcaster.firmware_status == 'invalid';
        $scope.firmwareUpdate = boxcaster && boxcaster.firmware_status == 'outdated';
      });
      $scope.selectizeConfig = {
        valueField: 'id',
        labelField: 'name',
        placeholder: 'Select Source...',
        highlight: true,
        searchField: 'name',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option'),
          item: renderSelectizeOption('source-chooser--selected')
        }
      };
    }]
  };
});

function shouldBeBroadcasting(boxcaster) {
  if (boxcaster && boxcaster.next_broadcast_at) {
    return Date.now() > moment(boxcaster.next_broadcast_at);
  } else {
    return false;
  }
}

function renderSelectizeOption(wrapperCssClass) {
  return function (item, escape) {
    if (item.type.startsWith('boxcaster')) {
      return "\n        <div class=\"".concat(wrapperCssClass, "\">\n          <small class=\"pull-right\" style=\"text-transform:capitalize\">\n            ").concat(boxcasterStatusIcon(item), "\n          </small>\n          <span class=\"source-icon source-icon--").concat(item.type, "\"/>\n          ").concat(item.name, "\n        </div>\n      ");
    } else if (item.type === 'static_rtmp') {
      return "\n        <div class=\"".concat(wrapperCssClass, "\">\n          <small class=\"pull-right\" style=\"text-transform:capitalize\">\n            ").concat(staticRtmpStatusIcon(item), "\n          </small>\n          <span class=\"source-icon source-icon--").concat(item.type, "\"/>\n          ").concat(item.name, "\n        </div>\n      ");
    } else if (item.type === 'recording') {
      return "\n        <div class=\"".concat(wrapperCssClass, "\">\n          <i class=\"fa fa-repeat\" style=\"width:15px; margin-left: 5px; margin-right: 10px;\"></i>\n          ").concat(item.name, "\n        </div>\n      ");
    } else {
      return "\n        <div class=\"".concat(wrapperCssClass, "\">\n          <span class=\"source-icon source-icon--").concat(item.type, "\"/>\n          ").concat(item.name, "\n        </div>\n      ");
    }
  };
}

function boxcasterStatusIcon(item) {
  // Simplified version of <boxcaster-status-label /> logic
  if (item.status == 'ready') {
    return "<i class=\"source-icon--ready fa fa-circle\"></i> Online";
  } else if (item.status.indexOf('broadcast') >= 0) {
    return "<i class=\"source-icon--in-use fa fa-circle\"></i> Broadcasting";
  } else if (shouldBeBroadcasting(item)) {
    return "<i class=\"source-icon--issue fa fa-circle\"></i> Check Source";
  } else {
    return "<i class=\"source-icon--offline fa fa-circle\"></i> ".concat(item.status);
  }
}

function staticRtmpStatusIcon(item) {
  if (!(item.diagnostics || {}).connected) {
    return "<i class=\"source-icon--offline fa fa-circle\"></i> Offline";
  }

  if (item.diagnostics.broadcasting) {
    return "<i class=\"source-icon--in-use fa fa-circle\"></i> Broadcasting";
  }

  return "<i class=\"source-icon--ready fa fa-circle\"></i> Connected";
}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// star rating directive
//
//   <star-rating count="2.5" />
var module = angular.module('app.directives');
module.component('starRating', {
  restrict: 'E',
  bindings: {
    count: '='
  },
  controllerAs: '$ctrl',
  template: "\n    <span ng-switch=\"$ctrl.count\">\n      <span ng-switch-when=\"5\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n      </span>\n      <span ng-switch-when=\"4.5\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star-half-o\"></i>\n      </span>\n      <span ng-switch-when=\"4\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n      </span>\n      <span ng-switch-when=\"3\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n      </span>\n      <span ng-switch-when=\"2\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n      </span>\n      <span ng-switch-when=\"1\">\n        <i class=\"fa fa-star\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n      </span>\n      <span ng-switch-default>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n        <i class=\"fa fa-star-o\" style=\"color:#ddd\"></i>\n      </span>\n    </span>\n  "
});

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// stat block directive
//
//   <stat-block label="Stat Name" value="123" />
var module = angular.module('app.directives');
module.directive('statBlock', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      label: '=',
      value: '=',
      format: '@',
      size: '@'
    },
    template: "\n      <div class=\"stat-block {{size}}\"\n           ng-class=\"{\n              'col-xs-12': size == 'full' || !size,\n              'col-xs-6': size == 'half-l' || size == 'half-r'\n           }\">\n        <h2 ng-if=\"format === undefined || format == 'number'\">\n          <span fittext>\n            {{value | number}}\n          </span>\n        </h2>\n        <h2 ng-if=\"format == 'currency'\" class=\"text-center\">\n          <span fittext>\n            ${{value | number:2}}\n          </span>\n        </h2>\n        <h2 ng-if=\"format == 'hours'\" class=\"text-center\">\n          <span fittext>\n            {{value | number:1}}\n          </span>\n        </h2>\n\n        <h5 class=\"text-center overflow-ellipse\">{{label}}</h5>\n      </div>\n    "
  };
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_rtmp__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_utils__ = __webpack_require__(13);
// directive
//   <stream-diagnostics broadcast="broadcast" />
//



var RELOAD_INTERVAL_MS = 30000; // The current implementation limits read sizes to 1 byte and completely ignores the message. This
// is just some data to keep the socket alive.

var WEBSOCKET_PING_MESSAGE = 'x';
var WEBSOCKET_PING_INTERVAL_MS = 10000;
var WEBSOCKET_ERROR_DELAY_MS = 10000;
var SCOREBOARD_ASSIST_FIRMWARE_IMAGE_NAME = 'wsa2_firmware.bin';
var xAxisTimeCfg = {
  type: 'time',
  gridLines: {
    display: false,
    drawBorder: false
  },
  position: 'bottom',
  distribution: 'series',
  source: 'auto',
  time: {
    unit: 'minute',
    displayFormats: {
      minute: 'h:mm a'
    }
  },
  ticks: {
    fontSize: 11,
    fontFamily: 'Arial, sans-serif',
    autoSkip: true
  }
};
angular.module('app.directives').component('streamDiagnostics', {
  restrict: 'E',
  bindings: {
    broadcast: '=',
    onReload: '='
  },
  template: __webpack_require__(370),
  controllerAs: 'vm',
  controller: function StreamDiagnosticsController($http, $interval, $q, $timeout, $scope, $rootScope, ScoreboardAssistFirmware) {
    'ngInject';

    var _this = this;

    this.broadcast; //<-- injected via binding

    this.graphType = this.broadcast.timeframe == 'past' ? 'coarse' : 'fine';
    this.timeoutHandle = null;
    this.activeTab = 'stream health'; // This may be overridden later if there's scoreboard data for this broadcast, even if it's currently disabled.

    this.showScoreboard = false; // Will be set later if/when we receive valid scoreboard data

    this.scoreboardMode = null;
    $scope.$on('$destroy', function () {
      return $timeout.cancel(_this.timeoutHandle);
    });
    this.latestScoreboardAssistFirmwareVersion = null;

    if (this.broadcast.timeframe != 'past' && (this.broadcast.scoreboard_configuration || {}).scoreboard_make == 'BoxCast') {
      // If we're using the scoreboard assist, go fetch the latest firmware version
      ScoreboardAssistFirmware.version({
        id: SCOREBOARD_ASSIST_FIRMWARE_IMAGE_NAME
      }, function (resp) {
        _this.latestScoreboardAssistFirmwareVersion = resp.version;
      }, function (e) {
        console.warn('Error getting latest Scoreboard Assist firmware version', e);
      });
    }

    this.pastSummary = function () {
      switch ((_this.streamDiagnostics || {}).summary_status) {
        case 'OK':
          return {
            icon: '',
            text: ''
          };

        case 'Warning':
          return {
            icon: '',
            text: ''
          };

        case 'Critical':
          return {
            icon: '',
            text: ''
          };

        default:
          return {
            icon: '',
            text: ''
          };
      }
    };

    this.alertsFilter = function (value) {
      return value.is_active;
    };

    this.updateGraph = function () {
      if (_this.streamDiagnostics) {
        processGraphData();
      }
    };

    this.handleNewData = function (data) {
      _this.streamDiagnostics = data;

      if (_this.streamDiagnostics) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["a" /* BaselineIngestLatency */])(_this.streamDiagnostics, _this.broadcast);
        _this.scoreboardMode = ((_this.streamDiagnostics.scoreboard || {}).scoreboard_assist || {}).operation_mode; // If this.showScoreboard is false, make it true if there's data here

        _this.showScoreboard = _this.streamDiagnostics.data_version >= 3 && Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["g" /* HasIntegratedScoreboard */])(_this.broadcast.scoreboard_configuration) || Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["i" /* V3HasAnyScoreboardData */])(_this.streamDiagnostics);
        processGraphData();

        if (_this.broadcast.timeframe == 'past') {
          _this.pastBroadcastStarCount = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["d" /* ComputePastBroadcastStarRating */])(_this.streamDiagnostics || {});
          _this.pastBroadcastRecommendations = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["c" /* ComputePastBroadcastRecommendations */])(_this.broadcast, _this.streamDiagnostics || []);
        }

        $timeout(function () {
          return _this.onReload(_this.streamDiagnostics);
        });
      }
    };

    this.loadViaGet = function () {
      return $http.get("".concat(API_ROOT, "/account/broadcasts/").concat(_this.broadcast.id, "/stream_diagnostics")).then(function (r) {
        _this.handleNewData(r.data); // Decide on whether or not to auto-reload


        if (_this.broadcast.timeframe != 'past') {
          $timeout.cancel(_this.timeoutHandle);
          _this.timeoutHandle = $timeout(function () {
            return _this.loadViaGet();
          }, RELOAD_INTERVAL_MS);
        }
      })["catch"](function (err) {
        console.error('Error getting stream diagnostics', err); // Try again after the reload interval

        $timeout.cancel(_this.timeoutHandle);
        _this.timeoutHandle = $timeout(function () {
          return _this.loadViaGet();
        }, RELOAD_INTERVAL_MS);
      });
    }; // Returns a promise indicating whether or not we successfully got the WebSocket set up. If
    // not, load falls back to using HTTP.


    this.loadViaWebSocket = function () {
      var d = $q.defer(); // First, get the websocket address from the API

      $http.get("".concat(API_ROOT, "/account/broadcasts/").concat(_this.broadcast.id, "/stream_diagnostics/wss_endpoint")).then(function (r) {
        // Second, open the websocket to the address
        var wssAddress = r.data;

        var makeWebSocket = function makeWebSocket() {
          var ws = new WebSocket(wssAddress + '?access_token=' + encodeURIComponent(Object(__WEBPACK_IMPORTED_MODULE_2__auth_utils__["a" /* getAuthToken */])()));
          var pingInterval = null;
          var scopeDestroying = false;
          var opened = false;
          ws.addEventListener('open', function (e) {
            opened = true;
            pingInterval = $interval(function () {
              return ws.send(WEBSOCKET_PING_MESSAGE);
            }, WEBSOCKET_PING_INTERVAL_MS, 0, false);
          });
          ws.addEventListener('close', function (e) {
            if (!scopeDestroying) {
              console.warn('Web socket closed unexpectedly', e);
              $interval.cancel(pingInterval);

              if (opened) {
                // If we DID successfully open the web socket, then just try again pretty much
                // right away, as we likely just got disconnected
                $timeout(function () {
                  try {
                    makeWebSocket();
                  } catch (err) {
                    console.error('Error creating the web socket', err);
                    remoteLogger.error('Error creating the web socket', {
                      error: err
                    });

                    _this.loadViaGet();
                  }
                });
              } else {
                // If we didn't actually open the web socket, the broadcast might have transitioned
                // to past/VOD. Retry from a higher level after a timeout.
                $timeout(_this.load, WEBSOCKET_ERROR_DELAY_MS);
              }
            }
          });
          var lastRawStatsCoarse = null;
          var lastRawScoreboardStatsCoarse = null;
          ws.addEventListener('message', function (e) {
            var data = null;

            try {
              data = JSON.parse(e.data);
            } catch (err) {
              console.error('Error parsing stream diagnostics data', err);
            }

            if (data) {
              // Not every update will contain coarse data, as the stream diagnostics service only
              // refreshes this every ~minute. So hang onto the latest one and glue it on when it's
              // missing.
              if (data.raw_stats_coarse) {
                lastRawStatsCoarse = data.raw_stats_coarse;
              } else {
                data.raw_stats_coarse = lastRawStatsCoarse;
              }

              if (data.raw_scoreboard_stats_coarse) {
                lastRawScoreboardStatsCoarse = data.raw_scoreboard_stats_coarse;
              } else {
                data.raw_scoreboard_stats_coarse = lastRawScoreboardStatsCoarse;
              }

              _this.handleNewData(data);
            }
          });
          $scope.$on('$destroy', function () {
            scopeDestroying = true;
            $interval.cancel(pingInterval);
            ws.close(1000);
          });
        };

        try {
          makeWebSocket();
          d.resolve(true);
        } catch (err) {
          console.error('Error creating the web socket', err);
          remoteLogger.error('Error creating the web socket', {
            error: err
          });
          d.reject(err);
        }
      })["catch"](function (err) {
        console.error('Error getting stream diagnostics web socket address', err);
        d.reject(err);
      });
      return d.promise;
    };

    this.load = function () {
      if (!_this.broadcast.id) {
        console.warn('Broadcast ID not available. Did you pass in an unresolved promise on accident?');
        return;
      }

      if (_this.broadcast.timeframe == 'future') {
        console.warn('Diagnostics not applicable for future broadcast');
        return;
      } // Figure out whether or not to open the websocket connection. Only do that if the broadcast
      // is current or preroll and web sockets appear to be supported.


      var supportsWebSockets = ('WebSocket' in window);

      if ((_this.broadcast.timeframe === 'preroll' || _this.broadcast.timeframe === 'current') && supportsWebSockets) {
        _this.loadViaWebSocket()["catch"](_this.loadViaGet);

        return;
      }

      _this.loadViaGet();
    };

    var statValuesForIndex = function statValuesForIndex(stats, i, j) {
      var series = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var r = ((stats || {}).results || [])[i];
      if (!r || !r.series || !r.series.length) return [];
      return _.map(r.series[series].values, function (t) {
        return t[j];
      });
    };

    var processGraphData = function processGraphData() {
      var stats = _this.streamDiagnostics.raw_stats;

      if (_this.graphType == 'coarse') {
        stats = _this.streamDiagnostics.raw_stats_coarse;
      }

      var dataVersion = _this.streamDiagnostics.data_version;
      var bitrateLimits = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["f" /* GetBitrateLimitsForBroadcast */])($rootScope.ApiConfig, _this.broadcast);

      var hasAnyData = function hasAnyData(data) {
        return !!data && data.length;
      };

      var hasAnyDataOrNull = function hasAnyDataOrNull(data) {
        return hasAnyData(data) ? data : null;
      };

      var bitrateSuggestedMax = 0;

      if (dataVersion >= 3) {
        _this.bitrateData = [];
        var videoBitrateData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'bitrate', 'video');

        if (hasAnyData(videoBitrateData)) {
          _this.bitrateData.push(videoBitrateData);

          bitrateSuggestedMax += (bitrateLimits.video || {}).nominal || 6000000;
        }

        var audioBitrateData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'bitrate', 'audio');

        if (hasAnyData(audioBitrateData)) {
          _this.bitrateData.push(audioBitrateData);

          bitrateSuggestedMax += (bitrateLimits.audio || {}).nominal || 128000;
        }

        _this.bitrateLabels = hasAnyDataOrNull(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'bitrate', 'video')) || hasAnyDataOrNull(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'bitrate', 'audio'));
        _this.framerateData = [];
        var videoFrameRateData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'frame_rate', 'video');
        if (videoFrameRateData) _this.framerateData.push(videoFrameRateData); // XXX: Although we likely have audio and score "frame" rate data, we pursposefully don't show it, as it's
        // potentially confusing to users.

        _this.framerateLabels = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'frame_rate', 'video');
        _this.ingestLatencyData = [];
        _this.ingestLatencyLabels = [];

        if (stats.ingest_latency) {
          _this.ingestLatencyData.push(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'ingest_latency'));

          _this.ingestLatencyLabels = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'ingest_latency');
        }

        _this.plData = [];
        _this.totalPacketsLost = 0;
        var videoPacketLossData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'packet_loss', 'video');

        if (hasAnyData(videoPacketLossData)) {
          _this.plData.push(videoPacketLossData);

          _this.totalPacketsLost += _.sum(videoPacketLossData);
        }

        var audioPacketLossData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'packet_loss', 'audio');

        if (hasAnyData(audioPacketLossData)) {
          _this.plData.push(audioPacketLossData);

          _this.totalPacketsLost += _.sum(audioPacketLossData);
        }

        var scorePacketLossData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'packet_loss', 'score');

        if (hasAnyData(scorePacketLossData) && _this.showScoreboard) {
          _this.plData.push(scorePacketLossData);

          _this.totalPacketsLost += _.sum(scorePacketLossData);
        }

        _this.plLabels = hasAnyDataOrNull(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'packet_loss', 'video')) || hasAnyDataOrNull(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'packet_loss', 'audio'));
        _this.simulcastData = [];
        _this.simulcastLabels = [];

        var rtmpURLs = _.keys(stats.simulcast_frame_rate || {}).sort();

        if (rtmpURLs.length > 0) {
          // XXX: Since simulcasts can be added and removed, and they're collected with fill(none), each RTMP URL
          // can potentially have a different set of timestamps than the others. Here we collect all the timestamps
          // and make sure that each series gets a placeholder for each timestamp.
          _this.simulcastLabels = _.uniq(_.flatten(_.map(_.values(stats.simulcast_frame_rate || {}), function (v) {
            return _.flatten([Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(v, 'video'), Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(v, 'audio')]);
          }))).sort();

          _.each(rtmpURLs, function (u) {
            var s = stats.simulcast_frame_rate[u];
            var videoSimulcastData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(s, 'video');

            if (hasAnyData(videoSimulcastData)) {
              var videoSimulcastTimestamps = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(s, 'video');

              _this.simulcastData.push(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["j" /* V3PlaceholderTimestamps */])(videoSimulcastData, videoSimulcastTimestamps, _this.simulcastLabels));
            }
          });
        }
      } else {
        var valuesForIndex = function valuesForIndex(i, j) {
          var series = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          return statValuesForIndex(stats || {}, i, j, series);
        };

        _this.bitrateData = [_([]).concat(valuesForIndex(0, 1), valuesForIndex(1, 1), valuesForIndex(2, 1)).value()];
        _this.bitrateLabels = _([]).concat(valuesForIndex(0, 0), valuesForIndex(1, 0), valuesForIndex(2, 0)).value();
        _this.framerateData = [valuesForIndex(3, 1)];
        _this.framerateLabels = valuesForIndex(3, 0);
        _this.ingestLatencyData = [];
        _this.ingestLatencyLabels = [];
        _this.plData = [valuesForIndex(7, 1), valuesForIndex(8, 1)];
        _this.plLabels = valuesForIndex(7, 0);
        _this.totalPacketsLost = _.sum(_this.plData[0]) + _.sum(_this.plData[1]); // Multiple series support for simulcast by destination

        if (stats.results && stats.results[4] && stats.results[4].series && stats.results[4].series.length) {
          _this.simulcastData = _.map(stats.results[4].series, function (s, i) {
            return valuesForIndex(4, 1, i);
          });
          _this.simulcastLabels = valuesForIndex(4, 0);
        }

        bitrateSuggestedMax = ((bitrateLimits.video || {}).nominal || 6000000) + ((bitrateLimits.audio || {}).nominal || 128000);
      }

      var expectedVideoFrameRate = (_this.broadcast.transcoder_profile || '').match(/p60/) ? 60 : 30;
      _this.plOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              suggestedMax: 100,
              beginAtZero: true,
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(Math.round(value), 4);
              },
              fontFamily: 'monospace',
              fontSize: 8
            },
            stacked: true
          }],
          xAxes: [_.extend({}, xAxisTimeCfg, {
            stacked: true
          })]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.plLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              var kind = ['video ', 'audio ', 'serial '][item.datasetIndex] || '';
              return "".concat(item.yLabel, " ").concat(kind, "packets lost");
            }
          }
        }
      };
      _this.bitrateOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              suggestedMax: bitrateSuggestedMax,
              beginAtZero: true,
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(Math.round(value / 1000), 4);
              },
              fontFamily: 'monospace',
              fontSize: 8
            },
            stacked: true
          }],
          xAxes: [_.extend({}, xAxisTimeCfg, {
            stacked: true
          })]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.bitrateLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              var kind = '';

              if (_this.bitrateData && _this.bitrateData.length > 1) {
                kind = ['Video: ', 'Audio: '][item.datasetIndex] || '';
              }

              return "".concat(kind).concat(Math.round(item.yLabel / 1000), " kbps");
            }
          }
        }
      };
      _this.bitrateDatasetOverride = [{
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        cubicInterpolationMode: 'monotone'
      }, {
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        cubicInterpolationMode: 'monotone'
      }];
      _this.framerateOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              suggestedMax: expectedVideoFrameRate,
              beginAtZero: true,
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(Math.round(value), 4);
              },
              fontFamily: 'monospace',
              fontSize: 8
            }
          }],
          xAxes: [xAxisTimeCfg]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.framerateLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              return "".concat(Math.round(100 * item.yLabel) / 100.0, " FPS");
            }
          }
        }
      };
      _this.framerateDatasetOverride = [{
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        cubicInterpolationMode: 'monotone'
      }];
      _this.ingestLatencyOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              suggestedMin: 0,
              suggestedMax: 10,
              fontFamily: 'monospace',
              fontSize: 8
            }
          }],
          xAxes: [xAxisTimeCfg]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.framerateLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              if (Math.abs(item.yLabel) < 1.0) {
                return "".concat(Math.round(1000 * item.yLabel), " ms");
              }

              return "".concat(Math.round(1000 * item.yLabel) / 1000.0, " s");
            }
          }
        }
      };
      _this.ingestLatencyDatasetOverride = [{
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        cubicInterpolationMode: 'monotone'
      }];
      _this.simulcastOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              suggestedMax: expectedVideoFrameRate,
              beginAtZero: true,
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(Math.round(value), 4);
              },
              fontFamily: 'monospace',
              fontSize: 8
            }
          }],
          xAxes: [xAxisTimeCfg]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.simulcastLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              var i = item.datasetIndex;
              var rtmpUrl;

              if (dataVersion >= 3) {
                rtmpUrl = _.keys(stats.simulcast_frame_rate || {}).sort()[i];
              } else {
                rtmpUrl = stats.results[4].series[i].tags.rtmp_url;
              }

              var rtmpLabel = Object(__WEBPACK_IMPORTED_MODULE_1__utils_rtmp__["b" /* SanitizeRTMPURL */])(rtmpUrl);

              if (rtmpUrl.indexOf('facebook.com') >= 0) {
                rtmpLabel = 'Facebook';
              } else if (rtmpUrl.indexOf('youtube.com') >= 0) {
                rtmpLabel = 'YouTube';
              } else if (rtmpUrl.indexOf('pscp.tv') >= 0 || rtmpUrl.indexOf('twitter') >= 0) {
                rtmpLabel = 'Twitter';
              }

              return "".concat(Math.round(100 * item.yLabel) / 100.0, " FPS to ").concat(rtmpLabel);
            }
          }
        }
      };
      _this.simulcastDatasetOverride = [];

      for (var i = 0; i < (_this.simulcastData || []).length; i++) {
        _this.simulcastDatasetOverride.push({
          pointRadius: 0,
          pointHitRadius: 5,
          pointHoverRadius: 4,
          cubicInterpolationMode: 'monotone'
        });
      }

      var scoreboardStats = _this.streamDiagnostics.raw_scoreboard_stats;

      if (_this.graphType == 'coarse') {
        scoreboardStats = _this.streamDiagnostics.raw_scoreboard_stats_coarse;
      }

      _this.scoreDataRateData = [];
      _this.scoreDataRateLabels = [];

      if (dataVersion >= 3) {
        var scoreBitrateData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(stats, 'bitrate', 'score');
        if (hasAnyData(scoreBitrateData) && _this.showScoreboard) _this.scoreDataRateData.push(scoreBitrateData);
        _this.scoreDataRateLabels = hasAnyDataOrNull(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(stats, 'bitrate', 'score'));
      }

      var scoreboardAssistStats = (scoreboardStats || {}).scoreboard_assist;
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["e" /* FilterRSSIForLinkStatus */])(scoreboardAssistStats);
      var rssi = (scoreboardAssistStats || {}).rssi || {};
      var boxRSSITimestamps = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(rssi, 'box');
      var scoreboardRSSITimestamps = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["k" /* V3Timestamps */])(rssi, 'scoreboard');
      _this.rssiLabels = _.uniq(_.flatten([boxRSSITimestamps, scoreboardRSSITimestamps])).sort();
      _this.rssiData = [];
      var boxRSSIData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(rssi, 'box');
      if (hasAnyData(boxRSSIData)) _this.rssiData.push(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["j" /* V3PlaceholderTimestamps */])(boxRSSIData, boxRSSITimestamps, _this.rssiLabels));
      var scoreboardRSSIData = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["l" /* V3Values */])(rssi, 'scoreboard');
      if (hasAnyData(scoreboardRSSIData)) _this.rssiData.push(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["j" /* V3PlaceholderTimestamps */])(scoreboardRSSIData, scoreboardRSSITimestamps, _this.rssiLabels));
      _this.scoreboardEvents = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stream_diagnostics__["h" /* ParseScoreboardEvents */])(_this.streamDiagnostics, _this.broadcast.scoreboard_configuration);
      _this.scoreDataRateOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              beginAtZero: true,
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(value, 5);
              },
              fontFamily: 'monospace',
              fontSize: 8
            }
          }],
          xAxes: [xAxisTimeCfg]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.bitrateLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              return "".concat(Math.round(item.yLabel), " bps");
            }
          }
        }
      };
      _this.scoreDataRateDatasetOverride = [{
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        cubicInterpolationMode: 'monotone'
      }];
      _this.rssiOptions = {
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        scales: {
          yAxes: [{
            gridLines: {
              color: '#EEEEEE',
              zeroLineColor: '#EEEEEE',
              drawTicks: false,
              drawBorder: false,
              tickMarkLength: 0
            },
            ticks: {
              // use monospace font and 4 characters to align the graphs
              callback: function callback(value, index, values) {
                return padOut(Math.round(value), 4);
              },
              fontFamily: 'monospace',
              fontSize: 8
            }
          }],
          xAxes: [xAxisTimeCfg]
        },
        tooltips: {
          callbacks: {
            title: function title(items, data) {
              return moment(_this.framerateLabels[items[0].index]).format('ddd MMM Do, h:mm:ss a');
            },
            label: function label(item, data) {
              var side = '';

              if (_this.bitrateData && _this.bitrateData.length > 1) {
                side = ['Box Side: ', 'Scoreboard Side: '][item.datasetIndex] || '';
              }

              return "".concat(side).concat(Math.round(10 * item.yLabel) / 10.0, " dBm");
            }
          }
        }
      };
      _this.rssiDatasetOverride = [{
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        fill: false,
        cubicInterpolationMode: 'monotone'
      }, {
        pointRadius: 0,
        pointHitRadius: 5,
        pointHoverRadius: 4,
        fill: false,
        cubicInterpolationMode: 'monotone'
      }];
    };

    this.load();
  }
});

function padOut(str, length) {
  str = '' + str; //cast int to str

  while (str.length < length) {
    str = ' ' + str;
  }

  return str;
}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\" style=\"margin-bottom:20px;\">\n  <div class=\"col-xs-12 text-center\" ng-if=\"vm.showScoreboard\">\n    <div class=\"btn-group\">\n      <label class=\"btn btn-default\" ng-model=\"vm.activeTab\" uib-btn-radio=\"'stream health'\">Stream Health</label>\n      <label class=\"btn btn-default\" ng-model=\"vm.activeTab\" uib-btn-radio=\"'scoreboard'\">Scoreboard</label>\n    </div>\n  </div>\n\n  <div class=\"col-xs-12 text-left\">\n    <ol class=\"list-inline\">\n      <li style=\"padding-bottom:0; padding-left:0; line-height: 28px;\">\n        <div class=\"checkbox\">\n          <label style=\"padding-left:0\">\n            <toggle-switch ng-model=\"vm.showAllAlerts\"></toggle-switch>\n            Show\n            <span ng-show=\"vm.activeTab == 'stream health'\">Alert</span>\n            <span ng-show=\"vm.activeTab == 'scoreboard'\">Event</span>\n            History\n          </label>\n        </div>\n      </li>\n      <li style=\"padding-bottom:0; padding-left:0px; line-height: 28px;\">\n        <div class=\"checkbox\">\n          <label>\n            <toggle-switch ng-model=\"vm.showGraphs\"></toggle-switch> Show Graphs\n          </label>\n        </div>\n      </li>\n      <li style=\"padding-bottom: 0;  padding-left: 10px; line-height:45px; float:right\">\n        <small>Updated: {{vm.streamDiagnostics.updated_at|date:'medium'}}</small>\n      </li>\n    </ol>\n  </div>\n</div>\n\n<!-- PAST BROADCAST VIEW, stream health -->\n<div class=\"row text-center\" ng-if=\"vm.activeTab == 'stream health' && vm.broadcast.timeframe == 'past' && vm.broadcast.stream_source != 'recording'\">\n  <div class=\"col-xs-12 col-sm-6 diagnostics--summary\">\n    <table style=\"width:100%;margin-top:15px;\">\n      <tr>\n        <td>\n          <h1 style=\"color:gold;font-size:12pt;\">\n            <star-rating count=\"vm.pastBroadcastStarCount\"></star-rating>\n          </h1>\n        </td>\n        <td>\n          <h1>{{vm.streamDiagnostics.average_total_bitrate|bits:1:'value'}} <small>{{vm.streamDiagnostics.average_total_bitrate|bits:1:'suffix'}}ps</small></h1>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <p class=\"help-block\"><small>Broadcast Health</small></p>\n        </td>\n        <td>\n          <p class=\"help-block\"><small>Avg Bitrate</small></p>\n        </td>\n      </tr>\n      <tr ng-if=\"vm.broadcast.stream_source == 'rtmp' || vm.broadcast.stream_source == 'switcher'\">\n        <td>\n          <h1>{{vm.streamDiagnostics.average_video_frame_rate|number:2}} <small>FPS</small></h1>\n        </td>\n        <td ng-if=\"vm.streamDiagnostics.max_ingest_latency\">\n          <h1>{{vm.streamDiagnostics.max_ingest_latency|number:2}} <small>s</small></h1>\n        </td>\n      </tr>\n      <tr ng-if=\"vm.broadcast.stream_source == 'rtmp' || vm.broadcast.stream_source == 'switcher'\">\n        <td>\n          <p class=\"help-block\"><small>Avg Frame Rate</small></p>\n        </td>\n        <td ng-if=\"vm.streamDiagnostics.max_ingest_latency\">\n          <p class=\"help-block\"><small>Max Ingest Latency</small></p>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"col-xs-12 col-sm-6 text-left\">\n    <!-- recommendations -->\n    <ul class=\"list-unstyled\" style=\"margin-top:15px\">\n      <li ng-repeat=\"r in vm.pastBroadcastRecommendations\" style=\"margin-bottom:5px\">\n        <i class=\"fa fa-lightbulb-o\"></i>\n        <strong>{{r.text}}</strong>\n        <a ng-if=\"r.link\" href=\"{{r.link}}\" target=\"_blank\">{{r.linkText}}</a>\n      </li>\n      <li><a class=\"action-link\" ui-sref=\"resources\"><small>Review resources to improve your stream.</small></a></li>\n    </ul>\n  </div>\n</div>\n\n<!-- PREROLL/CURRENT BROADCAST VIEW, stream health -->\n<div class=\"row diagnostics--summary\" ng-if=\"vm.activeTab == 'stream health' && vm.broadcast.timeframe != 'past'\">\n  <div class=\"col-sm-2 text-center\">\n    <h1>\n      <i ng-if=\"vm.streamDiagnostics.status == 'OK'\" class=\"fa fa-2x fa-check-circle diagnostics--icon-OK\"></i>\n      <i ng-if=\"vm.streamDiagnostics.status == 'Warning'\" class=\"fa fa-2x fa-exclamation-triangle diagnostics--icon-Warning\"></i>\n      <i ng-if=\"vm.streamDiagnostics.status == 'Critical'\" class=\"fa fa-2x fa-exclamation-circle diagnostics--icon-Critical\"></i>\n    </h1>\n  </div>\n\n  <div class=\"col-sm-5 text-left\">\n    <p ng-if=\"!vm.streamDiagnostics.alerts.length\" class=\"help-block\" style=\"margin-top:20px\">\n      No alerts detected!\n      <span ng-if=\"vm.streamDiagnostics.status == 'OK'\">The broadcast health is looking good.</span>\n    </p>\n    <div ng-if=\"vm.streamDiagnostics.alerts.length\">\n      <div ng-repeat=\"a in filteredAlerts = (vm.streamDiagnostics.alerts | filter:vm.alertsFilter)\" class=\"diagnostics--alert-{{a.is_active ? 'active' : 'inactive'}}\">\n        <span class=\"label label-{{a.level == 'Critical' ? 'danger' : 'warning'}}\">\n          {{a.detected_at|date:'shortTime'}}\n          <span ng-hide=\"a.is_active\">- {{a.inactive_at|date:'shortTime'}}</span>:\n          {{a.message}}\n        </span>\n      </div>\n      <div ng-if=\"filteredAlerts.length == 0\">\n        <p class=\"help-block\" style=\"margin-top:20px\">\n          No active alerts.\n          <span ng-if=\"vm.streamDiagnostics.status == 'OK'\">The broadcast health is looking good.</span>\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-sm-5\" ng-if=\"vm.broadcast.stream_source != 'recording'\">\n    <table class=\"text-center\" style=\"width:100%\">\n      <tr>\n        <td valign=\"top\">\n          <h3>\n            {{vm.streamDiagnostics.last_total_bitrate|bits:1:'value'}}\n            <small>{{vm.streamDiagnostics.last_total_bitrate|bits:1:'suffix'}}ps</small>\n          </h3>\n        </td>\n        <td valign=\"top\" ng-if=\"vm.broadcast.transcoder_profile != 'audio'\">\n          <h3>\n            {{vm.streamDiagnostics.last_video_frame_rate|number:2}}\n            <small>FPS</small>\n          </h3>\n        </td>\n        <td valign=\"top\" ng-if=\"vm.broadcast.stream_source == 'rtmp' || vm.broadcast.stream_source == 'switcher'\">\n          <h3>\n            {{vm.streamDiagnostics.last_ingest_latency|number:2}}\n            <small>s</small>\n          </h3>\n        </td>\n      </tr>\n      <tr>\n        <td><p class=\"help-block\"><small>Broadcast Bitrate</small></p></td>\n        <td ng-if=\"vm.broadcast.transcoder_profile != 'audio'\"><p class=\"help-block\"><small>Broadcast Frame Rate</small></p></td>\n        <td ng-if=\"vm.broadcast.stream_source == 'rtmp' || vm.broadcast.stream_source == 'switcher'\"><p class=\"help-block\"><small>Ingestion Latency (s)</small></p></td>\n      </tr>\n    </table>\n  </div>\n</div>\n\n<!-- scoreboard -->\n<div class=\"row diagnostics--summary\" ng-if=\"vm.activeTab == 'scoreboard'\">\n  <div class=\"col-xs-12 col-lg-2 text-center\" ng-if=\"vm.scoreboardMode == 'pair'\">\n    <scoreboard-link-status\n        linked=\"vm.streamDiagnostics.scoreboard_assist_linked\" rssi=\"vm.streamDiagnostics.scoreboard_assist_rssi\" />\n  </div>\n\n  <div class=\"col-xs-12\" ng-class=\"vm.scoreboardMode == 'pair' ? 'col-lg-10' : ''\">\n    <scoreboard-diagnostics-status scoreboard-configuration=\"vm.broadcast.scoreboard_configuration\" stream-diagnostics=\"vm.streamDiagnostics\" />\n  </div>\n\n  <div class=\"col-xs-12 text-right\" ng-if=\"vm.broadcast.scoreboard_configuration.scoreboard_make == 'BoxCast'\">\n    <div style=\"font-size:10px\">\n      Identity:\n      <!-- Box side -->\n      <span ng-if=\"vm.scoreboardMode == 'pair' && vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.box\">\n        <span style=\"opacity:0.4\" uib-tooltip=\"Firmware: {{ vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.box.firmware_version }}\" tooltip-append-to-body=\"true\">\n        BoxCaster-side:\n        <span style=\"font-family:monospace\">{{ vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.box.serial_number }}</span>\n        </span>\n        <span class=\"label label-info\" ng-if=\"vm.latestScoreboardAssistFirmwareVersion != null && vm.latestScoreboardAssistFirmwareVersion != vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.box.firmware_version\">\n          Firmware Update Available\n        </span>\n      </span>\n      <!-- Scoreboard side -->\n      <span ng-if=\"vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.scoreboard\">\n        <span style=\"opacity:0.4\" uib-tooltip=\"Firmware: {{ vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.scoreboard.firmware_version }}\" tooltip-append-to-body=\"true\">\n        <span ng-show=\"vm.scoreboardMode == 'pair'\">Scoreboard-side:</span>\n        <span ng-hide=\"vm.scoreboardMode == 'pair'\">Scoreboard:</span>\n        <span style=\"font-family:monospace\">{{ vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.scoreboard.serial_number }}</span>\n        </span>\n        <span class=\"label label-info\" ng-if=\"vm.latestScoreboardAssistFirmwareVersion != null && vm.latestScoreboardAssistFirmwareVersion != vm.streamDiagnostics.scoreboard.scoreboard_assist.identity.scoreboard.firmware_version\">\n          Firmware Update Available\n        </span>\n      </div>\n    </div>\n  </div>\n</div>\n\n<hr ng-if=\"vm.showAllAlerts\">\n\n<!-- ALERT HISTORY, stream health -->\n<div class=\"row text-center\" ng-if=\"vm.activeTab == 'stream health' && vm.showAllAlerts\">\n  <div class=\"col-xs-12\">\n    <p ng-if=\"!vm.streamDiagnostics.alerts.length\" class=\"help-block text-center\" style=\"margin-top:20px\">\n      No alerts were detected!\n    </p>\n    <div ng-if=\"vm.streamDiagnostics.alerts.length\">\n      <table class=\"table-condensed table-hover text-left\" style=\"width:100%\">\n        <tbody>\n          <tr ng-repeat=\"a in vm.streamDiagnostics.alerts\">\n            <td><span class=\"label label-{{a.level == 'Critical' ? 'danger' : 'warning'}}\">{{a.level}}</span></td>\n            <td>{{a.message}}</td>\n            <td class=\"text-right\">\n              {{a.detected_at|date:'shortTime'}} <span ng-hide=\"a.is_active\">- {{a.inactive_at|date:'shortTime'}}</span>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n\n<!-- EVENT HISTORY, scoreboard -->\n<div class=\"row text-center\" ng-if=\"vm.activeTab == 'scoreboard' && vm.showAllAlerts\">\n  <div class=\"col-xs-12\">\n    <p ng-if=\"!vm.scoreboardEvents.length\" class=\"help-block text-center\" style=\"margin-top:20px\">\n      No events have been logged!\n    </p>\n    <div ng-if=\"vm.scoreboardEvents.length\">\n      <table class=\"table-condensed table-hover text-left\" style=\"width:100%\">\n        <tbody>\n          <tr ng-repeat=\"e in vm.scoreboardEvents\">\n            <td>{{e.message}}</td>\n            <td class=\"text-right\">{{e.timestamp|date:'mediumTime'}}</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n\n<hr ng-if=\"vm.showGraphs\">\n\n<!-- GRAPHS, stream health -->\n<div class=\"row text-center\" ng-if=\"vm.activeTab == 'stream health' && vm.showGraphs\">\n  <div class=\"clearfix\">\n    <div class=\"col-xs-12 text-right\">\n      <ol class=\"list-inline\">\n        <li><small>Graph Type:</small></li>\n        <li>\n          <div class=\"btn-group\">\n            <label class=\"btn btn-xs btn-default\"\n                  ng-model=\"vm.graphType\" uib-btn-radio=\"'fine'\"\n                  ng-click=\"vm.updateGraph()\">Last 60m (fine-grained)</label>\n            <label class=\"btn btn-xs btn-default\"\n                  ng-model=\"vm.graphType\" uib-btn-radio=\"'coarse'\"\n                  ng-click=\"vm.updateGraph()\">Full Broadcast (coarse)</label>\n          </div>\n        </li>\n      </ol>\n    </div>\n  </div>\n\n  <div style=\"margin-top:30px\" ng-if=\"vm.broadcast.stream_source != 'recording'\">\n    <p style=\"margin-bottom:0\"><strong>Broadcast Bitrate (kbps)</strong></p>\n    <canvas ng-if=\"vm.bitrateLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.bitrateData\"\n        chart-labels=\"vm.bitrateLabels\"\n        chart-options=\"vm.bitrateOptions\"\n        chart-dataset-override=\"vm.bitrateDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"vm.bitrateLabels.length == 0\">\n      No bitrate data available.\n    </p>\n  </div>\n  <div style=\"margin-top:30px\" ng-if=\"vm.broadcast.stream_source != 'recording' && vm.broadcast.transcoder_profile != 'audio'\">\n    <p style=\"margin-bottom:0\"><strong>Broadcast Frame Rate (FPS)</strong></p>\n    <canvas ng-if=\"vm.framerateLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.framerateData\"\n        chart-labels=\"vm.framerateLabels\"\n        chart-options=\"vm.framerateOptions\"\n        chart-dataset-override=\"vm.framerateDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"vm.framerateLabels.length == 0\">\n      No frame rate data available.\n    </p>\n  </div>\n  <div style=\"margin-top:30px\" ng-if=\"vm.broadcast.stream_source == 'rtmp' || vm.broadcast.stream_source == 'switcher'\">\n    <p style=\"margin-bottom:0\"><strong>Ingestion Latency (s)</strong></p>\n    <canvas ng-if=\"vm.ingestLatencyLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.ingestLatencyData\"\n        chart-labels=\"vm.ingestLatencyLabels\"\n        chart-options=\"vm.ingestLatencyOptions\"\n        chart-dataset-override=\"vm.ingestLatencyDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"vm.ingestLatencyLabels.length == 0\">\n      No ingestion latency data available.\n    </p>\n  </div>\n  <div style=\"margin-top:30px\" ng-if=\"vm.simulcastLabels.length || vm.broadcast.simulcast_configurations.length\">\n    <p style=\"margin-bottom:0\"><strong>Simulcast (FPS)</strong></p>\n    <canvas ng-if=\"vm.simulcastLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.simulcastData\"\n        chart-labels=\"vm.simulcastLabels\"\n        chart-options=\"vm.simulcastOptions\"\n        chart-dataset-override=\"vm.simulcastDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"!vm.simulcastLabels || vm.simulcastLabels.length == 0\">\n      No simulcast data available.\n    </p>\n  </div>\n  <div style=\"margin-top:30px\" ng-if=\"vm.broadcast.stream_source != 'rtmp' && vm.broadcast.stream_source != 'recording'\">\n    <p style=\"margin-bottom:0\"><strong>Packet Loss</strong></p>\n    <div ng-if=\"vm.totalPacketsLost > 0\">\n      <canvas height=\"50\"\n          class=\"chart chart-bar\"\n          chart-data=\"vm.plData\"\n          chart-labels=\"vm.plLabels\"\n          chart-options=\"vm.plOptions\"\n          chart-colors=\"[{backgroundColor:'#F15854', borderColor:'#F15854'},{backgroundColor:'#DECF3F',borderColor:'#DECF3F'}]\"\n          chart-dataset-override=\"[{hitRadius:5},{hitRadius:5}]\"></canvas>\n    </div>\n    <p class=\"help-block\" ng-if=\"vm.totalPacketsLost == 0\">\n      No packet loss reported. <span style=\"font-family:monospace\">＼(＾O＾)／</span>\n    </p>\n  </div>\n</div>\n\n<!-- GRAPHS, scoreboard -->\n<div class=\"row text-center\" ng-if=\"vm.activeTab == 'scoreboard' && vm.showGraphs\">\n  <div class=\"clearfix\">\n    <div class=\"col-xs-12 text-right\">\n      <ol class=\"list-inline\">\n        <li><small>Graph Type:</small></li>\n        <li>\n          <div class=\"btn-group\">\n            <label class=\"btn btn-xs btn-default\"\n                  ng-model=\"vm.graphType\" uib-btn-radio=\"'fine'\"\n                  ng-click=\"vm.updateGraph()\">Last 60m (fine-grained)</label>\n            <label class=\"btn btn-xs btn-default\"\n                  ng-model=\"vm.graphType\" uib-btn-radio=\"'coarse'\"\n                  ng-click=\"vm.updateGraph()\">Full Broadcast (coarse)</label>\n          </div>\n        </li>\n      </ol>\n    </div>\n  </div>\n\n  <div style=\"margin-top:30px\">\n    <p style=\"margin-bottom:0\"><strong>Scoreboard Data Rate</strong></p>\n    <canvas ng-if=\"vm.scoreDataRateLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.scoreDataRateData\"\n        chart-labels=\"vm.scoreDataRateLabels\"\n        chart-options=\"vm.scoreDataRateOptions\"\n        chart-dataset-override=\"vm.scoreDataRateDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"vm.scoreDataRateLabels.length == 0\">\n      No scoreboard data rate data available.\n    </p>\n  </div>\n\n  <div style=\"margin-top:30px\" ng-if=\"vm.scoreboardMode == 'pair'\">\n    <p style=\"margin-bottom:0\"><strong>Wireless Signal Strength</strong></p>\n    <canvas ng-if=\"vm.rssiLabels.length\"\n        height=\"50\"\n        class=\"chart chart-line\"\n        chart-data=\"vm.rssiData\"\n        chart-labels=\"vm.rssiLabels\"\n        chart-options=\"vm.rssiOptions\"\n        chart-dataset-override=\"vm.rssiDatasetOverride\"></canvas>\n    <p class=\"help-block\" ng-if=\"vm.rssiLabels.length == 0\">\n      No signal strength data available.\n    </p>\n  </div>\n</div>\n"

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {// time picker directive
//
//  <time-picker ng-model="dateTimeObj"
//               start-time="dateTimeObj"
//               end-time="dateTimeObj"
//               display-format="h:mm a"
//               step-minutes="30"
//               show-duration="false"
//               scroll-item-into-focus="false"
//               ></time-picker>
//
//  options:
//    - start-time: defaults to Now
//    - end-time: defaults to Now + 1 day
//    - display-format: defaults to 'h:mm a' (moment.js format parameters)
//    - step-minutes: defaults to 30
//    - show-duration: defaults to false
var module = angular.module('app.directives');
module.directive('timePicker', function () {
  'ngInject';

  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      displayFormat: '@',
      startTime: '=?',
      endTime: '=?',
      stepMinutes: '@',
      showDuration: '@'
    },
    template: "\n      <div class=\"input-group\">\n        <input type=\"text\"\n               class=\"form-control\"\n               ng-click=\"showOptions()\"\n               ng-model=\"dateModelFn\"\n               ng-model-options=\"{getterSetter: true, updateOn: 'blur'}\">\n        <div class=\"input-group-btn\">\n          <button type=\"button\" class=\"btn btn-default dropdown-toggle\" ng-click=\"toggleOptions()\"><span class=\"caret\"></span></button>\n          <ul class=\"dropdown-menu\"\n              role=\"menu\"\n              style=\"max-height:200px; overflow-y:scroll;\"\n              >\n            <li ng-repeat=\"option in options\"\n                ng-class=\"{active: option.hourValue == ngModelHourValue}\"\n                data-hour-value=\"{{option.hourValue}}\"\n                >\n              <a href=\"javascript://\" ng-click=\"selectOption(option.value)\">\n                {{option.label}}\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n    ",
    link: function link(scope, element, attrs, ngModelCtrl) {
      var displayFormat = scope.displayFormat || 'h:mm a';
      var startTime = scope.startTime || moment().startOf('day').toDate();
      var endTime = scope.endTime || moment(startTime).add(1, 'day').toDate();
      var stepMinutes = scope.stepMinutes || 30;

      if (stepMinutes < 0) {
        throw Error('Invalid value for step-minutes: ' + stepMinutes);
      }

      scope.dateModelFn = function (value) {
        if (arguments.length) {
          value = tryParseTime(value);
          ngModelCtrl.$setViewValue(value ? value.toDate() : null);
          ngModelCtrl.$commitViewValue();
        } else {
          value = ngModelCtrl.$modelValue;
        }

        if (value) {
          scope.ngModelHourValue = moment(value).format('HHmm');
          return moment(value).format(displayFormat);
        } else {
          return '';
        }
      };

      scope.$watch('startTime', _.throttle(function (newStartTime) {
        startTime = newStartTime || moment().startOf('day').toDate();
        endTime = scope.endTime || moment(startTime).add(1, 'day').toDate();

        if (ngModelCtrl.$modelValue < startTime) {
          // Make sure current time is after start time
          console.log('Adjusting current time to', startTime);
          ngModelCtrl.$setViewValue(startTime);
          ngModelCtrl.$commitViewValue();
        }

        scope.options = buildOptions(startTime, endTime, stepMinutes, scope.showDuration, displayFormat);
      }, 100));
      var menu = element.find('.dropdown-menu');
      var isMenuVisible = false;

      scope.showOptions = function () {
        if (!isMenuVisible) {
          menu.show();
          isMenuVisible = true;
          scrollItemIntoFocus(); // hack the position relative to the input, not the button

          var inputWidth = element.find('input').css('width');
          menu.css({
            left: "-".concat(inputWidth)
          });
        }
      };

      function scrollItemIntoFocus() {
        // scroll the closest option into focus
        var currentValue = moment(ngModelCtrl.$modelValue).format('HHmm');
        var closest = null;
        menu.find('li').each(function (i, item) {
          var itemValue = $(item).data('hour-value');
          var diff = Math.abs(itemValue - currentValue);

          if (!closest || diff < closest.diff) {
            closest = {
              diff: diff,
              item: item
            };
          }
        });

        if (closest) {
          menu.get(0).scrollTop = closest.item.offsetTop;
        }
      }

      scope.hideOptions = function () {
        setTimeout(function () {
          return menu.hide();
        }, 50);
        isMenuVisible = false;
      };

      scope.toggleOptions = function () {
        if (isMenuVisible) {
          scope.hideOptions();
        } else {
          scope.showOptions();
        }
      };

      scope.selectOption = function (option) {
        //console.log('selecting option', option);
        ngModelCtrl.$setViewValue(option);
        ngModelCtrl.$commitViewValue();
        scope.hideOptions();
      }; // Let stray clicks off the menu close the menu


      var strayClickHandler = function strayClickHandler(e) {
        if (!isMenuVisible) {
          return true;
        }

        if ($.contains(element.find('.input-group')[0], e.target)) {
          //console.log('click was inside directive; leaving menu open');
          e.preventDefault();
          e.stopPropagation();
        } else {
          //console.log('hiding from body click');
          scope.hideOptions();
        }
      };

      $('body').on('click', strayClickHandler);
      scope.$on('$destroy', function () {
        $('body').off('click', strayClickHandler);
      });
    }
  };
});

function buildOptions(startTime, endTime, stepMinutes, showDuration, displayFormat) {
  // Dynamically determine which options to show
  // Account for 24-hour wrap-around if necessary
  var options = [];

  if (endTime < startTime || !endTime || !startTime) {
    console.warn('Unable to generate options between', startTime, 'and', endTime);
    return options;
  }

  var startDate = moment(startTime).date();
  var ticker = moment(startTime).startOf('hour');
  var i = 0;

  while (ticker.isBefore(endTime)) {
    if (++i > 1000) {
      console.error('Infinite loop?', startTime, ticker, endTime, stepMinutes);
      return;
    }

    var option = {
      value: ticker.toDate(),
      label: ticker.format(displayFormat),
      hourValue: ticker.format('HHmm')
    };

    if (showDuration) {
      var diff = ticker.diff(startTime, 'minutes');

      if (diff < 0) {
        ticker = ticker.clone().add(stepMinutes, 'minutes');
        continue; //skip negatives
      }

      var label = labelForDuration(diff, ticker.date() != startDate);
      option.label += ' (' + label + ')';
    }

    options.push(option);
    ticker = ticker.clone().add(stepMinutes, 'minutes');
  }

  return options;
}

function labelForDuration(diff, isDifferentDay) {
  var displayDiff;

  if (diff < 60) {
    displayDiff = "".concat(diff, " minutes");
  } else {
    var fracHours = Math.round(10.0 * diff / 60.0) / 10.0;
    displayDiff = "".concat(fracHours, " hours");
  }

  if (isDifferentDay) {
    displayDiff += ' - Following Day';
  }

  return displayDiff;
}

function tryParseTime(string) {
  var formats = ['h:mm a', 'h:mm A', 'h:mma', 'h:mmA', 'h:m a', 'h:m A', 'h:ma', 'h:mA', 'HH:mm'];
  var result = null;
  if (!string) return result;

  _.each(formats, function (f) {
    result = moment(string, f);

    if (result.isValid()) {
      return false; //stop iteration
    } else {
      console.log('Unable to parse time', string, 'as', f);
    }
  });

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (module);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// upgrade button
//
//   <upgrade-botton >
//
var module = angular.module('app.directives');
module.directive('upgradeButton', function () {
  return {
    restrict: 'E',
    scope: {},
    template: "\n      <button type=\"button\" ng-click=\"vm.onClick($event)\" class=\"btn btn-default\" style=\"margin:15px\">\n        {{::vm.title()}}\n      </button>\n    ",
    controllerAs: 'vm',
    controller: ["$rootScope", "MeetingsService", function controller($rootScope, MeetingsService) {
      'ngInject';

      var account = $rootScope.account;

      this.title = function () {
        return 'Review Upgrade Options';
      };

      this.onClick = function ($event) {
        MeetingsService.openPreferredMethod();
      };
    }]
  };
});

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {


UploadModalController.$inject = ["params", "$uibModalInstance"];function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var module = angular.module('app.directives');
module.directive('uploadModalLauncher', ["$uibModal", function ($uibModal) {
  'ngInject';

  return _defineProperty({
    restrict: 'E',
    transclude: true,
    scope: {
      slotName: '=',
      allowImage: '=',
      allowVideo: '=',
      modalHeading: '@',
      onUploaded: '&'
    },
    template: __webpack_require__(202),
    link: function link(scope) {
      var allowVideo = scope.allowVideo,
          allowImage = scope.allowImage,
          slotName = scope.slotName,
          modalHeading = scope.modalHeading;

      scope.openUploadModal = function () {
        $uibModal.open({
          template: __webpack_require__(202),
          controller: UploadModalController,
          controllerAs: 'vm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            params: function params() {
              return {
                slotName: slotName,
                allowVideo: allowVideo,
                allowImage: allowImage,
                heading: modalHeading,
                file: scope.uploadedFile
              };
            }
          }
        }).result.then(function () {
          scope.onUploaded({
            file: scope.uploadedFile
          });
        });
      };
    }
  }, "template", "\n    <a ng-click=\"openUploadModal()\" class=\"class\" style=\"style\">\n      <div ng-transclude></div>\n    </a>\n    ");
}]);

function UploadModalController(params, $uibModalInstance) {
  var _this = this;

  this.params = params;

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this.upload = function () {
    if (!_this.file || !_this.file.upload) {
      return;
    }

    _this.uploading = true;

    _this.file.upload().then(function (result) {
      _this.uploading = false;
      $uibModalInstance.close(result);
    });
  };
}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// upload slot directive
//
// allows you to use the BoxCast media hosting infrastructure to
// input a URL or allow a new uploaded image/video.
//
//   <upload-slot ng-model="vm.myUploadedFile"
//                ng-change="vm.onUploadChange()"
//                allow-image="true"
//                allow-video="true"
//                slot-name="account"
//                ></upload-slot>
//
// the ng-model object that you get out is a special FileReader-like object
// with a few additional attributes:
//
//    upload() - function, returns promise when upload is complete with the
//               AccountUpload metadata response from the BoxCast API
//    videoDuration - float, seconds, if able to be computed by the browser
//
//
// Depends on https://github.com/danialfarid/ng-file-upload
var module = angular.module('app.directives');
module.directive('uploadSlot', ["toaster", "$q", "$uibModal", "$timeout", "AccountUploadsService", function (toaster, $q, $uibModal, $timeout, AccountUploadsService) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      ngChange: '@',
      slotName: '=',
      allowImage: '=',
      allowVideo: '=',
      compact: '=',
      hideRecentBrowse: '=',
      hideStockBrowse: '=',
      clearOnSuccess: '='
    },
    require: 'ngModel',
    template: __webpack_require__(375),
    link: function link(scope, element, attrs, ngModelCtrl) {
      var allowVideo = scope.allowVideo,
          allowImage = scope.allowImage,
          slotName = scope.slotName,
          hideRecentBrowse = scope.hideRecentBrowse,
          hideStockBrowse = scope.hideStockBrowse;
      var cfg = AccountUploadsService.uploadConfiguration(allowVideo, allowImage, slotName);
      scope.rules = cfg.rules;
      scope.fileTypeSentence = cfg.fileTypeSentence;
      scope.helpText = cfg.helpText;
      scope.showVideoHelp = cfg.showVideoHelp;
      scope.skipBrowseModal = hideRecentBrowse && hideStockBrowse;

      if (attrs.ngChange) {
        ngModelCtrl.$viewChangeListeners.push(function () {
          scope.$eval(attrs.ngChange);
        });
      }

      scope.browse = function () {
        return showBrowseDialog();
      };

      scope.$watch('file', function (newFile, oldFile) {
        if (newFile && newFile.__avoidUpload) {// Do nothing; result of browsing for other file
        } else if (newFile) {
          updateDataBinding({
            upload: function upload(args) {
              return uploadFile(args);
            },
            file: newFile
          });
        } else if (oldFile) {
          scope.file = null;
          updateDataBinding(null);
        } else {
          scope.file = null; // first load, no need to do anything
        }

        if (newFile && newFile.type) {
          var parts = newFile.type.split('/');
          scope.fileType = parts.length < 2 ? '' : parts[1];
        } else {
          scope.fileType = '';
        }
      }); // Wait for <video> preview to render so that we can try to compute duration

      scope.$watch(function () {
        return scope.file && element.find('video').get(0);
      }, function (videoElement) {
        if (videoElement) {
          videoElement.addEventListener('loadeddata', function () {
            console.log('Assigning video duration to upload candidate');
            scope.ngModel.videoDuration = videoElement.duration;
            updateDataBinding(scope.ngModel);
          });
        }
      });
      scope.$watch('invalidFile', function (err) {
        if (err) {
          console.warn('Invalid file upload attempted', err);
          toaster.pop('warning', "Invalid file (".concat(err.$error, " should be ").concat(err.$errorParam, "). Please try another file."));
        }
      });
      scope.$on('$destroy', function () {
        AccountUploadsService.destroy();
      });

      function updateDataBinding(value) {
        scope.ngModel = value;
        ngModelCtrl.$setViewValue(value);
        ngModelCtrl.$commitViewValue();

        if (value && scope.onChange) {
          scope.onChange(value);
        }
      }

      function showBrowseDialog() {
        $uibModal.open({
          template: __webpack_require__(376),
          controller: __webpack_require__(377)["default"],
          controllerAs: 'vm',
          resolve: {
            params: function params() {
              return {
                slotName: scope.slotName,
                allowImage: scope.allowImage,
                allowVideo: scope.allowVideo,
                hideRecentBrowse: scope.hideRecentBrowse,
                hideStockBrowse: scope.hideStockBrowse
              };
            }
          }
        }).result.then(function (result) {
          console.log('Back in <upload-slot>. Browse completed with result', result);

          if (result.type == 'file') {
            // Trigger watcher as if you had drag/dropped
            scope.file = result.result;
          } else if (result.type == 'upload') {
            // Already in our uploads subsystem, skip ahead a bit
            // XXX: touching `file` here triggers the watcher
            var f = result.result;
            scope.file = {
              __avoidUpload: true,
              name: f.filename,
              type: f.mimetype,
              size: f.filesize
            };
            updateDataBinding({
              upload: function upload() {
                return $q(function (resolve) {
                  return resolve(result.result);
                });
              },
              videoDuration: null
            });
          } else if (result.type == 'url') {
            // Skip ahead even further by just passing the URL along
            updateDataBinding({
              upload: function upload() {
                return $q(function (resolve) {
                  return resolve({
                    view_url: result.result
                  });
                });
              },
              videoDuration: null
            });
          }
        });
      }

      function uploadFile(args) {
        var file = scope.file,
            slotName = scope.slotName;
        return AccountUploadsService.processFileAndUpload(file, slotName, args).then(function (data) {
          if (scope.clearOnSuccess) {
            $timeout(function () {
              return scope.file = null;
            }, 1000);
          }

          return data;
        })["catch"](function (err) {
          console.error('Error acquiring upload path:', err);
          toaster.pop('warning', "File ".concat(file.name, " failed to upload."));
          file.status = 'error';
          throw err;
        });
      }
    }
  };
}]);

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"!file\"\n     ngf-drop\n     ngf-multiple=\"false\"\n     ngf-keep=\"false\"\n     ngf-validate=\"rules\",\n     ngf-max-size=\"allow\"\n     ngf-model-invalid=\"invalidFile\"\n     ng-model=\"file\"\n     name=\"file\"\n     class=\"drop-box\"\n     ng-class=\"compact?'compact':''\"\n>\n\n  <div class=\"drop-target text-center\">\n\n    <div class=\"no-file\">\n      <i class=\"fa fa-cloud-upload\"></i>\n      <div ng-show=\"!skipBrowseModal\">\n        <a class=\"browse-link\" href ng-click=\"browse()\">Upload {{fileTypeSentence}}</a>\n        or drag & drop\n      </div>\n      <form ng-show=\"skipBrowseModal\" name=\"myForm\">\n        <div class=\"form-group\">\n          <!-- Skip modal and go straight to file explorer if stock photos and recent uploads are hidden -->\n          <label class=\"browse-link\">\n            Upload {{fileTypeSentence}}\n            <input type=\"file\"\n                    name=\"file\"\n                    ngf-select\n                    ng-model=\"file\"\n                    ngf-multiple=\"false\"\n                    ngf-keep=\"false\"\n                    ngf-validate=\"rules\",\n                    ngf-model-invalid=\"invalidFile\"\n                    hidden\n                    >\n          </label>\n         or drag & drop\n          <div class=\"text-danger\" ng-show=\"myForm.file.$error.pattern\">\n            <i>Invalid file type ({{invalidFile.$errorParam}} required)</i>\n          </div>\n          <div class=\"text-danger\" ng-show=\"myForm.file.$error.maxSize\">\n            <i>File too large {{invalidFile.size / 1000000|number:1}}MB: max {{invalidFile.$errorParam}}</i>\n          </div>\n        </div>\n      </form>\n\n      {{helpText}}\n      <p ng-show=\"showVideoHelp\">\n        Recommend 720p with FastStart.<br/>\n        <a\n          href=\"https://support.boxcast.com/en/articles/4235102\"\n          target=\"_blank\">\n          Get help preparing video for upload.\n        </a>\n      </p>\n    </div>\n  </div>\n</div>\n\n<div ng-show=\"file\" class=\"text-center\">\n  <div class=\"has-file\" ng-class=\"file.type.startsWith('image') ? 'transparent-grid-bg' : ''\">\n    <a href class=\"pull-right\" ng-click=\"file = null\" title=\"Remove File\"><i class=\"fa fa-times-circle remove-icon\"></i></a>\n    <img ng-if=\"file.type.startsWith('image')\" class=\"img\" ngf-thumbnail=\"file\">\n    <video ng-if=\"file.type.startsWith('video')\" controls ngf-src=\"file\"></video>\n    <p ng-if=\"file.type.startsWith('application/pdf')\" class=\"text-center\"><i class=\"fa fa-file-pdf-o file-icon\"></i></p>\n    <p ng-if=\"file.name.endsWith('.vtt')\" class=\"text-center\"><i class=\"fa fa-file-text-o file-icon\"></i></p>\n  </div>\n  <p class=\"help-block overflow-ellipse\">\n    {{file.name}}<br>\n    <small>\n      {{fileType ? fileType+',' : ''}}\n      {{file.size|bytes}}\n    </small>\n  </p>\n  <p ng-show=\"file.status == 'error'\" class=\"text-danger\">\n    Error uploading.\n  </p>\n  <p ng-show=\"file.status == 'done'\" class=\"text-info\">\n    Successfully Uploaded!\n  </p>\n  <uib-progressbar value=\"file.progressPct\" ng-show=\"file.status == 'uploading'\" max=\"100\">\n    {{file.progressPct}}% Uploaded\n  </uib-progressbar>\n  <p ng-show=\"file.estimatedTimeRemainingMs\" class=\"text-info\">\n    Upload will finish in {{ file.estimatedTimeRemainingMs | remainingTime }}...\n  </p>\n</div>\n"

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Browse for File</h3>\n</div>\n<div class=\"modal-body\">\n\n  <h5 style=\"font-weight:bold\">Browse Your Computer</h5>\n  <form name=\"myForm\">\n    <div class=\"form-group\">\n      <input type=\"file\"\n             name=\"file\"    \n             ngf-select\n             ng-model=\"vm.file\"\n             ngf-multiple=\"false\"\n             ngf-keep=\"false\"\n             ngf-validate=\"vm.rules\",\n             ngf-model-invalid=\"vm.invalidFile\"\n             >\n        <div class=\"text-danger\" ng-show=\"myForm.file.$error.pattern\">\n          <i>Invalid file type ({{vm.invalidFile.$errorParam}} required)</i>\n        </div>\n        <div class=\"text-danger\" ng-show=\"myForm.file.$error.maxSize\">\n          <i>File too large {{vm.invalidFile.size / 1000000|number:1}}MB: max {{vm.invalidFile.$errorParam}}</i>\n        </div>\n      <img ng-if=\"myForm.file.$valid\"\n           ngf-thumbnail=\"vm.file\"\n           class=\"img\" style=\"max-width:160px;max-height:120px;margin:15px 0;\">\n    </div>\n    <div class=\"form-group\">\n      <button class=\"btn btn-primary btn-block\"\n              ng-if=\"vm.file && myForm.file.$valid\" \n              ng-click=\"vm.selectByFile(vm.file)\">Use This File</button>\n    </div>\n  </form>\n\n  <div ng-if=\"vm.uploads.length && !vm.hideRecentBrowse\">\n    <h5 style=\"font-weight:bold\">Other Recent Uploads</h5>\n\n    <ol class=\"list-inline\">\n      <li ng-repeat=\"f in vm.uploads track by f.id\" style=\"width:33%;margin-bottom:15px;\">\n        <div class=\"fixed-16-9\"\n             style=\"cursor:pointer\"\n             ng-click=\"vm.selectByUploadObject(f)\">\n          <div ng-if=\"f.mimetype.startsWith('image')\" style=\"background-image:url(&quot;{{f.view_url | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n          <video ng-if=\"f.mimetype.startsWith('video')\" ng-src=\"{{f.view_url | trustedUrl}}\" style=\"max-width:100%\"></video>\n          <div ng-if=\"f.mimetype.startsWith('application/pdf')\" class=\"fixed-16-9 text-center\" style=\"background:#fff;border:1px solid #111\">\n            <p>\n              <i class=\"fa fa-file-pdf-o fa-2x\" style=\"display:block !important;margin:15px\"></i>\n              {{f.filename}} ({{f.filesize|bytes}})\n            </p>\n          </div>\n        </div>\n        <div ng-if=\"!f.mimetype.startsWith('application/pdf')\" class=\"overflow-ellipse\" style=\"font-weight:bold;font-size:0.8em;color:#aaa;\">\n          {{f.filename}} ({{f.created_at|date}})\n        </div>\n      </li>\n    </ol>\n    <div>\n      <uib-pagination\n        total-items=\"vm.pagination.total\"\n        items-per-page=\"12\"\n        rotate=\"false\"\n        class=\"pagination-sm\"\n        ng-model=\"vm.pagination.current\"\n        ng-change=\"vm.loadUploadsForPage(vm.pagination.current, vm.q)\"></uib-pagination>\n    </div>\n\n  </div>\n\n  <div ng-if=\"vm.allowImage && !vm.hideStockBrowse\">\n    <h5 style=\"font-weight:bold\">Find Free Stock Photos</h5>\n    <form name=\"unsplashForm\" ng-submit=\"vm.searchUnsplash()\">\n      <div class=\"form-group\">\n        <div class=\"input-group\">\n          <input type=\"text\" class=\"form-control\" placeholder=\"Cats, basketball, flowers, ...\" ng-model=\"vm.unsplashQuery\">\n          <span class=\"input-group-btn\">\n            <button class=\"btn btn-default btn-secondary\" type=\"submit\">\n              <i ng-hide=\"vm.unsplashSearching\" class=\"fa fa-search\"></i>\n              <i ng-show=\"vm.unsplashSearching\" class=\"fa fa-spin fa-spinner\"></i>\n            </button>\n          </span>\n        </div>\n      </div>\n    </form>\n\n    <ol class=\"list-inline\" ng-if=\"vm.unsplashResults\">\n      <p class=\"help-block text-center\">Found {{vm.unsplashResults.total}} results. <span ng-show=\"vm.unsplashResults.total > 15\">Showing first 15.</span></p>\n      <li ng-repeat=\"f in vm.unsplashResults.results track by f.id\" style=\"width:33%;\">\n        <div class=\"fixed-16-9\"\n             style=\"cursor:pointer\"\n             ng-click=\"vm.selectByUrl(f.urls.regular)\">\n          <div style=\"background-image:url({{f.urls.thumb | trustedUrl}});background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n        </div>\n        <p class=\"help-block text-center\">\n          <small>\n            Image by <a href=\"{{f.user.links.html}}\" target=\"_blank\">{{f.user.first_name}} {{f.user.last_name}}</a>\n          </small>\n        </p>\n      </li>\n    </ol>\n\n    <p class=\"help-block text-center\">\n      Photo search powered by <a href=\"https://unsplash.com\" target=\"_blank\" class=\"action-link\" style=\"color:#000\"><i class=\"fa fa-camera\"></i> Unsplash</a>\n    </p>\n\n  </div>\n\n</div>\n\n"

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = UploadSlotBrowseController;
var PAGE_SIZE = 12;
function UploadSlotBrowseController(params, $uibModalInstance, $http, toaster, AccountUploadsService) {
  'ngInject';

  this.slotName = params.slotName;
  this.allowImage = params.allowImage;
  this.allowVideo = params.allowVideo;
  this.hideStockBrowse = params.hideStockBrowse;
  this.hideRecentBrowse = params.hideRecentBrowse;
  var cfg = AccountUploadsService.uploadConfiguration(this.allowVideo, this.allowImage, this.slotName);
  this.rules = cfg.rules;

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.selectByFile = function (file) {
    $uibModalInstance.close({
      type: 'file',
      result: file
    });
  };

  this.selectByUploadObject = function (upload) {
    $uibModalInstance.close({
      type: 'upload',
      result: upload
    });
  };

  this.selectByUrl = function (url) {
    // The Unsplash API *wants* us to hotlink to their image hosting so that
    // they can properly track hits, which is awesome for us!
    $uibModalInstance.close({
      type: 'url',
      result: url
    });
  };

  this.searchUnsplash = function () {
    var _this = this;

    this.unsplashSearching = true;
    this.unsplashResults = null;
    AccountUploadsService.searchUnsplash(this.unsplashQuery).then(function (results) {
      _this.unsplashResults = results;
    })["finally"](function () {
      return _this.unsplashSearching = false;
    });
  };

  this.q = '';

  this.loadUploadsForPage = function (p, q) {
    var _this2 = this;

    var filters = {};

    if (this.slotName) {
      filters['filter.slot'] = this.slotName;
    }

    return AccountUploadsService.listUploadsForPage(p, q, filters, PAGE_SIZE).then(function (response) {
      _this2.uploads = response.uploads;
      _this2.pagination = response.pagination;
    })["catch"](function (err) {
      toaster.pop('warning', 'Unable to load uploads. Please refresh the page and try again.');
    });
  };

  this.loadUploadsForPage(1, this.q);
}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// wifi signal strength directive
//
//   <wifi-signal-strength pct="0.5" label-position="'left'" />
//
var module = angular.module('app.directives');
module.directive('wifiSignalStrength', function () {
  return {
    restrict: 'E',
    scope: {
      pct: '=pct',
      labelPosition: '=labelPosition'
    },
    template: "\n      <div style=\"position:relative;text-align:center;top:5px;\">\n        <span class=\"hidden-xs\" style=\"position:relative;top:-5px;\" ng-if=\"labelPosition == 'left'\">{{(pct * 100) | number:0}}%</span>\n        <div style=\"display:inline-block;\" class=\"wifi-icon {{suppClass}}\"></div>\n        <span class=\"hidden-xs\" style=\"position:relative;top:-5px;\" ng-if=\"labelPosition == 'right'\">{{(pct * 100) | number:0}}%</span>\n      </div>\n    ",
    link: function link(scope) {
      // 4 bars: 0-9%=0 bars, 10-19%=0 bars, 20-39=2 bars, 40-59%=3 bars, ...
      if (scope.pct < 0.25) {
        scope.suppClass = 'none';
      } else if (scope.pct < 0.5) {
        scope.suppClass = 'weak';
      } else if (scope.pct < 0.75) {
        scope.suppClass = 'medium';
      } else {
        scope.suppClass = '';
      }
    }
  };
});

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// toggle switch directive
//
// example:
//   <p ng-init="checkedState = true">
//     Toggle
//     <toggle-switch ng-model="checkedState" color="blue"></toggle-switch>
//     Checked: '{{checkedState}}'
//   </p>
//
// note:
//  * `color` value must match the CSS options in app/styles/components/_toggle_switch.scss
var module = angular.module('app.directives');
var DEFAULT_COLOR = 'green';
module.directive('toggleSwitch', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      ngChange: '&',
      color: '@',
      label: '@'
    },
    require: 'ngModel',
    template: "\n      <label style=\"line-height: 24px\">\n        <span class=\"toggle-switch toggle-switch--{{::color}}\">\n          <input type=\"checkbox\" ng-model=\"ngModel\" ng-change=\"ngChange($event)\">\n          <span class=\"slider\"></span>\n        </span>\n        <span ng-if=\"label\" style=\"display: inline-block; margin-left: 5px;\">{{label}}</span>\n      </label>\n    ",
    link: function link(scope, element, attrs, ngModelCtrl) {
      scope.color = scope.color || DEFAULT_COLOR;
    }
  };
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
var module = angular.module('app.filters', []); // The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.

__webpack_require__(381);

__webpack_require__(382);

__webpack_require__(383);

__webpack_require__(384);

__webpack_require__(385);

__webpack_require__(386);

__webpack_require__(387);

__webpack_require__(388);

__webpack_require__(389);

__webpack_require__(390);

__webpack_require__(391);

__webpack_require__(392);

__webpack_require__(393);

__webpack_require__(394);

__webpack_require__(395);

__webpack_require__(396);

__webpack_require__(397);

__webpack_require__(398);

__webpack_require__(399);

module.filter('escape', function () {
  return window.encodeURIComponent;
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 381 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('bytes', function () {
  'ngInject';

  return function (bytes, precision) {
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
    if (typeof precision === 'undefined') precision = 1;
    if (bytes == 0) return '0 B';
    var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'],
        number = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
  };
});
angular.module('app.filters').filter('bits', function () {
  'ngInject';

  return function (bytes, precision) {
    var part = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';
    var value, suffix;

    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
      value = '-';
      suffix = '';
    } else {
      if (typeof precision === 'undefined') {
        precision = 1;
      }

      if (bytes == 0) {
        value = 0;
        suffix = 'b';
      } else {
        var units = ['b', 'kb', 'Mb', 'Gb', 'Tb', 'Pb'],
            number = Math.floor(Math.log(bytes) / Math.log(1024));
        value = (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision);
        suffix = units[number];
      }
    }

    if (part == 'value') {
      return value;
    } else if (part == 'suffix') {
      return suffix;
    } else {
      return "".concat(value, " ").concat(suffix);
    }
  };
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
// dateDuration filter
//
//    {{ startTime | dateDuration : endTime : showSeconds : defaultIfEndNull }}

angular.module('app.filters').filter('dateDuration', function ($filter) {
  'ngInject';

  return function (start, end, showSeconds, defaultIfEndNull) {
    if (defaultIfEndNull && !end) {
      return defaultIfEndNull;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["b" /* differenceFormattedAsDurationLabel */])(start, end, showSeconds);
  };
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_video_and_audio_config__ = __webpack_require__(27);

angular.module('app.filters').filter('configLabel', function ($rootScope) {
  'ngInject';

  var ApiConfig = $rootScope.ApiConfig;
  return function (value, section, subsection) {
    var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var cfg = (ApiConfig[section] || {})[subsection] || (__WEBPACK_IMPORTED_MODULE_0__utils_video_and_audio_config__["a" /* VideoAudioConfig */][section] || {})[subsection];

    var result = _.find(cfg, function (item) {
      return item.value == value;
    });

    return _.get(result, 'label', defaultValue);
  };
});

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// daySuffix filter
//
//  Returns "February 1st", "March 2nd", etc. for a given date. You can
//  also choose to just return "1st" or "2nd" by passing false as the 2nd arg.
angular.module('app.filters').filter('daySuffix', ["$filter", function ($filter) {
  'ngInject';

  var suffixes = ['th', 'st', 'nd', 'rd'];
  return function (input) {
    var withMonthName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!input) return '';
    var fullDate = $filter('date')(input, 'MMMM dd');
    var day = parseInt(fullDate.slice(-2));
    var relevantDigits = day < 30 ? day % 20 : day % 30;
    var suffix = relevantDigits <= 3 ? suffixes[relevantDigits] : suffixes[0];

    if (withMonthName) {
      return fullDate + suffix;
    } else {
      return day + suffix;
    }
  };
}]);

/***/ }),
/* 385 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('getById', function () {
  'ngInject';

  return function (map, searchValue) {
    var keyField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
    var displayField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    var result = _.find(map, function (item) {
      return item[keyField] == searchValue;
    });

    if (displayField) {
      return _.get(result, displayField, defaultValue);
    } else {
      return result;
    }
  };
});

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// macAddress filter -- formats a 12-character string as a MAC address. The default separator is a colon.
//
//    {{ address | macAddress : separator }}
angular.module('app.filters').filter('macAddress', ["$filter", function ($filter) {
  'ngInject';

  return function (input) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
    return input.toUpperCase().match(/.{1,2}/g).join(separator);
  };
}]);

/***/ }),
/* 387 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('metricSuffix', ["$filter", function ($filter) {
  'ngInject';

  var numberWithUnitFilter = $filter('numberWithUnit');
  return function (number, extraText) {
    if (!number) return '';
    if (!extraText) extraText = '';
    if (!_.isNumber(number)) return number; // Reduce the number to be < 1000

    var tridecadic_reduction = 0;

    while (number >= 1000.0) {
      number = number / 1000.0;
      tridecadic_reduction += 1;
    }

    var prefix;

    switch (tridecadic_reduction) {
      case 0:
        prefix = '';
        break;

      case 1:
        prefix = 'k';
        break;

      case 2:
        prefix = 'M';
        break;

      case 3:
        prefix = 'G';
        break;

      case 4:
        prefix = 'T';
        break;

      case 5:
        prefix = 'P';
        break;

      default:
        prefix = "10^".concat(3 * tridecadic_reduction);
    }

    return numberWithUnitFilter(number, 1, prefix + extraText);
  };
}]);

/***/ }),
/* 388 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('numberWithUnit', ["$filter", function ($filter) {
  'ngInject';

  var numberFilter = $filter('number');
  return function (number, fractionSize, unit) {
    if (!number) return '';
    if (!unit) unit = '';
    return "".concat(numberFilter(number, fractionSize), " ").concat(unit);
  };
}]);

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// Some global config for moment -- treat every interval as its unit right up to the next one
moment.relativeTimeThreshold('s', 60);
moment.relativeTimeThreshold('m', 60);
moment.relativeTimeThreshold('h', 24);
moment.relativeTimeThreshold('d', 30);
moment.relativeTimeThreshold('M', 12); // relativeTime filter -- formats date/time string into a relative time much like moment().fromNow(), but with slightly more intelligence.

angular.module('app.filters').filter('relativeTime', ["$filter", function ($filter) {
  'ngInject';

  return function (input) {
    var t = moment(input);
    var val = t.fromNow();

    if (val.match(/days?$/)) {
      // If moment wants to say "day" or "days", it's possible that this could be rounded in a non-intuitive way.
      // The most intuitive thing for users is the number of midnights crossed between now and then. The easiest
      // way to get that is to set the time (not the date) of the moment in question to match the time of "now",
      // then let moment do its thing.
      var now = moment();
      t.hours(now.hours());
      t.minutes(now.minutes());
      t.seconds(now.seconds());
      t.millisecond(now.millisecond());
      val = t.fromNow();
    }

    return val;
  };
}]);

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// remainingTime filter -- formats a number of milliseconds into a human-readable (and not overly-precise) form
angular.module('app.filters').filter('remainingTime', ["$filter", function ($filter) {
  'ngInject';

  return function (ms) {
    var rt = $filter('relativeTime')(new Date(Date.now() + ms));

    if (rt.indexOf('ago') != -1) {
      rt = 'in a few seconds';
    } else if (rt.startsWith('in ') && !rt.startsWith('in a few')) {
      rt = rt.replace(/^in /, 'in about ');
    }

    rt = rt.replace(/^in /, '');
    return rt;
  };
}]);

/***/ }),
/* 391 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('scoreboardTeamName', function () {
  'ngInject';

  return function (label) {
    var dflt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    // See origin_task/scorelayout#sanitizeName
    label = label || dflt;
    label = label.toUpperCase();

    if (label.length > 4) {
      label = label.substring(0, 4);
    }

    label = label.replace(/[^\x20-\x7E]+/g, '-');

    while (label.length < 4) {
      label += ' ';
    }

    return label;
  };
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
// secondsFormatted filter
//
//    {{ numberSeconds | secondsFormatted }}

angular.module('app.filters').filter('secondsFormatted', function ($filter) {
  'ngInject';

  return function (seconds) {
    var showSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var showHoursIfZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["e" /* secondsToFormattedLabel */])(seconds, showSeconds, showHoursIfZero);
  };
});

/***/ }),
/* 393 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('simulcast_destination', function () {
  'ngInject';

  return function (destination) {
    switch (destination) {
      case 'facebook':
        return 'Facebook Live';

      case 'youtube':
        return 'YouTube Live';

      case 'generic':
        return 'Other RTMP';

      case 'rtmp_push_channel':
        return 'Other RTMP';

      case 'twitter':
        return 'Twitter';

      default:
        console.warn('Invalid simulcast_destination', destination);
        return "(invalid destination type: ".concat(destination, ")");
    }
  };
});

/***/ }),
/* 394 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('simulcastStatus', ["$filter", function ($filter) {
  'ngInject';

  return function (status) {
    switch (status) {
      case null:
        return 'N/A';

      default:
        return $filter('unslugify')(status);
    }
  };
}]);

/***/ }),
/* 395 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('streamSourceName', ["$filter", function ($filter) {
  'ngInject';

  return function (broadcast) {
    switch (broadcast.stream_source) {
      case 'switcher':
        return 'Switcher Studio (iOS)';

      case 'app':
        return 'Broadcaster App';

      case 'rtmp':
        if (broadcast.static_rtmp_name) {
          return "RTMP: ".concat(broadcast.static_rtmp_name);
        } else {
          return 'RTMP';
        }

      case 'recording':
        return 'Re-Broadcast (Simulated Live)';

      case 'producer':
        return 'Producer (Browser-based streaming)';

      default:
        return broadcast.boxcaster_name;
    }
  };
}]);

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// storageDuration filter
//
//    {{ vm.account.storage_duration_days | storageDuration }}
angular.module('app.filters').filter('storageDuration', ["$filter", function ($filter) {
  'ngInject';

  return function (durationDays) {
    var days = parseInt(durationDays, 10);

    switch (days) {
      case 365:
        return '1 year';
        break;

      case 731:
        return '2 years';
        break;

      case 1096:
        return '3 years';
        break;

      case 1461:
        return '4 years';
        break;

      case 1826:
        return '5 years';
        break;

      default:
        return "".concat(durationDays, " days");
        break;
    }
  };
}]);

/***/ }),
/* 397 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('trustedUrl', ["$sce", function ($sce) {
  'ngInject';

  return function (string) {
    return $sce.trustAsResourceUrl(string);
  };
}]);

/***/ }),
/* 398 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('unslugify', ["$filter", function ($filter) {
  'ngInject';

  function titlecase(s) {
    return s.toString().toLowerCase().replace(/\b([a-z])/g, function (ch) {
      return ch.toUpperCase();
    });
  }

  return function (string) {
    return titlecase((string || '').replace(/_/g, ' '));
  };
}]);

/***/ }),
/* 399 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('usageType', ["$filter", function ($filter) {
  'ngInject';

  return function (input) {
    switch (input) {
      case 'broadcast_duration':
        return 'broadcast';

      case 'viewership':
        return 'viewership';

      case 'captioning':
        return 'caption';
    }

    return '';
  };
}]);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);

var subPages = [__webpack_require__(401), __webpack_require__(404), __webpack_require__(409), __webpack_require__(416), __webpack_require__(419), __webpack_require__(431), __webpack_require__(452), __webpack_require__(455), __webpack_require__(456), __webpack_require__(457), __webpack_require__(459), __webpack_require__(460), __webpack_require__(466), __webpack_require__(486), __webpack_require__(495), __webpack_require__(497), __webpack_require__(531), __webpack_require__(532), __webpack_require__(536), __webpack_require__(539), __webpack_require__(568)];
var module = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('app.pages', subPages.map(function (s) {
  return s["default"].name;
}));
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bulk_import_html__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bulk_import_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bulk_import_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bulk_import_controller__ = __webpack_require__(403);



var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('bulk-import', __WEBPACK_IMPORTED_MODULE_1__bulk_import_html___default.a, __WEBPACK_IMPORTED_MODULE_2__bulk_import_controller__["a" /* default */], 'BulkImportController');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = "<style>\n.bulk-import-progress-container {\n  max-width: 500px;\n  margin: 30px auto;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  padding: 20px;\n}\n.bulk-import-progress-container .row {\n  margin: 15px -15px;\n}\n.bulk-import-progress-container h1 {\n  margin: 0;\n}\n.bulk-import-progress-container i {\n  display: none;\n}\n.bulk-import-progress-container .todo {\n  color: #ccc;\n}\n.bulk-import-progress-container .complete,\n.bulk-import-progress-container .error {\n  color: #333;\n}\n.bulk-import-progress-container .todo i.fa-spinner,\n.bulk-import-progress-container .error i.fa-warning,\n.bulk-import-progress-container .complete i.fa-check {\n  display: inline-block;\n}\n</style>\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n\n\n      <div class=\"well\" ng-if=\"!vm.file\">\n        <h3>Import Broadcasts from CSV</h3>\n        <div class=\"row\">\n          <div class=\"col-sm-6\">\n            <h4>Instructions</h4>\n            <ol>\n              <li><a href=\"javascript://\" ng-disabled=\"vm.downloadingTemplate\" ng-click=\"vm.downloadTemplate()\">Download the Excel Template</a>.  Note that the file is customized for your BoxCast account -- do not share the template with others.</li>\n              <li>Open the file in Microsoft Excel or Google Sheets, and locate the tab labeled \"Broadcasts\" (the other tabs are only for reference).</li>\n              <li>Add one row per broadcast, leaving the header row in-tact.\n                <ul>\n                  <li>On many fields, we have configured the spreadsheet to load supported values as a dropdown. Please use the dropdown to select the value.  If the value does not match exactly, the import may be rejected.</li>\n                  <li>Leave non-required fields blank that you do not need (for example, if you don't want a scoreboard overlay).  Do not remove any columns or the import may fail.</li>\n                </ul>\n              </li>\n              <li>Export the \"Broadcasts\" tab as a CSV file (comma separated values). Leave the header row in place if given the option.</li>\n              <li>Drag and drop the CSV file into the area above to complete your scheduling.</li>\n            </ol>\n            <h4>FAQs</h4>\n            <ul>\n              <li>\n                <strong>Can I use something other than Microsoft Excel or Google Sheets?</strong>\n                <div>Yes, but other spreadsheet software does not support the dynamic lookup feature that is built into\n                  the template, so the import may fail if field values are not typed in precisely.\n                  Please refer to the extra tabs to find proper values to use for Sources, Channels, etc.</div>\n              </li>\n              <li>\n                <strong>Can I just reupload the XLSX file after editing?</strong>\n                <div>No, please export as a CSV (comma separated values) file.</div>\n              </li>\n              <li>\n                <strong>How many records are supported?</strong>\n                <div>You may import up to 1000 records at a time.</div>\n              </li>\n              <li>\n                <strong>How can I add social media broadcast destinations or a thumbnail image? I don't see it in the template.</strong>\n                <div>After you upload the file, you will have the option to attach social media broadcast destinations\n                  in bulk, or to upload thumbnail images for each broadcast. These actions are not easily represented in a spreadsheet, so we have\n                  expanded the upload tool to assist.</div>\n              </li>\n            </ul>\n          </div>\n          <div class=\"col-sm-6\">\n            <button ng-disabled=\"vm.downloadingTemplate\" type=\"button\" class=\"btn btn-block btn-lg btn-default\" ng-click=\"vm.downloadTemplate()\">\n              <i ng-hide=\"vm.downloadingTemplate\" class=\"fa fa-file-excel-o\"></i>\n              <i ng-show=\"vm.downloadingTemplate\" class=\"fa fa-spinner fa-spin\"></i>\n              Download Excel Template\n            </button>\n            <div style=\"margin:30px auto;max-width:800px;\">\n              <upload-slot ng-model=\"vm.file\"\n                          ng-change=\"vm.uploadCSV(vm.file)\"\n                          slot-name=\"'csv'\"\n                          allow-image=\"true\"\n                          allow-video=\"false\"\n                          hide-stock-browse=\"true\"\n                          hide-recent-browse=\"true\"></upload-slot>\n            </div>\n          </div>\n        </div>\n      </div>\n\n\n\n      <div class=\"well\" ng-if=\"vm.file\">\n\n        <div class=\"row\">\n          <div class=\"col-xs-6 text-left\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.file = null\">\n              <i class=\"fa fa-caret-left\"></i>\n              Back\n            </button>\n          </div>\n          <div class=\"col-xs-6 text-right\" ng-if=\"vm.showConfirm\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.saveAll()\">Finalize Import</button>\n          </div>\n        </div>\n\n        <div class=\"bulk-import-progress-container\" ng-if=\"vm.showProgress\">\n          <div class=\"row {{vm.progress.upload}}\">\n            <div class=\"col-xs-6\">\n              <h1>Uploading</h1>\n            </div>\n            <div class=\"col-xs-6 text-right\">\n              <i class=\"fa fa-2x text-success fa-check\"></i>\n              <i class=\"fa fa-2x text-danger fa-warning\"></i>\n              <i class=\"fa fa-2x fa-spinner fa-spin\"></i>\n            </div>\n          </div>\n          <div class=\"row {{vm.progress.process}}\">\n            <div class=\"col-xs-6\">\n              <h1>Processing File</h1>\n            </div>\n            <div class=\"col-xs-6 text-right\">\n              <i class=\"fa fa-2x text-success fa-check\"></i>\n              <i class=\"fa fa-2x text-danger fa-warning\"></i>\n              <i class=\"fa fa-2x fa-spinner fa-spin\"></i>\n            </div>\n          </div>\n          <div class=\"row {{vm.progress.validate}}\">\n            <div class=\"col-xs-6\">\n              <h1>Validating</h1>\n            </div>\n            <div class=\"col-xs-6 text-right\">\n              <i class=\"fa fa-2x text-success fa-check\"></i>\n              <i class=\"fa fa-2x text-danger fa-warning\"></i>\n              <i class=\"fa fa-2x fa-spinner fa-spin\"></i>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.showErrors\">\n          <h4>Error Importing CSV</h4>\n          <p>\n            There were one or more errors with your import. Please correct the issues in your CSV file and\n            <a href=\"javascript://\" ng-click=\"vm.file = null\">try the upload again</a>.\n          </p>\n\n          <ul>\n            <li ng-repeat=\"e in vm.errors\">\n              <strong class=\"text-danger\">{{e.error}}</strong> (from CSV line {{e.rowIndex+1}})\n            </li>\n          </ul>\n        </div>\n\n        <div ng-if=\"vm.showSaveProgress\">\n          <h4>Finalizing Import</h4>\n          <p>Please wait while the broadcasts are imported.  This could take some time, but please do not close this page until the import is complete.</p>\n\n          <div style=\"margin:50px 0\">\n            <h1 class=\"text-center\">\n              <i class=\"fa fa-spinner fa-spin\"></i>\n              Saving broadcast {{vm.submittingIndex + 1}} of {{vm.broadcasts.length}}\n            </h1>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.showComplete\">\n          <h4>Import Complete</h4>\n          <p>{{vm.broadcasts.length}} broadcasts were successfully imported.</p>\n          <div style=\"margin:50px 0\" class=\"text-center\">\n            <h1>\n              <i class=\"fa fa-check-square\" style=\"font-size:200px;color:#1AA8A1\"></i>\n            </h1>\n            <p>\n              <a href=\"/\">Return to Dashboard</a>\n            </p>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.showConfirm\">\n          <h4>Confirm Broadcast Import</h4>\n          <p>\n            {{vm.broadcasts.length}} broadcasts are ready to be imported. Please confirm the list below, and then\n            click to finalize the import.\n          </p>\n\n          <h4>Additional Actions</h4>\n          <div style=\"margin-bottom:15px\">\n            <div ng-if=\"(vm.service.allowFacebookLive || vm.service.allowYoutubeLive || vm.service.allowGenericRtmpPush || vm.service.allowTwitter)\">\n              <div>\n                <span ng-click=\"vm.showSocial = !vm.showSocial\" style=\"cursor:pointer\">\n                  <i class=\"fa\" ng-class=\"vm.showSocial ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n                  Add Social Media Destinations to All Imported Broadcasts\n                </span>\n              </div>\n              <div class=\"well clearfix\" uib-collapse=\"vm.showSocial !== true\">\n                <div class=\"form-horizontal\">\n                  <simulcast-configuration-editor vm=\"vm\"></simulcast-configuration-editor>\n                </div>\n              </div>\n            </div>\n            <div>\n              <span ng-click=\"vm.showThumbnailPicker = !vm.showThumbnailPicker\" style=\"cursor:pointer\">\n                <i class=\"fa\" ng-class=\"vm.showThumbnailPicker ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n                Add Thumbnails to Each Broadcast\n              </span>\n            </div>\n          </div>\n\n          <h4>Preview Imported Broadcasts</h4>\n          <div style=\"max-width:100%;max-height:calc(50vh);overflow:scroll;border:1px solid #ddd;\">\n            <table class=\"table table-condensed table-striped\">\n              <thead>\n                <tr>\n                  <th ng-if=\"vm.showThumbnailPicker\">Thumbnail</th>\n                  <th>Name</th>\n                  <th>Date/Time</th>\n                  <th>Accessibility</th>\n                  <th>Source</th>\n                  <th>Channels</th>\n                  <th ng-if=\"vm.service.showAnyScoreboards\">Sport/Scoreboard</th>\n                  <th ng-if=\"vm.showTeams\">Home</th>\n                  <th ng-if=\"vm.showTeams\">Home Color</th>\n                  <th ng-if=\"vm.showTeams\">Away</th>\n                  <th ng-if=\"vm.showTeams\">Away Color</th>\n                  <th>Advanced</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"b in vm.broadcasts track by $index\">\n                  <td ng-if=\"vm.showThumbnailPicker\" style=\"width:175px\">\n                    <div ng-if=\"b.content_settings.preview\" class=\"text-center\">\n                      <img ng-src=\"{{b.content_settings.preview | trustedUrl}}\" class=\"img\" style=\"max-width:100%\">\n                      <div><a href ng-click=\"b.content_settings.preview = null\">Change</a></div>\n                    </div>\n                    <div ng-if=\"!b.content_settings.preview\">\n                      <upload-slot ng-model=\"vm.thumbnails[$index]\"\n                                   ng-change=\"vm.uploadThumbnail($index)\"\n                                   slot-name=\"'preview'\"\n                                   allow-image=\"true\"\n                                   allow-video=\"false\"\n                                   compact=\"true\"></upload-slot>\n                    </div>\n                  </td>\n                  <td>\n                    {{b.name}}\n                    <div ng-show=\"b.description\" style=\"font-size:8pt;max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;\">{{b.description}}</></div>\n                  </td>\n                  <td><date-range start=\"b.starts_at\" end=\"b.stops_at\"></date-range></td>\n                  <td>\n                    <span ng-if=\"b.is_ticketed\" class=\"label label-success\">${{b.ticket_price | number:2}} / ticket</span>\n                    <span ng-if=\"b.is_private\" class=\"label label-danger\">Private</span>\n                    <span ng-if=\"!b.is_ticketed && !b.is_private\" class=\"label label-default\">Public</span>\n                  </td>\n                  <td>{{b | streamSourceName}}</td>\n                  <td>{{b.__channel_name__}}</td>\n                  <td ng-if=\"vm.service.showAnyScoreboards\">\n                    <div ng-if=\"b.sport\">{{b.sport}}</div>\n                    <div ng-if=\"b.scoreboard_make\">\n                      {{b.scoreboard_make}} - {{b.scoreboard_model}}\n                      <span ng-if=\"b.overlay_location\">({{b.overlay_location}})</span>\n                    </div>\n                  </td>\n                  <td ng-if=\"vm.showTeams\">{{b.home_team_name}}</td>\n                  <td ng-if=\"vm.showTeams\"><boxcast-color-picker ng-model=\"b.home_team_logo\"></boxcast-color-picker></td>\n                  <td ng-if=\"vm.showTeams\">{{b.away_team_name}}</td>\n                  <td ng-if=\"vm.showTeams\"><boxcast-color-picker ng-model=\"b.away_team_logo\"></boxcast-color-picker></td>\n                  <td>\n                    <span ng-if=\"b.target_video_resolution != 'default'\">\n                      {{b.target_video_resolution}}p\n                    </span>\n                    <span ng-if=\"b.target_high_frame_rate === true\">\n                      (up to 60 FPS) \n                    </span>\n                    <span ng-if=\"b.target_high_frame_rate === false\">\n                      (up to 30 FPS) \n                    </span>\n                    <span ng-if=\"b.requests_captioning === true\">\n                      Automated Captioning\n                    </span>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div><!--/end overflow-x:scroll-->\n\n          <p class=\"text-center\" style=\"margin: 30px 0\">\n            <button type=\"button\" class=\"btn btn-lg btn-block btn-primary\" ng-click=\"vm.saveAll()\">Finalize Import</button>\n          </p>\n\n        </div><!--/end showConfirm-->\n\n      </div><!--/end .well-->\n\n    </div>\n</main>\n"

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BulkImportController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_pricing__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_download__ = __webpack_require__(26);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var MAX_IMPORT_RECORDS = 1000;

var BulkImportController = /*#__PURE__*/function () {
  function BulkImportController($timeout, $rootScope, $http, EditOrCreateEventService, Facebook, toaster) {
    'ngInject';

    _classCallCheck(this, BulkImportController);

    var ApiConfig = $rootScope.ApiConfig;
    this.$timeout = $timeout;
    this.$http = $http;
    this.toaster = toaster;
    this.service = EditOrCreateEventService.getInstance();
    this.service.initBroadcast();
    this.service.bulkImportMode = true;
    this.fb = Facebook;
    this.fb.init();
    this.validSports = ApiConfig.stream.sports.map(function (s) {
      return s.value;
    });
  }

  _createClass(BulkImportController, [{
    key: "loginFacebook",
    value: function loginFacebook() {
      this.fb.login();
    }
  }, {
    key: "logoutFacebook",
    value: function logoutFacebook() {
      var _this = this;

      this.fb.logout().then(function () {
        return _this.fb.init();
      });
    }
  }, {
    key: "downloadTemplate",
    value: function downloadTemplate() {
      var _this2 = this;

      var $http = this.$http;
      this.downloadingTemplate = true;
      $http.get("".concat(API_ROOT, "/account/broadcast_import_template"), {
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this2.downloadingTemplate = false;
        console.log('loaded template', response);
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_download__["a" /* forceBrowserDownload */])(URL.createObjectURL(blob), 'broadcast_import.xlsx');
      })["catch"](function (data, status) {
        _this2.downloadingTemplate = false;
        console.error('Error loading template', data, status);
        alert('Unable to download template. Please refresh your browser and try again. For best results, try using Google Chrome.');
      });
    }
  }, {
    key: "uploadThumbnail",
    value: function uploadThumbnail(index) {
      var file = this.thumbnails[index];
      var broadcast = this.broadcasts[index];
      file.upload().then(function (result) {
        broadcast.content_settings = broadcast.content_settings || {};
        broadcast.content_settings.preview = result.view_url;
        broadcast.content_settings.poster = result.view_url;
      });
    }
  }, {
    key: "uploadCSV",
    value: function uploadCSV(result) {
      var _this3 = this;

      var $timeout = this.$timeout;
      this.errors = [];
      this.broadcasts = [];
      this.progress = {
        upload: 'todo',
        process: 'todo',
        validate: 'todo'
      };
      this.showProgress = true;
      this.showErrors = false;
      this.showConfirm = false;
      var r = new FileReader();

      r.onload = function (e) {
        $timeout(function () {
          _this3.progress.upload = 'complete';

          _this3.parseFile(e.target.result);
        }, 100);
      };

      r.oneror = function (e) {
        $timeout(function () {
          _this3.progress.upload = 'error';
        }, 0);
      };

      r.readAsText(result.file);
    }
  }, {
    key: "parseFile",
    value: function parseFile(fileContents) {
      var _this4 = this;

      var $timeout = this.$timeout;
      this.fileContents = fileContents;
      this.rows = CSVToListOfDicts(this.fileContents);
      this.errors = [];
      this.broadcasts = [];
      this.thumbnails = {};
      this.showTeams = false;
      this.rows.forEach(function (r, i) {
        try {
          _this4.broadcasts.push(_this4.validateAndTransform(r));
        } catch (e) {
          _this4.errors.push({
            row: r,
            rowIndex: i,
            error: e.toString()
          });
        }
      });

      if (this.broadcasts.length > MAX_IMPORT_RECORDS) {
        this.errors.push({
          row: {},
          rowIndex: MAX_IMPORT_RECORDS,
          error: "A maximum of ".concat(MAX_IMPORT_RECORDS, " imported broadcasts are supported. Please remove some from your import file and try again.")
        });
      } // Artificial delays to make it look like we're working hard


      $timeout(function () {
        return _this4.progress.process = 'complete';
      }, 1000);
      $timeout(function () {
        if (_this4.errors.length) {
          _this4.progress.validate = 'error';
          $timeout(function () {
            _this4.showErrors = true;
            _this4.showProgress = false;
          }, 1000);
        } else {
          _this4.progress.validate = 'complete';
          $timeout(function () {
            _this4.showConfirm = true;
            _this4.showProgress = false;
          }, 1000);
        }
      }, 2500);
    }
  }, {
    key: "validateAndTransform",
    value: function validateAndTransform(r) {
      var b = {
        id: Math.random(),
        //<-- required for ng-repeat unique key
        content_settings: {},
        simulcast_configurations: [],
        do_not_record: this.service.account.feature_flags.no_recordings
      };
      this.service.broadcast = b; //<-- later methods have mutations that occur here
      // Map CSV field names to broadcast fields

      b.name = r.Name;
      if (!b.name) throw 'Name is required';
      b.description = r.Description; // Date/Time handling (note the actual saving process does more validation)

      b.startDate = this.service.startDate = moment(r['Date']).toDate();
      if (!r['Date'] || !b.startDate || isNaN(b.startDate.getTime())) throw "A valid, future start date is required. Please verify the date format in your CSV file.";
      b.startTime = this.service.startTime = parseTime(r['Start Time']);
      if (!b.startTime) throw "Invalid start time ".concat(startTime);
      b.endTime = this.service.endTime = parseTime(r['End Time']);
      if (!b.endTime) throw "Invalid end time ".concat(endTime);
      var dates = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(b.startDate, b.startTime, b.endTime, this.service.maxBroadcastDurationHours);
      b.starts_at = dates.starts_at;
      b.stops_at = dates.stops_at;

      if (moment(b.starts_at).toDate() < new Date()) {
        throw "A valid, future start date and time is required";
      }

      if (!this.service.isWithinAccountBroadcastDurationLimit) {
        throw "You are not allowed to stream for longer than ".concat(this.service.maxBroadcastDurationHours, " hours");
      } // Source handling (note that the actual saving process sets stream_source, etc)


      var s = r['Source'];

      var box = _.find(this.service.boxcasters, {
        name: s
      });

      var staticRtmp = _.find(this.service.staticRTMPs, {
        name: s
      });

      if (s == 'BoxCast Broadcaster (iOS)') {
        b.boxcaster_id = 'stream_source:app';
      } else if (box != null) {
        b.boxcaster_id = box.id;
        b.boxcaster_name = box.name;
      } else if (staticRtmp != null) {
        b.boxcaster_id = "stream_source:rtmp:".concat(staticRtmp.id);
      } else if (s == 'Producer') {
        b.boxcaster_id = 'stream_source:producer';
      } else {
        throw "Source ".concat(s, " not found");
      }

      this.service.explodeStreamSourceSettings(b); // Accessibility and Ticketing

      var t = r['Broadcast Type'];
      b.visibility = {
        'Private/Test': 'private',
        Public: 'public',
        'Flex (Ticketed HD)': 'flex',
        Ticketed: 'ticketed'
      }[t];
      if (!b.visibility) throw "Broadcast type ".concat(t, " invalid");
      b.ticket_price = parseFloat((r['Ticket Price'] || '').replace('$', ''), 10);

      if (b.visibility == 'ticketed' || b.visibility == 'flex') {
        if (isNaN(b.ticket_price) || b.ticket_price < this.service.minTicketPrice) {
          throw "Minimum ticket price is $".concat(this.service.minTicketPrice);
        }
      } else if (b.ticket_price) {
        throw "A ticket price should not be set on non-ticketed broadcasts";
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils_pricing__["b" /* updatePriceSettingsFromVisibilityOption */])(b, b.visibility); // Channel handling

      var c = r['Channels'];

      if (c) {
        var channel = _.find(this.service.channels, {
          name: c
        });

        if (!channel) throw "Channel ".concat(c, " not found");
        b.in_channel_ids = [channel.id];
        b.__channel_name__ = channel.name; //for display purposes on confirm screen
      } // Advanced Settings


      b.target_video_resolution = 'default';

      if (r['Video Resolution']) {
        b.target_video_resolution = parseInt(r['Video Resolution'], 10);

        if (!_.find(this.service.videoResolutions, {
          value: b.target_video_resolution
        })) {
          throw "Invalid video resolution ".concat(this.b.target_video_resolution);
        }
      }

      b.target_high_frame_rate = 'default';

      if ((r['High Frame Rate'] || '').toUpperCase() == 'YES') {
        b.target_high_frame_rate = true;
      } else if ((r['High Frame Rate'] || '').toUpperCase() == 'NO') {
        b.target_high_frame_rate = false;
      }

      if (this.service.account.feature_flags.automated_captioning || this.service.account.feature_flags.live_automated_captioning) {
        b.requests_captioning = this.service.account.content_settings.requestsCaptioning;
      } // Scoreboard


      if (r['Sport']) {
        if (this.validSports.includes(r['Sport'])) {
          b.sport = r['Sport'];
        } else {
          throw "".concat(r['Sport'], " is an invalid sport option");
        }
      }

      if (r['Scoreboard']) {
        this.service.scoreboards.forEach(function (s) {
          if (r['Scoreboard'].startsWith(s.value)) {
            b.scoreboard_make = s.value;
            s.models.forEach(function (m) {
              if (r['Scoreboard'].endsWith(m.value)) {
                b.scoreboard_model = m.value;
              }
            });
          }
        });

        if (!b.scoreboard_make || !b.scoreboard_model) {
          throw "Invalid scoreboard ".concat(r['Scoreboard']);
        }
      }

      b.overlay_location = (r['Scoreboard Location'] || '').toLowerCase();
      b.sportzcast_bot_number = r['SportzCast ScoreBOT Number'];
      b.home_team_name = r['Home Team Name'];

      if (b.home_team_name) {
        b.home_team_logo = this.service.accountScoreboard.home_team_logo;
      }

      b.away_team_name = r['Away Team Name']; // Expose home/away color picker if *any* record has a team name defined

      if (b.scoreboard_make || b.home_team_name || b.away_team_name) {
        this.showTeams = true;
      }

      return b;
    }
  }, {
    key: "addSimulcastDestination",
    value: function addSimulcastDestination(d) {
      return this.service.addSimulcastDestination(d);
    }
  }, {
    key: "removeSimulcastDestination",
    value: function removeSimulcastDestination(d) {
      return this.service.removeSimulcastDestination(d);
    }
  }, {
    key: "saveAll",
    value: function saveAll() {
      this.showSaveProgress = true;
      this.showConfirm = false;
      this.__sharedSimulcastConfigurations = angular.copy(this.service.broadcast.simulcast_configurations || []);
      this.submittingIndex = 0;

      try {
        this.workSaveQueue();
      } catch (e) {
        console.error(e);
        this.toaster.pop('warning', 'There was an error saving the broadcast. Please refresh and try again after verifying which broadcasts were created.');
      }
    }
  }, {
    key: "workSaveQueue",
    value: function workSaveQueue(i) {
      var _this5 = this;

      if (this.submittingIndex >= this.broadcasts.length) {
        this.showSaveProgress = false;
        this.showComplete = true;
        console.log('Completed all save operations');
        return;
      }

      var b = angular.copy(this.broadcasts[this.submittingIndex]);
      b.simulcast_configurations = this.__sharedSimulcastConfigurations;
      console.log('Saving', b);
      this.service.broadcast = b; // Derived value things

      this.service.visibility = b.visibility;
      this.service.startDate = b.startDate;
      this.service.startTime = b.startTime;
      this.service.endTime = b.endTime;
      this.service.compensateEndDate();

      if (this.service.showAnyScoreboards) {
        this.service.broadcast.scoreboard_configuration = {
          sport: b.sport,
          scoreboard_make: b.scoreboard_make,
          scoreboard_model: b.scoreboard_model,
          overlay_location: b.overlay_location,
          home_team_name: b.home_team_name,
          home_team_logo: b.home_team_logo,
          away_team_name: b.away_team_name,
          away_team_logo: b.away_team_logo,
          sportzcast_bot_number: b.sportzcast_bot_number
        };
      }

      delete b.id;
      this.service.saveChanges(true, true).then(function () {
        console.log('Saved!');
        _this5.submittingIndex++;

        _this5.workSaveQueue();
      })["catch"](function (e) {
        console.error('Error saving', e);
        _this5.submittingIndex++;

        _this5.workSaveQueue();
      });
    }
  }]);

  return BulkImportController;
}();



function CSVToListOfDicts(data) {
  var result = [];
  var arr = CSVToArray(data);

  if (arr.length < 2) {
    return result;
  }

  var keyIndex = arr[0];

  for (var i = 1; i < arr.length; i++) {
    if (!_.filter(arr[i]).length) {
      continue;
    }

    var row = {};
    arr[i].forEach(function (v, j) {
      row[keyIndex[j]] = v;
    });
    result.push(row);
  }

  return result;
} // ref: http://stackoverflow.com/a/1293163/2343
// This will parse a delimited string into an array of arrays.


function CSVToArray(data) {
  var delimiter = ',';
  var reQuotedValue = new RegExp('""', 'g');
  var rePattern = new RegExp( // Delimiters.
  '(\\' + delimiter + '|\\r?\\n|\\r|^)' + // Quoted fields.
  '(?:"([^"]*(?:""[^"]*)*)"|' + // Standard fields.
  '([^"\\' + delimiter + '\\r\\n]*))', 'gi'); // Create an array to hold our data. Give the array
  // a default empty first row.

  var arrData = [[]]; // Create an array to hold our individual pattern
  // matching groups.

  var arrMatches = null; // Keep looping over the regular expression matches
  // until we can no longer find a match.

  while (arrMatches = rePattern.exec(data)) {
    // Get the delimiter that was found.
    var matchedDelimiter = arrMatches[1]; // Check to see if the given delimiter has a length
    // (is not the start of string) and if it matches
    // field delimiter. If id does not, then we know
    // that this delimiter is a row delimiter.

    if (matchedDelimiter.length && matchedDelimiter !== delimiter) {
      // Since we have reached a new row of data,
      // add an empty row to our data array.
      arrData.push([]);
    }

    var matchedValue; // Now that we have our delimiter out of the way,
    // let's check to see which kind of value we
    // captured (quoted or unquoted).

    if (arrMatches[2]) {
      // We found a quoted value. When we capture
      // this value, unescape any double quotes.
      matchedValue = arrMatches[2].replace(reQuotedValue, '"');
    } else {
      // We found a non-quoted value.
      matchedValue = arrMatches[3];
    } // Now that we have our value string, let's add
    // it to the data array.


    arrData[arrData.length - 1].push(matchedValue);
  } // Return the parsed data.


  return arrData;
}

function parseTime(timeStr, dt) {
  if (!dt) {
    dt = new Date();
  }

  var time = timeStr.match(/(\d+)(?::(\d\d))?\s*(p?)/i);

  if (!time) {
    return NaN;
  }

  var hours = parseInt(time[1], 10);

  if (hours == 12 && !time[3]) {
    hours = 0;
  } else {
    hours += hours < 12 && time[3] ? 12 : 0;
  }

  dt.setHours(hours);
  dt.setMinutes(parseInt(time[2], 10) || 0);
  dt.setSeconds(0, 0);
  return dt;
}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__caption_editor_html__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__caption_editor_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__caption_editor_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__caption_editor_controller__ = __webpack_require__(406);



var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('caption-editor', __WEBPACK_IMPORTED_MODULE_1__caption_editor_html___default.a, __WEBPACK_IMPORTED_MODULE_2__caption_editor_controller__["a" /* default */], 'CaptionEditorController', '/caption-editor/:broadcastId');

__webpack_require__(408); //<-- require *After* we create angular module above


/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "<style>\n.btn-transparent {\n  border: none;\n  background: none;\n  box-shadow: none;\n  margin: 0;\n  padding: 0;\n}\n</style>\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n\n  <div class=\"row\" style=\"margin-bottom:15px\">\n    <div class=\"col-sm-4\">\n      <a ui-sref=\"events.detail({id: vm.id, tab: 'captions'})\" class=\"btn btn-default\">\n        <i class=\"fa fa-caret-left\"></i>\n        Back to Broadcast Details\n      </a>\n    </div>\n    <div class=\"col-sm-8 text-right\">\n      <div ng-if=\"vm.captionMeta\">\n        <span ng-if=\"vm.captionMeta.failure_reason\" class=\"label label-danger\">Failed: {{vm.captionMeta.failure_reason}}</span>\n        <span class=\"label label-default\">{{vm.captionMeta.publish_status|unslugify}}</span>\n        <span class=\"label label-default\">Updated: {{vm.captionMeta.updated_at|date:'short'}}</span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\" ng-if=\"vm.broadcast.timeframe != 'past'\">\n    <p class=\"text-center\">\n      Captioning is only supported for recorded broadcasts.\n    </p>\n  </div>\n\n  <div class=\"row text-center\" ng-if=\"vm.broadcast.timeframe == 'past' && (vm.captionMeta||{}).status != 'completed'\">\n    <caption-details caption-meta=\"vm.captionMeta\" on-create=\"vm.startCaptioning(upload)\"></caption-details>\n  </div>\n\n\n  <div class=\"row\" ng-if=\"vm.captionMeta.status == 'completed'\">\n\n    <div class=\"col-xs-8\">\n\n      <div class=\"panel caption-table\" style=\"margin-bottom:0; background:transparent;\">\n        <div class=\"caption-table--header\">\n          <div class=\"row\">\n            <div class=\"col-xs-1\">Start</div>\n            <div class=\"col-xs-1\">Stop</div>\n            <div class=\"col-xs-10\">\n              <div class=\"pull-right\" ng-show=\"vm.canEdit\">\n                <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\n                  <button tabindex=\"-1\" id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-transparent\" uib-dropdown-toggle>\n                    <i class=\"fa fa-cog\" style=\"border:none;color:#fff;\"></i>\n                  </button>\n                  <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\n                    <li role=\"menuitem\">\n                      <a href=\"javascript://\" ng-click=\"vm.mode = (vm.mode == 'full' ? 'review' : 'full')\">\n                        <i ng-show=\"vm.mode == 'review'\" class=\"fa fa-check\" style=\"margin:0 5px 0 -15px;font-size:8pt;width:6px;line-height:17px;\"></i>\n                        Review Low-Confidence Cues\n                      </a>\n                    </li>\n                    <li role=\"menuitem\">\n                      <a href=\"javascript://\" ng-click=\"vm.timestampEdit = !vm.timestampEdit\">\n                        <i ng-show=\"vm.timestampEdit\" class=\"fa fa-check\" style=\"margin:0 5px 0 -15px;font-size:8pt;width:6px;line-height:17px;\"></i>\n                        Allow Timestamp Editing\n                      </a>\n                    </li>\n                    <li ng-if=\"vm.captionMeta.publish_status != 'publishing'\" role=\"menuitem\">\n                      <a href=\"javascript://\" ng-click=\"vm.showReplaceCaptions = true\">Replace Captions with WebVTT File</a>\n                    </li>\n                    <li role=\"menuitem\"><a href=\"javascript://\" ng-click=\"vm.findAndReplace()\">Find and Replace...</a></li>\n                  </ul>\n                </div>\n              </div>\n              Caption\n            </div>\n          </div>\n        </div>\n        <div class=\"caption-table-scroll\">\n          <div vs-repeat=\"{\n                  scrollParent: '.caption-table-scroll',\n                  scrollMargin: 200,\n                }\">\n            <div ng-repeat=\"c in vm.captions | filter : vm.filterByConfidenceMode\"\n                 id=\"caption--index-{{c.absoluteIndex}}\"\n                 class=\"row caption--row\"\n                 ng-class=\"{\n                   'caption--low-confidence': (c.confidence < vm.CONFIDENCE_THRESHOLD),\n                   'caption--playback-active': (c.absoluteIndex === vm.activeCaptionIndex)\n                 }\"\n                 >\n              <div class=\"col-xs-12 text-center\" ng-if=\"c.type == 'silence'\">\n                <small style=\"color:#ccc\" ng-if=\"!c.isLast\">... no captions ...</small>\n                <small ng-if=\"c.isLast\">\n                  <a href=\"javascript://\" ng-click=\"vm.insertCueAfter(c.absoluteIndex - 1)\">Insert Cue</a>\n                </small>\n              </div>\n              <div ng-if=\"c.type == 'cue'\" >\n                <div class=\"col-xs-1 no-padding caption--start\">\n                  <span ng-show=\"(c.timestampEdit || vm.timestampEdit) && vm.canEdit\">\n                    <input type=\"text\" ng-model=\"c.start_time_fmt\" ng-change=\"vm.onChangeTime(c)\" ng-model-options=\"{getterSetter: true, updateOn: 'blur'}\" style=\"max-width:100%\">\n                  </span>\n                  <span ng-hide=\"(c.timestampEdit || vm.timestampEdit) && vm.canEdit\">{{c.start_time_fmt.replace('.000','.0')}}</span>\n                </div>\n                <div class=\"col-xs-1 no-padding caption--stop\">\n                  <span ng-show=\"(c.timestampEdit || vm.timestampEdit) && vm.canEdit\">\n                    <input type=\"text\" ng-model=\"c.end_time_fmt\" ng-change=\"vm.onChangeTime(c)\" ng-model-options=\"{getterSetter: true, updateOn: 'blur'}\" style=\"max-width:100%\">\n                  </span>\n                  <span ng-hide=\"(c.timestampEdit || vm.timestampEdit) && vm.canEdit\">{{c.end_time_fmt.replace('.000','.0')}}</span>\n                </div>\n                <div class=\"col-xs-9 caption--text\" >\n                  <textarea rows=\"2\" type=\"text\" ng-model=\"c.text\" ng-change=\"vm.onEditCaption(c)\" ng-disabled=\"!vm.canEdit\"></textarea>\n                </div>\n                <div class=\"col-xs-1 no-padding caption--actions text-right\" style=\"white-space:nowrap\">\n                  <button type=\"button\" tabindex=\"-1\" class=\"btn btn-transparent\" ng-click=\"vm.player.pause()\" ng-show=\"c.absoluteIndex == vm.activeCaptionIndex && vm.isPlayerPlaying\">\n                    <i class=\"fa fa-pause\"></i>\n                  </button>\n                  <button type=\"button\" tabindex=\"-1\" class=\"btn btn-transparent\" ng-click=\"vm.play(c)\" ng-hide=\"c.absoluteIndex == vm.activeCaptionIndex && vm.isPlayerPlaying\">\n                    <i class=\"fa fa-play\"></i>\n                  </button>\n                  <div class=\"btn-group\" uib-dropdown dropdown-append-to-body ng-show=\"vm.canEdit\">\n                    <button tabindex=\"-1\" id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-transparent\" uib-dropdown-toggle>\n                      <i class=\"fa fa-ellipsis-h\"></i>\n                    </button>\n                    <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\n                      <li role=\"menuitem\" ng-if=\"!(c.timestampEdit || vm.timestampEdit)\"><a href=\"javascript://\" ng-click=\"c.timestampEdit = true\">Edit Start/Stop Times</a></li>\n                      <li role=\"menuitem\" ng-if=\"vm.canInsertBeforeCue(c.absoluteIndex)\">\n                        <a href=\"javascript://\" ng-click=\"vm.insertCueBefore(c.absoluteIndex)\">Insert Cue Before</a>\n                      </li>\n                      <li role=\"menuitem\" ng-if=\"vm.canInsertAfterCue(c.absoluteIndex)\">\n                        <a href=\"javascript://\" ng-click=\"vm.insertCueAfter(c.absoluteIndex)\">Insert Cue After</a>\n                      </li>\n                      <li role=\"menuitem\" ng-if=\"c.confidence < vm.CONFIDENCE_THRESHOLD\"><a href=\"javascript://\" ng-click=\"c.confidence = 1.0 && vm.onEditCaption(c)\">Mark Accurate</a></li>\n                      <li role=\"menuitem\"><a href=\"javascript://\" ng-click=\"vm.deleteCue(c.absoluteIndex)\">Delete Cue</a></li>\n                    </ul>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div><!--/panel-->\n\n    </div>\n\n    <div class=\"col-xs-4\">\n      <div ng-if=\"vm.playerOptions\">\n          <div style=\"position:relative\">\n            <boxcast-player channel-id=\"vm.broadcast.channel_id\" options=\"vm.playerOptions\"></boxcast-player>\n\n            <div class=\"caption--preview\" ng-show=\"vm.activeCaptionIndex !== null && vm.captions[vm.activeCaptionIndex].text\">\n              <span>{{vm.captions[vm.activeCaptionIndex].text}}</span>\n            </div>\n          </div>\n      </div>\n      <div ng-if=\"vm.cuesDirty || vm.captionMeta.publish_status == 'unpublished'\" style=\"margin-top:15px;\">\n        <button type=\"button\" class=\"btn btn-lg btn-primary btn-block\"\n                ng-disabled=\"vm.saving\"\n                ng-click=\"vm.save()\">\n          <i class=\"fa fa-spin fa-spinner\" ng-show=\"vm.saving\"></i>\n          Publish {{vm.captionMeta.publish_status == 'published' ? 'Changes' : ''}}\n        </button>\n      </div>\n      <div ng-if=\"vm.captionMeta.publish_status == 'publishing'\" style=\"margin-top:15px;\">\n        <div class=\"bg-info text-info\" style=\"padding:10px; border:1px solid\">\n          <i class=\"fa fa-spin fa-spinner\"></i>\n          The captions are being published. Note that you cannot make further edits until publishing is complete.\n        </div>\n      </div>\n      <div ng-if=\"vm.recordingIsTrimmed\" class=\"help-block\" style=\"margin-top:15px;\">\n        <i class=\"fa fa-info-circle\" style=\"width:15px;\"></i>\n        The caption editor is currently showing the complete recorded broadcast, but the published version will still be trimmed.\n      </div>\n\n      <div style=\"margin-top:15px;\">\n        <div ng-if=\"vm.showReplaceCaptions\" class=\"well\" style=\"margin-top:15px;\">\n          <div class=\"row\">\n            <div class=\"col-sm-12\">\n              <div class=\"caption-upload-cell\" style=\"margin:0 auto; max-width:300px\">\n                <upload-slot ng-model=\"vm.captionFile\"\n                            ng-change=\"vm.uploadCaption(vm.captionFile)\"\n                            slot-name=\"'caption'\"\n                            allow-image=\"false\"\n                            allow-video=\"false\"\n                            hide-stock-browse=\"true\"\n                            hide-recent-browse=\"true\"\n                            compact=\"true\"></upload-slot>\n              </div>\n            </div>\n            <div class=\"col-sm-12\">\n              <p ng-hide=\"vm.uploadWebVTT\" class=\"help-block\" style=\"margin:15px 0\">\n                WebVTT caption files generated from other services and tools may be uploaded to BoxCast.\n                <a href=\"https://support.boxcast.com/en/articles/4235125\" target=\"_blank\">Learn More</a>\n              </p>\n              <div ng-show=\"vm.uploadWebVTT && vm.uploadWebVTT.errors.length\">\n                <h4>Error Processing WebVTT File</h4>\n                <ul class=\"text-left text-danger\">\n                  <li ng-repeat=\"e in vm.uploadWebVTT.errors\">{{e.message}} (line {{e.line}}, col {{e.col}})</li>\n                </ul>\n              </div>\n              <div ng-show=\"vm.uploadWebVTT && !vm.uploadWebVTT.errors.length\">\n                <h4>Review WebVTT Upload</h4>\n                <textarea class=\"form-control\" rows=\"15\" style=\"font-size:8pt;font-family:monospace\" readonly>{{vm.uploadWebVTTText}}</textarea>\n              </div>\n            </div>\n          </div>\n          <div style=\"margin-top:15px\" ng-if=\"vm.uploadWebVTT && vm.uploadWebVTT.cues.length && !vm.uploadWebVTT.errors.length\">\n            <button ng-click=\"vm.saveUploadedCaptions(vm.uploadWebVTT)\" type=\"button\" class=\"btn btn-lg btn-primary\">\n              Replace Captions with Upload\n            </button>\n          </div>\n        </div>\n      </div>\n\n    </div>\n\n  </div><!--/row-->\n\n</main>\n"

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CaptionEditorController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_caption__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__webvtt_parser__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_date__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var CAPTION_RELOAD_INTERVAL_MS = 10000;
var CAPTION_SILENCE_NOTIFY_GAP = 5.0;
var CAPTION_MIN_GAP_TO_INSERT = 1.0;

function scrollToElementInsideContainer(el, container) {
  if (container && el) {
    container.scrollTop = el.offsetTop; // TODO: try to align in center of viewport
  }
}

var CaptionEditorController = /*#__PURE__*/function () {
  function CaptionEditorController($state, $timeout, $scope, Broadcast, Caption, Recording, toaster) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, CaptionEditorController);

    this.$state = $state;
    this.$timeout = $timeout;
    this.Broadcast = Broadcast;
    this.Caption = Caption;
    this.toaster = toaster;
    this.CONFIDENCE_THRESHOLD = 0.4;
    this.id = $state.params.broadcastId;
    this.broadcast = Broadcast.get({
      id: this.id
    }, function (b) {
      return _this.recording = Recording.get({
        id: b.recording_id
      });
    }, function (e) {
      return toaster.pop('warning', 'Unable to load broadcast');
    });
    var promise = this.broadcast.$promise.then(function () {
      return _this.safeReloadCaptions();
    }).then(function () {
      return _this.onLoadComplete();
    })["catch"](function (e) {
      console.error(e);
    });
    this.caption = {};
    this.mode = 'full';

    this.filterByConfidenceMode = function (cue) {
      if (_this.mode == 'full') {
        return true;
      } else {
        return cue.originalConfidence < 0.4;
      }
    };

    this.loadingPromises = [promise];
    $scope.$on('$destroy', function () {
      $timeout.cancel(_this.captionReloadHandle);
    });
  }

  _createClass(CaptionEditorController, [{
    key: "progress",
    get: function get() {
      if (!this.captionMeta) return 0;
      var _this$captionMeta = this.captionMeta,
          status = _this$captionMeta.status,
          publish_status = _this$captionMeta.publish_status;
      if (status == 'failed') return 0;
      if (status == 'requested') return 10;
      if (status == 'processing_audio') return 20;
      if (status == 'transcribing') return 30;
      if (status == 'processing_transcription') return 80;
      if (status == 'completed' && publish_status == 'unpublished') return 90;
      if (status == 'completed' && publish_status == 'publishing') return 95;
      return 100;
    }
  }, {
    key: "canEdit",
    get: function get() {
      if (this.saving) return false;
      if (this.captionMeta.publish_status == 'publishing') return false;
      return true;
    }
  }, {
    key: "cuesDirty",
    get: function get() {
      return this._cuesDirty;
    },
    set: function set(val) {
      this.$state.current.confirmOnExit = val;
      this._cuesDirty = val;
    }
  }, {
    key: "recordingIsTrimmed",
    get: function get() {
      if (!this.recording) return false;
      var r = this.recording;
      return r.start_seconds != '' && r.start_seconds != 0 || r.stop_seconds != '' && r.stop_seconds != r.duration_seconds;
    }
  }, {
    key: "onLoadComplete",
    value: function onLoadComplete() {
      var _this2 = this;

      var $timeout = this.$timeout;
      this.activeCaptionIndex = null;

      var updateActiveCaption = function updateActiveCaption(currentTime) {
        for (var i = 0; i < _this2.captions.length; i++) {
          var c = _this2.captions[i];

          if (c.start_time <= currentTime && c.end_time >= currentTime) {
            _this2.activeCaptionIndex = i;
            return;
          }

          if (c.start_time > currentTime) {
            _this2.activeCaptionIndex = null;
            return;
          }
        }
      };

      var updateActiveCaptionDebounced = _.throttle(updateActiveCaption, 500);

      this.playerOptions = {
        alwaysShowMediaControl: true,
        onPlayerStateChanged: function onPlayerStateChanged(eventName, arg) {
          $timeout(function () {
            _this2.isPlayerPlaying = eventName == 'play';

            if (eventName == 'seek') {
              updateActiveCaption(arg);

              if (_this2.__avoidNextAutoSeek) {
                _this2.__avoidNextAutoSeek = false;
              } else {
                scrollToElementInsideContainer($("#caption--index-".concat(_this2.activeCaptionIndex))[0], $('.caption-table-scroll')[0]);
              }
            } else {
              updateActiveCaption(_this2.player.getCurrentTime());
            }
          }, 0);
        },
        onTimeUpdate: function onTimeUpdate(t) {
          $timeout(function () {
            return updateActiveCaptionDebounced(t);
          }, 0);
        },
        onLoadPlayer: function onLoadPlayer(player) {
          _this2.player = player; // Disable caption plugin since captions will always be displayed.

          _.each(_this2.player.core.plugins, function (p) {
            if (p.name === 'closed_captions') {
              p.disable();
            }
          });
        },
        trimSeconds: {
          start: 0,
          stop: 365 * 24 * 60 * 60
        }
      };
    }
  }, {
    key: "onEditCaption",
    value: function onEditCaption(c) {
      this.cuesDirty = true;
      c.confidence = 1.0;
    }
  }, {
    key: "startCaptioning",
    value: function startCaptioning() {
      var _this3 = this;

      var upload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var Caption = this.Caption,
          toaster = this.toaster;
      this.saving = true;
      var data = {
        source: 'on-demand'
      };

      if (upload != null) {
        data = {
          source: 'uploaded',
          status: 'complete',
          cues: upload.cues.map(function (c) {
            return {
              start_time: c.startTime,
              end_time: c.endTime,
              text: c.text,
              confidence: 1.0
            };
          })
        };
      }

      Caption.create({
        broadcast_id: this.id
      }, data).$promise.then(function () {
        _this3.saving = false;
        toaster.pop('success', 'Successfully started captioning.');

        _this3.safeReloadCaptions();
      })["catch"](function (err) {
        _this3.saving = false;
        toaster.pop('warning', 'Unable to start captioning. Please refresh and try again.');
        console.error(err);
      });
    }
  }, {
    key: "save",
    value: function save() {
      var _this4 = this;

      var Caption = this.Caption,
          toaster = this.toaster; // Process the UI representation of the cues

      var cuesToSave = angular.copy(this.captions).filter(function (c) {
        return c.type == 'cue';
      });
      var data = {
        publish_status: 'publishing',
        cues: cuesToSave
      };
      this.saving = true;
      Caption.update({
        broadcast_id: this.id,
        id: this.captionMeta.id
      }, data).$promise.then(function () {
        _this4.saving = false;
        toaster.pop('success', 'Saved captions');

        _this4.safeReloadCaptions();
      })["catch"](function (err) {
        _this4.saving = false;
        toaster.pop('warning', 'Unable to save captions, please check your entry and try again.');
        console.error(err);
      });
    }
  }, {
    key: "play",
    value: function play(caption) {
      this.__avoidNextAutoSeek = true;
      this.player.seek(caption.start_time);
      this.player.play();
    }
  }, {
    key: "processCaptionsAndInjectSilence",
    value: function processCaptionsAndInjectSilence(cues) {
      var newCaptions = [];
      var absoluteIndexCounter = 0;
      cues.forEach(function (c, i) {
        // check for previous gap
        if (i > 0) {
          var lastCaption = cues[i - 1];

          if (c.start_time - lastCaption.end_time > CAPTION_SILENCE_NOTIFY_GAP) {
            newCaptions.push({
              absoluteIndex: absoluteIndexCounter++,
              type: 'silence',
              start_time: lastCaption.end_time + 0.1,
              end_time: c.start_time - 0.1,
              start_time_fmt: Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(lastCaption.end_time + 0.1),
              end_time_fmt: Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(c.start_time - 0.1)
            });
          }
        }

        c.absoluteIndex = absoluteIndexCounter++;
        c.type = 'cue';
        c.start_time = rounded(c.start_time);
        c.end_time = rounded(c.end_time);
        c.originalConfidence = c.confidence;
        c.start_time_fmt = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(c.start_time);
        c.end_time_fmt = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(c.end_time);
        newCaptions.push(c);
      });
      var lastCaptionEndTime = newCaptions.length && newCaptions[newCaptions.length - 1].end_time || 0;

      if (lastCaptionEndTime + CAPTION_MIN_GAP_TO_INSERT < this.broadcast.recording_duration_seconds) {
        newCaptions.push({
          absoluteIndex: absoluteIndexCounter++,
          type: 'silence',
          isLast: true,
          start_time: lastCaptionEndTime + 0.1,
          end_time: this.broadcast.recording_duration_seconds,
          start_time_fmt: Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(lastCaptionEndTime + 0.1),
          end_time_fmt: Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(this.broadcast.recording_duration_seconds)
        });
      }

      this.captions = newCaptions;
    }
  }, {
    key: "safeReloadCaptions",
    value: function safeReloadCaptions() {
      var _this5 = this;

      var Caption = this.Caption,
          toaster = this.toaster,
          $timeout = this.$timeout;
      var captionQuery = Caption.query({
        broadcast_id: this.id
      }, function (results) {
        _this5.noCaptions = results.length == 0;
        _this5.captionMeta = _.find(results, function (r) {
          return r.recording_id == _this5.broadcast.recording_id;
        });

        _this5.processCaptionsAndInjectSilence((_this5.captionMeta || {}).cues || []);

        _this5.cuesDirty = false;
        var publishStatus = (_this5.captionMeta || {}).publish_status;

        if (publishStatus == 'publishing') {
          _this5.captionReloadHandle = $timeout(function () {
            return _this5.safeReloadCaptions();
          }, CAPTION_RELOAD_INTERVAL_MS);
        }
      }, function (err) {
        toaster.pop('warning', 'Unable to load captions.');
      });
      return captionQuery.$promise;
    }
  }, {
    key: "findAndReplace",
    value: function findAndReplace() {
      var find = prompt('Find Text:');
      if (!find) return;
      var regEx = new RegExp(find, 'ig');
      var matches = [];
      this.captions.forEach(function (c) {
        if (c.type != 'cue') return;
        if (c.text.match(regEx)) matches.push(c);
      });

      if (!matches.length) {
        alert('No matches found');
        return;
      }

      var replace = prompt("Found ".concat(matches.length, " matches. Replace With:"));
      if (!replace) return;
      matches.forEach(function (c) {
        c.text = c.text.replace(regEx, replace);
      });
      this.cuesDirty = true;
    }
  }, {
    key: "canInsertBeforeCue",
    value: function canInsertBeforeCue(index) {
      var c = this.captions[index];
      if (c.start_time == 0) return false;
      var prev = this.captions[index - 1] || {
        end_time: 0
      };

      if (prev.type == 'silence') {
        return true;
      } else {
        return c.start_time - prev.end_time > CAPTION_MIN_GAP_TO_INSERT;
      }
    }
  }, {
    key: "canInsertAfterCue",
    value: function canInsertAfterCue(index) {
      var c = this.captions[index];
      var next = this.captions[index + 1];

      if (!next || next.type == 'silence') {
        return true;
      } else {
        return next.start_time - c.end_time > CAPTION_MIN_GAP_TO_INSERT;
      }
    }
  }, {
    key: "insertCueBefore",
    value: function insertCueBefore(index) {
      var start_time = this.captions[index].start_time - CAPTION_SILENCE_NOTIFY_GAP;

      if (this.captions[index - 1] && this.captions[index - 1].type != 'silence') {
        if (this.captions[index - 1].end_time > start_time) {
          start_time = this.captions[index - 1].end_time + 0.1;
        }
      }

      this.captions.splice(index, 0, {
        text: 'Text...',
        start_time: Math.max(start_time, 0),
        end_time: this.captions[index].start_time - 0.1,
        confidence: 1.0,
        timestampEdit: true
      });
      this.processCaptionsAndInjectSilence(this.captions.filter(function (c) {
        return c.type != 'silence';
      }));
      this.cuesDirty = true;
    }
  }, {
    key: "insertCueAfter",
    value: function insertCueAfter(index) {
      var end_time = this.captions[index].end_time + CAPTION_SILENCE_NOTIFY_GAP;

      if (this.captions[index + 1] && this.captions[index + 1].type != 'silence') {
        if (end_time > this.captions[index + 1].start_time) {
          end_time = this.captions[index + 1].start_time - 0.1;
        }
      }

      this.captions.splice(index + 1, 0, {
        text: 'Text...',
        start_time: this.captions[index].end_time + 0.1,
        end_time: end_time,
        confidence: 1.0,
        timestampEdit: true
      });
      this.processCaptionsAndInjectSilence(this.captions.filter(function (c) {
        return c.type != 'silence';
      }));
      this.cuesDirty = true;
    }
  }, {
    key: "deleteCue",
    value: function deleteCue(index) {
      this.captions.splice(index, 1);
      this.processCaptionsAndInjectSilence(this.captions.filter(function (c) {
        return c.type != 'silence';
      }));
      this.cuesDirty = true;
    }
  }, {
    key: "onChangeTime",
    value: function onChangeTime(c) {
      c.start_time = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["c" /* formattedLabelToSeconds */])(c.start_time_fmt);
      c.end_time = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["c" /* formattedLabelToSeconds */])(c.end_time_fmt);
      this.processCaptionsAndInjectSilence(this.captions.filter(function (c) {
        return c.type != 'silence';
      }));
      this.cuesDirty = true;
    }
  }, {
    key: "uploadCaption",
    value: function uploadCaption(result) {
      var _this6 = this;

      var $timeout = this.$timeout;

      if (!result) {
        return;
      }

      var r = new FileReader();

      r.onload = function (e) {
        $timeout(function () {
          _this6.parseFile(e.target.result);
        }, 100);
      };

      r.oneror = function (e) {
        $timeout(function () {
          _this6.uploadWebVTT = {
            errors: [{
              message: 'Unable to read file.',
              line: 0,
              col: 0
            }]
          };
        }, 0);
      };

      r.readAsText(result.file);
    }
  }, {
    key: "parseFile",
    value: function parseFile(fileContents) {
      var _this7 = this;

      var $timeout = this.$timeout;
      this.parser = this.parser || new __WEBPACK_IMPORTED_MODULE_1__webvtt_parser__["a" /* default */]();
      $timeout(function () {
        // Replace plain & with &amp; (but leave &amp; as-is);
        fileContents = fileContents.replace(/&amp;/g, '&').replace(/&/g, '&amp;');
        _this7.uploadWebVTT = _this7.parser.parse(fileContents);
        _this7.uploadWebVTTText = _this7.uploadWebVTT.cues.map(function (c) {
          return "".concat(Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["e" /* secondsToFormattedLabel */])(c.startTime), " - ").concat(c.text);
        }).join('\n');
      }, 0);
    }
  }, {
    key: "saveUploadedCaptions",
    value: function saveUploadedCaptions(upload) {
      var _this8 = this;

      var Caption = this.Caption,
          toaster = this.toaster;
      var data = {
        status: 'complete',
        publish_status: 'publishing',
        cues: upload.cues.map(function (c) {
          return {
            start_time: c.startTime,
            end_time: c.endTime,
            text: c.text,
            confidence: 1.0
          };
        })
      };
      this.saving = true;
      Caption.update({
        broadcast_id: this.id,
        id: this.captionMeta.id
      }, data).$promise.then(function () {
        _this8.saving = false;
        _this8.captionFile = null;
        _this8.uploadWebVTT = null;
        _this8.uploadWebVTTText = null;
        _this8.showReplaceCaptions = null;
        toaster.pop('success', 'Saved captions');

        _this8.safeReloadCaptions();
      })["catch"](function (err) {
        _this8.saving = false;
        toaster.pop('warning', 'Unable to save captions, please check your entry and try again.');
        console.error(err);
      });
    }
  }]);

  return CaptionEditorController;
}();



function rounded(floatOrString) {
  var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  // round to at most 4 decimals, and ensure strings are cast to floats
  var f = parseFloat(floatOrString, 10);
  var str = f.toFixed(places).replace(/0+$/, '');
  return parseFloat(str, 10);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var CaptionUtils = /*#__PURE__*/function () {
  function CaptionUtils() {
    _classCallCheck(this, CaptionUtils);
  }

  _createClass(CaptionUtils, null, [{
    key: "findCaptionAt",
    value: // Return the caption that is contains the given timestamp (or null)
    function findCaptionAt(timestamp, captions) {
      return _.find(CaptionUtils.mapCaptionsWithStartAndEndTimestamps(captions), function (c) {
        return c.start <= timestamp && c.end >= timestamp;
      });
    } // Find the end of the last captioned segment prior to the provided timestamp

  }, {
    key: "findLastEndPointPriorTo",
    value: function findLastEndPointPriorTo(timestamp, captions) {
      captions = _.sortBy(CaptionUtils.mapCaptionsWithStartAndEndTimestamps(captions), 'end');

      var i = _.findLastIndex(captions, function (c) {
        return timestamp > c.end;
      });

      return i > 0 ? captions[i] : null;
    } // Glue start and end timestamps on the list of captions

  }, {
    key: "mapCaptionsWithStartAndEndTimestamps",
    value: function mapCaptionsWithStartAndEndTimestamps(captions) {
      return _.map(_.sortByAll(captions, ['playback_start_time_fmt', 'id']), function (c) {
        return _.extend({}, c, {
          start: Object(__WEBPACK_IMPORTED_MODULE_0__date__["c" /* formattedLabelToSeconds */])(c.playback_start_time_fmt),
          end: Object(__WEBPACK_IMPORTED_MODULE_0__date__["c" /* formattedLabelToSeconds */])(c.playback_stop_time_fmt)
        });
      });
    } // Look for any overlapping captions in the list

  }, {
    key: "findOverlapping",
    value: function findOverlapping(captions) {
      captions = CaptionUtils.mapCaptionsWithStartAndEndTimestamps(captions);
      var results = [];

      for (var i = 0, l = captions.length; i < l; i++) {
        var caption = captions[i];
        var overlaps = [];

        for (var j = 0; j < l; j++) {
          var caption2 = captions[j];

          if (i != j && (caption2.start < caption.end && caption2.end > caption.start || caption2.end < caption.start && caption2.start > caption.end)) {
            overlaps.push(caption2);
          }
        }

        if (overlaps.length) {
          results.push(_.extend({}, caption, {
            overlaps: overlaps
          }));
        }
      }

      return results;
    }
  }]);

  return CaptionUtils;
}();



/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__webvtt_parser__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date__ = __webpack_require__(4);


var MAX_CAPTION_TRANSCRIBE_TIME_SEC = 2 * 60 * 60; //2 hrs

var module = angular.module('caption-editor');
module.directive('captionTranscribeProgress', function () {
  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      captionMeta: '='
    },
    template: "\n    <div class=\"well\" style=\"margin:30px 0\">\n      <uib-progressbar value=\"vm.progress()\" max=\"100\" style=\"margin:15px 0\">\n        {{vm.progress()}}% Processed\n      </uib-progressbar>\n      <table style=\"width:100%;font-size:8pt;\">\n        <tr>\n          <td width=\"5%\">Starting</td>\n          <td width=\"25%\">Processing Audio</td>\n          <td width=\"40%\">Transcribing</td>\n          <td width=\"20%\">Processing Transcription</td>\n          <td width=\"10%\">Complete</td>\n        </tr>\n      </table>\n    </div>\n    ",
    controllerAs: 'vm',
    controller: function controller($scope) {
      'ngInject';

      this.progress = function () {
        if (!$scope.captionMeta) return 0;
        var _$scope$captionMeta = $scope.captionMeta,
            status = _$scope$captionMeta.status,
            updated_at = _$scope$captionMeta.updated_at;
        if (status == 'failed') return 0;
        if (status == 'requested') return 5;
        if (status == 'requesting_audio') return 10;

        if (status == 'processing_audio') {
          // estimate percent of way through the extraction based on start date
          var totalDuration = $scope.broadcast.recording_duration_seconds || 60 * 30;
          var processingTime = moment().diff(updated_at, 'seconds') || 0;
          return 10 + Math.round(20 * Math.min(1, processingTime / totalDuration));
        }

        if (status == 'transcribing') {
          // estimate percent of way through the transcribe process based on start date
          var totalDuration = $scope.broadcast.recording_duration_seconds || 60 * 30;
          var processingTime = Math.min(moment().diff(updated_at, 'seconds') || 0, MAX_CAPTION_TRANSCRIBE_TIME_SEC);
          return 30 + Math.round(50 * Math.min(1, processingTime / totalDuration));
        }

        if (status == 'processing_transcription') return 90;
        if (status == 'completed') return 100;
        return 100;
      };
    }
  };
});
var PARTIAL_TEMPLATE_WEBVTT_UPLOAD = "\n  <div class=\"row\">\n    <div class=\"col-sm-6\">\n      <div class=\"caption-upload-cell\" style=\"margin:15px auto 0; max-width:300px\">\n        <upload-slot ng-model=\"vm.captionFile\"\n                    ng-change=\"vm.uploadCaption(vm.captionFile)\"\n                    slot-name=\"'caption'\"\n                    allow-image=\"false\"\n                    allow-video=\"false\"\n                    hide-stock-browse=\"true\"\n                    hide-recent-browse=\"true\"\n                    compact=\"true\"></upload-slot>\n      </div>\n    </div>\n    <div class=\"col-sm-6\">\n      <p ng-hide=\"vm.uploadWebVTT\" class=\"help-block\" style=\"margin:45px 15px 0\">\n        WebVTT caption files generated from other services and tools may be uploaded to BoxCast.\n        <a href=\"https://support.boxcast.com/en/articles/4235125\" target=\"_blank\">Learn More</a>\n      </p>\n      <div ng-show=\"vm.uploadWebVTT && vm.uploadWebVTT.errors.length\">\n        <h4>Error Processing WebVTT File</h4>\n        <ul class=\"text-left text-danger\">\n          <li ng-repeat=\"e in vm.uploadWebVTT.errors\">{{e.message}} (line {{e.line}}, col {{e.col}})</li>\n        </ul>\n      </div>\n      <div ng-show=\"vm.uploadWebVTT && !vm.uploadWebVTT.errors.length\">\n        <h4>Review WebVTT Upload</h4>\n        <textarea class=\"form-control\" rows=\"15\" style=\"font-size:8pt;font-family:monospace\" readonly>{{vm.uploadWebVTTText}}</textarea>\n      </div>\n    </div>\n  </div>\n\n  <div style=\"margin-top:15px\" ng-if=\"vm.uploadWebVTT && vm.uploadWebVTT.cues.length && !vm.uploadWebVTT.errors.length\">\n    <button ng-click=\"onCreate({upload: vm.uploadWebVTT})\" type=\"button\" class=\"btn btn-lg btn-primary\">\n      Saved Uploaded Caption File\n    </button>\n  </div>\n";
module.directive('captionDetails', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      captionMeta: '=',
      linkToEditor: '=',
      onCreate: '&',
      onDownload: '&'
    },
    template: "\n    <div>\n\n      <div ng-if=\"!captionMeta\" style=\"max-width:800px; margin:0 auto;\">\n        <div ng-if=\"::($root.account.feature_flags.automated_captioning || $root.account.feature_flags.live_automated_captioning)\">\n          <h4><strong>Add Captions Automatically</strong></h4>\n          <p class=\"help-block text-center\" style=\"margin:15px 0\">\n            Click \"Generate Captions\" to start the automatic transcription and captioning of your broadcast.\n            This process will usually take around 1 hour. You will then be able to edit the captions before publishing.\n          </p>\n          <button ng-click=\"onCreate()\" type=\"button\" class=\"btn btn-lg btn-primary\">\n            Generate Captions\n          </button>\n        </div>\n\n        <div ng-if=\"::(!$root.account.feature_flags.automated_captioning && !$root.account.feature_flags.live_automated_captioning)\">\n          <div class=\"row\">\n            <div class=\"col-sm-6\">\n              <img class=\"img\" src=\"/img/sample-automated-captions.png\" style=\"max-width:100%\">\n            </div>\n            <div class=\"col-sm-6 text-left\">\n              <h4><strong>Add Captions Automatically</strong></h4>\n              <p class=\"help-block\" style=\"margin:15px 0\">\n                A 1 hour broadcast can take up to 3 hours to manually caption. Save yourself the time and\n                automatically caption your recorded broadcasts with the touch of a button.\n                <a href=\"https://support.boxcast.com/en/articles/4235130\" target=\"_blank\">Learn More</a>\n              </p>\n              <upgrade-button></upgrade-button>\n            </div>\n          </div>\n        </div>\n\n        <hr style=\"width:50%;margin:30px auto\">\n        <h4 class=\"text-center\"><strong>Add Captions Manually</strong></h4>\n        <div>".concat(PARTIAL_TEMPLATE_WEBVTT_UPLOAD, "</div>\n      </div>\n\n      <div ng-if=\"captionMeta.status == 'failed'\" style=\"max-width:800px; margin:0 auto;\">\n        <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:30px;\">\n          The captioning process failed. Reason: {{captionMeta.failure_reason}}.\n        </div>\n        <button ng-click=\"onCreate()\" type=\"button\" class=\"btn btn-lg btn-primary\">\n          Try Captioning Again\n        </button>\n      </div>\n\n      <div ng-if=\"captionMeta && (captionMeta.status != 'completed')\" style=\"max-width:800px; margin:0 auto;\">\n        <h4 class=\"text-center\"><strong>Generating Captions...</strong></h4>\n        <p class=\"help-block text-center\" style=\"margin:15px 0\">\n          This process will usually take around 1 hour. You will then be able to edit the captions\n          before publishing. Feel free to leave the page and come back later.\n        </p>\n        <caption-transcribe-progress broadcast=\"broadcast\" caption-meta=\"captionMeta\"></caption-transcribe-progress>\n      </div>\n\n      <div ng-if=\"captionMeta && captionMeta.publish_status == 'publishing'\" style=\"max-width:800px; margin:0 auto;\">\n        <div class=\"bg-info text-info\" style=\"padding:10px; border:1px solid;margin-bottom:15px;\">\n          <i class=\"fa fa-spin fa-spinner\"></i>\n          The captions are being published and will be available for viewers within a few minutes.\n        </div>\n      </div>\n\n      <div ng-if=\"linkToEditor && captionMeta && captionMeta.status == 'completed'\">\n        <div ng-if=\"captionMeta.publish_status == 'unpublished'\">\n          <h4 class=\"text-center\"><strong>Captions Generated &amp; Ready For Review</strong></h4>\n          <p class=\"help-block text-center\" style=\"margin:15px 0\">\n            Review &amp; Publish your captions to make them available to viewers.\n            <br>\n            <small>(Hint: Click the settings icon &amp; \"Review Low-Confidence Cues\" to edit quickly)</small>\n          </p>\n          <a ui-sref=\"caption-editor({broadcastId: broadcast.id})\" class=\"btn btn-lg btn-primary\">\n            Review and Edit\n          </a>\n        </div>\n        <div ng-if=\"captionMeta.publish_status != 'unpublished'\" class=\"row\">\n          <div class=\"col-xs-6 text-left\">\n            <a ui-sref=\"caption-editor({broadcastId: broadcast.id})\" class=\"btn btn-sm btn-default\">\n              <i class=\"fa fa-edit\"></i>\n              Edit Captions\n            </a>\n            <div class=\"btn-group\" uib-dropdown>\n              <button tabindex=\"-1\" type=\"button\" class=\"btn btn-default btn-sm\" uib-dropdown-toggle>\n                Download Captions\n                <i class=\"fa fa-caret-down\" style=\"margin-left: 5px;\"></i>\n              </button>\n              <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\n                <li role=\"menuitem\"><a href=\"javascript://\" ng-click=\"onDownload({format: 'webvtt'})\">WebVTT File (.vtt)</a></li>\n                <li role=\"menuitem\"><a href=\"javascript://\" ng-click=\"onDownload({format: 'text'})\">Text File (.txt)</a></li>\n              </ul>\n            </div>\n          </div>\n          <div class=\"col-xs-6\">\n            <table class=\"text-left\" align=\"right\">\n              <tr><th class=\"font-bold text-bx-accessible-grey\">Status:</th><td>&nbsp;</td><td>{{captionMeta.publish_status|unslugify}}</td></tr>\n              <tr><th class=\"font-bold text-bx-accessible-grey\">Updated:</th><td>&nbsp;</td><td>{{captionMeta.updated_at|date:'medium'}}</td></tr>\n            </table>\n          </div>\n        </div>\n      </div>\n\n    </div>\n    "),
    controller: function controller($scope, $timeout) {
      'ngInject';

      var _this = this;

      var parser = new __WEBPACK_IMPORTED_MODULE_0__webvtt_parser__["a" /* default */]();

      this.uploadCaption = function (result) {
        if (!result) {
          return;
        }

        var r = new FileReader();

        r.onload = function (e) {
          $timeout(function () {
            _this.parseFile(e.target.result);
          }, 100);
        };

        r.oneror = function (e) {
          $timeout(function () {
            _this.uploadWebVTT = {
              errors: [{
                message: 'Unable to read file.',
                line: 0,
                col: 0
              }]
            };
          }, 0);
        };

        r.readAsText(result.file);
      };

      this.parseFile = function (fileContents) {
        $timeout(function () {
          // Replace plain & with &amp; (but leave &amp; as-is);
          fileContents = fileContents.replace(/&amp;/g, '&').replace(/&/g, '&amp;');
          _this.uploadWebVTT = parser.parse(fileContents);
          _this.uploadWebVTTText = _this.uploadWebVTT.cues.map(function (c) {
            return "".concat(Object(__WEBPACK_IMPORTED_MODULE_1__utils_date__["e" /* secondsToFormattedLabel */])(c.startTime), " - ").concat(c.text);
          }).join('\n');
        }, 0);
      };
    },
    controllerAs: 'vm'
  };
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channels_html__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channels_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__channels_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controller__ = __webpack_require__(412);




var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('channels', __WEBPACK_IMPORTED_MODULE_1__channels_html___default.a, __WEBPACK_IMPORTED_MODULE_3__controller__["a" /* default */], 'ChannelsController', '/channels?id');
Object(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */])(module);
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n\n  <div class=\"well text-center\" ng-if=\"!vm.channels.length && !vm.loaded\">\n    <h4 class=\"help-block\" style=\"margin:30px auto;\">\n      Loading...\n    </h4>\n  </div>\n\n  <div class=\"well text-center\" ng-if=\"!vm.channels.length && vm.loaded\">\n    <h4 class=\"help-block\" style=\"margin:30px auto;\">\n      There are no custom channels currently defined.\n    </h4>\n    <button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"vm.openChannelModal()\">\n      &plus; Add Channel\n    </button>\n  </div>\n\n  <div class=\"well\" ng-if=\"vm.channels.length\">\n    <div class=\"row\">\n      <div class=\"col-md-9\">\n        <div ng-repeat=\"c in vm.channels\" id=\"{{c.id}}\" style=\"margin-bottom:15px\">\n          <div id=\"channel-card-{{c.id}}\"\n               class=\"channel-card boxcaster-card channel-card-{{c.id == vm.selectedChannelId ? 'expanded' : 'collapsed'}}\">\n            <channel-row-header channel=\"c\"\n                                on-toggle-details=\"vm.select(c)\"\n                                ></channel-row-header>\n            <div class=\"boxcaster-card-details\" uib-collapse=\"c.id != vm.selectedChannelId\" style=\"\">\n              <channel-row-details channel=\"c\"\n                                   broadcasts=\"vm.broadcasts\"\n                                   broadcasts-pagination=\"vm.broadcastsPagination\"\n                                   loading-broadcasts=\"vm.loadingBroadcasts\"\n                                   page-size=\"vm.pageSize\"\n                                   on-load-selected-broadcasts-for-page=\"vm.loadSelectedBroadcastsForPage\"\n                                   on-edit=\"vm.openChannelModal(c)\"\n                                   on-add-broadcast=\"vm.openAddBroadcastModal(c)\"\n                                   ></channel-row-details>\n            </div>\n          </div>\n        </div><!--/ng-repeat:channels-->\n      </div><!--/col-md-9-->\n      <div class=\"col-md-3 text-md-right\">\n        <button ng-click=\"vm.openChannelModal()\" class=\"btn btn-lg btn-block btn-success\">+ Add a Channel</button>\n        <a ng-if=\"vm.videoPortalEnabled\" class=\"btn btn-block btn-default\" href=\"{{vm.videoPortalLink}}\" target=\"_blank\" style=\"text-align: left; white-space: normal;\">\n          <i class=\"fa fa-external-link\" style=\"margin-right: 8px;\" />View Video Portal on BoxCast.tv\n        </a>\n        <button type=\"button\" class=\"btn btn-block btn-default\"\n          ng-if=\"clipboard.supported && vm.videoPortalEnabled\"\n          clipboard\n          text=\"vm.videoPortalLink\"\n          on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n          on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n          uib-tooltip=\"Copy the Video Portal link to your clipboard\" tooltip-placement=\"bottom\"\n          style=\"text-align: left; white-space: normal;\"\n        >\n          <i class=\"fa fa-copy\" style=\"width:20px\"></i>\n          Copy Video Portal Link\n        </button>\n      </div>\n    </div><!--/row-->\n  </div><!--/well-->\n\n</main>\n"

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerComponents;
function registerComponents(module) {
  // <ichannel-row-header />
  module.component('channelRowHeader', {
    bindings: {
      channel: '=',
      onToggleDetails: '&'
    },
    controllerAs: 'vm',
    controller: function controller($scope, $rootScope) {
      'ngInject';

      var _this = this;

      this.$onInit = function () {
        $scope.c = _this.channel; //shortcut for template

        $scope.ff = $rootScope.account.feature_flags;
        $scope.ef = $rootScope.account.extra_features;
        var cs = _this.channel.content_settings || {};

        if (cs.preview) {
          _this.bgStyle = {
            'background-image': "url(\"".concat(_this.channel.content_settings.preview, "\")")
          };
        } else {
          _this.bgStyle = {};
        }

        _this.audioPodcastEnabled = cs.podcast && cs.podcast.audio;
        _this.videoPodcastEnabled = cs.podcast && cs.podcast.video;
      };
    },
    template: "\n      <div class=\"row integration-card-header\" ng-click=\"vm.onToggleDetails(c)\">\n        <div class=\"hidden-xs col-sm-1\" style=\"width:90px\">\n          <div class=\"bg-image-badge\"\n                ng-style=\"vm.bgStyle\"\n                >\n          </div>\n        </div>\n        <div class=\"hidden-xs col-sm-1\" style=\"width:30px\">\n          <i ng-hide=\"c.__isLive\" class=\"fa fa-circle color--grey\"></i>\n          <i ng-show=\"c.__isLive\" class=\"fa fa-circle color--online\"></i>\n        </div>\n        <div class=\"col-sm-5 text-left\" style=\"flex:1\">\n          <p class=\"overflow-ellipse body-2\" style=\"margin-bottom:0\"><strong>{{c.name}}</strong></p>\n          <p class=\"overflow-ellipse\" style=\"margin-bottom:0\"><small>{{c.description}}</small></p>\n        </div>\n        <div class=\"hidden-xs col-sm-5 text-right\" style=\"flex:1\">\n          <ul class=\"list-inline label-list justify-end\">\n            <li ng-if=\"::ef.video_portal && !c.is_private\">\n              <span class=\"label label-lagoon\">Video Portal Enabled</span>\n            </li>\n            <li ng-if=\"c.is_ticketed && c.free_variant && c.free_variant != 'none'\">\n              <span class=\"label label-success\">Flex (Ticketed HD)</span>\n            </li>\n            <li ng-if=\"c.is_ticketed\">\n              <span class=\"label label-success\">${{c.ticket_price | number:2}} / ticket</span>\n            </li>\n            <li ng-if=\"::ff.podcast && vm.audioPodcastEnabled\">\n              <span class=\"label label-podcast\">Audio Podcast Enabled</span>\n            </li>\n            <li ng-if=\"::ff.podcast && vm.videoPodcastEnabled\">\n              <span class=\"label label-podcast\">Video Podcast Enabled</span>\n            </li>\n            <li ng-if=\"::ff.geoblock && c.content_settings.geoblock\">\n              <span class=\"label label-danger\">Geoblock Enabled</span>\n            </li>\n            <li ng-if=\"::ff.password && c.content_settings.cryptblock\">\n              <span class=\"label label-danger\">Password Block Enabled</span>\n            </li>\n            <li ng-if=\"::ff.host_restrictions && c.content_settings.hostRestrictions\">\n              <span class=\"label label-danger\">Embedding Restriction Enabled</span>\n            </li>\n          </ul>\n        </div>\n        <div class=\"col-sm-1 text-center\">\n          <i class=\"fa fa-chevron-up\"></i>\n          <i class=\"fa fa-chevron-down\"></i>\n        </div>\n      </div>\n    "
  }); // <channel-row-details />

  module.component('channelRowDetails', {
    bindings: {
      channel: '=',
      broadcasts: '=',
      broadcastsPagination: '=',
      loadingBroadcasts: '=',
      pageSize: '=',
      onLoadSelectedBroadcastsForPage: '=',
      onEdit: '&',
      onAddBroadcast: '&'
    },
    controllerAs: 'vm',
    controller: function controller($scope, $rootScope) {
      'ngInject';

      var _this2 = this;

      this.$onInit = function () {
        $scope.c = _this2.channel; //shortcut for template

        $scope.ff = $rootScope.account.feature_flags;
        $scope.ef = $rootScope.account.extra_features;
        $scope.canEmbed = $rootScope.user.can('embed', 'broadcast/*');
        _this2.mediaTokenRestrictions = $rootScope.account.extra_features.media_token_restrictions;
        _this2.BOXCAST_TV_SHOW_URL = BOXCAST_TV_SHOW_URL;
      };
    },
    template: "\n      <div class=\"channel-row-details row\" style=\"display:block; /*undo flexbox*/\">\n        <div class=\"col-xs-12 visible-xs hidden-sm\">\n          <ul class=\"list-inline\">\n            <li ng-if=\"::ef.video_portal && !c.is_private\">\n              <span class=\"label label-lagoon\">Video Portal Enabled</span>\n            </li>\n            <li ng-if=\"c.is_ticketed && c.free_variant && c.free_variant != 'none'\">\n              <span class=\"label label-success\">Flex (Ticketed HD)</span>\n            </li>\n            <li ng-if=\"c.is_ticketed\">\n              <span class=\"label label-success\">${{c.ticket_price | number:2}} / ticket</span>\n            </li>\n            <li ng-if=\"::ff.podcast && vm.audioPodcastEnabled\">\n              <span class=\"label label-podcast\">Audio Podcast Enabled</span>\n            </li>\n            <li ng-if=\"::ff.podcast && vm.videoPodcastEnabled\">\n              <span class=\"label label-podcast\">Video Podcast Enabled</span>\n            </li>\n            <li ng-if=\"::ff.geoblock && c.content_settings.geoblock\">\n              <span class=\"label label-danger\">Geoblock Enabled</span>\n            </li>\n            <li ng-if=\"::ff.password && c.content_settings.cryptblock\">\n              <span class=\"label label-danger\">Password Block Enabled</span>\n            </li>\n            <li ng-if=\"::ff.host_restrictions && c.content_settings.hostRestrictions\">\n              <span class=\"label label-danger\">Embedding Restriction Enabled</span>\n            </li>\n          </ul>\n        </div>\n        <div class=\"col-sm-8\">\n          <div ng-if=\"vm.loadingBroadcasts\">\n            <p class=\"text-center\" style=\"margin-top:50px\">\n              <i class=\"fa fa-spin fa-spinner\"></i> Loading...\n            </p>\n          </div>\n          <div ng-if=\"!vm.loadingBroadcasts && !vm.broadcasts.length\">\n            <p class=\"text-center help-block\" style=\"margin-top:30px\">\n              There are no broadcasts in this channel.\n            </p>\n            <p class=\"text-center\">\n              <button class=\"btn btn-lg btn-default\" ng-click=\"vm.onAddBroadcast(c)\">\n                <i style=\"width:20px\" class=\"fa fa-plus\"></i> Add Broadcast\n              </button>\n            </p>\n          </div>\n          <div ng-if=\"!vm.loadingBroadcasts && vm.broadcasts.length\">\n            <ul class=\"list-unstyled\" style=\"margin:0 -30px 0 -15px\">\n              <li ng-repeat=\"broadcast in vm.broadcasts track by broadcast.id\">\n                <broadcast-card broadcast=\"broadcast\" show-view-count=\"false\" extra-css-classes=\"'col-lg-4 col-xxl-3 col-sm-6 col-xs-12'\"></broadcast-card>\n              </li>\n            </ul>\n            <div class=\"clearfix\"></div>\n\n            <p ng-if=\"vm.broadcastsPagination.total > vm.pageSize\"\n               class=\"pull-right help-block\"\n               style=\"margin-top:24px;\">\n              <small>\n              Showing broadcasts\n              {{vm.broadcastsPagination.resultMin}} - {{vm.broadcastsPagination.resultMax}}\n              of {{vm.broadcastsPagination.total}}\n              </small>\n            </p>\n\n            <uib-pagination ng-if=\"vm.broadcastsPagination.total > vm.pageSize\"\n                            total-items=\"vm.broadcastsPagination.total\"\n                            items-per-page=\"vm.pageSize\"\n                            max-size=\"10\"\n                            rotate=\"false\"\n                            class=\"pagination-sm\"\n                            ng-model=\"vm.broadcastsPagination.current\"\n                            ng-change=\"vm.onLoadSelectedBroadcastsForPage(vm.broadcastsPagination.current)\"></uib-pagination>\n\n          </div>\n        </div>\n        <div class=\"col-sm-4\">\n          <ul class=\"list-unstyled\" style=\"margin-top:0\">\n            <li>\n              <button class=\"btn btn-block btn-primary\" ng-click=\"vm.onEdit(c)\" style=\"text-align:left\">\n                <i style=\"width:20px\" class=\"fa fa-edit\"></i> Edit Channel Settings\n              </button>\n            </li>\n            <li>\n              <p class=\"text-left help-block\" style=\"font-weight:bold\"></p>\n              <button class=\"btn btn-block btn-default\" ng-click=\"vm.onAddBroadcast(c)\" style=\"text-align:left\">\n                <i style=\"width:20px\" class=\"fa fa-plus\"></i> Add Broadcast\n              </button>\n            </li>\n            <li ng-if=\"::ff.analytics\">\n              <p class=\"text-left help-block\" style=\"font-weight:bold;margin-top:15px;\">REPORTS</p>\n              <a class=\"btn btn-block btn-default\" ui-sref=\"reports.viewer({report: 'channels', id: c.id})\" style=\"text-align:left\">\n                <i style=\"width:20px\" class=\"fa fa-line-chart\"></i> Analytics\n              </a>\n            </li>\n            <li ng-if=\"c.is_ticketed\">\n              <p class=\"text-left help-block\" style=\"font-weight:bold\"></p>\n              <a class=\"btn btn-block btn-default\" ui-sref=\"reports.tickets({report: 'channels', id: c.id})\" style=\"text-align:left\">\n                <i style=\"width:20px\" class=\"fa fa-ticket\"></i> Ticket Report\n              </a>\n            </li>\n            <li ng-if=\"::canEmbed\">\n              <p class=\"text-left help-block\" style=\"font-weight:bold;margin-top:15px;\">WATCH</p>\n              <a class=\"btn btn-block btn-default\" ui-sref=\"embed({channel_id: c.id})\" style=\"text-align:left\">\n                <i style=\"width:20px\" class=\"fa fa-code\"></i> Embed\n              </a>\n            </li>\n            <li ng-if=\"::!vm.mediaTokenRestrictions\">\n              <p class=\"text-left help-block\" style=\"font-weight:bold\"></p>\n              <a class=\"btn btn-block btn-default\" href=\"{{vm.BOXCAST_TV_SHOW_URL}}{{c.id}}\" target=\"_blank\" style=\"text-align:left\">\n                <i style=\"width:20px\" class=\"fa fa-external-link\"></i> View on BoxCast.tv\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n    "
  });
}

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelsController; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PAGE_SIZE = 8;

var ChannelsController = /*#__PURE__*/function () {
  function ChannelsController(Channel, Broadcast, $rootScope, $scope, $state, $uibModal, $q, $timeout, toaster) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, ChannelsController);

    var ApiConfig = $rootScope.ApiConfig;
    this.$uibModal = $uibModal;
    this.account = $rootScope.account;
    this.$scope = $scope;
    this.$state = $state;
    this.$q = $q;
    this.$timeout = $timeout;
    this.Channel = Channel;
    this.Broadcast = Broadcast;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.toaster = toaster;
    this.defaultTicketPrice = ApiConfig.ticket.default_price;
    this.minTicketPrice = ApiConfig.ticket.minimum_price;
    this.pageSize = PAGE_SIZE;
    this.videoPortalEnabled = $rootScope.account.extra_features.video_portal;
    this.videoPortalLink = this.videoPortalEnabled ? "".concat(BOXCAST_TV_VIDEO_PORTAL_URL).concat(this.account.id) : null;
    this.loadingPromises = [];
    this.loadSelectedBroadcastsForPage = this.loadSelectedBroadcastsForPage.bind(this);
    var query = $state.params;

    if (query.id) {
      this.selectedChannel = {
        id: query.id
      };
    }

    this.loaded = false;
    this.reload().then(function () {
      _this.loaded = true; // Scroll to the selected channel from querystring

      query.id && _this.scrollToChannel(query.id);
    })["catch"](function (err) {
      console.error(err);
      toaster.pop('warning', 'Unable to load channels', 'Please refresh the page to try again');
    });
    $scope.$on('broadcast:edited', function () {
      _this.loadSelectedBroadcastsForPage(_this.broadcastsPagination.current);
    });
  }

  _createClass(ChannelsController, [{
    key: "scrollToChannel",
    value: function scrollToChannel(id) {
      var scrollToId = "#channel-card-".concat(id);
      this.$timeout(function () {
        $('html, body').animate({
          scrollTop: $(scrollToId).offset().top - 90
        });
      }, 10);
    }
  }, {
    key: "markChannelIdAsLive",
    value: function markChannelIdAsLive(id) {
      this.channels.forEach(function (c) {
        if (c.id == id) {
          c.__isLive = true;
        }
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this2 = this;

      return this.init().then(function () {
        // Flag LIVE channels
        _this2.liveBroadcasts.forEach(function (b) {
          (b.in_channel_ids || []).forEach(function (channelId) {
            _this2.markChannelIdAsLive(channelId);
          });
        });
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      var $q = this.$q,
          Broadcast = this.Broadcast,
          Channel = this.Channel;
      var selected = (this.selectedChannel || {}).id;
      this.channels = Channel.query({
        l: 1000
      }); // Restore selected channel with new object

      var cPromise = this.channels.$promise.then(function () {
        if (selected) {
          _this3.select(_.find(_this3.channels, {
            id: selected
          }), false);
        }
      }); // All Live Broadcasts ... to use to see which channels have currently live
      // broadcasts, so we need to get each live broadcast in *show* scope so that we
      // can look into the `broadcast.in_channel_ids`

      this.liveBroadcasts = [];
      var bPromise = $q(function (resolve, reject) {
        Broadcast.query({
          q: 'timeframe:preroll timeframe:current',
          l: 100
        }, function (broadcasts) {
          $q.all(broadcasts.map(function (b) {
            var broadcast = Broadcast.get({
              id: b.id
            });
            return broadcast.$promise;
          })).then(function (broadcasts) {
            _this3.liveBroadcasts = broadcasts;
            resolve(broadcasts);
          })["catch"](function (err) {
            reject(err);
          });
        }, function (err) {
          return reject(err);
        });
      });
      this.loadingPromises.push(cPromise);
      this.loadingPromises.push(bPromise);
      return $q.all([cPromise, bPromise]);
    }
  }, {
    key: "select",
    value: function select(channel) {
      var toggleIfSelected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var Channel = this.Channel,
          $state = this.$state; // Update URL to make back navigation work

      $state.go('channels', {
        id: channel.id
      }, {
        notify: false,
        location: 'replace',
        reloadOnSearch: false
      }); // Toggle off if already selected

      if (toggleIfSelected && this.selectedChannelId === channel.id) {
        this.selectedChannelId = null;
        this.selectedChannel = {};
        this.broadcasts = [];
        this.broadcastsPagination = {};
        return;
      }

      this.selectedChannelId = channel.id;
      this.selectedChannel = channel;
      this.loadSelectedBroadcastsForPage(1); //this.scrollToChannel(channel.id);
    }
  }, {
    key: "loadSelectedBroadcastsForPage",
    value: function loadSelectedBroadcastsForPage(p) {
      var _this4 = this;

      var Channel = this.Channel,
          selectedChannelId = this.selectedChannelId,
          toaster = this.toaster;
      this.loadingBroadcasts = true;
      var query = Channel.getBroadcasts({
        id: selectedChannelId,
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-starts_at'
      }, function (data, headers) {
        _this4.broadcasts = data;
        var pagination = JSON.parse(headers('x-pagination'));
        _this4.broadcastsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length
        };
        _this4.loadingBroadcasts = false;
      }, function (err) {
        toaster.pop('Unable to load broadcasts. Please refresh the page and try again.');
        _this4.loadingBroadcasts = false;
      });
      this.loadingPromises.push(query.$promise);
    }
  }, {
    key: "openChannelModal",
    value: function openChannelModal(_channel) {
      var $uibModal = this.$uibModal,
          _minTicketPrice = this.minTicketPrice,
          _defaultTicketPrice = this.defaultTicketPrice; // Create vs. Edit

      _channel = _channel || {
        ticket_price: _defaultTicketPrice,
        is_private: false
      };

      var _parentVM = this;

      $uibModal.open({
        template: __webpack_require__(413),
        resolve: {
          channel: function channel() {
            return _channel;
          },
          parentVM: function parentVM() {
            return _parentVM;
          },
          minTicketPrice: function minTicketPrice() {
            return _minTicketPrice;
          },
          defaultTicketPrice: function defaultTicketPrice() {
            return _defaultTicketPrice;
          }
        },
        controllerAs: 'vm',
        controller: __webpack_require__(414)["default"],
        keyboard: false,
        backdrop: 'static'
      });
    }
  }, {
    key: "openAddBroadcastModal",
    value: function openAddBroadcastModal(channel) {
      var _this5 = this;

      var $uibModal = this.$uibModal,
          Broadcast = this.Broadcast;
      $uibModal.open({
        template: __webpack_require__(199),
        controller: __webpack_require__(200)["default"],
        size: 'lg',
        controllerAs: 'vm',
        resolve: {
          options: function options() {
            return {
              skipRecordingSourceValidation: true,
              modalTitle: 'Add Broadcast to ' + channel.name
            };
          }
        }
      }).result.then(function (broadcast) {
        console.log('adding broadcast ', broadcast.id, ' to channel ', channel.id);
        var channelIds = broadcast.in_channel_ids || [];
        channelIds.push(channel.id);
        return Broadcast.update({
          id: broadcast.id
        }, {
          in_channel_ids: channelIds
        }).$promise;
      }).then(function () {
        _this5.reload();
      });
    }
  }]);

  return ChannelsController;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = "<form name=\"channelForm\" role=\"form\">\n\n<div class=\"modal-header\" style=\"border-bottom:0;padding-bottom:0;\">\n  <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li style=\"padding-left: 15px\">\n      <h3 ng-if=\"vm.channel.id\" class=\"modal-title\">Edit Channel</h3>\n      <h3 ng-if=\"!vm.channel.id\" class=\"modal-title\">Create New Channel</h3>\n    </li>\n    <li class=\"pull-right\" ng-class=\"vm.activeTab == 'advanced' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = 'advanced'\">Advanced</a>\n    </li>\n    <li class=\"pull-right\"\n        ng-if=\"::vm.FeatureFlags.podcast\"\n        ng-class=\"vm.activeTab == 'podcast' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = 'podcast'\">Podcasting</a>\n    </li>\n    <li class=\"pull-right\"\n        ng-if=\"::(vm.FeatureFlags.host_restrictions || vm.FeatureFlags.password || vm.FeatureFlags.geoblock)\"\n        ng-class=\"vm.activeTab == 'privacy' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = 'privacy'\">Privacy and Security</a>\n    </li>\n    <li class=\"pull-right\" ng-class=\"!vm.activeTab ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.activeTab = ''\">Overview</a>\n    </li>\n  </ol>\n</div>\n<div class=\"modal-body\" style=\"padding-top:0\">\n  <div ng-if=\"vm.showError\">\n    <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n      Please fill out all required fields before submitting.\n    </div>\n  </div>\n\n  <!-- Overview Tab -->\n  <div ng-show=\"!vm.activeTab\">\n\n    <div class=\"form-group\">\n      <label for=\"name\">Name: <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n      <input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" ng-model=\"vm.channel.name\" ng-maxlength=\"::vm.limits.name\" required>\n      <p ng-show=\"(channelForm.name.$dirty || channelForm.name.$touched) && !vm.channel.name\">\n        <span class=\"text-danger\" ng-if=\"channelForm.name.$error.maxlength\">The channel name is too long.</span>\n        <span class=\"text-danger\" ng-if=\"channelForm.name.$error.required\">The channel name cannot be blank.</span>\n      </p>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"description\">Description: <i class=\"text-danger\" style=\"font-size:12px;vertical-align:top\"></i></label>\n      <textarea rows=\"2\" class=\"form-control\" id=\"description\" ng-model=\"vm.channel.description\"></textarea>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"description\">Preview Image:</label>\n      <div ng-if=\"vm.channel.content_settings.preview\" class=\"text-center\">\n        <img ng-src=\"{{vm.channel.content_settings.preview | trustedUrl}}\" class=\"img\" style=\"max-width:100%\">\n        <div><a href ng-click=\"vm.channel.content_settings.preview = null\">Change</a></div>\n      </div>\n      <div ng-if=\"!vm.channel.content_settings.preview\">\n        <upload-slot ng-model=\"vm.previewFile\"\n                     ng-change=\"vm.uploadPreviewImage(vm.previewFile)\"\n                     slot-name=\"'preview'\"\n                     allow-image=\"true\"\n                     allow-video=\"false\"\n                     compact=\"true\"></upload-slot>\n      </div>\n    </div>\n\n    <div ng-if=\"vm.showTicketedChannelSupport\">\n      <p class=\"help-block\">\n        If you would like to set up a ticketed channel, please\n        <a href=\"https://www.boxcast.com/contact/general\" target=\"_blank\">contact BoxCast Support</a>.\n      </p>\n    </div>\n\n    <div ng-if=\"vm.showVisibility\">\n      <div class=\"form-group\" ng-class=\"{'has-error' : vm.showInvalidVisibilityForVideoPortal }\">\n        <label>Visibility: <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <div>\n          <div class=\"btn-group\">\n            <label class=\"btn btn-default\" ng-show=\"::!vm.FeatureFlags.no_public\" ng-model=\"vm.visibility\" uib-btn-radio=\"'public'\">Public</label>\n            <label class=\"btn btn-default\" ng-show=\"::vm.FeatureFlags.flex\" ng-model=\"vm.visibility\" uib-btn-radio=\"'flex'\">Flex (Ticketed HD)</label>\n            <label class=\"btn btn-default\" ng-show=\"::!vm.FeatureFlags.no_ticketed\" ng-model=\"vm.visibility\" uib-btn-radio=\"'ticketed'\">Ticketed</label>\n          </div>\n        </div>\n        <div ng-if=\"vm.showInvalidVisibilityForVideoPortal\" class=\"text-danger mt-tight\">Only public channels cannot be shown in your Video Portal.</div>\n      </div>\n\n      <div class=\"form-group\" ng-if=\"vm.visibility == 'ticketed' || vm.visibility == 'flex'\">\n        <label for=\"ticket_price\">Ticket Price</label>\n        <div class=\"input-group\">\n          <div class=\"input-group-addon\">$</div>\n          <input type=\"number\" step=\"0.01\" class=\"form-control\" style=\"max-width: 100px\" id=\"ticket_price\" ng-model=\"vm.channel.ticket_price\">\n          <div class=\"pull-left\" ng-if=\"vm.visibility == 'flex'\">\n            <div class=\"body-3\" style=\"margin:7px 0 0 10px\">\n              <i class=\"fa fa-info-circle\"></i>\n              Viewers will receive a low-quality stream for free\n            </div>\n          </div>\n        </div>\n        <p class=\"help-block\"><i class=\"fa fa-info-circle\"></i> The minimum ticket price is ${{vm.minTicketPrice | number:2}}</p>\n      </div>\n    </div>\n\n    <!-- channel.is_private, for removing channels from a video portal -->\n    <!-- if they aren't on public and have is_private set to true, don't show this at all -->\n    <div ng-if=\"vm.ExtraFeatures.video_portal\" ng-show=\"!(vm.channel.is_private && vm.visibility != 'public')\" class=\"form-group\">\n      <div class=\"input-group\">\n        <label style=\"line-height: 24px\">\n          <span class=\"toggle-switch toggle-switch--blue\">\n            <input type=\"checkbox\" ng-model=\"vm.channel.is_private\" ng-true-value=\"false\" ng-false-value=\"true\" >\n            <span class=\"slider\"></span>\n          </span>\n          <span style=\"display: inline-block; margin-left: 5px;\">Show in Video Portal</span>\n        </label>\n        <p style=\"font-size:10pt;margin-bottom: 10px\">\n          Ths BoxCast Video Portal controls which channels and broadcasts are available to viewers on your boxcast.tv page.\n        </p>\n      </div>\n    </div>\n\n    <div class=\"form-group\" ng-class=\"{'has-error' : vm.showWebsiteUrlError}\">\n      <label>\n        Website\n        <i class=\"fa fa-info-circle\"\n           tooltip-append-to-body=\"true\"\n           uib-tooltip=\"Link to a website representing this channel. Leave blank to auto-generate.\"></i>\n      </label>\n      <input type=\"text\" class=\"form-control\" ng-model=\"vm.channel.content_settings.website\" placeholder=\"e.g. https://my-website.com/my-channel\">\n    </div>\n\n    <div class=\"form-group\">\n      <label>\n        Content Language\n        <i class=\"fa fa-info-circle\"\n           tooltip-append-to-body=\"true\"\n           uib-tooltip=\"This is the language in which the majority of this channel's content is provided.\"></i>\n      </label>\n      <select class=\"form-control\"\n              ng-model=\"vm.channel.content_settings.language\"\n              ng-options=\"e.value as e.label for e in vm.contentLanguages\">\n      </select>\n    </div>\n  </div><!-- end overview tab -->\n\n  <!-- Privacy and Security Tab -->\n  <div ng-if=\"::(vm.FeatureFlags.host_restrictions || vm.FeatureFlags.password || vm.FeatureFlags.geoblock)\" ng-show=\"vm.activeTab == 'privacy'\">\n    <div ng-if=\"::vm.FeatureFlags.geoblock\">\n      <label ng-click=\"vm.channel.content_settings.geoblock = vm.channel.content_settings.geoblock ? null : {is_whitelist:true}\" style=\"cursor:pointer\">\n        <i class=\"fa\" ng-class=\"vm.channel.content_settings.geoblock ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n        Enable Geo-blocking\n      </label>\n    </div>\n    <div ng-if=\"::vm.FeatureFlags.geoblock\" ng-show=\"vm.channel.content_settings.geoblock\">\n      <div class=\"row\">\n        <div class=\"form-group col-xs-6\">\n          <div class=\"btn-group\">\n            <label class=\"btn btn-default\" ng-model=\"vm.channel.content_settings.geoblock.is_whitelist\" uib-btn-radio=\"true\">Allow</label>\n            <label class=\"btn btn-default\" ng-model=\"vm.channel.content_settings.geoblock.is_whitelist\" uib-btn-radio=\"false\">Deny</label>\n          </div>\n        </div>\n        <div class=\"form-group col-xs-6\">\n          <label ng-click=\"vm.channel.content_settings.geoblock.strategy = vm.channel.content_settings.geoblock.strategy == 'html5' ? undefined : 'html5'\" style=\"cursor:pointer;margin-top:4px;\">\n            <i class=\"fa\" ng-class=\"vm.channel.content_settings.geoblock.strategy == 'html5' ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n            Prefer HTML5 location detection\n            <i class=\"fa fa-info-circle\" style=\"opacity:0.5\" tooltip-append-to-body=\"true\" uib-tooltip=\"HTML5 location detection (vs IP address detection) is more accurate but may prompt the user for permission before determining whether or not to allow access.\"></i>\n          </label>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"form-group col-xs-4\">\n          <label for=\"edit-channel-lat\">Latitude (decimal form)</label>\n          <input id=\"edit-channel-lat\" type=\"number\" step=\"any\" class=\"form-control\" ng-model=\"vm.channel.content_settings.geoblock.center_lat\" placeholder=\"e.g. 41.511546\">\n        </div>\n        <div class=\"form-group col-xs-4\">\n          <label for=\"edit-channel-lng\">Longitude (decimal form)</label>\n          <input id=\"edit-channel-lng\" type=\"number\" step=\"any\" class=\"form-control\" ng-model=\"vm.channel.content_settings.geoblock.center_lon\" placeholder=\"e.g. -81.6918137\">\n        </div>\n        <div class=\"form-group col-xs-4\">\n          <label for=\"edit-channel-radius\">Radius (miles)</label>\n          <input id=\"edit-channel-radius\" type=\"number\" step=\"any\" min=\"0\" class=\"form-control\" ng-model=\"vm.channel.content_settings.geoblock.radius\" placeholder=\"e.g. 100\">\n        </div>\n        <div class=\"form-group col-xs-12\">\n          <label for=\"edit-channel-zip\">Zip Code List (optional, instead of lat+lon+radius)</label>\n          <textarea\n            id=\"edit-channel-zip\"\n            rows=\"2\"\n            class=\"form-control\"\n            ng-model=\"vm.channel.content_settings.geoblock.zip\"\n            placeholder=\"e.g. 10001, 10002, 10003\"\n            ></textarea>\n          <p class=\"text-warning\" ng-if=\"vm.getZipCodeListLength() > (0.75 * vm.MAX_ZIP_CODE_FIELD_LENGTH) && vm.getZipCodeListLength() <= vm.MAX_ZIP_CODE_FIELD_LENGTH\">\n          <i class=\"fa fa-warning\"></i> Warning, the maximum size of the zip code list is {{vm.MAX_ZIP_CODE_FIELD_LENGTH | number}} characters.\n            You are currently at {{vm.getZipCodeListLength()}} characters. Consider ways to reduce the size of this field.\n          </p>\n          <p class=\"text-danger\" ng-if=\"vm.getZipCodeListLength() > vm.MAX_ZIP_CODE_FIELD_LENGTH\">\n            <i class=\"fa fa-warning\"></i> The maximum size of the zip code list is 15,000 characters.\n            You are currently at {{vm.getZipCodeListLength()}} characters.\n            This value will be truncated when saved.\n          </p>\n        </div>\n      </div>\n    </div>\n\n    <div ng-if=\"::vm.FeatureFlags.password\">\n      <label ng-click=\"vm.channel.content_settings.cryptblock = vm.channel.content_settings.cryptblock ? null : {}\" style=\"cursor:pointer\">\n        <i class=\"fa\" ng-class=\"vm.channel.content_settings.cryptblock ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n        Enable Password Protection\n      </label>\n    </div>\n    <div ng-if=\"::vm.FeatureFlags.password\" ng-show=\"vm.channel.content_settings.cryptblock\">\n      <div class=\"form-group\"  ng-class=\"{'has-error' : vm.showInvalidPasswordForVideoPortal }\">\n        <div>\n          <span ng-show=\"vm.channel.content_settings.cryptblock.crypt\">Change Password</span>\n          <span ng-hide=\"vm.channel.content_settings.cryptblock.crypt\">Enter Password</span>\n        </div>\n        <input type=\"password\" autocomplete=\"hi-browser-plz-dont-autofill-this\" class=\"form-control\" ng-model=\"vm.channel.content_settings.cryptblock.__password__\">\n        <div ng-if=\"vm.showInvalidPasswordForVideoPortal\" class=\"text-danger mt-tight\">Password Protection is not available for channels in your Video Portal.</div>\n      </div>\n    </div>\n\n    <div ng-if=\"::vm.FeatureFlags.host_restrictions\">\n      <host-restrictions-settings content-settings=\"vm.channel.content_settings\"></host-restrictions-settings>\n    </div>\n  </div><!-- end Privacy and Security tab -->\n\n  <!-- Podcasting Tab -->\n  <div ng-if=\"::vm.FeatureFlags.podcast\" ng-show=\"vm.activeTab == 'podcast'\">\n    <div>\n      <label ng-click=\"vm.toggleEnablePodcast('audio')\" style=\"cursor:pointer\">\n        <i class=\"fa\" ng-class=\"vm.channel.content_settings.podcast.audio ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n        Enable Audio Podcast\n      </label>\n    </div>\n    <div>\n      <label ng-click=\"vm.toggleEnablePodcast('video')\" style=\"cursor:pointer\">\n        <i class=\"fa\" ng-class=\"vm.channel.content_settings.podcast.video ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n        Enable Video Podcast\n      </label>\n    </div>\n    <div ng-show=\"vm.showPodcastSettings()\">\n      <div class=\"row\">\n        <div class=\"col-sm-8\">\n          <div class=\"form-group\">\n            <label for=\"podcast_category\">Category:</label>\n            <select class=\"form-control\"\n                    id=\"podcast_category\"\n                    ng-model=\"vm.channel.content_settings.podcast.category\"\n                    ng-options=\"e.value as e.label for e in vm.podcastCategories | orderBy:'label'\">\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"podcast_author\">\n              Author:\n              <i class=\"fa fa-info-circle\"\n                tooltip-append-to-body=\"true\"\n                uib-tooltip=\"Leave blank to use the account display name.\"></i>\n            </label>\n            <input type=\"text\" class=\"form-control\" id=\"podcast_author\" ng-model=\"vm.channel.content_settings.podcast.author\" placeholder=\"{{::vm.defaultPodcastAuthor}}\">\n          </div>\n        </div>\n        <div class=\"form-group col-sm-4\">\n          <label>\n            Preview Image:\n            <i class=\"fa fa-info-circle\"\n               tooltip-append-to-body=\"true\"\n               uib-tooltip=\"Artwork must be a minimum size of 1400 x 1400 pixels and a maximum size of 3000 x 3000 pixels, in JPEG or PNG format, 72 dpi, with appropriate file extensions (.jpg, .png), and in the RGB colorspace.\"></i>\n          </label>\n          <div ng-if=\"vm.channel.content_settings.podcast.image\" class=\"text-center\">\n            <img ng-src=\"{{vm.channel.content_settings.podcast.image | trustedUrl}}\" class=\"img\" style=\"max-width:100%\">\n            <div><a href ng-click=\"vm.channel.content_settings.podcast.image = null\">Change</a></div>\n          </div>\n          <div ng-if=\"!vm.channel.content_settings.podcast.image\">\n            <upload-slot ng-model=\"vm.podcastImageFile\"\n                         ng-change=\"vm.uploadPodcastImage(vm.podcastImageFile)\"\n                         slot-name=\"'podcast-preview'\"\n                         allow-image=\"true\"\n                         allow-video=\"false\"\n                         compact=\"true\"></upload-slot>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"form-group col-xs-6\">\n          <label for=\"podcast_owner_name\">Owner Name:</label>\n          <input type=\"text\" class=\"form-control\" id=\"podcast_owner_name\" ng-model=\"vm.channel.content_settings.podcast.owner_name\">\n        </div>\n        <div class=\"form-group col-xs-6\">\n          <label for=\"podcast_owner_email\">Owner Email:</label>\n          <input type=\"text\" class=\"form-control\" id=\"podcast_owner_email\" ng-model=\"vm.channel.content_settings.podcast.owner_email\">\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"form-group col-xs-12\">\n          <label for=\"podcastSubtitle\">\n            Subtitle\n            <i class=\"fa fa-question-circle\" uib-tooltip=\"For best results, choose a subtitle that is only a few words long. Leave blank to use the channel description.\"></i>\n          </label>\n          <textarea rows=\"2\" class=\"form-control\" id=\"podcastSubtitle\" ng-model=\"vm.channel.content_settings.podcast.subtitle\" placeholder=\"{{ vm.channel.description }}\"></textarea>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"form-group col-xs-12\">\n          <label for=\"podcastSummary\">\n            Summary\n            <i class=\"fa fa-question-circle\" uib-tooltip=\"Leave blank to use the channel description.\"></i>\n          </label>\n          <textarea rows=\"2\" class=\"form-control\" id=\"podcastSummary\" ng-model=\"vm.channel.content_settings.podcast.summary\" placeholder=\"{{ vm.channel.description }}\"></textarea>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"form-group col-xs-12\">\n          <label ng-click=\"vm.channel.content_settings.podcast.explicit = !vm.channel.content_settings.podcast.explicit\" style=\"cursor:pointer\">\n            <i class=\"fa\" ng-class=\"vm.channel.content_settings.podcast.explicit ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n            Explicit?\n          </label>\n        </div>\n      </div>\n    </div>\n  </div><!-- end podcasting tab -->\n\n  <!-- Advanced Tab -->\n  <div ng-show=\"vm.activeTab == 'advanced'\">\n    <div ng-if=\"::vm.FeatureFlags.enterprise_last_mile_delivery\">\n      <label ng-click=\"vm.channel.content_settings.enterprise_last_mile_delivery = !vm.enterpriseLastMileDelivery()\" style=\"cursor:pointer\">\n        <i class=\"fa\" ng-class=\"vm.enterpriseLastMileDelivery() ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n        Enable Enterprise Last-Mile Delivery\n      </label>\n    </div>\n    <p style=\"margin:0 0 0 0;\"><strong>Channel ID</strong></p>\n    <p ng-if=\"vm.channel.id\" class=\"help-block\" style=\"font-family:monospace; margin:0 0 15px 0\">{{vm.channel.id}}</p>\n    <p ng-if=\"!vm.channel.id\" class=\"help-block\" style=\"margin:0 0 15px 0\"><small><em>Will be auto-generated when created.</em></small></p>\n\n    <p style=\"margin:0 0 0 0\"><strong>Content Settings Metadata</strong></p>\n    <p class=\"help-block\" style=\"margin-top:0;\"><small>Note: this metadata can be used when performing an API integration.\n    If you don't know what that means or how you would use it, it's safest to just leave this empty!</small></p>\n    <table class=\"table table-unstyled table-condensed\">\n      <tr ng-repeat=\"(key, value) in vm.channel.content_settings\"\n          ng-if=\"vm.allowContentSettingsEdit(key)\">\n        <td>\n          <input type=\"text\" readonly class=\"form-control input-sm\" ng-model=\"key\">\n        </td>\n        <td>\n          <input type=\"text\" class=\"form-control input-sm\" ng-model=\"value\" ng-change=\"vm.updateContentSettings(key, value)\" placeholder=\"Value\">\n        </td>\n        <td>\n          <a href class=\"action-link\" ng-click=\"vm.deleteContentSettings(key)\">\n            <i aria-label=\"Delete Key\" class=\"fa fa-trash\"></i>\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\">\n          <button class=\"btn btn-sm btn-default\" type=\"button\" ng-click=\"vm.addContentSettings()\">Add New Setting</button>\n        </td>\n      </tr>\n    </table>\n\n  </div><!-- end advanced tab -->\n\n</div>\n<div class=\"modal-footer\">\n  <a class=\"pull-left action-link\" href=\"javascript://\" ng-if=\"vm.channel.id\" ng-click=\"vm.delete()\">\n    <i aria-label=\"Delete Channel\" class=\"fa fa-trash\"></i> Delete Channel\n  </a>\n\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Close</button>\n  <button ng-if=\"vm.channel.id\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.update()\">Save Changes</button>\n  <button ng-if=\"!vm.channel.id\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.create()\">Create</button>\n</div>\n\n</form>\n"

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalCreateChannelController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_content_settings__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_pricing__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_password__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_validate__ = __webpack_require__(415);




var MAX_ZIP_CODE_FIELD_LENGTH = 60000; // gives you >8.5k zip codes in your list (more than CA + TX + PA)

function ModalCreateChannelController($uibModalInstance, $rootScope, ConfirmDialog, Channel, Podcast, toaster, channel, parentVM, minTicketPrice, defaultTicketPrice) {
  'ngInject';

  var _this = this;

  this.showError = false;
  this.FeatureFlags = $rootScope.account.feature_flags;
  this.ExtraFeatures = $rootScope.account.extra_features;
  this.MAX_ZIP_CODE_FIELD_LENGTH = MAX_ZIP_CODE_FIELD_LENGTH;

  if (this.FeatureFlags.no_public) {
    // If we don't allow public broadcasts (usually set for flex sites),
    // we need to demand that broadcasts accessed through a channel fall
    // through to the individual event configuration.
    this.showTicketedChannelSupport = true;
    this.showVisibility = false;
    this.visibility = 'public';
  } else if (this.FeatureFlags.no_ticketed) {
    // If we don't allow ticketed broadcasts, we don't show the visibility, but we also don't need
    // to show the support block about ticketed channels.
    this.showTicketedChannelSupport = false;
    this.showVisibility = false;
    this.visibility = 'public';
  } else {
    this.showTicketedChannelSupport = false;
    this.showVisibility = true;
    this.minTicketPrice = minTicketPrice;

    if (channel.free_variant == 'none') {
      this.visibility = 'ticketed';
    } else if (channel.free_variant == 'low') {
      this.visibility = 'flex';
    } else {
      this.visibility = 'public';
    }
  }

  this.limits = $rootScope.ApiConfig.modelFieldLimits('channel', 'maximum');
  this.channel = angular.copy(channel);
  this.channel.content_settings = this.channel.content_settings || {}; // Load content languages (and account default, if set).

  var langs = angular.copy($rootScope.ApiConfig.content_languages || []);
  var accountDefaultLanguage = $rootScope.account.content_settings.language;

  if (accountDefaultLanguage) {
    var accountDefaultLanguageLabel = (_.findWhere($rootScope.ApiConfig.content_languages || [], {
      value: accountDefaultLanguage
    }) || {}).label;

    if (accountDefaultLanguageLabel) {
      langs.unshift({
        value: '',
        label: "Use account default (".concat(accountDefaultLanguageLabel, ")")
      });
    }
  }

  this.contentLanguages = langs;

  if (!this.channel.content_settings.language) {
    this.channel.content_settings.language = '';
  }

  if (this.FeatureFlags.podcast) {
    // Load podcast categories
    Podcast.getCategories(function (result) {
      var podcastCategories = [];

      _.each(result, function (categories, code) {
        var category = categories[0];
        var subcategory = categories[1];

        if (category && subcategory) {
          podcastCategories.push({
            value: code,
            label: "".concat(category, " \u2014 ").concat(subcategory)
          });
        } else if (category) {
          podcastCategories.push({
            value: code,
            label: category
          });
        }
      });

      _this.podcastCategories = podcastCategories;
    }, function (error) {
      console.warn(error);
    }); // Set default placeholders

    var accountDisplayName = $rootScope.account.content_settings.display_name;
    this.defaultPodcastAuthor = accountDisplayName || $rootScope.account.name;
  } // Support for content settings editor


  this.allowContentSettingsEdit = function (key) {
    var isSupportedDataType = typeof key == 'string';
    return !_.includes(PROTECTED_CONTENT_SETTINGS_KEYS, key) && isSupportedDataType;
  };

  this.showContentSettings = _.filter(_.keys(this.channel.content_settings), this.allowContentSettingsEdit).length;

  this.addContentSettings = function () {
    var key = prompt('Enter the field key:');

    if (!key || !key.trim()) {
      return;
    } else if (typeof _this.channel.content_settings[key] != 'undefined') {
      toaster.pop('warning', "Unable to add new key: ".concat(key, " already exists."));
    } else {
      _this.channel.content_settings[key] = '';
    }
  };

  this.updateContentSettings = function (key, value) {
    _this.channel.content_settings[key] = value;
  };

  this.deleteContentSettings = function (key) {
    delete _this.channel.content_settings[key];
  };

  if (!this.channel.ticket_price) {
    this.channel.ticket_price = defaultTicketPrice;
  } // Podcast-related functions


  var checkAndSetPodcastOwner = function checkAndSetPodcastOwner() {
    var podcastSettings = _this.channel.content_settings.podcast || {};

    if (!podcastSettings.owner_email || !podcastSettings.owner_name) {
      podcastSettings.owner_email = ($rootScope.user || {}).email;
      podcastSettings.owner_name = ($rootScope.user || {}).name;
    }
  };

  var sanitizePodcastSettings = function sanitizePodcastSettings() {
    if (!_this.FeatureFlags.podcast) {
      delete _this.channel.content_settings.podcast;
      return;
    }

    var podcastSettings = _this.channel.content_settings.podcast || {};

    if (!podcastSettings.audio && !podcastSettings.video) {
      delete _this.channel.content_settings.podcast;
      return;
    }
  };

  this.showPodcastSettings = function () {
    var podcastSettings = _this.channel.content_settings.podcast || {};
    return podcastSettings.audio || podcastSettings.video;
  };

  this.toggleEnablePodcast = function (which) {
    var podcastSettings = _this.channel.content_settings.podcast || {};

    if (podcastSettings[which]) {
      delete _this.channel.content_settings.podcast[which];
    } else {
      if (!_this.channel.content_settings.podcast) _this.channel.content_settings.podcast = {};
      _this.channel.content_settings.podcast[which] = true;
      checkAndSetPodcastOwner();
    }
  };

  this.enterpriseLastMileDelivery = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_content_settings__["a" /* enterpriseLastMileDelivery */])(_this.channel);
  };

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this["delete"] = function () {
    var modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Delete Channel',
      actionButtonClass: 'danger',
      headerText: 'Please Confirm',
      bodyText: 'Are you sure you want to delete this channel? Any links or embed widgets you have pointing to it will become invalid.'
    };
    ConfirmDialog.show(modalOptions).then(function () {
      Channel["delete"]({
        id: _this.channel.id
      }, function () {
        parentVM.selectedChannel = null;
        parentVM.reload();

        _this.cancel();
      });
    });
  };

  var validate = function validate() {
    if (!_this.channel.name || !_this.visibility) {
      return false;
    }

    if (_this.visibility == 'ticketed' || _this.visibility == 'flex') {
      if (!_this.channel.ticket_price || _this.channel.ticket_price < minTicketPrice) {
        return false;
      }
    } // Check for valid video portal configuration


    _this.showInvalidPasswordForVideoPortal = false;
    _this.showInvalidVisibilityForVideoPortal = false;

    if (_this.ExtraFeatures.video_portal) {
      if (_this.visibility != 'public' && _this.channel.is_private === false) _this.showInvalidVisibilityForVideoPortal = true;
      if (_this.channel.is_private === false && _this.channel.content_settings.cryptblock) _this.showInvalidPasswordForVideoPortal = true;
    } // Look at possible password changes.


    Object(__WEBPACK_IMPORTED_MODULE_2__utils_password__["a" /* checkContentSettingsForChangesOnSave */])(_this.channel.content_settings); // Validate website URL

    _this.showWebsiteUrlError = false;

    if (_this.channel.content_settings.website && !Object(__WEBPACK_IMPORTED_MODULE_3__utils_validate__["a" /* isValidUrl */])(_this.channel.content_settings.website)) {
      _this.showWebsiteUrlError = true;
    }

    return !_this.showWebsiteUrlError && !_this.showInvalidVisibilityForVideoPortal && !_this.showInvalidPasswordForVideoPortal;
  };

  this.uploadPreviewImage = function (file) {
    file.upload().then(function (result) {
      _this.channel.content_settings = _this.channel.content_settings || {};
      _this.channel.content_settings.preview = result.view_url;
    });
  };

  this.uploadPodcastImage = function (file) {
    file.upload().then(function (result) {
      console.log('Podcast image uploaded', result);
      _this.channel.content_settings = _this.channel.content_settings || {};
      _this.channel.content_settings.podcast = _this.channel.content_settings.podcast || {};
      _this.channel.content_settings.podcast.image = result.view_url;
    });
  };

  this.update = function () {
    if (!validate()) {
      _this.showError = true;
      return;
    }

    _this.showError = false;

    if (!_this.channel.content_settings.language) {
      delete _this.channel.content_settings.language;
    }

    sanitizePodcastSettings();
    sanitizeGeoblockSettings(); // Third param tells our price settings it's a channel so it won't override is_private

    _this.channel = Object(__WEBPACK_IMPORTED_MODULE_1__utils_pricing__["b" /* updatePriceSettingsFromVisibilityOption */])(_this.channel, _this.visibility, true);
    Channel.update({
      id: channel.id
    }, _this.channel, function () {
      parentVM.reload();

      _this.cancel();
    }, function (error) {
      alert('Unable to create channel. Please refresh the page and try again.');
      console.warn(error);
    });
  };

  this.create = function () {
    if (!validate()) {
      _this.showError = true;
      return;
    }

    _this.showError = false;

    if (!_this.channel.content_settings.language) {
      delete _this.channel.content_settings.language;
    }

    sanitizePodcastSettings();
    sanitizeGeoblockSettings();
    _this.channel = Object(__WEBPACK_IMPORTED_MODULE_1__utils_pricing__["b" /* updatePriceSettingsFromVisibilityOption */])(_this.channel, _this.visibility, true);
    Channel.create(_this.channel, function (c) {
      parentVM.selectedChannel = c;
      parentVM.reload();

      _this.cancel();
    }, function (error) {
      alert('Unable to create channel. Please refresh the page and try again.');
      console.warn(error);
    });
  };

  this.getZipCodeListLength = function () {
    return ((_this.channel.content_settings.geoblock || {}).zip || '').length;
  };

  var sanitizeGeoblockSettings = function sanitizeGeoblockSettings() {
    if (_this.getZipCodeListLength() > MAX_ZIP_CODE_FIELD_LENGTH) {
      _this.channel.content_settings.geoblock.zip = _this.channel.content_settings.geoblock.zip.substr(0, MAX_ZIP_CODE_FIELD_LENGTH);
    }
  };
}

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidUrl;
function isValidUrl(str) {
  return str.match(/http(s)?:\/\/.?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contributors_html__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contributors_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__contributors_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contributors_js__ = __webpack_require__(418);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ContributorsController = /*#__PURE__*/_createClass(function ContributorsController() {
  'ngInject';

  _classCallCheck(this, ContributorsController);

  this.contributors = __WEBPACK_IMPORTED_MODULE_2__contributors_js__["a" /* default */];
});

var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('contributors', __WEBPACK_IMPORTED_MODULE_1__contributors_html___default.a, ContributorsController, 'ContributorsController');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\"> \n        <div class=\"well\">\n          <div class=\"row\">\n            <div class=\"col-xs-6 col-md-3\" ng-repeat=\"contributor in vm.contributors\">\n              <div class=\"thumbnail\">\n                <img class=\"img-circle\" ng-src=\"{{contributor.profile_img}}\" ng-alt=\"{{contributor.name}} headshot\">\n                <div class=\"caption\">\n                  <h3 class=\"h4\">{{contributor.name}}</h3>\n                  <p>{{contributor.title}}</p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </main>\n"

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var contributors = [{
  name: 'Jeremy Hutchcraft',
  title: 'Front End Developer',
  profile_img: 'https://i.imgur.com/g7gswnL.jpg'
}, {
  name: 'Greg DiPietro',
  title: 'Front End Developer',
  profile_img: 'https://pbs.twimg.com/profile_images/674262058226069505/43jnHbB2_400x400.jpg'
}, {
  name: 'Mike Griffith',
  title: 'Software Engineer',
  profile_img: 'https://avatars.githubusercontent.com/u/167782?v=4'
}];
/* harmony default export */ __webpack_exports__["a"] = (contributors);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__embed_html__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__embed_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__embed_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__embed__ = __webpack_require__(421);



var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('embed', __WEBPACK_IMPORTED_MODULE_1__embed_html___default.a, __WEBPACK_IMPORTED_MODULE_2__embed__["a" /* default */], 'EmbedController', '/embed?channel_id');

__webpack_require__(423);

/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\" ng-if=\"$root.account.showOnboarding() && !vm.isStreamMonkey\">\n    <onboarding upcoming-broadcasts=\"{}\" current-broadcasts=\"{}\" past-broadcasts=\"{}\"></onboarding>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <p class=\"pull-right hidden-xs\">\n        <a href=\"https://support.boxcast.com/en/articles/4235070\" target=\"_blank\" style=\"position:relative;bottom:-10px\">Need Help? Read our embed docs.</a>\n      </p>\n      <uib-tabset active=\"vm.activeTab\">\n        <uib-tab>\n          <uib-tab-heading>\n            Website Embed\n          </uib-tab-heading>\n          <div class=\"tab-container\">\n            <div class=\"\" style=\"background:#fff; padding:15px;\">\n              <div style=\"max-width:1000px\">\n\n                <div ng-if=\"!vm.FeatureFlags.highlights || vm.singleEvent\">\n                  <embed-broadcasts account=\"vm.account\"\n                                    channels=\"vm.channels\"\n                                    sources-combined=\"vm.sourcesCombined\"\n                                    show-preview=\"vm.showPreview\"\n                                    output=\"vm.output\"\n                                    ></embed-broadcasts>\n                </div>\n                <div ng-if=\"vm.FeatureFlags.highlights && !vm.singleEvent\">\n                  <div class=\"form-group\">\n                    <label>Media Type</label>\n                    <div>\n                      <div class=\"btn-group\">\n                        <label class=\"btn btn-default\" ng-model=\"vm.mediaType\" uib-btn-radio=\"'broadcasts'\" style=\"width:160px\">Broadcasts</label>\n                        <label class=\"btn btn-default\" ng-model=\"vm.mediaType\" uib-btn-radio=\"'highlights'\" style=\"width:160px\">Highlights</label>\n                      </div>\n                    </div>\n                  </div>\n                  <div ng-if=\"vm.mediaType == 'broadcasts'\">\n                    <embed-broadcasts account=\"vm.account\"\n                                      channels=\"vm.channels\"\n                                      sources-combined=\"vm.sourcesCombined\"\n                                      show-preview=\"vm.showPreview\"\n                                      output=\"vm.output\"\n                                      ></embed-broadcasts>\n                  </div>\n                  <div ng-if=\"vm.mediaType == 'highlights'\">\n                    <embed-highlights account=\"vm.account\"\n                                      channels=\"vm.channels\"\n                                      sources-combined=\"vm.sourcesCombined\"\n                                      show-preview=\"vm.showPreview\"\n                                      output=\"vm.output\"\n                                      ></embed-highlights>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n          </div>\n        </uib-tab>\n        <uib-tab>\n          <uib-tab-heading>\n            Other Integrations\n          </uib-tab-heading>\n          <div class=\"tab-container\">\n            <div class=\"\" style=\"background:#fff; padding:15px;\">\n              <div style=\"max-width:1000px\">\n                <embed-other account=\"vm.account\"\n                             channels=\"vm.channels\"\n                             sources-combined=\"vm.sourcesCombined\"\n                             show-preview=\"vm.showPreview\"\n                             output=\"vm.output\"\n                             ></embed-other>\n              </div>\n            </div>\n          </div>\n        </uib-tab>\n      </uib-tabset>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmbedController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_embed__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isStreamMonkey__ = __webpack_require__(10);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var EmbedController = /*#__PURE__*/function () {
  function EmbedController(Account, Channel, BoxCaster, StaticRTMP, $rootScope, $scope, $state, $q) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, EmbedController);

    this.$scope = $scope;
    this.$state = $state;
    this.Account = Account;
    this.Channel = Channel;
    this.BoxCaster = BoxCaster;
    this.StaticRTMP = StaticRTMP;
    this.$q = $q;
    this.account = $rootScope.account;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.m3u8Enabled = !$rootScope.account.extra_features.static_m3u8_disabled && $rootScope.user.can('embed', 'broadcast/*:m3u8');
    var ApiConfig = $rootScope.ApiConfig;
    this.defaultTicketPrice = ApiConfig.ticket.default_price;
    this.minTicketPrice = ApiConfig.ticket.minimum_price;
    this.activeTab = 0;
    this.mediaType = 'broadcasts';
    this.isStreamMonkey = Object(__WEBPACK_IMPORTED_MODULE_1__utils_isStreamMonkey__["a" /* default */])(this.account.migration_service_id); // Output of embed directive

    this.output = {
      type: 'all',
      channelId: null,
      title: true,
      description: true,
      related: true,
      embedType: 'javascript',
      args: {
        applyBrandColor: true,
        showTitleAndDescription: true,
        showTitle: true,
        showDescription: true,
        showHighlights: false,
        showRelated: true,
        defaultVideo: 'next'
      },
      boxcastLink: '',
      boxcastTVLink: '',
      all_m3u8: '',
      source_m3u8: '',
      channel_m3u8: '',
      single_m3u8: '',
      layout: 'player-with-playlist',
      integrationType: '',
      //force selection
      mediaType: 'rss'
    };

    if (this.$state.params.channel_id) {
      this.output.type = 'channel';
      this.output.channelId = this.$state.params.channel_id;
    }

    $scope.$watch(function () {
      return [_this.activeTab, _this.output.type, _this.output.channelId, _this.output.title, _this.output.description, _this.output.related, _this.output.args, _this.output.all_m3u8, _this.output.source_m3u8, _this.output.channel_m3u8, _this.output.single_m3u8];
    }, function (newVal, oldVal) {
      var _newVal = _slicedToArray(newVal, 11),
          activeTab = _newVal[0],
          type = _newVal[1],
          channelId = _newVal[2],
          title = _newVal[3],
          description = _newVal[4],
          related = _newVal[5],
          args = _newVal[6],
          all_m3u8 = _newVal[7],
          source_m3u8 = _newVal[8],
          channel_m3u8 = _newVal[9],
          single_m3u8 = _newVal[10];

      _this.output.embedCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3WidgetEmbed(channelId, args);
      _this.output.iframeCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3IframeEmbed(channelId, args);
      _this.output.linkCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Link(channelId, args);
      _this.output.appCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3App(channelId, args);
      _this.output.highlightsCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Highlights(channelId, args);
      _this.output.rss3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Rss(channelId, args);
      _this.output.audioMRSS3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3MRSS(channelId, 'audio', args);
      _this.output.videoMRSS3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3MRSS(channelId, 'video', args);
      _this.output.rokuDirectPublisher = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].rokuDirectPublisher(channelId, args);
      _this.output.audioPodcast3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Podcast(channelId, 'audio', args);
      _this.output.videoPodcast3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Podcast(channelId, 'video', args);
      _this.output.boxcastLink = BOXCAST_SHOW_URL + channelId;
      _this.output.boxcastTVLink = BOXCAST_TV_SHOW_URL + channelId;

      if (type == 'all') {
        _this.output.m3u8 = all_m3u8;
      } else if (type == 'source') {
        _this.output.m3u8 = source_m3u8;
      } else if (type == 'channel') {
        _this.output.m3u8 = channel_m3u8;
      } else if (type == 'single') {
        _this.output.m3u8 = single_m3u8;
      }
    }, true);
    this.reload();
  }

  _createClass(EmbedController, [{
    key: "reload",
    value: function reload() {
      var _this2 = this;

      var account = this.account,
          FeatureFlags = this.FeatureFlags,
          $q = this.$q,
          m3u8Enabled = this.m3u8Enabled;
      this.mediaTokenRestrictions = account.extra_features.media_token_restrictions;

      if (!this.output.channelId) {
        this.output.channelId = account.channel_id;
        this.output.all_m3u8 = account.static_playlist_url;
      }

      this.output.args.market = account.market;
      this.loadingPromises = [];
      this.channels = this.Channel.query({
        l: 1000
      }, function () {
        var found = false;

        if (_this2.output.channelId) {
          var channel = _.find(_this2.channels, function (c) {
            return c.id === _this2.output.channelId;
          });

          if (channel) {
            _this2.output.channel = channel;
            found = true;
          }
        }

        if (!found) {
          _this2.output.channel = _.first(_this2.channels);
        }

        if (m3u8Enabled || FeatureFlags.podcast) {
          _this2.output.channel_m3u8 = '';

          _this2.loadingPromises.push(_this2.Channel.get({
            id: _this2.output.channelId
          }, function (c) {
            _this2.output.channel = c;
            _this2.output.channel_m3u8 = c.static_playlist_url;
          }).$promise);
        }
      });
      this.loadingPromises.push(this.channels.$promise);
      this.boxcasters = this.BoxCaster.query({
        l: 1000,
        s: 'name'
      });
      this.staticRTMPs = this.StaticRTMP.query({
        l: 1000,
        s: 'name'
      });
      this.loadingPromises.push($q.all([this.boxcasters.$promise, this.staticRTMPs.$promise]).then(function () {
        _this2.boxcasters.forEach(function (b) {
          return b.type = 'boxcaster';
        });

        _this2.staticRTMPs.forEach(function (s) {
          return s.type = 'static_rtmp';
        });

        _this2.sourcesCombined = _this2.boxcasters.concat(_this2.staticRTMPs);
        _this2.output.source = _.first(_this2.sourcesCombined);
      }));
    }
  }]);

  return EmbedController;
}();



/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/* jshint ignore:start */
var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

var Base64 = /*#__PURE__*/function () {
  function Base64() {
    _classCallCheck(this, Base64);
  }

  _createClass(Base64, [{
    key: "encode",
    value: function encode(input) {
      var output = '';
      var chr1,
          chr2,
          chr3 = '';
      var enc1,
          enc2,
          enc3,
          enc4 = '';
      var i = 0;

      do {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }

        output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);

      return output;
    }
  }, {
    key: "decode",
    value: function decode(input) {
      var output = '';
      var chr1,
          chr2,
          chr3 = '';
      var enc1,
          enc2,
          enc3,
          enc4 = '';
      var i = 0; // remove all characters that are not A-Z, a-z, 0-9, +, /, or =

      var base64test = /[^A-Za-z0-9\+\/\=]/g;

      if (base64test.exec(input)) {
        window.alert('There were invalid base64 characters in the input text.\n' + "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" + 'Expect errors in decoding.');
      }

      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

      do {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output = output + String.fromCharCode(chr1);

        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }

        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }

        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);

      return output;
    }
  }]);

  return Base64;
}();

var base64 = new Base64();
/* harmony default export */ __webpack_exports__["a"] = (base64);
/* jshint ignore:end */

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_embed__ = __webpack_require__(29);

var module = angular.module('embed');
module.component('embedBroadcasts', {
  bindings: {
    account: '=',
    sourcesCombined: '=',
    channels: '=',
    output: '=',
    // Fix data flow
    singleEvent: '=?'
  },
  template: __webpack_require__(424),
  controllerAs: 'vm',
  controller: EmbedDirectiveController
});
module.component('embedHighlights', {
  bindings: {
    account: '=',
    sourcesCombined: '=',
    channels: '=',
    output: '=',
    // Fix data flow
    singleEvent: '=?'
  },
  template: __webpack_require__(425),
  controllerAs: 'vm',
  controller: EmbedDirectiveController
});
module.component('embedOther', {
  bindings: {
    account: '=',
    sourcesCombined: '=',
    channels: '=',
    output: '=',
    // Fix data flow
    singleEvent: '=?'
  },
  template: __webpack_require__(426),
  controllerAs: 'vm',
  controller: EmbedDirectiveController
});
module.component('embedSelectBroadcasts', {
  bindings: {
    parentVM: '=parentVm',
    mode: '@',
    hideAll: '=',
    hideChannels: '=',
    hideSources: '=',
    hideSingleBroadcast: '=',
    broadcastValidator: '='
  },
  controllerAs: 'vm',
  controller: function controller() {
    var _this = this;

    this.$onInit = function () {
      if (_this.mode == 'highlights') {
        _this.label = 'Highlights';
      } else {
        _this.label = 'Broadcasts';
      }
    }; // Fake the EditOrCreateEventService for purposes on the <recording-source-chooser />


    this.service = {
      sourceBroadcast: null,
      sourceBroadcastUnavailable: null,
      broadcast: {},
      updateSourceBroadcast: function updateSourceBroadcast(b) {
        return _this.service.sourceBroadcast = b;
      }
    };
  },
  template: __webpack_require__(427)
});
module.component('embedCopyPaste', {
  bindings: {
    parentVM: '=parentVm',
    type: '@'
  },
  controllerAs: 'vm',
  template: __webpack_require__(428)
});
module.component('embedAdvancedSettings', {
  bindings: {
    parentVM: '=parentVm'
  },
  controllerAs: 'vm',
  template: __webpack_require__(429)
});

function EmbedDirectiveController($uibModal, $scope, $rootScope, Account, BoxCaster, StaticRTMP, Broadcast, Channel, clipboard) {
  'ngInject';

  var _this2 = this;

  this.FeatureFlags = $rootScope.account.feature_flags;
  this.showHighlights = !!this.FeatureFlags.highlights;
  this.m3u8Enabled = !$rootScope.account.extra_features.static_m3u8_disabled && $rootScope.user.can('embed', 'broadcast/*:m3u8');
  this.BoxCaster = BoxCaster;
  this.StaticRTMP = StaticRTMP;
  this.Broadcast = Broadcast;
  this.Channel = Channel;

  this.$onInit = function () {
    _this2.changeLayout(_this2.output.layout);
  }; // Set embed defaults based on account content settings


  var a = $rootScope.account;
  var cs = a.content_settings;
  if (cs.showDonations) this.output.args.showDonations = true;
  if (cs.showCountdown) this.output.args.showCountdown = true;

  if (cs.poster) {
    this.showPoster = true;
    this.output.args.poster = cs.poster;
  }

  if (cs.customPreroll) {
    this.showPreroll = true;
    this.output.args.customPreroll = cs.customPreroll;
  }

  this.showAutoplayOptions = !!this.output.args.autoplay;
  $scope.clipboard = clipboard; //isolate scope here to didn't inherit this from $rootScope

  $scope.$watch(function () {
    return _this2.output.args.market;
  }, function (market) {
    return _this2.showVersionOverride = market == 'internal';
  });
  this.showPreroll = false;
  this.showPoster = false;

  this.showPodcastOption = function (which) {
    if (!_this2.FeatureFlags.podcast) return false;
    if (_this2.output.type != 'channel') return false;
    if (!_this2.output.channel) return false;
    if (_this2.output.channel.id !== _this2.output.channelId) return false;
    return true;
  };

  this.allowPodcastForChannel = function (which) {
    if (!_this2.showPodcastOption(which)) return false;
    var ccs = _this2.output.channel.content_settings || {};
    if (!ccs.podcast) return false;
    if (!which) return true;
    return ccs.podcast[which];
  };

  var ngResources = {};

  this.clearPrerollIfNecessary = function () {
    if (!_this2.showPreroll) delete _this2.output.args.customPreroll;
  };

  this.clearPosterIfNecessary = function () {
    if (!_this2.showPoster) delete _this2.output.args.poster;
  };

  this.clearPlayerVersionIfNecessary = function () {
    if (!_this2.showPlayerVersion) delete _this2.output.args.version;
  };

  var checkAndUnselectPodcast = function checkAndUnselectPodcast() {
    if ((_this2.output.embedType === 'audio-podcast' || _this2.output.embedType === 'video-podcast') && !_this2.allowPodcastForChannel()) {
      // User had 'Podcast' selected, but that is no longer valid.
      _this2.output.embedType = 'javascript';
    }
  };

  this.selectAllBroadcasts = function () {
    _this2.output.channelId = _this2.account.channel_id;
    _this2.output.all_m3u8 = _this2.account.static_playlist_url;
    checkAndUnselectPodcast();
  };

  this.selectCustomChannel = function (channel) {
    _this2.output.type = 'channel';
    _this2.output.channel = channel;
    if (!channel) return;
    _this2.output.channelId = channel.id;

    if (_this2.m3u8Enabled || _this2.FeatureFlags.podcast) {
      _this2.output.channel_m3u8 = '';
      ngResources.channel = _this2.Channel.get({
        id: _this2.output.channelId
      }, function (c) {
        if (channel.id != c.id) return; //race condition

        _this2.output.channel = c;
        _this2.output.channel_m3u8 = c.static_playlist_url;
        checkAndUnselectPodcast();
      });
    } else {
      checkAndUnselectPodcast();
    }
  };

  this.selectOneSource = function (source) {
    _this2.output.type = 'source';
    _this2.output.source = source;
    if (!source) return;
    _this2.output.sourceId = source.id;
    _this2.output.channelId = source.channel_id;

    if (_this2.m3u8Enabled) {
      _this2.output.source_m3u8 = '';

      if (source.type == 'boxcaster') {
        ngResources.boxcaster = _this2.BoxCaster.get({
          id: _this2.output.sourceId
        }, function (b) {
          if (source.id != b.id) return; //race condition

          _this2.output.source_m3u8 = b.static_playlist_url;
        });
      } else if (source.type == 'static_rtmp') {
        ngResources.staticRTMP = _this2.StaticRTMP.get({
          id: _this2.output.sourceId
        }, function (s) {
          if (source.id != s.id) return; //race condition

          _this2.output.source_m3u8 = s.static_playlist_url;
        });
      }
    }

    checkAndUnselectPodcast();
  };

  this.selectSingleBroadcast = function (broadcast) {
    //console.log('selecting single broadcast', broadcast.id);
    _this2.output.broadcast = broadcast;

    if (!broadcast) {
      _this2.output.broadcastId = '';
      _this2.output.channelId = '';
      _this2.output.single_m3u8 = '';
      checkAndUnselectPodcast();
      return;
    }

    _this2.output.broadcastId = broadcast.id;
    _this2.output.channelId = broadcast.channel_id;

    if (_this2.m3u8Enabled) {
      _this2.output.single_m3u8 = '';
      ngResources.broadcast = _this2.Broadcast.get({
        id: _this2.output.broadcastId
      }, function (b) {
        if (broadcast.id != b.id) return; //race condition

        _this2.output.single_m3u8 = b.static_playlist_url;
      });
    }

    checkAndUnselectPodcast();
  };

  this.validateBroadastSelection = function (b) {
    // block ticketed broadcasts from static m3u8
    if (_this2.output.integrationType == 'm3u8') {
      if (b.is_ticketed) {
        throw new Error('This broadcast is ticketed, which is not supported by static M3U8.');
      }
    }
  };

  this.changeAutoplayOptions = function () {
    if (_this2.output.args.autoplay === 'try-muted') {
      _this2._savePlayInline = _this2.output.args.playInline;
      _this2.output.args.playInline = true;
      _this2.disablePlayInline = true;
    } else {
      _this2.output.args.playInline = _this2._savePlayInline;
      delete _this2._savePlayInline;
      delete _this2.disablePlayInline;
    }
  };

  this.showHideAutoplayOptions = function () {
    if (_this2.showAutoplayOptions) {
      _this2._lastAutoplay = _this2.output.args.autoplay;
      delete _this2.output.args.autoplay;
      _this2.showAutoplayOptions = false;
    } else {
      if (_this2._lastAutoplay) {
        _this2.output.args.autoplay = _this2._lastAutoplay;
        delete _this2._lastAutoplay;
      } else {
        _this2.output.args.autoplay = 'true';
      }

      _this2.showAutoplayOptions = true;
    }

    _this2.changeAutoplayOptions();
  };

  this.loading = function () {
    function check(ngResourceObj) {
      return ngResourceObj && ngResourceObj.$promise && !ngResourceObj.$resolved;
    }

    return check(ngResources.boxcaster) || check(ngResources.broadcast) || check(ngResources.channel);
  };

  this.formatSourceOpt = function (b) {
    if (b.type == 'boxcaster') {
      return "".concat(b.name, " (").concat(b.status, ")");
    } else {
      return "RTMP: ".concat(b.name);
    }
  };

  this.formatBroadcastOpt = function (b) {
    var starts_at = moment(b.starts_at).format('lll');
    return "".concat(b.name, " (").concat(starts_at, ")");
  };

  this.showPreview = function (type) {
    // NOTE: v3 needs special argument to be previewable on dashboard without
    // intpreting our window.location.hash as part of a redirect
    var args = angular.copy(_this2.output.args);
    args.disableRedirectRulesOnLoad = true;
    var script;

    if (type == 'highlights') {
      script = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Highlights(_this2.output.channelId, args);
    } else {
      script = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3WidgetEmbed(_this2.output.channelId, args);
    }

    $uibModal.open({
      size: 'lg',
      template: __webpack_require__(430),
      controller: function controller($scope, $uibModalInstance, $timeout) {
        'ngInject';

        $scope.cancel = function () {
          return $uibModalInstance.dismiss('cancel');
        };

        $timeout(function () {
          return iframeify(script);
        });
      }
    });
  };

  this.uploadPoster = function (file) {
    file.upload().then(function (response) {
      _this2.output.args.poster = response.view_url;
    });
  };

  this.uploadCustomPreroll = function (file) {
    file.upload().then(function (response) {
      _this2.output.args.customPreroll = response.view_url;
    });
  };

  this.showSDKs = function () {
    _this2.output.integrationType = 'sdk';
  };

  this.changeLayout = function (layout) {
    // toggle appropriate advanced settings
    if (layout == 'player-only') {
      _this2.output.args.showTitleAndDescription = false;
      _this2.output.args.showDocuments = false;
      _this2.output.args.showIndex = false;
      _this2.output.args.showRelated = false;
      _this2.output.args.showHighlights = false;
      _this2.output.args.playlistOnRight = false;
      _this2.output.args.showDonations = false; // always hide donations because it would cause title to appear

      delete _this2.output.args.showChat;
    } else if (layout == 'player-and-title') {
      _this2.output.args.showTitleAndDescription = true;
      _this2.output.args.showDocuments = false;
      _this2.output.args.showIndex = false;
      _this2.output.args.showRelated = false;
      _this2.output.args.showHighlights = false;
      _this2.output.args.playlistOnRight = false;
      _this2.output.args.showDonations = !!cs.showDonations; // default to account content settings

      delete _this2.output.args.showChat;
    } else if (layout == 'player-with-playlist') {
      _this2.output.args.showTitleAndDescription = true;
      _this2.output.args.showDocuments = true;
      _this2.output.args.showIndex = true;
      _this2.output.args.showRelated = true;
      _this2.output.args.showHighlights = true;
      _this2.output.args.playlistOnRight = true;
      _this2.output.args.showDonations = !!cs.showDonations; // default to account content settings

      if (_this2.FeatureFlags.viewer_chat) {
        _this2.output.args.showChat = true;
      }
    }
  };

  this.checkFilterForIntegration = function (integrationType) {
    if (integrationType == 'feeds') {
      // single broadcast filter is not supported
      if (_this2.output.type == 'single') {
        _this2.output.type = 'all';
      }
    } else if (integrationType == 'podcast') {
      // the only valid option is a channel filter
      if (_this2.output.type != 'channel') {
        _this2.selectCustomChannel(_this2.channels[0]);
      }
    } else if (integrationType == 'm3u8') {// all filter options are supported
    } else if (integrationType == 'app') {// all filter options are supported
    }
  };

  this.outputCode = function (type) {
    if (type == 'broadcasts') {
      if (_this2.output.embedType == 'javascript') {
        return _this2.output.embedCode3;
      } else if (_this2.output.embedType == 'iframe') {
        return _this2.output.iframeCode3;
      } else if (_this2.output.embedType == 'link') {
        return _this2.output.linkCode3;
      }
    } else if (type == 'highlights') {
      return _this2.output.highlightsCode3;
    } else if (type == 'other') {
      if (_this2.output.integrationType == 'app') {
        return _this2.output.appCode3;
      } else if (_this2.output.integrationType == 'm3u8') {
        return _this2.output.m3u8;
      } else if (_this2.output.integrationType == 'feeds' && _this2.output.mediaType == 'rss') {
        return _this2.output.rss3;
      } else if (_this2.output.integrationType == 'feeds' && _this2.output.mediaType == 'audio-mrss') {
        return _this2.output.audioMRSS3;
      } else if (_this2.output.integrationType == 'feeds' && _this2.output.mediaType == 'video-mrss') {
        return _this2.output.videoMRSS3;
      } else if (_this2.output.integrationType == 'feeds' && _this2.output.mediaType == 'roku-direct-publisher') {
        return _this2.output.rokuDirectPublisher;
      } else if (_this2.output.integrationType == 'podcast' && _this2.output.mediaType == 'audio-podcast') {
        return _this2.output.audioPodcast3;
      } else if (_this2.output.integrationType == 'podcast' && _this2.output.mediaType == 'video-podcast') {
        return _this2.output.videoPodcast3;
      }
    }
  };

  this.copyLabel = function (type) {
    if (type == 'broadcasts') {
      if (_this2.output.embedType == 'link') {
        return 'Copy this Link to Share';
      } else {
        return 'Copy & Paste into your Website';
      }
    } else if (type == 'highlights') {
      return 'Copy & Paste into your Website';
    } else if (type == 'other') {
      if (_this2.output.integrationType == 'app') {
        return 'Copy this Web View URL';
      } else if (_this2.output.integrationType == 'm3u8') {
        return 'Copy this M3U8 URL';
      } else if (_this2.output.integrationType == 'podcast') {
        return 'Copy this Feed URL';
      } else if (_this2.output.integrationType == 'feeds') {
        return 'Copy this Feed URL';
      }
    }
  };

  this.showPreviewEmbed = function (type) {
    if (type == 'broadcasts' || type == 'highlights') {
      if (_this2.output.embedType == 'link') {
        return false;
      }

      return true;
    }

    return false;
  };
}

function iframeify(script) {
  var iframe = document.createElement('iframe');
  iframe.style.border = 'none';
  iframe.style.width = '100%';
  iframe.src = '/404-just-so-i-have-right-protocol-on-window';
  $('#modal-preview-script').html(iframe);
  setTimeout(function () {
    var doc;

    if (iframe.contentDocument) {
      // FF Chrome
      doc = iframe.contentDocument;
    } else if (iframe.contentWindow) {
      // IE
      doc = iframe.contentWindow.document;
    }

    doc.open(); //'text/htmlreplace');

    doc.write('<link rel="stylesheet" href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css" integrity="sha384-1q8mTJOASx8j1Au+a5WDVnPi2lkFfwwEAa8hDDdjZlpLegxhjVME1fgjWPGmkzs7" crossorigin="anonymous">');
    doc.write(script);
    doc.write('<script src="//js.boxcast.com/libs/iframeResizer-3.5.2.contentWindow.min.js"></script>');
    doc.close();
    setTimeout(function () {
      return $(iframe).iFrameResize();
    }, 0);
  }, 0);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"vm.mediaTokenRestrictions\">\n  <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px\">\n    Your account has a custom authentication mechanism enabled.  Please note that the standard embed code\n    is unlikely to function properly as a result, and you should instead rely on the custom API integration.\n  </div>\n</div>\n\n<div ng-if=\"!vm.singleEvent\">\n  <div class=\"form-group\">\n    <label>Filter</label>\n    <embed-select-broadcasts parent-vm=\"vm\"></embed-select-broadcasts>\n  </div>\n</div>\n\n<div class=\"form-group\">\n  <label>\n    Integration Method\n    <i class=\"fa fa-question-circle\" uib-tooltip=\"The JavaScript widget is preferred, but you may need to use the Inline\n      Frame if your web site does not allow script tags or if you have conflicting libraries that cause the video player\n      to not function correctly.\"></i>\n  </label>\n  <div>\n    <div class=\"btn-group\">\n      <label class=\"btn btn-default\"\n            ng-model=\"vm.output.embedType\"\n            style=\"width:160px\"\n            uib-btn-radio=\"'javascript'\">JavaScript</label>\n      <label class=\"btn btn-default\"\n            ng-model=\"vm.output.embedType\"\n            style=\"width:160px\"\n            uib-btn-radio=\"'iframe'\">Inline Frame</label>\n      <label class=\"btn btn-default\"\n            ng-if=\"!vm.mediaTokenRestrictions\"\n            ng-model=\"vm.output.embedType\"\n            ng-click=\"vm.showAdvancedFeatures = false\"\n            style=\"width:160px\"\n            uib-btn-radio=\"'link'\">Link</label>\n    </div>\n  </div>\n  <div class=\"checkbox\" ng-if=\"vm.output.embedType === 'iframe'\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.output.args.iframeResize\"> Auto-Resize Inline Frame\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"Please note that this requires JavaScript\"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"vm.output.embedType === 'link'\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.output.args.applyBrandColor\"> Apply Brand Color\n    </label>\n  </div>\n</div>\n\n<div class=\"form-group\" ng-if=\"vm.output.embedType == 'javascript' || vm.output.embedType == 'iframe' || vm.output.embedType == 'app'\">\n  <label>Layout</label>\n  <div>\n    <div class=\"btn-group\">\n      <label class=\"btn btn-default btn-square\"\n          ng-model=\"vm.output.layout\"\n          uib-btn-radio=\"'player-with-playlist'\"\n          ng-click=\"vm.changeLayout('player-with-playlist')\"\n          style=\"width:160px\">\n        <img class=\"img\" src=\"/img/embed-player-with-playlist.png\">\n        <small>Full Featured</small>\n      </label>\n      <label class=\"btn btn-default btn-square\"\n          ng-model=\"vm.output.layout\"\n          uib-btn-radio=\"'player-and-title'\"\n          ng-click=\"vm.changeLayout('player-and-title')\"\n          style=\"width:160px\">\n        <img class=\"img\" src=\"/img/embed-player-and-title.png\">\n        <small>Player + Description</small>\n      </label>\n      <label class=\"btn btn-default btn-square\"\n          ng-model=\"vm.output.layout\"\n          uib-btn-radio=\"'player-only'\"\n          ng-click=\"vm.changeLayout('player-only')\"\n          style=\"width:160px\">\n        <img class=\"img\" src=\"/img/embed-player-only.png\">\n        <small>Player</small>\n      </label>\n    </div>\n  </div>\n</div>\n\n<div class=\"form-group\" ng-if=\"vm.output.embedType == 'javascript' || vm.output.embedType == 'iframe' || vm.output.embedType == 'app'\">\n  <strong><a href=\"javascript://\" ng-click=\"vm.showAdvancedFeatures = !vm.showAdvancedFeatures\">Advanced Settings &gt;&gt;</a></strong>\n</div>\n<div class=\"form-group\" ng-if=\"vm.showAdvancedFeatures\">\n  <embed-advanced-settings parent-vm=\"vm\"></embed-advanced-settings>\n</div>\n\n<div class=\"form-group\" ng-hide=\"vm.output.type == 'single' && !vm.output.channelId\">\n  <embed-copy-paste type=\"broadcasts\" parent-vm=\"vm\"></embed-copy-paste>\n</div>\n"

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"vm.mediaTokenRestrictions\">\n  <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px\">\n    Your account has a custom authentication mechanism enabled.  Please note that the standard embed code\n    is unlikely to function properly as a result, and you should instead rely on the custom API integration.\n  </div>\n</div>\n\n<div class=\"form-group\">\n  <label>Filter</label>\n  <embed-select-broadcasts mode=\"highlights\" parent-vm=\"vm\"></embed-select-broadcasts>\n</div>\n\n<div ng-hide=\"!vm.output.channelId\">\n  <div class=\"form-group\">\n    <embed-copy-paste type=\"highlights\" parent-vm=\"vm\"></embed-copy-paste>\n  </div>\n</div>\n"

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\n  <label>Integration Type</label>\n  <div class=\"integration-type-controls\">\n    <div class=\"btn-group\">\n      <label class=\"btn btn-default btn-square\"\n             ng-if=\"::!vm.singleEvent\"\n             ng-model=\"vm.output.integrationType\"\n             ng-click=\"vm.checkFilterForIntegration('sdk')\"\n             uib-btn-radio=\"'sdk'\">API / SDK Integration</label>\n      <label class=\"btn btn-default btn-square\"\n             ng-if=\"::$root.account.feature_flags.podcast && !vm.singleEvent\"\n             ng-model=\"vm.output.integrationType\"\n             ng-click=\"vm.checkFilterForIntegration('feeds')\"\n             uib-btn-radio=\"'feeds'\">RSS, MRSS, or JSON Feed</label>\n      <label class=\"btn btn-default btn-square\"\n             ng-if=\"$root.account.feature_flags.podcast && !vm.singleEvent && vm.channels.length\"\n             ng-model=\"vm.output.integrationType\"\n             ng-click=\"vm.checkFilterForIntegration('podcast')\"\n             uib-btn-radio=\"'podcast'\">Podcast Feed</label>\n      <label class=\"btn btn-default btn-square\"\n             ng-if=\"::vm.m3u8Enabled\"\n             ng-model=\"vm.output.integrationType\"\n             ng-click=\"vm.checkFilterForIntegration('m3u8')\"\n             uib-btn-radio=\"'m3u8'\">Static M3U8</label>\n      <label class=\"btn btn-default btn-square\"\n             ng-model=\"vm.output.integrationType\"\n             ng-click=\"vm.checkFilterForIntegration('app')\"\n             uib-btn-radio=\"'app'\">Web View (Third-Party App)</label>\n    </div>\n\n    <div ng-if=\"vm.output.integrationType == 'app'\" class=\"integration-type-controls__info\">\n      <div style=\"padding:10px; border:1px solid;\" class=\"bg-info text-info text-sm\">\n        <i class=\"fa fa-info-circle\"></i>\n        Web Views can be useful for integrating with apps like Subsplash. For more control, consider an API integration <a href=\"javascript://\" ng-click=\"vm.showSDKs()\">using one of our supported SDKs</a>.\n      </div>\n    </div>\n    <div class=\"clearfix\"></div>\n  </div>\n</div>\n\n<div class=\"form-group\" ng-hide=\"vm.singleEvent || !vm.output.integrationType || vm.output.integrationType == 'sdk'\">\n  <label>Filter Broadcasts</label>\n  <embed-select-broadcasts\n    parent-vm=\"vm\"\n    hide-all=\"vm.output.integrationType == 'podcast'\"\n    hide-sources=\"vm.output.integrationType == 'podcast'\"\n    hide-single-broadcast=\"vm.output.integrationType == 'podcast' || vm.output.integrationType == 'feeds'\"\n    broadcast-validator=\"vm.validateBroadastSelection\"\n    ></embed-select-broadcasts>\n</div>\n\n<div ng-if=\"vm.output.integrationType == 'app'\">\n  <div class=\"form-group\">\n    <label>Layout</label>\n    <div>\n      <div class=\"btn-group\">\n        <label class=\"btn btn-default btn-square\"\n            ng-model=\"vm.output.layout\"\n            uib-btn-radio=\"'player-with-playlist'\"\n            ng-click=\"vm.changeLayout('player-with-playlist')\"\n            style=\"width:160px\">\n          <img class=\"img\" src=\"/img/embed-player-with-playlist.png\">\n          <small>Full Featured</small>\n        </label>\n        <label class=\"btn btn-default btn-square\"\n            ng-model=\"vm.output.layout\"\n            uib-btn-radio=\"'player-and-title'\"\n            ng-click=\"vm.changeLayout('player-and-title')\"\n            style=\"width:160px\">\n          <img class=\"img\" src=\"/img/embed-player-and-title.png\">\n          <small>Player + Description</small>\n        </label>\n        <label class=\"btn btn-default btn-square\"\n            ng-model=\"vm.output.layout\"\n            uib-btn-radio=\"'player-only'\"\n            ng-click=\"vm.changeLayout('player-only')\"\n            style=\"width:160px\">\n          <img class=\"img\" src=\"/img/embed-player-only.png\">\n          <small>Player</small>\n        </label>\n      </div>\n    </div>\n  </div>\n  <div class=\"form-group\" ng-if=\"vm.output.embedType == 'javascript' || vm.output.embedType == 'iframe' || vm.output.embedType == 'app'\">\n    <strong><a href=\"javascript://\" ng-click=\"vm.showAdvancedFeatures = !vm.showAdvancedFeatures\">Advanced Settings &gt;&gt;</a></strong>\n  </div>\n  <div class=\"form-group\" ng-if=\"vm.showAdvancedFeatures\">\n    <embed-advanced-settings parent-vm=\"vm\"></embed-advanced-settings>\n  </div>\n</div>\n\n<div ng-hide=\"vm.output.type == 'single' && !vm.output.broadcast\">\n\n  <div class=\"form-group\" ng-if=\"vm.output.integrationType == 'podcast'\">\n    <label>Feed Type</label>\n    <div>\n      <div class=\"btn-group\">\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'audio-podcast'\">Audio Podcast</label>\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'video-podcast'\">Video Podcast</label>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"form-group\" ng-if=\"vm.output.integrationType == 'feeds'\">\n    <label>Feed Type</label>\n    <div>\n      <div class=\"btn-group\">\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'rss'\">RSS With Links</label>\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'audio-mrss'\">Audio MRSS</label>\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'video-mrss'\">Video MRSS</label>\n        <label class=\"btn btn-default btn-square\" ng-model=\"vm.output.mediaType\" uib-btn-radio=\"'roku-direct-publisher'\">Roku Direct Publisher</label>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.output.integrationType === 'm3u8'\">\n    <div class=\"text-warning bg-warning\" style=\"border:1px solid; padding:10px; margin:15px 0;\">\n      <i class=\"fa fa-warning\"></i> This URL can be used for integration into certain third party app providers.  It\n      should <em>never</em> be distributed directly to viewers. Also be aware that the use of this URL for watching\n      the broadcast will skew your analytics.  If you would like to retain analytics, your app should be updated to\n      use one of the supported <a href=\"javascript://\" ng-click=\"vm.showSDKs()\">BoxCast SDKs</a>.\n      <div style=\"margin-top:15px\">\n        <span ng-click=\"vm.output.showM3U8Confirmed = true\" style=\"cursor:pointer; font-weight:bold;\">\n          <i class=\"fa\" ng-class=\"{ 'fa-square-o': !vm.output.showM3U8Confirmed, 'fa-check-square-o': vm.output.showM3U8Confirmed }\"></i>\n          I understand, show me the URL.\n        </span>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.output.integrationType == 'podcast'\">\n    <div ng-if=\"vm.output.mediaType == 'audio-podcast' && !vm.allowPodcastForChannel('audio')\">\n      <div class=\"text-warning bg-warning\" style=\"border:1px solid; padding:10px; margin:15px 0;\">\n        <p><strong>The audio podcast settings must be configured for the channel prior to selecting this option.</strong></p>\n        <a ui-sref=\"channels({id: vm.output.channel.id})\">View Channel Settings</a>\n      </div>\n    </div>\n    <div ng-if=\"vm.output.mediaType == 'video-podcast' && !vm.allowPodcastForChannel('video')\">\n      <div class=\"text-warning bg-warning\" style=\"border:1px solid; padding:10px; margin:15px 0;\">\n        <p><strong>The video podcast settings must be configured for the channel prior to selecting this option.</strong></p>\n        <a ui-sref=\"channels({id: vm.output.channel.id})\">View Channel Settings</a>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"form-group\"\n      ng-hide=\"!vm.outputCode('other')\n        || (vm.output.integrationType == 'm3u8' && !vm.output.showM3U8Confirmed)\n        || (vm.output.integrationType === 'podcast' && vm.output.mediaType == 'audio-podcast' && !vm.allowPodcastForChannel('audio'))\n        || (vm.output.integrationType === 'podcast' && vm.output.mediaType == 'video-podcast' && !vm.allowPodcastForChannel('video'))\n      \">\n    <embed-copy-paste type=\"other\" parent-vm=\"vm\"></embed-copy-paste>\n  </div>\n\n</div>\n\n\n<div ng-if=\"vm.output.integrationType == 'sdk'\">\n  <p><strong>Review API Documentation and Platform SDKs</strong></p>\n  <style>\n    .sdk-list small {\n        opacity: 0.6;\n    }\n    .sdk-list .label {\n        padding: 4px 6px 4px 6px;\n        font-size: 1.2rem;\n    }\n    .sdk-list .label-default {\n    }\n  </style>\n  <table class=\"table sdk-list\">\n    <tbody>\n      <tr>\n        <td>REST API documentation.</td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://boxcast.github.io/boxcast_api/\" target=\"_blank\">\n            <i class=\"fa fa-flask\"></i> Developer Docs\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Build your own AppleTV app (TVML).\n          <div><span class=\"label label-default\">JavaScript</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-tvos\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for TVML\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Build your own iOS, macOS, watchOS, or tvOS app.\n          <div><span class=\"label label-default\">Swift</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-apple\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for Apple\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Build your own Roku app.\n          <div><span class=\"label label-default\">BrightScript</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-roku\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for Roku\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Build your own Android app.\n          <div><span class=\"label label-default\">Java</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-android\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for Android\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Build your own React Native app.\n          <div><span class=\"label label-default\">JavaScript</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-react-native\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for React Native\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Integrate a custom video player (e.g. JW Player, Video.js).\n          <div><span class=\"label label-default\">JavaScript</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/boxcast-sdk-js\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> BoxCast SDK for JavaScript\n          </a>\n        </td>\n      </tr>\n      <tr>\n        <td>Host a custom video website portal.\n          <div><span class=\"label label-default\">JavaScript</span> <span class=\"label label-default\">HTML</span> <span class=\"label label-default\">CSS</span></div></td>\n        <td class=\"text-right\">\n          <a class=\"btn btn-default btn-block\" href=\"https://github.com/boxcast/example_video_portal_vuejs\" target=\"_blank\">\n            <i class=\"fa fa-code-fork\"></i> Sample Vue.js Website\n          </a>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n\n  <p><strong>Additional Resources</strong></p>\n  <ol class=\"list-inline\">\n    <li>\n      <a class=\"btn btn-default\" href=\"https://www.boxcast.com/dev-support\" target=\"_blank\">\n        <i class=\"fa fa-question-circle\"></i> Developer Support\n      </a>\n    </li>\n    <li>\n      <a class=\"btn btn-default\" href=\"https://www.boxcast.com/status\" target=\"_blank\">\n        <i class=\"fa fa-heartbeat\"></i> Platform Status\n      </a>\n    </li>\n    <li ng-if=\"::$root.user.can('list', 'api-keys')\">\n      <a class=\"btn btn-default\" ui-sref=\"settings.api_keys\">\n        <i class=\"fa fa-key\"></i> Manage API Keys\n      </a>\n    </li>\n  </ol>\n</div>\n"

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <div class=\"btn-group\">\n    <label class=\"btn btn-default\"\n          ng-model=\"vm.parentVM.output.type\"\n          uib-btn-radio=\"'all'\"\n          style=\"width:120px\"\n          ng-click=\"vm.parentVM.selectAllBroadcasts()\"\n          ng-if=\"!vm.hideAll\">All</label>\n    <label class=\"btn btn-default\"\n          ng-model=\"vm.parentVM.output.type\"\n          uib-btn-radio=\"'channel'\"\n          style=\"width:120px\"\n          ng-click=\"vm.parentVM.selectCustomChannel(vm.parentVM.channels[0])\"\n          ng-if=\"vm.parentVM.channels.length > 0 && !vm.hideChannels\">By Channel</label>\n    <label class=\"btn btn-default\"\n          ng-model=\"vm.parentVM.output.type\"\n          uib-btn-radio=\"'source'\"\n          style=\"width:120px\"\n          ng-click=\"vm.parentVM.selectOneSource(vm.parentVM.sourcesCombined[0])\"\n          ng-if=\"vm.parentVM.sourcesCombined.length > 0 && !vm.hideSources\">By Source</label>\n    <label class=\"btn btn-default\"\n          ng-model=\"vm.parentVM.output.type\"\n          uib-btn-radio=\"'single'\"\n          style=\"width:120px\"\n          ng-click=\"vm.parentVM.selectSingleBroadcast(vm.parentVM.output.broadcast)\"\n          ng-if=\"!vm.hideSingleBroadcast\">By Broadcast</label>\n  </div>\n\n  <div ng-if=\"!vm.hideSources && vm.parentVM.output.type == 'source'\" class=\"form-group\" style=\"width:480px;margin-top:15px;\">\n    <label>Source</label>\n    <select class=\"form-control\"\n            ng-model=\"vm.parentVM.output.source\"\n            ng-change=\"vm.parentVM.selectOneSource(vm.parentVM.output.source)\"\n            ng-options=\"b as vm.parentVM.formatSourceOpt(b) for b in vm.parentVM.sourcesCombined track by b.id\"\n            required>\n    </select>\n  </div>\n\n  <div ng-if=\"!vm.hideChannels && vm.parentVM.output.type == 'channel'\" class=\"form-group\" style=\"width:480px;margin-top:15px;\">\n    <label>Channel</label>\n    <select class=\"form-control\"\n            ng-model=\"vm.parentVM.output.channel\"\n            ng-change=\"vm.parentVM.selectCustomChannel(vm.parentVM.output.channel)\"\n            ng-options=\"c as c.name for c in vm.parentVM.channels track by c.id\"\n            required>\n    </select>\n  </div>\n\n  <div ng-if=\"!vm.hideSingleBroadcast && vm.parentVM.output.type == 'single'\" class=\"form-group\" style=\"width:480px;margin-top:15px;\">\n    <label>Broadcast</label>\n    <recording-source-chooser edit-or-create-event-service=\"vm.service\"\n                              skip-recording-source-validation=\"true\"\n                              select-source-title=\"Select Broadcast...\"\n                              modal-title=\"Select Broadcast\"\n                              broadcast-validator=\"vm.broadcastValidator\"\n                              on-select-broadcast=\"vm.parentVM.selectSingleBroadcast\"></recording-source-chooser>\n  </div>\n</div>\n"

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <hr>\n  <label ng-show=\"vm.parentVM.loading()\">Loading, please wait...</label>\n  <div ng-hide=\"vm.parentVM.loading()\">\n\n    <div class=\"pull-right\">\n      <ol class=\"list-inline\">\n        <li ng-show=\"vm.parentVM.showPreviewEmbed(vm.type)\">\n          <button ng-click=\"vm.parentVM.showPreview(vm.type)\" type=\"button\" class=\"btn btn-default\">\n            Preview Embed Code\n          </button>\n        </li>\n        <li ng-show=\"vm.parentVM.output.embedType == 'link'\">\n          <a href=\"{{vm.parentVM.outputCode(vm.type)}}\" target=\"_blank\" class=\"btn btn-default\">\n            <i class=\"fa fa-external-link\"></i> View on BoxCast.tv\n          </a>\n        </li>\n        <li ng-if=\"$root.clipboard.supported\">\n          <button class=\"btn btn-success\" clipboard\n                  text=\"vm.parentVM.outputCode(vm.type)\"\n                  on-copied=\"$root.toaster.pop('success', 'Copied!')\"\n                  on-error=\"$root.toaster.pop('warning', 'Could not copy :(')\"\n                  >Copy Embed Code <i class=\"fa fa-copy\"></i></button>\n        </li>\n      </ol>\n    </div>\n\n    <label>{{vm.parentVM.copyLabel(vm.type)}}</label>\n\n    <div ng-if=\"!vm.parentVM.loading() && vm.type == 'other' && vm.parentVM.output.integrationType == 'm3u8' && !vm.parentVM.output.m3u8\">\n      <div class=\"text-warning bg-warning\" style=\"border:1px solid;padding:10px\">\n        The M3U8 link is not available.  Are you trying to access a ticketed resource?\n      </div>\n    </div>\n\n    <textarea readonly class=\"form-control\" rows=\"7\">{{vm.parentVM.outputCode(vm.type)}}</textarea>\n\n    <p class=\"help-block\" ng-if=\"vm.type == 'broadcasts' && vm.parentVM.output.integrationType == 'iframe'\">\n      <small>\n        <i class=\"fa fa-info-circle\"></i>\n        If the iframe code above does not work, you may need copy just the value inside the src=\"...\" attribute,\n        depending on how your web site hosting provider functions.\n      </small>\n    </p>\n  </div>\n\n</div>\n"

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = "<div style=\"width:290px\" class=\"pull-left\">\n  <p><strong>Player Settings</strong></p>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-click=\"vm.parentVM.showHideAutoplayOptions()\"> Customize Auto-play Behavior\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, you can customize the auto-play behavior. Do Not Auto-play will never attempt to auto-play video; Try With Sound will try to auto-play with sound; Try With Sound or Muted will first try with sound, then try again with the video muted if the first attempt fails.\" tooltip-append-to-body=\"true\"></i>\n      <select class=\"form-control\" ng-change=\"vm.parentVM.changeAutoplayOptions()\" ng-show=\"vm.parentVM.showAutoplayOptions\" ng-model=\"vm.parentVM.output.args.autoplay\" required>\n        <option value=\"false\">Do Not Auto-play</option>\n        <option value=\"true\">Try With Sound</option>\n        <option value=\"try-muted\">Try With Sound or Muted</option>\n      </select>\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-disabled=\"vm.parentVM.disablePlayInline\" ng-model=\"vm.parentVM.output.args.playInline\"> Play Inline\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, the broadcast video will play 'inline' on mobile devices (rather than full-screen). If customizing auto-play behavior, you will likely want this too.\"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.dvr\" ng-true-value=\"false\" ng-false-value=\"true\"> Disable Live DVR\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"By default, DVR scrubbing is enabled for all live videos. If checked, the player will disable the feature. \"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"vm.parentVM.showVersionOverride\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.showPlayerVersion\" ng-click=\"vm.parentVM.clearPlayerVersionIfNecessary()\" ng-disabled=\"vm.parentVM.output.embedType === 'iframe'\">\n      Player Version Override\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"Pin to a specific version of the BoxCast Video Player\"></i>\n    </label>\n  </div>\n  <div class=\"form-group\" ng-if=\"vm.parentVM.showPlayerVersion && vm.parentVM.output.embedType !== 'iframe'\">\n    <input type=\"url\" class=\"form-control\" ng-model=\"vm.parentVM.output.args.version\" placeholder=\"e.g. 3.1.8\">\n    <p class=\"help-block\">\n      <i class=\"fa fa-info-circle\"></i> Only override for testing new features or if Support has given you a specific reason to use an older version. By default, we use the latest stable version of the player.\n    </p>\n  </div>\n  <p><strong>Additional Features</strong></p>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showCountdown\"> Countdown Timer\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, the player will show a large countdown timer for future broadcasts.\"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"::vm.parentVM.FeatureFlags.donations\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showDonations\"> Collect Donations\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, the player title area will add a button to collect online donations from viewers.\"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.showPoster\" ng-click=\"vm.parentVM.clearPosterIfNecessary()\">\n      Custom Thumbnail Image\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"This image will show behind the play button instead of the automatically captured frame.\"></i>\n    </label>\n  </div>\n  <div class=\"form-group\" ng-if=\"vm.parentVM.showPoster\">\n    <div ng-if=\"vm.parentVM.output.args.poster\" class=\"text-center\">\n      <div>\n        <img ng-src=\"{{vm.parentVM.output.args.poster | trustedUrl}}\" class=\"img\" style=\"max-width:100%\">\n      </div>\n      <a href ng-click=\"vm.parentVM.output.args.poster = null\">Change</a>\n    </div>\n    <div ng-if=\"!vm.parentVM.output.args.poster\">\n      <upload-slot ng-model=\"vm.parentVM.posterFile\"\n                    ng-change=\"vm.parentVM.uploadPoster(vm.parentVM.posterFile)\"\n                    slot-name=\"'poster'\"\n                    allow-image=\"true\"\n                    allow-video=\"false\"\n                    compact=\"true\"></upload-slot>\n    </div>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.showPreroll\" ng-click=\"vm.parentVM.clearPrerollIfNecessary()\">\n      Custom Pre-Broadcast Video\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"This video will play in a loop before the broadcast starts\"></i>\n    </label>\n  </div>\n  <div class=\"form-group\" ng-if=\"vm.parentVM.showPreroll\">\n    <div ng-if=\"vm.parentVM.output.args.customPreroll\" class=\"text-center\">\n      <div>\n        <video ng-src=\"{{vm.parentVM.output.args.customPreroll | trustedUrl}}\" controls style=\"max-width:100%;\"></video>\n      </div>\n      <a href ng-click=\"vm.parentVM.output.args.customPreroll = null\">Change</a>\n    </div>\n    <div ng-if=\"!vm.parentVM.output.args.customPreroll\">\n      <upload-slot ng-model=\"vm.parentVM.customPrerollFile\"\n                    ng-change=\"vm.parentVM.uploadCustomPreroll(vm.parentVM.customPrerollFile)\"\n                    slot-name=\"'preroll'\"\n                    allow-image=\"false\"\n                    allow-video=\"true\"\n                    compact=\"true\"></upload-slot>\n    </div>\n  </div>\n</div>\n<div class=\"pull-left\">\n  <div ng-if=\"!vm.parentVM.singleEvent\">\n    <p><strong>Default Video Selection</strong></p>\n    <div class=\"radio\">\n      <label>\n        <input type=\"radio\" ng-model=\"vm.parentVM.output.args.defaultVideo\" value=\"next\"> Show next broadcast immediately\n        <i class=\"fa fa-question-circle\" uib-tooltip=\"With this option, the widget will default to showing and selecting\n          the next future broadcast as soon as the current live broadcast ends. A countdown timer will be displayed on\n          this broadcast until it begins.\" tooltip-append-to-body=\"true\"></i>\n      </label>\n    </div>\n    <div class=\"radio\">\n      <label>\n        <input type=\"radio\" ng-model=\"vm.parentVM.output.args.defaultVideo\" value=\"closest\"> Show closest broadcast\n        <i class=\"fa fa-question-circle\" uib-tooltip=\"With the *closest* option, the widget will only show the\n          the next upcoming broadcast when it is closer in time than the previous recording.\" tooltip-append-to-body=\"true\"></i>\n      </label>\n    </div>\n  </div>\n  <p><strong>Layout Customization</strong></p>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.applyBrandColor\"> Apply Brand Color to Video Progress Bar\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showTitleAndDescription\"> Show Description Below Player\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"::vm.parentVM.FeatureFlags.documents\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showDocuments\"> Show Documents\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"::vm.parentVM.FeatureFlags.cue_points\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showIndex\"> Show Video Index\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"!vm.parentVM.singleEvent\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showRelated\"> Show Playlist\n    </label>\n  </div>\n  <div class=\"checkbox\" ng-if=\"::vm.parentVM.FeatureFlags.viewer_chat\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.showChat\"> Show Viewer Chat\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.playlistOnRight\"> Two-Column Layout\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, the widget will show the playlist and list of highlights to the right of the video player. By default, the list is shown below the video.\"></i>\n    </label>\n  </div>\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"vm.parentVM.output.args.hidePreBroadcastTextOverlay\"> Hide Overlay Messages Before Broadcast\n      <i class=\"fa fa-question-circle\" uib-tooltip=\"If selected, the player text overlays and countdown timer will not appear before a broadcast.  This is often used in conjunction with a pre-broadcast video or poster image.\" tooltip-append-to-body=\"true\"></i>\n    </label>\n  </div>\n</div>\n<div class=\"clearfix\"></div>\n"

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Preview Embed Code</h3>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <p class=\"help-block\">\n        <i class=\"fa fa-info-circle\"></i>\n        You can place this anywhere on your web site. The embed is shown inside an inline frame here, but you can place it\n        directly alongside your other website content so that it inherits the typography and other style elements.\n      </p>\n      <div id=\"modal-preview-script\">Loading...</div>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Close Preview</button>\n</div>\n\n"

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__edit__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__detail__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__highlights__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trim_recordings__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scoreboard_controls__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__player_with_highlight_capture__ = __webpack_require__(445);





 // The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.

var module = angular.module('events', []);
module.controller('EditEventController', __WEBPACK_IMPORTED_MODULE_0__edit__["a" /* default */]);
module.controller('EventDetailController', __WEBPACK_IMPORTED_MODULE_1__detail__["a" /* default */]);
module.controller('HighlightsController', __WEBPACK_IMPORTED_MODULE_2__highlights__["a" /* default */]);
module.controller('TrimRecordingsController', __WEBPACK_IMPORTED_MODULE_3__trim_recordings__["a" /* default */]);
module.directive('scoreboardControls', __WEBPACK_IMPORTED_MODULE_4__scoreboard_controls__["a" /* default */]);
module.component('playerWithHighlightCapture', __WEBPACK_IMPORTED_MODULE_5__player_with_highlight_capture__["a" /* default */]);
module.config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('events', {
    url: '/events',
    template: "<div ui-view></div>",
    "abstract": true
  }).state('events.detail', {
    url: '/:id?tab&action&from_producer',
    template: __webpack_require__(449),
    controller: __WEBPACK_IMPORTED_MODULE_1__detail__["a" /* default */],
    controllerAs: 'vm',
    reloadOnSearch: false
  }).state('events.trim', {
    url: '/:id/trim/:recording',
    template: __webpack_require__(450),
    controller: __WEBPACK_IMPORTED_MODULE_3__trim_recordings__["a" /* default */],
    controllerAs: 'vm'
  }).state('events.highlights', {
    url: '/:id/highlights/:recording',
    template: __webpack_require__(451),
    controller: __WEBPACK_IMPORTED_MODULE_2__highlights__["a" /* default */],
    controllerAs: 'vm'
  }); //.state('events.edit', {
  //  url: '/:id/edit',
  //  template: require('./edit.html'),
  //  controller: EditEventController,
  //  controllerAs: 'vm',
  //})
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditEventController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_pricing__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_error__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_timezone__ = __webpack_require__(42);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }





var EditEventController = /*#__PURE__*/function () {
  function EditEventController($scope, $state, $uibModalInstance, $q, $uibModal, Broadcast, Facebook, ConfirmDialog, EditOrCreateEventService, OneOrAllDialog, toaster, broadcastId, activeTab, $rootScope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, EditEventController);

    this.$scope = $scope;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.$uibModalInstance = $uibModalInstance;
    this.Broadcast = Broadcast;
    this.ConfirmDialog = ConfirmDialog;
    this.OneOrAllDialog = OneOrAllDialog;
    this.toaster = toaster;
    this.activeTab = activeTab;
    this.fb = Facebook;
    this.fb.init();
    this.service = EditOrCreateEventService.getInstance();
    this.service.initBroadcast(broadcastId);
    this.service.initScope($scope);
    this.showError = false;
    var accountTimezone__tzInfo = $rootScope.account.time_zone;
    var currentTimezone__jstz = Object(__WEBPACK_IMPORTED_MODULE_2__utils_timezone__["a" /* FindTimeZone */])();
    this.currentTimezoneValue = currentTimezone__jstz;
    this.currentTimezone = Object(__WEBPACK_IMPORTED_MODULE_2__utils_timezone__["c" /* JstzToTzInfo */])(currentTimezone__jstz);
    this.timezoneMatchesAccount = Object(__WEBPACK_IMPORTED_MODULE_2__utils_timezone__["b" /* JstzMatchesTzInfo */])(currentTimezone__jstz, accountTimezone__tzInfo);
    this.minStartTime = moment().startOf('day').toDate();

    if (this.service.broadcast.$promise) {
      this.service.broadcast.$promise.then(function () {
        _this.showSocial = _this.service.broadcast.simulcast_configurations.length > 0 || !!$rootScope.account.feature_flags.no_viewers;

        _this.fb.init(); // Derived data for editing


        _this.isImported = _this.service.broadcast.stream_source == 'imported';
        _this.canEditStart = _this.service.broadcast.timeframe == 'future' || _this.isImported;
        _this.canEditStop = _this.service.broadcast.timeframe != 'past' || _this.isImported;

        if (_this.isImported) {
          _this.minStartTime = moment(_this.service.broadcast.starts_at).startOf('day').toDate();
        } // Podcast settings expanded only if already updated


        var cs = _this.service.broadcast.content_settings;
        _this.showPodcast = cs.podcast_preview || cs.podcast_subtitle || cs.podcast_summary;
      });
    } else {
      this.fb.init();
    }

    this.loadingPromises = [this.service.broadcast.$promise, this.service.boxcasters.$promise, this.service.account.$promise, this.service.channels.$promise];
    $q.all(this.loadingPromises)["catch"](function (e) {
      console.error(e);
      toaster.pop('warning', 'Error loading broadcast', 'Sorry, we were not able to load the broadcast. Please refresh this page and try again.');

      _this.cancel();
    });
    this.confirmOnExit = false;
    $scope.$watch(function () {
      return $scope.form.$pristine;
    }, function (isPristine) {
      _this.confirmOnExit = _this.confirmOnExit || !isPristine;
    });
  }

  _createClass(EditEventController, [{
    key: "loginFacebook",
    value: function loginFacebook() {
      var _this2 = this;

      this.fb.login().then(function () {
        _this2.service.initializeEmptyFacebookAccountIDs();
      });
    }
  }, {
    key: "logoutFacebook",
    value: function logoutFacebook() {
      var _this3 = this;

      this.fb.logout().then(function () {
        return _this3.fb.init();
      });
    }
  }, {
    key: "facebookLiveSimulcastFeedType",
    value: function facebookLiveSimulcastFeedType(config) {
      return config.fb_feed_id.split(':', 1)[0];
    }
  }, {
    key: "facebookLiveSimulcastFeedID",
    value: function facebookLiveSimulcastFeedID(config) {
      return config.fb_feed_id.replace(/^[^:]*:/, '');
    }
  }, {
    key: "fbLiveShowGlass",
    value: function fbLiveShowGlass(config) {
      return config.fb_feed_id && config.facebook_account_id && config.facebook_account_id != this.fb.facebook_account_id;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var doIt = true;

      if (this.confirmOnExit) {
        doIt = confirm('Are you sure you want to abandon your changes?');
      }

      if (doIt) {
        this.$uibModalInstance.dismiss('cancel');
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      this.cancel();
      this.$state.go('new-event', {
        cloneId: this.service.broadcast.id
      });
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _this4 = this;

      var Broadcast = this.Broadcast,
          ConfirmDialog = this.ConfirmDialog,
          OneOrAllDialog = this.OneOrAllDialog,
          toaster = this.toaster,
          $state = this.$state,
          $uibModalInstance = this.$uibModalInstance;

      var deleteThisBroadcast = function deleteThisBroadcast() {
        var resource = Broadcast["delete"]({
          id: _this4.service.broadcast.id
        }, function () {
          $uibModalInstance.dismiss();

          _this4.cancel();

          $state.go('home', {}, {
            reload: true
          });
        }, function (e) {
          if (e.status === 409 && e.data && e.data.error_description && RegExp('uses? the recording of this broadcast').test(e.data.error_description)) {
            toaster.pop('warning', 'Error deleting broadcast', e.data.error_description + '.');
          } else {
            alert('Error deleting broadcast. Please reload this page and try again.');
          }
        });
        _this4.loadingPromises = [resource.$promise];
      };

      var deleteBroadcastWithRecurrences = function deleteBroadcastWithRecurrences() {
        var resource = Broadcast.deleteRecurring({
          id: _this4.service.broadcast.id
        }, {
          id: _this4.service.broadcast.id,
          recurrence: {
            id: _this4.service.broadcast.recurrence.id,
            broadcasts: _this4.service.broadcast.recurrence.broadcasts
          }
        }, function () {
          $uibModalInstance.dismiss();

          _this4.cancel();

          $state.go('home', {}, {
            reload: true
          });
        }, function (e) {
          if (e.status === 409 && e.data && e.data.error_description && RegExp('scheduled to use the recording of this broadcast').test(e.data.error_description)) {
            toaster.pop('warning', 'Error deleting broadcast', e.data.error_description.replace('of this broadcast', 'of one or more of these broadcasts') + '.');
          } else {
            alert('Error deleting broadcasts. Please reload this page and try again.');
          }
        });
        _this4.loadingPromises = [resource.$promise];
      };

      var promptAndDelete = function promptAndDelete(deleteFn) {
        var modalOptions = {
          closeButtonText: 'Cancel',
          actionButtonText: 'Delete Broadcast',
          actionButtonClass: 'danger',
          headerText: 'Please Confirm',
          bodyText: 'Are you sure you want to permanently delete this broadcast? Once deleted, a broadcast cannot be recovered.'
        };

        if (deleteFn === deleteBroadcastWithRecurrences) {
          modalOptions.actionButtonText = 'Delete Broadcasts';
          modalOptions.bodyText = 'Are you sure you want to permanently delete these broadcasts? Once deleted, broadcasts cannot be recovered.';
        }

        ConfirmDialog.show(modalOptions).then(deleteFn);
      };

      if (this.service.broadcast.timeframe != 'past' && this.service.broadcast.recurrence && this.service.broadcast.recurrence.broadcasts && this.service.broadcast.recurrence.broadcasts.length) {
        var otherBroadcasts = [];
        var otherBroadcastsText = '';

        if (this.service.broadcast.timeframe == 'future') {
          // If this broadcast is in the future, then "other broadcasts" is only other future broadcasts
          otherBroadcasts = _.filter(this.service.broadcast.recurrence.broadcasts, function (b) {
            return b.timeframe == 'future';
          });
          otherBroadcastsText = 'future';
        } else {
          // If this broadcast is pre-roll or current, then "other broadcasts" is current AND future broadcasts
          otherBroadcasts = _.filter(this.service.broadcast.recurrence.broadcasts, function (b) {
            return b.timeframe != 'past';
          });
          otherBroadcastsText = 'current and future';
        }

        if (otherBroadcasts.length) {
          // Other non-past recurring broadcasts in the series!
          var modalOptions = {
            headerText: "Delete all ".concat(otherBroadcastsText, " broadcasts in the series?"),
            bodyText: "This broadcast is one of ".concat(otherBroadcasts.length + 1, " ").concat(otherBroadcastsText, " broadcasts in a recurring series. Do you want to delete this broadcast only, or all ").concat(otherBroadcastsText, " broadcasts in the series?"),
            allButtonClass: 'danger',
            oneButtonClass: 'danger'
          };
          OneOrAllDialog.show(modalOptions).then(function (result) {
            if (result == 'one') {
              // Just delete this one
              promptAndDelete(deleteThisBroadcast);
            } else {
              // Delete all the future ones
              _this4.service.broadcast.recurrence.broadcasts = otherBroadcasts;
              promptAndDelete(deleteBroadcastWithRecurrences);
            }
          });
        } else {
          // All other recurring broadcasts in the series are past, so we're just operating on this one.
          promptAndDelete(deleteThisBroadcast);
        }
      } else {
        // This is a past broadcast or single non-recurring broadcast
        promptAndDelete(deleteThisBroadcast);
      }
    }
  }, {
    key: "addSimulcastDestination",
    value: function addSimulcastDestination(d, params) {
      this.confirmOnExit = true;
      return this.service.addSimulcastDestination(d, params);
    }
  }, {
    key: "removeSimulcastDestination",
    value: function removeSimulcastDestination(d) {
      this.confirmOnExit = true;
      return this.service.removeSimulcastDestination(d);
    }
  }, {
    key: "styleDoNotRecord",
    get: function get() {
      if (this.service.broadcast.timeframe == 'future') {
        return {
          cursor: 'pointer'
        };
      } else {
        return {
          cursor: 'not-allowed',
          color: '#aaa'
        };
      }
    }
  }, {
    key: "toggleDoNotRecord",
    value: function toggleDoNotRecord() {
      // Don't toggle unless it's in the future
      if (this.service.broadcast.timeframe != 'future') return;
      this.service.broadcast.do_not_record = !this.service.broadcast.do_not_record;
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this5 = this;

      var $uibModal = this.$uibModal,
          OneOrAllDialog = this.OneOrAllDialog;

      var saveThisBroadcast = function saveThisBroadcast() {
        _this5.showError = false;
        _this5.submitting = true;

        _this5.service.saveChanges().then(function (broadcast) {
          _this5.submitting = false;

          _this5.$uibModalInstance.close(broadcast);
        })["catch"](function (error) {
          var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_1__utils_error__["a" /* errorDescriptionFromResponse */])(error);

          if (errorDetails == 'invalid') {
            _this5.showError = true;
          } else {
            alert('Unable to save broadcast. Please check your fields and try again.\n\n' + errorDetails);
          }

          _this5.submitting = false;
        });
      };

      var checkForRecurringUpdates = function checkForRecurringUpdates() {
        if (_this5.service.broadcast.timeframe != 'past' && _this5.service.broadcast.recurrence && _this5.service.broadcast.recurrence.broadcasts && _this5.service.broadcast.recurrence.broadcasts.length) {
          var otherBroadcasts = [];
          var otherBroadcastsText = '';

          if (_this5.service.broadcast.timeframe == 'future') {
            // If this broadcast is in the future, then "other broadcasts" is only other future broadcasts
            otherBroadcasts = _.filter(_this5.service.broadcast.recurrence.broadcasts, function (b) {
              return b.timeframe == 'future';
            });
            otherBroadcastsText = 'future';
          } else {
            // If this broadcast is pre-roll or current, then "other broadcasts" is current AND future broadcasts
            otherBroadcasts = _.filter(_this5.service.broadcast.recurrence.broadcasts, function (b) {
              return b.timeframe != 'past';
            });
            otherBroadcastsText = 'current and future';
          }

          if (otherBroadcasts.length) {
            // Other recurring broadcasts in the series!
            var modalOptions = {
              headerText: "Update all ".concat(otherBroadcastsText, " broadcasts in the series?"),
              bodyText: "This broadcast is one of ".concat(otherBroadcasts.length + 1, " ").concat(otherBroadcastsText, " broadcasts in a recurring series. Do you want to apply your edits to this broadcast only, or all ").concat(otherBroadcastsText, " broadcasts in the series?")
            };
            OneOrAllDialog.show(modalOptions).then(function (result) {
              if (result == 'one') {
                // Just update this one
                delete _this5.service.broadcast.recurrence;
                saveThisBroadcast();
              } else {
                // Update all the future ones
                _this5.service.broadcast.recurrence.broadcasts = otherBroadcasts;
                saveThisBroadcast();
              }
            });
          } else {
            // All other recurring broadcasts in the series are past, so we're just operating on this one.
            delete _this5.service.broadcast.recurrence;
            saveThisBroadcast();
          }
        } else {
          // This is a past broadcast or single non-recurring broadcast
          delete _this5.service.broadcast.recurrence;
          saveThisBroadcast();
        }
      };

      if (this.service.broadcast.timeframe != 'past' && this.service.conflictingEvents.length > 0) {
        var conflictingEvents = this.service.conflictingEvents;
        $uibModal.open({
          template: __webpack_require__(204),
          controller: function controller($scope, $uibModalInstance) {
            'ngInject';

            $scope.conflictingEvents = conflictingEvents;

            $scope.ok = function (result) {
              return $uibModalInstance.close(result);
            };

            $scope.close = function () {
              return $uibModalInstance.dismiss('cancel');
            };
          }
        }).result.then(checkForRecurringUpdates);
      } else {
        checkForRecurringUpdates();
      }
    }
  }]);

  return EditEventController;
}();



/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventDetailController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__broadcast_with_rtmp_controller__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_capture_highlight_recorded__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__embed_single_event_controller__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_download_or_export_recording__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_highlight_preview__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__uploads_modal_upload_event__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_allow_social__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_clappr__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_date__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_broadcast__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_download__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_rtmp__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_stream_diagnostics__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_uploads__ = __webpack_require__(437);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
















var UPLOAD_PROGRESS_INTERVAL_MS = 5000;
var SIMULCAST_FPS_THRESHOLD = 10; // if we're getting at least 10 fps through, we're OK

var EventDetailController = /*#__PURE__*/function () {
  function EventDetailController($state, $scope, $timeout, $http, $location, AccountUploadsService, Broadcast, Channel, $uibModal, ConfirmDialog, Overlays, Facebook, Highlight, Caption, BandwidthTestClient, toaster, $analytics, $sce, $rootScope, BoxCaster, Recording, StaticRTMP) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, EventDetailController);

    this.$state = $state;
    this.$http = $http;
    this.$location = $location;
    this.AccountUploadsService = AccountUploadsService;
    this.Broadcast = Broadcast;
    this.$uibModal = $uibModal;
    this.ConfirmDialog = ConfirmDialog;
    this.Highlight = Highlight;
    this.BoxCaster = BoxCaster;
    this.Recording = Recording;
    this.Caption = Caption;
    this.BandwidthTestClient = BandwidthTestClient;
    this.Overlays = Overlays;
    this.toaster = toaster;
    this.$analytics = $analytics;
    this.$sce = $sce;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.account = $rootScope.account;
    this.user = $rootScope.user;
    this.sanitizeRTMPURL = __WEBPACK_IMPORTED_MODULE_11__utils_rtmp__["b" /* SanitizeRTMPURL */];
    this.StaticRTMP = StaticRTMP;
    this.fb = Facebook;
    this.queryParams = this.$location.search();

    if (this.queryParams.from_producer === 'true') {
      $timeout(function () {
        toaster.pop('success', 'Thank you for streaming with Producer');
      });
    }

    var ApiConfig = $rootScope.ApiConfig;
    var FeatureFlags = $rootScope.account.feature_flags;
    this.channelMap = {};

    if (!!FeatureFlags.no_viewers) {
      this.channels = [];
    } else {
      this.channels = Channel.query({
        l: 1000
      }, function () {
        _this.channels.forEach(function (c) {
          return _this.channelMap[c.id] = c;
        });
      });
    }

    this.enableScoreboardControls = false;
    this.showRtmpConfig = false;
    this.isTriCaster = navigator.userAgent.indexOf('Tricaster') > 0;
    this.activeOverlays = [];
    this.FeatureFlags = FeatureFlags;
    this.canCreate = this.user.can('create', 'broadcast');
    this.canEdit = this.user.can('update', 'broadcast/*');
    this.canUpload = this.user.can('create', 'broadcast/*:upload');
    this.sports = ApiConfig.stream.sports;
    this.hasAnalyticsFeature = !!FeatureFlags.analytics;
    this.allowEmbed = this.user.can('embed', 'broadcast/*');
    this.allowPromote = this.user.can('promote', 'broadcast/*') && !this.account.extra_features.media_token_restrictions;
    this.allowSimulatedLive = !!FeatureFlags.simulated_live;
    this.allowHighlights = this.user.can('list', 'broadcast/*:highlights');
    this.allowOverlays = FeatureFlags.overlays && this.user.can('update', 'broadcast/*:metadata/overlays');
    this.allowLiveAutomatedCaptioning = FeatureFlags.live_automated_captioning; // allowSocial is complicated... it will be determined after the broadcast is loaded in fixBroadcast() => computeAllowSocial()

    this.allowSocial = false;
    this.activeDestinationStatus = {};
    this.activeDestinationDetails = {};

    this.toggleActiveDestinationDetails = function (i) {
      _this.activeDestinationDetails[i] = !_this.activeDestinationDetails[i];
    };

    this.onStreamDiagnosticsReload = function (data) {
      // For static RTMP broadcasts, if stream diagnostics reports a change in standard, then reload the
      // static RTMP with diagnostics; this will update our source icon with the latest information.
      if (_this.broadcast && _this.broadcast.stream_source == 'rtmp' && _this.broadcast.static_rtmp_id) {
        var lastRTMPStandard = (_this.streamDiagnostics || {}).last_rtmp_standard || '';
        var newRTMPStandard = (data || {}).last_rtmp_standard || '';

        if (lastRTMPStandard != newRTMPStandard) {
          StaticRTMP.get({
            id: _this.broadcast.static_rtmp_id,
            include_diagnostics: true
          }, function (r) {
            _this.staticRTMPDiagnostics = r.diagnostics;
          });
        }
      }

      _this.streamDiagnostics = data; // reconcile active simulcast destinations against the stream diagnostics data

      if ((_this.broadcast || {}).simulcast_configurations) {
        _this.broadcast.simulcast_configurations.forEach(function (s, i) {
          var possibleConfiguredUrls = ["".concat(s.rtmps_url, "/").concat(s.stream_key), "".concat(s.rtmp_url, "/").concat(s.stream_key), s.fb_secure_stream_url, s.fb_stream_url];

          if (s.stream_url) {
            possibleConfiguredUrls.push("".concat(Object(__WEBPACK_IMPORTED_MODULE_11__utils_rtmp__["b" /* SanitizeRTMPURL */])(s.stream_url), "/").concat(encodeURIComponent(s.stream_key)));
          }

          if (data.data_version >= 3) {
            _.each(data.raw_stats.simulcast_frame_rate || {}, function (s, rtmpURL) {
              var sanitizedURL = Object(__WEBPACK_IMPORTED_MODULE_11__utils_rtmp__["b" /* SanitizeRTMPURL */])(rtmpURL);
              possibleConfiguredUrls.forEach(function (url) {
                if (sanitizedURL == url && !!s && !!s.video && s.video.length > 0) {
                  var fps = s.video[s.video.length - 1][1];
                  _this.activeDestinationStatus[i] = {
                    connected: fps > SIMULCAST_FPS_THRESHOLD,
                    fps: fps
                  };
                }
              });
            });
          } else {
            var influxSeries = data.raw_stats.results && data.raw_stats.results[4] && data.raw_stats.results[4].series || [];
            influxSeries.forEach(function (d) {
              var seriesUrl = (d.tags || {}).rtmp_url;
              possibleConfiguredUrls.forEach(function (url) {
                if (seriesUrl == url) {
                  var fps;
                  var values = d.values || [];

                  if (values.length > 1) {
                    fps = values[values.length - 2][1]; //2nd from last accounts for a "full" period
                  } else {
                    fps = (values[values.length - 1] || [0, 0])[1];
                  }

                  _this.activeDestinationStatus[i] = {
                    connected: fps > SIMULCAST_FPS_THRESHOLD,
                    fps: fps
                  };
                }
              });
            });
          }
        });
      }

      _this.computeBroadcastStatus();
    };

    if (this.user.can('list', 'broadcast/*:captions') && this.user.can('create', 'broadcast/*:caption') && this.user.can('read', 'broadcast/*:caption/*') && this.user.can('update', 'broadcast/*:caption/*')) {
      this.allowCaptions = true;
    }

    if (FeatureFlags.cue_points) {
      this.cue = {};
    }

    if (FeatureFlags.documents) {
      this.documents = {};
    }

    this.graphType = 'fine';

    if (this.allowOverlays) {
      this.loadUploadsForPage(1);
    }

    this.reload(true).then(function (res) {
      /**
       * Wait until after the broadcast has loaded, then check If the user has edit permissions
       * if so, open the edit dialog
       */
      if (_this.queryParams.action === 'open_edit') {
        _this.edit();
      }
    })["catch"](function (err) {
      console.error(err);
    }); // Support auto-reloading of page silently

    this._reloadHandle = $timeout(function () {
      return _this.reloadSilent();
    }, REFRESH_INTERVAL_MS);
    $scope.$on('$destroy', function () {
      $timeout.cancel(_this._reloadHandle);
      $timeout.cancel(_this._calculateRecordingUploadHandle);
      $timeout.cancel(_this._captionReloadHandle);

      _this.BandwidthTestClient.cancelIfInFlight();
    }); // Workaround for binding scope issue

    this.onOverlayChange = this.onOverlayChange.bind(this);
    this.saveOverlays = this.saveOverlays.bind(this);

    this.reloadPlayerMeta = function () {
      return $scope.$broadcast('boxcast:refreshMeta');
    };
  } ///
  /// Recording Uploads
  ///


  _createClass(EventDetailController, [{
    key: "canDownloadOrExport",
    get: function get() {
      var user = this.user; // If the user is not capable of creating any download or export, then don't show it

      if (user.cannot('create', 'recording/*:download') && user.cannot('create', 'recording/*:kaltura-export') && user.cannot('create', 'recording/*:vimeo-export') && user.cannot('create', 'recording/*:youtube-export')) {
        return false;
      } // If there's no transcoded recording, then don't show it.


      if (!this.recordingIsTranscoded) {
        return false;
      }

      return true;
    }
  }, {
    key: "recordingIsAvailable",
    get: function get() {
      return this.broadcast.timeframe === 'past' && (this.broadcast.stream_source === 'imported' || this.publicView && this.publicView.status && this.publicView.status === 'recorded');
    }
  }, {
    key: "storageIsExpired",
    get: function get() {
      return this.publicView && this.publicView.status && this.publicView.status === 'not_recorded' && _.contains(['expired', 'purged'], this.publicView.reason);
    }
  }, {
    key: "recordingUploadMostRecent",
    get: function get() {
      if (!this.recordingUploads || !this.recordingUploads.length) return null;
      return this.recordingUploads[0];
    }
  }, {
    key: "recordingUploadStatus",
    get: function get() {
      return (this.recordingUploadMostRecent || {}).status;
    }
  }, {
    key: "recordingUploadFailureReason",
    get: function get() {
      return (this.recordingUploadMostRecent || {}).failure_reason;
    }
  }, {
    key: "recordingUploadProgress",
    get: function get() {
      if (!this.recordingUploads || !this.recordingUploads.length) return null;
      if (this.recordingUploadStatus == 'failed') return null;
      return this.recordingUploads[0].progress;
    }
  }, {
    key: "recordingIsTranscoded",
    get: function get() {
      if (!this.broadcast) {
        return false;
      } else if (this.broadcast.recording_id && this.broadcast.recording_duration_seconds) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "recordingIsBeingUploaded",
    get: function get() {
      if (!this.broadcast) {
        return false;
      } else if (!this.broadcast.recording_id && this.broadcast.stream_source == 'imported') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "recordingIsBeingReplaced",
    get: function get() {
      if (!this.broadcast || !this.recordingUploads || !this.recordingUploads.length) {
        return false;
      } else if (this.broadcast.recording_id && ['created', 'uploaded', 'assigned', 'processing', 'failed'].indexOf(this.recordingUploadStatus) >= 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "recordingIsWaitingToBePublished",
    get: function get() {
      if (!this.broadcast || !this.recordingUploads || !this.recordingUploads.length) {
        return false;
      } else if (this.broadcast.recording_id && this.broadcast.stream_source == 'imported' && this.recordingUploadStatus == 'completed' && this.broadcast.is_private) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "recordingUploadStatusMessage",
    get: function get() {
      // Support normal upload workflow
      var s = this.recordingUploadStatus;
      if (!s) return null;

      if (s == 'failed') {
        var reason = this.recordingUploadFailureReason;

        if (reason == 'transcode_failed') {
          return "Video failed to process due to an error transcoding your video. Please verify the file is the correct format before trying again.";
        } else if (reason == 'internal_server_error') {
          return "Video failed to process due to an internal server error.";
        } else if (_.contains(reason, 'CannotStartContainerError') && _.contains(reason, 'ThrottlingException')) {
          return "Video failed to process due to an internal error allocating a server for processing the upload.";
        } else if (reason) {
          return "Video failed to process: ".concat(reason, ".");
        } else {
          return 'Video failed to process. Please verify the file is the correct format before trying again.';
        }
      }

      return {
        created: 'Video has not finished uploading',
        uploaded: 'Video is waiting to be processed',
        assigned: 'Video is about to be processed',
        processing: 'Video is being transcoded',
        completed: 'Video will be ready momentarily'
      }[s] || 'Video upload status is unknown';
    }
  }, {
    key: "recordingReplacementStatusMessage",
    get: function get() {
      var s = this.recordingUploadStatus;
      if (!s) return null;

      if (s == 'failed') {
        var reason = this.recordingUploadFailureReason;

        if (reason == 'transcode_failed') {
          return "Video failed to process due to an error transcoding your video. Please verify the file is the correct format before trying again.";
        } else if (reason == 'internal_server_error') {
          return "Video failed to process due to an internal server error.";
        } else if (_.contains(reason, 'CannotStartContainerError') && _.contains(reason, 'ThrottlingException')) {
          return "Replacement video failed to process due to an internal error allocating a server for processing the upload.";
        } else if (reason) {
          return "Replacement video failed to process: ".concat(reason, ".");
        } else {
          return 'Replacement video failed to process. Please verify the file is the correct format before trying again';
        }
      }

      return {
        created: 'Replacement video has not finished uploading',
        uploaded: 'Replacement video is waiting to be processed',
        assigned: 'Replacement video is about to be processed',
        processing: 'Replacement video is being transcoded',
        completed: 'Replacement video will be ready momentarily'
      }[s] || 'Replacement video upload status is unknown';
    }
  }, {
    key: "recordingProcessingEstimate",
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_13__utils_uploads__["a" /* estimateProcessingTimeRemaining */])({
        broadcast: this.broadcast,
        upload: this.recordingUploadMostRecent
      });
    }
  }, {
    key: "emailMeWhenComplete",
    get: function get() {
      return ((this.broadcast || {}).metadata || {})['notify:uploaded_completed_email'] == this.user.email;
    },
    set: function set(val) {
      var _this2 = this;

      var user = this.user,
          Broadcast = this.Broadcast,
          toaster = this.toaster;
      var metadata = this.broadcast.metadata || {};

      if (val) {
        metadata['notify:uploaded_completed_email'] = user.email;
      } else {
        metadata['notify:uploaded_completed_email'] = undefined;
      }

      Broadcast.update({
        id: this.broadcast.id
      }, {
        metadata: metadata
      }, function (b) {
        return _this2.setBroadcast(b);
      }, function (e) {
        console.error(e);
        toaster.pop('warning', "Unable to add ".concat(user.email, " to notification for upload"));

        _this2.reloadSilent();
      });
    }
  }, {
    key: "showHighlights",
    get: function get() {
      return this.allowHighlights && (this.broadcast.recording_requested || this.broadcast.stream_source == 'imported') && (this.recordingIsTranscoded && !this.storageIsExpired || this.broadcast.timeframe == 'current');
    }
  }, {
    key: "producerBroadcastURL",
    get: function get() {
      return window.VUE_DASHBOARD_ROOT + '/producer/' + this.broadcast.id;
    }
  }, {
    key: "loadRecordingUploads",
    value: function loadRecordingUploads() {
      var _this3 = this;

      var $http = this.$http,
          toaster = this.toaster,
          $timeout = this.$timeout;
      $http.get("".concat(API_ROOT, "/account/broadcasts/").concat(this.$state.params.id, "/uploads")).then(function (response) {
        _this3.recordingUploads = response.data;
      }).then(function () {
        $timeout.cancel(_this3._calculateRecordingUploadHandle);

        if (_this3.recordingIsBeingUploaded || _this3.recordingIsBeingReplaced) {
          _this3._calculateRecordingUploadHandle = $timeout(function () {
            _this3.loadRecordingUploads();
          }, UPLOAD_PROGRESS_INTERVAL_MS);
        }
      })["catch"](function (e) {
        toaster.pop('warning', 'Could not load recording uploads');
      });
    }
  }, {
    key: "uploadReplacement",
    value: function uploadReplacement() {
      var _this4 = this;

      var $uibModal = this.$uibModal;
      $uibModal.open({
        template: __webpack_require__(213),
        controllerAs: 'vm',
        controller: __WEBPACK_IMPORTED_MODULE_5__uploads_modal_upload_event__["a" /* default */],
        size: 'lg',
        //  Prevent accidental close...
        backdrop: 'static',
        keyboard: false,
        resolve: {
          broadcast: function broadcast() {
            return _this4.broadcast;
          },
          highlights: function highlights() {
            return _this4.highlights;
          }
        }
      }).result.then(function (b) {
        _this4.reloadSilent();
      });
    }
  }, {
    key: "cancelUpload",
    value: function cancelUpload() {
      var _this5 = this;

      if (confirm('Do you wish to cancel this upload?')) {
        var $http = this.$http,
            toaster = this.toaster,
            $timeout = this.$timeout,
            recordingUploadMostRecent = this.recordingUploadMostRecent;
        $http.put("".concat(API_ROOT, "/account/broadcasts/").concat(this.$state.params.id, "/uploads/").concat(recordingUploadMostRecent.id), {
          status: 'canceled'
        }).then(function () {
          _this5.loadRecordingUploads();
        })["catch"](function (e) {
          toaster.pop('warning', 'Could not cancel upload. Please refresh and try again.');
        });
      }
    } ///
    /// Overlays
    ///

  }, {
    key: "loadUploadsForPage",
    value: function loadUploadsForPage(p) {
      var _this6 = this;

      var Overlays = this.Overlays,
          toaster = this.toaster;
      this.uploadsPromise = Overlays.loadOverlaysForPage(p).then(function (result) {
        _this6.uploads = result.uploads;
        _this6.uploadsPagination = result.pagination;
      })["catch"](function (err) {
        toaster.pop('warn', 'Unable to load overlay image gallery.');
      });
    }
  }, {
    key: "uploadOverlay",
    value: function uploadOverlay(file) {
      var _this7 = this;

      file.upload().then(function (result) {
        console.log('Overlay image uploaded', result);
        _this7.file = null;

        _this7.loadUploadsForPage(1);
      });
    }
  }, {
    key: "addOverlay",
    value: function addOverlay(upload) {
      var _this8 = this;

      var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var Overlays = this.Overlays,
          activeOverlays = this.activeOverlays,
          uploads = this.uploads,
          $rootScope = this.$rootScope,
          toaster = this.toaster;
      upload.__showOverlay = false;
      Overlays.prepareUploadForOverlay(upload).then(function (overlay) {
        if (replace) {
          uploads.forEach(function (u) {
            return u.__inUse = false;
          });

          while (activeOverlays.length) {
            activeOverlays.pop();
          }
        }

        activeOverlays.push(overlay);
        upload.__inUse = true;
        _this8.overlaysChanged = true;
      })["catch"](function (err) {
        console.error(err);
        toaster.pop('warn', 'Unable to select overlay image.');
      });
    }
  }, {
    key: "deleteUpload",
    value: function deleteUpload(upload) {
      var _this9 = this;

      var ConfirmDialog = this.ConfirmDialog,
          AccountUploadsService = this.AccountUploadsService,
          toaster = this.toaster;
      upload.__showOverlay = false;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Delete Image From Gallery',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to delete this image from your gallery? It will no longer be accessible.'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        AccountUploadsService.deleteUpload(upload).then(function () {
          toaster.pop('success', 'The image was successfully deleted.');
        }).then(function () {
          _this9.loadUploadsForPage(1);
        })["catch"](function (error) {
          console.error(error);
          toaster.pop('warning', 'An error occurred while trying to delete the image. Please refresh and try again.');
        });
      });
    }
  }, {
    key: "removeOverlay",
    value: function removeOverlay(upload) {
      upload.__showOverlay = false;

      _.remove(this.activeOverlays, {
        url: upload.view_url
      });

      upload.__inUse = false;
      this.overlaysChanged = true;
    }
  }, {
    key: "onOverlayChange",
    value: function onOverlayChange(overlay, attrs) {
      var i = this.activeOverlays.indexOf(overlay);

      if (i < 0) {
        console.warn('Unable to locate changed overlay', overlay, 'in', this.activeOverlays);
        return;
      }

      _.assign(this.activeOverlays[i], attrs);

      this.overlaysChanged = true;
    }
  }, {
    key: "restoreOverlaysFromMetadata",
    value: function restoreOverlaysFromMetadata() {
      var _this10 = this;

      if (!this.allowOverlays) return;

      if (!this.overlaysChanged) {
        this.activeOverlays = angular.copy((this.broadcast.metadata || {}).overlays || []); //make copy so that we can restore later

        this.activeOverlays.forEach(function (o) {
          _this10.uploadsPromise.then(function () {
            _.where(_this10.uploads, {
              view_url: o.url
            }).forEach(function (u) {
              return u.__inUse = true;
            });
          });
        });
      }
    }
  }, {
    key: "discardOverlays",
    value: function discardOverlays() {
      this.overlaysChanged = false;
      this.uploads.forEach(function (u) {
        return u.__inUse = false;
      });
      this.restoreOverlaysFromMetadata();
    }
  }, {
    key: "saveOverlays",
    value: function saveOverlays() {
      var _this11 = this;

      var Broadcast = this.Broadcast,
          broadcast = this.broadcast,
          toaster = this.toaster;
      var metadata = broadcast.metadata || {};
      metadata.overlays = this.activeOverlays;
      this.overlaysSaving = true;
      Broadcast.update({
        id: this.broadcast.id
      }, {
        metadata: metadata
      }, function (b) {
        _this11.overlaysChanged = false;
        _this11.overlaysSaving = false;

        _this11.setBroadcast(b);

        toaster.pop('success', 'Overlay activated.');
      }, function (err) {
        _this11.overlaysSaving = false;
        console.error(err);
        toaster.pop('warning', "Unable to activate overlays. Please refresh and try again.");
      });
    } ///
    /// Cue Points
    ///

  }, {
    key: "addCue",
    value: function addCue() {
      var _this12 = this;

      var Broadcast = this.Broadcast;

      if (!this.cue.name) {
        this.toaster.pop('warning', 'Please enter a title for the video index entry');
        return;
      }

      var timestamp = this.clapprUtils.getCurrentTime();
      var segmentAndOffset = this.clapprUtils.getPlayerSegmentAndOffsetForTime(timestamp);
      console.log(segmentAndOffset);

      if (!segmentAndOffset) {
        this.toaster.pop('warning', 'Please make sure the start time is within the valid range of the video.');
        return;
      }

      var content_settings = this.broadcast.content_settings || {};
      content_settings.cues = angular.copy(content_settings.cues || []);
      content_settings.cues.push({
        name: this.cue.name,
        description: '',
        playback_start_time_fmt: Object(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* secondsToFormattedLabel */])(timestamp),
        // XXX: TODO: can we map to VOD timestamp when live?
        segment: segmentAndOffset[0],
        time_offset_in_segment: segmentAndOffset[1]
      });
      content_settings.cues = _.sortBy(content_settings.cues, 'playback_start_time_fmt');
      Broadcast.update({
        id: this.$state.params.id
      }, {
        content_settings: content_settings
      }).$promise.then(function (b) {
        _this12.toaster.pop('success', 'Saved video index entry');

        _this12.setBroadcast(b);

        _this12.reloadPlayerMeta();

        _this12.cue.name = '';
      })["catch"](function (err) {
        _this12.toaster.pop('warning', 'Unable to save video index entry, please check your entry and try again.');

        console.error(err);
      });
    }
  }, {
    key: "seekCue",
    value: function seekCue(c) {
      this.player.seek(Object(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formattedLabelToSeconds */])(c.playback_start_time_fmt));
      this.player.play();
    }
  }, {
    key: "deleteCue",
    value: function deleteCue(c) {
      var _this13 = this;

      var Broadcast = this.Broadcast;
      var idx = this.broadcast.content_settings.cues.indexOf(c);

      if (idx < 0) {
        this.toaster.pop('warning', 'Unable to delete video index entry, please refresh and try again.');
        return;
      }

      var cs = angular.copy(this.broadcast.content_settings);
      cs.cues.splice(idx, 1);
      Broadcast.update({
        id: this.$state.params.id
      }, {
        content_settings: cs
      }).$promise.then(function (b) {
        _this13.toaster.pop('success', 'Deleted video index entry');

        _this13.setBroadcast(b);

        _this13.reloadPlayerMeta();
      })["catch"](function (err) {
        _this13.toaster.pop('warning', 'Unable to delete video index entry, please refresh and try again.');

        console.error(err);
      });
    }
  }, {
    key: "editCue",
    value: function editCue(c) {
      var _this14 = this;

      var Broadcast = this.Broadcast;
      delete c.__enableEditMode;
      Broadcast.update({
        id: this.$state.params.id
      }, {
        content_settings: this.broadcast.content_settings
      }).$promise.then(function (b) {
        _this14.toaster.pop('success', 'Saved video index entry');

        _this14.setBroadcast(b);

        _this14.reloadPlayerMeta();
      })["catch"](function (err) {
        _this14.toaster.pop('warning', 'Unable to save video index entry, please check your entry and try again.');

        console.error(err);
      });
    } ///
    /// Documents
    ///

  }, {
    key: "saveDocument",
    value: function saveDocument(d, file) {
      var _this15 = this;

      var Broadcast = this.Broadcast,
          toaster = this.toaster;

      if (!file) {
        toaster.pop('warning', 'Please select a file');
        return;
      }

      if (!d || !d.name || !d.name.trim()) {
        toaster.pop('warning', 'Please enter a valid document name');
        return;
      }

      file.upload().then(function (result) {
        console.log('Document uploaded', result);
        var cs = angular.copy(_this15.broadcast.content_settings) || {};
        cs.documents = cs.documents || [];
        cs.documents.push({
          name: d.name,
          url: result.view_url
        });
        Broadcast.update({
          id: _this15.$state.params.id
        }, {
          content_settings: cs
        }).$promise.then(function (b) {
          toaster.pop('success', 'Successfully uploaded document');

          _this15.setBroadcast(b);

          _this15.newDocumentFile = null;
        }).then(function () {
          _this15.document = {};
        })["catch"](function (err) {
          toaster.pop('warning', 'Unable to upload document, please check your entry and try again.');
          console.error(err);
        });
      });
    }
  }, {
    key: "deleteDocument",
    value: function deleteDocument(d) {
      var _this16 = this;

      var Broadcast = this.Broadcast,
          ConfirmDialog = this.ConfirmDialog;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Remove Document',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to remove this document from the broadcast?'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        var idx = _this16.broadcast.content_settings.documents.indexOf(d);

        if (idx < 0) {
          _this16.toaster.pop('warning', 'Unable to delete document, please check your entry and try again.');

          return;
        }

        var cs = angular.copy(_this16.broadcast.content_settings);
        cs.documents.splice(idx, 1);
        Broadcast.update({
          id: _this16.$state.params.id
        }, {
          content_settings: cs
        }).$promise.then(function (b) {
          _this16.toaster.pop('success', 'Deleted document');

          _this16.setBroadcast(b);
        })["catch"](function (err) {
          _this16.toaster.pop('warning', 'Unable to delete document, please check your entry and try again.');

          console.error(err);
        });
      });
    }
  }, {
    key: "editDocument",
    value: function editDocument(d) {
      var _this17 = this;

      var Broadcast = this.Broadcast;
      delete d.__enableEditMode;
      Broadcast.update({
        id: this.$state.params.id
      }, {
        content_settings: this.broadcast.content_settings
      }).$promise.then(function (b) {
        _this17.toaster.pop('success', 'Saved document');

        _this17.setBroadcast(b);
      })["catch"](function (err) {
        _this17.toaster.pop('warning', 'Unable to save document, please check your entry and try again.');

        console.error(err);
      });
    } ///
    /// Captions
    ///

  }, {
    key: "startCaptioning",
    value: function startCaptioning() {
      var _this18 = this;

      var upload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var Caption = this.Caption,
          toaster = this.toaster;
      var data = {
        source: 'on-demand'
      };

      if (upload != null) {
        data = {
          source: 'uploaded',
          status: 'complete',
          cues: upload.cues.map(function (c) {
            return {
              start_time: c.startTime,
              end_time: c.endTime,
              text: c.text,
              confidence: 1.0
            };
          })
        };
      }

      Caption.create({
        broadcast_id: this.broadcast.id
      }, data).$promise.then(function () {
        toaster.pop('success', 'Successfully started captioning.');

        _this18.safeReloadCaptions();
      })["catch"](function (err) {
        toaster.pop('warning', 'Unable to start captioning. Please refresh and try again.');
        console.error(err);
      });
    }
  }, {
    key: "safeReloadCaptions",
    value: function safeReloadCaptions() {
      var _this19 = this;

      var Caption = this.Caption,
          $timeout = this.$timeout,
          toaster = this.toaster;

      if (!this.allowCaptions) {
        return;
      }

      var CAPTION_RELOAD_INTERVAL_MS = 30000;
      this.loadingCaptions = true;
      Caption.query({
        broadcast_id: this.$state.params.id
      }, function (captions) {
        _this19.loadingCaptions = false;
        _this19.caption = null;

        _.each(captions, function (c) {
          if (c.recording_id === _this19.broadcast.recording_id) {
            _this19.caption = c;
          }
        });

        if (_this19.caption) {
          if (_this19.caption.status != 'completed' && _this19.caption.status != 'failed') {
            _this19._captionReloadHandle = $timeout(function () {
              return _this19.safeReloadCaptions();
            }, CAPTION_RELOAD_INTERVAL_MS);
          }

          if (_this19.caption.cues) {
            _this19.captionTranscipt = _this19.caption.cues.map(function (c) {
              return "".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* secondsToFormattedLabel */])(c.start_time), "   ").concat(c.text);
            }).join('\n');
          }
        }
      }, function (err) {
        console.error(err);
        _this19.loadingCaptions = false;
        toaster.pop('warning', 'Unable to load captions', 'There was an issue loading the captions for the broadcast. Please reload and try again.');
      });
    }
  }, {
    key: "downloadCaption",
    value: function downloadCaption(format) {
      var _this20 = this;

      var Caption = this.Caption,
          toaster = this.toaster;
      Caption.render({
        broadcast_id: this.$state.params.id,
        id: this.caption.id,
        format: format
      }, function (response) {
        var extension = format === 'text' ? 'txt' : 'vtt';
        var filename = _this20.$state.params.id + '_captions.' + extension;
        Object(__WEBPACK_IMPORTED_MODULE_10__utils_download__["a" /* forceBrowserDownload */])(URL.createObjectURL(response.blob), filename);
      }, function (err) {
        console.error(err);
        toaster.pop('warning', 'Unable to download captions', 'There was an issue downloading the captions for the broadcast. Please reload and try again.');
      });
    }
  }, {
    key: "canEnterProducer",
    get: function get() {
      var account = this.account;
      return account.feature_flags.producer;
    } ///
    /// RTMP
    ///

  }, {
    key: "canUsePreview",
    get: function get() {
      var account = this.account; // Low-latency preview is gated by feature flag PLUS browser-compatibility
      // Note that we're not feature-detecting Flash specifically (although we could)
      // because this allows us to advertise to desktop users who might only have
      // to install the flash plugin to get it to work.

      if (!account.extra_features.low_latency_preview) {
        return false;
      }

      if (navigator.userAgent.indexOf('iOS') >= 0 || navigator.userAgent.indexOf('Android') >= 0) {
        return false;
      }

      if ((this.broadcast || {}).actual_codec == 'hevc') {
        return false;
      }

      return !!(this.broadcast || {}).rtmp_preview_url;
    }
  }, {
    key: "configureRTMP",
    value: function configureRTMP() {
      if (this.broadcast.stream_source != 'rtmp' && this.broadcast.stream_source != 'switcher') {
        this.showRtmpConfig = false;
        return;
      }

      this.rtmpVideoParams = Object(__WEBPACK_IMPORTED_MODULE_0__broadcast_with_rtmp_controller__["b" /* resolutionForBroadcast */])(this.broadcast);
      this.rtmpVideoParams.framerate = 30;

      if (this.FeatureFlags.high_frame_rate && this.broadcast.target_high_frame_rate === true) {
        this.rtmpVideoParams.framerate = 60;
      }

      if (this.broadcast.static_rtmp_id || this.broadcast.rtmp_ingestion_url) {
        // If we have static RTMP, or API has already assigned the single-use address, go ahead
        // and show settings unless broadcast is already over.
        this.showRtmpConfig = this.broadcast.timeframe != 'past';
      } else {
        // For Generic RTMP, we won't have the RTMP config until at least pre-roll, but we also
        // need to take the extra step of making a stream.  Go ahead and try that as long as we're
        // eligible to based ont he timeframe. Note that static RTMP channels do this automagically.
        this.showRtmpConfig = false;
      }
    }
  }, {
    key: "_openRtmpModal",
    value: function _openRtmpModal(_encoderType) {
      var _this21 = this;

      var BandwidthTestClient = this.BandwidthTestClient;
      var RUN_TEST_EVERY_TIME = false; //useful for testing

      var showFullRTMPSettingsModal = function showFullRTMPSettingsModal() {
        _this21.$uibModal.open({
          template: __webpack_require__(438),
          controllerAs: 'vm',
          controller: __WEBPACK_IMPORTED_MODULE_0__broadcast_with_rtmp_controller__["a" /* default */],
          size: 'lg',
          resolve: {
            availableBandwidth: function availableBandwidth() {
              return _this21.availableBandwidth;
            },
            broadcast: function broadcast() {
              return _this21.broadcast;
            },
            encoderType: function encoderType() {
              return _encoderType;
            }
          }
        });
      };

      if (this.availableBandwidth && !RUN_TEST_EVERY_TIME) {
        showFullRTMPSettingsModal();
      } else {
        this.BandwidthTestClient.cancelIfInFlight();
        this.$uibModal.open({
          template: "\n        <div class=\"modal-header\">\n          <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n          <h3>Testing Bandwidth</h3>\n        </div>\n        <div class=\"modal-body text-center\">\n          <p>Please wait while we run a bandwidth test to determinte appropriate settings.</p>\n          <h1>\n            <small>ESTIMATED UPLOAD SPEED</small>\n            <span class=\"throb-in-progress\" style=\"display:inline-block;min-width:175px;text-align:right;font-weight:bold;\">\n              {{vm.estimatedBandwidth|bits}}ps\n            </span>\n          </h1>\n        </div>\n        ",
          controllerAs: 'vm',
          controller: function controller($uibModalInstance, $timeout) {
            'ngInject';

            var _this22 = this;

            this.close = function () {
              return $uibModalInstance.dismiss('cancel');
            };

            this.estimatedBandwidth = 0;

            this.onProgress = function (stats) {
              $timeout(function () {
                _this22.estimatedBandwidth = stats.estimatedBandwidth;

                if (isNaN(_this22.estimatedBandwidth) || _this22.estimatedBandwidth < 0) {
                  _this22.estimatedBandwidth = 0;
                }
              }, 0);
            };

            BandwidthTestClient.runTestOrUseRecentCached(this.onProgress, RUN_TEST_EVERY_TIME).then(function (result) {
              var delay = result.fromCache ? 0 : 1000;
              $timeout(function () {
                $uibModalInstance.close(result);
              }, delay);
            });
          },
          size: 'lg'
        }).result.then(function (result) {
          _this21.availableBandwidth = result.availableBandwidth;
          showFullRTMPSettingsModal();
        });
      }
    }
  }, {
    key: "tricaster",
    value: function tricaster() {
      this._openRtmpModal('TriCaster');
    }
  }, {
    key: "rtmp",
    value: function rtmp() {
      this._openRtmpModal('Other Encoder');
    } ///
    /// Misc
    ///

  }, {
    key: "showDiagnostics",
    get: function get() {
      if (!this.broadcast) return false;
      return this.broadcast.timeframe != 'future' && this.broadcast.stream_source != 'imported';
    }
  }, {
    key: "activeLiveAutomatedCaptions",
    get: function get() {
      // A broadcast has active live, automated captions if:
      //  - live automated captioning is allowed;
      //  - the broadcast requests captioning; and
      //  - the broadcast is current or preroll,
      if (!this.allowLiveAutomatedCaptioning) return false;
      if (!this.broadcast.requests_captioning) return false;
      return ['preroll', 'current'].indexOf(this.broadcast.timeframe) >= 0;
    }
  }, {
    key: "showCaptionsTab",
    get: function get() {
      // If captions aren't allowed, don't show the tab
      if (!this.allowCaptions) return false; // If recordingIsAvailable, then the user can do captions things, so show the tab.

      if (this.recordingIsAvailable) return true; // If we get here, the only reason to show the tab is if the broadcast has active live
      // automated captions and the user can edit the broadcast.

      return this.activeLiveAutomatedCaptions && this.canEdit;
    }
  }, {
    key: "showRecordingControls",
    get: function get() {
      return (this.canEdit || this.canCreate) && this.publicView && this.broadcast.timeframe == 'past' && !this.storageIsExpired || this.showReplayViaSimulatedLive;
    }
  }, {
    key: "showUploadReplacement",
    get: function get() {
      return this.canUpload && this.broadcast.timeframe == 'past' && this.broadcast.stream_source != 'recording' && !this.broadcast.do_not_record;
    }
  }, {
    key: "showEditHighlightClips",
    get: function get() {
      return this.showHighlights && this.recordingIsTranscoded;
    }
  }, {
    key: "showReplayViaSimulatedLive",
    get: function get() {
      return this.allowSimulatedLive && (this.broadcast.timeframe != 'past' || this.recordingIsAvailable && this.recordingIsV2a);
    }
  }, {
    key: "boxCasterStatusLabel",
    get: function get() {
      // get the status label CSS class ... only shown for future/current broadcasts
      if (!this.boxcaster) {
        return 'unknown';
      } // boxcaster statuses include:
      // * unregistered probing decommissioned (admin only)
      // * ready preparing_broadcast broadcasting
      // * offline
      // boxcaster warnings include:
      // * no_video_input updating_firmware
      // * none


      if (this.broadcast.timeframe == 'future') {
        // Future broadcasts are OK to be in strange states
        if (['broadcasting', 'preparing_broadcast', 'ready'].indexOf(this.boxcaster.status) >= 0) {
          return 'connected';
        } else {
          return 'unknown';
        }
      } else {
        // If the timeframe is current/preroll, it's a warning to be anything other than broadcasting/preparing
        if (['broadcasting', 'preparing_broadcast'].indexOf(this.boxcaster.status) >= 0) {
          if (this.boxcaster.next_broadcast_id != this.broadcast.id) {
            // Special case of "broadcasting" but with some *other* broadcast
            return 'warning';
          } else if (this.boxcaster.warning && this.boxcaster.warning != 'none') {
            return 'warning';
          } else {
            return 'connected';
          }
        } else {
          return 'warning';
        }
      }
    }
  }, {
    key: "diagnosticsIconStyle",
    value: function diagnosticsIconStyle(s, idx) {
      if (s.status === 'error') {
        return 'warning';
      } else if (this.activeDestinationStatus[idx] && this.activeDestinationStatus[idx].connected) {
        return 'connected';
      }

      return '';
    }
  }, {
    key: "setBroadcast",
    value: function setBroadcast(broadcast) {
      // If the broadcast is going from non-past to past and the captions tab is selected, select the
      // overview tab to avoid a goofy interim state in the captions tab.
      if (this.broadcast.timeframe !== 'past' && broadcast.timeframe === 'past' && this.activeTab === 'captions') {
        this.changeTab('');
      }

      this.broadcast = broadcast;
      this.fixBroadcast();
      this.computeBroadcastStatus();
    }
  }, {
    key: "reloadSilent",
    value: function reloadSilent() {
      var _this23 = this;

      var $timeout = this.$timeout,
          FeatureFlags = this.FeatureFlags;
      $timeout.cancel(this._reloadHandle);
      this.Broadcast.get({
        id: this.$state.params.id
      }, function (b) {
        _this23.setBroadcast(b);

        _this23._reloadHandle = $timeout(function () {
          return _this23.reloadSilent();
        }, REFRESH_INTERVAL_MS);
      }, function (error) {
        console.error('Unable to reload broadcast metadata, will try again.', error);
        _this23._reloadHandle = $timeout(function () {
          return _this23.reloadSilent();
        }, REFRESH_INTERVAL_MS);
      });
    }
  }, {
    key: "reload",
    value: function reload(firstTime) {
      var _this24 = this;

      return new Promise(function (resolve, reject) {
        var $timeout = _this24.$timeout,
            FeatureFlags = _this24.FeatureFlags;
        var id = _this24.$state.params.id;
        _this24.broadcast = _this24.Broadcast.get({
          id: id
        }, function (b) {
          _this24.setBroadcast(b);

          _this24.safeReloadCaptions();

          _this24.playerOptions = {
            autoplay: false,
            ticketId: _this24.ticketId,
            onLoadBroadcast: function onLoadBroadcast() {
              $timeout(function () {
                var SelectedBroadcastStore = boxcast.model.SelectedBroadcastStore;
                _this24.publicView = SelectedBroadcastStore.view;
                _this24.publicBroadcast = SelectedBroadcastStore.broadcast;

                _this24.computeBroadcastStatus(); // The first time this is loaded, if the captions tab was requested via URL and it's
                // now able to be shown (showCaptionsTab depends on publicView), select it.


                if (firstTime && _this24.$state.params.tab === 'captions' && _this24.showCaptionsTab) {
                  _this24.activeTab = _this24.$state.params.tab;
                }
              }, 0);
            },
            onRefresh: function onRefresh(SelectedBroadcastStore) {
              // Player refreshed its metadata; keep dashboard in sync
              _this24.reloadSilent();

              $timeout(function () {
                _this24.publicView = SelectedBroadcastStore.view;
                _this24.publicBroadcast = SelectedBroadcastStore.broadcast;

                _this24.computeBroadcastStatus();
              }, 0);
            },
            onLoadPlayer: function onLoadPlayer(player) {
              return $timeout(function () {
                _this24.player = player;
                _this24.clapprUtils = new __WEBPACK_IMPORTED_MODULE_7__utils_clappr__["a" /* default */](player);

                if (_this24.clapprUtils.isUsingHlsJs() && _this24.broadcast.recording_id) {
                  _this24.isUsingHlsJsOnRecording = true;
                }
              }, 0);
            }
          };

          if (_this24.broadcast.scoreboard_configuration && _this24.broadcast.scoreboard_configuration.sport && _this24.broadcast.scoreboard_configuration.scoreboard_make === 'Manual') {
            _this24.enableScoreboardControls = true;
          }

          if (firstTime) {
            if (_this24.$state.params.tab && _this24.$state.params.tab !== 'captions') {
              _this24.activeTab = _this24.$state.params.tab;
            }

            if (_this24.$state.params.action && _this24.$state.params.action === 'export' && _this24.canDownloadOrExport) {
              _this24.downloadOrExport();
            }

            _this24.fb.init();
          }

          resolve(b);
        }, function (error) {
          if (error && error.data && error.data.error == 'not_found') {
            // If broadcast was not found, kick them back to home screen
            _this24.$state.go('home');

            _this24.toaster.pop('warning', "Broadcast ".concat(id, " could not be found"));
          } else if (error && error.data && error.data.error == 'gone') {
            // If broadcast was deleted, kick them back to home screen
            _this24.$state.go('home');

            _this24.toaster.pop('warning', "Broadcast ".concat(id, " was deleted"));
          } else {
            console.error(error);

            _this24.toaster.pop('warning', "There was an error loading the broadcast. Please refresh the page and try again.", '', 0);
          }

          reject(error);
        });
        _this24.highlights = _this24.Highlight.query({
          broadcastId: _this24.$state.params.id,
          s: 'streamed_at'
        }, function (data, headers) {
          var pagination = JSON.parse(headers('x-pagination'));
          _this24.totalHighlights = pagination.total;
        });
        _this24.loadingPromises = [_this24.broadcast.$promise, _this24.highlights.$promise];
      });
    }
  }, {
    key: "computeAllowSocial",
    value: function computeAllowSocial() {
      var FeatureFlags = this.FeatureFlags,
          account = this.account,
          broadcast = this.broadcast;
      this.allowSocial = Object(__WEBPACK_IMPORTED_MODULE_6__utils_allow_social__["a" /* AllowSocial */])(FeatureFlags, account, broadcast);
    }
  }, {
    key: "computeBroadcastStatus",
    value: function computeBroadcastStatus() {
      this.broadcastStatus = Object(__WEBPACK_IMPORTED_MODULE_12__utils_stream_diagnostics__["b" /* ComputeBroadcastStatus */])(this.broadcast, this.publicView, this.boxcaster, this.streamDiagnostics, this.staticRTMPDiagnostics);
    }
  }, {
    key: "fixBroadcast",
    value: function fixBroadcast() {
      var _this25 = this;

      var canUpload = this.canUpload,
          BoxCaster = this.BoxCaster,
          Broadcast = this.Broadcast,
          Recording = this.Recording,
          StaticRTMP = this.StaticRTMP,
          $http = this.$http;
      this.ticketId = '.' + this.broadcast.admin_token;
      this.generateEmailLink();
      this.restoreOverlaysFromMetadata();
      this.configureRTMP();

      if (canUpload) {
        this.loadRecordingUploads();
      }

      var cs = this.broadcast.content_settings || {};

      if (cs.agenda_url && !cs.documents) {
        this.broadcast.content_settings.documents = [{
          name: 'Agenda',
          url: this.broadcast.content_settings.agenda_url
        }];
        delete this.broadcast.content_settings.agenda_url;
      }

      if (this.broadcast.stream_source == 'boxcaster' && this.broadcast.boxcaster_id) {
        BoxCaster.get({
          id: this.broadcast.boxcaster_id
        }, function (b) {
          _this25.boxcaster = b;

          _this25.computeBroadcastStatus();
        });
      }

      if (this.broadcast.stream_source == 'rtmp' && this.broadcast.static_rtmp_id) {
        StaticRTMP.get({
          id: this.broadcast.static_rtmp_id,
          include_diagnostics: true
        }, function (r) {
          _this25.staticRTMPDiagnostics = r.diagnostics;
        });
      }

      if (this.broadcast.stream_source === 'recording' && this.broadcast.source_broadcast_id) {
        if (!this.sourceBroadcast || this.sourceBroadcast.id !== this.broadcast.source_broadcast_id) {
          Broadcast.get({
            id: this.broadcast.source_broadcast_id
          }, function (b) {
            _this25.sourceBroadcast = b;

            if (_this25.broadcast.timeframe !== 'past') {
              var durationSeconds = (_this25.sourceBroadcast || {}).recording_duration_seconds;

              if (durationSeconds) {
                _this25.broadcast.stops_at = moment(_this25.broadcast.starts_at).add(durationSeconds, 'seconds').toDate();
              }
            }
          }, function (e) {
            if (e.status === 404 || e.status === 410) {
              _this25.sourceBroadcastUnavailable = true;
            } else {
              console.error(e);
            }
          });
        }
      }

      if (!this.simulatedLiveBroadcasts) {
        this.Broadcast.query({
          'filter.source_broadcast_id': this.broadcast.id,
          l: 1000,
          s: 'starts_at'
        }, function (results) {
          return _this25.simulatedLiveBroadcasts = results;
        }, function (e) {
          return console.error(e);
        });
      }

      if (this.broadcast.recording_id && !this.recordingSegments) {
        this.recordingSegments = Recording.segments({
          id: this.broadcast.recording_id
        }, function (segments) {
          return _this25.recordingIsV2a = _.some(segments, function (s) {
            return s.byte_ranges;
          });
        });
      }

      this.computeAllowSocial();
      var broadcastStartsAt = moment(this.broadcast.starts_at);
      var latestFacebookLiveScheduledEventTime = moment().add(7, 'days');
      this.canCreateFacebookLiveScheduledEvent = broadcastStartsAt < latestFacebookLiveScheduledEventTime; // Persist state values to allow 2-way binding separate from the computed properties

      this.showChatStateValue = this.showChat;
      this.enableCaptionsStateValue = this.enableCaptions;
    }
  }, {
    key: "youtubeEmbedUrl",
    value: function youtubeEmbedUrl(config) {
      return this.$sce.trustAsResourceUrl("https://www.youtube.com/embed/".concat(config.youtube_broadcast_id, "?autoplay=1"));
    }
  }, {
    key: "youtubeWatchUrl",
    value: function youtubeWatchUrl(config) {
      return this.$sce.trustAsResourceUrl("https://www.youtube.com/watch/".concat(config.youtube_broadcast_id));
    }
  }, {
    key: "periscopeWatchUrl",
    value: function periscopeWatchUrl(config) {
      return this.$sce.trustAsResourceUrl(config.share_url);
    }
  }, {
    key: "twitterWatchUrl",
    value: function twitterWatchUrl(config) {
      return this.$sce.trustAsResourceUrl(config.share_url);
    }
  }, {
    key: "canShowFacebookLiveProducerURL",
    value: function canShowFacebookLiveProducerURL(config) {
      // Can't show it if doesn't exist
      if (!config.live_producer_url) return false; // Can't show it if not logged in or for another user, as it won't work

      if (config.facebook_account_id != this.fb.facebook_account_id) return false; // Pretty sure the live producer page only works when the broadcast is scheduled

      return config.status == 'scheduled';
    }
  }, {
    key: "canShowFacebookPermalinkURL",
    value: function canShowFacebookPermalinkURL(config) {
      // Can't show it if it doesn't exist
      if (!config.permalink_url) return false; // XXX: https://developers.facebook.com/support/bugs/673296246903206/
      // XXX: https://www.facebook.com/business/help/2087325741287572?id=1123223941353904
      // The permalink_url doesn't actually go active until the live stream is live.

      return _.contains(['published', 'scheduled_live', 'stopping', 'stopped'], config.status);
    }
  }, {
    key: "createFacebookLiveScheduledEvent",
    value: function createFacebookLiveScheduledEvent(config) {
      var Broadcast = this.Broadcast,
          broadcast = this.broadcast,
          toaster = this.toaster;
      config.__updating = true;
      var promise = Broadcast.scheduleSimulcast({
        id: broadcast.id,
        simulcast_id: config.id
      }).$promise;
      promise.then(function (response) {
        _.assign(config, response);
      })["catch"](function (e) {
        console.error(e);
        toaster.pop('warning', 'Unable to schedule the Facebook Live event. Please check the status of your Facebook account on the settings page and try again.');
      })["finally"](function () {
        config.__updating = false;
      });
      this.loadingPromises.push(promise);
    }
  }, {
    key: "facebookLiveSimulcastFeedType",
    value: function facebookLiveSimulcastFeedType(config) {
      return config.fb_feed_id.split(':', 1)[0];
    }
  }, {
    key: "facebookLiveSimulcastFeedID",
    value: function facebookLiveSimulcastFeedID(config) {
      return config.fb_feed_id.replace(/^[^:]*:/, '');
    }
  }, {
    key: "createYouTubeEvent",
    value: function createYouTubeEvent(config) {
      var _this26 = this;

      var Broadcast = this.Broadcast,
          broadcast = this.broadcast,
          toaster = this.toaster;
      config.__updating = true;
      var promise = Broadcast.scheduleSimulcast({
        id: broadcast.id,
        simulcast_id: config.id
      }).$promise;
      promise.then(function (response) {
        _.assign(config, response);
      })["catch"](function (e) {
        console.error(e);

        _this26.toaster.pop('warning', 'Unable to create the linked YouTube event. Please check the status of your YouTube account on the settings page and try again.');
      })["finally"](function () {
        config.__updating = false;
      });
      this.loadingPromises.push(promise);
    }
  }, {
    key: "scheduleSimulatedLive",
    value: function scheduleSimulatedLive() {
      this.$state.go('new-event', {
        streamSource: 'recording',
        sourceBroadcastId: this.broadcast.id
      });
    }
  }, {
    key: "downloadOrExport",
    value: function downloadOrExport() {
      var $uibModal = this.$uibModal,
          _broadcast = this.broadcast,
          $analytics = this.$analytics;
      $uibModal.open({
        template: __webpack_require__(439),
        controllerAs: 'vm',
        controller: __WEBPACK_IMPORTED_MODULE_3__modal_download_or_export_recording__["a" /* default */],
        resolve: {
          broadcast: function broadcast() {
            return _broadcast;
          }
        }
      });
    }
  }, {
    key: "changeTab",
    value: function changeTab(newActiveTab) {
      if (newActiveTab != this.activeTab) {
        if (newActiveTab != '') {
          this.$location.search('tab', newActiveTab).replace();
        } else {
          this.$location.search('tab', null).replace();
        }
      }

      this.activeTab = newActiveTab;
    }
  }, {
    key: "edit",
    value: function edit() {
      var _this27 = this;

      var _activeTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var $uibModal = this.$uibModal,
          canEdit = this.canEdit;

      if (!canEdit) {
        console.warn('Not allowed to edit');
        return;
      }

      $uibModal.open({
        template: __webpack_require__(197),
        controller: 'EditEventController',
        controllerAs: 'vm',
        resolve: {
          broadcastId: function broadcastId() {
            return _this27.broadcast.id;
          },
          activeTab: function activeTab() {
            return _activeTab;
          }
        }
      }).result.then(function (broadcast) {
        //this.broadcast = broadcast;
        var params = {
          id: broadcast.id,
          tab: _activeTab
        };

        if (_this27.queryParams.action === 'open_edit') {
          // the broadcast edit dialog was saved, we dont want it to re-open after the update has succeeded
          params.action = null;
        } // Refresh entire state of page (e.g. scoreboard)


        _this27.$state.go('events.detail', params, {
          reload: true
        });
      });
    }
  }, {
    key: "openHighlight",
    value: function openHighlight(highlight) {
      var _this28 = this;

      var Highlight = this.Highlight,
          $uibModal = this.$uibModal;
      var highlightDetails = Highlight.get({
        broadcastId: this.broadcast.id,
        id: highlight.id
      });
      highlightDetails.$promise.then(function () {
        if (!_this28.broadcast.is_private && _this28.broadcast.is_ticketed && highlightDetails.duration > MAX_MONETIZED_HIGHLIGHT_TIME_S) {
          // Can't preview -- open the editor
          $uibModal.open({
            size: 'lg',
            backdrop: 'static',
            // don't allow accidental clicks on backdrop to close
            template: __webpack_require__(214),
            controllerAs: 'vm',
            controller: __WEBPACK_IMPORTED_MODULE_1__modal_capture_highlight_recorded__["a" /* default */],
            resolve: {
              highlightObj: function highlightObj() {
                return highlightDetails;
              },
              recordingId: function recordingId() {
                return _this28.broadcast.recording_id;
              }
            }
          });
        } else {
          // Open the preview
          var modalInstance = _this28.openHighlightPreviewModal(highlightDetails);

          modalInstance.closed.then(function () {
            // Refresh highlights in case the user deleted this one in the modal.
            _this28.highlights = _this28.Highlight.query({
              broadcastId: _this28.broadcast.id
            });
          });
        }
      });
    }
  }, {
    key: "openHighlightPreviewModal",
    value: function openHighlightPreviewModal(_highlightDetails) {
      var _this29 = this;

      var _showSave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var $uibModal = this.$uibModal;
      return $uibModal.open({
        template: __webpack_require__(215),
        resolve: {
          broadcast: function broadcast() {
            return _this29.broadcast;
          },
          highlightDetails: function highlightDetails() {
            return _highlightDetails;
          },
          showSave: function showSave() {
            return _showSave;
          }
        },
        controller: __WEBPACK_IMPORTED_MODULE_4__modal_highlight_preview__["a" /* default */],
        controllerAs: 'vm',
        size: 'lg'
      });
    }
  }, {
    key: "openLowLatencyPreview",
    value: function openLowLatencyPreview() {
      this.preview = true;
    }
  }, {
    key: "onNewHighlightCaptured",
    value: function onNewHighlightCaptured() {
      this.toaster.pop('success', 'Highlight saved');
      this.highlights = this.Highlight.query({
        broadcastId: this.broadcast.id
      });
    }
  }, {
    key: "enterProducer",
    value: function enterProducer() {
      window.location.replace(this.producerBroadcastURL);
    }
  }, {
    key: "startASAP",
    value: function startASAP() {
      var _this30 = this;

      var Broadcast = this.Broadcast,
          ConfirmDialog = this.ConfirmDialog;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Start Now',
        actionButtonClass: 'success',
        headerText: 'Please Confirm',
        bodyText: 'Are you ready to go live with your broadcast now? This will make your broadcast go live to viewers as soon as possible.'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        var params = {
          starts_at: 'now'
        };

        if (!_this30.broadcast.source_broadcast_id) {
          // XXX: API will accidentally change the stops_at date because it is a function of
          // starts_at + duration (in minutes). So we need to remind it to keep it the same.
          params.stops_at = _this30.broadcast.stops_at;
        }

        Broadcast.update({
          id: _this30.broadcast.id
        }, params, function (b) {
          return _this30.reload();
        }, function (e) {
          console.error(e);
          alert('Error starting broadcast. Please reload this page and try again.');
        });
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this31 = this;

      var Broadcast = this.Broadcast,
          ConfirmDialog = this.ConfirmDialog;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Stop Broadcast',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to stop this broadcast?'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        Broadcast.update({
          id: _this31.broadcast.id
        }, {
          stops_at: 'now'
        }, function () {
          _this31.reload();

          if (_this31.activeTab == 'captions') {
            _this31.changeTab('');
          }
        }, function () {
          return alert('Error stopping broadcast. Please reload this page and try again.');
        });
      });
    }
  }, {
    key: "generateEmailLink",
    value: function generateEmailLink() {
      var startDateTime = moment(this.broadcast.starts_at).format('dddd, MMMM Do [at] h:mma');
      var subject = escape("Invitation to ".concat(this.broadcast.name));
      var body = escape("Broadcast: ".concat(this.broadcast.name, "\n") + "Date: ".concat(startDateTime, "\n") + "\n" + "".concat(this.broadcast.description, "\n") + "\n" + "To view this event just click the link below:\n" + "".concat(this.broadcast.viewer_url, "\n") + "\n" + "If the above URL does not work try copying and pasting it into your browser.\n");
      this.emailLink = "mailto:?subject=".concat(subject, "&body=").concat(body);
    }
  }, {
    key: "embed",
    value: function embed() {
      var _this32 = this;

      var $uibModal = this.$uibModal;
      $uibModal.open({
        template: __webpack_require__(440),
        size: 'lg',
        controllerAs: 'vm',
        controller: __WEBPACK_IMPORTED_MODULE_2__embed_single_event_controller__["a" /* default */],
        resolve: {
          broadcast: function broadcast() {
            return _this32.broadcast;
          }
        }
      });
    }
  }, {
    key: "tweet",
    value: function tweet() {
      var url = escape(this.broadcast.viewer_url);
      var text = escape("Watch ".concat(this.broadcast.name, " online at"));
      window.open('http://twitter.com/share?url=' + url + '&text=' + text, 'Promote on Twitter', 'dependent=1,height=400,width=600,resizable=1');
    }
  }, {
    key: "facebook",
    value: function facebook() {
      // Use the graph API directly since we don't have proper opengraph
      // headers on our show page.
      // https://developers.facebook.com/docs/graph-api/reference/v2.4/post
      var previewImg = this.broadcast.preview;

      if (!previewImg) {
        previewImg = "".concat(IMG_ROOT, "boxcast_social_play_square.png");
      } // Use the "share" dialog (rather than "feed") so we can post into groups as well.
      // NOTE: the FB docs suggest that some of these params only work for "feed" but
      // they seem to work for share as well, so we're running with it!


      FB.ui({
        method: 'share',
        href: this.broadcast.viewer_url,
        name: this.broadcast.name,
        title: this.broadcast.name,
        description: this.broadcast.description,
        picture: Object(__WEBPACK_IMPORTED_MODULE_9__utils_broadcast__["a" /* ensureHttpOnProtocolRelativeUrl */])(previewImg),
        caption: 'BoxCast :: a smarter way to stream',
        type: 'video'
      }, function (response) {});
    } ///
    /// BoxCaster Settings
    ///

  }, {
    key: "videoInputStandard",
    get: function get() {
      var d = this.streamDiagnostics || {}; // If BoxCaster has locked in, return that.  Otherwise, base it on the Box's preference to use SDI before HDMI before Composite

      if (d.locked_input == 'SDI') {
        return d.last_sdi_standard;
      } else if (d.locked_input == 'HDMI') {
        return d.last_hdmi_standard;
      } else if (d.locked_input == 'Composite2') {
        return d.last_composite_standard;
      } else {
        return d.last_sdi_standard || d.last_hdmi_standard || d.last_composite_standard || '';
      }
    }
  }, {
    key: "videoInputName",
    get: function get() {
      var d = this.streamDiagnostics || {}; // If BoxCaster has locked in, return that.  Otherwise, base it on the Box's preference to use SDI before HDMI before Composite

      if (d.locked_input == 'Composite2') {
        return 'RCA';
      } else if (d.locked_input) {
        return d.locked_input; //SDI or HDMI
      } else {
        return d.last_sdi_standard && 'SDI' || d.last_hdmi_standard && 'HDMI' || d.last_composite_standard && 'RCA' || '';
      }
    }
  }, {
    key: "streamingProfileName",
    get: function get() {
      var tp = (this.broadcast || {}).transcoder_profile || '';
      tp = tp.replace(/:.*/, '').replace('p60', 'p');

      if (tp == 'audio') {
        tp = 'Audio';
      }

      return tp;
    }
  }, {
    key: "lockedInputMismatchWarning",
    get: function get() {
      var d = this.streamDiagnostics || {};
      var locked = d.locked_standard;
      var current = this.videoInputStandard;

      if (!locked || !current || locked == current) {
        return false;
      } // Don't worry about framerate changes; only about resolution or interlaced/progressive


      function stripFramerate(r) {
        if (r.indexOf('i') >= 0) {
          return r.substring(0, r.indexOf('i') + 1);
        } else if (r.indexOf('p') >= 0) {
          return r.substring(0, r.indexOf('p') + 1);
        } else {
          return r;
        }
      }

      return stripFramerate(locked) != stripFramerate(current);
    }
  }, {
    key: "streamingProfileMatchesVideoInput",
    get: function get() {
      var is = this.videoInputStandard;
      var sp = this.streamingProfileName;

      if (!is || !sp) {
        return true; //don't bother warning if one of them doesn't exist yet
      }

      var inputRes = is.substring(0, is.indexOf('p')) || is.substring(0, is.indexOf('i')) || '';
      var transcodeRes = sp.substring(0, sp.indexOf('p')) || '';
      var hfr = (this.broadcast || {}).actual_high_frame_rate === true; // Check for same resolution

      if (inputRes != transcodeRes) {
        return false;
      } // Check for high framerate on p60/i60 input


      var framerate = is.match(/[0-9.]+$/);
      framerate = parseFloat(framerate && framerate[0], 10);
      var inputHighFramerate = framerate > 30 && !isNaN(framerate);

      if (inputHighFramerate && !hfr) {
        return false;
      }

      return true;
    } ///
    /// Static RTMP Settings
    ///

  }, {
    key: "staticRTMPStatusLabel",
    get: function get() {
      if (!this.staticRTMPDiagnostics || !this.staticRTMPDiagnostics.connected) {
        return 'unknown';
      }

      return 'connected';
    }
  }, {
    key: "staticRTMPStatus",
    get: function get() {
      var diagnostics = this.staticRTMPDiagnostics || {};

      if (diagnostics.broadcasting) {
        return 'Broadcasting';
      } else if (diagnostics.connected) {
        return 'Connected';
      } else if (diagnostics.connected === false) {
        return 'Offline';
      } else {
        return '';
      }
    }
  }, {
    key: "staticRTMPVideoInput",
    get: function get() {
      if (!this.staticRTMPDiagnostics || !this.staticRTMPDiagnostics.connected) {
        return '';
      }

      var height = this.staticRTMPDiagnostics.video_height;
      var width = this.staticRTMPDiagnostics.video_width;
      var frameRate = this.staticRTMPDiagnostics.frame_rate;

      if (height == 0 || width == 0 || frameRate == 0) {
        return '';
      }

      return width + 'x' + height + ', ' + frameRate + ' FPS';
    } ///
    /// Viewer Chat
    ///

  }, {
    key: "showChat",
    get: function get() {
      // A broadcast content_settings override always takes precedence
      if (this.showChatHasBroadcastOverride) {
        return this.broadcast.content_settings.showChat;
      }

      return this.account.content_settings.showChat;
    }
  }, {
    key: "showChatHasBroadcastOverride",
    get: function get() {
      return this.broadcast.content_settings.showChat !== undefined;
    }
  }, {
    key: "updateShowChat",
    value: function updateShowChat() {
      var _this33 = this;

      var Broadcast = this.Broadcast,
          toaster = this.toaster;
      Broadcast.get({
        id: this.broadcast.id
      }, function (b) {
        var cs = _objectSpread(_objectSpread({}, b.content_settings), {}, {
          showChat: _this33.showChatStateValue
        });

        Broadcast.update({
          id: _this33.broadcast.id
        }, {
          content_settings: cs
        }, function (b) {
          _this33.setBroadcast(b);

          toaster.pop('success', _this33.showChatStateValue ? 'Enabled chat' : 'Disabled chat');
        }, function (e) {
          console.error(e);
          toaster.pop('warning', "Unable to ".concat(_this33.showChatStateValue ? 'enable' : 'disable', " chat. Please refresh the page and try again."));

          _this33.reloadSilent();
        });
      });
    } ///
    /// Live captions
    ///

  }, {
    key: "enableCaptions",
    get: function get() {
      // If there's a value specified in the broadcast metadata, use it.
      var captionsConfiguration = this.broadcast.metadata.live_captions || {};

      if (captionsConfiguration.enabled !== undefined) {
        return captionsConfiguration.enabled;
      } // If there's nothing specified in the metadata, assume it's enabled.


      return true;
    }
  }, {
    key: "updateEnableCaptions",
    value: function updateEnableCaptions() {
      var _this34 = this;

      var Broadcast = this.Broadcast,
          toaster = this.toaster;
      Broadcast.get({
        id: this.broadcast.id
      }, function (b) {
        var md = _objectSpread(_objectSpread({}, b.metadata), {}, {
          live_captions: {
            enabled: _this34.enableCaptionsStateValue
          }
        });

        Broadcast.update({
          id: _this34.broadcast.id
        }, {
          metadata: md
        }, function (b2) {
          _this34.setBroadcast(b2);

          toaster.pop('success', _this34.enableCaptionsStateValue ? 'Enabled live captions' : 'Disabled live captions');
        }, function (e) {
          console.error(e);
          toaster.pop('warning', "Unable to ".concat(_this34.enableCaptionsStateValue ? 'enable' : 'disable', " live captions. Please refresh the page and try again."));

          _this34.reloadSilent();
        });
      });
    }
  }]);

  return EventDetailController;
}();



/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = "[General]\nName={{streamName}}\n\n[Output]\nMode=Advanced\n\n[SimpleOutput]\nUseAdvanced=false\n\n[AdvOut]\nRescaleRes=2880x1800\nTrackIndex=1\nRecType=Standard\nRecRescaleRes=2880x1800\nRecTracks=1\nFFOutputToFile=true\nFFRescaleRes=2880x1800\nFFVEncoderId=0\nFFAEncoderId=0\nFFAudioTrack=1\nApplyServiceSettings=true\nFFFormat=\nFFFormatMimeType=\nFFVEncoder=\nFFAEncoder=\nTrack1Bitrate={{audioBitrateKbps}}\n\n[Video]\nBaseCX={{width}}\nBaseCY={{height}}\nOutputCX={{width}}\nOutputCY={{height}}\n"

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmbedSingleEventController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_embed__ = __webpack_require__(29);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var EmbedSingleEventController = /*#__PURE__*/function () {
  function EmbedSingleEventController(ApiConfig, Account, $rootScope, $scope, $uibModalInstance, broadcast) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, EmbedSingleEventController);

    this.$scope = $scope;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.$uibModalInstance = $uibModalInstance; // This is passed via `resolve`

    this.broadcast = broadcast; // Output of embed directive

    this.output = {
      type: 'single',
      embedType: 'javascript',
      channelId: this.broadcast.channel_id,
      broadcast: this.broadcast,
      title: true,
      description: true,
      related: false,
      args: {
        applyBrandColor: true,
        showTitleAndDescription: true,
        showTitle: true,
        showDescription: true,
        showHighlights: false,
        showRelated: false,
        showCountdown: true
      },
      embedCode: '',
      iframeCode: '',
      boxcastLink: '',
      boxcastTVLink: '',
      m3u8: this.broadcast.static_playlist_url,
      layout: 'player-and-title'
    };
    $scope.$watch(function () {
      return [_this.output.type, _this.output.channelId, _this.output.title, _this.output.description, _this.output.related, _this.output.args];
    }, function (newVal, oldVal) {
      var _newVal = _slicedToArray(newVal, 6),
          type = _newVal[0],
          channelId = _newVal[1],
          title = _newVal[2],
          description = _newVal[3],
          related = _newVal[4],
          args = _newVal[5];

      _this.output.embedCode = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v2WidgetEmbed(channelId, title, description, related);
      _this.output.embedCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3WidgetEmbed(channelId, args);
      _this.output.iframeCode = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v2IframeEmbed(channelId, title, description, related);
      _this.output.iframeCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3IframeEmbed(channelId, args);
      _this.output.linkCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Link(channelId, args);
      _this.output.appCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3App(channelId, args);
      _this.output.highlightsCode3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Highlights(channelId, args);
      _this.output.rss3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Rss(channelId, args);
      _this.output.audioMRSS3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3MRSS(channelId, 'audio', args);
      _this.output.videoMRSS3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3MRSS(channelId, 'video', args);
      _this.output.rokuDirectPublisher = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].rokuDirectPublisher(channelId, args);
      _this.output.audioPodcast3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Podcast(channelId, 'audio', args);
      _this.output.videoPodcast3 = __WEBPACK_IMPORTED_MODULE_0__utils_embed__["a" /* default */].v3Podcast(channelId, 'video', args);
      _this.output.boxcastLink = BOXCAST_SHOW_URL + channelId;
      _this.output.boxcastTVLink = BOXCAST_TV_SHOW_URL + channelId;
    }, true);
    this.output.args.market = $rootScope.account.market;
  }

  _createClass(EmbedSingleEventController, [{
    key: "cancel",
    value: function cancel() {
      this.$uibModalInstance.dismiss('cancel');
    }
  }]);

  return EmbedSingleEventController;
}();



/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DownloadOrExportRecordingController;
function DownloadOrExportRecordingController($uibModalInstance, $scope, $timeout, $rootScope, toaster, Recording, VimeoUser, YouTubeUser, $analytics, broadcast) {
  'ngInject';

  var _this = this;

  this.hasVideo = broadcast.transcoder_profile !== 'audio';
  this.activeTab = this.hasVideo ? 'mp4' : 'm4a';
  this.unlock = {};
  this.allowKaltura = false;
  this.allowYoutube = false;
  this.allowVimeo = false;
  this.youtubeUsers = [];
  this.youtubeUserId = null;
  this.youtubeLicense = 'youtube';
  this.youtubePrivacy = 'private';
  this.vimeoUsers = [];
  this.vimeoUserId = null;
  this.allowKaltura = $rootScope.account.extra_features.kaltura;
  this.allowYoutube = !!$rootScope.account.feature_flags.youtube_export;
  this.allowVimeo = !!$rootScope.account.feature_flags.vimeo_export;

  if (this.allowYoutube) {
    this.youtubeUsers = YouTubeUser.query();
    this.youtubeUsers.$promise.then(function () {
      _this.youtubeUserId = (_.first(_this.youtubeUsers) || {}).id;
    });
  }

  if (this.allowVimeo) {
    this.vimeoUsers = VimeoUser.query();
    this.vimeoUsers.$promise.then(function () {
      _this.vimeoUserId = (_.first(_this.vimeoUsers) || {}).id;
    });
  }

  this.recording = {};
  this.$reloadRecordingTimeout = null;

  this.reloadRecording = function () {
    $timeout.cancel(_this.$reloadRecordingTimeout);
    Recording.get({
      id: broadcast.recording_id
    }, function (recording) {
      // On completion of an export, make sure we re-lock
      _.each(['kaltura', 'vimeo', 'youtube'], function (e) {
        if (_this.recording["".concat(e, "_export_status")] !== 'ready' && recording["".concat(e, "_export_status")] == 'ready') {
          delete _this.unlock[e];
        }
      });

      _this.recording = recording;
      _this.$reloadRecordingTimeout = $timeout(_this.reloadRecording, 5000);
    }, function (error) {
      console.error(error);
      toaster.pop('warning', 'Unable to fetch recording. Please try again.');

      _this.cancel();
    });
  };

  this.reloadRecording();
  $scope.$on('$destroy', function () {
    return $timeout.cancel(_this.$reloadRecordingTimeout);
  });

  this.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  this.canStart = function () {
    var processingStatuses = ['requesting', 'requested', 'awaiting_conversion'];

    var mp4DownloadInFlight = function mp4DownloadInFlight() {
      return _.contains(processingStatuses, _this.recording.download_status) || _.startsWith(_this.recording.download_status, 'processing:');
    };

    var m4aDownloadInFlight = function m4aDownloadInFlight() {
      return _.contains(processingStatuses, _this.recording.audio_download_status) || _.startsWith(_this.recording.audio_download_status, 'processing:');
    };

    var kalturaExportInFlight = function kalturaExportInFlight() {
      return _.contains(processingStatuses, _this.recording.kaltura_export_status) || _.startsWith(_this.recording.kaltura_export_status, 'processing:');
    };

    var vimeoExportInFlight = function vimeoExportInFlight() {
      return _.contains(processingStatuses, _this.recording.vimeo_export_status) || _.startsWith(_this.recording.vimeo_export_status, 'processing:');
    };

    var youtubeExportInFlight = function youtubeExportInFlight() {
      return _.contains(processingStatuses, _this.recording.youtube_export_status) || _.startsWith(_this.recording.youtube_export_status, 'processing:');
    };

    var exportInFlight = function exportInFlight() {
      return kalturaExportInFlight() || vimeoExportInFlight() || youtubeExportInFlight();
    };

    if (_this.activeTab === 'mp4') {
      return (!_this.recording.download_url || _this.recording.download_status == 'expired') && !mp4DownloadInFlight() && !exportInFlight();
    } else if (_this.activeTab === 'm4a') {
      return (!_this.recording.audio_download_url || _this.recording.audio_download_status == 'expired') && !m4aDownloadInFlight();
    } else if (_this.activeTab === 'kaltura') {
      return !mp4DownloadInFlight() && !kalturaExportInFlight();
    } else if (_this.activeTab === 'vimeo') {
      return !mp4DownloadInFlight() && !vimeoExportInFlight();
    } else if (_this.activeTab === 'youtube') {
      return !mp4DownloadInFlight() && !youtubeExportInFlight();
    }
  };

  this.changeTab = function (tabId) {
    _this.activeTab = tabId;
    _this.unlock = {};
  };

  this.start = function () {
    // the debounce in angular is dubious; just double-check here that we can start, and get out if we can't.
    if (!_this.canStart()) return;

    if (_this.activeTab === 'mp4') {
      _this.recording.download_status = 'requesting';
      Recording.prepareDownload({
        id: broadcast.recording_id
      }, function (response) {
        _this.recording.download_status = 'requested';
        console.log('Submitted request to download mp4...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.download_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to prepare mp4 download. Please try again.');
        $analytics.eventTrack('event-download', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'm4a') {
      _this.recording.audio_download_status = 'requesting';
      Recording.prepareDownload({
        id: broadcast.recording_id,
        audio_only: true
      }, function (response) {
        _this.recording.audio_download_status = 'requested';
        console.log('Submitted request to m4a download...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.audio_download_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to prepare m4a download. Please try again.');
        $analytics.eventTrack('event-download-audio', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'kaltura') {
      _this.recording.kaltura_export_status = 'requesting';
      Recording.startKalturaExport({
        id: broadcast.recording_id
      }, function (response) {
        _this.recording.kaltura_export_status = 'requested';
        console.log('Submitted request to export to kaltura...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.kaltura_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('event-kaltura-export', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'vimeo') {
      // This isn't documented, but Vimeo limits the name to 128 characters (PLATFORM-6277)
      var videoInfo = {
        name: broadcast.name.substr(0, 128),
        description: broadcast.description
      };
      _this.recording.vimeo_export_status = 'requesting';
      Recording.startVimeoExport({
        id: broadcast.recording_id,
        vimeo_user_id: _this.vimeoUserId,
        video_info: videoInfo
      }, function (response) {
        _this.recording.vimeo_export_status = 'requested';
        console.log('Submitted request to export to vimeo...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.vimeo_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('event-vimeo-export', {
          category: 'error'
        });
      });
    } else if (_this.activeTab === 'youtube') {
      // https://developers.google.com/youtube/v3/docs/videos
      //
      // title (string): The video's title. The property value has a maximum length of 100 characters
      // and may contain all valid UTF-8 characters except < and >.
      //
      // description (string): The video's description. The property value has a maximum length of
      // 5000 bytes and may contain all valid UTF-8 characters except < and >.
      var _videoInfo = {
        snippet: {
          title: broadcast.name.replace(/</g, '[').replace(/>/g, ']').substr(0, 100),
          description: broadcast.description.replace(/</g, '[').replace(/>/g, ']').substr(0, 5000)
        },
        status: {
          privacyStatus: _this.youtubePrivacy,
          license: _this.youtubeLicense
        }
      };
      _this.recording.youtube_export_status = 'requesting';
      Recording.startYoutubeExport({
        id: broadcast.recording_id,
        youtube_user_id: _this.youtubeUserId,
        video_info: _videoInfo
      }, function (response) {
        _this.recording.youtube_export_status = 'requested';
        console.log('Submitted request to export to youtube...', response);

        _this.reloadRecording();
      }, function (error) {
        _this.recording.youtube_export_status = 'failed';
        console.error(error);
        toaster.pop('warning', 'Unable to export video. Please try again.');
        $analytics.eventTrack('event-youtube-export', {
          category: 'error'
        });
      });
    }
  };

  this.status = function () {
    var s = null;

    if (_this.activeTab === 'mp4') {
      s = _this.recording.download_status;
    } else if (_this.activeTab === 'm4a') {
      s = _this.recording.audio_download_status;
    } else if (_this.activeTab === 'kaltura') {
      s = _this.recording.kaltura_export_status;
    } else if (_this.activeTab === 'vimeo') {
      s = _this.recording.vimeo_export_status;
    } else if (_this.activeTab === 'youtube') {
      s = _this.recording.youtube_export_status;
    }

    if (_.startsWith(s, 'processing:')) {
      s = 'processing';
    }

    return s;
  };

  this.statusPercent = function () {
    var p = 0;

    if (_this.activeTab === 'mp4' || _this.activeTab === 'm4a') {
      var s = null;

      if (_this.activeTab === 'mp4') {
        s = _this.recording.download_status;
      } else if (_this.activeTab === 'm4a') {
        s = _this.recording.audio_download_status;
      }

      if (s === 'ready') {
        p = 100;
      } else if (_.startsWith(s, 'processing:')) {
        p = parseInt(s.replace('processing:', ''), 10) || 0;
      }
    } else {
      // Compensate for fact that download-preparation is only first half of the battle.
      // Now that we have an MP4 in S3, we need to get it over to the social provider.
      var _s = null;

      if (_this.activeTab === 'kaltura') {
        _s = _this.recording.kaltura_export_status;
      } else if (_this.activeTab === 'vimeo') {
        _s = _this.recording.vimeo_export_status;
      } else if (_this.activeTab === 'youtube') {
        _s = _this.recording.youtube_export_status;
      }

      if (_s === 'ready') {
        p = 100;
      } else if (_.contains(['awaiting_conversion', 'requested'], _s)) {
        if (_this.recording.download_status === 'ready') {
          p = 50;
        } else if (_.startsWith(_this.recording.download_status, 'processing:')) {
          p = Math.round((parseInt(_this.recording.download_status.replace('processing:', ''), 10) || 0) / 2);
        }
      } else if (_.startsWith(_s, 'processing:')) {
        p = 50 + Math.round((parseInt(_s.replace('processing:', ''), 10) || 0) / 2);
      }
    }

    return p;
  };
}

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = estimateProcessingTimeRemaining;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
 // Assume (guess?) that we'll have a two-minute overhead for things like daemon polling, task
// assignment, startup, teardown, etc.

var PROCESSING_OVERHEAD_MS = 2 * 60 * 1000;

var estimatePreProcessingTimeRemaining = function estimatePreProcessingTimeRemaining(broadcast) {
  // Assume (guess?) that we'll have a two-minute overhead, followed by a transcode that
  // matches the broadcast duration
  var broadcastDurationMs = __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.stops_at).toDate().getTime() - __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.starts_at).toDate().getTime();
  return PROCESSING_OVERHEAD_MS + broadcastDurationMs;
};

var estimateCurrentProcessingTimeRemaining = function estimateCurrentProcessingTimeRemaining(broadcast, upload, now) {
  // If we're processing, balance the duration estimate with one based on the upload creation
  // time and completion percentage.
  var progressPercent = upload.progress || 0.0; // First, the estimate based on broadcast duration and percentage remaining

  var broadcastDurationMs = __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.stops_at).toDate().getTime() - __WEBPACK_IMPORTED_MODULE_0_moment___default()(broadcast.starts_at).toDate().getTime();
  var broadcastDurationEstimateMs = broadcastDurationMs * (100.0 - progressPercent) / 100.0; // Next, the estimate based on upload creation time and progress (if possible)

  var uploadProgressEstimateMs = null;

  if (progressPercent > 0.0) {
    if (upload.created_at) {
      var uploadCreatedAt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(upload.created_at).toDate().getTime();

      if (now > uploadCreatedAt) {
        var elapsed = now - uploadCreatedAt;
        var estimatedTotalDuration = elapsed * 100.0 / progressPercent;
        var estimatedCompletion = uploadCreatedAt + estimatedTotalDuration;
        uploadProgressEstimateMs = estimatedCompletion - now;
      }
    }
  }

  if (!uploadProgressEstimateMs) {
    // If this is null, just set it to broadcastDurationEstimateMs because progressPercent is
    // likely zero and the math is a wash
    uploadProgressEstimateMs = broadcastDurationEstimateMs;
  } // Calculate a weighted average of our two estimates (based on percentage complete)


  return broadcastDurationEstimateMs * (100.0 - progressPercent) / 100.0 + uploadProgressEstimateMs * progressPercent / 100.0;
};
/**
 * Estimate the amount of processing (transcoding) time remaining (in milliseconds) for a broadcast
 * with an upload.
 *
 * @param  {Object} opts An object containing the keys:
 *                       - broadcast: The broadcast object
 *                       - upload: The upload object
 * @return {Number}      The estimated processing time remaining, in milliseconds, or null if the
 *                       arguments don't make sense.
 */


function estimateProcessingTimeRemaining(opts) {
  var broadcast = opts.broadcast;
  var upload = opts.upload;

  if (!broadcast || !upload) {
    return null;
  }

  if (upload.status == 'uploaded' || upload.status == 'assigned') {
    return estimatePreProcessingTimeRemaining(broadcast);
  }

  if (upload.status == 'processing') {
    var now = opts.now || Date.now();
    return estimateCurrentProcessingTimeRemaining(broadcast, upload, now);
  } // Catch-all


  return null;
}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"vm.encoderType != 'TriCaster'\" class=\"modal-header\" style=\"border-bottom:0;padding-bottom:0;\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n\n  <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li ng-class=\"!vm.activeTab ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.selectTab(null)\">RTMP Encoder Settings</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'obs' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.selectTab('obs')\">OBS Profile</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'fmle' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.selectTab('fmle')\">FMLE Configuration</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'wirecast' ? 'active' : ''\">\n      <a href=\"javascript://\" ng-click=\"vm.selectTab('wirecast')\">Wirecast Configuration</a>\n    </li>\n  </ol>\n</div>\n\n<!-- TriCaster custom logic ... remember, it's accessed from inside custom webview -->\n<div ng-if=\"vm.encoderType == 'TriCaster'\" class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Broadcast from {{ vm.encoderType }}</h3>\n</div>\n<div class=\"modal-body\" ng-if=\"vm.encoderType == 'TriCaster'\">\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <div class=\"bg-info text-info\" style=\"padding:10px; border:1px solid\">\n    You're all set! Your configuration file should automatically download. Simply choose \"BoxCast\" From your list of streaming configuration presets.\n  </div>\n  <p class=\"help-block\">\n    Your configuration file contains the following settings:\n  </p>\n  <table class=\"table\">\n    <tr>\n      <td>Video parameters</td>\n      <th>{{vm.width}}x{{vm.height}}, {{vm.frameRate}}fps</th>\n    </tr>\n    <tr>\n      <td>Audio parameters</td>\n      <th>Stereo (2-channel), 48 kHz sampling rate</th>\n    </tr>\n    <tr>\n      <td>Video bitrate</td>\n      <th>\n        {{vm.videoBitrateKbps}} kbps\n\n        <small class=\"pull-right\" style=\"font-weight:normal;opacity:0.8;\">Detected {{vm.availableBandwidth|bytes}}ps upload speed</small>\n      </th>\n    </tr>\n    <tr>\n      <td>Audio bitrate</td>\n      <th>{{vm.audioBitrateKbps}} kbps</th>\n    </tr>\n    <tr>\n      <td>Video codec</td>\n      <th>{{vm.codec}}</th>\n    </tr>\n    <tr>\n      <td>Audio codec</td>\n      <th>AAC</th>\n    </tr>\n    <tr>\n      <td>Rate control</td>\n      <th>CBR</th>\n    </tr>\n    <tr>\n      <td>RTMP URL</td>\n      <td>\n        <ul style=\"margin-bottom:0\">\n          <li>RTMP URL \n            <strong>{{vm.rtmpUrl}}</strong>\n            <button ng-if=\"clipboard.supported\"\n              class=\"btn btn-link\"\n              clipboard\n              text=\"vm.rtmpUrl\"\n              on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n              on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n              uib-tooltip=\"Copy the RTMP base URL to your clipboard\" tooltip-placement=\"bottom\"\n              style=\"padding:0;\">\n              <i class=\"fa fa-clipboard\" style=\"width:20px\"></i>\n            </button>\n          </li>\n          <li>Stream key \n            <strong>{{vm.streamKey}}</strong>\n            <button ng-if=\"clipboard.supported\"\n              class=\"btn btn-link\"\n              clipboard\n              text=\"vm.streamKey\"\n              on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n              on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n              uib-tooltip=\"Copy the stream key to your clipboard\" tooltip-placement=\"bottom\"\n              style=\"padding:0;\">\n              <i class=\"fa fa-clipboard\" style=\"width:20px\"></i>\n            </button>\n          </li>\n        </ul>\n      </td>\n    </tr>\n  </table>\n  <p class=\"text-center\">\n    <a class=\"btn btn-primary\" ng-href=\"{{ vm.xmlUrl }} \" download=\"{{ vm.xmlDownloadName }}\">Download Configuration File</a>\n  </p>\n</main>\n</div>\n\n<!-- FMLE tab -->\n<div class=\"modal-body\" ng-if=\"vm.activeTab == 'fmle'\" style=\"padding-top:0\">\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <p class=\"help-block\" style=\"margin-top:0\">\n    To encode with Flash Media Live Encoder:\n  </p>\n  <ol>\n    <li>Download <a ng-href=\"{{ vm.xmlUrl }} \" download=\"{{ vm.xmlDownloadName }}\">the configuration XML file</a>.</li>\n    <li>Start Flash Media Live Encoder.</li>\n    <li>From the <em>File</em> menu, click <em>Open Profile</em>. Open the file you downloaded in step 1.</li>\n    <li>If you receive a <em>Profile Validation</em> warning, click <em>OK</em>.</li>\n    <li>Configure video inputs and any other settings you wish to customize.</li>\n    <li>Click <em>Start</em> to begin streaming.</li>\n  </ol>\n  <p class=\"text-center\">\n    <a class=\"btn btn-primary\" ng-href=\"{{ vm.xmlUrl }} \" download=\"{{ vm.xmlDownloadName }}\">Download Configuration File</a>\n  </p>\n</main>\n</div>\n\n\n<!-- OBS tab -->\n<div class=\"modal-body\" ng-if=\"vm.activeTab == 'obs'\" style=\"padding-top:0\">\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <p class=\"help-block\" style=\"margin-top:0\">\n    To encode with Open Broadcaster Software:\n  </p>\n  <ol>\n    <li>Download <a ng-href=\"{{ vm.zipUrl }} \" download=\"{{ vm.zipDownloadName }}\">the profile zip file</a>.</li>\n    <li>Open OBS.</li>\n    <li>From the <em>File</em> menu, click <em>Show Profile Folder</em>.</li>\n    <li>Unzip the downloaded profile zip file and place the unzipped folder in the Profile Folder opened in the previous step.</li>\n    <li>Exit and restart OBS.</li>\n    <li>From the <em>Profile</em> menu, click on the <strong>{{ vm.broadcast.channel_id }}</strong> profile.\n    <li>Configure video inputs and any other settings you wish to customize.</li>\n    <li>Click <em>Start Streaming</em>.</li>\n  </ol>\n  <p class=\"text-center\">\n    <a class=\"btn btn-primary\" ng-href=\"{{ vm.zipUrl }} \" download=\"{{ vm.zipDownloadName }}\">Download Profile File</a>\n  </p>\n</main>\n</div>\n\n\n<!-- Generic RTMP Settings tab -->\n<div class=\"modal-body\" ng-if=\"!vm.activeTab\" style=\"padding-top:0\">\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <h4 style=\"margin:0\">RTMP URL</h4>\n  <p style=\"margin:0 0 10px\" class=\"help-block\">\n    <small>Depending on your encoder, you may need to enter the URL and stream key separately.</small>\n  </p>\n\n  <div class=\"clearfix\">\n    <div class=\"pull-left\">\n      <p style=\"margin:0\">Server URL and Stream Key</p>\n      <div style=\"font-weight: bold; border:1px solid #ddd; border-radius:4px; padding:3px 12px;\">\n        {{vm.rtmpUrl}}/{{vm.streamKey}}\n        <button ng-if=\"clipboard.supported\"\n          class=\"btn btn-link\"\n          clipboard\n          text=\"vm.rtmpUrl + '/' + vm.streamKey\"\n          on-copied=\"toaster.pop('success', 'URL successfully copied')\"\n          on-error=\"toaster.pop('warning', 'URL could not be copied')\"\n          uib-tooltip=\"Copy the RTMP URL to your clipboard\" tooltip-placement=\"bottom\"\n          style=\"padding:0;\">\n          <i class=\"fa fa-clipboard\" style=\"width:20px\"></i>\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"clearfix\" style=\"margin:10px 0 30px\">\n    <div class=\"pull-left\">\n      <p style=\"margin:0\">Server URL</p>\n      <div style=\"font-weight: bold; border:1px solid #ddd; border-radius:4px; padding:3px 12px;\">\n        {{vm.rtmpUrl}}\n        <button ng-if=\"clipboard.supported\"\n          class=\"btn btn-link\"\n          clipboard\n          text=\"vm.rtmpUrl\"\n          on-copied=\"toaster.pop('success', 'URL successfully copied')\"\n          on-error=\"toaster.pop('warning', 'URL could not be copied')\"\n          uib-tooltip=\"Copy the RTMP URL to your clipboard\" tooltip-placement=\"bottom\"\n          style=\"padding:0;\">\n          <i class=\"fa fa-clipboard\" style=\"width:20px\"></i>\n        </button>\n      </div>\n    </div>\n    <div class=\"pull-left\" style=\"margin-left:10px\">\n      <p style=\"margin:0\">Stream Key</p>\n      <div style=\"font-weight: bold; border:1px solid #ddd; border-radius:4px; padding:3px 12px;\">\n        {{vm.streamKey}}\n        <button ng-if=\"clipboard.supported\"\n          class=\"btn btn-link\"\n          clipboard\n          text=\"vm.streamKey\"\n          on-copied=\"toaster.pop('success', 'Stream key successfully copied')\"\n          on-error=\"toaster.pop('warning', 'Stream key could not be copied')\"\n          uib-tooltip=\"Copy the Stream Key to your clipboard\" tooltip-placement=\"bottom\"\n          style=\"padding:0;\">\n          <i class=\"fa fa-clipboard\" style=\"width:20px\"></i>\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"pull-right\">\n    <small class=\"pull-right\" style=\"font-weight:normal;opacity:0.8;\">Detected {{vm.availableBandwidth|bytes}}ps upload speed</small>\n  </div>\n  <h4>Encoder Settings</h4>\n\n  <div class=\"row\">\n    <div class=\"col-sm-6\" style=\"padding-right:0\">\n      <table class=\"table\" style=\"border-bottom:1px solid #ddd;border-right:1px solid #ddd\">\n        <tr>\n          <td>Video parameters</td>\n          <th>{{vm.width}}x{{vm.height}}, {{vm.frameRate}}fps</th>\n        </tr>\n        <tr>\n          <td>Audio parameters</td>\n          <th>Stereo (2-channel)</th>\n        </tr>\n        <tr>\n          <td>Audio Sample Rate</td>\n          <th>44.1 kHz or 48 kHz</th>\n        </tr>\n        <tr>\n          <td>Rate control</td>\n          <th>CBR</th>\n        </tr>\n      </table>\n    </div>\n    <div class=\"col-sm-6\" style=\"padding-left:0\">\n      <table class=\"table\" style=\"border-bottom:1px solid #ddd\">\n        <tr>\n          <td>Video bitrate</td>\n          <th>\n            {{vm.videoBitrateKbps}} kbps\n\n            <i class=\"pull-right fa fa-question-circle\" style=\"opacity:0.4\"\n                uib-tooltip=\"The BoxCast server can handle variable bitrates, but please do not exceed\n                {{vm.maxVideoBitrate/1000000|number:1}} Mbps or we cannot guarantee that your stream will perform appropriately.\"\n                tooltip-append-to-body=\"true\"></i>\n\n            <span ng-if=\"(vm.videoBitrateKbps * 1000) < vm.minVideoBitrate\">\n              <i class=\"pull-right text-danger fa fa-warning\"\n                  uib-tooltip=\"Your available bandwidth is too low. For best performance, your network should be able to\n                  support a video bitrate of at least {{vm.minVideoBitrate/1000000|number:1}} Mbps for the selected resolution and frame rate.\"\n                  tooltip-append-to-body=\"true\"></i>\n            </span>\n          </th>\n        </tr>\n        <tr>\n          <td>Audio bitrate</td>\n          <th>{{vm.audioBitrateKbps}} kbps</th>\n        </tr>\n        <tr>\n          <td>Video codec</td>\n          <th>{{vm.codec}}</th>\n        </tr>\n        <tr>\n          <td>Audio codec</td>\n          <th>AAC</th>\n        </tr>\n      </table>\n    </div>\n  </div>\n</main>\n</div>\n\n\n<!-- Wirecast tab -->\n<div class=\"modal-body\" ng-if=\"vm.activeTab == 'wirecast'\" style=\"padding-top:0\">\n<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <p class=\"help-block\" style=\"margin-top:0\">\n    First, follow the one-time setup instructions at:\n    <br>\n    <a href=\"https://support.boxcast.com/en/articles/4235188\" target=\"_blank\">\n      https://support.boxcast.com/en/articles/4235188\n      <i class=\"fa fa-external-link\"></i> \n    </a>\n  </p>\n  <p class=\"help-block\">\n    To encode with Wirecast:\n    <ul>\n      <li>Within Wirecast, click <em>Output</em>, then <em>Output Settings...</em></li>\n      <li>In the <em>Destination</em> box, choose <em>BoxCast</em> and click <em>OK</em>.</li>\n      <li>From the <em>Encoding</em> box, choose <strong>{{ vm.encodingSelection }}</strong>.</li>\n      <li>In the <em>Username</em> box, enter <strong>{{ user.email }}</strong> and click <em>Authenticate</em>.</li>\n      <li>In the popup box, enter your BoxCast password and click <em>OK</em>.</li>\n      <li>In the <em>Channel:</em> box, choose <strong>{{ vm.streamName }}</strong>.</li>\n      <li>Click <em>OK</em>.</li>\n      <li>Activate streaming within Wirecast by selecting <em>Output</em> -> <em>Start / Stop Broadcasting</em> -> <em>Start All</em>\n          or <em>Start BoxCast: {{ vm.streamName }}</em></li>\n    </ul>\n  </p>\n  <p class=\"help-block\">\n    Alternatively, for more control over the streaming parameters, follow the <b>RTMP Encoder Settings</b>,\n    using Wirecast's <b>RTMP Server</b> output.\n  </p>\n</main>\n</div>\n"

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\" style=\"border-bottom:0;padding-bottom:0;\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n\n  <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li ng-class=\"vm.activeTab == 'mp4' ? 'active' : ''\" ng-if=\"vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('mp4')\">Download</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'youtube' ? 'active' : ''\" ng-if=\"vm.allowYoutube && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('youtube')\">YouTube</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'vimeo' ? 'active' : ''\" ng-if=\"vm.allowVimeo && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('vimeo')\">Vimeo</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'kaltura' ? 'active' : ''\" ng-if=\"vm.allowKaltura && vm.hasVideo\">\n      <a href ng-click=\"vm.changeTab('kaltura')\">Kaltura</a>\n    </li>\n    <li ng-class=\"vm.activeTab == 'm4a' ? 'active' : ''\">\n      <a href ng-click=\"vm.changeTab('m4a')\">Audio</a>\n    </li>\n  </ol>\n\n</div>\n<div class=\"modal-body\" style=\"padding-top:0\" ng-show=\"vm.recording.id\">\n\n  <!-- download mp4 -->\n  <div ng-if=\"vm.activeTab == 'mp4'\">\n    <p class=\"help-block\">\n      <small>\n        Recordings can be downloaded in MP4 (video+audio) format. This process can take a few minutes while we convert your recording to the proper format.\n      </small>\n    </p>\n    <div class=\"form-group text-center\">\n      <button class=\"btn btn-default\"\n        ng-hide=\"vm.recording.download_url && vm.status() != 'expired'\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Generate Download\n      </button>\n      <a class=\"btn btn-success\"\n        download\n        ng-show=\"vm.recording.download_url && vm.status() != 'expired'\"\n        ng-href=\"{{vm.recording.download_url}}\">\n        <i class=\"fa fa-download\"></i>\n        Download Video\n      </a>\n      <button type=\"button\" class=\"btn btn-link\"\n        ng-if=\"clipboard.supported\"\n        ng-show=\"vm.recording.download_url && vm.status() != 'expired'\"\n        clipboard\n        text=\"vm.recording.download_url\"\n        on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n        on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n        uib-tooltip=\"Copy the MP4 link to your clipboard\" tooltip-placement=\"bottom\">\n        <i class=\"fa fa-copy\" style=\"width:20px\"></i>\n        Copy Video Link\n      </button>\n    </div>\n  </div>\n\n  <!-- download m4a -->\n  <div ng-if=\"vm.activeTab == 'm4a'\">\n    <p class=\"help-block\">\n      <small>\n        Recordings can be downloaded in M4A (audio-only) format. This process can take a few minutes while we convert your recording to the proper format.\n      </small>\n    </p>\n    <div class=\"form-group text-center\">\n      <button class=\"btn btn-default\"\n        ng-hide=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Generate Download\n      </button>\n      <a class=\"btn btn-success\"\n        download\n        ng-show=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        ng-href=\"{{vm.recording.audio_download_url}}\">\n        <i class=\"fa fa-download\"></i>\n        Download Audio\n      </a>\n      <button type=\"button\" class=\"btn btn-link\"\n        ng-if=\"clipboard.supported\"\n        ng-show=\"vm.recording.audio_download_url && vm.status() != 'expired'\"\n        clipboard\n        text=\"vm.recording.audio_download_url\"\n        on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n        on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n        uib-tooltip=\"Copy the M4A link to your clipboard\" tooltip-placement=\"bottom\">\n        <i class=\"fa fa-copy\" style=\"width:20px\"></i>\n        Copy Audio Link\n      </button>\n    </div>\n  </div>\n\n  <!-- youtube -->\n  <div ng-if=\"vm.activeTab == 'youtube'\">\n    <p class=\"help-block\">\n      <small>\n        Recordings can be exported to YouTube. This process can take a few minutes while we convert your recording\n        to the proper format and then send it to YouTube.\n      </small>\n    </p>\n    <div ng-hide=\"vm.youtubeUsers.length\">\n      <p>\n        There are no linked YouTube accounts.\n        Please <a ui-sref=\"settings.youtube\" ng-click=\"vm.cancel()\">link your YouTube account</a> before attempting to export.\n      </p>\n    </div>\n    <div ng-show=\"vm.youtubeUsers.length && (vm.recording.youtube_export_status != 'ready' || vm.unlock.youtube)\">\n      <div class=\"form-group\">\n        <label for=\"youtube_user\">Export As User</label>\n        <select class=\"form-control\" id=\"youtube_user\" ng-model=\"vm.youtubeUserId\" ng-disabled=\"!vm.canStart()\" required>\n          <option ng-repeat=\"u in vm.youtubeUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"youtube_license\">License</label>\n        <select class=\"form-control\" id=\"youtube_license\" ng-model=\"vm.youtubeLicense\" ng-disabled=\"!vm.canStart()\" required>\n          <option value=\"youtube\" ng-selected=\"true\">YouTube</option>\n          <option value=\"creativeCommon\">Creative Commons</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"youtube_privacy\">Privacy Status</label>\n        <select class=\"form-control\" id=\"youtube_privacy\" ng-model=\"vm.youtubePrivacy\" ng-disabled=\"!vm.canStart()\" required>\n          <option value=\"private\" ng-selected=\"true\">private</option>\n          <option value=\"public\">public</option>\n          <option value=\"unlisted\">unlisted</option>\n        </select>\n      </div>\n      <div class=\"form-group text-center\">\n        <button class=\"btn btn-default overflow-ellipse\"\n          ng-disabled=\"!vm.canStart()\"\n          ng-click=\"vm.start()\"\n          analytics-on analytics-event=\"event-edit\" analytics-category=\"youtube-export\" analytics-label=\"\">\n          <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n          <i class=\"fa fa-youtube-play\" style=\"width:20px\"></i>\n          Export To YouTube\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <!-- vimeo -->\n  <div ng-if=\"vm.activeTab == 'vimeo'\">\n    <p class=\"help-block\">\n      <small>\n        Recordings can be exported to Vimeo. This process can take a few minutes while we convert your recording\n        to the proper format and then send it to Vimeo.\n      </small>\n    </p>\n    <div ng-hide=\"vm.vimeoUsers.length\">\n      <p>\n        There are no linked Vimeo accounts.\n        Please <a ui-sref=\"settings.vimeo\" ng-click=\"vm.cancel()\">link your Vimeo account</a> before attempting to export.\n      </p>\n    </div>\n    <div ng-show=\"vm.vimeoUsers.length && (vm.recording.vimeo_export_status != 'ready' || vm.unlock.vimeo)\">\n      <div class=\"form-group\">\n        <label for=\"vimeo_user\">Export As User</label>\n        <select class=\"form-control\" id=\"vimeo_user\" ng-model=\"vm.vimeoUserId\" ng-disabled=\"!vm.canStart()\" required>\n          <option ng-repeat=\"u in vm.vimeoUsers\" value=\"{{u.id}}\">{{u.display_name}}</option>\n        </select>\n      </div>\n      <div class=\"form-group text-center\">\n        <button class=\"btn btn-default overflow-ellipse\"\n          ng-disabled=\"!vm.canStart()\"\n          ng-click=\"vm.start()\"\n          analytics-on analytics-event=\"event-edit\" analytics-category=\"vimeo-export\" analytics-label=\"\">\n          <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n          <i class=\"fa fa-vimeo\" style=\"width:20px\"></i>\n          Export To Vimeo\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <!-- kaltura -->\n  <div ng-if=\"vm.activeTab == 'kaltura'\">\n    <p class=\"help-block\">\n      <small>\n        Recordings can be exported to Kaltura. This process can take a few minutes while we convert your recording\n        to the proper format and then send it to Kaltura.\n      </small>\n    </p>\n    <div class=\"form-group text-center\" ng-show=\"(vm.recording.kaltura_export_status != 'ready' || vm.unlock.kaltura)\">\n      <button class=\"btn btn-default overflow-ellipse\"\n        ng-disabled=\"!vm.canStart()\"\n        ng-click=\"vm.start()\"\n        analytics-on analytics-event=\"event-edit\" analytics-category=\"kaltura-export\" analytics-label=\"\">\n        <i ng-hide=\"vm.canStart()\" class=\"fa fa-spin fa-spinner\"></i>\n        Export To Kaltura\n      </button>\n    </div>\n  </div>\n\n  <!-- status messaging -->\n  <div ng-switch=\"vm.status()\">\n    <div ng-switch-when=\"expired|unprocessed\" ng-switch-when-separator=\"|\">\n      <!-- nobody has requested this yet, or the previous one expired -->\n    </div>\n    <div ng-switch-when=\"requesting\">\n      <p class=\"text-center\">\n        <em>Loading...</em>\n      </p>\n    </div>\n    <div ng-switch-when=\"awaiting_conversion|processing|requested\" ng-switch-when-separator=\"|\">\n      <p class=\"text-center\">\n        Your request is processing. Feel free to close this window and come back later.\n      </p>\n      <uib-progressbar value=\"vm.statusPercent()\" max=\"100\">\n        {{vm.statusPercent()}}% Complete\n      </uib-progressbar>\n      <p class=\"text-center\">\n        <em><random-waiting-message interval=\"5000\"></random-waiting-message></em>\n      </p>\n    </div>\n    <div ng-switch-when=\"ready\">\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'mp4' || vm.activeTab == 'm4a'\">\n        Your download is ready!\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'kaltura' && !vm.unlock.kaltura\">\n        The video has been successfully exported to Kaltura.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.kaltura = true\"><small>Export this video again.</small></button>\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'vimeo' && !vm.unlock.vimeo\">\n        The video has been successfully exported to Vimeo.<br>\n        Look for an email from Vimeo or visit <a href=\"https://vimeo.com/home/myvideos\" target=\"_blank\">My Videos</a> for next steps.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.vimeo = true\"><small>Export this video again.</small></button>\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'youtube' && !vm.unlock.youtube\">\n        The video has been successfully exported to YouTube.<br>\n        Look for an email from YouTube or visit your <a href=\"https://www.youtube.com/my_videos\" target=\"_blank\">Video Manager</a> for next steps.<br>\n        <button class=\"btn btn-link\" ng-click=\"vm.unlock.youtube = true\"><small>Export this video again.</small></button>\n      </p>\n    </div>\n    <div ng-switch-when=\"failed\">\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'mp4' || vm.activeTab == 'm4a'\">\n        <i class=\"fa fa-warning\"></i>\n        The download request failed.\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'kaltura'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.overview\">Kaltura Configuration Settings</a> correct?\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'vimeo'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.vimeo\">Vimeo Configuration Settings</a> correct?\n      </p>\n      <p class=\"text-center\" ng-show=\"vm.activeTab == 'youtube'\">\n        <i class=\"fa fa-warning\"></i>\n        The export request failed. Are your <a ng-click=\"vm.cancel()\" ui-sref=\"settings.youtube\">YouTube Configuration Settings</a> correct?\n      </p>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body\">\n  <button type=\"button\" class=\"pull-right close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <uib-tabset active=\"vm.activeTab\">\n    <uib-tab>\n      <uib-tab-heading>\n        Website Embed\n      </uib-tab-heading>\n      <div class=\"tab-container\" style=\"border:none;padding:0\">\n        <div style=\"padding:15px 0 0 0;\">\n          <div class=\"help-block\" style=\"margin-top:0\">\n            <small>This embed code is good for this broadcast only. If you want a playlist with other broadcasts to show up on your website, <a ng-click=\"vm.cancel()\" ui-sref=\"embed\">visit the Embed page</a>.</small>\n          </div>\n          <div style=\"max-width:1000px\">\n            <embed-broadcasts account=\"{}\"\n                              channels=\"[]\"\n                              sources-combined=\"[]\"\n                              show-preview=\"vm.showPreview\"\n                              output=\"vm.output\"\n                              single-event=\"vm.broadcast\"\n                              ></embed-broadcasts>\n          </div>\n        </div>\n      </div>\n    </uib-tab>\n    <uib-tab>\n      <uib-tab-heading>\n        Other Integrations\n      </uib-tab-heading>\n      <div class=\"tab-container\" style=\"border:none;padding:0\">\n        <div style=\"padding:15px 0 0 0;\">\n          <div style=\"max-width:1000px\">\n            <embed-other account=\"{}\"\n                         channels=\"[]\"\n                         sources-combined=\"[]\"\n                         show-preview=\"vm.showPreview\"\n                         output=\"vm.output\"\n                         single-event=\"vm.broadcast\"\n                         ></embed-other>\n          </div>\n        </div>\n      </div>\n    </uib-tab>\n  </uib-tabset>\n</div>\n"

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightsController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_capture_highlight_recorded__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_download_or_export_highlight__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_highlight_preview__ = __webpack_require__(207);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }





var HighlightsController = /*#__PURE__*/function () {
  function HighlightsController($state, Broadcast, Highlight, ConfirmDialog, $rootScope, $uibModal, toaster) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, HighlightsController);

    this.$state = $state;
    this.$uibModal = $uibModal;
    this.toaster = toaster;
    this.Highlight = Highlight;
    this.ConfirmDialog = ConfirmDialog;
    this.user = $rootScope.user;
    this.HIGHLIGHTS_PAGE_SIZE = 10;
    this.maxMonetizedHighlightTimeS = MAX_MONETIZED_HIGHLIGHT_TIME_S;
    this.broadcastIsMonetized = false;
    this.broadcast = Broadcast.get({
      id: $state.params.id
    }, function (b) {
      _this.broadcastIsMonetized = !b.is_private && b.is_ticketed;
    });
    this.loadHighlightsForPage(1);
    this.loadingPromises = [this.broadcast.$promise, this.highlights.$promise];
  }

  _createClass(HighlightsController, [{
    key: "canDownloadOrExport",
    get: function get() {
      var user = this.user; // If the user is not capable of creating any download or export, then don't show it

      if (user.cannot('create', 'highlight/*:download') && user.cannot('create', 'highlight/*:kaltura-export') && user.cannot('create', 'highlight/*:vimeo-export') && user.cannot('create', 'highlight/*:youtube-export')) {
        return false;
      } // If there's no transcoded recording, then don't show it.


      if (!this.recordingIsTranscoded) {
        return false;
      }

      return true;
    }
  }, {
    key: "recordingIsTranscoded",
    get: function get() {
      if (!this.broadcast) {
        return false;
      } else if (this.broadcast.recording_id && this.broadcast.recording_duration_seconds) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "showCaptureModal",
    value: function showCaptureModal(highlight) {
      var _this2 = this;

      var $uibModal = this.$uibModal,
          Highlight = this.Highlight;
      $uibModal.open({
        size: 'lg',
        backdrop: 'static',
        // don't allow accidental clicks on backdrop to close
        template: __webpack_require__(214),
        controllerAs: 'vm',
        controller: __WEBPACK_IMPORTED_MODULE_0__modal_capture_highlight_recorded__["a" /* default */],
        resolve: {
          highlightObj: function highlightObj() {
            return highlight;
          },
          recordingId: function recordingId() {
            return _this2.broadcast.recording_id;
          }
        }
      });
    }
  }, {
    key: "showHighlight",
    value: function showHighlight(highlight) {
      if (!this.broadcastIsMonetized || highlight.duration <= this.maxMonetizedHighlightTimeS) {
        this.playHighlight(highlight);
      } else {
        this.showCaptureModal(highlight);
      }
    }
  }, {
    key: "playHighlight",
    value: function playHighlight(highlight) {
      var _this3 = this;

      var $uibModal = this.$uibModal,
          $timeout = this.$timeout,
          Highlight = this.Highlight;
      $uibModal.open({
        template: __webpack_require__(215),
        resolve: {
          broadcast: function broadcast() {
            return _this3.broadcast;
          },
          highlightDetails: function highlightDetails() {
            return highlight;
          },
          showSave: function showSave() {
            return false;
          }
        },
        controller: __WEBPACK_IMPORTED_MODULE_2__modal_highlight_preview__["a" /* default */],
        controllerAs: 'vm'
      });
    }
  }, {
    key: "delete",
    value: function _delete(highlight) {
      var _this4 = this;

      var Highlight = this.Highlight,
          ConfirmDialog = this.ConfirmDialog,
          $state = this.$state;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Delete Highlight',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to permanently delete this highlight?'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        Highlight["delete"]({
          id: highlight.id,
          broadcastId: _this4.broadcast.id
        }, function () {
          _this4.toaster.pop('warning', 'Successfully deleted highlight');

          _this4.highlights = Highlight.query({
            broadcastId: _this4.broadcast.id
          });
        }, function () {
          return alert('Error deleting highlight. Please reload this page and try again.');
        });
      });
    }
  }, {
    key: "download",
    value: function download(_highlight) {
      var _this5 = this;

      this.$uibModal.open({
        template: __webpack_require__(210),
        controllerAs: 'vm',
        controller: __WEBPACK_IMPORTED_MODULE_1__modal_download_or_export_highlight__["a" /* default */],
        resolve: {
          broadcast: function broadcast() {
            return _this5.broadcast;
          },
          highlight: function highlight() {
            return _highlight;
          }
        }
      });
    }
  }, {
    key: "loadHighlightsForPage",
    value: function loadHighlightsForPage(p) {
      var _this6 = this;

      this.highlights = this.Highlight.query({
        broadcastId: this.$state.params.id,
        p: p - 1,
        l: this.HIGHLIGHTS_PAGE_SIZE,
        s: 'streamed_at'
      }, function (data, headers) {
        var pagination = JSON.parse(headers('x-pagination'));
        _this6.highlightsPagination = {
          current: p,
          total: pagination.total,
          resultMin: _this6.HIGHLIGHTS_PAGE_SIZE * (p - 1) + 1,
          resultMax: _this6.HIGHLIGHTS_PAGE_SIZE * (p - 1) + data.length
        };
      }, function (err) {
        console.log(err);

        _this6.toaster.pop('warning', 'Unable to load highlights.');
      });
    }
  }]);

  return HighlightsController;
}();



/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrimRecordingsController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var TrimRecordingsController = /*#__PURE__*/function () {
  function TrimRecordingsController($state, $scope, Broadcast, Recording, $q, $timeout, $uibModal) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, TrimRecordingsController);

    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;
    this.broadcast = Broadcast.get({
      id: $state.params.id
    });
    this.recording = Recording.get({
      id: $state.params.recording
    });
    this.segmentRange = [0, 0];
    this.startSeconds = 0;
    this.stopSeconds = 0;

    this.onChangeBounds = function (startSeconds, stopSeconds, startSegment, stopSegment) {
      _this.startSeconds = Math.ceil(startSeconds);
      _this.stopSeconds = Math.floor(stopSeconds);
      _this.segmentRange = [startSegment, stopSegment];
    };

    this.loadingPromises = [this.broadcast.$promise, this.recording.$promise];
  }

  _createClass(TrimRecordingsController, [{
    key: "showPreviewModal",
    value: function showPreviewModal() {
      var _this2 = this;

      var $uibModal = this.$uibModal,
          $timeout = this.$timeout;
      $uibModal.open({
        template: __webpack_require__(206),
        controller: function controller($scope, $uibModalInstance) {
          'ngInject';

          $scope.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };

          $scope.title = 'Preview Trimmed Recording';
          $scope.broadcast = _this2.broadcast;
          $scope.options = {
            autostart: true,
            // TODO: ticketId = admin_token?
            //ticketId: BROADCAST_TICKET,
            trimSeconds: {
              // Support for v3 player
              start: _this2.startSeconds,
              stop: _this2.stopSeconds
            },
            onLoadBroadcast: function onLoadBroadcast(b) {
              // Support for v2 player
              b.start_segment = _this2.segmentRange[0];
              b.stop_segment = _this2.segmentRange[1];
            }
          };
        }
      });
    }
  }, {
    key: "saveChanges",
    value: function saveChanges() {
      var _this3 = this;

      this.isSaving = true;
      this.recording.start_segment = '';
      this.recording.stop_segment = '';
      this.recording.start_seconds = this.startSeconds;
      this.recording.stop_seconds = this.stopSeconds;
      this.recording.$update(function () {
        _this3.$state.go('events.detail', {
          id: _this3.$state.params.id
        });
      }, function () {
        _this3.isSaving = false;
        alert('Unable to save trimmed recording. Please try again.');
      });
    }
  }]);

  return TrimRecordingsController;
}();



/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scoreboardControls;
/* unused harmony export defaultScoreForSport */
/* unused harmony export configForSport */
// directive for controlling the score of a broadcasted sporting event
//
//    <scoreboard-controls broadcast="vm.broadcast"
//                         scoreboard="vm.scoreboard" />
//
//
// depending on the sport inside the scoreboard configuration object, different
// controls will be presented.
//
// upon changing the score, the change will be persisted back to the server.
var SCOREBOARD_CHANGE_DEBOUNCE_MS = 500; //batch subsequent changes

function scoreboardControls(ApiConfig, Broadcast, $interval) {
  'ngInject';

  return {
    template: __webpack_require__(444),
    scope: {
      broadcast: '=',
      scoreboard: '='
    },
    link: function link(scope, element) {
      ApiConfig.then(function () {
        return scope.sports = ApiConfig.stream.sports;
      });
      var config = configForSport(scope.scoreboard.sport);
      scope.controls = config.controls;
      scope.increments = config.increments;
      scope.presets = config.presets;

      function reloadScore() {
        if (!scope.broadcast.id) {
          console.warn('Broadcast is not defined; cannot load score', scope.broadcast);
          return;
        }

        return Broadcast.getScore({
          id: scope.broadcast.id
        }, function (score) {
          return scope.score = score || {};
        }).$promise;
      }

      scope.update = function (key) {
        console.log('Update fired for', key, 'to', scope.score[key]);
        saveScoreDebounced();
      };

      scope.handlePresetClick = function (preset) {
        console.log('Preset clicked', preset);

        if (preset.confirm) {
          if (!confirm(preset.confirm)) {
            return;
          }
        }

        scope.score = preset.set(scope.score);
        scope.update();
      };

      scope.handleIncrementClick = function (field, increment) {
        console.log('Increment clicked', field, increment);
        scope.score[field] = scope.score[field] + increment;
        scope.update();
      };

      function saveScore() {
        // TODO: der grabbing server score first, then merging changes if
        // necessary (or warning user that someone else might be editing). this
        // could be easier to manage oddities than trying to refresh from the
        // server except while in a control editing.
        if (!scope.broadcast.id) {
          console.warn('Cannot save score; broadcast is not defined');
          return;
        }

        Broadcast.saveScore({
          id: scope.broadcast.id
        }, scope.score, function (score) {
          return console.log('Saved score successfully!');
        });
      }

      var saveScoreDebounced = _.debounce(saveScore, SCOREBOARD_CHANGE_DEBOUNCE_MS);

      scope.loadingPromise = reloadScore(); // XXX: should we poll for other browsers making changes to scoreboard or
      // assume this user is source of truth?
      //let SCOREBOARD_REFRESH_INTERVAL_MS = 10000;
      //let reloadHandle = $interval(reloadScore, SCOREBOARD_REFRESH_INTERVAL_MS);
      //scope.$on('$destroy', () => $interval.cancel(reloadHandle));
    }
  };
}
function defaultScoreForSport(sport) {
  var _configForSport = configForSport(sport),
      controls = _configForSport.controls;

  var data = {};
  controls.forEach(function (c) {
    if (c.radioGroup && c.radioGroup.length) {
      data[c.key] = c.radioGroup[0].key;
    } else {
      data[c.key] = c.min;
    }
  });
  return data;
}
function configForSport(sport) {
  var controls = [];
  var increments = []; // in addition to the standard +/- 1

  var presets = [{
    label: 'Reset Scoreboard',
    confirm: 'Are you sure you want to reset the scoreboard?',
    set: function set(x) {
      x = _.merge(x, defaultScoreForSport(sport));
      x.home_score = 0;
      x.away_score = 0;
      return x;
    }
  }];

  switch (sport.toLowerCase()) {
    case 'basketball (2 halves)':
      controls = [{
        label: 'Half',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      increments = [1, 2, 3];
      break;

    case 'basketball (4 quarters)':
      controls = [{
        label: 'Quarter',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      increments = [1, 2, 3];
      break;

    case 'soccer':
      controls = [{
        label: 'Quarter/Half',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      break;

    case 'lacrosse':
      controls = [{
        label: 'Quarter/Half',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      break;

    case 'hockey':
      controls = [{
        label: 'Period',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      break;

    case 'wrestling':
      controls = [{
        label: 'Round',
        key: 'round',
        min: 1,
        max: 9,
        className: 'col-xs-12'
      }];
      increments = [1, 2, 3];
      break;

    case 'baseball/softball':
      controls = [{
        label: 'Inning',
        key: 'inning',
        min: 1,
        max: 99,
        className: 'col-xs-12 col-md-6'
      }, {
        label: null,
        key: 'inning_half',
        className: 'col-xs-12 col-md-6',
        radioGroup: [{
          label: 'Top',
          key: 'top'
        }, {
          label: 'Bottom',
          key: 'bottom'
        }]
      }, {
        label: 'Outs',
        key: 'outs',
        min: 0,
        max: 3,
        className: 'col-xs-12 col-md-4'
      }, {
        label: 'Balls',
        key: 'balls',
        min: 0,
        max: 4,
        className: 'col-xs-12 col-md-4'
      }, {
        label: 'Strikes',
        key: 'strikes',
        min: 0,
        max: 3,
        className: 'col-xs-12 col-md-4'
      }];
      increments = [1, 2, 3, 4];
      presets = presets.concat([{
        label: 'Next Batter',
        set: function set(x) {
          x.balls = 0;
          x.strikes = 0;
          return x;
        }
      }, {
        label: 'Next Half-Inning',
        set: function set(x) {
          if (x.inning_half == 'top') {
            x.inning_half = 'bottom';
          } else {
            x.inning_half = 'top';
            x.inning = (x.inning || 0) + 1;
          }

          x.outs = 0;
          x.balls = 0;
          x.strikes = 0;
          return x;
        }
      }]);
      break;

    case 'football':
      controls = [{
        label: 'Quarter',
        key: 'period',
        min: 1,
        max: 9,
        className: 'col-xs-12 col-md-4 col-lg-3'
      }, {
        label: 'Down',
        key: 'down',
        min: 1,
        max: 4,
        className: 'col-xs-6 col-md-4 col-lg-3'
      }, {
        label: 'Yards to Go',
        key: 'yards_to_go',
        min: 1,
        max: 100,
        className: 'col-xs-6 col-md-4 col-lg-3'
      }, {
        label: 'Possession',
        key: 'possession',
        className: 'col-xs-12 col-lg-3 no-padding',
        radioGroup: [{
          label: 'Away',
          key: 'away'
        }, {
          label: 'Home',
          key: 'home'
        }]
      }];
      increments = [1, 2, 3, 6];
      presets = presets.concat([{
        label: 'New Set of Downs',
        set: function set(x) {
          x.yards_to_go = 10;
          x.down = 1;
          return x;
        }
      }]);
      break;

    case 'volleyball':
      controls = [{
        label: 'Service',
        key: 'service',
        className: 'col-xs-12 col-lg-3 no-padding',
        radioGroup: [{
          label: 'Away',
          key: 'away'
        }, {
          label: 'Home',
          key: 'home'
        }]
      }, {
        label: 'Set',
        key: 'set',
        min: 1,
        max: 9,
        className: 'col-xs-12 col-lg-3'
      }, {
        label: 'Home Games Won',
        key: 'home_games_won',
        min: 0,
        max: 99,
        className: 'col-xs-6 col-lg-3'
      }, {
        label: 'Away Games Won',
        key: 'away_games_won',
        min: 0,
        max: 99,
        className: 'col-xs-6 col-lg-3'
      }];
      break;

    default:
      console.warn('Unknown sport', scoreboard);
      break;
  }

  return {
    controls: controls,
    increments: increments,
    presets: presets
  };
}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "<div cg-busy=\"{promise: vm.loadingPromise, message: 'Loading...', minDuration: 500}\">\n  <div ng-if=\"loadingPromise.$$state.status != 0\"> <!-- don't load the ng-change events into the DOM until after we've loaded the score -->\n\n    <div class=\"row\" style=\"margin-bottom:10px\">\n      <div class=\"col-xs-6 col-sm-5 text-center\">\n            <color-swatch color=\"scoreboard.away_team_logo\"\n                          label=\"scoreboard.away_team_name + ' (Away)'\"\n                          extra-style=\"{width: '100%'}\"></color-swatch>\n      </div>\n      <div class=\"hidden-xs col-sm-2 text-center\">\n            vs.\n      </div>\n      <div class=\"col-xs-6 col-sm-5 text-center\">\n            <color-swatch color=\"scoreboard.home_team_logo\"\n                          label=\"scoreboard.home_team_name + ' (Home)'\"\n                          extra-style=\"{width: '100%'}\"></color-swatch>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-xs-6 col-sm-5 text-center\">\n            <number-spinner ng-model=\"score.away_score\"\n                            ng-change=\"update('away_score')\"\n                            size=\"lg\"\n                            width=\"auto\"\n                            min-value=\"0\"\n                            max-value=\"999\"></number-spinner>\n            <div ng-if=\"increments.length\">\n              <ul class=\"list-inline\" style=\"font-size:14pt\">\n                <li ng-repeat=\"increment in ::increments\" style=\"padding:5px 10px\">\n                <a class=\"btn btn-default\" href=\"javascript://\" ng-click=\"handleIncrementClick('away_score', increment)\">\n                  {{(increment > 0 ? '+' : '') + increment}}\n                </a>\n                </li>\n              </ul>\n              <div class=\"clearfix\"></div>\n            </div>\n      </div>\n      <div class=\"hidden-xs col-sm-2 text-center\">\n      </div>\n      <div class=\"col-xs-6 col-sm-5 text-center\">\n            <number-spinner ng-model=\"score.home_score\"\n                            ng-change=\"update('home_score')\"\n                            size=\"lg\"\n                            input-width=\"auto\"\n                            min-value=\"0\"\n                            max-value=\"999\"></number-spinner>\n            <div ng-if=\"increments.length\">\n              <ul class=\"list-inline\" style=\"font-size:14pt\">\n                <li ng-repeat=\"increment in ::increments\" style=\"padding:5px 10px\">\n                <a class=\"btn btn-default\" href=\"javascript://\" ng-click=\"handleIncrementClick('home_score', increment)\">\n                  {{(increment > 0 ? '+' : '') + increment}}\n                </a>\n                </li>\n              </ul>\n              <div class=\"clearfix\"></div>\n            </div>\n      </div>\n    </div>\n\n    <div class=\"row\" style=\"margin-top:0; margin-bottom:15px;\">\n      <div ng-repeat=\"control in controls track by $index\"\n           class=\"{{control.className}}\"\n           style=\"vertical-align:bottom; text-align:center; padding-bottom:15px;\">\n        <strong ng-if=\"control.label\">{{control.label}}</strong>\n        <strong ng-if=\"!control.label\">&nbsp;</strong>\n        <div ng-if=\"!control.radioGroup\">\n          <number-spinner ng-model=\"score[control.key]\"\n                          ng-change=\"update(control.key)\"\n                          size=\"lg\"\n                          width=\"130px\"\n                          min-value=\"control.min\"\n                          max-value=\"control.max\"></number-spinner>\n        </div>\n        <div ng-if=\"control.radioGroup\">\n          <div class=\"btn-group\">\n            <label ng-repeat=\"b in ::control.radioGroup\"\n                    class=\"btn btn-default btn-lg\"\n                    ng-model=\"score[control.key]\"\n                    ng-change=\"update(control.key)\"\n                    uib-btn-radio=\"b.key\">{{b.label}}</label>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"clearfix\"></div>\n\n    <div ng-if=\"presets.length\">\n      <ul class=\"list-inline\">\n        <li ng-repeat=\"preset in ::presets\" style=\"margin-right:15px\">\n          <a class=\"action-link\" href=\"javascript://\" ng-click=\"handlePresetClick(preset)\">{{preset.label}}</a>\n        </li>\n      </ul>\n      <div class=\"clearfix\"></div>\n    </div>\n\n    <p class=\"help-block\">\n    <small>\n      <i class=\"fa fa-info-circle\"></i>\n      The scoreboard data is updated at the same time as other live action at your venue. If you\n      are watching the broadcast above while updating the scoreboard information, remember that the\n      video lags the live data by at least 30 seconds, so expect to see your updated\n      scoreboard information with the same delay.\n    </small>\n    </p>\n\n  </div>\n</div>\n"

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_error__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_clappr__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_highlight_capture_plugin__ = __webpack_require__(446);


 // angular.component definition for a modified boxcast-player that
// supports a highlight capture component.

var playerWithHighlightCapture = {
  bindings: {
    channelId: '<',
    options: '<',
    broadcast: '<',
    onOpenHighlightPreview: '=',
    onNewHighlightCaptured: '=',
    onOpenLowLatencyPreview: '=',
    parentVm: '<'
  },
  template: "\n    <boxcast-player ng-if=\"!vm.noViewers && vm.__readyToLoadPlayer\"\n                    channel-id=\"vm.channelId\"\n                    options=\"vm.options\"></boxcast-player>\n    <div class=\"fixed-16-9\" ng-if=\"vm.noViewers\">\n      <h3 style=\"color:#fff;display:flex;align-items:center;justify-content:center;padding:0 15px;\">\n        <div>\n          <p>{{vm.noViewersSimulcastMessage()}}</p>\n          <p>\n            <button ng-if=\"vm.canUsePreview() && vm.broadcast.actual_codec != 'hevc'\"\n                    ng-click=\"vm.openLowLatencyPreview()\"\n                    analytics-on analytics-event=\"event-edit\" analytics-category=\"preview\" analytics-label=\"\"\n                    class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n              <i class=\"fa fa-video-camera\" style=\"width:20px\"></i>\n              <span>Show Preview</span>\n            </button>\n          </p>\n          <p>\n            <a class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left;position:relative;padding-left:37px;\" ng-if=\"vm.canLinkToSocial()\" ng-href=\"{{vm.socialLink()}}\" target=\"_blank\">\n              <img ng-src=\"/img/{{vm.socialIcon()}}\" ng-if=\"vm.socialIcon()\" style=\"position:absolute;top:0;left:0;height:32px;width:32px;\">\n              {{vm.socialText()}}\n            </a>\n          </p>\n        </div>\n      </h3>\n    </div>\n  ",
  controllerAs: 'vm',
  controller: PlayerWithHighlightCaptureController
};

function PlayerWithHighlightCaptureController($scope, $element, $attrs, $timeout, $rootScope, $sce, toaster, Highlight) {
  'ngInject';

  var _this = this;

  var account = $rootScope.account,
      user = $rootScope.user;
  this.FeatureFlags = account.feature_flags;
  this.account = account;
  this.$sce = $sce;
  this.toaster = toaster;
  this.Highlight = Highlight;
  this.noViewers = this.FeatureFlags.no_viewers;
  /* the following are provided automagically by angular.component bindings...
  this.channelId = channelId;
  this.options = options;
  this.onOpenHighlightPreview = onOpenHighlightPreview;
  this.onNewHighlightCaptured = onNewHighlightCaptured;
  this.onOpenLowLatencyPreview = onOpenLowLatencyPreview;
  this.parentVm = parentVm;
  */

  var watchFn = function watchFn() {
    if (_this.noViewers) return;
    if (!_this.channelId) return;
    if (!_this.options.ticketId) return;

    if (_this.FeatureFlags.highlights && _this.broadcast.recording_requested !== false && user.can('create', 'broadcast/*:highlight')) {
      var origOnLoadPlayer = _this.options.onLoadPlayer || function () {};

      _this.options.onLoadPlayer = function (player) {
        _this.clapprUtils = new __WEBPACK_IMPORTED_MODULE_1__utils_clappr__["a" /* default */](player);
        origOnLoadPlayer(player);
      };

      _this.options.clapprPlugins = [__WEBPACK_IMPORTED_MODULE_2__player_highlight_capture_plugin__["a" /* default */]];
      _this.options.clapprConfig = {
        highlightCapturePlugin: {
          onPreview: function onPreview(data) {
            return $timeout(function () {
              return _this.onHighlightCapturePreview(data);
            }, 0);
          },
          onSave: function onSave(data) {
            return $timeout(function () {
              return _this.onHighlightCaptureSave(data);
            }, 0);
          }
        }
      };
    }

    _this.__readyToLoadPlayer = true;
  };

  $scope.$watch(function () {
    return _this.channelId;
  }, watchFn);
  $scope.$watch(function () {
    return _this.options;
  }, watchFn, true);

  this._unpackAndValidateHighlightData = function (data) {
    var highlight = {
      name: data.name,
      start_seconds: data.start_seconds || Math.floor(_this.clapprUtils.getMediaAbsoluteTimeForTime(data.start)),
      stop_seconds: data.stop_seconds || Math.ceil(_this.clapprUtils.getMediaAbsoluteTimeForTime(data.end))
    };

    if (highlight.start_seconds === null || highlight.stop_seconds === null) {
      console.warn('error getting start/stop seconds', data, highlight);

      _this.toaster.pop('warning', 'Unable to generate highlight. Please check the selected time and duration and then try again.');

      return;
    }

    return highlight;
  };

  this.onHighlightCapturePreview = function (data) {
    var highlight = _this._unpackAndValidateHighlightData(data);

    if (!highlight) return;

    _this.onOpenHighlightPreview.bind(_this.parentVm)(highlight, true).result.then(function (result) {
      console.log('saving with original data', data, 'and updates from preview', result); // User opted to save the highlight from within the preview

      _this.onHighlightCaptureSave(angular.extend({}, data, result));
    });
  };

  this.onHighlightCaptureSave = function (data) {
    var highlight = _this._unpackAndValidateHighlightData(data);

    if (!highlight) return;

    if (!highlight.name) {
      _this.toaster.pop('warning', 'Please provide a name for the highlight before saving.');

      return;
    }

    _this.Highlight.create({
      broadcastId: _this.broadcast.id
    }, highlight).$promise.then(function () {
      _this.onNewHighlightCaptured.bind(_this.parentVm)();

      data.fnClose();
    })["catch"](function (err) {
      console.error(err);

      _this.toaster.pop('warning', "The highlight could not be created: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__utils_error__["a" /* errorDescriptionFromResponse */])(err)));
    });
  };

  this.socialSimulcastInfo = function () {
    if (!_this.broadcast || !_this.broadcast.simulcast_configurations || _this.broadcast.simulcast_configurations.length != 1 || !_this.broadcast.simulcast_configurations[0]) {
      return null;
    }

    var simulcast = _this.broadcast.simulcast_configurations[0];
    var destination = simulcast.destination,
        fb_feed_id = simulcast.fb_feed_id,
        youtube_broadcast_id = simulcast.youtube_broadcast_id,
        share_url = simulcast.share_url;

    if (destination == 'facebook' && fb_feed_id) {
      return {
        destination: 'facebook',
        link: "https://www.facebook.com/".concat(fb_feed_id.replace(/^[^:]*:/, ''), "/videos"),
        text: 'Watch on Facebook'
      };
    }

    if (destination == 'youtube' && youtube_broadcast_id) {
      return {
        destination: 'youtube',
        link: "https://www.youtube.com/live_event_analytics?v=".concat(youtube_broadcast_id),
        text: 'YouTube Live Control Room'
      };
    }

    if (destination == 'twitter' && share_url) {
      return {
        destination: 'twitter',
        link: share_url,
        text: 'Watch on Twitter'
      };
    }

    return null;
  };

  this.socialIcon = function () {
    var info = _this.socialSimulcastInfo() || {};
    if (info.destination == 'facebook') return 'icon_facebook@30px.png';
    if (info.destination == 'youtube') return 'icon_youtube@30px.png';
    if (info.destination == 'twitter') return 'icon_twitter@30px.png';
    return '';
  };

  this.canLinkToSocial = function () {
    return !!_this.socialSimulcastInfo();
  };

  this.socialLink = function () {
    return _this.$sce.trustAsResourceUrl(_this.socialSimulcastInfo().link);
  };

  this.socialText = function () {
    return _this.socialSimulcastInfo().text;
  };

  this.canUsePreview = function () {
    var account = _this.account; // Low-latency preview is gated by feature flag PLUS browser-compatibility
    // Note that we're not feature-detecting Flash specifically (although we could)
    // because this allows us to advertise to desktop users who might only have
    // to install the flash plugin to get it to work.

    if (!account.extra_features.low_latency_preview) {
      return false;
    }

    if (navigator.userAgent.indexOf('iOS') >= 0 || navigator.userAgent.indexOf('Android') >= 0) {
      return false;
    }

    return !!(_this.broadcast || {}).rtmp_preview_url;
  };

  this.noViewersSimulcastMessage = function () {
    var beVerb;
    var haveVerb;

    switch (_this.broadcast.timeframe) {
      case 'past':
        beVerb = 'was';
        haveVerb = 'had';
        break;

      case 'preroll': // fall-through

      case 'future':
        beVerb = 'will be';
        haveVerb = 'has';
        break;

      default:
        beVerb = 'is being';
        haveVerb = 'has';
        break;
    }

    var destinations = _.map(_this.broadcast.simulcast_configurations, function (s) {
      switch (s.destination) {
        case 'facebook':
          return 'Facebook';
          break;

        case 'youtube':
          return 'YouTube';
          break;

        case 'twitter':
          return 'Twitter';
          break;

        default:
          return 'an RTMP destination';
          break;
      }
    });

    if (_.countBy(destinations, function (d) {
      return d === 'an RTMP destination';
    }) > 1) {
      destinations = _.map(destinations, function (d) {
        return d !== 'an RTMP destination' ? d : 'RTMP destinations';
      });
    }

    destinations = _.uniq(destinations).sort();

    if (destinations.length === 0) {
      // In theory this should never happen, but in case it does, we short-circuit something sensible.
      return "This broadcast ".concat(beVerb, " streamed, but ").concat(haveVerb, " no destination configured.");
    } else if (destinations.length === 1) {
      destinations = destinations[0];
    } else if (destinations.length === 2) {
      var first, last;

      if (_.contains(destinations, 'an RTMP destination')) {
        destinations = _.without(destinations, 'an RTMP destination');
        first = destinations[0];
        last = 'an RTMP destination';
      } else if (_.contains(destinations, 'RTMP destinations')) {
        destinations = _.without(destinations, 'RTMP destinations');
        first = destinations[0];
        last = 'RTMP destinations';
      } else {
        first = destinations[0];
        last = destinations[1];
      }

      destinations = "".concat(first, " and ").concat(last);
    } else {
      var _last;

      if (_.contains(destinations, 'an RTMP destination')) {
        destinations = _.without(destinations, 'an RTMP destination');
        _last = 'an RTMP destination';
      } else if (_.contains(destinations, 'RTMP destinations')) {
        _last = 'RTMP destinations';
      } else {
        _last = destinations.pop();
      }

      destinations = "".concat(destinations.join(', '), ", and ").concat(_last);
    }

    return "This broadcast ".concat(beVerb, " streamed to ").concat(destinations, ".");
  };

  this.openLowLatencyPreview = function () {
    _this.onOpenLowLatencyPreview.bind(_this.parentVm)();
  };
}

/* harmony default export */ __webpack_exports__["a"] = (playerWithHighlightCapture);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightCapturePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_utils_date__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__highlight_capture_plugin_scss__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__highlight_capture_plugin_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__highlight_capture_plugin_scss__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



var Clappr = boxcast.libs.Clappr;
var UICorePlugin = Clappr.UICorePlugin,
    Events = Clappr.Events,
    $ = Clappr.$;

var HighlightCapturePlugin = /*#__PURE__*/function (_UICorePlugin) {
  _inherits(HighlightCapturePlugin, _UICorePlugin);

  var _super = _createSuper(HighlightCapturePlugin);

  function HighlightCapturePlugin(core) {
    var _this;

    _classCallCheck(this, HighlightCapturePlugin);

    _this = _super.call(this, core);
    var options = core.options.highlightCapturePlugin || {};

    _this._onPreview = options.onPreview || function () {};

    _this._onSave = options.onSave || function () {};

    return _this;
  }

  _createClass(HighlightCapturePlugin, [{
    key: "supportedVersion",
    get: function get() {
      return {
        min: '0.4.0'
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'highlight-capture';
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        "class": this.name
      };
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.core.mediaControl, Events.MEDIACONTROL_RENDERED, this._onMediaControlRendered);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(HighlightCapturePlugin.prototype), "destroy", this).call(this);

      this._$form.find('.close').off('click');

      this._$form.find('.preview').off('click');

      this._$form.find('.save').off('click');

      this._$form.find('input,select').off('keydown');
    }
  }, {
    key: "_getCurrentTime",
    value: function _getCurrentTime() {
      // XXX: playback.getCurrentTime is often wildly inaccurate. Asking the <video> element directly is better.
      //var time = this.core.getCurrentPlayback().getCurrentTime();
      var time = this.core.$el.find('video, audio').get(0).currentTime;
      console.log('Clicked at', time, ' on video element. Playback reports', this.core.getCurrentPlayback().getCurrentTime());
      return time;
    }
  }, {
    key: "_getVideoDuration",
    value: function _getVideoDuration() {
      //return this.core.getCurrentPlayback().getDuration();
      return this.core.$el.find('video, audio').get(0).duration;
    }
  }, {
    key: "_getFormSelections",
    value: function _getFormSelections() {
      var _this2 = this;

      var name = this._$form.find('.description').val();

      var start = Object(__WEBPACK_IMPORTED_MODULE_0__app_utils_date__["c" /* formattedLabelToSeconds */])(this._$form.find('.start-time').val());
      console.log('start is', start, 'from', this._$form.find('.start-time').val());
      var duration = parseInt(this._$form.find('.duration').val(), 10) * parseInt(this._$form.find('.duration-relative').val(), 10);
      var end = start + duration;
      start = Math.max(0, start);
      end = Math.max(0, end);
      start = Math.min(start, this._getVideoDuration());
      end = Math.min(end, this._getVideoDuration());

      if (start > end) {
        var _ref = [end, start];
        start = _ref[0];
        end = _ref[1];
      }

      var fnClose = function fnClose() {
        return _this2._onCloseForm();
      };

      return {
        start: start,
        end: end,
        name: name,
        fnClose: fnClose
      };
    }
  }, {
    key: "_onMediaControlRendered",
    value: function _onMediaControlRendered() {
      var playback = this.core.getCurrentPlayback();

      if (playback.name == 'hls') {
        this._appendCameraIcon();

        this._appendForm();
      } else {
        console.log('Playback does not support time-to-segment mapping; cannot load highlight capture plugin.');
      }
    }
  }, {
    key: "_appendForm",
    value: function _appendForm() {
      var _this3 = this;

      this._$form = $(FORM_HTML);

      this._$form.hide();

      this._$form.find('.close').on('click', function () {
        return _this3._onCloseForm();
      });

      this._$form.find('.preview').on('click', function () {
        return _this3._onPreview(_this3._getFormSelections());
      });

      this._$form.find('.save').on('click', function () {
        return _this3._onSave(_this3._getFormSelections());
      });

      this._$form.find('.refresh-start-time').on('click', function (e) {
        return _this3._updateStartTime(e);
      });

      this._$form.find('input,select').on('keydown', function (e) {
        return e.stopPropagation();
      });

      if (this._$form[0]) {
        // Clappr 0.4+
        this.core.mediaControl.$el.append(this._$form[0]);
      } else {
        this.core.mediaControl.$el.append(this._$form);
      }
    }
  }, {
    key: "_appendCameraIcon",
    value: function _appendCameraIcon() {
      var _this4 = this;

      var mc = this.core.mediaControl;
      mc.$('.media-control-right-panel .media-control-icon').last().after(CAMERA_HTML);
      mc.$('.highlight-capture-plugin-camera-container button').click(function (e) {
        return _this4._onCameraClick(e);
      });
    }
  }, {
    key: "_onCameraClick",
    value: function _onCameraClick(e) {
      var playback = this.core.getCurrentPlayback();
      this._wasPlaying = playback.isPlaying();
      this.core.mediaControl.pause();
      this.core.mediaControl.setKeepVisible();

      this._updateStartTime();

      this._$form.show();
    }
  }, {
    key: "_updateStartTime",
    value: function _updateStartTime() {
      var clickedAtTime = this._getCurrentTime();

      this._$form.find('.start-time').val(Object(__WEBPACK_IMPORTED_MODULE_0__app_utils_date__["e" /* secondsToFormattedLabel */])(clickedAtTime));
    }
  }, {
    key: "_onCloseForm",
    value: function _onCloseForm() {
      this._$form.hide();

      this.core.mediaControl.resetKeepVisible();

      if (this._wasPlaying) {
        this.core.getCurrentPlayback().play();
      }
    }
  }]);

  return HighlightCapturePlugin;
}(UICorePlugin);


var CAMERA_HTML = "\n<div class=\"highlight-capture-plugin-camera-container\" style=\"padding: 0; margin-top: 6px;\">\n  <button type=\"button\" class=\"boxcast-clappr-button\">\n    <i class=\"fa fa-camera\" />\n  </button>\n</div>\n";
var FORM_HTML = "\n<div class=\"highlight-form\">\n  <div class=\"close-container\">\n    <i class=\"close fa fa-times-circle\" />\n  </div>\n  <h3>Capture a Highlight</h3>\n  <div style=\"display:flex;\">\n    <div style=\"width:75%;text-align:left;margin-right:10px;\">\n      <div style=\"margin-bottom:10px\">\n        Description<br>\n        <input type=\"text\" class=\"description form-control\" placeholder=\"Enter a name for this clip...\" maxlength=\"255\">\n      </div>\n      <div style=\"display:flex\">\n        <div style=\"margin-right:10px;line-height:32px\">\n          <select class=\"duration form-control\">\n            <option selected value=\"10\">10 sec</option>\n            <option value=\"20\">20 sec</option>\n            <option value=\"30\">30 sec</option>\n            <option value=\"40\">40 sec</option>\n            <option value=\"50\">50 sec</option>\n            <option value=\"60\">60 sec</option>\n            <option value=\"90\">90 sec</option>\n            <option value=\"120\">2 min</option>\n            <option value=\"180\">3 min</option>\n          </select>\n        </div>\n        <div style=\"margin-right:10px;line-height:32px\">\n          <select class=\"duration-relative form-control\">\n            <option selected value=\"-1\">before</option>\n            <option value=\"1\">after</option>\n          </select>\n        </div>\n        <div style=\"line-height:32px;margin-right:10px;\">\n          <input type=\"text\" class=\"start-time form-control\">\n        </div>\n        <div style=\"line-height:32px\">\n          <i class=\"refresh-start-time fa fa-refresh\"></i>\n        </div>\n      </div>\n    </div>\n    <div style=\"width:25%;\">\n      &nbsp;<br>\n      <button class=\"preview btn btn-warning btn-block\">Preview</button>\n      <button class=\"save btn btn-primary btn-block\">Save Highlight</button>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(448);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./highlight-capture-plugin.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./highlight-capture-plugin.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, "[data-player] .highlight-capture-plugin-camera-container {\n  display: inline-block;\n  height: 32px;\n  padding: 9px 12px 0 5px;\n  vertical-align: top; }\n  [data-player] .highlight-capture-plugin-camera-container a {\n    color: #fff;\n    opacity: 1; }\n  [data-player] .highlight-capture-plugin-camera-container a:hover {\n    opacity: 0.8; }\n\n[data-player] i.fa {\n  font: normal normal normal 14px/1 FontAwesome; }\n\n[data-player] .highlight-form {\n  position: relative;\n  z-index: 1;\n  pointer-events: all;\n  background: rgba(0, 0, 0, 0.2);\n  padding: 10px; }\n  [data-player] .highlight-form .close-container {\n    float: right; }\n    [data-player] .highlight-form .close-container i {\n      cursor: pointer;\n      color: #fff;\n      opacity: 1; }\n  [data-player] .highlight-form i.refresh-start-time {\n    cursor: pointer; }\n  [data-player] .highlight-form input,\n  [data-player] .highlight-form select {\n    color: #333; }\n", ""]);

// exports


/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-sm-8\">\n      <h1 style=\"margin-top:0;font-size:16pt;\">{{vm.broadcast.name}}</h1>\n    </div>\n    <div ng-if=\"vm.allowPromote && (vm.broadcast.timeframe != 'past' || vm.recordingIsAvailable)\" class=\"hidden-xs col-sm-4 overflow-ellipse text-right\">\n      <a ng-href=\"{{vm.broadcast.viewer_url}}\" target=\"_blank\">{{vm.broadcast.viewer_url}} <i class=\"fa fa-external-link\"></i></a>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-8 col-lg-9\">\n\n      <div ng-if=\"vm.account.max_simultaneous_streams > 0 && vm.broadcast.is_limited_by_active_stream_count\">\n        <div class=\"bg-warning text-warning\" style=\"border:1px solid;padding:10px;margin-bottom:15px;\">\n          <p>Your account is only able to stream {{ vm.account.max_simultaneous_streams }} simultaneous broadcast{{ vm.account.max_simultaneous_streams != 1 ? 's' : '' }}. This broadcast will start once other broadcasts have ended.</p>\n          <p style=\"margin-bottom:0px\">If you would like to add additional simultaneous broadcasts to your account, please <a href=\"mailto:questions@boxcast.com\" target=\"_blank\">contact customer support</a>.</p>\n        </div>\n      </div>\n\n      <div ng-if=\"vm.broadcastStatus\">\n        <div class=\"well\" style=\"border-bottom:3px solid {{vm.broadcastStatus.status == 'ok' ? 'green' : vm.broadcastStatus.status == 'warning' ? 'orange' : 'red'}};padding:10px;\">\n          <div class=\"clearfix\">\n            <div class=\"col-sm-8 no-padding\">\n              <span style=\"color:#aaa;font-weight:bold;font-size:10pt;\">STATUS</span>&nbsp;\n              <strong>{{vm.broadcastStatus.title}}</strong>\n            </div>\n            <div class=\"col-sm-4 no-padding text-sm-right\">\n              <small>{{vm.broadcastStatus.subtitle}}</small>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div ng-if=\"!vm.preview && !vm.recordingIsBeingUploaded\" style=\"background:#000;\">\n        <!-- NOTE: capping width to avoid a massive height -->\n        <div class=\"cap-player-width-container\">\n          <player-with-highlight-capture\n                broadcast=\"vm.broadcast\"\n                channel-id=\"vm.broadcast.channel_id\"\n                options=\"vm.playerOptions\"\n                parent-vm=\"vm\"\n                on-open-highlight-preview=\"vm.openHighlightPreviewModal\"\n                on-new-highlight-captured=\"vm.onNewHighlightCaptured\"\n                on-open-low-latency-preview=\"vm.openLowLatencyPreview\"\n                ></player-with-highlight-capture>\n        </div>\n      </div>\n      <div ng-if=\"vm.preview\" class=\"low-latency-wrapper\">\n        <!-- NOTE: capping width to avoid a massive height -->\n        <div class=\"cap-player-width-container\">\n          <div class=\"fixed-16-9\">\n            <low-latency-player broadcast=\"vm.broadcast\"></low-latency-player>\n          </div>\n          <button class=\"btn btn-link close-btn\" ng-click=\"vm.preview = false\">&times;</button>\n          <a class=\"label label-info indicator-overlay\" href=\"https://support.boxcast.com/en/articles/4235096-troubleshoot-remotely-using-low-latency-preview\" target=\"_blank\">\n            Low-Latency Preview\n          </a>\n        </div>\n      </div>\n\n      <div ng-if=\"vm.recordingIsBeingUploaded\" style=\"background:#000;\">\n        <div class=\"cap-player-width-container\">\n          <div class=\"fixed-16-9\">\n            <h3 style=\"color:#fff;display:flex;align-items:center;justify-content:center;padding:0 15px;\">\n              <div>\n                <i ng-hide=\"vm.recordingUploadStatus == 'failed'\" class=\"fa fa-spin fa-spinner\" style=\"margin-right:15px\"></i>\n                {{vm.recordingUploadStatusMessage}}\n                <uib-progressbar value=\"vm.recordingUploadProgress\" ng-show=\"vm.recordingUploadProgress > 0\" max=\"100\" style=\"margin-top:15px\">\n                  {{vm.recordingUploadProgress}}% Processed\n                </uib-progressbar>\n                <p ng-show=\"vm.recordingProcessingEstimate\" style=\"font-size:0.6em;margin:15px 0 0 0\">\n                  Estimated time remaining: {{ vm.recordingProcessingEstimate | remainingTime }}\n                </p>\n                <p ng-if=\"vm.recordingUploadStatus == 'failed'\" style=\"font-size:0.6em;margin:15px 0 30px;\">\n                  If you need assistance, <a title=\"Support documentation\" href=\"https://support.boxcast.com/en/articles/4235131\" target=\"_blank\">please review the support documentation</a>.\n                </p>\n                <div class=\"form-group\" ng-if=\"vm.recordingUploadStatus != 'failed'\" style=\"font-size:0.5em;margin:15px 0 0 0\">\n                  <span ng-click=\"vm.emailMeWhenComplete = !vm.emailMeWhenComplete\" style=\"cursor:pointer;opacity:0.8\">\n                    <i class=\"fa\" ng-class=\"vm.emailMeWhenComplete ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n                    Email me when completed\n                  </span>\n                </div>\n              </div>\n            </h3>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row\" ng-if=\"vm.recordingIsBeingReplaced\">\n        <div class=\"col-xs-12\">\n          <div class=\"bg-info text-info\" style=\"padding:15px;border:1px solid;margin-top:15px;\">\n            <i ng-hide=\"vm.recordingUploadStatus == 'failed'\" class=\"fa fa-spin fa-spinner\"></i>\n            {{vm.recordingReplacementStatusMessage}}\n            <uib-progressbar value=\"vm.recordingUploadProgress\" ng-show=\"vm.recordingUploadProgress> 0\" max=\"100\" style=\"margin-top:15px\">\n              {{vm.recordingUploadProgress}}% Processed\n            </uib-progressbar>\n            <p ng-show=\"vm.recordingProcessingEstimate\" style=\"margin:15px 0 0 0\">\n                  Estimated time remaining: {{ vm.recordingProcessingEstimate | remainingTime }}\n                </p>\n            <p ng-if=\"vm.recordingUploadStatus == 'created'\">\n              If the upload has failed, <a href=\"javascript://\" ng-click=\"vm.cancelUpload()\">click here to cancel and try the upload again</a>.\n            </p>\n            <p ng-if=\"vm.recordingUploadStatus == 'failed'\">\n              If you need assistance, <a title=\"Support documentation\" href=\"https://support.boxcast.com/en/articles/4235131\" target=\"_blank\">please review the support documentation</a>.\n            </p>\n            <div class=\"form-group\" ng-if=\"vm.recordingUploadStatus != 'failed'\" style=\"margin:15px 0 0 0\">\n              <span ng-click=\"vm.emailMeWhenComplete = !vm.emailMeWhenComplete\" style=\"cursor:pointer;opacity:0.8\">\n                <i class=\"fa\" ng-class=\"vm.emailMeWhenComplete ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n                Email me when completed\n              </span>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row\" ng-if=\"vm.recordingIsWaitingToBePublished\">\n        <div class=\"col-xs-12\">\n          <div class=\"bg-info text-info\" style=\"padding:15px;border:1px solid;margin-top:15px;\">\n            Congratulations! The broadcast is ready to be published.\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" ng-click=\"vm.edit('publish')\" ng-if=\"::vm.canEdit\"\n              analytics-on analytics-event=\"event-edit\" analytics-category=\"open-modal\" analytics-label=\"\">\n              Publish and Review Settings\n            </button>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <div class=\"well well-with-inline-tabs\" style=\"margin-top:15px\">\n            <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n              <li ng-class=\"!vm.activeTab ? 'active' : ''\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"overview\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('')\">Overview</a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'diagnostics' ? 'active' : ''\" ng-if=\"vm.showDiagnostics\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"diagnostics\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('diagnostics')\">\n                  <i ng-if=\"vm.streamDiagnostics.status\" class=\"fa fa-circle\"\n                    ng-style=\"{color: vm.streamDiagnostics.status=='OK' ? 'green' : vm.streamDiagnostics.status=='Warning' ? 'orange' : vm.streamDiagnostics.status=='Critical' ? 'red' : ''}\">\n                  </i>\n                  Diagnostics\n                </a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'analytics' ? 'active' : ''\" ng-if=\"vm.broadcast.timeframe != 'future'\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"analytics\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('analytics')\">Analytics</a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'scoreboard' ? 'active' : ''\" ng-if=\"vm.enableScoreboardControls\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"scoreboard\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('scoreboard')\">Scoreboard</a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'overlays' ? 'active' : ''\" ng-if=\"vm.allowOverlays && vm.broadcast.timeframe != 'past' && vm.broadcast.stream_source != 'recording' && vm.broadcast.stream_source != 'producer'\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"overlays\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('overlays')\">\n                  <i ng-if=\"vm.activeOverlays.length\" class=\"fa fa-circle\" style=\"color: green;\"></i>\n                  Overlays\n                </a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'captions' ? 'active' : ''\" ng-if=\"vm.showCaptionsTab\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"captions\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('captions')\">\n                  <i ng-if=\"vm.activeLiveAutomatedCaptions\" class=\"fa fa-circle\"\n                    ng-style=\"{color: vm.enableCaptions ? 'green' : 'orange'}\">\n                  </i>\n                  Captions\n                </a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'documents' ? 'active' : ''\" ng-if=\"vm.FeatureFlags.documents && (vm.broadcast.timeframe != 'past' || vm.recordingIsAvailable)\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"documents\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('documents')\">Documents</a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'video_index' ? 'active' : ''\" ng-if=\"vm.FeatureFlags.cue_points && vm.recordingIsAvailable\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"video_index\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('video_index')\">Video Index</a>\n              </li>\n              <li ng-class=\"vm.activeTab == 'viewer_chat' ? 'active' : ''\" ng-if=\"vm.FeatureFlags.viewer_chat\">\n                <a href=\"javascript://\"\n                  analytics-on analytics-category=\"broadcast-details-tab-change\" analytics-event=\"viewer_chat\" analytics-label=\"\"\n                  ng-click=\"vm.changeTab('viewer_chat')\">\n                  <i ng-if=\"vm.showChatStateValue\" class=\"fa fa-circle\" style=\"color: green\"></i>\n                  Chat\n                </a>\n              </li>\n              <li class=\"pull-right\">\n                <a href=\"javascript://\" ng-click=\"vm.edit()\" ng-if=\"::vm.canEdit\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"open-modal\" analytics-label=\"\">\n                  <i class=\"fa fa-pencil\"></i> Edit Broadcast\n                </a>\n              </li>\n            </ol>\n\n            <div ng-show=\"!vm.activeTab\">\n              <broadcast-label-list broadcast=\"vm.broadcast\"></broadcast-label-list>\n              <p style=\"font-size:10pt; white-space:pre-line\">{{vm.broadcast.description}}</p>\n              <p>\n                <date-range start=\"vm.broadcast.starts_at\" end=\"vm.broadcast.stops_at\"></date-range>\n              </p>\n              <p ng-if=\"vm.allowPromote && (vm.broadcast.timeframe != 'past' || vm.recordingIsAvailable)\">\n                <strong>View on BoxCast.tv:</strong><br>\n                <a ng-href=\"{{vm.broadcast.viewer_url}}\" target=\"_blank\">{{vm.broadcast.viewer_url}}<i class=\"fa fa-external-link\" style=\"margin-left: 5px;\"></i></a>\n              </p>\n              <div ng-if=\"vm.broadcast.in_channel_ids.length > 0 || vm.broadcast.tags.length > 0\" style=\"margin-bottom: 10px;\">\n                <strong>Published Channels</strong><br>\n                <ul class=\"list-inline\">\n                  <li ng-repeat=\"channel_id in vm.broadcast.in_channel_ids\">\n                    <a ui-sref=\"channels({id: channel_id})\" class=\"label label-info\">\n                      {{vm.channels | getById:channel_id:'id':'name'}}\n                    </a>\n                  </li>\n                  <li ng-repeat=\"tag in vm.broadcast.tags\">\n                    <span class=\"label label-info\">Tag: {{tag}}</span>\n                  </li>\n                </ul>\n              </div>\n              <div ng-if=\"vm.showHighlights && vm.highlights.length > 0\" style=\"margin-bottom: 10px;\">\n                <strong>Highlight Clips</strong><br>\n                <ul class=\"list-inline\">\n                  <li ng-repeat=\"highlight in vm.highlights track by highlight.id\" class=\"text-center\">\n                    <a href=\"javascript://\" ng-click=\"vm.openHighlight(highlight)\">\n                      <img class=\"img img-thumbnail\" style=\"width:100px\" ng-src=\"{{highlight.preview}}\"><br>\n                      <p class=\"overflow-ellipse\" style=\"width:100px\"><small>{{highlight.name}}</small></p>\n                    </a>\n                  </li>\n                </ul>\n                <div ng-if=\"vm.totalHighlights > vm.highlights.length\" class=\"text-center\" style=\"margin-top:5px;\">\n                  <a\n                    ui-sref=\"events.highlights({id: vm.broadcast.id, recording: vm.broadcast.recording_id})\"\n                    href=\"javascript://\"\n                    style=\"padding-right:50px\">\n                    <small><strong>View all highlights</strong></small>\n                  </a>\n                </div>\n              </div>\n              <div ng-if=\"vm.simulatedLiveBroadcasts.length > 0\" style=\"margin-bottom: 10px;\">\n                <strong>Re-Broadcasts (Simulated Live):</strong><br>\n                <table class=\"table table-condensed table-striped table-hover\">\n                  <thead>\n                    <tr>\n                      <th>Name</th>\n                      <th>Date/Time</th>\n                      <th>Status</th>\n                      <th>Accessibility</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr ng-repeat=\"broadcast in vm.simulatedLiveBroadcasts track by broadcast.id\"\n                        ng-click=\"$state.go('events.detail', {id: broadcast.id})\">\n                      <td>{{broadcast.name}}</td>\n                      <td><date-range start=\"broadcast.starts_at\" end=\"broadcast.stops_at\"></date-range></td>\n                      <td>\n                        <span ng-if=\"broadcast.timeframe == 'past' && broadcast.do_not_record\" class=\"label label-default\">Not Recorded</span>\n                        <span ng-if=\"broadcast.timeframe == 'past' && !broadcast.do_not_record\" class=\"label label-primary\">Recorded</span>\n                        <span ng-if=\"broadcast.timeframe == 'current'\" class=\"label label-success\">Live</span>\n                        <span ng-if=\"broadcast.timeframe == 'preroll' || broadcast.timeframe == 'future'\" class=\"label label-info\">Upcoming</span>\n                      </td>\n                      <td>\n                        <span ng-if=\"broadcast.is_ticketed\" class=\"label label-success\">${{broadcast.ticket_price | number:2}} / ticket</span>\n                        <span ng-if=\"broadcast.is_private\" class=\"label label-danger\">Private</span>\n                        <span ng-if=\"!broadcast.is_ticketed && !broadcast.is_private\" class=\"label label-default\">Public</span>\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div><!-- end overview tab -->\n\n            <div ng-show=\"vm.activeTab == 'diagnostics'\" ng-if=\"vm.showDiagnostics\">\n              <stream-diagnostics ng-if=\"vm.broadcast.id\"\n                                  broadcast=\"vm.broadcast\"\n                                  on-reload=\"vm.onStreamDiagnosticsReload\"\n                                  ></stream-diagnostics>\n            </div><!-- end diagnostics tab -->\n\n            <div ng-if=\"vm.activeTab == 'analytics'\">\n              <broadcast-basic-analytics broadcast=\"vm.broadcast\"></broadcast-basic-analytics>\n            </div><!-- end analyticstab -->\n\n            <div ng-show=\"vm.activeTab == 'scoreboard'\" ng-if=\"vm.enableScoreboardControls && vm.broadcast.id && vm.broadcast.scoreboard_configuration.sport\">\n              <scoreboard-controls broadcast=\"vm.broadcast\" scoreboard=\"vm.broadcast.scoreboard_configuration\"></scoreboard-controls>\n            </div><!-- end scoreboard tab -->\n\n\n            <div ng-show=\"vm.activeTab == 'overlays'\">\n\n              <div style=\"padding:15px; overflow:hidden;\">\n                <div style=\"border:1px solid #aaa\">\n                  <div class=\"fixed-16-9 transparent-grid-bg overlay-canvas draggable-parent resizable-parent\">\n                    <div>\n                      <div ng-repeat=\"o in vm.activeOverlays\">\n                        <overlay-image overlay=\"o\" on-change=\"vm.onOverlayChange\"></overlay-image>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div ng-show=\"vm.overlaysChanged\" class=\"text-center\">\n                <button ng-click=\"vm.discardOverlays()\" ng-disabled=\"vm.overlaysSaving\" class=\"btn btn-default\" type=\"button\">Discard Changes</button>\n                <button ng-click=\"vm.saveOverlays()\" ng-disabled=\"vm.overlaysSaving\" class=\"btn btn-primary\" type=\"button\">\n                  <span ng-hide=\"vm.overlaysSaving\">\n                    Apply Changes\n                  </span>\n                  <span ng-show=\"vm.overlaysSaving\">\n                    <i class=\"fa fa-spin fa-spinner\"></i> Saving...\n                  </span>\n                </button>\n              </div>\n\n              <h4>Overlay Gallery</h4>\n              <div class=\"row overlay-gallery\">\n                <div class=\"col-xs-6 col-sm-4 col-lg-3 text-center\" style=\"margin-bottom:15px\"\n                     ng-repeat=\"u in vm.uploads\">\n                  <div class=\"fixed-16-9 transparent-grid-bg\">\n                    <div class=\"upload-image\"\n                         ng-style=\"{'background-image': 'url(&quot;'+u.view_url+'&quot;)'}\"\n                         ng-class=\"{active: u.__inUse}\"\n                         ng-mouseover=\"u.__showOverlay = true\"\n                         ng-mouseout=\"u.__showOverlay = false\">\n                      <div ng-show=\"u.__showOverlay\" class=\"upload-details\">\n                        <p class=\"overflow-ellipse\">{{u.filename}}</p>\n                        <div ng-if=\"!u.__inUse\" style=\"position:absolute;top:20px;left:0;right:0;\">\n                          <button ng-click=\"vm.addOverlay(u)\" class=\"btn btn-primary\">Add</button>\n                        </div>\n                        <div ng-if=\"!u.__inUse && vm.activeOverlays.length\" style=\"position:absolute;bottom:5px;left:5px\">\n                          <button ng-click=\"vm.addOverlay(u, true)\" class=\"btn btn-xs btn-default\">Replace</button>\n                        </div>\n                        <div ng-if=\"!u.__inUse\" style=\"position:absolute;bottom:5px;right:5px\">\n                          <button ng-click=\"vm.deleteUpload(u)\" class=\"btn btn-xs btn-danger\" title=\"Delete from gallery\"><i class=\"fa fa-trash\"></i></button>\n                        </div>\n                        <div ng-if=\"u.__inUse\" style=\"position:absolute;bottom:5px;right:5px\">\n                          <button ng-click=\"vm.removeOverlay(u)\" class=\"btn btn-xs btn-default\">Remove</button>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"col-xs-6 col-sm-4 col-lg-3\">\n                    <upload-slot ng-model=\"vm.file\"\n                                ng-change=\"vm.uploadOverlay(vm.file)\"\n                                slot-name=\"'overlay'\"\n                                allow-image=\"true\"\n                                allow-video=\"false\"\n                                hide-stock-browse=\"true\"\n                                hide-recent-browse=\"true\"\n                                compact=\"true\"\n                                clear-on-success=\"true\"></upload-slot>\n                </div>\n              </div>\n              <div ng-show=\"vm.uploadsPagination.total > 20\">\n                <uib-pagination total-items=\"vm.uploadsPagination.total\"\n                                items-per-page=\"20\"\n                                max-size=\"10\"\n                                rotate=\"false\"\n                                class=\"pagination-sm\"\n                                ng-model=\"vm.uploadsPagination.current\"\n                                ng-change=\"vm.loadUploadsForPage(vm.uploadsPagination.current)\"></uib-pagination>\n              </div>\n\n              <p class=\"help-block\" style=\"margin-top:30px\"><small>\n                <i class=\"fa fa-info-circle\"></i>\n                Overlays can be used to mix sponsor graphics or full slate messages into your video. Just like\n                scoreboard overlays, these are updated at the same time as other live action at your venue.\n                If you are watching the broadcast above while updating the overlays, remember that the\n                video lags the live data by at least 30 seconds, so expect to see your updated\n                overlays with the same delay.\n              </small></p>\n\n            </div><!-- end overlays tab -->\n\n            <div ng-if=\"vm.activeTab == 'documents'\">\n              <table class=\"table table-striped\" ng-if=\"vm.broadcast.content_settings.documents.length > 0\" style=\"margin-bottom:30px\">\n                <thead>\n                  <tr><th colspan=\"2\">Documents</th></tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"d in vm.broadcast.content_settings.documents\">\n                    <td class=\"text-left\">\n                      <div ng-if=\"!d.__enableEditMode\">\n                        <ol class=\"list-inline\">\n                          <li><a href=\"javascript://\" ng-click=\"d.__enableEditMode = true\"><i class=\"fa fa-pencil-square-o\"></i></a></li>\n                          <li><a target=\"_blank\" href=\"{{::d.url}}\"><i class=\"fa fa-file-pdf-o\"></i></a></li>\n                          <li><strong>{{::d.name}}</strong></li>\n                        </ol>\n                      </div>\n                      <div ng-if=\"d.__enableEditMode\">\n                        <div class=\"row\">\n                          <div class=\"col-sm-8\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"d.name\" placeholder=\"Enter document title\" required>\n                          </div>\n                          <div class=\"col-sm-4 text-sm-right\">\n                            <ol class=\"list-inline\">\n                              <li>\n                                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.editDocument(d)\">Save Changes</button>\n                              </li>\n                              <li>\n                                <button type=\"button\" class=\"btn btn-default\" ng-click=\"d.__enableEditMode = false\">Cancel</button>\n                              </li>\n                            </ol>\n                          </div>\n                        </div>\n                      </div>\n                    </td>\n                    <td align=\"right\" nowrap>\n                      <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.deleteDocument(d)\"><i class=\"fa fa-trash\"></i> Delete</button>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n\n              <div class=\"row\">\n                <div class=\"col-sm-6\">\n                  <upload-slot ng-model=\"vm.newDocumentFile\"\n                               slot-name=\"'document'\"\n                               allow-image=\"false\"\n                               allow-video=\"false\"\n                               hide-stock-browse=\"true\"\n                               hide-recent-browse=\"false\"\n                               compact=\"true\"></upload-slot>\n                </div>\n                <div class=\"col-sm-6\">\n                  <label>Add a Document</label>\n                  <div>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.document.name\" placeholder=\"Document name\" required>\n                    <p class=\"help-block\"><small><i class=\"fa fa-info-circle\"></i> The name should be concise (e.g. Agenda). The name is displayed to viewers in the embedded player.</small></p>\n                  </div>\n                  <div style=\"margin:10px 0\">\n                    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.saveDocument(vm.document, vm.newDocumentFile, true)\">Save Document</button>\n                  </div>\n                </div>\n              </div>\n\n            </div><!--/ Documents -->\n\n\n            <div ng-if=\"vm.activeTab == 'video_index'\">\n              <form role=\"form\">\n                <div class=\"row\">\n                  <div class=\"col-xs-12\">\n                    <div class=\"form-group\" ng-if=\"!vm.isUsingHlsJsOnRecording\">\n                      <p class=\"help-block\">\n                        <small>Video Index entry is not available. Make sure the broadcast has finished recording and that you\n                          are using Chrome or Firefox.</small>\n                      </p>\n                    </div>\n                    <div class=\"form-group\" ng-if=\"vm.isUsingHlsJsOnRecording\">\n                      <label for=\"cueText\">Enter title for a new video index...</label>\n                      <div class=\"input-group\">\n                        <input type=\"text\" class=\"form-control\" id=\"cueText\" ng-model=\"vm.cue.name\" required>\n                        <span class=\"input-group-btn\">\n                          <button ng-click=\"vm.addCue()\" class=\"btn btn-primary btn-block overflow-ellipse\" style=\"width:100px\">\n                            Save\n                          </button>\n                        </span>\n                      </div>\n                      <p class=\"help-block\">\n                        <small>Video indexing allows you to tag individual spots in the broadcast for quick seeking by\n                          viewers.  The point in time is syncronized with the video player above.</small>\n                      </p>\n                    </div>\n                  </div>\n                </div>\n              </form>\n\n              <table class=\"table table-striped\" ng-if=\"vm.broadcast.content_settings.cues.length > 0\">\n                <thead>\n                  <tr><th colspan=\"3\">Video Index</th></tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"c in vm.broadcast.content_settings.cues\">\n                    <td class=\"text-left\" colspan=\"{{c.__enableEditMode ? 2 : 1}}\">\n                      <div ng-if=\"!c.__enableEditMode\">\n                        <strong><small>{{c.name}}</small></strong><br>\n                        <small>{{c.playback_start_time_fmt}}</small>\n                      </div>\n                      <div ng-if=\"c.__enableEditMode\">\n                        <div class=\"row\">\n                          <div class=\"col-xs-12\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"c.name\" placeholder=\"Enter video index title\" required>\n                          </div>\n                        </div>\n                        <div class=\"row\" style=\"margin-top:15px\">\n                          <div class=\"col-sm-3\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"c.playback_start_time_fmt\" required>\n                          </div>\n                          <div class=\"col-sm-9 text-sm-right\">\n                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"c.__enableEditMode = false\">Cancel</button>\n                            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.deleteCue(c)\"><i class=\"fa fa-trash\"></i> Delete</button>\n                            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.editCue(c)\">Save Changes</button>\n                          </div>\n                        </div>\n                      </div>\n                    </td>\n                    <td align=\"right\" nowrap ng-if=\"!c.__enableEditMode\">\n                      <a href=\"javascript://\" ng-click=\"vm.seekCue(c)\"><i class=\"fa fa-play\"></i></a> &nbsp;\n                      <a href=\"javascript://\" ng-click=\"c.__enableEditMode = true\"><i class=\"fa fa-pencil-square-o\"></i></a>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </div><!--/ cues -->\n\n            <div ng-if=\"vm.activeTab == 'captions'\">\n              <div ng-if=\"!vm.caption && vm.broadcast.content_settings.caption_url || vm.publicBroadcast.has_captions\" class=\"bg-warning text-warning\" style=\"padding:10px; border:1px solid; margin: 15px 0\">\n                <h4>This broadcast was captioned with the legacy caption tool.</h4>\n                <p>We are in the process of testing a vastly improved closed captioning workflow.  Please\n                <a href=\"mailto:questions@boxcast.com\">contact support</a> for assistance upgrading this broadcast.</p>\n                <p><a href=\"{{vm.broadcast.content_settings.caption_url || vm.publicView.caption_url}}\" target=\"_blank\">Current WebVTT File</a></p>\n              </div>\n              <div ng-if=\"vm.broadcast.timeframe == 'past' && !vm.recordingIsTranscoded\" class=\"bg-warning text-warning\" style=\"padding:10px; border:1px solid; margin: 15px 0\">\n                <h4>This broadcast cannot be captioned.</h4>\n                <p>\n                  Only fully transcoded recordings are able to be captioned.  If this was an older upload, you may need\n                  to re-upload the video to ensure it is properly processed.\n                </p>\n              </div>\n              <div ng-if=\"vm.broadcast.timeframe == 'past' && vm.recordingIsTranscoded\">\n                <div ng-if=\"vm.loadingCaptions && !vm.caption\">\n                  <p><i class=\"fa fa-spin fa-spinner\"></i> Loading...</p>\n                </div>\n                <div class=\"text-center\" ng-if=\"!vm.loadingCaptions || vm.caption\">\n                  <caption-details broadcast=\"vm.broadcast\"\n                                              caption-meta=\"vm.caption\"\n                                              link-to-editor=\"true\"\n                                              on-create=\"vm.startCaptioning(upload)\"\n                                              on-download=\"vm.downloadCaption(format)\"></caption-details>\n                  <div ng-if=\"vm.captionTranscipt && vm.caption.publish_status != 'unpublished'\" style=\"margin-top:15px\">\n                    <pre class=\"text-xs\" style=\"text-align:left;\">{{::vm.captionTranscipt}}</pre>\n                  </div>\n                </div>\n              </div>\n              <div ng-if=\"vm.broadcast.timeframe == 'preroll' || vm.broadcast.timeframe == 'current'\">\n                <div class=\"row\" style=\"margin-top: 30px\">\n                  <div class=\"col-md-6 col-md-offset-3 text-center\">\n                    <p class=\"help-block\" style=\"font-size:10pt\">\n                      This broadcast is being captioned in real time. You can pause and resume captioning below.\n                    </p>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-xs-12 text-center\">\n                    <toggle-switch ng-model=\"vm.enableCaptionsStateValue\" ng-change=\"vm.updateEnableCaptions()\" label=\"Enable live captioning for this broadcast\"></toggle-switch>\n                  </div>\n                </div>\n              </div>\n            </div><!--/captions-->\n\n            <div ng-if=\"vm.activeTab == 'viewer_chat' && vm.FeatureFlags.viewer_chat\">\n\n              <div class=\"row\" style=\"margin-top: 30px\">\n                <div class=\"col-md-6 col-md-offset-3 text-center\">\n                  <p class=\"help-block\">\n                    <span ng-if=\"vm.account.content_settings.showChat\">\n                      Your account has enabled chat by default on all broadcasts.\n                    </span>\n                    <span ng-if=\"!vm.account.content_settings.showChat\">\n                      Your account has not enabled chat by default for all broadcasts.\n                    </span>\n                    You can override that setting below, or <a href=\"/settings/preferences\">update your account default settings</a>.\n                  </p>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-xs-12 text-center\">\n                  <ol class=\"list-inline\" style=\"line-height: 30px\">\n                    <li>\n                      <toggle-switch ng-model=\"vm.showChatStateValue\" ng-change=\"vm.updateShowChat()\" label=\"Enable chat for this broadcast\"></toggle-switch>\n                    </li>\n                    <li>\n                      <span style=\"border-right:1px solid #ccc; display:inline-block; height: 30px; vertical-align: bottom; margin: 0 15px 0\"></span>\n                    </li>\n                    <li>\n                      <a ng-disabled=\"vm.broadcast.timeframe == 'past'\" class=\"btn btn-primary\" href=\"/events/{{vm.broadcast.id}}/moderate-chat\">Moderate Chat</a>\n                    </li>\n                  </ol>\n                </div>\n              </div>\n            </div><!--/viewer_chat-->\n\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-sm-4 col-lg-3 broadcast-details-right-col\">\n      <!-- start/stop to keep visible at all times -->\n      <div style=\"margin-bottom:30px;\">\n        <table class=\"inner-border-only\" style=\"width:100%;margin:0;\">\n          <tr>\n            <td style=\"padding-left:0\">\n              <h4 style=\"margin:0\">DATE</h4>\n              <strong>{{vm.broadcast.starts_at|date}}</strong>\n            </td>\n            <td>\n              <h4 style=\"margin:0\">START</h4>\n              <strong>{{vm.broadcast.starts_at|date:'shortTime'}}</strong>\n            </td>\n            <td ng-if=\"vm.broadcast.stops_at && !vm.broadcast.stops_at.startsWith('9999-12-31')\">\n              <h4 style=\"margin:0\">STOP</h4>\n              <strong>{{vm.broadcast.stops_at|date:'shortTime'}}</strong>\n            </td>\n          </tr>\n        </table>\n      </div>\n\n      <!-- only show full boxcaster details/status if event isn't already over -->\n      <div ng-if=\"vm.canUsePreview || vm.canEdit && ((vm.broadcast.timeframe == 'preroll') || (vm.broadcast.timeframe == 'current') || (vm.broadcast.stream_source == 'producer' && vm.broadcast.timeframe !== 'past'))\" style=\"margin-bottom:30px;\">\n        <h4 style=\"margin-top:0\">Broadcast Controls</h4>\n        <p>\n          <a ng-href=\"{{ vm.producerBroadcastURL }}\" \n            ng-if=\"vm.canEnterProducer && vm.broadcast.stream_source == 'producer' && vm.broadcast.timeframe !== 'past'\"\n            analytics-on analytics-event=\"enter-producer\" analytics-category=\"enter\" analytics-label=\"\"\n            class=\"btn btn-block btn-lagoon overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-clapperboard\" style=\"width:20px\"></i>\n            Enter Broadcast in Producer\n          </a>\n          <button ng-if=\"vm.canUsePreview\"\n                  ng-click=\"vm.preview = !vm.preview\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"preview\" analytics-label=\"\"\n                  class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-video-camera\" style=\"width:20px\"></i>\n            <span ng-hide=\"vm.preview\">Show Preview</span>\n            <span ng-show=\"vm.preview\">Exit Preview</span>\n          </button>\n          <button ng-if=\"::vm.canEdit\"\n                  ng-show=\"vm.broadcast.timeframe == 'preroll' && vm.broadcast.stream_source !== 'producer'\"\n                  ng-click=\"vm.startASAP()\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"start-asap\" analytics-label=\"\"\n                  class=\"btn btn-block btn-success overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-power-off\" style=\"width:20px\"></i>\n            Start Now\n          </button>\n          <button ng-if=\"::vm.canEdit\"\n                  ng-show=\"vm.broadcast.timeframe == 'current' || vm.broadcast.timeframe == 'preroll'\"\n                  ng-click=\"vm.stop()\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"stop\" analytics-label=\"\"\n                  class=\"btn btn-block btn-danger overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"far fa-stop-circle\" style=\"width:20px\"></i>\n            Stop Broadcast\n          </button>\n        </p>\n      </div>\n\n      <!-- only show recording controls if recording is available and that recording is not an imported MP4 -->\n      <div ng-if=\"vm.showRecordingControls\" style=\"margin-bottom:30px\">\n        <h4 style=\"margin-top:0\">Recording Controls</h4>\n        <p ng-if=\"vm.recordingIsTranscoded\">\n          <a ui-sref=\"events.trim({id: vm.broadcast.id, recording: vm.broadcast.recording_id})\"\n            analytics-on analytics-event=\"event-edit\" analytics-category=\"trim\" analytics-label=\"\"\n            class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-crop\" style=\"width:20px\"></i>\n            Trim Recording\n          </a>\n        </p>\n        <!-- XXX: TODO: make edit highlights not depend on recording ID so we can edit them while still live -->\n        <p ng-if=\"vm.showEditHighlightClips\">\n          <a ui-sref=\"events.highlights({id: vm.broadcast.id, recording: vm.broadcast.recording_id})\"\n            analytics-on analytics-event=\"event-edit\" analytics-category=\"highlight\" analytics-label=\"edit-clips\"\n            class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-camera\" style=\"width:20px\"></i>\n            Edit Highlight Clips\n          </a>\n        </p>\n        <p ng-if=\"vm.canDownloadOrExport\">\n          <button ng-click=\"vm.downloadOrExport()\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"download\" analytics-label=\"\"\n                  class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-download\" style=\"width:20px\"></i>\n            Download or Export Recording\n          </button>\n        </p>\n        <p ng-if=\"vm.showUploadReplacement\">\n          <button ng-click=\"vm.uploadReplacement()\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"upload\" analytics-label=\"\"\n                  class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-upload\" style=\"width:20px\"></i>\n            Upload Replacement Video\n          </button>\n        </p>\n        <p ng-if=\"vm.showReplayViaSimulatedLive\">\n          <button ng-click=\"vm.scheduleSimulatedLive()\"\n                  analytics-on analytics-event=\"event-edit\" analytics-category=\"simulated-live\" analytics-label=\"\"\n                  class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n            <i class=\"fa fa-repeat\" style=\"width:20px\"></i>\n            Re-Broadcast (Simulated Live)\n          </button>\n        </p>\n      </div>\n\n      <!-- only show full boxcaster details/status if broadcast isn't already over -->\n      <div style=\"margin-bottom:30px\">\n        <h4 style=\"margin-top:0\">Source</h4>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'boxcaster'\">\n          <div ng-if=\"vm.broadcast.timeframe == 'past'\">\n            <a href=\"{{vueDashboardRoot}}/sources?boxcaster_id={{vm.broadcast.boxcaster_id}}\" class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n              <i class=\"pull-right fa fa-chevron-right\"></i>\n              BoxCaster {{vm.broadcast.boxcaster_name}}\n            </a>\n          </div>\n          <div ng-if=\"vm.broadcast.timeframe != 'past'\">\n            <button ng-if=\"vm.broadcast.boxcaster_id\"\n                    class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                    ng-click=\"vm.showSourceDetails = !vm.showSourceDetails\">\n              <i class=\"fa fa-circle diagnostics--icon-{{vm.boxCasterStatusLabel}}\" style=\"width:20px\"></i>\n              <i class=\"pull-right fa fa-chevron-{{vm.showSourceDetails?'up':'down'}}\"></i>\n              BoxCaster {{vm.broadcast.boxcaster_name}}\n            </button>\n            <div class=\"destination-details\" ng-show=\"vm.showSourceDetails\">\n              <table class=\"inner-border-only\" style=\"width:100%\">\n                <tr ng-if=\"vm.boxcaster.warning != 'none'\">\n                  <td colspan=\"2\">\n                    <div class=\"bg-warning text-warning text-center\" style=\"padding:5px 3px;border:1px solid;margin:0;\">\n                      <strong>{{vm.boxcaster.warning | unslugify}}</strong>\n                    </div>\n                  </td>\n                </tr>\n                <tr ng-if=\"vm.boxcaster.status == 'broadcasting' && vm.boxcaster.next_broadcast_id && vm.boxcaster.next_broadcast_id != vm.broadcast.id\">\n                  <td colspan=\"2\">\n                    <div class=\"bg-warning text-warning text-center\" style=\"padding:5px 3px;border:1px solid;margin:0;\">\n                      Broadcasting Another Broadcast<br>\n                      <a ui-sref=\"events.detail({id: vm.boxcaster.next_broadcast_id})\">{{vm.boxcaster.next_broadcast_name}}</a>\n                    </div>\n                  </td>\n                </tr>\n                <tr>\n                  <td colspan=\"{{vm.broadcast.timeframe != 'future' ? 1 : 2}}\" valign=\"top\">\n                    Status<br>\n                    <strong>{{vm.boxcaster.status | unslugify}}</strong>\n                  </td>\n                  <td ng-if=\"vm.broadcast.timeframe != 'future'\" valign=\"top\">\n                    Video Source<br>\n                    <strong>{{vm.videoInputName || '-'}}</strong>\n                  </td>\n                </tr>\n                <tr ng-if=\"vm.broadcast.timeframe != 'future'\">\n                  <td ng-class=\"(vm.lockedInputMismatchWarning ? 'text-warning bg-warning' : '')\" valign=\"top\">\n                    Video Input<br>\n                    <strong ng-hide=\"vm.lockedInputMismatchWarning\">{{vm.videoInputStandard || '-'}}</strong>\n                    <strong ng-show=\"vm.lockedInputMismatchWarning\">\n                      Need: {{vm.streamDiagnostics.locked_standard || '-'}}<br>\n                      Currently: {{vm.videoInputStandard || '-'}}\n                    </strong>\n                  </td>\n                  <td valign=\"top\">\n                    Streaming Profile<br>\n                    <strong>\n                      {{vm.streamingProfileName || '-'}}\n                    </strong>\n                    <span ng-if=\"vm.broadcast.actual_high_frame_rate === true\">\n                      (up to 60 FPS)\n                    </span>\n                  </td>\n                </tr>\n                <tr ng-if=\"!vm.streamingProfileMatchesVideoInput\" class=\"text-center\">\n                  <td colspan=\"2\">\n                    <a href=\"https://support.boxcast.com/en/articles/4235058\" target=\"_blank\">Why are these different? <i class=\"fa fa-external-link\"></i></a>\n                  </td>\n                </tr>\n                <tr>\n                  <td colspan=\"2\">\n                    WAN IP Address<br>\n                    <strong>{{vm.boxcaster.last_seen_ip || '-'}}</strong>\n                  </td>\n                </tr>\n                <tr>\n                  <td colspan=\"2\">\n                    <p style=\"margin-bottom:0;text-align:center\">\n                      <a href=\"{{vueDashboardRoot}}/sources?boxcaster_id={{vm.broadcast.boxcaster_id}}\">BoxCaster Settings</a>\n                    </p>\n                  </td>\n                </tr>\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'rtmp'\">\n          <div ng-if=\"vm.broadcast.timeframe == 'past'\">\n            <div ng-if=\"vm.broadcast.static_rtmp_name && vm.broadcast.static_rtmp_id\">\n              <a  href=\"{{vueDashboardRoot}}/sources?static_rtmp_id={{vm.broadcast.static_rtmp_id}}\" class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n                <i class=\"pull-right fa fa-chevron-right\"></i>\n                {{vm.broadcast.static_rtmp_name}}\n              </a>\n            </div>\n            <div ng-if=\"vm.broadcast.static_rtmp_name && !vm.broadcast.static_rtmp_id\">\n              <strong>{{vm.broadcast.static_rtmp_name}}</strong>\n            </div>\n            <div ng-if=\"!vm.broadcast.static_rtmp_name\">\n              <strong>Single-Use RTMP</strong>\n            </div>\n          </div>\n          <div ng-if=\"vm.broadcast.timeframe != 'past'\">\n            <button ng-if=\"vm.showRtmpConfig && vm.isTriCaster\"\n                    ng-click=\"vm.tricaster()\"\n                    class=\"btn btn-block btn-primary overflow-ellipse\" style=\"text-align:left\">\n              <i class=\"fa fa-cog\" style=\"width:20px\"></i>\n              Broadcast From TriCaster\n            </button>\n            <button ng-if=\"vm.showRtmpConfig && !vm.isTriCaster && !vm.broadcast.static_rtmp_name\"\n                    class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                    ng-click=\"vm.showSourceDetails = !vm.showSourceDetails\">\n              <i class=\"pull-right fa fa-chevron-{{vm.showSourceDetails?'up':'down'}}\"></i>\n              <i class=\"fa fa-cog\" style=\"width:20px\"></i>\n              RTMP Encoder Settings\n            </button>\n            <button ng-if=\"vm.showRtmpConfig && !vm.isTriCaster && vm.broadcast.static_rtmp_name\"\n                    class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                    ng-click=\"vm.showSourceDetails = !vm.showSourceDetails\">\n              <i class=\"fa fa-circle diagnostics--icon-{{vm.staticRTMPStatusLabel}}\" style=\"width:20px\"></i>\n              <i class=\"pull-right fa fa-chevron-{{vm.showSourceDetails?'up':'down'}}\"></i>\n              {{vm.broadcast.static_rtmp_name}}\n            </button>\n            <div class=\"destination-details\" ng-show=\"vm.showSourceDetails\">\n              <table class=\"inner-border-only\" style=\"width:100%;table-layout:fixed;overflow:hidden;\">\n                <tr>\n                  <td colspan=\"2\" valign=\"top\">\n                    Server URL and Stream Key<br>\n                    <div style=\"position:relative;\">\n                      <strong title=\"{{vm.broadcast.rtmp_ingestion_url || '-'}}\" style=\"display:inline-block;max-width:90%;word-wrap: break-word;\">\n                        {{vm.broadcast.rtmp_ingestion_url || '-'}}\n                      </strong>\n                      <span ng-if=\"$root.clipboard.supported\" style=\"position:absolute;right:0;top:0;\">\n                        <a href=\"javascript://\"\n                          clipboard\n                          text=\"vm.broadcast.rtmp_ingestion_url\"\n                          on-copied=\"$root.toaster.pop('success', 'Successfully copied')\"\n                          on-error=\"$root.toaster.pop('warning', 'Could not be copied')\">\n                          <i class=\"fa fa-copy\"></i>\n                        </a>\n                      </span>\n                    </div>\n                  </td>\n                </tr>\n                <tr ng-if=\"vm.broadcast.static_rtmp_name\">\n                  <td valign=\"top\">\n                    Status<br>\n                    <strong>{{vm.staticRTMPStatus}}</strong>\n                  </td>\n                  <td valign=\"top\">\n                    Video Input<br>\n                    <strong>{{vm.staticRTMPVideoInput || '-'}}</strong>\n                  </td>\n                </tr>\n                <tr ng-if=\"vm.broadcast.timeframe != 'future'\">\n                  <td valign=\"top\">\n                    Video Parameters<br>\n                    <strong>\n                      {{vm.rtmpVideoParams.width}}x{{vm.rtmpVideoParams.height}},\n                      {{vm.rtmpVideoParams.framerate}} FPS\n                    </strong>\n                  </td>\n                  <td valign=\"top\">\n                    Streaming Profile<br>\n                    <strong>\n                      {{vm.streamingProfileName || '-'}}\n                    </strong>\n                    <span ng-if=\"vm.broadcast.actual_high_frame_rate === false\">\n                      (up to 30 FPS)\n                    </span>\n                    <span ng-if=\"vm.broadcast.actual_high_frame_rate === true\">\n                      (up to 60 FPS)\n                    </span>\n                  </td>\n                </tr>\n                <tr>\n                  <td colspan=\"2\" valign=\"top\" class=\"text-center\">\n                    <a href=\"javascript://\" ng-click=\"vm.rtmp()\">Show Full RTMP Settings</a>\n                  </td>\n                </tr>\n                <tr>\n                  <td colspan=\"2\" valign=\"top\" class=\"text-center\">\n                    <a href=\"https://support.boxcast.com/en/articles/4235181\" target=\"_blank\">RTMP Help <i class=\"fa fa-external-link\"></i></a>\n                  </td>\n                </tr>\n              </table>\n            </div>\n            <div ng-if=\"!vm.showRtmpConfig\">\n              <strong>RTMP Encoder Settings Not Yet Available</strong>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'app'\">\n          <div ng-if=\"vm.broadcast.timeframe == 'past'\">\n            <a href=\"{{vueDashboardRoot}}/sources?broadcaster_app=true\" class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\">\n              <i class=\"pull-right fa fa-chevron-right\"></i>\n              Broadcaster App\n            </a>\n          </div>\n          <div ng-if=\"vm.broadcast.timeframe != 'past'\">\n            <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                    ng-click=\"vm.showSourceDetails = !vm.showSourceDetails\">\n              <i class=\"pull-right fa fa-chevron-{{vm.showSourceDetails?'up':'down'}}\"></i>\n              Broadcaster App\n            </button>\n            <div class=\"destination-details\" ng-show=\"vm.showSourceDetails\">\n              <table class=\"inner-border-only\" style=\"width:100%\">\n                <tr>\n                  <td valign=\"top\">\n                    Streaming Profile<br>\n                    <strong>\n                      {{vm.streamingProfileName || '-'}}\n                    </strong>\n                    <span ng-if=\"vm.broadcast.actual_high_frame_rate === true\">\n                      (up to 60 FPS)\n                    </span>\n                  </td>\n                </tr>\n                <tr>\n                  <td valign=\"top\">\n                    <a href=\"https://support.boxcast.com/en/articles/4235049\" target=\"_blank\">Help using Broadcaster <i class=\"fa fa-external-link\"></i></a>\n                  </td>\n                </tr>\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'switcher'\">\n          <strong>Switcher Studio</strong>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'imported'\">\n          <strong>Imported File</strong>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'recording'\">\n          <a ng-if=\"!vm.sourceBroadcastUnavailable && vm.sourceBroadcast\"\n             ui-sref=\"events.detail({id: vm.broadcast.source_broadcast_id})\"\n             class=\"btn btn-block btn-default\"\n             style=\"text-align:left\">\n            <recording-source-chooser-preview broadcast=\"vm.sourceBroadcast\"></recording-source-chooser-preview>\n          </a>\n          <div ng-if=\"!vm.sourceBroadcastUnavailable && !vm.sourceBroadcast\"><i class=\"fa fa-spin fa-spinner\"></i> Re-Broadcast (Simulated Live)</div>\n          <div ng-if=\"vm.sourceBroadcastUnavailable\" class=\"btn btn-block btn-default\" style=\"text-align: left; cursor: default; pointer-events: none;\">\n            <i class=\"fa fa-repeat\"></i> Re-Broadcast (Simulated Live)\n          </div>\n        </div>\n\n        <div ng-if=\"vm.broadcast.stream_source == 'producer'\">\n          <strong>Producer (Browser-based streaming)</strong>\n        </div>\n\n      </div>\n\n      <!-- used to only show destination for non-past, but let's keep them around -->\n      <div ng-if=\"!vm.broadcast.is_ticketed && vm.broadcast.simulcast_configurations.length\" style=\"margin-bottom:30px\">\n        <h4 style=\"margin-top:0\">Destinations</h4>\n\n        <div ng-repeat=\"s in vm.broadcast.simulcast_configurations\" style=\"margin-bottom:10px\">\n          <div ng-switch=\"s.destination\">\n            <div ng-switch-when=\"facebook\">\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                      ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i ng-if=\"vm.broadcast.timeframe != 'past'\" class=\"fa fa-circle diagnostics--icon-{{vm.diagnosticsIconStyle(s, $index)}}\" style=\"width:20px\"></i>\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">Facebook</span>\n                <span class=\"body-3 text-muted\">{{s.fb_user_name}}</span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <p class=\"help-block\" ng-show=\"vm.broadcast.timeframe == 'future' && !s.fb_id && vm.canCreateFacebookLiveScheduledEvent\">\n                  BoxCast will automatically create the Facebook Live event on the linked\n                  account at the time of the broadcast. Want to create a scheduled live post?\n                  <span ng-hide=\"s.__updating\">\n                    <br><a href analytics-on analytics-event=\"create-scheduled-fb\" analytics-category=\"destinations\" ng-click=\"vm.createFacebookLiveScheduledEvent(s)\">Create the scheduled live event now</a>.\n                  </span>\n                  <span ng-show=\"s.__updating\">\n                    <br><i class=\"fa fa-spin fa-spinner\"></i> Scheduling live event...\n                  </span>\n                </p>\n                <p class=\"help-block\" ng-show=\"vm.broadcast.timeframe == 'future' && !s.fb_id && !vm.canCreateFacebookLiveScheduledEvent\">\n                  BoxCast will automatically create the Facebook Live event on the linked\n                  account at the time of the broadcast. Want to create a scheduled live post? Return here within 7\n                  days of the broadcast start date to schedule the live broadcast.\n                </p>\n                <p>\n                  Streaming Status:<br>\n                  <strong>{{s.status | simulcastStatus}}</strong>\n                  <div ng-if=\"s.status === 'error' && s.fb_status\" class=\"bg-danger text-danger\" style=\"padding:10px; margin:10px 0;border:1px solid\">\n                    {{s.fb_status}}\n                  </div>\n                </p>\n                <p ng-if=\"vm.broadcast.timeframe != 'past' && vm.activeDestinationStatus[$index]\">\n                  Last Detected Frame Rate:<br>\n                  <strong>{{vm.activeDestinationStatus[$index].fps}} FPS</strong>\n                </p>\n                <p>\n                  Linked to Account:<br>\n                  <strong>{{s.fb_user_name}}</strong>\n                  <span ng-if=\"s.fb_feed_id == 'user:me'\">(to timeline)</span>\n                  <span ng-if=\"s.fb_feed_id != 'user:me'\">\n                    <a href=\"https://www.facebook.com/{{vm.facebookLiveSimulcastFeedID(s)}}\" target=\"_blank\">\n                      (to {{ vm.facebookLiveSimulcastFeedType(s) }} ID {{ vm.facebookLiveSimulcastFeedID(s) }})\n                      <i class=\"fa fa-external-link\"></i>\n                    </a>\n                  </span>\n                </p>\n                <p style=\"margin-bottom:0\">Links:</p>\n                <ul>\n                  <li><a ui-sref=\"settings.facebook\">BoxCast Facebook Account Settings</a></li>\n                  <li ng-if=\"vm.canShowFacebookLiveProducerURL(s)\">\n                    <a ng-href=\"{{s.live_producer_url}}\" target=\"_blank\">Facebook Live Producer</a>\n                    <i class=\"fa fa-question-circle\" uib-tooltip=\"Facebook Live Producer can give you more information about your stream. Be careful not change any settings, as they have already been configured by BoxCast.\"></i>\n                  </li>\n                  <li ng-if=\"vm.canShowFacebookPermalinkURL(s)\"><a ng-href=\"{{s.permalink_url}}\" target=\"_blank\">Facebook Video Page</a></li>\n                </ul>\n              </div>\n            </div>\n            <div ng-switch-when=\"youtube\">\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                      ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i ng-if=\"vm.broadcast.timeframe != 'past'\" class=\"fa fa-circle diagnostics--icon-{{vm.activeDestinationStatus[$index].connected ? 'connected' : ''}}\" style=\"width:20px\"></i>\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">YouTube</span>\n                <span class=\"body-3 text-muted\"> - {{s.youtube_display_name}}</span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <div ng-if=\"!s.youtube_broadcast_id\">\n                  <p class=\"help-block\" ng-show=\"vm.broadcast.timeframe == 'past'\">\n                    It appears that the YouTube Live simulcast was not properly linked.\n                  </p>\n                  <p class=\"help-block\" ng-show=\"vm.broadcast.timeframe == 'future'\">\n                    BoxCast will automatically create the YouTube Live event on the linked\n                    account at the time of the broadcast. Need the watch URL prior to the start of the broadcast?\n                    <span ng-hide=\"s.__updating\">\n                      <br><a analytics-on analytics-event=\"create-scheduled-yt\" analytics-category=\"destinations\" href ng-click=\"vm.createYouTubeEvent(s)\">Create the YouTube event now</a>.\n                    </span>\n                    <span ng-show=\"s.__updating\">\n                      <br><i class=\"fa fa-spin fa-spinner\"></i> Scheduling live event...\n                    </span>\n                  </p>\n                </div>\n                <div ng-if=\"s.youtube_broadcast_id || vm.broadcast.timeframe == 'current' || vm.broadcast.timeframe == 'preroll'\">\n                  <p>\n                    Streaming Status:<br>\n                    <strong>{{s.status | simulcastStatus}}</strong>\n                    <div ng-if=\"s.youtube_error\" class=\"bg-danger text-danger\" style=\"padding:10px; margin:10px 0;border:1px solid\">\n                      {{s.youtube_error}}\n                    </div>\n                  </p>\n                  <p ng-if=\"vm.broadcast.timeframe != 'past' && vm.activeDestinationStatus[$index]\">\n                    Last Detected Frame Rate:<br>\n                    <strong>{{vm.activeDestinationStatus[$index].fps}} FPS</strong>\n                  </p>\n                  <p>\n                    Linked to Account:<br>\n                    <strong>{{s.youtube_display_name}}</strong>\n                  </p>\n                  <p style=\"margin-bottom:0\">Links:</p>\n                  <ul>\n                    <li><a ui-sref=\"settings.youtube\">BoxCast YouTube Account Settings</a></li>\n                    <li ng-show=\"s.youtube_broadcast_id\">\n                      <a ng-href=\"https://www.youtube.com/live_event_analytics?v={{s.youtube_broadcast_id}}\"\n                         target=\"_blank\">YouTube Live Control Room</a>\n                    </li>\n                    <li ng-show=\"s.youtube_broadcast_id\">\n                      <a ng-href=\"{{vm.youtubeWatchUrl(s)}}\" target=\"_blank\">YouTube Watch Page</a>\n                    </li>\n                  </ul>\n                  <div class=\"fixed-16-9\" style=\"margin-left:-10px;margin-right:-10px;margin-bottom:-5px;\">\n                    <iframe ng-if=\"s.youtube_broadcast_id\"\n                            ng-src=\"{{vm.youtubeEmbedUrl(s)}}\"\n                            frameborder=\"0\" allowfullscreen></iframe>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div ng-switch-when=\"periscope\">\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                      ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">Periscope</span>\n                <span class=\"body-3 text-muted\">{{s.periscope_display_name}}</span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <div ng-if=\"!s.share_url\">\n                  <p class=\"help-block\">\n                    It appears that the Periscope simulcast was not properly linked.\n                  </p>\n                </div>\n                <div ng-if=\"s.share_url\">\n                  <p>\n                    Linked to Account:<br>\n                    <strong>{{s.periscope_display_name}}</strong>\n                  </p>\n                  <p style=\"margin-bottom:0\">Links:</p>\n                  <ul>\n                    <li ng-show=\"s.share_url\">\n                      <a ng-href=\"{{vm.periscopeWatchUrl(s)}}\" target=\"_blank\">Watch on pscp.tv</a>\n                    </li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div ng-switch-when=\"rtmp_push_channel\">\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                      ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i ng-if=\"vm.broadcast.timeframe != 'past'\" class=\"fa fa-circle diagnostics--icon-{{vm.activeDestinationStatus[$index].connected ? 'connected' : ''}}\" style=\"width:20px\"></i>\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">RTMP</span>\n                <span class=\"body-3 text-muted\"> - {{s.name}} <small>({{vm.sanitizeRTMPURL(s.stream_url)}})</small></span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <p class=\"mb-0 mt-base\">Simulcasting to RTMP Destination:</p>\n                <p class=\"font-bold mb-base\">{{s.name}}</p>\n                <p class=\"mb-0\">Stream URL:</p>\n                <p class=\"font-bold\">{{vm.sanitizeRTMPURL(s.stream_url)}}</p>\n\n                <p ng-if=\"vm.broadcast.timeframe != 'past' && vm.activeDestinationStatus[$index]\">\n                  Last Detected Frame Rate:<br>\n                  <strong>{{vm.activeDestinationStatus[$index].fps}} FPS</strong>\n                </p>\n                <p></p>\n              </div>\n            </div>\n            <div ng-switch-when=\"twitter\">\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i ng-if=\"vm.broadcast.timeframe != 'past'\"\n                  class=\"fa fa-circle diagnostics--icon-{{vm.activeDestinationStatus[$index].connected ? 'connected' : ''}}\"\n                  style=\"width:20px\"></i>\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">Twitter</span>\n                <span class=\"body-3 text-muted\">{{s.twitter_display_name}}</span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <div ng-if=\"!s.share_url\">\n                  <p class=\"help-block mt-base\" ng-show=\"vm.broadcast.timeframe == 'past'\">\n                    It appears that the Twitter simulcast was not properly linked.\n                  </p>\n                  <p class=\"help-block\" ng-show=\"vm.broadcast.timeframe == 'future'\">\n                    BoxCast will automatically create the Twitter event on the linked account at\n                    the time of the broadcast.\n                  </p>\n                </div>\n                <div ng-if=\"s.share_url || vm.broadcast.timeframe == 'current' || vm.broadcast.timeframe == 'preroll'\">\n                  <p class=\"mt-base\">\n                    Streaming Status:<br>\n                    <strong>{{s.status | simulcastStatus}}</strong>\n                  </p>\n                  <p ng-if=\"vm.broadcast.timeframe != 'past' && vm.activeDestinationStatus[$index]\">\n                    Last Detected Frame Rate:<br>\n                    <strong>{{vm.activeDestinationStatus[$index].fps}} FPS</strong>\n                  </p>\n                  <p>\n                    Linked to Account:<br>\n                    <strong>{{s.twitter_display_name}}</strong>\n                  </p>\n                  <p style=\"margin-bottom:0\">Links:</p>\n                  <ul>\n                    <li><a ui-sref=\"settings.twitter\">BoxCast Twitter Account Settings</a></li>\n                    <li ng-show=\"s.share_url\">\n                      <a ng-href=\"{{vm.twitterWatchUrl(s)}}\" target=\"_blank\">Watch on Twitter</a>\n                    </li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div ng-switch-default>\n              <button class=\"btn btn-block btn-default overflow-ellipse\" style=\"text-align:left\"\n                      ng-click=\"vm.toggleActiveDestinationDetails($index)\">\n                <i ng-if=\"vm.broadcast.timeframe != 'past'\" class=\"fa fa-circle diagnostics--icon-{{vm.activeDestinationStatus[$index].connected ? 'connected' : ''}}\" style=\"width:20px\"></i>\n                <i class=\"pull-right fa fa-chevron-{{vm.activeDestinationDetails[$index]?'up':'down'}}\"></i>\n                <span class=\"font-medium\">Custom RTMP</span>\n                <span class=\"body-3 text-muted\"> - {{s.stream_url}}</span>\n              </button>\n              <div class=\"destination-details\" ng-if=\"vm.activeDestinationDetails[$index]\">\n                <p class=\"mt-base\">\n                  Simulcasting to Stream URL:<br>\n                  <strong>{{s.stream_url}}</strong>\n                  <!--{{s.stream_key}}-->\n                </p>\n                <p ng-if=\"vm.broadcast.timeframe != 'past' && vm.activeDestinationStatus[$index]\">\n                  Last Detected Frame Rate:<br>\n                  <strong>{{vm.activeDestinationStatus[$index].fps}} FPS</strong>\n                </p>\n                <p></p>\n              </div>\n            </div>\n          </div>\n        </div>\n\n      </div>\n\n\n      <div ng-if=\"vm.broadcast.timeframe != 'future'\" style=\"margin-bottom:30px;\">\n        <h4 style=\"margin-top:0\">\n          Analytics Summary\n        </h4>\n        <div style=\"background:#fff;border:1px solid #ccc;border-radius:4px;padding:10px;\">\n          <table style=\"width:100%\" class=\"text-left\">\n            <tr class=\"font-medium text-xs text-bx-accessible-grey\">\n              <td style=\"width:33%\">ACTIVE</td>\n              <td style=\"width:33%\" ng-if=\"::vm.hasAnalyticsFeature\">PEAK</td>\n              <td style=\"width:33%\">TOTAL VIEWS</td>\n            </tr>\n            <tr style=\"font-weight:bold;font-size:1.6em\">\n              <td>{{vm.broadcast.total_active_viewer_count|number}}</td>\n              <td ng-if=\"::vm.hasAnalyticsFeature\">{{vm.broadcast.peak_active_viewer_count|number}}</td>\n              <td>{{vm.broadcast.total_view_count|number}}</td>\n            </tr>\n          </table>\n        </div>\n      </div>\n\n      <div ng-if=\"vm.broadcast.is_ticketed || vm.broadcast.sold_ticket_count > 0\">\n        <h4 style=\"margin-top:0\">\n          Ticketing\n        </h4>\n        <div style=\"background:#fff;border:1px solid #ccc;border-radius:4px;padding:10px;margin-bottom:30px;\">\n          <table style=\"width:100%\" class=\"text-left\">\n            <tr style=\"border-bottom:1px solid #eee;font-weight:bold;\">\n              <td class=\"text-bx-accessible-grey\" style=\"padding-bottom:10px;\">TICKET PRICE</td>\n              <td style=\"padding-bottom:10px;\">\n                {{vm.broadcast.ticket_price|currency}}\n                <a href=\"javascript://\" ng-click=\"vm.edit('publish')\" ng-if=\"::vm.canEdit\" class=\"action-link\" style=\"color:#333;\"><i class=\"fa fa-pencil\"></i></a>\n              </td>\n            </tr>\n            <tr style=\"font-weight:bold;\">\n              <td class=\"text-bx-accessible-grey\" style=\"width:50%;padding-top:10px;\">TICKETS SOLD</td>\n              <td class=\"text-bx-accessible-grey\" style=\"width:50%;padding-top:10px;\">TICKET REVENUE</td>\n            </tr>\n            <tr style=\"font-weight:bold;font-size:1.6em;border-bottom:1px solid #eee\">\n              <td>{{vm.broadcast.sold_ticket_count|number:0}}</td>\n              <td>${{vm.broadcast.sold_ticket_total|number:2}}</td>\n            </tr>\n            <tr>\n              <td colspan=\"2\" style=\"padding-top:10px\">\n                <a ui-sref=\"reports.tickets({report: 'broadcasts', id: vm.broadcast.id})\" class=\"btn btn-sm btn-block btn-default\" style=\"text-align:left;\">\n                  <i class=\"fa fa-ticket\"></i> Ticket Report\n                </a>\n              </td>\n            </tr>\n            <tr ng-repeat=\"channel_id in vm.broadcast.in_channel_ids\"\n                ng-if=\"::vm.channelMap[channel_id].ticket_price\">\n              <td colspan=\"2\" style=\"padding-top:5px;\">\n                <a ui-sref=\"reports.tickets({report: 'channels', id: channel_id})\" class=\"btn btn-sm btn-block btn-default\" style=\"text-align:left;height:auto;white-space:initial;\">\n                  <i class=\"fa fa-ticket\"></i> Ticket Report: {{::vm.channelMap[channel_id].name}}\n                </a>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n\n      <div ng-if=\"(vm.allowPromote || vm.allowEmbed) && (vm.broadcast.timeframe != 'past' || vm.recordingIsAvailable)\">\n        <h4 style=\"margin-top:0\">Promote this Broadcast</h4>\n        <div class=\"text-center\">\n          <ul class=\"list-inline\">\n            <li ng-if=\"vm.allowPromote\">\n              <a class=\"btn btn-primary\" href=\"{{vm.emailLink}}\"\n                analytics-on analytics-event=\"event-promote\" analytics-category=\"email\" analytics-label=\"\"\n                uib-tooltip=\"Email event invitation\" tooltip-placement=\"bottom\">\n                <i class=\"fa fa-envelope\" style=\"width:20px\"></i>\n              </a>\n            </li>\n            <li ng-if=\"vm.allowSocial\">\n              <button class=\"btn btn-primary\"\n                      ng-click=\"vm.tweet()\"\n                      analytics-on analytics-event=\"event-promote\" analytics-category=\"tweet\" analytics-label=\"\"\n                      uib-tooltip=\"Tweet a link to your Twitter followers\" tooltip-placement=\"bottom\">\n                <i class=\"fa fa-twitter\" style=\"width:20px\"></i>\n              </button>\n            </li>\n            <li ng-if=\"vm.allowSocial\">\n              <button class=\"btn btn-primary\"\n                      ng-click=\"vm.facebook()\"\n                      analytics-on analytics-event=\"event-promote\" analytics-category=\"facebook\" analytics-label=\"\"\n                      uib-tooltip=\"Post a link on your Facebook timeline\" tooltip-placement=\"bottom\">\n                <i class=\"fa fa-facebook\" style=\"width:20px\"></i>\n              </button>\n            </li>\n            <li ng-if=\"vm.allowEmbed\">\n              <button class=\"btn btn-primary\"\n                      ng-click=\"vm.embed()\"\n                      analytics-on analytics-event=\"event-promote\" analytics-category=\"embed\" analytics-label=\"\"\n                      uib-tooltip=\"Embed this event on your web site\" tooltip-placement=\"bottom\">\n                <i class=\"fa fa-code\" style=\"width:20px\"></i>\n              </button>\n            </li>\n            <li ng-if=\"vm.allowPromote && clipboard.supported\">\n              <button class=\"btn btn-primary\"\n                clipboard\n                text=\"vm.broadcast.viewer_url\"\n                on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n                on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n                analytics-on analytics-event=\"event-promote\" analytics-category=\"copy\" analytics-label=\"\"\n                uib-tooltip=\"Copy the BoxCast.tv event link to your clipboard\" tooltip-placement=\"bottom\">\n                <i class=\"fa fa-copy\" style=\"width:20px\"></i>\n              </button>\n            </li>\n          </ul>\n        </div>\n      </div>\n\n    </div>\n  </main>\n"

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n\n    <form id=\"recording-form\" name=\"form\" role=\"form\">\n\n      <div class=\"col-sm-12\">\n        <a ui-sref=\"events.detail({id: vm.broadcast.id})\" class=\"btn btn-default\">\n          <i class=\"fa fa-caret-left\"></i>\n          Back to Broadcast Details\n        </a>\n      </div>\n\n      <div class=\"col-sm-12\">\n        <h3>Adjust Start/Stop Times</h3>\n      </div>\n\n      <div class=\"col-sm-12\">\n        <recording-trimmer broadcast-id=\"vm.broadcast.id\"\n                           recording-id=\"vm.recording.id\"\n                           on-change-bounds=\"vm.onChangeBounds\"></recording-trimmer>\n      </div>\n\n      <div class=\"col-sm-12\">\n        <div class=\"form-group text-center\">\n          <a ui-sref=\"events.detail({id: vm.broadcast.id})\" class=\"btn btn-default\">\n            Cancel\n          </a>\n          <button class=\"btn btn-primary\" ng-click=\"vm.showPreviewModal()\">\n            Preview Trimmed Recording\n          </button>\n          <button ng-click=\"vm.saveChanges()\"\n                  ng-disabled=\"!form.$valid || vm.isSaving\"\n                  class=\"btn btn-success\">\n            <i ng-show=\"vm.isSaving\" class=\"fa fa-cog fa-spin\"></i>\n            Save Trimmed Recording\n          </button>\n        </div>\n      </div>\n\n      <div class=\"col-sm-12\">\n        <p class=\"help-block\"><i class=\"fa fa-question-circle\"></i> Drag the tall yellow bars below the video to trim any unnecessary\n        content from the beginning or end of the recording (the area inside the yellow indicates how much of the video is kept).\n        Then drag the red circle to scrub through the trimmed video as a quick preview. When you are finished, you\n        can preview the video and then Save the trimmed recording.</p>\n      </div>\n\n    </form>\n  </div>\n</main>\n"

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <a ui-sref=\"events.detail({id: vm.broadcast.id})\" class=\"btn btn-default\">\n        <i class=\"fa fa-caret-left\"></i>\n        Back to Broadcast Details\n      </a>\n      <button ng-click=\"vm.showCaptureModal()\" class=\"btn btn-success pull-right\">\n        Capture New Highlight\n      </button>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h3>Highlight Clips for {{vm.broadcast.name}}</h3>\n      <p ng-if=\"vm.highlights.length == 0\">\n        <em>There are no highlights currently captured.</em>\n      </p>\n      <div ng-if=\"vm.highlights.length\">\n        <table class=\"table table-striped\">\n          <tbody>\n            <tr ng-repeat=\"highlight in vm.highlights track by highlight.id\">\n              <td style=\"width:100px\">\n                <img ng-src=\"{{highlight.preview}}\" ng-click=\"vm.showHighlight(highlight)\" class=\"img img-thumbnail\" style=\"width:100px; cursor:pointer;\">\n              </td>\n              <td>\n                {{highlight.name}}\n                ({{highlight.duration | secondsFormatted:true:false}})\n                <div><small>{{highlight.description}}</small></div>\n              </td>\n              <td class=\"text-right\">\n                <button class=\"btn btn-default\" ng-click=\"vm.delete(highlight)\">\n                  <i class=\"fa fa-trash\"></i>\n                </button>\n                <button class=\"btn btn-default\" ng-if=\"vm.canDownloadOrExport\" ng-click=\"vm.download(highlight)\">\n                  <i class=\"fa fa-cloud-download\"></i>\n                </button>\n                <button class=\"btn btn-default\" ng-click=\"vm.showCaptureModal(highlight)\">\n                  <i class=\"fa fa-pencil\"></i>\n                </button>\n                <button ng-show=\"!vm.broadcastIsMonetized || highlight.duration <= vm.maxMonetizedHighlightTimeS\" class=\"btn btn-default\" ng-click=\"vm.playHighlight(highlight)\">\n                  <i class=\"fa fa-share\"></i> Share\n                </button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        <uib-pagination\n            total-items=\"vm.highlightsPagination.total\" items-per-page=\"vm.HIGHLIGHTS_PAGE_SIZE\" max-size=\"10\"\n            rotate=\"false\" class=\"pagination-sm\" style=\"margin:0 0 5px 0\" ng-model=\"vm.highlightsPagination.current\"\n            ng-change=\"vm.loadHighlightsForPage(vm.highlightsPagination.current)\"></uib-pagination>\n        <p class=\"help-block\" style=\"margin:0 0 0 2px\">\n          Showing results\n          {{vm.highlightsPagination.resultMin}} -\n          {{vm.highlightsPagination.resultMax}}\n          of {{vm.highlightsPagination.total}}\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extended_test_html__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extended_test_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__extended_test_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extended_test_controller__ = __webpack_require__(454);



var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('extended-test', __WEBPACK_IMPORTED_MODULE_1__extended_test_html___default.a, __WEBPACK_IMPORTED_MODULE_2__extended_test_controller__["a" /* default */], 'ExtendedTestController', '/extended-test');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = "<style>\n  tags-input .host {\n    margin: 0px;\n  }\n  tags-input .tags .tag-item {\n    background: #428bca;\n  }\n</style>\n<div class=\"container-fluid\"\n     style=\"max-width:720px\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"row form-horizontal\">\n      <div class=\"col-xs-12\">\n        <div class=\"well clearfix\">  \n          <h3>Create New Extended Tests</h3><br/>\n          <div class=\"form-group\">\n            <label class=\"col-sm-4\">Duration: </label>\n            <div class=\"col-sm-8\">\n              <select id=\"duration\" \n                      ng-model=\"vm.duration\" \n                      required class=\"form-control\" \n                      ng-options=\"d.value as d.label for d in ::vm.DURATIONS\">\n              </select>\n            </div>\n          </div>\n  \n          <div class=\"form-group\">\n            <label class=\"col-sm-4\">Start in: </label>\n            <div class=\"col-sm-8\">\n              <select id=\"start_offset\" \n                      ng-model=\"vm.start_offset\" \n                      required class=\"form-control\"\n                      ng-options=\"o.value as o.label for o in ::vm.START_OFFSETS\">\n              </select>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"col-sm-4\">BoxCasters: <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <div class=\"col-sm-8\">\n              <tags-input required class=\"bootstrap\" \n                          ng-model=\"vm.boxcasters_to_test\" \n                          add-on-paste=\"true\" \n                          add-from-autocomplete-only=\"true\" \n                          placeholder=\"Add a BoxCaster\" \n                          display-property=\"id\"\n                          on-tag-added=\"vm.onBoxCasterAdd($tag)\">\n                <auto-complete source=\"vm.loadBoxCasters($query)\" min-length=\"0\" debounce-delay=\"0\"></auto-complete>\n              </tags-input>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"col-sm-4\">Target video bitrate: <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <div class=\"col-sm-8\">\n              <select id=\"target_video_bitrate\" \n                      ng-model=\"vm.target_video_bitrate\" \n                      required class=\"form-control\"\n                      ng-options=\"b.value as b.label for b in vm.service.videoBitrates\">\n              </select>\n            </div>\n          </div>\n    \n          <div class=\"form-group\">\n            <label class=\"col-sm-4\">Target audio bitrate: <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <div class=\"col-sm-8\">\n              <select id=\"target_audio_bitrate\" \n                      ng-model=\"vm.target_audio_bitrate\" \n                      required class=\"form-control\"\n                      ng-options=\"b.value as b.label for b in vm.service.audioBitrates\">\n              </select>\n            </div>\n          </div>  \n          <button type=\"button\" class=\"btn btn-success pull-right\" ng-click=\"vm.submit()\" ng-disabled=\"!form.$valid\">\n            <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n            Create\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</form>"

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExtendedTestController; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var ExtendedTestController = /*#__PURE__*/function () {
  function ExtendedTestController(BoxCaster, EditOrCreateEventService, toaster, $scope, $state, $q) {
    'ngInject';

    _classCallCheck(this, ExtendedTestController);

    this.BoxCaster = BoxCaster;
    this.service = EditOrCreateEventService.getInstance();
    this.boxcasters = [];
    this.getAllBoxCasters();
    this.toaster = toaster;
    this.$scope = $scope;
    this.$state = $state;
    this.$q = $q; // Valid extended test durations and a default duration.

    this.DURATIONS = [{
      label: '1 hour',
      value: 1 * 60 * 60 * 1000
    }, {
      label: '2 hours',
      value: 2 * 60 * 60 * 1000
    }, {
      label: '3 hours',
      value: 3 * 60 * 60 * 1000
    }, {
      label: '4 hours',
      value: 4 * 60 * 60 * 1000
    }, {
      label: '5 hours',
      value: 5 * 60 * 60 * 1000
    }, {
      label: '6 hours',
      value: 6 * 60 * 60 * 1000
    }, {
      label: '7 hours',
      value: 7 * 60 * 60 * 1000
    }, {
      label: '8 hours',
      value: 8 * 60 * 60 * 1000
    }];
    this.DEFAULT_DURATION = 6 * 60 * 60 * 1000; // Offset from "now" for the start time (15 minutes minimum).
    //
    // The API's forecaster looks at the schedule of upcoming broadcasts to know how many servers to
    // keep up, plus some reserve. During off-peak hours when nothing is broadcasting, only the
    // reserve is kept alive, and starting a large number of extended tests at once will completely
    // consume the reserve servers and delay any "real" broadcasts from starting. Since it takes 10-12
    // minutes to bring up new servers, scheduling extended tests 15 minutes in advance gives the API
    // forecaster enough advance warning to bring up the servers needed for these broadcasts, as well
    // as maintain the reserve in case any new (real) broadcasts are added on the fly.

    this.START_OFFSETS = [{
      label: '15 minutes',
      value: 15 * 60 * 1000
    }, {
      label: '1 hour',
      value: 1 * 60 * 60 * 1000
    }, {
      label: '2 hours',
      value: 2 * 60 * 60 * 1000
    }, {
      label: '3 hours',
      value: 3 * 60 * 60 * 1000
    }, {
      label: '4 hours',
      value: 4 * 60 * 60 * 1000
    }, {
      label: '5 hours',
      value: 5 * 60 * 60 * 1000
    }, {
      label: '6 hours',
      value: 6 * 60 * 60 * 1000
    }, {
      label: '7 hours',
      value: 7 * 60 * 60 * 1000
    }, {
      label: '8 hours',
      value: 8 * 60 * 60 * 1000
    }];
    this.DEFAULT_START_OFFSET = 15 * 60 * 1000;
    this.DEFAULT_AUDIO_BITRATE = 'default';
    this.DEFAULT_VIDEO_BITRATE = 'default';
    this.duration = this.DEFAULT_DURATION;
    this.start_offset = this.DEFAULT_START_OFFSET;
    this.target_video_bitrate = this.DEFAULT_VIDEO_BITRATE;
    this.target_audio_bitrate = this.DEFAULT_AUDIO_BITRATE;
    this.boxcasters_to_test = [];
    this.service.initBroadcast();
    this.service.initScope(this.$scope);
  }

  _createClass(ExtendedTestController, [{
    key: "loadBoxCasters",
    value: function loadBoxCasters(query) {
      var _this = this;

      var found = [];

      for (var i = 0; i < this.boxcasters.length; i++) {
        if (this.boxcasters[i].id.indexOf(query) > -1) {
          found.push(this.boxcasters[i]);
        }
      } // ensure only boxcasters with the same prefix are loaded


      if (this.boxcasters_to_test && this.boxcasters_to_test.length) {
        found = found.filter(function (b) {
          return b.id[0] == _this.boxcasters_to_test[0].id[0];
        });
      }

      return found;
    }
  }, {
    key: "onBoxCasterAdd",
    value: function onBoxCasterAdd(tag) {
      this.service.broadcast.boxcaster_id = tag.id;
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;

      var $q = this.$q;
      this.submitting = true;
      var startTime = new Date(Date.now() + parseInt(this.start_offset));
      var stopTime = new Date(startTime.getTime() + parseInt(this.duration));
      var promiseChain = this.boxcasters_to_test.reduce(function (promise, b) {
        return promise.then(function () {
          console.log("Scheduling extended test for ".concat(b.id));

          _this2.service.initBroadcast();

          _this2.service.startDate = startTime;
          _this2.service.startTime = startTime;
          _this2.service.endTime = stopTime;
          _this2.service.visibility = 'private';
          _this2.service.broadcast.boxcaster_id = b.id;
          _this2.service.broadcast.target_audio_bitrate = _this2.target_audio_bitrate;
          _this2.service.broadcast.target_video_bitrate = _this2.target_video_bitrate;
          _this2.service.broadcast.name = "Extended ".concat(b.id);
          _this2.service.broadcast.description = "Extended test of ".concat(b.id, " from ").concat(startTime, " to ").concat(stopTime, " using target bitrates\n                        ").concat(_this2.target_video_bitrate, " video / ").concat(_this2.target_audio_bitrate, " audio");
          return _this2.service.saveChanges();
        })["catch"](function (error) {
          console.error(error);
          throw error;
        });
      }, $q.when());
      promiseChain.then(function () {
        _this2.toaster.pop({
          type: 'success',
          title: 'Successfully scheduled extended tests'
        });

        _this2.submitting = false;

        _this2.$state.go('home');
      })["catch"](function (error) {
        _this2.toaster.pop({
          type: 'warning',
          title: 'Error scheduling extended tests'
        });

        _this2.submitting = false;
      });
    }
  }, {
    key: "getAllBoxCasters",
    value: function getAllBoxCasters() {
      var _this3 = this;

      var l = 500;
      var s = 'name';
      var q = 'credentialed:true';
      this.BoxCaster.query({
        l: l,
        s: s,
        q: q,
        p: 0
      }, function (results, headers) {
        var pagination = JSON.parse(headers('x-pagination'));
        _this3.boxcasters = _this3.boxcasters.concat(results);

        for (var p = 1; p <= pagination.last; p++) {
          _this3.BoxCaster.query({
            l: l,
            s: s,
            q: q,
            p: p
          }, function (results) {
            _this3.boxcasters = _this3.boxcasters.concat(results);
          });
        }
      });
    }
  }]);

  return ExtendedTestController;
}();



/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_utils_js__ = __webpack_require__(13);


var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('home', '', function () {
  // check for homepage version redirect to vue /home or /dashboard
  var homeKey = __WEBPACK_IMPORTED_MODULE_1__auth_utils_js__["d" /* storage */].get('new-home');
  var url = homeKey === '0' ? 'home' : 'broadcasts';
  window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/").concat(url));
}, 'HomeController', '/');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);

var template = "\n  <div style=\"position:fixed;left:0;right:0;bottom:0;top:0;background:#000;z-index:99999999\">\n    <div class=\"turn-off screen\">\n    </div>\n  </div>\n";
var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('logout', template, function LogoutController(AuthService, $timeout) {
  'ngInject';

  $timeout(function () {
    AuthService.logout();
  }, 1000);
}, 'LogoutController');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marketing_corner_html__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marketing_corner_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__marketing_corner_html__);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var MarketingCornerController = /*#__PURE__*/_createClass(function MarketingCornerController($rootScope, $http, toaster, ConfirmDialog, MeetingsService) {
  'ngInject';

  var _this = this;

  _classCallCheck(this, MarketingCornerController);

  this.account = $rootScope.account;
  this.$http = $http;
  this.toaster = toaster;
  this.ConfirmDialog = ConfirmDialog;
  this.MeetingsService = MeetingsService;
  this.user = $rootScope.user;
  this.ff = this.account.feature_flags;
  this.features = [{
    name: 'Unlimited Destinations',
    enabled: !this.ff.single_destination,
    info: 'Stream to your website, Facebook Live, YouTube, Twitter, a hosted link, Chromecast, any RTMP destination or your mobile apps.'
  }, {
    name: 'Analytics',
    enabled: this.ff.analytics,
    info: 'Understand your reach with engagement graphs and data on total views, unique viewers, and average view duration. See where in the world your viewers are watching, with a live interactive map. Take a detailed look at how viewers watch your content with data on viewing destinations, devices, browsers and operating systems, and playback quality'
  }, {
    name: 'Graphic Overlays',
    enabled: this.ff.overlays,
    info: 'Enhance your broadcast with graphics like logos, watermarks, lower thirds, full screen overlays or basic advertisements.'
  }, {
    name: 'Ticketing',
    enabled: !this.ff.no_ticketed,
    info: 'Generate revenue by selling tickets to your live or recorded broadcasts. Includes 25% revenue share for viewer support and processing.'
  }, {
    name: 'Automatic Recording',
    enabled: !this.ff.no_recordings,
    info: 'Let viewers watch the automatically recorded broadcast using the same links and embeds.'
  }, {
    name: 'Password Protection',
    enabled: this.ff.password,
    info: 'Protect your broadcasts with a single password.'
  }, {
    name: 'API Access',
    enabled: this.ff.api_keys,
    info: "Customize your video workflow using BoxCast's API."
  }, {
    name: 'Stream to Smart TV Apps',
    enabled: this.ff.appletv_roku,
    info: 'Let viewers watch your stream on their Smart TVs using the BoxCast App for Apple TV, Roku, and Amazon Fire TV'
  }, {
    name: 'Scoreboard Overlays',
    enabled: this.ff.manual_scoreboard,
    info: 'Overlay a live scoreboard on your broadcast. Control the scoreboard on your computer, phone, or tablet or integrate with your onsite scoreboard.'
  }, {
    name: 'Concurrent Broadcasts',
    enabled: this.account.max_simultaneous_streams != 1,
    info: 'Account for overlapping events by streaming two or more broadcasts simultaneously.'
  }, {
    name: 'Donations',
    enabled: this.ff.donations,
    info: 'Accept donations for your organization. Includes 6% processing fee.'
  }, {
    name: 'Automated Captioning',
    enabled: this.ff.automated_captioning,
    info: 'Save time, adhere to compliance standards, and make your recorded broadcasts more accessible by automatically adding closed captions'
  }, {
    name: 'Multi-Site Player',
    enabled: this.ff.multi_site,
    info: 'Stream to multiple remote campuses in high-quality without buffering.'
  }, {
    name: 'Highlight Clipping',
    enabled: this.ff.highlights,
    info: 'Capture important moments and share them on social media by quickly clipping highlights mid-broadcast or after your broadcast is over.'
  }, {
    name: 'Simulated Live',
    enabled: this.ff.simulated_live,
    info: 'Re-broadcast recorded or uploaded broadcasts to any destination.'
  }, {
    name: 'Geo-Blocking',
    enabled: this.ff.geoblock,
    info: 'Restrict viewership geographically based on zipcode or point and radius.'
  }, {
    name: 'Embedding Restrictions',
    enabled: this.ff.host_restrictions,
    info: 'Maintain control of your content by limiting the destinations or URLs where the broadcast can be watched.'
  }, {
    name: 'Video Markers',
    enabled: this.ff.cue_points,
    info: 'Help viewers easily find significant moments by naming and tagging points in a recorded broadcast.'
  }];
  this.additionalOptions = [{
    name: 'Additional Concurrent Broadcasts',
    info: 'Account for overlapping events by streaming two or more broadcasts simultaneously.'
  }, {
    name: 'Custom Smart TV Apps',
    info: 'Let viewers access your streams on your own branded TV app on Apple TV and Roku.'
  }, {
    name: 'Additional Features',
    info: "We're always listening and looking for ways to improve your experience. Some of our newer features may not be listed here."
  }];

  this.scheduleTime = function () {
    _this.MeetingsService.scheduleMeeting();
  };
});

var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('marketing-corner', __WEBPACK_IMPORTED_MODULE_1__marketing_corner_html___default.a, MarketingCornerController, 'MarketingCornerController');
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = "<style>\n  .upgrade-options td {\n    font-size: 14pt;\n    margin: 5px 3%;\n    min-width: 300px;\n    text-align: left;\n  }\n  .upgrade-options h2 {\n    font-family: Stratum2-bold;\n    margin-bottom: 20px;\n  }\n  .info {\n    margin-left: 20px;\n    color: grey;\n    text-align: right !important;\n  }\n  .enabled {\n    color: #5cb85c;\n  }\n\n</style>\n<main class=\"container-fluid upgrade-options\">\n\n  <div class=\"row text-center\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <h2 class=\"text-center\" style=\"margin-bottom:10px\">Available Features</h2>\n        <table align=\"center\" style=\"margin-bottom:10px;max-width:1250px;\">\n          <tr>\n            <td ng-repeat=\"feature in vm.features\" style=\"display:inline-block\">\n              <div style=\"float:left;width:90%;\">\n                <i class=\"fa\" ng-class=\"{ 'fa-square-o': !feature.enabled, 'fa-check enabled': feature.enabled }\" style=\"padding-right:5px\"></i>\n                <span>{{feature.name}}</span>\n              </div>\n              <div style=\"float:right;width:10%;\">\n                <i class=\"info fa fa-info-circle\" \n                   uib-tooltip=\"{{feature.info}}\"\n                   tooltip-append-to-body=\"true\">\n                </i>\n              </div>\n            </td>\n            <!-- Need placeholders that make the table look nice when the number of elements is not a multiple of 3 -->\n            <td style=\"display:inline-block\"></td>\n            <td style=\"display:inline-block\"></td>\n          </tr>\n        </table>\n        <h2 class=\"text-center\" style=\"margin-bottom:10px\">Need More?</h2>\n        <table align=\"center\" style=\"margin-bottom:10px;max-width:1250px;\">\n          <tr>\n            <td ng-repeat=\"option in vm.additionalOptions\" style=\"display:inline-block\">\n              <span>{{option.name}}</span>\n              <i class=\"info fa fa-info-circle\"\n                  uib-tooltip=\"{{option.info}}\"\n                  tooltip-append-to-body=\"true\">\n              </i>\n            </td>\n            <!-- Need placeholders that make the table look nice when the number of elements is not a multiple of 3 -->\n            <td style=\"display:inline-block\"></td>\n            <td style=\"display:inline-block\"></td>\n          </tr>\n        </table>\n        <p style=\"font-size:12pt\">\n          Interested in discussing upgrade opportunities for your account? We're happy to help!</br>\n          Schedule a time to talk to your client manager.\n        </p>\n        <a class=\"btn btn-primary btn-lg\" style=\"padding:10px\" ng-click=\"vm.scheduleTime()\">\n          Schedule Time\n        </a>\n      </div>\n    </div>\n  </div>\n\n</main>"

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('multi-site', "", function () {
  // Migrated to dashboard_vue
  window.location.href = '/multi-site';
}, 'MultiSiteController'));

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var navbarModule = angular.module('app.pages.navbar', []);
navbarModule.directive('topNavbar', function () {
  return {
    restrict: 'E',
    scope: {},
    template: __webpack_require__(461),
    controller: __webpack_require__(462)["default"],
    controllerAs: 'vm',
    bindToController: true
  };
});
navbarModule.directive('leftNavbar', function () {
  return {
    restrict: 'E',
    template: __webpack_require__(464),
    controller: __webpack_require__(465)["default"],
    controllerAs: 'vm',
    bindToController: true
  };
});
/* harmony default export */ __webpack_exports__["default"] = (navbarModule);

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navbar navbar-fixed-top navbar-default\">\n\n  <div ng-if=\"vm.isIE11 && !vm.isIE11Hidden\" style=\"position:fixed; z-index:1; top: 5px; padding: 5px; width: 100%\">\n    <div uib-alert class=\"alert-warning text-center\" close=\"vm.onDismissIE11()\"\n      style=\"max-width: 700px; margin: 0 auto;\">\n      You’re using a web browser that will stop being supported on June 15, 2021. Please upgrade to a compatible browser\n      for optimal performance and security.\n      <a href=\"https://support.boxcast.com/en/articles/5307468-upgrade-from-internet-explorer-11\" target=\"_blank\">Learn\n        more</a>\n    </div>\n  </div>\n\n  <!-- show expiration and payment notifications in an \"eyebrow\"-->\n  <div ng-if=\"vm.eyebrowReason\" class=\"eyebrow row\">\n    <div class=\"col-xs-12\">\n      <a href=\"javascript://\">\n        <div ng-if=\"vm.eyebrowReason == 'trial_will_expire' && !vm.isStreamMonkey\"\n          ng-click=\"(vm.upgrades && vm.upgrades.length) ? vm.viewProposal() : vm.onCompleteSetup()\" class=\"row\">\n          <div class=\"col-xs-6\">\n            <span class=\"visible-xs\">\n              <strong>Trial</strong> ends\n            </span>\n            <span class=\"hidden-xs\">\n              Your trial <span ng-show=\"vm.planName\">of the <strong>{{vm.planName}}</strong></span> ends\n            </span>\n            <strong ng-if=\"vm.expiresIn == 0\">today.</strong>\n            <span ng-if=\"vm.expiresIn > 0\">in <strong>{{vm.expiresIn}} {{vm.expiresIn == 1 ? 'day' :\n                'days'}}.</strong></span>\n            <span class=\"hidden-xs\" ng-if=\"!(vm.upgrades && vm.upgrades.length)\">\n              View <strong style=\"border-bottom:1px solid;\">plan features</strong>\n              or <strong style=\"border-bottom:1px solid;\"\n                onclick=\"window.open('https://www.boxcast.com/shure-promotion-details', '_blank'); return false;\">available\n                promotions</strong>.\n            </span>\n          </div>\n          <div ng-if=\"vm.upgrades && vm.upgrades.length\" class=\"col-xs-6 text-right\">\n            <span class=\"hidden-xs hidden-sm\">New pricing and plan proposal available</span> <strong\n              style=\"border-bottom:1px solid;margin-left:20px\">View Proposal</strong>\n          </div>\n          <div ng-if=\"!(vm.upgrades && vm.upgrades.length)\" class=\"col-xs-6 text-right\">\n            <span class=\"hidden-xs hidden-sm\">Ready to sign up?</span>\n            <strong>\n              <span style=\"border-bottom:1px solid\" class=\"hidden-xs\">Get started today</span>\n              <span style=\"border-bottom:1px solid\" class=\"hidden-sm hidden-md hidden-lg\">Sign up</span>\n            </strong>\n          </div>\n        </div>\n        <div ng-if=\"vm.eyebrowReason == 'trial_will_expire' && vm.account.status === 'onboarding' && vm.isStreamMonkey\"\n          ng-click=\"vm.$state.go('complete-migration')\" ui-sref=\"complete-migration.welcome\">\n          <div class=\"col-xs-6\">\n            <span class=\"visible-xs\">\n              <strong>Trial</strong> ends\n              <strong ng-if=\"vm.expiresIn == 0\">today.</strong>\n              <span ng-if=\"vm.expiresIn > 0\">in <strong>{{vm.expiresIn}} {{vm.expiresIn == 1 ? 'day' :\n                  'days'}}.</strong></span>\n            </span>\n            <span class=\"hidden-xs\">\n              Your trial <span ng-show=\"vm.planName\">of the <strong>{{vm.planName}}</strong></span> ends\n              <strong ng-if=\"vm.expiresIn == 0\">today.</strong>\n              <span ng-if=\"vm.expiresIn > 0\">in <strong>{{vm.expiresIn}} {{vm.expiresIn == 1 ? 'day' :\n                  'days'}}.</strong></span>\n            </span>\n          </div>\n          <div class=\"col-xs-6 text-right\">\n            <span class=\"hidden-xs hidden-sm\">Ready to make the switch?</span>\n            <strong>\n              <span style=\"border-bottom:1px solid\">Complete Migration</span>\n            </strong>\n          </div>\n        </div>\n        <div ng-if=\"vm.eyebrowReason == 'activation_will_expire'\" ng-click=\"vm.$state.go('settings.payment')\"\n          class=\"row\">\n          <div class=\"col-sm-6\">\n            <strong>Your <span class=\"hidden-xs\">BoxCast</span> subscription</strong> ends\n            <strong ng-if=\"vm.expiresIn == 0\">today</strong>\n            <span ng-if=\"vm.expiresIn > 0\">in <strong>{{vm.expiresIn}} {{vm.expiresIn == 1 ? 'day' :\n                'days'}}</strong></span>\n          </div>\n          <div class=\"col-sm-6 text-right hidden-xs\">\n            Please <strong style=\"border-bottom:1px solid\">update your billing details</strong>\n            or call (888) 392-2278 to ensure uninterrupted service.\n          </div>\n        </div>\n        <div ng-if=\"vm.eyebrowReason == 'need_payment'\" ng-click=\"vm.$state.go('settings.payment')\" class=\"row\">\n          <div class=\"col-xs-12 text-center\">\n            <strong class=\"hidden-xs hidden-sm\" style=\"margin-right:5px\">We had some trouble processing your\n              payment.</strong>\n            Please <strong style=\"border-bottom:1px solid\">update your billing details</strong> <span\n              class=\"hidden-xs\">or call (888) 392-2278 to ensure uninterrupted service.</span>\n          </div>\n        </div>\n        <div ng-if=\"vm.eyebrowReason == 'has_upgrade'\">\n          <div class=\"col-xs-10 col-xs-offset-1 text-center\" ng-click=\"vm.viewProposal()\" style=\"padding:0\">\n            <span class=\"hidden-xs\" style=\"margin-right:5px\">You have an upgrade available for your account.</span>\n            <strong style=\"border-bottom:1px solid\">View Proposal</strong>\n          </div>\n          <div class=\"col-xs-1 text-right\" style=\"padding:0\">\n            <i ng-click=\"vm.hideEyebrow()\" class=\"fa fa-times pull-right\"></i>\n          </div>\n        </div>\n        <div ng-if=\"vm.eyebrowReason == 'unverified_email_address'\" ng-click=\"vm.$state.go('settings.my_account')\"\n          class=\"row\">\n          <div class=\"col-xs-12 text-center\">\n            <span class=\"hidden-xs hidden-sm\" style=\"margin-right:5px\">Please verify your email address.</span>\n            <strong style=\"border-bottom:1px solid\">Take action to secure your account.</strong>\n          </div>\n        </div>\n      </a>\n    </div>\n  </div>\n  <!-- end if -->\n\n  <!-- mobile top nav -->\n  <div class=\"visible-xs visible-sm\">\n    <div class=\"navbar-header mobile\">\n      <div class=\"pull-left\">\n        <a ng-click=\"vm.toggleNav()\" href=\"javascript://\"><i class=\"fa fa-bars\" style=\"color:#000\"></i></a>\n      </div>\n      <div ng-if=\"vm.currentState == 'home' && !$root.user.is_impersonating\">\n        <h3><img src=\"/img/boxcast_logo_dark.png\" class=\"logo\" alt=\"BoxCast Logo\" /></h3>\n      </div>\n      <div ng-if=\"vm.currentState != 'home' && !$root.user.is_impersonating\">\n        <h3>{{vm.currentPageTitle}}</h3>\n      </div>\n      <div ng-if=\"$root.user.is_impersonating\">\n        <!-- use view title as placeholder for reminder that admin user is in impersonation mode -->\n        <h3\n          style=\"color: #bf2525; border: 1px solid; border-radius: 4px; line-height: 30px; margin: 10px auto; font-size: 14px; padding: 0 10px; max-width: 230px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;\">\n          Impersonating {{$root.account.name}}\n        </h3>\n      </div>\n    </div>\n  </div>\n\n  <!-- desktop top nav -->\n  <div class=\"hidden-xs hidden-sm\">\n    <div class=\"navbar-header\" style=\"position:relative\">\n      <a href=\"/\" class=\"navbar-brand\" style=\"position:relative\">\n        <img src=\"/img/boxcast_logo_dark.png\" class=\"logo\"  alt=\"BoxCast Logo\">\n        <div ng-show=\"vm.showLoading\">\n          <div class=\"spin-box-bg\"></div>\n          <div class=\"spin-box\"></div>\n        </div>\n      </a>\n    </div>\n    <div class=\"navbar-links\">\n      <div class=\"container-fluid\">\n        <div style=\"float:left; padding:0 15px;\">\n          <!-- use view title as placeholder for reminder that admin user is in impersonation mode -->\n          <h3 ng-if=\"!$root.user.is_impersonating\">{{vm.currentPageTitle}}</h3>\n          <h3 ng-if=\"$root.user.is_impersonating\"\n            style=\"color: #bf2525; border: 1px solid; border-radius: 4px; line-height: 30px; margin: 10px 0; font-size: 14px; padding: 0 10px; max-width: 230px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;\">\n            Impersonating {{$root.account.name}}\n          </h3>\n        </div>\n\n        <ul class=\"nav navbar-nav pull-right\">\n          <li class=\"dropdown\" ng-class=\"{open: vm.isDropdownOpen}\">\n            <a href id=\"topnav-user-dropdown\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">\n              <span class=\"visually-hidden\">Toggle User Menu</span>\n              <i ng-if=\"!$root.account.content_settings.profile_img\" class=\"fa fa-user\"></i>\n              <div ng-if=\"$root.account.content_settings.profile_img\" class=\"fixed-square\"\n                style=\"float:left;width:36px;height:36px;margin-right:3px;background:#fff\">\n                <div\n                  style=\"background-image:url(&quot;{{$root.account.content_settings.profile_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\">\n                </div>\n              </div>\n              <span class=\"caret\"></span>\n            </a>\n            <ul class=\"dropdown-menu dropdown-menu-right\" style=\"max-height:300px; overflow-y:scroll;\">\n              <li ng-if=\"vm.user.authorized_accounts.length > 1\"\n                ng-repeat=\"a in ::vm.user.authorized_accounts | orderBy:'name'\" role=\"menuitem\"\n                ng-class=\"{active: a.id == vm.account.id}\">\n                <a ng-if=\"a.id != vm.account.id\" href ng-click=\"vm.switchAccount(a)\">{{a.name}}</a>\n                <a ng-if=\"a.id == vm.account.id\" href disabled\n                  style=\"background-color: #444; cursor: default;\">{{a.name}}</a>\n              </li>\n              <li ng-if=\"vm.user.authorized_accounts.length > 1\" class=\"divider\"></li>\n              <li><a ui-sref=\"settings.my_account\">My Account</a></li>\n              <li><a ui-sref=\"logout\">Sign Out</a></li>\n            </ul>\n          </li>\n        </ul>\n\n        <div class=\"notification-icons pull-right\">\n          <ul class=\"list-inline\">\n            <li class=\"block text-xs font-medium text-bx-accessible-grey\" ng-show=\"vm.boxcastersOnline > 0\" style=\"line-height: 12px; text-align: center; padding-top: 10px;\">\n              <i class=\"fa fa-check-circle\" style=\"font-size: 1.6rem; color: var(--color-bx-green)\"></i>\n              <br>\n              <small class=\"block mt-tight text-xs\" style=\"white-space:nowrap;\">\n                <ng-pluralize count=\"vm.boxcastersOnline\" when=\"{\n                  '1': 'BoxCaster Online',\n                  'other': 'BoxCasters Online'\n                }\"></ng-pluralize>\n              </small>\n            </li>\n            <li class=\"block text-xs font-medium text-bx-accessible-grey\" ng-show=\"vm.boxcastersNeedAttention > 0\" style=\"line-height: 12px; text-align: center; padding-top: 10px;\">\n              <i class=\"fa fa-exclamation-circle\" style=\"font-size: 1.6rem; color:var(--color-bx-red)\"></i>\n              <br>\n              <small class=\"block mt-tight text-xs\" style=\"white-space:nowrap;\">\n                <a class=\"subtle-link\" href=\"{{$root.vueDashboardRoot}}/sources\" style=\"text-decoration: none\">\n                  <ng-pluralize count=\"vm.boxcastersNeedAttention\" when=\"{\n                    '1': 'BoxCaster Needs Attention',\n                    'other': 'BoxCasters Need Attention'\n                  }\">\n                  </ng-pluralize>\n                </a>\n              </small>\n            </li>\n          </ul>\n        </div>\n\n        <ul ng-show=\"vm.hasOrder\" class=\"nav navbar-nav pull-right\" style=\"padding:7px 20px 0 0\">\n          <li text-s>\n            <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.openOrderStatus()\">\n              <img src=\"/img/box_open_icon.png\" height=\"15px\"></i> Check Order Status\n            </button>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</nav>"

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page_names__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_modal_checkout__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isStreamMonkey__ = __webpack_require__(10);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }





var TopNavController = /*#__PURE__*/function () {
  function TopNavController($scope, $state, $timeout, $rootScope, AuthService, BoxCaster, User, ConfirmDialog, Account, MeetingsService, Checkout, Order, $uibModal, $analytics, $q) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, TopNavController);

    this.$state = $state;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.AuthService = AuthService;
    this.BoxCaster = BoxCaster;
    this.User = User;
    this.Account = Account;
    this.ConfirmDialog = ConfirmDialog;
    this.reloadInterval = REFRESH_INTERVAL_MS;
    this.$uibModal = $uibModal;
    this.$analytics = $analytics;
    this.MeetingsService = MeetingsService;
    this.Order = Order;
    this.user = $rootScope.user;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    this.isStreamMonkey = Object(__WEBPACK_IMPORTED_MODULE_2__utils_isStreamMonkey__["a" /* default */])(this.account.migration_service_id);
    var ua = window.navigator.userAgent;
    this.isIE11 = ua.indexOf('Windows ') >= 0 && ua.indexOf('Trident/') >= 0;

    this.onDismissIE11 = function () {
      _this.isIE11Hidden = true;
    };

    this.showLoading = false;
    $rootScope.$on('loading:state', function (state) {
      _this.showLoading = state;
    });
    $rootScope.$on('user:switchAccount', function (evt, a) {
      return _this.switchAccount(a);
    });
    $rootScope.$on('open-sm-modal', function () {
      _this.openSMModal();
    });
    $rootScope.$on('account-migrated', function () {
      _this.hideEyebrow();
    }); // Keep track of state of the account's BoxCasters to show online/warning indicators

    this.checkBoxcasterOnline();
    this.checkForNewOrders();
    this.planName = '';

    if (this.account.isTrialing()) {
      this.Account.getBilling().$promise.then(function (result) {
        _this.planName = Checkout.stripeBasePlanNameShortFromBillingResult(result);
      });
    }

    if (this.user.can('list', 'upgrades')) {
      this.upgrades = this.Account.getUpgrades();
      this.upgrades.$promise.then(function () {
        // Filter out proposals that were generated via self-service
        _this.upgrades = _this.upgrades.filter(function (u) {
          return !u.self_service;
        }); // Show "eyebrow" in certain situations

        if (_this.account.authorized()) {
          if (_this.account.contract == 'trial') {
            _this.expiresIn = moment(_this.account.expires_on).diff(moment(), 'days');
            _this.eyebrowReason = 'trial_will_expire';
          } else if (_this.account.payment_method == 'activation') {
            _this.expiresIn = moment(_this.account.expires_on).diff(moment(), 'days');

            if (_this.expiresIn < 30) {
              _this.eyebrowReason = 'activation_will_expire';
            }
          } else if (_this.account.payment_status == 'info_requested' || _this.account.payment_status == 'declined') {
            _this.eyebrowReason = 'need_payment';
          } else if (_this.upgrades && _this.upgrades.length && _this.user.metadata.alert_upgrade) {
            _this.eyebrowReason = 'has_upgrade';
          } else if (_this.user.pending_email_update) {
            _this.eyebrowReason = 'unverified_email_address';
          } else if (_this.user.metadata.alert_upgrade) {
            // Remove the metadata since there are no upgrades to alert about
            delete _this.user.metadata.alert_upgrade;
            User.update({
              metadata: _this.user.metadata
            }, function (user) {
              $rootScope.user.reloadFromResource(user);
            }, function () {
              console.error('Error updating user metadata');
            });
          }

          if (_this.eyebrowReason) {
            $scope.$emit('show-eyebrow');
          }
        }
      });
    }

    this.viewProposal = function () {
      var hasUpgrade = _this.upgrades && _this.upgrades.length == 1;

      if (_this.isStreamMonkey && !hasUpgrade) {
        _this.openSMModal();
      } else if (hasUpgrade) {
        $state.go('checkout', {
          pd_did: _this.upgrades[0].pandadoc_id,
          pd_sid: _this.upgrades[0].share_id
        }, {
          reload: true
        });
      } else {
        $state.go('settings.payment');
      }

      $analytics.eventTrack('view-proposal', {
        category: 'upgrade'
      });
    };

    this.onContactUs = function () {
      _this.MeetingsService.openPreferredMethod();
    };

    this.onCompleteSetup = function () {
      if (_this.isStreamMonkey) {
        _this.openSMModal();
      } else {
        var checkoutURL = window.VUE_DASHBOARD_ROOT + "/checkout";
        window.location.href = checkoutURL;
      }
    };

    this.openSMModal = function () {
      _this.$uibModal.open({
        template: __webpack_require__(217),
        controller: __WEBPACK_IMPORTED_MODULE_1__settings_modal_checkout__["a" /* default */],
        controllerAs: 'vm',
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        resolve: {
          params: function params() {
            return {};
          },
          isStreamMonkeyMode: true
        }
      }).result.then(function (accountData) {
        if (accountData.status === 'active') {
          $rootScope.$emit('account-migrated', accountData);
        }
      });
    };

    this.hideEyebrow = function () {
      _this.eyebrowReason = null;
      $scope.$emit('hide-eyebrow');
      delete _this.user.metadata.alert_upgrade;
      User.update({
        metadata: _this.user.metadata
      }, function (user) {
        $rootScope.user.reloadFromResource(user);
      }, function () {
        console.error('Error updating user metadata');
      });
      $analytics.eventTrack('hide-eyebrow', {
        category: 'upgrade'
      });
    }; // Need to watch this because it changes as user navigates


    $scope.$watch(function () {
      return $state.current.name;
    }, function (name) {
      _this.currentState = name;
      _this.currentPageTitle = __WEBPACK_IMPORTED_MODULE_0__page_names__["a" /* default */][name];
    }); // Always let clicks of document not on the exact opener close it

    $(document).click(function (e) {
      var TARGET_ID = 'topnav-user-dropdown'; // Assume the user has clicked elsewhere and we'll be closing the dropdown.

      var isDropdownOpen = false; // Any click on the topnav user dropdown (or any of its children) means toggle state; so go
      // looking at the click target to see if it's the dropdown or any of its children.

      var target = e.target;

      while (target) {
        if (target.id == TARGET_ID) {
          isDropdownOpen = !_this.isDropdownOpen;
          break;
        }

        target = target.parentNode;
      } // Toggle it async


      $scope.$evalAsync(function () {
        return _this.isDropdownOpen = isDropdownOpen;
      });
    });
  }

  _createClass(TopNavController, [{
    key: "switchAccount",
    value: function switchAccount(a) {
      var ConfirmDialog = this.ConfirmDialog,
          User = this.User;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Switch Account',
        actionButtonClass: 'primary',
        headerText: 'Confirm Account Switch',
        bodyText: "Your user will be moved to the ".concat(a.name, " account.  All other logged in sessions for your user (including on other devices) will be affected.")
      };
      ConfirmDialog.show(modalOptions).then(function () {
        User.switchAccount({
          accountId: a.id
        }).$promise.then(function () {
          window.location.reload();
        });
      });
    }
  }, {
    key: "checkBoxcasterOnline",
    value: function checkBoxcasterOnline() {
      var _this2 = this;

      var BoxCaster = this.BoxCaster,
          $rootScope = this.$rootScope,
          $timeout = this.$timeout;
      var boxcasters = BoxCaster.query({
        l: 1000
      }, function () {
        $rootScope.boxcasters = boxcasters;
        $rootScope.$broadcast('data:boxcasters', boxcasters);
        _this2.boxcastersOnline = _.reduce(boxcasters, function (total, box) {
          return box.status == 'offline' ? total : total + 1;
        }, 0);
        _this2.boxcastersNeedAttention = _.reduce(boxcasters, function (total, box) {
          // TODO: also consider if box is offline but should be broadcasting; not that
          // offline by itself is a normal state
          return box.firmware_status != 'current' ? total + 1 : total;
        }, 0);
        _this2.reloadInterval = REFRESH_INTERVAL_MS;
        $timeout(function () {
          return _this2.checkBoxcasterOnline();
        }, _this2.reloadInterval);
      }, function (error) {
        _this2.reloadInterval = Math.min(2 * _this2.reloadInterval, 120000); //exponential backoff up to 2min

        $timeout(function () {
          return _this2.checkBoxcasterOnline();
        }, _this2.reloadInterval);
      });
    }
  }, {
    key: "toggleNav",
    value: function toggleNav() {
      var $container = $('left-navbar').parent();
      $container.toggleClass('nav-open'); // Disable touch scroll bubbling to background

      if ($container.hasClass('nav-open')) {
        $('body').css({
          overflow: 'hidden'
        });
      } else {
        $('body').css({
          overflow: 'auto'
        });
      }
    }
  }, {
    key: "checkForNewOrders",
    value: function checkForNewOrders() {
      var _this3 = this;

      this.hasOrder = false;

      if (!this.account.metadata.has_new_order) {
        return;
      }

      this.Order.query().$promise.then(function (result) {
        var isOutdated = false;

        var filtered = _.filter(result, function (o) {
          return o.status != 'cancelled';
        });

        if (filtered.length > 0) {
          _this3.hasOrder = true;

          _this3.Order.query({
            id: filtered[0].id
          }).$promise.then(function (result) {
            isOutdated = _this3.order.ship_date && Date.now() > moment(_this3.order.ship_date).add(_this3.order.is_international ? 21 : 14, 'days');
          });
        }

        if (!_this3.order || isOutdated) {
          delete _this3.account.metadata.has_new_order;

          _this3.Account.update({
            metadata: _this3.account.metadata
          }, function (account) {
            _this3.$rootScope.account = account;
          }, function () {
            console.error('Error updating account metadata');
          });

          _this3.hasOrder = false;
        }
      });
    }
  }, {
    key: "openOrderStatus",
    value: function openOrderStatus() {
      var _this4 = this;

      this.$uibModal.open({
        template: __webpack_require__(218),
        resolve: {
          order: function order() {
            return _this4.order;
          },
          account: function account() {
            return _this4.account;
          },
          showOrdersLink: function showOrdersLink() {
            return true;
          }
        },
        controller: __webpack_require__(219)["default"],
        controllerAs: 'vm'
      });
      this.$analytics.eventTrack("order-status-modal", {
        category: 'open',
        label: ''
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      this.$state.go('logout');
    }
  }]);

  return TopNavController;
}();

/* harmony default export */ __webpack_exports__["default"] = (TopNavController);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Map of page route -> title
// NOTE: This needs to be updated whenever a new page is added.
// There's probably a better way in UI router to configure/communicate
// the name of the active route, but this is what we got for now.
var PAGE_NAMES = {
  home: 'Broadcasts',
  'bulk-import': 'Bulk Import',
  'caption-editor': 'Caption Editor',
  channels: 'Channels',
  'complete-migration': 'Complete Migration',
  contributors: 'Contributors',
  embed: 'Embed Code Generator',
  'extended-test': 'Create Extended Test',
  'marketing-corner': 'Upgrade Options',
  'multi-site': 'Multi-Site Player',
  'new-event': 'Schedule',
  resources: 'Resources',
  sources: 'Sources',
  uploads: 'Uploads',
  'settings.overview': 'Settings',
  'settings.integrations': 'Settings',
  'settings.users': 'Settings',
  'settings.facebook': 'Settings',
  'settings.my_account': 'Settings',
  'settings.payment': 'Settings',
  'settings.rtmp_push_channels': 'Settings',
  'settings.youtube': 'Settings',
  'settings.twitter': 'Settings',
  'settings.vimeo': 'Settings',
  events: 'Broadcasts',
  'events.detail': 'Broadcast Details',
  'events.edit': 'Edit Broadcast Details',
  'events.trim': 'Trim Recording',
  'events.highlights': 'Broadcast Highlights',
  reports: 'Reports',
  'reports.donations': 'Donations Report',
  'reports.tickets': 'Tickets Report',
  'reports.viewer': 'Viewer Analytics'
};
/* harmony default export */ __webpack_exports__["a"] = (PAGE_NAMES);

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = "<div style=\"position:relative;min-height:95%;\">\n  <div class=\"user\">\n  </div>\n  <ul class=\"nav\">\n    <li ui-sref-active=\"active\" ng-if=\"vm.showGetStarted()\">\n      <a ui-sref=\"complete-migration\" ui-sref-opts=\"{reload: true}\">\n        <span class=\"nav-icon\"><i class=\"fa fa-power-off\"></i></span>\n        <span class=\"nav-label\">Get Started</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\">\n      <a href=\"{{vueDashboardRoot}}/\">\n        <span class=\"nav-icon\"><i class=\"fa fa-home\"></i></span>\n        <span class=\"nav-label\">Broadcasts</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canScheduleBroadcast\">\n      <a ui-sref=\"new-event\">\n        <span class=\"nav-icon\"><i class=\"fa fa-calendar-plus-o\"></i></span>\n        <span class=\"nav-label\">Schedule</span>\n      </a>\n    </li>\n    <li ng-if=\"::vm.allowProducer\">\n      <a href=\"{{vueDashboardRoot}}/producer\">\n        <span class=\"nav-icon\"><i class=\"fa-light fa-clapperboard\"></i></span>\n        <span class=\"nav-label\">Producer <div style=\"display: inline-block; background-color: var(--color-bx-lagoon); color: white; padding: .4rem .8rem; border-radius: .4rem; margin-left: 1.2rem; font-size: 1.2rem; font-weight: 500\">BETA</div></span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.account.is_manufacturer\">\n      <a ui-sref=\"extended-test\">\n        <span class=\"nav-icon\" style=\"position: relative\">\n          <i class=\"fa fa-server\"></i>\n        </span>\n        <span class=\"nav-label\">Extended Test</span>\n      </a>\n    </li>\n    <li class=\"divider\"></li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canEditChannel\">\n      <a ui-sref=\"channels\">\n        <span class=\"nav-icon\"><i class=\"fa fa-television\"></i></span>\n        <span class=\"nav-label\">Channels</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canEmbed\">\n      <a ui-sref=\"embed\">\n        <span class=\"nav-icon\"><i class=\"fa fa-code\"></i></span>\n        <span class=\"nav-label\">Embed</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canUpload\">\n      <a ng-href=\"{{vm.uploadsRoute}}\">\n        <span class=\"nav-icon\"><i class=\"fa fa-image\"></i></span>\n        <span class=\"nav-label\">Media Uploads</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.FeatureFlags.multi_site\">\n      <a href=\"{{vueDashboardRoot}}/multi-site\">\n        <span class=\"nav-icon\"><i class=\"fa fa-building-o\"></i></span>\n        <span class=\"nav-label\">Multi-Site Player</span>\n      </a>\n    </li>\n    <li ng-class=\"{active:$state.includes('reports')}\" ng-if=\"vm.canAccessReports && vm.account.defaultReportState()\">\n      <a ng-href=\"{{$state.href(vm.account.defaultReportState())}}\">\n        <span class=\"nav-icon\"><i class=\"fa fa-line-chart\"></i></span>\n        <span class=\"nav-label\">Reports</span>\n      </a>\n    </li>\n    <li ng-class=\"{active:$state.includes('settings')}\">\n      <a href=\"{{vueDashboardRoot}}/settings/my-account\">\n        <span class=\"nav-icon\"><i class=\"fa fa-cog\"></i></span>\n        <span class=\"nav-label\">Settings</span>\n      </a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::vm.canEditBoxcaster\">\n      <a href=\"{{vueDashboardRoot}}/sources\">\n        <span class=\"nav-icon\"><i class=\"fa fa-video-camera\"></i></span>\n        <span class=\"nav-label\">Sources</span>\n      </a>\n    </li>\n\n    <!-- some of the hidden top-nav options move in here on small screen -->\n    <li class=\"divider visible-xs visible-sm\"></li>\n    <li class=\"visible-xs visible-sm dropdown\" ng-class=\"{open: vm.isDropdownOpen}\"\n      ng-show=\"vm.user.authorized_accounts.length > 1\">\n      <a href ng-click=\"vm.isDropdownOpen = !vm.isDropdownOpen\" class=\"dropdown-toggle\" data-toggle=\"dropdown\"\n        role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">\n        <span class=\"nav-icon\"><i class=\"fa fa-user\"></i></span>\n        <span class=\"nav-label\">Switch User</span>\n      </a>\n      <ul class=\"dropdown-menu\">\n        <li ng-repeat=\"a in ::vm.user.authorized_accounts | orderBy:'name'\" role=\"menuitem\"\n          ng-class=\"{active: a.id == vm.account.id}\">\n          <a ng-if=\"a.id != vm.account.id\" href ng-click=\"vm.switchAccount(a)\">{{a.name}}</a>\n          <a ng-if=\"a.id == vm.account.id\" href disabled style=\"background-color: #444; cursor: default;\">{{a.name}}</a>\n        </li>\n      </ul>\n    </li>\n    <li class=\"visible-xs visible-sm\">\n      <a ng-click=\"vm.logout()\">\n        <span class=\"nav-icon\"><i class=\"fa fa-sign-out\"></i></span>\n        <span class=\"nav-label\">Sign Out</span>\n      </a>\n    </li>\n  </ul>\n\n  <div class=\"clearfix\"></div>\n\n\n  <div style=\"position:absolute; bottom:-110px; left:0; right:0; padding:5px;\" class=\"text-center\">\n    <ol class=\"list-inline text-center\">\n      <li>\n        <a href=\"https://support.boxcast.com\" target=\"_blank\" class=\"need-help\">\n          Need Help?\n        </a>\n      </li>\n    </ol>\n    <div style=\"display:block!important; margin-bottom:20px; color:#ccc;\" id=\"appcues-launchpad\"></div>\n    <ol class=\"list-inline text-center\" ng-hide=\"vm.account.isTrialing() || !vm.canUpgrade\">\n      <li>\n        <a ui-sref=\"settings.payment\" style=\"font-size:1.4rem; font-weight:bold; color: rgba(255, 255, 255, 0.6)\">\n          Upgrade Options\n        </a>\n      </li>\n    </ol>\n    <ol class=\"list-inline text-center\">\n      <li>\n        <a href=\"https://www.boxcast.com/refer-earn\" target=\"_blank\"\n          style=\"font-size:1.4rem; font-weight:bold; color: rgba(255, 255, 255, 0.6)\">\n          Refer + Earn $100\n          <i class=\"fa-regular fa-arrow-up-right-from-square\"\n            style=\"font-size:1.4rem; font-weight:bold; color: rgba(255, 255, 255, 0.6)\"></i>\n        </a>\n      </li>\n    </ol>\n  </div>\n\n</div>"

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isStreamMonkey__ = __webpack_require__(10);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var LeftNavController = /*#__PURE__*/function () {
  function LeftNavController(AuthService, $scope, $state, $rootScope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, LeftNavController);

    this.AuthService = AuthService;
    this.$state = $state;
    this.user = AuthService.user;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    this.canEditBoxcaster = $rootScope.user.can('update', 'boxcaster/*');
    this.canEditChannel = $rootScope.user.can('update', 'channel/*');
    this.canUpload = $rootScope.user.can('create', 'upload');
    this.canAccessReports = $rootScope.user.can('read', 'viewer-analytics/*');
    this.canScheduleBroadcast = $rootScope.user.can('create', 'broadcast');
    this.canEmbed = $rootScope.user.can('embed', 'broadcast/*');
    this.canUpgrade = $rootScope.user.can('create', 'upgrade');
    this.currentYear = new Date().getFullYear();
    this.getStartedFlag = null;

    this.switchAccount = function (a) {
      return $rootScope.$emit('user:switchAccount', a);
    };

    this.allowProducer = $rootScope.user.can('create', 'broadcast') && this.FeatureFlags.producer;
    this.uploadsRoute = $rootScope.user.can('create', 'broadcast') && $rootScope.user.can('create', 'broadcast/*:upload') ? $rootScope.vueDashboardRoot + '/uploads' : $rootScope.vueDashboardRoot + '/uploads/thumbnail-images';

    if (this.account.extra_features.product_tour && window.Appcues) {
      // takes odd parameters - docs: https://docs.appcues.com/article/703-launchpad-installation
      window.Appcues.loadLaunchpad('#appcues-launchpad', {
        position: 'top-right'
      });
    }

    this.showGetStarted = function () {
      if (_this.getStartedFlag === false) return false;else return (_this.account.contract === 'trial' || _this.account.status === 'onboarding') && Object(__WEBPACK_IMPORTED_MODULE_1__utils_isStreamMonkey__["a" /* default */])(_this.account.migration_service_id);
    };

    $rootScope.$on('account-migrated', function () {
      _this.getStartedFlag = false;
    });
  }

  _createClass(LeftNavController, [{
    key: "logout",
    value: function logout() {
      this.$state.go('logout');
    }
  }]);

  return LeftNavController;
}();

/* harmony default export */ __webpack_exports__["default"] = (LeftNavController);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__new_event_html__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__new_event_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__new_event_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__new_event_controller__ = __webpack_require__(468);



var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('new-event', __WEBPACK_IMPORTED_MODULE_1__new_event_html___default.a, __WEBPACK_IMPORTED_MODULE_2__new_event_controller__["a" /* default */], 'NewEventController', '/new-event?cloneId&boxcasterId&streamSource&staticRtmpId&sourceBroadcastId'); // Require this *after* we create the module via `wire` above

__webpack_require__(483);

/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n<div class=\"container-fluid\"\n     style=\"max-width:720px\"\n     ng-show=\"(vm.service.boxcasters.length || vm.service.allowSwitcher || vm.service.allowBroadcasterApp || vm.service.staticRTMPs.length || vm.service.allowSimulatedLive || vm.service.allowProducer)\">\n  <!-- XXX: form needs to be here so it is accessible in service for validation -->\n  <form name=\"form\" role=\"form\" style=\"margin-bottom: 50px\">\n    <div ng-if=\"vm.wizard\">\n      <new-event-wizard />\n    </div>\n    <div ng-if=\"!vm.wizard\">\n      <new-event-quick />\n    </div>\n  </form>\n</div>\n\n<div class=\"container-fluid\"\n     style=\"max-width:720px\"\n     ng-hide=\"(vm.service.boxcasters.length || vm.service.allowSwitcher || vm.service.allowBroadcasterApp || vm.service.staticRTMPs.length || vm.service.allowSimulatedLive || vm.service.allowProducer)\">\n  <div class=\"well text-center\" style=\"padding:30px\">\n    <h4 class=\"help-block\" style=\"margin-bottom:20px\">\n      Add a source before scheduling a broadcast.\n    </h4>\n    <a class=\"btn btn-lg btn-success\" href=\"{{vueDashboardRoot}}/sources\">\n      Add a Source\n    </a>\n  </div>\n</div>\n\n</main>\n"

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewEventController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_error__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_timezone__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rrule__ = __webpack_require__(469);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }





var NewEventController = /*#__PURE__*/function () {
  function NewEventController($scope, $state, $analytics, $timeout, $q, $uibModal, EditOrCreateEventService, toaster, Facebook, $rootScope, Overlays) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, NewEventController);

    var account = $rootScope.account,
        user = $rootScope.user;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$analytics = $analytics;
    this.$q = $q;
    this.$uibModal = $uibModal;
    this.EditOrCreateEventService = EditOrCreateEventService;
    this.toaster = toaster;
    this.fb = Facebook;
    this.Overlays = Overlays;
    this.showFeatured = account.extra_features.featured_broadcasts;
    var _this$$state$params = this.$state.params,
        boxcasterId = _this$$state$params.boxcasterId,
        streamSource = _this$$state$params.streamSource,
        staticRtmpId = _this$$state$params.staticRtmpId,
        sourceBroadcastId = _this$$state$params.sourceBroadcastId;

    if (streamSource == 'app') {
      // Make sure to always allow broadcaster app, even if they haven't had the automatic
      // preference feature flag applied yet.
      if (!account.usage_flags.broadcaster_app) {
        var usage_flags = (account.usage_flags || '').split(/\s+/);
        usage_flags.push('broadcaster_app');
        account.usage_flags = usage_flags.sort().join(' ');
      }
    }

    this.showSocial = true;
    this.MAX_RECURRING_EVENTS = MAX_RECURRING_EVENTS;
    this.wizard = false;

    if (localStorage.getItem('wizard')) {
      this.wizard = parseInt(localStorage.getItem('wizard'), 10) == 1;
    }

    var cloneId = null,
        clone = false;
    $scope.$watch(function () {
      return $scope.form.$pristine;
    }, function (isPristine) {
      _this.$state.current.confirmOnExit = !isPristine;
    });
    var accountTimezone__tzInfo = $rootScope.account.time_zone;
    var currentTimezone__jstz = Object(__WEBPACK_IMPORTED_MODULE_1__utils_timezone__["a" /* FindTimeZone */])();
    this.currentTimezoneValue = currentTimezone__jstz;
    this.currentTimezone = Object(__WEBPACK_IMPORTED_MODULE_1__utils_timezone__["c" /* JstzToTzInfo */])(currentTimezone__jstz);
    this.timezoneMatchesAccount = Object(__WEBPACK_IMPORTED_MODULE_1__utils_timezone__["b" /* JstzMatchesTzInfo */])(currentTimezone__jstz, accountTimezone__tzInfo);
    this.recurring = {
      enabled: false,
      pattern: 'week',
      end: 'after',
      endCount: 10,
      endDate: moment().add(30, 'day').toDate(),
      onDays: [1, 2, 3, 4, 5]
    };

    this.toggleOnDays = function (i) {
      var idx = _this.recurring.onDays.indexOf(i);

      if (idx > -1) {
        _this.recurring.onDays.splice(idx, 1);
      } else {
        _this.recurring.onDays.push(i);
      }
    };

    this.getPatternLastRecurringDate = function () {
      var count = _this.recurring.endCount > 1 ? _this.recurring.endCount : 1;
      var recurrence;

      switch (_this.recurring.pattern) {
        case "day":
          recurrence = new __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */]({
            freq: __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */].DAILY,
            count: count,
            wkst: __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */].SU,
            dtstart: _this.service.startDate // eg. new Date(Date.UTC(2012, 1, 1, 10, 30))

          });
          break;

        case "week":
          recurrence = new __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */]({
            freq: __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */].WEEKLY,
            count: count,
            wkst: __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */].SU,
            dtstart: _this.service.startDate
          });
          break;

        case "weekbyday":
          recurrence = new __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */]({
            freq: __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */].WEEKLY,
            byweekday: _this.recurring.onDays,
            count: count,
            wkst: __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */].SU,
            dtstart: _this.service.startDate
          });
          break;

        case "month":
          var opts = {
            freq: __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */].MONTHLY,
            count: count,
            wkst: __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */].SU,
            dtstart: _this.service.startDate
          }; // if recurrence falls within last dates of a month, accomodate
          // 31st each month with a fallback to the last valid day in that month:

          if (moment(_this.service.startDate).date() === 31) {
            opts.bymonthday = [28, 29, 30, 31];
            opts.bysetpos = -1;
          } else if (moment(_this.service.startDate).date() === 30) {
            // 30th each month with a fall back to the 28th or 29th (in leap years) in February
            opts.bymonthday = [28, 29, 30];
            opts.bysetpos = -1;
          } else if (moment(_this.service.startDate).date() === 29) {
            // 29th each month with a fall back to the 28th in February in non-leap years
            opts.bymonthday = [28, 29];
            opts.bysetpos = -1;
          }

          recurrence = new __WEBPACK_IMPORTED_MODULE_2_rrule__["a" /* RRule */](opts);
          break;

        default:
          console.log("unknown pattern: ".concat(_this.recurring.pattern));
          return moment(_this.service.startDate);
      }

      var recurringDates = recurrence.all();
      var lastRecurringDate = recurringDates[recurringDates.length - 1];
      return moment(lastRecurringDate);
    };

    this.isRecurringPatternValid = function () {
      // pattern is valid if this is not a simulated live rebroadcast
      if (!_this.service.sourceBroadcast) {
        return true;
      }

      if (_this.service.account.storage_policy !== "auto-delete") {
        return true;
      }

      var broadcastExpiration = moment(_this.service.sourceBroadcast.storage_expires_at);

      if (_this.recurring.end === 'on') {
        return moment(_this.recurring.endDate).isBefore(broadcastExpiration);
      }

      var lastRecurringDate = _this.getPatternLastRecurringDate();

      return lastRecurringDate.isBefore(broadcastExpiration);
    };

    if (this.$state.params.cloneId) {
      cloneId = this.$state.params.cloneId;
      clone = true;
      this.scheduleAgain = true;
      this.$analytics.eventTrack("new-event-".concat(this.wizard ? 'wizard' : 'quick'), {
        category: 'open',
        label: 'clone'
      });
    } else {
      this.scheduleAgain = false;
      this.$analytics.eventTrack("new-event-".concat(this.wizard ? 'wizard' : 'quick'), {
        category: 'open',
        label: ''
      });
    }

    this.service = EditOrCreateEventService.getInstance();
    this.service.initBroadcast(cloneId, clone);
    this.service.initScope($scope);

    if (boxcasterId) {
      this.service.broadcast.boxcaster_id = boxcasterId;
    } else if (staticRtmpId) {
      this.service.broadcast.boxcaster_id = "stream_source:rtmp:".concat(staticRtmpId);
    } else if (streamSource) {
      this.service.broadcast.boxcaster_id = "stream_source:".concat(streamSource);

      if (streamSource === 'recording' && sourceBroadcastId) {
        this.service.fromBroadcast(sourceBroadcastId);
      }
    }

    this.maxValidStep = 1;
    this.step = 1;
    this.showError = false;

    if (this.service.broadcast.$promise) {
      this.service.broadcast.$promise.then(function () {
        _this.fb.init();
      });
    } else {
      $timeout(function () {
        return _this.fb.init();
      }, 0);
    }

    $q.all([this.service.boxcasters.$promise, this.service.staticRTMPs.$promise]).then(function () {
      if (!_this.service.broadcast.boxcaster_id) {
        _this.service.chooseDefaultSourceForNewBroadcast();
      }
    });

    if (account.feature_flags.overlays && user.can('update', 'broadcast/*:metadata/overlays')) {
      this.loadOverlays();
    }

    this.loadingPromises = [this.service.boxcasters.$promise, this.service.channels.$promise]; // Auto-focus on page load

    setTimeout(function () {
      return $('#eventName').focus();
    }, 0);
  }

  _createClass(NewEventController, [{
    key: "loadOverlays",
    value: function loadOverlays() {
      var _this2 = this;

      var Overlays = this.Overlays,
          toaster = this.toaster;
      Overlays.loadOverlaysForPage(1).then(function (result) {
        _this2.overlays = result.uploads;
      })["catch"](function (err) {
        toaster.pop('info', 'Unable to load overlay image gallery.');
      });
    }
  }, {
    key: "selectOverlay",
    value: function selectOverlay(upload) {
      var _this3 = this;

      var Overlays = this.Overlays,
          toaster = this.toaster;
      var broadcast = this.service.broadcast;
      this.processingOverlay = true;
      Overlays.prepareUploadForOverlay(upload).then(function (overlay) {
        broadcast.metadata = broadcast.metadata || {};
        broadcast.metadata.overlays = [overlay];
        _this3.processingOverlay = false;
      })["catch"](function (err) {
        console.error(err);
        toaster.pop('warn', 'Unable to select overlay image.');
        _this3.processingOverlay = false;
      });
    }
  }, {
    key: "loginFacebook",
    value: function loginFacebook() {
      var _this4 = this;

      this.fb.login().then(function () {
        _this4.service.initializeEmptyFacebookAccountIDs();
      });
    }
  }, {
    key: "logoutFacebook",
    value: function logoutFacebook() {
      var _this5 = this;

      this.fb.logout().then(function () {
        return _this5.fb.init();
      });
    }
  }, {
    key: "toggleEntryMode",
    value: function toggleEntryMode() {
      this.wizard = !this.wizard;
      localStorage.setItem('wizard', this.wizard ? '1' : '0');
      this.$analytics.eventTrack("new-event-".concat(this.wizard ? 'wizard' : 'quick'), {
        category: 'toggle-entry-mode',
        label: ''
      });
    }
  }, {
    key: "validateCurrentTab",
    value: function validateCurrentTab() {
      this.service.errors = [];

      if (this.step == 1) {
        if (!this.service.validateOverview()) {
          this.$analytics.eventTrack("new-event-".concat(this.wizard ? 'wizard' : 'quick'), {
            category: 'validate-error',
            label: 'overview'
          });
          return false;
        }
      }

      if (this.step == 2) {
        if (!this.service.validateSchedule()) {
          this.$analytics.eventTrack("new-event-".concat(this.wizard ? 'wizard' : 'quick'), {
            category: 'validate-error',
            label: 'schedule'
          });
          return false;
        }

        if (this.recurring.enabled && this.recurring.end == 'after' && this.recurring.endCount > MAX_RECURRING_EVENTS) {
          this.$analytics.eventTrack("new-event-".concat(this.wizard ? 'wizard' : 'quick'), {
            category: 'validate-error',
            label: 'recurring'
          });
          return false;
        }
      }

      if (this.step == 3) {
        if (!this.service.validateScoreboard()) {
          this.$analytics.eventTrack("new-event-".concat(this.wizard ? 'wizard' : 'quick'), {
            category: 'validate-error',
            label: 'scoreboard'
          });
          return false;
        }
      }

      if (this.step == 4) {
        if (!this.service.validatePublish()) {
          this.$analytics.eventTrack("new-event-".concat(this.wizard ? 'wizard' : 'quick'), {
            category: 'validate-error',
            label: 'publish'
          });
          return false;
        }
      }

      return true;
    }
  }, {
    key: "prevTab",
    value: function prevTab() {
      this.step -= 1; // skip scoreboard tab if not available

      if (!this.service.showAnyScoreboards && this.step == 3) {
        this.step -= 1;
      }

      if (this.step < 1) {
        this.step = 1;
      }
    }
  }, {
    key: "nextTab",
    value: function nextTab() {
      if (!this.validateCurrentTab()) {
        this.showError = true;
        return;
      }

      this.showError = false;
      this.step += 1; // skip scoreboard tab if not available

      if (!this.service.showAnyScoreboards && this.step == 3) {
        this.step += 1;
      }

      if (this.step > 5) {
        this.step = 5;
      } // keep track of how far they've gone successfully (in case they go back)


      this.maxValidStep = Math.max(this.step, this.maxValidStep);
    }
  }, {
    key: "selectTab",
    value: function selectTab(idx) {
      if (this.maxValidStep > idx - 1) {
        this.step = idx;
      }
    }
  }, {
    key: "addSimulcastDestination",
    value: function addSimulcastDestination(d, params) {
      return this.service.addSimulcastDestination(d, params);
    }
  }, {
    key: "removeSimulcastDestination",
    value: function removeSimulcastDestination(d) {
      return this.service.removeSimulcastDestination(d);
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this6 = this;

      var $uibModal = this.$uibModal;

      var actuallySubmit = function actuallySubmit() {
        _this6.showError = false;
        _this6.submitting = true;

        if (_this6.recurring.enabled) {
          _this6.service.broadcast.recurrence = {
            interval: _this6.recurring.pattern,
            on_days: _this6.recurring.onDays,
            max: MAX_RECURRING_EVENTS,
            time_zone: _this6.currentTimezoneValue
          };

          if (_this6.recurring.end == 'after') {
            _this6.service.broadcast.recurrence.end_after_count = _this6.recurring.endCount || 1;
          } else if (_this6.recurring.end == 'on') {
            _this6.service.broadcast.recurrence.end_on_date = _this6.recurring.endDate;
          }
        }

        _this6.service.saveChanges().then(function (broadcast) {
          _this6.submitting = false;

          _this6.$analytics.eventTrack("new-event-".concat(_this6.wizard ? 'wizard' : 'quick'), {
            category: 'saved',
            label: ''
          });

          if (_this6.scheduleAgain) {
            console.log('Success! Copying this and doing another...', broadcast);

            _this6.toaster.pop({
              type: 'success',
              title: 'Successfully scheduled broadcast',
              body: 'You can now schedule another like it. The defaults have been filled in.'
            });

            _this6.$state.current.confirmOnExit = false;

            _this6.$state.go('new-event', {
              cloneId: broadcast.id
            }, {
              reload: true
            });
          } else {
            console.log('Success! Redirecting to view event...', broadcast);

            _this6.toaster.pop({
              type: 'success',
              title: 'Successfully scheduled broadcast'
            });

            _this6.$state.current.confirmOnExit = false;

            _this6.$state.go('events.detail', {
              id: broadcast.id
            });
          }

          _this6.$rootScope.$emit('sm-schedule-step', 2);
        })["catch"](function (error) {
          _this6.submitting = false;
          var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_0__utils_error__["a" /* errorDescriptionFromResponse */])(error);

          if (errorDetails == 'invalid') {
            _this6.showError = true;
            $('html, body').animate({
              scrollTop: 0
            });
          } else {
            console.error(error);
            alert('Unable to save broadcast. Please check your fields and try again.\n\n' + errorDetails);
          }

          _this6.$analytics.eventTrack("new-event-".concat(_this6.wizard ? 'wizard' : 'quick'), {
            category: 'error',
            label: errorDetails
          });
        });
      }; //end actuallySubmit


      if (this.service.conflictingEvents.length > 0) {
        var conflictingEvents = this.service.conflictingEvents;
        $uibModal.open({
          template: __webpack_require__(204),
          controller: function controller($scope, $uibModalInstance) {
            'ngInject';

            $scope.conflictingEvents = conflictingEvents;

            $scope.ok = function (result) {
              return $uibModalInstance.close(result);
            };

            $scope.close = function () {
              return $uibModalInstance.dismiss('cancel');
            };
          }
        }).result.then(actuallySubmit);
      } else {
        actuallySubmit();
      }
    }
  }]);

  return NewEventController;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rrule__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rruleset__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rrulestr__ = __webpack_require__(225);
/* unused harmony reexport rrulestr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(18);
/* unused harmony reexport Frequency */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__weekday__ = __webpack_require__(20);
/* unused harmony reexport Weekday */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__rrule__["c"]; });
/* unused harmony reexport RRuleSet */
/*!
 * rrule.js - Library for working with recurrence rules for calendar dates.
 * https://github.com/jakubroztocil/rrule
 *
 * Copyright 2010, Jakub Roztocil and Lars Schoning
 * Licenced under the BSD licence.
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 * Based on:
 * python-dateutil - Extensions to the standard Python datetime module.
 * Copyright (c) 2003-2011 - Gustavo Niemeyer <gustavo@niemeyer.net>
 * Copyright (c) 2012 - Tomi Pieviläinen <tomi.pievilainen@iki.fi>
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 */






/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__rrule__["c" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterresult__ = __webpack_require__(44);


/**
 * IterResult subclass that calls a callback function on each add,
 * and stops iterating when the callback returns false.
 */
var CallbackIterResult = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CallbackIterResult, _super);
    function CallbackIterResult(method, args, iterator) {
        var _this = _super.call(this, method, args) || this;
        _this.iterator = iterator;
        return _this;
    }
    CallbackIterResult.prototype.add = function (date) {
        if (this.iterator(date, this._result.length)) {
            this._result.push(date);
            return true;
        }
        return false;
    };
    return CallbackIterResult;
}(__WEBPACK_IMPORTED_MODULE_1__iterresult__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (CallbackIterResult);
//# sourceMappingURL=callbackiterresult.js.map

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isFullyConvertible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__totext__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsetext__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rrule__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(45);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__parsetext__["a"]; });





/*!
* rrule.js - Library for working with recurrence rules for calendar dates.
* https://github.com/jakubroztocil/rrule
*
* Copyright 2010, Jakub Roztocil and Lars Schoning
* Licenced under the BSD licence.
* https://github.com/jakubroztocil/rrule/blob/master/LICENCE
*
*/
/**
 *
 * Implementation of RRule.fromText() and RRule::toText().
 *
 *
 * On the client side, this file needs to be included
 * when those functions are used.
 *
 */
// =============================================================================
// fromText
// =============================================================================
/**
 * Will be able to convert some of the below described rules from
 * text format to a rule object.
 *
 *
 * RULES
 *
 * Every ([n])
 *       day(s)
 *     | [weekday], ..., (and) [weekday]
 *     | weekday(s)
 *     | week(s)
 *     | month(s)
 *     | [month], ..., (and) [month]
 *     | year(s)
 *
 *
 * Plus 0, 1, or multiple of these:
 *
 * on [weekday], ..., (or) [weekday] the [monthday], [monthday], ... (or) [monthday]
 *
 * on [weekday], ..., (and) [weekday]
 *
 * on the [monthday], [monthday], ... (and) [monthday] (day of the month)
 *
 * on the [nth-weekday], ..., (and) [nth-weekday] (of the month/year)
 *
 *
 * Plus 0 or 1 of these:
 *
 * for [n] time(s)
 *
 * until [date]
 *
 * Plus (.)
 *
 *
 * Definitely no supported for parsing:
 *
 * (for year):
 *     in week(s) [n], ..., (and) [n]
 *
 *     on the [yearday], ..., (and) [n] day of the year
 *     on day [yearday], ..., (and) [n]
 *
 *
 * NON-TERMINALS
 *
 * [n]: 1, 2 ..., one, two, three ..
 * [month]: January, February, March, April, May, ... December
 * [weekday]: Monday, ... Sunday
 * [nth-weekday]: first [weekday], 2nd [weekday], ... last [weekday], ...
 * [monthday]: first, 1., 2., 1st, 2nd, second, ... 31st, last day, 2nd last day, ..
 * [date]:
 *     [month] (0-31(,) ([year])),
 *     (the) 0-31.(1-12.([year])),
 *     (the) 0-31/(1-12/([year])),
 *     [weekday]
 *
 * [year]: 0000, 0001, ... 01, 02, ..
 *
 * Definitely not supported for parsing:
 *
 * [yearday]: first, 1., 2., 1st, 2nd, second, ... 366th, last day, 2nd last day, ..
 *
 * @param {String} text
 * @return {Object, Boolean} the rule, or null.
 */
var fromText = function (text, language) {
    if (language === void 0) { language = __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */]; }
    return new __WEBPACK_IMPORTED_MODULE_2__rrule__["c" /* default */](Object(__WEBPACK_IMPORTED_MODULE_1__parsetext__["a" /* default */])(text, language) || undefined);
};
var common = [
    'count',
    'until',
    'interval',
    'byweekday',
    'bymonthday',
    'bymonth'
];
__WEBPACK_IMPORTED_MODULE_0__totext__["a" /* default */].IMPLEMENTED = [];
__WEBPACK_IMPORTED_MODULE_0__totext__["a" /* default */].IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* Frequency */].HOURLY] = common;
__WEBPACK_IMPORTED_MODULE_0__totext__["a" /* default */].IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* Frequency */].MINUTELY] = common;
__WEBPACK_IMPORTED_MODULE_0__totext__["a" /* default */].IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* Frequency */].DAILY] = ['byhour'].concat(common);
__WEBPACK_IMPORTED_MODULE_0__totext__["a" /* default */].IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* Frequency */].WEEKLY] = common;
__WEBPACK_IMPORTED_MODULE_0__totext__["a" /* default */].IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* Frequency */].MONTHLY] = common;
__WEBPACK_IMPORTED_MODULE_0__totext__["a" /* default */].IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* Frequency */].YEARLY] = ['byweekno', 'byyearday'].concat(common);
// =============================================================================
// Export
// =============================================================================
var toText = function (rrule, gettext, language, dateFormatter) {
    return new __WEBPACK_IMPORTED_MODULE_0__totext__["a" /* default */](rrule, gettext, language, dateFormatter).toString();
};
var isFullyConvertible = __WEBPACK_IMPORTED_MODULE_0__totext__["a" /* default */].isFullyConvertible;

//# sourceMappingURL=index.js.map

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rrule__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(7);



// =============================================================================
// Helper functions
// =============================================================================
/**
 * Return true if a value is in an array
 */
var contains = function (arr, val) {
    return arr.indexOf(val) !== -1;
};
var defaultGetText = function (id) { return id.toString(); };
var defaultDateFormatter = function (year, month, day) { return month + " " + day + ", " + year; };
/**
 *
 * @param {RRule} rrule
 * Optional:
 * @param {Function} gettext function
 * @param {Object} language definition
 * @constructor
 */
var ToText = /** @class */ (function () {
    function ToText(rrule, gettext, language, dateFormatter) {
        if (gettext === void 0) { gettext = defaultGetText; }
        if (language === void 0) { language = __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */]; }
        if (dateFormatter === void 0) { dateFormatter = defaultDateFormatter; }
        this.text = [];
        this.language = language || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */];
        this.gettext = gettext;
        this.dateFormatter = dateFormatter;
        this.rrule = rrule;
        this.options = rrule.options;
        this.origOptions = rrule.origOptions;
        if (this.origOptions.bymonthday) {
            var bymonthday = [].concat(this.options.bymonthday);
            var bynmonthday = [].concat(this.options.bynmonthday);
            bymonthday.sort(function (a, b) { return a - b; });
            bynmonthday.sort(function (a, b) { return b - a; });
            // 1, 2, 3, .., -5, -4, -3, ..
            this.bymonthday = bymonthday.concat(bynmonthday);
            if (!this.bymonthday.length)
                this.bymonthday = null;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isPresent */])(this.origOptions.byweekday)) {
            var byweekday = !Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* isArray */])(this.origOptions.byweekday)
                ? [this.origOptions.byweekday]
                : this.origOptions.byweekday;
            var days = String(byweekday);
            this.byweekday = {
                allWeeks: byweekday.filter(function (weekday) {
                    return !weekday.n;
                }),
                someWeeks: byweekday.filter(function (weekday) {
                    return Boolean(weekday.n);
                }),
                isWeekdays: days.indexOf('MO') !== -1 &&
                    days.indexOf('TU') !== -1 &&
                    days.indexOf('WE') !== -1 &&
                    days.indexOf('TH') !== -1 &&
                    days.indexOf('FR') !== -1 &&
                    days.indexOf('SA') === -1 &&
                    days.indexOf('SU') === -1,
                isEveryDay: days.indexOf('MO') !== -1 &&
                    days.indexOf('TU') !== -1 &&
                    days.indexOf('WE') !== -1 &&
                    days.indexOf('TH') !== -1 &&
                    days.indexOf('FR') !== -1 &&
                    days.indexOf('SA') !== -1 &&
                    days.indexOf('SU') !== -1
            };
            var sortWeekDays = function (a, b) {
                return a.weekday - b.weekday;
            };
            this.byweekday.allWeeks.sort(sortWeekDays);
            this.byweekday.someWeeks.sort(sortWeekDays);
            if (!this.byweekday.allWeeks.length)
                this.byweekday.allWeeks = null;
            if (!this.byweekday.someWeeks.length)
                this.byweekday.someWeeks = null;
        }
        else {
            this.byweekday = null;
        }
    }
    /**
     * Test whether the rrule can be fully converted to text.
     * @param {RRule} rrule
     * @return {Boolean}
     */
    ToText.isFullyConvertible = function (rrule) {
        var canConvert = true;
        if (!(rrule.options.freq in ToText.IMPLEMENTED))
            return false;
        if (rrule.origOptions.until && rrule.origOptions.count)
            return false;
        for (var key in rrule.origOptions) {
            if (contains(['dtstart', 'wkst', 'freq'], key))
                return true;
            if (!contains(ToText.IMPLEMENTED[rrule.options.freq], key))
                return false;
        }
        return canConvert;
    };
    ToText.prototype.isFullyConvertible = function () {
        return ToText.isFullyConvertible(this.rrule);
    };
    /**
     * Perform the conversion. Only some of the frequencies are supported.
     * If some of the rrule's options aren't supported, they'll
     * be omitted from the output an "(~ approximate)" will be appended.
     * @return {*}
     */
    ToText.prototype.toString = function () {
        var gettext = this.gettext;
        if (!(this.options.freq in ToText.IMPLEMENTED)) {
            return gettext('RRule error: Unable to fully convert this rrule to text');
        }
        this.text = [gettext('every')];
        // @ts-ignore
        this[__WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].FREQUENCIES[this.options.freq]]();
        if (this.options.until) {
            this.add(gettext('until'));
            var until = this.options.until;
            this.add(this.dateFormatter(until.getUTCFullYear(), this.language.monthNames[until.getUTCMonth()], until.getUTCDate()));
        }
        else if (this.options.count) {
            this.add(gettext('for'))
                .add(this.options.count.toString())
                .add(this.plural(this.options.count) ? gettext('times') : gettext('time'));
        }
        if (!this.isFullyConvertible())
            this.add(gettext('(~ approximate)'));
        return this.text.join('');
    };
    ToText.prototype.HOURLY = function () {
        var gettext = this.gettext;
        if (this.options.interval !== 1)
            this.add(this.options.interval.toString());
        this.add(this.plural(this.options.interval) ? gettext('hours') : gettext('hour'));
    };
    ToText.prototype.MINUTELY = function () {
        var gettext = this.gettext;
        if (this.options.interval !== 1)
            this.add(this.options.interval.toString());
        this.add(this.plural(this.options.interval)
            ? gettext('minutes')
            : gettext('minute'));
    };
    ToText.prototype.DAILY = function () {
        var gettext = this.gettext;
        if (this.options.interval !== 1)
            this.add(this.options.interval.toString());
        if (this.byweekday && this.byweekday.isWeekdays) {
            this.add(this.plural(this.options.interval)
                ? gettext('weekdays')
                : gettext('weekday'));
        }
        else {
            this.add(this.plural(this.options.interval) ? gettext('days') : gettext('day'));
        }
        if (this.origOptions.bymonth) {
            this.add(gettext('in'));
            this._bymonth();
        }
        if (this.bymonthday) {
            this._bymonthday();
        }
        else if (this.byweekday) {
            this._byweekday();
        }
        else if (this.origOptions.byhour) {
            this._byhour();
        }
    };
    ToText.prototype.WEEKLY = function () {
        var gettext = this.gettext;
        if (this.options.interval !== 1) {
            this.add(this.options.interval.toString()).add(this.plural(this.options.interval) ? gettext('weeks') : gettext('week'));
        }
        if (this.byweekday && this.byweekday.isWeekdays) {
            if (this.options.interval === 1) {
                this.add(this.plural(this.options.interval)
                    ? gettext('weekdays')
                    : gettext('weekday'));
            }
            else {
                this.add(gettext('on')).add(gettext('weekdays'));
            }
        }
        else if (this.byweekday && this.byweekday.isEveryDay) {
            this.add(this.plural(this.options.interval) ? gettext('days') : gettext('day'));
        }
        else {
            if (this.options.interval === 1)
                this.add(gettext('week'));
            if (this.origOptions.bymonth) {
                this.add(gettext('in'));
                this._bymonth();
            }
            if (this.bymonthday) {
                this._bymonthday();
            }
            else if (this.byweekday) {
                this._byweekday();
            }
        }
    };
    ToText.prototype.MONTHLY = function () {
        var gettext = this.gettext;
        if (this.origOptions.bymonth) {
            if (this.options.interval !== 1) {
                this.add(this.options.interval.toString()).add(gettext('months'));
                if (this.plural(this.options.interval))
                    this.add(gettext('in'));
            }
            else {
                // this.add(gettext('MONTH'))
            }
            this._bymonth();
        }
        else {
            if (this.options.interval !== 1)
                this.add(this.options.interval.toString());
            this.add(this.plural(this.options.interval)
                ? gettext('months')
                : gettext('month'));
        }
        if (this.bymonthday) {
            this._bymonthday();
        }
        else if (this.byweekday && this.byweekday.isWeekdays) {
            this.add(gettext('on')).add(gettext('weekdays'));
        }
        else if (this.byweekday) {
            this._byweekday();
        }
    };
    ToText.prototype.YEARLY = function () {
        var gettext = this.gettext;
        if (this.origOptions.bymonth) {
            if (this.options.interval !== 1) {
                this.add(this.options.interval.toString());
                this.add(gettext('years'));
            }
            else {
                // this.add(gettext('YEAR'))
            }
            this._bymonth();
        }
        else {
            if (this.options.interval !== 1)
                this.add(this.options.interval.toString());
            this.add(this.plural(this.options.interval) ? gettext('years') : gettext('year'));
        }
        if (this.bymonthday) {
            this._bymonthday();
        }
        else if (this.byweekday) {
            this._byweekday();
        }
        if (this.options.byyearday) {
            this.add(gettext('on the'))
                .add(this.list(this.options.byyearday, this.nth, gettext('and')))
                .add(gettext('day'));
        }
        if (this.options.byweekno) {
            this.add(gettext('in'))
                .add(this.plural(this.options.byweekno.length)
                ? gettext('weeks')
                : gettext('week'))
                .add(this.list(this.options.byweekno, undefined, gettext('and')));
        }
    };
    ToText.prototype._bymonthday = function () {
        var gettext = this.gettext;
        if (this.byweekday && this.byweekday.allWeeks) {
            this.add(gettext('on'))
                .add(this.list(this.byweekday.allWeeks, this.weekdaytext, gettext('or')))
                .add(gettext('the'))
                .add(this.list(this.bymonthday, this.nth, gettext('or')));
        }
        else {
            this.add(gettext('on the')).add(this.list(this.bymonthday, this.nth, gettext('and')));
        }
        // this.add(gettext('DAY'))
    };
    ToText.prototype._byweekday = function () {
        var gettext = this.gettext;
        if (this.byweekday.allWeeks && !this.byweekday.isWeekdays) {
            this.add(gettext('on')).add(this.list(this.byweekday.allWeeks, this.weekdaytext));
        }
        if (this.byweekday.someWeeks) {
            if (this.byweekday.allWeeks)
                this.add(gettext('and'));
            this.add(gettext('on the')).add(this.list(this.byweekday.someWeeks, this.weekdaytext, gettext('and')));
        }
    };
    ToText.prototype._byhour = function () {
        var gettext = this.gettext;
        this.add(gettext('at')).add(this.list(this.origOptions.byhour, undefined, gettext('and')));
    };
    ToText.prototype._bymonth = function () {
        this.add(this.list(this.options.bymonth, this.monthtext, this.gettext('and')));
    };
    ToText.prototype.nth = function (n) {
        n = parseInt(n.toString(), 10);
        var nth;
        var npos;
        var gettext = this.gettext;
        if (n === -1)
            return gettext('last');
        npos = Math.abs(n);
        switch (npos) {
            case 1:
            case 21:
            case 31:
                nth = npos + gettext('st');
                break;
            case 2:
            case 22:
                nth = npos + gettext('nd');
                break;
            case 3:
            case 23:
                nth = npos + gettext('rd');
                break;
            default:
                nth = npos + gettext('th');
        }
        return n < 0 ? nth + ' ' + gettext('last') : nth;
    };
    ToText.prototype.monthtext = function (m) {
        return this.language.monthNames[m - 1];
    };
    ToText.prototype.weekdaytext = function (wday) {
        var weekday = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["e" /* isNumber */])(wday) ? (wday + 1) % 7 : wday.getJsWeekday();
        return ((wday.n ? this.nth(wday.n) + ' ' : '') + this.language.dayNames[weekday]);
    };
    ToText.prototype.plural = function (n) {
        return n % 100 !== 1;
    };
    ToText.prototype.add = function (s) {
        this.text.push(' ');
        this.text.push(s);
        return this;
    };
    ToText.prototype.list = function (arr, callback, finalDelim, delim) {
        if (delim === void 0) { delim = ','; }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* isArray */])(arr)) {
            arr = [arr];
        }
        var delimJoin = function (array, delimiter, finalDelimiter) {
            var list = '';
            for (var i = 0; i < array.length; i++) {
                if (i !== 0) {
                    if (i === array.length - 1) {
                        list += ' ' + finalDelimiter + ' ';
                    }
                    else {
                        list += delimiter + ' ';
                    }
                }
                list += array[i];
            }
            return list;
        };
        callback =
            callback ||
                function (o) {
                    return o.toString();
                };
        var self = this;
        var realCallback = function (arg) {
            return callback && callback.call(self, arg);
        };
        if (finalDelim) {
            return delimJoin(arr.map(realCallback), delim, finalDelim);
        }
        else {
            return arr.map(realCallback).join(delim + ' ');
        }
    };
    return ToText;
}());
/* harmony default export */ __webpack_exports__["a"] = (ToText);
//# sourceMappingURL=totext.js.map

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rrule__ = __webpack_require__(11);


// =============================================================================
// Parser
// =============================================================================
var Parser = /** @class */ (function () {
    function Parser(rules) {
        this.done = true;
        this.rules = rules;
    }
    Parser.prototype.start = function (text) {
        this.text = text;
        this.done = false;
        return this.nextSymbol();
    };
    Parser.prototype.isDone = function () {
        return this.done && this.symbol === null;
    };
    Parser.prototype.nextSymbol = function () {
        var best;
        var bestSymbol;
        var p = this;
        this.symbol = null;
        this.value = null;
        do {
            if (this.done)
                return false;
            var rule = void 0;
            best = null;
            for (var name_1 in this.rules) {
                rule = this.rules[name_1];
                var match = rule.exec(p.text);
                if (match) {
                    if (best === null || match[0].length > best[0].length) {
                        best = match;
                        bestSymbol = name_1;
                    }
                }
            }
            if (best != null) {
                this.text = this.text.substr(best[0].length);
                if (this.text === '')
                    this.done = true;
            }
            if (best == null) {
                this.done = true;
                this.symbol = null;
                this.value = null;
                return;
            }
            // @ts-ignore
        } while (bestSymbol === 'SKIP');
        // @ts-ignore
        this.symbol = bestSymbol;
        this.value = best;
        return true;
    };
    Parser.prototype.accept = function (name) {
        if (this.symbol === name) {
            if (this.value) {
                var v = this.value;
                this.nextSymbol();
                return v;
            }
            this.nextSymbol();
            return true;
        }
        return false;
    };
    Parser.prototype.acceptNumber = function () {
        return this.accept('number');
    };
    Parser.prototype.expect = function (name) {
        if (this.accept(name))
            return true;
        throw new Error('expected ' + name + ' but found ' + this.symbol);
    };
    return Parser;
}());
function parseText(text, language) {
    if (language === void 0) { language = __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */]; }
    var options = {};
    var ttr = new Parser(language.tokens);
    if (!ttr.start(text))
        return null;
    S();
    return options;
    function S() {
        // every [n]
        ttr.expect('every');
        var n = ttr.acceptNumber();
        if (n)
            options.interval = parseInt(n[0], 10);
        if (ttr.isDone())
            throw new Error('Unexpected end');
        switch (ttr.symbol) {
            case 'day(s)':
                options.freq = __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].DAILY;
                if (ttr.nextSymbol()) {
                    AT();
                    F();
                }
                break;
            // FIXME Note: every 2 weekdays != every two weeks on weekdays.
            // DAILY on weekdays is not a valid rule
            case 'weekday(s)':
                options.freq = __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].WEEKLY;
                options.byweekday = [
                    __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].MO,
                    __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].TU,
                    __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].WE,
                    __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].TH,
                    __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].FR
                ];
                ttr.nextSymbol();
                F();
                break;
            case 'week(s)':
                options.freq = __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].WEEKLY;
                if (ttr.nextSymbol()) {
                    ON();
                    F();
                }
                break;
            case 'hour(s)':
                options.freq = __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].HOURLY;
                if (ttr.nextSymbol()) {
                    ON();
                    F();
                }
                break;
            case 'minute(s)':
                options.freq = __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].MINUTELY;
                if (ttr.nextSymbol()) {
                    ON();
                    F();
                }
                break;
            case 'month(s)':
                options.freq = __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].MONTHLY;
                if (ttr.nextSymbol()) {
                    ON();
                    F();
                }
                break;
            case 'year(s)':
                options.freq = __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].YEARLY;
                if (ttr.nextSymbol()) {
                    ON();
                    F();
                }
                break;
            case 'monday':
            case 'tuesday':
            case 'wednesday':
            case 'thursday':
            case 'friday':
            case 'saturday':
            case 'sunday':
                options.freq = __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].WEEKLY;
                var key = ttr.symbol.substr(0, 2).toUpperCase();
                options.byweekday = [__WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */][key]];
                if (!ttr.nextSymbol())
                    return;
                // TODO check for duplicates
                while (ttr.accept('comma')) {
                    if (ttr.isDone())
                        throw new Error('Unexpected end');
                    var wkd = decodeWKD();
                    if (!wkd) {
                        throw new Error('Unexpected symbol ' + ttr.symbol + ', expected weekday');
                    }
                    // @ts-ignore
                    options.byweekday.push(__WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */][wkd]);
                    ttr.nextSymbol();
                }
                MDAYs();
                F();
                break;
            case 'january':
            case 'february':
            case 'march':
            case 'april':
            case 'may':
            case 'june':
            case 'july':
            case 'august':
            case 'september':
            case 'october':
            case 'november':
            case 'december':
                options.freq = __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].YEARLY;
                options.bymonth = [decodeM()];
                if (!ttr.nextSymbol())
                    return;
                // TODO check for duplicates
                while (ttr.accept('comma')) {
                    if (ttr.isDone())
                        throw new Error('Unexpected end');
                    var m = decodeM();
                    if (!m) {
                        throw new Error('Unexpected symbol ' + ttr.symbol + ', expected month');
                    }
                    options.bymonth.push(m);
                    ttr.nextSymbol();
                }
                ON();
                F();
                break;
            default:
                throw new Error('Unknown symbol');
        }
    }
    function ON() {
        var on = ttr.accept('on');
        var the = ttr.accept('the');
        if (!(on || the))
            return;
        do {
            var nth = decodeNTH();
            var wkd = decodeWKD();
            var m = decodeM();
            // nth <weekday> | <weekday>
            if (nth) {
                // ttr.nextSymbol()
                if (wkd) {
                    ttr.nextSymbol();
                    if (!options.byweekday)
                        options.byweekday = [];
                    // @ts-ignore
                    options.byweekday.push(__WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */][wkd].nth(nth));
                }
                else {
                    if (!options.bymonthday)
                        options.bymonthday = [];
                    // @ts-ignore
                    options.bymonthday.push(nth);
                    ttr.accept('day(s)');
                }
                // <weekday>
            }
            else if (wkd) {
                ttr.nextSymbol();
                if (!options.byweekday)
                    options.byweekday = [];
                // @ts-ignore
                options.byweekday.push(__WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */][wkd]);
            }
            else if (ttr.symbol === 'weekday(s)') {
                ttr.nextSymbol();
                if (!options.byweekday) {
                    options.byweekday = [
                        __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].MO,
                        __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].TU,
                        __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].WE,
                        __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].TH,
                        __WEBPACK_IMPORTED_MODULE_1__rrule__["c" /* default */].FR
                    ];
                }
            }
            else if (ttr.symbol === 'week(s)') {
                ttr.nextSymbol();
                var n = ttr.acceptNumber();
                if (!n) {
                    throw new Error('Unexpected symbol ' + ttr.symbol + ', expected week number');
                }
                options.byweekno = [parseInt(n[0], 10)];
                while (ttr.accept('comma')) {
                    n = ttr.acceptNumber();
                    if (!n) {
                        throw new Error('Unexpected symbol ' + ttr.symbol + '; expected monthday');
                    }
                    options.byweekno.push(parseInt(n[0], 10));
                }
            }
            else if (m) {
                ttr.nextSymbol();
                if (!options.bymonth)
                    options.bymonth = [];
                // @ts-ignore
                options.bymonth.push(m);
            }
            else {
                return;
            }
        } while (ttr.accept('comma') || ttr.accept('the') || ttr.accept('on'));
    }
    function AT() {
        var at = ttr.accept('at');
        if (!at)
            return;
        do {
            var n = ttr.acceptNumber();
            if (!n) {
                throw new Error('Unexpected symbol ' + ttr.symbol + ', expected hour');
            }
            options.byhour = [parseInt(n[0], 10)];
            while (ttr.accept('comma')) {
                n = ttr.acceptNumber();
                if (!n) {
                    throw new Error('Unexpected symbol ' + ttr.symbol + '; expected hour');
                }
                options.byhour.push(parseInt(n[0], 10));
            }
        } while (ttr.accept('comma') || ttr.accept('at'));
    }
    function decodeM() {
        switch (ttr.symbol) {
            case 'january':
                return 1;
            case 'february':
                return 2;
            case 'march':
                return 3;
            case 'april':
                return 4;
            case 'may':
                return 5;
            case 'june':
                return 6;
            case 'july':
                return 7;
            case 'august':
                return 8;
            case 'september':
                return 9;
            case 'october':
                return 10;
            case 'november':
                return 11;
            case 'december':
                return 12;
            default:
                return false;
        }
    }
    function decodeWKD() {
        switch (ttr.symbol) {
            case 'monday':
            case 'tuesday':
            case 'wednesday':
            case 'thursday':
            case 'friday':
            case 'saturday':
            case 'sunday':
                return ttr.symbol.substr(0, 2).toUpperCase();
            default:
                return false;
        }
    }
    function decodeNTH() {
        switch (ttr.symbol) {
            case 'last':
                ttr.nextSymbol();
                return -1;
            case 'first':
                ttr.nextSymbol();
                return 1;
            case 'second':
                ttr.nextSymbol();
                return ttr.accept('last') ? -2 : 2;
            case 'third':
                ttr.nextSymbol();
                return ttr.accept('last') ? -3 : 3;
            case 'nth':
                var v = parseInt(ttr.value[1], 10);
                if (v < -366 || v > 366)
                    throw new Error('Nth out of range: ' + v);
                ttr.nextSymbol();
                return ttr.accept('last') ? -v : v;
            default:
                return false;
        }
    }
    function MDAYs() {
        ttr.accept('on');
        ttr.accept('the');
        var nth = decodeNTH();
        if (!nth)
            return;
        options.bymonthday = [nth];
        ttr.nextSymbol();
        while (ttr.accept('comma')) {
            nth = decodeNTH();
            if (!nth) {
                throw new Error('Unexpected symbol ' + ttr.symbol + '; expected monthday');
            }
            options.bymonthday.push(nth);
            ttr.nextSymbol();
        }
    }
    function F() {
        if (ttr.symbol === 'until') {
            var date = Date.parse(ttr.text);
            if (!date)
                throw new Error('Cannot parse until date:' + ttr.text);
            options.until = new Date(date);
        }
        else if (ttr.accept('for')) {
            options.count = parseInt(ttr.value[0], 10);
            ttr.expect('number');
            // ttr.expect('times')
        }
    }
}
//# sourceMappingURL=parsetext.js.map

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o) {
  var i = 0;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  i = o[Symbol.iterator]();
  return i.next.bind(i);
}

// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
var LuxonError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(LuxonError, _Error);

  function LuxonError() {
    return _Error.apply(this, arguments) || this;
  }

  return LuxonError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * @private
 */


var InvalidDateTimeError = /*#__PURE__*/function (_LuxonError) {
  _inheritsLoose(InvalidDateTimeError, _LuxonError);

  function InvalidDateTimeError(reason) {
    return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
  }

  return InvalidDateTimeError;
}(LuxonError);
/**
 * @private
 */

var InvalidIntervalError = /*#__PURE__*/function (_LuxonError2) {
  _inheritsLoose(InvalidIntervalError, _LuxonError2);

  function InvalidIntervalError(reason) {
    return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
  }

  return InvalidIntervalError;
}(LuxonError);
/**
 * @private
 */

var InvalidDurationError = /*#__PURE__*/function (_LuxonError3) {
  _inheritsLoose(InvalidDurationError, _LuxonError3);

  function InvalidDurationError(reason) {
    return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
  }

  return InvalidDurationError;
}(LuxonError);
/**
 * @private
 */

var ConflictingSpecificationError = /*#__PURE__*/function (_LuxonError4) {
  _inheritsLoose(ConflictingSpecificationError, _LuxonError4);

  function ConflictingSpecificationError() {
    return _LuxonError4.apply(this, arguments) || this;
  }

  return ConflictingSpecificationError;
}(LuxonError);
/**
 * @private
 */

var InvalidUnitError = /*#__PURE__*/function (_LuxonError5) {
  _inheritsLoose(InvalidUnitError, _LuxonError5);

  function InvalidUnitError(unit) {
    return _LuxonError5.call(this, "Invalid unit " + unit) || this;
  }

  return InvalidUnitError;
}(LuxonError);
/**
 * @private
 */

var InvalidArgumentError = /*#__PURE__*/function (_LuxonError6) {
  _inheritsLoose(InvalidArgumentError, _LuxonError6);

  function InvalidArgumentError() {
    return _LuxonError6.apply(this, arguments) || this;
  }

  return InvalidArgumentError;
}(LuxonError);
/**
 * @private
 */

var ZoneIsAbstractError = /*#__PURE__*/function (_LuxonError7) {
  _inheritsLoose(ZoneIsAbstractError, _LuxonError7);

  function ZoneIsAbstractError() {
    return _LuxonError7.call(this, "Zone is an abstract class") || this;
  }

  return ZoneIsAbstractError;
}(LuxonError);

/**
 * @private
 */
var n = "numeric",
    s = "short",
    l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hour12: false
};
/**
 * {@link toLocaleString}; format like '09:30:23', always 24-hour.
 */

var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hour12: false
};
/**
 * {@link toLocaleString}; format like '09:30:23 EDT', always 24-hour.
 */

var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hour12: false,
  timeZoneName: s
};
/**
 * {@link toLocaleString}; format like '09:30:23 Eastern Daylight Time', always 24-hour.
 */

var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hour12: false,
  timeZoneName: l
};
/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
 */

var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
 */

var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};

/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/
/**
 * @private
 */
// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
  return typeof o === "string";
}
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
} // CAPABILITIES

function hasIntl() {
  try {
    return typeof Intl !== "undefined" && Intl.DateTimeFormat;
  } catch (e) {
    return false;
  }
}
function hasFormatToParts() {
  return !isUndefined(Intl.DateTimeFormat.prototype.formatToParts);
}
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
} // OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }

  return arr.reduce(function (best, next) {
    var pair = [by(next), next];

    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce(function (a, k) {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
} // NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
} // x % n but takes the sign of n instead of x

function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}
function padStart(input, n) {
  if (n === void 0) {
    n = 2;
  }

  var minus = input < 0 ? "-" : "";
  var target = minus ? input * -1 : input;
  var result;

  if (target.toString().length < n) {
    result = ("0".repeat(n) + target).slice(-n);
  } else {
    result = target.toString();
  }

  return "" + minus + result;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}
function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    var f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}
function roundTo(number, digits, towardZero) {
  if (towardZero === void 0) {
    towardZero = false;
  }

  var factor = Math.pow(10, digits),
      rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
} // DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  var modMonth = floorMod(month - 1, 12) + 1,
      modYear = year + (month - modMonth) / 12;

  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)

function objToLocalTS(obj) {
  var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that

  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }

  return +d;
}
function weeksInWeekYear(weekYear) {
  var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7,
      last = weekYear - 1,
      p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
  return p1 === 4 || p2 === 3 ? 53 : 52;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > 60 ? 1900 + year : 2000 + year;
} // PARSING

function parseZoneInfo(ts, offsetFormat, locale, timeZone) {
  if (timeZone === void 0) {
    timeZone = null;
  }

  var date = new Date(ts),
      intlOpts = {
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };

  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }

  var modified = Object.assign({
    timeZoneName: offsetFormat
  }, intlOpts),
      intl = hasIntl();

  if (intl && hasFormatToParts()) {
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function (m) {
      return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
  } else if (intl) {
    // this probably doesn't work for all locales
    var without = new Intl.DateTimeFormat(locale, intlOpts).format(date),
        included = new Intl.DateTimeFormat(locale, modified).format(date),
        diffed = included.substring(without.length),
        trimmed = diffed.replace(/^[, \u200e]+/, "");
    return trimmed;
  } else {
    return null;
  }
} // signedOffset('-5', '30') -> -330

function signedOffset(offHourStr, offMinuteStr) {
  var offHour = parseInt(offHourStr, 10); // don't || this because we want to preserve -0

  if (Number.isNaN(offHour)) {
    offHour = 0;
  }

  var offMin = parseInt(offMinuteStr, 10) || 0,
      offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
} // COERCION

function asNumber(value) {
  var numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError("Invalid unit value " + value);
  return numericValue;
}
function normalizeObject(obj, normalizer, nonUnitKeys) {
  var normalized = {};

  for (var u in obj) {
    if (hasOwnProperty(obj, u)) {
      if (nonUnitKeys.indexOf(u) >= 0) continue;
      var v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }

  return normalized;
}
function formatOffset(offset, format) {
  var hours = Math.trunc(Math.abs(offset / 60)),
      minutes = Math.trunc(Math.abs(offset % 60)),
      sign = offset >= 0 ? "+" : "-";

  switch (format) {
    case "short":
      return "" + sign + padStart(hours, 2) + ":" + padStart(minutes, 2);

    case "narrow":
      return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");

    case "techie":
      return "" + sign + padStart(hours, 2) + padStart(minutes, 2);

    default:
      throw new RangeError("Value format " + format + " is out of range for property format");
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}
var ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?/;

function stringify(obj) {
  return JSON.stringify(obj, Object.keys(obj).sort());
}
/**
 * @private
 */


var monthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [].concat(monthsNarrow);

    case "short":
      return [].concat(monthsShort);

    case "long":
      return [].concat(monthsLong);

    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

    default:
      return null;
  }
}
var weekdaysLong = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
var weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
var weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [].concat(weekdaysNarrow);

    case "short":
      return [].concat(weekdaysShort);

    case "long":
      return [].concat(weekdaysLong);

    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];

    default:
      return null;
  }
}
var meridiems = ["AM", "PM"];
var erasLong = ["Before Christ", "Anno Domini"];
var erasShort = ["BC", "AD"];
var erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [].concat(erasNarrow);

    case "short":
      return [].concat(erasShort);

    case "long":
      return [].concat(erasLong);

    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric, narrow) {
  if (numeric === void 0) {
    numeric = "always";
  }

  if (narrow === void 0) {
    narrow = false;
  }

  var units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  var lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;

  if (numeric === "auto" && lastable) {
    var isDay = unit === "days";

    switch (count) {
      case 1:
        return isDay ? "tomorrow" : "next " + units[unit][0];

      case -1:
        return isDay ? "yesterday" : "last " + units[unit][0];

      case 0:
        return isDay ? "today" : "this " + units[unit][0];

    }
  }

  var isInPast = Object.is(count, -0) || count < 0,
      fmtValue = Math.abs(count),
      singular = fmtValue === 1,
      lilUnits = units[unit],
      fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function formatString(knownFormat) {
  // these all have the offsets removed because we don't have access to them
  // without all the intl stuff this is backfilling
  var filtered = pick(knownFormat, ["weekday", "era", "year", "month", "day", "hour", "minute", "second", "timeZoneName", "hour12"]),
      key = stringify(filtered),
      dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";

  switch (key) {
    case stringify(DATE_SHORT):
      return "M/d/yyyy";

    case stringify(DATE_MED):
      return "LLL d, yyyy";

    case stringify(DATE_MED_WITH_WEEKDAY):
      return "EEE, LLL d, yyyy";

    case stringify(DATE_FULL):
      return "LLLL d, yyyy";

    case stringify(DATE_HUGE):
      return "EEEE, LLLL d, yyyy";

    case stringify(TIME_SIMPLE):
      return "h:mm a";

    case stringify(TIME_WITH_SECONDS):
      return "h:mm:ss a";

    case stringify(TIME_WITH_SHORT_OFFSET):
      return "h:mm a";

    case stringify(TIME_WITH_LONG_OFFSET):
      return "h:mm a";

    case stringify(TIME_24_SIMPLE):
      return "HH:mm";

    case stringify(TIME_24_WITH_SECONDS):
      return "HH:mm:ss";

    case stringify(TIME_24_WITH_SHORT_OFFSET):
      return "HH:mm";

    case stringify(TIME_24_WITH_LONG_OFFSET):
      return "HH:mm";

    case stringify(DATETIME_SHORT):
      return "M/d/yyyy, h:mm a";

    case stringify(DATETIME_MED):
      return "LLL d, yyyy, h:mm a";

    case stringify(DATETIME_FULL):
      return "LLLL d, yyyy, h:mm a";

    case stringify(DATETIME_HUGE):
      return dateTimeHuge;

    case stringify(DATETIME_SHORT_WITH_SECONDS):
      return "M/d/yyyy, h:mm:ss a";

    case stringify(DATETIME_MED_WITH_SECONDS):
      return "LLL d, yyyy, h:mm:ss a";

    case stringify(DATETIME_MED_WITH_WEEKDAY):
      return "EEE, d LLL yyyy, h:mm a";

    case stringify(DATETIME_FULL_WITH_SECONDS):
      return "LLLL d, yyyy, h:mm:ss a";

    case stringify(DATETIME_HUGE_WITH_SECONDS):
      return "EEEE, LLLL d, yyyy, h:mm:ss a";

    default:
      return dateTimeHuge;
  }
}

function stringifyTokens(splits, tokenToString) {
  var s = "";

  for (var _iterator = _createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;) {
    var token = _step.value;

    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }

  return s;
}

var _macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */

var Formatter = /*#__PURE__*/function () {
  Formatter.create = function create(locale, opts) {
    if (opts === void 0) {
      opts = {};
    }

    return new Formatter(locale, opts);
  };

  Formatter.parseFormat = function parseFormat(fmt) {
    var current = null,
        currentFull = "",
        bracketed = false;
    var splits = [];

    for (var i = 0; i < fmt.length; i++) {
      var c = fmt.charAt(i);

      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({
            literal: bracketed,
            val: currentFull
          });
        }

        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({
            literal: false,
            val: currentFull
          });
        }

        currentFull = c;
        current = c;
      }
    }

    if (currentFull.length > 0) {
      splits.push({
        literal: bracketed,
        val: currentFull
      });
    }

    return splits;
  };

  Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
    return _macroTokenToFormatOpts[token];
  };

  function Formatter(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }

  var _proto = Formatter.prototype;

  _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }

    var df = this.systemLoc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.format();
  };

  _proto.formatDateTime = function formatDateTime(dt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.format();
  };

  _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.formatToParts();
  };

  _proto.resolvedOptions = function resolvedOptions(dt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.resolvedOptions();
  };

  _proto.num = function num(n, p) {
    if (p === void 0) {
      p = 0;
    }

    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }

    var opts = Object.assign({}, this.opts);

    if (p > 0) {
      opts.padTo = p;
    }

    return this.loc.numberFormatter(opts).format(n);
  };

  _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
    var _this = this;

    var knownEnglish = this.loc.listingMode() === "en",
        useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory" && hasFormatToParts(),
        string = function string(opts, extract) {
      return _this.loc.extract(dt, opts, extract);
    },
        formatOffset = function formatOffset(opts) {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }

      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    },
        meridiem = function meridiem() {
      return knownEnglish ? meridiemForDateTime(dt) : string({
        hour: "numeric",
        hour12: true
      }, "dayperiod");
    },
        month = function month(length, standalone) {
      return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
        month: length
      } : {
        month: length,
        day: "numeric"
      }, "month");
    },
        weekday = function weekday(length, standalone) {
      return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
        weekday: length
      } : {
        weekday: length,
        month: "long",
        day: "numeric"
      }, "weekday");
    },
        maybeMacro = function maybeMacro(token) {
      var formatOpts = Formatter.macroTokenToFormatOpts(token);

      if (formatOpts) {
        return _this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    },
        era = function era(length) {
      return knownEnglish ? eraForDateTime(dt, length) : string({
        era: length
      }, "era");
    },
        tokenToString = function tokenToString(token) {
      // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
      switch (token) {
        // ms
        case "S":
          return _this.num(dt.millisecond);

        case "u": // falls through

        case "SSS":
          return _this.num(dt.millisecond, 3);
        // seconds

        case "s":
          return _this.num(dt.second);

        case "ss":
          return _this.num(dt.second, 2);
        // minutes

        case "m":
          return _this.num(dt.minute);

        case "mm":
          return _this.num(dt.minute, 2);
        // hours

        case "h":
          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);

        case "hh":
          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);

        case "H":
          return _this.num(dt.hour);

        case "HH":
          return _this.num(dt.hour, 2);
        // offset

        case "Z":
          // like +6
          return formatOffset({
            format: "narrow",
            allowZ: _this.opts.allowZ
          });

        case "ZZ":
          // like +06:00
          return formatOffset({
            format: "short",
            allowZ: _this.opts.allowZ
          });

        case "ZZZ":
          // like +0600
          return formatOffset({
            format: "techie",
            allowZ: _this.opts.allowZ
          });

        case "ZZZZ":
          // like EST
          return dt.zone.offsetName(dt.ts, {
            format: "short",
            locale: _this.loc.locale
          });

        case "ZZZZZ":
          // like Eastern Standard Time
          return dt.zone.offsetName(dt.ts, {
            format: "long",
            locale: _this.loc.locale
          });
        // zone

        case "z":
          // like America/New_York
          return dt.zoneName;
        // meridiems

        case "a":
          return meridiem();
        // dates

        case "d":
          return useDateTimeFormatter ? string({
            day: "numeric"
          }, "day") : _this.num(dt.day);

        case "dd":
          return useDateTimeFormatter ? string({
            day: "2-digit"
          }, "day") : _this.num(dt.day, 2);
        // weekdays - standalone

        case "c":
          // like 1
          return _this.num(dt.weekday);

        case "ccc":
          // like 'Tues'
          return weekday("short", true);

        case "cccc":
          // like 'Tuesday'
          return weekday("long", true);

        case "ccccc":
          // like 'T'
          return weekday("narrow", true);
        // weekdays - format

        case "E":
          // like 1
          return _this.num(dt.weekday);

        case "EEE":
          // like 'Tues'
          return weekday("short", false);

        case "EEEE":
          // like 'Tuesday'
          return weekday("long", false);

        case "EEEEE":
          // like 'T'
          return weekday("narrow", false);
        // months - standalone

        case "L":
          // like 1
          return useDateTimeFormatter ? string({
            month: "numeric",
            day: "numeric"
          }, "month") : _this.num(dt.month);

        case "LL":
          // like 01, doesn't seem to work
          return useDateTimeFormatter ? string({
            month: "2-digit",
            day: "numeric"
          }, "month") : _this.num(dt.month, 2);

        case "LLL":
          // like Jan
          return month("short", true);

        case "LLLL":
          // like January
          return month("long", true);

        case "LLLLL":
          // like J
          return month("narrow", true);
        // months - format

        case "M":
          // like 1
          return useDateTimeFormatter ? string({
            month: "numeric"
          }, "month") : _this.num(dt.month);

        case "MM":
          // like 01
          return useDateTimeFormatter ? string({
            month: "2-digit"
          }, "month") : _this.num(dt.month, 2);

        case "MMM":
          // like Jan
          return month("short", false);

        case "MMMM":
          // like January
          return month("long", false);

        case "MMMMM":
          // like J
          return month("narrow", false);
        // years

        case "y":
          // like 2014
          return useDateTimeFormatter ? string({
            year: "numeric"
          }, "year") : _this.num(dt.year);

        case "yy":
          // like 14
          return useDateTimeFormatter ? string({
            year: "2-digit"
          }, "year") : _this.num(dt.year.toString().slice(-2), 2);

        case "yyyy":
          // like 0012
          return useDateTimeFormatter ? string({
            year: "numeric"
          }, "year") : _this.num(dt.year, 4);

        case "yyyyyy":
          // like 000012
          return useDateTimeFormatter ? string({
            year: "numeric"
          }, "year") : _this.num(dt.year, 6);
        // eras

        case "G":
          // like AD
          return era("short");

        case "GG":
          // like Anno Domini
          return era("long");

        case "GGGGG":
          return era("narrow");

        case "kk":
          return _this.num(dt.weekYear.toString().slice(-2), 2);

        case "kkkk":
          return _this.num(dt.weekYear, 4);

        case "W":
          return _this.num(dt.weekNumber);

        case "WW":
          return _this.num(dt.weekNumber, 2);

        case "o":
          return _this.num(dt.ordinal);

        case "ooo":
          return _this.num(dt.ordinal, 3);

        case "q":
          // like 1
          return _this.num(dt.quarter);

        case "qq":
          // like 01
          return _this.num(dt.quarter, 2);

        case "X":
          return _this.num(Math.floor(dt.ts / 1000));

        case "x":
          return _this.num(dt.ts);

        default:
          return maybeMacro(token);
      }
    };

    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  };

  _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
    var _this2 = this;

    var tokenToField = function tokenToField(token) {
      switch (token[0]) {
        case "S":
          return "millisecond";

        case "s":
          return "second";

        case "m":
          return "minute";

        case "h":
          return "hour";

        case "d":
          return "day";

        case "M":
          return "month";

        case "y":
          return "year";

        default:
          return null;
      }
    },
        tokenToString = function tokenToString(lildur) {
      return function (token) {
        var mapped = tokenToField(token);

        if (mapped) {
          return _this2.num(lildur.get(mapped), token.length);
        } else {
          return token;
        }
      };
    },
        tokens = Formatter.parseFormat(fmt),
        realTokens = tokens.reduce(function (found, _ref) {
      var literal = _ref.literal,
          val = _ref.val;
      return literal ? found : found.concat(val);
    }, []),
        collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function (t) {
      return t;
    }));

    return stringifyTokens(tokens, tokenToString(collapsed));
  };

  return Formatter;
}();

var Invalid = /*#__PURE__*/function () {
  function Invalid(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }

  var _proto = Invalid.prototype;

  _proto.toMessage = function toMessage() {
    if (this.explanation) {
      return this.reason + ": " + this.explanation;
    } else {
      return this.reason;
    }
  };

  return Invalid;
}();

/**
 * @interface
 */

var Zone = /*#__PURE__*/function () {
  function Zone() {}

  var _proto = Zone.prototype;

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  _proto.offsetName = function offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  ;

  _proto.formatOffset = function formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  ;

  _proto.offset = function offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  ;

  _proto.equals = function equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  ;

  _createClass(Zone, [{
    key: "type",

    /**
     * The type of zone
     * @abstract
     * @type {string}
     */
    get: function get() {
      throw new ZoneIsAbstractError();
    }
    /**
     * The name of this zone.
     * @abstract
     * @type {string}
     */

  }, {
    key: "name",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
    /**
     * Returns whether the offset is known to be fixed for the whole year.
     * @abstract
     * @type {boolean}
     */

  }, {
    key: "universal",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }, {
    key: "isValid",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }]);

  return Zone;
}();

var singleton = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */

var LocalZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(LocalZone, _Zone);

  function LocalZone() {
    return _Zone.apply(this, arguments) || this;
  }

  var _proto = LocalZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
        locale = _ref.locale;
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  ;

  _proto.offset = function offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  ;

  _proto.equals = function equals(otherZone) {
    return otherZone.type === "local";
  }
  /** @override **/
  ;

  _createClass(LocalZone, [{
    key: "type",

    /** @override **/
    get: function get() {
      return "local";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      if (hasIntl()) {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
      } else return "local";
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "instance",

    /**
     * Get a singleton instance of the local zone
     * @return {LocalZone}
     */
    get: function get() {
      if (singleton === null) {
        singleton = new LocalZone();
      }

      return singleton;
    }
  }]);

  return LocalZone;
}(Zone);

var matchingRegex = RegExp("^" + ianaRegex.source + "$");
var dtfCache = {};

function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }

  return dtfCache[zone];
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, ""),
      parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted),
      fMonth = parsed[1],
      fDay = parsed[2],
      fYear = parsed[3],
      fHour = parsed[4],
      fMinute = parsed[5],
      fSecond = parsed[6];
  return [fYear, fMonth, fDay, fHour, fMinute, fSecond];
}

function partsOffset(dtf, date) {
  var formatted = dtf.formatToParts(date),
      filled = [];

  for (var i = 0; i < formatted.length; i++) {
    var _formatted$i = formatted[i],
        type = _formatted$i.type,
        value = _formatted$i.value,
        pos = typeToPos[type];

    if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }

  return filled;
}

var ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */

var IANAZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(IANAZone, _Zone);

  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  IANAZone.create = function create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }

    return ianaZoneCache[name];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  ;

  IANAZone.resetCache = function resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Fantasia/Castle") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @return {boolean}
   */
  ;

  IANAZone.isValidSpecifier = function isValidSpecifier(s) {
    return !!(s && s.match(matchingRegex));
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  ;

  IANAZone.isValidZone = function isValidZone(zone) {
    try {
      new Intl.DateTimeFormat("en-US", {
        timeZone: zone
      }).format();
      return true;
    } catch (e) {
      return false;
    }
  } // Etc/GMT+8 -> -480

  /** @ignore */
  ;

  IANAZone.parseGMTOffset = function parseGMTOffset(specifier) {
    if (specifier) {
      var match = specifier.match(/^Etc\/GMT(0|[+-]\d{1,2})$/i);

      if (match) {
        return -60 * parseInt(match[1]);
      }
    }

    return null;
  };

  function IANAZone(name) {
    var _this;

    _this = _Zone.call(this) || this;
    /** @private **/

    _this.zoneName = name;
    /** @private **/

    _this.valid = IANAZone.isValidZone(name);
    return _this;
  }
  /** @override **/


  var _proto = IANAZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
        locale = _ref.locale;
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  ;

  _proto.offset = function offset(ts) {
    var date = new Date(ts);
    if (isNaN(date)) return NaN;

    var dtf = makeDTF(this.name),
        _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date),
        year = _ref2[0],
        month = _ref2[1],
        day = _ref2[2],
        hour = _ref2[3],
        minute = _ref2[4],
        second = _ref2[5],
        adjustedHour = hour === 24 ? 0 : hour;

    var asUTC = objToLocalTS({
      year: year,
      month: month,
      day: day,
      hour: adjustedHour,
      minute: minute,
      second: second,
      millisecond: 0
    });
    var asTS = +date;
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }
  /** @override **/
  ;

  _proto.equals = function equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /** @override **/
  ;

  _createClass(IANAZone, [{
    key: "type",
    get: function get() {
      return "iana";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.valid;
    }
  }]);

  return IANAZone;
}(Zone);

var singleton$1 = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */

var FixedOffsetZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(FixedOffsetZone, _Zone);

  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  FixedOffsetZone.instance = function instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  ;

  FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
    if (s) {
      var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);

      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }

    return null;
  };

  _createClass(FixedOffsetZone, null, [{
    key: "utcInstance",

    /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */
    get: function get() {
      if (singleton$1 === null) {
        singleton$1 = new FixedOffsetZone(0);
      }

      return singleton$1;
    }
  }]);

  function FixedOffsetZone(offset) {
    var _this;

    _this = _Zone.call(this) || this;
    /** @private **/

    _this.fixed = offset;
    return _this;
  }
  /** @override **/


  var _proto = FixedOffsetZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName() {
    return this.name;
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /** @override **/
  ;

  /** @override **/
  _proto.offset = function offset() {
    return this.fixed;
  }
  /** @override **/
  ;

  _proto.equals = function equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /** @override **/
  ;

  _createClass(FixedOffsetZone, [{
    key: "type",
    get: function get() {
      return "fixed";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.fixed === 0 ? "UTC" : "UTC" + formatOffset(this.fixed, "narrow");
    }
  }, {
    key: "universal",
    get: function get() {
      return true;
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }]);

  return FixedOffsetZone;
}(Zone);

/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */

var InvalidZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(InvalidZone, _Zone);

  function InvalidZone(zoneName) {
    var _this;

    _this = _Zone.call(this) || this;
    /**  @private */

    _this.zoneName = zoneName;
    return _this;
  }
  /** @override **/


  var _proto = InvalidZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName() {
    return null;
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset() {
    return "";
  }
  /** @override **/
  ;

  _proto.offset = function offset() {
    return NaN;
  }
  /** @override **/
  ;

  _proto.equals = function equals() {
    return false;
  }
  /** @override **/
  ;

  _createClass(InvalidZone, [{
    key: "type",
    get: function get() {
      return "invalid";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return false;
    }
  }]);

  return InvalidZone;
}(Zone);

/**
 * @private
 */
function normalizeZone(input, defaultZone) {
  var offset;

  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    var lowered = input.toLowerCase();
    if (lowered === "local") return defaultZone;else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;else if ((offset = IANAZone.parseGMTOffset(input)) != null) {
      // handle Etc/GMT-4, which V8 chokes on
      return FixedOffsetZone.instance(offset);
    } else if (IANAZone.isValidSpecifier(lowered)) return IANAZone.create(input);else return FixedOffsetZone.parseSpecifier(lowered) || new InvalidZone(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && input.offset && typeof input.offset === "number") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new InvalidZone(input);
  }
}

var now = function now() {
  return Date.now();
},
    defaultZone = null,
    // not setting this directly to LocalZone.instance bc loading order issues
defaultLocale = null,
    defaultNumberingSystem = null,
    defaultOutputCalendar = null,
    throwOnInvalid = false;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */


var Settings = /*#__PURE__*/function () {
  function Settings() {}

  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  Settings.resetCaches = function resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
  };

  _createClass(Settings, null, [{
    key: "now",

    /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */
    get: function get() {
      return now;
    }
    /**
     * Set the callback for returning the current timestamp.
     * The function should return a number, which will be interpreted as an Epoch millisecond count
     * @type {function}
     * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
     * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
     */
    ,
    set: function set(n) {
      now = n;
    }
    /**
     * Get the default time zone to create DateTimes in.
     * @type {string}
     */

  }, {
    key: "defaultZoneName",
    get: function get() {
      return Settings.defaultZone.name;
    }
    /**
     * Set the default time zone to create DateTimes in. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(z) {
      if (!z) {
        defaultZone = null;
      } else {
        defaultZone = normalizeZone(z);
      }
    }
    /**
     * Get the default time zone object to create DateTimes in. Does not affect existing instances.
     * @type {Zone}
     */

  }, {
    key: "defaultZone",
    get: function get() {
      return defaultZone || LocalZone.instance;
    }
    /**
     * Get the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: "defaultLocale",
    get: function get() {
      return defaultLocale;
    }
    /**
     * Set the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(locale) {
      defaultLocale = locale;
    }
    /**
     * Get the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: "defaultNumberingSystem",
    get: function get() {
      return defaultNumberingSystem;
    }
    /**
     * Set the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(numberingSystem) {
      defaultNumberingSystem = numberingSystem;
    }
    /**
     * Get the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: "defaultOutputCalendar",
    get: function get() {
      return defaultOutputCalendar;
    }
    /**
     * Set the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(outputCalendar) {
      defaultOutputCalendar = outputCalendar;
    }
    /**
     * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */

  }, {
    key: "throwOnInvalid",
    get: function get() {
      return throwOnInvalid;
    }
    /**
     * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */
    ,
    set: function set(t) {
      throwOnInvalid = t;
    }
  }]);

  return Settings;
}();

var intlDTCache = {};

function getCachedDTF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var key = JSON.stringify([locString, opts]);
  var dtf = intlDTCache[key];

  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }

  return dtf;
}

var intlNumCache = {};

function getCachedINF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var key = JSON.stringify([locString, opts]);
  var inf = intlNumCache[key];

  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }

  return inf;
}

var intlRelCache = {};

function getCachedRTF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var _opts = opts,
      base = _opts.base,
      cacheKeyOpts = _objectWithoutPropertiesLoose(_opts, ["base"]); // exclude `base` from the options


  var key = JSON.stringify([locString, cacheKeyOpts]);
  var inf = intlRelCache[key];

  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }

  return inf;
}

var sysLocaleCache = null;

function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else if (hasIntl()) {
    var computedSys = new Intl.DateTimeFormat().resolvedOptions().locale; // node sometimes defaults to "und". Override that because that is dumb

    sysLocaleCache = !computedSys || computedSys === "und" ? "en-US" : computedSys;
    return sysLocaleCache;
  } else {
    sysLocaleCache = "en-US";
    return sysLocaleCache;
  }
}

function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:
  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u
  var uIndex = localeStr.indexOf("-u-");

  if (uIndex === -1) {
    return [localeStr];
  } else {
    var options;
    var smaller = localeStr.substring(0, uIndex);

    try {
      options = getCachedDTF(localeStr).resolvedOptions();
    } catch (e) {
      options = getCachedDTF(smaller).resolvedOptions();
    }

    var _options = options,
        numberingSystem = _options.numberingSystem,
        calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it

    return [smaller, numberingSystem, calendar];
  }
}

function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (hasIntl()) {
    if (outputCalendar || numberingSystem) {
      localeStr += "-u";

      if (outputCalendar) {
        localeStr += "-ca-" + outputCalendar;
      }

      if (numberingSystem) {
        localeStr += "-nu-" + numberingSystem;
      }

      return localeStr;
    } else {
      return localeStr;
    }
  } else {
    return [];
  }
}

function mapMonths(f) {
  var ms = [];

  for (var i = 1; i <= 12; i++) {
    var dt = DateTime.utc(2016, i, 1);
    ms.push(f(dt));
  }

  return ms;
}

function mapWeekdays(f) {
  var ms = [];

  for (var i = 1; i <= 7; i++) {
    var dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }

  return ms;
}

function listStuff(loc, length, defaultOK, englishFn, intlFn) {
  var mode = loc.listingMode(defaultOK);

  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}

function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || hasIntl() && new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}
/**
 * @private
 */


var PolyNumberFormatter = /*#__PURE__*/function () {
  function PolyNumberFormatter(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;

    if (!forceSimple && hasIntl()) {
      var intlOpts = {
        useGrouping: false
      };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }

  var _proto = PolyNumberFormatter.prototype;

  _proto.format = function format(i) {
    if (this.inf) {
      var fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      // to match the browser's numberformatter defaults
      var _fixed = this.floor ? Math.floor(i) : roundTo(i, 3);

      return padStart(_fixed, this.padTo);
    }
  };

  return PolyNumberFormatter;
}();
/**
 * @private
 */


var PolyDateFormatter = /*#__PURE__*/function () {
  function PolyDateFormatter(dt, intl, opts) {
    this.opts = opts;
    this.hasIntl = hasIntl();
    var z;

    if (dt.zone.universal && this.hasIntl) {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      var gmtOffset = -1 * (dt.offset / 60);
      var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
      var isOffsetZoneSupported = IANAZone.isValidZone(offsetZ);

      if (dt.offset !== 0 && isOffsetZoneSupported) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata.
        // So we have to make do. Two cases:
        // 1. The format options tell us to show the zone. We can't do that, so the best
        // we can do is format the date in UTC.
        // 2. The format options don't tell us to show the zone. Then we can adjust them
        // the time and tell the formatter to show it to us in UTC, so that the time is right
        // and the bad zone doesn't show up.
        z = "UTC";

        if (opts.timeZoneName) {
          this.dt = dt;
        } else {
          this.dt = dt.offset === 0 ? dt : DateTime.fromMillis(dt.ts + dt.offset * 60 * 1000);
        }
      }
    } else if (dt.zone.type === "local") {
      this.dt = dt;
    } else {
      this.dt = dt;
      z = dt.zone.name;
    }

    if (this.hasIntl) {
      var intlOpts = Object.assign({}, this.opts);

      if (z) {
        intlOpts.timeZone = z;
      }

      this.dtf = getCachedDTF(intl, intlOpts);
    }
  }

  var _proto2 = PolyDateFormatter.prototype;

  _proto2.format = function format() {
    if (this.hasIntl) {
      return this.dtf.format(this.dt.toJSDate());
    } else {
      var tokenFormat = formatString(this.opts),
          loc = Locale.create("en-US");
      return Formatter.create(loc).formatDateTimeFromString(this.dt, tokenFormat);
    }
  };

  _proto2.formatToParts = function formatToParts() {
    if (this.hasIntl && hasFormatToParts()) {
      return this.dtf.formatToParts(this.dt.toJSDate());
    } else {
      // This is kind of a cop out. We actually could do this for English. However, we couldn't do it for intl strings
      // and IMO it's too weird to have an uncanny valley like that
      return [];
    }
  };

  _proto2.resolvedOptions = function resolvedOptions() {
    if (this.hasIntl) {
      return this.dtf.resolvedOptions();
    } else {
      return {
        locale: "en-US",
        numberingSystem: "latn",
        outputCalendar: "gregory"
      };
    }
  };

  return PolyDateFormatter;
}();
/**
 * @private
 */


var PolyRelFormatter = /*#__PURE__*/function () {
  function PolyRelFormatter(intl, isEnglish, opts) {
    this.opts = Object.assign({
      style: "long"
    }, opts);

    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }

  var _proto3 = PolyRelFormatter.prototype;

  _proto3.format = function format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  };

  _proto3.formatToParts = function formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  };

  return PolyRelFormatter;
}();
/**
 * @private
 */


var Locale = /*#__PURE__*/function () {
  Locale.fromOpts = function fromOpts(opts) {
    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
  };

  Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
    if (defaultToEN === void 0) {
      defaultToEN = false;
    }

    var specifiedLocale = locale || Settings.defaultLocale,
        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
    localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale()),
        numberingSystemR = numberingSystem || Settings.defaultNumberingSystem,
        outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
  };

  Locale.resetCache = function resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  };

  Locale.fromObject = function fromObject(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        locale = _ref.locale,
        numberingSystem = _ref.numberingSystem,
        outputCalendar = _ref.outputCalendar;

    return Locale.create(locale, numberingSystem, outputCalendar);
  };

  function Locale(locale, numbering, outputCalendar, specifiedLocale) {
    var _parseLocaleString = parseLocaleString(locale),
        parsedLocale = _parseLocaleString[0],
        parsedNumberingSystem = _parseLocaleString[1],
        parsedOutputCalendar = _parseLocaleString[2];

    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = {
      format: {},
      standalone: {}
    };
    this.monthsCache = {
      format: {},
      standalone: {}
    };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }

  var _proto4 = Locale.prototype;

  _proto4.listingMode = function listingMode(defaultOK) {
    if (defaultOK === void 0) {
      defaultOK = true;
    }

    var intl = hasIntl(),
        hasFTP = intl && hasFormatToParts(),
        isActuallyEn = this.isEnglish(),
        hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");

    if (!hasFTP && !(isActuallyEn && hasNoWeirdness) && !defaultOK) {
      return "error";
    } else if (!hasFTP || isActuallyEn && hasNoWeirdness) {
      return "en";
    } else {
      return "intl";
    }
  };

  _proto4.clone = function clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    }
  };

  _proto4.redefaultToEN = function redefaultToEN(alts) {
    if (alts === void 0) {
      alts = {};
    }

    return this.clone(Object.assign({}, alts, {
      defaultToEN: true
    }));
  };

  _proto4.redefaultToSystem = function redefaultToSystem(alts) {
    if (alts === void 0) {
      alts = {};
    }

    return this.clone(Object.assign({}, alts, {
      defaultToEN: false
    }));
  };

  _proto4.months = function months$1(length, format, defaultOK) {
    var _this = this;

    if (format === void 0) {
      format = false;
    }

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, length, defaultOK, months, function () {
      var intl = format ? {
        month: length,
        day: "numeric"
      } : {
        month: length
      },
          formatStr = format ? "format" : "standalone";

      if (!_this.monthsCache[formatStr][length]) {
        _this.monthsCache[formatStr][length] = mapMonths(function (dt) {
          return _this.extract(dt, intl, "month");
        });
      }

      return _this.monthsCache[formatStr][length];
    });
  };

  _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
    var _this2 = this;

    if (format === void 0) {
      format = false;
    }

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, length, defaultOK, weekdays, function () {
      var intl = format ? {
        weekday: length,
        year: "numeric",
        month: "long",
        day: "numeric"
      } : {
        weekday: length
      },
          formatStr = format ? "format" : "standalone";

      if (!_this2.weekdaysCache[formatStr][length]) {
        _this2.weekdaysCache[formatStr][length] = mapWeekdays(function (dt) {
          return _this2.extract(dt, intl, "weekday");
        });
      }

      return _this2.weekdaysCache[formatStr][length];
    });
  };

  _proto4.meridiems = function meridiems$1(defaultOK) {
    var _this3 = this;

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, undefined, defaultOK, function () {
      return meridiems;
    }, function () {
      // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
      // for AM and PM. This is probably wrong, but it's makes parsing way easier.
      if (!_this3.meridiemCache) {
        var intl = {
          hour: "numeric",
          hour12: true
        };
        _this3.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(function (dt) {
          return _this3.extract(dt, intl, "dayperiod");
        });
      }

      return _this3.meridiemCache;
    });
  };

  _proto4.eras = function eras$1(length, defaultOK) {
    var _this4 = this;

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, length, defaultOK, eras, function () {
      var intl = {
        era: length
      }; // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.

      if (!_this4.eraCache[length]) {
        _this4.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(function (dt) {
          return _this4.extract(dt, intl, "era");
        });
      }

      return _this4.eraCache[length];
    });
  };

  _proto4.extract = function extract(dt, intlOpts, field) {
    var df = this.dtFormatter(dt, intlOpts),
        results = df.formatToParts(),
        matching = results.find(function (m) {
      return m.type.toLowerCase() === field;
    });
    return matching ? matching.value : null;
  };

  _proto4.numberFormatter = function numberFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }

    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the rest of the condition is used heavily)
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  };

  _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
    if (intlOpts === void 0) {
      intlOpts = {};
    }

    return new PolyDateFormatter(dt, this.intl, intlOpts);
  };

  _proto4.relFormatter = function relFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }

    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  };

  _proto4.isEnglish = function isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || hasIntl() && new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  };

  _proto4.equals = function equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  };

  _createClass(Locale, [{
    key: "fastNumbers",
    get: function get() {
      if (this.fastNumbersCached == null) {
        this.fastNumbersCached = supportsFastNumbers(this);
      }

      return this.fastNumbersCached;
    }
  }]);

  return Locale;
}();

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

function combineRegexes() {
  for (var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++) {
    regexes[_key] = arguments[_key];
  }

  var full = regexes.reduce(function (f, r) {
    return f + r.source;
  }, "");
  return RegExp("^" + full + "$");
}

function combineExtractors() {
  for (var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    extractors[_key2] = arguments[_key2];
  }

  return function (m) {
    return extractors.reduce(function (_ref, ex) {
      var mergedVals = _ref[0],
          mergedZone = _ref[1],
          cursor = _ref[2];

      var _ex = ex(m, cursor),
          val = _ex[0],
          zone = _ex[1],
          next = _ex[2];

      return [Object.assign(mergedVals, val), mergedZone || zone, next];
    }, [{}, null, 1]).slice(0, 2);
  };
}

function parse(s) {
  if (s == null) {
    return [null, null];
  }

  for (var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    patterns[_key3 - 1] = arguments[_key3];
  }

  for (var _i = 0, _patterns = patterns; _i < _patterns.length; _i++) {
    var _patterns$_i = _patterns[_i],
        regex = _patterns$_i[0],
        extractor = _patterns$_i[1];
    var m = regex.exec(s);

    if (m) {
      return extractor(m);
    }
  }

  return [null, null];
}

function simpleParse() {
  for (var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    keys[_key4] = arguments[_key4];
  }

  return function (match, cursor) {
    var ret = {};
    var i;

    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }

    return [ret, null, cursor + i];
  };
} // ISO and SQL parsing


var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/,
    isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/,
    isoTimeRegex = RegExp("" + isoTimeBaseRegex.source + offsetRegex.source + "?"),
    isoTimeExtensionRegex = RegExp("(?:T" + isoTimeRegex.source + ")?"),
    isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/,
    isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/,
    isoOrdinalRegex = /(\d{4})-?(\d{3})/,
    extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay"),
    extractISOOrdinalData = simpleParse("year", "ordinal"),
    sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/,
    // dumbed-down version of the ISO one
sqlTimeRegex = RegExp(isoTimeBaseRegex.source + " ?(?:" + offsetRegex.source + "|(" + ianaRegex.source + "))?"),
    sqlTimeExtensionRegex = RegExp("(?: " + sqlTimeRegex.source + ")?");

function int(match, pos, fallback) {
  var m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}

function extractISOYmd(match, cursor) {
  var item = {
    year: int(match, cursor),
    month: int(match, cursor + 1, 1),
    day: int(match, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}

function extractISOTime(match, cursor) {
  var item = {
    hours: int(match, cursor, 0),
    minutes: int(match, cursor + 1, 0),
    seconds: int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3])
  };
  return [item, null, cursor + 4];
}

function extractISOOffset(match, cursor) {
  var local = !match[cursor] && !match[cursor + 1],
      fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
      zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}

function extractIANAZone(match, cursor) {
  var zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
} // ISO time parsing


var isoTimeOnly = RegExp("^T?" + isoTimeBaseRegex.source + "$"); // ISO duration parsing

var isoDuration = /^-?P(?:(?:(-?\d{1,9})Y)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})W)?(?:(-?\d{1,9})D)?(?:T(?:(-?\d{1,9})H)?(?:(-?\d{1,9})M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,9}))?S)?)?)$/;

function extractISODuration(match) {
  var s = match[0],
      yearStr = match[1],
      monthStr = match[2],
      weekStr = match[3],
      dayStr = match[4],
      hourStr = match[5],
      minuteStr = match[6],
      secondStr = match[7],
      millisecondsStr = match[8];
  var hasNegativePrefix = s[0] === "-";
  var negativeSeconds = secondStr && secondStr[0] === "-";

  var maybeNegate = function maybeNegate(num, force) {
    if (force === void 0) {
      force = false;
    }

    return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
  };

  return [{
    years: maybeNegate(parseInteger(yearStr)),
    months: maybeNegate(parseInteger(monthStr)),
    weeks: maybeNegate(parseInteger(weekStr)),
    days: maybeNegate(parseInteger(dayStr)),
    hours: maybeNegate(parseInteger(hourStr)),
    minutes: maybeNegate(parseInteger(minuteStr)),
    seconds: maybeNegate(parseInteger(secondStr), secondStr === "-0"),
    milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
  }];
} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that


var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};

function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);

  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }

  return result;
} // RFC 2822/5322


var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;

function extractRFC2822(match) {
  var weekdayStr = match[1],
      dayStr = match[2],
      monthStr = match[3],
      yearStr = match[4],
      hourStr = match[5],
      minuteStr = match[6],
      secondStr = match[7],
      obsOffset = match[8],
      milOffset = match[9],
      offHourStr = match[10],
      offMinuteStr = match[11],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  var offset;

  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }

  return [result, new FixedOffsetZone(offset)];
}

function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
} // http date


var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
    rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
    ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;

function extractRFC1123Or850(match) {
  var weekdayStr = match[1],
      dayStr = match[2],
      monthStr = match[3],
      yearStr = match[4],
      hourStr = match[5],
      minuteStr = match[6],
      secondStr = match[7],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

function extractASCII(match) {
  var weekdayStr = match[1],
      monthStr = match[2],
      dayStr = match[3],
      hourStr = match[4],
      minuteStr = match[5],
      secondStr = match[6],
      yearStr = match[7],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset);
var extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset);
/**
 * @private
 */

function parseISODate(s) {
  return parse(s, [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset], [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime], [isoTimeCombinedRegex, extractISOTimeAndOffset]);
}
function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s) {
  return parse(s, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
}
function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
  return parse(s, [isoTimeOnly, extractISOTimeOnly]);
}
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOYmdTimeOffsetAndIANAZone = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s) {
  return parse(s, [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeOffsetAndIANAZone], [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]);
}

var INVALID = "Invalid Duration"; // unit conversion constants

var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1000
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1000
  },
  hours: {
    minutes: 60,
    seconds: 60 * 60,
    milliseconds: 60 * 60 * 1000
  },
  minutes: {
    seconds: 60,
    milliseconds: 60 * 1000
  },
  seconds: {
    milliseconds: 1000
  }
},
    casualMatrix = Object.assign({
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1000
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix),
    daysInYearAccurate = 146097.0 / 400,
    daysInMonthAccurate = 146097.0 / 4800,
    accurateMatrix = Object.assign({
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix); // units ordered by size

var orderedUnits = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"];
var reverseUnits = orderedUnits.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"

function clone(dur, alts, clear) {
  if (clear === void 0) {
    clear = false;
  }

  // deep merge for vals
  var conf = {
    values: clear ? alts.values : Object.assign({}, dur.values, alts.values || {}),
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
  };
  return new Duration(conf);
}

function antiTrunc(n) {
  return n < 0 ? Math.floor(n) : Math.ceil(n);
} // NB: mutates parameters


function convert(matrix, fromMap, fromUnit, toMap, toUnit) {
  var conv = matrix[toUnit][fromUnit],
      raw = fromMap[fromUnit] / conv,
      sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]),
      // ok, so this is wild, but see the matrix in the tests
  added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? antiTrunc(raw) : Math.trunc(raw);
  toMap[toUnit] += added;
  fromMap[fromUnit] -= added * conv;
} // NB: mutates parameters


function normalizeValues(matrix, vals) {
  reverseUnits.reduce(function (previous, current) {
    if (!isUndefined(vals[current])) {
      if (previous) {
        convert(matrix, vals, previous, vals, current);
      }

      return current;
    } else {
      return previous;
    }
  }, null);
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime.plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration.years}, {@link Duration.months}, {@link Duration.weeks}, {@link Duration.days}, {@link Duration.hours}, {@link Duration.minutes}, {@link Duration.seconds}, {@link Duration.milliseconds} accessors.
 * * **Configuration** See  {@link Duration.locale} and {@link Duration.numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration.plus}, {@link Duration.minus}, {@link Duration.normalize}, {@link Duration.set}, {@link Duration.reconfigure}, {@link Duration.shiftTo}, and {@link Duration.negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration.as}, {@link Duration.toISO}, {@link Duration.toFormat}, and {@link Duration.toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */


var Duration = /*#__PURE__*/function () {
  /**
   * @private
   */
  function Duration(config) {
    var accurate = config.conversionAccuracy === "longterm" || false;
    /**
     * @access private
     */

    this.values = config.values;
    /**
     * @access private
     */

    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */

    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */

    this.invalid = config.invalid || null;
    /**
     * @access private
     */

    this.matrix = accurate ? accurateMatrix : casualMatrix;
    /**
     * @access private
     */

    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */


  Duration.fromMillis = function fromMillis(count, opts) {
    return Duration.fromObject(Object.assign({
      milliseconds: count
    }, opts));
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {string} [obj.locale='en-US'] - the locale to use
   * @param {string} obj.numberingSystem - the numbering system to use
   * @param {string} [obj.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  ;

  Duration.fromObject = function fromObject(obj) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
    }

    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit, ["locale", "numberingSystem", "conversionAccuracy", "zone" // a bit of debt; it's super inconvenient internally not to be able to blindly pass this
      ]),
      loc: Locale.fromObject(obj),
      conversionAccuracy: obj.conversionAccuracy
    });
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  ;

  Duration.fromISO = function fromISO(text, opts) {
    var _parseISODuration = parseISODuration(text),
        parsed = _parseISODuration[0];

    if (parsed) {
      var obj = Object.assign(parsed, opts);
      return Duration.fromObject(obj);
    } else {
      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    }
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  ;

  Duration.fromISOTime = function fromISOTime(text, opts) {
    var _parseISOTimeOnly = parseISOTimeOnly(text),
        parsed = _parseISOTimeOnly[0];

    if (parsed) {
      var obj = Object.assign(parsed, opts);
      return Duration.fromObject(obj);
    } else {
      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    }
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  ;

  Duration.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }

    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }

    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({
        invalid: invalid
      });
    }
  }
  /**
   * @private
   */
  ;

  Duration.normalizeUnit = function normalizeUnit(unit) {
    var normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  ;

  Duration.isDuration = function isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  ;

  var _proto = Duration.prototype;

  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * The duration will be converted to the set of units in the format string using {@link Duration.shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  _proto.toFormat = function toFormat(fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
    var fmtOpts = Object.assign({}, opts, {
      floor: opts.round !== false && opts.floor !== false
    });
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID;
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  ;

  _proto.toObject = function toObject(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) return {};
    var base = Object.assign({}, this.values);

    if (opts.includeConfig) {
      base.conversionAccuracy = this.conversionAccuracy;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }

    return base;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  ;

  _proto.toISO = function toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;
    var s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  ;

  _proto.toISOTime = function toISOTime(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) return null;
    var millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;
    opts = Object.assign({
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended"
    }, opts);
    var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
    var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";

    if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
      fmt += opts.format === "basic" ? "ss" : ":ss";

      if (!opts.suppressMilliseconds || value.milliseconds !== 0) {
        fmt += ".SSS";
      }
    }

    var str = value.toFormat(fmt);

    if (opts.includePrefix) {
      str = "T" + str;
    }

    return str;
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  ;

  _proto.toJSON = function toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  ;

  _proto.toString = function toString() {
    return this.toISO();
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  ;

  _proto.toMillis = function toMillis() {
    return this.as("milliseconds");
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  ;

  _proto.valueOf = function valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  ;

  _proto.plus = function plus(duration) {
    if (!this.isValid) return this;
    var dur = friendlyDuration(duration),
        result = {};

    for (var _iterator = _createForOfIteratorHelperLoose(orderedUnits), _step; !(_step = _iterator()).done;) {
      var k = _step.value;

      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }

    return clone(this, {
      values: result
    }, true);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  ;

  _proto.minus = function minus(duration) {
    if (!this.isValid) return this;
    var dur = friendlyDuration(duration);
    return this.plus(dur.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnit(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnit((x, u) => u === "hour" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  ;

  _proto.mapUnits = function mapUnits(fn) {
    if (!this.isValid) return this;
    var result = {};

    for (var _i = 0, _Object$keys = Object.keys(this.values); _i < _Object$keys.length; _i++) {
      var k = _Object$keys[_i];
      result[k] = asNumber(fn(this.values[k], k));
    }

    return clone(this, {
      values: result
    }, true);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  ;

  _proto.get = function get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  ;

  _proto.set = function set(values) {
    if (!this.isValid) return this;
    var mixed = Object.assign(this.values, normalizeObject(values, Duration.normalizeUnit, []));
    return clone(this, {
      values: mixed
    });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  ;

  _proto.reconfigure = function reconfigure(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        locale = _ref.locale,
        numberingSystem = _ref.numberingSystem,
        conversionAccuracy = _ref.conversionAccuracy;

    var loc = this.loc.clone({
      locale: locale,
      numberingSystem: numberingSystem
    }),
        opts = {
      loc: loc
    };

    if (conversionAccuracy) {
      opts.conversionAccuracy = conversionAccuracy;
    }

    return clone(this, opts);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  ;

  _proto.as = function as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */
  ;

  _proto.normalize = function normalize() {
    if (!this.isValid) return this;
    var vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone(this, {
      values: vals
    }, true);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  ;

  _proto.shiftTo = function shiftTo() {
    for (var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++) {
      units[_key] = arguments[_key];
    }

    if (!this.isValid) return this;

    if (units.length === 0) {
      return this;
    }

    units = units.map(function (u) {
      return Duration.normalizeUnit(u);
    });
    var built = {},
        accumulated = {},
        vals = this.toObject();
    var lastUnit;

    for (var _iterator2 = _createForOfIteratorHelperLoose(orderedUnits), _step2; !(_step2 = _iterator2()).done;) {
      var k = _step2.value;

      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        var own = 0; // anything we haven't boiled down yet should get boiled to this unit

        for (var ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        } // plus anything that's already in this unit


        if (isNumber(vals[k])) {
          own += vals[k];
        }

        var i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = own - i; // we'd like to absorb these fractions in another unit
        // plus anything further down the chain that should be rolled up in to this

        for (var down in vals) {
          if (orderedUnits.indexOf(down) > orderedUnits.indexOf(k)) {
            convert(this.matrix, vals, down, built, k);
          }
        } // otherwise, keep it in the wings to boil it later

      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    } // anything leftover becomes the decimal for the last unit
    // lastUnit must be defined since units is not empty


    for (var key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }

    return clone(this, {
      values: built
    }, true).normalize();
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  ;

  _proto.negate = function negate() {
    if (!this.isValid) return this;
    var negated = {};

    for (var _i2 = 0, _Object$keys2 = Object.keys(this.values); _i2 < _Object$keys2.length; _i2++) {
      var k = _Object$keys2[_i2];
      negated[k] = -this.values[k];
    }

    return clone(this, {
      values: negated
    }, true);
  }
  /**
   * Get the years.
   * @type {number}
   */
  ;

  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  _proto.equals = function equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    if (!this.loc.equals(other.loc)) {
      return false;
    }

    function eq(v1, v2) {
      // Consider 0 and undefined as equal
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }

    for (var _iterator3 = _createForOfIteratorHelperLoose(orderedUnits), _step3; !(_step3 = _iterator3()).done;) {
      var u = _step3.value;

      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }

    return true;
  };

  _createClass(Duration, [{
    key: "locale",
    get: function get() {
      return this.isValid ? this.loc.locale : null;
    }
    /**
     * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
     *
     * @type {string}
     */

  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
  }, {
    key: "years",
    get: function get() {
      return this.isValid ? this.values.years || 0 : NaN;
    }
    /**
     * Get the quarters.
     * @type {number}
     */

  }, {
    key: "quarters",
    get: function get() {
      return this.isValid ? this.values.quarters || 0 : NaN;
    }
    /**
     * Get the months.
     * @type {number}
     */

  }, {
    key: "months",
    get: function get() {
      return this.isValid ? this.values.months || 0 : NaN;
    }
    /**
     * Get the weeks
     * @type {number}
     */

  }, {
    key: "weeks",
    get: function get() {
      return this.isValid ? this.values.weeks || 0 : NaN;
    }
    /**
     * Get the days.
     * @type {number}
     */

  }, {
    key: "days",
    get: function get() {
      return this.isValid ? this.values.days || 0 : NaN;
    }
    /**
     * Get the hours.
     * @type {number}
     */

  }, {
    key: "hours",
    get: function get() {
      return this.isValid ? this.values.hours || 0 : NaN;
    }
    /**
     * Get the minutes.
     * @type {number}
     */

  }, {
    key: "minutes",
    get: function get() {
      return this.isValid ? this.values.minutes || 0 : NaN;
    }
    /**
     * Get the seconds.
     * @return {number}
     */

  }, {
    key: "seconds",
    get: function get() {
      return this.isValid ? this.values.seconds || 0 : NaN;
    }
    /**
     * Get the milliseconds.
     * @return {number}
     */

  }, {
    key: "milliseconds",
    get: function get() {
      return this.isValid ? this.values.milliseconds || 0 : NaN;
    }
    /**
     * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
     * on invalid DateTimes or Intervals.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }
    /**
     * Returns an error code if this Duration became invalid, or null if the Duration is valid
     * @return {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]);

  return Duration;
}();
function friendlyDuration(durationish) {
  if (isNumber(durationish)) {
    return Duration.fromMillis(durationish);
  } else if (Duration.isDuration(durationish)) {
    return durationish;
  } else if (typeof durationish === "object") {
    return Duration.fromObject(durationish);
  } else {
    throw new InvalidArgumentError("Unknown duration argument " + durationish + " of type " + typeof durationish);
  }
}

var INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end

function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
  } else {
    return null;
  }
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link fromDateTimes}, {@link after}, {@link before}, or {@link fromISO}.
 * * **Accessors** Use {@link start} and {@link end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link count}, {@link length}, {@link hasSame}, {@link contains}, {@link isAfter}, or {@link isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link set}, {@link splitAt}, {@link splitBy}, {@link divideEqually}, {@link merge}, {@link xor}, {@link union}, {@link intersection}, or {@link difference}.
 * * **Comparison** To compare this Interval to another one, use {@link equals}, {@link overlaps}, {@link abutsStart}, {@link abutsEnd}, {@link engulfs}.
 * * **Output** To convert the Interval into other representations, see {@link toString}, {@link toISO}, {@link toISODate}, {@link toISOTime}, {@link toFormat}, and {@link toDuration}.
 */


var Interval = /*#__PURE__*/function () {
  /**
   * @private
   */
  function Interval(config) {
    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */

    this.e = config.end;
    /**
     * @access private
     */

    this.invalid = config.invalid || null;
    /**
     * @access private
     */

    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */


  Interval.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }

    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }

    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({
        invalid: invalid
      });
    }
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  ;

  Interval.fromDateTimes = function fromDateTimes(start, end) {
    var builtStart = friendlyDateTime(start),
        builtEnd = friendlyDateTime(end);
    var validateError = validateStartEnd(builtStart, builtEnd);

    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  ;

  Interval.after = function after(start, duration) {
    var dur = friendlyDuration(duration),
        dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  ;

  Interval.before = function before(end, duration) {
    var dur = friendlyDuration(duration),
        dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime.fromISO} and optionally {@link Duration.fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  ;

  Interval.fromISO = function fromISO(text, opts) {
    var _split = (text || "").split("/", 2),
        s = _split[0],
        e = _split[1];

    if (s && e) {
      var start, startIsValid;

      try {
        start = DateTime.fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }

      var end, endIsValid;

      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }

      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }

      if (startIsValid) {
        var dur = Duration.fromISO(e, opts);

        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        var _dur = Duration.fromISO(s, opts);

        if (_dur.isValid) {
          return Interval.before(end, _dur);
        }
      }
    }

    return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  ;

  Interval.isInterval = function isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  ;

  var _proto = Interval.prototype;

  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  _proto.length = function length(unit) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    return this.isValid ? this.toDuration.apply(this, [unit]).get(unit) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  ;

  _proto.count = function count(unit) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    if (!this.isValid) return NaN;
    var start = this.start.startOf(unit),
        end = this.end.startOf(unit);
    return Math.floor(end.diff(start, unit).get(unit)) + 1;
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  ;

  _proto.hasSame = function hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  ;

  _proto.isEmpty = function isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  ;

  _proto.isAfter = function isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  ;

  _proto.isBefore = function isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  ;

  _proto.contains = function contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  ;

  _proto.set = function set(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        start = _ref.start,
        end = _ref.end;

    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...[DateTime]} dateTimes - the unit of time to count.
   * @return {[Interval]}
   */
  ;

  _proto.splitAt = function splitAt() {
    var _this = this;

    if (!this.isValid) return [];

    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }

    var sorted = dateTimes.map(friendlyDateTime).filter(function (d) {
      return _this.contains(d);
    }).sort(),
        results = [];
    var s = this.s,
        i = 0;

    while (s < this.e) {
      var added = sorted[i] || this.e,
          next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }

    return results;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {[Interval]}
   */
  ;

  _proto.splitBy = function splitBy(duration) {
    var dur = friendlyDuration(duration);

    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }

    var s = this.s,
        idx = 1,
        next;
    var results = [];

    while (s < this.e) {
      var added = this.start.plus(dur.mapUnits(function (x) {
        return x * idx;
      }));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }

    return results;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {[Interval]}
   */
  ;

  _proto.divideEqually = function divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.overlaps = function overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.abutsStart = function abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.abutsEnd = function abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.engulfs = function engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.equals = function equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  ;

  _proto.intersection = function intersection(other) {
    if (!this.isValid) return this;
    var s = this.s > other.s ? this.s : other.s,
        e = this.e < other.e ? this.e : other.e;

    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  ;

  _proto.union = function union(other) {
    if (!this.isValid) return this;
    var s = this.s < other.s ? this.s : other.s,
        e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {[Interval]} intervals
   * @return {[Interval]}
   */
  ;

  Interval.merge = function merge(intervals) {
    var _intervals$sort$reduc = intervals.sort(function (a, b) {
      return a.s - b.s;
    }).reduce(function (_ref2, item) {
      var sofar = _ref2[0],
          current = _ref2[1];

      if (!current) {
        return [sofar, item];
      } else if (current.overlaps(item) || current.abutsStart(item)) {
        return [sofar, current.union(item)];
      } else {
        return [sofar.concat([current]), item];
      }
    }, [[], null]),
        found = _intervals$sort$reduc[0],
        final = _intervals$sort$reduc[1];

    if (final) {
      found.push(final);
    }

    return found;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {[Interval]} intervals
   * @return {[Interval]}
   */
  ;

  Interval.xor = function xor(intervals) {
    var _Array$prototype;

    var start = null,
        currentCount = 0;

    var results = [],
        ends = intervals.map(function (i) {
      return [{
        time: i.s,
        type: "s"
      }, {
        time: i.e,
        type: "e"
      }];
    }),
        flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends),
        arr = flattened.sort(function (a, b) {
      return a.time - b.time;
    });

    for (var _iterator = _createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;) {
      var i = _step.value;
      currentCount += i.type === "s" ? 1 : -1;

      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }

        start = null;
      }
    }

    return Interval.merge(results);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {[Interval]}
   */
  ;

  _proto.difference = function difference() {
    var _this2 = this;

    for (var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      intervals[_key2] = arguments[_key2];
    }

    return Interval.xor([this].concat(intervals)).map(function (i) {
      return _this2.intersection(i);
    }).filter(function (i) {
      return i && !i.isEmpty();
    });
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  ;

  _proto.toString = function toString() {
    if (!this.isValid) return INVALID$1;
    return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime.toISO}
   * @return {string}
   */
  ;

  _proto.toISO = function toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return this.s.toISO(opts) + "/" + this.e.toISO(opts);
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  ;

  _proto.toISODate = function toISODate() {
    if (!this.isValid) return INVALID$1;
    return this.s.toISODate() + "/" + this.e.toISODate();
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime.toISO}
   * @return {string}
   */
  ;

  _proto.toISOTime = function toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format string.
   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime.toFormat} for details.
   * @param {Object} opts - options
   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
   * @return {string}
   */
  ;

  _proto.toFormat = function toFormat(dateFormat, _temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2,
        _ref3$separator = _ref3.separator,
        separator = _ref3$separator === void 0 ? " – " : _ref3$separator;

    if (!this.isValid) return INVALID$1;
    return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  ;

  _proto.toDuration = function toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }

    return this.e.diff(this.s, unit, opts);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  ;

  _proto.mapEndpoints = function mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  };

  _createClass(Interval, [{
    key: "start",
    get: function get() {
      return this.isValid ? this.s : null;
    }
    /**
     * Returns the end of the Interval
     * @type {DateTime}
     */

  }, {
    key: "end",
    get: function get() {
      return this.isValid ? this.e : null;
    }
    /**
     * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
     * @type {boolean}
     */

  }, {
    key: "isValid",
    get: function get() {
      return this.invalidReason === null;
    }
    /**
     * Returns an error code if this Interval is invalid, or null if the Interval is valid
     * @type {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]);

  return Interval;
}();

/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */

var Info = /*#__PURE__*/function () {
  function Info() {}

  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  Info.hasDST = function hasDST(zone) {
    if (zone === void 0) {
      zone = Settings.defaultZone;
    }

    var proto = DateTime.now().setZone(zone).set({
      month: 12
    });
    return !zone.universal && proto.offset !== proto.set({
      month: 6
    }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  ;

  Info.isValidIANAZone = function isValidIANAZone(zone) {
    return IANAZone.isValidSpecifier(zone) && IANAZone.isValidZone(zone);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone.isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  ;

  Info.normalizeZone = function normalizeZone$1(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {[string]}
   */
  ;

  Info.months = function months(length, _temp) {
    if (length === void 0) {
      length = "long";
    }

    var _ref = _temp === void 0 ? {} : _temp,
        _ref$locale = _ref.locale,
        locale = _ref$locale === void 0 ? null : _ref$locale,
        _ref$numberingSystem = _ref.numberingSystem,
        numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem,
        _ref$locObj = _ref.locObj,
        locObj = _ref$locObj === void 0 ? null : _ref$locObj,
        _ref$outputCalendar = _ref.outputCalendar,
        outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;

    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {[string]}
   */
  ;

  Info.monthsFormat = function monthsFormat(length, _temp2) {
    if (length === void 0) {
      length = "long";
    }

    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$locale = _ref2.locale,
        locale = _ref2$locale === void 0 ? null : _ref2$locale,
        _ref2$numberingSystem = _ref2.numberingSystem,
        numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem,
        _ref2$locObj = _ref2.locObj,
        locObj = _ref2$locObj === void 0 ? null : _ref2$locObj,
        _ref2$outputCalendar = _ref2.outputCalendar,
        outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;

    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {[string]}
   */
  ;

  Info.weekdays = function weekdays(length, _temp3) {
    if (length === void 0) {
      length = "long";
    }

    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        _ref3$locale = _ref3.locale,
        locale = _ref3$locale === void 0 ? null : _ref3$locale,
        _ref3$numberingSystem = _ref3.numberingSystem,
        numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem,
        _ref3$locObj = _ref3.locObj,
        locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;

    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link weekdays}
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {[string]}
   */
  ;

  Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
    if (length === void 0) {
      length = "long";
    }

    var _ref4 = _temp4 === void 0 ? {} : _temp4,
        _ref4$locale = _ref4.locale,
        locale = _ref4$locale === void 0 ? null : _ref4$locale,
        _ref4$numberingSystem = _ref4.numberingSystem,
        numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem,
        _ref4$locObj = _ref4.locObj,
        locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;

    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {[string]}
   */
  ;

  Info.meridiems = function meridiems(_temp5) {
    var _ref5 = _temp5 === void 0 ? {} : _temp5,
        _ref5$locale = _ref5.locale,
        locale = _ref5$locale === void 0 ? null : _ref5$locale;

    return Locale.create(locale).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {[string]}
   */
  ;

  Info.eras = function eras(length, _temp6) {
    if (length === void 0) {
      length = "short";
    }

    var _ref6 = _temp6 === void 0 ? {} : _temp6,
        _ref6$locale = _ref6.locale,
        locale = _ref6$locale === void 0 ? null : _ref6$locale;

    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, timezone support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `zones`: whether this environment supports IANA timezones
   * * `intlTokens`: whether this environment supports internationalized token-based formatting/parsing
   * * `intl`: whether this environment supports general internationalization
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { intl: true, intlTokens: false, zones: true, relative: false }
   * @return {Object}
   */
  ;

  Info.features = function features() {
    var intl = false,
        intlTokens = false,
        zones = false,
        relative = false;

    if (hasIntl()) {
      intl = true;
      intlTokens = hasFormatToParts();
      relative = hasRelative();

      try {
        zones = new Intl.DateTimeFormat("en", {
          timeZone: "America/New_York"
        }).resolvedOptions().timeZone === "America/New_York";
      } catch (e) {
        zones = false;
      }
    }

    return {
      intl: intl,
      intlTokens: intlTokens,
      zones: zones,
      relative: relative
    };
  };

  return Info;
}();

function dayDiff(earlier, later) {
  var utcDayStart = function utcDayStart(dt) {
    return dt.toUTC(0, {
      keepLocalTime: true
    }).startOf("day").valueOf();
  },
      ms = utcDayStart(later) - utcDayStart(earlier);

  return Math.floor(Duration.fromMillis(ms).as("days"));
}

function highOrderDiffs(cursor, later, units) {
  var differs = [["years", function (a, b) {
    return b.year - a.year;
  }], ["quarters", function (a, b) {
    return b.quarter - a.quarter;
  }], ["months", function (a, b) {
    return b.month - a.month + (b.year - a.year) * 12;
  }], ["weeks", function (a, b) {
    var days = dayDiff(a, b);
    return (days - days % 7) / 7;
  }], ["days", dayDiff]];
  var results = {};
  var lowestOrder, highWater;

  for (var _i = 0, _differs = differs; _i < _differs.length; _i++) {
    var _differs$_i = _differs[_i],
        unit = _differs$_i[0],
        differ = _differs$_i[1];

    if (units.indexOf(unit) >= 0) {
      var _cursor$plus;

      lowestOrder = unit;
      var delta = differ(cursor, later);
      highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));

      if (highWater > later) {
        var _cursor$plus2;

        cursor = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[unit] = delta - 1, _cursor$plus2));
        delta -= 1;
      } else {
        cursor = highWater;
      }

      results[unit] = delta;
    }
  }

  return [cursor, results, highWater, lowestOrder];
}

function _diff (earlier, later, units, opts) {
  var _highOrderDiffs = highOrderDiffs(earlier, later, units),
      cursor = _highOrderDiffs[0],
      results = _highOrderDiffs[1],
      highWater = _highOrderDiffs[2],
      lowestOrder = _highOrderDiffs[3];

  var remainingMillis = later - cursor;
  var lowerOrderUnits = units.filter(function (u) {
    return ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0;
  });

  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      var _cursor$plus3;

      highWater = cursor.plus((_cursor$plus3 = {}, _cursor$plus3[lowestOrder] = 1, _cursor$plus3));
    }

    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }

  var duration = Duration.fromObject(Object.assign(results, opts));

  if (lowerOrderUnits.length > 0) {
    var _Duration$fromMillis;

    return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}

var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}; // eslint-disable-next-line

var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  var value = parseInt(str, 10);

  if (isNaN(value)) {
    value = "";

    for (var i = 0; i < str.length; i++) {
      var code = str.charCodeAt(i);

      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (var key in numberingSystemsUTF16) {
          var _numberingSystemsUTF = numberingSystemsUTF16[key],
              min = _numberingSystemsUTF[0],
              max = _numberingSystemsUTF[1];

          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }

    return parseInt(value, 10);
  } else {
    return value;
  }
}
function digitRegex(_ref, append) {
  var numberingSystem = _ref.numberingSystem;

  if (append === void 0) {
    append = "";
  }

  return new RegExp("" + numberingSystems[numberingSystem || "latn"] + append);
}

var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";

function intUnit(regex, post) {
  if (post === void 0) {
    post = function post(i) {
      return i;
    };
  }

  return {
    regex: regex,
    deser: function deser(_ref) {
      var s = _ref[0];
      return post(parseDigits(s));
    }
  };
}

var NBSP = String.fromCharCode(160);
var spaceOrNBSP = "( |" + NBSP + ")";
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");

function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}

function stripInsensitivities(s) {
  return s.replace(/\./g, "") // ignore dots that were made optional
  .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
  .toLowerCase();
}

function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: function deser(_ref2) {
        var s = _ref2[0];
        return strings.findIndex(function (i) {
          return stripInsensitivities(s) === stripInsensitivities(i);
        }) + startIndex;
      }
    };
  }
}

function offset(regex, groups) {
  return {
    regex: regex,
    deser: function deser(_ref3) {
      var h = _ref3[1],
          m = _ref3[2];
      return signedOffset(h, m);
    },
    groups: groups
  };
}

function simple(regex) {
  return {
    regex: regex,
    deser: function deser(_ref4) {
      var s = _ref4[0];
      return s;
    }
  };
}

function escapeToken(value) {
  // eslint-disable-next-line no-useless-escape
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

function unitForToken(token, loc) {
  var one = digitRegex(loc),
      two = digitRegex(loc, "{2}"),
      three = digitRegex(loc, "{3}"),
      four = digitRegex(loc, "{4}"),
      six = digitRegex(loc, "{6}"),
      oneOrTwo = digitRegex(loc, "{1,2}"),
      oneToThree = digitRegex(loc, "{1,3}"),
      oneToSix = digitRegex(loc, "{1,6}"),
      oneToNine = digitRegex(loc, "{1,9}"),
      twoToFour = digitRegex(loc, "{2,4}"),
      fourToSix = digitRegex(loc, "{4,6}"),
      literal = function literal(t) {
    return {
      regex: RegExp(escapeToken(t.val)),
      deser: function deser(_ref5) {
        var s = _ref5[0];
        return s;
      },
      literal: true
    };
  },
      unitate = function unitate(t) {
    if (token.literal) {
      return literal(t);
    }

    switch (t.val) {
      // era
      case "G":
        return oneOf(loc.eras("short", false), 0);

      case "GG":
        return oneOf(loc.eras("long", false), 0);
      // years

      case "y":
        return intUnit(oneToSix);

      case "yy":
        return intUnit(twoToFour, untruncateYear);

      case "yyyy":
        return intUnit(four);

      case "yyyyy":
        return intUnit(fourToSix);

      case "yyyyyy":
        return intUnit(six);
      // months

      case "M":
        return intUnit(oneOrTwo);

      case "MM":
        return intUnit(two);

      case "MMM":
        return oneOf(loc.months("short", true, false), 1);

      case "MMMM":
        return oneOf(loc.months("long", true, false), 1);

      case "L":
        return intUnit(oneOrTwo);

      case "LL":
        return intUnit(two);

      case "LLL":
        return oneOf(loc.months("short", false, false), 1);

      case "LLLL":
        return oneOf(loc.months("long", false, false), 1);
      // dates

      case "d":
        return intUnit(oneOrTwo);

      case "dd":
        return intUnit(two);
      // ordinals

      case "o":
        return intUnit(oneToThree);

      case "ooo":
        return intUnit(three);
      // time

      case "HH":
        return intUnit(two);

      case "H":
        return intUnit(oneOrTwo);

      case "hh":
        return intUnit(two);

      case "h":
        return intUnit(oneOrTwo);

      case "mm":
        return intUnit(two);

      case "m":
        return intUnit(oneOrTwo);

      case "q":
        return intUnit(oneOrTwo);

      case "qq":
        return intUnit(two);

      case "s":
        return intUnit(oneOrTwo);

      case "ss":
        return intUnit(two);

      case "S":
        return intUnit(oneToThree);

      case "SSS":
        return intUnit(three);

      case "u":
        return simple(oneToNine);
      // meridiem

      case "a":
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)

      case "kkkk":
        return intUnit(four);

      case "kk":
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)

      case "W":
        return intUnit(oneOrTwo);

      case "WW":
        return intUnit(two);
      // weekdays

      case "E":
      case "c":
        return intUnit(one);

      case "EEE":
        return oneOf(loc.weekdays("short", false, false), 1);

      case "EEEE":
        return oneOf(loc.weekdays("long", false, false), 1);

      case "ccc":
        return oneOf(loc.weekdays("short", true, false), 1);

      case "cccc":
        return oneOf(loc.weekdays("long", true, false), 1);
      // offset/zone

      case "Z":
      case "ZZ":
        return offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);

      case "ZZZ":
        return offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are

      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);

      default:
        return literal(t);
    }
  };

  var unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}

var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  }
};

function tokenForPart(part, locale, formatOpts) {
  var type = part.type,
      value = part.value;

  if (type === "literal") {
    return {
      literal: true,
      val: value
    };
  }

  var style = formatOpts[type];
  var val = partTypeStyleToTokenVal[type];

  if (typeof val === "object") {
    val = val[style];
  }

  if (val) {
    return {
      literal: false,
      val: val
    };
  }

  return undefined;
}

function buildRegex(units) {
  var re = units.map(function (u) {
    return u.regex;
  }).reduce(function (f, r) {
    return f + "(" + r.source + ")";
  }, "");
  return ["^" + re + "$", units];
}

function match(input, regex, handlers) {
  var matches = input.match(regex);

  if (matches) {
    var all = {};
    var matchIndex = 1;

    for (var i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        var h = handlers[i],
            groups = h.groups ? h.groups + 1 : 1;

        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }

        matchIndex += groups;
      }
    }

    return [matches, all];
  } else {
    return [matches, {}];
  }
}

function dateTimeFromMatches(matches) {
  var toField = function toField(token) {
    switch (token) {
      case "S":
        return "millisecond";

      case "s":
        return "second";

      case "m":
        return "minute";

      case "h":
      case "H":
        return "hour";

      case "d":
        return "day";

      case "o":
        return "ordinal";

      case "L":
      case "M":
        return "month";

      case "y":
        return "year";

      case "E":
      case "c":
        return "weekday";

      case "W":
        return "weekNumber";

      case "k":
        return "weekYear";

      case "q":
        return "quarter";

      default:
        return null;
    }
  };

  var zone;

  if (!isUndefined(matches.Z)) {
    zone = new FixedOffsetZone(matches.Z);
  } else if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  } else {
    zone = null;
  }

  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }

  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }

  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }

  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }

  var vals = Object.keys(matches).reduce(function (r, k) {
    var f = toField(k);

    if (f) {
      r[f] = matches[k];
    }

    return r;
  }, {});
  return [vals, zone];
}

var dummyDateTimeCache = null;

function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }

  return dummyDateTimeCache;
}

function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }

  var formatOpts = Formatter.macroTokenToFormatOpts(token.val);

  if (!formatOpts) {
    return token;
  }

  var formatter = Formatter.create(locale, formatOpts);
  var parts = formatter.formatDateTimeParts(getDummyDateTime());
  var tokens = parts.map(function (p) {
    return tokenForPart(p, locale, formatOpts);
  });

  if (tokens.includes(undefined)) {
    return token;
  }

  return tokens;
}

function expandMacroTokens(tokens, locale) {
  var _Array$prototype;

  return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function (t) {
    return maybeExpandMacroToken(t, locale);
  }));
}
/**
 * @private
 */


function explainFromTokens(locale, input, format) {
  var tokens = expandMacroTokens(Formatter.parseFormat(format), locale),
      units = tokens.map(function (t) {
    return unitForToken(t, locale);
  }),
      disqualifyingUnit = units.find(function (t) {
    return t.invalidReason;
  });

  if (disqualifyingUnit) {
    return {
      input: input,
      tokens: tokens,
      invalidReason: disqualifyingUnit.invalidReason
    };
  } else {
    var _buildRegex = buildRegex(units),
        regexString = _buildRegex[0],
        handlers = _buildRegex[1],
        regex = RegExp(regexString, "i"),
        _match = match(input, regex, handlers),
        rawMatches = _match[0],
        matches = _match[1],
        _ref6 = matches ? dateTimeFromMatches(matches) : [null, null],
        result = _ref6[0],
        zone = _ref6[1];

    if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
      throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
    }

    return {
      input: input,
      tokens: tokens,
      regex: regex,
      rawMatches: rawMatches,
      matches: matches,
      result: result,
      zone: zone
    };
  }
}
function parseFromTokens(locale, input, format) {
  var _explainFromTokens = explainFromTokens(locale, input, format),
      result = _explainFromTokens.result,
      zone = _explainFromTokens.zone,
      invalidReason = _explainFromTokens.invalidReason;

  return [result, zone, invalidReason];
}

var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
    leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];

function unitOutOfRange(unit, value) {
  return new Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}

function dayOfWeek(year, month, day) {
  var js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return js === 0 ? 7 : js;
}

function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}

function uncomputeOrdinal(year, ordinal) {
  var table = isLeapYear(year) ? leapLadder : nonLeapLadder,
      month0 = table.findIndex(function (i) {
    return i < ordinal;
  }),
      day = ordinal - table[month0];
  return {
    month: month0 + 1,
    day: day
  };
}
/**
 * @private
 */


function gregorianToWeek(gregObj) {
  var year = gregObj.year,
      month = gregObj.month,
      day = gregObj.day,
      ordinal = computeOrdinal(year, month, day),
      weekday = dayOfWeek(year, month, day);
  var weekNumber = Math.floor((ordinal - weekday + 10) / 7),
      weekYear;

  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear);
  } else if (weekNumber > weeksInWeekYear(year)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }

  return Object.assign({
    weekYear: weekYear,
    weekNumber: weekNumber,
    weekday: weekday
  }, timeObject(gregObj));
}
function weekToGregorian(weekData) {
  var weekYear = weekData.weekYear,
      weekNumber = weekData.weekNumber,
      weekday = weekData.weekday,
      weekdayOfJan4 = dayOfWeek(weekYear, 1, 4),
      yearInDays = daysInYear(weekYear);
  var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3,
      year;

  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }

  var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal),
      month = _uncomputeOrdinal.month,
      day = _uncomputeOrdinal.day;

  return Object.assign({
    year: year,
    month: month,
    day: day
  }, timeObject(weekData));
}
function gregorianToOrdinal(gregData) {
  var year = gregData.year,
      month = gregData.month,
      day = gregData.day,
      ordinal = computeOrdinal(year, month, day);
  return Object.assign({
    year: year,
    ordinal: ordinal
  }, timeObject(gregData));
}
function ordinalToGregorian(ordinalData) {
  var year = ordinalData.year,
      ordinal = ordinalData.ordinal,
      _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal),
      month = _uncomputeOrdinal2.month,
      day = _uncomputeOrdinal2.day;

  return Object.assign({
    year: year,
    month: month,
    day: day
  }, timeObject(ordinalData));
}
function hasInvalidWeekData(obj) {
  var validYear = isInteger(obj.weekYear),
      validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear)),
      validWeekday = integerBetween(obj.weekday, 1, 7);

  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.week);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  var validYear = isInteger(obj.year),
      validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  var validYear = isInteger(obj.year),
      validMonth = integerBetween(obj.month, 1, 12),
      validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  var hour = obj.hour,
      minute = obj.minute,
      second = obj.second,
      millisecond = obj.millisecond;
  var validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0,
      validMinute = integerBetween(minute, 0, 59),
      validSecond = integerBetween(second, 0, 59),
      validMillisecond = integerBetween(millisecond, 0, 999);

  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

var INVALID$2 = "Invalid DateTime";
var MAX_DATE = 8.64e15;

function unsupportedZone(zone) {
  return new Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
} // we cache week data on the DT object and this intermediates the cache


function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }

  return dt.weekData;
} // clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties


function clone$1(inst, alts) {
  var current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime(Object.assign({}, current, alts, {
    old: current
  }));
} // find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)


function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  var utcGuess = localTS - o * 60 * 1000; // Test whether the zone matches the offset for this ts

  var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done

  if (o === o2) {
    return [utcGuess, o];
  } // If not, change the ts by the difference in the offset


  utcGuess -= (o2 - o) * 60 * 1000; // If that gives us the local time we want, we're done

  var o3 = tz.offset(utcGuess);

  if (o2 === o3) {
    return [utcGuess, o2];
  } // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time


  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
} // convert an epoch timestamp into a calendar object with the given offset


function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;
  var d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
} // convert a calendar object to a epoch timestamp


function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
} // create a new DT instance by adding a duration, adjusting for DSTs


function adjustTime(inst, dur) {
  var oPre = inst.o,
      year = inst.c.year + Math.trunc(dur.years),
      month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
      c = Object.assign({}, inst.c, {
    year: year,
    month: month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }),
      millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"),
      localTS = objToLocalTS(c);

  var _fixOffset = fixOffset(localTS, oPre, inst.zone),
      ts = _fixOffset[0],
      o = _fixOffset[1];

  if (millisToAdd !== 0) {
    ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same

    o = inst.zone.offset(ts);
  }

  return {
    ts: ts,
    o: o
  };
} // helper useful in turning the results of parsing into real dates
// by handling the zone options


function parseDataToDateTime(parsed, parsedZone, opts, format, text) {
  var setZone = opts.setZone,
      zone = opts.zone;

  if (parsed && Object.keys(parsed).length !== 0) {
    var interpretationZone = parsedZone || zone,
        inst = DateTime.fromObject(Object.assign(parsed, opts, {
      zone: interpretationZone,
      // setZone is a valid option in the calling methods, but not in fromObject
      setZone: undefined
    }));
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(new Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
  }
} // if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details


function toTechFormat(dt, format, allowZ) {
  if (allowZ === void 0) {
    allowZ = true;
  }

  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ: allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
} // technical time formats (e.g. the time part of ISO 8601), take some options
// and this commonizes their handling


function toTechTimeFormat(dt, _ref) {
  var _ref$suppressSeconds = _ref.suppressSeconds,
      suppressSeconds = _ref$suppressSeconds === void 0 ? false : _ref$suppressSeconds,
      _ref$suppressMillisec = _ref.suppressMilliseconds,
      suppressMilliseconds = _ref$suppressMillisec === void 0 ? false : _ref$suppressMillisec,
      includeOffset = _ref.includeOffset,
      _ref$includePrefix = _ref.includePrefix,
      includePrefix = _ref$includePrefix === void 0 ? false : _ref$includePrefix,
      _ref$includeZone = _ref.includeZone,
      includeZone = _ref$includeZone === void 0 ? false : _ref$includeZone,
      _ref$spaceZone = _ref.spaceZone,
      spaceZone = _ref$spaceZone === void 0 ? false : _ref$spaceZone,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? "extended" : _ref$format;
  var fmt = format === "basic" ? "HHmm" : "HH:mm";

  if (!suppressSeconds || dt.second !== 0 || dt.millisecond !== 0) {
    fmt += format === "basic" ? "ss" : ":ss";

    if (!suppressMilliseconds || dt.millisecond !== 0) {
      fmt += ".SSS";
    }
  }

  if ((includeZone || includeOffset) && spaceZone) {
    fmt += " ";
  }

  if (includeZone) {
    fmt += "z";
  } else if (includeOffset) {
    fmt += format === "basic" ? "ZZZ" : "ZZ";
  }

  var str = toTechFormat(dt, fmt);

  if (includePrefix) {
    str = "T" + str;
  }

  return str;
} // defaults for unspecified units in the supported calendars


var defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
},
    defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
},
    defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}; // Units in the supported calendars, sorted by bigness

var orderedUnits$1 = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
    orderedWeekUnits = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"],
    orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"]; // standardize case and plurality in units

function normalizeUnit(unit) {
  var normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
} // this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.


function quickDT(obj, zone) {
  // assume we have the higher-order units
  for (var _iterator = _createForOfIteratorHelperLoose(orderedUnits$1), _step; !(_step = _iterator()).done;) {
    var u = _step.value;

    if (isUndefined(obj[u])) {
      obj[u] = defaultUnitValues[u];
    }
  }

  var invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);

  if (invalid) {
    return DateTime.invalid(invalid);
  }

  var tsNow = Settings.now(),
      offsetProvis = zone.offset(tsNow),
      _objToTS = objToTS(obj, offsetProvis, zone),
      ts = _objToTS[0],
      o = _objToTS[1];

  return new DateTime({
    ts: ts,
    zone: zone,
    o: o
  });
}

function diffRelative(start, end, opts) {
  var round = isUndefined(opts.round) ? true : opts.round,
      format = function format(c, unit) {
    c = roundTo(c, round || opts.calendary ? 0 : 2, true);
    var formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  },
      differ = function differ(unit) {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  };

  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }

  for (var _iterator2 = _createForOfIteratorHelperLoose(opts.units), _step2; !(_step2 = _iterator2()).done;) {
    var unit = _step2.value;
    var count = differ(unit);

    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }

  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link local}, {@link utc}, and (most flexibly) {@link fromObject}. To create one from a standard string format, use {@link fromISO}, {@link fromHTTP}, and {@link fromRFC2822}. To create one from a custom string format, use {@link fromFormat}. To create one from a native JS date, use {@link fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link toObject}), use the {@link year}, {@link month},
 * {@link day}, {@link hour}, {@link minute}, {@link second}, {@link millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link weekYear}, {@link weekNumber}, and {@link weekday} accessors.
 * * **Configuration** See the {@link locale} and {@link numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link set}, {@link reconfigure}, {@link setZone}, {@link setLocale}, {@link plus}, {@link minus}, {@link endOf}, {@link startOf}, {@link toUTC}, and {@link toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link toRelative}, {@link toRelativeCalendar}, {@link toJSON}, {@link toISO}, {@link toHTTP}, {@link toObject}, {@link toRFC2822}, {@link toString}, {@link toLocaleString}, {@link toFormat}, {@link toMillis} and {@link toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */


var DateTime = /*#__PURE__*/function () {
  /**
   * @access private
   */
  function DateTime(config) {
    var zone = config.zone || Settings.defaultZone;
    var invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */

    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    var c = null,
        o = null;

    if (!invalid) {
      var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);

      if (unchanged) {
        var _ref2 = [config.old.c, config.old.o];
        c = _ref2[0];
        o = _ref2[1];
      } else {
        var ot = zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    /**
     * @access private
     */


    this._zone = zone;
    /**
     * @access private
     */

    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */

    this.invalid = invalid;
    /**
     * @access private
     */

    this.weekData = null;
    /**
     * @access private
     */

    this.c = c;
    /**
     * @access private
     */

    this.o = o;
    /**
     * @access private
     */

    this.isLuxonDateTime = true;
  } // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */


  DateTime.now = function now() {
    return new DateTime({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                            //~> now
   * @example DateTime.local(2017)                        //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                     //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12)                 //~> 2017-03-12T00:00:00
   * @example DateTime.local(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  ;

  DateTime.local = function local(year, month, day, hour, minute, second, millisecond) {
    if (isUndefined(year)) {
      return DateTime.now();
    } else {
      return quickDT({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        millisecond: millisecond
      }, Settings.defaultZone);
    }
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.utc()                            //~> now
   * @example DateTime.utc(2017)                        //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                     //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                 //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765Z
   * @return {DateTime}
   */
  ;

  DateTime.utc = function utc(year, month, day, hour, minute, second, millisecond) {
    if (isUndefined(year)) {
      return new DateTime({
        ts: Settings.now(),
        zone: FixedOffsetZone.utcInstance
      });
    } else {
      return quickDT({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        millisecond: millisecond
      }, FixedOffsetZone.utcInstance);
    }
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  ;

  DateTime.fromJSDate = function fromJSDate(date, options) {
    if (options === void 0) {
      options = {};
    }

    var ts = isDate(date) ? date.valueOf() : NaN;

    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }

    var zoneToUse = normalizeZone(options.zone, Settings.defaultZone);

    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  ;

  DateTime.fromMillis = function fromMillis(milliseconds, options) {
    if (options === void 0) {
      options = {};
    }

    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  ;

  DateTime.fromSeconds = function fromSeconds(seconds, options) {
    if (options === void 0) {
      options = {};
    }

    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {string|Zone} [obj.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [obj.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} obj.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} obj.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  ;

  DateTime.fromObject = function fromObject(obj) {
    var zoneToUse = normalizeZone(obj.zone, Settings.defaultZone);

    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    var tsNow = Settings.now(),
        offsetProvis = zoneToUse.offset(tsNow),
        normalized = normalizeObject(obj, normalizeUnit, ["zone", "locale", "outputCalendar", "numberingSystem"]),
        containsOrdinal = !isUndefined(normalized.ordinal),
        containsGregorYear = !isUndefined(normalized.year),
        containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
        containsGregor = containsGregorYear || containsGregorMD,
        definiteWeekDef = normalized.weekYear || normalized.weekNumber,
        loc = Locale.fromObject(obj); // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff

    var units,
        defaultValues,
        objNow = tsToObj(tsNow, offsetProvis);

    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits$1;
      defaultValues = defaultUnitValues;
    } // set default values for missing stuff


    var foundFirst = false;

    for (var _iterator3 = _createForOfIteratorHelperLoose(units), _step3; !(_step3 = _iterator3()).done;) {
      var u = _step3.value;
      var v = normalized[u];

      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    } // make sure the values we have are in range


    var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized),
        invalid = higherOrderInvalid || hasInvalidTimeData(normalized);

    if (invalid) {
      return DateTime.invalid(invalid);
    } // compute the actual time


    var gregorian = useWeekData ? weekToGregorian(normalized) : containsOrdinal ? ordinalToGregorian(normalized) : normalized,
        _objToTS2 = objToTS(gregorian, offsetProvis, zoneToUse),
        tsFinal = _objToTS2[0],
        offsetFinal = _objToTS2[1],
        inst = new DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc: loc
    }); // gregorian data + weekday serves only to validate


    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
    }

    return inst;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  ;

  DateTime.fromISO = function fromISO(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseISODate = parseISODate(text),
        vals = _parseISODate[0],
        parsedZone = _parseISODate[1];

    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  ;

  DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseRFC2822Date = parseRFC2822Date(text),
        vals = _parseRFC2822Date[0],
        parsedZone = _parseRFC2822Date[1];

    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  ;

  DateTime.fromHTTP = function fromHTTP(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseHTTPDate = parseHTTPDate(text),
        vals = _parseHTTPDate[0],
        parsedZone = _parseHTTPDate[1];

    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @see https://moment.github.io/luxon/docs/manual/parsing.html#table-of-tokens
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  ;

  DateTime.fromFormat = function fromFormat(text, fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }

    var _opts = opts,
        _opts$locale = _opts.locale,
        locale = _opts$locale === void 0 ? null : _opts$locale,
        _opts$numberingSystem = _opts.numberingSystem,
        numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem,
        localeToUse = Locale.fromOpts({
      locale: locale,
      numberingSystem: numberingSystem,
      defaultToEN: true
    }),
        _parseFromTokens = parseFromTokens(localeToUse, text, fmt),
        vals = _parseFromTokens[0],
        parsedZone = _parseFromTokens[1],
        invalid = _parseFromTokens[2];

    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text);
    }
  }
  /**
   * @deprecated use fromFormat instead
   */
  ;

  DateTime.fromString = function fromString(text, fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    return DateTime.fromFormat(text, fmt, opts);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  ;

  DateTime.fromSQL = function fromSQL(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseSQL = parseSQL(text),
        vals = _parseSQL[0],
        parsedZone = _parseSQL[1];

    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  ;

  DateTime.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }

    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }

    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({
        invalid: invalid
      });
    }
  }
  /**
   * Check if an object is a DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  ;

  DateTime.isDateTime = function isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  } // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  ;

  var _proto = DateTime.prototype;

  _proto.get = function get(unit) {
    return this[unit];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  ;

  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  _proto.resolvedLocaleOpts = function resolvedLocaleOpts(opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this),
        locale = _Formatter$create$res.locale,
        numberingSystem = _Formatter$create$res.numberingSystem,
        calendar = _Formatter$create$res.calendar;

    return {
      locale: locale,
      numberingSystem: numberingSystem,
      outputCalendar: calendar
    };
  } // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  ;

  _proto.toUTC = function toUTC(offset, opts) {
    if (offset === void 0) {
      offset = 0;
    }

    if (opts === void 0) {
      opts = {};
    }

    return this.setZone(FixedOffsetZone.instance(offset), opts);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  ;

  _proto.toLocal = function toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link plus}. You may wish to use {@link toLocal} and {@link toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  ;

  _proto.setZone = function setZone(zone, _temp) {
    var _ref3 = _temp === void 0 ? {} : _temp,
        _ref3$keepLocalTime = _ref3.keepLocalTime,
        keepLocalTime = _ref3$keepLocalTime === void 0 ? false : _ref3$keepLocalTime,
        _ref3$keepCalendarTim = _ref3.keepCalendarTime,
        keepCalendarTime = _ref3$keepCalendarTim === void 0 ? false : _ref3$keepCalendarTim;

    zone = normalizeZone(zone, Settings.defaultZone);

    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      var newTS = this.ts;

      if (keepLocalTime || keepCalendarTime) {
        var offsetGuess = zone.offset(this.ts);
        var asObj = this.toObject();

        var _objToTS3 = objToTS(asObj, offsetGuess, zone);

        newTS = _objToTS3[0];
      }

      return clone$1(this, {
        ts: newTS,
        zone: zone
      });
    }
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  ;

  _proto.reconfigure = function reconfigure(_temp2) {
    var _ref4 = _temp2 === void 0 ? {} : _temp2,
        locale = _ref4.locale,
        numberingSystem = _ref4.numberingSystem,
        outputCalendar = _ref4.outputCalendar;

    var loc = this.loc.clone({
      locale: locale,
      numberingSystem: numberingSystem,
      outputCalendar: outputCalendar
    });
    return clone$1(this, {
      loc: loc
    });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  ;

  _proto.setLocale = function setLocale(locale) {
    return this.reconfigure({
      locale: locale
    });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link reconfigure} and {@link setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  ;

  _proto.set = function set(values) {
    if (!this.isValid) return this;
    var normalized = normalizeObject(values, normalizeUnit, []),
        settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday),
        containsOrdinal = !isUndefined(normalized.ordinal),
        containsGregorYear = !isUndefined(normalized.year),
        containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
        containsGregor = containsGregorYear || containsGregorMD,
        definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    var mixed;

    if (settingWeekStuff) {
      mixed = weekToGregorian(Object.assign(gregorianToWeek(this.c), normalized));
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian(Object.assign(gregorianToOrdinal(this.c), normalized));
    } else {
      mixed = Object.assign(this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month

      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }

    var _objToTS4 = objToTS(mixed, this.o, this.zone),
        ts = _objToTS4[0],
        o = _objToTS4[1];

    return clone$1(this, {
      ts: ts,
      o: o
    });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  ;

  _proto.plus = function plus(duration) {
    if (!this.isValid) return this;
    var dur = friendlyDuration(duration);
    return clone$1(this, adjustTime(this, dur));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
  */
  ;

  _proto.minus = function minus(duration) {
    if (!this.isValid) return this;
    var dur = friendlyDuration(duration).negate();
    return clone$1(this, adjustTime(this, dur));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  ;

  _proto.startOf = function startOf(unit) {
    if (!this.isValid) return this;
    var o = {},
        normalizedUnit = Duration.normalizeUnit(unit);

    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through

      case "quarters":
      case "months":
        o.day = 1;
      // falls through

      case "weeks":
      case "days":
        o.hour = 0;
      // falls through

      case "hours":
        o.minute = 0;
      // falls through

      case "minutes":
        o.second = 0;
      // falls through

      case "seconds":
        o.millisecond = 0;
        break;
      // no default, invalid units throw in normalizeUnit()
    }

    if (normalizedUnit === "weeks") {
      o.weekday = 1;
    }

    if (normalizedUnit === "quarters") {
      var q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }

    return this.set(o);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  ;

  _proto.endOf = function endOf(unit) {
    var _this$plus;

    return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
  } // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @see https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  ;

  _proto.toFormat = function toFormat(fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID$2;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param opts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hour12: false }); //=> '11:32'
   * @return {string}
   */
  ;

  _proto.toLocaleString = function toLocaleString(opts) {
    if (opts === void 0) {
      opts = DATE_SHORT;
    }

    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTime(this) : INVALID$2;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  ;

  _proto.toLocaleParts = function toLocaleParts(opts) {
    if (opts === void 0) {
      opts = {};
    }

    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  ;

  _proto.toISO = function toISO(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) {
      return null;
    }

    return this.toISODate(opts) + "T" + this.toISOTime(opts);
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  ;

  _proto.toISODate = function toISODate(_temp3) {
    var _ref5 = _temp3 === void 0 ? {} : _temp3,
        _ref5$format = _ref5.format,
        format = _ref5$format === void 0 ? "extended" : _ref5$format;

    var fmt = format === "basic" ? "yyyyMMdd" : "yyyy-MM-dd";

    if (this.year > 9999) {
      fmt = "+" + fmt;
    }

    return toTechFormat(this, fmt);
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  ;

  _proto.toISOWeekDate = function toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  ;

  _proto.toISOTime = function toISOTime(_temp4) {
    var _ref6 = _temp4 === void 0 ? {} : _temp4,
        _ref6$suppressMillise = _ref6.suppressMilliseconds,
        suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise,
        _ref6$suppressSeconds = _ref6.suppressSeconds,
        suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds,
        _ref6$includeOffset = _ref6.includeOffset,
        includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset,
        _ref6$includePrefix = _ref6.includePrefix,
        includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix,
        _ref6$format = _ref6.format,
        format = _ref6$format === void 0 ? "extended" : _ref6$format;

    return toTechTimeFormat(this, {
      suppressSeconds: suppressSeconds,
      suppressMilliseconds: suppressMilliseconds,
      includeOffset: includeOffset,
      includePrefix: includePrefix,
      format: format
    });
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime, always in UTC
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  ;

  _proto.toRFC2822 = function toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  ;

  _proto.toHTTP = function toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  ;

  _proto.toSQLDate = function toSQLDate() {
    return toTechFormat(this, "yyyy-MM-dd");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  ;

  _proto.toSQLTime = function toSQLTime(_temp5) {
    var _ref7 = _temp5 === void 0 ? {} : _temp5,
        _ref7$includeOffset = _ref7.includeOffset,
        includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset,
        _ref7$includeZone = _ref7.includeZone,
        includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone;

    return toTechTimeFormat(this, {
      includeOffset: includeOffset,
      includeZone: includeZone,
      spaceZone: true
    });
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  ;

  _proto.toSQL = function toSQL(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) {
      return null;
    }

    return this.toSQLDate() + " " + this.toSQLTime(opts);
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  ;

  _proto.toString = function toString() {
    return this.isValid ? this.toISO() : INVALID$2;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link toMillis}
   * @return {number}
   */
  ;

  _proto.valueOf = function valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  ;

  _proto.toMillis = function toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  ;

  _proto.toSeconds = function toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  ;

  _proto.toJSON = function toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  ;

  _proto.toBSON = function toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  ;

  _proto.toObject = function toObject(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) return {};
    var base = Object.assign({}, this.c);

    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }

    return base;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  ;

  _proto.toJSDate = function toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  } // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  ;

  _proto.diff = function diff(otherDateTime, unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid(this.invalid || otherDateTime.invalid, "created by diffing an invalid DateTime");
    }

    var durOpts = Object.assign({
      locale: this.locale,
      numberingSystem: this.numberingSystem
    }, opts);

    var units = maybeArray(unit).map(Duration.normalizeUnit),
        otherIsLater = otherDateTime.valueOf() > this.valueOf(),
        earlier = otherIsLater ? this : otherDateTime,
        later = otherIsLater ? otherDateTime : this,
        diffed = _diff(earlier, later, units, durOpts);

    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  ;

  _proto.diffNow = function diffNow(unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    if (opts === void 0) {
      opts = {};
    }

    return this.diff(DateTime.now(), unit, opts);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  ;

  _proto.until = function until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  ;

  _proto.hasSame = function hasSame(otherDateTime, unit) {
    if (!this.isValid) return false;
    var inputMs = otherDateTime.valueOf();
    var otherZoneDateTime = this.setZone(otherDateTime.zone, {
      keepLocalTime: true
    });
    return otherZoneDateTime.startOf(unit) <= inputMs && inputMs <= otherZoneDateTime.endOf(unit);
  }
  /**
   * Equality check
   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  ;

  _proto.equals = function equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  ;

  _proto.toRelative = function toRelative(options) {
    if (options === void 0) {
      options = {};
    }

    if (!this.isValid) return null;
    var base = options.base || DateTime.fromObject({
      zone: this.zone
    }),
        padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    var units = ["years", "months", "days", "hours", "minutes", "seconds"];
    var unit = options.unit;

    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }

    return diffRelative(base, this.plus(padding), Object.assign(options, {
      numeric: "always",
      units: units,
      unit: unit
    }));
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  ;

  _proto.toRelativeCalendar = function toRelativeCalendar(options) {
    if (options === void 0) {
      options = {};
    }

    if (!this.isValid) return null;
    return diffRelative(options.base || DateTime.fromObject({
      zone: this.zone
    }), this, Object.assign(options, {
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    }));
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  ;

  DateTime.min = function min() {
    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }

    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }

    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  ;

  DateTime.max = function max() {
    for (var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      dateTimes[_key2] = arguments[_key2];
    }

    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }

    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.max);
  } // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  ;

  DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$locale = _options.locale,
        locale = _options$locale === void 0 ? null : _options$locale,
        _options$numberingSys = _options.numberingSystem,
        numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys,
        localeToUse = Locale.fromOpts({
      locale: locale,
      numberingSystem: numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  ;

  DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
    if (options === void 0) {
      options = {};
    }

    return DateTime.fromFormatExplain(text, fmt, options);
  } // FORMAT PRESETS

  /**
   * {@link toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  ;

  _createClass(DateTime, [{
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }
    /**
     * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
     * @type {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
    /**
     * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "locale",
    get: function get() {
      return this.isValid ? this.loc.locale : null;
    }
    /**
     * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
     * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "outputCalendar",
    get: function get() {
      return this.isValid ? this.loc.outputCalendar : null;
    }
    /**
     * Get the time zone associated with this DateTime.
     * @type {Zone}
     */

  }, {
    key: "zone",
    get: function get() {
      return this._zone;
    }
    /**
     * Get the name of the time zone.
     * @type {string}
     */

  }, {
    key: "zoneName",
    get: function get() {
      return this.isValid ? this.zone.name : null;
    }
    /**
     * Get the year
     * @example DateTime.local(2017, 5, 25).year //=> 2017
     * @type {number}
     */

  }, {
    key: "year",
    get: function get() {
      return this.isValid ? this.c.year : NaN;
    }
    /**
     * Get the quarter
     * @example DateTime.local(2017, 5, 25).quarter //=> 2
     * @type {number}
     */

  }, {
    key: "quarter",
    get: function get() {
      return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
     * Get the month (1-12).
     * @example DateTime.local(2017, 5, 25).month //=> 5
     * @type {number}
     */

  }, {
    key: "month",
    get: function get() {
      return this.isValid ? this.c.month : NaN;
    }
    /**
     * Get the day of the month (1-30ish).
     * @example DateTime.local(2017, 5, 25).day //=> 25
     * @type {number}
     */

  }, {
    key: "day",
    get: function get() {
      return this.isValid ? this.c.day : NaN;
    }
    /**
     * Get the hour of the day (0-23).
     * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
     * @type {number}
     */

  }, {
    key: "hour",
    get: function get() {
      return this.isValid ? this.c.hour : NaN;
    }
    /**
     * Get the minute of the hour (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
     * @type {number}
     */

  }, {
    key: "minute",
    get: function get() {
      return this.isValid ? this.c.minute : NaN;
    }
    /**
     * Get the second of the minute (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
     * @type {number}
     */

  }, {
    key: "second",
    get: function get() {
      return this.isValid ? this.c.second : NaN;
    }
    /**
     * Get the millisecond of the second (0-999).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
     * @type {number}
     */

  }, {
    key: "millisecond",
    get: function get() {
      return this.isValid ? this.c.millisecond : NaN;
    }
    /**
     * Get the week year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
     * @type {number}
     */

  }, {
    key: "weekYear",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
    }
    /**
     * Get the week number of the week year (1-52ish).
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
     * @type {number}
     */

  }, {
    key: "weekNumber",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
    }
    /**
     * Get the day of the week.
     * 1 is Monday and 7 is Sunday
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 11, 31).weekday //=> 4
     * @type {number}
     */

  }, {
    key: "weekday",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
    }
    /**
     * Get the ordinal (meaning the day of the year)
     * @example DateTime.local(2017, 5, 25).ordinal //=> 145
     * @type {number|DateTime}
     */

  }, {
    key: "ordinal",
    get: function get() {
      return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
    }
    /**
     * Get the human readable short month name, such as 'Oct'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
     * @type {string}
     */

  }, {
    key: "monthShort",
    get: function get() {
      return this.isValid ? Info.months("short", {
        locObj: this.loc
      })[this.month - 1] : null;
    }
    /**
     * Get the human readable long month name, such as 'October'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthLong //=> October
     * @type {string}
     */

  }, {
    key: "monthLong",
    get: function get() {
      return this.isValid ? Info.months("long", {
        locObj: this.loc
      })[this.month - 1] : null;
    }
    /**
     * Get the human readable short weekday, such as 'Mon'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
     * @type {string}
     */

  }, {
    key: "weekdayShort",
    get: function get() {
      return this.isValid ? Info.weekdays("short", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }
    /**
     * Get the human readable long weekday, such as 'Monday'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
     * @type {string}
     */

  }, {
    key: "weekdayLong",
    get: function get() {
      return this.isValid ? Info.weekdays("long", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }
    /**
     * Get the UTC offset of this DateTime in minutes
     * @example DateTime.now().offset //=> -240
     * @example DateTime.utc().offset //=> 0
     * @type {number}
     */

  }, {
    key: "offset",
    get: function get() {
      return this.isValid ? +this.o : NaN;
    }
    /**
     * Get the short human name for the zone's current offset, for example "EST" or "EDT".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */

  }, {
    key: "offsetNameShort",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "short",
          locale: this.locale
        });
      } else {
        return null;
      }
    }
    /**
     * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */

  }, {
    key: "offsetNameLong",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "long",
          locale: this.locale
        });
      } else {
        return null;
      }
    }
    /**
     * Get whether this zone's offset ever changes, as in a DST.
     * @type {boolean}
     */

  }, {
    key: "isOffsetFixed",
    get: function get() {
      return this.isValid ? this.zone.universal : null;
    }
    /**
     * Get whether the DateTime is in a DST.
     * @type {boolean}
     */

  }, {
    key: "isInDST",
    get: function get() {
      if (this.isOffsetFixed) {
        return false;
      } else {
        return this.offset > this.set({
          month: 1
        }).offset || this.offset > this.set({
          month: 5
        }).offset;
      }
    }
    /**
     * Returns true if this DateTime is in a leap year, false otherwise
     * @example DateTime.local(2016).isInLeapYear //=> true
     * @example DateTime.local(2013).isInLeapYear //=> false
     * @type {boolean}
     */

  }, {
    key: "isInLeapYear",
    get: function get() {
      return isLeapYear(this.year);
    }
    /**
     * Returns the number of days in this DateTime's month
     * @example DateTime.local(2016, 2).daysInMonth //=> 29
     * @example DateTime.local(2016, 3).daysInMonth //=> 31
     * @type {number}
     */

  }, {
    key: "daysInMonth",
    get: function get() {
      return daysInMonth(this.year, this.month);
    }
    /**
     * Returns the number of days in this DateTime's year
     * @example DateTime.local(2016).daysInYear //=> 366
     * @example DateTime.local(2013).daysInYear //=> 365
     * @type {number}
     */

  }, {
    key: "daysInYear",
    get: function get() {
      return this.isValid ? daysInYear(this.year) : NaN;
    }
    /**
     * Returns the number of weeks in this DateTime's year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2004).weeksInWeekYear //=> 53
     * @example DateTime.local(2013).weeksInWeekYear //=> 52
     * @type {number}
     */

  }, {
    key: "weeksInWeekYear",
    get: function get() {
      return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
    }
  }], [{
    key: "DATE_SHORT",
    get: function get() {
      return DATE_SHORT;
    }
    /**
     * {@link toLocaleString} format like 'Oct 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_MED",
    get: function get() {
      return DATE_MED;
    }
    /**
     * {@link toLocaleString} format like 'Fri, Oct 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_MED_WITH_WEEKDAY",
    get: function get() {
      return DATE_MED_WITH_WEEKDAY;
    }
    /**
     * {@link toLocaleString} format like 'October 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_FULL",
    get: function get() {
      return DATE_FULL;
    }
    /**
     * {@link toLocaleString} format like 'Tuesday, October 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_HUGE",
    get: function get() {
      return DATE_HUGE;
    }
    /**
     * {@link toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_SIMPLE",
    get: function get() {
      return TIME_SIMPLE;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_SECONDS",
    get: function get() {
      return TIME_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_WITH_SHORT_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_WITH_LONG_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '09:30', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_SIMPLE",
    get: function get() {
      return TIME_24_SIMPLE;
    }
    /**
     * {@link toLocaleString} format like '09:30:23', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_SECONDS",
    get: function get() {
      return TIME_24_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 EDT', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_24_WITH_SHORT_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_24_WITH_LONG_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_SHORT",
    get: function get() {
      return DATETIME_SHORT;
    }
    /**
     * {@link toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_SHORT_WITH_SECONDS",
    get: function get() {
      return DATETIME_SHORT_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED",
    get: function get() {
      return DATETIME_MED;
    }
    /**
     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED_WITH_SECONDS",
    get: function get() {
      return DATETIME_MED_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED_WITH_WEEKDAY",
    get: function get() {
      return DATETIME_MED_WITH_WEEKDAY;
    }
    /**
     * {@link toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_FULL",
    get: function get() {
      return DATETIME_FULL;
    }
    /**
     * {@link toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_FULL_WITH_SECONDS",
    get: function get() {
      return DATETIME_FULL_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_HUGE",
    get: function get() {
      return DATETIME_HUGE;
    }
    /**
     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_HUGE_WITH_SECONDS",
    get: function get() {
      return DATETIME_HUGE_WITH_SECONDS;
    }
  }]);

  return DateTime;
}();
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
  }
}

var VERSION = "1.28.0";

exports.DateTime = DateTime;
exports.Duration = Duration;
exports.FixedOffsetZone = FixedOffsetZone;
exports.IANAZone = IANAZone;
exports.Info = Info;
exports.Interval = Interval;
exports.InvalidZone = InvalidZone;
exports.LocalZone = LocalZone;
exports.Settings = Settings;
exports.VERSION = VERSION;
exports.Zone = Zone;
//# sourceMappingURL=luxon.js.map


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__iterresult__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(7);



function argsMatch(left, right) {
    if (Array.isArray(left)) {
        if (!Array.isArray(right))
            return false;
        if (left.length !== right.length)
            return false;
        return left.every(function (date, i) { return date.getTime() === right[i].getTime(); });
    }
    if (left instanceof Date) {
        return right instanceof Date && left.getTime() === right.getTime();
    }
    return left === right;
}
var Cache = /** @class */ (function () {
    function Cache() {
        this.all = false;
        this.before = [];
        this.after = [];
        this.between = [];
    }
    /**
     * @param {String} what - all/before/after/between
     * @param {Array,Date} value - an array of dates, one date, or null
     * @param {Object?} args - _iter arguments
     */
    Cache.prototype._cacheAdd = function (what, value, args) {
        if (value) {
            value =
                value instanceof Date
                    ? __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].clone(value)
                    : __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].cloneDates(value);
        }
        if (what === 'all') {
            this.all = value;
        }
        else {
            args._value = value;
            this[what].push(args);
        }
    };
    /**
     * @return false - not in the cache
     *         null  - cached, but zero occurrences (before/after)
     *         Date  - cached (before/after)
     *         []    - cached, but zero occurrences (all/between)
     *         [Date1, DateN] - cached (all/between)
     */
    Cache.prototype._cacheGet = function (what, args) {
        var cached = false;
        var argsKeys = args ? Object.keys(args) : [];
        var findCacheDiff = function (item) {
            for (var i = 0; i < argsKeys.length; i++) {
                var key = argsKeys[i];
                if (!argsMatch(args[key], item[key])) {
                    return true;
                }
            }
            return false;
        };
        var cachedObject = this[what];
        if (what === 'all') {
            cached = this.all;
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* isArray */])(cachedObject)) {
            // Let's see whether we've already called the
            // 'what' method with the same 'args'
            for (var i = 0; i < cachedObject.length; i++) {
                var item = cachedObject[i];
                if (argsKeys.length && findCacheDiff(item))
                    continue;
                cached = item._value;
                break;
            }
        }
        if (!cached && this.all) {
            // Not in the cache, but we already know all the occurrences,
            // so we can find the correct dates from the cached ones.
            var iterResult = new __WEBPACK_IMPORTED_MODULE_0__iterresult__["a" /* default */](what, args);
            for (var i = 0; i < this.all.length; i++) {
                if (!iterResult.accept(this.all[i]))
                    break;
            }
            cached = iterResult.getValue();
            this._cacheAdd(what, cached, args);
        }
        return Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* isArray */])(cached)
            ? __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].cloneDates(cached)
            : cached instanceof Date
                ? __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].clone(cached)
                : cached;
    };
    return Cache;
}());

//# sourceMappingURL=cache.js.map

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__yearinfo__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__monthinfo__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__easter__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datetime__ = __webpack_require__(46);







// =============================================================================
// Iterinfo
// =============================================================================
var Iterinfo = /** @class */ (function () {
    function Iterinfo(options) {
        this.options = options;
    }
    Iterinfo.prototype.rebuild = function (year, month) {
        var options = this.options;
        if (year !== this.lastyear) {
            this.yearinfo = Object(__WEBPACK_IMPORTED_MODULE_3__yearinfo__["a" /* rebuildYear */])(year, options);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["h" /* notEmpty */])(options.bynweekday) &&
            (month !== this.lastmonth || year !== this.lastyear)) {
            var _a = this.yearinfo, yearlen = _a.yearlen, mrange = _a.mrange, wdaymask = _a.wdaymask;
            this.monthinfo = Object(__WEBPACK_IMPORTED_MODULE_4__monthinfo__["a" /* rebuildMonth */])(year, month, yearlen, mrange, wdaymask, options);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["f" /* isPresent */])(options.byeaster)) {
            this.eastermask = Object(__WEBPACK_IMPORTED_MODULE_5__easter__["a" /* easter */])(year, options.byeaster);
        }
    };
    Object.defineProperty(Iterinfo.prototype, "lastyear", {
        get: function () {
            return this.monthinfo ? this.monthinfo.lastyear : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "lastmonth", {
        get: function () {
            return this.monthinfo ? this.monthinfo.lastmonth : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "yearlen", {
        get: function () {
            return this.yearinfo.yearlen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "yearordinal", {
        get: function () {
            return this.yearinfo.yearordinal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "mrange", {
        get: function () {
            return this.yearinfo.mrange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "wdaymask", {
        get: function () {
            return this.yearinfo.wdaymask;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "mmask", {
        get: function () {
            return this.yearinfo.mmask;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "wnomask", {
        get: function () {
            return this.yearinfo.wnomask;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "nwdaymask", {
        get: function () {
            return this.monthinfo ? this.monthinfo.nwdaymask : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "nextyearlen", {
        get: function () {
            return this.yearinfo.nextyearlen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "mdaymask", {
        get: function () {
            return this.yearinfo.mdaymask;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "nmdaymask", {
        get: function () {
            return this.yearinfo.nmdaymask;
        },
        enumerable: true,
        configurable: true
    });
    Iterinfo.prototype.ydayset = function () {
        return [Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* range */])(this.yearlen), 0, this.yearlen];
    };
    Iterinfo.prototype.mdayset = function (_, month, __) {
        var start = this.mrange[month - 1];
        var end = this.mrange[month];
        var set = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(null, this.yearlen);
        for (var i = start; i < end; i++)
            set[i] = i;
        return [set, start, end];
    };
    Iterinfo.prototype.wdayset = function (year, month, day) {
        // We need to handle cross-year weeks here.
        var set = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(null, this.yearlen + 7);
        var i = __WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].toOrdinal(new Date(Date.UTC(year, month - 1, day))) -
            this.yearordinal;
        var start = i;
        for (var j = 0; j < 7; j++) {
            set[i] = i;
            ++i;
            if (this.wdaymask[i] === this.options.wkst)
                break;
        }
        return [set, start, i];
    };
    Iterinfo.prototype.ddayset = function (year, month, day) {
        var set = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(null, this.yearlen);
        var i = __WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].toOrdinal(new Date(Date.UTC(year, month - 1, day))) -
            this.yearordinal;
        set[i] = i;
        return [set, i, i + 1];
    };
    Iterinfo.prototype.htimeset = function (hour, _, second, millisecond) {
        var _this = this;
        var set = [];
        this.options.byminute.forEach(function (minute) {
            set = set.concat(_this.mtimeset(hour, minute, second, millisecond));
        });
        __WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].sort(set);
        return set;
    };
    Iterinfo.prototype.mtimeset = function (hour, minute, _, millisecond) {
        var set = this.options.bysecond.map(function (second) {
            return new __WEBPACK_IMPORTED_MODULE_6__datetime__["b" /* Time */](hour, minute, second, millisecond);
        });
        __WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].sort(set);
        return set;
    };
    Iterinfo.prototype.stimeset = function (hour, minute, second, millisecond) {
        return [new __WEBPACK_IMPORTED_MODULE_6__datetime__["b" /* Time */](hour, minute, second, millisecond)];
    };
    Iterinfo.prototype.getdayset = function (freq) {
        switch (freq) {
            case __WEBPACK_IMPORTED_MODULE_2__types__["a" /* Frequency */].YEARLY: return this.ydayset.bind(this);
            case __WEBPACK_IMPORTED_MODULE_2__types__["a" /* Frequency */].MONTHLY: return this.mdayset.bind(this);
            case __WEBPACK_IMPORTED_MODULE_2__types__["a" /* Frequency */].WEEKLY: return this.wdayset.bind(this);
            case __WEBPACK_IMPORTED_MODULE_2__types__["a" /* Frequency */].DAILY: return this.ddayset.bind(this);
            default: return this.ddayset.bind(this);
        }
    };
    Iterinfo.prototype.gettimeset = function (freq) {
        switch (freq) {
            case __WEBPACK_IMPORTED_MODULE_2__types__["a" /* Frequency */].HOURLY: return this.htimeset.bind(this);
            case __WEBPACK_IMPORTED_MODULE_2__types__["a" /* Frequency */].MINUTELY: return this.mtimeset.bind(this);
            case __WEBPACK_IMPORTED_MODULE_2__types__["a" /* Frequency */].SECONDLY: return this.stimeset.bind(this);
        }
    };
    return Iterinfo;
}());
/* harmony default export */ __webpack_exports__["a"] = (Iterinfo);
//# sourceMappingURL=index.js.map

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rebuildYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__masks__ = __webpack_require__(478);




function rebuildYear(year, options) {
    var firstyday = new Date(Date.UTC(year, 0, 1));
    var yearlen = __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].isLeapYear(year) ? 366 : 365;
    var nextyearlen = __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].isLeapYear(year + 1) ? 366 : 365;
    var yearordinal = __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].toOrdinal(firstyday);
    var yearweekday = __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].getWeekday(firstyday);
    var result = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ yearlen: yearlen,
        nextyearlen: nextyearlen,
        yearordinal: yearordinal,
        yearweekday: yearweekday }, baseYearMasks(year)), { wnomask: null });
    if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* empty */])(options.byweekno)) {
        return result;
    }
    result.wnomask = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["l" /* repeat */])(0, yearlen + 7);
    var firstwkst;
    var wyearlen;
    var no1wkst = firstwkst = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["j" /* pymod */])(7 - yearweekday + options.wkst, 7);
    if (no1wkst >= 4) {
        no1wkst = 0;
        // Number of days in the year, plus the days we got
        // from last year.
        wyearlen =
            result.yearlen + Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["j" /* pymod */])(yearweekday - options.wkst, 7);
    }
    else {
        // Number of days in the year, minus the days we
        // left in last year.
        wyearlen = yearlen - no1wkst;
    }
    var div = Math.floor(wyearlen / 7);
    var mod = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["j" /* pymod */])(wyearlen, 7);
    var numweeks = Math.floor(div + mod / 4);
    for (var j = 0; j < options.byweekno.length; j++) {
        var n = options.byweekno[j];
        if (n < 0) {
            n += numweeks + 1;
        }
        if (!(n > 0 && n <= numweeks)) {
            continue;
        }
        var i = void 0;
        if (n > 1) {
            i = no1wkst + (n - 1) * 7;
            if (no1wkst !== firstwkst) {
                i -= 7 - firstwkst;
            }
        }
        else {
            i = no1wkst;
        }
        for (var k = 0; k < 7; k++) {
            result.wnomask[i] = 1;
            i++;
            if (result.wdaymask[i] === options.wkst)
                break;
        }
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* includes */])(options.byweekno, 1)) {
        // Check week number 1 of next year as well
        // orig-TODO : Check -numweeks for next year.
        var i = no1wkst + numweeks * 7;
        if (no1wkst !== firstwkst)
            i -= 7 - firstwkst;
        if (i < yearlen) {
            // If week starts in next year, we
            // don't care about it.
            for (var j = 0; j < 7; j++) {
                result.wnomask[i] = 1;
                i += 1;
                if (result.wdaymask[i] === options.wkst)
                    break;
            }
        }
    }
    if (no1wkst) {
        // Check last week number of last year as
        // well. If no1wkst is 0, either the year
        // started on week start, or week number 1
        // got days from last year, so there are no
        // days from last year's last week number in
        // this year.
        var lnumweeks = void 0;
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* includes */])(options.byweekno, -1)) {
            var lyearweekday = __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].getWeekday(new Date(Date.UTC(year - 1, 0, 1)));
            var lno1wkst = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["j" /* pymod */])(7 - lyearweekday.valueOf() + options.wkst, 7);
            var lyearlen = __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].isLeapYear(year - 1) ? 366 : 365;
            var weekst = void 0;
            if (lno1wkst >= 4) {
                lno1wkst = 0;
                weekst = lyearlen + Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["j" /* pymod */])(lyearweekday - options.wkst, 7);
            }
            else {
                weekst = yearlen - no1wkst;
            }
            lnumweeks = Math.floor(52 + Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["j" /* pymod */])(weekst, 7) / 4);
        }
        else {
            lnumweeks = -1;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* includes */])(options.byweekno, lnumweeks)) {
            for (var i = 0; i < no1wkst; i++)
                result.wnomask[i] = 1;
        }
    }
    return result;
}
function baseYearMasks(year) {
    var yearlen = __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].isLeapYear(year) ? 366 : 365;
    var firstyday = new Date(Date.UTC(year, 0, 1));
    var wday = __WEBPACK_IMPORTED_MODULE_1__dateutil__["b" /* default */].getWeekday(firstyday);
    if (yearlen === 365) {
        return {
            mmask: __WEBPACK_IMPORTED_MODULE_3__masks__["a" /* M365MASK */],
            mdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__["e" /* MDAY365MASK */],
            nmdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__["g" /* NMDAY365MASK */],
            wdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__["i" /* WDAYMASK */].slice(wday),
            mrange: __WEBPACK_IMPORTED_MODULE_3__masks__["b" /* M365RANGE */]
        };
    }
    return {
        mmask: __WEBPACK_IMPORTED_MODULE_3__masks__["c" /* M366MASK */],
        mdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__["f" /* MDAY366MASK */],
        nmdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__["h" /* NMDAY366MASK */],
        wdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__["i" /* WDAYMASK */].slice(wday),
        mrange: __WEBPACK_IMPORTED_MODULE_3__masks__["d" /* M366RANGE */]
    };
}
//# sourceMappingURL=yearinfo.js.map

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return WDAYMASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return M365MASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return M365RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return M366MASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return M366RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MDAY365MASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MDAY366MASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NMDAY365MASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NMDAY366MASK; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(7);


// =============================================================================
// Date masks
// =============================================================================
// Every mask is 7 days longer to handle cross-year weekly periods.
var M365MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(1, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(2, 28), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(3, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(4, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(5, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(6, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(7, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(8, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(9, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(10, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(11, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(12, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(1, 7));
var M366MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(1, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(2, 29), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(3, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(4, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(5, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(6, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(7, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(8, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(9, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(10, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(11, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(12, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(1, 7));
var M28 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* range */])(1, 29);
var M29 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* range */])(1, 30);
var M30 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* range */])(1, 31);
var M31 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* range */])(1, 32);
var MDAY366MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])(M31, M29, M31, M30, M31, M30, M31, M31, M30, M31, M30, M31, M31.slice(0, 7));
var MDAY365MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])(M31, M28, M31, M30, M31, M30, M31, M31, M30, M31, M30, M31, M31.slice(0, 7));
var NM28 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* range */])(-28, 0);
var NM29 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* range */])(-29, 0);
var NM30 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* range */])(-30, 0);
var NM31 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* range */])(-31, 0);
var NMDAY366MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])(NM31, NM29, NM31, NM30, NM31, NM30, NM31, NM31, NM30, NM31, NM30, NM31, NM31.slice(0, 7));
var NMDAY365MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])(NM31, NM28, NM31, NM30, NM31, NM30, NM31, NM31, NM30, NM31, NM30, NM31, NM31.slice(0, 7));
var M366RANGE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366];
var M365RANGE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365];
var WDAYMASK = (function () {
    var wdaymask = [];
    for (var i = 0; i < 55; i++)
        wdaymask = wdaymask.concat(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* range */])(7));
    return wdaymask;
})();

//# sourceMappingURL=masks.js.map

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rebuildMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rrule__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(7);


function rebuildMonth(year, month, yearlen, mrange, wdaymask, options) {
    var result = {
        lastyear: year,
        lastmonth: month,
        nwdaymask: []
    };
    var ranges = [];
    if (options.freq === __WEBPACK_IMPORTED_MODULE_0__rrule__["c" /* default */].YEARLY) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* empty */])(options.bymonth)) {
            ranges = [[0, yearlen]];
        }
        else {
            for (var j = 0; j < options.bymonth.length; j++) {
                month = options.bymonth[j];
                ranges.push(mrange.slice(month - 1, month + 1));
            }
        }
    }
    else if (options.freq === __WEBPACK_IMPORTED_MODULE_0__rrule__["c" /* default */].MONTHLY) {
        ranges = [mrange.slice(month - 1, month + 1)];
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* empty */])(ranges)) {
        return result;
    }
    // Weekly frequency won't get here, so we may not
    // care about cross-year weekly periods.
    result.nwdaymask = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* repeat */])(0, yearlen);
    for (var j = 0; j < ranges.length; j++) {
        var rang = ranges[j];
        var first = rang[0];
        var last = rang[1] - 1;
        for (var k = 0; k < options.bynweekday.length; k++) {
            var i = void 0;
            var _a = options.bynweekday[k], wday = _a[0], n = _a[1];
            if (n < 0) {
                i = last + (n + 1) * 7;
                i -= Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["j" /* pymod */])(wdaymask[i] - wday, 7);
            }
            else {
                i = first + (n - 1) * 7;
                i += Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["j" /* pymod */])(7 - wdaymask[i] + wday, 7);
            }
            if (first <= i && i <= last)
                result.nwdaymask[i] = 1;
        }
    }
    return result;
}
//# sourceMappingURL=monthinfo.js.map

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = easter;
function easter(y, offset) {
    if (offset === void 0) { offset = 0; }
    var a = y % 19;
    var b = Math.floor(y / 100);
    var c = y % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = Math.floor(19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = Math.floor(32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    var date = Date.UTC(y, month - 1, day + offset);
    var yearStart = Date.UTC(y, 0, 1);
    return [Math.ceil((date - yearStart) / (1000 * 60 * 60 * 24))];
}
//# sourceMappingURL=easter.js.map

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildPoslist;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dateutil__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(7);


function buildPoslist(bysetpos, timeset, start, end, ii, dayset) {
    var poslist = [];
    for (var j = 0; j < bysetpos.length; j++) {
        var daypos = void 0;
        var timepos = void 0;
        var pos = bysetpos[j];
        if (pos < 0) {
            daypos = Math.floor(pos / timeset.length);
            timepos = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["j" /* pymod */])(pos, timeset.length);
        }
        else {
            daypos = Math.floor((pos - 1) / timeset.length);
            timepos = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["j" /* pymod */])(pos - 1, timeset.length);
        }
        var tmp = [];
        for (var k = start; k < end; k++) {
            var val = dayset[k];
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["f" /* isPresent */])(val))
                continue;
            tmp.push(val);
        }
        var i = void 0;
        if (daypos < 0) {
            i = tmp.slice(daypos)[0];
        }
        else {
            i = tmp[daypos];
        }
        var time = timeset[timepos];
        var date = __WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].fromOrdinal(ii.yearordinal + i);
        var res = __WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].combine(date, time);
        // XXX: can this ever be in the array?
        // - compare the actual date instead?
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* includes */])(poslist, res))
            poslist.push(res);
    }
    __WEBPACK_IMPORTED_MODULE_0__dateutil__["b" /* default */].sort(poslist);
    return poslist;
}
//# sourceMappingURL=poslist.js.map

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iterSet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datewithzone__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iter_index__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dateutil__ = __webpack_require__(6);



function iterSet(iterResult, _rrule, _exrule, _rdate, _exdate, tzid) {
    var _exdateHash = {};
    var _accept = iterResult.accept;
    function evalExdate(after, before) {
        _exrule.forEach(function (rrule) {
            rrule.between(after, before, true).forEach(function (date) {
                _exdateHash[Number(date)] = true;
            });
        });
    }
    _exdate.forEach(function (date) {
        var zonedDate = new __WEBPACK_IMPORTED_MODULE_0__datewithzone__["a" /* DateWithZone */](date, tzid).rezonedDate();
        _exdateHash[Number(zonedDate)] = true;
    });
    iterResult.accept = function (date) {
        var dt = Number(date);
        if (isNaN(dt))
            return _accept.call(this, date);
        if (!_exdateHash[dt]) {
            evalExdate(new Date(dt - 1), new Date(dt + 1));
            if (!_exdateHash[dt]) {
                _exdateHash[dt] = true;
                return _accept.call(this, date);
            }
        }
        return true;
    };
    if (iterResult.method === 'between') {
        evalExdate(iterResult.args.after, iterResult.args.before);
        iterResult.accept = function (date) {
            var dt = Number(date);
            if (!_exdateHash[dt]) {
                _exdateHash[dt] = true;
                return _accept.call(this, date);
            }
            return true;
        };
    }
    for (var i = 0; i < _rdate.length; i++) {
        var zonedDate = new __WEBPACK_IMPORTED_MODULE_0__datewithzone__["a" /* DateWithZone */](_rdate[i], tzid).rezonedDate();
        if (!iterResult.accept(new Date(zonedDate.getTime())))
            break;
    }
    _rrule.forEach(function (rrule) {
        Object(__WEBPACK_IMPORTED_MODULE_1__iter_index__["a" /* iter */])(iterResult, rrule.options);
    });
    var res = iterResult._result;
    __WEBPACK_IMPORTED_MODULE_2__dateutil__["b" /* default */].sort(res);
    switch (iterResult.method) {
        case 'all':
        case 'between':
            return res;
        case 'before':
            return ((res.length && res[res.length - 1]) || null);
        case 'after':
        default:
            return ((res.length && res[0]) || null);
    }
}
//# sourceMappingURL=iterset.js.map

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var module = angular.module('new-event'); // NOTE: we intentionally use old-school directive rather than component
// so we can inherit parent controller/scope and allow toggling between
// 2 view modes without destroying state of controller.
//
// The templates files rely on `vm` which is included via the parent scope.
//
// These are essentially utilized as ng-include's but work better with our
// webpack setup this way.
// Top Level Components
//    * <new-event-quick />
//    * <new-event-wizard />

module.directive('newEventQuick', function () {
  return {
    restrict: 'E',
    template: __webpack_require__(484)
  };
});
module.directive('newEventWizard', function () {
  return {
    restrict: 'E',
    template: __webpack_require__(485)
  };
});

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row form-horizontal\">\n  <div ng-if=\"vm.showError\" class=\"col-xs-12\">\n    <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n      {{vm.service.errors.join('. ') || 'Please fill out all required fields before proceeding.'}}\n    </div>\n  </div>\n\n  <div class=\"col-xs-12\">\n\n    <div class=\"text-right\" ng-hide=\"vm.newEventQuickSettings.showModeToggle === false\">\n      <span style=\"line-height:34px\">\n        <small><strong><i class=\"fa fa-flash\"></i> Quick Entry</strong></small>\n        &nbsp;<span style=\"opacity:0.5\">|</span>&nbsp;\n        <a href=\"javascript://\" ng-click=\"vm.toggleEntryMode()\" class=\"subtle-link\"><small><i class=\"fa fa-magic\"></i>\n            Wizard</small></a>\n        <span ng-if=\"::vm.service.user.can('read', 'broadcast-import-template')\">\n          &nbsp;<span style=\"opacity:0.5\">|</span>&nbsp;\n          <a ui-sref=\"bulk-import\" class=\"subtle-link\"><small><i class=\"fa fa-list-alt\"></i> Bulk</small></a>\n        </span>\n      </span>\n    </div>\n\n    <div class=\"well\">\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-4\" for=\"eventName\">Broadcast Name <i class=\"fa fa-asterisk text-danger\"\n          style=\"font-size:10px;vertical-align:top\"></i></label>\n        <div class=\"col-sm-8\">\n          <input type=\"text\" class=\"form-control\" id=\"eventName\" name=\"eventName\" ng-model=\"vm.service.broadcast.name\"\n            ng-maxlength=\"::vm.service.limits.name\" required>\n          <div class=\"form-group\"\n            ng-show=\"(form.eventName.$dirty || form.eventName.$touched) && !vm.service.broadcast.name\">\n            <span class=\"text-danger\" ng-if=\"form.eventName.$error.maxlength\">The broadcast name is too long.</span>\n            <span class=\"text-danger\" ng-if=\"form.eventName.$error.required\">The broadcast name cannot be blank.</span>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-4\" for=\"eventDescription\">Description</label>\n        <div class=\"col-sm-8\">\n          <textarea rows=\"3\" class=\"form-control\" id=\"eventDescription\"\n            ng-model=\"vm.service.broadcast.description\"></textarea>\n        </div>\n      </div>\n\n      <div class=\"form-group\" ng-hide=\"vm.newEventQuickSettings.showPreview === false || vm.service.simulcastOnly\">\n        <label class=\"col-sm-4\">Preview Image</label>\n        <div class=\"col-sm-8\">\n          <div ng-if=\"vm.service.broadcast.content_settings.preview\" class=\"text-center\">\n            <img ng-src=\"{{vm.service.broadcast.content_settings.preview | trustedUrl}}\" class=\"img\"\n              style=\"max-width:100%\">\n            <div><a href ng-click=\"vm.service.broadcast.content_settings.preview = null\">Change</a></div>\n          </div>\n          <div ng-if=\"!vm.service.broadcast.content_settings.preview\">\n            <upload-slot ng-model=\"vm.file\" ng-change=\"vm.service.uploadPreviewImage(vm.file)\" slot-name=\"'preview'\"\n              allow-image=\"true\" allow-video=\"false\" compact=\"true\"></upload-slot>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\" ng-hide=\"vm.newEventQuickSettings.showBoxCasters === false\">\n        <label class=\"col-sm-4\" for=\"boxcaster\">Source <i class=\"fa fa-asterisk text-danger\"\n            style=\"font-size:10px;vertical-align:top\"></i></label>\n        <div class=\"col-sm-8\">\n          <source-chooser edit-or-create-event-service=\"vm.service\"></source-chooser>\n          <p class=\"help-block\" style=\"float:left;\"\n            ng-show=\"vm.service.allowSimulatedLive && !vm.service.boxcasters.length && !vm.service.allowSwitcher && !vm.service.allowBroadcasterApp && !vm.service.staticRTMPs.length\">\n            <i class=\"fa fa-info-circle\" style=\"width:15px;\"></i>\n            Need to <a href=\"{{vueDashboardRoot}}/sources\">add a source</a>?\n          </p>\n        </div>\n      </div>\n\n      <div class=\"form-group\" ng-if=\"vm.service.isSimulatedLive\">\n        <label class=\"col-sm-4\">Source Broadcast<i class=\"fa fa-asterisk text-danger\"\n            style=\"font-size:10px;vertical-align:top\"></i></label>\n        <div class=\"col-sm-8\">\n          <recording-source-chooser edit-or-create-event-service=\"vm.service\"></recording-source-chooser>\n        </div>\n      </div>\n\n      <div ng-show=\"vm.service.isRTMPBasedSource\">\n        <div class=\"form-group\" ng-hide=\"vm.service.hideOptionVideoResolution\">\n          <label class=\"col-sm-4\" for=\"video_resolution\">Video Resolution</label>\n          <div class=\"col-sm-8\">\n            <div class=\"btn-group btn-group-justified\">\n              <label class=\"btn btn-default\" ng-model=\"vm.service.broadcast.target_video_resolution\" uib-btn-radio=\"480\"\n                ng-if=\"vm.service.resolutionLimit >= 480\">480p</label>\n              <label class=\"btn btn-default\" ng-model=\"vm.service.broadcast.target_video_resolution\" uib-btn-radio=\"720\"\n                ng-if=\"vm.service.resolutionLimit >= 720\">720p</label>\n              <label class=\"btn btn-default\" ng-model=\"vm.service.broadcast.target_video_resolution\"\n                uib-btn-radio=\"1080\" ng-if=\"vm.service.resolutionLimit >= 1080\">1080p</label>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.hideHighFrameRate\">\n          <label class=\"col-sm-4\" for=\"target_high_frame_rate\">Frame Rate</label>\n          <div class=\"col-sm-8\">\n            <div class=\"btn-group btn-group-justified\">\n              <label class=\"btn btn-default\" ng-model=\"vm.service.broadcast.target_high_frame_rate\"\n                uib-btn-radio=\"false\">Standard&nbsp; <small style=\"opacity:0.4;font-weight:bold;\">30fps\n                  max</small></label>\n              <label class=\"btn btn-default\" ng-model=\"vm.service.broadcast.target_high_frame_rate\"\n                uib-btn-radio=\"true\">High&nbsp; <small style=\"opacity:0.4;font-weight:bold;\">60fps max</small></label>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-4\">\n          Start Date\n          <i class=\"fa fa-asterisk text-danger\" style=\"font-size:12px;vertical-align:top\"></i>\n          <i class=\"fa fa-question-circle\" style=\"font-size:12px;vertical-align:top\"\n            uib-tooltip=\"All dates and times are based on your computer's current timezone\"></i>\n        </label>\n        <div class=\"col-sm-8\">\n          <div class=\"input-group\" style=\"max-width:200px\">\n            <input type=\"text\" class=\"form-control\" ng-model=\"vm.service.startDate\"\n              ng-change=\"vm.service.getConflictingEvents(true)\" uib-datepicker-popup=\"MM/dd/yyyy\"\n              is-open=\"vm.startDatePopupOpened\" ng-required=\"true\" datepicker-options=\"vm.service.datepickerOptions\">\n            <span class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-default\"\n                ng-click=\"vm.startDatePopupOpened = !vm.startDatePopupOpened\"><i\n                  class=\"glyphicon glyphicon-calendar\"></i></button>\n            </span>\n          </div>\n\n          <div ng-if=\"vm.service.otherEvents.length > 0\" style=\"margin-top:10px\">\n            <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\"\n              ng-if=\"vm.service.account.max_simultaneous_streams > 0 && vm.service.worstCaseSimultaneousStreams >= vm.service.account.max_simultaneous_streams\">\n              <h5 style=\"margin-top:0;font-weight:bold;\">\n                Stream Limits\n              </h5>\n              <p>\n                Your account is only able to stream {{ vm.service.account.max_simultaneous_streams }} simultaneous\n                broadcast{{ vm.service.account.max_simultaneous_streams > 1 ? 's' : '' }}. This broadcast will not\n                start if that count is exceeded. If you would like to add additional simultaneous broadcasts to your\n                account, please <a href=\"mailto:questions@boxcast.com\" target=\"_blank\">contact customer support</a>.\n              </p>\n            </div>\n            <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\"\n              ng-if=\"vm.service.conflictingEvents.length > 0\">\n              <h5 style=\"margin-top:0;font-weight:bold;\">\n                Conflicting Broadcasts\n              </h5>\n              <ul class=\"list-unstyled\" style=\"margin:0\">\n                <li ng-repeat=\"broadcast in vm.service.conflictingEvents track by broadcast.id\" style=\"font-size:0.8em\">\n                  <strong>{{::broadcast.name}}</strong> <span>({{::broadcast.starts_at | date:'h:mm a'}} -\n                    {{::broadcast.stops_at | date:'shortTime'}})</span>\n                </li>\n              </ul>\n            </div>\n            <div ng-if=\"vm.service.otherEvents.length > 0\" style=\"opacity:0.5\">\n              <h5 style=\"margin-top:0;font-weight:bold;\">\n                Other Broadcasts on {{vm.service.startDate | date}}\n              </h5>\n              <ul class=\"list-unstyled\" style=\"margin:0\">\n                <li ng-repeat=\"broadcast in vm.service.otherEvents track by broadcast.id\" style=\"font-size:0.8em\">\n                  <strong>{{::broadcast.name}}</strong> <span>({{::broadcast.starts_at | date:'h:mm a'}}</span><span\n                    ng-if=\"broadcast.stops_at && !broadcast.stops_at.startsWith('9999-12-31')\">- {{::broadcast.stops_at\n                    | date:'shortTime'}}</span><span>)</span>\n                </li>\n              </ul>\n            </div>\n          </div>\n\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-4\">Start Time</label>\n        <div class=\"col-sm-8\">\n          <div class=\"clearfix\">\n            <div style=\"max-width:200px;float:left;margin-right:10px;\">\n              <time-picker ng-model=\"vm.service.startTime\" scroll-item-into-focus=\"true\"\n                ng-change=\"vm.service.getConflictingEvents()\"></time-picker>\n            </div>\n            <p class=\"help-block\" style=\"float:left;\">\n              <i class=\"fa fa-info-circle\" style=\"width:15px;\"></i>\n              All times {{vm.currentTimezone}}\n            </p>\n          </div>\n          <p class=\"text-warning\" ng-show=\"vm.service.recordingStorageExpires\">\n            <i class=\"fa fa-warning\"></i>\n            The source recording for this simulated live broadcast will be purged before the broadcast's start time.\n          </p>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-4\">End Time</label>\n        <div class=\"col-sm-8\" ng-hide=\"vm.service.isSimulatedLive\">\n          <div class=\"clearfix\">\n            <div style=\"max-width:200px;float:left;margin-right:10px;\">\n              <time-picker ng-model=\"vm.service.endTime\" start-time=\"vm.service.startTime\" show-duration=\"true\"\n                ng-change=\"vm.service.getConflictingEvents()\"></time-picker>\n            </div>\n            <p class=\"help-block\" style=\"float:left;\">\n              <i class=\"fa fa-clock-o\" style=\"width:15px;\"></i>\n              Duration: {{ vm.service.startTime | dateDuration : vm.service.endTime : false :\n              vm.service.maxBroadcastDurationHours+':00' }} hours\n            </p>\n          </div>\n          <p class=\"text-warning\"\n            ng-show=\"!vm.service.isSimulatedLive && vm.service.endTime.toTimeString() < vm.service.startTime.toTimeString()\">\n            <i class=\"fa fa-warning\"></i>\n            The end time is <em>before</em> the start time, so the broadcast will continue until the following day\n          </p>\n          <p class=\"text-danger\"\n            ng-show=\"!vm.service.isSimulatedLive && vm.service.endTime.toTimeString() == vm.service.startTime.toTimeString()\">\n            <i class=\"fa fa-warning\"></i>\n            A broadcast must have a non-zero duration\n          </p>\n          <p class=\"text-danger\" ng-show=\"vm.service.isInThePast\">\n            <i class=\"fa fa-warning\"></i>\n            A broadcast may not be scheduled in the past\n          </p>\n        </div>\n        <div class=\"col-sm-8\" ng-show=\"vm.service.isSimulatedLive\">\n          <div class=\"clearfix\">\n            <p ng-hide=\"vm.service.simulatedLiveEndTime\" class=\"help-block\" style=\"float:left;\">\n              <i class=\"fa fa-clock-o\" style=\"width:15px;\"></i>\n              End time will be calculated from the recording duration.\n            </p>\n            <div ng-if=\"vm.service.simulatedLiveEndTime\" style=\"max-width:200px;float:left;margin-right:10px;\">\n              <input class=\"form-control\" disabled\n                value=\"{{vm.service.simulatedLiveEndTime | date:'shortTime' | lowercase}}\">\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <recurrence-pattern ng-if=\"vm.newEventQuickSettings.showRecurring !== false\"></recurrence-pattern>\n\n      <div class=\"form-group\" ng-hide=\"vm.service.simulcastOnly\">\n        <label class=\"col-sm-4\">Broadcast Type <i class=\"fa fa-asterisk text-danger\"\n            style=\"font-size:10px;vertical-align:top\"></i></label>\n        <div class=\"col-sm-8\">\n          <div class=\"btn-group\">\n            <label class=\"btn btn-default\" ng-model=\"vm.service.visibility\" uib-btn-radio=\"'private'\"> Private</label>\n            <label class=\"btn btn-default\" ng-if=\"vm.service.showPublic\" ng-model=\"vm.service.visibility\"\n              uib-btn-radio=\"'public'\"> Public</label>\n            <label class=\"btn btn-default\" ng-if=\"vm.service.showFlex\" ng-model=\"vm.service.visibility\"\n              uib-btn-radio=\"'flex'\"> Flex (Ticketed HD)</label>\n            <label class=\"btn btn-default\" ng-if=\"vm.service.showTicketed\" ng-model=\"vm.service.visibility\"\n              uib-btn-radio=\"'ticketed'\"> Ticketed</label>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\" ng-show=\"vm.service.visibility == 'ticketed' || vm.service.visibility == 'flex'\">\n        <label class=\"col-sm-4\" for=\"ticket_price\">Ticket Price <i class=\"fa fa-asterisk text-danger\"\n            style=\"font-size:10px;vertical-align:top\"></i></label>\n        <div class=\"col-sm-8\">\n          <div class=\"input-group\">\n            <div class=\"input-group-addon\">$</div>\n            <input type=\"number\" step=\"0.01\" class=\"form-control\" style=\"max-width: 100px\" id=\"ticket_price\"\n              ng-model=\"vm.service.broadcast.ticket_price\">\n          </div>\n          <p class=\"help-block\" ng-show=\"vm.service.visibility == 'ticketed'\"><i class=\"fa fa-info-circle\"></i> Minimum\n            ticket price is ${{vm.service.minTicketPrice | number:2}}</p>\n          <p class=\"help-block\" ng-show=\"vm.service.visibility == 'flex'\"><i class=\"fa fa-info-circle\"></i> Minimum\n            ticket price is ${{vm.service.minTicketPrice | number:2}}. Viewers will receive a low-quality stream for\n            free.</p>\n        </div>\n      </div>\n\n      <div class=\"form-group\" ng-show=\"vm.service.showChannelSelector\">\n        <label class=\"col-sm-4\">Channels</label>\n        <div class=\"col-sm-8\">\n          <select selectize config=\"{\n              valueField: 'id',\n              labelField: 'name',\n              placeholder: 'Select Channels...',\n              highlight: true,\n              searchField: 'name',\n              selectOnTab: false,\n              plugins: ['remove_button']\n            }\" options=\"vm.service.channels\" ng-model=\"vm.service.broadcast.in_channel_ids\"></select>\n          <p class=\"text-warning\" ng-show=\"vm.service.visibility == 'private'\">\n            <i class=\"fa fa-warning\"></i> Channels are not applicable to private broadcasts.\n          </p>\n        </div>\n      </div>\n\n      <div class=\"form-group\" ng-show=\"vm.service.showFeatured\">\n        <label class=\"col-sm-4\">Tags</label>\n        <div class=\"col-sm-8\">\n          <select selectize config=\"{\n            valueField: 'name',\n            labelField: 'name',\n            placeholder: 'Select Tags...',\n            highlight: true,\n            searchField: 'name',\n            selectOnTab: true,\n            plugins: ['remove_button'],\n            create: true\n          }\" options=\"vm.service.tags\" ng-model=\"vm.service.broadcast.tags\"></select>\n        </div>\n      </div>\n\n      <div\n        ng-if=\"(vm.service.allowFacebookLive || vm.service.allowYoutubeLive || vm.service.allowGenericRtmpPush || vm.service.allowTwitter) && vm.newEventQuickSettings.showModeToggle !== false\">\n        <simulcast-configuration-editor vm=\"vm\" vertical-form=\"false\"></simulcast-configuration-editor>\n      </div>\n\n      <div ng-if=\"vm.service.showAnyScoreboards || (vm.service.allowDefaultOverlay && vm.overlays.length)\">\n        <div ng-if=\"vm.newEventQuickSettings.showSports !== false\">\n          <div ng-if=\"!vm.scheduleAgain || (vm.scheduleAgain && vm.service.broadcast.name)\">\n            <broadcast-overlay-configuration vm=\"vm\"></broadcast-overlay-configuration>\n          </div>\n        </div>\n      </div>\n\n      <p style=\"font-weight:bold;\">\n        <a ng-click=\"vm.showAdvanced = !vm.showAdvanced\" href>\n          <i class=\"fa\" ng-class=\"vm.showAdvanced ? 'fa-caret-down' : 'fa-caret-right'\"></i>\n          {{vm.showAdvanced ? 'Hide' : 'Show'}} Advanced Settings\n        </a>\n      </p>\n\n      <div class=\"well\" uib-collapse=\"!(vm.showAdvanced === true && !vm.service.broadcast.boxcaster_id)\">\n        <p class=\"help-block text-center\" style=\"margin:30px\">\n          <strong>Please choose a source before configuring any advanced settings.</strong>\n        </p>\n      </div>\n      <div class=\"well\" uib-collapse=\"!(vm.showAdvanced === true && vm.service.broadcast.boxcaster_id)\">\n        <div class=\"form-group\" ng-hide=\"vm.service.hideOptionRecord\">\n          <div class=\"col-xs-12\">\n            <label ng-click=\"vm.service.broadcast.do_not_record = !vm.service.broadcast.do_not_record\"\n              style=\"cursor:pointer\">\n              <i class=\"fa\" ng-class=\"vm.service.broadcast.do_not_record ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Enable Live-Only\n              <i class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\"\n                uib-tooltip=\"Enabling this option means viewers can only watch the broadcast while it is live. Disabling this option will record the broadcast and offer on-demand playback when the broadcast is over.\"\n                tooltip-placement=\"bottom\" style=\"opacity:0.5\"></i>\n            </label>\n          </div>\n        </div>\n\n        <div class=\"form-group\"\n          ng-hide=\"!vm.service.FeatureFlags.automated_captioning || vm.service.FeatureFlags.live_automated_captioning || vm.service.broadcast.do_not_record || vm.service.isSimulatedLive\">\n          <div class=\"col-xs-12\">\n            <label ng-click=\"vm.service.broadcast.requests_captioning = !vm.service.broadcast.requests_captioning\"\n              style=\"cursor:pointer;\">\n              <i class=\"fa\" ng-class=\"vm.service.broadcast.requests_captioning ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Request Automated Captioning When Recorded\n            </label>\n          </div>\n        </div>\n\n        <div class=\"form-group\"\n          ng-hide=\"!vm.service.FeatureFlags.live_automated_captioning || vm.service.isSimulatedLive\">\n          <div class=\"col-xs-12\">\n            <label ng-click=\"vm.service.broadcast.requests_captioning = !vm.service.broadcast.requests_captioning\"\n              style=\"cursor:pointer;\">\n              <i class=\"fa\" ng-class=\"vm.service.broadcast.requests_captioning ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Automated Live Captioning\n            </label>\n          </div>\n        </div>\n\n        <div class=\"form-group\" ng-if=\"::vm.service.FeatureFlags.password\">\n          <div class=\"col-xs-12\">\n            <label\n              ng-click=\"vm.service.broadcast.content_settings.cryptblock = vm.service.broadcast.content_settings.cryptblock ? null : {}\"\n              style=\"cursor:pointer\">\n              <i class=\"fa\"\n                ng-class=\"vm.service.broadcast.content_settings.cryptblock ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Enable Password Protection\n            </label>\n            <div ng-if=\"vm.service.broadcast.content_settings.cryptblock\" style=\"margin-top:5px\">\n              <div>\n                <span ng-show=\"vm.service.broadcast.content_settings.cryptblock.crypt\">Change Password</span>\n                <span ng-hide=\"vm.service.broadcast.content_settings.cryptblock.crypt\">Enter Password</span>\n              </div>\n              <input type=\"password\" autocomplete=\"hi-browser-plz-dont-autofill-this\" class=\"form-control\"\n                ng-model=\"vm.service.broadcast.content_settings.cryptblock.__password__\">\n            </div>\n          </div>\n        </div>\n\n        <div class=\"form-group\" ng-if=\"::vm.service.FeatureFlags.enterprise_last_mile_delivery\">\n          <div class=\"col-xs-12\">\n            <label\n              ng-click=\"vm.service.broadcast.content_settings.enterprise_last_mile_delivery = !vm.service.enterpriseLastMileDelivery\"\n              style=\"cursor:pointer\">\n              <i class=\"fa\" ng-class=\"vm.service.enterpriseLastMileDelivery ? 'fa-check-square-o' : 'fa-square-o'\"\n                style=\"width:20px\"></i>\n              Enable Enterprise Last-Mile Delivery\n            </label>\n          </div>\n        </div>\n\n        <div class=\"form-group\" ng-if=\"::vm.service.FeatureFlags.host_restrictions\">\n          <div class=\"col-xs-12\">\n            <host-restrictions-settings content-settings=\"vm.service.broadcast.content_settings\">\n            </host-restrictions-settings>\n          </div>\n        </div>\n\n        <div ng-if=\"::vm.service.FeatureFlags.podcast\">\n          <div class=\"form-group\">\n            <div class=\"col-sm-12\">\n              <p style=\"font-weight:bold;\">\n                <a ng-click=\"vm.showPodcast = !vm.showPodcast\" href>\n                  <i class=\"fa\" ng-class=\"vm.showPodcast ? 'fa-caret-down' : 'fa-caret-right'\"></i>\n                  {{vm.showPodcast ? 'Hide' : 'Show'}} Podcast-Specific Settings\n                </a>\n              </p>\n            </div>\n          </div>\n          <div ng-show=\"vm.showPodcast\">\n            <podcast-settings broadcast=\"vm.service.broadcast\"\n              on-upload-preview-image=\"vm.service.uploadPodcastPreviewImage\"></podcast-settings>\n          </div>\n        </div>\n\n        <div class=\"form-group\" ng-show=\"vm.service.showOptionTargetBufferLatency\">\n          <label class=\"col-sm-4\" for=\"target_buffer_latency\">\n            BoxCast Flow Control\n            <i class=\"fa fa-question-circle\" style=\"opacity:0.5\"\n              uib-tooltip-html=\"vm.service.targetBufferLatencyTooltip\" tooltip-append-to-body=\"true\"></i>\n          </label>\n          <div class=\"col-sm-8\">\n            <select class=\"form-control\" id=\"target_buffer_latency\"\n              ng-model=\"vm.service.broadcast.target_buffer_latency\"\n              ng-options=\"e.value as e.label for e in vm.service.bufferLatencies\">\n            </select>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.hideOptionTargetVideoBitRate\">\n          <label class=\"col-sm-4\" for=\"target_video_bitrate\">Target Video Bitrate</label>\n          <div class=\"col-sm-8\">\n            <select class=\"form-control\" id=\"target_video_bitrate\" ng-model=\"vm.service.broadcast.target_video_bitrate\"\n              ng-options=\"e.value as e.label for e in vm.service.videoBitrates\">\n            </select>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.hideOptionTargetAudioBitRate\">\n          <label class=\"col-sm-4\" for=\"target_audio_bitrate\">Target Audio Bitrate</label>\n          <div class=\"col-sm-8\">\n            <select class=\"form-control\" id=\"target_audio_bitrate\" ng-model=\"vm.service.broadcast.target_audio_bitrate\"\n              ng-options=\"e.value as e.label for e in vm.service.audioBitrates\">\n            </select>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.hideOptionAudioSource\">\n          <label class=\"col-sm-4\" for=\"audio_source\">Audio Source</label>\n          <div class=\"col-sm-8\">\n            <select class=\"form-control\" id=\"audio_source\" ng-model=\"vm.service.broadcast.audio_source\"\n              ng-options=\"e.value as e.label for e in vm.service.audioSources\">\n            </select>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.isRTMPBasedSource || vm.service.hideOptionVideoResolution\">\n          <label class=\"col-sm-4\" for=\"video_resolution\">Video Resolution</label>\n          <div class=\"col-sm-8\">\n            <select class=\"form-control\" id=\"video_resolution\" ng-model=\"vm.service.broadcast.target_video_resolution\"\n              ng-disabled=\"vm.service.isAudioOnly\" ng-options=\"e.value as e.label for e in vm.service.videoResolutions\">\n            </select>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.isRTMPBasedSource || vm.service.hideHighFrameRate\">\n          <label class=\"col-sm-4\" for=\"target_high_frame_rate\">High Frame Rate</label>\n          <div class=\"col-sm-8\">\n            <select class=\"form-control\" id=\"target_high_frame_rate\"\n              ng-model=\"vm.service.broadcast.target_high_frame_rate\" ng-disabled=\"vm.service.isAudioOnly\"\n              ng-options=\"e.value as e.label for e in vm.service.highFrameRates\">\n            </select>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.hideOptionDSCPValue\">\n          <label class=\"col-sm-4\" for=\"dscp\">DSCP Value</label>\n          <div class=\"col-sm-8\">\n            <select class=\"form-control\" id=\"dscp\" ng-model=\"vm.service.broadcast.dscp_value\"\n              ng-options=\"e.value as e.label for e in ::vm.service.dscpValues\">\n            </select>\n          </div>\n        </div>\n      </div>\n      <!--/advanced setings well-->\n\n      <button type=\"button\" class=\"btn btn-success btn-block\" ng-click=\"vm.submit()\" ng-disabled=\"vm.submitting\">\n        <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n        Schedule Broadcast\n      </button>\n\n      <p class=\"help-block\" ng-show=\"vm.recurring.enabled\">\n        <i class=\"fa fa-info-circle\"></i>\n        Please note, the recurrence pattern defined will generate a separate event for each instance. You can then\n        manually edit or delete any instance as needed.\n      </p>\n\n      <!-- Clone from here is superceded by recurrence options (I think). Clone is still a thing from an existing event though...\n          <div style=\"margin-top: 15px\" ng-hide=\"vm.newEventQuickSettings.showClone === false\">\n            <span ng-click=\"vm.scheduleAgain = !vm.scheduleAgain\" style=\"cursor:pointer;opacity:0.8\">\n              <i class=\"fa\" ng-class=\"vm.scheduleAgain ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n              Recurring broadcast? Clone this and schedule another broadcast.\n            </span>\n          </div>\n          -->\n\n    </div>\n\n  </div>\n</div>"

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = "<!-- wizard tabs -->\n<div class=\"row\">\n  <div class=\"wizard-steps\" style=\"margin-bottom:15px\">\n    <div class=\"step\" ng-class=\"{active: vm.step == 1, done: vm.maxValidStep > 0}\">\n      <div class=\"bounding-box\" ng-click=\"vm.selectTab(1)\">\n        <span class=\"label\">1</span>\n        <p class=\"hidden-xs\">Overview</p>\n      </div>\n    </div>\n    <div class=\"step\" ng-class=\"{active: vm.step == 2, done: vm.maxValidStep > 1}\">\n      <div class=\"bounding-box\" ng-click=\"vm.selectTab(2)\">\n        <span class=\"label\">2</span>\n        <p class=\"hidden-xs\">Schedule</p>\n      </div>\n    </div>\n    <div ng-if=\"vm.service.showAnyScoreboards || (vm.service.allowDefaultOverlay && vm.overlays.length)\" class=\"step\"\n      ng-class=\"{active: vm.step == 3, done: vm.maxValidStep > 2}\">\n      <div class=\"bounding-box\" ng-click=\"vm.selectTab(3)\">\n        <span class=\"label\">3</span>\n        <p class=\"hidden-xs\">Overlays</p>\n      </div>\n    </div>\n    <div class=\"step\" ng-class=\"{active: vm.step == 4, done: vm.maxValidStep > 3}\">\n      <div class=\"bounding-box\" ng-click=\"vm.selectTab(4)\">\n        <span class=\"label\">{{vm.service.showAnyScoreboards ? 4 : 3}}</span>\n        <p class=\"hidden-xs\">Publish</p>\n      </div>\n    </div>\n    <div class=\"step\" ng-class=\"{active: vm.step == 5, done: vm.maxValidStep > 4}\">\n      <div class=\"bounding-box\" ng-click=\"vm.selectTab(5)\">\n        <span class=\"label\">{{vm.service.showAnyScoreboards ? 5 : 4}}</span>\n        <p class=\"hidden-xs\">Confirm</p>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"row\">\n  <div ng-if=\"vm.showError\" class=\"col-xs-12\">\n    <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n      {{vm.service.errors.join('. ') || 'Please fill out all required fields before proceeding.'}}\n    </div>\n  </div>\n\n  <div class=\"col-xs-12\">\n\n    <div class=\"well\" ng-show=\"vm.step == 1\">\n      <h3>Overview</h3>\n      <div class=\"form-group\">\n        <label for=\"eventName\">Broadcast Name <i class=\"fa fa-asterisk text-danger\"\n            style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"eventName\" name=\"eventName\" ng-model=\"vm.service.broadcast.name\"\n          ng-maxlength=\"::vm.service.limits.name\" required>\n        <p ng-show=\"(form.eventName.$dirty || form.eventName.$touched) && !vm.service.broadcast.name\">\n          <span class=\"text-danger\" ng-if=\"form.eventName.$error.maxlength\">The broadcast name is too long.</span>\n          <span class=\"text-danger\" ng-if=\"form.eventName.$error.required\">The broadcast name cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"row\">\n        <div class=\"form-group col-xs-12 col-sm-8\">\n          <label for=\"eventDescription\">Broadcast Description</label>\n          <textarea rows=\"3\" class=\"form-control\" id=\"eventDescription\"\n            ng-model=\"vm.service.broadcast.description\"></textarea>\n        </div>\n        <div class=\"form-group col-xs-12 col-sm-4\" ng-hide=\"vm.service.simulcastOnly\">\n          <div ng-if=\"vm.service.broadcast.content_settings.preview\" class=\"text-center\">\n            <img ng-src=\"{{vm.service.broadcast.content_settings.preview | trustedUrl}}\" class=\"img\"\n              style=\"max-width:100%\">\n            <div><a href ng-click=\"vm.service.broadcast.content_settings.preview = null\">Change</a></div>\n          </div>\n          <div ng-if=\"!vm.service.broadcast.content_settings.preview\">\n            <upload-slot ng-model=\"vm.file\" ng-change=\"vm.service.uploadPreviewImage(vm.file)\" slot-name=\"'preview'\"\n              allow-image=\"true\" allow-video=\"false\" compact=\"true\"></upload-slot>\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"boxcaster\">Source<i class=\"fa fa-asterisk text-danger\"\n            style=\"font-size:10px;vertical-align:top\"></i></label>\n        <source-chooser edit-or-create-event-service=\"vm.service\"></source-chooser>\n        <p class=\"help-block\"\n          ng-show=\"vm.service.allowSimulatedLive && !vm.service.boxcasters.length && !vm.service.allowSwitcher && !vm.service.allowBroadcasterApp && !vm.service.staticRTMPs.length\">\n          <i class=\"fa fa-info-circle\" style=\"width:15px;\"></i>\n          Need to <a href=\"{{vueDashboardRoot}}/sources\">add a source</a>?\n        </p>\n        <label ng-if=\"vm.service.isSimulatedLive\" style=\"margin-top: 5px;\">Source Broadcast<i\n            class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <recording-source-chooser ng-if=\"vm.service.isSimulatedLive\" edit-or-create-event-service=\"vm.service\">\n        </recording-source-chooser>\n      </div>\n      <div class=\"row\" ng-show=\"vm.service.isRTMPBasedSource\">\n        <div class=\"form-group col-xs-12 col-sm-6\" ng-hide=\"vm.service.hideOptionVideoResolution\">\n          <label for=\"video_resolution\">Video Resolution</label>\n          <div class=\"btn-group btn-group-justified\">\n            <label class=\"btn btn-default\" ng-model=\"vm.service.broadcast.target_video_resolution\" uib-btn-radio=\"480\"\n              ng-if=\"vm.service.resolutionLimit >= 480\">480p</label>\n            <label class=\"btn btn-default\" ng-model=\"vm.service.broadcast.target_video_resolution\" uib-btn-radio=\"720\"\n              ng-if=\"vm.service.resolutionLimit >= 720\">720p</label>\n            <label class=\"btn btn-default\" ng-model=\"vm.service.broadcast.target_video_resolution\" uib-btn-radio=\"1080\"\n              ng-if=\"vm.service.resolutionLimit >= 1080\">1080p</label>\n          </div>\n        </div>\n        <div class=\"form-group col-xs-12 col-sm-6\" ng-hide=\"vm.service.hideHighFrameRate\">\n          <label for=\"target_high_frame_rate\">Frame Rate</label>\n          <div class=\"btn-group btn-group-justified\">\n            <label class=\"btn btn-default\" ng-model=\"vm.service.broadcast.target_high_frame_rate\"\n              uib-btn-radio=\"false\">Standard&nbsp; <small style=\"opacity:0.4;font-weight:bold;\">30fps\n                max</small></label>\n            <label class=\"btn btn-default\" ng-model=\"vm.service.broadcast.target_high_frame_rate\"\n              uib-btn-radio=\"true\">High&nbsp; <small style=\"opacity:0.4;font-weight:bold;\">60fps max</small></label>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"well\" ng-show=\"vm.step == 2\">\n      <h3>Schedule <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></h3>\n\n      <div class=\"row\">\n        <div class=\"col-xs-12\" style=\"margin:15px 0\">\n          <div style=\"display:flex; flex-wrap:wrap;\">\n\n            <div style=\"width:290px;margin-right:15px\">\n              <div class=\"form-group\">\n                <div class=\"datepicker\">\n                  <!-- hack: need wrapper class to target custom styles -->\n                  <uib-datepicker ng-model=\"vm.service.startDate\" ng-change=\"vm.service.getConflictingEvents(true)\"\n                    datepicker-options=\"vm.service.datepickerOptions\"></uib-datepicker>\n                </div>\n              </div>\n            </div>\n\n            <div style=\"width:225px;flex:1;\">\n              <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\"\n                ng-if=\"vm.service.account.max_simultaneous_streams > 0 && vm.service.worstCaseSimultaneousStreams >= vm.service.account.max_simultaneous_streams\">\n                <h5 style=\"margin-top:0;font-weight:bold;\">\n                  Stream Limits\n                </h5>\n                <p>\n                  Your account is only able to stream {{ vm.service.account.max_simultaneous_streams }} simultaneous\n                  broadcast{{ vm.service.account.max_simultaneous_streams > 1 ? 's' : '' }}. This broadcast will not\n                  start if that count is exceeded. If you would like to add additional simultaneous broadcasts to\n                  your account, please <a href=\"mailto:questions@boxcast.com\" target=\"_blank\">contact customer\n                    support</a>.\n                </p>\n              </div>\n              <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\"\n                ng-if=\"vm.service.conflictingEvents.length > 0\">\n                <h5 style=\"margin-top:0;font-weight:bold;\">\n                  Conflicting Broadcasts\n                </h5>\n                <ul class=\"list-unstyled\" style=\"margin:0\">\n                  <li ng-repeat=\"broadcast in vm.service.conflictingEvents track by broadcast.id\">\n                    {{::broadcast.name}}\n                    <span>({{::broadcast.starts_at | date:'h:mm a'}} - {{::broadcast.stops_at | date:'shortTime'}})</span>\n                  </li>\n                </ul>\n              </div>\n              <div ng-if=\"vm.service.otherEvents.length > 0\">\n                <h5 style=\"margin-top:0;font-weight:bold;\">\n                  Other Broadcasts on {{vm.service.startDate | date}}\n                </h5>\n                <ul class=\"list-unstyled\" style=\"margin:0\">\n                  <li ng-repeat=\"broadcast in vm.service.otherEvents track by broadcast.id\">\n                    {{::broadcast.name}}\n                    <span> -- ({{::broadcast.starts_at | date:'h:mm a'}}</span>\n                    <span ng-if=\"broadcast.stops_at && !broadcast.stops_at.startsWith('9999-12-31')\">\n                      - {{::broadcast.stops_at | date:'shortTime'}})\n                    </span>\n                  </li>\n                </ul>\n              </div>\n            </div>\n\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"form-group pull-left\" style=\"padding-left:15px; max-width:200px\">\n          <label>Start Time</label>\n          <time-picker ng-model=\"vm.service.startTime\" scroll-item-into-focus=\"true\"\n            ng-change=\"vm.service.getConflictingEvents()\"></time-picker>\n        </div>\n        <div class=\"form-group pull-left\" style=\"padding-left:15px; max-width:200px\">\n          <label>End Time</label>\n          <time-picker ng-hide=\"vm.service.isSimulatedLive\" ng-model=\"vm.service.endTime\"\n            start-time=\"vm.service.startTime\" show-duration=\"true\" ng-change=\"vm.service.getConflictingEvents()\">\n          </time-picker>\n          <p class=\"help-block\" ng-show=\"vm.service.isSimulatedLive && !vm.service.simulatedLiveEndTime\">\n            <i class=\"fa fa-clock-o\" style=\"width:15px;\"></i>\n            End time will be calculated from the recording duration.\n          </p>\n          <input ng-if=\"vm.service.isSimulatedLive && vm.service.simulatedLiveEndTime\" class=\"form-control\" disabled\n            value=\"{{vm.service.simulatedLiveEndTime | date:'shortTime' | lowercase}}\">\n        </div>\n        <div class=\"form-group pull-left\" style=\"padding-left:15px;padding-top:15px\">\n          <p class=\"help-block\">\n            <i class=\"fa fa-info-circle\" style=\"width:15px;\"></i>\n            All times {{vm.currentTimezone}}\n            <br>\n            <span ng-if=\"vm.service.isSimulatedLive && vm.service.simulatedLiveEndTime\">\n              <i class=\"fa fa-clock-o\" style=\"width:15px\"></i>\n              Broadcast Duration: {{ vm.service.startTime | dateDuration : vm.service.simulatedLiveEndTime : false :\n              vm.service.maxBroadcastDurationHours+':00' }} hours\n            </span>\n            <span ng-if=\"!vm.service.isSimulatedLive\">\n              <i class=\"fa fa-clock-o\" style=\"width:15px\"></i>\n              Broadcast Duration: {{ vm.service.startTime | dateDuration : vm.service.endTime : false :\n              vm.service.maxBroadcastDurationHours+':00' }} hours</span>\n            </span>\n          </p>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <p class=\"text-warning\"\n            ng-show=\"!vm.service.isSimulatedLive && vm.service.endTime.toTimeString() < vm.service.startTime.toTimeString()\">\n            <i class=\"fa fa-warning\"></i>\n            The end time is <em>before</em> the start time, so the broadcast will continue until the following day\n          </p>\n          <p class=\"text-danger\"\n            ng-show=\"!vm.service.isSimulatedLive && vm.service.endTime.toTimeString() == vm.service.startTime.toTimeString()\">\n            <i class=\"fa fa-warning\"></i>\n            A broadcast must have a non-zero duration\n          </p>\n          <p class=\"text-warning\" ng-show=\"vm.service.recordingStorageExpires\">\n            <i class=\"fa fa-warning\"></i>\n            The source recording for this simulated live broadcast will be purged before the broadcast's start time.\n          </p>\n          <p class=\"text-danger\" ng-show=\"vm.service.isInThePast\">\n            <i class=\"fa fa-warning\"></i>\n            A broadcast may not be scheduled in the past\n          </p>\n        </div>\n      </div>\n      <recurrence-pattern></recurrence-pattern>\n    </div>\n\n    <div class=\"well\" ng-show=\"vm.step == 3\">\n      <h3>Overlays</h3>\n      <div class=\"row\" ng-if=\"(!vm.scheduleAgain || (vm.scheduleAgain && vm.service.broadcast.name))\">\n        <broadcast-overlay-configuration vm=\"vm\"></broadcast-overlay-configuration>\n      </div>\n    </div>\n\n    <div class=\"well\" ng-show=\"vm.step == 4\">\n      <h3>Publish</h3>\n\n      <div class=\"form-group\" ng-hide=\"vm.service.simulcastOnly\">\n        <label>Broadcast Type <i class=\"fa fa-asterisk text-danger\"\n            style=\"font-size:10px;vertical-align:top\"></i></label>\n        <div>\n          <div class=\"btn-group\">\n            <label class=\"btn btn-default\" ng-model=\"vm.service.visibility\" uib-btn-radio=\"'private'\"> Private</label>\n            <label class=\"btn btn-default\" ng-if=\"vm.service.showPublic\" ng-model=\"vm.service.visibility\"\n              uib-btn-radio=\"'public'\"> Public</label>\n            <label class=\"btn btn-default\" ng-if=\"vm.service.showFlex\" ng-model=\"vm.service.visibility\"\n              uib-btn-radio=\"'flex'\"> Flex (Ticketed HD)</label>\n            <label class=\"btn btn-default\" ng-if=\"vm.service.showTicketed\" ng-model=\"vm.service.visibility\"\n              uib-btn-radio=\"'ticketed'\"> Ticketed</label>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\" ng-if=\"vm.service.visibility == 'ticketed' || vm.service.visibility == 'flex'\">\n        <label for=\"ticket_price\">Ticket Price <i class=\"fa fa-asterisk text-danger\"\n            style=\"font-size:10px;vertical-align:top\"></i></label>\n        <div class=\"input-group\">\n          <div class=\"input-group-addon\">$</div>\n          <input type=\"number\" step=\"0.01\" class=\"form-control\" style=\"max-width: 100px\" id=\"ticket_price\"\n            ng-model=\"vm.service.broadcast.ticket_price\">\n          <div class=\"pull-left\" ng-if=\"vm.service.visibility == 'flex'\">\n            <div style=\"font-size:10pt;color:#999;margin:7px 0 0 10px\">\n              <i class=\"fa fa-info-circle\"></i>\n              Viewers will receive a low-quality stream for free\n            </div>\n          </div>\n        </div>\n        <p class=\"help-block\"><i class=\"fa fa-info-circle\"></i> The minimum ticket price is ${{vm.service.minTicketPrice\n          | number:2}}</p>\n      </div>\n\n      <div class=\"form-group\" ng-show=\"vm.service.showChannelSelector\">\n        <label>Channels</label>\n        <!--TODO: Auto insert \"My Private Channel\" or \"{account name}'s public channel\" -->\n        <div>\n          <select selectize config=\"{\n                    valueField: 'id',\n                    labelField: 'name',\n                    placeholder: 'Select Channels...',\n                    highlight: true,\n                    searchField: 'name',\n                    selectOnTab: true,\n                    plugins: ['remove_button']\n                  }\" options=\"vm.service.channels\" ng-model=\"vm.service.broadcast.in_channel_ids\"></select>\n        </div>\n        <p class=\"text-warning\" ng-if=\"vm.service.visibility == 'private'\">\n          <i class=\"fa fa-warning\"></i> Channels are not applicable to private broadcasts.\n        </p>\n        <p class=\"help-block\">\n          Optional: Channels are used to organize your broadcasts. These can be edited later as well.\n        </p>\n      </div>\n\n      <div class=\"form-group\" ng-show=\"vm.service.showFeatured\">\n        <label>Tags</label>\n        <div>\n          <select selectize config=\"{\n            valueField: 'name',\n            labelField: 'name',\n            placeholder: 'Select Tags...',\n            highlight: true,\n            searchField: 'name',\n            selectOnTab: true,\n            plugins: ['remove_button'],\n            create: true\n          }\" options=\"vm.service.tags\" ng-model=\"vm.service.broadcast.tags\"></select>\n        </div>\n      </div>\n\n      <div\n        ng-if=\"(vm.service.allowFacebookLive || vm.service.allowYoutubeLive || vm.service.allowGenericRtmpPush || vm.service.allowTwitter)\"\n        class=\"clearfix form-horizontal\">\n        <simulcast-configuration-editor vm=\"vm\" vertical-form=\"true\"></simulcast-configuration-editor>\n      </div>\n\n    </div>\n\n    <div class=\"well\" ng-show=\"vm.step == 5\">\n      <h3>Confirm Broadcast Settings</h3>\n      <div class=\"bg-warning text-warning\" style=\"padding:5px 10px;margin-bottom:15px;border:1px solid;\">\n        This broadcast is not yet scheduled. Please review your selections, then click Schedule This Broadcast to\n        proceed.\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-xs-12 col-sm-6\">\n          <p>Name:<br><strong>{{vm.service.broadcast.name}}</strong></p>\n          <p>Description:<br>\n            <em ng-if=\"!vm.service.broadcast.description\">No Description Entered</em>\n            <strong ng-if=\"vm.service.broadcast.description\">{{vm.service.broadcast.description}}</strong>\n          </p>\n          <p>BoxCaster:<br><strong>{{vm.service.boxcasters |\n              getById:vm.service.broadcast.boxcaster_id:'id':'name'}}</strong></p>\n          <div ng-if=\"vm.service.showAnyScoreboards\">\n            <scoreboard-config-summary service=\"vm.service\"\n              scoreboard-configuration=\"vm.service.broadcast.scoreboard_configuration\" label-suffix=\":\"\n              bold-labels=\"true\" bold-values=\"false\"></scoreboard-config-summary>\n          </div>\n        </div>\n        <div class=\"col-xs-12 col-sm-6\">\n          <p>Date/Time:<br>\n            <strong>{{vm.service.startDate | date}}</strong><br>\n            <strong>{{vm.service.startTime | date:'shortTime'}} - {{vm.service.endTime | date:'shortTime'}}</strong>\n            ({{ vm.service.startTime | dateDuration : vm.service.endTime : false :\n            vm.service.maxBroadcastDurationHours+':00' }} hours)\n          </p>\n          <p ng-show=\"vm.recurring.enabled\">Recurring:<br>\n            <strong>Every {{vm.recurring.pattern}} ending\n              <span ng-show=\"vm.recurring.end=='after'\">after {{vm.recurring.endCount}} instances</span>\n              <span ng-show=\"vm.recurring.end=='on'\">on {{vm.recurring.endDate|date}}</span>\n            </strong>\n          </p>\n          <p>Channels:<br>\n            <em ng-if=\"vm.service.broadcast.in_channel_ids.length == 0\">No Channels Selected</em>\n          <ul ng-if=\"vm.service.broadcast.in_channel_ids.length > 0\">\n            <li ng-repeat=\"channel_id in vm.service.broadcast.in_channel_ids\">\n              <strong>{{vm.service.channels | getById:channel_id:'id':'name'}}</strong>\n            </li>\n          </ul>\n          </p>\n          <p ng-if=\"vm.service.showFeatured\">Featured:<br>\n            <em ng-if=\"!vm.service.broadcast.tags.includes('featured')\">No</em>\n            <strong ng-if=\"vm.service.broadcast.tags.includes('featured')\">Yes</strong>\n          </p>\n          <p ng-if=\"(vm.service.allowFacebookLive || vm.service.allowYoutubeLive || vm.service.allowGenericRtmpPush)\">\n            Social Media Broadcasts:<br>\n            <em ng-show=\"vm.service.broadcast.simulcast_configurations.length == 0\">\n              Disabled\n            </em>\n            <strong ng-show=\"vm.service.broadcast.simulcast_configurations.length == 1\">\n              1 Broadcast\n            </strong>\n            <strong ng-show=\"vm.service.broadcast.simulcast_configurations.length > 1\">\n              {{ vm.service.broadcast.simulcast_configurations.length }} Broadcasts\n            </strong>\n          </p>\n          <p>Broadcast Type:<br>\n            <span ng-if=\"vm.service.visibility == 'private'\">\n              <strong>Private/Test</strong>\n            </span>\n            <span ng-if=\"vm.service.visibility == 'public'\">\n              <strong>Public</strong>\n            </span>\n            <span ng-if=\"vm.service.visibility == 'ticketed'\">\n              <strong>Ticketed: ${{vm.service.broadcast.ticket_price|number:2}}</strong>\n            </span>\n            <span ng-if=\"vm.service.visibility == 'flex'\">\n              <strong>Flex: ${{vm.service.broadcast.ticket_price|number:2}}, free low quality stream</strong>\n            </span>\n          </p>\n        </div>\n      </div>\n\n      <p style=\"font-weight:bold;\">\n        <a ng-click=\"vm.showAdvanced = !vm.showAdvanced\" href>\n          <i class=\"fa\" ng-class=\"vm.showAdvanced ? 'fa-caret-down' : 'fa-caret-right'\"></i>\n          {{vm.showAdvanced ? 'Hide' : 'Show'}} Advanced Settings\n        </a>\n      </p>\n      <div class=\"well\" uib-collapse=\"vm.showAdvanced !== true\">\n        <div class=\"form-group\" ng-hide=\"vm.service.hideOptionRecord\">\n          <label ng-click=\"vm.service.broadcast.do_not_record = !vm.service.broadcast.do_not_record\"\n            style=\"cursor:pointer\">\n            <i class=\"fa\" ng-class=\"vm.service.broadcast.do_not_record ? 'fa-check-square-o' : 'fa-square-o'\"\n              style=\"width:20px\"></i>\n            Enable Live-Only\n            <i class=\"fa fa-question-circle\" tooltip-append-to-body=\"true\"\n              uib-tooltip=\"Enabling this option means viewers can only watch the broadcast while it is live. Disabling this option will record the broadcast and offer on-demand playback when the broadcast is over.\"\n              tooltip-placement=\"bottom\" style=\"opacity:0.5\"></i>\n          </label>\n        </div>\n        <div class=\"form-group\"\n          ng-hide=\"!vm.service.FeatureFlags.automated_captioning || vm.service.FeatureFlags.live_automated_captioning || vm.service.broadcast.do_not_record || vm.service.isSimulatedLive\">\n          <label ng-click=\"vm.service.broadcast.requests_captioning = !vm.service.broadcast.requests_captioning\"\n            style=\"cursor:pointer\">\n            <i class=\"fa\" ng-class=\"vm.service.broadcast.requests_captioning ? 'fa-check-square-o' : 'fa-square-o'\"\n              style=\"width:20px\"></i>\n            Request Automated Captioning When Recorded\n          </label>\n        </div>\n        <div class=\"form-group\"\n          ng-hide=\"!vm.service.FeatureFlags.live_automated_captioning || vm.service.isSimulatedLive\">\n          <label ng-click=\"vm.service.broadcast.requests_captioning = !vm.service.broadcast.requests_captioning\"\n            style=\"cursor:pointer\">\n            <i class=\"fa\" ng-class=\"vm.service.broadcast.requests_captioning ? 'fa-check-square-o' : 'fa-square-o'\"\n              style=\"width:20px\"></i>\n            Automated Live Captioning\n          </label>\n        </div>\n        <div ng-if=\"::vm.service.FeatureFlags.password\" class=\"form-group\">\n          <label\n            ng-click=\"vm.service.broadcast.content_settings.cryptblock = vm.service.broadcast.content_settings.cryptblock ? null : {}\"\n            style=\"cursor:pointer\">\n            <i class=\"fa\"\n              ng-class=\"vm.service.broadcast.content_settings.cryptblock ? 'fa-check-square-o' : 'fa-square-o'\"\n              style=\"width:20px\"></i>\n            Enable Password Protection\n          </label>\n          <div ng-if=\"vm.service.broadcast.content_settings.cryptblock\" style=\"margin-top:5px\">\n            <div>\n              <span ng-show=\"vm.service.broadcast.content_settings.cryptblock.crypt\">Change Password</span>\n              <span ng-hide=\"vm.service.broadcast.content_settings.cryptblock.crypt\">Enter Password</span>\n            </div>\n            <input type=\"password\" autocomplete=\"hi-browser-plz-dont-autofill-this\" class=\"form-control\"\n              ng-model=\"vm.service.broadcast.content_settings.cryptblock.__password__\">\n          </div>\n        </div>\n        <div ng-if=\"::vm.service.FeatureFlags.enterprise_last_mile_delivery\" class=\"form-group\">\n          <label\n            ng-click=\"vm.service.broadcast.content_settings.enterprise_last_mile_delivery = !vm.service.enterpriseLastMileDelivery\"\n            style=\"cursor:pointer\">\n            <i class=\"fa\" ng-class=\"vm.service.enterpriseLastMileDelivery ? 'fa-check-square-o' : 'fa-square-o'\"\n              style=\"width:20px\"></i>\n            Enable Enterprise Last-Mile Delivery\n          </label>\n        </div>\n        <div ng-if=\"::vm.service.FeatureFlags.host_restrictions\" class=\"form-group\">\n          <host-restrictions-settings content-settings=\"vm.service.broadcast.content_settings\">\n          </host-restrictions-settings>\n        </div>\n        <div ng-if=\"::vm.service.FeatureFlags.podcast\">\n          <p style=\"font-weight:bold;\">\n            <a ng-click=\"vm.showPodcast = !vm.showPodcast\" href>\n              <i class=\"fa\" ng-class=\"vm.showPodcast ? 'fa-caret-down' : 'fa-caret-right'\"></i>\n              {{vm.showPodcast ? 'Hide' : 'Show'}} Podcast-Specific Settings\n            </a>\n          </p>\n          <div ng-show=\"vm.showPodcast\">\n            <podcast-settings broadcast=\"vm.service.broadcast\"\n              on-upload-preview-image=\"vm.service.uploadPodcastPreviewImage\"></podcast-settings>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-show=\"vm.service.showOptionTargetBufferLatency\">\n          <label for=\"target_buffer_latency\">\n            BoxCast Flow Control\n            <i class=\"fa fa-question-circle\" style=\"opacity:0.5\"\n              uib-tooltip-html=\"vm.service.targetBufferLatencyTooltip\" tooltip-append-to-body=\"true\"></i>\n          </label>\n          <select class=\"form-control\" id=\"target_buffer_latency\"\n            ng-model=\"vm.service.broadcast.target_buffer_latency\"\n            ng-options=\"e.value as e.label for e in vm.service.bufferLatencies\">\n          </select>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.hideOptionTargetVideoBitRate\">\n          <label for=\"target_video_bitrate\">Target Video Bitrate</label>\n          <select class=\"form-control\" id=\"target_video_bitrate\" ng-model=\"vm.service.broadcast.target_video_bitrate\"\n            ng-options=\"e.value as e.label for e in vm.service.videoBitrates\">\n          </select>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.hideOptionTargetAudioBitRate\">\n          <label for=\"target_audio_bitrate\">Target Audio Bitrate</label>\n          <select class=\"form-control\" id=\"target_audio_bitrate\" ng-model=\"vm.service.broadcast.target_audio_bitrate\"\n            ng-options=\"e.value as e.label for e in vm.service.audioBitrates\">\n          </select>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.hideOptionAudioSource\">\n          <label for=\"audio_source\">Audio Source</label>\n          <select class=\"form-control\" id=\"audio_source\" ng-model=\"vm.service.broadcast.audio_source\"\n            ng-options=\"e.value as e.label for e in vm.service.audioSources\">\n          </select>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.isRTMPBasedSource || vm.service.hideOptionVideoResolution\">\n          <label for=\"video_resolution\">Video Resolution</label>\n          <select class=\"form-control\" id=\"video_resolution\" ng-model=\"vm.service.broadcast.target_video_resolution\"\n            ng-disabled=\"vm.service.isAudioOnly\" ng-options=\"e.value as e.label for e in vm.service.videoResolutions\">\n          </select>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.isRTMPBasedSource || vm.service.hideHighFrameRate\">\n          <label for=\"target_high_frame_rate\">High Frame Rate</label>\n          <select class=\"form-control\" id=\"target_high_frame_rate\"\n            ng-model=\"vm.service.broadcast.target_high_frame_rate\" ng-disabled=\"vm.service.isAudioOnly\"\n            ng-options=\"e.value as e.label for e in vm.service.highFrameRates\">\n          </select>\n        </div>\n        <div class=\"form-group\" ng-hide=\"vm.service.hideOptionDSCPValue\">\n          <label for=\"dscp\">DSCP Value</label>\n          <select class=\"form-control\" id=\"dscp\" ng-model=\"vm.service.broadcast.dscp_value\"\n            ng-options=\"e.value as e.label for e in ::vm.service.dscpValues\">\n          </select>\n        </div>\n      </div>\n      <!--/advanced setings well-->\n\n      <button type=\"button\" ng-show=\"vm.step == 5\" class=\"btn btn-success btn-block\" ng-click=\"vm.submit()\"\n        ng-disabled=\"vm.submitting\">\n        <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n        Schedule Broadcast\n      </button>\n\n      <p class=\"help-block\" ng-show=\"vm.recurring.enabled\">\n        <i class=\"fa fa-info-circle\"></i>\n        Please note, the recurrence pattern defined will generate a separate broadcast for each instance. You can then\n        manually edit or delete any instance as needed.\n      </p>\n\n      <!-- Clone from here is superceded by recurrence options (I think). Clone is still a thing from an existing event though...\n        <div class=\"form-group\" style=\"margin-top:15px\">\n          <span ng-click=\"vm.scheduleAgain = !vm.scheduleAgain\" style=\"cursor:pointer;opacity:0.8\">\n            <i class=\"fa\" ng-class=\"vm.scheduleAgain ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n            Recurring broadcast? Clone this and schedule another broadcast.\n          </span>\n        </div>\n        -->\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-xs-6 col-sm-3 col-sm-offset-3 text-left\">\n      <button type=\"button\" ng-show=\"vm.step > 1\" class=\"btn btn-block btn-default\" ng-click=\"vm.prevTab()\">\n        <i class=\"fa fa-chevron-left\"></i> Prev\n      </button>\n    </div>\n    <div class=\"col-xs-6 col-sm-3 text-right\">\n      <button type=\"button\" ng-show=\"vm.step < 5\" class=\"btn btn-block btn-primary\" ng-click=\"vm.nextTab()\">\n        Next <i class=\"fa fa-chevron-right\"></i>\n      </button>\n    </div>\n  </div>\n\n  <div class=\"row\" style=\"margin-top: 15px;\">\n    <div class=\"text-center\">\n      <span style=\"line-height:34px\">\n        <a href=\"javascript://\" ng-click=\"vm.toggleEntryMode()\" class=\"subtle-link\"><small><i class=\"fa fa-flash\"></i>\n            Quick Entry</small></a>\n        &nbsp;<span style=\"opacity:0.5\">|</span>&nbsp;\n        <small><strong><i class=\"fa fa-magic\"></i> Wizard</strong></small>\n        <span ng-if=\"::vm.service.user.can('read', 'broadcast-import-template')\">\n          &nbsp;<span style=\"opacity:0.5\">|</span>&nbsp;\n          <a ui-sref=\"bulk-import\" class=\"subtle-link\"><small><i class=\"fa fa-list-alt\"></i> Bulk</small></a>\n        </span>\n      </span>\n    </div>\n  </div>"

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.
var module = angular.module('app.pages.reports', []);
module.config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('reports', {
    url: '/reports',
    template: __webpack_require__(487),
    "abstract": true
  }).state('reports.viewer', {
    url: '/viewer?report&id&preset&since&until',
    template: __webpack_require__(488),
    controller: __webpack_require__(489)["default"],
    controllerAs: 'vm'
  }).state('reports.donations', {
    url: '/donations',
    template: __webpack_require__(490),
    controller: __webpack_require__(491)["default"],
    controllerAs: 'vm'
  }).state('reports.tickets', {
    url: '/tickets?report&id',
    template: __webpack_require__(492),
    controller: __webpack_require__(493)["default"],
    controllerAs: 'vm'
  });
});

__webpack_require__(494);

/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = "<main class=\"analytics container-fluid\">\n\n  <div class=\"col-xs-12\">\n    <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n      <li ui-sref-active=\"active\" ng-if=\"::($root.account.feature_flags.analytics && $root.user.can('read', 'viewer-analytics/*'))\">\n        <a ui-sref=\"reports.viewer\">Viewer Analytics</a>\n      </li>\n      <li ui-sref-active=\"active\" ng-if=\"::(!$root.account.feature_flags.no_ticketed && $root.user.can('read', 'broadcast/*:tickets:summary') && $root.user.can('read', 'channel/*:tickets:summary') && $root.user.can('read', 'tickets:summary'))\">\n        <a ui-sref=\"reports.tickets\">Ticket Reports</a>\n      </li>\n      <li ui-sref-active=\"active\" ng-if=\"::($root.account.feature_flags.donations && $root.user.can('read', 'donations:summary'))\">\n        <a ui-sref=\"reports.donations\">Donations Report</a>\n      </li>\n    </ol>\n  </div>\n  <div class=\"clearfix\"></div>\n\n  <div ui-view></div>\n\n</main>\n\n"

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = "<style>\n.graph-element-container .graph-tooltip {\n  visibility: hidden\n}\n.graph-element-container:hover .graph-tooltip {\n    visibility: visible;\n}\n.graph-tooltip text {\n    fill: #FFFFFF;\n    font-size: 12px;\n    font-family: sans-serif;\n    font-weight: bold;\n}\n.graph-tooltip rect {\n    fill: #111111;\n    stroke: #000000;\n}\n</style>\n\n<main class=\"container-fluid\" ng-if=\"::vm.canDoAnalytics\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-sm-4\" style=\"margin-bottom:15px\">\n      <div class=\"btn-group btn-block\" uib-dropdown is-open=\"dropdown_channel.isopen\">\n        <button type=\"button\" class=\"btn btn-primary btn-block\" uib-dropdown-toggle style=\"text-align:left\">\n          <div style=\"display:flex; align-items:center\">\n            <div style=\"flex: 1; margin-right: 10px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\">\n              <div><small>Select Channel</small></div>\n              <div class=\"font-bold\" style=\"overflow: hidden; text-overflow: ellipsis;\">\n                {{vm.selectedChannelName}}\n              </div>\n            </div>\n            <i class=\"fa fa-caret-down\"></i>\n          </div>\n        </button>\n        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" style=\"width:100%\">\n          <li role=\"menuitem\">\n            <a ui-sref=\"reports.viewer({report:null, id:null, preset:vm.datePreset, since:vm.since, until:vm.until})\">Entire Account</a>\n          </li>\n          <li class=\"divider\"></li>\n          <li role=\"menuitem\" ng-repeat=\"c in vm.channels track by c.id\">\n            <a\n               style=\"overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\"\n               ui-sref=\"reports.viewer({report:'channels', id:c.id, preset:vm.datePreset, since:vm.since, until:vm.until})\"\n            >{{c.name}}</a>\n          </li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-sm-4\" style=\"margin-bottom:15px\">\n      <div class=\"btn-group btn-block\" uib-dropdown is-open=\"vm.dateDropdownOpened\">\n        <button type=\"button\" class=\"btn btn-primary btn-block\" uib-dropdown-toggle style=\"text-align: left;\">\n          <div style=\"display:flex; align-items:center\">\n            <div style=\"flex: 1; margin-right: 10px;\">\n              <div><small>Select Date Range</small></div>\n              <div class=\"font-bold\">\n                {{vm.since|date}} - {{vm.until|date}}\n              </div>\n            </div>\n            <i class=\"fa fa-calendar\"></i>\n          </div>\n        </button>\n        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" style=\"width:100%\">\n          <li role=\"menuitem\"><a href ng-click=\"vm.selectDatePreset('past_week')\">Past Week </a></li>\n          <li role=\"menuitem\"><a href ng-click=\"vm.selectDatePreset('past_month')\">Past Month </a></li>\n          <li role=\"menuitem\"><a href ng-click=\"vm.selectDatePreset('past_year')\">Past Year</a></li>\n          <li role=\"menuitem\"><a href ng-click=\"vm.selectDatePreset('this_cal_month')\">This Calendar Month</a></li>\n          <li role=\"menuitem\"><a href ng-click=\"vm.selectDatePreset('last_cal_month')\">Last Calendar Month</a></li>\n          <li class=\"divider\"></i>\n          <li role=\"menuitem\" ng-click=\"$event.stopPropagation()\">\n            <div class=\"col-xs-12\">Custom Date Range</div>\n            <div class=\"col-xs-12\">\n              <ol class=\"list-inline\">\n                <li>\n                  <div class=\"input-group\" style=\"max-width:150px\">\n                    <input type=\"text\" class=\"form-control\"\n                            ng-model=\"vm.customSince\"\n                            uib-datepicker-popup=\"MM/dd/yyyy\"\n                            is-open=\"vm.customSinceDatePopupOpened\"\n                            ng-required=\"true\"\n                            datepicker-options=\"{showWeeks: false}\">\n                    <span class=\"input-group-btn\">\n                      <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.customSinceDatePopupOpened = !vm.customSinceDatePopupOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                  </div>\n                </li>\n                <li>\n                  <div class=\"input-group\" style=\"max-width:150px\">\n                    <input type=\"text\" class=\"form-control\"\n                            ng-model=\"vm.customUntil\"\n                            uib-datepicker-popup=\"MM/dd/yyyy\"\n                            is-open=\"vm.customUntilDatePopupOpened\"\n                            ng-required=\"true\"\n                            datepicker-options=\"{minDate: vm.customSince, showWeeks: false}\">\n                    <span class=\"input-group-btn\">\n                      <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.customUntilDatePopupOpened = !vm.customUntilDatePopupOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                  </div>\n                </li>\n                <li>\n                  <div class=\"input-group\">\n                    <button type=\"button\"\n                            class=\"btn btn-primary btn-sm\"\n                            ng-click=\"vm.selectDatePreset('custom', {since: vm.customSince, until: vm.customUntil})\"\n                            >Apply</button>\n                  </div>\n                </li>\n              </ol>\n            </div>\n          </li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-sm-4\" style=\"margin-bottom:15px\">\n      <div class=\"text-center text-sm\">\n        Note: some aggregated statistics (live&nbsp;vs&nbsp;recorded, quality, avg&nbsp;duration)\n        are delayed by up to 24 hours.\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"hidden-xs col-sm-12\" style=\"margin-bottom:5px;\">\n      <p class=\"text-sm\">\n        <span style=\"display: inline-block; background-color: var(--color-bx-lagoon); color: white; padding: .3rem .7rem; border-radius: .4rem; margin-right: 1rem; font-size: 1rem; font-weight: 500; vertical-align: middle;\">BETA</span>\n        <a ng-if=\"vm.canExport()\" \n          href=\"javascript://\" \n          ng-click=\"vm.downloadAnalytics()\" \n          style=\"display: inline-block; margin-right: 1rem; {{vm.isExporting ? 'cursor: not-allowed; opacity: 0.7;' : ''}}\"\n        ><i class=\"fa fa-file-csv\"></i> Export data to CSV <i ng-if=\"vm.isExporting\" class=\"fa fa-spin fa-spinner\"></i></a>\n        <span class=\"text-xs text-bx-accessible-grey\">\n          <i class=\"fa fa-info-circle\"></i> Exports are available for up to 50,000 views. Note: data may be delayed by up to 24 hours.\n        </span>\n      </p>\n    </div>\n  </div>\n\n  <!-- Empty State -->\n  <div class=\"row\" ng-if=\"!vm.hasViews()\">\n    <div style=\"margin:50px 0;\" class=\"text-center\">\n      <i class=\"fa fa-4x fa-line-chart\" style=\"font-size:175px;\"></i>\n      <h2 class=\"text-bx-accessible-grey\">You don't have any viewership data yet for this channel.</h2>\n      <p><a ui-sref=\"resources\">Check out our resources section to learn how to promote your broadcasts!</a></p>\n    </div>\n  </div>\n\n  <!-- Container for All Analytics Graphs/Charts -->\n  <div class=\"row\" ng-if=\"vm.hasViews()\">\n\n    <div class=\"col-sm-12\">\n      <div class=\"well\">\n        <h4>\n          {{vm.selectedChannelName}} Summary\n          <a style=\"float:right; color:#aaa; border-bottom:1px dotted; font-size:12px;\" ui-sref=\"events.detail({id: vm.broadcast.id})\" ng-if=\"vm.broadcast.id\">\n            View Broadcast\n          </a>\n        </h4>\n        <div class=\"row text-center\">\n          <div class=\"col-xs-12 col-sm-6\">\n\n            <!-- multi-broadcast summary -->\n            <div class=\"row text-center\" ng-if=\"vm.report != 'broadcasts'\">\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;\">\n                <p style=\"font-weight:bold;\">Total Views</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.total_view_count|number}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.total_view_count\" compare=\"vm.analyticsCompare.total_view_count\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;\">\n                <p style=\"font-weight:bold;\">Unique Viewers</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.unique_viewer_count|number}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.unique_viewer_count\" compare=\"vm.analyticsCompare.unique_viewer_count\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;margin-top:15px;\">\n                <p style=\"font-weight:bold;\">Avg. View Duration</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.avg_view_duration|secondsFormatted}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.avg_view_duration\" compare=\"vm.analyticsCompare.avg_view_duration\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;margin-top:15px;\">\n                <p style=\"font-weight:bold;\">Watched Broadcasts</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.viewed_broadcast_count|number}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.viewed_broadcast_count\" compare=\"vm.analyticsCompare.viewed_broadcast_count\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n            </div>\n\n            <!-- single broadcast summary -->\n            <div class=\"row text-center\" ng-if=\"vm.report == 'broadcasts'\">\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;\">\n                <p style=\"font-weight:bold;\">All-Time Views</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.broadcast.total_view_count|number}}</h1>\n                <p class=\"text-sm text-muted\">&nbsp;</p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;\">\n                <p style=\"font-weight:bold;\">Views This Period</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.total_view_count|number}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.total_view_count\" compare=\"vm.analyticsCompare.total_view_count\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;margin-top:15px;\">\n                <p style=\"font-weight:bold;\">Unique Viewers</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.unique_viewer_count|number}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.unique_viewer_count\" compare=\"vm.analyticsCompare.unique_viewer_count\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n              <div class=\"col-xs-6\" style=\"border-right:1px solid #eee;margin-top:15px;\">\n                <p style=\"font-weight:bold;\">Avg. View Duration</p>\n                <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.analytics.avg_view_duration|secondsFormatted}}</h1>\n                <p class=\"text-sm text-muted\">\n                  <compare-to-percent base=\"vm.analytics.avg_view_duration\" compare=\"vm.analyticsCompare.avg_view_duration\"></compare-to-percent>\n                  vs prev period\n                </p>\n              </div>\n            </div>\n\n          </div>\n\n          <div class=\"col-xs-12 col-sm-6\">\n            <p class=\"text-center\"><strong>Cumulative Views vs. Prev Period</strong></p>\n\n            <canvas height=\"105\"\n                class=\"chart chart-line\"\n                chart-data=\"vm.viewsVsData\"\n                chart-labels=\"vm.viewsVsLabels\"\n                chart-options=\"vm.viewsVsOptions\"></canvas>\n          </div>\n\n        </div>\n      </div>\n    </div>\n\n\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <h4>When Viewers Watch</h4>\n\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-6\">\n            <p class=\"text-center\"><strong>By Day</strong></p>\n            <div>\n              <canvas height=\"175\"\n                  class=\"chart chart-line\"\n                  chart-data=\"vm.viewsData\"\n                  chart-labels=\"vm.viewsLabels\"\n                  chart-options=\"vm.viewsOptions\"></canvas>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-sm-6\">\n            <p class=\"text-center\"><strong>By Time of Day / Day of Week</strong></p>\n            <table class=\"table\" style=\"font-size:0.8em\">\n              <tr>\n                <td>12am</td>\n                <td colspan=\"7\" rowspan=\"6\">\n                  <svg viewBox=\"0 0 100 50\" xmlns=\"http://www.w3.org/2000/svg\">\n                    <svg id=\"bubble-grid\" viewBox=\"0 0 100 50\">\n                      <g id=\"outer_{{$index}}\" ng-repeat=\"day in vm.bubbleGraphRows track by $index\" ng-cloak>\n                        <g ng-repeat=\"hr in day.hours track by $index\"\n                           id=\"inner_{{$index}}\"\n                           class=\"graph-element-container\"\n                           ng:attr:transform=\"translate({{vm.bubbleGraphX(day, hr, $index, $parent.$index)}}, {{vm.bubbleGraphY(day, hr, $index, $parent.$index)}})\"\n                           ng-cloak\n                           >\n                          <circle x=\"0\" y=\"0\"\n                                  ng:attr:r=\"{{vm.bubbleGraphR(day, hr, $index, $parent.$index)}}\"\n                                  fill=\"#044B94\"\n                                  fill-opacity=\"0.4\"\n                                  />\n                          <!--\n                            XXX: SVG tooltips are a pain. Problems with z-index and clipping\n                            near edges are not easy to solve.  The default <title> implementation\n                            is not robust (nonconfigurable delay/style) but it's at least reliable.\n                          <g class=\"graph-tooltip\" transform=\"translate(0,0),scale(0.3)\" opacity=\"0.75\">\n                              <rect rx=\"4\" width=\"125\" height=\"20\"></rect>\n                              <text x=\"4\" y=\"14\">\n                                {{vm.bubbleGraphTitle(day, hr, $index, $parent.$index)}}\n                              </text>\n                          </g>\n                          -->\n                          <title>{{vm.bubbleGraphTitle(day, hr, $index, $parent.$index)}}</title>\n                        </g>\n                      </g>\n                    </svg>\n                  </svg>\n                </td>\n              </tr>\n              <tr><td>4am</td></tr>\n              <tr><td>8am</td></tr>\n              <tr><td>12pm</td></tr>\n              <tr><td>4pm</td></tr>\n              <tr><td>8pm</td></tr>\n              <tr class=\"text-center\">\n                <td style=\"width:50px\"></td>\n                <td style=\"width:14.28%\">Sun</td>\n                <td style=\"width:14.28%\">Mon</td>\n                <td style=\"width:14.28%\">Tue</td>\n                <td style=\"width:14.28%\">Wed</td>\n                <td style=\"width:14.28%\">Thu</td>\n                <td style=\"width:14.28%\">Fri</td>\n                <td style=\"width:14.28%\">Sat</td>\n              </tr>\n            </table>\n          </div>\n          <div class=\"col-xs-12\" style=\"margin-top:15px;\" ng-if=\"vm.liveData\">\n            <p class=\"text-center\">\n              <strong>\n                {{100*vm.liveData[0]|number:0}}% Watch <span style=\"border-bottom:1px dotted #5DA5DA\">Live</span>\n                <span style=\"opacity:0.5\">&nbsp;/&nbsp;</span>\n                {{100*vm.liveData[1]|number:0}}% Watch <span style=\"border-bottom:1px dotted #4D4D4D\">Recorded</span>\n              </strong>\n            </p>\n            <div style=\"position:relative;height:10px;\">\n              <div style=\"position:absolute;height:10px;top:0;left:0;width:{{100*vm.liveData[0]}}%;border:2px solid #5DA5DA;background:rgba(93,165,218,0.4);border-right:none;\">\n              </div>\n              <div style=\"position:absolute;height:10px;top:0;left:{{100*vm.liveData[0]}}%;width:{{100*vm.liveData[1]}}%;border:2px solid #4D4D4D;background:rgba(77,77,77,0.4);border-left:none;\">\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <h4>How Viewers Watch</h4>\n        <div class=\"row\">\n          <div class=\"col-sm-8\">\n            <div class=\"row\">\n              <div class=\"col-sm-6\">\n                <p class=\"text-center\"><strong>Playback Quality</strong></p>\n                <canvas class=\"chart chart-pie\"\n                        chart-data=\"vm.qualityData\"\n                        chart-labels=\"vm.qualityLabels\"\n                        chart-legend=\"true\"\n                        chart-options=\"vm.qualityPieChartOptions\"\n                        ></canvas>\n              </div>\n              <div class=\"col-sm-6\">\n                <p class=\"text-center\"><strong>Device Type</strong></p>\n                <canvas class=\"chart chart-pie\"\n                        chart-data=\"vm.mobileData\"\n                        chart-labels=\"vm.mobileLabels\"\n                        chart-legend=\"true\"\n                        chart-options=\"vm.pieChartOptions\"\n                        ></canvas>\n              </div>\n            </div>\n            <div class=\"row\" style=\"margin-top:30px\">\n              <div class=\"col-sm-6\">\n                <p class=\"text-center\"><strong>Browser</strong></p>\n                <canvas class=\"chart chart-pie\"\n                        chart-data=\"vm.browserData\"\n                        chart-labels=\"vm.browserLabels\"\n                        chart-legend=\"true\"\n                        chart-options=\"vm.pieChartOptions\"\n                        ></canvas>\n              </div>\n              <div class=\"col-sm-6\">\n                <p class=\"text-center\"><strong>Operating System</strong></p>\n                <canvas class=\"chart chart-pie\"\n                        chart-data=\"vm.osData\"\n                        chart-labels=\"vm.osLabels\"\n                        chart-legend=\"true\"\n                        chart-options=\"vm.pieChartOptions\"\n                        ></canvas>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-sm-4\">\n            <p class=\"text-center\"><strong>Viewership By Destination</strong></p>\n            <table class=\"table table-condensed\">\n              <thead style=\"text-align:center;font-size:0.8em\">\n                <tr>\n                  <td></td><td></td><td class=\"text-right\">Views</td>\n                  <!--td class=\"text-right\">Pct.</td-->\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"h in vm.analytics.hostData\">\n                  <td class=\"text-center\">\n                    <strong>{{$index + 1}}.</strong>\n                  </td>\n                  <td class=\"text-left\">\n                    <img src=\"/img/{{h.icon}}\" style=\"display:inline-block;height:15px;width:15px;margin-right:5px;\">\n                    <strong>{{h.label}}</strong>\n                  </td>\n                  <td class=\"text-right\"><strong>{{h.value|number}}</strong></td>\n                  <!--td class=\"text-right\" style=\"color:#aaa;width:1%;padding-left:10px;\">{{h.percent|number:1}}%</td-->\n                </tr>\n              </tbody>\n            </table>\n            <p ng-if=\"vm.insights.device\">\n              <strong style=\"color:#aaa\">INSIGHT</strong>\n              Most viewers watch on <strong>{{vm.insights.device}}</strong>.\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div class=\"col-xs-12\" ng-if=\"vm.regionData && vm.regionData.length\">\n      <div class=\"well\">\n        <h4>Where Viewers Watch</h4>\n        <div class=\"row\">\n          <div class=\"col-sm-8\">\n            <p class=\"text-center\"><strong>Geolocation</strong></p>\n            <analytics-geo-chart analytics=\"vm.analytics\"></analytics-geo-chart>\n            <p ng-if=\"vm.insights.geo.states > 1\">\n              <strong style=\"color:#aaa\">INSIGHT</strong>1\n              You have viewers in\n              <span ng-if=\"vm.insights.geo.countries > 1\"><strong>{{vm.insights.geo.countries}} countries</strong> and</span>\n              <strong>{{vm.insights.geo.states}} states</strong>.\n            </p>\n          </div>\n          <div class=\"col-sm-4\">\n            <p class=\"text-center\"><strong>Top Regions</strong></p>\n            <table class=\"table table-condensed\">\n              <thead style=\"text-align:center;font-size:0.8em\">\n                <tr>\n                  <td></td><td></td><td class=\"text-right\">Views</td>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"region in vm.regionDataSlice\">\n                  <td class=\"text-center\">\n                    <strong>{{$index + 1}}.</strong>\n                  </td>\n                  <td class=\"text-left\">\n                    <strong>{{region.label}}</strong>\n                  </td>\n                  <td class=\"text-right\">\n                    <strong>{{region.count}}</strong>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n            <p ng-if=\"vm.regionData.length > vm.regionDataSlice.length\" class=\"text-center\">\n              <a href=\"javascript://\" ng-click=\"vm.loadMoreRegionData()\">\n                <strong><small>Show More</small></strong>\n              </a>\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div class=\"col-xs-12\" ng-if=\"vm.report != 'broadcasts'\">\n      <div class=\"well\">\n        <h4>Hall of Fame</h4>\n        <div class=\"row\">\n          <div class=\"col-sm-6\">\n            <p class=\"text-center\"><strong>Most Viewed Broadcasts</strong></p>\n\n            <table style=\"margin-top:15px\" class=\"table table-condensed table-fixed\">\n              <thead class=\"text-sm\" style=\"text-align:center;\">\n                <tr>\n                  <td style=\"width: 40px;\"></td><!-- Col 1 -->\n                  <td></td><!-- Col 2 -->\n                  <td style=\"width: 80px;\">Views this Period</td><!-- Col 3 -->\n                  <td style=\"width: 80px;\">All-time Views</td><!-- Col 4 -->\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"broadcast in vm.analytics.most_popular_broadcasts\">\n                  <td class=\"text-right\">\n                    <strong>{{$index + 1}}.</strong>\n                  </td>\n                  <td>\n                    <a class=\"body-3 text-bx-lagoon underline\" ui-sref=\"events.detail({id: broadcast.broadcast_id})\" style=\"overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: block; line-height: 1.3;\">\n                      <strong>{{broadcast.broadcast_name}}</strong>\n                    </a>\n                    <span class=\"text-muted\" style=\"display: block;\">\n                        <date-range start=\"broadcast.broadcast_starts_at\" end=\"broadcast.broadcast_stops_at\"></date-range>\n                    </span>\n                  </td>\n                  <td class=\"text-center\">\n                    <strong>{{broadcast.view_count | number}}</strong>\n                  </td>\n                  <td class=\"text-center\">\n                    <strong>{{broadcast.total_view_count | number}}</strong>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n\n          </div>\n          <div class=\"col-sm-6\">\n            <p class=\"text-center\"><strong>Achievements Unlocked</strong></p>\n\n            <div class=\"flex-grid achievements\">\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.views_over_1000\" name=\"&gt;1000 Channel Views\" description=\"Great job on getting over 1000 total views!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.views_over_10000\" name=\"&gt;10,000 Channel Views\" description=\"Amazing job on getting over 10,000 total views!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.hotspot\" name=\"Hotspot!\" description=\"Hotspot! Your viewers love to watch at the same time of day and same day of week!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.hifi\" name=\"Hi-Fi Viewers\" description=\"You've got some high-fidelity viewers - they're all watching in HD!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.do_it_live\" name=\"In The Moment\" description=\"More than 95% of viewers are watching live - that's awesome!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.engaged\" name=\"Engaged!\" description=\"Your viewers are engaged, demonstrated by a high average view duration\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.daily_double\" name=\"Daily Double\" description=\"You've more than doubled viewership compared to the previous period. Nice work!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"vm.achievements.world_traveler\" name=\"World Traveler\" description=\"Your broadcasts are being watched internationally in multiple countries!\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"false\" name=\"\" description=\"\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"false\" name=\"\" description=\"\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"false\" name=\"\" description=\"\"></achievements-cell>\n              <achievements-cell class=\"flex-cell-33\" enabled=\"false\" name=\"\" description=\"\"></achievements-cell>\n            </div>\n\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</main>\n"

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_geo__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_download__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_analytics__ = __webpack_require__(196);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }






var ViewerAnalyticsController = /*#__PURE__*/function () {
  function ViewerAnalyticsController(AnalyticsResource, AnalyticsExportResource, Broadcast, Channel, ApiConfig, $state, $rootScope, $q, toaster, $http, $scope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, ViewerAnalyticsController);

    this.AnalyticsResource = AnalyticsResource;
    this.AnalyticsExportResource = AnalyticsExportResource;
    this.Broadcast = Broadcast;
    this.Channel = Channel;
    this.toaster = toaster;
    this.$q = $q;
    this.canDoAnalytics = $rootScope.account.feature_flags.analytics && $rootScope.user.can('read', 'viewer-analytics/*');

    if (!this.canDoAnalytics) {
      return;
    }

    this.report = $state.params.report;
    this.id = $state.params.id;
    this.account = $rootScope.account;
    this.channels = Channel.query({
      l: 1000
    });
    this.regionDictPromise = $http.get('/img/region_codes.json').then(function (response) {
      _this.regionDict = response.data;
    }); // Analytics exports are restricted to <= 50,000 views.

    this.exportViewLimit = 50000; // isExporting designates whether an export request is actively being processed.

    this.isExporting = false;
    var commonPieChartOptions = {
      aspectRatio: 2.5,
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontSize: 12,
          boxWidth: 12,
          padding: 5
        }
      }
    };

    var pieChartLabel = function pieChartLabel(point, context) {
      var views = context.datasets[point.datasetIndex].data[point.index];

      var totalViews = _.sum(context.datasets[point.datasetIndex].data);

      var label = context.labels[point.index];
      var valueString = "".concat(views, " view").concat(views == 1 ? '' : 's');
      var percentString = '';

      if (totalViews > 0) {
        percentString = " (".concat(Math.round(100.0 * views / totalViews), "%)");
      }

      return "".concat(label, ": ").concat(valueString).concat(percentString);
    };

    var qualityPieChartLabel = function qualityPieChartLabel(point, context) {
      var duration = context.datasets[point.datasetIndex].data[point.index];

      var totalDuration = _.sum(context.datasets[point.datasetIndex].data);

      var label = context.labels[point.index];
      var valueString = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["f" /* secondsToFormattedLabel2 */])(duration);
      var percentString = '';

      if (totalDuration > 0) {
        percentString = " (".concat(Math.round(100.0 * duration / totalDuration), "%)");
      }

      return "".concat(label, ": ").concat(valueString).concat(percentString);
    };

    this.pieChartOptions = _.extend({}, commonPieChartOptions, {
      tooltips: {
        callbacks: {
          label: pieChartLabel
        }
      }
    });
    this.qualityPieChartOptions = _.extend({}, commonPieChartOptions, {
      tooltips: {
        callbacks: {
          label: qualityPieChartLabel
        }
      }
    });
    this.loadingPromises = [this.channels.$promise, this.regionDictPromise];
    var preset = $state.params.preset;

    if (!preset) {
      if (this.report == 'broadcasts') {
        preset = 'all_time';
      } else {
        preset = 'past_week';
      }
    }

    this.selectDatePreset(preset, $state.params);
  }

  _createClass(ViewerAnalyticsController, [{
    key: "selectDatePreset",
    value: function selectDatePreset(preset) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var toaster = this.toaster;

      if (this.datePreset == preset && preset != 'custom') {
        return;
      }

      this.datePreset = preset;

      switch (preset) {
        case 'all_time':
          this.since = moment(); //<-- XXX: this needs reset below after we get the broadcast resource

          this.until = moment(); // Ensure equal number of days in comparison period...

          var days = this.until.diff(this.since, 'days');
          this.compareSince = null;
          this.compareUntil = null;
          this.graphGranularity = 'day';
          break;

        case 'custom':
          this.since = moment(args.since);
          this.until = moment(args.until); // Ensure equal number of days in comparison period...

          var days = this.until.diff(this.since, 'days');
          this.compareSince = moment(this.since).clone().subtract(days, 'days');
          this.compareUntil = this.compareSince.clone().add(days, 'days');
          this.graphGranularity = 'day';
          break;

        case 'past_week':
          // subtract 6 days, not the full 7, as it's inclusive of the current day.
          this.since = moment().subtract(6, 'days');
          this.until = moment(); // Ensure equal number of days in comparison period...

          var days = this.until.diff(this.since, 'days');
          this.compareSince = moment(this.since).clone().subtract(6, 'days');
          this.compareUntil = this.compareSince.clone().add(days, 'days');
          this.graphGranularity = 'day';
          break;

        case 'past_month':
          this.since = moment().subtract(1, 'month');
          this.until = moment(); // Ensure equal number of days in comparison period...

          var days = this.until.diff(this.since, 'days');
          this.compareSince = moment(this.since).clone().subtract(1, 'month');
          this.compareUntil = this.compareSince.clone().add(days, 'days');
          this.graphGranularity = 'day';
          break;

        case 'past_year':
          this.since = moment().subtract(1, 'year');
          this.until = moment(); // Ensure equal number of days in comparison period...

          var days = this.until.diff(this.since, 'days');
          this.compareSince = moment(this.since).clone().subtract(1, 'year');
          this.compareUntil = this.compareSince.clone().add(days, 'days');
          this.graphGranularity = 'month';
          break;

        case 'this_cal_month':
          this.since = moment().startOf('month');
          this.until = moment(); // Get entire previous month as comparison, even if it has more days

          this.compareSince = moment(this.since).clone().subtract(1, 'month').startOf('month');
          this.compareUntil = moment(this.since).clone().subtract(1, 'month').endOf('month');
          this.graphGranularity = 'day';
          break;

        case 'last_cal_month':
          this.since = moment().subtract(1, 'month').startOf('month');
          this.until = moment().subtract(1, 'month').endOf('month'); // Get entire previous month as comparison, even if it has more days

          this.compareSince = moment().subtract(2, 'month').startOf('month');
          this.compareUntil = moment().subtract(2, 'month').endOf('month');
          this.graphGranularity = 'day';
          break;

        default:
          toaster.pop('warning', 'Unknown date preset');
      } // Defaults for custom date picker


      this.customSince = this.since.clone().toDate();
      this.customUntil = this.until.clone().toDate(); // Normalize to DateTime objects instead of moment instances

      this.since = this.since.toDate();
      this.until = this.until.toDate();
      this.compareSince = this.compareSince ? this.compareSince.toDate() : null;
      this.compareUntil = this.compareUntil ? this.compareUntil.toDate() : null;
      this.dateDropdownOpened = false;
      this.reload();
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this2 = this;

      var account = this.account,
          report = this.report,
          id = this.id,
          Broadcast = this.Broadcast,
          Channel = this.Channel;

      switch (report) {
        case 'broadcasts':
          this.broadcast = Broadcast.get({
            id: id
          }, function (broadcast) {
            if (_this2.datePreset == 'all_time') {
              _this2.since = moment(_this2.broadcast.starts_at);
              _this2.customSince = _this2.since.clone().toDate();
              _this2.since = _this2.since.toDate();
            }

            _this2.selectedChannelName = broadcast.name;

            _this2.queryAnalytics(broadcast.channel_id);
          });
          break;

        case 'channels':
          Channel.get({
            id: id
          }, function (channel) {
            return _this2.selectedChannelName = channel.name;
          });
          this.queryAnalytics(id);
          break;

        default:
          this.selectedChannelName = 'Entire Account';
          this.queryAnalytics(account.channel_id);
          break;
      }
    }
  }, {
    key: "hasViews",
    value: function hasViews() {
      if (!this.analytics) return false;
      return this.analytics.total_view_count > 0;
    } // Analytics exports are restricted based on the # of views in the current report.

  }, {
    key: "canExport",
    value: function canExport() {
      return this.hasViews() && this.analytics.total_view_count <= this.exportViewLimit;
    }
  }, {
    key: "queryAnalytics",
    value: function queryAnalytics(channel_id) {
      var _this3 = this;

      var $q = this.$q,
          toaster = this.toaster,
          AnalyticsResource = this.AnalyticsResource; // TODO: configurable timezone
      // NOTE: the time portion is ignored by API, only the date is used, but we need the
      // time so that you can pass the timezone in. Time logic is: since <= date < until

      this.analytics = AnalyticsResource.get({
        channel_id: channel_id,
        since: moment(this.since).local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ'),
        until: moment(this.until).clone().add(1, 'day').local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ')
      });

      if (this.datePreset == 'all_time') {
        this.analyticsCompare = {};
      } else {
        this.analyticsCompare = AnalyticsResource.get({
          channel_id: channel_id,
          since: moment(this.compareSince).local().set({
            h: 0,
            m: 0,
            s: 0,
            ms: 0
          }).format('YYYY-MM-DDTHH:mm:ssZ'),
          until: moment(this.compareUntil).clone().add(1, 'day').local().set({
            h: 0,
            m: 0,
            s: 0,
            ms: 0
          }).format('YYYY-MM-DDTHH:mm:ssZ')
        });
      }

      this.loadingPromises = [this.analytics.$promise, this.analyticsCompare.$promise, this.regionDictPromise];
      $q.all([this.analytics.$promise, this.analyticsCompare.$promise, this.regionDictPromise]).then(function () {
        // If no collected view data for selected option; API returns null. We coerce into something
        // that avoids explosion or other special handling by UI.
        var dummy = function dummy() {
          return {
            live_view_count: 0,
            recorded_view_count: 0,
            live_view_seconds: 0,
            recorded_view_seconds: 0,
            unique_viewer_count: 0,
            viewed_broadcast_count: 0,
            daily_view_counts: [],
            weekday_hourly_view_counts: [],
            view_durations_by_quality: {},
            view_counts_by_host: {},
            most_popular_broadcasts: []
          };
        };

        if (_this3.analytics.live_view_count === undefined) {
          _this3.analytics = angular.extend(_this3.analytics, dummy());
        }

        if (_this3.analyticsCompare.live_view_count === undefined) {
          _this3.analyticsCompare = angular.extend(_this3.analyticsCompare, dummy());
        } // glue on computed fields


        _this3.analytics.total_view_count = _this3.analytics.live_view_count + _this3.analytics.recorded_view_count;
        _this3.analytics.total_view_duration = _this3.analytics.live_view_seconds + _this3.analytics.recorded_view_seconds;
        _this3.analytics.avg_view_duration = _this3.analytics.total_view_duration / _this3.analytics.total_view_count;

        if (_this3.analytics.live_buffer_seconds == 0 || _this3.analytics.live_view_seconds == 0) {
          _this3.analytics.live_rebuffer_pct = 0;
        } else {
          _this3.analytics.live_rebuffer_pct = 100 * (_this3.analytics.live_buffer_seconds / (_this3.analytics.live_buffer_seconds + _this3.analytics.live_view_seconds));
        }

        if (_this3.analytics.recorded_buffer_seconds == 0 || _this3.analytics.recorded_view_seconds == 0) {
          _this3.analytics.recorded_rebuffer_pct = 0;
        } else {
          _this3.analytics.recorded_rebuffer_pct = 100 * (_this3.analytics.recorded_buffer_seconds / (_this3.analytics.recorded_buffer_seconds + _this3.analytics.recorded_view_seconds));
        } // shared graph config


        _this3.barOptions = {
          barPercentage: 0.95,
          categoryPercentage: 0.5,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              },
              position: 'bottom',
              ticks: {
                fontSize: 10
              }
            }]
          }
        }; // compute graph data

        _this3.viewsLabels = [];
        _this3.viewsData = [[]];
        _this3.viewsOptions = {
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'MMM Do'
                }
              },
              //categoryPercentage: 0.20, //1 every 5 labels
              gridLines: {
                display: false
              },
              position: 'bottom',
              ticks: {
                fontSize: 11,
                fontFamily: 'Arial, sans-serif',
                //maxRotation: 0,
                autoSkip: true
              }
            }] //yAxes: [{
            //  gridLines: { display: false }
            //}]

          },
          tooltips: {
            callbacks: {
              title: function title(items, data) {
                return _this3.viewsLabels[items[0].index].format('ddd MMM Do');
              }
            }
          }
        };
        (_this3.analytics.daily_view_counts || []).forEach(function (c, i) {
          _this3.viewsLabels.push(moment(_this3.since).clone().add(i, 'day'));

          _this3.viewsData[0].push(c);
        });
        _this3.qualityData = _.values(_this3.analytics.view_durations_by_quality);
        _this3.qualityLabels = _.keys(_this3.analytics.view_durations_by_quality).map(function (l) {
          return l || 'Not reported';
        }); // Compute insights before we mutate the view_counts_by_* dictionaries

        _this3.insights = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["a" /* computeInsights */])(null, _this3.analytics); // Better formatting on hosts

        _this3.analytics.hostData = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["c" /* normalizeHostData */])(_this3.analytics); // NOTE: this has to happen before we mutate the view_counts_by_* dictionaries below

        var mobile = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["e" /* normalizePlatform */])(_this3.analytics.view_counts_by_os, _this3.analytics.view_counts_by_browser);
        _this3.mobileData = _.values(mobile);
        _this3.mobileLabels = _.keys(mobile);
        _this3.analytics.view_counts_by_browser = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["b" /* normalizeBrowsers */])(_this3.analytics.view_counts_by_browser);

        var sortedBrowsers = _(_this3.analytics.view_counts_by_browser).pairs().sortBy(1).reverse().value();

        _this3.browserData = sortedBrowsers.map(function (p) {
          return p[1];
        });
        _this3.browserLabels = sortedBrowsers.map(function (p) {
          return p[0];
        });
        _this3.analytics.view_counts_by_os = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["d" /* normalizeOSs */])(_this3.analytics.view_counts_by_os);

        var sortedOS = _(_this3.analytics.view_counts_by_os).pairs().sortBy(1).reverse().value();

        _this3.osData = sortedOS.map(function (p) {
          return p[1];
        });
        _this3.osLabels = sortedOS.map(function (p) {
          return p[0];
        });
        _this3.regionData = [];

        _.each(_this3.analytics.view_counts_by_region_code, function (count, code) {
          var label = Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["f" /* regionNameFromCode */])(code, _this3.regionDict);

          _this3.regionData.push({
            code: code,
            count: count,
            label: label
          });
        });

        _this3.regionData = _.sortBy(_this3.regionData, 'count');

        _this3.regionData.reverse();

        _this3.regionDataCount = 10;
        _this3.regionDataSlice = _this3.regionData.slice(0, _this3.regionDataCount);

        if (_this3.analytics.live_view_count || _this3.analytics.recorded_view_count) {
          var totalViewCount = _this3.analytics.live_view_count + _this3.analytics.recorded_view_count;
          _this3.liveData = [_this3.analytics.live_view_count / totalViewCount, _this3.analytics.recorded_view_count / totalViewCount];
        } else {
          _this3.liveData = null;
        }

        _this3.bubbleGraphRows = [];
        var maxWeekDayHourVal = 1;

        _.range(7).forEach(function (d, i) {
          var day = {
            dayIndex: d,
            hours: []
          };

          _.range(24).forEach(function (h, i) {
            var viewCount = (_this3.analytics.weekday_hourly_view_counts || [])[d * 24 + h] || 0;
            maxWeekDayHourVal = Math.max(viewCount, maxWeekDayHourVal);
            day.hours.push(viewCount);
          });

          _this3.bubbleGraphRows.push(day);
        });

        _this3.bubbleGraphScaleFactor = 0.05 * (100 / maxWeekDayHourVal); // compute comparison graph data structure

        _this3.viewsVsLabels = [];
        _this3.viewsVsTooltips = [];

        _.range(Math.max((_this3.analytics.daily_view_counts || []).length, _this3.analyticsCompare.daily_view_counts.length)).forEach(function (i) {
          var curr = moment(_this3.since).clone().add(i, 'day');
          var comp = moment(_this3.compareSince).clone().add(i, 'day');

          _this3.viewsVsLabels.push(curr);

          _this3.viewsVsTooltips.push("".concat(curr.format('ddd MMM Do'), " vs ").concat(comp.format('ddd MMM Do')));
        });

        _this3.viewsVsData = [[], //cululative count of current period
        [] //cumulative count of comparison period
        ];
        _this3.viewsVsOptions = {
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'MMM Do'
                }
              },
              //categoryPercentage: 0.20, //1 every 5 labels
              gridLines: {
                display: false
              },
              position: 'bottom',
              ticks: {
                fontSize: 11,
                fontFamily: 'Arial, sans-serif',
                //maxRotation: 0,
                autoSkip: true
              }
            }] //yAxes: [{
            //  gridLines: { display: false }
            //}]

          },
          tooltips: {
            callbacks: {
              title: function title(items, data) {
                return _this3.viewsVsTooltips[items[0].index];
              }
            }
          }
        };
        var sum = 0;
        (_this3.analytics.daily_view_counts || []).forEach(function (c) {
          return _this3.viewsVsData[0].push(sum += c);
        });
        sum = 0;
        (_this3.analyticsCompare.daily_view_counts || []).forEach(function (c) {
          return _this3.viewsVsData[1].push(sum += c);
        }); // compute comparison stats

        _this3.analyticsCompare.total_view_count = _this3.analyticsCompare.live_view_count + _this3.analyticsCompare.recorded_view_count;
        _this3.analyticsCompare.total_view_duration = _this3.analyticsCompare.live_view_seconds + _this3.analyticsCompare.recorded_view_seconds;
        _this3.analyticsCompare.avg_view_duration = _this3.analyticsCompare.total_view_duration / _this3.analyticsCompare.total_view_count;

        _this3.computeAchievements();
      })["catch"](function (err) {
        console.error(err);
        toaster.pop('warning', 'Unable to load analytics. Please refresh the page and try again.');
      });
    } // downloadAnalytics handles click events from the "export analytics" link on the reports/viewer page.

  }, {
    key: "downloadAnalytics",
    value: function downloadAnalytics() {
      var _this4 = this;

      var account = this.account,
          report = this.report,
          id = this.id,
          Broadcast = this.Broadcast,
          Channel = this.Channel; // block download requests if: exports are not allowed (i.e. the date range exceeds the allowed limit);
      // or if an export is already in progress.

      if (!this.canExport() || this.isExporting) return; // designate that we're now actively processing an export request.

      this.isExporting = true;

      switch (report) {
        case 'broadcasts':
          this.broadcast = Broadcast.get({
            id: id
          }, function (broadcast) {
            if (_this4.datePreset == 'all_time') {
              _this4.since = moment(_this4.broadcast.starts_at);
              _this4.customSince = _this4.since.clone().toDate();
              _this4.since = _this4.since.toDate();
            }

            _this4.exportAnalytics(broadcast.channel_id);
          });
          break;

        case 'channels':
          Channel.get({
            id: id
          }, function (channel) {
            return _this4.selectedChannelName = channel.name;
          });
          this.exportAnalytics(id);
          break;

        default:
          this.exportAnalytics(account.channel_id);
          break;
      }
    } // exportAnalytics calls on the viewer_analytics_service to get detailed view analytics for the
    // currently-viewed analytics and prompts a csv file download.

  }, {
    key: "exportAnalytics",
    value: function exportAnalytics(channel_id) {
      var _this5 = this;

      var AnalyticsExportResource = this.AnalyticsExportResource,
          toaster = this.toaster; // TODO: configurable timezone
      // NOTE: the time portion is ignored by API, only the date is used, but we need the
      // time so that you can pass the timezone in. Time logic is: since <= date < until

      var params = {
        channel_id: channel_id,
        since: moment(this.since).local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ'),
        until: moment(this.until).clone().add(1, 'day').local().set({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        }).format('YYYY-MM-DDTHH:mm:ssZ')
      };
      AnalyticsExportResource.render(params, function (response) {
        // got our response, so the export is done processing.
        _this5.isExporting = false;
        var disposition = response.headers['content-disposition'];
        var filename = disposition.match(/filename=(\"?)(.+)\1/)[2];
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_download__["a" /* forceBrowserDownload */])(URL.createObjectURL(response.blob), filename);
      }, function (err) {
        // error, but the export is done processing.
        _this5.isExporting = false;
        console.error(err);
        toaster.pop('warning', 'Unable to export analytics', 'There was an issue exporting your analytics. Please reload and try again.');
      });
    }
  }, {
    key: "loadMoreRegionData",
    value: function loadMoreRegionData() {
      this.regionDataCount += 10;
      this.regionDataSlice = this.regionData.slice(0, this.regionDataCount);
    }
  }, {
    key: "computeAchievements",
    value: function computeAchievements() {
      this.achievements = {
        // was total view count over 1000?
        views_over_1000: this.analytics.total_view_count > 1000,
        // was total view count over 10000?
        views_over_10000: this.analytics.total_view_count > 10000,
        // were 75% of views from a single time-of-day & day-of-week combo?
        hotspot: Math.max(this.analytics.weekday_hourly_view_counts) > 0.75 * (this.analytics.weekday_hourly_view_counts || []).reduce(function (a, b) {
          return a + b;
        }, 0),
        // were more than 75% of views at 720 or 1080 quality?
        hifi: ((this.analytics.view_durations_by_quality || {})['720p'] || 0) + ((this.analytics.view_durations_by_quality || {})['1080p'] || 0) > 0.75 * this.analytics.total_view_count,
        // were live views more than 95% of total?
        do_it_live: this.analytics.live_view_count / this.analytics.total_view_count > 0.95,
        // was avg view duration at least 10 min?
        engaged: this.analytics.avg_view_duration > 10 * 60,
        // did total view count more than double compared to prior?
        daily_double: this.analytics.total_view_count > 2 * this.analyticsCompare.total_view_count,
        // multiple countries
        world_traveler: Object(__WEBPACK_IMPORTED_MODULE_1__utils_geo__["a" /* countCountries */])(this.analytics.view_counts_by_region_code) > 1
      };
    }
  }, {
    key: "bubbleGraphX",
    value: function bubbleGraphX(day, hr, hrIndex, dayIndex) {
      // based on 100x50 grid
      return 100 * ((day.dayIndex + 0.5) / 7);
    }
  }, {
    key: "bubbleGraphY",
    value: function bubbleGraphY(day, hr, hrIndex, dayIndex) {
      // based on 100x50 grid
      return 50 * ((hrIndex + 0.5) / 24);
    }
  }, {
    key: "bubbleGraphR",
    value: function bubbleGraphR(day, hr, hrIndex, dayIndex) {
      // based on 100x100 grid
      return Math.min(5, hr * this.bubbleGraphScaleFactor);
    }
  }, {
    key: "bubbleGraphTitle",
    value: function bubbleGraphTitle(day, hr, hrIndex, dayIndex) {
      var hrLabel;

      if (hrIndex > 12) {
        hrLabel = "".concat(hrIndex - 12, "pm");
      } else if (hrIndex == 12) {
        hrLabel = '12pm';
      } else if (hrIndex == 0) {
        hrLabel = '12am';
      } else {
        hrLabel = "".concat(hrIndex, "am");
      }

      var dayLabel = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'][dayIndex];
      return "".concat(hr, " (").concat(dayLabel, " at ").concat(hrLabel, ")");
    }
  }]);

  return ViewerAnalyticsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (ViewerAnalyticsController);

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\" ng-if=\"::vm.canReadDonations\">\n  <div class=\"col-xs-12\">\n    <div class=\"well\">\n      <p>This report lists recent donations to your account, sorted by date. BoxCast will issue your payments in\n      accordance with your contract terms.</p>\n\n      <div style=\"margin:15px 0\">\n        <span class=\"pull-right\" ng-show=\"vm.start && vm.end\">\n          Showing donations from {{vm.start|date}} - {{vm.end|date}}.\n        </span>\n        <div class=\"btn-group\">\n          <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod(null)\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"null\">All Time</label>\n          <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod('this_q')\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"'this_q'\">This Quarter</label>\n          <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod('last_q')\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"'last_q'\">Last Quarter</label>\n        </div>\n      </div>\n\n      <div ng-if=\"vm.donations.length == 0\" class=\"bg-info text-info\" style=\"padding:15px;margin-bottom:15px;border:1px solid;\">\n        <small>\n          No donations have been recorded for your account.\n          <a ui-sref=\"settings.overview\">You can enable donations on the account settings page</a>.\n        </small>\n      </div>\n\n      <div ng-if=\"vm.donations.length > 0\">\n\n        <!-- summary block -->\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <div class=\"well\">\n              <div class=\"row text-center\">\n                <div class=\"col-xs-6 col-sm-4\" style=\"border-right:1px solid #eee;\">\n                  <p style=\"font-weight:bold;\">Donation Count</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.summary.count | number}}</h1>\n                  <p style=\"font-size:0.8em\">Number of donation transactions.</p>\n                </div>\n                <div class=\"col-xs-6 col-sm-4\" style=\"border-right:1px solid #eee;\">\n                  <p style=\"font-weight:bold;\">Gross Revenue</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.summary.total | currency}}</h1>\n                  <p style=\"font-size:0.8em\">Total value of donations.</p>\n                </div>\n                <div class=\"col-xs-12 col-sm-4\">\n                  <p style=\"font-weight:bold;\">Net Proceeds</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{((vm.summary.total - vm.summary.total_refund)*0.94) | currency}}</h1>\n                  <p style=\"font-size:0.8em\">\n                    Gross\n                    <span ng-if=\"vm.summary.total_refund\">minus {{vm.summary.count_refund}} refunds</span>\n                    minus 6% processing.\n                  </p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <p class=\"help-block\">\n          Showing results\n          {{vm.donationsPagination.resultMin}} -\n          {{vm.donationsPagination.resultMax}}\n          of {{vm.donationsPagination.total}}\n        </p>\n        <table class=\"table table-condensed\">\n          <thead>\n            <tr>\n              <th>Donor Name</th>\n              <th>Email</th>\n              <th>Address</th>\n              <th>Amount</th>\n              <th>Invoice</th>\n              <th>Date</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"d in vm.donations track by d.id\">\n              <td>{{::d.name}}</td>\n              <td>{{::d.email}}</td>\n              <td>\n                <em ng-hide=\"::(d.address || d.city || d.state || d.zip)\" style=\"opacity:0.5\">\n                  Not entered\n                </em>\n                <span ng-show=\"::(d.address || d.city || d.state || d.zip)\">\n                  {{::d.address}}<br>\n                  {{::d.city}}, {{::d.state}} {{::d.zip}}\n                </span>\n              </td>\n              <td class=\"text-right\">\n                <span ng-show=\"::d.is_refunded\">\n                  <strike>${{::d.amount|number:2}}</strike>\n                  <span class=\"label label-default\">Refunded</span>\n                </span>\n                <span ng-hide=\"::d.is_refunded\">\n                  ${{::d.amount|number:2}}\n                </span>\n              </td>\n              <td>{{::d.invoice_handle}}</td>\n              <td>{{::d.created_at|date}}</td>\n            </tr>\n          </tbody>\n        </table>\n        <uib-pagination ng-if=\"vm.donationsPagination.total > 20\"\n                        total-items=\"vm.donationsPagination.total\"\n                        items-per-page=\"20\"\n                        max-size=\"10\"\n                        rotate=\"false\"\n                        class=\"pagination-sm\"\n                        ng-model=\"vm.donationsPagination.current\"\n                        ng-change=\"vm.loadDonationsForPage(vm.donationsPagination.current)\"></uib-pagination>\n      </div>\n    </div>\n  </div>\n</div>\n\n"

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PAGE_SIZE = 20;

var DonationsController = /*#__PURE__*/function () {
  function DonationsController($rootScope, Donation, toaster) {
    'ngInject';

    _classCallCheck(this, DonationsController);

    this.Donation = Donation;
    this.account = $rootScope.account;
    this.toaster = toaster;
    this.canReadDonations = $rootScope.user.can('read', 'donations:summary');

    if (!this.canReadDonations) {
      return;
    }

    this.loadingPromises = [];
    this.setTimePeriod(null); //start at "all time"
  }

  _createClass(DonationsController, [{
    key: "setTimePeriod",
    value: function setTimePeriod(value) {
      // moment.month gives 0-11
      // we'll translate into quarter number 1-4
      var currentQuarterNumber = Math.ceil((moment().month() + 1) / 3);
      var startMonth = (currentQuarterNumber - 1) * 3;
      var endMonth = currentQuarterNumber * 3 - 1;

      if (value == 'this_q') {
        this.timePeriod = value;
        this.start = moment().month(startMonth).startOf('month').toDate();
        this.end = moment().month(endMonth).endOf('month').toDate();
      } else if (value == 'last_q') {
        this.timePeriod = value;
        this.start = moment().month(startMonth).subtract(3, 'months').startOf('month').toDate();
        this.end = moment().month(endMonth).subtract(3, 'months').endOf('month').toDate();
      } else {
        this.timePeriod = null;
        this.start = null;
        this.end = null;
      }

      this.loadDonationsForPage(1);
    }
  }, {
    key: "loadDonationsForPage",
    value: function loadDonationsForPage(p) {
      var _this = this;

      var Donation = this.Donation,
          account = this.account,
          toaster = this.toaster;
      var q = undefined;

      if (this.start && this.end) {
        q = "created_at:[".concat(this.start.toISOString(), " TO ").concat(this.end.toISOString(), "]");
      }

      var donations = Donation.query({
        q: q,
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-created_at'
      }, function (data, headers) {
        _this.donations = data;
        var pagination = JSON.parse(headers('x-pagination'));
        _this.donationsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length
        };
      }, function (err) {
        toaster.pop('warning', 'Unable to load donations. Please refresh the page and try again.');
      });
      this.summary = Donation.summary({
        q: q
      });
      this.loadingPromises.push(donations.$promise);
      this.loadingPromises.push(this.summary.$promise);
    }
  }]);

  return DonationsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (DonationsController);

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = "<div class=\"analytics row\" ng-if=\"::(!vm.FeatureFlags.no_ticketed && vm.canReadTicketSummaries)\">\n  <div class=\"col-xs-12\">\n    <div class=\"well\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...'}\">\n\n      <ol class=\"breadcrumb\" ng-if=\"vm.report\">\n        <li>\n          <a ui-sref=\"reports.tickets({report: null, id: null})\">Ticket Reports</a>\n        </li>\n        <li ng-if=\"vm.report && vm.report != 'account'\" ng-class=\"vm.report && !vm.id ? 'active' : ''\">\n          <a ui-sref=\"reports.tickets({report: vm.report, id: null})\">{{vm.reportName}}</a>\n        </li>\n        <li ng-if=\"vm.report && vm.report != 'account' && vm.id\" ng-class=\"vm.report && vm.id ? 'active' : ''\">\n          <a ui-sref=\"reports.tickets({report: vm.report, id: vm.id})\">{{vm.entity.name}}</a>\n        </li>\n        <li ng-if=\"vm.report == 'account'\" ng-class=\"active\">\n          {{vm.reportName}}\n        </li>\n      </ol>\n\n      <!-- No report type selected yet -->\n      <div ng-if=\"!vm.report\">\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-6\" style=\"margin-bottom:30px\">\n            <p>Select the report you would like to view.</p>\n            <div style=\"max-width: 350px\">\n              <a ui-sref=\"reports.tickets({report: 'account', id: 'broadcast'})\" class=\"btn btn-primary btn-block\" style=\"text-align:left\">\n                <div><small><i class=\"fa fa-ticket\"></i> Ticket Purchase Report</small></div>\n                <span class=\"font-bold\">All Single Broadcast Tickets</span>\n                <i class=\"pull-right fa fa-caret-right\" style=\"position:relative;top:-9px;\"></i>\n              </a>\n            </div>\n            <div style=\"max-width: 350px; margin-top:15px;\">\n              <a ui-sref=\"reports.tickets({report: 'account', id: 'channel'})\" class=\"btn btn-primary btn-block\" style=\"text-align:left\">\n                <div><small><i class=\"fa fa-ticket\"></i> Ticket Purchase Report</small></div>\n                <span class=\"font-bold\">All Channel Tickets</span>\n                <i class=\"pull-right fa fa-caret-right\" style=\"position:relative;top:-9px;\"></i>\n              </a>\n            </div>\n            <div style=\"max-width: 350px; margin-top:15px;\">\n              <a ui-sref=\"reports.tickets({report: 'broadcasts'})\" class=\"btn btn-primary btn-block\" style=\"text-align:left\">\n                <div><small><i class=\"fa fa-ticket\"></i> Ticket Purchase Report</small></div>\n                <span class=\"font-bold\">Single Broadcast Tickets By Broadcast</span>\n                <i class=\"pull-right fa fa-caret-right\" style=\"position:relative;top:-9px;\"></i>\n              </a>\n            </div>\n            <div style=\"max-width: 350px; margin-top:15px;\">\n              <a ui-sref=\"reports.tickets({report: 'channels'})\" class=\"btn btn-primary btn-block\" style=\"text-align:left\">\n                <div><small><i class=\"fa fa-ticket\"></i> Ticket Purchase Report</small></div>\n                <span class=\"font-bold\">Channel Tickets By Channel</span>\n                <i class=\"pull-right fa fa-caret-right\" style=\"position:relative;top:-9px;\"></i>\n              </a>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-sm-6\">\n            <p class=\"text-center\"><strong>Recent Ticket Purchases</strong></p>\n            <canvas height=\"200\"\n                class=\"chart chart-line\"\n                chart-data=\"vm.ticketsGraphData\"\n                chart-labels=\"vm.ticketsGraphLabels\"\n                chart-options=\"vm.ticketsGraphOptions\"\n                chart-series=\"['Single Broadcast Ticket Count', 'Channel Ticket Count']\"></canvas>\n          </div>\n        </div>\n      </div>\n\n      <!-- No specific broadcast/channel selected yet -->\n      <div ng-if=\"vm.report == 'broadcasts' && !vm.id\">\n        <p>Select the broadcast you would like to view.</p>\n\n        <table class=\"table table-condensed table-hover\">\n          <thead>\n            <tr>\n              <th>Name</th>\n              <th>Date/Time</th>\n              <th>Accessibility</th>\n              <th class=\"hidden-xs\">Sold Count</th>\n              <th class=\"hidden-xs\">Sold Total</th>\n              <th></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"broadcast in vm.broadcasts track by broadcast.id\"\n                ng-click=\"$state.go('reports.tickets', {report: vm.report, id: broadcast.id})\">\n              <th>{{broadcast.name}}</th>\n              <td><date-range start=\"broadcast.starts_at\" end=\"broadcast.stops_at\"></date-range></td>\n              <td>\n                <span ng-if=\"broadcast.is_ticketed\" class=\"label label-success\">${{broadcast.ticket_price | number:2}} / ticket</span>\n                <span ng-if=\"broadcast.is_private\" class=\"label label-danger\">Private</span>\n                <span ng-if=\"!broadcast.is_ticketed && !broadcast.is_private\" class=\"label label-default\">Public</span>\n              </td>\n              <td class=\"hidden-xs text-right\">\n                <strong>{{broadcast.sold_ticket_count | number}}</strong>\n              </td>\n              <td class=\"hidden-xs text-right\">\n                <strong>{{broadcast.sold_ticket_total | currency}}</strong>\n              </td>\n              <td class=\"text-right\">\n                <a class=\"small-link\"><i class=\"fa fa-list\"></i> View Report</a>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        <uib-pagination ng-if=\"vm.broadcastsPagination.total > 20\"\n                        total-items=\"vm.broadcastsPagination.total\"\n                        items-per-page=\"20\"\n                        max-size=\"10\"\n                        rotate=\"false\"\n                        class=\"pagination-sm\"\n                        ng-model=\"vm.broadcastsPagination.current\"\n                        ng-change=\"vm.loadBroadcastsForPage(vm.broadcastsPagination.current)\"></uib-pagination>\n      </div>\n      <div ng-if=\"vm.report == 'channels' && !vm.id\">\n        <p>Select the channel you would like to view.</p>\n\n        <table class=\"table table-condensed table-hover\">\n          <thead>\n            <tr>\n              <th>Name</th>\n              <th>Accessibility</th>\n              <th></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"channel in vm.channels track by channel.id\"\n                ng-click=\"$state.go('reports.tickets', {report: vm.report, id: channel.id})\">\n              <th>{{channel.name}}</th>\n              <td>\n                <span ng-if=\"channel.is_ticketed\" class=\"label label-success\">${{channel.ticket_price | number:2}} / ticket</span>\n                <span ng-if=\"!channel.is_ticketed\" class=\"label label-default\">Public</span>\n              </td>\n              <td class=\"text-right\">\n                <a class=\"small-link\"><i class=\"fa fa-list\"></i> View Report</a>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        <uib-pagination ng-if=\"vm.channelsPagination.total > 20\"\n                        total-items=\"vm.channelsPagination.total\"\n                        items-per-page=\"20\"\n                        max-size=\"10\"\n                        rotate=\"false\"\n                        class=\"pagination-sm\"\n                        ng-model=\"vm.channelsPagination.current\"\n                        ng-change=\"vm.loadChannelsForPage(vm.channelsPagination.current)\"></uib-pagination>\n      </div>\n\n      <!-- Show ticket list -->\n      <div ng-if=\"vm.report && vm.id\">\n        <p>This report lists recent ticket purchases, sorted by date. BoxCast will issue your payments in\n        accordance with your contract terms.</p>\n\n        <div style=\"margin:15px 0\">\n          <span class=\"pull-right\" ng-show=\"vm.start && vm.end\">\n            Showing tickets from {{vm.start|date}} - {{vm.end|date}}.\n          </span>\n          <div class=\"btn-group\">\n            <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod(null)\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"null\">All Time</label>\n            <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod('this_q')\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"'this_q'\">This Quarter</label>\n            <label class=\"btn btn-sm btn-default\" ng-click=\"vm.setTimePeriod('last_q')\" ng-model=\"vm.timePeriod\" uib-btn-radio=\"'last_q'\">Last Quarter</label>\n          </div>\n        </div>\n\n        <div class=\"row\" style=\"margin-bottom:15px\">\n          <div class=\"col-sm-12\">\n            <div class=\"well\">\n              <div class=\"row text-center\">\n                <div class=\"col-xs-6 col-sm-4\" style=\"border-right:1px solid #eee;\">\n                  <p style=\"font-weight:bold;\">Total Tickets Sold</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.summary.count | number}}</h1>\n                  <p style=\"font-size:0.8em\">Count of tickets sold for all time.</p>\n                </div>\n                <div class=\"col-xs-6 col-sm-4\" style=\"border-right:1px solid #eee;\">\n                  <p style=\"font-weight:bold;\">Gross Ticket Revenue</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{vm.summary.total | currency}}</h1>\n                  <p style=\"font-size:0.8em\">Total value of tickets sold for all time.</p>\n                </div>\n                <div class=\"col-xs-12 col-sm-4\">\n                  <p style=\"font-weight:bold;\">Gross Minus Refunds</p>\n                  <h1 style=\"margin:0 0 10px;line-height:34px;\">{{(vm.summary.total - vm.summary.total_refund) | currency}}</h1>\n                  <p style=\"font-size:0.8em\">\n                    Gross ticket revenue minus {{vm.summary.count_refund}} refunds.</span>\n                  </p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"vm.tickets.length == 0\" class=\"bg-info text-info\" style=\"padding:15px;margin-bottom:15px;border:1px solid;\">\n          <small>\n            No tickets recorded for {{vm.entity.name}}.\n          </small>\n        </div>\n\n        <div ng-if=\"vm.tickets.length > 0\">\n          <p class=\"help-block\">\n            Showing results\n            {{vm.ticketsPagination.resultMin}} -\n            {{vm.ticketsPagination.resultMax}}\n            of {{vm.ticketsPagination.total}}\n          </p>\n          <table class=\"table table-condensed\">\n            <thead>\n              <tr>\n                <th>Name</th>\n                <th>Email</th>\n                <th ng-if=\"vm.id == 'broadcast'\">Broadcast</th>\n                <th ng-if=\"vm.id == 'channel'\">Channel</th>\n                <th>Price</th>\n                <th>Invoice</th>\n                <th>Date</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"d in vm.tickets track by d.id\">\n                <td>{{d.name}}</td>\n                <td>{{d.email_masked}}</td>\n                <td ng-if=\"vm.id == 'broadcast'\">{{d.broadcast_name}}</td>\n                <td ng-if=\"vm.id == 'channel'\">{{d.channel_name}}</td>\n                <td class=\"text-right\">\n                  <span ng-show=\"d.is_refunded\">\n                    <strike>${{d.price|number:2}}</strike>\n                    <span class=\"label label-default\">Refunded</span>\n                  </span>\n                  <span ng-hide=\"d.is_refunded\">\n                    ${{d.price|number:2}}\n                  </span>\n                </td>\n                <td>{{d.invoice_handle}}</td>\n                <td>{{d.created_at|date}}</td>\n              </tr>\n            </tbody>\n          </table>\n          <uib-pagination ng-if=\"vm.ticketsPagination.total > 20\"\n                          total-items=\"vm.ticketsPagination.total\"\n                          items-per-page=\"20\"\n                          max-size=\"10\"\n                          rotate=\"false\"\n                          class=\"pagination-sm\"\n                          ng-model=\"vm.ticketsPagination.current\"\n                          ng-change=\"vm.loadTicketsForPage(vm.ticketsPagination.current)\"></uib-pagination>\n        </div>\n      </div>\n\n\n    </div>\n  </div>\n</div>\n\n"

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PAGE_SIZE = 20;

var TicketsController = /*#__PURE__*/function () {
  function TicketsController($state, $q, toaster, Ticket, Channel, Broadcast, $rootScope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, TicketsController);

    this.toaster = toaster;
    this.Ticket = Ticket;
    this.Channel = Channel;
    this.Broadcast = Broadcast;
    this.$q = $q;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.canReadTicketSummaries = $rootScope.user.can('read', 'broadcast/*:tickets:summary') && $rootScope.user.can('read', 'channel/*:tickets:summary') && $rootScope.user.can('read', 'tickets:summary');

    if (this.FeatureFlags.no_ticketed || !this.canReadTicketSummaries) {
      return;
    }

    this.report = $state.params.report;
    this.id = $state.params.id;
    this.account = $rootScope.account;
    this.timePeriod = null;
    this.loadingPromises = [];

    switch (this.report) {
      case 'broadcasts':
        this.reportName = 'Single Broadcast';

        if (this.id) {
          Broadcast.get({
            id: this.id
          }, function (obj) {
            return _this.entity = obj;
          });
          this.loadTicketsForPage(1);
        } else {
          this.loadBroadcastsForPage(1);
        }

        break;

      case 'channels':
        this.reportName = 'Channel';

        if (this.id) {
          Channel.get({
            id: this.id
          }, function (obj) {
            return _this.entity = obj;
          });
          this.loadTicketsForPage(1);
        } else {
          this.loadChannelsForPage(1);
        }

        break;

      case 'account':
        this.entity = this.account;

        if (this.id == 'channel') {
          this.reportName = 'All Channel Tickets';
        } else {
          this.reportName = 'All Broadcast Tickets';
        }

        this.loadTicketsForPage(1);
        break;

      default:
        this.loadGraph();
    }
  }

  _createClass(TicketsController, [{
    key: "loadGraph",
    value: function loadGraph() {
      var _this2 = this;

      var Ticket = this.Ticket,
          $q = this.$q;
      var NUM_DAYS = 30;
      var start = moment().subtract(NUM_DAYS, 'day');
      var end = moment();
      var q = "created_at:[".concat(start.toISOString(), " TO ").concat(end.toISOString(), "]");
      var p1 = Ticket.queryAll({
        type: 'broadcast',
        l: 1000,
        s: '-created_at',
        q: q
      });
      var p2 = Ticket.queryAll({
        type: 'channel',
        l: 1000,
        s: '-created_at',
        q: q
      });
      $q.all([p1, p2]).then(function (results) {
        var tickets = results[0];
        var channelTickets = results[1];
        _this2.ticketsByDay = _.groupBy(tickets, function (t) {
          return moment(t.created_at).format('YYYY-MM-DD');
        });
        _this2.channelTicketsByDay = _.groupBy(channelTickets, function (t) {
          return moment(t.created_at).format('YYYY-MM-DD');
        });
        _this2.ticketsGraphLabels = [];
        _this2.ticketsGraphTooltips = [];
        _this2.ticketsGraphData = [[], //daily count of broadcast tickets
        [] //daily count of channel tickets
        ];

        _.range(NUM_DAYS - 1, -1, -1).forEach(function (i) {
          var dt = moment().clone().subtract(i, 'day');
          var dtf = dt.format('YYYY-MM-DD');

          _this2.ticketsGraphLabels.push(dt);

          _this2.ticketsGraphTooltips.push("Tickets sold on ".concat(dt.format('ddd MMM Do')));

          _this2.ticketsGraphData[0].push((_this2.ticketsByDay[dtf] || {}).length || 0);

          _this2.ticketsGraphData[1].push((_this2.channelTicketsByDay[dtf] || {}).length || 0);
        });

        _this2.ticketsGraphOptions = {
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'MMM Do'
                }
              },
              //categoryPercentage: 0.20, //1 every 5 labels
              gridLines: {
                display: false
              },
              position: 'bottom',
              ticks: {
                fontSize: 11,
                fontFamily: 'Arial, sans-serif',
                //maxRotation: 0,
                autoSkip: true
              }
            }],
            yAxes: [{
              ticks: {
                min: 0,
                beginAtZero: true,
                suggestedMax: 10
              }
            }]
          },
          tooltips: {
            callbacks: {
              title: function title(items, data) {
                return _this2.ticketsGraphTooltips[items[0].index];
              }
            }
          }
        };
      });
    }
  }, {
    key: "loadBroadcastsForPage",
    value: function loadBroadcastsForPage(p) {
      var _this3 = this;

      var Broadcast = this.Broadcast,
          toaster = this.toaster;
      var query = Broadcast.query({
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-starts_at'
      }, function (data, headers) {
        _this3.broadcasts = data;
        var pagination = JSON.parse(headers('x-pagination'));
        _this3.broadcastsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length
        };
      }, function (err) {
        toaster.pop('warning', 'Unable to load broadcasts. Please refresh the page and try again.');
      });
      this.loadingPromises.push(query.$promise);
      if (p > 1) window.scrollTo(0, 0);
    }
  }, {
    key: "loadChannelsForPage",
    value: function loadChannelsForPage(p) {
      var _this4 = this;

      var Channel = this.Channel,
          toaster = this.toaster;
      var query = Channel.query({
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: 'name'
      }, function (data, headers) {
        _this4.channels = data;
        var pagination = JSON.parse(headers('x-pagination'));
        _this4.channelsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length
        };
      }, function (err) {
        toaster.pop('warning', 'Unable to load channels. Please refresh the page and try again.');
      });
      this.loadingPromises.push(query.$promise);
      if (p > 1) window.scrollTo(0, 0);
    }
  }, {
    key: "loadTicketsForPage",
    value: function loadTicketsForPage(p) {
      var _this5 = this;

      var Ticket = this.Ticket,
          toaster = this.toaster;
      var params = {
        resource: this.report,
        id: this.id
      };

      if (params.resource == 'account') {
        params.type = this.id; //type=channel or type=broadcast passed as querystring

        delete params.resource;
        delete params.id;
      }

      if (this.start && this.end) {
        params.q = "created_at:[".concat(this.start.toISOString(), " TO ").concat(this.end.toISOString(), "]");
      }

      var query = Ticket.query(angular.extend({}, params, {
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-created_at'
      }), function (data, headers) {
        _this5.tickets = data;
        var pagination = JSON.parse(headers('x-pagination'));
        _this5.ticketsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length
        };
      }, function (err) {
        toaster.pop('warning', 'Unable to load tickets. Please refresh the page and try again.');
      });
      this.summary = Ticket.summary(params);
      this.loadingPromises.push(query.$promise);
      this.loadingPromises.push(this.summary.$promise);
      if (p > 1) window.scrollTo(0, 0);
    }
  }, {
    key: "setTimePeriod",
    value: function setTimePeriod(value) {
      // moment.month gives 0-11
      // we'll translate into quarter number 1-4
      var currentQuarterNumber = Math.ceil((moment().month() + 1) / 3);
      var startMonth = (currentQuarterNumber - 1) * 3;
      var endMonth = currentQuarterNumber * 3 - 1;

      if (value == 'this_q') {
        this.timePeriod = value;
        this.start = moment().month(startMonth).startOf('month').toDate();
        this.end = moment().month(endMonth).endOf('month').toDate();
      } else if (value == 'last_q') {
        this.timePeriod = value;
        this.start = moment().month(startMonth).subtract(3, 'months').startOf('month').toDate();
        this.end = moment().month(endMonth).subtract(3, 'months').endOf('month').toDate();
      } else {
        this.timePeriod = null;
        this.start = null;
        this.end = null;
      }

      this.loadTicketsForPage(1);
    }
  }]);

  return TicketsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (TicketsController);

/***/ }),
/* 494 */
/***/ (function(module, exports) {

angular.module('app.pages.reports').component('achievementsCell', {
  bindings: {
    enabled: '<',
    name: '@',
    description: '@'
  },
  template: "\n      <div ng-class=\"$ctrl.enabled ? 'unlocked' : 'locked'\">\n        <i ng-if=\"!$ctrl.enabled\" class=\"fa fa-4x fa-trophy\"></i>\n        <i ng-if=\"$ctrl.enabled\" class=\"fa fa-4x fa-trophy\" uib-tooltip=\"{{$ctrl.description}}\" tooltip-append-to-body=\"true\"></i>\n        <label ng-if=\"$ctrl.enabled\" uib-tooltip=\"{{$ctrl.description}}\" tooltip-append-to-body=\"true\">{{$ctrl.name}}</label>\n        <label ng-if=\"!$ctrl.enabled\">&nbsp;</label>\n      </div>\n    "
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_html__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__resources_html__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var ResourcesController = /*#__PURE__*/function () {
  function ResourcesController($rootScope) {
    'ngInject';

    _classCallCheck(this, ResourcesController);

    this.account = $rootScope.account;
    this.platformSteps = [{
      name: 'Acquisition',
      image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Acquisition.png?t=1484855601418',
      link: 'https://www.boxcast.com/product/platform#acquisition'
    }, {
      name: 'Production',
      image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Video_Production.png?t=1484855601418',
      link: 'https://www.boxcast.com/product/platform#live-production'
    }, {
      name: 'Compression',
      image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Compression.png?t=1484855601418',
      link: 'https://www.boxcast.com/product/platform#compression'
    }, {
      name: 'Transfer',
      image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Transfer.png?t=1484855601418',
      link: 'https://www.boxcast.com/product/platform#transfer'
    }, {
      name: 'Encoding',
      image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Encoding.png?t=1484855601418',
      link: 'https://www.boxcast.com/product/platform#transcoding'
    }, {
      name: 'Delivery',
      image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Delivery.png?t=1484855601418',
      link: 'https://www.boxcast.com/product/platform#delivery'
    }, {
      name: 'Presentation',
      image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Presentation.png?t=1484855601418',
      link: 'https://www.boxcast.com/product/platform#presentation'
    }, {
      name: 'Promotion',
      image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Promotion.png?t=1484855601418',
      link: 'https://www.boxcast.com/product/platform#promotion'
    }, {
      name: 'Monetization',
      image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Monetization.png?t=1484855601418',
      link: 'https://www.boxcast.com/product/platform#monetization'
    }];
  }

  _createClass(ResourcesController, [{
    key: "openPlatformStep",
    value: function openPlatformStep(p) {
      window.open(p.link);
    }
  }, {
    key: "changeTab",
    value: function changeTab(name) {
      this.tab = name;
      window.scrollTo(0, 0);
    }
  }]);

  return ResourcesController;
}();

var module = Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('resources', __WEBPACK_IMPORTED_MODULE_1__resources_html___default.a, ResourcesController, 'ResourcesController');
module.component('resourceCard', {
  transclude: true,
  controllerAs: 'vm',
  bindings: {
    title: '@',
    image: '@'
  },
  template: "\n    <div class=\"resource-card well\">\n      <div style=\"display:flex\">\n        <div class=\"img-container\"\n             style=\"background-image:url({{vm.image}});\n                    background-size:cover;\n                    background-repeat: no-repeat;\n                    background-position: 50% 50%;\n                    background-color: #000;\">\n\n        </div>\n        <div class=\"content-container\">\n          <h3>{{vm.title}}</h3>\n          <div ng-transclude></div>\n        </div>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n  "
});
module.component('resourceArticle', {
  controllerAs: 'vm',
  bindings: {
    name: '@',
    description: '@',
    link: '@',
    type: '@'
  },
  template: "\n    <span class=\"label label-default\">\n      {{vm.type}}\n    </span>\n    <h4><a href=\"{{vm.link}}\" target=\"_blank\">{{vm.name}}</a></h4>\n    <p>{{vm.description}}</p>\n  "
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\">\n\n  <!--- main tabs -->\n  <div class=\"clearfix\">\n    <div class=\"col-xs-12\">\n      <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n        <li ng-class=\"{active:!vm.tab}\">\n          <a href ng-click=\"vm.tab = null\">Getting Started</a>\n        </li>\n        <li ng-class=\"{active:vm.tab == 'setup'}\">\n          <a href ng-click=\"vm.tab = 'setup'\">Setup &amp; Production</a>\n        </li>\n        <li ng-class=\"{active:vm.tab == 'distribution'}\">\n          <a href ng-click=\"vm.tab = 'distribution'\">Distribution &amp; Promotion</a>\n        </li>\n      </ol>\n    </div>\n  </div>\n\n  <!--- getting started content -->\n  <div class=\"row\" ng-if=\"!vm.tab\">\n    <div class=\"col-xs-12\">\n      <div class=\"well text-center\">\n        <div>\n        <h3>Welcome to BoxCast Resources</h3>\n        <p>Everything you need to know to create amazing live streamed broadcasts</p>\n        <img src=\"//www.boxcast.com/hubfs/May2016/Icon-Education.png\" class=\"building-graphic\">\n        </div>\n\n        <div class=\"row\" style=\"max-width: 720px; margin: 30px auto 15px;\">\n          <h3 style=\"margin-bottom:25px\">Check Out Our Resources</h3>\n          <div class=\"col-xs-12 col-sm-4\">\n            <a class=\"btn btn-lg btn-default btn-block\" href ng-click=\"vm.changeTab('setup')\" style=\"padding:30px 15px; white-space:normal; font-size:14px;\">\n              Setup and Production\n            </a>\n          </div>\n           <div class=\"col-xs-12 col-sm-4\">\n            <a class=\"btn btn-lg btn-default btn-block\" href ng-click=\"vm.changeTab('distribution')\" style=\"padding:30px 15px; white-space:normal; font-size:14px;\">\n              Promotion and Distribution\n            </a>\n          </div>\n          <div class=\"col-xs-12 col-sm-4\">\n            <a class=\"btn btn-lg btn-default btn-block\" href=\"https://support.boxcast.com\" target=\"_blank\" style=\"padding:30px 15px; white-space:normal; font-size:14px;\">\n              Technical Support\n            </a>\n          </div>\n        </div>\n\n\n        <!-- TODO: Improve spacing from video to text to platform information.  -->\n        <div class=\"row\" style=\"margin-top:60px\">\n          <h3>The BoxCast Platform</h3>\n          <p style=\"margin: 15px 15px;\">Live video streaming can be complicated and intimidating. Here at BoxCast, we do live video streaming differently. Learn how each step of BoxCast's end-to-end platform works hard behind the scenes to make it easy to create great live video.</p>\n          <div class=\"platform-banner\">\n            <ol class=\"list-unstyled platform-banner-text text-center clearfix\">\n              <li class=\"empty-space\">&nbsp;</li>\n              <li ng-repeat=\"p in ::vm.platformSteps\"\n                  ng-mouseover=\"hover=$index\"\n                  ng-mouseout=\"hover=null\"\n                  ng-class=\"{active:hover===$index}\"\n                  ng-click=\"vm.openPlatformStep(p)\"\n                  title=\"Learn more about {{p.name}}\"\n                  style=\"cursor:pointer\">\n                <img src=\"{{p.image}}\" data-pin-nopin=\"true\">\n                {{p.name}}\n              </li>\n              <li class=\"empty-space\">&nbsp;</li>\n            </ol>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n\n  <!--- Event Setup & Production content -->\n  <div class=\"row\" ng-if=\"vm.tab == 'setup'\">\n    <div class=\"col-xs-12\">\n\n      <resource-card\n          title=\"Finding the Right Equipment\"\n          image=\"/img/resources/finding-the-right-equiptment.jpg\">\n        <ol class=\"list-unstyled\">\n          <li>\n            <resource-article name=\"BoxCast Equipment Guide - Spring 2017\"\n                              description=\"Find our update on the state of live video streaming in 2017, and recommendations for the latest Cameras, Tripods, Switchers, and Streaming Hardware.\"\n                              link=\"https://cdn2.hubspot.net/hubfs/484866/Ebook_Guides/Equipment%20Guide%20Spring%202017/The%20Best%20Equipment%20for%20Live%20Video%20Streaming%202017.pdf\"\n                              type=\"Guide\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"Finding the Right Equipment\"\n                              description=\"A list of BoxCast’s favorite production equipment for live video streaming, whether you’re a beginner, an intermediate, or an expert\"\n                              link=\"https://www.boxcast.com/blog/the-best-live-video-streaming-equipment-for-every-level\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"The Best Strategy for Buying Video Equipment\"\n                              description=\"Finding video equipment can seem overwhelming, but these five guidelines will help you break down your decision process and evaluate what’s best for you.\"\n                              link=\"https://www.boxcast.com/blog/the-best-strategy-for-buying-video-equipment\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n\n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"The Best Ways to Buy Used Video Equipment For Your Church\"\n                              description=\"Not every church has the budget to buy new equipment. Luckily, there's plenty of high-quality, used equipment out there. Here are some tips on how to find it.\"\n                              link=\"https://www.boxcast.com/blog/the-best-ways-to-buy-used-video-equipment-for-your-church\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n\n          <li>\n            <resource-article name=\"8 Reasons Why Hardware is the Best Option for Streaming\"\n                              description=\"BoxCast provides eight reasons why hardware encoders are better than software solutions for live streaming video.\"\n                              link=\"https://www.boxcast.com/blog/8-reasons-why-hardware-is-the-best-option-for-streaming\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n\n           <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"How to Choose the Right Microphone for Your Pastor\"\n                              description=\"Few things ruin a church broadcast more thoroughly than bad sound. This post deals with the types of microphones your pastor should use during services.\"\n                              link=\"https://www.boxcast.com/blog/how-to-choose-the-right-microphone-for-your-pastor\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n\n          <li ng-show=\"vm.account.market == 'enterprise'\">\n            <resource-article name=\"The Best Live Video Streaming Equipment for Your City Hall\"\n                              description=\"There are a ton of options when it comes to finding the right camera for your city hall. This post will help you identify which one is right for you.\"\n                              link=\"https://www.boxcast.com/blog/the-best-live-video-streaming-equipment-for-your-city-hall\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n\n          <li>\n            <resource-article name=\"What is a Video Switcher?\"\n                              description=\"If you're looking to enhance the value of your stream, integrating multiple camera angles is a great way to get started. How? By using a video switcher.\"\n                              link=\"https://www.boxcast.com/blog/what-is-a-video-switcher\"\n                              type=\"Video\"></resource-article>\n          </li>\n\n          <li>\n            <resource-article name=\"Using BoxCast Switcher for Mobile Video Switching\"\n                              description=\"BoxCast Switcher, the app that turns every iOS device into a camera that can stream live. This post outlines several of its innovative features.\"\n                              link=\"https://www.boxcast.com/blog/everything-you-need-to-know-about-boxcast-switcher\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n      <resource-card\n          title=\"Perfecting your Setup\"\n          image=\"http://cdn2.hubspot.net/hubfs/484866/Collateral_Church/church_lighting_2.jpg\">\n        <ol class=\"list-unstyled\">\n\n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"Why You Need to Improve Your Church Lighting\"\n                              description=\"Any church worship space not designed specifically for video production can benefit from improved lighting. Here’s what to look for and how to start.\"\n                              link=\"https://www.boxcast.com/blog/why-you-need-to-improve-your-church-lighting\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          \n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"How to Fix Your Church's Lighting Problems\"\n                              description=\"A well-lit live stream is key to a good viewing experience. This post discusses common lighting problems for churches and their easy fixes.\"\n                              link=\"https://www.boxcast.com/blog/how-to-fix-your-churchs-lighting-problems\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n\n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"The Solution to Becoming a Strong Multi-Site Church\"\n                              description=\"This post explores why BoxCast’s Multi-Site Video Player is the solution to enabling remote campuses to watch your live broadcasts seamlessly.\"\n                              link=\"https://www.boxcast.com/blog/the-solution-to-becoming-a-strong-multi-site-church\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n\n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"How Your Church Can Stream Amazing Outdoor Events\"\n                              description=\"Streaming outdoor activities poses a set of challenges. Here are some tips on how to overcome them.\"\n                              link=\"https://www.boxcast.com/blog/how-to-live-video-stream-amazing-outdoor-events\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n\n          <li>\n            <resource-article name=\"How to Beautifully Stream in Remote Locations\"\n                              description=\"This infographic shows how to pair BoxCast's live video streaming technology with Ubiquiti’s Wireless Range Extenders to stream a remote event.\"\n                              link=\"https://www.boxcast.com/blog/infographic-how-to-beautifully-stream-in-remote-locations\"\n                              type=\"Infographic\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How to Stream When There is No Internet\"\n                              description=\"This video shows how we were able to put on a high quality live video stream without a local internet connection.\"\n                              link=\"https://www.youtube.com/watch?v=EoTwYJ4rnnw&index=8&list=PL-wL96a9X8Mguru0jl0p0sGn_K8XGpRy7\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"Why You'll Love BoxCast’s Low-Latency Preview\"\n                              description=\"Introducing BoxCast Preview, a new feature that shows you exactly what will be broadcast to the world, but with only a few seconds of latency.\"\n                              link=\"https://www.boxcast.com/blog/why-youll-love-boxcasts-low-latency-preview\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n         \n          <li>\n            <resource-article name=\"RTMP Streaming Guide\"\n                              description=\"This quick tutorial will show you how to stream to BoxCast's platform over RTMP. \"\n                              link=\"https://www.youtube.com/watch?v=EU3vZuv8yIs\"\n                              type=\"Video\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n      <resource-card\n          title=\"Crystal Clear Audio\"\n          image=\"/img/resources/crystal-clear-audio.jpeg\">\n        <ol class=\"list-unstyled\">\n\n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"5 Easy Ways to Improve the Audio of Your Church Stream\"\n                              description=\"Few things ruin a church broadcast more thoroughly than bad sound. This post deals with the types of microphones your pastor should use during services.\"\n                              link=\"https://www.boxcast.com/blog/5-easy-ways-to-improve-the-audio-of-your-live-streams\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          \n          <li>\n            <resource-article name=\"How Do I Fix Audio Issues With My Stream?\"\n                              description=\"Clipping, low bitrates, and slow networks can all effect your audio stream. This help-desk post explains how to fix them.\"\n                              link=\"https://support.boxcast.com/en/articles/4235126\"\n                              type=\"Support\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n      <resource-card\n          title=\"Ideal Internet Connection\"\n          image=\"/img/resources/ideal-internet-connection.jpeg\">\n        <ol class=\"list-unstyled\">\n          <li>\n            <resource-article name=\"Is a Wi-Fi Connection Sufficient to Stream?\"\n                              description=\"Wireless is far less reliable than a hardline connection, but streaming is possible.\"\n                              link=\"https://support.boxcast.com/en/articles/4235053\"\n                              type=\"Support\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How Do I configure my Boxcaster for a Wireless (Wi-Fi) Connection?\"\n                              description=\"This help-desk article explains how to connect your BoxCaster to a wireless network.\"\n                              link=\"https://support.boxcast.com/en/articles/4235147\"\n                              type=\"Support\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How Fast Does My Internet Need to Be to Live Stream?\"\n                              description=\"In this Tech Tips video, we discuss the various internet speeds that are necessary for live video streaming and we give you a basic understanding of the difference between uploading and downloading.\"\n                              link=\"https://youtu.be/MOdQRHHxEEk\"\n                              type=\"Video\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n      <resource-card\n          title=\"Best Practices for Live Video Production\"\n          image=\"/img/resources/camera-operation.jpg\">\n        <ol class=\"list-unstyled\">\n          <li>\n            <resource-article name=\"How to Get the Best Picture Quality for Your Stream\"\n                              description=\"Is equipment the most important part of a successful live stream production? We say no. Even more important than equipment is knowing how to use what you have.\"\n                              link=\"https://www.youtube.com/watch?v=BCnvl8RZ7YY&t=485s\"\n                              type=\"Webinar\"></resource-article>\n          </li>\n\n          <li>\n            <resource-article name=\"What You Need to Know to Frame and Compose a Killer Shot\"\n                              description=\"A guide for camera operation.\"\n                              link=\"https://www.boxcast.com/hubfs/Ebook_Guides/Framing_and_Composition_Guide.pdf\"\n                              type=\"Guide\"></resource-article>\n          </li>\n        <li>\n          <resource-article name=\"Understanding White Balance in 90 Seconds\"\n                              description=\"Don't know what white balance is? We'll explain it real quick in this month's episode of BoxCast Tech Tips. \"\n                              link=\"https://youtu.be/_8wr_aTF03A\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n          <resource-article name=\"HDMI vs. SDI Video Connections\"\n                              description=\"On this episode of BoxCast Tech Tips, Josh compares two commonly used video connections: HDMI and SDI.\"\n                              link=\"https://www.boxcast.com/blog/hdmi-vs-sdi-video-connections-whats-the-difference\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n          <resource-article name=\"What's the Difference Between Various SDI Signals?\"\n                              description=\"In this episode of Tech Tips, we overview the different SDI signals with a simple explanation.\"\n                              link=\"https://youtu.be/PGc_zChVR1U\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n          <resource-article name=\"Which Frame Rate Should You Use?\"\n                              description=\"In this episode of BoxCast tech tips, we break down the differences in frame rates.\"\n                              link=\"https://www.youtube.com/watch?v=2bDojZWNaLk\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li ng-show=\"vm.account.market == 'sports'\">\n          <resource-article name=\"What’s the Best Frame Rate and Shutter Speed for Sports Video?\"\n                              description=\"This post explains why frame rate and shutter speed are so important when it comes to capturing sports video and makes suggestions for the optimum settings.\"\n                              link=\"https://www.boxcast.com/blog/whats-the-best-frame-rate-and-shutter-speed-for-sports-video\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n        \n        </ol>\n      </resource-card>\n\n      <resource-card\n          title=\"Production from Mobile Devices\"\n          image=\"/img/resources/mobile-devices.jpg\">\n        <ol class=\"list-unstyled\">\n          <li>\n            <resource-article name=\"Four Awesome Ways to Use BoxCast’s Newest App, Broadcaster\"\n                              description=\"The Broadcaster app is the next step BoxCast has taken to make your live video streaming experience as easy as possible. This post explains four ways to use it.\"\n                              link=\"https://www.boxcast.com/blog/four-awesome-ways-to-use-boxcasts-newest-app\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"Everything You Need to Know About BoxCast Switcher\"\n                              description=\"Introducing BoxCast Switcher, the app that turns every iOS device into a camera that can stream live. This post outlines several of its innovative features.\"\n                              link=\"https://www.boxcast.com/blog/everything-you-need-to-know-about-boxcast-switcher\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"Broadcaster- BoxCast's Live Video Streaming App\"\n                              description=\"In this Tech Tips video, we show you how easy it is to stream directly from the your phone using Broadcaster.\"\n                              link=\"https://youtu.be/65wGjp7zLrc\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"The Best Equipment for Streaming from Your iPhone\"\n                              description=\"In this Tech Tips Video, we give you recommendations for a microphone, stabilizer mount, and tripod from streaming live from your iPhone.\"\n                              link=\"https://youtu.be/EF-adbbcNfw\"\n                              type=\"Video\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n      <resource-card\n          title=\"Advanced BoxCast Broadcast Settings\"\n          image=\"/img/resources/advanced-settings.png\">\n        <ol class=\"list-unstyled\">\n           <li>\n            <resource-article name=\"How Do I Set Up Recurring Broadcasts?\"\n                              description=\"Setting up recurring broadcasts allows you to automate the scheduling of broadcasts that occur regularly. Here's how:\"\n                              link=\"https://support.boxcast.com/en/articles/4235093\"\n                              type=\"Support\"></resource-article>\n           </li>\n           <li>\n            <resource-article name=\"How to Make Highlight Clips with BoxCast\"\n                              description=\"This post explains how to use the BoxCast highlight clip feature to capture and distribute highlights for both live and archived video.\"\n                              link=\"https://www.boxcast.com/blog/how-to-make-highlight-clips-with-boxcast\"\n                              type=\"Blog Post\"></resource-article>\n           </li>\n           <li>\n            <resource-article name=\"How to Use the BoxCast Trimming Feature\"\n                              description=\"BoxCast's trimming feature lets you easily trim off the very beginning or end of your archived broadcast so that you can focus on what your viewers really want to watch.\"\n                              link=\"https://www.boxcast.com/blog/video-how-to-use-the-boxcast-trimming-feature\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"Why You'll Love BoxCast’s Low-Latency Preview\"\n                              description=\"Introducing BoxCast Preview, a new feature that shows you exactly what will be broadcast to the world, but with only a few seconds of latency.\"\n                              link=\"https://www.boxcast.com/blog/why-youll-love-boxcasts-low-latency-preview\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n\n\n    </div>\n  </div>\n\n  <!--- Event Distribution and Promotion content -->\n  <div class=\"row\" ng-if=\"vm.tab == 'distribution'\">\n    <div class=\"col-xs-12\">\n      \n       <resource-card\n          title=\"Online Event Promotion\"\n          image=\"/img/resources/online-event-promotion.jpeg\"\n          ng-show=\"vm.account.market == 'sports'\">\n        <ol class=\"list-unstyled\">\n\n          <li ng-show=\"vm.account.market == 'sports'\">\n            <resource-article name=\"5 Steps to Promoting Your Biggest Game\"\n                              description=\"Five easy-to-follow steps that will help athletic directors promote the biggest sports event of the year and leverage attention for the school.\"\n                              link=\"https://www.boxcast.com/blog/5-steps-to-promoting-your-biggest-game-of-the-year\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          \n          <li ng-show=\"vm.account.market == 'sports'\">\n            <resource-article name=\"Five Ways to Ensure Fans Find Your Sports Stream\"\n                              description=\"5 quick ways to increase the viewership for your sports stream.\"\n                              link=\"https://www.boxcast.com/blog/five-ways-to-ensure-fans-find-your-sports-stream\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n      <resource-card\n          title=\"Social Media\"\n          image=\"/img/resources/social-media.png\">\n        <ol class=\"list-unstyled\">\n          <li>\n            <resource-article name=\"4 Reasons Your Organization Needs a Social Media Presence\"\n                              description=\"SThis post outlines four ways that a strong social media presence enables organizations to share, learn from, and interact with their online audiences.\"\n                              link=\"https://www.boxcast.com/blog/4-reasons-your-organization-needs-a-strong-social-media-presence\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How to Leverage Social Media to Grow Your Organization\"\n                              description=\"This free guide walks you through the biggest social media giants to help you understand how to use the platforms to benefit your organization.\"\n                              link=\"http://www.boxcast.com/hubfs/Ebook_Guides/Social_Media_Guide.pdf\"\n                              type=\"Guide\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"Are you Growing Your Live Video Streaming Audience\"\n                              description=\"Streaming your services helps you include faraway members in your worship experience — but only if they know it’s available and how to access it.\"\n                              link=\"https://www.boxcast.com/blog/are-you-growing-your-live-video-streaming-audience\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"Raise the Profile of Your Church\"\n                              description=\"Local news coverage is a great way to raise the profile of your church and share what you’re doing with a broad audience. Here are five easy ways to do it.\"\n                              link=\"https://www.boxcast.com/blog/5-easy-ways-to-raise-the-profile-of-your-church\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"Can We Track How Many People Have Watched a Video?\"\n                              description=\"See how many people are watching your live video streams.\"\n                              link=\"https://support.boxcast.com/en/articles/4235145\"\n                              type=\"Support\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How to Better Connect with Your Live Stream Audience\"\n                              description=\"In today's digital age, a pastor must be sure to connect with the online audience as well as the live one. Here are 3 ways to engage your entire community.\"\n                              link=\"https://www.boxcast.com/blog/how-to-better-connect-with-your-live-stream-audience\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"5 Facebook Groups to Help Strengthen Your Ministry\"\n                              description=\"This post explores five Facebook groups that will help you develop your own ministry, whether you’re the senior pastor, an A/V professional, or worship leader.\"\n                              link=\"https://www.boxcast.com/blog/5-facebook-groups-to-help-strengthen-your-ministry\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"Raise the Profile of Your Church\"\n                              description=\"Local news coverage is a great way to raise the profile of your church and share what you’re doing with a broad audience. Here are five easy ways to do it.\"\n                              link=\"https://www.boxcast.com/blog/5-easy-ways-to-raise-the-profile-of-your-church\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How to Stream to YouTube Live from BoxCast\"\n                              description=\"In this Tech Tips video, we show you how easy it is to simulcast to YouTube Live directly from your BoxCast Dashboard!\"\n                              link=\"https://youtu.be/nSzYc8b7754\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How to Stream to Facebook Live using BoxCast\"\n                              description=\"In this Tech Tips video, we show you how easy it is to stream directly to Facebook Live from your BoxCast Dashboard!\"\n                              link=\"https://youtu.be/613gsoI9T-Y\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How to Export BoxCast Videos to YouTube and Vimeo\"\n                              description=\"This short video shows you how to export BoxCast Archives directly to YouTube and Vimeo right from your BoxCast Dashboard.\"\n                              link=\"https://youtu.be/QIsjUaUqKnw\"\n                              type=\"Video\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n      <resource-card\n          title=\"Monetization\"\n          image=\"/img/resources/monetization.jpg\">\n        <ol class=\"list-unstyled\">\n        \n          <li>\n            <resource-article name=\"Can I Make Money from My Live Streams?\"\n                              description=\"Streaming doesn’t only benefit viewers; it can also be a great way for organizations to generate new revenue. Here's how to make money from your live streams.\"\n                              link=\"https://www.boxcast.com/blog/can-i-make-money-from-my-live-streams\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li ng-show=\"vm.account.market == 'sports'\">\n            <resource-article name=\"How Can my Live Stream Make Money for my Program\"\n                              description=\"Live video streaming doesn't only help spread awareness about your games; the platform can actually be used to generate revenue to put back into your program.\"\n                              link=\"https://www.boxcast.com/blog/how-can-my-live-stream-make-money-for-my-program\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li ng-show=\"vm.account.market == 'sports'\">\n            <resource-article name=\"How to Turn Your Games into Pay-Per-View Events\"\n                              description=\"With the help of BoxCast's live streaming platform, ECAC Hockey created a new revenue source that is helping their organization thrive. Here's how they do it.\"\n                              link=\"https://www.boxcast.com/blog/turn-your-games-into-pay-per-view-event\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n      <resource-card\n          title=\"Video Distribution\"\n          image=\"/img/resources/video-distribution.jpeg\">\n        <ol class=\"list-unstyled\">\n          <li>\n            <resource-article name=\"How to Embed a BoxCast Stream on Your Website\"\n                              description=\"Embedding your vide stream on your website is only a few steps away.\"\n                              link=\"https://www.youtube.com/watch?v=wB47W_hY_lA&t=1s\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How to Stream to YouTube Live with BoxCast\"\n                              description=\"BoxCast's YouTube Live integration lets you stream directly to YouTube Live. This short video shows you how it works.\"\n                              link=\"https://www.boxcast.com/blog/how-to-stream-to-youtube-live-with-boxcast\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How to Stream to Facebook Live Using BoxCast\"\n                              description=\"In this tutorial, we show you how to stream to Facebook Live from the BoxCast Streaming Platform.\"\n                              link=\"https://www.youtube.com/watch?v=Qdj4ZamnsM0&t=1s\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How to Wow Your Fans with a Pre-Roll Video\"\n                              description=\"The ability to create a custom pre-event video gives you a great new way to add an extra element to your live video stream and keep your viewers hooked.\"\n                              link=\"https://www.boxcast.com/blog/how-to-wow-your-fans-with-an-entertaining-pre-roll-video\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li ng-show=\"vm.account.market == 'enterprise'\">\n            <resource-article name=\"How Streaming Can Help Your City Hall Reach a New Audience\"\n                              description=\"This video explores why the City of Avon Lake chose to start live streaming their city council meetings to their website.\"\n                              link=\"https://www.boxcast.com/blog/how-streaming-can-help-your-city-hall-reach-a-new-audience\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n      <resource-card\n          title=\"Creating a Great Website\"\n          image=\"/img/resources/website.png\"\n          ng-show=\"vm.account.market == 'house-of-worship' || vm.account.market == 'sports'\">\n        <ol class=\"list-unstyled\">\n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"5 Guiding Principles for a Powerful Church Website\"\n                              description=\"A powerful church website is a necessary tool to engage current and new members alike, providing them with ways to strengthen their faith.\"\n                              link=\"https://www.boxcast.com/blog/5-guiding-principles-for-a-powerful-church-website\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"4 Ways to Make a Great Church Website\"\n                              description=\"This post sets out to answer to one simple question: what makes a great church website? Here are the 4 most important ways to make your engaging.\"\n                              link=\"https://www.boxcast.com/blog/4-ways-to-make-a-great-church-website\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li ng-show=\"vm.account.market == 'house-of-worship'\">\n            <resource-article name=\"How to Integrate BoxCast with Church Online Platform\"\n                              description=\"This short video explains how to integrate the two systems.\"\n                              link=\"https://www.youtube.com/watch?v=5oBR5kz7nvE&index=12&list=PL-wL96a9X8Mguru0jl0p0sGn_K8XGpRy7\"\n                              type=\"Video\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n      <resource-card\n          title=\"Post Production\"\n          image=\"/img/resources/video-editting.jpg\">\n        <ol class=\"list-unstyled\">\n          <li>\n            <resource-article name=\"How to Use the BoxCast Trimming Feature\"\n                              description=\"BoxCast's trimming feature lets you easily trim off the very beginning or end of your archived broadcast so that you can focus on what your viewers really want to watch.\"\n                              link=\"https://www.boxcast.com/blog/video-how-to-use-the-boxcast-trimming-feature\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How to Download a BoxCast Broadcast\"\n                              description=\"Learn to download a broadcast after it is recorded.\"\n                              link=\"https://www.youtube.com/watch?v=A7vxX7lCk1E\"\n                              type=\"Video\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"Did You Know You Can Download a BoxCast Broadcast?\"\n                              description=\"With the click of a button, BoxCast customers can access the archived versions of their streams just minutes after each event is over.\"\n                              link=\"https://www.boxcast.com/blog/did-you-know-you-can-now-download-a-boxcast-stream\"\n                              type=\"Blog Post\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"Where Can I Find a Downloadable File of My Archived Event?\"\n                              description=\"BoxCast lets you download your archived streams. Here's how:\"\n                              link=\"https://support.boxcast.com/en/articles/4235148\"\n                              type=\"Support\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"What is a Channel?\"\n                              description=\"Channels provide you with a way to organize your events. This help-desk post tells you what you have to know:\"\n                              link=\"https://support.boxcast.com/en/articles/4235050\"\n                              type=\"Support\"></resource-article>\n          </li>\n          <li>\n            <resource-article name=\"How Do I Add Closed Captions to My Video?\"\n                              description=\"Closed Captions make your videos more accessible. Here's how to add them:\"\n                              link=\"https://support.boxcast.com/en/articles/4235125\"\n                              type=\"Support\"></resource-article>\n          </li>\n        </ol>\n      </resource-card>\n\n\n\n    </div>\n  </div>\n\n</main>\n\n"

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rtmp_push_channels__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appearance__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wifi_configuration_service__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_isStreamMonkey__ = __webpack_require__(10);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





 // The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.

var module = angular.module('settings', []);
module.service('WifiConfigurationService', __WEBPACK_IMPORTED_MODULE_2__wifi_configuration_service__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* default */])(module);
module.config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('settings', {
    url: '/settings',
    template: __webpack_require__(506),
    "abstract": true,
    controller: /*#__PURE__*/_createClass(function SettingsController($rootScope) {
      'ngInject';

      _classCallCheck(this, SettingsController);

      this.isStreamMonkey = Object(__WEBPACK_IMPORTED_MODULE_4__utils_isStreamMonkey__["a" /* default */])($rootScope.account.migration_service_id);
    }),
    controllerAs: 'vm'
  }).state('settings.appearance', {
    url: '/appearance',
    template: __webpack_require__(507),
    controller: __WEBPACK_IMPORTED_MODULE_1__appearance__["a" /* default */],
    controllerAs: 'vm'
  }).state('settings.integrations', {
    url: '/integrations?integration_id',
    template: __webpack_require__(508),
    controller: __webpack_require__(509)["default"],
    controllerAs: 'vm'
  }).state('settings.facebook', {
    url: '/facebook',
    template: __webpack_require__(513),
    controller: __webpack_require__(514)["default"],
    controllerAs: 'vm'
  }).state('settings.youtube', {
    url: '/youtube?code&error&link',
    template: __webpack_require__(515),
    controller: __webpack_require__(516)["default"],
    controllerAs: 'vm'
  }).state('settings.vimeo', {
    url: '/vimeo?code&link',
    template: __webpack_require__(517),
    controller: __webpack_require__(518)["default"],
    controllerAs: 'vm'
  }).state('settings.payment', {
    url: '/payment?pd_did&pd_sid&show_orders&action',
    template: __webpack_require__(519),
    controller: __webpack_require__(520)["default"],
    controllerAs: 'vm'
  }).state('settings.twitter', {
    url: '/twitter?link',
    template: __webpack_require__(528),
    controller: __webpack_require__(529)["default"],
    controllerAs: 'vm'
  }).state('settings.rtmp_destinations', {
    url: '/rtmp-push-channels',
    template: __webpack_require__(530),
    controller: __WEBPACK_IMPORTED_MODULE_0__rtmp_push_channels__["a" /* default */],
    controllerAs: 'vm'
  }).state('settings.upgrade', {
    url: '/upgrade?pd_did&pd_sid',
    // The upgrade page is deprecated, but there still may be links our there to it
    // Redirect to the payment page
    controller: function controller($state) {
      'ngInject';

      $state.go('settings.payment', $state.params);
    }
  }) // Migrated pages to dashboard_vue
  .state('settings.overview', {
    url: '/',
    template: "",
    controller: function controller() {
      return window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/settings/preferences"));
    }
  }).state('settings.my_account', {
    url: '/my-account?password_changed',
    template: "",
    controller: function controller() {
      return window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/settings/my-account"));
    }
  }).state('settings.users', {
    url: '/users',
    template: "",
    controller: function controller() {
      return window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/settings/users"));
    }
  }).state('settings.storage', {
    url: '/storage',
    template: '',
    controller: function controller() {
      return window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/settings/storage"));
    }
  }).state('settings.api_keys', {
    url: '/api-keys',
    template: "",
    controller: function controller() {
      return window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/settings/api-keys"));
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RTMPPushChannelsController = /*#__PURE__*/_createClass(function RTMPPushChannelsController($state) {
  'ngInject';

  _classCallCheck(this, RTMPPushChannelsController);

  $state.go('settings.integrations');
});

/* harmony default export */ __webpack_exports__["a"] = (RTMPPushChannelsController);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SettingsAppearanceController; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var APPLE_CATEGORIES = ['Books', 'Business', 'Developer Tools', 'Education', 'Entertainment', 'Finance', 'Food & Drink', 'Games', 'Graphics & Design', 'Health & Fitness', 'Lifestyle', 'Magazines & Newspapers', 'Medical', 'Music', 'Navigation', 'News', 'Photo & Video', 'Productivity', 'Reference', 'Shopping', 'Social Networking', 'Sports', 'Stickers', 'Travel', 'Utilities', 'Weather'];
var ROKU_CATEGORIES = ['Animals & Pets', 'Apps', 'Cars & Motorcycles', 'Classic TV', 'Comedy', 'Crime & Mystery', 'Drama', 'Educational', 'eSports & Gaming', 'Faith-Based', 'Food & Home', 'Games', 'Health & Wellness', 'How To', 'International', 'Kids & Family', 'Lifestyle', 'Local News', 'Movies & TV', 'Music', 'News', 'Personal Media', 'Photo Apps', 'Premium Services', 'Reality & Pop Culture', 'Relaxation & Meditation', 'Rent/Buy Movies', 'Sci & Tech', 'Screensavers', 'Shopping', 'Special Interest', 'Sports', 'Subscription Channels', 'TV en Español', 'Travel', 'Watch With Cable', 'Weather', 'Web Video'];

var SettingsAppearanceController = /*#__PURE__*/function () {
  function SettingsAppearanceController(Account, Broadcast, $rootScope, $uibModal, $q, toaster, AppleTvApp, RokuApp) {
    'ngInject';

    _classCallCheck(this, SettingsAppearanceController);

    this.Account = Account;
    this.Broadcast = Broadcast;
    this.$uibModal = $uibModal;
    this.$q = $q;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.canEditAccountSettings = $rootScope.user.can('update', 'account');
    this.toaster = toaster;
    this.AppleTvApp = AppleTvApp;
    this.RokuApp = RokuApp;
    this.refresh();
  }

  _createClass(SettingsAppearanceController, [{
    key: "rokuImageList",
    value: function rokuImageList() {
      if (!this.rokuApp) {
        return null;
      }

      if (this._rokuImageList) {
        return this._rokuImageList;
      }

      var r = this.rokuApp;
      this._rokuImageList = [{
        id: 'logo',
        name: 'Logo',
        src: r.logo,
        noValidate: true,
        preview_w: 300,
        preview_h: 100
      }, {
        id: 'icon',
        name: 'App Icon',
        src: r.icon,
        w: 540,
        h: 405,
        preview_w: 180,
        preview_h: 135
      }, {
        id: 'channel_store_icon_fhd',
        name: 'Store Icon Full HD',
        src: r.channel_store_icon_fhd,
        w: 540,
        h: 405,
        preview_w: 180,
        preview_h: 135
      }, {
        id: 'channel_store_icon_large',
        name: 'Store Icon Large',
        src: r.channel_store_icon_large,
        w: 336,
        h: 210,
        preview_w: 168,
        preview_h: 105
      }, {
        id: 'channel_store_icon_small',
        name: 'Store Icon Small',
        src: r.channel_store_icon_small,
        w: 246,
        h: 140,
        preview_w: 123,
        preview_h: 70
      }, {
        id: 'splash_screen_fhd',
        name: 'Splash Full HD',
        src: r.splash_screen_fhd,
        w: 1920,
        h: 1080,
        preview_w: 384,
        preview_h: 216
      }, {
        id: 'splash_screen_hd',
        name: 'Splash Large',
        src: r.splash_screen_hd,
        w: 1280,
        h: 720,
        preview_w: 240,
        preview_h: 135
      }, {
        id: 'splash_screen_sd',
        name: 'Splash Small',
        src: r.splash_screen_sd,
        w: 720,
        h: 480,
        preview_w: 162,
        preview_h: 108
      }];
      return this._rokuImageList;
    }
  }, {
    key: "appleTVImageList",
    value: function appleTVImageList() {
      if (!this.appleTVApp) {
        return null;
      }

      if (this._appleTVImageList) {
        return this._appleTVImageList;
      }

      var a = this.appleTVApp;
      this._appleTVImageList = [{
        id: 'app_icon_background_layer',
        name: 'App Icon Background',
        src: a.app_icon_background_layer,
        w: 1280,
        h: 768,
        preview_w: 360,
        preview_h: 216
      }, {
        id: 'app_icon_foreground_layer',
        name: 'App Icon Foreground',
        src: a.app_icon_foreground_layer,
        w: 1280,
        h: 768,
        preview_w: 360,
        preview_h: 216
      }, {
        id: 'app_icon_small_background_layer_2x',
        name: 'App Icon Small Background',
        src: a.app_icon_small_background_layer_2x,
        w: 800,
        h: 480,
        preview_w: 180,
        preview_h: 108
      }, {
        id: 'app_icon_small_foreground_layer_2x',
        name: 'App Icon Small Foreground',
        src: a.app_icon_small_foreground_layer_2x,
        w: 800,
        h: 480,
        preview_w: 180,
        preview_h: 108
      }, {
        id: 'launch_image',
        name: 'Launch Image',
        src: a.launch_image,
        w: 1920,
        h: 1080,
        preview_w: 384,
        preview_h: 216
      }, {
        id: 'top_shelf_image_2x',
        name: 'Top Shelf Image',
        src: a.top_shelf_image_2x,
        w: 3840,
        h: 1440,
        preview_w: 317,
        preview_h: 119
      }, {
        id: 'top_shelf_wide_image_2x',
        name: 'Top Shelf Wide Image',
        src: a.top_shelf_wide_image_2x,
        w: 4640,
        h: 1440,
        preview_w: 384,
        preview_h: 119
      }];
      return this._appleTVImageList;
    }
  }, {
    key: "statusText",
    value: function statusText(app) {
      if (app && app.status) {
        return {
          waiting_on_customer: 'Waiting for Your Submission',
          submitted_to_boxcast: 'In Development',
          submitted_for_review: 'In Review',
          released: 'Released',
          removed: 'Removed'
        }[app.status] || 'Unknown';
      }

      return 'Unknown';
    }
  }, {
    key: "statusLabelLevel",
    value: function statusLabelLevel(app) {
      if (app && app.status) {
        return {
          waiting_on_customer: 'warning',
          submitted_to_boxcast: 'info',
          submitted_for_review: 'info',
          released: 'success',
          removed: 'danger'
        }[app.status] || 'default';
      }

      return 'default';
    }
  }, {
    key: "statusLabelTooltip",
    value: function statusLabelTooltip(app) {
      if (app && app.status) {
        return {
          waiting_on_customer: 'Configure your organization\'s app information and images by selecting "Edit Information". When complete, click "Submit to BoxCast".',
          submitted_to_boxcast: "Your organization's information has been sent, and your app is being built by BoxCast.",
          submitted_for_review: "Your organization's app has been submitted for review.",
          released: "Your organization's app is live.",
          removed: "Your organization's app has been removed."
        }[app.status] || '';
      }

      return '';
    }
  }, {
    key: "allAppleTVFieldsSet",
    value: function allAppleTVFieldsSet() {
      return hasAllFieldsSet(this.appleTVApp, ['apple_developer_account_name', 'name', 'subtitle', 'category', 'promotional_text', 'keywords', 'description', 'app_icon_background_layer', 'app_icon_foreground_layer', 'app_icon_small_background_layer_2x', 'app_icon_small_foreground_layer_2x', 'launch_image', 'top_shelf_image_2x', 'top_shelf_wide_image_2x']);
    }
  }, {
    key: "updateAppleTVAppReadyToSubmit",
    value: function updateAppleTVAppReadyToSubmit() {
      if (this.appleTVApp) {
        this.appleTVApp._ready_to_submit = this.allAppleTVFieldsSet() && !this.needPublicRecordedBroadcasts;
      }
    }
  }, {
    key: "allRokuFieldsSet",
    value: function allRokuFieldsSet() {
      return hasAllFieldsSet(this.rokuApp, ['roku_developer_account_name', 'channel_name', 'channel_description', 'web_description', 'category', 'more_information_url', 'splash_screen_fhd', 'splash_screen_hd', 'splash_screen_sd', 'channel_store_icon_fhd', 'channel_store_icon_large', 'channel_store_icon_small', 'logo', 'icon']);
    }
  }, {
    key: "updateRokuAppReadyToSubmit",
    value: function updateRokuAppReadyToSubmit() {
      if (this.rokuApp) {
        this.rokuApp._ready_to_submit = this.allRokuFieldsSet() && !this.needPublicRecordedBroadcasts;
      }
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this = this;

      this.account = this.Account.get();
      var appleTVPromise = this.AppleTvApp.query({
        s: '-created_at',
        l: 1
      }).$promise.then(function (result) {
        if (result && result.length) {
          _this.appleTVApp = _this.AppleTvApp.get({
            id: result[0].id
          });
          return _this.appleTVApp.$promise;
        }
      }).then(function () {
        _this.updateAppleTVAppReadyToSubmit();

        delete _this._appleTVImageList;
      });
      var rokuPromise = this.RokuApp.query({
        s: '-created_at',
        l: 1
      }).$promise.then(function (result) {
        if (result && result.length) {
          _this.rokuApp = _this.RokuApp.get({
            id: result[0].id
          });
          return _this.rokuApp.$promise;
        }
      }).then(function () {
        _this.updateRokuAppReadyToSubmit();

        delete _this._rokuImageList;
      }); // Keep track of loading state of AJAX requests

      this.loadingPromises = [this.account.$promise, appleTVPromise, rokuPromise]; // After we get the apple tv and roku apps, check to see if we need to look for public, recorded broadcasts

      this.needPublicRecordedBroadcasts = false;
      this.$q.all([appleTVPromise, rokuPromise]).then(function () {
        // We only need to check for public, recorded broadcasts if at least one app exists and is waiting_on_customer.
        var needsBroadcastQuery = false;

        if (_this.rokuApp && _this.rokuApp.status == 'waiting_on_customer' || _this.appleTVApp && _this.appleTVApp.status == 'waiting_on_customer') {
          needsBroadcastQuery = true;
        }

        if (!needsBroadcastQuery) {
          return;
        } // If we get here, we need to go check for public, recorded broadcasts


        _this.needPublicRecordedBroadcasts = true;

        _this.updateAppleTVAppReadyToSubmit();

        _this.updateRokuAppReadyToSubmit();

        _this.loadingPromises.push(_this.Broadcast.query({
          'filter.exclude_past_live_only': true,
          q: "timeframe:past",
          l: 1000,
          s: "-starts_at"
        }, function (broadcasts) {
          return _.find(broadcasts, function (b) {
            if (!b.is_private && !b.is_ticketed && b.recording_duration_seconds > 0) {
              _this.needPublicRecordedBroadcasts = false;

              _this.updateAppleTVAppReadyToSubmit();

              _this.updateRokuAppReadyToSubmit();

              return true;
            }

            return false;
          });
        }, function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to find recorded broadcasts.');
        }).$promise);
      });
    }
  }, {
    key: "submitToBoxCast",
    value: function submitToBoxCast(type, app) {
      var _this2 = this;

      var RokuApp = this.RokuApp,
          AppleTvApp = this.AppleTvApp,
          toaster = this.toaster;

      if (type == 'roku') {
        this.rokuApp._submitting = true;
        RokuApp.update({
          id: app.id,
          status: 'submitted_to_boxcast'
        }, function (app) {
          _this2.rokuApp = app;
        }, function (err) {
          console.error(err);
          _this2.rokuApp._submitting = false;
          toaster.pop('warning', 'Unable to submit app. Please confirm all fields have been filed out and try again.');
        });
      } else if (type == 'appletv') {
        this.appleTVApp._submitting = true;
        AppleTvApp.update({
          id: app.id,
          status: 'submitted_to_boxcast'
        }, function (app) {
          _this2.appleTVApp = app;
        }, function (err) {
          console.error(err);
          _this2.appleTVApp._submitting = false;
          toaster.pop('warning', 'Unable to submit app. Please confirm all fields have been filed out and try again.');
        });
      } else {
        console.error('Unknown submission type: ', type, app);
      }
    }
  }, {
    key: "showEditAppearanceModal",
    value: function showEditAppearanceModal() {
      var $uibModal = this.$uibModal;

      var _parentVM = this;

      $uibModal.open({
        template: __webpack_require__(500),
        controller: __webpack_require__(501)["default"],
        controllerAs: 'vm',
        resolve: {
          parentVM: function parentVM() {
            return _parentVM;
          }
        },
        //  Prevent accidental close...
        keyboard: false,
        backdrop: 'static'
      });
    }
  }, {
    key: "showEditRokuModal",
    value: function showEditRokuModal() {
      var $uibModal = this.$uibModal;

      var _parentVM2 = this;

      $uibModal.open({
        template: __webpack_require__(502),
        controller: ModalEditRokuController,
        controllerAs: 'vm',
        resolve: {
          parentVM: function parentVM() {
            return _parentVM2;
          }
        },
        size: 'lg',
        //  Prevent accidental close...
        keyboard: false,
        backdrop: 'static'
      });
    }
  }, {
    key: "showEditAppleTVModal",
    value: function showEditAppleTVModal() {
      var $uibModal = this.$uibModal;

      var _parentVM3 = this;

      $uibModal.open({
        template: __webpack_require__(503),
        controller: ModalEditAppleTVController,
        controllerAs: 'vm',
        resolve: {
          parentVM: function parentVM() {
            return _parentVM3;
          }
        },
        size: 'lg',
        //  Prevent accidental close...
        keyboard: false,
        backdrop: 'static'
      });
    }
  }]);

  return SettingsAppearanceController;
}();



function ModalEditRokuController(parentVM, $uibModalInstance, $rootScope, RokuApp, toaster) {
  'ngInject';

  var _this3 = this;

  this.app = angular.copy(parentVM.rokuApp);
  this.images = angular.copy(parentVM.rokuImageList());
  this.categories = ROKU_CATEGORIES;
  var account = parentVM.account;
  this.app.channel_name = this.app.channel_name || account.content_settings.display_name || account.name;
  this.app.channel_description = this.app.channel_description || account.content_settings.description;
  this.app.web_description = this.app.web_description || account.content_settings.description;
  this.app.more_information_url = this.app.more_information_url || account.content_settings.website;
  this.app.end_user_support_contact = this.app.end_user_support_contact || 'questions@boxcast.com';
  var defaultCategory = account.market === 'house-of-worship' ? 'Faith-Based' : 'Special Interest';
  this.app.category = this.app.category || defaultCategory;
  this.uploads = {};
  this.files = {};
  this.images.forEach(function (img) {
    _this3.uploads[img.id] = null;
    _this3.files[img.id] = null;
  });
  this.limits = $rootScope.ApiConfig.modelFieldLimits('roku_app', 'maximum');

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.onChangeImage = function (img) {
    img.src = '';
    _this3.app[img.id] = '';
    _this3.uploads[img.id] = null;
    _this3.files[img.id] = null;
  };

  this.onLoadImage = function (img, $event) {
    _this3.uploads[img.id] = {
      naturalWidth: $event.target.naturalWidth,
      naturalHeight: $event.target.naturalHeight
    };
  };

  this.uploadInto = function (img, file) {
    file.upload().then(function (response) {
      img.src = response.view_url;
      _this3.app[img.id] = response.view_url;
    });
  };

  this.update = function () {
    _this3.showError = false;
    _this3.saving = true;
    var appUpdate = angular.copy(_this3.app);
    delete appUpdate.status;
    RokuApp.update(appUpdate, function (app) {
      parentVM.refresh();

      _this3.cancel();
    }, function (err) {
      _this3.saving = false;
      console.error(err);
      toaster.pop('warning', 'There was an error saving your app submission. Please try again.');
    });
  };
}

function ModalEditAppleTVController(parentVM, $uibModalInstance, $rootScope, AppleTvApp, toaster) {
  'ngInject';

  var _this4 = this;

  this.app = angular.copy(parentVM.appleTVApp);
  this.images = angular.copy(parentVM.appleTVImageList());
  this.categories = APPLE_CATEGORIES;
  var account = parentVM.account;
  this.app.name = this.app.name || account.content_settings.display_name || account.name;
  this.app.description = this.app.description || account.content_settings.description;
  this.app.marketing_url = this.app.marketing_url || account.content_settings.website;
  this.app.support_url = this.app.support_url || 'https://support.boxcast.com';
  this.app.category = this.app.category || 'Lifestyle';
  this.uploads = {};
  this.files = {};
  this.images.forEach(function (img) {
    _this4.uploads[img.id] = null;
    _this4.files[img.id] = null;
  });
  this.limits = $rootScope.ApiConfig.modelFieldLimits('apple_tv_app', 'maximum');

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.onChangeImage = function (img) {
    img.src = '';
    _this4.app[img.id] = '';
    _this4.uploads[img.id] = null;
    _this4.files[img.id] = null;
  };

  this.onLoadImage = function (img, $event) {
    _this4.uploads[img.id] = {
      naturalWidth: $event.target.naturalWidth,
      naturalHeight: $event.target.naturalHeight
    };
  };

  this.uploadInto = function (img, file) {
    file.upload().then(function (response) {
      img.src = response.view_url;
      _this4.app[img.id] = response.view_url;
    });
  };

  var resizeURL = function resizeURL(origURL, w, h) {
    return "https://images.weserv.nl/?url=".concat(encodeURIComponent(origURL), "&w=").concat(w, "&h=").concat(h, "&fit=fill");
  };

  var shapeUpdateParams = function shapeUpdateParams(app) {
    // Make a copy to not mutate the original object
    var ret = angular.copy(_this4.app); // Don't post the status, which isn't changing

    delete ret.status; // Fill in resize URLs for 1x versions of 2x images

    if (ret.top_shelf_image_2x) {
      ret.top_shelf_image = resizeURL(ret.top_shelf_image_2x, 1920, 720);
    }

    if (ret.top_shelf_wide_image_2x) {
      ret.top_shelf_wide_image = resizeURL(ret.top_shelf_wide_image_2x, 2320, 720);
    }

    if (ret.app_icon_small_background_layer_2x) {
      ret.app_icon_small_background_layer = resizeURL(ret.app_icon_small_background_layer_2x, 400, 240);
    }

    if (ret.app_icon_small_foreground_layer_2x) {
      ret.app_icon_small_foreground_layer = resizeURL(ret.app_icon_small_foreground_layer_2x, 400, 240);
    }

    return ret;
  };

  this.update = function () {
    _this4.showError = false;
    _this4.saving = true;
    AppleTvApp.update(shapeUpdateParams(_this4.app), function (app) {
      parentVM.refresh();

      _this4.cancel();
    }, function (err) {
      _this4.saving = false;
      console.error(err);
      toaster.pop('warning', 'There was an error saving your app submission. Please try again.');
    });
  };
}

function hasAllFieldsSet(app, fields) {
  var missingAny = false;
  fields.forEach(function (k) {
    return missingAny = missingAny || !app[k].trim();
  });
  return !missingAny;
}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Edit Appearance Settings</h3>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\">\n\n    <div ng-if=\"vm.showError\" class=\"col-xs-12\">\n      <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n        Please fill out all required fields before submitting.\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n\n      <div ng-if=\"::!vm.FeatureFlags.appletv_roku\">\n        <p class=\"help-block text-center\" style=\"margin:15px\">\n        Your account is not currently eligible to show in the BoxCast Apps (Roku, Apple TV, Amazon Fire TV).<br>\n          <upgrade-button ng-click=\"vm.cancel()\"></upgrade-button>\n        </p>\n      </div><!--/appletv-tease-->\n      <div ng-if=\"::vm.FeatureFlags.appletv_roku\">\n        <div ng-click=\"vm.onShowInAppsClick()\" class=\"checkbox\" style=\"cursor:pointer\">\n          <i class=\"fa\" ng-class=\"vm.account.enable_public_discovery ? 'fa-check-square-o' : 'fa-square-o'\" style=\"width:20px\"></i>\n          Show My Account Channel in the BoxCast Apps (Roku, Apple TV, Amazon Fire TV)\n        </div>\n        <div ng-if=\"vm.showPublicAppSettingsWarning()\">\n          <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin:15px 0\">\n            Before enabling, please ensure your poster images are uploaded below.\n          </div>\n        </div>\n      </div><!--/ appletv-->\n\n      <div class=\"form-group\">\n        <label>Brand Color</label>\n        <boxcast-color-picker ng-model=\"vm.content_settings.color\" default-color=\"#FFFFFF\"></boxcast-color-picker>\n      </div>\n\n      <div class=\"row\">\n\n        <div class=\"form-group col-sm-6\">\n          <label>Profile Image<br><small style=\"font-weight:normal\">(400px &times; 400px, PNG or JPG, under 200kb in size)</small></label>\n          <div ng-if=\"vm.profile_img && (vm.profile_img.naturalWidth != 400 || vm.profile_img.naturalHeight != 400)\">\n            <div class=\"label label-warning\" style=\"display:inline-block;margin-bottom:10px\">\n              Logo is {{vm.profile_img.naturalWidth}}x{{vm.profile_img.naturalHeight}} but should be 400x400\n            </div>\n          </div>\n          <button ng-if=\"vm.content_settings.profile_img\" class=\"btn btn-xs btn-default\" ng-click=\"vm.onChangeImage('profile_img')\">Change</button>\n        </div>\n        <div class=\"form-group col-sm-6\">\n          <div ng-if=\"vm.content_settings.profile_img\" class=\"text-center\">\n            <div class=\"fixed-16-9\" style=\"background:#fff\">\n              <div style=\"width:56.25%;margin:0 21.875%;\">\n                <div class=\"fixed-square transparent-grid-bg\" style=\"color:#ccc;\">\n                  <div style=\"background-image:url(&quot;{{vm.content_settings.profile_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n                  <img ng-src=\"{{vm.content_settings.profile_img | trustedUrl}}\"\n                      ng-onload=\"vm.onLoadImage('profile_img', $event)\"\n                      style=\"width:0;height:0;opacity:0;\">\n                </div>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"!vm.content_settings.profile_img\">\n            <upload-slot ng-model=\"vm.profileImgFile\"\n                          ng-change=\"vm.uploadIntoCS('profile_img', vm.profileImgFile)\"\n                          slot-name=\"'app-assets'\"\n                          allow-image=\"true\"\n                          allow-video=\"false\"\n                          compact=\"true\"></upload-slot>\n          </div>\n        </div>\n\n        <div class=\"form-group col-sm-6\">\n          <label>Account Poster (Large)<br><small style=\"font-weight:normal\">Used on Apple TV and Fire TV apps<br>(1280px &times; 720px, PNG or JPG, under 300kb in size)</small></label>\n          <div ng-if=\"vm.logo_img && (vm.logo_img.naturalWidth != 1280 || vm.logo_img.naturalHeight != 720)\">\n            <div class=\"label label-warning\" style=\"display:inline-block;margin-bottom:10px\">\n              Logo is {{vm.logo_img.naturalWidth}}x{{vm.logo_img.naturalHeight}} but should be 1280x720\n            </div>\n          </div>\n          <button ng-if=\"vm.content_settings.logo_img\" class=\"btn btn-xs btn-default\" ng-click=\"vm.onChangeImage('logo_img')\">Change</button>\n        </div>\n        <div class=\"form-group col-sm-6\">\n          <div ng-if=\"vm.content_settings.logo_img\" class=\"text-center\">\n            <div class=\"fixed-16-9 transparent-grid-bg\" style=\"color:#ccc;\">\n              <div style=\"background-image:url(&quot;{{vm.content_settings.logo_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n              <img ng-src=\"{{vm.content_settings.logo_img | trustedUrl}}\"\n                   ng-onload=\"vm.onLoadImage('logo_img', $event)\"\n                   style=\"width:0;height:0;opacity:0;\">\n            </div>\n          </div>\n          <div ng-if=\"!vm.content_settings.logo_img\">\n            <upload-slot ng-model=\"vm.appLogoFile\"\n                          ng-change=\"vm.uploadIntoCS('logo_img', vm.appLogoFile)\"\n                          slot-name=\"'app-assets'\"\n                          allow-image=\"true\"\n                          allow-video=\"false\"\n                          compact=\"true\"></upload-slot>\n          </div>\n        </div>\n\n        <div class=\"form-group col-sm-6\">\n          <label>Account Poster (Small)<br><small style=\"font-weight:normal\">Used in Roku app<br>(300px &times; 169px, PNG or JPG, under 150kb in size)</small></label>\n          <div ng-if=\"vm.thumb_img && (vm.thumb_img.naturalWidth != 300 || vm.thumb_img.naturalHeight != 169)\">\n            <div class=\"label label-warning\" style=\"display:inline-block;margin-bottom:10px\">\n              Logo is {{vm.thumb_img.naturalWidth}}x{{vm.thumb_img.naturalHeight}} but should be 300x169\n            </div>\n          </div>\n          <button ng-if=\"vm.content_settings.thumb_img\" class=\"btn btn-xs btn-default\" ng-click=\"vm.onChangeImage('thumb_img')\">Change</button>\n        </div>\n        <div class=\"form-group col-sm-6\">\n          <div ng-if=\"vm.content_settings.thumb_img\" class=\"text-center\">\n            <div class=\"fixed-16-9 transparent-grid-bg\" style=\"color:#ccc;\">\n              <div style=\"background-image:url(&quot;{{vm.content_settings.thumb_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n              <img ng-src=\"{{vm.content_settings.thumb_img | trustedUrl}}\"\n                   ng-onload=\"vm.onLoadImage('thumb_img', $event)\"\n                   style=\"width:0;height:0;opacity:0;\">\n            </div>\n          </div>\n          <div ng-if=\"!vm.content_settings.thumb_img\">\n            <upload-slot ng-model=\"vm.appThumbFile\"\n                          ng-change=\"vm.uploadIntoCS('thumb_img', vm.appThumbFile)\"\n                          slot-name=\"'app-assets'\"\n                          allow-image=\"true\"\n                          allow-video=\"false\"\n                          compact=\"true\"></upload-slot>\n          </div>\n        </div>\n\n      </div>\n\n    </div>\n\n  </div>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n    <button ng-disabled=\"vm.saving\"\n            ng-click=\"vm.update()\"\n            class=\"btn btn-primary\">\n      <i ng-show=\"vm.saving\" class=\"fa fa-spin fa-spinner\"></i>\n      Update Settings\n    </button>\n</div>\n"

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalEditContentSettingsController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_content_settings__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_password__ = __webpack_require__(41);


function ModalEditContentSettingsController($uibModal, $uibModalInstance, $cacheFactory, $rootScope, Account, $httpParamSerializer, $sce, toaster, parentVM) {
  'ngInject';

  var _this = this;

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this.account = angular.copy(parentVM.account);
  this.FeatureFlags = parentVM.FeatureFlags;
  this.activeTab = '';
  this.content_settings = this.account.content_settings;
  this.showPoster = this.content_settings.poster;
  this.showPreroll = this.content_settings.customPreroll;

  this.onLoadImage = function (which, $event) {
    _this[which] = $event.target;
  };

  this.onChangeImage = function (which) {
    _this.content_settings[which] = null;
    _this[which] = null;
  };

  this.onShowInAppsClick = function () {
    _this.account.enable_public_discovery = !_this.account.enable_public_discovery;

    if (_this.account.enable_public_discovery && !_this.content_settings.display_name) {
      _this.content_settings.display_name = _this.account.name;
    }
  };

  this.uploadIntoCS = function (key, file) {
    file.upload().then(function (response) {
      console.log(response);

      if (key.indexOf('.') >= 0) {
        setValue(key, response.view_url, _this.content_settings);
      } else {
        _this.content_settings[key] = response.view_url;
      }
    });
  };

  this.showPublicAppSettingsWarning = function () {
    if (!_this.account.enable_public_discovery) {
      return false;
    } else {
      return !(_this.content_settings.thumb_img && _this.content_settings.logo_img);
    }
  };

  this.enterpriseLastMileDelivery = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_content_settings__["a" /* enterpriseLastMileDelivery */])(_this.account);
  };

  this.update = function () {
    _this.showError = false;
    _this.saving = true;
    var data = angular.copy(_this.content_settings); // Remove as many keys as we can to keep the payload small when sent to the player

    if (!_.trim(data.donateMessage)) delete data.donateMessage;
    if (!_this.showPoster) delete data.poster;
    if (!_this.showPreroll) delete data.customPreroll;
    if (!data.hide_linkback) delete data.hide_linkback; // If they set up the app, make sure we don't have a null thumb/image

    var enablePublicDiscovery = _this.account.enable_public_discovery;

    if (enablePublicDiscovery && !(data.thumb_img && data.logo_img)) {
      _this.showError = true;
      _this.saving = false;
      toaster.pop('warning', 'Please fill in all BoxCast App Settings fields, including logos.');
      return false;
    } // Look at possible password changes.


    Object(__WEBPACK_IMPORTED_MODULE_1__utils_password__["a" /* checkContentSettingsForChangesOnSave */])(data);
    Account.update({
      content_settings: data,
      enable_public_discovery: enablePublicDiscovery
    }, function (account) {
      // Invalidate cache
      $cacheFactory.get('$http').remove("".concat(API_ROOT, "/account"));
      $rootScope.account = account;
      parentVM.refresh();

      _this.cancel();
    }, function () {
      _this.saving = false;
      alert('There was an error trying to save the settings. Please try again.');
    });
  };
}

function setValue(path, val, obj) {
  var fields = path.split('.');
  var result = obj;

  for (var i = 0, n = fields.length; i < n && result !== undefined; i++) {
    var field = fields[i];

    if (i === n - 1) {
      result[field] = val;
    } else {
      if (typeof result[field] === 'undefined' || !_.isObject(result[field])) {
        result[field] = {};
      }

      result = result[field];
    }
  }
}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3>Edit Roku Channel Store Information</h3>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\">\n    <div ng-if=\"vm.showError\" class=\"col-xs-12\">\n      <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n        Please fill out all required fields before submitting.\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"bg-info text-info\" style=\"padding:15px;margin-bottom:15px;border-radius:4px;\">\n        Need help filling out these fields? Check out our <a href=\"https://support.boxcast.com/en/articles/4550679-branded-app-fulfillment-process\" target=\"_blank\">support article <i class=\"fa fa-external-link\"></i></a> to get started.\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"form-group\">\n        <label for=\"channel_name\">Channel Name <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"channel_name\" name=\"channel_name\" ng-model=\"vm.app.channel_name\" ng-maxlength=\"::vm.limits.channel_name\" required>\n        <p class=\"help-block\"><small>This channel name must be globally unique across all Roku apps. If there is a conflict, we will need to work with you when submitting the app to find a new unique name.</small></p>\n        <p ng-show=\"(form.channel_name.$dirty || form.channel_name.$touched) && !vm.app.channel_name\">\n        <span class=\"text-danger\" ng-if=\"form.channel_name.$error.maxlength\">The Channel Name is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.channel_name.$error.required\">The Channel Name cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"category\">Preferred Category <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <select class=\"form-control\" ng-model=\"vm.app.category\">\n          <option ng-repeat=\"c in vm.categories\">{{c}}</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"channel_description\">Channel Description ({{ ::vm.limits.channel_description }} character max)<i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <textarea class=\"form-control\" id=\"channel_description\" name=\"channel_description\" ng-model=\"vm.app.channel_description\" ng-maxlength=\"::vm.limits.channel_description\" required></textarea>\n        <p ng-show=\"(form.channel_description.$dirty || form.channel_description.$touched) && !vm.app.channel_description\">\n        <span class=\"text-danger\" ng-if=\"form.channel_description.$error.maxlength\">The Channel Description is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.channel_description.$error.required\">The Channel Description cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"more_information_url\">Preferred URL for More Information <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"more_information_url\" name=\"more_information_url\" ng-model=\"vm.app.more_information_url\" ng-maxlength=\"::vm.limits.more_information_url\" required>\n        <p ng-show=\"(form.more_information_url.$dirty || form.more_information_url.$touched) && !vm.app.more_information_url\">\n        <span class=\"text-danger\" ng-if=\"form.more_information_url.$error.maxlength\">The URL is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.more_information_url.$error.required\">The URL cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"end_user_support_contact\">End User Support Contact <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"end_user_support_contact\" name=\"end_user_support_contact\" ng-model=\"vm.app.end_user_support_contact\" ng-maxlength=\"::vm.limits.end_user_support_contact\" required>\n        <p ng-show=\"(form.end_user_support_contact.$dirty || form.end_user_support_contact.$touched) && !vm.app.end_user_support_contact\">\n        <span class=\"text-danger\" ng-if=\"form.end_user_support_contact.$error.maxlength\">The Email is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.end_user_support_contact.$error.required\">The Email cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"web_description\">Web Description ({{ ::vm.limits.web_description }} character max) <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <textarea class=\"form-control\" id=\"web_description\" name=\"web_description\" ng-model=\"vm.app.web_description\" ng-maxlength=\"::vm.limits.web_description\" required></textarea>\n        <p ng-show=\"(form.web_description.$dirty || form.web_description.$touched) && !vm.app.web_description\">\n        <span class=\"text-danger\" ng-if=\"form.web_description.$error.maxlength\">The Description is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.web_description.$error.required\">The Description cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"app_background_color\">App Background Color <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <boxcast-color-picker ng-model=\"vm.app.app_background_color\" default-color=\"#FFFFFF\"></boxcast-color-picker>\n        </p>\n      </div>\n    </div>\n\n    <div ng-repeat=\"img in vm.images\" class=\"clearfix\">\n      <div class=\"form-group col-md-6\">\n        <label>{{img.name}}<br><small style=\"font-weight:normal\">(<span ng-if=\"img.w && img.h\">{{img.w}}px &times; {{img.h}}px, </span>PNG or JPG, under 2MB in size)</small></label>\n        <div ng-if=\"!img.noValidate && vm.uploads[img.id] && (vm.uploads[img.id].naturalWidth != img.w || vm.uploads[img.id].naturalHeight != img.h)\">\n          <div class=\"label label-warning\" style=\"display:inline-block;margin-bottom:10px\">\n            Image is {{vm.uploads[img.id].naturalWidth}}x{{vm.uploads[img.id].naturalHeight}} but should be {{img.w}}x{{img.h}}\n          </div>\n        </div>\n        <button ng-if=\"img.src\" class=\"btn btn-xs btn-default\" ng-click=\"vm.onChangeImage(img)\">Change</button>\n      </div>\n      <div class=\"form-group col-md-6\">\n        <div ng-if=\"img.src\" class=\"text-center\">\n          <fixed-image-preview src=\"img.src\" height=\"img.preview_h\" width=\"img.preview_w\" on-load=\"vm.onLoadImage(img, $event)\"></fixed-image-preview>\n        </div>\n        <div ng-if=\"!img.src\">\n          <upload-slot ng-model=\"vm.files[img.id]\"\n                       ng-change=\"vm.uploadInto(img, vm.files[img.id])\"\n                       slot-name=\"'app-assets'\"\n                       allow-image=\"true\"\n                       allow-video=\"false\"\n                       compact=\"true\"></upload-slot>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n  <button ng-disabled=\"vm.saving || form.$invalid\"\n          ng-click=\"vm.update()\"\n          class=\"btn btn-primary\">\n    <i ng-show=\"vm.saving\" class=\"fa fa-spin fa-spinner\"></i>\n    Update Settings\n  </button>\n</div>\n</form>\n"

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3>Edit Apple TV App Store Information</h3>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\">\n    <div ng-if=\"vm.showError\" class=\"col-xs-12\">\n      <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n        Please fill out all required fields before submitting.\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"bg-info text-info\" style=\"padding:15px;margin-bottom:15px;border-radius:4px;\">\n        Need help filling out these fields? Check out our <a href=\"https://support.boxcast.com/en/articles/4550679-branded-app-fulfillment-process\" target=\"_blank\">support article <i class=\"fa fa-external-link\"></i></a> to get started.\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\">\n      <div class=\"form-group\">\n        <label for=\"name\">Name in the App Store <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" ng-model=\"vm.app.name\" ng-maxlength=\"::vm.limits.name\" required>\n        <p class=\"help-block\"><small>This name must be globally unique across all Apple apps. If there is a conflict, we will need to work with you when submitting the app to find a new unique name.</small></p>\n        <p ng-show=\"(form.name.$dirty || form.name.$touched) && !vm.app.name\">\n        <span class=\"text-danger\" ng-if=\"form.name.$error.maxlength\">The Name is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.name.$error.required\">The Name cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"category\">Category <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <select class=\"form-control\" ng-model=\"vm.app.category\">\n          <option ng-repeat=\"c in vm.categories\">{{c}}</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"keywords\">Keywords <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"keywords\" name=\"keywords\" ng-model=\"vm.app.keywords\" ng-maxlength=\"::vm.limits.keywords\" required>\n        <p ng-show=\"(form.keywords.$dirty || form.keywords.$touched) && !vm.app.keywords\">\n        <span class=\"text-danger\" ng-if=\"form.keywords.$error.maxlength\">The Keywords are too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.keywords.$error.required\">The Keywords cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"subtitle\">Subtitle <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"subtitle\" name=\"subtitle\" ng-model=\"vm.app.subtitle\" ng-maxlength=\"::vm.limits.subtitle\" required>\n        <p ng-show=\"(form.subtitle.$dirty || form.subtitle.$touched) && !vm.app.subtitle\">\n        <span class=\"text-danger\" ng-if=\"form.subtitle.$error.maxlength\">The Subtitle is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.subtitle.$error.required\">The Subtitle cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"promotional_text\">Promotional Text <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"promotional_text\" name=\"promotional_text\" ng-model=\"vm.app.promotional_text\" ng-maxlength=\"::vm.limits.promotional_text\" required>\n        <p ng-show=\"(form.promotional_text.$dirty || form.promotional_text.$touched) && !vm.app.promotional_text\">\n        <span class=\"text-danger\" ng-if=\"form.promotional_text.$error.maxlength\">The Promotional Text is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.promotional_text.$error.required\">The Promotional Text cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"description\">Description <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <textarea class=\"form-control\" id=\"description\" name=\"description\" ng-model=\"vm.app.description\" ng-maxlength=\"::vm.limits.description\" required></textarea>\n        <p ng-show=\"(form.description.$dirty || form.description.$touched) && !vm.app.description\">\n        <span class=\"text-danger\" ng-if=\"form.description.$error.maxlength\">The Description is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.description.$error.required\">The Description cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"support_url\">Support URL <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"support_url\" name=\"support_url\" ng-model=\"vm.app.support_url\" ng-maxlength=\"::vm.limits.support_url\" required>\n        <p ng-show=\"(form.support_url.$dirty || form.support_url.$touched) && !vm.app.support_url\">\n        <span class=\"text-danger\" ng-if=\"form.support_url.$error.maxlength\">The URL is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.support_url.$error.required\">The URL cannot be blank.</span>\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"marketing_url\">Marketing URL <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n        <input type=\"text\" class=\"form-control\" id=\"marketing_url\" name=\"marketing_url\" ng-model=\"vm.app.marketing_url\" ng-maxlength=\"::vm.limits.marketing_url\" required>\n        <p ng-show=\"(form.marketing_url.$dirty || form.marketing_url.$touched) && !vm.app.marketing_url\">\n        <span class=\"text-danger\" ng-if=\"form.marketing_url.$error.maxlength\">The URL is too long.</span>\n        <span class=\"text-danger\" ng-if=\"form.marketing_url.$error.required\">The URL cannot be blank.</span>\n        </p>\n      </div>\n    </div>\n\n    <div ng-repeat=\"img in vm.images\" class=\"clearfix\">\n      <div class=\"form-group col-md-6\">\n        <label>{{img.name}}<br><small style=\"font-weight:normal\">({{img.w}}px &times; {{img.h}}px, PNG or JPG, under 2MB in size)</small></label>\n        <div ng-if=\"!img.noValidate && vm.uploads[img.id] && (vm.uploads[img.id].naturalWidth != img.w || vm.uploads[img.id].naturalHeight != img.h)\">\n          <div class=\"label label-warning\" style=\"display:inline-block;margin-bottom:10px\">\n            Image is {{vm.uploads[img.id].naturalWidth}}x{{vm.uploads[img.id].naturalHeight}} but should be {{img.w}}x{{img.h}}\n          </div>\n        </div>\n        <button ng-if=\"img.src\" class=\"btn btn-xs btn-default\" ng-click=\"vm.onChangeImage(img)\">Change</button>\n      </div>\n      <div class=\"form-group col-md-6\">\n        <div ng-if=\"img.src\" class=\"text-center\">\n          <fixed-image-preview src=\"img.src\" height=\"img.preview_h\" width=\"img.preview_w\" on-load=\"vm.onLoadImage(img, $event)\"></fixed-image-preview>\n        </div>\n        <div ng-if=\"!img.src\">\n          <upload-slot ng-model=\"vm.files[img.id]\"\n                       ng-change=\"vm.uploadInto(img, vm.files[img.id])\"\n                       slot-name=\"'app-assets'\"\n                       allow-image=\"true\"\n                       allow-video=\"false\"\n                       compact=\"true\"></upload-slot>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n  <button ng-disabled=\"vm.saving || form.$invalid\"\n          ng-click=\"vm.update()\"\n          class=\"btn btn-primary\">\n    <i ng-show=\"vm.saving\" class=\"fa fa-spin fa-spinner\"></i>\n    Update Settings\n  </button>\n</div>\n</form>\n\n"

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WifiConfigurationService; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var WifiConfigurationService = /*#__PURE__*/function () {
  function WifiConfigurationService($q, BoxCaster, $timeout) {
    'ngInject';

    _classCallCheck(this, WifiConfigurationService);

    this.$q = $q;
    this.BoxCaster = BoxCaster;
    this.$timeout = $timeout;
  }

  _createClass(WifiConfigurationService, [{
    key: "getConfig",
    value: function getConfig(boxcasterId) {
      var _this = this;

      // Returns a promise that is fullfilled when the result of the
      // `get_wifi_config` RPC completes.
      var BoxCaster = this.BoxCaster,
          $timeout = this.$timeout,
          $q = this.$q;
      var deferred = $q.defer();
      var startTime = new Date().getTime();
      var pollingId = null;
      var wifiConfig = null;

      var handleResult = function handleResult() {
        if (wifiConfig.response && !wifiConfig.error) {
          deferred.resolve(_this.mungeApiResponse(wifiConfig.response));
        } else if (wifiConfig.error) {
          deferred.reject(wifiConfig.response);
        } else if (new Date().getTime() - startTime > WIFI_POLL_TIMEOUT_MS) {
          deferred.reject('timeout');

          _this.destroy();
        } else {
          _this.timeoutHandle = $timeout(poll, WIFI_POLL_INTERVAL_MS);
        }
      };

      var poll = function poll() {
        if (!pollingId) {
          // Start the RPC
          wifiConfig = BoxCaster.postRPC({
            id: boxcasterId
          }, {
            request: 'get_wifi_config'
          }, function () {
            pollingId = wifiConfig.id;
            handleResult();
          }, function () {
            return deferred.reject('Unable to get Wi-Fi config');
          });
        } else {
          // Check status of existing RPC call to get wireless networks
          wifiConfig = BoxCaster.getRPC({
            id: boxcasterId,
            rpcId: pollingId
          }, function () {
            return handleResult();
          }, function () {
            return deferred.reject('Unable to get Wi-Fi config');
          });
        }
      };

      this.destroy = function () {
        console.log('Destroying the old RPC call');

        _this.$timeout.cancel(_this.timeoutHandle);

        BoxCaster.deleteRPC({
          id: boxcasterId,
          rpcId: pollingId
        });
      };

      poll();
      return deferred.promise;
    }
  }, {
    key: "setConfig",
    value: function setConfig(boxcasterId, config) {
      var _this2 = this;

      // Returns a promise that is fullfilled when the result of the
      // `set_wifi_config` RPC completes.
      var BoxCaster = this.BoxCaster,
          $timeout = this.$timeout,
          $q = this.$q;
      var deferred = $q.defer();
      var pollingId = null;
      var wifiConfig = null;

      var handleResult = function handleResult() {
        if (wifiConfig.response && !wifiConfig.error) {
          deferred.resolve(wifiConfig.response);
        } else if (wifiConfig.error) {
          deferred.reject(wifiConfig.response);
        } else {
          _this2.timeoutHandle = $timeout(poll, WIFI_POLL_INTERVAL_MS);
        }
      };

      var poll = function poll() {
        if (!pollingId) {
          // Start the RPC
          wifiConfig = BoxCaster.postRPC({
            id: boxcasterId
          }, {
            request: {
              message: 'set_wifi_config',
              config: config
            }
          }, function () {
            pollingId = wifiConfig.id;
            handleResult();
          }, function () {
            return deferred.reject('Unable to set Wi-Fi config');
          });
        } else {
          // Check status of existing RPC call to get wireless networks
          wifiConfig = BoxCaster.getRPC({
            id: boxcasterId,
            rpcId: pollingId
          }, function () {
            return handleResult();
          }, function () {
            return deferred.reject('Unable to set Wi-Fi config');
          });
        }
      };

      poll();
      return deferred.promise;
    }
  }, {
    key: "mungeApiResponse",
    value: function mungeApiResponse(response) {
      // XXX: looks like Ruby is doing some weird stuff to the RPC result (turning
      // empty arrays to nulls). We'll work around it here to avoid hacking away
      // at the ruby code.
      if (response.current && !response.current.networks) {
        response.current.networks = [];
      }

      if (!response.scan_results) {
        response.scan_results = [];
      }

      return response;
    }
  }]);

  return WifiConfigurationService;
}();



/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerComponents;
function registerComponents(module) {
  // <integration-row-header />
  module.component('integrationRowHeader', {
    controllerAs: 'vm',
    bindings: {
      account: '=',
      onToggleDetails: '&'
    },
    controller: function controller($scope) {
      'ngInject';

      var _this = this;

      this.$onInit = function () {
        $scope.a = _this.account; //shortcut for template
      };

      this.getBroadcastNames = function () {
        return _.pluck(_this.account.details, 'name').join(', ');
      };

      this.showOnline = function () {
        return _this.shouldBeBroadcasting() && !_this.showError();
      };

      this.showOffline = function () {
        return !_this.showError() && !_this.shouldBeBroadcasting();
      };

      this.showError = function () {
        return _this.account.token_is_invalid || _this.account.type === 'youtube' && !_this.account.__isYTLiveEnabled__;
      };

      this.shouldBeBroadcasting = function () {
        return _this.account.details && _this.account.details.length > 0;
      };

      this.isProbablyBroadcastingForReal = function () {
        return _.any(_.pluck(_this.account.details, 'transcoder_profile')) || _.any(_.pluck(_this.account.details, 'stream_source'), function (ss) {
          return ss === 'recording';
        });
      };
    },
    template: "\n      <div class=\"row integration-card-header\" ng-click=\"vm.onToggleDetails(a)\">\n        <div class=\"hidden-xs col-sm-1\" style=\"width:90px\">\n          <span class=\"integration-badge integration-badge--{{a.type}}\">\n            <img src=\"/img/ss-144x144.png\" class=\"icon-image\" ng-if=\"::a.type == 'ss'\">\n            <i class=\"fa fa-facebook\" ng-if=\"::a.type == 'facebook'\"></i>\n            <i class=\"fa fa-youtube-play\" ng-if=\"::a.type == 'youtube'\"></i>\n            <i class=\"fa fa-vimeo\" ng-if=\"::a.type == 'vimeo'\"></i>\n            <i class=\"fa fa-twitter\" ng-if=\"::a.type == 'twitter'\"></i>\n            <span ng-if=\"::a.type == 'rtmp_push'\">RTMP Push</span>\n            <span ng-if=\"::a.type == 'sportzcast'\">SPORTZ CAST</span>\n          </span>\n        </div>\n        <div class=\"col-sm-1\" style=\"width:30px\">\n          <div ng-hide=\"a.hideStatusDot\">\n            <i class=\"fa fa-circle color--online\" ng-if=\"vm.showOnline()\"></i>\n            <i class=\"fa fa-circle color--red\" ng-if=\"vm.showError()\"></i>\n            <i class=\"fa fa-circle color--grey\" ng-if=\"vm.showOffline()\"></i>\n          </div>\n        </div>\n        <div class=\"hidden-xs col-sm-5 text-left\" style=\"flex:1\">\n          <p class=\"overflow-ellipse body-2\" style=\"margin-bottom:0\"><strong>{{a.display_name}}</strong></p>\n          <p class=\"overflow-ellipse\" ng-if=\"a.display_subtitle\" style=\"margin-bottom:0\"><small>{{a.display_subtitle}}</small></p>\n        </div>\n        <div class=\"col-sm-5 text-left\" style=\"flex:1\">\n          <p class=\"visible-xs overflow-ellipse body-2\" style=\"margin-bottom:0\"><strong>{{a.display_name}}</strong></p>\n          <div class=\"overflow-ellipse\">\n            <span ng-if=\"vm.shouldBeBroadcasting()\">\n              <strong class=\"color--green\" ng-show=\"vm.isProbablyBroadcastingForReal()\">Broadcasting</strong>\n              <strong class=\"color--red\" ng-hide=\"vm.isProbablyBroadcastingForReal()\">Not Connected</strong>\n              <br><small>{{vm.getBroadcastNames()}}</small>\n            </span>\n          </div>\n        </div>\n        <div class=\"col-sm-1 text-center\">\n          <i class=\"fa fa-chevron-{{a.__showDetails?'up':'down'}}\"></i>\n        </div>\n      </div>\n    "
  }); // <integration-row-details />

  module.component('integrationRowDetails', {
    controllerAs: 'vm',
    bindings: {
      account: '=',
      onDeleteLink: '&',
      onEditRtmp: '&',
      onDeleteRtmp: '&',
      onRelink: '&',
      onEditSportzcast: '&'
    },
    controller: function controller($scope, $rootScope) {
      'ngInject';

      var _this2 = this;

      this.user = $rootScope.user;

      this.$onInit = function () {
        $scope.a = _this2.account; //shortcut for template
      };

      this.dateValid = function (d) {
        return d && Date.parse(d) != 0;
      };

      this.userCan = function (action, account) {
        switch (account.type) {
          case 'facebook': // fall-through

          case 'twitter': // fall-through

          case 'vimeo': // fall-through

          case 'youtube':
            return _this2.user.can(action, account.type + '-user/*');
            break;

          case 'rtmp_push':
            return _this2.user.can(action, 'static-rtmp-channel/*');
            break;

          default:
            // shrug
            return true;
        }
      };

      this.warningMessage = function () {
        if (_this2.account.token_is_invalid) {
          return _this2.account.token_invalid_reason;
        } else if (_this2.account.type === 'youtube' && !_this2.account.__isYTLiveEnabled__) {
          return 'YouTube Live permission is not set';
        }

        return null;
      };
    },
    template: "\n      <div class=\"row\" style=\"display:block\">\n        <div class=\"col-sm-8\">\n          <table class=\"table table-condensed body-3\">\n            <thead ng-if=\"vm.warningMessage()\">\n              <tr><th colspan=\"2\" class=\"text-xs\">ERROR</th></tr>\n              <tr><td colspan=\"2\">\n                <div class=\"bg-danger text-danger\" style=\"padding:10px;margin:0px 0 10px;border:1px solid\">{{ vm.warningMessage() }}</div>\n              </td></tr>\n            </thead>\n            <tr><th colspan=\"2\" class=\"text-xs\">CONFIGURATION</th></tr>\n            <tr ng-if=\"a.type == 'sportzcast'\"><td>Username</td><td>{{a.username}}</td></tr>\n            <tr ng-if=\"a.type != 'rtmp_push' && a.type != 'ss' && a.type != 'sportzcast'\"><td>Linked</td><td>{{a.created_at | date}}</td></tr>\n            <tr ng-if=\"vm.dateValid(a.token_last_used_at)\"><td>Last Used</td><td>{{a.token_last_used_at | date}}</td></tr>\n            <tr ng-if=\"vm.dateValid(a.token_expires_at)\"><td>Expires</td><td>{{a.token_expires_at | date}}</td></tr>\n\n            <tr ng-if=\"a.type == 'rtmp_push'\"><td>Stream URL</td><td>{{a.stream_url}}</td></tr>\n            <tr ng-if=\"a.type == 'rtmp_push'\"><td>Stream Key</td><td style=\"overflow-wrap: anywhere;\">{{a.stream_key}}</td></tr>\n            <tr ng-if=\"a.type == 'rtmp_push' && a.username\"><td>Username</td><td>{{a.username}}</td></tr>\n            <tr ng-if=\"a.type == 'rtmp_push' && a.password\"><td>Password</td><td><i class=\"fa fa-lock\"></i> \u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022</td></tr>\n            <tr ng-if=\"a.type == 'rtmp_push'\"><td>Max Resolution</td><td>{{a.max_resolution == 0 ? 'None (use highest)' : (a.max_resolution+'p')}}</td></tr>\n          </table>\n          <table ng-if=\"a.type == 'facebook' && a.pages_managed && a.pages_managed.length\" class=\"table table-condensed body-3\">\n            <tr><th class=\"text-xs\">PAGES MANAGED</th></tr>\n            <tr ng-repeat=\"p in a.pages_managed\">\n              <td>\n                {{p.name}}\n                <a href=\"https://www.facebook.com/profile.php?id={{p.id}}\" target=\"_blank\"><i class=\"fa fa-external-link\"></i></a>\n              </td>\n            </tr>\n          </table>\n          <p class=\"help-block\" ng-if=\"a.type == 'youtube'\">\n            <i class=\"fa fa-info-circle\"></i>\n            BoxCast uses YouTube API Services to create and manage your YouTube Live broadcasts.  By using this integration, you are\n            bound to the <a href=\"https://www.youtube.com/t/terms\" target=\"_blank\">YouTube Terms of Service</a>.\n          </p>\n          <p class=\"help-block\" ng-if=\"a.type == 'facebook'\">\n            <i class=\"fa fa-info-circle\"></i>\n            BoxCast uses the Facebook Live API to create and manage your Facebook Live broadcasts. Facebook's Platform Policy requires that\n            you don't put third-party video ads in your live video (for example, don't include bumpers, pre-roll, mid-roll or post-roll).\n            You must also ensure that any pre-recorded content is clearly distinguishable from live content. For more information, see the\n            <a href=\"https://developers.facebook.com/policy/#liveAPI\" target=\"_blank\">Live API section of Facebook's Platform Policy</a>.\n          </p>\n        </div>\n        <div class=\"col-sm-4\">\n          <p class=\"text-center\" ng-repeat=\"broadcast in a.details\">\n            <a class=\"btn btn-default btn-block\" ui-sref=\"events.detail({id: broadcast.id})\">\n              View Current Broadcast\n            </a>\n          </p>\n          <p class=\"text-center\" ng-if=\"a.type == 'rtmp_push'\">\n            <button type=\"button\" class=\"btn btn-default btn-block\" ng-if=\"::vm.userCan('update', a)\" ng-click=\"vm.onEditRtmp(a)\">\n              Edit Settings\n            </button>\n          </p>\n          <p class=\"text-center\" ng-if=\"a.type == 'facebook' || a.type == 'twitter'  || a.type == 'youtube'\">\n            <button type=\"button\" class=\"btn btn-default btn-block\" ng-if=\"::vm.userCan('update', a)\" ng-click=\"vm.onRelink(a)\">\n              Re-link Integration\n            </button>\n          </p>\n          <p class=\"text-center\" ng-if=\"a.type == 'rtmp_push'\">\n            <button type=\"button\" class=\"btn btn-default btn-block\" ng-if=\"::vm.userCan('delete', a)\" ng-click=\"vm.onDeleteRtmp(a)\">\n              Delete RTMP Push Channel\n            </button>\n          </p>\n          <p class=\"text-center\" ng-if=\"a.type != 'rtmp_push' && a.type != 'ss' && a.type != 'sportzcast'\">\n            <button type=\"button\" class=\"btn btn-default btn-block\" ng-if=\"::vm.userCan('delete', a)\" ng-click=\"vm.onDeleteLink(a)\">\n              Delete Link from BoxCast\n            </button>\n          </p>\n          <p class=\"text-center\" ng-if=\"a.type == 'sportzcast'\">\n            <button type=\"button\" class=\"btn btn-default btn-block\" ng-if=\"::vm.userCan('update', a)\" ng-click=\"vm.onEditSportzcast(a)\">\n              Edit Settings\n            </button>\n          </p>\n        </div>\n      </div>\n    "
  });
}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"row\" ng-if=\"$root.account.showOnboarding() && !vm.isStreamMonkey\">\n  <onboarding upcoming-broadcasts=\"{}\" current-broadcasts=\"{}\" past-broadcasts=\"{}\"></onboarding>\n</div>\n\n<div class=\"col-xs-12\">\n  <ol ng-if=\"$root.account.authorized()\" class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li>\n      <a ui-sref=\"settings.my_account\">Account</a>\n    </li>\n    <li>\n      <a ui-sref=\"settings.overview\">Preferences</a>\n    </li>\n    <li ng-if=\"::$root.user.can('list', 'users')\">\n      <a ui-sref=\"settings.users\">Users</a>\n    </li>\n    <li ng-if=\"::(\n                  $root.user.can('list', 'facebook-users') ||\n                  $root.user.can('list', 'twitter-users') ||\n                  $root.user.can('list', 'rtmp-push-channels') ||\n                  $root.user.can('read', 'sportzcast-configuration') ||\n                  $root.user.can('list', 'vimeo-users') ||\n                  $root.user.can('list', 'youtube-users')\n               )\"\n        ng-class=\"{active: ($state.is('settings.integrations')\n                         || $state.is('settings.rtmp_destinations')\n                         || $state.is('settings.facebook')\n                         || $state.is('settings.youtube')\n                         || $state.is('settings.vimeo')\n                         || $state.is('settings.twitter'))}\">\n      <a ui-sref=\"settings.integrations\">Integrations</a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::$root.user.can('list', 'orders')\">\n      <a ui-sref=\"settings.payment\">Billing</a>\n    </li>\n    <li ui-sref-active=\"active\" ng-if=\"::($root.user.can('update', 'billing') && $root.user.can('list', 'storage-bills') && (account.storage_policy == 'auto-bill' || account.storage_policy == 'auto-delete') && !FeatureFlags.no_viewers)\">\n      <a ui-sref=\"settings.storage\">Storage</a>\n    </li>\n    <li ng-if=\"::$root.user.can('list', 'api-keys')\">\n      <a ui-sref=\"settings.api_keys\">API Keys</a>\n    </li>\n    <li ui-sref-active=\"active\">\n      <a ui-sref=\"settings.appearance\">Appearance &amp; Apps</a>\n    </li>\n  </ol>\n</div>\n<div class=\"clearfix\"></div>\n\n<div ui-view></div>\n"

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = "<style>\n.well .pull-right a { font-weight: bold; text-decoration: none; }\n.account-settings .well .table { margin-left: -8px; /*counteract padding*/ }\n.account-settings .data-value { text-transform: none; }\n@media (min-width: 768px) {\n  .account-settings .data-value { width: 400px; text-align: left; }\n}\n</style>\n<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n\n  <div class=\"well\" ng-if=\"::vm.FeatureFlags.no_viewers\">\n    <div class=\"bg-warning text-warning\" style=\"padding:10px;margin:15px;border:1px solid;\">\n      No appearance settings can be configured on your plan.\n    </div>\n  </div>\n\n  <div class=\"well\" ng-if=\"::!vm.FeatureFlags.no_viewers\">\n    <div class=\"pull-right\" ng-if=\"::vm.canEditAccountSettings\">\n      <a href=\"javascript://\" ng-click=\"vm.showEditAppearanceModal()\">Edit <i class=\"fa fa-pencil-square-o\"></i></a>\n    </div>\n    <h3>BoxCast Apps &amp; Branding</h3>\n    <p class=\"help-block\"><small>\n      These settings are used to customize the BoxCast embedded player and your channel on the BoxCast apps\n      for Apple TV, Roku, and Amazon Fire TV.\n    </small></p>\n    <div style=\"max-width:768px; margin-bottom:15px;\">\n      <p>Show in BoxCast Apps <strong class=\"data-value\">{{vm.account.enable_public_discovery ? 'Enabled' : 'Disabled'}}</strong></p>\n      <div style=\"margin:0 0 10px;\">\n        Brand Color\n        <div class=\"data-value\">\n          <color-swatch ng-if=\"vm.account.content_settings.color\" color=\"vm.account.content_settings.color\" label=\"vm.account.content_settings.color\"></color-swatch>\n          <strong ng-if=\"!vm.account.content_settings.color\">Not Configured</strong>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-xs-6 col-sm-4 col-md-3\">\n        <p>Profile Image</p>\n        <div class=\"fixed-16-9\" style=\"background:#fff\">\n          <div style=\"width:56.25%;margin:0 21.875%;\">\n            <div class=\"fixed-square transparent-grid-bg\" style=\"color:#ccc;\">\n              <div ng-if=\"vm.account.content_settings.profile_img\" style=\"background-image:url(&quot;{{vm.account.content_settings.profile_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n              <div ng-if=\"!vm.account.content_settings.profile_img\" style=\"display:flex;align-items:center;justify-content:center;background:#fafafa;\"><small>Not Configured</small></div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-xs-6 col-sm-4 col-md-3\">\n        <p>Account Poster (Large)</p>\n        <div class=\"fixed-16-9 transparent-grid-bg\" style=\"color:#ccc;\">\n          <div style=\"background-image:url(&quot;{{vm.account.content_settings.logo_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n          <div ng-if=\"!vm.account.content_settings.logo_img\" style=\"display:flex;align-items:center;justify-content:center;background:#fafafa;\"><small>Not Configured</small></div>\n        </div>\n      </div>\n      <div class=\"col-xs-6 col-sm-4 col-md-3\">\n        <p>Account Poster (Small)</p>\n        <div class=\"fixed-16-9 transparent-grid-bg\" style=\"color:#ccc;\">\n          <div style=\"background-image:url(&quot;{{vm.account.content_settings.thumb_img | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n          <div ng-if=\"!vm.account.content_settings.thumb_img\" style=\"display:flex;align-items:center;justify-content:center;;background:#fafafa;\"><small>Not Configured</small></div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"well\" ng-if=\"vm.rokuApp\">\n    <div class=\"pull-right\">\n      <span class=\"label label-{{vm.statusLabelLevel(vm.rokuApp)}}\"\n            style=\"margin-right:15px\"\n            uib-tooltip=\"{{vm.statusLabelTooltip(vm.rokuApp)}}\"\n            tooltip-append-to-body=\"true\">\n        {{vm.statusText(vm.rokuApp)}}\n      </span>\n    </div>\n    <h3>Roku Channel Store Information</h3>\n\n    <div ng-if=\"vm.rokuApp.status == 'waiting_on_customer'\" class=\"bg-info text-info\" style=\"padding:15px;margin:15px 0;border:1px solid;\">\n      <p>\n        Let's get ready to build your app!\n        You can submit the form to BoxCast once you have filled out all required information, uploaded your images, and\n        we have received your invitation to your Roku Developer account.\n      </p>\n      <p>\n        <table>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-show=\"vm.rokuApp.roku_developer_account_name\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-hide=\"vm.rokuApp.roku_developer_account_name\"></i>\n              <span class=\"onboarding-item-heading\"><strong>Developer Account:</strong></span>\n            </td>\n            <td>\n              <span ng-show=\"vm.rokuApp.roku_developer_account_name\">You have invited BoxCast to collaborate with your Roku developer account.</span>\n              <span ng-hide=\"vm.rokuApp.roku_developer_account_name\">\n                Please invite BoxCast to collaborate with your Roku developer account.\n                <a href=\"https://support.boxcast.com/en/articles/4298779-linking-developer-accounts-to-boxcast-for-publishing-custom-branded-apps-to-roku-and-apple-tv\" target=\"_blank\">\n                  (<i class=\"fa fa-external-link\"></i> Need help?)\n                </a>\n              </span>\n            </td>\n          </tr>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-hide=\"vm.needPublicRecordedBroadcasts\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-show=\"vm.needPublicRecordedBroadcasts\"></i>\n              <span class=\"onboarding-item-heading\"><strong>Content:</strong></span>\n            </td>\n            <td>\n              <span ng-show=\"vm.needPublicRecordedBroadcasts\">Please ensure you have public, recorded broadcasts available for app review.</span>\n              <span ng-hide=\"vm.needPublicRecordedBroadcasts\">You have public, recorded broadcasts available for app review.</span>\n            </td>\n          </tr>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-show=\"vm.allRokuFieldsSet()\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-hide=\"vm.allRokuFieldsSet()\"></i>\n              <span class=\"onboarding-item-heading\"><strong>App Info:</strong></span>\n            </td>\n            <td>\n              <span ng-hide=\"vm.allRokuFieldsSet()\">\n                Please fill out all required app information and images.\n                <a href=\"https://support.boxcast.com/en/articles/4550679-branded-app-fulfillment-process\" target=\"_blank\">\n                  (<i class=\"fa fa-external-link\"></i> Need help?)\n                </a>\n              </span>\n              <span ng-show=\"vm.allRokuFieldsSet()\">You have provided all required app information and images.</span>\n            </td>\n          </tr>\n        </table>\n      </p>\n      <button type=\"button\" class=\"btn\"\n              ng-class=\"vm.rokuApp._ready_to_submit ? 'btn-default' : 'btn-primary'\"\n              ng-click=\"vm.showEditRokuModal()\">\n        Edit Information\n      </button>\n      <button type=\"button\" class=\"btn btn-primary\"\n              ng-click=\"vm.submitToBoxCast('roku', vm.rokuApp)\"\n              ng-disabled=\"!vm.rokuApp._ready_to_submit || vm.rokuApp._submitting\">\n        Submit to BoxCast\n      </button>\n    </div>\n\n    <table class=\"table table-no-border\">\n      <tr>\n        <th>Channel Name</th>\n        <th>Preferred Category</th>\n        <th>Channel Description</th>\n      </tr>\n      <tr>\n        <td>{{vm.rokuApp.channel_name}}</td>\n        <td>{{vm.rokuApp.category}}</td>\n        <td>{{vm.rokuApp.channel_description}}</td>\n      </tr>\n      <tr>\n        <th>Information URL</th>\n        <th>End User Support Contact</th>\n        <th>Web Description</th>\n      </tr>\n      <tr>\n        <td>{{vm.rokuApp.more_information_url}}</td>\n        <td>{{vm.rokuApp.end_user_support_contact}}</td>\n        <td>{{vm.rokuApp.web_description}}</td>\n      </tr>\n      <tr>\n        <th>App Background Color</th>\n      </tr>\n      <tr>\n        <td><color-swatch ng-if=\"vm.rokuApp.app_background_color\" color=\"vm.rokuApp.app_background_color\" label=\"vm.rokuApp.app_background_color\"></color-swatch></td>\n      </tr>\n    </table>\n    <p><strong>Roku App Images</strong></p>\n    <p><small>Roku Apps require a custom set of images. Here's an example of what each asset looks like. Still looking\n      for help? Reach out to support and we can happily walk you through the process.</small></p>\n    <div class=\"table-horiz-scroll-container\">\n      <!--div class=\"scroll-shadow\"></div-->\n      <div class=\"scroll-container\">\n        <table class=\"table table-no-border\">\n          <tr>\n            <td ng-repeat=\"img in vm.rokuImageList()\">\n              <div>{{::img.name}}</div>\n              <fixed-image-preview src=\"::img.src\" height=\"img.preview_h\" width=\"img.preview_w\"></fixed-image-preview>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"well\" ng-if=\"vm.appleTVApp\">\n    <div class=\"pull-right\">\n      <span class=\"label label-{{vm.statusLabelLevel(vm.appleTVApp)}}\"\n            style=\"margin-right:15px\"\n            uib-tooltip=\"{{vm.statusLabelTooltip(vm.appleTVApp)}}\"\n            tooltip-append-to-body=\"true\">\n        {{vm.statusText(vm.appleTVApp)}}\n      </span>\n    </div>\n    <h3>Apple TV App Store Information</h3>\n\n    <div ng-if=\"vm.appleTVApp.status == 'waiting_on_customer'\" class=\"bg-info text-info\" style=\"padding:15px;margin:15px 0;border:1px solid;\">\n      <p>\n        Let's get ready to build your app!\n        You can submit the form to BoxCast once you have filled out all required information, uploaded your images, and\n        we have received your invitation to your Apple Developer account.\n      </p>\n      <p>\n        <table>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-show=\"vm.appleTVApp.apple_developer_account_name\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-hide=\"vm.appleTVApp.apple_developer_account_name\"></i>\n              <span class=\"onboarding-item-heading\"><strong>Developer Account:</strong></span>\n            </td>\n            <td>\n              <span ng-show=\"vm.appleTVApp.apple_developer_account_name\">You have invited BoxCast to collaborate with your Apple developer account.</span>\n              <span ng-hide=\"vm.appleTVApp.apple_developer_account_name\">\n                Please invite BoxCast to collaborate with your Apple developer account.\n                <a href=\"https://support.boxcast.com/en/articles/4298779-linking-developer-accounts-to-boxcast-for-publishing-custom-branded-apps-to-roku-and-apple-tv\" target=\"_blank\">\n                  (<i class=\"fa fa-external-link\"></i> Need help?)\n                </a>\n              </span>\n            </td>\n          </tr>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-hide=\"vm.needPublicRecordedBroadcasts\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-show=\"vm.needPublicRecordedBroadcasts\"></i>\n              <span class=\"onboarding-item-heading\"><strong>Content:</strong></span>\n            </td>\n            <td>\n              <span ng-show=\"vm.needPublicRecordedBroadcasts\">Please ensure you have public, recorded broadcasts available for app review.</span>\n              <span ng-hide=\"vm.needPublicRecordedBroadcasts\">You have public, recorded broadcasts available for app review.</span>\n            </td>\n          </tr>\n          <tr>\n            <td style=\"padding-right: 10px;\">\n              <i class=\"fa fa-check-circle onboarding-item-heading\" ng-show=\"vm.allAppleTVFieldsSet()\"></i>\n              <i class=\"fa fa-circle-o onboarding-item-heading\" ng-hide=\"vm.allAppleTVFieldsSet()\"></i>\n              <span class=\"onboarding-item-heading\"><strong>App Info:</strong></span>\n            </td>\n            <td>\n              <span ng-hide=\"vm.allAppleTVFieldsSet()\">\n                Please fill out all required app information and images.\n                <a href=\"https://support.boxcast.com/en/articles/4550679-branded-app-fulfillment-process\" target=\"_blank\">\n                  (<i class=\"fa fa-external-link\"></i> Need help?)\n                </a>\n              </span>\n              <span ng-show=\"vm.allAppleTVFieldsSet()\">You have provided all required app information and images.</span>\n            </td>\n          </tr>\n        </table>\n      </p>\n      <button type=\"button\" class=\"btn\"\n              ng-class=\"vm.appleTVApp._ready_to_submit ? 'btn-default' : 'btn-primary'\"\n              ng-click=\"vm.showEditAppleTVModal()\">\n        Edit Information\n      </button>\n      <button type=\"button\" class=\"btn btn-primary\"\n              ng-click=\"vm.submitToBoxCast('appletv', vm.appleTVApp)\"\n              ng-disabled=\"!vm.appleTVApp._ready_to_submit || vm.appleTVApp._submitting\">\n        Submit to BoxCast\n      </button>\n    </div>\n\n    <table class=\"table table-no-border\">\n      <tr>\n        <th>Name in the App Store</th>\n        <th>Category</th>\n        <th>Keywords</th>\n      </tr>\n      <tr>\n        <td>{{vm.appleTVApp.name}}</td>\n        <td>{{vm.appleTVApp.category}}</td>\n        <td>{{vm.appleTVApp.keywords}}</td>\n      </tr>\n      <tr>\n        <th>Subtitle</th>\n        <th>Promotional Text</th>\n        <th>Description</th>\n      </tr>\n      <tr>\n        <td>{{vm.appleTVApp.subtitle}}</td>\n        <td>{{vm.appleTVApp.promotional_text}}</td>\n        <td>{{vm.appleTVApp.description}}</td>\n      </tr>\n      <tr>\n        <th>Support URL</th>\n        <th>Marketing URL</th>\n      </tr>\n      <tr>\n        <td>{{vm.appleTVApp.support_url}}</td>\n        <td>{{vm.appleTVApp.marketing_url}}</td>\n      </tr>\n    </table>\n    <p><strong>Apple TV App Images</strong></p>\n    <p><small>Apple TV Apps require a custom set of images. Here's an example of what each asset looks like. Still looking\n      for help? Reach out to support and we can happily walk you through the process.</small></p>\n    <div class=\"table-horiz-scroll-container\">\n      <!--div class=\"scroll-shadow\"></div-->\n      <div class=\"scroll-container\">\n        <table class=\"table table-no-border\">\n          <tr>\n            <td ng-repeat=\"img in vm.appleTVImageList()\">\n              <div>{{::img.name}}</div>\n              <fixed-image-preview src=\"::img.src\" height=\"img.preview_h\" width=\"img.preview_w\"></fixed-image-preview>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n\n</main>\n"

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n\n      <div class=\"well\">\n        <h3>Streaming Destinations</h3>\n\n        <div ng-if=\"vm.adBlockerEnabled\">\n          <div class=\"col-md-9 bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\">\n            <strong>It appears as though you have an ad-blocking extension enabled on your browser.</strong> These extensions can often\n            interfere with social media integrations, especially Facebook.  Please disable the ad-blocking extension for\n            dashboard.boxcast.com and refresh this page.\n          </div>\n        </div>\n\n        <div ng-if=\"vm.allAccounts.length == 0\" class=\"text-center\">\n          <h4 class=\"help-block\" style=\"margin:30px auto;\">\n            There are no integrations currently linked to your account.\n          </h4>\n          <button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"vm.showLinkModal()\">\n            &plus; Add Integration\n          </button>\n        </div>\n\n        <div class=\"row\" ng-if=\"vm.allAccounts.length > 0\">\n          <div class=\"col-md-9\">\n            <div ng-repeat=\"a in vm.allAccounts\"\n                 id=\"{{a.type}}-{{a.id}}\"\n                 style=\"margin-bottom:15px\">\n              <div class=\"integration-card integration-{{a.type}} integration-card-{{a.__showDetails?'expanded':'collapsed'}}\">\n                <integration-row-header account=\"a\"\n                                        on-toggle-details=\"vm.onToggleDetails(a)\"\n                                        ></integration-row-header>\n                <div class=\"integration-card-details\" uib-collapse=\"!a.__showDetails\" style=\"\">\n                  <integration-row-details account=\"a\"\n                                           on-edit-rtmp=\"vm.onEditRtmp(a)\"\n                                           on-delete-rtmp=\"vm.onDeleteRtmp(a)\"\n                                           on-delete-link=\"vm.onDeleteLink(a)\"\n                                           on-relink=\"vm.onRelink(a)\"\n                                           ></integration-row-details>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-md-3 text-center\">\n            <p>\n              <button type=\"button\" class=\"btn btn-success btn-lg btn-block\" ng-if=\"::vm.canAddAnyIntegration\" ng-click=\"vm.showLinkModal()\">\n                &plus; Add Integration\n              </button>\n            </p>\n            <div ng-if=\"vm.Facebook.loading\" class=\"help-block\">\n              <hr>\n              <p>\n                <small>\n                  Loading Facebook status...\n                  (Stuck? <a href=\"javascript://\" ng-click=\"vm.fbInit()\">Try again</a>.)\n                </small>\n              </p>\n            </div>\n            <div ng-if=\"vm.Facebook.connected\">\n              <hr>\n              <p>\n                <button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.logoutFacebook()\">\n                  Log out of Facebook\n                </button>\n              </p>\n            </div>\n            <div ng-if=\"vm.usingFirefox\" class=\"bg-info text-info\" style=\"padding:10px;border:1px solid;margin:15px 0;\">\n              Please note, the Facebook Container extension for Firefox can interfere with the integration used for\n              streaming. If you are using this extension and have issues configuring the Facebook integration, please\n              <a href=\"https://support.mozilla.org/en-US/kb/disable-or-remove-add-ons\" target=\"_blank\">disable\n                the the Facebook Container extension</a> and refresh this page.\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"well\" ng-if=\"::($root.account.feature_flags.sportzcast && $root.user.can('read', 'sportzcast-configuration'))\">\n        <h3>Scoreboard Integrations</h3>\n        <div ng-if=\"!vm.sportzcast.username\" class=\"text-center\">\n          <h4 class=\"help-block\" style=\"margin:30px auto;\">\n            There are no scoreboard integrations currently linked to your account.\n          </h4>\n          <button type=\"button\" class=\"btn btn-lg btn-success\" ng-if=\"::$root.user.can('update', 'sportzcast-configuration')\" ng-click=\"vm.onEditSportzcast()\">\n            &plus; Add Scoreboard Integration\n          </button>\n        </div>\n        <div class=\"row\" ng-if=\"vm.sportzcast.username\">\n          <div class=\"col-md-9\">\n            <div id=\"sportzcast-1\" style=\"margin-bottom:15px\">\n              <div class=\"integration-card integration-sportzcast integration-card-{{vm.sportzcast.__showDetails?'expanded':'collapsed'}}\">\n                <integration-row-header account=\"vm.sportzcast\" on-toggle-details=\"vm.onToggleDetails(vm.sportzcast)\" ></integration-row-header>\n                <div class=\"integration-card-details\" uib-collapse=\"!vm.sportzcast.__showDetails\" style=\"\">\n                  <integration-row-details account=\"vm.sportzcast\" on-edit-sportzcast=\"vm.onEditSportzcast()\"></integration-row-details>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var IntegrationsController = /*#__PURE__*/function () {
  function IntegrationsController($rootScope, $scope, Account, toaster, Facebook, YouTubeUser, TwitterUser, RTMPPushChannel, VimeoUser, Broadcast, $q, $uibModal, FacebookUser, $timeout, $state) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, IntegrationsController);

    this.account = $rootScope.account;
    this.user = $rootScope.user;
    this.FeatureFlags = this.account.feature_flags;
    this.$scope = $scope;
    this.Account = Account;
    this.toaster = toaster;
    this.Facebook = Facebook;
    this.YouTubeUser = YouTubeUser;
    this.TwitterUser = TwitterUser;
    this.RTMPPushChannel = RTMPPushChannel;
    this.VimeoUser = VimeoUser;
    this.Broadcast = Broadcast;
    this.$q = $q;
    this.$uibModal = $uibModal;
    this.FacebookUser = FacebookUser;
    this.$timeout = $timeout;
    this.$state = $state;
    this.canAddTwitterUsers = this.user.can('create', 'twitter-user');
    this.canAddAnyIntegration = this.user.can('create', 'facebook-user') || this.user.can('create', 'youtube-user') || this.user.can('create', 'twitter-user') || this.user.can('create', 'vimeo-user') || this.user.can('create', 'rtmp-push-channel');
    this.loadingPromises = [];
    this.expandCurrentFacebookUser = false;
    this.reload();
    this.fbInit(); // Detect traits that can cause social media integration problems

    this.adBlockerEnabled = false;
    blockAdBlock.on(true, function () {
      $timeout(function () {
        return _this.adBlockerEnabled = true;
      }, 0);
    });
    blockAdBlock.check();
    this.usingFirefox = false;

    if (navigator.userAgent.indexOf('Firefox') >= 0) {
      this.usingFirefox = true;
    }
  }

  _createClass(IntegrationsController, [{
    key: "reload",
    value: function reload() {
      var _this2 = this;

      var FacebookUser = this.FacebookUser,
          YouTubeUser = this.YouTubeUser,
          toaster = this.toaster,
          TwitterUser = this.TwitterUser,
          RTMPPushChannel = this.RTMPPushChannel,
          VimeoUser = this.VimeoUser,
          Broadcast = this.Broadcast,
          $q = this.$q,
          user = this.user;
      this.allAccounts = []; // Facebook

      if (user.can('list', 'facebook-users')) {
        this.loadingPromises.push(FacebookUser.query().$promise.then(function (users) {
          _this2.facebookAccounts = users;

          _this2.facebookAccounts.forEach(function (a) {
            return a.type = 'facebook';
          });

          _this2.allAccounts = _this2.allAccounts.concat(_this2.facebookAccounts);

          _this2.processFacebookLinkToCurrentUser();
        })["catch"](function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to load your linked Facebook accounts. Please reload this page and try again.');
        }));
      } // YouTube


      if (user.can('list', 'youtube-users')) {
        this.loadingPromises.push(YouTubeUser.query().$promise.then(function (users) {
          _this2.youtubeUsers = users;

          _this2.youtubeUsers.forEach(function (u) {
            u.type = 'youtube';
            u.__isYTLiveEnabled__ = _.reduce(u.scope, function (c, s) {
              return c + (s == 'https://www.googleapis.com/auth/youtube' ? 1 : 0);
            }, 0) > 0;
          });

          _this2.allAccounts = _this2.allAccounts.concat(_this2.youtubeUsers);
        })["catch"](function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to load your linked YouTube accounts. Please reload this page and try again.');
        }));
      } // Twitter


      if (user.can('list', 'twitter-users')) {
        this.loadingPromises.push(TwitterUser.query().$promise.then(function (users) {
          _this2.twitterUsers = users;

          _this2.twitterUsers.forEach(function (a) {
            return a.type = 'twitter';
          });

          _this2.allAccounts = _this2.allAccounts.concat(_this2.twitterUsers);
        })["catch"](function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to load your linked Twitter accounts. Please reload this page and try again.');
        }));
      } // Vimeo


      if (user.can('list', 'vimeo-users')) {
        this.loadingPromises.push(VimeoUser.query().$promise.then(function (users) {
          _this2.vimeoUsers = users;

          _this2.vimeoUsers.forEach(function (a) {
            return a.type = 'vimeo';
          });

          _this2.allAccounts = _this2.allAccounts.concat(_this2.vimeoUsers);
        })["catch"](function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to load your linked Vimeo accounts. Please reload this page and try again.');
        }));
      } // RTMP Push


      if (user.can('list', 'rtmp-push-channels')) {
        this.loadingPromises.push(RTMPPushChannel.query().$promise.then(function (channels) {
          _this2.rtmpPushChannels = channels;

          _this2.rtmpPushChannels.forEach(function (a) {
            return a.type = 'rtmp_push';
          });

          _this2.allAccounts = _this2.allAccounts.concat(_this2.rtmpPushChannels);
        })["catch"](function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to load your destinations. Please reload this page and try again.');
        }));
      } // All Live Broadcasts ... to use to see which simulcast implementations are active,
      // so we need to get each live one in *show* scope, not *list* scope


      this.loadingPromises.push($q(function (resolve, reject) {
        Broadcast.query({
          q: 'timeframe:current',
          l: 100
        }, function (broadcasts) {
          $q.all(broadcasts.map(function (b) {
            var broadcast = Broadcast.get({
              id: b.id
            });
            return broadcast.$promise;
          })).then(function (broadcasts) {
            _this2.broadcasts = broadcasts;
            resolve(broadcasts);
          })["catch"](function (err) {
            reject(err);
          });
        }, function (err) {
          return reject(err);
        });
      })); // Sportzcast configuration is modeled as an integration

      if (this.FeatureFlags.sportzcast && this.user.can('read', 'sportzcast-configuration')) {
        this.sportzcast = this.Account.getSportzcast(function () {
          // Work with <integration-row> components
          _this2.sportzcast.type = 'sportzcast';
          _this2.sportzcast.hideStatusDot = true;
          _this2.sportzcast.display_name = "ScoreBOT";
          _this2.sportzcast.display_subtitle = "Username ".concat(_this2.sportzcast.username);
        });
        this.loadingPromises.push(this.sportzcast.$promise);
      } // Once everything is done loading, match up the live broadcast configurations with the
      // linked social accounts;


      $q.all(this.loadingPromises).then(function () {
        _this2.allAccounts.forEach(function (a) {
          // Normalize display_name across various configuration types
          a.display_name = a.display_name || a.fb_user_name || a.name;
        });

        _this2.broadcasts.forEach(function (b) {
          b.simulcast_configurations.forEach(function (c) {
            if (c.destination == 'facebook') {
              _this2.facebookAccounts.forEach(function (a) {
                if (a.id == c.facebook_account_id) {
                  a.details = a.details || [];
                  a.details.push(b);
                }
              });
            } else if (c.destination == 'youtube') {
              _this2.youtubeUsers.forEach(function (a) {
                if (a.id == c.youtube_account_id) {
                  a.details = a.details || [];
                  a.details.push(b);
                }
              });
            } else if (c.destination == 'twitter') {
              _this2.twitterUsers.forEach(function (a) {
                if (a.id == c.twitter_account_id) {
                  a.details = a.details || [];
                  a.details.push(b);
                }
              });
            } else if (c.destination == 'rtmp_push_channel') {
              _this2.rtmpPushChannels.forEach(function (a) {
                if (a.id == c.rtmp_push_channel_id) {
                  a.details = a.details || [];
                  a.details.push(b);
                }
              });
            }
          });
        });

        _this2.allAccounts = _.sortBy(_this2.allAccounts, function (a) {
          var hasActivePrefix = a.details && a.details.length ? '0' : '1';
          return "".concat(hasActivePrefix, "-").concat(a.display_name, "-").concat(a.type);
        });
        var integrationID = _this2.$state.params.integration_id;

        if (integrationID) {
          var scrollToID;

          var _iterator = _createForOfIteratorHelper(_this2.allAccounts),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var a = _step.value;

              if (a.id == integrationID) {
                a.__showDetails = true;
                scrollToID = "#".concat(a.type, "-").concat(a.id);
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          if (scrollToID) {
            _this2.$timeout(function () {
              $('html, body').animate({
                scrollTop: $(scrollToID).offset().top - 100
              });
            }, 10);
          }
        }
      });
    }
  }, {
    key: "processFacebookLinkToCurrentUser",
    value: function processFacebookLinkToCurrentUser() {
      var _this3 = this;

      this.allAccounts.forEach(function (a) {
        if (a.type == 'facebook' && _this3.Facebook.connected && _this3.Facebook.me.id === a.fb_user_id) {
          a.pages_managed = _this3.Facebook.accounts;

          if (_this3.expandCurrentFacebookUser) {
            a.__showDetails = true;

            _this3.$timeout(function () {
              $('html, body').animate({
                scrollTop: $("#".concat(a.type, "-").concat(a.id)).offset().top - 100
              });
            }, 10);
          }
        } else {
          a.pages_managed = null;
        }
      });
    }
  }, {
    key: "showLinkModal",
    value: function showLinkModal() {
      var _this5 = this;

      var $uibModal = this.$uibModal,
          Facebook = this.Facebook,
          FeatureFlags = this.FeatureFlags,
          toaster = this.toaster,
          user = this.user;
      var parentVM = this;
      $uibModal.open({
        template: __webpack_require__(510),
        controller: function controller($uibModalInstance, $scope) {
          'ngInject';

          var _this4 = this;

          this.user = user;
          this.FeatureFlags = FeatureFlags;

          this.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };

          this.linkFacebook = function () {
            Facebook.login().then(function () {
              $scope.$evalAsync(function () {
                parentVM.expandCurrentFacebookUser = true;
                parentVM.fbInit();
                parentVM.reload();

                _this4.cancel();
              });
            })["catch"](function (err) {
              toaster.pop('warning', 'Unable to link the Facebook account');
              remoteLogger.error('Error linking Facebook account', {
                error: err
              });
            });
          };

          this.addRtmp = function () {
            _this4.cancel();

            parentVM.onAddRtmp();
          };
        },
        controllerAs: 'vm'
      }).result.then(function (r) {
        _this5.reload();
      });
    }
  }, {
    key: "onToggleDetails",
    value: function onToggleDetails(a) {
      if (a.__showDetails) {
        a.__showDetails = false;
      } else {
        a.__showDetails = true;
      }
    }
  }, {
    key: "onDeleteLink",
    value: function onDeleteLink(a) {
      var _this6 = this;

      var Facebook = this.Facebook,
          FacebookUser = this.FacebookUser,
          toaster = this.toaster,
          YouTubeUser = this.YouTubeUser,
          VimeoUser = this.VimeoUser,
          TwitterUser = this.TwitterUser;

      if (a.type == 'facebook') {
        if (!confirm('Are you sure you want to unlink the account? Any future events linked to this account will not stream to Facebook.')) {
          return false;
        }

        var deleteLinkedAccount = function deleteLinkedAccount() {
          FacebookUser["delete"]({
            id: a.id
          }).$promise.then(function () {
            toaster.pop('success', 'Deleted linked Facebook account.');

            _this6.reload();
          })["catch"](function (err) {
            console.error(err);
            toaster.pop('warning', 'Unable to delete your linked Facebook account. Please reload this page and try again.');
          });
        };

        if (Facebook.connected && Facebook.me.id == a.fb_user_id) {
          Facebook.logout().then(deleteLinkedAccount);
        } else {
          deleteLinkedAccount();
        }
      }

      if (a.type == 'youtube') {
        if (!confirm('Are you sure you want to unlink the account? Any future events linked to this account will not stream to YouTube.')) {
          return false;
        }

        YouTubeUser["delete"]({
          id: a.id
        }, function () {
          toaster.pop('success', 'Deleted linked YouTube account.');

          _this6.reload();
        }, function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to delete your linked YouTube account. Please reload this page and try again.');
        });
      }

      if (a.type == 'twitter') {
        if (!confirm('Are you sure you want to unlink the account?')) {
          return false;
        }

        TwitterUser["delete"]({
          id: a.id
        }, function () {
          toaster.pop('success', 'Deleted linked Twitter account.');

          _this6.reload();
        }, function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to delete your linked Twitter account. Please reload this page and try again.');
        });
      }

      if (a.type == 'vimeo') {
        if (!confirm('Are you sure you want to unlink the account?')) {
          return false;
        }

        VimeoUser["delete"]({
          id: a.id
        }, function () {
          toaster.pop('success', 'Deleted linked Vimeo account.');

          _this6.reload();
        }, function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to delete your linked Vimeo account. Please reload this page and try again.');
        });
      }
    }
  }, {
    key: "onDeleteRtmp",
    value: function onDeleteRtmp(a) {
      var _this7 = this;

      var RTMPPushChannel = this.RTMPPushChannel,
          toaster = this.toaster;

      if (!confirm('Are you sure you want to delete this destination? This will also unlink it from any broadcasts that use it.')) {
        return false;
      }

      RTMPPushChannel["delete"]({
        id: a.id
      }, function () {
        toaster.pop('success', 'Deleted destination.');

        _this7.reload();
      }, function (err) {
        console.error(err);
        toaster.pop('warning', 'Unable to delete your destination. Please reload this page and try again.');
      });
    }
  }, {
    key: "onRelink",
    value: function onRelink(a) {
      var _this8 = this;

      var $scope = this.$scope,
          $state = this.$state,
          Facebook = this.Facebook;

      if (a.type == 'facebook') {
        Facebook.login().then(function () {
          $scope.$evalAsync(function () {
            _this8.expandCurrentFacebookUser = true;

            _this8.fbInit();

            _this8.reload();
          });
        });
      } else {
        $state.go("settings.".concat(a.type), {
          link: 1
        });
      }
    }
  }, {
    key: "onEditSportzcast",
    value: function onEditSportzcast() {
      var _this9 = this;

      var $uibModal = this.$uibModal,
          Account = this.Account;
      $uibModal.open({
        template: __webpack_require__(511),
        controller: __webpack_require__(512)["default"],
        controllerAs: 'vm',
        resolve: {
          sportzcast: function sportzcast() {
            return _this9.sportzcast;
          }
        }
      }).result.then(function (r) {
        _this9.reload();
      });
    }
  }, {
    key: "onEditRtmp",
    value: function onEditRtmp(a) {
      var _this10 = this;

      var $uibModal = this.$uibModal,
          RTMPPushChannel = this.RTMPPushChannel;
      $uibModal.open({
        template: __webpack_require__(48),
        controller: __webpack_require__(49)["default"],
        controllerAs: 'vm',
        resolve: {
          mode: function mode() {
            return 'edit';
          },
          config: function config() {
            return a;
          }
        }
      }).result.then(function (r) {
        _this10.reload();
      });
    }
  }, {
    key: "onAddRtmp",
    value: function onAddRtmp() {
      var _$uibModal$open,
          _this11 = this;

      var $uibModal = this.$uibModal,
          RTMPPushChannel = this.RTMPPushChannel;
      $uibModal.open((_$uibModal$open = {
        controllerAs: 'vm',
        template: __webpack_require__(48),
        controller: __webpack_require__(49)["default"]
      }, _defineProperty(_$uibModal$open, "controllerAs", 'vm'), _defineProperty(_$uibModal$open, "resolve", {
        mode: function mode() {
          return 'add';
        },
        config: function config() {
          return {
            max_resolution: 0
          };
        }
      }), _$uibModal$open)).result.then(function (r) {
        _this11.reload();
      });
    }
  }, {
    key: "logoutFacebook",
    value: function logoutFacebook() {
      var _this12 = this;

      this.Facebook.logout().then(function () {
        return _this12.reload();
      });
    }
  }, {
    key: "fbInit",
    value: function fbInit() {
      var _this13 = this;

      this.Facebook.init().then(function () {
        if (_this13.expandCurrentFacebookUser) {
          return _this13.Facebook.loadStatus({
            force: true
          });
        }
      }).then(function () {
        _this13.$timeout(function () {
          _this13.processFacebookLinkToCurrentUser();
        }, 50); //wait 50ms because Facebook.accounts doesn't appear to be there in some cases

      })["catch"](function (e) {
        remoteLogger.error('Error initializing Facebook API', {
          error: e
        });

        _this13.toaster.pop('warning', 'Error initializing Facebook API');
      });
    }
  }]);

  return IntegrationsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (IntegrationsController);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n  <div class=\"modal-header\">\n    <a href class=\"pull-right\" ng-click=\"vm.cancel()\" title=\"Close Dialog\"><i class=\"fa fa-times\"></i></a>\n    <h3 class=\"modal-title\">Add an Integration</h3>\n  </div>\n  <div class=\"modal-body add-integration\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <ul class=\"list-unstyled\">\n          <li ng-if=\"::vm.user.can('create', 'facebook-user')\">\n            <button class=\"btn btn-default btn-lg btn-block\" ng-click=\"vm.linkFacebook()\">\n              <span class=\"pull-left integration-badge integration-badge--facebook\">\n                <i class=\"fa fa-facebook\"></i>\n              </span>\n              Facebook\n              <i class=\"pull-right fa fa-caret-right\"></i>\n            </button>\n          </li>\n          <li ng-if=\"::vm.user.can('create', 'youtube-user')\">\n            <a class=\"btn btn-default btn-lg btn-block\" ui-sref=\"settings.youtube({link: 1})\" ng-click=\"vm.cancel()\">\n              <span class=\"pull-left integration-badge integration-badge--youtube\">\n                <i class=\"fa fa-youtube-play\"></i>\n              </span>\n              YouTube\n              <i class=\"pull-right fa fa-caret-right\"></i>\n            </a>\n          </li>\n          <li ng-if=\"::vm.user.can('create', 'twitter-user')\">\n            <a class=\"btn btn-default btn-lg btn-block\" ui-sref=\"settings.twitter({link: 1})\" ng-click=\"vm.cancel()\">\n              <span class=\"pull-left integration-badge integration-badge--twitter\">\n                <i class=\"fa fa-twitter\"></i>\n              </span>\n              Twitter\n              <i class=\"pull-right fa fa-caret-right\"></i>\n            </a>\n          </li>\n          <li ng-if=\"::vm.user.can('create', 'vimeo-user')\">\n            <a class=\"btn btn-default btn-lg btn-block\" ui-sref=\"settings.vimeo({link: 1})\" ng-click=\"vm.cancel()\">\n              <span class=\"pull-left integration-badge integration-badge--vimeo\">\n                <i class=\"fa fa-vimeo\"></i>\n              </span>\n              Vimeo\n              <i class=\"pull-right fa fa-caret-right\"></i>\n            </a>\n          </li>\n          <li ng-if=\"::vm.user.can('create', 'rtmp-push-channel')\">\n            <button class=\"btn btn-default btn-lg btn-block\" ng-click=\"vm.addRtmp()\">\n              <span class=\"pull-left integration-badge integration-badge--rtmp_push\">\n                <span>RTMP Push</span>\n              </span>\n              RTMP Destination\n              <i class=\"pull-right fa fa-caret-right\"></i>\n            </button>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</form>\n"

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n    <h3 class=\"modal-title\">Edit Sportzcast Settings</h3>\n  </div>\n  <div class=\"modal-body\" ng-if=\"::($root.account.feature_flags.sportzcast && $root.user.can('update', 'sportzcast-configuration'))\">\n\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div class=\"form-group\">\n          <label for=\"sportzcastUsername\">SportzCast Username <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n          <input type=\"text\" class=\"form-control\" id=\"sportzcastUsername\" name=\"sportzcastUsername\" ng-model=\"vm.sportzcast.username\" ng-maxlength=\"::vm.limits.username\" required>\n          <p ng-show=\"(form.sportzcastUsername.$dirty || form.sportzcastUsername.$touched) && !vm.sportzcast.username\">\n            <span class=\"text-danger\" ng-if=\"form.sportzcastUsername.$error.maxlength\">The username is too long.</span>\n            <span class=\"text-danger\" ng-if=\"form.sportzcastUsername.$error.required\">The username cannot be blank.</span>\n          </p>\n        </div>\n        <div ng-if=\"!vm.previouslyEnabledSportzcast\">\n          <div class=\"form-group\">\n            <label for=\"password\">SportzCast Password <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <input type=\"password\" class=\"form-control\" id=\"password\" ng-model=\"vm.sportzcast.password\" required>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"password_confirm\">Confirm Password <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n            <input type=\"password\" class=\"form-control\" id=\"password_confirm\" ng-model=\"vm.passwordConfirm\" required>\n          </div>\n        </div>\n        <div ng-if=\"vm.previouslyEnabledSportzcast\">\n          <p>\n            <a href=\"javascript://\" ng-click=\"vm.showChangePassword = !vm.showChangePassword\">\n              Update SportzCast Password\n            </a>\n          </p>\n          <div class=\"well\" ng-if=\"vm.showChangePassword == true\">\n            <div class=\"form-group\">\n              <label for=\"password\">SportzCast Password <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n              <input type=\"password\" class=\"form-control\" id=\"password\" ng-model=\"vm.sportzcast.password\" required>\n            </div>\n            <div class=\"form-group\">\n              <label for=\"password_confirm\">Confirm Password <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n              <input type=\"password\" class=\"form-control\" id=\"password_confirm\" ng-model=\"vm.passwordConfirm\" required>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n  <div class=\"modal-footer\">\n      <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n      <button ng-disabled=\"saving\"\n              ng-click=\"vm.update()\"\n              class=\"btn btn-primary\">\n        <i ng-show=\"saving\" class=\"fa fa-spin fa-spinner\"></i>\n        Update Settings\n      </button> \n  </div>\n</form>\n\n"

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalEditSportzcast;
function ModalEditSportzcast(sportzcast, Account, $rootScope, toaster, $uibModalInstance) {
  'ngInject';

  var _this = this;

  var account = $rootScope.account; // passed in via `resolve`

  this.sportzcast = angular.copy(sportzcast);

  this.cancel = function () {
    return $uibModalInstance.dismiss();
  };

  this.limits = $rootScope.ApiConfig.modelFieldLimits('sportzcast_integration', 'maximum');
  this.showChangePassword = false;
  this.previouslyEnabledSportzcast = !!sportzcast.username;
  this.passwordConfirm = '';

  this.update = function () {
    // SportzCast validation
    var data = {
      username: _this.sportzcast.username
    };

    if (!data.username) {
      toaster.pop('warning', 'SportzCast username is required');
      return;
    }

    if (!_this.previouslyEnabledSportzcast || _this.showChangePassword) {
      if (!_this.sportzcast.password) {
        toaster.pop('warning', 'SportzCast password is required');
        return;
      }

      if (_this.sportzcast.password != _this.passwordConfirm) {
        toaster.pop('warning', 'SportzCast passwords do not match');
        return;
      }

      data.password = _this.sportzcast.password;
    } // Update common scoreboard settings separate from SportzCast


    _this.submitting = true;
    Account.updateSportzcast({
      id: account.id
    }, data).$promise.then(function (r) {
      $uibModalInstance.close(r);
    })["catch"](function (err) {
      console.error(e);
      toaster.pop('warning', 'Unable to save Sportzcast configuration. Please refresh and try again.');
      _this.submitting = false;
    });
  };
}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <p class=\"help-block\">\n        Please wait while you are redirected.\n        If you are stuck here, <a ui-sref=\"settings.integrations\">return to the integrations page</a>.\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FacebookSettingsController = /*#__PURE__*/_createClass(function FacebookSettingsController($state) {
  'ngInject';

  _classCallCheck(this, FacebookSettingsController);

  $state.go('settings.integrations');
});

/* harmony default export */ __webpack_exports__["default"] = (FacebookSettingsController);

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <p class=\"help-block\">\n        Please wait while your account link is processed.\n        If you are stuck here, <a ui-sref=\"settings.integrations\">return to the integrations page</a>.\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var GOOGLE_EMAIL_SCOPE = 'email';
var GOOGLE_PROFILE_SCOPE = 'profile';
var GOOGLE_AUTH_SCOPES = [GOOGLE_EMAIL_SCOPE, GOOGLE_PROFILE_SCOPE, YOUTUBE_SCOPE, YOUTUBE_ANALYTICS_SCOPE];
var GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';

var YouTubeSettingsController = /*#__PURE__*/function () {
  function YouTubeSettingsController(YouTubeUser, toaster, $state, $timeout) {
    'ngInject';

    _classCallCheck(this, YouTubeSettingsController);

    this.YouTubeUser = YouTubeUser;
    this.toaster = toaster;
    this.$state = $state;
    this.youtubeUsers = []; // If this page was loaded with `code`

    var code = $state.params.code,
        error = $state.params.error;

    if (code) {
      this.addCode(code);
    } else if (error) {
      var error_message = "Unable to link the requested YouTube account (YouTube said: \"".concat(error, "\"). Please try again.");

      if (error == 'access_denied') {
        error_message = 'Unable to link the requested YouTube account, as access was denied. Please try again.';
      }

      $timeout(function () {
        return toaster.pop('warning', error_message);
      }, 0);
    } else if ($state.params.link) {
      this.linkAccount();
    } else {
      $state.go('settings.integrations');
    }
  }

  _createClass(YouTubeSettingsController, [{
    key: "addCode",
    value: function addCode(code) {
      var YouTubeUser = this.YouTubeUser,
          toaster = this.toaster,
          $state = this.$state; // Ask the API to get the token for this code and redirect_uri

      var user = new YouTubeUser({
        code: code,
        redirect_uri: YOUTUBE_OAUTH_REDIRECT
      });
      var promise = user.$save().then(function (u) {
        toaster.pop('success', 'Successfully linked YouTube account.');
        $state.go('settings.integrations', {
          integration_id: u.id
        });
      })["catch"](function (err) {
        console.error(err);

        if (err.status == 422 && err.data && err.data.invalid_fields && err.data.invalid_fields.refresh_token) {
          toaster.pop('warning', 'Unable to link the requested YouTube account. Is it already linked?');
        } else {
          toaster.pop('warning', 'Unable to link the requested YouTube account. Please reload this page and try again.');
        }

        $state.go('settings.integrations');
      });
      this.loadingPromises = [promise];
    }
  }, {
    key: "linkAccount",
    value: function linkAccount() {
      var authParams = {
        client_id: YOUTUBE_CLIENT_ID,
        redirect_uri: YOUTUBE_OAUTH_REDIRECT,
        scope: GOOGLE_AUTH_SCOPES.join(' '),
        response_type: 'code',
        access_type: 'offline',
        prompt: 'consent'
      };
      var queryStr = Object.keys(authParams).map(function (k) {
        return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(authParams[k]));
      }).join('&');
      window.location.replace("".concat(GOOGLE_AUTH_URL, "?").concat(queryStr));
    }
  }]);

  return YouTubeSettingsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (YouTubeSettingsController);

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <p class=\"help-block\">\n        Please wait while your account link is processed.\n        If you are stuck here, <a ui-sref=\"settings.integrations\">return to the integrations page</a>.\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var VIMEO_AUTH_URL = 'https://api.vimeo.com/oauth/authorize';

var VimeoSettingsController = /*#__PURE__*/function () {
  function VimeoSettingsController(VimeoUser, toaster, $state) {
    'ngInject';

    _classCallCheck(this, VimeoSettingsController);

    this.VimeoUser = VimeoUser;
    this.toaster = toaster;
    this.$state = $state;
    this.vimeoUsers = []; // If this page was loaded with `code`

    var code = $state.params.code;

    if (code) {
      this.addCode(code);
    } else if ($state.params.link) {
      this.linkAccount();
    } else {
      $state.go('settings.integrations');
    }
  }

  _createClass(VimeoSettingsController, [{
    key: "addCode",
    value: function addCode(code) {
      var VimeoUser = this.VimeoUser,
          toaster = this.toaster,
          $state = this.$state; // Ask the API to get the token for this code and redirect_uri

      var user = new VimeoUser({
        code: code,
        redirect_uri: VIMEO_OAUTH_REDIRECT
      });
      var promise = user.$save().then(function (u) {
        $state.go('settings.integrations', {
          integration_id: u.id
        });
      })["catch"](function (err) {
        console.error(err);
        toaster.pop('warning', 'Unable to link the requested Vimeo account. Please reload this page and try again.');
      });
      this.loadingPromises = [promise];
    }
  }, {
    key: "linkAccount",
    value: function linkAccount() {
      var authParams = {
        response_type: 'code',
        client_id: VIMEO_CLIENT_ID,
        redirect_uri: VIMEO_OAUTH_REDIRECT,
        scope: VIMEO_SCOPE,
        state: 'vimeo'
      };
      var queryStr = Object.keys(authParams).map(function (k) {
        return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(authParams[k]));
      }).join('&');
      window.location.replace("".concat(VIMEO_AUTH_URL, "?").concat(queryStr));
    }
  }]);

  return VimeoSettingsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (VimeoSettingsController);

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\"\n  cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n\n  <div class=\"row\" ng-if=\"!vm.loading && (vm.upgradesAvailable && !vm.upgradesAvailable.length) && (vm.subscriptions && !vm.subscriptions.length)\">\n    <div class=\"col-sm-12\">\n      <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\">\n        Your account does not have an active subscription.  Please contact <a href=\"mailto:questions@boxcast.com\">questions@boxcast.com</a> or call <a href=\"tel:888-392-2278\">(888) 392-2278</a>.\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-12\"\n      ng-if=\"(vm.upgradesAvailable && !vm.upgradesAvailable.length) && vm.account.isTrialing() && (!vm.billing || vm.billing.payment_method == 'other')\">\n      <div class=\"well\">\n        <h3>Proposals</h3>\n        <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\">\n          <small>\n            Your trial expires on {{vm.account.expires_on | date}}. Your proposal to continue streaming should be\n            available here shortly. If you would like to begin sooner, please contact <a\n              href=\"mailto:questions@boxcast.com\">questions@boxcast.com</a> or call <a href=\"tel:888-392-2278\">(888) 392-2278</a>.\n          </small>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-sm-12\" ng-if=\"vm.upgradesAvailable && vm.upgradesAvailable.length\">\n      <div class=\"well\">\n        <h3>Proposals</h3>\n        <div ng-if=\"vm.account.status == 'initial' && vm.account.isTrialing()\">\n          <div class=\"bg-warning text-warning\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\">\n            <small>\n              Your trial expires on {{vm.account.expires_on | date}}. Review your proposal to ensure uninterrupted\n              service.\n            </small>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-8\">\n            <table class=\"table table-noborders\" style=\"margin:0 0 0 0;padding-bottom:0;\">\n              <thead>\n                <tr>\n                  <th style=\"width:40%\">Name</th>\n                  <th style=\"width:20%\">Date</th>\n                  <th></th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"u in vm.upgradesAvailable\">\n                  <td>{{u.name}}</td>\n                  <td>{{u.created_at|date}}</td>\n                  <td class=\"text-left\">\n                    <button class=\"btn btn-default btn-sm\" ng-if=\"::vm.canEditPaymentSettings\" ng-click=\"vm.review(u.pandadoc_id, u.share_id)\">Review <i class=\"fa fa-caret-right\"></i></button>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-sm-12\" ng-if=\"vm.outstandingInvoices.length\">\n      <div class=\"well\">\n        <h3>Outstanding Payments</h3>\n        <div class=\"row\">\n          <div class=\"col-sm-8\">\n            <div ng-if=\"vm.daysUntilSuspend > 0\" class=\"bg-warning text-warning\"\n              style=\"padding:10px;border:1px solid;margin-bottom:5px;\">\n              Your account will be suspended if payment is not received in {{vm.daysUntilSuspend}} day(s).\n            </div>\n            <table class=\"table table-condensed table-noborders\">\n              <thead>\n                <tr>\n                  <th>Due On</th>\n                  <th>Status</th>\n                  <th class=\"text-right\">Balance</th>\n                  <th></th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"inv in vm.outstandingInvoices\">\n                  <td>{{(inv.due_date*1000) | date}}</td>\n                  <td ng-switch=\"inv.detailedStatus\">\n                    <span ng-switch-when=\"failed\" class=\"label label-danger\">\n                      Failed Payment\n                    </span>\n                    <span ng-switch-when=\"pending\" class=\"label label-default\">\n                      Payment Pending\n                    </span>\n                    <span ng-switch-when=\"awaiting_payment\">\n                      <span ng-show=\"inv.days_past_due > 0\" class=\"label label-warning\" style=\"margin-right:5px\">\n                        {{inv.days_past_due}} Days Past Due\n                      </span>\n                      <span ng-show=\"vm.billing.payment_method == 'check'\" class=\"label label-default\">\n                        Awaiting Check\n                      </span>\n                      <span ng-show=\"vm.billing.payment_method == 'po'\" class=\"label label-default\">\n                        Awaiting Purchase Order\n                      </span>\n                      <span\n                        ng-show=\"!inv.past_due && vm.billing.payment_method != 'po' && vm.billing.payment_method != 'check'\"\n                        class=\"label label-default\">\n                        Awaiting Payment\n                      </span>\n                    </span>\n                    <span ng-switch-default class=\"label label-default\">\n                      Awaiting Payment\n                    </span>\n                  </td>\n                </div>\n                <td class=\"text-right\">{{(inv.amount_due / 100) | currency}}</td>\n                <td class=\"text-right\">\n                  <a ng-if=\"inv.hosted_invoice_url\" href=\"{{inv.hosted_invoice_url}}\" target=\"_blank\">\n                    <strong>View invoice <i class=\"fa fa-external-link\"></i></strong>\n                  </a>\n                  <span ng-if=\"inv.status == 'draft' && inv.closed\">\n                    <i class=\"fa fa-exclamation-circle\" tooltip-placement=\"top\"\n                      uib-tooltip=\"This invoice is not currently payable. Please contact us at billing@boxcast.com or (888) 392-2278.\"></i>\n                  </span>\n                  <span ng-if=\"inv.usage && inv.usage.length > 0\" ng-repeat=\"usage in inv.usage\">\n                    &nbsp;|&nbsp;\n                    <a\n                      href=\"javascript://\"\n                      ng-click=\"vm.showUsageSummary(usage.subscriptionItemId, usage.plan, usage.periodStart, usage.periodEnd)\">\n                      View {{usage.type | usageType}} usage\n                    </a>\n                  </span>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-hide=\"!vm.subscriptions || vm.account.isTrialing()\" class=\"col-sm-12\">\n    <div class=\"well\">\n      <h3>Current Subscription</h3>\n      <p ng-if=\"!vm.subscriptions.length\">\n        You currently do not have an active subscription.\n      </p>\n      <div class=\"row\">\n        <div class=\"col-sm-8\">\n          <div ng-if=\"vm.subscriptions.length\" ng-repeat=\"sub in vm.subscriptions\">\n            <div ng-if=\"vm.subscriptions.length > 1\">\n              <hr ng-if=\"$index > 0\">\n              <h4>Subscription {{$index + 1}}</h4>\n            </div>\n            <table class=\"table table-noborders table-condensed\">\n              <tbody>\n                <tr ng-repeat=\"item in sub.items.data\">\n                  <th style=\"width:60%\">\n                    <span ng-if=\"item.plan.quantity != 1\">{{item.plan.quantity}} x </span>{{item.plan.name}}\n                  </th>\n                  <td ng-show=\"item.plan.usage_type != 'metered'\" class=\"text-left\">\n                    {{(item.plan.quantity * item.plan.amount / 100) | currency}}/{{item.plan.interval}}\n                    <span ng-if=\"item.plan.interval == 'month'\" class=\"text-muted\">\n                      | {{(item.plan.quantity * item.plan.amount * 12 / 100) | currency}} annually\n                    </span>\n                  </td>\n                  <td ng-show=\"item.plan.usage_type == 'metered'\" class=\"text-left\">\n                    <a href=\"javascript://\" ng-click=\"vm.showUsageSummary(item.id, item.plan, sub.current_period_start, null)\">\n                      View usage\n                    </a>\n                  </td>\n                </tr>\n                <tr ng-if=\"sub.discount && sub.discount.coupon\">\n                  <th style=\"width:60%\">\n                    Discount\n                  </th>\n                  <td class=\"text-left\">\n                    -{{(sub.discount.coupon.amount_off / 100) | currency}}{{vm.isBilledMonthly ? '/month' : '/year'}}\n                    <span ng-if=\"vm.isBilledMonthly\" class=\"text-muted\">\n                        | {{(sub.discount.coupon.amount_off * 12 / 100) | currency}} annually\n                    </span>\n                  </td>\n                </tr>\n              </tbody>\n              <tfoot>\n                <tr>\n                  <th>Next Payment</th>\n                  <td>\n                    {{(sub.total_amount / 100) | currency}} <span ng-show=\"sub.hasUsage\"> + usage </span>on {{sub.current_period_end * 1000 | date}}\n                  </td>\n                </tr>\n                <tr ng-if=\"sub.annual_renewal\">\n                  <th>Annual Contract Renew</th>\n                  <td>{{sub.annual_renewal | date}}</td>\n                </tr>\n              </tfoot>\n            </table>\n          </div>\n        </div>\n        <div ng-if=\"vm.canEditPaymentSettings && vm.subscriptions.length\" class=\"col-sm-4\">\n          <p ng-if=\"vm.canChat\">\n            Need help? <a href=\"javascript://\" ng-click=\"vm.onLetsChat()\">Let's Chat</a>\n          </p>\n          <p ng-show=\"!vm.isPremium\" class=\"text-right\">\n            <button class=\"btn btn-default btn-block\" ng-click=\"vm.doChangePlan()\" style=\"max-width:250px\">\n              Upgrade Plan\n            </button>\n          </p>\n          <p ng-show=\"!vm.isPremium && !vm.isFree\" class=\"text-right\">\n            <button class=\"btn btn-default btn-block\" ng-click=\"vm.doPurchaseAddons()\" style=\"max-width:250px\">\n              Purchase Add-Ons\n            </button>\n          </p>\n          <p class=\"text-right\">\n            <button ng-click=\"vm.showActivationModal()\" class=\"btn btn-default btn-block\" style=\"max-width:250px\">\n              Activation Codes\n            </button>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.billing\" class=\"col-sm-12\">\n    <div class=\"well\">\n      <div class=\"pull-right\" ng-if=\"::vm.canEditPaymentSettings\">\n        <a href=\"javascript://\" ng-click=\"vm.showEditPaymentModal()\">\n          Edit <i class=\"fa fa-pencil-square-o\"></i>\n        </a>\n      </div>\n      <h3>Payment Information</h3>\n      <div class=\"row\">\n        <div class=\"col-sm-8\">\n          <div ng-if=\"vm.billing.payment_method == 'activation' && vm.accountExpired\" class=\"bg-danger text-danger\"\n            style=\"padding:10px;border:1px solid;margin-bottom:5px;\">\n            Your activation code has expired. Please \n            <a href=\"javascript://\" ng-click=\"vm.showEditPaymentModal()\" style=\"border-bottom:1px dotted;\">add a payment source</a> \n            to ensure uninterrupted service.\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'activation' && !vm.accountExpired && vm.accountExpiresSoon\" class=\"bg-warning text-warning\"\n            style=\"padding:10px;border:1px solid;margin-bottom:5px;\">\n            Your activation code will expire soon. Please \n            <a href=\"javascript://\" ng-click=\"vm.showEditPaymentModal()\" style=\"border-bottom:1px dotted;\">add a payment source</a> \n            to ensure uninterrupted service.\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'cc' && vm.cardOnFile && vm.account.payment_status == 'declined' && vm.outstandingInvoices.length\"\n            class=\"bg-danger text-danger\" style=\"padding:10px;border:1px solid;margin-bottom:5px;\">\n            There was an issue charging your card. Please \n            <a href=\"javascript://\" ng-click=\"vm.showEditPaymentModal()\" style=\"border-bottom:1px dotted;\">update your payment source</a> \n            to ensure uninterrupted service.\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'ach' && vm.cardOnFile && vm.account.payment_status == 'declined' && vm.outstandingInvoices.length\"\n            class=\"bg-danger text-danger\" style=\"padding:10px;border:1px solid;margin-bottom:5px;\">\n            There was an issue with your ACH payment. Please \n            <a href=\"javascript://\" ng-click=\"vm.showEditPaymentModal()\" style=\"border-bottom:1px dotted;\">update your payment source</a> \n            to ensure uninterrupted service.\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-4\" style=\"width:39%\">\n          <div class=\"form-group\">\n            <label>Billing Email</label>\n            <h4 style=\"word-wrap:break-word\">{{vm.billing.email}}</h4>\n          </div>\n          <div class=\"form-group\" style=\"margin-top:30px\">\n            <label>Billing Address</label>\n            <h4 style=\"white-space:pre-wrap;\">{{vm.formattedAddress}}</h4>\n          </div>\n        </div>\n        <div class=\"col-sm-4\">\n          <div class=\"form-group\">\n            <label>Payment Method</label>\n            <div ng-if=\"vm.billing.payment_method == 'cc'\">\n              <h4 ng-if=\"vm.cardOnFile\">\n                <div style=\"margin-bottom:10px\">Paying by Credit Card</div>\n                <i class=\" fa fa-credit-card\"></i> {{vm.cardOnFile.brand}} **** **** **** {{vm.cardOnFile.last4}}\n              </h4>\n            </div>\n            <div ng-if=\"vm.billing.payment_method == 'ach'\">\n              <h4 ng-if=\"vm.cardOnFile\">\n                <div style=\"margin-bottom:10px\">Paying by Bank (ACH)</div>\n                <i class=\" fa fa-university\"></i> {{vm.cardOnFile.bank_name}} **** **** {{vm.cardOnFile.last4}}\n              </h4>\n            </div>\n            <h4 ng-if=\"vm.billing.payment_method == 'po'\">\n              Paying by Purchase Order\n              (<a href=\"javascript://\" ng-click=\"vm.showPurchaseOrderInstructions()\">Instructions</a>)\n            </h4>\n            <h4 ng-if=\"vm.billing.payment_method == 'check'\">\n              Paying by Check\n              (<a href=\"javascript://\" ng-click=\"vm.showCheckInstructions()\">Instructions</a>)\n            </h4>\n            <h4 ng-if=\"vm.billing.payment_method == 'activation'\">\n              Activation Code\n            </h4>\n            <h4 ng-if=\"vm.billing.payment_method == 'other' || ((vm.billing.payment_method == 'cc' || vm.billing.payment_method == 'ach') && !vm.cardOnFile)\">\n              <div style=\"margin-bottom:10px\">No Payment Source On File</div>\n              <button type=\"button\" ng-click=\"vm.showEditPaymentModal()\" class=\"btn btn-primary\">Add a Payment Source</button>\n            </h4>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'cc' && vm.cardOnFile\" class=\"form-group\" style=\"margin-top:30px\">\n            <label>Expires</label>\n            <h4>{{vm.cardOnFile.exp_month}}/{{vm.cardOnFile.exp_year}}</h4>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'ach' && vm.cardOnFile\" class=\"form-group\" style=\"margin-top:30px\">\n            <label>Status</label>\n            <h4 style=\"text-transform:capitalize;\">{{vm.cardOnFile.status}}</h4>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'activation'\" class=\"form-group\" style=\"margin-top:30px\">\n            <label>Expires</label>\n            <h4>{{vm.account.expires_on | date}}</h4>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.paidInvoices.length\" class=\"col-sm-12\">\n    <div class=\"well\">\n      <h3>Payment History</h3>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <table class=\"table table-condensed table-noborders\">\n            <thead>\n              <tr>\n                <th style=\"width:20%\">Date</th>\n                <th style=\"width:20%\">Total</th>\n                <th></th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"inv in vm.paidInvoices\">\n                <td>{{(inv.date*1000) | date}}</td>\n                <td>{{(inv.amount_due / 100) | currency}}</td>\n                <td class=\"text-left\">\n                  <a ng-if=\"inv.hosted_invoice_url\" href=\"{{inv.hosted_invoice_url}}\" target=\"_blank\">\n                    <strong>View invoice <i class=\"fa fa-external-link\"></i></strong>\n                  </a>\n                  <span ng-if=\"inv.usage && inv.usage.length > 0\" ng-repeat=\"usage in inv.usage\">\n                    &nbsp;|&nbsp;\n                    <a \n                      href=\"javascript://\"\n                      ng-click=\"vm.showUsageSummary(usage.subscriptionItemId, usage.plan, usage.periodStart, usage.periodEnd)\">\n                      View {{usage.type | usageType}} usage\n                    </a>\n                  </span>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div id=\"shipment-history\" ng-show=\"vm.orders\" class=\"col-sm-12\">\n    <div ng-if=\"vm.orders\" class=\"well\">\n      <h3>Shipment History</h3>\n      <div class=\"row\" ng-if=\"vm.orders.length\">\n        <div class=\"col-sm-12\">\n          <table class=\"table table-condensed table-noborders\">\n            <thead>\n              <tr>\n                <th style=\"width:20%\">Order Date</th>\n                <th style=\"width:20%\">Status</th>\n                <th style=\"width:30%\">Items</th>\n                <th></th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"order in vm.orders\">\n                <td>{{order.created_at | date}}</td>\n                <td ng-switch=\"order.status\" style=\"padding-right: 1rem\">\n                  <span ng-switch-when=\"on_hold\" class=\"label label-danger\">Backordered</span>\n                  <span ng-switch-when=\"awaiting_payment\" class=\"label label-warning\">Awaiting Payment</span>\n                  <span ng-switch-when=\"awaiting_shipment\" class=\"label label-success\">Awaiting Shipment</span>\n                  <span ng-switch-when=\"shipped\" class=\"label label-success\">Shipped</span>\n                </td>\n                <td style=\"padding-right: 1rem\">\n                  <div ng-repeat=\"item in order.items\">\n                    <small>{{item.quantity}} &#8212; {{item.name}}</small>\n                  </div>\n                </td>\n                <td>\n                  <button class=\"btn btn-default btn-sm\" ng-click=\"vm.showOrderStatus(order)\">\n                    View Details\n                  </button>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"!vm.orders.length\">\n        <div class=\"col-sm-8\">\n          No shipment history.\n        </div>\n      </div>\n    </div>\n  </div>\n\n  </div>\n</main>"

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_stripe__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_checkout__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isStreamMonkey__ = __webpack_require__(10);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }





var UpdatePaymentController = /*#__PURE__*/function () {
  function UpdatePaymentController($rootScope, $http, $uibModal, $timeout, $state, $q, Account, ActivationCodes, Order, MeetingsService, toaster, $scope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, UpdatePaymentController);

    this.account = $rootScope.account;
    this.user = $rootScope.user;
    this.$http = $http;
    this.$uibModal = $uibModal;
    this.$timeout = $timeout;
    this.Account = Account;
    this.ActivationCodes = ActivationCodes;
    this.Order = Order;
    this.MeetingsService = MeetingsService;
    this.toaster = toaster;
    this.$state = $state;
    this.$scope = $scope;
    this.canEditPaymentSettings = $rootScope.user.can('update', 'billing');
    this.codes = this.ActivationCodes.query();
    this.accountExpired = moment(this.account.expires_on).toDate() < new Date();
    this.accountExpiresSoon = moment(this.account.expires_on).add(-30, 'day').toDate() < new Date();
    this.loadingPromises = [];
    this.isStreamMonkey = Object(__WEBPACK_IMPORTED_MODULE_2__utils_isStreamMonkey__["a" /* default */])(this.account.migration_service_id);
    this.isFree = this.account.contract == 'free' || this.account.contract == 'free2';
    this.reload();

    if (this.user.can('list', 'upgrades')) {
      this.loadingPromises.push(this.Account.getUpgrades(function (r) {
        _this.upgradesAvailable = r.filter(function (u) {
          return !u.self_service;
        });
      }).$promise);
    }

    this.loadingPromises.push(this.Order.query({
      page: 1,
      page_size: 10
    }, function (result) {
      _this.orders = _.filter(result, function (order) {
        return order.status != 'cancelled';
      });
    }).$promise);
    this.loading = true;
    $q.all(this.loadingPromises)["finally"](function () {
      _this.loading = false; // Do scrolling if requested

      var params = $state.params;

      if (params.show_orders) {
        $timeout(function () {
          $('html, body').animate({
            scrollTop: $('#shipment-history').offset().top - 90
          });
        });
      }
    }); // Check for passed-in parameters

    var params = $state.params;

    if (params.pd_did && params.pd_sid) {
      this.review(params.pd_did, params.pd_sid);
    } else if (params.action === 'checkout') {
      this.completeCheckout({});
    } else if (params.action === 'order_status') {
      $q.all(this.loadingPromises).then(function () {
        if (_this.orders.length) {
          _this.showOrderStatus(_this.orders[0]);
        }
      });
    }
  }

  _createClass(UpdatePaymentController, [{
    key: "reload",
    value: function reload() {
      var _this2 = this;

      var $http = this.$http,
          toaster = this.toaster;
      if (this.user.cannot('read', 'billing')) return;
      this.billing = this.Account.getBilling();
      this.billing.$promise.then(function () {
        var billingResult = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["d" /* parseBilling */])(_this2.billing);
        _this2.cardOnFile = billingResult.cardOnFile || billingResult.bankOnFile;
        _this2.paidInvoices = billingResult.paidInvoices;
        _this2.outstandingInvoices = billingResult.outstandingInvoices;
        _this2.daysUntilSuspend = billingResult.daysUntilSuspend;
        _this2.subscriptions = billingResult.subscriptions;
        _this2.isBilledMonthly = billingResult.isBilledMonthly;
        _this2.formattedAddress = billingResult.formattedAddress;
        _this2.isPremium = billingResult.isPremiumPlan;
      })["catch"](function (err) {
        if (err.status == 404) {// No Stripe customer for this account
        } else {
          console.error(err);
          toaster.pop('warning', 'Unable to load your current payment information. Please reload this page and try again.');
        }
      });
      this.loadingPromises.push(this.billing.$promise);
    }
  }, {
    key: "showEditPaymentModal",
    value: function showEditPaymentModal() {
      var $uibModal = this.$uibModal;

      var _parentVM = this;

      $uibModal.open({
        template: __webpack_require__(521),
        controller: __webpack_require__(522)["default"],
        controllerAs: 'vm',
        resolve: {
          parentVM: function parentVM() {
            return _parentVM;
          }
        },
        //  Prevent accidental close...
        keyboard: false,
        backdrop: 'static'
      });
    }
  }, {
    key: "showActivationModal",
    value: function showActivationModal() {
      var $uibModal = this.$uibModal;
      var parentVM = this;
      $uibModal.open({
        template: __webpack_require__(523),
        controller: function controller($scope, $rootScope, $uibModalInstance, toaster, ActivationCodes) {
          'ngInject';

          $scope.toaster = toaster;
          $scope.ActivationCodes = ActivationCodes;
          $scope.codes = angular.copy(parentVM.codes);

          $scope.validateAndUseActivationCode = function () {
            $scope.activating = true;
            $scope.activation_code = $scope.formatActivationCode($scope.activation_code || '');

            if ($scope.activation_code.length !== 24) {
              $scope.activating = false;
              $scope.toaster.pop('warning', 'Invalid activation code.');
              return;
            }

            $scope.ActivationCodes.activateAddon({
              id: $scope.activation_code
            }).$promise.then(function (data) {
              $scope.activating = false;
              $scope.toaster.pop('success', 'Successfully activated.');
              window.location = window.location.href.split('?')[0];
              window.location.reload();
              return;
            }, function (err) {
              console.error(err);
              $scope.activating = false;
              $scope.toaster.pop('warning', "Unable to activate code. ".concat(err.data.error_description));
              return;
            });
          };

          $scope.formatActivationCode = function (id) {
            try {
              return id.split('-').join('').match(new RegExp('.{1,4}', 'g')).join('-').toUpperCase();
            } catch (e) {
              return id;
            }
          };

          $scope.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };
        }
      });
    }
  }, {
    key: "doChangePlan",
    value: function doChangePlan() {
      var checkoutURL = window.VUE_DASHBOARD_ROOT + '/checkout';
      window.location.href = checkoutURL;
    }
  }, {
    key: "doPurchaseAddons",
    value: function doPurchaseAddons() {
      var checkoutURL = window.VUE_DASHBOARD_ROOT + '/checkout?start_step=add-on';
      window.location.href = checkoutURL;
    }
  }, {
    key: "onLetsChat",
    value: function onLetsChat() {
      if (window.Intercom) {
        window.Intercom('show');
      }
    }
  }, {
    key: "canChat",
    value: function canChat() {
      return !!window.Intercom;
    }
  }, {
    key: "showCheckInstructions",
    value: function showCheckInstructions() {
      var $uibModal = this.$uibModal;
      $uibModal.open({
        template: __webpack_require__(524),
        controller: function controller($scope, $uibModalInstance) {
          'ngInject';

          $scope.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };
        }
      });
    }
  }, {
    key: "showPurchaseOrderInstructions",
    value: function showPurchaseOrderInstructions() {
      var $uibModal = this.$uibModal;
      $uibModal.open({
        template: __webpack_require__(525),
        controller: function controller($scope, $uibModalInstance) {
          'ngInject';

          $scope.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };
        }
      });
    }
  }, {
    key: "review",
    value: function review(pd_did, pd_sid) {
      var account = this.account;
      var params = {
        pd_did: pd_did,
        pd_sid: pd_sid
      };

      if (!account.isTrialing()) {
        params.is_upgrade = true;
      }

      this.completeCheckout(params);
    }
  }, {
    key: "completeCheckout",
    value: function completeCheckout(params) {
      var $uibModal = this.$uibModal,
          $scope = this.$scope;

      if (this.isStreamMonkey && params.is_upgrade != true) {
        var instance = $uibModal.open({
          template: __webpack_require__(217),
          controller: __WEBPACK_IMPORTED_MODULE_1__modal_checkout__["a" /* default */],
          controllerAs: 'vm',
          backdrop: 'static',
          keyboard: false,
          size: 'lg',
          resolve: {
            params: function params() {
              return {};
            },
            isStreamMonkeyMode: true
          }
        }).result.then(function (accountData) {
          if (accountData.status === 'active') {
            $rootScope.$emit('account-migrated');
          }
        });
      } else {
        var checkoutURL = window.VUE_DASHBOARD_ROOT + "/checkout?pd_did=".concat(params.pd_did, "&pd_sid=").concat(params.pd_sid);
        window.location.href = checkoutURL;
      }

      $scope.$on('$destroy', function () {
        if (instance) instance.close();
      });
    }
  }, {
    key: "showOrderStatus",
    value: function showOrderStatus(_order) {
      var _this3 = this;

      this.$uibModal.open({
        template: __webpack_require__(218),
        resolve: {
          order: function order() {
            return _order;
          },
          account: function account() {
            return _this3.account;
          },
          showOrdersLink: function showOrdersLink() {
            return false;
          }
        },
        controller: __webpack_require__(219)["default"],
        controllerAs: 'vm'
      });
    }
  }, {
    key: "showUsageSummary",
    value: function showUsageSummary(_subscriptionItemId, _plan, _periodStart, _periodEnd) {
      this.$uibModal.open({
        template: __webpack_require__(526),
        resolve: {
          subscriptionItemId: function subscriptionItemId() {
            return _subscriptionItemId;
          },
          plan: function plan() {
            return _plan;
          },
          periodStart: function periodStart() {
            return _periodStart;
          },
          periodEnd: function periodEnd() {
            return _periodEnd;
          }
        },
        controller: __webpack_require__(527)["default"],
        controllerAs: 'vm'
      });
    }
  }]);

  return UpdatePaymentController;
}();

/* harmony default export */ __webpack_exports__["default"] = (UpdatePaymentController);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n    <h3 class=\"modal-title\">Edit Payment Info</h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div class=\"form-group\">\n          <div ng-if=\"vm.hasPaymentMethod()\" class=\"pull-right\">\n            <a href=\"javascript://\" ng-click=\"vm.changePaymentMethod()\" style=\"font-size:10pt;border-bottom:1px dotted;\">\n              Change Payment Method\n            </a>\n          </div>\n          <label>Payment Method</label>\n          <div ng-if=\"!vm.hasPaymentMethod()\" class=\"col-xs-12 col-md-8 col-md-offset-2\">\n            <div class=\"row text-center\" style=\"margin-top:30px\">\n              <checkout-payment-method vm=\"vm\"></checkout-payment-method>\n            </div>\n          </div>\n      \n          <div ng-if=\"vm.billing.payment_method == 'cc'\">\n            Paying by Credit Card\n            <div ng-if=\"vm.cardOnFile\" style=\"margin-top:5px;\">\n              <i class=\"fa fa-credit-card\"></i> {{vm.cardOnFile.brand}} **** **** **** {{vm.cardOnFile.last4}}\n              (Expires: {{vm.cardOnFile.exp_month}}/{{vm.cardOnFile.exp_year}})\n              <div ng-if=\"vm.changingPaymentMethod\" class=\"bg-info text-info\" style=\"padding:10px;border:1px solid;margin-bottom:5px;margin-top:5px;\">\n                This card will be used for all future payments\n              </div>\n            </div>\n            <div ng-if=\"!vm.cardOnFile\">\n              <div class=\"well\" style=\"margin:15px 0 0 0\">\n                <div class=\"form-control\"\n                      style=\"height:38px;padding-top:10px;margin-bottom:15px;\"\n                      ng-init=\"vm.stripeCard.mount('#stripe-elements-card')\">\n                  <div id=\"stripe-elements-card\"></div>\n                </div>\n                  <p><button type=\"button\" class=\"btn btn-block btn-primary\" ng-click=\"vm.addNewCard()\"\n                    ng-disabled=\"vm.addingCard\">Add</button></p>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'ach'\">\n            Paying by Bank (ACH)\n            <div ng-if=\"vm.cardOnFile\" style=\"margin-top:5px;\">\n              <i class=\" fa fa-university\"></i>  {{vm.cardOnFile.bank_name}} **** **** {{vm.cardOnFile.last4}}\n              <span style=\"text-transform: capitalize\">({{vm.cardOnFile.status}})</span>\n              <div ng-if=\"vm.changingPaymentMethod\" class=\"bg-info text-info\" style=\"padding:10px;border:1px solid;margin-bottom:5px;margin-top:5px;\">\n                This bank account will be used for all future payments\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'po'\">\n            Paying by Purchase Order\n            <div ng-if=\"vm.changingPaymentMethod\" class=\"bg-info text-info\" style=\"padding:10px;border:1px solid;margin-bottom:5px;margin-top:5px;\">\n              <p>Purchase orders are to be emailed to <strong>billing@boxcast.com</strong> or mailed to </p>\n              <strong>\n                BoxCast</br>\n                Attn: Payments Dept</br>\n                2401 Superior Via</br>\n                Cleveland, OH 44113</br></br>\n              </strong>\n              <p>by the due date indicated on each invoice. This payment change will apply to all future invoices.</p>\n            </div>\n          </div>\n          <div ng-if=\"vm.billing.payment_method == 'check'\">\n            Paying by Check\n            <div ng-if=\"vm.changingPaymentMethod\" class=\"bg-info text-info\" style=\"padding:10px;border:1px solid;margin-bottom:5px;margin-top:5px;\">\n              <p>Checks are to be made payable to <strong>BoxCast</strong> and mailed to </p>\n              <strong>\n                BoxCast</br>\n                Attn: Payments Dept</br>\n                2401 Superior Via</br>\n                Cleveland, OH 44113</br></br>\n              </strong>\n              <p>by the due date indicated on each invoice. This payment change will apply to all future invoices.</p></div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"col-xs-12\">\n        <div class=\"form-group\">\n          <label>Billing Email</label>\n          <input type=\"email\" class=\"form-control\" ng-model=\"vm.billing.email\" required>\n        </div>\n        <div class=\"form-group\">\n          <label>Billing Address</label>\n          <input type=\"text\" class=\"form-control\" ng-model=\"vm.billing.address\" placeholder=\"Address\" required>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-5\">\n            <div class=\"form-group\">\n              <input type=\"text\" class=\"form-control\" ng-model=\"vm.billing.city\" placeholder=\"City\" required>\n            </div>\n          </div>\n          <div class=\"col-xs-4\">\n            <div class=\"form-group\">\n              <input ng-if=\"vm.billing.country != 'US'\" type=\"text\" class=\"form-control\" ng-model=\"vm.billing.state\" placeholder=\"State\" required>\n              <select ng-if=\"vm.billing.country == 'US'\"\n                ng-model=\"vm.billing.state\"\n                ng-options=\"c.code as c.name for c in vm.states\"\n                id=\"state\" name=\"state\" class=\"form-control\" required>\n              </select>\n            </div>\n          </div>\n          <div class=\"col-xs-3\">\n            <div class=\"form-group\">\n              <input type=\"text\" class=\"form-control\" ng-model=\"vm.billing.postal_code\" placeholder=\"Postal Code\" required>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"form-group\">\n            <div class=\"col-xs-4\">\n              <select ng-model=\"vm.billing.country\"\n                ng-options=\"c.code as c.name for c in vm.countries\"\n                id=\"country\" name=\"country\" class=\"form-control\" required>\n              </select>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n      <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n      <button ng-disabled=\"vm.submitting || !form.$valid || (vm.billing.payment_method == 'cc' && !vm.cardOnFile)\"\n              ng-click=\"vm.update()\"\n              class=\"btn btn-primary\">\n        <i ng-show=\"vm.submitting\" class=\"fa fa-spin fa-spinner\"></i>\n        Update Settings\n      </button> \n  </div>\n</form>\n"

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalEditPaymentController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_stripe__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_error__ = __webpack_require__(19);


function ModalEditPaymentController(Account, Checkout, $uibModal, $uibModalInstance, $http, $timeout, toaster, $rootScope, $cacheFactory, parentVM) {
  'ngInject';

  var _this = this;

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this.$http = $http;
  this.$timeout = $timeout;
  this.$cacheFactory = $cacheFactory;
  this.$rootScope = $rootScope;
  this.toaster = toaster;
  this.account = $rootScope.account;
  this.Account = Account;
  this.states = [];
  this.$http.get('/img/states.json').then(function (response) {
    _this.states = response.data;
  });
  this.countries = [];
  this.$http.get('/img/countries.json').then(function (response) {
    _this.countries = response.data;
  });
  this.billing = angular.copy(parentVM.billing);
  this.cardOnFile = angular.copy(parentVM.cardOnFile);

  if (!this.billing.country || this.billing.country == '') {
    this.billing.country = 'US';
  }

  this.stripeCard = Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["a" /* getStripeCard */])();

  this.checkPreviousSelectedPayment = function () {
    var paymentException = _this.billing.payment_method === 'check' || _this.billing.payment_method === 'po';

    if (Checkout.currentInterval(_this.billing) === 'month' && paymentException) {
      _this.showAllPaymentOptions = true;
    }
  };

  this.changePaymentMethod = function () {
    _this.checkPreviousSelectedPayment();

    _this.billing.payment_method = null;
    _this.cardOnFile = null;
    _this.newStripeToken = null;
    _this.changingPaymentMethod = true;

    if (Checkout.currentInterval(_this.billing) === 'month') {
      _this.selectedInterval = 'monthly';
    }
  };

  this.hasPaymentMethod = function () {
    return _this.billing.payment_method && _.includes(['cc', 'ach', 'po', 'check'], _this.billing.payment_method);
  };

  if (!this.hasPaymentMethod()) {
    this.changePaymentMethod();
  }

  this.addNewCard = function () {
    _this.addingCard = true;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["b" /* getToken */])(_this.stripeCard).then(function (token) {
      _this.$timeout(function () {
        _this.newStripeToken = token.id;
        _this.cardOnFile = token.card;
      });
    })["catch"](function (err) {
      _this.$timeout(function () {
        _this.toaster.pop('warning', 'Unable to process credit card: ' + err);
      });
    })["finally"](function () {
      _this.addingCard = false;
    });
  };

  this.openPlaidLink = function () {
    if (!_this._linkHandler) {
      _this._linkHandler = Plaid.create({
        env: PLAID_ENV,
        key: PLAID_KEY,
        apiVersion: 'v2',
        clientName: 'BoxCast',
        product: ['auth'],
        selectAccount: true,
        onSuccess: function onSuccess(public_token, metadata) {
          return _onBankAccountLinkedViaPlaid(public_token, metadata);
        }
      });
    }

    _this._linkHandler.open();
  };

  this.onSelectPaymentMethod = function (m) {
    _this.billing.payment_method = m;

    if (m == 'ach') {
      _this.openPlaidLink();
    }
  };

  var _onBankAccountLinkedViaPlaid = function _onBankAccountLinkedViaPlaid(public_token, metadata) {
    console.log('Plaid public_token', public_token);
    console.log('Plaid metadata', metadata);

    _this.$http.post("".concat(INTEGRATIONS_ROOT, "/plaid/exchange_token"), {
      public_token: public_token,
      plaid_account_id: metadata.account_id
    }).then(function (response) {
      _this.billing.payment_method = 'ach';
      _this.newStripeToken = response.data.stripe_bank_account_token;
      _this.cardOnFile = null;
    })["catch"](function (err) {
      console.error('Error exchanging Plaid token', err);

      _this.toaster.pop('warning', 'We were unable to associate your bank account with our payment provider.'); // XXX: TODO: save the public_token so that we can manually exchange/link

    });
  };

  this.update = function () {
    _this.submitting = true;
    var updates = {
      address: _this.billing.address,
      city: _this.billing.city,
      country: _this.billing.country,
      state: _this.billing.state,
      email: _this.billing.email,
      postal_code: _this.billing.postal_code
    };

    if (_this.changingPaymentMethod) {
      updates.payment_method = _this.billing.payment_method;
    }

    if (_this.newStripeToken) {
      updates.stripe_token = _this.newStripeToken;
    }

    _this.Account.updateBilling(updates).$promise.then(function (billing) {
      // Invalidate cache
      _this.$cacheFactory.get('$http').remove("".concat(API_ROOT, "/account"));

      _this.$rootScope.account.payment_method = billing.payment_method;

      _this.cancel();

      parentVM.reload();
    })["catch"](function (err) {
      console.log(err);
      var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_1__utils_error__["a" /* errorDescriptionFromResponse */])(err);

      _this.toaster.pop('warning', 'Error updating payment settings', errorDetails);
    })["finally"](function () {
      _this.submitting = false;
    });
  };
}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n    <h3 class=\"modal-title\">Activation Codes</h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <table class=\"table\" ng-if=\"codes.length\">\n        <thead>\n          <tr>\n            <th>Existing Activation(s)</th>\n            <th class=\"text-right\">Activated On</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"code in codes\">\n            <td>{{code.plan_name}}</td>\n            <td class=\"text-right\">{{code.activated_at | date:'MMM d, yyyy':'UTC'}}</td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n      <p class=\"col-xs-12\" class=\"help-block\">If you have purchased an add-on activation code from an authorized\n        reseller, please enter it here.</p>\n      <div class=\"form-group col-xs-8\">\n        <input type=\"text\" class=\"form-control\" id=\"code\" ng-model=\"activation_code\" required\n          placeholder=\"XXXX-XXXX-XXXX-XXXX-XXXX\" autocomplete=\"off\">\n      </div>\n      <button ng-disabled=\"activating\"\n            ng-click=\"validateAndUseActivationCode()\"\n            class=\"btn btn-primary\">\n        <i ng-show=\"activating\" class=\"fa fa-spin fa-spinner\"></i>\n        Activate\n      </button> \n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancel</button>\n  </div>\n</form>\n"

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Paying via Check</h3>\n</div>\n<div class=\"modal-body\">\n  <p>1) Make the check payable to <strong>BoxCast</strong></p>\n  <p>2) Mail the check to:<br>\n    <strong>\n      BoxCast<br>\n      Attn: Payments Dept<br>\n      2401 Superior Viaduct<br>\n      Cleveland, OH 44113\n    </strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancel</button>\n</div>\n"

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Paying via Purchase Order</h3>\n</div>\n<div class=\"modal-body\">\n  <p>1) Review open invoices.</p>\n  <p>2) Send in the Purchase Order by one of the following methods:</p>\n  <p>\n    <table>\n      <tr>\n        <td>Email:</td>\n        <td>&nbsp;</td>\n        <td><a href=\"mailto:payments@boxcast.com\" target=\"_blank\">payments@boxcast.com</a></td>\n      </tr>\n      <tr>\n        <td valign=\"top\">Mail:</td>\n        <td>&nbsp;</td>\n        <td>BoxCast<br>\n          Attn: Payments Dept<br>\n          2401 Superior Viaduct<br>\n          Cleveland, OH 44113\n        </td>\n      </tr>\n    </table>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancel</button>\n</div>\n"

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h4 class=\"modal-title\">\n    <span style=\"text-transform:capitalize\">{{vm.usageType | usageType}}</span>\n    Usage for <strong>{{vm.periodStart*1000 | date}}</strong> to\n    <strong ng-show=\"vm.periodEnd\">{{vm.periodEnd*1000 | date}}</strong>\n    <strong ng-show=\"!vm.periodEnd\">Now</strong>\n  </h4>\n</div>\n<div class=\"modal-body\">\n  <main class=\"container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\"></main>\n  <div ng-if=\"!vm.summary && !vm.loading\">\n    <p>\n      There is no usage recorded for this period.\n      <span ng-show=\"!vm.periodEnd\">\n        Usage can take up to 24 hours to appear in the Dashboard. Please check back later.\n      </span>\n    </p>\n  </div>\n  <div ng-if=\"vm.summary\">\n    <p class=\"text-muted\">Last collected on: {{vm.summary.last_collected | date : 'short'}}</p>\n    <p class=\"text-muted\"><small>\n      Usage may take up to 24 hours to be collected. Because of this, usage at the end of the month\n      may not be charged until the following billing period.\n    </small></p>\n    <div class=\"row\" style=\"padding:5px\">\n      <div ng-show=\"vm.summary.total_usage || vm.summary.total_usage == 0\" class=\"col-xs-6 text-center\" style=\"border-right:1px solid #ccc;border-top:1px solid #ccc;padding:10px\">\n        <h4 class=\"text-muted\" style=\"margin-top:0\"><strong>QUANTITY</strong></h4>\n        <h2 style=\"margin-top:0\">\n          {{vm.summary.total_usage}}\n          <span ng-show=\"vm.summary.total_usage == 1\">hour</span>\n          <span ng-show=\"vm.summary.total_usage != 1\">hours</span>\n        </h2>\n      </div>\n      <div ng-show=\"vm.summary.amount_cents || vm.summary.amount_cents == 0\" class=\"col-xs-6 text-center\" style=\"border-top:1px solid #ccc;padding:10px\">\n        <h4 class=\"text-muted\" style=\"margin-top:0\"><strong>COST</strong></h4>\n        <h2 style=\"margin-top:0\">{{vm.summary.amount_cents/100 | currency}}</h2>\n      </div>\n      <div ng-show=\"!vm.summary.records || vm.summary.records.length == 0\" class=\"col-xs-12\" style=\"padding:10px\">\n        There is no usage recorded for this period.\n      </div>\n      <div ng-show=\"vm.summary.records.length > 0\" class=\"col-xs-12 tex-center\" style=\"background:#fff;border-top:1px solid #ccc;padding:10px\">\n        <h4 class=\"text-muted text-center\" style=\"margin-top:0\"><strong>DETAILS</strong></h4>\n        <div class=\"table-fix-head\">\n        <table class=\"table table-condensed table-striped\" style=\"margin-bottom:0\">\n          <thead>\n            <tr>\n              <th>Broadcast Name</th>\n              <th class=\"text-center\">Broadcast Date</th>\n              <th class=\"text-right\" style=\"padding:5px 10px 5px 10px;white-space:nowrap\">\n                <span ng-switch=\"vm.summary.type\">\n                  <span ng-switch-when=\"viewership\">\n                    Total Viewer Minutes\n                  </span>\n                  <span ng-switch-default>\n                    Broadcast Duration\n                  </span>\n                </span>\n              </th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"record in vm.summary.records\">\n              <td ng-show=\"!record.broadcast.deleted\">\n                <a ui-sref=\"events.detail({id: record.broadcast.id})\" target=\"_blank\">{{record.broadcast.name}}</a>\n              </td>\n              <td ng-show=\"record.broadcast.deleted\">\n                <i class=\"fa fa-minus-circle\" uib-tooltip=\"Broadcast was deleted\" tooltip-append-to-body=\"true\"></i>\n                {{record.broadcast.name}}\n              </td>\n              <td class=\"text-center\" style=\"white-space:nowrap\"><span>{{record.broadcast.starts_at | date : 'short'}}</span></td>\n              <td class=\"text-right\" style=\"padding-right:25px\">{{record.duration}}</td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalUsageSummary;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date__ = __webpack_require__(4);

function ModalUsageSummary(Account, $uibModalInstance, $filter, toaster, subscriptionItemId, plan, periodStart, periodEnd) {
  'ngInject';

  var _this = this;

  this.subscriptionItemId = subscriptionItemId;
  this.plan = plan;
  this.periodStart = periodStart;
  this.periodEnd = periodEnd;
  this.usageType = plan.metadata.usage_type;
  this.summaries = Account.getUsageSummaries({
    stripe_subscription_item_id: this.subscriptionItemId,
    subscription_period_start: periodStart
  });
  this.loadingPromises = [this.summaries.$promise];
  this.loading = true;
  this.summaries.$promise.then(function (r) {
    if (r.length > 0) {
      _this.summary = r[0];

      _.forEach(_this.summary.records, function (record) {
        switch (_this.summary.type) {
          case 'broadcast_duration':
          case 'captioning':
            record.duration = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date__["e" /* secondsToFormattedLabel */])(record.qty);
            break;

          case 'viewership':
            record.duration = $filter('number')(Math.round(record.qty / 60));
        }
      });
    }

    _this.loading = false;
  })["catch"](function (err) {
    toaster.pop('warning', 'Unable to load usage summary. Please refresh the page and try again.');
    console.error(err);
    _this.loading = false;
  });

  this.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <p class=\"help-block\">\n        Please wait while your account link is processed.\n        If you are stuck here, <a ui-sref=\"settings.integrations\">return to the integrations page</a>.\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_utils__ = __webpack_require__(13);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// TODO: Should I be using this, or just use local storage directly?

var TWITTER_AUTH_URL = 'https://api.twitter.com/oauth/authorize';

var TwitterSettingsController = /*#__PURE__*/function () {
  function TwitterSettingsController(TwitterUser, toaster, $http, $state, $window) {
    'ngInject';

    _classCallCheck(this, TwitterSettingsController);

    this.TwitterUser = TwitterUser;
    this.toaster = toaster;
    this.$http = $http;
    this.$state = $state;
    this.$window = $window;

    if ($state.params.link) {
      this._linkAccount();
    } else {
      var urlParams = new URLSearchParams($window.location.search);
      var denied = urlParams.get('denied');
      var oauthToken = urlParams.get('oauth_token');
      var oauthVerifier = urlParams.get('oauth_verifier');

      if (oauthToken && oauthVerifier || denied) {
        this._handleOauthCallback(oauthToken, oauthVerifier, denied);
      } else {
        $state.go('settings.integrations');
      }
    }
  }

  _createClass(TwitterSettingsController, [{
    key: "_handleOauthCallback",
    value: function _handleOauthCallback(token, verifier, denied) {
      var _this = this;

      if (denied) return this._handleLinkError('Authorize was denied');
      if (!token) return this._handleLinkError('Missing oauth_token');
      if (!verifier) return this._handleLinkError('Missing oauth_verifier');
      var storedToken = __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].get('twitterToken');
      if (storedToken != token) return this._handleLinkError('Unexpected oauth_token');
      var secret = __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].get('twitterTokenSecret');
      var user = new this.TwitterUser({
        token: token,
        secret: secret,
        verifier: verifier
      });
      var promise = user.$save().then(function (u) {
        var l = _this.$window.location;
        l.href = l.protocol + '//' + l.host + l.pathname + "#/settings/integrations?integration_id=".concat(u.id);
      })["catch"](function (err) {
        return _this._handleLinkError(err);
      });
      this.loadingPromises = [promise];
    }
  }, {
    key: "_linkAccount",
    value: function _linkAccount() {
      var _this2 = this;

      var promise = this.$http.post("".concat(API_ROOT, "/twitter/oauth/request_token"), {
        oauth_callback: TWITTER_OAUTH_REDIRECT
      }).then(function (resp) {
        return _this2._requestTokenResponse(resp.data);
      }, function (err) {
        return _this2._handleLinkError(err);
      });
      this.loadingPromises = [promise];
    }
  }, {
    key: "_handleLinkError",
    value: function _handleLinkError(errorMsg, obj) {
      var _console;

      (_console = console).error.apply(_console, _toConsumableArray([errorMsg, obj].filter(function (e) {
        return e;
      })));

      this.toaster.pop('warning', 'Unable to link the requested Twitter account. Please reload this page and try again.');
    }
  }, {
    key: "_requestTokenResponse",
    value: function _requestTokenResponse(resp) {
      // Ok, got a request token! Let's make sure it's confirmed
      if (!resp.oauth_callback_confirmed || !resp.oauth_token || !resp.oauth_token_secret) {
        return this._handleLinkError('Request token request failed', resp);
      }

      var twitterToken = resp.oauth_token;
      var twitterTokenSecret = resp.oauth_token_secret; // Ok, callback confirmed. Store the token and secret in local storage for later.

      __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].set('twitterToken', twitterToken);
      __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].set('twitterTokenSecret', twitterTokenSecret); // Send to oauth/authorize?oauth_token=XXX (Step 2); they'll come back with a token and a verifier

      window.location.replace(TWITTER_AUTH_URL + '?oauth_token=' + twitterToken);
    }
  }]);

  return TwitterSettingsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (TwitterSettingsController);

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <p class=\"help-block\">\n        Please wait while you are redirected.\n        If you are stuck here, <a ui-sref=\"settings.integrations\">return to the integrations page</a>.\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('sources', "", function () {
  // Migrated to dashboard_vue
  window.location.href = '/sources';
}, 'SourcesController'));

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.
var module = angular.module('switcher-studio', []);
module.config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('switcher-studio', {
    url: '/switcher-studio',
    template: '<div ui-view></div>',
    "abstract": true
  }).state('switcher-studio.events', {
    url: '',
    template: __webpack_require__(533),
    controller: __webpack_require__(534)["default"],
    controllerAs: 'vm'
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"vm.loading\" id=\"loading\">\n  <div>\n    <div class=\"frosted-o\"></div>\n  </div>\n</div>\n\n<main ng-hide=\"vm.loading\" class=\"container\" style=\"margin-top:15px\">\n\n  <div class=\"col-xs-4 text-left\" style=\"line-height:32px\">\n    <img src=\"/img/boxcast_logo_dark.png\" class=\"logo\"  alt=\"BoxCast Logo\" style=\"max-width:100%;max-height:32px;\">\n  </div>\n  <div class=\"col-xs-8 text-center\">\n    <div class=\"btn-group btn-group-justified\" role=\"group\">\n      <button ng-class=\"vm.tab=='scheduled'?'active':''\" ng-click=\"vm.tab = 'scheduled'\" type=\"button\" class=\"btn btn-boxcast\" style=\"width:33.33%\">\n        <i class=\"fa fa-calendar\"></i> <!--Scheduled Events-->\n      </button>\n      <button ng-class=\"vm.tab=='new'?'active':''\" ng-click=\"vm.tab = 'new'\" type=\"button\" class=\"btn btn-boxcast\" style=\"width:33.33%\">\n        <i class=\"fa fa-plus\"></i> <!--New Event-->\n      </button>\n      <button ng-class=\"vm.tab=='help'?'active':''\" ng-click=\"vm.tab = 'help'\" type=\"button\" class=\"btn btn-boxcast\" style=\"width:33.33%\">\n        <i class=\"fa fa-question\"></i> <!--Help-->\n      </button>\n    </div>\n  </div>\n  <div class=\"clearfix\"></div>\n\n  <div ng-show=\"vm.tab == 'new'\" class=\"container-fluid\" style=\"max-width:720px;margin-top:15px;\">\n    <!-- XXX: form needs to be here so it is accessible in service for validation -->\n    <form name=\"form\" role=\"form\">\n      <new-event-quick></new-event-quick>\n\n      <div style=\"text-align:center;margin:15px 0\">\n        <div ng-show=\"vm.bandwidth\">\n          Detected upload bandwidth of {{vm.bandwidth.availableBandwidth | bytes}}ps\n        </div>\n        <div ng-hide=\"vm.bandwidth\">\n          <i class=\"fa fa-spin fa-spinner\"></i> Checking available bandwidth...\n        </div>\n      </div>\n\n    </form>\n  </div>\n\n  <div ng-show=\"vm.tab == 'help'\" class=\"container-fluid\" style=\"max-width:720px\">\n    <h3>BoxCast Help</h3>\n    <p>To stream to BoxCast from the Switcher iOS app, you must have an active broadcast\n    at the time of the streaming.</p>\n    <p>You can schedule a broadcast on the BoxCast web dashboard from your computer, and as\n    long as you set \"Source\" to \"Switcher Studio (iOS)\", when you access this app during\n    the time of the broadcast, you will be able to stream directly to it.</p>\n    <p>You can also schedule a new BoxCast broadcast right here. Make sure the selected time is appropriate\n    for the start and end of your event, and BoxCast will take care of the rest!</p>\n  </div>\n\n  <div ng-show=\"vm.tab == 'scheduled'\" class=\"container-fluid\" style=\"max-width:720px\">\n\n    <div ng-if=\"vm.switcherAppMode == 'web'\" class=\"bg-warning text-warning\" style=\"margin:15px 0;border:1px solid;padding:15px\">\n      <div ng-show=\"vm.initializingSwitcherStudioV3\">\n        Initializing Switcher Studio integration...\n      </div>\n      <div ng-hide=\"vm.initializingSwitcherStudioV3\">\n        Switcher Studio app not detected. This page is intended to be accessed from inside the app and may not perform\n        appropriately otherwise.\n      </div>\n    </div>\n\n    <div ng-if=\"vm.futureBroadcasts.length == 0\">\n      <p class=\"text-center\" style=\"margin: 45px 0; padding: 10px;\">\n        There are no scheduled broadcasts. Create a new broadcast to begin streaming.\n      </p>\n      <p class=\"text-center\">\n        <button type=\"button\" class=\"btn btn-boxcast btn-lg btn-block\" ng-click=\"vm.tab = 'new'\">\n          Create Broadcast\n        </button>\n      </p>\n    </div>\n    <div class=\"switcher-event-row\"\n        ng-class=\"vm.isActive(broadcast) ? 'selected' : ''\"\n        ng-repeat=\"broadcast in vm.futureBroadcasts track by broadcast.id\">\n      <div class=\"col-xs-1\" ng-click=\"vm.toggleSelectedBroadcast(broadcast)\" style=\"cursor:pointer\">\n        <i class=\"fa\" ng-class=\"vm.isSelected(broadcast) ? 'fa-check-square-o' : 'fa-square-o'\" style=\"font-size:22px\"></i>\n      </div>\n      <div class=\"col-xs-11\" ng-click=\"vm.toggleSelectedBroadcast(broadcast)\" style=\"cursor:pointer\">\n        <div class=\"pull-right\">\n          <span ng-if=\"vm.isActive(broadcast)\" class=\"label\" style=\"background:#fff;color:#1AA8A1;border:1px solid #1AA8A1;\">Active</span>\n          <span ng-if=\"broadcast.is_ticketed\" class=\"label label-success\">${{broadcast.ticket_price | number:2}} / ticket</span>\n          <span ng-if=\"broadcast.is_private\" class=\"label label-danger\">Private</span>\n          <span ng-if=\"broadcast.timeframe == 'current'\" class=\"label label-danger\">LIVE NOW</span>\n        </div>\n        <div><strong>{{broadcast.name}}</strong></div>\n        <div class=\"text-bx-accessible-grey\" style=\"white-space:nowrap; text-overflow:ellipsis; overflow:hidden\">\n          <date-range start=\"broadcast.starts_at\" end=\"broadcast.stops_at\"></date-range>\n        </div>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n    <div class=\"row\" ng-if=\"vm.selectedBroadcast\" style=\"margin-top:15px\">\n      <div class=\"col-sm-6\" ng-hide=\"vm.isActive(vm.selectedBroadcast)\" style=\"margin-bottom:15px\">\n        <button type=\"button\" ng-click=\"vm.activateBroadcast(vm.selectedBroadcast)\" class=\"btn btn-primary btn-lg btn-block\">\n          Activate Selected Broadcast\n        </button>\n        <p class=\"help-block\">\n          <small>\n            Tap to start the BoxCast broadcast and link it to Switcher Studio.\n            You will still need to begin the stream in Switcher Studio after this window closes.\n          </small>\n        </p>\n      </div>\n      <div class=\"col-sm-6\" ng-show=\"vm.selectedBroadcast.timeframe == 'current' || vm.selectedBroadcast.timeframe == 'preroll'\" style=\"margin-bottom:15px\">\n        <button type=\"button\" ng-click=\"vm.stopBroadcast(vm.selectedBroadcast)\" class=\"btn btn-danger btn-lg btn-block\">\n          Stop Selected Broadcast\n        </button>\n      </div>\n    </div>\n\n    <div class=\"row\" style=\"margin-top:30px\">\n      <div class=\"col-xs-12 text-center\">\n        <small><a href ng-click=\"vm.loadFutureBroadcasts()\">Refresh Broadcast List</a></small>\n      </div>\n    </div>\n\n  </div>\n\n  <!-- XXX: HACK: whitespace to work around problem where viewport magically shrinks\n  inside the iOS webview when typing in a text field or opening the channel picker.\n  Gabe appears to have fixed it for now; leaving it commented in case of reports that\n  it occurs still under certain circumstances.\n  <div id=\"switcher-webview-hack\" style=\"height:320px;\">\n  </div>\n  -->\n\n\n  <div style=\"margin-top:50px;text-align:center\">\n    <hr>\n    <small><a ui-sref=\"logout\" class=\"subtle-link\">Log out of BoxCast</a></small>\n  </p>\n\n</main>\n\n\n<style type=\"text/css\">\n  body {\n    background-color: #FFF !important;\n    color: #333;\n  }\n\n  .well {\n    background-color: #FFF;\n    border: 1px solid #1AA8A1;\n  }\n\n\n  .switcher-event-row {\n    padding: 20px;\n    border: 1px solid #1AA8A1;\n    border-radius: 4px;\n    color: #333;\n    margin-top:15px;\n  }\n  .switcher-event-row.selected {\n    border: 1px solid #1AA8A1;\n    background-color: rgba(26, 168, 161, 0.60);\n    color: #000;\n  }\n\n\n  .btn-boxcast {\n      border: 1px solid #1AA8A1;\n      background-color: transparent;\n      color: #1AA8A1;\n  }\n\n  .btn-boxcast:hover,\n  .btn-boxcast:focus {\n      border: 1px solid #1AA8A1;\n      outline: 0;\n      color: #000;\n      background-color: #1AA8A1;\n  }\n  .btn-boxcast:active, .btn-boxcast.active {\n      border-color: #1AA8A1;\n      color: #333;\n      background-color: rgba(26, 168, 161, 0.60);\n      outline: 0;\n  }\n  .btn-boxcast:active:hover, .btn-boxcast.active:hover,\n  .btn-boxcast:active:focus, .btn-boxcast.active:focus,\n  .btn-boxcast:active.focus, .btn-boxcast.active.focus {\n      border-color: #1AA8A1;\n      background-color: rgba(26, 168, 161, 0.80);\n      outline: 0;\n  }\n</style>\n\n"

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_error__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_broadcast_with_rtmp_controller__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var PROVIDER_ID = '62B54187-6E38-43C8-9EC4-28709EEEC382';
var V3_INITIALIZE_TIMEOUT_MS = 10000;

var EventsController = /*#__PURE__*/function () {
  function EventsController($scope, $state, $analytics, $q, $http, $timeout, $uibModal, EditOrCreateEventService, Broadcast, toaster, BandwidthTestClient, Requester) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, EventsController);

    this.$scope = $scope;
    this.$state = $state;
    this.$analytics = $analytics;
    this.EditOrCreateEventService = EditOrCreateEventService;
    this.Broadcast = Broadcast;
    this.toaster = toaster;
    this.BandwidthTestClient = BandwidthTestClient;
    this.Requester = Requester;
    this.$q = $q;
    this.$http = $http;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;
    this.postRobot = __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default.a;
    this.switcherAppMode = 'web';

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.switcher) {
      // Decide if v2 (BoxCast Switcher) or v3 (Switcher Studio). Assume v2 unless the postMessage
      // calls return, in which case we're in the v3 shell.
      this.switcherAppMode = 'boxcast_switcher_webview';
      this.initializingSwitcherStudioV3 = true;
      this.postMessage('api', {
        method: 'GET',
        path: "/api/StreamingProviders/".concat(PROVIDER_ID)
      }).then(function (event) {
        console.log('Switcher provider settings', event);
        $timeout(function () {
          _this.initializingSwitcherStudioV3 = false;
          _this.switcherAppMode = 'studio_v3';
          _this.provider = event.data;
        });
      })["catch"](function (err) {
        console.error(err);
        $timeout(function () {
          return _this.initializingSwitcherStudioV3 = false;
        });
      });
      this.postMessage('api', {
        method: 'GET',
        path: "/api/StreamingProviders/".concat(PROVIDER_ID, "/SwitcherStreamSettings")
      }).then(function (event) {
        console.log('Current Switcher channel settings', event);
        $timeout(function () {
          return _this.currentSwitcherChannelSettings = event.data;
        });

        _this.postMessage('ui', {
          method: 'hideCover'
        });
      })["catch"](function (err) {
        console.error(err);
        $timeout(function () {
          return _this.currentSwitcherChannelSettings = {};
        });

        _this.postMessage('ui', {
          method: 'hideCover'
        });
      });
      $timeout(function () {
        if (_this.initializingSwitcherStudioV3) {
          _this.initializingSwitcherStudioV3 = false;
        }
      }, V3_INITIALIZE_TIMEOUT_MS);
    }

    this.tab = 'scheduled';
    this.loadFutureBroadcasts();
    this.newEventQuickSettings = {
      showModeToggle: false,
      showBoxCasters: false,
      showClone: false,
      showRecurring: false,
      showFBLive: false,
      // XXX: FB.ui api cannot be used inside Switcher webview
      showPreview: false
    };
    this.$analytics.eventTrack("new-event-switcher", {
      category: 'open',
      label: ''
    });
    this.service = EditOrCreateEventService.getInstance();
    this.service.initBroadcast();
    this.service.initScope($scope);
    this.service.visibility = 'private'; //default to private for Switcher events

    this.maxValidStep = 1;
    this.step = 1;
    this.showError = false; // XXX: don't need BoxCasters here since inside switcher

    this.service.boxcasters.$promise.then(function () {
      _this.service.broadcast.boxcaster_id = 'stream_source:switcher';
    });
    this.testBandwidth().then(function (bw) {
      $scope.$evalAsync(function () {
        _this.bandwidth = bw; // initialize the broadcast

        var _this$BandwidthTestCl = _this.BandwidthTestClient.getBitrates(bw.availableBandwidth),
            videoBitrate = _this$BandwidthTestCl.videoBitrate,
            audioBitrate = _this$BandwidthTestCl.audioBitrate;

        if (_this.service.broadcast.target_video_bitrate == 'default') {
          _this.service.broadcast.target_video_bitrate = videoBitrate;
        }

        if (_this.service.broadcast.target_audio_bitrate == 'default') {
          _this.service.broadcast.target_audio_bitrate = audioBitrate;
        }
      });
    });
    this.loading = true;
    this.loadingPromises = [this.service.boxcasters.$promise, this.service.channels.$promise, this.futureBroadcasts.$promise];
    $q.all(this.loadingPromises).then(function () {
      return _this.loading = false;
    }); // Auto-focus on page load

    setTimeout(function () {
      return $('#eventName').focus();
    }, 0);
  }

  _createClass(EventsController, [{
    key: "postMessage",
    value: function postMessage(route, params) {
      params = params || {};
      var method = params.method;
      var path = params.path;
      return __WEBPACK_IMPORTED_MODULE_2__utils_post_robot_min___default.a.send(window.parent, route, params).then(function (event) {
        return event;
      })["catch"](function (err) {
        throw err;
      });
    }
  }, {
    key: "testBandwidth",
    value: function testBandwidth() {
      return this.BandwidthTestClient.runTestOrUseRecentCached();
    }
  }, {
    key: "loadFutureBroadcasts",
    value: function loadFutureBroadcasts() {
      this.futureBroadcasts = this.Broadcast.query({
        'filter.stream_source': 'switcher',
        q: 'timeframe:current timeframe:preroll timeframe:future',
        s: 'starts_at',
        l: '20'
      });
    }
  }, {
    key: "isActive",
    value: function isActive(broadcast) {
      // TODO: reconcile difference between "active" (meaning switcher knows about it)
      // and "current" (meaning it's scheduled to be running now)
      return broadcast.timeframe == 'current' && this.currentSwitcherChannelSettings && this.currentSwitcherChannelSettings['channel-name'] == broadcast.name;
    }
  }, {
    key: "isSelected",
    value: function isSelected(broadcast) {
      return this.selectedBroadcast == broadcast;
    }
  }, {
    key: "toggleSelectedBroadcast",
    value: function toggleSelectedBroadcast(broadcast) {
      if (this.selectedBroadcast === broadcast) {
        this.selectedBroadcast = null;
      } else {
        this.selectedBroadcast = broadcast;
      }
    }
  }, {
    key: "activateBroadcast",
    value: function activateBroadcast(broadcast) {
      var _this2 = this;

      var $q = this.$q,
          toaster = this.toaster;
      var promise;

      if (broadcast.timeframe == 'current') {
        promise = $q(function (res, rej) {
          _this2.Broadcast.get({
            id: broadcast.id
          }, function (b) {
            return res(b);
          }, function (err) {
            return rej(err);
          });
        });
      } else {
        promise = this.EditOrCreateEventService.activateBroadcast(broadcast);
      }

      promise.then(function (broadcast) {
        _this2.waitForOrigin(broadcast).then(function (broadcast) {
          if (_this2.switcherAppMode == 'boxcast_switcher_webview') {
            window.webkit.messageHandlers.switcher.postMessage({
              action: 'dismiss'
            });
          } else {
            _this2.pokeV3APIWithNewBroadcast(broadcast, function () {
              _this2.postMessage('ui', {
                method: 'terminateBCProfileCreation',
                params: {
                  profile: _this2.currentSwitcherChannelSettings
                }
              });
            }, function () {
              _this2.toaster.pop('warning', 'Unable to communicate with Switcher Studio.');
            });
          }
        });
      })["catch"](function (response) {
        var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_0__utils_error__["a" /* errorDescriptionFromResponse */])(response);

        _this2.toaster.pop('warning', 'Unable to activate the broadcast.\n\n' + errorDetails);
      });
      this.selectedBroadcast = null;
      this.loadingPromises = [promise];
    }
  }, {
    key: "pokeV3APIWithNewBroadcast",
    value: function pokeV3APIWithNewBroadcast(broadcast) {
      var _this3 = this;

      var successCB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var errorCB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var $timeout = this.$timeout,
          toaster = this.toaster;
      var rtmpParts = Object(__WEBPACK_IMPORTED_MODULE_1__events_broadcast_with_rtmp_controller__["c" /* splitRtmpUrl */])(broadcast.rtmp_ingestion_url);
      var resolution = Object(__WEBPACK_IMPORTED_MODULE_1__events_broadcast_with_rtmp_controller__["b" /* resolutionForBroadcast */])(broadcast);
      var data = angular.extend({}, this.currentSwitcherChannelSettings, {
        StreamingProviderId: PROVIDER_ID,
        url: rtmpParts[0],
        'rtmp-stream': rtmpParts[1],
        //'version': '1',
        'audio-channel-count': 2,
        'audio-sample-rate': 44100,
        'video-frame-height': resolution.height,
        'video-frame-width': resolution.width,
        //'user-editable': true,
        'channel-name': broadcast.name
      });

      if (broadcast.target_audio_bitrate && !isNaN(broadcast.target_audio_bitrate)) {
        data['audio-bit-rate'] = broadcast.target_audio_bitrate;
      }

      if (broadcast.target_video_bitrate && !isNaN(broadcast.target_video_bitrate)) {
        data['video-bit-rate'] = broadcast.target_video_bitrate;
      }

      var method = 'PUT';

      if (Object.keys(this.currentSwitcherChannelSettings).length == 0) {
        method = 'POST';
      }

      return this.postMessage('api', {
        method: method,
        path: "/api/StreamingProviders/".concat(PROVIDER_ID, "/SwitcherStreamSettings"),
        data: data
      }).then(function (event) {
        console.log('Updated Switcher channel settings', event);

        if (event.data && event.data.ExceptionMessage) {
          $timeout(function () {
            return toaster.pop('warning', "There was an error communicating with Switcher Studio: ".concat(event.data.ExceptionMessage));
          });
        } else {
          $timeout(function () {
            return _this3.currentSwitcherChannelSettings = event.data;
          });
        }

        if (successCB) {
          $timeout(function () {
            return successCB();
          });
        }
      })["catch"](function (err) {
        console.error(err);
        $timeout(function () {
          return _this3.initializingSwitcherStudioV3 = false;
        });

        if (errorCB) {
          $timeout(function () {
            return errorCB();
          });
        }
      });
    }
  }, {
    key: "stopBroadcast",
    value: function stopBroadcast(broadcast) {
      var _this4 = this;

      var promise = this.EditOrCreateEventService.stopBroadcast(broadcast).then(function () {
        _this4.loadFutureBroadcasts();
      })["catch"](function (response) {
        var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_0__utils_error__["a" /* errorDescriptionFromResponse */])(response);

        _this4.toaster.pop('warning', 'Unable to stop broadcast. Please check your fields and try again.\n\n' + errorDetails);
      });
      this.selectedBroadcast = null;
      this.loadingPromises = [promise];
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this5 = this;

      // XXX: called by new-event-quick directive when scheduling
      var toaster = this.toaster;
      this.showError = false;
      this.submitting = true;
      this.service.saveChanges().then(function (broadcast) {
        _this5.submitting = false;

        _this5.$analytics.eventTrack("new-event-".concat(_this5.wizard ? 'wizard' : 'quick'), {
          category: 'saved',
          label: ''
        }); // NOTE: now that the event is "active" (due to time-based scheduling), we can dismiss
        // the web view and let the app take over.


        _this5.toaster.pop('success', 'Event successfully scheduled.');

        if (_this5.switcherAppMode == 'boxcast_switcher_webview') {
          window.webkit.messageHandlers.switcher.postMessage({
            action: 'dismiss'
          });
        } else {
          if (broadcast.timeframe == 'current') {
            _this5.waitForOrigin(broadcast).then(function (broadcast) {
              console.log('Origin ready for broadcast', broadcast);

              _this5.pokeV3APIWithNewBroadcast(broadcast, function () {
                _this5.postMessage('ui', {
                  method: 'terminateBCProfileCreation',
                  params: {
                    profile: _this5.currentSwitcherChannelSettings
                  }
                });
              }, function () {
                _this5.toaster.pop('warning', 'Unable to communicate with Switcher Studio.');
              });
            });
          } else {
            _this5.loadFutureBroadcasts();

            _this5.tab = 'scheduled';
          }
        }
      })["catch"](function (error) {
        var errorDetails = Object(__WEBPACK_IMPORTED_MODULE_0__utils_error__["a" /* errorDescriptionFromResponse */])(error);

        if (errorDetails == 'invalid') {
          _this5.showError = true;
          $('html, body').animate({
            scrollTop: 0
          });
        } else {
          console.error(error);

          _this5.toaster.pop('warning', 'Unable to save broadcast. Please check your fields and try again.\n\n' + errorDetails);
        }

        _this5.submitting = false;

        _this5.$analytics.eventTrack("new-event-".concat(_this5.wizard ? 'wizard' : 'quick'), {
          category: 'error',
          label: errorDetails
        });
      });
    }
  }, {
    key: "waitForOrigin",
    value: function waitForOrigin(broadcast) {
      var _this7 = this;

      var $uibModal = this.$uibModal;
      var updatedBroadcast;
      return $uibModal.open({
        template: __webpack_require__(535),
        controller: function controller($http, $interval, $uibModalInstance, $scope) {
          'ngInject';

          var _this6 = this;

          this.statusPct = 0;
          this.interval = $interval(function () {
            $http.get("".concat(API_ROOT, "/account/broadcasts/").concat(broadcast.id, "/view?channel_id=").concat(broadcast.channel_id)).then(function (view) {
              _this6.statusPct = view.data.progress;

              if (_this6.statusPct >= 90 || view.data.status != 'catching_up') {
                _this6.cancel();
              }
            });
          }, 1000);
          $scope.$on('$destroy', function () {
            $interval.cancel(_this6.interval);
          });

          this.cancel = function () {
            $uibModalInstance.close();
          };
        },
        controllerAs: 'vm'
      }).result.then(function () {
        updatedBroadcast = _this7.Broadcast.get({
          id: broadcast.id
        });
        return updatedBroadcast.$promise;
      }).then(function () {
        return updatedBroadcast;
      });
    }
  }]);

  return EventsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (EventsController);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h3 class=\"modal-title\">Please Wait</h3>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\">Broadcast is preparing...</p>\n  <uib-progressbar value=\"vm.statusPct\" max=\"100\">\n    {{vm.statusPct}}% Complete\n  </uib-progressbar>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"pull-right\">\n      <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">Close</button>\n    </div>\n</div>\n"

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uploads_html__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uploads_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__uploads_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_upload_event__ = __webpack_require__(211);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }




var PAGE_SIZE = 10;

var UploadsController = /*#__PURE__*/function () {
  function UploadsController($rootScope, $http, $q, toaster, $state, $uibModal, ConfirmDialog) {
    'ngInject';

    _classCallCheck(this, UploadsController);

    this.account = $rootScope.account;
    this.$http = $http;
    this.toaster = toaster;
    this.$q = $q;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.ConfirmDialog = ConfirmDialog;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.canUploadBroadcasts = $rootScope.user.can('create', 'broadcast') && $rootScope.user.can('create', 'broadcast/*:upload');

    if (this.canUploadBroadcasts) {
      this.slot = 'broadcast';
    } else {
      this.slot = 'preview';
    }

    this.file = null;
    this.uploadingPromises = {};
    this.reload();
  }

  _createClass(UploadsController, [{
    key: "reload",
    value: function reload() {
      this.loadUploadsForPage(1);
    }
  }, {
    key: "changeSlot",
    value: function changeSlot(slot) {
      this.slot = slot;

      if (this.slot != 'broadcast' && this.slot != 'template') {
        this.reload();
      }
    }
  }, {
    key: "loadUploadsForPage",
    value: function loadUploadsForPage(p) {
      var _this = this;

      var $http = this.$http,
          toaster = this.toaster;
      this.uploads = [];
      this.loading = true;
      var params = {
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-created_at'
      };

      if (this.slot) {
        params['filter.slot'] = this.slot;
      }

      $http.get("".concat(API_ROOT, "/account/uploads"), {
        params: params
      }).then(function (response) {
        _this.uploads = response.data;
        var pagination = JSON.parse(response.headers('x-pagination'));
        _this.pagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + response.data.length
        };
      })["catch"](function (err) {
        toaster.pop('warning', 'Unable to load uploads. Please refresh the page and try again.');
      })["finally"](function () {
        _this.loading = false;
      });
    }
  }, {
    key: "delete",
    value: function _delete(upload) {
      var _this2 = this;

      var ConfirmDialog = this.ConfirmDialog,
          $http = this.$http,
          toaster = this.toaster;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Delete Upload',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to delete this upload? It will no longer be accessible.'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        $http["delete"]("".concat(API_ROOT, "/account/uploads/").concat(upload.id)).then(function (response) {
          toaster.pop('success', 'The upload was successfully deleted.');
        }).then(function () {
          _this2.reload();
        })["catch"](function (error) {
          console.error(error);
          toaster.pop('warning', 'An error occurred while trying to delete the upload. Please refresh and try again.');
        });
      });
    }
  }, {
    key: "upload",
    value: function upload(file) {
      var _this3 = this;

      file.upload().then(function (result) {
        console.log('Uploaded', result);
        _this3.file = null;

        _this3.reload();
      });
    }
  }, {
    key: "uploadEventVideo",
    value: function uploadEventVideo() {
      var $uibModal = this.$uibModal,
          $state = this.$state;
      $uibModal.open({
        template: __webpack_require__(213),
        controllerAs: 'vm',
        controller: __WEBPACK_IMPORTED_MODULE_2__modal_upload_event__["a" /* default */],
        size: 'lg',
        //  Prevent accidental close...
        backdrop: 'static',
        keyboard: false,
        resolve: {
          broadcast: function broadcast() {
            return null;
          },
          highlights: function highlights() {
            return [];
          }
        }
      }).result.then(function (broadcast) {
        $state.go('events.detail', {
          id: broadcast.id
        });
      });
    }
  }, {
    key: "openViewModal",
    value: function openViewModal(f) {
      var $uibModal = this.$uibModal;
      var file = f;
      $uibModal.open({
        template: __webpack_require__(538),
        controllerAs: 'vm',
        controller: function controller($uibModalInstance) {
          this.file = file;
          this.isImage = this.file.mimetype.startsWith('image');
          this.isVideo = this.file.mimetype.startsWith('video');
          this.isPDF = this.file.mimetype.startsWith('application/pdf');

          this.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };
        }
      });
    }
  }]);

  return UploadsController;
}();

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])('uploads', __WEBPACK_IMPORTED_MODULE_1__uploads_html___default.a, UploadsController, 'UploadsController'));

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = "<main class=\"container-fluid\">\n<style>\n.open>.dropdown-menu {\n  left: -100px;\n}\n</style>\n\n<div class=\"col-xs-12\">\n  <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n    <li ng-class=\"{active: vm.slot == 'broadcast'}\" ng-if=\"::vm.canUploadBroadcasts\">\n      <a href ng-click=\"vm.changeSlot('broadcast')\">Broadcasts</a>\n    </li>\n    <li ng-class=\"{active: vm.slot == 'document'}\" ng-if=\"::vm.FeatureFlags.documents\">\n      <a href ng-click=\"vm.changeSlot('document')\">Documents</a>\n    </li>\n    <li ng-class=\"{active: vm.slot == 'overlay'}\" ng-if=\"::vm.FeatureFlags.overlays\">\n      <a href ng-click=\"vm.changeSlot('overlay')\">Overlays</a>\n    </li>\n    <li ng-class=\"{active: vm.slot == 'preroll'}\">\n      <a href ng-click=\"vm.changeSlot('preroll')\">Pre-Event Videos</a>\n    </li>\n    <li ng-class=\"{active: vm.slot == 'preview'}\">\n      <a href ng-click=\"vm.changeSlot('preview')\">Thumbnail Images</a>\n    </li>\n    <li ng-class=\"{active: vm.slot == 'template'}\" ng-if=\"::vm.FeatureFlags.overlays\">\n      <a href ng-click=\"vm.changeSlot('template')\">Templates</a>\n    </li>\n  </ol>\n</div>\n\n<div ng-if=\"vm.slot == 'broadcast'\">\n  <div class=\"col-xs-12 no-padding\">\n    <div class=\"well text-left\" style=\"padding:30px 60px\">\n      <h3 style=\"margin-top:30px;\">\n        Upload Recorded Broadcasts\n      </h3>\n      <p ng-if=\"vm.account.storage_policy == 'auto-bill'\" class=\"help-block\" style=\"margin:30px 0\">\n        Uploaded broadcasts will be stored for {{vm.account.storage_duration_days|storageDuration}}.\n        After that, they will be billed at your standard monthly rate of {{vm.account.storage_rate|currency}}\n        per hour of video.\n      </p>\n      <p ng-if=\"vm.account.storage_policy == 'auto-delete'\" class=\"help-block\" style=\"margin:30px 0\">\n        Uploaded broadcasts will be stored for {{vm.account.storage_duration_days|storageDuration}}.\n        After that, they will be purged from BoxCast's storage.\n      </p>\n      <button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"vm.uploadEventVideo()\">\n        <i class=\"fa fa-upload\"></i> Upload Broadcast\n      </button>\n    </div>\n  </div>\n</div>\n\n<div ng-if=\"vm.slot == 'template'\">\n  <div class=\"col-xs-12 no-padding\">\n    <div class=\"well text-center\" style=\"padding:40px\">\n      <h4 class=\"help-block\" style=\"margin-bottom:30px\">\n        Want to build your own graphics? Click the button below to download our templates.\n      </h4>\n      <a class=\"btn btn-success btn-lg\" href=\"https://assets.boxcast.com/media-uploads/templates.zip\" download>\n        <i class=\"fa fa-download\"></i> Download Templates\n      </a>\n    </div>\n  </div>\n</div>\n\n<div ng-if=\"vm.slot != 'broadcast' && vm.slot != 'template'\">\n\n\n  <div class=\"col-xs-12 no-padding\">\n    <div class=\"well\">\n\n      <div ng-if=\"vm.loading\">\n        <h4 class=\"help-block text-center\" style=\"margin:30px auto;\">Loading...</h4>\n      </div>\n      <div class=\"row\">\n        <div ng-if=\"!vm.loading && vm.uploads.length == 0\" class=\"col-xs-12 text-center\" style=\"margin-bottom:15px;\">\n          <h4 ng-show=\"vm.slot == 'document'\" class=\"help-block\">You don't have any documents</h4>\n          <h4 ng-show=\"vm.slot == 'overlay'\" class=\"help-block\">You don't have any overlays</h4>\n          <h4 ng-show=\"vm.slot == 'preroll'\" class=\"help-block\">You don't have any pre-event videos</h4>\n          <h4 ng-show=\"vm.slot == 'preview'\" class=\"help-block\">You don't have any thumbnail images</h4>\n        </div>\n\n        <div ng-if=\"!vm.loading\" ng-class=\"vm.uploads.length == 0 ? 'col-xs-12 text-center' : 'col-md-3 col-md-push-9 text-right'\"\n             style=\"margin-bottom:20px;\">\n          <upload-modal-launcher\n            ng-if=\"vm.slot == 'document'\"\n            modal-heading=\"Add Document\"\n            slot-name=\"vm.slot\"\n            allow-video=\"false\"\n            allow-image=\"false\"\n            on-uploaded=\"vm.reload()\">\n            <a class=\"btn btn-success btn-lg\" style=\"width:100%;max-width:300px;\">\n              &plus; Add Document\n            </a>\n          </upload-modal-launcher>\n          <upload-modal-launcher\n            ng-if=\"vm.slot == 'overlay'\"\n            modal-heading=\"Add Overlay\"\n            slot-name=\"vm.slot\"\n            allow-video=\"false\"\n            allow-image=\"true\"\n            on-uploaded=\"vm.reload()\">\n            <a class=\"btn btn-success btn-lg\" style=\"width:100%;max-width:300px;\">\n              &plus; Add Overlay\n            </a>\n          </upload-modal-launcher>\n          <upload-modal-launcher\n            ng-if=\"vm.slot == 'preroll'\"\n            modal-heading=\"Add Pre-Event Video\"\n            slot-name=\"vm.slot\"\n            allow-video=\"true\"\n            allow-image=\"false\"\n            on-uploaded=\"vm.reload()\">\n            <a class=\"btn btn-success btn-lg\" style=\"width:100%;max-width:300px;\">\n              &plus; Add Video\n            </a>\n          </upload-modal-launcher>\n          <upload-modal-launcher\n            ng-if=\"vm.slot == 'preview'\"\n            modal-heading=\"Add Thumbnail Image\"\n            slot-name=\"vm.slot\"\n            allow-video=\"false\"\n            allow-image=\"true\"\n            on-uploaded=\"vm.reload()\">\n            <a class=\"btn btn-success btn-lg\" style=\"width:100%;max-width:300px;\">\n              &plus; Add Thumbnail\n            </a>\n          </upload-modal-launcher>\n        </div>\n\n        <div ng-if=\"!vm.loading && vm.uploads.length > 0\" class=\"col-md-9 col-md-pull-3\">\n          <table class=\"table table-striped table-hover\">\n            <thead>\n              <tr>\n                <th ng-show=\"vm.slot == 'overlay' || vm.slot == 'preview'\">Preview</th>\n                <th>File Name</th>\n                <th>File Type</th>\n                <th>File Size</th>\n                <th>Uploaded</th>\n                <th></th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"f in vm.uploads track by f.id\">\n                <td ng-click=\"vm.openViewModal(f)\" ng-if=\"vm.slot == 'overlay' || vm.slot == 'preview'\">\n                  <div class=\"fixed-16-9\">\n                    <div style=\"background-image:url(&quot;{{f.view_url | trustedUrl}}&quot;);background-size:contain;background-position:50% 50%;background-repeat:no-repeat;\"></div>\n                  </div>\n                </td>\n                <td ng-click=\"vm.openViewModal(f)\">{{f.filename}}</td>\n                <td ng-click=\"vm.openViewModal(f)\">{{f.mimetype.split('/')[1]}}</td>\n                <td ng-click=\"vm.openViewModal(f)\">{{f.filesize|bytes}}</td>\n                <td ng-click=\"vm.openViewModal(f)\">{{f.created_at|date:'short'}}</td>\n                <td class=\"text-right\">\n                  <ul class=\"list-inline\">\n                    <li>\n                      <a href ng-click=\"vm.delete(f)\" title=\"Delete Upload\"><i class=\"fa fa-trash\"></i></a>\n                    </li>\n                  </ul>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n\n          <div ng-if=\"vm.pagination.total > 10\" class=\"text-center\">\n            <uib-pagination total-items=\"vm.pagination.total\"\n                            items-per-page=\"10\"\n                            max-size=\"10\"\n                            rotate=\"false\"\n                            class=\"pagination-sm\"\n                            ng-model=\"vm.pagination.current\"\n                            ng-change=\"vm.loadUploadsForPage(vm.pagination.current)\"></uib-pagination>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n</div>\n\n</main>\n\n"

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body text-center\">\n  <div ng-if=\"vm.isImage\" class=\"transparent-grid-bg\" style=\"padding:10px\">\n    <div class=\"crop-marks\">\n      <div><span><img ng-src=\"{{vm.file.view_url}}\" style=\"width:100%;\"></span></div>\n    </div>\n  </div>\n  <video ng-if=\"vm.isVideo\" style=\"width:100%\" loop autoplay controls=\"true\">\n    <source ng-src=\"{{vm.file.view_url}}\">\n  </video>\n  <iframe ng-if=\"vm.isPDF\" ng-src=\"{{vm.file.view_url | trustedUrl}}\" frameborder=\"0\" style=\"width:100%;height:450px\"></iframe>\n</div>\n<div class=\"modal-footer\">\n  <a ng-if=\"clipboard.supported\" \n    href\n    class=\"btn btn-primary pull-left\"\n    clipboard\n    text=\"vm.file.view_url\"\n    on-copied=\"toaster.pop('success', 'Link successfully copied')\"\n    on-error=\"toaster.pop('warning', 'Link could not be copied')\"\n    title=\"Copy URL to Clipboard\"\n    >\n    <i class=\"fa fa-copy\"></i>\n    Copy URL\n  </a>\n  <a ng-hide=\"vm.isPDF\" class=\"btn btn-primary pull-left\" href=\"{{vm.file.view_url}}\" target=\"_blank\" download>\n    <i class=\"fa fa-external-link\"></i>\n    Open\n  </a>\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n</div>\n"

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(540);
// The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.

var module = angular.module('app.pages.complete-migration', []);
module.config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('complete-migration', {
    url: '/complete-migration',
    template: __webpack_require__(550),
    controller: __webpack_require__(551)["default"],
    controllerAs: 'vm'
  }).state('complete-migration.welcome', {
    url: '/welcome',
    template: __webpack_require__(552),
    controller: __webpack_require__(553)["default"],
    controllerAs: 'vm'
  }).state('complete-migration.account-info', {
    url: '/account-info',
    template: __webpack_require__(554),
    controller: __webpack_require__(555)["default"],
    controllerAs: 'vm'
  }).state('complete-migration.video-organization', {
    url: '/video-organization',
    template: __webpack_require__(556),
    controller: __webpack_require__(557)["default"],
    controllerAs: 'vm'
  }).state('complete-migration.migration-progress', {
    url: '/migration-progress',
    template: __webpack_require__(562),
    controller: __webpack_require__(563)["default"],
    controllerAs: 'vm'
  }).state('complete-migration.plan-enrollment', {
    url: '/plan-enrollment',
    template: __webpack_require__(564),
    controller: __webpack_require__(565)["default"],
    controllerAs: 'vm'
  }).state('complete-migration.success', {
    url: '/success',
    template: __webpack_require__(566),
    controller: __webpack_require__(567)["default"],
    controllerAs: 'vm'
  });
});
Object(__WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */])(module);
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerComponents;
function registerComponents(module) {
  // <sources-tabs />
  module.component('sourceTabs', {
    controllerAs: 'vm',
    bindings: {
      broadcaster: '=',
      broadcastId: '=',
      location: '='
    },
    controller: __webpack_require__(541)["default"],
    template: __webpack_require__(549)
  });
}

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BoxCastersController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_boxcast_flow_control__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_sources__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_video_and_audio_config__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_isStreamMonkey__ = __webpack_require__(10);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }





var STATIC_RTMP_REFRESH_INTERVAL = 10000;

var BoxCastersController = /*#__PURE__*/function () {
  function BoxCastersController(BoxCaster, Broadcast, StaticRTMP, ConfirmDialog, $uibModal, $state, $q, $rootScope, $location, $timeout, toaster, $scope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, BoxCastersController);

    this.BoxCaster = BoxCaster;
    this.Broadcast = Broadcast;
    this.StaticRTMP = StaticRTMP;
    this.ConfirmDialog = ConfirmDialog;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.$q = $q;
    this.toaster = toaster;
    this.$location = $location;
    this.$timeout = $timeout;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    this.user = $rootScope.user;
    this.rtmpStatus = __WEBPACK_IMPORTED_MODULE_1__utils_sources__["b" /* sourceRtmpStatus */];
    this.sourceType = __WEBPACK_IMPORTED_MODULE_1__utils_sources__["c" /* sourceType */];
    this.url = $state.current.name;
    this.producerTestURL = window.VUE_DASHBOARD_ROOT + '/producer/test';
    this.allowRtmp = this.FeatureFlags.rtmp;
    this.allowBroadcaster = !this.FeatureFlags.broadcaster_app_source_disabled;
    this.showBroadcasterSource = !this.FeatureFlags.broadcaster_app_source_disabled && this.account.usage_flags.broadcaster_app;
    this.showProducerSource = this.FeatureFlags.producer;
    this.isStreamMonkey = Object(__WEBPACK_IMPORTED_MODULE_3__utils_isStreamMonkey__["a" /* default */])(this.account.migration_service_id);
    this.refresh().then(function () {
      _this.openAndFocusOnSource();

      _this.scheduleRefreshStaticRTMP();
    });
    this.getProducerEnterURL = this.getProducerEnterURL.bind(this);
    $scope.$on('$destroy', function () {
      $timeout.cancel(_this.timeoutHandle);
    });
    this.showAddSourceModal = this.showAddSourceModal.bind(this);
    this.sortSources = __WEBPACK_IMPORTED_MODULE_1__utils_sources__["a" /* sortSources */].bind(this);
    this.toggleDetails = this.toggleDetails.bind(this);
  }

  _createClass(BoxCastersController, [{
    key: "isSourcesPage",
    get: function get() {
      return this.getLocation() && this.getLocation().includes('sources');
    }
  }, {
    key: "getProducerEnterURL",
    value: function getProducerEnterURL(source) {
      if (source.details && source.details.id) return window.VUE_DASHBOARD_ROOT + '/producer/' + source.details.id;
      return window.VUE_DASHBOARD_ROOT + '/producer/new';
    }
  }, {
    key: "openAndFocusOnSource",
    value: function openAndFocusOnSource() {
      // XXX: must be called after `refresh()`
      var $location = this.$location,
          $q = this.$q,
          $timeout = this.$timeout;
      var query = $location.search();

      if (this.account.isTrialing() && Object.keys(query).length == 0) {
        if (this.staticRTMPs.length == 1) {
          query.static_rtmp_id = this.staticRTMPs[0].id;
        }
      }

      var scrollToId; // BoxCaster

      if (query.boxcaster_id) {
        var b = _.find(this.boxcasters, {
          id: query.boxcaster_id
        });

        if (b && !b.__showDetails) {
          this.toggleDetails(b);
          scrollToId = "#boxcaster-".concat(b.id);
        }
      } // Static RTMP Channel


      if (query.static_rtmp_id) {
        var r = _.find(this.staticRTMPs, {
          id: query.static_rtmp_id
        });

        if (r && !r.__showDetails) {
          this.toggleDetails(r);
          scrollToId = "#rtmp-".concat(query.static_rtmp_id);
        }
      } // Broadcaster


      if (query.broadcaster_app) {
        var b = _.find(this.allSources, {
          is_broadcaster: true
        });

        if (b && !b.__showDetails) {
          this.toggleDetails(b);
          scrollToId = '#broadcaster-';
        }
      }

      if (scrollToId) {
        $timeout(function () {
          $('html, body').animate({
            scrollTop: $(scrollToId).offset().top - 90
          });
        }, 10);
      }
    }
  }, {
    key: "startTest",
    value: function startTest(b) {
      var ConfirmDialog = this.ConfirmDialog,
          Broadcast = this.Broadcast,
          $state = this.$state;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Start Test Broadcast',
        actionButtonClass: 'primary',
        headerText: 'Please Confirm',
        bodyText: 'Would you like to run a test broadcast?'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        var params;

        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_sources__["c" /* sourceType */])(b) == 'rtmp') {
          // Static RTMP
          params = {
            stream_source: 'rtmp',
            static_rtmp_id: b.id
          };
        } else if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_sources__["c" /* sourceType */])(b) == 'broadcaster') {
          // Broadcaster
          params = {
            stream_source: 'app'
          };
        } else {
          // BoxCaster
          params = {
            stream_source: 'boxcaster',
            boxcaster_id: b.id
          };
        }

        var newBroadcast = Broadcast.save(angular.extend(params, {
          name: 'Test',
          starts_at: 'now',
          stops_at: moment().add(30, 'minutes').toISOString(),
          is_private: true
        }));
        newBroadcast.$promise.then(function () {
          console.log('Broadcast saved', newBroadcast);
          $state.go('events.detail', {
            id: newBroadcast.id
          });
        });
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this2 = this;

      var StaticRTMP = this.StaticRTMP,
          BoxCaster = this.BoxCaster,
          Broadcast = this.Broadcast,
          $q = this.$q;
      this.boxcasters = BoxCaster.query({
        l: 1000,
        s: 'name'
      }); // Get all live now broadcasts to match up stream sources

      this.broadcasts = Broadcast.query({
        q: 'timeframe:current',
        l: 100
      }); // Figure out which Static RTMPs are active

      this.broadcastsByBoxCaster = {};
      this.broadcastsByStaticRTMP = {};
      this.broadcastsByBroadcaster = {};
      this.broadcastsByProducer = {};
      var allPromises;
      var promises = [this.boxcasters.$promise, this.broadcasts.$promise];

      if (this.allowRtmp) {
        this.staticRTMPs = StaticRTMP.query({
          l: 1000,
          include_diagnostics: true
        });
        promises.push(this.staticRTMPs.$promise);
      }

      allPromises = $q.all(promises).then(function () {
        _this2.broadcasts.forEach(function (b) {
          if (b.stream_source == 'rtmp') {
            _this2.broadcastsByStaticRTMP[b.static_rtmp_id] = b;
          } else if (b.stream_source == 'boxcaster') {
            _this2.broadcastsByBoxCaster[b.boxcaster_id] = b;
          } else if (b.stream_source == 'app') {
            _this2.broadcastsByBroadcaster['__sentinel__'] = b;
          } else if (b.stream_source == 'producer') {
            _this2.broadcastsByProducer['__sentinel__'] = b;
          }
        });
      }); // Wait for all data, then massage it a bit

      allPromises.then(function () {
        _this2.loaded = true; // Collapse BoxCasters and RTMP addresses into 1 big ordered list

        _this2.allSources = (_this2.boxcasters || []).concat(_this2.staticRTMPs || []); // Add Broadcaster

        if (_this2.showBroadcasterSource) {
          var broadcasterDetails = {};

          if (_this2.broadcastsByBroadcaster['__sentinel__']) {
            broadcasterDetails = _this2.broadcastsByBroadcaster['__sentinel__'];
          }

          _this2.allSources = _this2.allSources.concat({
            is_broadcaster: true,
            name: 'Broadcaster App',
            details: broadcasterDetails
          });
        } // Add Producer


        if (_this2.showProducerSource) {
          var producerDetails = {};

          if (_this2.broadcastsByProducer['__sentinel__']) {
            producerDetails = _this2.broadcastsByProducer['__sentinel__'];
          }

          _this2.allSources = _this2.allSources.concat({
            is_producer: true,
            name: 'Producer',
            details: producerDetails
          });
        } // Sort the big list


        Object(__WEBPACK_IMPORTED_MODULE_1__utils_sources__["a" /* sortSources */])(_this2.allSources, _this2.broadcastsByStaticRTMP);
      });
      this.loadingPromises = [allPromises];
      return allPromises;
    }
  }, {
    key: "scheduleRefreshStaticRTMP",
    value: function scheduleRefreshStaticRTMP() {
      var _this3 = this;

      if (this.allowRtmp && this.staticRTMPs && this.staticRTMPs.length > 0) {
        var staticRTMPs = this.StaticRTMP.query({
          l: 1000,
          include_diagnostics: true
        });
        staticRTMPs.$promise.then(function () {
          for (var i = 0; i < _this3.allSources.length; i++) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_sources__["c" /* sourceType */])(_this3.allSources[i]) == 'rtmp') {
              _this3.allSources[i].diagnostics = _.find(staticRTMPs, function (r) {
                return r.id == _this3.allSources[i].id;
              }).diagnostics || _this3.allSources[i].diagnostics;
            }
          }

          _this3.staticRTMPRefreshInterval = STATIC_RTMP_REFRESH_INTERVAL;
        })["catch"](function (error) {
          console.log(error); // Exponential backoff up to 2 mins

          _this3.staticRTMPRefreshInterval = Math.min((_this3.staticRTMPRefreshInterval || STATIC_RTMP_REFRESH_INTERVAL) * 2, 120000);
        })["finally"](function () {
          _this3.timeoutHandle = _this3.$timeout(function () {
            return _this3.scheduleRefreshStaticRTMP();
          }, _this3.staticRTMPRefreshInterval);
        });
      }
    }
  }, {
    key: "toggleDetails",
    value: function toggleDetails(b) {
      var loadBoxcaster = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (b.__showDetails) {
        b.__showDetails = false;
      } else {
        b.__showDetails = true;

        if (loadBoxcaster) {
          b.details = this.BoxCaster.get({
            id: b.id
          });
        }
      }
    }
  }, {
    key: "editBoxCasterSettings",
    value: function editBoxCasterSettings(boxcaster) {
      var _this5 = this;

      var $uibModal = this.$uibModal,
          BoxCaster = this.BoxCaster;
      var parentVM = this;
      $uibModal.open({
        template: __webpack_require__(542),
        controllerAs: 'vm',
        backdrop: 'static',
        // don't allow accidental clicks on backdrop to close
        controller: function controller($rootScope, $sce, $uibModalInstance, toaster) {
          'ngInject';

          var _this4 = this;

          var ApiConfig = $rootScope.ApiConfig,
              account = $rootScope.account;
          var FeatureFlags = account.feature_flags;
          this.audioSliderOptions = {
            floor: -15.0,
            ceil: 15.0,
            step: 3,
            showTicks: true,
            translate: function translate(value) {
              return "".concat(value > 0 ? '+' : '').concat(value, " dBFS");
            }
          };
          this.videoBitrates = _.filter(__WEBPACK_IMPORTED_MODULE_2__utils_video_and_audio_config__["a" /* VideoAudioConfig */].boxcaster.video_bitrates, function (b) {
            return _.contains(b.serial_prefixes, boxcaster.id[0]);
          });
          this.audioBitrates = _.filter(__WEBPACK_IMPORTED_MODULE_2__utils_video_and_audio_config__["a" /* VideoAudioConfig */].boxcaster.audio_bitrates, function (b) {
            return _.contains(b.serial_prefixes, boxcaster.id[0]);
          });
          this.videoResolutions = _.filter(ApiConfig.boxcaster.video_resolutions, function (b) {
            return _.contains(b.serial_prefixes, boxcaster.id[0]) && (b.value == 'default' || b.value <= account.resolution_limit);
          });
          this.audioSources = _.filter(ApiConfig.boxcaster.audio_sources, function (b) {
            return _.contains(b.serial_prefixes, boxcaster.id[0]);
          });
          this.highFrameRates = _.filter(ApiConfig.boxcaster.high_frame_rates, function (b) {
            return _.contains(b.serial_prefixes, boxcaster.id[0]);
          });
          this.dscpValues = ApiConfig.boxcaster.dscp_values;
          this.bufferLatencies = _.filter(ApiConfig.boxcaster.buffer_latencies, function (b) {
            return _.contains(b.serial_prefixes, boxcaster.id[0]);
          });
          this.boxcaster = BoxCaster.get({
            id: boxcaster.id
          }, function (b) {
            return _this4.pristineBoxcaster = angular.copy(b);
          });
          this.isPro = boxcaster.id[0] === 'p';
          this.isHDSD2 = boxcaster.id[0] === 'o';
          this.showOptionTargetBufferLatency = (this.isPro || this.isHDSD2) && !account.feature_flags.boxcast_flow_control_disabled;
          this.targetBufferLatencyTooltip = $sce.trustAsHtml(this.isPro ? __WEBPACK_IMPORTED_MODULE_0__utils_boxcast_flow_control__["b" /* MaximumBoxCastFlowControlTooltipHTML */] : __WEBPACK_IMPORTED_MODULE_0__utils_boxcast_flow_control__["a" /* EnhancedBoxCastFlowControlTooltipHTML */]);
          this.boxcaster.$promise.then(function () {
            _this4.hasWifi = _this4.boxcaster.hasWifi();
            _this4.isOnline = _this4.boxcaster.status == 'ready';
            _this4.canConfigureWifi = _this4.hasWifi && _this4.isOnline;
          });
          this.limits = $rootScope.ApiConfig.modelFieldLimits('boxcaster', 'maximum');

          this.isAudioOnly = function () {
            return !!((_this4.boxcaster || {}).target_video_bitrate <= AUDIO_ONLY_BITRATE_HINT);
          }; // Keep track of loading state of AJAX requests


          this.loadingPromises = [this.boxcaster.$promise];

          this.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };

          this.settingsUnchanged = function () {
            return angular.equals(_this4.boxcaster, _this4.pristineBoxcaster);
          };

          this.saveSettings = function () {
            if (!_this4.boxcaster.name) {
              _this4.showError = true;
              return;
            }

            _this4.showError = false;
            _this4.savingSettings = true;
            BoxCaster.update({
              id: _this4.boxcaster.id
            }, _this4.boxcaster, function () {
              return $uibModalInstance.close(_this4.boxcaster);
            }, function (error) {
              _this4.savingSettings = false;
              toaster.pop('warning', 'Unable to save configuration. Please try again.');
            });
          };
        }
      }).result.then(function () {
        return _this5.refresh();
      });
    }
  }, {
    key: "editWifi",
    value: function editWifi(boxcaster) {
      var _this7 = this;

      var $uibModal = this.$uibModal,
          BoxCaster = this.BoxCaster;
      var parentVM = this;
      $uibModal.open({
        template: __webpack_require__(543),
        controllerAs: 'vm',
        controller: function controller($rootScope, $uibModalInstance, $scope, WifiConfigurationService, toaster) {
          'ngInject';

          var _this6 = this;

          var ApiConfig = $rootScope.ApiConfig,
              account = $rootScope.account;
          var FeatureFlags = account.feature_flags;
          this.videoBitrates = _.filter(__WEBPACK_IMPORTED_MODULE_2__utils_video_and_audio_config__["a" /* VideoAudioConfig */].boxcaster.video_bitrates, function (b) {
            return _.contains(b.serial_prefixes, boxcaster.id[0]);
          });
          this.audioBitrates = _.filter(__WEBPACK_IMPORTED_MODULE_2__utils_video_and_audio_config__["a" /* VideoAudioConfig */].boxcaster.audio_bitrates, function (b) {
            return _.contains(b.serial_prefixes, boxcaster.id[0]);
          });
          this.videoResolutions = _.filter(ApiConfig.boxcaster.video_resolutions, function (b) {
            return _.contains(b.serial_prefixes, boxcaster.id[0]) && (b.value == 'default' || b.value <= account.resolution_limit);
          });
          this.audioSources = _.filter(ApiConfig.boxcaster.audio_sources, function (b) {
            return _.contains(b.serial_prefixes, boxcaster.id[0]);
          });
          this.highFrameRates = _.filter(ApiConfig.boxcaster.high_frame_rates, function (b) {
            return _.contains(b.serial_prefixes, boxcaster.id[0]);
          });
          this.dscpValues = ApiConfig.boxcaster.dscp_values;
          this.boxcaster = BoxCaster.get({
            id: boxcaster.id
          });
          this.isPro = boxcaster.id[0] === 'p';
          this.boxcaster.$promise.then(function () {
            _this6.hasWifi = _this6.boxcaster.hasWifi();
            _this6.isOnline = _this6.boxcaster.status == 'ready';
            _this6.canConfigureWifi = _this6.hasWifi && _this6.isOnline;

            if (_this6.canConfigureWifi) {
              _this6.refreshWifiConfig();

              $scope.$on('$destroy', function () {
                WifiConfigurationService.destroy && WifiConfigurationService.destroy();
              });
            }
          });

          this.deleteNetwork = function (network) {
            if (!confirm("Are you sure you want to forget the network ".concat(network.ssid, "?"))) {
              return;
            }

            _this6.wifiConfig.current.networks.splice(_this6.wifiConfig.current.networks.indexOf(network), 1);

            _this6.saveWirelessChanges();
          };

          this.addNetwork = function (network) {
            if (!network.ssid || !network.password) {
              return;
            }

            _this6.wifiConfig.current.networks.push({
              ssid: network.ssid,
              password: network.password
            });

            _this6.showNetworkEntry = null;

            _this6.saveWirelessChanges();
          }; // Keep track of loading state of AJAX requests


          this.loadingPromises = [this.boxcaster.$promise];

          this.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };

          this.showUnsecuredHelp = function () {
            $uibModal.open({
              template: __webpack_require__(544),
              controller: function controller($scope, $uibModalInstance) {
                'ngInject';

                $scope.cancel = function () {
                  return $uibModalInstance.dismiss('cancel');
                };
              }
            });
          };

          this.refreshWifiConfig = function () {
            _this6.wifiConfig = WifiConfigurationService.getConfig(boxcaster.id).then(function (response) {
              // De-deupe the scan results
              response.scan_results = _.uniq(response.scan_results, 'ssid'); // Extract the list of connected networks

              _this6.wifiConnected = _.findWhere(response.scan_results, {
                connected: true
              }); // Restructure as dictionary for efficient lookup later

              _this6.wifiConfig = response;
              _this6.wifiConfigDict = {};
              response.scan_results.forEach(function (network) {
                _this6.wifiConfigDict[network.ssid] = network;
              }); // Filter out blank SSIDs or those that are already in the connected list from scan results

              _.remove(response.scan_results, function (r) {
                return !r.ssid || r.connected;
              });
            }, function (error) {
              _this6.wifiConfig = {
                error: true
              };
              _this6.wifiConnected = null;
            });
          };

          this.signalStrengthForNetwork = function (network) {
            return (_this6.wifiConfigDict[network.ssid] || {}).signal_strength;
          };

          this.saveWirelessChanges = function () {
            _this6.savingWireless = true;
            WifiConfigurationService.setConfig(boxcaster.id, _this6.wifiConfig.current).then(function (response) {
              _this6.savingWireless = false;

              _this6.refreshWifiConfig();
            }, function (error) {
              _this6.savingWireless = false;
              toaster.pop('warning', 'Unable to save wireless configuration. Please try again.');
            });
          };
        }
      }).result.then(function () {
        return _this7.refresh();
      });
    }
  }, {
    key: "showAddSourceModal",
    value: function showAddSourceModal(_sourceToAdd) {
      var _params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var $uibModal = this.$uibModal;

      var _parentVM = this;

      $uibModal.open({
        template: __webpack_require__(545),
        controller: __webpack_require__(227)["default"],
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          parentVM: function parentVM() {
            return _parentVM;
          },
          onlyShowEncoderGuides: function onlyShowEncoderGuides() {
            return false;
          },
          sourceToAdd: function sourceToAdd() {
            return _sourceToAdd;
          },
          params: function params() {
            return _params;
          }
        }
      });
    }
  }, {
    key: "showEncoderGuides",
    value: function showEncoderGuides() {
      var $uibModal = this.$uibModal;

      var _parentVM2 = this;

      $uibModal.open({
        template: __webpack_require__(547),
        controller: __webpack_require__(227)["default"],
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          parentVM: function parentVM() {
            return _parentVM2;
          },
          onlyShowEncoderGuides: function onlyShowEncoderGuides() {
            return true;
          },
          sourceToAdd: function sourceToAdd() {
            return 'rtmp';
          },
          params: function params() {
            return {};
          }
        }
      });
    }
  }, {
    key: "editRTMP",
    value: function editRTMP(staticRTMP) {
      var _this9 = this;

      var $uibModal = this.$uibModal,
          StaticRTMP = this.StaticRTMP,
          ConfirmDialog = this.ConfirmDialog,
          toaster = this.toaster;
      var parentVM = this;
      $uibModal.open({
        template: __webpack_require__(548),
        controllerAs: 'vm',
        controller: function controller($rootScope, $uibModalInstance, toaster) {
          'ngInject';

          var _this8 = this;

          this.limits = $rootScope.ApiConfig.modelFieldLimits('static_rtmp', 'maximum');
          this.staticRTMP = StaticRTMP.get({
            id: staticRTMP.id
          }); // Keep track of loading state of AJAX requests

          this.loadingPromises = [this.staticRTMP.$promise];

          this.cancel = function () {
            return $uibModalInstance.dismiss('cancel');
          };

          this["delete"] = function () {
            var modalOptions = {
              closeButtonText: 'Cancel',
              actionButtonText: 'Delete RTMP Source',
              actionButtonClass: 'danger',
              headerText: 'Please Confirm',
              bodyText: 'Are you sure you want to delete this RTMP source? Any encoders using this stream key and server URL will need to be updated.'
            };
            ConfirmDialog.show(modalOptions).then(function () {
              StaticRTMP["delete"]({
                id: _this8.staticRTMP.id
              }, function () {
                $uibModalInstance.close(_this8.staticRTMP); // remove the recently deleted source from the list of sources in the UI

                _this8.allSources.splice(_this8.allSources.findIndex(function (s) {
                  return s.id == _this8.staticRTMP.id;
                }), 1);
              }, function (err) {
                if (err.status == 409 && err.data.error_description.indexOf('upcoming broadcast') >= 0) {
                  console.error(err);
                  toaster.pop('warning', "There is at least one upcoming broadcast that uses this RTMP source. Please update all upoming broadcasts to use a different source and then try again.");
                } else {
                  console.error(err);
                  toaster.pop('warning', 'Unable to delete RTMP source. Please try again.');
                }
              });
            });
          };

          this.saveSettings = function () {
            if (!_this8.staticRTMP.name) {
              _this8.showError = true;
              return;
            }

            _this8.showError = false;
            _this8.savingSettings = true;
            StaticRTMP.update({
              id: _this8.staticRTMP.id
            }, {
              name: _this8.staticRTMP.name,
              description: _this8.staticRTMP.description
            }, function () {
              return $uibModalInstance.close(_this8.staticRTMP);
            }, function (error) {
              _this8.savingSettings = false;
              toaster.pop('warning', 'Unable to save configuration. Please try again.');
            });
          };
        }
      }).result.then(function () {
        return _this9.refresh();
      });
    }
  }, {
    key: "renameStaticRTMP",
    value: function renameStaticRTMP(staticRTMP, newName) {
      var _this10 = this;

      var StaticRTMP = this.StaticRTMP,
          toaster = this.toaster;
      staticRTMP._saving = true;
      StaticRTMP.update({
        id: staticRTMP.id
      }, {
        name: newName
      }, function () {
        staticRTMP._saving = false;
        staticRTMP._showRename = false;
        toaster.pop('success', 'Successfully renamed RTMP channel');

        _this10.refresh();
      }, function (err) {
        console.error(err);
        staticRTMP._saving = false;
        toaster.pop('warning', 'Error renaming RTMP channel. Please try again.');
      });
    }
  }, {
    key: "regenerateStreamKey",
    value: function regenerateStreamKey(staticRTMP) {
      var _this11 = this;

      var StaticRTMP = this.StaticRTMP,
          ConfirmDialog = this.ConfirmDialog,
          toaster = this.toaster;
      var modalOptions = {
        closeButtonText: 'Cancel',
        actionButtonText: 'Regenerate Stream Key',
        actionButtonClass: 'danger',
        headerText: 'Please Confirm',
        bodyText: 'Are you sure you want to change the stream key? The old key will be immediately removed, and your encoder must be updated with the new key before your broadcasts can continue.'
      };
      ConfirmDialog.show(modalOptions).then(function () {
        StaticRTMP.update({
          id: staticRTMP.id
        }, {
          regenerate_stream_key: true
        }, function () {
          toaster.pop('success', 'Successfully re-generated stream key');

          _this11.refresh();
        }, function (err) {
          console.error(err);
          toaster.pop('warning', 'Unable to regenerate stream key. Please try again.');
        });
      });
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      return window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    }
  }]);

  return BoxCastersController;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = "<form name=\"boxcasterForm\" role=\"form\">\n\n  <div class=\"modal-header\" style=\"border-bottom:0;padding-bottom:0;\">\n    <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n    <ol class=\"inline-tabs list-inline\" style=\"margin-bottom:15px\">\n      <li ng-class=\"!vm.activeTab ? 'active' : ''\">\n        <a href=\"javascript://\" ng-click=\"vm.activeTab = ''\">Overview</a>\n      </li>\n      <li ng-class=\"vm.activeTab == 'video' ? 'active' : ''\">\n        <a href=\"javascript://\" ng-click=\"vm.activeTab = 'video'\">Video</a>\n      </li>\n      <li ng-class=\"vm.activeTab == 'audio' ? 'active' : ''\">\n        <a href=\"javascript://\" ng-click=\"vm.activeTab = 'audio'\">Audio</a>\n      </li>\n      <li ng-class=\"vm.activeTab == 'streaming' ? 'active' : ''\">\n        <a href=\"javascript://\" ng-click=\"vm.activeTab = 'streaming'\">Streaming</a>\n      </li>\n    </ol>\n  </div>\n\n  <div ng-if=\"!vm.activeTab\" class=\"modal-body text-left\" style=\"padding-top:0\">\n    <div ng-if=\"vm.showError\">\n      <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n        Please fill out all required fields before submitting.\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"name\">BoxCaster Name <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n      <input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" ng-model=\"vm.boxcaster.name\" ng-maxlength=\"::vm.limits.name\" required>\n      <p ng-show=\"!vm.boxcaster.name\">\n        <span class=\"text-danger\" ng-if=\"boxcasterForm.name.$error.maxlength\">The BoxCaster name is too long.</span>\n        <span class=\"text-danger\" ng-if=\"boxcasterForm.name.$error.required\">The BoxCaster name cannot be blank.</span>\n      </p>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"checkbox\">\n        <label for=\"allows_remote_troubleshooting\">\n          <input type=\"checkbox\" id=\"allows_remote_troubleshooting\" ng-model=\"vm.boxcaster.allows_remote_troubleshooting\">\n          Allow Remote Troubleshooting\n          <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" tooltip-append-to-body=\"true\"\n             uib-tooltip=\"Allow BoxCast support staff to connect directly to your BoxCaster to perform remote troubleshooting.\" ></i>\n        </label>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"form-group col-sm-6\">\n        <p>\n          <label>Serial Number</label><br>\n          <span style=\"font-family:monospace\">{{vm.boxcaster.id}}</span>\n        </p>\n\n        <p ng-if=\"vm.boxcaster.ethernet_address\">\n          <label>Ethernet MAC Address</label><br>\n          <span style=\"font-family:monospace\">{{vm.boxcaster.ethernet_address | macAddress}}</span>\n        </p>\n\n        <p ng-if=\"vm.boxcaster.wireless_address\">\n          <label>Wireless MAC Address</label><br>\n          <span style=\"font-family:monospace\">{{vm.boxcaster.wireless_address | macAddress}}</span>\n        </p>\n      </div>\n\n      <div class=\"form-group col-sm-6\">\n        <label>Firmware Version</label>\n        <p>\n          <firmware-version boxcaster=\"vm.boxcaster\" concise=\"false\"></firmware-version>\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.activeTab == 'video'\" class=\"modal-body text-left\" style=\"padding-top:0\">\n    <div ng-if=\"vm.showError\">\n      <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n        Please fill out all required fields before submitting.\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"video_resolution\">\n        Video Resolution\n        <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\"\n           uib-tooltip=\"Choose the default video resolution for streaming, or 'Auto-detect' to let the BoxCaster choose the best resolution. You can also override this in the advanced settings of a broadcast.\" ></i>\n      </label>\n      <select class=\"form-control\" id=\"video_resolution\"\n              ng-model=\"vm.boxcaster.target_video_resolution\"\n              ng-disabled=\"vm.isAudioOnly()\"\n              ng-options=\"e.value as e.label for e in ::vm.videoResolutions\">\n      </select>\n    </div>\n\n    <div class=\"form-group\" ng-show=\"::vm.isPro\">\n      <label for=\"target_high_frame_rate\">\n        High Frame Rate\n        <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" tooltip-append-to-body=\"true\"\n           uib-tooltip=\"Choose the default frame rate for streaming, or 'Auto-detect' to let the BoxCaster choose the best frame rate. You can also override this in the advanced settings of a broadcast.\" ></i>\n      </label>\n      <select class=\"form-control\" id=\"target_high_frame_rate\"\n              ng-model=\"vm.boxcaster.target_high_frame_rate\"\n              ng-disabled=\"vm.isAudioOnly()\"\n              ng-options=\"e.value as e.label for e in ::vm.highFrameRates\">\n      </select>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.activeTab == 'audio'\" class=\"modal-body text-left\" style=\"padding-top:0\">\n    <div ng-if=\"vm.showError\">\n      <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n        Please fill out all required fields before submitting.\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"audio_source\">\n        Audio Source\n        <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\"\n           uib-tooltip=\"Choose the default audio source to use for streaming, or 'All Sources' to mix all available audio sources. You can also override this in the advanced settings of a broadcast.\" ></i>\n      </label>\n      <select class=\"form-control\" id=\"audio_source\"\n              ng-model=\"vm.boxcaster.audio_source\"\n              ng-options=\"e.value as e.label for e in ::vm.audioSources\">\n      </select>\n    </div>\n\n    <hr ng-if=\"vm.isHDSD2\" style=\"margin-top:25px\">\n\n    <label ng-if=\"vm.isHDSD2\">Audio Gain Control</label>\n    <p class=\"help-block\" ng-if=\"vm.isHDSD2\" style=\"padding-bottom: 15px;\">\n      Use the controls below to adjust the gain of incoming audio levels on your BoxCaster.\n      Gain adjustments are in dBFS (decibels relative to a full scale digital signal).\n      <a href=\"https://support.boxcast.com/en/articles/4235068-edit-the-advanced-settings-on-the-boxcaster\" target=\"_blank\" class=\"subtle-link\">Learn More</a>\n    </p>\n\n    <div class=\"form-group\" ng-if=\"vm.isHDSD2\">\n      <label for=\"analog_audio_level\">Analog:</label>\n      <rzslider id=\"analog_audio_level\"\n                rz-slider-model=\"vm.boxcaster.analog_audio_level\"\n                rz-slider-options=\"vm.audioSliderOptions\"></rzslider>\n      </select>\n    </div>\n\n    <div class=\"form-group\" ng-if=\"vm.isHDSD2\">\n      <label for=\"hdmi_audio_level\">HDMI:</label>\n      <rzslider id=\"hdmi_audio_level\"\n                rz-slider-model=\"vm.boxcaster.hdmi_audio_level\"\n                rz-slider-options=\"vm.audioSliderOptions\"></rzslider>\n      </select>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.activeTab == 'streaming'\" class=\"modal-body text-left\" style=\"padding-top:0\">\n    <div ng-if=\"vm.showError\">\n      <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n        Please fill out all required fields before submitting.\n      </div>\n    </div>\n\n    <div class=\"form-group\" ng-show=\"::vm.showOptionTargetBufferLatency\">\n      <label for=\"target_buffer_latency\">\n        BoxCast Flow Control\n        <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" uib-tooltip-html=\"::vm.targetBufferLatencyTooltip\"\n          tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\"></i>\n      </label>\n      <select class=\"form-control\" id=\"target_buffer_latency\"\n              ng-model=\"vm.boxcaster.target_buffer_latency\"\n              ng-options=\"e.value as e.label for e in ::vm.bufferLatencies\">\n      </select>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"target_video_bitrate\">\n        Target Video Bitrate\n        <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\"\n           uib-tooltip=\"Choose the target (highest) video bitrate to use for streaming, or 'Auto-detect' to allow the BoxCaster to manage the target video bitrate automatically. You can also override this in the advanced settings of a broadcast.\" ></i>\n      </label>\n      <select class=\"form-control\" id=\"target_video_bitrate\"\n              ng-model=\"vm.boxcaster.target_video_bitrate\"\n              ng-options=\"e.value as e.label for e in ::vm.videoBitrates\">\n      </select>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"target_audio_bitrate\">\n        Target Audio Bitrate\n        <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" tooltip-append-to-body=\"true\"\n           uib-tooltip=\"Choose the target (highest) audio bitrate to use for streaming, or 'Auto-detect' to allow the BoxCaster to manage the target audio bitrate automatically. You can also override this in the advanced settings of a broadcast.\" ></i>\n      </label>\n      <select class=\"form-control\" id=\"target_audio_bitrate\"\n              ng-model=\"vm.boxcaster.target_audio_bitrate\"\n              ng-options=\"e.value as e.label for e in ::vm.audioBitrates\">\n      </select>\n    </div>\n\n    <div class=\"form-group\">\n      <label for=\"dscp\">\n        DSCP Value\n        <i class=\"fa fa-question-circle\" style=\"opacity:0.5\" tooltip-append-to-body=\"true\"\n           uib-tooltip=\"Choose the DSCP value with which streaming traffic will be marked, or 'No DSCP' to not use DSCP. You can also override this in the advanced settings of a broadcast.\" ></i>\n      </label>\n      <select class=\"form-control\" id=\"dscp\"\n              ng-model=\"vm.boxcaster.dscp_value\"\n              ng-options=\"e.value as e.label for e in ::vm.dscpValues\">\n      </select>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-default\">Cancel</button>\n    <button ng-click=\"vm.saveSettings()\"\n            ng-disabled=\"vm.settingsUnchanged() || vm.savingSettings\"\n            class=\"btn btn-primary\">\n      <i ng-show=\"vm.savingSettings\" class=\"fa fa-spin fa-spinner\"></i>\n      Save Changes\n    </button>\n  </div>\n\n</form>\n"

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n  <div class=\"modal-header\">\n    <a href class=\"pull-right\" ng-click=\"vm.cancel()\" title=\"Close Dialog\"><i class=\"fa fa-times\"></i></a>\n    <h3 class=\"modal-title\">Configure Wi-Fi </h3>\n  </div>\n  <div class=\"modal-body text-left\">\n    <div class=\"row\">\n\n    <div class=\"col-xs-12\" ng-show=\"!vm.canConfigureWifi\">\n      <div class=\"\">\n        <p ng-if=\"!vm.hasWifi\">\n          The Wi-Fi configuration option is only available for HDSD2-generation BoxCasters and BoxCaster Pros.\n        </p>\n        <p ng-if=\"vm.hasWifi && !vm.isPro\">\n          Wi-Fi can only be configured when the BoxCaster is <strong>online and not broadcasting.</strong> <br><br>\n          To connect to Wi-Fi, please make sure the BoxCaster is powered on, plugged into Ethernet, and has an Internet connection.\n        </p>\n        <p ng-if=\"vm.hasWifi && vm.isPro\">\n          To connect to Wi-Fi, connect your BoxCaster Pro's Ethernet port to an Internet connection, or use the Broadcaster app.\n          <a href=\"https://support.boxcast.com/en/articles/4235057\">Learn How</a>\n        </p>\n      </div>\n    </div>\n\n    <div class=\"col-xs-12\" ng-show=\"vm.showNetworkEntry\">\n\n          <div class=\"form-group\">\n            <label for=\"ssid\">Wi-Fi SSID</label>\n            <input type=\"text\" class=\"form-control\" id=\"ssid\" ng-if=\"vm.showNetworkEntry.add_other\" ng-model=\"vm.showNetworkEntry.ssid\" required>\n            <input type=\"text\" class=\"form-control\" id=\"ssid\" readonly ng-if=\"!vm.showNetworkEntry.add_other\" ng-model=\"vm.showNetworkEntry.ssid\" required>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"password\">Password</label>\n            <input type=\"text\" class=\"form-control\" id=\"password\" ng-model=\"vm.showNetworkEntry.password\" required>\n          </div>\n\n          <div style=\"margin-top:15px\">\n            <button type=\"button\" ng-click=\"vm.showNetworkEntry = null\" class=\"btn btn-default\">Cancel</button>\n            <button ng-click=\"vm.addNetwork(vm.showNetworkEntry)\" class=\"btn btn-primary\">\n              Add Network\n            </button>\n          </div>\n\n    </div>\n\n    <div class=\"col-xs-12\" ng-show=\"vm.canConfigureWifi && !vm.showNetworkEntry\">\n      <div class=\"\">\n\n        <div ng-if=\"vm.savingWireless || vm.wifiConfig.$$state.status == 0\">\n          <i class=\"fa fa-spin fa-spinner\"></i>\n          <span ng-show=\"vm.savingWireless\">Saving Changes</span>\n          <span ng-hide=\"vm.savingWireless\">Searching for Wi-Fi Networks</span>\n        </div>\n\n        <p ng-if=\"vm.wifiConfig.error\" class=\"bg-warning text-warning\" style=\"padding:8px;border:1px solid\">\n          There was an error loading the Wi-Fi configuration: {{vm.wifiConfig.error_description}}\n        </p>\n\n        <div ng-if=\"!vm.savingWireless && vm.wifiConfig.$$state.status != 0 && !vm.wifiConfig.error\">\n            <h4>Configured Networks</h4>\n\n            <p ng-if=\"vm.wifiConfig.current.networks.length == 0\" class=\"bg-warning text-warning\" style=\"padding:8px;border:1px solid\">\n              There are no configured Wi-Fi networks.\n            </p>\n\n            <div ng-if=\"vm.wifiConfig.current.networks.length > 0\">\n              <table class=\"table table-condensed table-noborders\">\n                <tbody>\n                  <tr ng-repeat=\"network in vm.wifiConfig.current.networks\">\n                    <td style=\"width:5%\" class=\"text-left\">\n                      <span ng-if=\"network.connected || (vm.wifiConnected && vm.wifiConnected.ssid == network.ssid)\">\n                        <i class=\"fa fa-check text-primary\"></i>\n                      </span>\n                    </td>\n                    <td>{{network.ssid}}</td>\n                    <td class=\"text-left\" style=\"width:20%;font-size: 0.8em;line-height: 27px;\">\n                      <div ng-show=\"vm.signalStrengthForNetwork(network)\">\n                        <wifi-signal-strength label-position=\"'right'\" pct=\"vm.signalStrengthForNetwork(network)\"></wifi-signal-strength>\n                      </div>\n                    </td>\n                    <td class=\"text-right\" style=\"width:15%\">\n                      <button type=\"button\" class=\"btn btn-xs btn-block btn-danger\" ng-click=\"vm.deleteNetwork(network)\">\n                        Forget\n                      </button>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n\n            <a class=\"pull-right\" href=\"javascript://\" ng-click=\"vm.refreshWifiConfig()\">\n              <i class=\"fa fa-refresh\"></i>\n              Search Again\n            </a>\n            <h4>Available Networks</h4>\n\n            <table class=\"table table-condensed table-noborders\">\n              <tbody>\n                <tr ng-repeat=\"network in vm.wifiConfig.scan_results\">\n                  <td style=\"width:5%\" class=\"text-left\">\n                    <span ng-if=\"network.connected || (vm.wifiConnected && vm.wifiConnected.ssid == network.ssid)\">\n                      <i class=\"fa fa-check text-primary\"></i>\n                    </span>\n                  </td>\n                  <td>{{network.ssid}}</td>\n                  <td class=\"text-left\" style=\"width:20%;font-size: 0.8em;line-height: 27px;\">\n                    <wifi-signal-strength label-position=\"'right'\" pct=\"network.signal_strength\"></wifi-signal-strength>\n                  </td>\n                  <td class=\"text-right\" style=\"width:15%\">\n                    <button type=\"button\" class=\"btn btn-xs btn-block btn-default\" ng-click=\"vm.showNetworkEntry = network\">Add</button>\n                  </td>\n                </tr>\n                <tr>\n                  <td style=\"width:5%\" class=\"text-left\"></td>\n                  <td>Other...</td>\n                  <td></td>\n                  <td class=\"text-right\" style=\"width:15%\">\n                    <button type=\"button\" class=\"btn btn-xs btn-block btn-default\" ng-click=\"vm.showNetworkEntry = {add_other: true, ssid: '', password: ''}\">Add</button>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n\n\n            <div class=\"row\" style=\"margin-top:30px\">\n              <div class=\"col-sm-10\">\n                <div class=\"checkbox\">\n                  <label>\n                    <input type=\"checkbox\" ng-model=\"vm.wifiConfig.current.allow_open_networks\">\n                    Auto Connect To Open Networks\n                  </label>\n                  <p class=\"help-block\"><small>\n                    Attempt to connect to open networks if no configured networks are available.\n                    <a href=\"javascript://\" ng-click=\"vm.showUnsecuredHelp()\"><i class=\"fa fa-question-circle\"></i></a>\n                  </small>\n                  </p>\n                </div>\n              </div>\n              <div class=\"col-sm-2 text-sm-right\">\n                <button ng-click=\"vm.saveWirelessChanges()\"\n                        class=\"btn btn-primary\">\n                  <i ng-show=\"vm.savingWireless\" class=\"fa fa-spin fa-spinner\"></i>\n                  Save\n                </button>\n              </div>\n            </div>\n\n        </div>\n\n        <!-- <pre>{{vm.wifiConfig | json}}</pre> -->\n\n      </div>\n\n    </div>\n\n\n\n\n\n    </div>\n  </div>\n</form>\n"

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n  <div class=\"modal-header\">\n    <h3 class=\"modal-title\">Open (Unsecured) Networks</h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n       <p> \n          A wireless network that does not require a password (or other form of credentials) is an \"open\" or \"unsecured\" network. In general,\n          any information sent or received on an unsecured network will be visible to other users of the same network, meaning that these\n          networks are generally less secure than those that require a password.\n       </p> \n       <p> \n          Your BoxCaster is designed to communicate with the BoxCast servers using SSL/TLS -- basically, this means that all its communications\n          are secured with the same protocols used to secure things like online banking, web-based email, and other sensitive internet traffic.\n          (This is what makes the small \"lock\" icon show up in your browser.) For this reason, there is slightly less risk in allowing the\n          BoxCaster to use open networks.\n       </p> \n       <p> \n          However, an open network is more likely to be outside of your control than a secured network. If you choose to use an open network,\n          you are more likely to experience slow speeds, intermittent connectivity, or exposure to undesirable traffic. In general, it is always\n          best to use networks you know and trust, and over which you have some control. <strong>If in doubt, leave this box unchecked and\n          configure known, good wireless networks for your BoxCaster to use.</strong>\n       </p> \n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n      <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Close</button>\n  </div>\n</form>\n"

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n\n  <div class=\"modal-header\">\n    <a href class=\"pull-right\" ng-click=\"vm.cancel()\" title=\"Close Dialog\"><i class=\"fa fa-times\"></i></a>\n    <h3 ng-if=\"vm.sourceToAdd\" class=\"modal-title\">\n      <a href class=\"pull-left\" style=\"margin-right:10px;color:inherit;\" ng-click=\"vm.sourceToAdd=null\" title=\"Back\"><i class=\"fa fa-chevron-left\"></i></a>\n      <span ng-if=\"vm.sourceToAdd == 'boxcaster'\">Register a BoxCaster</span>\n      <span ng-if=\"vm.sourceToAdd == 'boxcaster-pro'\" class=\"modal-title\">Register a BoxCaster Pro</span>\n      <span ng-if=\"vm.sourceToAdd == 'broadcaster'\" class=\"modal-title\">Download Broadcaster</span>\n      <span ng-if=\"vm.sourceToAdd == 'rtmp'\" class=\"modal-title\">Add an RTMP Source</span>\n    </h3>\n    <h3 ng-if=\"!vm.sourceToAdd\" class=\"modal-title\">Add a Source</h3>\n  </div>\n\n  <div class=\"modal-body\">\n    <div class=\"row\">\n\n      <!-- main page; nothing selected -->\n      <div ng-show=\"!vm.sourceToAdd\" class=\"col-xs-12\"> <!-- use show instead of if so we can keep selected tab -->\n        <p ng-if=\"vm.detectedBox.$$state.status == 0\">\n          <i class=\"fa fa-spin fa-spinner\"></i> Searching for local BoxCaster...\n        </p>\n        <div ng-if=\"vm.detectedBox.$$state.status != 0 && vm.boxcaster.id\" class=\"row bg-success text-success\" style=\"border:1px solid;padding:10px;margin:0 0 15px\">\n          <div class=\"col-sm-10\">\n            <strong>We have auto-detected a new BoxCaster on your network.</strong></br>\n            Serial Number: {{vm.boxcaster.id}}\n          </div>\n          <div class=\"col-sm-2\" style=\"padding:0;margin-top:2px\">\n            <button ng-disabled=\"vm.saving\"\n                    ng-click=\"vm.registerBoxCaster()\"\n                    class=\"btn btn-success btn-block pull-right\">\n              <span ng-hide=\"vm.saving\">Register</span>\n              <span ng-show=\"vm.saving\"><i class=\"fa fa-spin fa-spinner\"></i> Registering...</span>\n            </button>\n          </div>\n        </div>\n        <div class=\"text-center\">\n          <source-tabbed-selector\n            allow-broadcaster=\"vm.allowBroadcaster\"\n            allow-rtmp=\"vm.allowRtmp\"\n            hide-producer=\"true\"\n            on-select=\"vm.select\"></source-tabbed-selector>\n        </div>\n      </div>\n\n      <!-- boxcaster page -->\n      <div ng-if=\"vm.sourceToAdd == 'boxcaster'\" class=\"col-xs-12\">\n        <p ng-if=\"vm.detectedBox.$$state.status == 0\">\n          <i class=\"fa fa-spin fa-spinner\"></i> Searching for local BoxCaster...\n        </p>\n        <div ng-if=\"vm.detectedBox.$$state.status != 0\">\n          <p ng-if=\"vm.detectedBox.id[0] == 'o'\" class=\"bg-success text-success\" style=\"border:1px solid;padding:10px;margin:0 0 15px\">\n            We have auto-detected a new BoxCaster on your network.\n          </p>\n          <h5 style=\"margin-bottom:0\"><strong>Serial Number</strong></h5>\n          <p class=\"help-block\" style=\"margin:0 0 5px 0;\"><small>Found on the bottom of the BoxCaster</small></p>\n          <div class=\"row form-group\" syle=\"maring-top:0\">\n            <div class=\"col-xs-8\">\n              <input type=\"text\"\n                      class=\"form-control\"\n                      placeholder=\"eg o9c4ebf3df16f\"\n                      ng-model=\"vm.boxcaster.id\"\n                      required\n                      style=\"font-family:monospace;\">\n            </div>\n            <div class=\"col-xs-4\">\n              <button ng-disabled=\"vm.saving\"\n                      ng-click=\"vm.registerBoxCaster()\"\n                      class=\"btn btn-primary btn-block\">\n                <span ng-hide=\"vm.saving\">Register</span>\n                <span ng-show=\"vm.saving\"><i class=\"fa fa-spin fa-spinner\"></i> Registering...</span>\n              </button>\n            </div>\n          </div>\n        </div>\n        <h4 style=\"margin-top:30px\"><strong>Buy a BoxCaster</strong></h4>\n        <div class=\"row\">\n          <div class=\"col-xs-4\">\n            <img class=\"img\" src=\"https://www.boxcast.com/hubfs/Dashboard%20Images/BoxCaster-Borderless.png\" style=\"width:100%;height:auto;\">\n          </div>\n          <div class=\"col-xs-5\">\n            <h5><strong>Product Information</strong></h5>\n            <small>\n              - Broadcast up to 1080p30</br>\n              - HDMI Input</br>\n              - Incorporate External Audio via RCA</br>\n              - H.264 Encoding</br>\n              - Automated Broadcasting</br>\n              - Ethernet and Wi-Fi</br>\n              <a href=\"https://www.boxcast.com/product/boxcaster\" target=\"_blank\" style=\"margin-left:5px;margin-top:5px;border-bottom:1px solid\">More Information</a>\n            </small>\n          </div>\n          <div class=\"col-xs-3\">\n            <p class=\"text-muted\" style=\"margin-top:30px;margin-bottom:0\">Price</p>\n            <h4 style=\"margin-top:5px\">\n              <strong>$399</strong>\n            </h4>\n            <p class=\"text-muted\" style=\"margin-top:15px;margin-bottom:5px\">To Buy</p>\n            <a ng-click=\"vm.onContactUs()\" class=\"btn btn-primary\">Contact Us</a>\n          </div>\n        </div>\n      </div>\n\n      <!-- boxcaster pro page -->\n      <div ng-if=\"vm.sourceToAdd == 'boxcaster-pro'\" class=\"col-xs-12\">\n        <p ng-if=\"vm.detectedBox.$$state.status == 0\">\n          <i class=\"fa fa-spin fa-spinner\"></i> Searching for local BoxCaster Pro...\n        </p>\n        <div ng-if=\"vm.detectedBox.$$state.status != 0\">\n          <p ng-if=\"vm.detectedBox.id[0] == 'p'\" class=\"bg-success text-success\" style=\"border:1px solid;padding:10px;margin:0 0 15px\">\n            We have auto-detected a new BoxCaster Pro on your network.\n          </p>\n          <h5 style=\"margin-bottom:0\"><strong>Serial Number</strong></h5>\n          <p class=\"help-block\" style=\"margin:0 0 5px 0;\"><small>Found on the back of the BoxCaster Pro</small></p>\n          <div class=\"row form-group\" syle=\"maring-top:0\">\n            <div class=\"col-xs-8\">\n              <input type=\"text\"\n                      class=\"form-control\"\n                      placeholder=\"eg p9c4ebf3df16f\"\n                      ng-model=\"vm.boxcaster.id\"\n                      required\n                      style=\"font-family:monospace;\">\n            </div>\n            <div class=\"col-xs-4\">\n              <button ng-disabled=\"vm.saving\"\n                      ng-click=\"vm.registerBoxCaster()\"\n                      class=\"btn btn-primary btn-block\">\n                <span ng-hide=\"vm.saving\">Register</span>\n                <span ng-show=\"vm.saving\"><i class=\"fa fa-spin fa-spinner\"></i> Registering...</span>\n              </button>\n            </div>\n          </div>\n        </div>\n        <h4 style=\"margin-top:30px\"><strong>Buy a BoxCaster Pro</strong></h4>\n        <div class=\"row\">\n          <div class=\"col-xs-4\">\n            <img class=\"img\" src=\"https://www.boxcast.com/hubfs/Dashboard%20Images/BoxCaster-Pro-Borderless.png\" style=\"width:100%;height:auto;\">\n          </div>\n          <div class=\"col-xs-5\">\n            <h5><strong>Product Information</strong></h5>\n            <small>\n              - Broadcast up to 1080p60</br>\n              - Accepts 4K, HD, and SD Video</br>\n              - HDMI and SDI Inputs and Outputs</br>\n              - Professional Mic/Line Audio Inputs</br>\n              - Efficient HEVC (H.265) Encoding</br>\n              - Automated Broadcasting</br>\n              <a href=\"https://www.boxcast.com/product/boxcaster-pro\" target=\"_blank\" style=\"margin-left:5px;margin-top:5px;border-bottom:1px solid\">More Information</a>\n            </small>\n          </div>\n          <div class=\"col-xs-3\">\n            <p class=\"text-muted\" style=\"margin-top:30px;margin-bottom:5px\">Price</p>\n            <h4 style=\"margin-top:0\"><strong>$2,995</strong></h4>\n            <p class=\"text-danger\">{{::vm.backorderMessages.pro_text}}</p>\n            <!--p class=\"text-muted\" style=\"margin-top:15px;margin-bottom:5px\">To Buy</p>\n            <a ng-click=\"vm.onContactUs()\" class=\"btn btn-primary\">Contact Us</a-->\n          </div>\n        </div>\n      </div>\n\n      <!-- broadcaster app page -->\n      <div ng-if=\"vm.sourceToAdd == 'broadcaster'\" class=\"col-xs-12\">\n        <div class=\"row\">\n          <div class=\"col-sm-8 col-sm-offset-2\">\n            <p>Use your phone to live stream from almost anywhere. The Broadcaster app for iOS is a free download available to all customers.</p>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-4 col-sm-offset-2\">\n            <img src=\"/img/broadcaster_app_qr.png\" style=\"height: 300px; width: 300px;\" />\n          </div>\n          <div class=\"col-sm-4\">\n            <a href=\"https://itunes.apple.com/us/app/broadcaster-smarter-way-to/id1105581053\" title=\"Download Broadcaster for iOS\" target=\"_blank\">\n              <img style=\"height:46px;margin-top:15px;\" src=\"https://www.boxcast.com/hubfs/BoxCast_May2016/Download_on_the_App_Store_Badge_US-UK_135x40.svg?t=1511299765595\">\n            </a>\n          </div>\n        </div>\n        <a ng-click=\"vm.cancel()\" class=\"btn btn-default btn-block\" style=\"margin-top:20px\">\n          Return to Sources\n        </a>\n      </div>\n\n      <!-- rtmp page -->\n      <div ng-if=\"vm.sourceToAdd == 'rtmp'\" class=\"col-xs-12\">\n        <div style=\"margin-bottom:30px\">\n          <p class=\"text-muted\">Add a source to generate a RTMP URL and stream key to plug into your encoder</p>\n          <div ng-if=\"vm.staticRTMPChannels.length < vm.staticRTMPChannelLimit\">\n            <h5 style=\"margin-bottom:5px;\"><strong>Source Name</strong></h5>\n            <p class=\"text-muted\" style=\"margin-bottom:5px\">Use a name that will help you identify the encoder</p>\n            <div class=\"row form-group\" syle=\"maring-top:0\">\n              <div class=\"col-xs-8\">\n                <input type=\"text\"\n                        class=\"form-control\"\n                        placeholder=\"e.g. My RTMP Encoder\"\n                        id=\"sourceName\"\n                        name=\"sourceName\"\n                        ng-model=\"vm.rtmpChannelName\"\n                        ng-maxlength=\"::vm.limits.name\"\n                        required>\n                <p ng-show=\"(form.sourceName.$dirty || form.sourceName.$touched) && !vm.rtmpChannelName\">\n                  <span class=\"text-danger\" ng-if=\"form.sourceName.$error.maxlength\">The source name is too long.</span>\n                  <span class=\"text-danger\" ng-if=\"form.sourceName.$error.required\">The source name cannot be blank.</span>\n                </p>\n              </div>\n              <div class=\"col-xs-4\">\n                <button ng-disabled=\"vm.saving\"\n                        ng-click=\"vm.createRtmpChannel()\"\n                        class=\"btn btn-primary btn-block\">\n                        Add Source\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div ng-if=\"vm.staticRTMPChannels.length >= vm.staticRTMPChannelLimit\" style=\"margin-bottom:30px\">\n          <p class=\"bg-danger text-danger\" style=\"border:1px solid;padding:10px;margin:0 0 15px\">\n            You have reached your limit of RTMP sources. Please delete a source or contact our support\n            team at questions@boxcast.com.\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</form>\n"

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENCODER_GUIDES; });
/* unused harmony export SOURCE_TABS */
var ENCODER_GUIDES = [{
  name: 'Any RTMP Encoder',
  img: '/img/source-vendors/rtmp.png',
  url: 'https://support.boxcast.com/en/articles/4235181'
}, {
  name: 'AJA HELO',
  img: '/img/source-vendors/AJA-HELO.png',
  url: 'https://support.boxcast.com/en/articles/4235194'
}, {
  name: 'Larix for Android',
  img: '/img/source-vendors/Larix.png',
  url: 'https://support.boxcast.com/en/articles/4235173'
}, {
  name: 'LiveU Solo',
  img: '/img/source-vendors/GoSolo.png',
  url: 'https://support.boxcast.com/en/articles/4235203'
}, {
  name: 'mimoLive',
  img: '/img/source-vendors/Mimo-Live.png',
  url: 'https://support.boxcast.com/en/articles/4235198'
}, {
  name: 'OBS',
  img: '/img/source-vendors/OBS.png',
  url: 'https://support.boxcast.com/en/articles/4235189'
}, {
  name: 'ProPresenter',
  img: '/img/source-vendors/ProPresenter.png',
  url: 'https://support.boxcast.com/en/articles/4632792'
}, {
  name: 'Sling Studio',
  img: '/img/source-vendors/SlingStudio.png',
  url: 'https://support.boxcast.com/en/articles/4235195'
}, {
  name: 'Switcher Studio',
  img: '/img/source-vendors/SwitcherStudio.png',
  url: 'https://support.boxcast.com/en/articles/4235196'
}, {
  name: 'Teradek',
  img: '/img/source-vendors/Teradek.png',
  url: 'https://support.boxcast.com/en/articles/4235192'
}, {
  name: 'vMix',
  img: '/img/source-vendors/Vmix.png',
  url: 'https://support.boxcast.com/en/articles/4235190'
}, {
  name: 'Wirecast',
  img: '/img/source-vendors/Wirecast.png',
  url: 'https://support.boxcast.com/en/articles/4235188'
}, {
  name: 'Zoom',
  img: '/img/source-vendors/Zoom.png',
  url: 'https://support.boxcast.com/en/articles/4235167'
}];
var SOURCE_TABS = {
  free: [{
    tag: 'Recommended for Webcam',
    description: "BoxCast's <strong>Producer</strong> is a built-in video source that lets you use your browser as an encoder and stream with a webcam or capture device.",
    selectName: 'producer',
    selectParams: {
      action: 'openProducer'
    },
    imageURL: 'Video-Source_Producer.png',
    learnMoreURL: 'https://www.boxcast.com/platform/producer',
    action: 'openProducer'
  }, {
    tag: 'Recommended for iOS',
    description: 'Our <strong>Broadcaster app</strong> empowers you to stream, share, and monitor broadcasts from your iOS device.',
    selectName: 'broadcaster',
    selectParams: {
      action: 'downloadBroadcasterApp'
    },
    imageURL: 'Video-Source_BroadcasterApp.png',
    learnMoreURL: 'https://www.boxcast.com/product/broadcaster'
  }, {
    description: 'Through <strong>RTMP</strong> functionality, BoxCast lets you stream directly to our platform from your hardware or software encoder of choice, including <strong>OBS</strong>.',
    selectName: 'rtmp',
    selectParams: {},
    imageURL: 'Video-Source_RTMP.png',
    learnMoreURL: 'openRTMP'
  }],
  boxcasters: [{
    tag: 'Recommended',
    description: 'Our advanced <strong>BoxCaster Pro</strong> encoder seamlessly fits into your production workflow and lets you schedule, preview, simulcast, and monitor your broadcasts.',
    selectName: 'boxcaster-pro',
    selectParams: {},
    imageURL: 'Video-Source_BoxCasterPro.png',
    learnMoreURL: 'https://www.boxcast.com/product/boxcaster-pro'
  }, {
    tag: 'Recommended',
    description: "The <strong>BoxCaster</strong> makes high-quality broadcasting super easy. Just plug in power, internet, and a camera, and you're ready to stream the crisp live video your viewers deserve!",
    selectName: 'boxcaster',
    selectParams: {},
    imageURL: 'Video-Source_BoxCaster.png',
    learnMoreURL: 'https://www.boxcast.com/product/boxcaster'
  }],
  rtmp: [{
    tag: 'Popular',
    description: 'BoxCast supports <strong>Wirecast</strong> by <strong>Telestream</strong> through an RTMP server URL and stream key.',
    selectName: 'rtmp',
    selectParams: {
      name: 'Wirecast'
    },
    imageURL: 'Wirecast.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235188'
  }, {
    tag: 'Popular',
    description: 'Use a <strong>Webcam and OBS</strong> (Open Broadcaster Software) and start streaming without spending a dime.',
    selectName: 'rtmp',
    selectParams: {
      name: 'OBS'
    },
    imageURL: 'OBS.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235189'
  }, {
    tag: 'Popular',
    description: 'BoxCast supports <strong>vMix</strong> by <strong>StudioCoast</strong> through an RTMP server URL and stream key.',
    selectName: 'rtmp',
    selectParams: {
      name: 'vMix'
    },
    imageURL: 'Vmix.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235190'
  }, {
    tag: 'Popular',
    description: 'BoxCast supports <strong>ProPresenter</strong> through an RTMP server URL and stream key.',
    selectName: 'rtmp',
    selectParams: {
      name: 'ProPresenter'
    },
    imageURL: 'ProPresenter.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4632792'
  }, {
    description: 'BoxCast supports the <strong>HELO</strong> encoder from <strong>AJA</strong> through RTMP.',
    selectName: 'rtmp',
    selectParams: {
      name: 'AJA HELO'
    },
    imageURL: 'AJA-HELO.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235194'
  }, {
    description: 'BoxCast supports the <strong>VidiU</strong> and <strong>VidiU PRO</strong> by <strong>Teradek</strong> through RTMP.',
    selectName: 'rtmp',
    selectParams: {
      name: 'Teradek VidiU'
    },
    imageURL: 'Teradek.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235192'
  }, {
    description: 'Stream <strong>Zoom</strong> conference calls between multiple people at your organization using BoxCast.',
    selectName: 'rtmp',
    selectParams: {
      name: 'Zoom'
    },
    imageURL: 'Zoom.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235167'
  }, {
    description: '<strong>Switcher Studio</strong> from <strong>Switcher</strong> supports BoxCast within its app for iPhone and iPad.',
    selectName: 'rtmp',
    selectParams: {
      name: 'Switcher Studio'
    },
    imageURL: 'SwitcherStudio.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235196'
  }, {
    description: '<strong>Larix Broadcaster</strong> from <strong>Softvelum</strong> is a free app for <strong>Android</strong> available on the Google Play store.',
    selectName: 'rtmp',
    selectParams: {
      name: 'Larix Broadcaster'
    },
    imageURL: 'Larix.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235173'
  }, {
    description: '<strong>mimoLive</strong> supports BoxCast within its app.',
    selectName: 'rtmp',
    selectParams: {
      name: 'mimoLive'
    },
    imageURL: 'Mimo-Live.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235198'
  }, {
    description: 'BoxCast supports <strong>SlingStudio</strong> from <strong>Sling Media</strong> through RTMP.',
    selectName: 'rtmp',
    selectParams: {
      name: 'SlingStudio'
    },
    imageURL: 'SlingStudio.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235195'
  }, {
    description: 'BoxCast supports the <strong>GoSolo</strong> from <strong>LiveU Solo</strong> through RTMP.',
    selectName: 'rtmp',
    selectParams: {
      name: 'LiveU Solo'
    },
    imageURL: 'GoSolo.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235203'
  }, {
    description: 'BoxCast supports the <strong>LiveShell</strong> encoder from <strong>Cerevo</strong> through RTMP.',
    selectName: 'rtmp',
    selectParams: {
      name: 'LiveShell'
    },
    imageURL: 'LiveShell.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235193'
  }, {
    description: 'BoxCast supports the <strong>ChurchStreamer</strong> from <strong>ChurchStreaming.tv</strong> through RTMP.',
    selectName: 'rtmp',
    selectParams: {
      name: 'ChurchStreamer'
    },
    imageURL: 'ChurchStreaming.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235204'
  }, {
    description: 'BoxCast supports <strong>AWS Elemental MediaLive</strong> from <strong>Amazon</strong> through an RTMP server URL and stream key.',
    selectName: 'rtmp',
    selectParams: {
      name: 'AWS Elemental Media Live'
    },
    imageURL: 'AWS-Elemental.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235199'
  }, {
    description: 'BoxCast supports <strong>Flash Media Live</strong> protocol from <strong>Adobe</strong> through an RTMP server URL and stream key.',
    selectName: 'rtmp',
    selectParams: {
      name: 'Flash Media Live'
    },
    imageURL: 'FMLE.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235202'
  }, {
    description: 'BoxCast lets you stream from your NewTek TriCaster, Teradek VidiU, SlingStudio, or other RTMP encoder.',
    selectName: 'rtmp',
    selectParams: {
      name: ''
    },
    imageURL: 'Video-Source_RTMP-Hardware.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235181'
  }, {
    description: 'With BoxCast, you can use Wirecast, OBS, MimoLive, Flash Media Live Encoder, or any other RTMP solution.',
    selectName: 'rtmp',
    selectParams: {
      name: ''
    },
    imageURL: 'Video-Source_RTMP-Software.png',
    learnMoreURL: 'https://support.boxcast.com/en/articles/4235181'
  }]
};

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <a href class=\"pull-right\" ng-click=\"vm.cancel()\" title=\"Close Dialog\"><i class=\"fa fa-times\"></i></a>\n  <h3 class=\"modal-title\">RTMP Encoder Guides</h3>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-muted\">Check out our guides on how to broadcast from RTMP encoders</p>\n  <div class=\"row text-center\">\n    <table align=\"center\" style=\"text-align:center;margin-bottom:10px\">\n      <tr>\n        <td ng-repeat=\"guide in vm.RTMP_ENCODER_GUIDES\" style=\"display:inline-block\">\n          <div class=\"btn-rtmp-guide\">\n            <a ng-href=\"{{guide.url}}\" target=\"_blank\">\n              <img class=\"img\" ng-src=\"{{guide.img}}\">\n            </a>\n            <h5 style=\"margin: 5px 0 5px 0;\"><strong>{{guide.name}}</strong></h5>\n          </div>\n        </td>\n      </tr>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" role=\"form\">\n  <div class=\"modal-header\">\n    <a href class=\"pull-right\" ng-click=\"vm.cancel()\" title=\"Close Dialog\"><i class=\"fa fa-times\"></i></a>\n    <h3 class=\"modal-title\">Edit RTMP</h3>\n  </div>\n  <div class=\"modal-body text-left\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div ng-if=\"vm.showError\">\n          <div class=\"bg-danger text-danger\" style=\"padding:15px;margin-bottom:15px;border:1px solid red;\">\n            Please fill out all required fields before submitting.\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"name\">Name <i class=\"fa fa-asterisk text-danger\" style=\"font-size:10px;vertical-align:top\"></i></label>\n          <input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" ng-model=\"vm.staticRTMP.name\" ng-maxlength=\"::vm.limits.name\" required>\n          <p ng-show=\"!vm.staticRTMP.name\">\n            <span class=\"text-danger\" ng-if=\"form.name.$error.maxlength\">The name is too long.</span>\n            <span class=\"text-danger\" ng-if=\"form.name.$error.required\">The name cannot be blank.</span>\n          </p>\n        </div>\n\n        <div class=\"form-group\">\n          <label for=\"description\">Description</label>\n          <textarea class=\"form-control\" id=\"description\" name=\"description\" ng-model=\"vm.staticRTMP.description\"></textarea>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <ul class=\"list-inline pull-left\">\n      <li>\n        <a href=\"javascript://\" ng-click=\"vm.delete()\" class=\"action-link\">\n          <i class=\"fa fa-trash\"></i> Delete\n        </a>\n      </li>\n    </ul>\n    <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-default\">Close</button>\n    <button ng-click=\"vm.saveSettings()\" ng-disabled=\"vm.savingSettings\" class=\"btn btn-primary\">\n      <i ng-show=\"vm.savingSettings\" class=\"fa fa-spin fa-spinner\"></i>\n      Save Changes\n    </button>\n  </div>\n</form>\n"

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"vm.isSourcesPage ? 'row' : ''\">\n    <div ng-class=\"vm.isSourcesPage ? 'col-md-9' : ''\">\n        <div ng-repeat=\"b in vm.allSources\" id=\"{{vm.sourceType(b)}}-{{b.id}}\" style=\"margin-bottom:15px\">\n\n            <div ng-if=\"vm.sourceType(b) == 'boxcaster'\"\n                class=\"boxcaster-card status-{{b.status}} warning-{{b.warning}} firmware-{{b.firmware_status}} boxcaster-card-{{b.__showDetails?'expanded':'collapsed'}}\">\n                <source-header-boxcaster boxcaster=\"b\" on-toggle-details=\"vm.toggleDetails(b, true)\">\n                </source-header-boxcaster>\n                <div class=\"boxcaster-card-details\" uib-collapse=\"!b.__showDetails\">\n                    <source-details-boxcaster boxcaster=\"b\" on-start-test=\"vm.startTest(b)\"\n                        on-edit-settings=\"vm.editBoxCasterSettings(b)\" on-edit-wifi=\"vm.editWifi(b)\"\n                        broadcast-id=\"vm.broadcastsByStaticRTMP[b.id].id\" location=\"vm.getLocation()\">\n                        </source-details-rtmp>\n                </div>\n            </div>\n        \n            <div ng-if=\"vm.sourceType(b) == 'rtmp'\"\n                class=\"boxcaster-card boxcaster-card-{{b.__showDetails?'expanded':'collapsed'}}\">\n                <source-header-rtmp rtmp=\"b\" rtmp-status=\"vm.rtmpStatus(b, vm.broadcastsByStaticRTMP)\"\n                    on-toggle-details=\"vm.toggleDetails(b)\"></source-header-rtmp>\n                <div class=\"boxcaster-card-details\" uib-collapse=\"!b.__showDetails\">\n                    <source-details-rtmp rtmp=\"b\" rtmp-status=\"vm.rtmpStatus(b, vm.broadcastsByStaticRTMP)\"\n                        on-start-test=\"vm.startTest(b)\" on-regenerate-stream-key=\"vm.regenerateStreamKey(b)\"\n                        on-edit-settings=\"vm.editRTMP(b)\" broadcast-id=\"vm.broadcastsByStaticRTMP[b.id].id\"\n                        on-show-encoder-guides=\"vm.showEncoderGuides()\" location=\"vm.getLocation()\">\n                    </source-details-rtmp>\n                </div>\n            </div>\n        \n            <div ng-if=\"vm.sourceType(b) == 'broadcaster'\"\n                class=\"boxcaster-card boxcaster-card-{{b.__showDetails?'expanded':'collapsed'}}\">\n                <source-header-broadcaster broadcaster=\"b\" on-toggle-details=\"vm.toggleDetails(b)\">\n                </source-header-broadcaster>\n                <div class=\"boxcaster-card-details\" uib-collapse=\"!b.__showDetails\">\n                    <source-details-broadcaster broadcaster=\"b\" on-start-test=\"vm.startTest(b)\"\n                        broadcast-id=\"vm.broadcastsByBroadcaster['__sentinel__'].id\" location=\"vm.getLocation()\">\n                    </source-details-broadcaster>\n                </div>\n            </div>\n        \n        </div>\n        {{location}}\n    </div>\n    <div class=\"col-md-3 text-md-right\" ng-if=\"vm.isSourcesPage\">\n        <button ng-click=\"vm.showAddSourceModal()\" class=\"btn btn-lg btn-block btn-success\">+ Add a Source</button>\n    </div>\n</div>"

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = "<main class=\"onboarding-container\" style=\"margin-bottom: 0px;\">\n  <div id=\"migrationTabs\" class=\"well onboarding\" style=\"margin-bottom: 0px;\">\n\n    <ul ng-if=\"vm.account.status === 'onboarding'\" class=\"nav flex-grid\"\n      style=\"margin-bottom: 15px; justify-content: flex-start; gap: 10px 0;\">\n      <li class=\"migrate-li\" ui-sref-active=\"active\">\n        <button id=\"welcome\" ng-class=\"{active: vm.tabIndex === 0}\" style=\"cursor: default;\">\n          <i class=\"fa fa-check-circle\" style=\"color: #1aa8a1;\" ng-show=\"vm.tabIndex > 0\"></i><span\n            ng-show=\"vm.tabIndex <= 0\" style=\"font-size:20px; font-weight: bold; margin-right: 5px;\">1</span> Welcome\n        </button>\n      </li>\n      <li class=\"migrate-li\" ui-sref-active=\"active\">\n        <button id=\"account-info\" ng-class=\"{active: vm.tabIndex === 1}\" style=\"cursor: default;\">\n          <i class=\"fa fa-check-circle\" style=\"color: #1aa8a1;\" ng-show=\"vm.tabIndex > 1\"></i><span\n            ng-show=\"vm.tabIndex <= 1\" style=\"font-size:20px; font-weight: bold; margin-right: 5px;\">2</span> Account\n          Information\n        </button>\n      </li>\n      <li class=\"migrate-li\">\n        <button id=\"video-organization\" ng-class=\"{active: vm.tabIndex === 2}\" style=\"cursor: default;\">\n          <i class=\"fa fa-check-circle\" style=\"color: #1aa8a1;\" ng-show=\"vm.tabIndex > 2\"></i><span\n            ng-show=\"vm.tabIndex <= 2\" style=\"font-size:20px; font-weight: bold; margin-right: 5px;\">3</span> Video\n          Organization\n        </button>\n      </li>\n      <li class=\"migrate-li\" ui-sref-active=\"active\">\n        <button id=\"migration-progress\" ng-class=\"{active: vm.tabIndex === 3}\" style=\"cursor: default;\">\n          <i class=\"fa fa-check-circle\" style=\"color: #1aa8a1;\" ng-show=\"vm.tabIndex > 3\"></i><span\n            ng-show=\"vm.tabIndex <= 3\" style=\"font-size:20px; font-weight: bold; margin-right: 5px;\">4</span> Migration\n          Progress\n        </button>\n      </li>\n      <li class=\"migrate-li\" ui-sref-active=\"active\">\n        <button id=\"plan-enrollment\" ng-class=\"{active: vm.tabIndex === 4}\" style=\"cursor: default;\">\n          <i class=\"fa fa-check-circle\" style=\"color: #1aa8a1;\" ng-show=\"vm.tabIndex > 4\"></i><span\n            ng-show=\"vm.tabIndex <= 4\" style=\"font-size:20px; font-weight: bold; margin-right: 5px;\">5</span> Plan\n          Enrollment\n        </button>\n      </li>\n    </ul>\n    <div ui-view></div>\n  </div>\n\n  <div class=\"migration-footer\">\n    <button ng-if=\"vm.tabIndex > 0\" ng-click=\"vm.prevTab()\" class=\"save-btn\"\n      style=\"border-color: #00a3BB; background-color: #00a3BB3D; color: white; margin-right: 10px;\">Back</button>\n    <button ng-disabled=\"!vm.rootScope.videoSetup && vm.tabIndex == 2\" ng-if=\"4 > vm.tabIndex\"\n      ng-click=\"vm.nextTab()\" ng-class=\"!vm.rootScope.videoSetup && vm.tabIndex == 2 ? 'save-btn-disabled' : 'save-btn'\"\n      style=\"border-color: #00a3BB; background-color: #00a3BB3D; color: white;\">Next</button>\n  </div>\n</main>"

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CompleteMigrationController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_isStreamMonkey__ = __webpack_require__(10);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var CompleteMigrationController = /*#__PURE__*/function () {
  function CompleteMigrationController($rootScope, $state, $scope, $http, User, Account, $location) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, CompleteMigrationController);

    this.rootScope = $rootScope;
    this.account = $rootScope.account;
    this.accountInfo = Account.getBilling();
    this.user = User;
    this.$state = $state;
    this.$location = $location;
    this.$http = $http;
    this.numVideos = 0;
    $rootScope.videoSetup = false;
    this.isStreamMonkey = Object(__WEBPACK_IMPORTED_MODULE_0__utils_isStreamMonkey__["a" /* default */])(this.account.migration_service_id);
    this.tabArr = ['welcome', 'account-info', 'video-organization', 'migration-progress', 'plan-enrollment', 'success'];
    this.tabIndex = this.tabArr.findIndex(function (element) {
      return element == $location.$$path.substring($location.$$path.lastIndexOf('/') + 1);
    });
    this.$http.get("".concat(API_ROOT, "/account/migration/imports")).then(function (resp) {
      _this.numVideos = resp.data.length;
    });

    if (this.account.status != 'onboarding') {
      this.$state.go('complete-migration.success');
    }

    var activeTab = this.$state.current.name.split('.')[1] || localStorage.getItem('activeTab') || 'welcome';
    this.switchTab(activeTab);
    $rootScope.$on('account-migrated', function (event, state) {
      _this.account.status = state.status;

      _this.$state.go('complete-migration.success');
    });
    var deregisterLocation = $rootScope.$on('$locationChangeSuccess', function (evt, newUrl, oldUrl) {
      if (!_this.tabArr.includes(oldUrl.substring(oldUrl.lastIndexOf('/') + 1)) && newUrl.substring(newUrl.lastIndexOf('/') + 1) == 'plan-enrollment') {
        var rootScope = _this.rootScope;
        rootScope.$emit('open-sm-modal');
      }
    });
    var deregisterState = $rootScope.$on('$stateChangeStart', function (event, toState) {
      var tab = toState.name.split('.')[1] || 'welcome';
      _this.tabIndex = _this.tabArr.findIndex(function (element) {
        return element == tab;
      });
    });
    var deregisterCheck = $rootScope.$on('checkValidation', function (event, data) {
      $rootScope.videoSetup = data;
    });
    $scope.$on('$destroy', function destroyScope() {
      deregisterState();
      deregisterLocation();
      deregisterCheck();
    });
  }

  _createClass(CompleteMigrationController, [{
    key: "openCompleteAccountModal",
    value: function openCompleteAccountModal() {
      var rootScope = this.rootScope;
      rootScope.$emit('open-sm-modal'); // the modal instance lives in top-navbar.js
    }
  }, {
    key: "nextTab",
    value: function nextTab() {
      this.tabIndex++;
      this.switchTab(this.tabArr[this.tabIndex], true);
    }
  }, {
    key: "prevTab",
    value: function prevTab() {
      this.tabIndex--;
      this.switchTab(this.tabArr[this.tabIndex], true);
    }
  }, {
    key: "switchTab",
    value: function switchTab(tab, checkClick) {
      this.tabIndex = this.tabArr.findIndex(function (element) {
        return element == tab;
      });
      localStorage.setItem('activeTab', tab);
      this.$state.go("complete-migration.".concat(this.tabArr[this.tabIndex]));

      if (tab == 'plan-enrollment' && checkClick) {
        this.openCompleteAccountModal();
      }
    }
  }]);

  return CompleteMigrationController;
}();



/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = "<div class=\"well onboarding\" ng-if=\"vm.account.status === 'onboarding'\">\n    <header class=\" onboarding__header\" style=\"margin-bottom: 3rem;\">\n        <div style=\"margin-left:-3rem; margin-right: -3rem; margin-top:-3rem;\">\n            <img style=\"max-width: 100%;\"\n                src=\"https://www.boxcast.com/hubfs/BoxCast.com%20-%20Visual%20Assets/Stream%20Monkey%20Landing%20Page/BoxCast+Stream-Monkey-Landing-Page-Header_DESKTOP.png\">\n        </div>\n        <h1 class=\"onboarding__title\">\n            <strong>Welcome {{ vm.user.name.split(' ')[0] }}! So happy you're here!</strong>\n        </h1>\n        <p class=\"onboarding__lead\">\n            We are giving you a free trial of the BoxCast platform so you can get comfortable before completing\n            your migration.\n            Your Stream Monkey account is still fully functioning until you choose to accept the BoxCast terms of\n            service and accept your plan. At that point, your Stream Monkey account will be closed.\n        </p>\n    </header>\n    <div>\n        <h4 class=\"margin-sm\">\n            <strong>We recommend that you complete these steps before completing the migration process: </strong>\n        </h4>\n        <ul class=\"margin-lg text-lg\">\n            <li class=\"margin-sm\">\n                <a href=\"https://support.boxcast.com/en/articles/4235181-connect-an-rtmp-compatible-encoder-to-boxcast\"\n                    target=\"_blank\">Set up your encoder</a>\n                and any\n                <a href=\"https://boxcast.tv/channel/koxqjc1sadjt9nmaocsr?b=qsebibecsgz2sin0bgqk\" target=\"_blank\">social\n                    media\n                    accounts</a>\n                you wish to stream to.\n            </li>\n            <li class=\"margin-sm\">\n                <a href=\"https://boxcast.tv/channel/koxqjc1sadjt9nmaocsr?b=tyd0qkzcudvrvqn4u9rl\"\n                    target=\"_blank\">Schedule a\n                    broadcast.</a>\n            </li>\n            <li class=\"margin-sm\">\n                <a href=\"https://boxcast.tv/channel/koxqjc1sadjt9nmaocsr?b=zpt61ceeucxai3gq5jun\" target=\"_blank\">Embed\n                    the\n                    player\n                    onto your website.</a>\n            </li>\n            <li>\n                <a href=\"https://support.boxcast.com/en/articles/6024225-stream-monkey-migration-checklist\"\n                    target=\"_blank\">Check this\n                    list of items that might need extra set up</a>\n            </li>\n        </ul>\n        <p class=\"text-lg margin-lg\">\n            All of your video, playlist, and media center embed codes will have redirects from Stream Monkey and will\n            not need to be\n            re-embedded.\n        </p>\n        <div class=\"well text-lg\">\n            <p>When you go to complete the migration and accept your plan, we’ve chosen a BoxCast plan closest to\n                your current plan with Stream Monkey. You should not see a price increase, but you may see some new\n                features.</p>\n            <p><strong>If you have paid annually, </strong> you will accept the terms, and the money you have\n                prepaid will be applied to your BoxCast account, so your total due today will be zero.</p>\n            <p><strong>If you’re on a monthly plan,</strong> you will be credited for anything you’ve paid this\n                month.\n                You are allowed to upgrade or downgrade during this process, if you wish.</p>\n            <p>\n                Be sure to reach out in the chat if you have any questions, and check out our\n                <a href=\"https://support.boxcast.com/en/\" target=\"_blank\">support page</a>.\n            </p>\n            <p>Happy Streaming!</p>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WelcomeController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_isStreamMonkey__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_sources__ = __webpack_require__(50);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var STATIC_RTMP_REFRESH_INTERVAL = 10000;

var WelcomeController = /*#__PURE__*/function () {
  function WelcomeController(BoxCaster, Broadcast, StaticRTMP, ConfirmDialog, $uibModal, $state, $q, $rootScope, $location, $timeout, toaster, $scope, $http) {
    var _this = this;

    _classCallCheck(this, WelcomeController);

    this.rootScope = $rootScope;
    this.user = $rootScope.user;
    this.account = $rootScope.account;
    this.BoxCaster = BoxCaster;
    this.Broadcast = Broadcast;
    this.StaticRTMP = StaticRTMP;
    this.ConfirmDialog = ConfirmDialog;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.$q = $q;
    this.toaster = toaster;
    this.$location = $location;
    this.$timeout = $timeout;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    this.user = $rootScope.user;
    this.$http = $http;
    this.rtmpStatus = __WEBPACK_IMPORTED_MODULE_1__utils_sources__["b" /* sourceRtmpStatus */];
    this.sourceType = __WEBPACK_IMPORTED_MODULE_1__utils_sources__["c" /* sourceType */];
    this.numVideos = 0;
    var monthsArr = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var dateArr = this.account.expires_on.split('-');
    this.expDate = "".concat(monthsArr[parseInt(dateArr[1]) - 1], " ").concat(dateArr[2], ", ").concat(dateArr[0]);
    this.$http.get("".concat(API_ROOT, "/account/migration/imports")).then(function (resp) {
      _this.numVideos = resp.data.length;
    });
    this.allowRtmp = this.FeatureFlags.rtmp;
    this.allowBroadcaster = !this.FeatureFlags.broadcaster_app_source_disabled;
    this.showBroadcasterSource = !this.FeatureFlags.broadcaster_app_source_disabled && this.account.usage_flags.broadcaster_app;
    this.isStreamMonkey = Object(__WEBPACK_IMPORTED_MODULE_0__utils_isStreamMonkey__["a" /* default */])(this.account.migration_service_id);

    if (this.account.status != 'onboarding') {
      this.$state.go('complete-migration.success');
    }

    this.refresh().then(function () {
      _this.scheduleRefreshStaticRTMP();
    });
    $scope.$on('$destroy', function () {
      $timeout.cancel(_this.timeoutHandle);
    });
  }

  _createClass(WelcomeController, [{
    key: "refresh",
    value: function refresh() {
      var _this2 = this;

      var StaticRTMP = this.StaticRTMP,
          BoxCaster = this.BoxCaster,
          Broadcast = this.Broadcast,
          $q = this.$q;
      this.boxcasters = BoxCaster.query({
        l: 1000,
        s: 'name'
      }); // Get all live now broadcasts to match up stream sources

      this.broadcasts = Broadcast.query({
        q: 'timeframe:current',
        l: 100
      }); // Figure out which Static RTMPs are active

      this.broadcastsByBoxCaster = {};
      this.broadcastsByStaticRTMP = {};
      this.broadcastsByBroadcaster = {};
      var allPromises;
      var promises = [this.boxcasters.$promise, this.broadcasts.$promise];

      if (this.allowRtmp) {
        this.staticRTMPs = StaticRTMP.query({
          l: 1000,
          include_diagnostics: true
        });
        promises.push(this.staticRTMPs.$promise);
      }

      allPromises = $q.all(promises).then(function () {
        _this2.broadcasts.forEach(function (b) {
          if (b.stream_source == 'rtmp') {
            _this2.broadcastsByStaticRTMP[b.static_rtmp_id] = b;
          } else if (b.stream_source == 'boxcaster') {
            _this2.broadcastsByBoxCaster[b.boxcaster_id] = b;
          } else if (b.stream_source == 'app') {
            _this2.broadcastsByBroadcaster['__sentinel__'] = b;
          }
        });
      }); // Wait for all data, then massage it a bit

      allPromises.then(function () {
        _this2.loaded = true; // Collapse BoxCasters and RTMP addresses into 1 big ordered list

        _this2.allSources = (_this2.boxcasters || []).concat(_this2.staticRTMPs || []); // Add Broadcaster

        if (_this2.showBroadcasterSource) {
          var broadcasterDetails = {};

          if (_this2.broadcastsByBroadcaster['__sentinel__']) {
            broadcasterDetails = _this2.broadcastsByBroadcaster['__sentinel__'];
          }

          _this2.allSources = _this2.allSources.concat({
            is_broadcaster: true,
            name: 'Broadcaster App',
            details: broadcasterDetails
          });
        } // Sort the big list


        Object(__WEBPACK_IMPORTED_MODULE_1__utils_sources__["a" /* sortSources */])(_this2.allSources, _this2.broadcastsByStaticRTMP);
      });
      this.loadingPromises = [allPromises];
      return allPromises;
    }
  }, {
    key: "scheduleRefreshStaticRTMP",
    value: function scheduleRefreshStaticRTMP() {
      var _this3 = this;

      if (this.allowRtmp && this.staticRTMPs && this.staticRTMPs.length > 0) {
        var staticRTMPs = this.StaticRTMP.query({
          l: 1000,
          include_diagnostics: true
        });
        staticRTMPs.$promise.then(function () {
          for (var i = 0; i < _this3.allSources.length; i++) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_sources__["c" /* sourceType */])(_this3.allSources[i]) == 'rtmp') {
              _this3.allSources[i].diagnostics = _.find(staticRTMPs, function (r) {
                return r.id == _this3.allSources[i].id;
              }).diagnostics || _this3.allSources[i].diagnostics;
            }
          }

          _this3.staticRTMPRefreshInterval = STATIC_RTMP_REFRESH_INTERVAL;
        })["catch"](function (error) {
          console.log(error); // Exponential backoff up to 2 mins

          _this3.staticRTMPRefreshInterval = Math.min((_this3.staticRTMPRefreshInterval || STATIC_RTMP_REFRESH_INTERVAL) * 2, 120000);
        })["finally"](function () {
          _this3.timeoutHandle = _this3.$timeout(function () {
            return _this3.scheduleRefreshStaticRTMP();
          }, _this3.staticRTMPRefreshInterval);
        });
      }
    }
  }, {
    key: "toggleDetails",
    value: function toggleDetails(b) {
      var loadBoxcaster = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (b.__showDetails) {
        b.__showDetails = false;
      } else {
        b.__showDetails = true;

        if (loadBoxcaster) {
          b.details = this.BoxCaster.get({
            id: b.id
          });
        }
      }
    }
  }, {
    key: "openCompleteAccountModal",
    value: function openCompleteAccountModal() {
      var rootScope = this.rootScope;
      rootScope.$emit('open-sm-modal'); // the modal instance lives in top-navbar.js
    }
  }]);

  return WelcomeController;
}();



/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row form-horizontal\">\n    <h3 class=\"col-xs-12 text-center\" style=\"font-weight:bold; margin: 30px 0\">Confirm Your Account Information &\n        Sources</h3>\n    <div class=\"col-xs-12\">\n        <h3>Account Information</h3>\n        <div class=\"well\"\n            style=\"box-shadow: none; background-color: #fafafa; border: 1px solid #ebebeb; margin-bottom: 0;\">\n            <div class=\"form-group\" style=\"margin-top: 5px;\">\n                <div class=\"col-md-6\" ng-if=\"vm.user.name\">\n                    <p class=\"infoTitle\">Name</p>\n                    <p class=\"infoP\">\n                        {{ vm.user.name }}</p>\n                </div>\n                <div class=\"col-md-6\" ng-if=\"vm.userContact.phone\">\n                    <p class=\"infoTitle\">Phone Number</p>\n                    <p class=\"infoP\">\n                        {{ vm.userContact.phone }}</p>\n                </div>\n                <div class=\"col-md-6\" ng-if=\"vm.user.email\">\n                    <p class=\"infoTitle\">Email</p>\n                    <p class=\"infoP\">\n                        {{ vm.user.email }}</p>\n                </div>\n                <div class=\"col-md-6\" ng-if=\"vm.account.name\">\n                    <p class=\"infoTitle\">Organization Name</p>\n                    <p class=\"infoP\">\n                        {{ vm.account.name }}</p>\n                </div>\n                <div class=\"col-md-6\" ng-if=\"vm.accountInfo.city\">\n                    <p class=\"infoTitle\">City</p>\n                    <p class=\"infoP\" ng-if=\"vm.accountInfo.city != null\">\n                        {{ vm.accountInfo.city }}</p>\n                </div>\n                <div class=\"col-md-6\" ng-if=\"vm.accountInfo.state\">\n                    <p class=\"infoTitle\">State/Region</p>\n                    <p class=\"infoP\" ng-if=\"vm.accountInfo.state != null\">\n                        {{ vm.accountInfo.state}}</p>\n                </div>\n            </div>\n        </div>\n        <div class=\"text-center\">\n            <button ui-sref=\"settings.my_account\" class=\"save-btn\">Edit Account</button>\n        </div>\n    </div>\n\n    <div class=\"col-xs-12\" style=\"margin-top: 30px\">\n        <h3>Sources</h3>\n        <div class=\"tab-holder\">\n            <div ng-if=\"vm.allSources.length\">\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <source-tabs></source-tabs>\n                    </div>\n                </div>\n            </div>\n            <div class=\"text-center\">\n                <a href=\"{{vueDashboardRoot}}/sources\" class=\"save-btn\">Edit Sources</a>\n            </div>\n        </div>\n\n        <!--/well-->\n    </div>\n\n</div>"

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AccountInfoController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_isStreamMonkey__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_sources__ = __webpack_require__(50);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var STATIC_RTMP_REFRESH_INTERVAL = 10000;

var AccountInfoController = /*#__PURE__*/function () {
  function AccountInfoController(BoxCaster, Broadcast, StaticRTMP, ConfirmDialog, $uibModal, $state, $q, $rootScope, $location, $timeout, toaster, $scope, $http, User, Account) {
    var _this = this;

    _classCallCheck(this, AccountInfoController);

    this.user = $rootScope.user;
    this.userContact = User.getContact();
    this.account = $rootScope.account;
    this.BoxCaster = BoxCaster;
    this.Broadcast = Broadcast;
    this.StaticRTMP = StaticRTMP;
    this.ConfirmDialog = ConfirmDialog;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.$q = $q;
    this.toaster = toaster;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$http = $http;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    this.user = $rootScope.user;
    this.rtmpStatus = __WEBPACK_IMPORTED_MODULE_1__utils_sources__["b" /* sourceRtmpStatus */];
    this.sourceType = __WEBPACK_IMPORTED_MODULE_1__utils_sources__["c" /* sourceType */];
    this.accountInfo = Account.getBilling();
    this.numVideos = 0;
    this.$http.get("".concat(API_ROOT, "/account/migration/imports")).then(function (resp) {
      _this.numVideos = resp.data.length;
    });
    this.allowRtmp = this.FeatureFlags.rtmp;
    this.allowBroadcaster = !this.FeatureFlags.broadcaster_app_source_disabled;
    this.showBroadcasterSource = !this.FeatureFlags.broadcaster_app_source_disabled && this.account.usage_flags.broadcaster_app;
    this.isStreamMonkey = Object(__WEBPACK_IMPORTED_MODULE_0__utils_isStreamMonkey__["a" /* default */])(this.account.migration_service_id);

    if (this.account.status != 'onboarding') {
      this.$state.go('complete-migration.success');
    }

    this.refresh().then(function () {
      _this.scheduleRefreshStaticRTMP();
    });
    $scope.$on('$destroy', function () {
      $timeout.cancel(_this.timeoutHandle);
    });
  }

  _createClass(AccountInfoController, [{
    key: "refresh",
    value: function refresh() {
      var _this2 = this;

      var StaticRTMP = this.StaticRTMP,
          BoxCaster = this.BoxCaster,
          Broadcast = this.Broadcast,
          $q = this.$q;
      this.boxcasters = BoxCaster.query({
        l: 1000,
        s: 'name'
      }); // Get all live now broadcasts to match up stream sources

      this.broadcasts = Broadcast.query({
        q: 'timeframe:current',
        l: 100
      }); // Figure out which Static RTMPs are active

      this.broadcastsByBoxCaster = {};
      this.broadcastsByStaticRTMP = {};
      this.broadcastsByBroadcaster = {};
      var allPromises;
      var promises = [this.boxcasters.$promise, this.broadcasts.$promise];

      if (this.allowRtmp) {
        this.staticRTMPs = StaticRTMP.query({
          l: 1000,
          include_diagnostics: true
        });
        promises.push(this.staticRTMPs.$promise);
      }

      allPromises = $q.all(promises).then(function () {
        _this2.broadcasts.forEach(function (b) {
          if (b.stream_source == 'rtmp') {
            _this2.broadcastsByStaticRTMP[b.static_rtmp_id] = b;
          } else if (b.stream_source == 'boxcaster') {
            _this2.broadcastsByBoxCaster[b.boxcaster_id] = b;
          } else if (b.stream_source == 'app') {
            _this2.broadcastsByBroadcaster['__sentinel__'] = b;
          }
        });
      }); // Wait for all data, then massage it a bit

      allPromises.then(function () {
        _this2.loaded = true; // Collapse BoxCasters and RTMP addresses into 1 big ordered list

        _this2.allSources = (_this2.boxcasters || []).concat(_this2.staticRTMPs || []); // Add Broadcaster

        if (_this2.showBroadcasterSource) {
          var broadcasterDetails = {};

          if (_this2.broadcastsByBroadcaster['__sentinel__']) {
            broadcasterDetails = _this2.broadcastsByBroadcaster['__sentinel__'];
          }

          _this2.allSources = _this2.allSources.concat({
            is_broadcaster: true,
            name: 'Broadcaster App',
            details: broadcasterDetails
          });
        } // Sort the big list


        Object(__WEBPACK_IMPORTED_MODULE_1__utils_sources__["a" /* sortSources */])(_this2.allSources, _this2.broadcastsByStaticRTMP);
      });
      this.loadingPromises = [allPromises];
      return allPromises;
    }
  }, {
    key: "scheduleRefreshStaticRTMP",
    value: function scheduleRefreshStaticRTMP() {
      var _this3 = this;

      if (this.allowRtmp && this.staticRTMPs && this.staticRTMPs.length > 0) {
        var staticRTMPs = this.StaticRTMP.query({
          l: 1000,
          include_diagnostics: true
        });
        staticRTMPs.$promise.then(function () {
          for (var i = 0; i < _this3.allSources.length; i++) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_sources__["c" /* sourceType */])(_this3.allSources[i]) == 'rtmp') {
              _this3.allSources[i].diagnostics = _.find(staticRTMPs, function (r) {
                return r.id == _this3.allSources[i].id;
              }).diagnostics || _this3.allSources[i].diagnostics;
            }
          }

          _this3.staticRTMPRefreshInterval = STATIC_RTMP_REFRESH_INTERVAL;
        })["catch"](function (error) {
          console.log(error); // Exponential backoff up to 2 mins

          _this3.staticRTMPRefreshInterval = Math.min((_this3.staticRTMPRefreshInterval || STATIC_RTMP_REFRESH_INTERVAL) * 2, 120000);
        })["finally"](function () {
          _this3.timeoutHandle = _this3.$timeout(function () {
            return _this3.scheduleRefreshStaticRTMP();
          }, _this3.staticRTMPRefreshInterval);
        });
      }
    }
  }, {
    key: "toggleDetails",
    value: function toggleDetails(b) {
      var loadBoxcaster = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (b.__showDetails) {
        b.__showDetails = false;
      } else {
        b.__showDetails = true;

        if (loadBoxcaster) {
          b.details = this.BoxCaster.get({
            id: b.id
          });
        }
      }
    }
  }]);

  return AccountInfoController;
}();



/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row form-horizontal\" style=\"position: relative;\">\n    <div class=\"col-xs-12\" style=\"margin-top: 30px; margin-bottom: 10px;\">\n        <h3 ng-if=\"!vm.finished || vm.signedUp\" style=\"display: inline-block;\">\n            <span style=\"font-weight:bold;\">Understanding + Setting Up Your Video Portal</span>\n        </h3>\n        <h3 ng-if=\"vm.finished && !vm.signedUp\" style=\"display: inline-block;\">\n            <span style=\"font-weight:bold;\">Understanding Your Video Organization</span>\n        </h3>\n        <div>\n            <p ng-if=\"!vm.finished || vm.signedUp\" class=\"text-lg margin-lg\">The BoxCast Video Portal is a great tool to\n                help your viewers navigate your\n                content. It is similar to a\n                Stream Monkey channel and will power set top boxes (Apple TV, Roku, and Fire TV apps) as well as provide\n                you\n                with an\n                embeddable link similar to SM’s Media Center. Any content not included in the portal can be added to it\n                later, or accessed\n                through a separate embed code. Please note that BoxCast’s Portal is similar to a SM channel, and\n                BoxCast’s\n                channel is\n                similar to SM’s folder or playlist. <em>Please note that BoxCast’s Portal is similar to a SM channel,\n                    and\n                    BoxCast’s channel\n                    is similar to SM’s folder or playlist.</em></p>\n            <p ng-if=\"vm.finished && !vm.signedUp\" class=\"text-lg margin-lg\">All Stream Monkey channels have become\n                BoxCast channels, and all Stream Monkey\n                folders have become BoxCast tags. BoxCast\n                channels can be manually added to your Video Portal at any time to ensure they appear on your boxcast.tv\n                page and TV\n                apps (Roku, Apple, and Fire TV).\n            </p>\n            <p ng-if=\"vm.finished && !vm.signedUp\" class=\"text-lg margin-lg\">Learn more about where your content now\n                lives from our <a href=\"https://support.boxcast.com/en/articles/6159127-boxcast-video-portals-explained\"\n                    style=\"cursor: pointer;\">support article</a>.</p>\n            <ul ng-if=\"!vm.finished || vm.signedUp\" class=\"margin-lg text-lg\">\n                <li class=\"margin-sm\">\n                    <p>All SM channels not chosen for the Video Portal will become BoxCast channels</p>\n                </li>\n                <li class=\"margin-sm\">\n                    <p>All top-level folders in the SM channel chosen for conversion to a BoxCast Video Portal will turn\n                        into BoxCast channels</p>\n                </li>\n                <li class=\"margin-sm\">\n                    <p>All second-level+ folders in the SM channel chosen for conversion to a BoxCast Video Portal will\n                        be converted to tags</p>\n                </li>\n                <li class=\"margin-sm\">\n                    <p>All SM folders in channels not chosen for the Video Portal will become tags </p>\n                </li>\n            </ul>\n            <p ng-if=\"!vm.finished || vm.signedUp\" class=\"text-lg margin-lg\">Learn more about where your content will\n                live from our <a href=\"https://support.boxcast.com/en/articles/6159127-boxcast-video-portals-explained\"\n                    style=\"cursor: pointer;\" style=\"cursor: pointer;\">support article</a>.\n            </p>\n            <p ng-if=\" !vm.finished || vm.signedUp\" class=\" text-lg margin-lg\"><strong>NOTE:</strong> If you use your\n                SM channel for a podcast RSS feed\n                only,\n                don’t choose that channel for your Video\n                Portal. Your SM channel will be automatically turned into a BoxCast channel, and your RSS feeds will\n                still\n                work.</p>\n        </div>\n        <div style=\"margin-bottom: 10px;\">\n            <p ng-if=\"!vm.finished || vm.signedUp\" class=\"text-lg margin-lg\">Boxcast Video Portal</p>\n            <label ng-if=\"!vm.finished\" style=\"display: block;\" for=\"channelPicker\">Choose your primary channel</label>\n            <select ng-if=\"!vm.finished\" class=\"channel-control\" id=\"channelPicker\" ng-model=\"vm.scope.channelSelected\"\n                ng-options=\"e.name for e in vm.scope.channelOptions track by e.name\">\n            </select>\n            <p ng-if=\"vm.finished && vm.signedUp\" class=\"text-lg margin-lg\"><strong>{{ vm.scope.channelSelected.name\n                    }}</strong>\n            </p>\n            <a ng-click=\"vm.showList = !vm.showList\" ng-if=\"vm.finished && vm.signedUp\" class=\"text-lg margin-lg\"\n                style=\"cursor: pointer;\">{{\n                vm.showList ? 'Hide' : 'Show' }}\n                All\n                Channel + Folder Conversions</a>\n        </div>\n        <div>\n            <div>\n                <div ng-if=\"vm.tableData.length > 0 && !vm.finished\" style=\"margin-bottom: 10px;\">\n                    <h3 style=\"display: inline-block;\">\n                        <span style=\"font-weight: bold;\">Channel + Folder Conversions</span>\n                    </h3>\n                </div>\n                <div ng-if=\"vm.tableData.length > 0 && !vm.finished || vm.showList\" style=\"width: 50%; float: left;\">\n                    <table class=\"table progress-table\" style=\"border-right: none;\">\n                        <thead>\n                            <tr><strong>OLD Stream Monkey Video Organization</strong></tr>\n                        </thead>\n                        <tbody ng-repeat=\"b in vm.tableData\">\n                            <tr>\n                                <td ng-style=\"{'padding-left': b.indent}\"><i ng-class=\"b.smIcon\"\n                                        style=\"padding-right: 5px;\"></i>{{\n                                    b.name }}</td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n                <div ng-if=\"vm.tableData.length > 0 && !vm.finished || vm.showList\" style=\"width: 50%; float: left;\">\n                    <table class=\"table progress-table\" style=\"border-right: none;\">\n                        <thead>\n                            <tr><strong>NEW Stream Monkey Video Organization</strong></tr>\n                        </thead>\n                        <tbody ng-repeat=\"b in vm.tableData\">\n                            <tr>\n                                <td ng-style=\"{'padding-left': b.indent}\"><i ng-class=\"b.bcIcon\"\n                                        style=\"padding-right: 5px;\"></i>{{\n                                    b.name }}</td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n                <button ng-if=\"vm.tableData.length > 0 && !vm.finished\" class=\"portalSetup\"\n                    ng-click=\"vm.openSetup()\">Set Up Video Portal</button>\n            </div>\n            <a ng-if=\"!vm.signedUp && !vm.finished\" ng-click=\"vm.openSkip()\" class=\"text-lg margin-lg\"\n                style=\"cursor: pointer\">Continue without setting up a Video Portal</a>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VideoOrganizationController; });
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VideoOrganizationController = /*#__PURE__*/function () {
  function VideoOrganizationController($rootScope, $scope, $uibModal, $http) {
    var _this = this;

    _classCallCheck(this, VideoOrganizationController);

    _defineProperty(this, "openSkip", function () {
      _this.$uibModal.open({
        template: __webpack_require__(558),
        controller: __webpack_require__(559)["default"],
        controllerAs: 'vm',
        resolve: {
          activeTab: function activeTab() {
            return null;
          }
        }
      }).result.then(function (skipRes) {
        _this.finished = skipRes;

        if (skipRes) {
          localStorage.setItem('checkStepComplete', 'true');

          _this.rootScope.$emit('checkValidation', true);
        }
      });
    });

    _defineProperty(this, "openSetup", function () {
      _this.$uibModal.open({
        scope: _this.scope,
        template: __webpack_require__(560),
        controller: __webpack_require__(561)["default"],
        controllerAs: 'vm',
        resolve: {
          activeTab: function activeTab() {
            return null;
          }
        }
      }).result.then(function (check) {
        _this.finished = check.finished;
        _this.signedUp = check.signedUp;

        if (check.finished && check.signedUp) {
          _this.$http.post("".concat(API_ROOT, "/account/migration/channels/").concat(_this.scope.channelSelected.boxcast_channel_id, "/convert_to_portal")).then(function (resp) {});

          _this.rootScope.$emit('checkValidation', true);
        }
      });
    });

    this.account = $rootScope.account;
    this.rootScope = $rootScope;
    this.$http = $http;
    this.signedUp = false;
    this.finished = false;
    this.$uibModal = $uibModal;
    this.scope = $scope;
    this.scope.channelSelected = '';
    this.scope.channelOptions = [];
    this.showList = false;
    this.tableData = [];
    this.updateChannelOptions();

    if (localStorage.getItem('checkStepComplete') != null) {
      this.finished = true;
      this.rootScope.$emit('checkValidation', true);
    }

    $scope.$watch('channelSelected', function (channelSelected) {
      if (channelSelected != '') {
        //Call API
        _this.$http.get("".concat(API_ROOT, "/account/migration/channels/").concat(channelSelected.boxcast_channel_id, "/preview_convert_to_portal")).then(function (resp) {
          _this.tableData = [{
            name: channelSelected.name,
            smIcon: _this.getIcon('Channel'),
            bcIcon: _this.getIcon('Video Portal'),
            indent: '0px'
          }];

          if (resp.data.portal_channels) {
            _this.createTable(resp.data.portal_channels, 1);
          }
        });
      }
    });
  }

  _createClass(VideoOrganizationController, [{
    key: "createTable",
    value: function createTable(children, count) {
      var _iterator = _createForOfIteratorHelper(children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          var name = child.name,
              tags = child.tags;
          this.tableData.push({
            name: name,
            smIcon: this.getIcon('Folder'),
            bcIcon: this.getIcon('Channel'),
            indent: "".concat(count * 25, "px")
          });

          if (tags) {
            var _iterator2 = _createForOfIteratorHelper(tags),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var tag = _step2.value;
                this.tableData.push({
                  name: tag,
                  smIcon: this.getIcon('Folder'),
                  bcIcon: this.getIcon('Tag'),
                  indent: "".concat((count + 1) * 25, "px")
                });
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon(iconType) {
      if (iconType == 'Video Portal') {
        return 'fa fa-light fa-play-circle';
      } else if (iconType == 'Channel') {
        return 'fa fa-light fa-tv';
      } else if (iconType == 'Folder') {
        return 'fa fa-light fa-folder';
      } else if (iconType == 'Tag') {
        return 'fa fa-light fa-tag';
      }
    }
  }, {
    key: "updateChannelOptions",
    value: function updateChannelOptions() {
      var _this2 = this;

      this.$http.get("".concat(API_ROOT, "/account/migration/channels")).then(function (resp) {
        var _iterator3 = _createForOfIteratorHelper(resp.data),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var obj = _step3.value;

            if (obj.monkey_channel_id) {
              _this2.scope.channelOptions.push(obj);
            }

            if (obj.converted_to_portal) {
              _this2.finished = true;
              _this2.signedUp = true;
              _this2.scope.channelSelected = obj;

              _this2.rootScope.$emit('checkValidation', true);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      });
    }
  }]);

  return VideoOrganizationController;
}();



/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header modal-checkout\">\n    <div>\n        <h3 style=\"display: inline-block;\">\n            <span style=\"font-weight:bold;\">Are You Sure?</span>\n        </h3>\n        <p class=\"text-lg margin-sm\">If you do not set up a Video Portal, all Stream Monkey channels will become BoxCast\n            channels, and all SM folders will\n            become BoxCast tags. You will need to manually add channels and videos to your Video Portal for them to\n            appear\n            on your\n            boxcast.tv page and set top boxes (Apple TV, Roku, and Fire TV apps)</p>\n        <a href=\"https://support.boxcast.com/en/articles/6159127-boxcast-video-portals-explained\"\n            style=\"cursor: pointer;\">Learn More</a>\n    </div>\n</div>\n<div class=\"modal-header modal-checkout\">\n    <div>\n        <button class=\"migrateModalBtn\" style=\"background: #D32F2F;\" ng-click=\"vm.dismiss(true)\">Skip Setup</button>\n        <button class=\"migrateModalBtn\" style=\"color: #00263E;\" ng-click=\"vm.dismiss(false)\">Cancel</button>\n    </div>\n</div>"

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SkipSetupController; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var SkipSetupController = /*#__PURE__*/function () {
  function SkipSetupController($scope, $uibModalInstance) {
    _classCallCheck(this, SkipSetupController);

    this.$uibModalInstance = $uibModalInstance;
  }

  _createClass(SkipSetupController, [{
    key: "dismiss",
    value: function dismiss(check) {
      this.$uibModalInstance.close(check);
    }
  }]);

  return SkipSetupController;
}();



/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header modal-checkout\">\n    <h3 style=\"display: inline-block;\">\n        <span style=\"font-weight:bold;\">Set up your video portal</span>\n    </h3>\n    <p class=\"text-lg margin-lg\">Your Stream Monkey channel <strong>{{ vm.$scope.channelSelected.name }}</strong>, along\n        with\n        all\n        folders and videos\n        in your channel, will be imported\n        into a BoxCast Video Portal. All other SM channels and videos will not appear on boxcast.tv or your set top\n        boxes unless\n        they are manually added. Learn more</p>\n    <a href=\"https://support.boxcast.com/en/articles/6159127-boxcast-video-portals-explained\"\n        style=\"cursor: pointer;\">Learn More</a>\n</div>\n<div class=\"modal-header modal-checkout\">\n    <button class=\"migrateModalBtn\" style=\"color: black; border: 2px solid #00A3BB; width: 160px;\"\n        ng-click=\"vm.dismiss(true, true)\">Set Up Video Portal</button>\n    <button class=\"migrateModalBtn\" style=\"color: black;\" ng-click=\"vm.dismiss(false, false)\">Cancel</button>\n</div>"

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SetupPortalController; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var SetupPortalController = /*#__PURE__*/function () {
  function SetupPortalController($scope, $uibModalInstance) {
    _classCallCheck(this, SetupPortalController);

    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
  }

  _createClass(SetupPortalController, [{
    key: "dismiss",
    value: function dismiss(finished, signedUp) {
      var check = {
        finished: finished,
        signedUp: signedUp
      };
      this.$uibModalInstance.close(check);
    }
  }]);

  return SetupPortalController;
}();



/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row form-horizontal\" style=\"position: relative;\">\n    <div class=\"col-xs-12\" style=\"margin-top: 30px; margin-bottom: 10px;\">\n        <h3 ng-if=\"vm.items.length != 0\" style=\"display: inline-block;\">\n            <span style=\"font-weight:bold;\">Migrating Your Videos:</span>\n            {{ vm.totalCompleted }} of {{ vm.smallItems.length + vm.longItems.length }} Transferred\n        </h3>\n        <button ng-if=\"vm.notMigrated\" ng-click=\"vm.updateBroadcastList()\" class=\"save-btn\"\n            style=\"float: right; margin-top: 0px; margin-bottom: 0px;\">Refresh</button>\n    </div>\n    <div class=\"col-xs-12\">\n        <table ng-if=\"vm.smallItems.length != 0\" class=\"table progress-table\">\n            <thead>\n                <tr>\n                    <th>Date</th>\n                    <th>Title</th>\n                    <th>Tags</th>\n                    <th>Status</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat=\"b in vm.smallItems\">\n                    <td>{{ b.createdAt }}</td>\n                    <td>{{ b.name }}</td>\n                    <td style=\"width: 35%;\">\n                        <p ng-repeat=\"c in b.tags\" style=\"display: inline-block; margin-right: 15px;\"><i\n                                class=\"fa fa-light fa-tag\" style=\"padding-right: 3px;\"></i>{{ c }}\n                        </p>\n                    </td>\n                    <td>{{ b.status }}</td>\n                </tr>\n                <tr ng-if=\"vm.toggleLong\" ng-repeat=\"b in vm.longItems\">\n                    <td>{{ b.createdAt }}</td>\n                    <td>{{ b.name }}</td>\n                    <td style=\"width: 35%;\">\n                        <p ng-repeat=\"c in b.tags\" style=\"display: inline-block; margin-right: 15px;\"><i\n                                class=\"fa fa-light fa-tag\" style=\"padding-right: 3px;\"></i>{{ c }}\n                        </p>\n                    </td>\n                    <td>{{ b.status }}</td>\n                </tr>\n                <tr ng-if=\"vm.smallItems.length + vm.longItems.length > vm.smallLargeBreak\">\n                    <td ng-if=\"!vm.toggleLong\"><a ng-click=\"vm.toggleShow()\" style=\"cursor: pointer;\">View more\n                            videos</a></td>\n                    <td ng-if=\"vm.toggleLong\"><a ng-click=\"vm.toggleShow()\" style=\"cursor: pointer;\">View fewer\n                            videos</a></td>\n                    <td></td>\n                    <td></td>\n                </tr>\n            </tbody>\n        </table>\n        <div style=\"text-align: center; margin-top: 35px;\">\n            <p ng-if=\"vm.smallItems.length == 0\">No items to migrate. Please continue to the next step.</p>\n            <p ng-if=\"vm.smallItems.length != 0 && vm.smallItems.length + vm.longItems.length != vm.totalCompleted\">\n                Migration will continue\n                running,\n                please proceed to the next step.</p>\n            <p ng-if=\"vm.smallItems.length != 0 && vm.smallItems.length + vm.longItems.length == vm.totalCompleted\">All\n                items have been\n                migrated. Please\n                continue to the next step.</p>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MigrationProgressController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_isStreamMonkey__ = __webpack_require__(10);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

 // How many broadcast imports to load from the account migration

var PAGE_SIZE = 500; // Where to break between small/large (show more/fewer)

var SMALL_LARGE_BREAK = 20;

var MigrationProgressController = /*#__PURE__*/function () {
  function MigrationProgressController($rootScope, $state, $http, User, Account) {
    'ngInject';

    _classCallCheck(this, MigrationProgressController);

    this.rootScope = $rootScope;
    this.account = $rootScope.account;
    this.accountInfo = Account.getBilling();
    this.user = User;
    this.$state = $state;
    this.$http = $http;
    this.smallItems = [];
    this.longTimes = [];
    this.toggleLong = false;
    this.notMigrated = false;
    this.totalCompleted = 0;
    this.smallLargeBreak = SMALL_LARGE_BREAK;
    this.isStreamMonkey = Object(__WEBPACK_IMPORTED_MODULE_0__utils_isStreamMonkey__["a" /* default */])(this.account.migration_service_id);
    this.updateBroadcastList();

    if (this.account.status != 'onboarding') {
      this.$state.go('complete-migration.success');
    }
  }

  _createClass(MigrationProgressController, [{
    key: "toggleShow",
    value: function toggleShow() {
      this.toggleLong = !this.toggleLong;
    }
  }, {
    key: "updateBroadcastList",
    value: function updateBroadcastList() {
      var _this = this;

      this.$http.get("".concat(API_ROOT, "/account/migration/imports?page_size=").concat(PAGE_SIZE)).then(function (resp) {
        var monthsArr = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        _this.totalCompleted = 0;
        _this.notMigrated = false;
        _this.smallItems = [];
        _this.longItems = [];

        for (var i = 0; i < resp.data.length; i++) {
          var dateArr = resp.data[i].created_at.slice(0, resp.data[i].created_at.indexOf('T')).split('-'); // Broadcast conversions can happen via either a conversion task or a BoxCast upload.
          // If done via conversion task, the status is in task_status; if done via upload, the
          // status is in upload_status.

          var conversionStatus = void 0;

          if (resp.data[i].upload_status) {
            conversionStatus = resp.data[i].upload_status;
          } else if (resp.data[i].task_status) {
            conversionStatus = resp.data[i].task_status;
          } else {
            conversionStatus = 'Not started';
          }

          if (conversionStatus != 'ready') {
            _this.notMigrated = true;
          } // If the status has a colon followed by some digits, change "foo:XX" to "foo (XX%)" as
          // it's more readable.


          conversionStatus = conversionStatus.replace(/([^:]+):(\d+)/, function (_, p1, p2) {
            return "".concat(p1, " (").concat(p2, "%)");
          }); // Capitalize the first letter of the status
          // And if the status is 'ready', show "Imported" instead

          var status = conversionStatus === 'ready' ? 'Imported' : conversionStatus.charAt(0).toUpperCase() + conversionStatus.slice(1);

          if (_this.smallItems.length < _this.smallLargeBreak) {
            _this.smallItems.push({
              name: resp.data[i].name,
              createdAt: "".concat(monthsArr[parseInt(dateArr[1]) - 1], " ").concat(dateArr[2], ", ").concat(dateArr[0]),
              tags: resp.data[i].tags.split(','),
              status: status
            });
          } else {
            _this.longItems.push({
              name: resp.data[i].name,
              createdAt: "".concat(monthsArr[parseInt(dateArr[1]) - 1], " ").concat(dateArr[2], ", ").concat(dateArr[0]),
              tags: resp.data[i].tags.split(','),
              status: status
            });
          }

          if (conversionStatus == 'ready') {
            _this.totalCompleted++;
          }
        }
      })["catch"](function () {
        return false;
      });
    }
  }]);

  return MigrationProgressController;
}();



/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row form-horizontal\" style=\"display: flex; justify-content: center; align-items: center; height: 275px;\">\n    <p style=\"font-size: 20px;\"><a ng-click=\"vm.openCompleteAccountModal()\" style=\"cursor: pointer;\">Launch plan\n            enrollment</a> to complete your\n        migration</p>\n</div>"

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PlanEnrollmentController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_isStreamMonkey__ = __webpack_require__(10);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var PlanEnrollmentController = /*#__PURE__*/function () {
  function PlanEnrollmentController($rootScope, $state, $scope, $http, User, Account) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, PlanEnrollmentController);

    this.rootScope = $rootScope;
    this.account = $rootScope.account;
    this.accountInfo = Account.getBilling();
    this.user = User;
    this.$state = $state;
    this.$http = $http;
    this.isStreamMonkey = Object(__WEBPACK_IMPORTED_MODULE_0__utils_isStreamMonkey__["a" /* default */])(this.account.migration_service_id);
    this.numVideos = 0;
    this.$http.get("".concat(API_ROOT, "/account/migration/imports")).then(function (resp) {
      _this.numVideos = resp.data.length;
    });

    if (this.account.status != 'onboarding') {
      this.$state.go("complete-migration.success");
    }

    $rootScope.$on('account-migrated', function (data) {
      _this.account.status = data.status;
    });
  }

  _createClass(PlanEnrollmentController, [{
    key: "openCompleteAccountModal",
    value: function openCompleteAccountModal() {
      var rootScope = this.rootScope;
      rootScope.$emit('open-sm-modal'); // the modal instance lives in top-navbar.js
    }
  }]);

  return PlanEnrollmentController;
}();



/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = "<div class=\"well onboarding\" ng-if=\"vm.account.status != 'onboarding'\">\n    <header class=\"onboarding__header\">\n        <div>\n            <img loading=\"lazy\" width=\"346\" height=\"224\" src=\"/img/onboarding-celebrate2.png\">\n        </div>\n        <h1 class=\"onboarding__title\">\n            <strong>Your account has been migrated to BoxCast!</strong>\n        </h1>\n        <p class=\"onboarding__lead\">\n            <a href=\"/\" class=\"btn btn-lg btn-success\">\n                Explore The Dashboard\n            </a>\n        </p>\n    </header>\n</div>"

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SuccessController; });
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SuccessController = /*#__PURE__*/_createClass(function SuccessController($rootScope) {
  _classCallCheck(this, SuccessController);

  this.account = $rootScope.account;
});



/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('checkout', []);
module.config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('checkout', {
    url: '/:pd_did?pd_sid?start_step',
    template: "",
    controller: function controller($state) {
      // Remove undefined params
      Object.keys($state.params).forEach(function (key) {
        if (!$state.params[key]) {
          delete $state.params[key];
        }
      });
      var urlParams = new URLSearchParams($state.params);
      window.location.replace("".concat(window.VUE_DASHBOARD_ROOT, "/checkout?") + urlParams);
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
var module = angular.module('app.resources', []); // The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.

__webpack_require__(570);

__webpack_require__(572);

__webpack_require__(573);

__webpack_require__(574);

__webpack_require__(575);

__webpack_require__(576);

__webpack_require__(577);

__webpack_require__(578);

__webpack_require__(579);

__webpack_require__(580);

__webpack_require__(581);

__webpack_require__(582);

__webpack_require__(583);

__webpack_require__(584);

__webpack_require__(585);

__webpack_require__(586);

__webpack_require__(587);

__webpack_require__(588);

__webpack_require__(589);

__webpack_require__(590);

__webpack_require__(591);

__webpack_require__(592);

__webpack_require__(593);

__webpack_require__(594);

__webpack_require__(595);

__webpack_require__(596);

__webpack_require__(597);

__webpack_require__(598);

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_objectify__ = __webpack_require__(571);

var module = angular.module('app.resources');

var transformAccountResponse = function transformAccountResponse(data) {
  var account = angular.fromJson(data); // Some fields that might be blank strings we actually want to be empty hashes

  if (!account['content_settings']) account['content_settings'] = {};
  if (!account['metadata']) account['metadata'] = {}; // Some fields are space-separated lists (or arrays) of flags. Turn these into objects
  // where the flags become keys and the values are boolean.

  account['feature_flags'] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_objectify__["a" /* arrayToObject */])(account['feature_flags'] || []);
  account['extra_features'] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_objectify__["b" /* fieldsToObject */])(account['extra_features'] || '');
  account['usage_flags'] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_objectify__["b" /* fieldsToObject */])(account['usage_flags'] || '');
  return account;
};

module.factory('Account', function ($resource, $cacheFactory) {
  'ngInject';

  var Account = $resource("".concat(API_ROOT, "/account"), {}, {
    get: {
      method: 'GET',
      cache: true,
      transformResponse: transformAccountResponse
    },
    update: {
      method: 'PUT',
      transformResponse: transformAccountResponse
    },
    // Scoreboard configuration
    getScoreboard: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/scoreboard_configuration")
    },
    updateScoreboard: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/scoreboard_configuration")
    },
    // Sportzcast Integration
    getSportzcast: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/sportzcast_configuration")
    },
    updateSportzcast: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/sportzcast_configuration")
    },
    // Kaltura Integration
    getKaltura: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/kaltura_configuration")
    },
    updateKaltura: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/kaltura_configuration")
    },
    // Billing
    getBilling: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/billing")
    },
    updateBilling: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/billing")
    },
    // Upgrades
    getUpgrades: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/upgrades"),
      isArray: true
    },
    createUpgrade: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/upgrades")
    },
    getProducts: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/products"),
      isArray: true
    },
    // Caption Vocabulary
    getCaptionVocabulary: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/caption_vocabulary")
    },
    updateCaptionVocabulary: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/caption_vocabulary")
    },
    // Usage summaries
    getUsageSummaries: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/usage_summaries"),
      isArray: true
    }
  });
  angular.extend(Account.prototype, {
    authorized: function authorized() {
      var ret = this.can_stream;

      if (this.contract == 'trial' && moment(this.expires_on).toDate() < new Date()) {
        ret = false;
      } else if (this.contract == 'trial' && this.status == 'initial') {
        ret = false;
      }

      return ret;
    },
    defaultReportState: function defaultReportState() {
      // Prefer viewer analytics, but fall back to tickets or donations
      if (!this.feature_flags.analytics) {
        if (!this.feature_flags.no_ticketed) {
          return 'reports.tickets';
        } else if (this.feature_flags.donations) {
          return 'reports.donations';
        }
      }

      return 'reports.viewer';
    },
    isTrialing: function isTrialing() {
      return this.contract == 'trial';
    },
    refresh: function refresh() {
      var _this = this;

      $cacheFactory.get('$http').remove("".concat(API_ROOT, "/account"));
      return Account.get().$promise.then(function (newAccount) {
        Object.keys(newAccount).forEach(function (k) {
          _this[k] = newAccount[k];
        });
        return _this;
      });
    },
    showOnboarding: function showOnboarding() {
      // TODO remove this when no longer testing product tours [UA-1023]
      var hasProductTourFlag = this.extra_features.product_tour;
      return this.status == 'onboarding' && this.metadata.onboarding_step && !hasProductTourFlag;
    }
  });
  return Account;
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = arrayToObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = fieldsToObject;
/**
 * Converts an array of field strings into an object with the fields as keys and true as values.
 *
 * @param  {Array} array An array of field strings. E.g. `["foo", "bar"]`
 * @return {Object}      An object with the fields as keys and true as values.
 *                       E.g. `{foo: true, bar: true}`
 */
function arrayToObject(array) {
  return _.reduce(array, function (m, flag) {
    if (flag) {
      m[flag] = true;
    }

    return m;
  }, {});
}
/**
 * Converts a string of space-separated fields into an object with the fields as keys and true as
 * values.
 *
 * @param  {String} fields A string with space-separated field values. E.g. `"foo bar"`
 * @return {Object}        An object with the fields as keys and true as values.
 *                         E.g. `{foo: true, bar: true}`
 */

function fieldsToObject(fields) {
  return arrayToObject(fields.split(/\s+/));
}

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources'); // XXX: Let the reader beware! I tried doing this with an interceptor on the resource below, but
// Angular 1.whatever does some _shenanigans_ with resource interceptors, and no matter what I
// tried, I could not get this to work that way. So this http interceptor looks for 404 responses
// on the current account reseller route and resolves them with an empty object.

module.config(function ($httpProvider) {
  'ngInject';

  $httpProvider.interceptors.push(function ($q) {
    return {
      responseError: function responseError(rejection) {
        if ((rejection.config || {}).url == "".concat(API_ROOT, "/account/reseller")) {
          rejection.status = 200;
          rejection.data = {};
          return $q.resolve(rejection);
        }

        return $q.reject(rejection);
      }
    };
  });
});
module.factory('AccountReseller', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/reseller"));
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('ActivationCodes', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/activations/:id"), {
    id: '@id'
  }, {
    activateAddon: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/activations/:id/addon")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('AnalyticsResource', function AnalyticsResource($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/viewer_analytics/:channel_id"), {
    channel_id: '@channel_id'
  }, {});
});
module.factory('AnalyticsExportResource', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/viewer_analytics/:channel_id/export"), {
    channel_id: '@channel_id'
  }, {
    render: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/viewer_analytics/:channel_id/export"),
      responseType: 'arraybuffer',
      transformResponse: function transformResponse(data, headers) {
        return {
          blob: new Blob([data], {
            type: headers('content-type')
          }),
          headers: headers()
        };
      }
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('AppleTvApp', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/apple_tv_apps/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('BoxCaster', function ($resource) {
  'ngInject';

  var BoxCaster = $resource("".concat(API_ROOT, "/account/boxcasters/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    },
    postRPC: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/boxcasters/:id/rpcs/:rpcId"),
      params: {
        id: '@id',
        rpcId: '@rpcId'
      }
    },
    getRPC: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/boxcasters/:id/rpcs/:rpcId"),
      params: {
        id: '@id',
        rpcId: '@rpcId'
      }
    },
    deleteRPC: {
      method: 'DELETE',
      url: "".concat(API_ROOT, "/account/boxcasters/:id/rpcs/:rpcId"),
      params: {
        id: '@id',
        rpcId: '@rpcId'
      }
    },
    getRegistration: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/boxcaster/registration")
    },
    postRegistration: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/boxcasters")
    }
  });

  BoxCaster.prototype.hasWifi = function () {
    return this.id.startsWith('o') || this.id.startsWith('p');
  };

  BoxCaster.prototype.isPro = function () {
    return this.id.startsWith('p');
  };

  return BoxCaster;
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Broadcast', function Broadcast($resource, $q, $http) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/broadcasts/:id"), {
    id: '@id',
    simulcast_id: '@simulcast_id'
  }, {
    get: {
      method: 'GET',
      transformResponse: function transformResponse(data) {
        var broadcast = angular.fromJson(data);

        if (!broadcast.content_settings) {
          broadcast.content_settings = {};
        }

        if (!broadcast.metadata) {
          broadcast.metadata = {};
        }

        return broadcast;
      }
    },
    create: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/broadcasts")
    },
    patch: {
      method: 'PATCH'
    },
    update: {
      method: 'PUT'
    },
    view: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/broadcasts/:id/view")
    },
    deleteRecurring: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/broadcasts/:id/delete_recurring")
    },
    // Score here is the actual game/match score
    getScore: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/broadcasts/:id/metadata/scoreboard")
    },
    saveScore: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/account/broadcasts/:id/metadata/scoreboard")
    },
    scheduleSimulcast: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/broadcasts/:id/simulcast_configuration/:simulcast_id/schedule")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Caption', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/broadcasts/:broadcast_id/captions/:id"), {
    broadcast_id: '@broadcast_id',
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT'
    },
    render: {
      method: 'GET',
      params: {
        type: '@format'
      },
      url: "".concat(API_ROOT, "/account/broadcasts/:broadcast_id/captions/:id/render?format=:format"),
      responseType: 'arraybuffer',
      transformResponse: function transformResponse(data, headers) {
        return {
          blob: new Blob([data], {
            type: headers('Content-Type')
          })
        };
      }
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Channel', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/channels/:id"), {
    id: '@id'
  }, {
    create: {
      method: 'POST'
    },
    update: {
      method: 'PUT'
    },
    getBroadcasts: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/channels/:id/broadcasts"),
      isArray: true
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('BroadcastTags', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/broadcast_tags/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/broadcast_tags?l=1000"),
      isArray: true
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Donation', function Donation($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/donations/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    },
    summary: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/donations/summary")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('FacebookUser', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/facebook_users/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var module = angular.module('app.resources'); // From https://dev.maxmind.com/geoip/legacy/codes

var CONTINENT_CODE_FROM_COUNTRY_CODE = {
  AD: 'EU',
  AE: 'AS',
  AF: 'AS',
  AG: 'NA',
  AI: 'NA',
  AL: 'EU',
  AM: 'AS',
  AN: 'NA',
  AO: 'AF',
  AP: 'AS',
  AQ: 'AN',
  AR: 'SA',
  AS: 'OC',
  AT: 'EU',
  AU: 'OC',
  AW: 'NA',
  AX: 'EU',
  AZ: 'AS',
  BA: 'EU',
  BB: 'NA',
  BD: 'AS',
  BE: 'EU',
  BF: 'AF',
  BG: 'EU',
  BH: 'AS',
  BI: 'AF',
  BJ: 'AF',
  BL: 'NA',
  BM: 'NA',
  BN: 'AS',
  BO: 'SA',
  BR: 'SA',
  BS: 'NA',
  BT: 'AS',
  BV: 'AN',
  BW: 'AF',
  BY: 'EU',
  BZ: 'NA',
  CA: 'NA',
  CC: 'AS',
  CD: 'AF',
  CF: 'AF',
  CG: 'AF',
  CH: 'EU',
  CI: 'AF',
  CK: 'OC',
  CL: 'SA',
  CM: 'AF',
  CN: 'AS',
  CO: 'SA',
  CR: 'NA',
  CU: 'NA',
  CV: 'AF',
  CX: 'AS',
  CY: 'AS',
  CZ: 'EU',
  DE: 'EU',
  DJ: 'AF',
  DK: 'EU',
  DM: 'NA',
  DO: 'NA',
  DZ: 'AF',
  EC: 'SA',
  EE: 'EU',
  EG: 'AF',
  EH: 'AF',
  ER: 'AF',
  ES: 'EU',
  ET: 'AF',
  EU: 'EU',
  FI: 'EU',
  FJ: 'OC',
  FK: 'SA',
  FM: 'OC',
  FO: 'EU',
  FR: 'EU',
  FX: 'EU',
  GA: 'AF',
  GB: 'EU',
  GD: 'NA',
  GE: 'AS',
  GF: 'SA',
  GG: 'EU',
  GH: 'AF',
  GI: 'EU',
  GL: 'NA',
  GM: 'AF',
  GN: 'AF',
  GP: 'NA',
  GQ: 'AF',
  GR: 'EU',
  GS: 'AN',
  GT: 'NA',
  GU: 'OC',
  GW: 'AF',
  GY: 'SA',
  HK: 'AS',
  HM: 'AN',
  HN: 'NA',
  HR: 'EU',
  HT: 'NA',
  HU: 'EU',
  ID: 'AS',
  IE: 'EU',
  IL: 'AS',
  IM: 'EU',
  IN: 'AS',
  IO: 'AS',
  IQ: 'AS',
  IR: 'AS',
  IS: 'EU',
  IT: 'EU',
  JE: 'EU',
  JM: 'NA',
  JO: 'AS',
  JP: 'AS',
  KE: 'AF',
  KG: 'AS',
  KH: 'AS',
  KI: 'OC',
  KM: 'AF',
  KN: 'NA',
  KP: 'AS',
  KR: 'AS',
  KW: 'AS',
  KY: 'NA',
  KZ: 'AS',
  LA: 'AS',
  LB: 'AS',
  LC: 'NA',
  LI: 'EU',
  LK: 'AS',
  LR: 'AF',
  LS: 'AF',
  LT: 'EU',
  LU: 'EU',
  LV: 'EU',
  LY: 'AF',
  MA: 'AF',
  MC: 'EU',
  MD: 'EU',
  ME: 'EU',
  MF: 'NA',
  MG: 'AF',
  MH: 'OC',
  MK: 'EU',
  ML: 'AF',
  MM: 'AS',
  MN: 'AS',
  MO: 'AS',
  MP: 'OC',
  MQ: 'NA',
  MR: 'AF',
  MS: 'NA',
  MT: 'EU',
  MU: 'AF',
  MV: 'AS',
  MW: 'AF',
  MX: 'NA',
  MY: 'AS',
  MZ: 'AF',
  NA: 'AF',
  NC: 'OC',
  NE: 'AF',
  NF: 'OC',
  NG: 'AF',
  NI: 'NA',
  NL: 'EU',
  NO: 'EU',
  NP: 'AS',
  NR: 'OC',
  NU: 'OC',
  NZ: 'OC',
  OM: 'AS',
  PA: 'NA',
  PE: 'SA',
  PF: 'OC',
  PG: 'OC',
  PH: 'AS',
  PK: 'AS',
  PL: 'EU',
  PM: 'NA',
  PN: 'OC',
  PR: 'NA',
  PS: 'AS',
  PT: 'EU',
  PW: 'OC',
  PY: 'SA',
  QA: 'AS',
  RE: 'AF',
  RO: 'EU',
  RS: 'EU',
  RU: 'EU',
  RW: 'AF',
  SA: 'AS',
  SB: 'OC',
  SC: 'AF',
  SD: 'AF',
  SE: 'EU',
  SG: 'AS',
  SH: 'AF',
  SI: 'EU',
  SJ: 'EU',
  SK: 'EU',
  SL: 'AF',
  SM: 'EU',
  SN: 'AF',
  SO: 'AF',
  SR: 'SA',
  ST: 'AF',
  SV: 'NA',
  SY: 'AS',
  SZ: 'AF',
  TC: 'NA',
  TD: 'AF',
  TF: 'AN',
  TG: 'AF',
  TH: 'AS',
  TJ: 'AS',
  TK: 'OC',
  TL: 'AS',
  TM: 'AS',
  TN: 'AF',
  TO: 'OC',
  TR: 'EU',
  TT: 'NA',
  TV: 'OC',
  TW: 'AS',
  TZ: 'AF',
  UA: 'EU',
  UG: 'AF',
  UM: 'OC',
  US: 'NA',
  UY: 'SA',
  UZ: 'AS',
  VA: 'EU',
  VC: 'NA',
  VE: 'SA',
  VG: 'NA',
  VI: 'NA',
  VN: 'AS',
  VU: 'OC',
  WF: 'OC',
  WS: 'OC',
  YE: 'AS',
  YT: 'AF',
  ZA: 'AF',
  ZM: 'AF',
  ZW: 'AF'
};

var Geolocation = /*#__PURE__*/function () {
  function Geolocation($q, $timeout) {
    _classCallCheck(this, Geolocation);

    this.$q = $q;
    this.$timeout = $timeout;
  }

  _createClass(Geolocation, [{
    key: "get",
    value: function get() {
      var _this = this;

      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.$q(function (resolve, reject) {
        if (!window.fetch) {
          // your browser is bad and you should feel bad
          reject("your browser does not support 'fetch'");
          return;
        }

        var timeout = opts && opts.timeout;
        var timedOut = false;

        if (timeout) {
          _this.$timeout(function () {
            timedOut = true;
            reject('timed out');
          }, timeout);
        }

        fetch(GEO_URL).then(function (res) {
          return res.json();
        }).then(function (resp) {
          // Try to glue on the continent code from the response. Ideally this would happen in the
          // geoip_service, but it's not quite so straightforward, unfortunately.
          if (resp.country_code) {
            var continentCode = CONTINENT_CODE_FROM_COUNTRY_CODE[resp.country_code];

            if (continentCode) {
              resp.continent_code = continentCode;
            }
          }

          if (!timedOut) {
            resolve(resp);
          }
        })["catch"](function (error) {
          if (!timedOut) {
            reject(error);
          }
        });
      });
    }
  }]);

  return Geolocation;
}();

module.factory('Geolocation', function ($q, $timeout) {
  'ngInject';

  return new Geolocation($q, $timeout);
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// Highlights are very similar to regular broadcasts recordings with a trimmed
// start and stop segment.
//
// The list of all highlights for a given broadcast is at:
//    GET /account/broadcasts/{BID}/highlights
//
// The segment list for a given highlight is at:
//    GET /account/broadcasts/{BID}/highlights/{HID}/segments
//
// ... which can be found via the "view" endpoint:
//    GET /highlights/{HID}/view
//
// The trim points can be managed at:
//    GET/PUT /account/broadcasts/{BID}/highlights/{HID}
//        start_seconds & stop_seconds
//
var module = angular.module('app.resources');
module.factory('Highlight', function Highlight($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/broadcasts/:broadcastId/highlights/:id"), {
    broadcastId: '@broadcastId',
    id: '@id'
  }, {
    create: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/broadcasts/:broadcastId/highlights")
    },
    update: {
      method: 'PUT'
    },
    view: {
      method: 'GET',
      url: "".concat(API_ROOT, "/highlights/:id/view")
    },
    prepareDownload: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/highlights/:id/download")
    },
    getKalturaExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/highlights/:id/kaltura_export")
    },
    startKalturaExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/highlights/:id/kaltura_export")
    },
    getYoutubeExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/highlights/:id/youtube_export")
    },
    startYoutubeExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/highlights/:id/youtube_export")
    },
    getVimeoExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/highlights/:id/vimeo_export")
    },
    startVimeoExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/highlights/:id/vimeo_export")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Order', function ($resource) {
  'ngInject';

  var Order = $resource("".concat(API_ROOT, "/account/orders/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    }
  });
  return Order;
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('TwitterUser', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/twitter_users/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Podcast', function ($resource) {
  'ngInject';

  return $resource("".concat(SYNDICATION_SERVICE_BASE_URL, "/podcasts"), {}, {
    getCategories: {
      method: 'GET',
      url: "".concat(SYNDICATION_SERVICE_BASE_URL, "/config/podcast-categories")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Recording', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/recordings/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    },
    segments: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/recordings/:id/segments"),
      isArray: true
    },
    prepareDownload: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/recordings/:id/download")
    },
    getKalturaExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/recordings/:id/kaltura_export")
    },
    startKalturaExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/recordings/:id/kaltura_export")
    },
    getYoutubeExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/recordings/:id/youtube_export")
    },
    startYoutubeExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/recordings/:id/youtube_export")
    },
    getVimeoExportStatus: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/recordings/:id/vimeo_export")
    },
    startVimeoExport: {
      method: 'POST',
      url: "".concat(API_ROOT, "/account/recordings/:id/vimeo_export")
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 589 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var module = angular.module('app.resources');
var lastRequesterAddress = null;
module.config(["$httpProvider", function ($httpProvider) {
  'ngInject';

  $httpProvider.interceptors.push(["$q", function ($q) {
    return {
      response: function response(_response) {
        var requesterAddress = _response.headers('BoxCast-Requester-Address');

        if (requesterAddress) {
          lastRequesterAddress = requesterAddress;
        }

        return _response;
      }
    };
  }]);
}]);
module.service('Requester', /*#__PURE__*/function () {
  function AuthService() {
    _classCallCheck(this, AuthService);
  }

  _createClass(AuthService, [{
    key: "address",
    get: function get() {
      return lastRequesterAddress;
    }
  }]);

  return AuthService;
}());

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('RokuApp', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/roku_apps/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_rtmp__ = __webpack_require__(24);

var module = angular.module('app.resources');
module.factory('RTMPPushChannel', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/rtmp_push_channels/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true,
      transformResponse: function transformResponse(data, headersGetter, status) {
        return _.map(angular.fromJson(data), __WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["c" /* TransformRTMPPushChannelAPIToClient */]);
      }
    },
    get: {
      method: 'GET',
      transformResponse: function transformResponse(data, headersGetter, status) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["c" /* TransformRTMPPushChannelAPIToClient */])(angular.fromJson(data));
      }
    },
    create: {
      method: 'POST',
      transformRequest: function transformRequest(data, headersGetter) {
        return angular.toJson(Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["d" /* TransformRTMPPushChannelClientToAPI */])(data));
      },
      transformResponse: function transformResponse(data, headersGetter, status) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["c" /* TransformRTMPPushChannelAPIToClient */])(angular.fromJson(data));
      }
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT',
      transformRequest: function transformRequest(data, headersGetter) {
        return angular.toJson(Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["d" /* TransformRTMPPushChannelClientToAPI */])(data));
      },
      transformResponse: function transformResponse(data, headersGetter, status) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils_rtmp__["c" /* TransformRTMPPushChannelAPIToClient */])(angular.fromJson(data));
      }
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('ScoreboardAssistFirmware', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/scoreboard-assist/firmware/:id"), {
    id: '@id'
  }, {
    version: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/scoreboard-assist/firmware/:id/version"),
      transformResponse: function transformResponse(data) {
        return {
          version: data
        };
      }
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('StaticRTMP', function StaticRTMP($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/static_rtmps/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    update: {
      method: 'PUT'
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('Ticket', function Ticket($resource, $q) {
  'ngInject';

  var resource = $resource("".concat(API_ROOT, "/account/:resource/:id/tickets"), {
    id: '@id',
    resource: '@resource'
  }, {
    summary: {
      method: 'GET',
      url: "".concat(API_ROOT, "/account/:resource/:id/tickets/summary")
    }
  });

  resource.queryAll = function (params) {
    var tickets = [];
    var d = $q.defer();
    var paramsCopy = angular.copy(params);
    resource.query(paramsCopy, function (results, headers) {
      tickets = tickets.concat(results);
      var pagination = JSON.parse(headers('x-pagination'));

      if (!pagination || !pagination.last) {
        d.resolve(tickets);
        return;
      }

      var promises = [];

      for (var p = 1; p <= pagination.last; p++) {
        var paramsCopy2 = angular.copy(params);
        paramsCopy2.p = p;
        promises.push(resource.query(paramsCopy2).$promise);
      }

      $q.all(promises).then(function (results) {
        var i;

        for (i = 0; i < results.length; i++) {
          tickets = tickets.concat(results[i]);
        }

        d.resolve(tickets);
      })["catch"](function (e) {
        return d.reject(e);
      });
    }, function (err) {
      d.reject(err);
    });
    return d.promise;
  };

  return resource;
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('User', function ($resource) {
  'ngInject';

  var User = $resource("".concat(API_ROOT, "/user"), {
    accountId: '@accountId'
  }, {
    get: {
      method: 'GET',
      transformResponse: function transformResponse(data) {
        var user = angular.fromJson(data);

        if (!user.metadata) {
          user.metadata = {};
        }

        return user;
      }
    },
    update: {
      method: 'PUT'
    },
    updatePassword: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/user/password")
    },
    resendEmailVerification: {
      method: 'POST',
      url: "".concat(API_ROOT, "/user/resend_email_verification")
    },
    switchAccount: {
      method: 'POST',
      url: "".concat(API_ROOT, "/user/switch_account/:accountId")
    },
    validateEmail: {
      method: 'POST',
      url: "".concat(API_ROOT, "/checkout/validate_email")
    },
    getContact: {
      method: 'GET',
      url: "".concat(API_ROOT, "/user/contact")
    },
    updateContact: {
      method: 'PUT',
      url: "".concat(API_ROOT, "/user/contact")
    }
  });
  angular.extend(User.prototype, {
    can: function can(action, resource) {
      var possibleActions = (this._capsByResource || {})[resource] || [];
      return possibleActions.some(function (possibleAction) {
        return action === possibleAction;
      });
    },
    cannot: function cannot(action, resource) {
      return !this.can(action, resource);
    },
    configureCapabilities: function configureCapabilities(capsByResource) {
      this._capsByResource = capsByResource;
    },
    reloadFromResource: function reloadFromResource(reloadedResource) {
      var _this = this;

      Object.keys(reloadedResource).forEach(function (k) {
        _this[k] = reloadedResource[k];
      });
    }
  });
  return User;
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('UserCapabilities', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/user/capabilities"), {}, {
    get: {
      method: 'GET',
      isArray: true
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('VimeoUser', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/vimeo_users/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var module = angular.module('app.resources');
module.factory('YouTubeUser', function ($resource) {
  'ngInject';

  return $resource("".concat(API_ROOT, "/account/youtube_users/:id"), {
    id: '@id'
  }, {
    query: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE'
    },
    update: {
      method: 'PUT'
    }
  });
});
/* harmony default export */ __webpack_exports__["default"] = (module);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account_uploads_service__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_config__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bandwidth_test_client__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__capabilities__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkout__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__confirm_dialog__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__edit_or_create_event_service__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__facebook__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__jszip__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__meetings_service__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__multi_part_upload__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__one_or_all_dialog__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__overlays__ = __webpack_require__(615);













var module = angular.module('app.services', [__WEBPACK_IMPORTED_MODULE_0__account_uploads_service__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__api_config__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__bandwidth_test_client__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__capabilities__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__checkout__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__confirm_dialog__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__edit_or_create_event_service__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__facebook__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__jszip__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9__meetings_service__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__multi_part_upload__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11__one_or_all_dialog__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_12__overlays__["a" /* default */].name]);
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_files__ = __webpack_require__(601);

var module = angular.module('app.services.account-uploads-service', []); // Break large broadcast uploads into 100 MB pieces for multi-part upload

var MAX_CHUNK_SIZE = 100 * 1024 * 1024; // Amazon has a hard-limit on multi-part uploads of 5TB. However, there is a maximum number of
// 10,000 parts. So the limit is the minimum of 5 TB and 10,000 x MAX_CHUNK_SIZE.

var MAX_MULTI_PART_UPLOAD_SIZE = Math.min(5 * 1024 * 1024 * 1024 * 1024, 10000 * MAX_CHUNK_SIZE); // Put this in GB (and just round down) for the file size rule.

var MAX_MULTI_PART_UPLOAD_SIZE_GB = Math.floor(MAX_MULTI_PART_UPLOAD_SIZE / (1024 * 1024 * 1024)); // How long to be uploading before we start estimating time remaining (10s)

var TIME_REMAINING_THRESHOLD_MS = 10000;
module.service('AccountUploadsService', function ($http, $timeout, $q, $window, toaster, Upload, MultiPartUpload) {
  this.uploadConfiguration = function (allowVideo, allowImage, slotName) {
    var result = {};
    result.rules = {
      size: allowVideo ? {
        max: '5GB'
      } : {
        max: '1MB'
      },
      pattern: (allowImage ? '.jpg,.jpeg,.png,.gif' : '') + (allowVideo && allowImage ? ',' : '') + (allowVideo ? '.mp4' : '')
    };

    switch (slotName) {
      case 'broadcast':
        result.rules.pattern = '.mp4,.mov';
        result.rules.size = {
          max: "".concat(MAX_MULTI_PART_UPLOAD_SIZE_GB, "GB")
        };
        result.fileTypeSentence = 'a video';
        result.helpText = '[MP4, MOV]';
        result.showVideoHelp = false;
        break;

      case 'preview': //thumbnail

      case 'poster':
        result.fileTypeSentence = 'an image';
        result.helpText = '[PNG, JPG] [1920x1080px]';
        break;

      case 'preroll':
        result.fileTypeSentence = 'an MP4';
        result.showVideoHelp = true; // XXX: need to figure out how to inject link

        result.helpText = '[Recommend 720p with FastStart]';
        break;

      case 'overlay':
        result.fileTypeSentence = 'a PNG';
        result.helpText = '[up to 1920x1080px] [5MB]';
        result.rules.size = {
          max: '5MB'
        };
        result.rules.pattern = '.png';
        break;

      case 'document':
        result.fileTypeSentence = 'a PDF';
        result.helpText = '[5MB]';
        result.rules.size = {
          max: '5MB'
        };
        result.rules.pattern = '.pdf';
        break;

      case 'caption':
        result.fileTypeSentence = 'a WebVTT file';
        result.helpText = '(up to 5MB)';
        result.rules.size = {
          max: '5MB'
        };
        result.rules.pattern = '.vtt';
        break;

      case 'csv':
        result.fileTypeSentence = 'a CSV file';
        result.helpText = '(up to 5MB)';
        result.rules.size = {
          max: '5MB'
        };
        result.rules.pattern = '.csv';
        break;

      case 'podcast-preview':
        result.fileTypeSentence = 'an image';
        result.helpText = '[PNG, JPG] [Min 1400x1400px] [Max 3000x3000px] [12MB] [72dpi] [RGB]';
        result.rules.size = {
          max: '12MB'
        };
        break;

      case 'app-assets':
        result.fileTypeSentence = 'an image';
        result.helpText = '[PNG, JPG]';
        break;

      default:
        result.fileTypeSentence = 'a file to upload';
    }

    return result;
  };

  this.searchUnsplash = function (query) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15;
    this.unsplashSearching = true;
    this.unsplashResults = null;
    return $http({
      method: 'GET',
      url: 'https://api.unsplash.com/search/photos',
      params: {
        query: query,
        page: page,
        per_page: pageSize
      },
      headers: {
        'Ignore-Http-Interceptor-Auth': true,
        Authorization: "Client-ID ".concat(UNSPLASH_APP_ID)
      }
    }).then(function (response) {
      return response.data;
    });
  };

  this.listUploadsForPage = function (p, q, filters, pageSize) {
    return $http.get("".concat(API_ROOT, "/account/uploads"), {
      params: _.extend({
        q: q,
        p: Math.max(0, p - 1),
        l: pageSize,
        s: '-created_at'
      }, filters)
    }).then(function (response) {
      var pagination = JSON.parse(response.headers('x-pagination'));
      return {
        uploads: response.data,
        pagination: {
          current: p,
          total: pagination.total,
          resultMin: pageSize * (p - 1) + 1,
          resultMax: pageSize * (p - 1) + response.data.length
        }
      };
    });
  };

  this.deleteUpload = function (upload) {
    return $http["delete"]("".concat(API_ROOT, "/account/uploads/").concat(upload.id));
  };

  this.destroy = function () {
    MultiPartUpload.destroy();
  };

  var monotonicTime = function monotonicTime() {
    if ($window.performance && $window.performance.now) {
      return $window.performance.now();
    }

    return Date.now();
  };

  var updateFileProgress = function updateFileProgress(file, evt) {
    // Update the total percentage
    file.progressPct = parseInt(100.0 * evt.loaded / evt.total); // See how long we've been at it

    var now = monotonicTime();
    var elapsedTimeMs = now - file.uploadStartedAt;

    if (elapsedTimeMs < TIME_REMAINING_THRESHOLD_MS) {
      return;
    } // If we've been uploading for longer than TIME_REMAINING_THRESHOLD_MS, then start estimating
    // the remaining upload time.


    var totalEstimateMs = elapsedTimeMs * 1.0 * evt.total / evt.loaded;
    file.estimatedTimeRemainingMs = totalEstimateMs - elapsedTimeMs;
  };

  this.processFileAndUpload = function (file, slotName, args) {
    var uploadMetaUrl;
    var statusUploaded = 'uploaded';
    var statusFailed = 'error';

    if (slotName == 'broadcast') {
      if (!(args || {}).broadcast_id) {
        throw Error('broadcast_id is required');
      }

      uploadMetaUrl = "".concat(API_ROOT, "/account/broadcasts/").concat(args.broadcast_id, "/uploads");
      statusFailed = 'failed'; //XXX: upload_service uses `failed` instead of `error`
    } else {
      uploadMetaUrl = "".concat(API_ROOT, "/account/uploads");
    }

    file.status = 'uploading';
    file.progressPct = 0;
    file.uploadStartedAt = monotonicTime();
    var promise = $http.post(uploadMetaUrl, {
      filename: Object(__WEBPACK_IMPORTED_MODULE_0__utils_files__["a" /* sanitizeFilenameForUpload */])(file.name),
      mimetype: file.type || 'application/octet-stream',
      mime_type: file.type || 'application/octet-stream',
      filesize: file.size,
      slot: slotName,
      max_chunk_size: MAX_CHUNK_SIZE
    }).then(function (result) {
      console.log('Created upload slot', result);
      var uploadId = result.data.id;
      var s3UploadPromise;

      if (result.data.parts && result.data.parts.length > 0) {
        // Multi-part upload
        s3UploadPromise = MultiPartUpload.start("".concat(uploadMetaUrl, "/").concat(uploadId), file, result.data.parts);
      } else if (result.data.presigned_url) {
        // XXX: Upload.http is required because multipart/form-data doesn't work with presigned PUT
        s3UploadPromise = Upload.http({
          url: result.data.presigned_url,
          headers: {
            'Content-Type': file.type
          },
          method: 'PUT',
          data: file
        });
      } else {
        var psp = result.data.signed_upload;
        s3UploadPromise = Upload.upload({
          url: psp.url,
          method: 'POST',
          data: _.extend({}, psp.params, {
            file: file
          })
        });
      }

      return s3UploadPromise.then(function (resp) {
        console.log('Successfully uploaded', resp.data);
        file.status = 'done';
        return $http.put("".concat(uploadMetaUrl, "/").concat(uploadId), {
          status: statusUploaded
        });
      }, function (err) {
        console.error('Error uploading:', err);
        toaster.pop('warning', "File ".concat(file.name, " failed to upload."));
        file.status = 'error';
        return $http.put("".concat(uploadMetaUrl, "/").concat(uploadId), {
          status: statusFailed
        });
      }, function (evt) {
        return updateFileProgress(file, evt);
      });
    }).then(function (response) {
      return response.data; //peel off artifact of using $http rather than ngResource
    });
    return promise;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sanitizeFilenameForUpload;
function removeAllButLast(haystack, needle) {
  if (haystack.indexOf(needle) < 0) {
    return haystack;
  } else {
    var parts = haystack.split(needle);
    return parts.slice(0, -1).join('') + needle + parts.slice(-1);
  }
}

function sanitizeFilenameForUpload(filename) {
  var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'file';
  // Only keep the simplest set of url-safe characters to avoid ever escaping
  var cleaned = filename.replace(/\s+/g, '_').replace(/[^0-9a-zA-Z\._]/g, '_') || defaultFilename; // Only 1 period to avoid weird MIME issues

  return removeAllButLast(cleaned, '.');
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var module = angular.module('api-config', []); // Keep this around for lifetime of window/application, regardless of
// angular service lifecycle.

var globalState = {};
module.service('ApiConfig', function ($q, $http) {
  'ngInject'; // Once loading is complete, broadcast when our
  // promises have resolved to allow routing

  var _this = this;

  var deferredResolve = $q.defer();

  this.verifyResolved = function (res) {
    return deferredResolve.promise;
  }; // Stub


  this.account = {};
  this.stream = {};
  this.boxcaster = {};
  this.time_zones = [];
  this.content_languages = [];
  this.ticket = {};
  this.currentPage = 1; // Grab actual config values from API

  if (!_.keys(globalState).length) {
    $http.get("".concat(API_ROOT, "/api_configuration")).then(function (result) {
      _.each(result.data, function (value, key) {
        _this[key] = angular.copy(value);
        globalState[key] = angular.copy(value);
      });

      deferredResolve.resolve();
    });
  } else {
    _.each(globalState, function (value, key) {
      return _this[key] = value;
    });

    deferredResolve.resolve();
  }

  this.scopes = function () {
    return $http.get("".concat(API_ROOT, "/api_configuration/scopes")).then(function (r) {
      return r.data;
    });
  }; // Support basic promise API


  this.then = function () {
    var _deferredResolve$prom;

    return (_deferredResolve$prom = deferredResolve.promise).then.apply(_deferredResolve$prom, arguments);
  }; // Function to return field limits as a flattened hash per model


  this.modelFieldLimits = function (modelName, constraintName) {
    var constraints = angular.copy(_this.model_constraints[modelName] || {});

    _.each(constraints, function (v, k) {
      v = v[constraintName];

      if (!v) {
        delete constraints[k];
      } else {
        constraints[k] = v;
      }
    });

    return constraints;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_video_and_audio_config__ = __webpack_require__(27);


var DefaultBandwidth = 2000000; // hope they have at least 2 MBps up

var BandwidthTextExpiresInMs = 10 * 60 * 1000; // 10 minutes

var OverallTimeoutInSec = 60; //1 minute

var bandwidthFactor = 0.6,
    // Only use ~60% of the available bandwidth
videoToAudioBitrateScale = 8; // Starting at the minimum, for every 1 bit we add to audio, we add this many bits to video

var module = angular.module('bandwidth-test-client', []);
module.service('BandwidthTestClient', function (Requester, $q) {
  'ngInject';

  var _this = this;

  var audioBitrates = _(__WEBPACK_IMPORTED_MODULE_1__utils_video_and_audio_config__["a" /* VideoAudioConfig */].stream.audio_bitrates).pluck('value').map(function (x) {
    return parseInt(x, 10);
  }).filter().value();

  var videoBitrates = _(__WEBPACK_IMPORTED_MODULE_1__utils_video_and_audio_config__["a" /* VideoAudioConfig */].stream.video_bitrates).pluck('value').map(function (x) {
    return parseInt(x, 10);
  }).filter(function (x) {
    return x && x > 10000;
  }).value();

  this.init = function () {
    return $q(function (resolve, reject) {
      __webpack_require__.e/* require.ensure */(2).then((function () {
        var BandwidthTestClient = __webpack_require__(646);

        resolve(BandwidthTestClient);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    });
  };

  this.cancelIfInFlight = function () {
    if (_this._bandwidthTest) {
      _this._bandwidthTest.cancel();
    }
  };

  this.runTestOrUseRecentCached = function () {
    var onProgress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var alwaysRun = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return $q(function (resolve, reject) {
      _this.init().then(function (BandwidthTest) {
        // In order to prevent extra bandwidth probing, we can skip the bandwidth test if:
        //  - A bandwidth test has been done before, and
        //  - It was done from the same internet-facing address, and
        //  - It was done within the last 10 minutes.
        var lastBandwidthTest = __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].get('lastBwTest') && JSON.parse(__WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].get('lastBwTest'));
        var skipBandwidthTest = lastBandwidthTest && lastBandwidthTest.success && (!Requester.address || lastBandwidthTest.requesterAddress == Requester.address) && lastBandwidthTest.timestamp && Date.now() - lastBandwidthTest.timestamp < BandwidthTextExpiresInMs;

        if (skipBandwidthTest && !alwaysRun) {
          console.log('Skipping another bandwidth test');
          resolve(angular.extend({
            fromCache: true
          }, lastBandwidthTest));
          return;
        }

        _this._bandwidthTest = new BandwidthTest({
          overallTimeout: OverallTimeoutInSec,
          onProgress: onProgress
        });
        var uploadTestUrl = "".concat(BANDWIDTH_TEST_URL, "/upload");

        _this._bandwidthTest.testUpload({
          url: uploadTestUrl
        }).then(function (r) {
          resolve({
            success: true,
            requesterAddress: Requester.address,
            availableBandwidth: r.bandwidth,
            rSquared: r.rSquared,
            timestamp: Date.now()
          });
        })["catch"](function (e) {
          console.warn('Failed to get available bandwidth; using default.', e);
          resolve({
            success: false,
            requesterAddress: Requester.address,
            availableBandwidth: DefaultBandwidth,
            timestamp: Date.now()
          });
        });
      });
    }).then(function (bw) {
      if (bw.success) {
        __WEBPACK_IMPORTED_MODULE_0__auth_utils__["d" /* storage */].set('lastBwTest', JSON.stringify(bw));
      }

      return bw;
    });
  };

  function getBitrateLimits(height, frameRate) {
    // Attempt to match bitrate based on other parameters to line up closely to the
    // transcoded output https://github.com/boxcast/origin_task/blob/master/stream/variant.go
    // NOTE that RTMP doesn't support UHD resolutions so they're not accounted for here.
    var audioMin = 48000,
        audioMax = 192000,
        videoMin = 300000,
        videoMax = 6000000;

    if (height < 720) {
      videoMax = 1700000;
    } else if (height == 720 && frameRate == 30) {
      videoMax = 2750000;
    } else if (height == 720 && frameRate == 60) {
      videoMax = 2750000;
    } else if (height == 1080 && frameRate == 30) {
      videoMax = 6000000;
    } else if (height == 1080 && frameRate == 60) {
      videoMax = 8000000;
    }

    return {
      audio: {
        min: audioMin,
        max: audioMax
      },
      video: {
        min: videoMin,
        max: videoMax
      },
      inflectionPoint: audioMax + videoMin + (audioMax - audioMin) * videoToAudioBitrateScale
    };
  }

  this.getBitrates = function (bandwidth) {
    var videoBitrate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var audioBitrate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var frameRate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var availableBandwidth = bandwidthFactor * bandwidth;
    var bitrateLimits = getBitrateLimits(height || 720, frameRate || 30);
    console.log('availableBandwidth', availableBandwidth);
    console.log('bitrateLimits', bitrateLimits);

    if (videoBitrate && !audioBitrate) {
      // Video bitrate fixed, choose audio
      audioBitrate = Math.min(Math.max(Math.round(availableBandwidth - videoBitrate), bitrateLimits.audio.min), bitrateLimits.audio.max);
    } else if (!videoBitrate && audioBitrate) {
      // Audio bitrate fixed, choose video
      videoBitrate = Math.min(Math.max(Math.round(availableBandwidth - audioBitrate), bitrateLimits.video.min), bitrateLimits.video.max);
    } else if (!videoBitrate && !audioBitrate) {
      // Choose both bitrates
      var min = bitrateLimits.audio.min + bitrateLimits.video.min;

      if (availableBandwidth <= min) {
        audioBitrate = bitrateLimits.audio.min;
        videoBitrate = bitrateLimits.video.min;
      } else if (availableBandwidth < bitrateLimits.inflectionPoint) {
        var max = bitrateLimits.audio.max + bitrateLimits.video.max,
            dX = (availableBandwidth - min) / (max - min);
        audioBitrate = Math.round(bitrateLimits.audio.min + dX * (bitrateLimits.audio.max - bitrateLimits.audio.min));
        videoBitrate = Math.round(bitrateLimits.video.min + dX * (bitrateLimits.video.max - bitrateLimits.video.min));
      } else {
        audioBitrate = bitrateLimits.audio.max;
        var leftoverForVideo = Math.round(availableBandwidth - audioBitrate);
        videoBitrate = Math.max(Math.min(leftoverForVideo, bitrateLimits.video.max), bitrateLimits.video.min);
      }
    }

    if (!videoBitrate) {
      videoBitrate = 0; //could be NaN
    } // Scale to nearest supported value


    videoBitrate = floorToClosest(videoBitrate, videoBitrates);
    audioBitrate = floorToClosest(audioBitrate, audioBitrates); // Recommend between 75% and 150% of the stated transcode limit for the given
    // resolution/framerate

    var minVideoBitrate = 0.75 * bitrateLimits.video.max;
    var maxVideoBitrate = 1.5 * bitrateLimits.video.max;
    return {
      videoBitrate: videoBitrate,
      audioBitrate: audioBitrate,
      minVideoBitrate: minVideoBitrate,
      maxVideoBitrate: maxVideoBitrate
    };
  };

  function floorToClosest(val, vals) {
    for (var i = 0; i < vals.length; i++) {
      if (vals[i] > val) {
        return vals[Math.max(0, i - 1)];
      }
    }

    return vals[vals.length - 1];
  }
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export globalState */
/* unused harmony export Capabilities */
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var module = angular.module('capabilities', []); // Keep this around for lifetime of window/application, regardless of
// angular service lifecycle.  Only export for testing purposes.

var globalState = {
  account: null,
  reseller: null,
  capabilities: null,
  user: null
};
function Capabilities(Account, AccountReseller, User, UserCapabilities, $q) {
  'ngInject'; // Wrap the loading in a basic promise API

  var _this = this;

  var promise;

  this.verifyResolved = function () {
    return promise;
  };

  this.then = function () {
    var _promise;

    (_promise = promise).then.apply(_promise, arguments);
  }; // Expose helper methods


  this.canUserVisitState = function (state) {
    if (_this.account.authorized()) {
      switch (state.name) {
        case 'channels':
          return _this.user.can('update', 'channel/*');

        case 'settings.boxcasters':
        case 'settings.edit_boxcaster':
        case 'sources':
          return _this.user.can('update', 'boxcaster/*');

        case 'settings.payment':
          return _this.user.can('list', 'orders');

        case 'settings.api_keys':
          return _this.user.can('create', 'api-key');

        case 'settings.integrations':
          return _this.user.can('list', 'facebook-users') || _this.user.can('list', 'twitter-users') || _this.user.can('list', 'vimeo-users') || _this.user.can('list', 'youtube-users') || _this.user.can('list', 'rtmp-push-channels') || _this.user.can('read', 'sportzcast-configuration');

        case 'settings.storage':
          return _this.user.can('update', 'billing') && _this.user.can('list', 'storage-bills') && (_this.account.storage_policy == 'auto-bill' || account.storage_policy == 'auto-delete') && !_this.account.feature_flags.no_viewers;

        case 'embed':
          return _this.user.can('embed', 'broadcast/*');

        case 'reports.viewer':
          return _this.user.can('read', 'viewer-analytics/*');

        case 'reports.tickets':
          return _this.user.can('read', 'viewer-analytics/*') && _this.user.can('read', 'broadcast/*:tickets:summary') && _this.user.can('read', 'channel/*:tickets:summary') && _this.user.can('read', 'tickets:summary');

        case 'reports.donations':
          return _this.user.can('read', 'viewer-analytics/*') && _this.user.can('read', 'donations:summary');

        case 'new-event':
          return _this.user.can('create', 'broadcast');

        case 'uploads':
          return _this.user.can('create', 'upload');

        case 'extended-test':
          return _this.account.is_manufacturer;

        default:
          return true;
      }
    } else {
      switch (state.name) {
        case 'home':
        case 'logout':
        case 'settings.payment':
        case 'settings.upgrade':
        case 'checkout':
          return true;

        default:
          return false;
      }
    }
  };

  var init = function init(account, reseller, user, capabilities) {
    // Turn the list of capabilities into a hash keyed by resource
    var capsByResource = {};
    capabilities.forEach(function (cap) {
      var actions = capsByResource[cap.resource] || [];
      actions.push.apply(actions, _toConsumableArray(cap.actions));
      capsByResource[cap.resource] = actions;
    }); // Configure the user with the list of capabilities. This lets its `can` and `cannot` methods work.

    user.configureCapabilities(capsByResource);
  }; // Initialize with the account, capabilities, and user. Note that other services will ask for the
  // account and user, and use the capabilities via the user object.


  if (!globalState.account || !globalState.reseller || !globalState.user || !globalState.capabilities) {
    this.account = Account.get(function () {
      globalState.account = _this.account;
    });
    this.reseller = AccountReseller.get();
    this.user = User.get(function () {
      globalState.user = _this.user;
    });
    var capabilities = UserCapabilities.get();
    promise = $q.all([this.account.$promise, this.reseller.$promise, this.user.$promise, capabilities.$promise]).then(function () {
      return init(_this.account, _this.reseller, _this.user, capabilities);
    });
  } else {
    this.account = globalState.account;
    this.reseller = globalState.reseller;
    this.user = globalState.user;
    var _capabilities = globalState.capabilities;
    promise = $q.all([this.account.$promise, this.reseller.$promise, this.user.$promise, _capabilities.$promise]);
    init(this.account, this.reseller, this.user, _capabilities);
  }
}
module.service('Capabilities', Capabilities);
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CheckoutService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_stripe__ = __webpack_require__(30);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }


var module = angular.module('app.services.checkout', []);
var CheckoutService = /*#__PURE__*/function () {
  function CheckoutService($window, $timeout, $q, $http, Account) {
    'ngInject'; // Various SKU constants

    _classCallCheck(this, CheckoutService);

    this.BOXCASTER_SKU = 'BXC-HDSD2';
    this.BOXCASTER_PRO_SKU = 'BXC-PRO-2995';
    this.RETURN_LABEL_SKU = 'shipping-return-label';
    this.SHURE_KIT_SKU = 'BXC-AUDIO-IOS';
    this.SHURE_COUPON_SKU = 'coupon:one-time:promotion-bxc-audio-ios:28800'; // PD Template IDs

    this.PANDADOC_TEMPLATE_FREE_TRIAL = 'WAbYt2SgSbviDpwSfzdJpe';
    this.PANDADOC_TEMPLATE_FREE_TRIAL_WITH_PROMO = 'YE6QEWNPK3UvsZABvyTQkJ';
    this.$window = $window;
    this.$timeout = $timeout;
    this.$q = $q;
    this.$http = $http;
    this.Account = Account;
  }

  _createClass(CheckoutService, [{
    key: "registerPandadocWatcher",
    value: function registerPandadocWatcher($scope, handler) {
      var $window = this.$window;

      var onMessage = function onMessage(evt) {
        if (evt && evt.data) {
          try {
            var message = JSON.parse(evt.data);

            if (message && message.event) {
              onHandlePandadocMessage(message.event, message.data);
            }
          } catch (e) {
            console.warn(e);
          }
        }
      };

      var onHandlePandadocMessage = function onHandlePandadocMessage(event, data) {
        $scope.$evalAsync(function () {
          handler && handler(event, data);
        });
      };

      $window.addEventListener('message', onMessage, false);
      $scope.$on('$destroy', function () {
        $window.removeEventListener('message', onMessage);
      });
    }
  }, {
    key: "openPlaidLink",
    value: function openPlaidLink() {
      var _this = this;

      var deferred = this.$q.defer();
      Plaid.create({
        env: PLAID_ENV,
        key: PLAID_KEY,
        apiVersion: 'v2',
        clientName: 'BoxCast',
        product: ['auth'],
        selectAccount: true,
        onSuccess: function onSuccess(public_token, metadata) {
          _this.$http.post("".concat(INTEGRATIONS_ROOT, "/plaid/exchange_token"), {
            public_token: public_token,
            plaid_account_id: metadata.account_id
          }).then(function (response) {
            deferred.resolve({
              metadata: metadata,
              tokenResponse: response
            });
          })["catch"](function (err) {
            deferred.reject(err);
          });
        }
      }).open();
      return deferred.promise;
    }
  }, {
    key: "submitCard",
    value: function submitCard(stripeCard) {
      var _this2 = this;

      var deferred = this.$q.defer();
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["b" /* getToken */])(stripeCard).then(function (token) {
        _this2.$timeout(function () {
          deferred.resolve(token);
        });
      })["catch"](function (err) {
        _this2.$timeout(function () {
          deferred.reject(err);
        });
      });
      return deferred.promise;
    }
  }, {
    key: "getLocations",
    value: function getLocations() {
      var _this3 = this;

      var deferred = this.$q.defer();
      var promises = [];
      this.states = [];
      this.countries = [];
      promises.push(this.$http.get('/img/states.json').then(function (response) {
        _this3.states = response.data;
      }));
      promises.push(this.$http.get('/img/countries.json').then(function (response) {
        _this3.countries = response.data;
      }));
      this.$q.all(promises).then(function () {
        deferred.resolve({
          states: _this3.states,
          countries: _this3.countries
        });
      });
      return deferred.promise;
    }
  }, {
    key: "getBilling",
    value: function getBilling() {
      var deferred = this.$q.defer();
      this.Account.getBilling().$promise.then(function (data) {
        deferred.resolve(Object(__WEBPACK_IMPORTED_MODULE_0__utils_stripe__["d" /* parseBilling */])(data || {}));
      })["catch"](function (err) {
        if (err.status == 404) {
          // No linked Stripe customer
          deferred.resolve({}, null, null);
        } else {
          deferred.reject(err);
        }
      });
      return deferred.promise;
    }
  }, {
    key: "isPurchasingSubscription",
    value: function isPurchasingSubscription(proposal) {
      return proposal.products.subscription_items.length > 0;
    }
  }, {
    key: "validateBillingAddress",
    value: function validateBillingAddress(billing) {
      if (!billing) return false;
      return !!billing.address && !!billing.city && !!billing.state && !!billing.country && !!billing.postal_code;
    }
  }, {
    key: "validateShippingAddress",
    value: function validateShippingAddress(shipping) {
      return !!shipping.address && !!shipping.city && !!shipping.state && !!shipping.country && !!shipping.postal_code;
    }
  }, {
    key: "isDocumentSelfServiceGenerated",
    value: function isDocumentSelfServiceGenerated(currentUpgrade) {
      var pdMetadata = ((currentUpgrade.proposal || {}).document || {}).metadata || {};
      return isTruthy(pdMetadata.SelfService);
    }
  }, {
    key: "stripeBasePlanNameShortFromBillingResult",
    value: function stripeBasePlanNameShortFromBillingResult(billingResult) {
      var name = '';

      if (!billingResult.subscriptions || !billingResult.subscriptions.data) {
        return name;
      }

      billingResult.subscriptions.data.forEach(function (sub) {
        sub.items.data.forEach(function (subItem) {
          if (subItem.plan.metadata.is_addon == 'false') {
            var planNameContains = function planNameContains(str) {
              if (subItem.plan.id.toLowerCase().indexOf(str) >= 0) {
                return true;
              }

              if (((subItem.plan.metadata || {}).display_name || '').toLowerCase().indexOf(str) >= 0) {
                return true;
              }

              return false;
            };

            if (planNameContains('experience')) {
              name = 'Experience Plan';
            } else if (planNameContains('growth')) {
              name = 'Growth Plan';
            } else if (planNameContains('essential')) {
              name = 'Essential Plan';
            }
          }
        });
      });
      return name;
    }
  }, {
    key: "stripeBasePlanAmountFromBillingResult",
    value: function stripeBasePlanAmountFromBillingResult(billingResult) {
      var amount = 0;

      if (!billingResult.subscriptions || !billingResult.subscriptions.data) {
        return name;
      }

      billingResult.subscriptions.data.forEach(function (sub) {
        sub.items.data.forEach(function (subItem) {
          if (subItem.plan.metadata.is_addon == 'false') {
            amount = subItem.plan.amount / 100;
          }
        });
      });
      return amount;
    }
  }, {
    key: "stripeBasePlanLookupKeyFromBillingResult",
    value: function stripeBasePlanLookupKeyFromBillingResult(billingResult) {
      var lookupkey = '';
      billingResult.subscriptions.data.forEach(function (sub) {
        sub.items.data.forEach(function (subItem) {
          if (subItem.plan.metadata.is_addon == 'false') {
            lookupkey = subItem.price.lookup_key;
          }
        });
      });
      return lookupkey;
    }
  }, {
    key: "stripePlanIDs",
    value: function stripePlanIDs(basePlan, interval, selectedAddOns) {
      var IDs = [];

      if (interval == 'annual') {
        IDs.push("".concat(basePlan, ":").concat(interval));
      } else if (basePlan == 'essential') {
        IDs.push('essential:monthly:9900');
      } else if (basePlan == 'growth') {
        IDs.push('growth:monthly:14900');
      } else if (basePlan == 'experience') {
        IDs.push('experience:monthly:19900');
      }

      IDs.push.apply(IDs, _toConsumableArray(selectedAddOns || []));
      return IDs;
    }
  }, {
    key: "stripeSKUs",
    value: function stripeSKUs(encoder, oneTimeCharges) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var res = [];
      res.push.apply(res, _toConsumableArray(oneTimeCharges || []));

      if (encoder == 'boxcaster') {
        res.push(this.BOXCASTER_SKU);
      } else if (encoder == 'pro') {
        res.push(this.BOXCASTER_PRO_SKU);
      }

      if (options.shure_promo) {
        res.push(this.SHURE_KIT_SKU);
        res.push(this.SHURE_COUPON_SKU);
      }

      return res;
    }
  }, {
    key: "paymentMethodFromAccount",
    value: function paymentMethodFromAccount(account) {
      return _.find(['po', 'check', 'cc', 'ach'], function (m) {
        return account.payment_method == m;
      }) || 'cc';
    }
  }, {
    key: "currentInterval",
    value: function currentInterval(billing) {
      var subData = (billing.subscriptions || {}).data || [];
      var interval = '';

      if (subData.length > 0 && (subData[0].items.data || []).length > 0) {
        interval = subData[0].items.data[0].plan.interval;
      }

      return interval;
    }
  }]);

  return CheckoutService;
}();

function isTruthy(metadataValue) {
  return metadataValue === true || metadataValue === 'true';
}

module.service('Checkout', CheckoutService);
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var module = angular.module('confirm-dialog', []);
module.service('ConfirmDialog', function ($uibModal) {
  'ngInject';

  var modalDefaults = {
    backdrop: true,
    keyboard: true,
    modalFade: true,
    template: "\n      <div class=\"modal-header\">\n        <h3 class=\"modal-title\">{{modalOptions.headerText}}</h3>\n      </div>\n      <div class=\"modal-body\">\n        <p>{{modalOptions.bodyText}}</p>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-{{modalOptions.closeButtonClass}}\" data-ng-click=\"modalOptions.close()\">{{modalOptions.closeButtonText}}</button>\n        <button class=\"btn btn-{{modalOptions.actionButtonClass}}\" data-ng-click=\"modalOptions.ok();\">{{modalOptions.actionButtonText}}</button>\n      </div>\n    "
  };
  var modalOptions = {
    closeButtonText: 'Close',
    closeButtonClass: 'default',
    actionButtonText: 'OK',
    actionButtonClass: 'primary',
    headerText: 'Proceed?',
    bodyText: 'Perform this action?'
  };

  this.showModal = function (customModalOptions, customModalDefaults) {
    if (!customModalDefaults) customModalDefaults = {};
    customModalDefaults.backdrop = 'static';
    return this.show(customModalDefaults, customModalOptions);
  };

  this.show = function (customModalOptions, customModalDefaults) {
    //Create temp objects to work with since we're in a singleton service
    var tempModalDefaults = {};
    var tempModalOptions = {}; //Map angular-ui modal custom defaults to modal defaults defined in service

    angular.extend(tempModalDefaults, modalDefaults, customModalDefaults); //Map modal.html $scope custom properties to defaults defined in service

    angular.extend(tempModalOptions, modalOptions, customModalOptions);

    if (!tempModalDefaults.controller) {
      tempModalDefaults.controller = function ($scope, $uibModalInstance) {
        'ngInject';

        $scope.modalOptions = tempModalOptions;

        $scope.modalOptions.ok = function (result) {
          $uibModalInstance.close(result);
        };

        $scope.modalOptions.close = function (result) {
          $uibModalInstance.dismiss('cancel');
        };
      };
    }

    return $uibModal.open(tempModalDefaults).result;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EditOrCreateEventService */
/* unused harmony export _EditOrCreateEventServiceImpl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_content_settings__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_pricing__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_date__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_password__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_rtmp__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_timezone__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_scoreboard__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_video_and_audio_config__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_boxcast_flow_control__ = __webpack_require__(226);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }










var module = angular.module('edit-or-create-event-service', []); // Emulate factory pattern

var EditOrCreateEventService = /*#__PURE__*/function () {
  function EditOrCreateEventService($q, BoxCaster, Broadcast, Recording, Account, Channel, BroadcastTags, $rootScope, YouTubeUser, StaticRTMP, Facebook, TwitterUser, RTMPPushChannel, toaster, $window, $uibModal, $sce) {
    'ngInject';

    _classCallCheck(this, EditOrCreateEventService);

    this.$q = $q;
    this.Broadcast = Broadcast;
    this.Recording = Recording;
    this.BoxCaster = BoxCaster;
    this.Account = Account;
    this.Channel = Channel;
    this.BroadcastTags = BroadcastTags;
    this.$rootScope = $rootScope;
    this.YouTubeUser = YouTubeUser;
    this.StaticRTMP = StaticRTMP;
    this.Facebook = Facebook;
    this.TwitterUser = TwitterUser;
    this.RTMPPushChannel = RTMPPushChannel;
    this.toaster = toaster;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.$sce = $sce;
  }

  _createClass(EditOrCreateEventService, [{
    key: "getInstance",
    value: function getInstance() {
      return new _EditOrCreateEventServiceImpl(this.$q, this.BoxCaster, this.Broadcast, this.Recording, this.Account, this.Channel, this.BroadcastTags, this.$rootScope, this.YouTubeUser, this.StaticRTMP, this.Facebook, this.TwitterUser, this.RTMPPushChannel, this.toaster, this.$window, this.$uibModal, this.$sce);
    }
  }, {
    key: "activateBroadcast",
    value: function activateBroadcast(broadcast) {
      // XXX: activating a broadcast means resetting the start/end date.
      // If we're in pre-roll, keep the same end date, but if you're trying to activate
      // something much further out, keep the exact same duration.
      var stops_at = broadcast.stops_at;

      if (broadcast.timeframe == 'future') {
        var duration = moment(broadcast.stops_at) - moment(broadcast.starts_at);
        stops_at = moment().add(duration).toDate().toISOString();
      }

      return this.Broadcast.update({
        id: broadcast.id
      }, {
        stream_source: 'switcher',
        starts_at: 'now',
        stops_at: stops_at
      }).$promise;
    }
  }, {
    key: "stopBroadcast",
    value: function stopBroadcast(broadcast) {
      return this.Broadcast.update({
        id: broadcast.id
      }, {
        stops_at: 'now'
      }).$promise;
    }
  }]);

  return EditOrCreateEventService;
}();
var _EditOrCreateEventServiceImpl = /*#__PURE__*/function () {
  function _EditOrCreateEventServiceImpl($q, BoxCaster, Broadcast, Recording, Account, Channel, BroadcastTags, $rootScope, YouTubeUser, StaticRTMP, Facebook, TwitterUser, RTMPPushChannel, toaster, $window, $uibModal, $sce) {
    'ngInject';

    _classCallCheck(this, _EditOrCreateEventServiceImpl);

    this.$q = $q;
    this.Broadcast = Broadcast;
    this.Recording = Recording;
    this.ApiConfig = $rootScope.ApiConfig;
    this.account = $rootScope.account;
    this.user = $rootScope.user;
    this.FeatureFlags = this.account.feature_flags;
    this.BoxCaster = BoxCaster;
    this.Account = Account;
    this.Channel = Channel;
    this.BroadcastTags = BroadcastTags;
    this.YouTubeUser = YouTubeUser;
    this.StaticRTMP = StaticRTMP;
    this.fb = Facebook;
    this.TwitterUser = TwitterUser;
    this.RTMPPushChannel = RTMPPushChannel;
    this.toaster = toaster;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.limits = $rootScope.ApiConfig.modelFieldLimits('broadcast', 'maximum');
    this.genericRTMPPushLimits = $rootScope.ApiConfig.modelFieldLimits('generic_rtmp_push', 'maximum');
    this.canDelete = $rootScope.user.can('delete', 'broadcast/*');
    this.enhancedBoxCastFlowControlTooltip = $sce.trustAsHtml(__WEBPACK_IMPORTED_MODULE_8__utils_boxcast_flow_control__["a" /* EnhancedBoxCastFlowControlTooltipHTML */]);
    this.maximumBoxCastFlowControlTooltip = $sce.trustAsHtml(__WEBPACK_IMPORTED_MODULE_8__utils_boxcast_flow_control__["b" /* MaximumBoxCastFlowControlTooltipHTML */]);
    this.selectedBoxCaster = null;
    this.scrambleChannelId = true; //... but only if the scramble option is shown

    this.bulkImportMode = false;
    this.initConfig();
    this.initRelatedData();
  }

  _createClass(_EditOrCreateEventServiceImpl, [{
    key: "initScope",
    value: function initScope($scope) {
      var _this = this;

      var ApiConfig = this.ApiConfig,
          BoxCaster = this.BoxCaster;
      this.$scope = $scope;
      $scope.$watchCollection(function () {
        return [_this.startDate, _this.startTime, _this.endTime];
      }, function () {
        return _this.compensateEndDate();
      });
      $scope.$watch(function () {
        return _this.boxCasterIdSafe;
      }, function (id) {
        _this.selectedBoxCaster = _.findWhere(_this.boxcasters, {
          id: id
        });

        _this.initAdvancedSettingsBySource();

        if (id && !id.startsWith('stream_source:')) {
          _this.boxcaster = BoxCaster.get({
            id: id
          }, function () {
            return _this.initAdvancedSettingsBySource();
          });
        } else {
          _this.boxcaster = null;
        }
      });
      $scope.$watchCollection(function () {
        return [_this.startTime, _this.sourceBroadcast];
      }, function () {
        var durationSeconds = (_this.sourceBroadcast || {}).recording_duration_seconds;

        if (!durationSeconds) {
          _this.simulatedLiveEndTime = null;
          return;
        }

        _this.simulatedLiveEndTime = moment(_this.startTime).add(durationSeconds, 'seconds').toDate();
      });
      $scope.$watch(function () {
        return _this.boxCasterIdSafe;
      }, function (newValue, oldValue) {
        if (oldValue == 'stream_source:recording' && newValue != 'stream_source:recording') {
          // If switching from simulated live, initialize advanced settings to sane defaults
          _this.broadcast.do_not_record = _this.doNotRecordDefault;
          _this.broadcast.requests_captioning = _this.requestsCaptioningDefault;
        } else if (newValue == 'stream_source:recording' && oldValue != 'stream_source:recording') {
          // If switching to simulated live, initialize advanced settings.
          if (oldValue || !_this.broadcast.id) {
            // If switching TO simulated live either from some other non-empty value (like an
            // actual BoxCaster) OR this is a new broadcast, set live-only from accout default.
            // The $watch can and will fire when the broadcast loads as well, so we have to be extra
            // careful we don't touch this unless it was something before (i.e. this is not the
            // initial load) or it's a new broadcast (there's no ID yet), where it makes sense to
            // be toggling values at startup.
            _this.broadcast.do_not_record = !_this.account.default_record_simulated_live;
          }

          _this.broadcast.requests_captioning = false;
        } else if (oldValue == 'stream_source:app' && newValue != 'stream_source:app') {
          // Switching from Broadcaster app to something else
          if (_this.broadcast && _this.broadcast.target_buffer_latency == 'standard') {
            // If the user had selected standard latency, put it back to 'default'
            _this.broadcast.target_buffer_latency = 'default';
          }
        }
      });
    }
  }, {
    key: "initConfig",
    value: function initConfig() {
      var account = this.account,
          ApiConfig = this.ApiConfig,
          FeatureFlags = this.FeatureFlags; // Get account feature flags

      this.showAutomatedScoreboard = FeatureFlags.automated_scoreboard;
      this.showSportzcast = FeatureFlags.sportzcast;
      this.showManualScoreboard = FeatureFlags.manual_scoreboard;
      this.showAnyScoreboards = this.showAutomatedScoreboard || this.showSportzcast || this.showManualScoreboard;
      this.showFlex = FeatureFlags.flex;
      this.showPublic = !FeatureFlags.no_public;
      this.showTicketed = !FeatureFlags.no_ticketed;
      this.showFeatured = account.extra_features.featured_broadcasts;
      this.showSportzCast = FeatureFlags.sportzcast;
      this.allowBroadcasterApp = account.usage_flags.broadcaster_app && !FeatureFlags.broadcaster_app_source_disabled;
      this.allowRtmp = FeatureFlags.rtmp;
      this.allowSwitcher = account.usage_flags.switcher;
      this.allowFacebookLive = FeatureFlags.facebook_live;
      this.allowYoutubeLive = FeatureFlags.youtube_live;
      this.allowGenericRtmpPush = FeatureFlags.generic_rtmp_push;
      this.allowTwitter = FeatureFlags.twitter;
      this.allowSimulatedLive = FeatureFlags.simulated_live;
      this.allowDefaultOverlay = true;
      this.resolutionLimit = account.resolution_limit;
      this.allowHighFrameRate = FeatureFlags.high_frame_rate;
      this.maxBroadcastDurationHours = account.max_broadcast_duration_hrs;
      this.simulcastOnly = FeatureFlags.no_viewers;
      this.simulcastLimit = FeatureFlags.single_destination ? 1 : 999;
      this.allowProducer = FeatureFlags.producer; // Grab shared config values

      this.sports = ApiConfig.stream.sports;
      this.scoreboards = ApiConfig.stream.scoreboards;
      this.dscpValues = ApiConfig.stream.dscp_values;
      this.minTicketPrice = ApiConfig.ticket.minimum_price;
      this.initAdvancedSettingsBySource();
    }
  }, {
    key: "initAdvancedSettingsBySource",
    value: function initAdvancedSettingsBySource() {
      var _this2 = this;

      var ApiConfig = this.ApiConfig;
      this.videoResolutions = _.filter(ApiConfig.stream.video_resolutions, function (b) {
        return b.value == 'default' || b.value <= _this2.resolutionLimit;
      });
      this.videoBitrates = __WEBPACK_IMPORTED_MODULE_7__utils_video_and_audio_config__["a" /* VideoAudioConfig */].stream.video_bitrates;
      this.audioBitrates = __WEBPACK_IMPORTED_MODULE_7__utils_video_and_audio_config__["a" /* VideoAudioConfig */].stream.audio_bitrates;
      this.audioSources = ApiConfig.stream.audio_sources;
      this.highFrameRates = ApiConfig.stream.high_frame_rates;
      this.bufferLatencies = ApiConfig.stream.buffer_latencies; // Restrict BoxCaster source capabilities based on capabilities (inferred by serial number prefix)

      if (this.isBoxCaster && this.boxCasterIdSafe) {
        var filter = function filter(b) {
          return _.contains(b.serial_prefixes, _this2.boxcasterPrefix);
        };

        this.videoResolutions = _.filter(this.videoResolutions, filter);
        this.videoBitrates = _.filter(this.videoBitrates, filter);
        this.audioBitrates = _.filter(this.audioBitrates, filter);
        this.audioSources = _.filter(this.audioSources, filter);
        this.highFrameRates = _.filter(this.highFrameRates, filter);
        this.bufferLatencies = _.filter(this.bufferLatencies, filter);

        if (this.isBoxCasterPro) {
          // BoxCaster Pro doesn't currently support audio-only.
          this.videoBitrates = _.filter(this.videoBitrates, function (b) {
            return b.value != AUDIO_ONLY_BITRATE_HINT;
          });
        }
      } // Prevent scoreboards and overlays for simulated live as well as producer broadcasts


      if (this.isSimulatedLive || this.isProducerBroadcast) {
        this.showAnyScoreboards = false;
        this.allowDefaultOverlay = false;
      } else {
        this.showAnyScoreboards = this.showAutomatedScoreboard || this.showSportzcast || this.showManualScoreboard;
        this.allowDefaultOverlay = true;
      } // Default RTMP sources to the account resolution and frame rate limit


      if (this.broadcast && this.broadcast.timeframe != 'past') {
        if (this.isRTMPBasedSource) {
          if (this.broadcast.target_video_resolution == 'default') {
            this.broadcast.target_video_resolution = this.resolutionLimit;
          }

          if (this.broadcast.target_high_frame_rate == 'default') {
            this.broadcast.target_high_frame_rate = this.allowHighFrameRate;
          }
        }
      } // Dynamic advanced settings labels


      var overridden = function overridden(field) {
        return _this2.boxcaster && _this2.boxcaster[field] && _this2.boxcaster[field] != 'default';
      };

      var sourceName = this.isBroadcasterApp ? 'Broadcaster App' : 'BoxCaster';

      var updateLabel = function updateLabel(field, settings) {
        var defaultVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Auto-detect';

        if (!settings || !settings.length) {
          return;
        } else if (_this2.isRTMPBasedSource) {
          settings[0].label = "Default";
        } else if (overridden(field)) {
          var label = (_.first(_.filter(settings, function (s) {
            return s.value == _this2.boxcaster[field];
          })) || {}).label;
          settings[0].label = "".concat(sourceName, " Default: ").concat(label);
        } else {
          settings[0].label = defaultVal;
        }
      };

      updateLabel('target_video_bitrate', this.videoBitrates);
      updateLabel('target_audio_bitrate', this.audioBitrates);
      updateLabel('audio_source', this.audioSources, 'All Sources');
      updateLabel('target_video_resolution', this.videoResolutions);
      updateLabel('target_high_frame_rate', this.highFrameRates);
      updateLabel('dscp_value', this.dscpValues, 'No DSCP');

      if (this.isBroadcasterApp) {
        // For Broadcaster, don't allow the "default" buffer latency (as there's no BoxCaster to "default" to)
        this.bufferLatencies = _.reject(this.bufferLatencies, function (v) {
          return v.value == 'default';
        });

        if (this.broadcast && this.broadcast.target_buffer_latency == 'default') {
          this.broadcast.target_buffer_latency = 'standard';
        }
      } else {
        updateLabel('target_buffer_latency', this.bufferLatencies, 'Standard');
      }
    }
  }, {
    key: "initRelatedData",
    value: function initRelatedData() {
      var _this3 = this;

      var BoxCaster = this.BoxCaster,
          Account = this.Account,
          Channel = this.Channel,
          BroadcastTags = this.BroadcastTags,
          FeatureFlags = this.FeatureFlags,
          YouTubeUser = this.YouTubeUser,
          StaticRTMP = this.StaticRTMP,
          TwitterUser = this.TwitterUser,
          RTMPPushChannel = this.RTMPPushChannel,
          $q = this.$q;
      this.boxcasters = BoxCaster.query({
        l: 1000,
        s: 'name'
      }, function () {
        _this3.selectedBoxCaster = _.findWhere(_this3.boxcasters, {
          id: _this3.boxCasterIdSafe
        });
      });

      if (FeatureFlags.no_viewers) {
        this.channels = [];
      } else {
        this.channels = Channel.query({
          l: 1000
        });
      }

      this.tags = BroadcastTags.query();
      this.accountScoreboard = Account.getScoreboard();

      if (this.showSportzcast) {
        this.sportzcast = Account.getSportzcast();
      } else {
        this.sportzcast = {};
      }

      var destinationPromsises = [];
      this.youtubeUsers = [];

      if (this.allowYoutubeLive) {
        destinationPromsises.push(YouTubeUser.query().$promise.then(function (users) {
          _this3.youtubeUsers = users.filter(function (user) {
            return user.scope && _.contains(user.scope, YOUTUBE_SCOPE);
          });
        }));
      }

      this.staticRTMPs = [];

      if (this.allowRtmp) {
        this.staticRTMPs = StaticRTMP.query({
          l: 1000,
          include_diagnostics: true
        });
        destinationPromsises.push(this.staticRTMPs.$promise);
      }

      this.twitterUsers = [];

      if (this.allowTwitter) {
        this.twitterUsers = TwitterUser.query();
        destinationPromsises.push(this.twitterUsers.$promise);
      }

      this.rtmpPushChannels = [];

      if (this.allowGenericRtmpPush) {
        this.rtmpPushChannels = RTMPPushChannel.query();
        destinationPromsises.push(this.rtmpPushChannels.$promise);
      }

      this.destinationPromise = $q.all(destinationPromsises);
      this.sourcesPromise = $q.all([this.boxcasters.$promise, this.staticRTMPs.$promise]).then(function () {
        _this3.sources = [];
        _this3.sources = _this3.sources.concat(_this3.boxcasters.map(function (b) {
          return angular.extend({
            type: "boxcaster".concat(b.id.startsWith('p') ? '_pro' : '')
          }, b);
        }));

        if (_this3.allowSwitcher) {
          _this3.sources = _this3.sources.concat({
            type: 'switcher',
            id: 'stream_source:switcher',
            name: 'Switcher Studio (iOS)'
          });
        }

        if (_this3.allowBroadcasterApp) {
          _this3.sources = _this3.sources.concat({
            type: 'broadcaster',
            id: 'stream_source:app',
            name: 'Broadcaster App'
          });
        }

        if (_this3.allowProducer) {
          _this3.sources = _this3.sources.concat({
            type: 'producer',
            id: 'stream_source:producer',
            name: 'Producer (Browser-based streaming)'
          });
        }

        if (_this3.allowRtmp) {
          _this3.sources = _this3.sources.concat(_this3.staticRTMPs.map(function (r) {
            return angular.extend({
              type: 'static_rtmp'
            }, r, {
              id: "stream_source:rtmp:".concat(r.id)
            });
          }));
        }

        var sourceIsEditable = (_this3.broadcast.timeframe || 'future') == 'future';

        if (_this3.allowSimulatedLive || !sourceIsEditable && !_this3.broadcast.source_broadcast_id) {
          _this3.sources = _this3.sources.concat({
            type: 'recording',
            id: 'stream_source:recording',
            name: 'Re-Broadcast (Simulated Live)'
          });
        }
      });
    }
  }, {
    key: "initBroadcast",
    value: function initBroadcast(id, clone) {
      var _this4 = this;

      var ApiConfig = this.ApiConfig,
          Broadcast = this.Broadcast,
          FeatureFlags = this.FeatureFlags,
          $q = this.$q;

      if (id) {
        // Edit broadcast mode...
        this.broadcast = Broadcast.get({
          id: id,
          include_recurrence: true
        }, function () {
          _this4.minDate = new Date();

          if (clone) {
            _this4.broadcast.id = null;

            var _getDatesForClonedBro = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["d" /* getDatesForClonedBroadcast */])(_this4.broadcast, moment()),
                starts_at = _getDatesForClonedBro.starts_at,
                stops_at = _getDatesForClonedBro.stops_at;

            _this4.broadcast.starts_at = starts_at;
            _this4.broadcast.stops_at = stops_at;
            delete _this4.broadcast.id;
            delete _this4.broadcast.timeframe;
            delete _this4.broadcast.channel_id;
            delete _this4.broadcast.recurrence;
          }

          if (_this4.broadcast.recurrence && _this4.broadcast.recurrence.id) {
            // Un-replace date tokens for the purpose of editing (only for broadcasts that are part of a recurrence)
            _this4.broadcast.name = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["g" /* unreplaceDateTokens */])(_this4.broadcast.name || '', _this4.broadcast.starts_at);
            _this4.broadcast.description = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["g" /* unreplaceDateTokens */])(_this4.broadcast.description || '', _this4.broadcast.starts_at); // Make sure time zone attribute is set for any date changes

            _this4.broadcast.recurrence.time_zone = Object(__WEBPACK_IMPORTED_MODULE_5__utils_timezone__["a" /* FindTimeZone */])();
          }

          _this4.startDate = moment(_this4.broadcast.starts_at).toDate();
          _this4.startTime = moment(_this4.broadcast.starts_at).toDate(); // XXX: compensate for old indefinite broadcasts ... we don't suppport that anymore

          if (!_this4.broadcast.stops_at || _this4.broadcast.stops_at.startsWith('9999-12-31')) {
            _this4.endTime = moment(_this4.startTime).add(_this4.maxBroadcastDurationHours, 'hours').subtract(1, 'minute');
          } else {
            _this4.endTime = moment(_this4.broadcast.stops_at).toDate(); // XXX: API stops_at is a derived field; it only really stores starts_at and duration in minutes
            // so we need to work around an off-by-one error when there are non-zero seconds in the starts_at

            if (moment(_this4.endTime).seconds() > 0) {
              _this4.endTime = moment(_this4.endTime).add(1, 'minute').toDate();
            } // XXX: Broadcaster for iOS uses 24:00:00 hours for duration rather than 23:59:59, which
            // causes some issues with other assumptions throughout the app. Correct for that minute here.


            if (moment(_this4.startTime).add(1, 'days').format('YYYY-MM-DD HH:mm') == moment(_this4.endTime).format('YYYY-MM-DD HH:mm')) {
              _this4.endTime = moment(_this4.endTime).subtract(1, 'minute').toDate();
            }
          }

          if (_this4.broadcast.stream_source == 'imported') {
            _this4.datepickerOptions = {
              maxDate: _this4.minDate,
              showWeeks: false
            };
          } else {
            _this4.datepickerOptions = {
              minDate: _this4.minDate,
              showWeeks: false
            };
          }

          _this4.visibility = Object(__WEBPACK_IMPORTED_MODULE_1__utils_pricing__["a" /* inferVisiblityOptionFromPriceSettings */])(_this4.broadcast);
          _this4.origVisibility = _this4.visibility;
          _this4.isFeatured = _.contains(_this4.broadcast.tags, 'featured');

          if (!_this4.broadcast.ticket_price) {
            _this4.broadcast.ticket_price = _this4.account.ticket_price || ApiConfig.ticket.default_price;
          }

          if (_this4.broadcast.stream_source && _this4.broadcast.stream_source != 'boxcaster') {
            if (_this4.broadcast.stream_source == 'rtmp' && _this4.broadcast.static_rtmp_id) {
              _this4.broadcast.boxcaster_id = "stream_source:rtmp:".concat(_this4.broadcast.static_rtmp_id);
            } else {
              // If this is static RTMP, add that to the sources list.
              if (_this4.broadcast.stream_source === 'rtmp') {
                // XXX: Ideally, this would be in the middle of the list next to the other RTMP stream sources, but
                // that logic is really complicated. Since this is meant to be "edit only" (and no one should be
                // configuring new broadcasts with single-use RTMP), we're just going to stick it at the end.
                _this4.sourcesPromise.then(function () {
                  _this4.sources = _this4.sources.concat({
                    type: 'rtmp',
                    id: 'stream_source:rtmp',
                    name: 'Single-Use RTMP'
                  });
                });
              }

              _this4.broadcast.boxcaster_id = "stream_source:".concat(_this4.broadcast.stream_source);
            }
          } // If the previously-selected video bitrate option is "Audio Only", then the user
          // cannot change the bitrate, so we'll use this to disable the select control.


          _this4.disableVideoBitrate = _this4.broadcast.timeframe == 'past' || _this4.broadcast.timeframe == 'current' && _this4.isAudioOnly;
          _this4.disableAudioOnlyOption = _this4.broadcast.timeframe == 'current' && !_this4.isAudioOnly; // Once user selects an actual video bitrate, they can't go back to "default",
          // which really means "auto-detect" (too late)

          _this4.disableDefaultVideoBitrateOption = _this4.broadcast.timeframe == 'current' && _this4.broadcast.target_video_bitrate != 'default'; // integer to string values for max_resolution

          _this4.broadcast.simulcast_configurations.filter(function (s) {
            return s.destination === 'generic';
          }).forEach(function (s) {
            return s.max_resolution = s.max_resolution.toString();
          }); // Glue `max_resolution` onto each rtmp_push_channel in case the user edits them


          _this4.broadcast.simulcast_configurations.filter(function (s) {
            return s.destination === 'rtmp_push_channel';
          }).forEach(function (s) {
            if (!s.max_resolution) {
              s.max_resolution = '0';
            }
          }); // Separate out feed type and ID for facebook


          _this4.broadcast.simulcast_configurations.filter(function (s) {
            return s.destination === 'facebook';
          }).forEach(function (s) {
            if (s.fb_feed_id === 'user:me') {
              s.feed_type = 'user:me';
            } else {
              s.feed_type = s.fb_feed_id.split(':', 1)[0];
              s.feed_id = s.fb_feed_id.replace(/^[^:]*:/, '');
            }
          });

          _this4.otherEvents = [];
          _this4.conflictingEvents = [];
          _this4.worstCaseSimultaneousStreams = 0;

          _this4.getConflictingEvents(true);

          _this4.broadcast.content_settings = _this4.broadcast.content_settings || {};
          Object(__WEBPACK_IMPORTED_MODULE_6__utils_scoreboard__["e" /* restoreScoreboardUIConfiguration */])(_this4.broadcast.scoreboard_configuration);

          if (_this4.broadcast.source_broadcast_id) {
            _this4.fromBroadcast(_this4.broadcast.source_broadcast_id, clone);
          }
        }, function (error) {});
        this.broadcast.$promise.then(function () {
          return _this4.updateScoreboardMakes();
        });
      } else {
        var _this$broadcast;

        // Create new broadcast mode (no ID specified)...
        this.broadcast = (_this$broadcast = {
          name: null,
          description: null,
          boxcaster_id: null,
          stream_source: 'boxcaster',
          do_not_record: this.doNotRecordDefault,
          sport: null,
          target_high_frame_rate: 'default',
          target_video_bitrate: 'default',
          target_audio_bitrate: 'default',
          transcoder_profile: 'default',
          dscp_value: 'default',
          audio_source: 'default',
          target_video_resolution: 'default',
          target_codec: 'default',
          ticket_price: null,
          free_variant: null,
          in_channel_ids: [],
          simulcast_configurations: [],
          content_settings: {}
        }, _defineProperty(_this$broadcast, "ticket_price", this.account.ticket_price || ApiConfig.ticket.default_price), _defineProperty(_this$broadcast, "scoreboard_configuration", {
          overlay_location: 'bottom'
        }), _defineProperty(_this$broadcast, "metadata", {}), _defineProperty(_this$broadcast, "requests_captioning", this.requestsCaptioningDefault), _defineProperty(_this$broadcast, "target_buffer_latency", 'default'), _this$broadcast);
        this.isFeatured = false;
        this.accountScoreboard.$promise.then(function () {
          _this4.broadcast.scoreboard_configuration.home_team_name = _this4.accountScoreboard.home_team_name;
          _this4.broadcast.scoreboard_configuration.home_team_logo = _this4.accountScoreboard.home_team_logo;
        });
        var now = moment().set({
          second: 0,
          millisecond: 0
        });
        this.startDate = now.clone().toDate();
        this.startTime = now.clone().toDate();
        this.originalStartTime = new Date(this.startTime.getTime());
        this.minDate = now.clone().toDate();
        this.endTime = now.clone().add(30, 'minutes').toDate();
        this.originalEndTime = new Date(this.endTime.getTime());
        this.visibility = this.showPublic ? 'public' : 'private';
        this.datepickerOptions = {
          minDate: this.minDate,
          showWeeks: false
        };
        this.otherEvents = [];
        this.conflictingEvents = [];
        this.worstCaseSimultaneousStreams = 0;
        this.getConflictingEvents(true);
      }
    }
  }, {
    key: "fromBroadcast",
    value: function fromBroadcast(broadcastId) {
      var _this5 = this;

      var clone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var account = this.account,
          broadcast = this.broadcast,
          Broadcast = this.Broadcast;
      broadcast.stream_source = 'recording';
      Broadcast.get({
        id: broadcastId
      }, function (b) {
        return _this5.updateSourceBroadcast(b);
      }, function (err) {
        if (err && (err.status == 404 || err.status == 410)) {
          // 404/410 means this source isn't available anymore
          if (clone) {
            // Cloning, so just clear out the source info and let them pick something else
            _this5.sourceBroadcast = null;
            broadcast.source_broadcast_id = null;
            _this5.datepickerOptions.minDate = _this5.minDate;
          } else {
            // Not cloning -- let them know the source broadcast is not available anymore.
            _this5.sourceBroadcastUnavailable = true;
            _this5.sourceBroadcastProblem = 'is unavailable';
          }
        } else {
          console.error('Failed to get source broadcast', err);
        }
      });
    }
  }, {
    key: "updateSourceBroadcast",
    value: function updateSourceBroadcast(b) {
      var account = this.account,
          broadcast = this.broadcast;
      this.sourceBroadcast = b;
      broadcast.source_broadcast_id = b.id;
      this.datepickerOptions.minDate = new Date(Math.max(this.minDate.getTime(), moment(this.sourceBroadcast.stops_at).toDate().getTime()));

      if (account.storage_policy == 'auto-delete') {
        this.datepickerOptions.maxDate = moment(this.sourceBroadcast.storage_expires_at).toDate();
      }

      if (b.timeframe == 'past' && b.recording_duration_seconds <= 0) {
        this.sourceBroadcastProblem = 'does not exist';
      } else if (this.recordingStorageExpires) {
        this.sourceBroadcastProblem = "will be purged before the broadcast's start time";
      }
    }
  }, {
    key: "showChannelSelector",
    get: function get() {
      // If account doesn't have channels defined, never show it.
      // If it's a private event, only show selector if they've got channels selected
      if (!this.channels || this.channels.length == 0) {
        return false;
      }

      var selectedChannels = this.broadcast.in_channel_ids || [];
      var hasChannelsSelected = selectedChannels.length > 0;
      return this.visibility != 'private' || hasChannelsSelected;
    }
  }, {
    key: "showScoreboardModel",
    get: function get() {
      return this.scoreboardModels && this.scoreboardModels.length > 1;
    }
  }, {
    key: "boxcasterPrefix",
    get: function get() {
      return this.boxCasterIdSafe[0];
    }
  }, {
    key: "boxCasterIdSafe",
    get: function get() {
      return (this.broadcast || {}).boxcaster_id || '';
    }
  }, {
    key: "hideOptionRecord",
    get: function get() {
      return this.FeatureFlags.no_recordings;
    }
  }, {
    key: "isAudioOnly",
    get: function get() {
      return !!((this.broadcast || {}).target_video_bitrate <= AUDIO_ONLY_BITRATE_HINT);
    }
  }, {
    key: "isBoxCaster",
    get: function get() {
      return !this.boxCasterIdSafe.startsWith('stream_source:');
    }
  }, {
    key: "isBoxCasterHDSD2",
    get: function get() {
      return (this.boxcasterPrefix || '').startsWith('o');
    }
  }, {
    key: "isBoxCasterPro",
    get: function get() {
      return (this.boxcasterPrefix || '').startsWith('p');
    }
  }, {
    key: "isBroadcasterApp",
    get: function get() {
      return this.boxCasterIdSafe.startsWith('stream_source:app');
    }
  }, {
    key: "isRTMPSelected",
    get: function get() {
      return this.boxCasterIdSafe.startsWith('stream_source:rtmp');
    }
  }, {
    key: "isSimulatedLive",
    get: function get() {
      return this.boxCasterIdSafe == 'stream_source:recording';
    }
  }, {
    key: "isSwitcher",
    get: function get() {
      return this.boxCasterIdSafe.startsWith('stream_source:switcher');
    }
  }, {
    key: "isProducerBroadcast",
    get: function get() {
      return this.boxCasterIdSafe.startsWith('stream_source:producer');
    }
  }, {
    key: "isRTMPBasedSource",
    get: function get() {
      return this.isRTMPSelected || this.isSwitcher;
    }
  }, {
    key: "hideOptionTargetAudioBitRate",
    get: function get() {
      return this.isRTMPBasedSource || this.isSimulatedLive || this.isProducerBroadcast;
    }
  }, {
    key: "hideHighFrameRate",
    get: function get() {
      return !this.allowHighFrameRate || this.isSwitcher || this.isSimulatedLive || this.isProducerBroadcast || !(this.isRTMPSelected || this.isBroadcasterApp || this.isBoxCasterPro);
    }
  }, {
    key: "hideOptionTargetVideoBitRate",
    get: function get() {
      return this.isRTMPBasedSource || this.isSimulatedLive || this.isProducerBroadcast;
    }
  }, {
    key: "hideOptionAudioSource",
    get: function get() {
      return this.isBroadcasterApp || this.isRTMPBasedSource || this.isSimulatedLive || this.isProducerBroadcast;
    }
  }, {
    key: "hideOptionVideoResolution",
    get: function get() {
      return this.isSimulatedLive || this.isProducerBroadcast;
    }
  }, {
    key: "hideOptionDSCPValue",
    get: function get() {
      return this.isBroadcasterApp || this.isRTMPBasedSource || this.isSimulatedLive || this.isProducerBroadcast;
    }
  }, {
    key: "showOptionTargetBufferLatency",
    get: function get() {
      // If they don't have the BoxCast Flow Control feature, don't show it
      if (this.account.feature_flags.boxcast_flow_control_disabled) {
        return false;
      } // Only show for BoxCaster HDSD2, Pro,  or Broadcaster app


      return this.isBoxCasterHDSD2 || this.isBoxCasterPro || this.isBroadcasterApp;
    }
  }, {
    key: "enterpriseLastMileDelivery",
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils_content_settings__["a" /* enterpriseLastMileDelivery */])(this.broadcast);
    }
  }, {
    key: "requestsCaptioningDefault",
    get: function get() {
      return (this.FeatureFlags.automated_captioning || this.FeatureFlags.live_automated_captioning) && this.account.content_settings.requestsCaptioning;
    }
  }, {
    key: "doNotRecordDefault",
    get: function get() {
      return !!this.FeatureFlags.no_recordings;
    }
  }, {
    key: "targetBufferLatencyTooltip",
    get: function get() {
      if (this.isBoxCasterPro || this.isBroadcasterApp) {
        return this.maximumBoxCastFlowControlTooltip;
      }

      return this.enhancedBoxCastFlowControlTooltip;
    }
  }, {
    key: "chooseDefaultSourceForNewBroadcast",
    value: function chooseDefaultSourceForNewBroadcast() {
      // Force a selection if user has multiple BoxCasters registered
      if (this.boxcasters.length > 1) {
        return;
      } // Choose one and only BoxCaster


      if (this.boxcasters.length == 1) {
        this.selectedBoxCaster = this.boxcasters[0];
        this.broadcast.boxcaster_id = this.selectedBoxCaster.id;
        return;
      } // Force a selection if user has multiple static RTMP channels defined


      if (this.staticRTMPs.length > 1) {
        return;
      } // Choose one and only static RTMP channel


      if (this.staticRTMPs.length == 1) {
        this.broadcast.boxcaster_id = "stream_source:rtmp:".concat(this.staticRTMPs[0].id);
        return;
      } // Otherwise, prefer Broadcaster > Switcher Studio


      if (this.allowBroadcasterApp) {
        this.broadcast.boxcaster_id = 'stream_source:app';
      } else if (this.allowSwitcher) {
        this.broadcast.boxcaster_id = 'stream_source:switcher';
      } else if (this.allowSimulatedLive) {
        this.broadcast.boxcaster_id = 'stream_source:recording';
      }
    }
  }, {
    key: "initializeEmptyFacebookAccountIDs",
    value: function initializeEmptyFacebookAccountIDs() {
      var _this6 = this;

      (this.broadcast.simulcast_configurations || []).forEach(function (sc) {
        if (sc.destination === 'facebook' && !sc.facebook_account_id) {
          sc.facebook_account_id = _this6.fb.facebook_account_id;
        }
      });
    }
  }, {
    key: "addSimulcastDestination",
    value: function addSimulcastDestination(destination, params) {
      this.broadcast.simulcast_configurations = this.broadcast.simulcast_configurations || [];
      params = params || {};
      var destConfig = {
        destination: destination,
        isHelpRow: params.isHelpRow
      };

      switch (destination) {
        case 'facebook':
          var id = params.id || this.fb.facebook_account_id;

          if (!id) {
            // only allow 1 "unlinked" account to show up in the UI
            var unlinkedFBConfigs = _.filter(this.broadcast.simulcast_configurations, function (sc) {
              return sc.destination == 'facebook' && !sc.facebook_account_id;
            });

            if (unlinkedFBConfigs.length > 0) {
              return;
            }
          }

          destConfig.facebook_account_id = id;
          destConfig.feed_type = 'user:me';
          destConfig.fb_privacy = 'EVERYONE';
          break;

        case 'youtube':
          destConfig.youtube_account_id = params.id || (this.youtubeUsers[0] || {}).id;
          destConfig.privacy = 'unlisted';
          break;

        case 'generic':
          destConfig.stream_url = '';
          destConfig.stream_key = '';
          destConfig.max_resolution = '0';
          break;

        case 'twitter':
          destConfig.twitter_account_id = params.id || (this.twitterUsers[0] || {}).id;
          destConfig.should_not_tweet = false;
          break;

        case 'rtmp_push_channel':
          destConfig.rtmp_push_channel_id = params.id || (this.rtmpPushChannels[0] || {}).id;
          destConfig.max_resolution = '0';
          break;

        default:
          return;
      }

      this.broadcast.simulcast_configurations.push(destConfig);
    }
  }, {
    key: "removeSimulcastDestination",
    value: function removeSimulcastDestination(obj) {
      _.remove(this.broadcast.simulcast_configurations, obj);
    }
  }, {
    key: "facebookFeedTypeChanged",
    value: function facebookFeedTypeChanged(config) {
      // For pages, events, and groups, only public visibility is permitted.
      switch (config.feed_type) {
        case 'page':
          config.feed_id = (this.fb.accounts[0] || {}).id || '';
          config.fb_privacy = 'EVERYONE';
          break;

        case 'group':
          config.feed_id = (this.fb.groups[0] || {}).id || '';
          config.fb_privacy = 'EVERYONE';
          break;

        case 'event':
          config.feed_id = (this.fb.events[0] || {}).id || '';
          config.fb_privacy = 'EVERYONE';
          break;
      }
    }
  }, {
    key: "addNewMultiUseChannel",
    value: function addNewMultiUseChannel(config) {
      var _$uibModal$open,
          _this7 = this;

      var $uibModal = this.$uibModal,
          RTMPPushChannel = this.RTMPPushChannel;
      $uibModal.open((_$uibModal$open = {
        controllerAs: 'vm',
        template: __webpack_require__(48),
        controller: __webpack_require__(49)["default"]
      }, _defineProperty(_$uibModal$open, "controllerAs", 'vm'), _defineProperty(_$uibModal$open, "resolve", {
        mode: function mode() {
          return 'add';
        },
        config: function config() {
          return {
            max_resolution: 0
          };
        }
      }), _$uibModal$open)).result.then(function (r) {
        _this7.rtmpPushChannels = RTMPPushChannel.query(function () {
          config.rtmp_push_channel_id = r.id;
        });
      });
    }
  }, {
    key: "uploadPreviewImage",
    value: function uploadPreviewImage(file) {
      var _this8 = this;

      file.upload().then(function (result) {
        _this8.broadcast.content_settings = _this8.broadcast.content_settings || {};
        _this8.broadcast.content_settings.preview = result.view_url;
        _this8.broadcast.content_settings.poster = result.view_url;
      });
    }
  }, {
    key: "uploadPodcastPreviewImage",
    value: function uploadPodcastPreviewImage(file) {
      var _this9 = this;

      file.upload().then(function (result) {
        _this9.broadcast.content_settings = _this9.broadcast.content_settings || {};
        _this9.broadcast.content_settings.podcast_preview = result.view_url;
      });
    }
  }, {
    key: "updateScoreboardMakes",
    value: function updateScoreboardMakes() {
      var _this10 = this;

      var FeatureFlags = this.FeatureFlags; // Grab the list of valid makes for the selected sport

      this.scoreboardMakes = [];

      if (this.isBoxCaster) {
        _.each(this.scoreboards, function (s) {
          if (s.require_tag && !FeatureFlags[s.require_tag]) {
            return;
          }

          if (!_this10.bulkImportMode) {
            if (s.value == 'BoxCast' || s.value == 'Sportzcast' || s.value == 'Manual') {
              // skip scoreboard makes that are handled separately in the UI
              return;
            }
          }

          _.each(s.models, function (m) {
            if (!_this10.broadcast.scoreboard_configuration.sport || m.sports.indexOf(_this10.broadcast.scoreboard_configuration.sport) >= 0) {
              _this10.scoreboardMakes.push(s);

              return false;
            }
          });
        });
      } else if (this.bulkImportMode) {
        // Only manual and Sportzcast allowed without a BoxCaster
        if (FeatureFlags.manual_scoreboard) {
          this.scoreboardMakes.push(_.find(this.scoreboards, {
            value: 'Manual'
          }));
        }

        if (FeatureFlags.sportzcast) {
          this.scoreboardMakes.push(_.find(this.scoreboards, {
            value: 'Sportzcast'
          }));
        }
      } else {// Only manual and Sportzcast allowed without a BoxCaster, and these are
        // handled directly in the UI
      } // See if the make the user has selected is valid per this sport, otherwise reset it


      if (!this.scoreboardMakes || !_.find(this.scoreboardMakes, {
        value: this.broadcast.scoreboard_configuration.scoreboard_make
      })) {
        this.broadcast.scoreboard_configuration.scoreboard_make = null;
      }

      this.updateScoreboardModels();
    }
  }, {
    key: "updateScoreboardModels",
    value: function updateScoreboardModels() {
      var _this11 = this;

      // Grab the list of valid models for the selected make
      var selectedMake = _.find(this.scoreboards, {
        value: this.broadcast.scoreboard_configuration.scoreboard_make
      });

      var allModels = _.result(selectedMake, 'models');

      this.scoreboardModels = [];

      _.each(allModels, function (m) {
        if (!_this11.broadcast.scoreboard_configuration.sport || m.sports.indexOf(_this11.broadcast.scoreboard_configuration.sport) >= 0) {
          _this11.scoreboardModels.push(m);
        }
      }); //console.log('New scoreboard models', this.scoreboardModels);
      // See if the model the user has selected is valid per this make, otherwise reset it


      if (!this.scoreboardModels || !_.find(this.scoreboardModels, {
        value: this.broadcast.scoreboard_configuration.scoreboard_model
      })) {
        this.broadcast.scoreboard_configuration.scoreboard_model = null;
      } // If the selected make only has 1 model, go ahead and pre-select it


      if (this.scoreboardModels && this.scoreboardModels.length == 1) {
        this.broadcast.scoreboard_configuration.scoreboard_model = this.scoreboardModels[0].value;
      }
    }
  }, {
    key: "getConflictingEvents",
    value: function getConflictingEvents() {
      var _this12 = this;

      var refreshDayEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var getEventsOnSelectedDayFn = function getEventsOnSelectedDayFn() {
        // NOTE: the dates used in the query need to be converted to UTC directly (not just with ISO 8601 offset specified)
        var dateStart = moment(_this12.startDate).startOf('day').utc().format();
        var dateEnd = moment(_this12.startDate).startOf('day').add(1, 'days').utc().format();
        var query = "+starts_at:[".concat(dateStart, " TO ").concat(dateEnd, "]");
        return _this12.Broadcast.query({
          q: query,
          l: 1000
        }, function (events) {
          // Get rid of this event
          _this12.otherEvents = _.reject(events, {
            id: _this12.broadcast.id
          });
        }).$promise;
      };

      var getConflictingEventsFn = function getConflictingEventsFn() {
        // First, find other events on the same source
        var eventsFromThisSource = [];

        if (_this12.broadcast.boxcaster_id && _this12.broadcast.boxcaster_id.startsWith('stream_source:rtmp')) {
          // RTMP
          if (_this12.broadcast.boxcaster_id.startsWith('stream_source:rtmp:')) {
            // static RTMP
            var staticRtmpId = _this12.broadcast.boxcaster_id.replace('stream_source:rtmp:', '');

            eventsFromThisSource = _.filter(_this12.otherEvents, function (b) {
              return b.stream_source === 'rtmp' && b.static_rtmp_id === staticRtmpId;
            });
          } else {
            // single-use RTMP
            eventsFromThisSource = _.filter(_this12.otherEvents, function (b) {
              return b.stream_source === 'rtmp' && b.static_rtmp_id === '';
            });
          }
        } else if (_this12.broadcast.boxcaster_id && _this12.broadcast.boxcaster_id.startsWith('stream_source:app')) {
          // Broadcaster
          eventsFromThisSource = _.filter(_this12.otherEvents, function (b) {
            return b.stream_source === 'app';
          });
        } else if (_this12.broadcast.boxcaster_id && !_this12.broadcast.boxcaster_id.startsWith('stream_source:')) {
          // BoxCaster
          eventsFromThisSource = _.filter(_this12.otherEvents, function (b) {
            return b.stream_source === 'boxcaster' && b.boxcaster_id === _this12.broadcast.boxcaster_id;
          });
        } else if (_this12.broadcast.boxcaster_id == 'stream_source:recording') {
          // Simulated Live (ignoring for now)
          // TODO: FIXME: attempt a better overlap check, but may require a little
          // more work to understand durations
          _this12.worstCaseSimultaneousStreams = 0;
          return;
        } // Next, find any that overlap


        var dates = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(_this12.startDate, _this12.startTime, _this12.endTime);
        var startsAt = Date.parse(dates.starts_at);
        var stopsAt = Date.parse(dates.stops_at);
        _this12.conflictingEvents = _.filter(eventsFromThisSource, function (b) {
          var thisStartsAt = Date.parse(b.starts_at);
          var thisStopsAt = Date.parse(b.stops_at);
          return !(stopsAt <= thisStartsAt || thisStopsAt <= startsAt);
        }); // Next, see how many other events are running at this time NOT from this source (to see how
        // many simultaneous) broadcasts might be going at once

        var eventsNotFromThisSource = _.reject(_this12.otherEvents, function (b) {
          return _.some(eventsFromThisSource, function (e) {
            return e.id === b.id;
          });
        });

        var conflictingEventsNotFromThisSource = _.filter(eventsNotFromThisSource, function (b) {
          if (b.stream_source == 'recording') {
            // TODO: FIXME: Ignoring Simulated Live for now
            return false;
          }

          var thisStartsAt = Date.parse(b.starts_at);
          var thisStopsAt = Date.parse(b.stops_at);
          return !(stopsAt <= thisStartsAt || thisStopsAt <= startsAt);
        }); // Finally, see how many unique "sources" there are for these conflicting events from other
        // sources. While the static RTMP and BoxCaster sources can only stream one broadcast at a
        // time, single-use RTMP and broadcaster broadcasts can (in theory) be used simultaneously.
        // Therefore, the length of this source list is the worst-case number of simultaneous
        // broadcasts at the proposed time. It could actually be less than this. But we use this
        // number to indicate to the user that they may hit their stream limit.


        var otherConflictingEventsSources = _.uniq(_.map(conflictingEventsNotFromThisSource, function (b) {
          if (b.stream_source === 'rtmp') {
            if (b.static_rtmp_id === '') {
              return "single-use-rtmp-".concat(b.id);
            } else {
              return b.static_rtmp_id;
            }
          } else if (b.stream_source === 'app') {
            return "broadcaster-".concat(b.id);
          } else {
            return b.boxcaster_id;
          }
        }));

        _this12.worstCaseSimultaneousStreams = otherConflictingEventsSources.length;
      };

      if (refreshDayEvents) {
        getEventsOnSelectedDayFn().then(getConflictingEventsFn);
      } else {
        getConflictingEventsFn();
      }
    }
  }, {
    key: "compensateEndDate",
    value: function compensateEndDate() {
      // Make sure end date is same day-of-month as start date
      // NOTE: Need to be careful to make minimum set of mutations in here since these objects
      // are in an angular watcher and will choke the digest cycle if changed willy nilly.
      var start = moment(this.startTime);
      var end = this.endTime ? moment(this.endTime) : null;

      if (!end) {// Open-ended event
      } else if (this.originalStartTime && this.originalEndTime && this.originalStartTime.getTime() != this.startTime.getTime() && this.originalEndTime.getTime() == this.endTime.getTime()) {
        // User changed start time but not end ... keep end locked 30 mins after start
        this.endTime = start.clone().add(30, 'minutes').toDate();
        this.originalEndTime = new Date(this.endTime.getTime());
        this.originalStartTime = new Date(this.startTime.getTime()); //avoid infinite digest
        //console.log('keeping end time locked 30 mins after start');
      } else if (end.format('HH:mm') < start.format('HH:mm')) {
        // Compensate for rolling across midnight (keep hours/minutes but bump to day after start)
        if (end.subtract(1, 'days').format('YYYY-MM-DD') != start.format('YYYY-MM-DD')) {
          this.endTime = end.set({
            year: start.get('year'),
            month: start.get('month'),
            date: start.get('date')
          }).add(1, 'days').toDate(); //console.log('adding a day to end datetime (rolled across midnight)');
        } else {//console.log('already compensated?');
        }
      } else if (end.format('YYYY-MM-DD') != start.format('YYYY-MM-DD')) {
        this.endTime = end.set({
          year: start.get('year'),
          month: start.get('month'),
          date: start.get('date')
        }).toDate(); //console.log('resetting end date');
      } else {//console.log('nothing to see here');
      }
    }
  }, {
    key: "explodeStreamSourceSettings",
    value: function explodeStreamSourceSettings(broadcast) {
      if (this.isBoxCaster) {
        broadcast.stream_source = 'boxcaster';
      } else {
        broadcast.stream_source = broadcast.boxcaster_id.replace('stream_source:', '');
        broadcast.boxcaster_id = null;
      } // Deal with static RTMP channel


      if (broadcast.stream_source.startsWith('rtmp:')) {
        broadcast.static_rtmp_id = broadcast.stream_source.replace('rtmp:', '');
        broadcast.stream_source = 'rtmp';
      }
    }
  }, {
    key: "validateAll",
    value: function validateAll() {
      this.errors = [];
      var result = true;
      result = this.validateOverview() && result;
      result = this.validateSchedule() && result;
      result = this.validateScoreboard() && result;
      result = this.validatePublish() && result;
      result = this.validateAdvanced() && result;

      if (result && this.$scope.form.$invalid) {
        console.dir(this.$scope.form);
        var e = this.$scope.form.$error || {};

        if (e.required) {
          this.errors.push('Please fill out all required fields');
        } else {
          this.errors.push('Please check all fields for proper values');
        }

        result = false;
      }

      return result;
    }
  }, {
    key: "validateOverview",
    value: function validateOverview() {
      var result = true;

      if (!this.broadcast.name) {
        this.errors.push('Broadcast Name is required');
        result = false;
      }

      if (!this.broadcast.boxcaster_id) {
        this.errors.push('Source is required');
        result = false;
      }

      if (this.isSimulatedLive && !this.broadcast.source_broadcast_id) {
        this.errors.push('Source broadcast is required');
        result = false;
      }

      return result;
    }
  }, {
    key: "isInThePast",
    get: function get() {
      // if this event is set to happen entirely in the past, don't allow it to be scheduled
      var now = new Date().getTime();
      var dates = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(this.startDate, this.startTime, this.endTime, this.maxBroadcastDurationHours);
      var startsAt = moment(dates.starts_at).toDate().getTime();
      var stopsAt = moment(dates.stops_at).toDate().getTime();
      return now > startsAt && now > stopsAt;
    }
  }, {
    key: "validateSchedule",
    value: function validateSchedule() {
      var result = true;

      if (this.broadcast.timeframe != 'past') {
        if (!this.isWithinAccountBroadcastDurationLimit) {
          this.errors.push("You are not allowed to stream for longer than ".concat(this.maxBroadcastDurationHours, " hours (contact us if you would like to upgrade your account)"));
          result = false;
        }

        if (this.recordingStorageExpires) {
          this.errors.push('The recording storage expires before the simulated live broadcast is scheduled to begin.');
          result = false;
        }

        if (this.isInThePast) {
          this.errors.push('A broadcast may not be scheduled in the past.');
          result = false;
        }
      }

      return result;
    }
  }, {
    key: "validateScoreboard",
    value: function validateScoreboard() {
      var result = true;
      var sc = this.broadcast.scoreboard_configuration;

      if (this.broadcast.timeframe == 'past' || !sc.sport) {
        return result;
      }

      if (sc.manual) {// manual scoreboard settings do not need validated
      } else if (sc.connection == 'scoreboard_adapter') {
        if (!sc.scoreboard_make || !sc.scoreboard_model) {
          this.errors.push('Scoreboard Make and Model are required');
          result = false;
        }
      } else if (sc.connection == 'scoreboard_assist') {// scoreboard assist settings do not need validated
      } else if (sc.connection == 'scorebot') {
        if (isNaN(parseInt(sc.sportzcast_bot_number, 10))) {
          this.errors.push('A valid ScoreBOT number is required');
          result = false;
        }
      } else {
        this.errors.push('A scoreboard connection is required');
        result = false;
      }

      return result;
    }
  }, {
    key: "validatePublish",
    value: function validatePublish() {
      var result = true;

      if (!this.visibility) {
        this.errors.push("Broadcast Type is required");
        result = false;
      }

      if (this.visibility == 'ticketed' || this.visibility == 'flex') {
        if (!this.broadcast.ticket_price || this.broadcast.ticket_price < this.minTicketPrice) {
          this.errors.push("The ticket price must be at least ".concat(this.minTicketPrice));
          result = false;
        }
      }

      var validSimulcast = this.broadcast.simulcast_configurations.filter(function (s) {
        return s.destination === 'generic';
      }).every(function (s) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__utils_rtmp__["a" /* IsRtmpURLValid */])(s.stream_url);
      });

      if (!validSimulcast) {
        this.errors.push('Invalid RTMP URL');
        result = false;
      }

      var validFbSimulcast = this.broadcast.simulcast_configurations.filter(function (s) {
        return s.destination === 'facebook';
      }).every(function (s) {
        return s.feed_type === 'user:me' || !!s.feed_id;
      });

      if (!validFbSimulcast) {
        this.errors.push('Invalid Facebook Destination');
        result = false;
      }

      var validMaxResolution = this.broadcast.simulcast_configurations.filter(function (s) {
        return s.destination === 'generic';
      }).every(function (s) {
        return !!s.max_resolution;
      });

      if (!validMaxResolution) {
        this.errors.push('Invalid Max Resolution');
        result = false;
      }

      if (this.simulcastOnly && this.simulcastLimit === 1 && this.broadcast.simulcast_configurations.length !== 1) {
        this.errors.push('Please select a single destination');
        result = false;
      }

      return result;
    }
  }, {
    key: "validateAdvanced",
    value: function validateAdvanced() {
      var _this13 = this;

      var result = true;

      if (this.broadcast.simulcast_configurations.length > 0 && this.isAudioOnly) {
        this.errors.push('Audio-only broadcasts cannot be sent to simulcast destinations.');
        result = false;
      }

      var hostRestrictions = this.broadcast.content_settings.hostRestrictions;

      if (hostRestrictions) {
        if (!hostRestrictions.allowedHosts.length) {
          this.errors.push('At least one allowed host is required');
          result = false;
        }

        hostRestrictions.allowedHosts.forEach(function (h) {
          if (!h) {
            _this13.errors.push('Allowed host cannot be blank');

            result = false;
          }
        });
      } else {
        delete this.broadcast.content_settings.hostRestrictions;
      }

      var passwordBlock = this.broadcast.content_settings.cryptblock;

      if (passwordBlock) {
        if (!passwordBlock.__password__ && !passwordBlock.crypt) {
          this.errors.push('Please choose a password');
          result = false;
        }
      } else {
        delete this.broadcast.content_settings.cryptblock;
      }

      return result;
    }
  }, {
    key: "isWithinAccountBroadcastDurationLimit",
    get: function get() {
      if (!this.endTime) return true;
      if (this.isSimulatedLive) return true; // ¯\_(ツ)_/¯

      var dates = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(this.startDate, this.startTime, this.endTime, this.maxBroadcastDurationHours);
      var duration = (moment(dates.stops_at) - moment(dates.starts_at)) / (60 * 60 * 1000);
      return duration <= this.maxBroadcastDurationHours;
    }
  }, {
    key: "recordingStorageExpires",
    get: function get() {
      if (this.broadcast.timeframe && this.broadcast.timeframe !== 'past') {
        return false;
      }

      if (!this.isSimulatedLive) {
        return false;
      }

      if (!this.sourceBroadcast) {
        return false;
      }

      if (this.account.storage_policy !== 'auto-delete') {
        return false;
      }

      var storageExpiresAt = Date.parse(this.sourceBroadcast.storage_expires_at);
      var dates = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(this.startDate, this.startTime, this.endTime);
      var startsAt = Date.parse(dates.starts_at);
      return storageExpiresAt < startsAt;
    }
  }, {
    key: "showScrambleOption",
    get: function get() {
      return this.visibility == 'private' && this.origVisibility != 'private';
    }
  }, {
    key: "showAddSimulcast",
    get: function get() {
      if (this.broadcast && this.broadcast.simulcast_configurations && this.broadcast.simulcast_configurations.length >= this.simulcastLimit) {
        return false;
      }

      return this.visibility != 'ticketed' && this.visibility != 'flex' && (this.allowFacebookLive && !this.fb.loading && this.fb.connected || this.allowYoutubeLive && this.youtubeUsers.length || this.allowTwitter && this.twitterUsers.length || this.allowGenericRtmpPush && this.rtmpPushChannels.length || this.allowGenericRtmpPush);
    }
  }, {
    key: "saveChanges",
    value: function saveChanges() {
      var skipFormValidation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var skipCustomStreamSourceHandling = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var $scope = this.$scope,
          $q = this.$q,
          Broadcast = this.Broadcast,
          toaster = this.toaster;
      var deferred = $q.defer();

      if (!skipFormValidation && !this.validateAll()) {
        console.log('Invalid form', this.errors);
        deferred.reject('invalid');
        return deferred.promise;
      } // Adjust dates when broadcast crosses midnight


      var dates = Object(__WEBPACK_IMPORTED_MODULE_2__utils_date__["a" /* adjustBroadcastDatesForCrossingMidnight */])(this.startDate, this.startTime, this.endTime, this.maxBroadcastDurationHours);
      this.broadcast.starts_at = dates.starts_at;
      this.broadcast.stops_at = dates.stops_at; // Make a copy so we can mutate the original in ways that might be incompatible with the
      // edit/create pages

      var broadcast = angular.copy(this.broadcast); // Clean up the visibility settings on the broadcast object

      broadcast = Object(__WEBPACK_IMPORTED_MODULE_1__utils_pricing__["b" /* updatePriceSettingsFromVisibilityOption */])(broadcast, this.visibility); // Clean up cruft from UI shenanigans

      Object(__WEBPACK_IMPORTED_MODULE_3__utils_password__["a" /* checkContentSettingsForChangesOnSave */])(broadcast.content_settings);

      if (broadcast.content_settings.preview === null) {
        delete broadcast.content_settings.preview;
      }

      if (!this.bulkImportMode) {
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_scoreboard__["d" /* mapScoreboardUIConfigurationToAPI */])(broadcast.scoreboard_configuration);
      }

      if (this.showFeatured) {
        if (this.isFeatured) {
          if (!_.contains(broadcast.tags, 'featured')) {
            broadcast.tags.push('featured');
          }
        } else {
          _.remove(broadcast.tags, function (t) {
            return t == 'featured';
          });
        }
      } // Simulcast configuration managed separately


      var simulcastMeta = broadcast.simulcast_configurations;
      delete broadcast.simulcast_configurations; // Remove instructional rows

      simulcastMeta.filter(function (s) {
        return !s.isHelpRow;
      }); // Someone may have clicked the "Multi-Use" tab to see what that was about _AFTER_ filling out
      // the single-use fields. In that case, flip it back to generic.

      simulcastMeta.filter(function (s) {
        return s.destination === 'rtmp_push_channel';
      }).forEach(function (s) {
        if (!s.rtmp_push_channel_id && s.stream_url && s.stream_key) {
          s.destination = 'generic';

          if (!s.max_resolution) {
            s.max_resolution = '0';
          }
        }
      }); // string to integers for max_resolution

      simulcastMeta.filter(function (s) {
        return s.destination === 'generic';
      }).forEach(function (s) {
        return s.max_resolution = parseInt(s.max_resolution);
      }); // filter out any multi-use RTMP that don't actually have a channel selected

      simulcastMeta = simulcastMeta.filter(function (s) {
        return s.destination !== 'rtmp_push_channel' || !!s.rtmp_push_channel_id;
      }); // Recombine feed type and ID for facebook

      simulcastMeta.filter(function (s) {
        return s.destination === 'facebook';
      }).forEach(function (s) {
        if (s.feed_type === 'user:me') {
          s.fb_feed_id = 'user:me';
        } else {
          s.fb_feed_id = s.feed_type + ':' + s.feed_id;
        }

        delete s.feed_type;
        delete s.feed_id;
      }); // Support regenerating the channel ID

      if (this.showScrambleOption && this.scrambleChannelId) {
        broadcast.regenerate_channel_id = '1';
        broadcast.metadata = broadcast.metadata || {};
        broadcast.metadata.original_channel_id = broadcast.metadata.original_channel_id || broadcast.channel_id;
      } else {
        delete broadcast.regenerate_channel_id;
      } // Deal with custom stream sources


      if (!skipCustomStreamSourceHandling) {
        this.explodeStreamSourceSettings(broadcast);
      } // Handle start/stop time editibility


      if (broadcast.stream_source != 'imported') {
        if (broadcast.timeframe == 'current') {
          // If this broadcast is live, API won't let us change the start time
          delete broadcast.starts_at;
        } else if (broadcast.timeframe == 'past') {
          // If this broadcast was in the past, API won't let us change the start or stop time
          delete broadcast.starts_at;
          delete broadcast.stops_at;
        }
      } // Remove unnecessary fields for imported/simulated live broadcasts


      if (broadcast.stream_source == 'imported' || broadcast.stream_source == 'recording') {
        broadcast.target_video_bitrate = null;
        broadcast.target_audio_bitrate = null;
        broadcast.audio_source = null;
        broadcast.target_video_resolution = null;
        broadcast.target_high_frame_rate = null;
        broadcast.dscp_value = null;
      } // Simulated live broadcasts have some special values


      if (broadcast.stream_source == 'recording') {
        broadcast.requests_captioning = false;

        if (broadcast.stops_at) {
          broadcast.stops_at = null;
        }
      } // Do not attempt to change the stream source for *past* broadcasts (can cause
      // weird issues with archived BoxCasters, RTMP Sources, etc.)


      if (broadcast.timeframe == 'past') {
        delete broadcast.stream_source;
        delete broadcast.static_rtmp_id;
        delete broadcast.boxcaster_id;
        delete broadcast.source_broadcast_id;
      }

      if (broadcast.timeframe && broadcast.timeframe != 'future') {
        // Do not attempt to change the target_buffer_latency for any non-future broadcast
        delete broadcast.target_buffer_latency;
      } else {
        // Make sure target_buffer_latency makes sense
        if (this.account.feature_flags.boxcast_flow_control_disabled) {
          broadcast.target_buffer_latency = 'default';
        } else if (this.isBoxCasterHDSD2) {
          if (broadcast.target_buffer_latency == 'maximum') {
            broadcast.target_buffer_latency = 'enhanced';
          }
        } else if (!this.isBoxCasterHDSD2 && !this.isBoxCasterPro && !this.isBroadcasterApp) {
          broadcast.target_buffer_latency = 'default';
        }
      } // Detach from old static RTMP channel if switching to non-RTMP source


      if (broadcast.stream_source != 'rtmp' && broadcast.static_rtmp_id) {
        broadcast.static_rtmp_id = null;
      }

      var promise;

      if (broadcast.id) {
        // Update existing broadcast
        if (broadcast.timeframe != 'past') {
          broadcast.simulcast_configurations = simulcastMeta;
        } else {
          delete broadcast.scoreboard_configuration;
        }

        promise = Broadcast.update({
          id: broadcast.id
        }, broadcast).$promise;
      } else {
        // Save new broadcast
        broadcast.simulcast_configurations = simulcastMeta;
        promise = Broadcast.save(broadcast).$promise;
      }

      promise.then(function (response) {
        // Handle any warnings/errors from simulcast
        (response.simulcast_configurations || []).forEach(function (c) {
          if (c.error) {
            console.error(c);
            toaster.pop('warning', "There was an error saving the simulcast configuration: ".concat(c.error.error_description));
          }
        });
        deferred.resolve(response);
      })["catch"](function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }
  }]);

  return _EditOrCreateEventServiceImpl;
}();
module.service('EditOrCreateEventService', EditOrCreateEventService);
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FacebookService */
var module = angular.module('boxcast.services.facebook', []); // NOTE: Changing the scope of permissions from Facebook requires
// that you submit the app for approval for the permissions using
// the tools at developer.facebook.com.

var FACEBOOK_SCOPE = ['pages_manage_metadata', 'pages_manage_posts', 'pages_read_engagement', 'pages_show_list', 'publish_to_groups', 'publish_video', 'user_events'].join(',');
var FB_LOAD_STATUS_DEBOUNCE_MS = 60000; //only poll once per minute at most

module.service('Facebook', FacebookService);
function FacebookService($http, $q, $timeout) {
  'ngInject';

  var _this = this;

  this.loading = false;
  this.auth = {};

  this.init = function () {
    _this.loading = true;
    return waitForSDK().then(function () {
      return _this.loadStatus({
        silent: true
      });
    }).then(function () {
      _this.loading = false;
    })["catch"](function (err) {
      _this.loading = false;
      remoteLogger.error('Unable to initialize Facebook', {
        error: err
      });
    });
  };

  this._loadStatusInFlight = false;
  this._lastLoadStatusComplete = 0;

  this.loadStatus = function (options) {
    return $q(function (resolve, reject) {
      var checkAgainTimer = $timeout(function () {
        // getLoginStatus sometimes hangs the first time...
        _this.loadStatus(options).then(function () {
          resolve(_this);
        });
      }, 1000);

      if (_this._loadStatusInFlight) {
        console.log('Facebook#loadStatus -- in flight, will not start another FB API call');
        return; //let checkAgainTimer resolve in a bit
      }

      if (!options.force && new Date() - _this._lastLoadStatusComplete < FB_LOAD_STATUS_DEBOUNCE_MS) {
        console.log('Facebook#loadStatus -- using cached loadStatus value');
        $timeout.cancel(checkAgainTimer);
        resolve(_this);
        return;
      }

      _this._loadStatusInFlight = true;
      FB.getLoginStatus(function (response) {
        if (checkAgainTimer) {
          $timeout.cancel(checkAgainTimer);
        }

        $timeout(function () {
          _this._loadStatusInFlight = false;
          _this._lastLoadStatusComplete = new Date();
          updateInstanceFromAuthResponse(response, options).then(function () {
            return resolve(_this);
          })["catch"](function (e) {
            return reject(e);
          });
        }, 0);
      }, true);
    });
  };

  var updateInstanceFromAuthResponse = function updateInstanceFromAuthResponse(response) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _this.connected = response.status == 'connected';
    _this.status = response.status;
    _this.auth = response.authResponse || {};

    if (_this.connected) {
      return $q.all([_this.queryMe(options), _this.queryAccounts(), _this.queryEvents(), _this.queryGroups()]);
    } else {
      _this.me = {};
      _this.accounts = [];
      return $q(function (r) {
        return r();
      });
    }
  };

  this.queryMe = function (options) {
    return $q(function (resolve, reject) {
      FB.api('/me', function (response) {
        // name, id
        $timeout(function () {
          _this.me = response;

          if (_this.auth.accessToken) {
            _this.linkAccount(options).then(function () {
              return resolve(response);
            })["catch"](function (e) {
              return reject(e);
            });
          } else {
            resolve(response);
          }
        }, 0);
      });
    });
  };

  var doFbApi = function doFbApi(url) {
    return $q(function (resolve, reject) {
      FB.api(url, function (response) {
        $timeout(function () {
          if (response.error) {
            remoteLogger.error("Error from Facebook URL", {
              facebook_url: url,
              error: response.error
            });
            reject(response.error);
          } else {
            resolve(response);
          }
        }, 0);
      });
    });
  }; // It seems that by default, Facebook returns about 25 results per page, taking 500-900ms to do so (all
  // server-side, not network). In order to prevent unbounded recursion and a long delay when loading the
  // Facebook account, we limit results to 10 pages or 250 results (whichever comes first). In general,
  // this should keep load times below 5-10s (and usually lower, assuming most people don't have _that_
  // many pages, groups, and events).


  var fbRecursiveCallLimit = 10;
  var fbResultLimit = 250;

  var paginateFbApi = function paginateFbApi(url) {
    return $q(function (resolve, reject) {
      // Closure variable to collect results
      var results = [];
      var totalCalls = 0; // Error and success callbacks

      var completionSuccess = function completionSuccess(response) {
        results = results.concat(response.data || []);

        if (response.paging && response.paging.next) {
          // More pages, apparently
          if (totalCalls >= fbRecursiveCallLimit) {
            console.warn("Facebook would provide more results, but we stopped after ".concat(totalCalls, " to the API. Results will be limited."));
            resolve(results);
          } else if (results.length >= fbResultLimit) {
            console.warn("Facebook would provide more results, but we stopped after finding ".concat(results.length, " results. Results will be limited."));
            resolve(results);
          } else {
            totalCalls += 1;
            doFbApi(response.paging.next).then(completionSuccess)["catch"](function (e) {
              return reject(e);
            });
          }
        } else {
          // No more pages, resolve
          resolve(results);
        }
      }; // Now kick off the first API call


      totalCalls += 1;
      doFbApi(url).then(completionSuccess)["catch"](function (e) {
        return reject(e);
      });
    });
  };

  this.queryAccounts = function () {
    return paginateFbApi('/me/accounts?fields=id,name,cover').then(function (results) {
      _this.accounts = _.sortBy(results, function (a) {
        return (a.name || '').toLowerCase();
      });
      return results;
    })["catch"](function (error) {
      _this.accounts = [];
      throw error;
    });
  };

  this.queryEvents = function () {
    return paginateFbApi('/me/events?fields=id,name,cover,start_time').then(function (results) {
      _this.events = _.sortBy(results, function (e) {
        return Date.parse(e.start_time);
      });
      return results;
    })["catch"](function (error) {
      _this.events = [];
      throw error;
    });
  };

  this.queryGroups = function () {
    return paginateFbApi('/me/groups?fields=id,name,cover').then(function (results) {
      _this.groups = _.sortBy(results, function (g) {
        return (g.name || '').toLowerCase();
      });
      return results;
    })["catch"](function (error) {
      _this.groups = [];
      throw error;
    });
  };

  this.logout = function () {
    return $q(function (resolve, reject) {
      if (!window.FB) {
        return resolve(false);
      }

      FB.logout(function () {
        _this.facebook_account_id = null;
        _this.connected = false;
        _this.status = {};
        _this.auth = {};
        _this.me = {};
        _this.accounts = [];
        _this.events = [];
        _this.groups = [];
        resolve(true);
      });
    });
  };

  this.login = function () {
    return $q(function (resolve, reject) {
      FB.login(function (resp) {
        updateInstanceFromAuthResponse(resp).then(function () {
          resolve(true);
        })["catch"](function (err) {
          reject(err);
        });
      }, {
        scope: FACEBOOK_SCOPE
      });
    });
  };

  this.linkAccount = function (options) {
    return $q(function (resolve, reject) {
      $http.get("".concat(API_ROOT, "/account/facebook_users/").concat(_this.me.id)).then(function (response) {
        // User already exists, extend the token
        $http.put("".concat(API_ROOT, "/account/facebook_users/").concat(_this.me.id), {
          fb_user_access_token: _this.auth.accessToken,
          fb_user_name: _this.me.name
        }).then(function (response) {
          console.log('Updated Facebook->BoxCast linkage:', response.data);
          _this.facebook_account_id = response.data.id;
          resolve(_this.facebook_account_id);
        })["catch"](function (err) {
          reject(err);
        });
      })["catch"](function (err) {
        if (err.status != 404) {
          remoteLogger.error('Error linking facebook account:', {
            error: err
          });
          reject(err);
          return;
        }

        if (options && options.silent) {
          // 404, user doesn't exist in BoxCast DB ... don't auto-create it since
          // we're in silent mode. Wait for user to explicitly want to link.
          _this.connected = false;
          _this.status = {};
          _this.auth = {};
          _this.me = {};
          _this.accounts = [];
          _this.events = [];
          _this.groups = [];
          resolve({});
        } else {
          // 404, user doesn't exist in BoxCast DB ... create it!
          $http.post("".concat(API_ROOT, "/account/facebook_users"), {
            fb_user_id: _this.me.id,
            fb_user_access_token: _this.auth.accessToken,
            fb_user_name: _this.me.name
          }).then(function (response) {
            console.log('Linked Facebook->BoxCast:', response.data); // XXX: is there a race condition?

            _this.facebook_account_id = response.data.id;
            resolve(_this.facebook_account_id);
          })["catch"](function (err) {
            reject(err);
          });
        }
      });
    });
  }; // Private helpers


  var waitForSDK = function waitForSDK() {
    var deferred = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (deferred === null) {
      deferred = $q.defer();
    }

    if (window['FB']) {
      deferred.resolve(FB);
      _this.FB = FB;
      return deferred.promise;
    } else {
      console.log('FB SDK not yet loaded, checking again');
      $timeout.cancel(_this._waitForSDKTimer);
      _this._waitForSDKTimer = $timeout(function () {
        return waitForSDK(deferred);
      }, 100);
      return deferred.promise;
    }
  };
}
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var module = angular.module('jszip', []);
module.service('JSZip', function () {
  this.init = function () {
    return new Promise(function (resolve, reject) {
      __webpack_require__.e/* require.ensure */(0).then((function () {
        var jszip = __webpack_require__(647);

        resolve(jszip);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    });
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var module = angular.module('app.services.meetings-service', []);
module.service('MeetingsService', function ($uibModal, $rootScope) {
  var _this = this;

  var account = $rootScope.account;

  this.openPreferredMethod = function () {
    // Prefer chat if it's available
    if (_this.openChat()) {
      return;
    } // Otherwise, schedule a meeting


    _this.scheduleMeeting();
  };

  this.openChat = function () {
    if (window.Intercom) {
      window.Intercom('show');
      return true;
    }

    return false;
  };

  this.scheduleMeeting = function () {
    var _title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Schedule time with a live streaming expert';

    var url = "".concat(HUBSPOT_MEETINGS_BASE_URL, "/brian-lee/meeting-with-boxcast?embed=true");

    if (account.isTrialing()) {
      url = "".concat(HUBSPOT_MEETINGS_BASE_URL, "/brian-lee/boxcast-live-stream-meeting?embed=true");
    }

    $uibModal.open({
      template: __webpack_require__(611),
      controller: __webpack_require__(612)["default"],
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        title: function title() {
          return _title;
        },
        meetingLink: function meetingLink() {
          return url;
        }
      }
    });
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\" style=\"text-align:center;border-bottom:none 0;padding-bottom:0\">\n  <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n  <h4 class=\"modal-title\"><strong>{{::vm.title}}</strong></h4>\n</div>\n<div class=\"modal-body\" style=\"text-align:center;padding-top:0\">\n  <iframe frameborder=\"0\" width=\"100%\" height=\"700px\" class=\"embed-responsive-item\" style=\"padding-top:10px!important\" ng-src=\"{{::vm.meetingLink}}\"></iframe>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n</div>"

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ModalScheduleMeeting;
function ModalScheduleMeeting($uibModalInstance, $rootScope, $sce, title, meetingLink) {
  'ngInject';

  this.cancel = function () {
    return $uibModalInstance.dismiss('cancel');
  };

  this.account = $rootScope.account;
  this.user = $rootScope.user;
  this.title = title;
  var meetingLink = meetingLink;
  var nameParts = this.user.name.split(' ');
  meetingLink += "&email=".concat(this.user.email, "&firstName=").concat(nameParts[0], "&lastName=").concat(nameParts[1], "&organization_name=").concat(this.account.name);
  this.meetingLink = $sce.trustAsResourceUrl(meetingLink);
}

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var module = angular.module('app.services.multi-part-upload', []);
var MAX_SIMULTANEOUS_UPLOAD_PARTS = 4;
var MAX_BACKOFF_MS = 10000;
var EXP_BACKOFF_FACTOR = 1.75;
module.service('MultiPartUpload', function ($q, $http, $timeout, Upload) {
  var MultiPartUpload = /*#__PURE__*/function () {
    function MultiPartUpload(baseUrl, file, parts) {
      _classCallCheck(this, MultiPartUpload);

      this._baseUrl = baseUrl;
      this._file = file;
      this._parts = parts;
      this._destroyed = false;
      this._totalUploadSize = _.reduce(this._parts, function (m, p) {
        return m + p.size;
      }, 0);
      this._advanceDelay = 0;
      this._deferred = $q.defer();
      this._promise = this._deferred.promise; // Glue on a state for each part

      _.each(this._parts, function (p) {
        if (p.complete) {
          p.state = 'complete';
        } else {
          p.state = 'not-started';
        }
      });

      this._advance();
    }

    _createClass(MultiPartUpload, [{
      key: "$promise",
      get: function get() {
        return this._promise;
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this._destroyed = true;

        if (this._timeout) {
          $timeout.cancel(this._timeout);
        }
      } // This function advances the state of the multi-part upload

    }, {
      key: "_advance",
      value: function _advance() {
        var _this = this;

        if (this._destroyed) return; // Each part has an state (internal, maintained by this class, NOT provided from the API), one of:
        //  - not-started
        //  - uploading (PUT of the part content in flight)
        //  - uploaded (will have set complete: true and etag: <something>)
        //  - updating (PUT of the part status in flight)
        //  - complete
        // If there are >= MAX_SIMULTANEOUS_UPLOAD_PARTS parts still in flight, nothing to do.

        var numInFlight = _.filter(this._parts, function (p) {
          return _.contains(['uploading', 'updating'], p.state);
        }).length;

        if (numInFlight >= MAX_SIMULTANEOUS_UPLOAD_PARTS) return; // First, let's look for a part to update

        var partToUpdate = _.find(this._parts, function (p) {
          return p.state === 'uploaded';
        });

        if (partToUpdate) {
          this._startPartUpdate(partToUpdate); // Call ourselves recursively, as we might be able to start more.


          return this._advance();
        } // Next, let's go looking for a part to upload


        var partToUpload = _.find(this._parts, function (p) {
          return p.state === 'not-started';
        });

        if (partToUpload) {
          partToUpload.$promise = this._startPartUpload(partToUpload); // Call ourselves recursively, as we might be able to start more.

          return this._advance();
        } // If there are still some in flight, wait until they're done


        if (numInFlight > 0) return; // All done, I guess... this promise _should_ resolve immediately since all the child
        // promises have already resolved.

        $q.all(_.map(this._parts, function (p) {
          return p.$promise;
        })).then(function (r) {
          return _this._deferred.resolve(r);
        }, function (e) {
          return _this._deferred.reject(e);
        });
      } // This function calls _advance asynchronously with the appropriate backoff

    }, {
      key: "_advanceAsync",
      value: function _advanceAsync(lastCallSuccessful) {
        var _this2 = this;

        this._timeout = $timeout(function () {
          return _this2._advance();
        }, this._nextAdvanceDelay(lastCallSuccessful));
      } // Get the next delay for calling _advance

    }, {
      key: "_nextAdvanceDelay",
      value: function _nextAdvanceDelay(lastCallSuccessful) {
        if (lastCallSuccessful) {
          this._advanceDelay = 0;
        } else {
          this._advanceDelay = Math.min(Math.max(1000, this._advanceDelay) * EXP_BACKOFF_FACTOR, MAX_BACKOFF_MS);
        }

        return this._advanceDelay;
      } // A function to notify the promise of progress; it is called with an individual
      // progress event, and converts it into a new event that summarizes total progress.

    }, {
      key: "_notifyProgress",
      value: function _notifyProgress(e) {
        var _this3 = this;

        var newEvent = {
          loaded: this._totalLoaded(),
          total: this._totalUploadSize,
          type: e.type,
          config: e.config,
          lengthComputable: true,
          target: e.target
        };

        if (this._deferred.notify) {
          this._deferred.notify(newEvent);
        }

        if (this._promise.progressFunc) {
          $timeout(function () {
            return _this3._promise.progressFunc(newEvent);
          });
        }
      } // Called after successfully updating a part status with the API

    }, {
      key: "_partUpdateComplete",
      value: function _partUpdateComplete(resp, part) {
        part.state = 'complete';

        this._advanceAsync(true);
      } // Called if updating a part status with the API fails

    }, {
      key: "_partUpdateError",
      value: function _partUpdateError(err, part) {
        console.error('Error updating part:', part, err);
        part.state = 'uploaded';

        this._advanceAsync(false);
      } // Called when a part upload has completed successfully

    }, {
      key: "_partUploadComplete",
      value: function _partUploadComplete(resp, part) {
        part.complete = true;
        part.etag = resp.headers('ETag');
        part.state = 'uploaded';

        this._advanceAsync(true);
      } // Called when a part upload failed

    }, {
      key: "_partUploadError",
      value: function _partUploadError(err, part) {
        var _this4 = this;

        console.error('Error uploading part:', part, err);
        part.state = 'not-started'; // The upload service refreshes the presigned PUT URLs for any incomplete parts when we GET
        // the upload again. Refresh it here and update the presigned URL for any incomplete parts
        // in case we've hit their signature expiration.

        $http.get(this._baseUrl).then(function (resp) {
          _.each(_.where(_this4._parts, function (p) {
            return _.contains(['not-started', 'uploading'], p.state);
          }), function (p) {
            var refreshedPart = _.find(resp.data.parts, function (p2) {
              return p2.part_number === p.part_number;
            });

            if (refreshedPart) {
              p.presigned_url = refreshedPart.presigned_url;
            }
          });

          _this4._advanceAsync(false);
        }, function (err) {
          console.error('Error refreshing upload:', err);

          _this4._advanceAsync(false);
        });
      } // Called for progress/notify on a part upload

    }, {
      key: "_partUploadProgress",
      value: function _partUploadProgress(evt, part) {
        part.loaded = evt.loaded;

        this._notifyProgress(evt);
      } // Start the update of a part status with the API and return its promise

    }, {
      key: "_startPartUpdate",
      value: function _startPartUpdate(part) {
        var _this5 = this;

        part.state = 'updating';
        return $http.put("".concat(this._baseUrl, "/parts/").concat(part.part_number), {
          complete: part.complete,
          etag: part.etag
        }).then(function (r) {
          return _this5._partUpdateComplete(r, part);
        }, function (e) {
          return _this5._partUpdateError(e, part);
        });
      } // Start the upload of a part and return its promise

    }, {
      key: "_startPartUpload",
      value: function _startPartUpload(part) {
        var _this6 = this;

        part.state = 'uploading';
        return Upload.http({
          url: part.presigned_url,
          headers: {
            'Content-Type': this._file.type
          },
          method: 'PUT',
          data: this._file.slice(part.offset, part.offset + part.size)
        }).then(function (r) {
          return _this6._partUploadComplete(r, part);
        }, function (e) {
          return _this6._partUploadError(e, part);
        }, function (n) {
          return _this6._partUploadProgress(n, part);
        });
      } // A function to calculate total loaded amount across all promises

    }, {
      key: "_totalLoaded",
      value: function _totalLoaded() {
        return _.reduce(this._parts, function (m, p) {
          return m + (p.loaded || 0);
        }, 0);
      }
    }]);

    return MultiPartUpload;
  }();

  this.destroy = function () {
    if (this._mpu) {
      this._mpu.destroy();
    }
  };

  this.start = function (baseUrl, file, parts) {
    this._mpu = new MultiPartUpload(baseUrl, file, parts);
    return this._mpu.$promise;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var module = angular.module('one-or-all-dialog', []);
module.service('OneOrAllDialog', function ($uibModal) {
  'ngInject';

  var modalDefaults = {
    backdrop: true,
    keyboard: true,
    modalFade: true,
    template: "\n      <div class=\"modal-header\">\n        <h3 class=\"modal-title\">{{modalOptions.headerText}}</h3>\n      </div>\n      <div class=\"modal-body\">\n        <p>{{modalOptions.bodyText}}</p>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-{{modalOptions.closeButtonClass}}\" data-ng-click=\"modalOptions.close()\">{{modalOptions.closeButtonText}}</button>\n        <button class=\"btn btn-{{modalOptions.allButtonClass}}\" data-ng-click=\"modalOptions.ok('all');\">{{modalOptions.allButtonText}}</button>\n        <button class=\"btn btn-{{modalOptions.oneButtonClass}}\" data-ng-click=\"modalOptions.ok('one');\">{{modalOptions.oneButtonText}}</button>\n      </div>\n    "
  };
  var modalOptions = {
    headerText: 'Proceed?',
    bodyText: 'Perform this action?',
    closeButtonText: 'Close',
    closeButtonClass: 'default',
    allButtonText: 'All Upcoming Broadcasts In The Series',
    allButtonClass: 'primary',
    oneButtonText: 'This Broadcast Only',
    oneButtonClass: 'primary'
  };

  this.show = function (customModalOptions, customModalDefaults) {
    //Create temp objects to work with since we're in a singleton service
    var tempModalDefaults = {};
    var tempModalOptions = {}; //Map angular-ui modal custom defaults to modal defaults defined in service

    angular.extend(tempModalDefaults, modalDefaults, customModalDefaults); //Map modal.html $scope custom properties to defaults defined in service

    angular.extend(tempModalOptions, modalOptions, customModalOptions);

    if (!tempModalDefaults.controller) {
      tempModalDefaults.controller = function ($scope, $uibModalInstance) {
        'ngInject';

        $scope.modalOptions = tempModalOptions;

        $scope.modalOptions.ok = function (result) {
          $uibModalInstance.close(result);
        };

        $scope.modalOptions.close = function (result) {
          $uibModalInstance.dismiss('cancel');
        };
      };
    }

    return $uibModal.open(tempModalDefaults).result;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_overlay_image__ = __webpack_require__(198);

var module = angular.module('app.services.overlays', []);
var PAGE_SIZE = 20;
module.service('Overlays', function ($q, $http) {
  'ngInject';

  var _this = this;

  this.loadOverlaysForPage = function (p) {
    return $http.get("".concat(API_ROOT, "/account/uploads"), {
      params: {
        'filter.slot': 'overlay',
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-created_at'
      }
    }).then(function (response) {
      var pagination = JSON.parse(response.headers('x-pagination'));
      return {
        uploads: response.data,
        pagination: {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + response.data.length
        }
      };
    });
  };

  this.preloadUploadImage = function (upload) {
    return $q(function (resolve, reject) {
      // this needs to be in the initialization logic when first dragging onto canvas
      $('<img/>') // Make in memory copy of image to avoid css issues
      .attr('src', upload.view_url).load(function () {
        var width = this.width,
            height = this.height; // get actual image dimensions from <img>

        resolve({
          width: width,
          height: height
        });
      }).error(function (err) {
        reject(err);
      });
    });
  };

  this.prepareUploadForOverlay = function (upload) {
    return _this.preloadUploadImage(upload).then(function (dims) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__directives_overlay_image__["uploadImageToOverlay"])(upload, dims.width, dims.height);
    });
  };
});
/* harmony default export */ __webpack_exports__["a"] = (module);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular_ui_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular_ui_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular_ui_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_resource__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angulartics__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angulartics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angulartics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angulartics_google_analytics__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angulartics_google_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angulartics_google_analytics__);
// 3rd party angular modules



__webpack_require__(182);

__webpack_require__(617);

__webpack_require__(184);

__webpack_require__(187);

__webpack_require__(618);

__webpack_require__(620);

__webpack_require__(622);

__webpack_require__(623);

__webpack_require__(625);

__webpack_require__(626);

__webpack_require__(627);

__webpack_require__(628);

__webpack_require__(186);

__webpack_require__(629);

__webpack_require__(631);




__webpack_require__(188);

__webpack_require__(635);

__webpack_require__(192);

__webpack_require__(193);

__webpack_require__(637);

__webpack_require__(639);

__webpack_require__(31);

__webpack_require__(52);

__webpack_require__(181);

__webpack_require__(641);

__webpack_require__(642);

var module = angular.module('app.thirdparty', ['angular-clipboard', 'angularMoment', 'angulartics', 'angulartics.google.analytics', 'cgBusy', //angular-busy
'chart.js', 'color.picker', 'ngFileUpload', 'ngFitText', 'ngTagsInput', 'ngResource', 'rzModule', //angularjs-slider
'selectize', 'toaster', 'ui.bootstrap', 'ui.router', 'leaflet-directive', 'vs-repeat']);
module.value('fitTextConfig', {
  config: {
    debounce: _.debounce,
    delay: 100,
    loadDelay: 250,
    min: 13,
    max: 30
  }
}); // Init Google Analytics

(function (i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;
  i[r] = i[r] || function () {
    (i[r].q = i[r].q || []).push(arguments);
  }, i[r].l = 1 * new Date();
  a = s.createElement(o), m = s.getElementsByTagName(o)[0];
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

ga('create', GOOGLE_ANALYTICS_KEY, GOOGLE_ANALYTICS_DOMAIN); ////
// Init Facebook

window.fbAsyncInit = function () {
  FB.init({
    appId: FACEBOOK_APP_ID,
    xfbml: true,
    cookie: true,
    version: 'v8.0'
  });
};

(function (d, s, id) {
  var js,
      fjs = d.getElementsByTagName(s)[0];

  if (d.getElementById(id)) {
    return;
  }

  js = d.createElement(s);
  js.id = id;
  js.src = '//connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk'); ////
// Init DataDog logging


if (window.DD_LOGS) {
  DD_LOGS.init({
    clientToken: DATADOG_LOGS_CLIENT_TOKEN,
    forwardErrorsToLogs: false,
    sampleRate: 100
  });
  window.remoteLogger = DD_LOGS.logger;

  if (window.location.hostname == 'localhost') {
    // Use console logging for local development
    window.remoteLogger.setHandler('console');
  }
} else {
  console.warn('DD_LOGS not available so remote troubleshooting will be limited. Do you have an ad blocker enabled?');
} ////


/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(15)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory(require('angular'));
    } else {
        root.angularClipboard = factory(root.angular);
  }
}(this, function (angular) {

return angular.module('angular-clipboard', [])
    .factory('clipboard', ['$document', '$window', function ($document, $window) {
        function createNode(text, context) {
            var node = $document[0].createElement('textarea');
            node.style.position = 'absolute';
            node.style.fontSize = '12pt';
            node.style.border = '0';
            node.style.padding = '0';
            node.style.margin = '0';
            node.style.left = '-10000px';
            node.style.top = ($window.pageYOffset || $document[0].documentElement.scrollTop) + 'px';
            node.textContent = text;
            return node;
        }

        function copyNode(node) {
            try {
                // Set inline style to override css styles
                $document[0].body.style.webkitUserSelect = 'initial';

                var selection = $document[0].getSelection();
                selection.removeAllRanges();

                var range = document.createRange();
                range.selectNodeContents(node);
                selection.addRange(range);
                // This makes it work in all desktop browsers (Chrome)
                node.select();
                // This makes it work on Mobile Safari
                node.setSelectionRange(0, 999999);

                try {
                    if(!$document[0].execCommand('copy')) {
                        throw('failure copy');
                    }
                } finally {
                    selection.removeAllRanges();
                }
            } finally {
                // Reset inline style
                $document[0].body.style.webkitUserSelect = '';
            }
        }

        function copyText(text, context) {
            var left = $window.pageXOffset || $document[0].documentElement.scrollLeft;
            var top = $window.pageYOffset || $document[0].documentElement.scrollTop;
            
            var node = createNode(text, context);
            $document[0].body.appendChild(node);
            copyNode(node);

            $window.scrollTo(left, top);
            $document[0].body.removeChild(node);
        }

        return {
            copyText: copyText,
            supported: 'queryCommandSupported' in $document[0] && $document[0].queryCommandSupported('copy')
        };
    }])
    .directive('clipboard', ['clipboard', function (clipboard) {
        return {
            restrict: 'A',
            scope: {
                onCopied: '&',
                onError: '&',
                text: '=',
                supported: '=?'
            },
            link: function (scope, element) {
                scope.supported = clipboard.supported;

                element.on('click', function (event) {
                    try {
                        clipboard.copyText(scope.text, element[0]);
                        if (angular.isFunction(scope.onCopied)) {
                            scope.$evalAsync(scope.onCopied());
                        }
                    } catch (err) {
                        if (angular.isFunction(scope.onError)) {
                            scope.$evalAsync(scope.onError({err: err}));
                        }
                    }
                });
            }
        };
    }]);

}));


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(619);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/index.js!./rzslider.min.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/index.js!./rzslider.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, "/*! angularjs-slider - v2.11.0 -  (c) Rafal Zajac <rzajac@gmail.com>, Valentin Hervieu <valentin@hervieu.me>, Jussi Saarivirta <jusasi@gmail.com>, Angelin Sirbu <angelin.sirbu@gmail.com> -  https://github.com/angular-slider/angularjs-slider -  2016-04-01 */\nrzslider{position:relative;display:inline-block;width:100%;height:4px;margin:35px 0 15px 0;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}rzslider[disabled]{cursor:not-allowed}rzslider[disabled] .rz-pointer{cursor:not-allowed;background-color:#d8e0f3}rzslider span{position:absolute;display:inline-block;white-space:nowrap}rzslider .rz-base{width:100%;height:100%;padding:0}rzslider .rz-bar-wrapper{left:0;z-index:1;width:100%;height:32px;padding-top:16px;margin-top:-16px;box-sizing:border-box}rzslider .rz-bar-wrapper.rz-draggable{cursor:move}rzslider .rz-bar{left:0;z-index:1;width:100%;height:4px;background:#d8e0f3;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px}rzslider .rz-bar.rz-selection{z-index:2;background:#0db9f0;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px}rzslider .rz-pointer{top:-14px;z-index:3;width:32px;height:32px;cursor:pointer;background-color:#0db9f0;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px}rzslider .rz-pointer:after{position:absolute;top:12px;left:12px;width:8px;height:8px;background:#fff;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;content:''}rzslider .rz-pointer:hover:after{background-color:#fff}rzslider .rz-pointer.rz-active{z-index:4}rzslider .rz-pointer.rz-active:after{background-color:#451aff}rzslider .rz-bubble{bottom:16px;padding:1px 3px;color:#55637d;cursor:default}rzslider .rz-bubble.rz-selection{top:16px}rzslider .rz-bubble.rz-limit{color:#55637d}rzslider .rz-ticks{position:absolute;top:-3px;left:0;z-index:1;display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;height:0;padding:0 11px;margin:0;list-style:none;box-sizing:border-box;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}rzslider .rz-ticks .rz-tick{width:10px;height:10px;text-align:center;cursor:pointer;background:#d8e0f3;border-radius:50%}rzslider .rz-ticks .rz-tick.rz-selected{background:#0db9f0}rzslider .rz-ticks .rz-tick .rz-tick-value{position:absolute;top:-30px;transform:translate(-50%,0)}rzslider.rz-vertical{position:relative;width:4px;height:100%;padding:0;margin:0 20px;vertical-align:baseline}rzslider.rz-vertical .rz-base{width:100%;height:100%;padding:0}rzslider.rz-vertical .rz-bar-wrapper{top:auto;left:0;width:32px;height:100%;padding:0 0 0 16px;margin:0 0 0 -16px}rzslider.rz-vertical .rz-bar{bottom:0;left:auto;width:4px;height:100%}rzslider.rz-vertical .rz-pointer{top:auto;bottom:0;left:-14px!important}rzslider.rz-vertical .rz-bubble{bottom:0;left:16px!important;margin-left:3px}rzslider.rz-vertical .rz-bubble.rz-selection{top:auto;left:16px!important}rzslider.rz-vertical .rz-ticks{top:0;left:-3px;z-index:1;width:0;height:100%;padding:11px 0;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}rzslider.rz-vertical .rz-ticks .rz-tick{vertical-align:middle}rzslider.rz-vertical .rz-ticks .rz-tick .rz-tick-value{top:auto;left:22px;transform:translate(0,-28%)}", ""]);

// exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(621);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./angular-busy.min.css", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./angular-busy.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".cg-busy{position:absolute;top:0;left:0;right:0;bottom:0;z-index:1001}.cg-busy-animation.ng-hide-add,.cg-busy-animation.ng-hide-remove{-webkit-transition:all .3s ease;-moz-transition:all .3s ease;-o-transition:all .3s ease;transition:all .3s ease;display:block!important}.cg-busy-animation.ng-hide-remove{opacity:0;-webkit-transform:translate(0px,-40px);-moz-transform:translate(0px,-40px);-ms-transform:translate(0px,-40px);-o-transform:translate(0px,-40px);transform:translate(0px,-40px)}.cg-busy-animation.ng-hide-add,.cg-busy-animation.ng-hide-remove.ng-hide-remove-active{opacity:1;-webkit-transform:translate(0px,0);-moz-transform:translate(0px,0);-ms-transform:translate(0px,0);-o-transform:translate(0px,0);transform:translate(0px,0)}.cg-busy-animation.ng-hide-add.ng-hide-add-active{opacity:0;-webkit-transform:translate(0px,-40px);-moz-transform:translate(0px,-40px);-ms-transform:translate(0px,-40px);-o-transform:translate(0px,-40px);transform:translate(0px,-40px)}.cg-busy-backdrop{background-color:#fff;opacity:.7}.cg-busy-backdrop-animation.ng-hide-add,.cg-busy-backdrop-animation.ng-hide-remove{-webkit-transition:opacity .3s ease;-moz-transition:opacity .3s ease;-o-transition:opacity .3s ease;transition:opacity .3s ease;display:block!important}.cg-busy-backdrop-animation.ng-hide{opacity:0}.cg-busy-default-wrapper{text-align:center}.cg-busy-default-sign{display:inline-block;position:relative;z-index:1002;padding-bottom:6px;color:#333;text-shadow:0 1px 1px rgba(255,255,255,.75);background-color:#e9eeee;border:1px solid #ddd;border-top-width:0;-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px;border-top-left-radius:0;border-top-right-radius:0;-webkit-box-shadow:inset 0 1px 0 rgba(255,255,255,.2),0 1px 2px rgba(0,0,0,.05);-moz-box-shadow:inset 0 1px 0 rgba(255,255,255,.2),0 1px 2px rgba(0,0,0,.05);box-shadow:inset 0 1px 0 rgba(255,255,255,.2),0 1px 2px rgba(0,0,0,.05)}.cg-busy-default-text{margin:13px 12px 6px 49px;font-size:16px;color:#555;text-align:left;max-width:400px}.cg-busy-default-spinner{position:absolute;width:25px;height:25px;display:inline-block;top:12px;left:14px}.cg-busy-default-spinner div{width:12%;height:26%;background:#000;position:absolute;left:44.5%;top:37%;opacity:0;-webkit-animation:cg-busy-spinner-anim 1s linear infinite;-moz-animation:cg-busy-spinner-anim 1s linear infinite;-ms-animation:cg-busy-spinner-anim 1s linear infinite;-o-animation:cg-busy-spinner-anim 1s linear infinite;animation:cg-busy-spinner-anim 1s linear infinite;-webkit-border-radius:50px;-moz-border-radius:50px;border-radius:50px;-webkit-box-shadow:0 0 3px rgba(0,0,0,.2);-moz-box-shadow:0 0 3px rgba(0,0,0,.2);box-shadow:0 0 3px rgba(0,0,0,.2)}.cg-busy-default-spinner div.bar1{-webkit-transform:rotate(0deg) translate(0,-142%);-moz-transform:rotate(0deg) translate(0,-142%);-ms-transform:rotate(0deg) translate(0,-142%);-o-transform:rotate(0deg) translate(0,-142%);transform:rotate(0deg) translate(0,-142%);-webkit-animation-delay:0s;-moz-animation-delay:0s;-ms-animation-delay:0s;-o-animation-delay:0s;animation-delay:0s}.cg-busy-default-spinner div.bar2{-webkit-transform:rotate(30deg) translate(0,-142%);-moz-transform:rotate(30deg) translate(0,-142%);-ms-transform:rotate(30deg) translate(0,-142%);-o-transform:rotate(30deg) translate(0,-142%);transform:rotate(30deg) translate(0,-142%);-webkit-animation-delay:-.9167s;-moz-animation-delay:-.9167s;-ms-animation-delay:-.9167s;-o-animation-delay:-.9167s;animation-delay:-.9167s}.cg-busy-default-spinner div.bar3{-webkit-transform:rotate(60deg) translate(0,-142%);-moz-transform:rotate(60deg) translate(0,-142%);-ms-transform:rotate(60deg) translate(0,-142%);-o-transform:rotate(60deg) translate(0,-142%);transform:rotate(60deg) translate(0,-142%);-webkit-animation-delay:-.833s;-moz-animation-delay:-.833s;-ms-animation-delay:-.833s;-o-animation-delay:-.833s;animation-delay:-.833s}.cg-busy-default-spinner div.bar4{-webkit-transform:rotate(90deg) translate(0,-142%);-moz-transform:rotate(90deg) translate(0,-142%);-ms-transform:rotate(90deg) translate(0,-142%);-o-transform:rotate(90deg) translate(0,-142%);transform:rotate(90deg) translate(0,-142%);-webkit-animation-delay:-.75s;-moz-animation-delay:-.75s;-ms-animation-delay:-.75s;-o-animation-delay:-.75s;animation-delay:-.75s}.cg-busy-default-spinner div.bar5{-webkit-transform:rotate(120deg) translate(0,-142%);-moz-transform:rotate(120deg) translate(0,-142%);-ms-transform:rotate(120deg) translate(0,-142%);-o-transform:rotate(120deg) translate(0,-142%);transform:rotate(120deg) translate(0,-142%);-webkit-animation-delay:-.667s;-moz-animation-delay:-.667s;-ms-animation-delay:-.667s;-o-animation-delay:-.667s;animation-delay:-.667s}.cg-busy-default-spinner div.bar6{-webkit-transform:rotate(150deg) translate(0,-142%);-moz-transform:rotate(150deg) translate(0,-142%);-ms-transform:rotate(150deg) translate(0,-142%);-o-transform:rotate(150deg) translate(0,-142%);transform:rotate(150deg) translate(0,-142%);-webkit-animation-delay:-.5833s;-moz-animation-delay:-.5833s;-ms-animation-delay:-.5833s;-o-animation-delay:-.5833s;animation-delay:-.5833s}.cg-busy-default-spinner div.bar7{-webkit-transform:rotate(180deg) translate(0,-142%);-moz-transform:rotate(180deg) translate(0,-142%);-ms-transform:rotate(180deg) translate(0,-142%);-o-transform:rotate(180deg) translate(0,-142%);transform:rotate(180deg) translate(0,-142%);-webkit-animation-delay:-.5s;-moz-animation-delay:-.5s;-ms-animation-delay:-.5s;-o-animation-delay:-.5s;animation-delay:-.5s}.cg-busy-default-spinner div.bar8{-webkit-transform:rotate(210deg) translate(0,-142%);-moz-transform:rotate(210deg) translate(0,-142%);-ms-transform:rotate(210deg) translate(0,-142%);-o-transform:rotate(210deg) translate(0,-142%);transform:rotate(210deg) translate(0,-142%);-webkit-animation-delay:-.41667s;-moz-animation-delay:-.41667s;-ms-animation-delay:-.41667s;-o-animation-delay:-.41667s;animation-delay:-.41667s}.cg-busy-default-spinner div.bar9{-webkit-transform:rotate(240deg) translate(0,-142%);-moz-transform:rotate(240deg) translate(0,-142%);-ms-transform:rotate(240deg) translate(0,-142%);-o-transform:rotate(240deg) translate(0,-142%);transform:rotate(240deg) translate(0,-142%);-webkit-animation-delay:-.333s;-moz-animation-delay:-.333s;-ms-animation-delay:-.333s;-o-animation-delay:-.333s;animation-delay:-.333s}.cg-busy-default-spinner div.bar10{-webkit-transform:rotate(270deg) translate(0,-142%);-moz-transform:rotate(270deg) translate(0,-142%);-ms-transform:rotate(270deg) translate(0,-142%);-o-transform:rotate(270deg) translate(0,-142%);transform:rotate(270deg) translate(0,-142%);-webkit-animation-delay:-.25s;-moz-animation-delay:-.25s;-ms-animation-delay:-.25s;-o-animation-delay:-.25s;animation-delay:-.25s}.cg-busy-default-spinner div.bar11{-webkit-transform:rotate(300deg) translate(0,-142%);-moz-transform:rotate(300deg) translate(0,-142%);-ms-transform:rotate(300deg) translate(0,-142%);-o-transform:rotate(300deg) translate(0,-142%);transform:rotate(300deg) translate(0,-142%);-webkit-animation-delay:-.1667s;-moz-animation-delay:-.1667s;-ms-animation-delay:-.1667s;-o-animation-delay:-.1667s;animation-delay:-.1667s}.cg-busy-default-spinner div.bar12{-webkit-transform:rotate(330deg) translate(0,-142%);-moz-transform:rotate(330deg) translate(0,-142%);-ms-transform:rotate(330deg) translate(0,-142%);-o-transform:rotate(330deg) translate(0,-142%);transform:rotate(330deg) translate(0,-142%);-webkit-animation-delay:-.0833s;-moz-animation-delay:-.0833s;-ms-animation-delay:-.0833s;-o-animation-delay:-.0833s;animation-delay:-.0833s}@-webkit-keyframes cg-busy-spinner-anim{from{opacity:1}to{opacity:.25}}@-moz-keyframes cg-busy-spinner-anim{from{opacity:1}to{opacity:.25}}@keyframes cg-busy-spinner-anim{from{opacity:1}to{opacity:.25}}", ""]);

// exports


/***/ }),
/* 622 */
/***/ (function(module, exports) {

angular.module("cgBusy",[]),angular.module("cgBusy").factory("_cgBusyTrackerFactory",["$timeout","$q",function(a,b){return function(){var c={};c.promises=[],c.delayPromise=null,c.durationPromise=null,c.delayJustFinished=!1,c.reset=function(b){c.minDuration=b.minDuration,c.promises=[],angular.forEach(b.promises,function(a){a&&!a.$cgBusyFulfilled&&d(a)}),0!==c.promises.length&&(c.delayJustFinished=!1,b.delay&&(c.delayPromise=a(function(){c.delayPromise=null,c.delayJustFinished=!0},parseInt(b.delay,10))),b.minDuration&&(c.durationPromise=a(function(){c.durationPromise=null},parseInt(b.minDuration,10)+(b.delay?parseInt(b.delay,10):0))))},c.isPromise=function(a){var b=a&&(a.then||a.$then||a.$promise&&a.$promise.then);return"undefined"!=typeof b},c.callThen=function(a,c,d){var e;a.then||a.$then?e=a:a.$promise?e=a.$promise:a.denodeify&&(e=b.when(a));var f=e.then||e.$then;f.call(e,c,d)};var d=function(a){if(!c.isPromise(a))throw new Error("cgBusy expects a promise (or something that has a .promise or .$promise");-1===c.promises.indexOf(a)&&(c.promises.push(a),c.callThen(a,function(){a.$cgBusyFulfilled=!0,-1!==c.promises.indexOf(a)&&c.promises.splice(c.promises.indexOf(a),1)},function(){a.$cgBusyFulfilled=!0,-1!==c.promises.indexOf(a)&&c.promises.splice(c.promises.indexOf(a),1)}))};return c.active=function(){return c.delayPromise?!1:c.delayJustFinished?(c.delayJustFinished=!1,0===c.promises.length&&(c.durationPromise=null),c.promises.length>0):c.durationPromise?!0:c.promises.length>0},c}}]),angular.module("cgBusy").value("cgBusyDefaults",{}),angular.module("cgBusy").directive("cgBusy",["$compile","$templateCache","cgBusyDefaults","$http","_cgBusyTrackerFactory",function(a,b,c,d,e){return{restrict:"A",link:function(f,g,h){var i=g.css("position");("static"===i||""===i||"undefined"==typeof i)&&g.css("position","relative");var j,k,l,m,n,o=e(),p={templateUrl:"angular-busy.html",delay:0,minDuration:0,backdrop:!0,message:"Please Wait...",wrapperClass:"cg-busy cg-busy-animation"};angular.extend(p,c),f.$watchCollection(h.cgBusy,function(c){if(c||(c={promise:null}),angular.isString(c))throw new Error("Invalid value for cg-busy. cgBusy no longer accepts string ids to represent promises/trackers.");(angular.isArray(c)||o.isPromise(c))&&(c={promise:c}),c=angular.extend(angular.copy(p),c),c.templateUrl||(c.templateUrl=p.templateUrl),angular.isArray(c.promise)||(c.promise=[c.promise]),m||(m=f.$new()),m.$message=c.message,angular.equals(o.promises,c.promise)||o.reset({promises:c.promise,delay:c.delay,minDuration:c.minDuration}),m.$cgBusyIsActive=function(){return o.active()},j&&l===c.templateUrl&&n===c.backdrop||(j&&j.remove(),k&&k.remove(),l=c.templateUrl,n=c.backdrop,d.get(l,{cache:b}).then(function(b){if(c.backdrop="undefined"==typeof c.backdrop?!0:c.backdrop,c.backdrop){var d='<div class="cg-busy cg-busy-backdrop cg-busy-backdrop-animation ng-hide" ng-show="$cgBusyIsActive()"></div>';k=a(d)(m),g.append(k)}var e='<div class="'+c.wrapperClass+' ng-hide" ng-show="$cgBusyIsActive()">'+b.data+"</div>";j=a(e)(m),angular.element(j.children()[0]).css("position","absolute").css("top",0).css("left",0).css("right",0).css("bottom",0),g.append(j)},function(a){throw new Error("Template specified for cgBusy ("+c.templateUrl+") could not be loaded. "+a)}))},!0)}}}]),angular.module("cgBusy").run(["$templateCache",function(a){"use strict";a.put("angular-busy.html",'<div class="cg-busy-default-wrapper">\n\n   <div class="cg-busy-default-sign">\n\n      <div class="cg-busy-default-spinner">\n         <div class="bar1"></div>\n         <div class="bar2"></div>\n         <div class="bar3"></div>\n         <div class="bar4"></div>\n         <div class="bar5"></div>\n         <div class="bar6"></div>\n         <div class="bar7"></div>\n         <div class="bar8"></div>\n         <div class="bar9"></div>\n         <div class="bar10"></div>\n         <div class="bar11"></div>\n         <div class="bar12"></div>\n      </div>\n\n      <div class="cg-busy-default-text">{{$message}}</div>\n\n   </div>\n\n</div>')}]);

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(624);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./selectize.default.css", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./selectize.default.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, "/**\n * selectize.default.css (v0.12.6) - Default Theme\n * Copyright (c) 2013–2015 Brian Reavis & contributors\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\"); you may not use this\n * file except in compliance with the License. You may obtain a copy of the License at:\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software distributed under\n * the License is distributed on an \"AS IS\" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF\n * ANY KIND, either express or implied. See the License for the specific language\n * governing permissions and limitations under the License.\n *\n * @author Brian Reavis <brian@thirdroute.com>\n */\n.selectize-control.plugin-drag_drop.multi > .selectize-input > div.ui-sortable-placeholder {\n  visibility: visible !important;\n  background: #f2f2f2 !important;\n  background: rgba(0, 0, 0, 0.06) !important;\n  border: 0 none !important;\n  -webkit-box-shadow: inset 0 0 12px 4px #fff;\n  box-shadow: inset 0 0 12px 4px #fff;\n}\n.selectize-control.plugin-drag_drop .ui-sortable-placeholder::after {\n  content: '!';\n  visibility: hidden;\n}\n.selectize-control.plugin-drag_drop .ui-sortable-helper {\n  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n.selectize-dropdown-header {\n  position: relative;\n  padding: 5px 8px;\n  border-bottom: 1px solid #d0d0d0;\n  background: #f8f8f8;\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.selectize-dropdown-header-close {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  color: #303030;\n  opacity: 0.4;\n  margin-top: -12px;\n  line-height: 20px;\n  font-size: 20px !important;\n}\n.selectize-dropdown-header-close:hover {\n  color: #000000;\n}\n.selectize-dropdown.plugin-optgroup_columns .optgroup {\n  border-right: 1px solid #f2f2f2;\n  border-top: 0 none;\n  float: left;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.selectize-dropdown.plugin-optgroup_columns .optgroup:last-child {\n  border-right: 0 none;\n}\n.selectize-dropdown.plugin-optgroup_columns .optgroup:before {\n  display: none;\n}\n.selectize-dropdown.plugin-optgroup_columns .optgroup-header {\n  border-top: 0 none;\n}\n.selectize-control.plugin-remove_button [data-value] {\n  position: relative;\n  padding-right: 24px !important;\n}\n.selectize-control.plugin-remove_button [data-value] .remove {\n  z-index: 1;\n  /* fixes ie bug (see #392) */\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 17px;\n  text-align: center;\n  font-weight: bold;\n  font-size: 12px;\n  color: inherit;\n  text-decoration: none;\n  vertical-align: middle;\n  display: inline-block;\n  padding: 2px 0 0 0;\n  border-left: 1px solid #0073bb;\n  -webkit-border-radius: 0 2px 2px 0;\n  -moz-border-radius: 0 2px 2px 0;\n  border-radius: 0 2px 2px 0;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.selectize-control.plugin-remove_button [data-value] .remove:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n.selectize-control.plugin-remove_button [data-value].active .remove {\n  border-left-color: #00578d;\n}\n.selectize-control.plugin-remove_button .disabled [data-value] .remove:hover {\n  background: none;\n}\n.selectize-control.plugin-remove_button .disabled [data-value] .remove {\n  border-left-color: #aaaaaa;\n}\n.selectize-control.plugin-remove_button .remove-single {\n  position: absolute;\n  right: 0;\n  top: 0;\n  font-size: 23px;\n}\n.selectize-control {\n  position: relative;\n}\n.selectize-dropdown,\n.selectize-input,\n.selectize-input input {\n  color: #303030;\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 18px;\n  -webkit-font-smoothing: inherit;\n}\n.selectize-input,\n.selectize-control.single .selectize-input.input-active {\n  background: #fff;\n  cursor: text;\n  display: inline-block;\n}\n.selectize-input {\n  border: 1px solid #d0d0d0;\n  padding: 8px 8px;\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1);\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n}\n.selectize-control.multi .selectize-input.has-items {\n  padding: 5px 8px 2px;\n}\n.selectize-input.full {\n  background-color: #fff;\n}\n.selectize-input.disabled,\n.selectize-input.disabled * {\n  cursor: default !important;\n}\n.selectize-input.focus {\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);\n}\n.selectize-input.dropdown-active {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.selectize-input > * {\n  vertical-align: baseline;\n  display: -moz-inline-stack;\n  display: inline-block;\n  zoom: 1;\n  *display: inline;\n}\n.selectize-control.multi .selectize-input > div {\n  cursor: pointer;\n  margin: 0 3px 3px 0;\n  padding: 2px 6px;\n  background: #1da7ee;\n  color: #fff;\n  border: 1px solid #0073bb;\n}\n.selectize-control.multi .selectize-input > div.active {\n  background: #92c836;\n  color: #fff;\n  border: 1px solid #00578d;\n}\n.selectize-control.multi .selectize-input.disabled > div,\n.selectize-control.multi .selectize-input.disabled > div.active {\n  color: #ffffff;\n  background: #d2d2d2;\n  border: 1px solid #aaaaaa;\n}\n.selectize-input > input {\n  display: inline-block !important;\n  padding: 0 !important;\n  min-height: 0 !important;\n  max-height: none !important;\n  max-width: 100% !important;\n  margin: 0 1px !important;\n  text-indent: 0 !important;\n  border: 0 none !important;\n  background: none !important;\n  line-height: inherit !important;\n  -webkit-user-select: auto !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n.selectize-input > input::-ms-clear {\n  display: none;\n}\n.selectize-input > input:focus {\n  outline: none !important;\n}\n.selectize-input::after {\n  content: ' ';\n  display: block;\n  clear: left;\n}\n.selectize-input.dropdown-active::before {\n  content: ' ';\n  display: block;\n  position: absolute;\n  background: #f0f0f0;\n  height: 1px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.selectize-dropdown {\n  position: absolute;\n  z-index: 10;\n  border: 1px solid #d0d0d0;\n  background: #fff;\n  margin: -1px 0 0 0;\n  border-top: 0 none;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.selectize-dropdown [data-selectable] {\n  cursor: pointer;\n  overflow: hidden;\n}\n.selectize-dropdown [data-selectable] .highlight {\n  background: rgba(125, 168, 208, 0.2);\n  -webkit-border-radius: 1px;\n  -moz-border-radius: 1px;\n  border-radius: 1px;\n}\n.selectize-dropdown .option,\n.selectize-dropdown .optgroup-header {\n  padding: 5px 8px;\n}\n.selectize-dropdown .option,\n.selectize-dropdown [data-disabled],\n.selectize-dropdown [data-disabled] [data-selectable].option {\n  cursor: inherit;\n  opacity: 0.5;\n}\n.selectize-dropdown [data-selectable].option {\n  opacity: 1;\n}\n.selectize-dropdown .optgroup:first-child .optgroup-header {\n  border-top: 0 none;\n}\n.selectize-dropdown .optgroup-header {\n  color: #303030;\n  background: #fff;\n  cursor: default;\n}\n.selectize-dropdown .active {\n  background-color: #f5fafd;\n  color: #495c68;\n}\n.selectize-dropdown .active.create {\n  color: #495c68;\n}\n.selectize-dropdown .create {\n  color: rgba(48, 48, 48, 0.5);\n}\n.selectize-dropdown-content {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 200px;\n  -webkit-overflow-scrolling: touch;\n}\n.selectize-control.single .selectize-input,\n.selectize-control.single .selectize-input input {\n  cursor: pointer;\n}\n.selectize-control.single .selectize-input.input-active,\n.selectize-control.single .selectize-input.input-active input {\n  cursor: text;\n}\n.selectize-control.single .selectize-input:after {\n  content: ' ';\n  display: block;\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  margin-top: -3px;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 5px 5px 0 5px;\n  border-color: #808080 transparent transparent transparent;\n}\n.selectize-control.single .selectize-input.dropdown-active:after {\n  margin-top: -4px;\n  border-width: 0 5px 5px 5px;\n  border-color: transparent transparent #808080 transparent;\n}\n.selectize-control.rtl.single .selectize-input:after {\n  left: 15px;\n  right: auto;\n}\n.selectize-control.rtl .selectize-input > input {\n  margin: 0 4px 0 -2px !important;\n}\n.selectize-control .selectize-input.disabled {\n  opacity: 0.5;\n  background-color: #fafafa;\n}\n.selectize-control.multi .selectize-input.has-items {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.selectize-control.multi .selectize-input.disabled [data-value] {\n  color: #999;\n  text-shadow: none;\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.selectize-control.multi .selectize-input.disabled [data-value],\n.selectize-control.multi .selectize-input.disabled [data-value] .remove {\n  border-color: #e6e6e6;\n}\n.selectize-control.multi .selectize-input.disabled [data-value] .remove {\n  background: none;\n}\n.selectize-control.multi .selectize-input [data-value] {\n  text-shadow: 0 1px 0 rgba(0, 51, 83, 0.3);\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n  background-color: #1b9dec;\n  background-image: -moz-linear-gradient(top, #1da7ee, #178ee9);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#1da7ee), to(#178ee9));\n  background-image: -webkit-linear-gradient(top, #1da7ee, #178ee9);\n  background-image: -o-linear-gradient(top, #1da7ee, #178ee9);\n  background-image: linear-gradient(to bottom, #1da7ee, #178ee9);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff1da7ee', endColorstr='#ff178ee9', GradientType=0);\n  -webkit-box-shadow: 0 1px 0 rgba(0,0,0,0.2),inset 0 1px rgba(255,255,255,0.03);\n  box-shadow: 0 1px 0 rgba(0,0,0,0.2),inset 0 1px rgba(255,255,255,0.03);\n}\n.selectize-control.multi .selectize-input [data-value].active {\n  background-color: #0085d4;\n  background-image: -moz-linear-gradient(top, #008fd8, #0075cf);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#008fd8), to(#0075cf));\n  background-image: -webkit-linear-gradient(top, #008fd8, #0075cf);\n  background-image: -o-linear-gradient(top, #008fd8, #0075cf);\n  background-image: linear-gradient(to bottom, #008fd8, #0075cf);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff008fd8', endColorstr='#ff0075cf', GradientType=0);\n}\n.selectize-control.single .selectize-input {\n  -webkit-box-shadow: 0 1px 0 rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.8);\n  box-shadow: 0 1px 0 rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.8);\n  background-color: #f9f9f9;\n  background-image: -moz-linear-gradient(top, #fefefe, #f2f2f2);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#fefefe), to(#f2f2f2));\n  background-image: -webkit-linear-gradient(top, #fefefe, #f2f2f2);\n  background-image: -o-linear-gradient(top, #fefefe, #f2f2f2);\n  background-image: linear-gradient(to bottom, #fefefe, #f2f2f2);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffefefe', endColorstr='#fff2f2f2', GradientType=0);\n}\n.selectize-control.single .selectize-input,\n.selectize-dropdown.single {\n  border-color: #b8b8b8;\n}\n.selectize-dropdown .optgroup-header {\n  padding-top: 7px;\n  font-weight: bold;\n  font-size: 0.85em;\n}\n.selectize-dropdown .optgroup {\n  border-top: 1px solid #f0f0f0;\n}\n.selectize-dropdown .optgroup:first-child {\n  border-top: 0 none;\n}\n", ""]);

// exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Selectize"] = __webpack_require__(194);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 626 */
/***/ (function(module, exports) {

/**
 * Angular Selectize2
 * https://github.com/machineboy2045/angular-selectize
 **/

angular.module('selectize', []).value('selectizeConfig', {}).directive("selectize", ['selectizeConfig', function(selectizeConfig) {
  return {
    restrict: 'EA',
    require: '^ngModel',
    scope: { ngModel: '=', config: '=?', options: '=?', ngDisabled: '=', ngRequired: '&' },
    link: function(scope, element, attrs, modelCtrl) {

      var selectize,
          settings = angular.extend({}, Selectize.defaults, selectizeConfig, scope.config);

      scope.options = scope.options || [];
      scope.config = scope.config || {};

      var isEmpty = function(val) {
        return val === undefined || val === null || !val.length; //support checking empty arrays
      };

      var toggle = function(disabled) {
        disabled ? selectize.disable() : selectize.enable();
      }

      var validate = function() {
        var isInvalid = (scope.ngRequired() || attrs.required || settings.required) && isEmpty(scope.ngModel);
        modelCtrl.$setValidity('required', !isInvalid);
      };

      var setSelectizeOptions = function(curr, prev) {
        angular.forEach(prev, function(opt){
          if(curr.indexOf(opt) === -1){
            var value = opt[settings.valueField];
            selectize.removeOption(value, true);
          }
        });

        selectize.addOption(curr, true);

        setSelectizeValue();
      }

      var setSelectizeValue = function() {
        validate();

        selectize.$control.toggleClass('ng-valid', modelCtrl.$valid);
        selectize.$control.toggleClass('ng-invalid', modelCtrl.$invalid);
        selectize.$control.toggleClass('ng-dirty', modelCtrl.$dirty);
        selectize.$control.toggleClass('ng-pristine', modelCtrl.$pristine);

        if (!angular.equals(selectize.items, scope.ngModel)) {
          selectize.setValue(scope.ngModel, true);
        }
      }

      settings.onChange = function(value) {
        var value = angular.copy(selectize.items);
        if (settings.maxItems == 1) {
          value = value[0]
        }
        modelCtrl.$setViewValue( value );

        if (scope.config.onChange) {
          scope.config.onChange.apply(this, arguments);
        }
      };

      settings.onOptionAdd = function(value, data) {
        if( scope.options.indexOf(data) === -1 ) {
          scope.options.push(data);

          if (scope.config.onOptionAdd) {
            scope.config.onOptionAdd.apply(this, arguments);
          }
        }
      };

      settings.onInitialize = function() {
        selectize = element[0].selectize;

        setSelectizeOptions(scope.options);

        //provides a way to access the selectize element from an
        //angular controller
        if (scope.config.onInitialize) {
          scope.config.onInitialize(selectize);
        }

        scope.$watchCollection('options', setSelectizeOptions);
        scope.$watch('ngModel', setSelectizeValue);
        scope.$watch('ngDisabled', toggle);
      };

      element.selectize(settings);

      element.on('$destroy', function() {
        if (selectize) {
          selectize.destroy();
          element = null;
        }
      });
    }
  };
}]);


/***/ }),
/* 627 */
/***/ (function(module, exports) {

!function(t,e,i,n){"use strict";i.module("ngFitText",[]).value("fitTextDefaultConfig",{debounce:!1,delay:250,loadDelay:10,compressor:1,min:0,max:Number.POSITIVE_INFINITY}).directive("fittext",["$timeout","fitTextDefaultConfig","fitTextConfig",function(e,n,o){return{restrict:"A",scope:!0,link:function(f,a,l){function r(){var t=T*h/s.offsetWidth/h;return Math.max(Math.min((c[0].offsetWidth-6)*t*p,parseFloat(y)),parseFloat(m))}function u(){s.offsetHeight*s.offsetWidth!==0&&(d.fontSize=T+"px",d.lineHeight="1",d.display="inline-block",d.fontSize=r()+"px",d.lineHeight=b,d.display=v)}i.extend(n,o.config);var c=a.parent(),s=a[0],d=s.style,x=t.getComputedStyle(a[0],null),h=a.children().length||1,g=l.fittextLoadDelay||n.loadDelay,p=l.fittext||n.compressor,m=("inherit"===l.fittextMin?x["font-size"]:l.fittextMin)||n.min,y=("inherit"===l.fittextMax?x["font-size"]:l.fittextMax)||n.max,b=x["line-height"],v=x.display,T=10;e(function(){u()},g),f.$watch(l.ngBind,function(){u()}),n.debounce?i.element(t).bind("resize",n.debounce(function(){f.$apply(u)},n.delay)):i.element(t).bind("resize",function(){f.$apply(u)})}}}]).provider("fitTextConfig",function(){var t=this;return this.config={},this.$get=function(){var e={};return e.config=t.config,e},this})}(window,document,angular);

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["tinycolor"] = __webpack_require__(34);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(630);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/index.js!./angularjs-color-picker.min.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/index.js!./angularjs-color-picker.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, "/*!\r\n * angularjs-color-picker v3.4.8\r\n * https://github.com/ruhley/angular-color-picker/\r\n *\r\n * Copyright 2017 ruhley\r\n *\r\n * 2017-10-06 09:52:03\r\n *\r\n */.color-picker-wrapper{position:relative}.color-picker-wrapper .color-picker-input-wrapper{display:table;position:relative}.color-picker-wrapper .input-group{position:relative;border-collapse:separate}.color-picker-wrapper .input-group .color-picker-input,.color-picker-wrapper .input-group .input-group-addon{display:table-cell}.color-picker-wrapper .input-group .color-picker-input{position:relative;z-index:2;float:left;margin-bottom:0}.color-picker-wrapper .input-group .input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc}.color-picker-wrapper .input-group .input-group-addon:first-child{border-right-width:0}.color-picker-wrapper .input-group .input-group-addon:last-child{border-left-width:0}.color-picker-wrapper .input-group .color-picker-input-swatch{padding-left:12px}.color-picker-wrapper .color-picker-input-swatch{padding-left:36px}.color-picker-wrapper .color-picker-swatch{cursor:pointer;z-index:3}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon){position:absolute;top:3px;width:28px;height:70%;box-sizing:border-box;border-radius:3px;vertical-align:middle;background-position:-80px 0;border:solid 1px #ccc;padding:0;margin:0;display:inline-block}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon).color-picker-swatch-left{left:3px}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon).color-picker-swatch-right{right:3px}.color-picker-wrapper .color-picker-panel{position:absolute;background:#fff;border:solid 1px #ccc;box-shadow:0 0 20px rgba(0,0,0,.5);z-index:99999;width:150px;table-layout:fixed;border:1px solid #fff;padding-right:1px;box-sizing:content-box}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper{display:table;width:100%}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row{display:table-row}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-overlay{position:absolute;width:100%;height:150px;top:0;left:0;z-index:2}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation{background-image:linear-gradient(45deg,grey 25%,transparent 25%),linear-gradient(-45deg,grey 25%,transparent 25%),linear-gradient(45deg,transparent 75%,grey 75%),linear-gradient(-45deg,transparent 75%,grey 75%);background-size:10px 10px;background-position:0 0,0 5px,5px -5px,-5px 0}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation{display:table-cell;position:relative;left:1px;width:20px;background-color:#fff;cursor:row-resize}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-slider{position:absolute;top:0;left:0;width:18px;height:2px;background:#fff;border:solid 1px #000;box-sizing:content-box;margin-top:-1px;z-index:3}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid{display:table-cell;position:relative;width:150px;height:150px;cursor:crosshair}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-grid-inner{width:150px;height:150px;z-index:9}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-overlay{background-image:url(data:image/png;base64,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);pointer-events:none}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-picker{position:absolute;top:70px;left:70px;width:12px;height:12px;border:solid 1px #000;border-radius:10px;margin-top:-6px;margin-left:-6px;background:0 0;box-sizing:content-box;z-index:99}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-picker>div{position:absolute;top:0;left:0;width:8px;height:8px;border-radius:8px;border:solid 2px #fff;box-sizing:content-box}.color-picker-wrapper .color-picker-panel .color-picker-actions .color-picker-action{width:calc(33.3333% - 6px);margin:3px}.color-picker-wrapper .color-picker-panel.color-picker-show-inline{position:relative}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation.color-picker-show-lightness.color-picker-show-alpha{width:230px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation.color-picker-show-lightness{width:210px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation.color-picker-show-alpha{width:210px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-lightness.color-picker-show-alpha{width:210px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-lightness{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-alpha{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-saturation.color-picker-show-alpha{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-saturation.color-picker-show-lightness{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-saturation.color-picker-show-lightness.color-picker-show-alpha{width:210px}.color-picker-wrapper .color-picker-panel.color-picker-show-lightness.color-picker-show-alpha{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue{width:170px}.color-picker-wrapper .color-picker-panel.color-picker-show-saturation{width:170px}.color-picker-wrapper .color-picker-panel.color-picker-show-lightness{width:170px}.color-picker-wrapper .color-picker-panel.color-picker-show-alpha{width:170px}.color-picker-wrapper .color-picker-panel.color-picker-panel-bottom{top:auto}.color-picker-wrapper .color-picker-panel.color-picker-panel-top{bottom:100%}.color-picker-wrapper .color-picker-panel.color-picker-panel-left{left:0}.color-picker-wrapper .color-picker-panel.color-picker-panel-right{right:0}.color-picker-wrapper .color-picker-panel.color-picker-panel-round .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-overlay{background-image:url(data:image/png;base64,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);border-radius:50%}.color-picker-wrapper .color-picker-panel.color-picker-panel-round .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-grid-inner{background-color:#fff}.color-picker-wrapper .color-picker-hidden{display:none}.color-picker-wrapper.color-picker-disabled .color-picker-grid,.color-picker-wrapper.color-picker-disabled .color-picker-hue,.color-picker-wrapper.color-picker-disabled .color-picker-input,.color-picker-wrapper.color-picker-disabled .color-picker-opacity,.color-picker-wrapper.color-picker-disabled .color-picker-swatch{cursor:not-allowed!important}.color-picker-wrapper.color-picker-swatch-only .color-picker-input{padding-left:33px;padding-right:0;width:35px}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon{width:35px;height:100%;border-right:1px solid #ccc}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon:first-child{border-right-width:1px}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon:last-child{border-left-width:1px}.color-picker-wrapper.color-picker-swatch-only .input-group .color-picker-input{padding:0;width:1px;opacity:0;cursor:pointer}.color-picker-wrapper.color-picker-swatch-only .input-group .color-picker-input:focus{outline:0}.color-picker-wrapper.color-picker-closed .color-picker-panel{display:none}.color-picker-wrapper.color-picker-horizontal .color-picker-panel{width:150px!important}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row{display:block}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid{display:block}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation{cursor:col-resize;display:block;left:0;width:150px;height:20px}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue .color-picker-overlay,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness .color-picker-overlay,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity .color-picker-overlay,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation .color-picker-overlay{height:20px}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue .color-picker-slider,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness .color-picker-slider,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity .color-picker-slider,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation .color-picker-slider{width:2px;height:18px;margin-top:0}", ""]);

// exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(632);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./angularjs-color-picker-bootstrap.min.css", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./angularjs-color-picker-bootstrap.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, "/*!\r\n * angularjs-color-picker v3.4.8\r\n * https://github.com/ruhley/angular-color-picker/\r\n *\r\n * Copyright 2017 ruhley\r\n *\r\n * 2017-10-06 09:52:03\r\n *\r\n */.color-picker-wrapper .color-picker-input-wrapper{width:100%}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon){height:28px}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon{border-radius:4px}", ""]);

// exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(634)
module.exports = 'angulartics.google.analytics'


/***/ }),
/* 634 */
/***/ (function(module, exports) {

(function(window, angular, undefined) {'use strict';

/**
 * @ngdoc overview
 * @name angulartics.google.analytics
 * Enables analytics support for Google Analytics (http://google.com/analytics)
 */
angular.module('angulartics.google.analytics', ['angulartics'])
.config(['$analyticsProvider', function ($analyticsProvider) {

  // GA already supports buffered invocations so we don't need
  // to wrap these inside angulartics.waitForVendorApi

  $analyticsProvider.settings.pageTracking.trackRelativePath = true;

  // Set the default settings for this module
  $analyticsProvider.settings.ga = {
    // array of additional account names (only works for analyticsjs)
    additionalAccountNames: undefined,
    userId: null
  };

  function setDimensionsAndMetrics(properties) {
    if (window.ga) {
      // add custom dimensions and metrics
      for(var idx = 1; idx<=200;idx++) {
        if (properties['dimension' +idx.toString()]) {
          ga('set', 'dimension' +idx.toString(), properties['dimension' +idx.toString()]);
        }
        if (properties['metric' +idx.toString()]) {
          ga('set', 'metric' +idx.toString(), properties['metric' +idx.toString()]);
        }
      }
    }
  }

  $analyticsProvider.registerPageTrack(function (path) {
    if (window._gaq) {
      _gaq.push(['_trackPageview', path]);
      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
        _gaq.push([accountName + '._trackPageview', path]);
      });
    }
    if (window.ga) {
      if ($analyticsProvider.settings.ga.userId) {
        ga('set', '&uid', $analyticsProvider.settings.ga.userId);
      }
      ga('send', 'pageview', path);
      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
        ga(accountName +'.send', 'pageview', path);
      });
    }
  });

  /**
   * Track Event in GA
   * @name eventTrack
   *
   * @param {string} action Required 'action' (string) associated with the event
   * @param {object} properties Comprised of the mandatory field 'category' (string) and optional  fields 'label' (string), 'value' (integer) and 'noninteraction' (boolean)
   *
   * @link https://developers.google.com/analytics/devguides/collection/gajs/eventTrackerGuide#SettingUpEventTracking
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
   */
  $analyticsProvider.registerEventTrack(function (action, properties) {

    // Google Analytics requires an Event Category
    if (!properties || !properties.category) {
      properties = properties || {};
      properties.category = 'Event';
    }
    // GA requires that eventValue be an integer, see:
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#eventValue
    // https://github.com/luisfarzati/angulartics/issues/81
    if (properties.value) {
      var parsed = parseInt(properties.value, 10);
      properties.value = isNaN(parsed) ? 0 : parsed;
    }

    if (window.ga) {

      var eventOptions = {
        eventCategory: properties.category,
        eventAction: action,
        eventLabel: properties.label,
        eventValue: properties.value,
        nonInteraction: properties.noninteraction,
        page: properties.page || window.location.hash.substring(1) || window.location.pathname,
        userId: $analyticsProvider.settings.ga.userId
      };

      // add custom dimensions and metrics
      setDimensionsAndMetrics(properties);

      if ($analyticsProvider.settings.ga.transport) {
        ga('send', 'event', eventOptions, { transport: $analyticsProvider.settings.ga.transport});
      }
      else {
        ga('send', 'event', eventOptions);
      }

      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
        ga(accountName +'.send', 'event', eventOptions);
      });
    }

    else if (window._gaq) {
      _gaq.push(['_trackEvent', properties.category, action, properties.label, properties.value, properties.noninteraction]);
    }

  });

  /**
   * Exception Track Event in GA
   * @name exceptionTrack
   *
   * @param {object} properties Comprised of the mandatory fields 'appId' (string), 'appName' (string) and 'appVersion' (string) and 
   * optional  fields 'fatal' (boolean) and 'description' (string)
   *
   * @https://developers.google.com/analytics/devguides/collection/analyticsjs/exceptions
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
   */
  $analyticsProvider.registerExceptionTrack(function (properties) {
    if (!properties || !properties.appId || !properties.appName || !properties.appVersion) {
        console.error('Must be setted appId, appName and appVersion.');
        return;
    }

    if(properties.fatal === undefined) {
        console.log('No "fatal" provided, sending with fatal=true');
        properties.exFatal = true;
    }

    properties.exDescription = properties.description;

    ga('send', 'exception', properties);
  });

  $analyticsProvider.registerSetUsername(function (userId) {
    $analyticsProvider.settings.ga.userId = userId;
  });

  $analyticsProvider.registerSetUserProperties(function (properties) {
    // add custom dimensions and metrics
    setDimensionsAndMetrics(properties);
  });

  /**
   * User Timings Event in GA
   * @name userTimings
   *
   * @param {object} properties Comprised of the mandatory fields:
   *     'timingCategory' (string),
   *     'timingVar' (string),
   *     'timingValue' (number)
   * Properties can also have the optional fields:
   *     'timingLabel' (string)
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings
   */
  $analyticsProvider.registerUserTimings(function (properties) {
    if (!properties || !properties.timingCategory || !properties.timingVar || !properties.timingValue) {
      console.error('Properties timingCategory, timingVar, and timingValue are required to be set.');
      return;
    }

    if(window.ga) {
      ga('send', 'timing', properties);
    }
  });

}]);
})(window, window.angular);


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(636);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!../postcss-loader/index.js!./toaster.min.css", function() {
			var newContent = require("!!../css-loader/index.js!../postcss-loader/index.js!./toaster.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, "/*!\r\n * Toastr\r\n * Version 2.0.1\r\n * Copyright 2012 John Papa and Hans Fjallemark.\r\n * All Rights Reserved.\r\n * Use, reproduction, distribution, and modification of this code is subject to the terms and\r\n * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php\r\n *\r\n * Author: John Papa and Hans Fjallemark\r\n * Project: https://github.com/CodeSeven/toastr\r\n */\r\n.toast-title{font-weight:700}.toast-message{-ms-word-wrap:break-word;word-wrap:break-word}.toast-message a,.toast-message label{color:#fff}.toast-message a:hover{color:#ccc;text-decoration:none}.toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}.toast-close-button:focus,.toast-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}button.toast-close-button{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-center{top:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-center{bottom:12px}.toast-bottom-left{bottom:12px;left:12px}.toast-center{top:45%}#toast-container{position:fixed;z-index:999999;pointer-events:auto;}#toast-container.toast-bottom-center,#toast-container.toast-center,#toast-container.toast-top-center{width:100%;pointer-events:none}#toast-container.toast-bottom-center>div,#toast-container.toast-center>div,#toast-container.toast-top-center>div{margin:auto;pointer-events:auto}#toast-container.toast-bottom-center>button,#toast-container.toast-center>button,#toast-container.toast-top-cente>button{pointer-events:auto}#toast-container *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}#toast-container>div{margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;background-position:15px center;background-repeat:no-repeat;-moz-box-shadow:0 0 12px #999;-webkit-box-shadow:0 0 12px #999;box-shadow:0 0 12px #999;color:#fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}#toast-container>:hover{-moz-box-shadow:0 0 12px #000;-webkit-box-shadow:0 0 12px #000;box-shadow:0 0 12px #000;opacity:1;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);filter:alpha(opacity=100);cursor:pointer}#toast-container>.toast-info{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=)!important}#toast-container>.toast-wait{background-image:url(data:image/gif;base64,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)!important}#toast-container>.toast-error{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=)!important}#toast-container>.toast-success{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==)!important}#toast-container>.toast-warning{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=)!important}#toast-container.toast-bottom-full-width>div,#toast-container.toast-top-full-width>div{width:96%;margin:auto}.toast{background-color:#030303}.toast-success{background-color:#51a351}.toast-error{background-color:#bd362f}.toast-info,.toast-wait{background-color:#2f96b4}.toast-warning{background-color:#f89406}@media all and (max-width:240px){#toast-container>div{padding:8px 8px 8px 50px;width:11em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media all and (min-width:241px) and (max-width:480px){#toast-container>div{padding:8px 8px 8px 50px;width:18em}#toast-container .toast-close-button{right:-.2em;top:-.2em}}@media all and (min-width:481px) and (max-width:768px){#toast-container>div{padding:15px 15px 15px 50px;width:25em}}:not(.no-enter)#toast-container>div.ng-enter,:not(.no-leave)#toast-container>div.ng-leave{-webkit-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;-moz-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;-ms-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;-o-transition:1000ms cubic-bezier(.25,.25,.75,.75) all;transition:1000ms cubic-bezier(.25,.25,.75,.75) all}:not(.no-enter)#toast-container>div.ng-enter.ng-enter-active,:not(.no-leave)#toast-container>div.ng-leave{opacity:.8}:not(.no-enter)#toast-container>div.ng-enter,:not(.no-leave)#toast-container>div.ng-leave.ng-leave-active{opacity:0}", ""]);

// exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(638);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/index.js!./ng-tags-input.min.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/index.js!./ng-tags-input.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, "tags-input{display:block}tags-input *,tags-input :after,tags-input :before{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}tags-input .host{position:relative;margin-top:5px;margin-bottom:5px;height:100%}tags-input .host:active{outline:0}tags-input .tags{-moz-appearance:textfield;-webkit-appearance:textfield;padding:1px;overflow:hidden;word-wrap:break-word;cursor:text;background-color:#fff;border:1px solid #a9a9a9;box-shadow:1px 1px 1px 0 #d3d3d3 inset;height:100%}tags-input .tags.focused{outline:0;-webkit-box-shadow:0 0 3px 1px rgba(5,139,242,.6);-moz-box-shadow:0 0 3px 1px rgba(5,139,242,.6);box-shadow:0 0 3px 1px rgba(5,139,242,.6)}tags-input .tags .tag-list{margin:0;padding:0;list-style-type:none}tags-input .tags .tag-item{margin:2px;padding:0 5px;display:inline-block;float:left;font:14px \"Helvetica Neue\",Helvetica,Arial,sans-serif;height:26px;line-height:25px;border:1px solid #acacac;border-radius:3px;background:-webkit-linear-gradient(top,#f0f9ff 0,#cbebff 47%,#a1dbff 100%);background:linear-gradient(to bottom,#f0f9ff 0,#cbebff 47%,#a1dbff 100%)}tags-input .tags .tag-item.selected{background:-webkit-linear-gradient(top,#febbbb 0,#fe9090 45%,#ff5c5c 100%);background:linear-gradient(to bottom,#febbbb 0,#fe9090 45%,#ff5c5c 100%)}tags-input .tags .tag-item .remove-button{margin:0 0 0 5px;padding:0;border:none;background:0 0;cursor:pointer;vertical-align:middle;font:700 16px Arial,sans-serif;color:#585858}tags-input .tags .input.invalid-tag,tags-input .tags .tag-item .remove-button:active{color:red}tags-input .tags .input{border:0;outline:0;margin:2px;padding:0 0 0 5px;float:left;height:26px;font:14px \"Helvetica Neue\",Helvetica,Arial,sans-serif}tags-input .tags .input::-ms-clear{display:none}tags-input.ng-invalid .tags{-webkit-box-shadow:0 0 3px 1px rgba(255,0,0,.6);-moz-box-shadow:0 0 3px 1px rgba(255,0,0,.6);box-shadow:0 0 3px 1px rgba(255,0,0,.6)}tags-input[disabled] .host:focus{outline:0}tags-input[disabled] .tags{background-color:#eee;cursor:default}tags-input[disabled] .tags .tag-item{opacity:.65;background:-webkit-linear-gradient(top,#f0f9ff 0,rgba(203,235,255,.75) 47%,rgba(161,219,255,.62) 100%);background:linear-gradient(to bottom,#f0f9ff 0,rgba(203,235,255,.75) 47%,rgba(161,219,255,.62) 100%)}tags-input[disabled] .tags .tag-item .remove-button{cursor:default}tags-input[disabled] .tags .tag-item .remove-button:active{color:#585858}tags-input[disabled] .tags .input{background-color:#eee;cursor:default}tags-input .autocomplete{margin-top:5px;position:absolute;padding:5px 0;z-index:999;width:100%;background-color:#fff;border:1px solid rgba(0,0,0,.2);-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);-moz-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2)}tags-input .autocomplete .suggestion-list{margin:0;padding:0;list-style-type:none;max-height:280px;overflow-y:auto;position:relative}tags-input .autocomplete .suggestion-item{padding:5px 10px;cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font:16px \"Helvetica Neue\",Helvetica,Arial,sans-serif;color:#000;background-color:#fff}tags-input .autocomplete .suggestion-item.selected,tags-input .autocomplete .suggestion-item.selected em{color:#fff;background-color:#0097cf}tags-input .autocomplete .suggestion-item em{font:normal 700 16px \"Helvetica Neue\",Helvetica,Arial,sans-serif;color:#000;background-color:#fff}", ""]);

// exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(640);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/index.js!./ng-tags-input.bootstrap.min.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/index.js!./ng-tags-input.bootstrap.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, "tags-input{box-shadow:none;border:none;padding:0;min-height:34px}tags-input .host{margin:0}tags-input .tags{-moz-appearance:none;-webkit-appearance:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;-moz-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s}tags-input .tags .tag-item{color:#fff;background:#428bca;border:1px solid #357ebd;border-radius:4px}tags-input .tags .tag-item.selected{color:#fff;background:#d9534f;border:1px solid #d43f3a}tags-input .tags .tag-item .remove-button:hover{text-decoration:none}tags-input .tags.focused{border:1px solid #66afe9;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}tags-input .autocomplete{border-radius:4px}tags-input .autocomplete .suggestion-item.selected,tags-input .autocomplete .suggestion-item.selected em{color:#262626;background-color:#f5f5f5}tags-input .autocomplete .suggestion-item em{color:#000;background-color:#fff}tags-input.ng-invalid .tags{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}tags-input[disabled] .tags{background-color:#eee}tags-input[disabled] .tags .tag-item{background:#337ab7;opacity:.65}tags-input[disabled] .tags .input{background-color:#eee}.input-group tags-input{padding:0;display:table-cell}.input-group tags-input:not(:first-child) .tags{border-top-left-radius:0;border-bottom-left-radius:0}.input-group tags-input:not(:last-child) .tags{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-lg tags-input:first-child .tags{border-top-left-radius:6px;border-bottom-left-radius:6px}.input-group-lg tags-input:last-child .tags{border-top-right-radius:6px;border-bottom-right-radius:6px}.input-group-sm tags-input:first-child .tags{border-top-left-radius:3px;border-bottom-left-radius:3px}.input-group-sm tags-input:last-child .tags{border-top-right-radius:3px;border-bottom-right-radius:3px}.input-group-lg tags-input,tags-input.ti-input-lg{min-height:46px}.input-group-lg tags-input .tags,tags-input.ti-input-lg .tags{border-radius:6px}.input-group-lg tags-input .tags .tag-item,tags-input.ti-input-lg .tags .tag-item{height:38px;line-height:37px;font-size:18px;border-radius:6px}.input-group-lg tags-input .tags .tag-item .remove-button,tags-input.ti-input-lg .tags .tag-item .remove-button{font-size:20px}.input-group-lg tags-input .tags .input,tags-input.ti-input-lg .tags .input{height:38px;font-size:18px}.input-group-sm tags-input,tags-input.ti-input-sm{min-height:30px}.input-group-sm tags-input .tags,tags-input.ti-input-sm .tags{border-radius:3px}.input-group-sm tags-input .tags .tag-item,tags-input.ti-input-sm .tags .tag-item{height:22px;line-height:21px;font-size:12px;border-radius:3px}.input-group-sm tags-input .tags .tag-item .remove-button,tags-input.ti-input-sm .tags .tag-item .remove-button{font-size:16px}.input-group-sm tags-input .tags .input,tags-input.ti-input-sm .tags .input{height:22px;font-size:12px}.has-feedback tags-input .tags{padding-right:30px}.has-success tags-input .tags{border-color:#3c763d}.has-success tags-input .tags.focused{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-error tags-input .tags{border-color:#a94442}.has-error tags-input .tags.focused{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-warning tags-input .tags{border-color:#8a6d3b}.has-warning tags-input .tags.focused{border-color:#66512c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}", ""]);

// exports


/***/ }),
/* 641 */
/***/ (function(module, exports) {

function _toConsumableArray(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}function _defineProperty(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function _sliceIterator(e,t){var n=[],r=!0,o=!1,a=void 0;try{for(var s,i=e[Symbol.iterator]();!(r=(s=i.next()).done)&&(n.push(s.value),!t||n.length!==t);r=!0);}catch(e){o=!0,a=e}finally{try{r||null==i.return||i.return()}finally{if(o)throw a}}return n}function _slicedToArray(e,t){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return _sliceIterator(e,t);throw new TypeError("Invalid attempt to destructure non-iterable instance")}!function(Y,U){var X=U.element.prototype.closest;if(!X){var r=["matches","matchesSelector","webkitMatches","webkitMatchesSelector","msMatches","msMatchesSelector","mozMatches","mozMatchesSelector"].reduce(function(e,t){var n;return null!==(n=e)&&void 0!==n?n:t in document.documentElement?t:null},null);X=function(e){for(var t,n=this[0].parentNode;n!==document.documentElement&&null!=n&&!n[r](e);)n=n.parentNode;return(null===(t=n)||void 0===t?void 0:t[r](e))?U.element(n):U.element()}}function G(){var e,t,n,r;return"pageYOffset"in Y?{scrollTop:Y.pageYOffset,scrollLeft:Y.pageXOffset}:{scrollTop:null!==(e=null!==(t=document.documentElement.scrollTop)&&void 0!==t?t:document.body.scrollTop)&&void 0!==e?e:0,scrollLeft:null!==(n=null!==(r=document.documentElement.scrollLeft)&&void 0!==r?r:document.body.scrollLeft)&&void 0!==n?n:0}}function K(e,t){return e===Y?"clientWidth"===t?Y.innerWidth:Y.innerHeight:e[t]}function c(e,t){var n,r;n=t,r="".concat(e," attribute is deprecated. Pass the options object to vs-repeat attribute instead https://github.com/kamilkp/angular-vs-repeat#options"),console.warn("vs-repeat deprecation: ".concat(r),n[0])}var Q={latch:!1,container:null,scrollParent:null,size:null,offsetBefore:0,offsetAfter:0,scrolledToBeginning:U.noop,scrolledToEnd:U.noop,scrolledToBeginningOffset:0,scrolledToEndOffset:0,scrollMargin:0,horizontal:!1,autoresize:!1,hunked:!1,hunkSize:0},e=U.module("vs-repeat",[]).directive("vsRepeat",["$compile","$parse",function(F,J){return{restrict:"A",scope:!0,compile:function(t,n){var e="vsRepeatContainer"in n?U.element(t[0].querySelector(n.vsRepeatContainer)):t,r=e.children(),o=r.eq(0),L=o[0].outerHTML,q="$vs_collection";["vsSize","vsScrollParent","vsSizeProperty","vsHorizontal","vsOffsetBefore","vsOffsetAfter","vsScrolledToEndOffset","vsScrolledToBeginningOffset","vsExcess","vsScrollMargin"].forEach(function(e){e in n&&c(e,t)});var a=_slicedToArray(function(e){for(var t=["ng-repeat","data-ng-repeat","ng-repeat-start","data-ng-repeat-start"],n=0;n<t.length;n++){var r=t[n];if(e.attr(r))return[r,e.attr(r),0<=r.indexOf("-start")]}throw new Error("angular-vs-repeat: no ng-repeat directive on a child element")}(o),3),H=a[0],s=a[1],W=a[2],i=_slicedToArray(/^\s*(\S+)\s+in\s+([\S\s]+?)(track\s+by\s+\S+)?$/.exec(s),4),j=i[1],N=i[2],D=i[3];if(W)for(var l=0,d=r.eq(l);null==d.attr("ng-repeat-end")&&null==d.attr("data-ng-repeat-end");)l++,d=r.eq(l),L+=d[0].outerHTML;return e.empty(),{pre:function(g,m,e){var t;function n(e){if("number"==typeof e.size)e.getSize=function(){return e.size};else{var t=J(String(e.size));e.getSize=function(e){return t(g,_defineProperty({},j,e))}}}g.vsRepeat={options:_extends({},Q,null!==(t=g.$eval(e.vsRepeat))&&void 0!==t?t:{})};var R=g.vsRepeat.options;n(R);var x,z=U.isDefined(e.vsRepeatContainer)?U.element(m[0].querySelector(e.vsRepeatContainer)):m,r=U.element(L),o=r[0].tagName.toLowerCase(),y=[],$=U.element("<"+o+' class="vs-repeat-before-content"></'+o+">"),b=U.element("<"+o+' class="vs-repeat-after-content"></'+o+">"),I=null===R.size,w=R.scrollParent?"window"===R.scrollParent?U.element(Y):X.call(z,R.scrollParent):z,S=R.horizontal?"clientWidth":"clientHeight",a=R.horizontal?"offsetWidth":"offsetHeight",T=R.horizontal?"scrollWidth":"scrollHeight",A=R.horizontal?"scrollLeft":"scrollTop";if((g.vsRepeat.totalSize=0)===w.length)throw"Specified scroll parent selector did not match any element";if(g.vsRepeat.$scrollParent=w,g.vsRepeat.sizesCumulative=[],R.debug){var s="window"===R.scrollParent?U.element(document.body):w,i=U.element('<div class="vs-repeat-debug-element"></div>');i.css("position","window"===R.scrollParent?"fixed":"absolute"),s.append(i),g.$on("$destroy",function(){i.remove()})}var C,O,M,_,l,d=K(w[0],S)||50;function c(){!y||y.length<1?(g[q]=[],x=0,g.vsRepeat.sizesCumulative=[0]):(x=y.length,R.size?u():p()),h()}function u(){var n=0<arguments.length&&void 0!==arguments[0]?arguments[0]:null,e=y.map(function(e){var t;return null!==(t=n)&&void 0!==t?t:R.getSize(e)}),t=0;g.vsRepeat.sizesCumulative=[0].concat(_toConsumableArray(e.map(function(e){return t+=e})))}function p(){I?g.$$postDigest(function(){if(z[0].offsetHeight||z[0].offsetWidth){for(var e=z.children(),t=0,n=!1,r=!1;t<e.length;){if(null!=e[t].attributes[H]||r){if(n||(d=0),n=!0,e[t][a]&&(d+=e[t][a]),!W)break;if(null!=e[t].attributes["ng-repeat-end"]||null!=e[t].attributes["data-ng-repeat-end"])break;r=!0}t++}n&&(u(d),h(),I=!1,g.$root&&!g.$root.$$phase&&g.$digest())}else var o=g.$watch(function(){(z[0].offsetHeight||z[0].offsetWidth)&&(o(),p())})}):u(d)}function B(n){var r=R.horizontal?"width":"height";return["","min-","max-"].reduce(function(e,t){return e["".concat(t).concat(r)]=n,e},{})}function v(){var e=w[0][A];k()&&(g.$digest(),R._ensureScrollIntegrity&&(w[0][A]=e))}function f(){R.autoresize&&(I=!0,p(),g.$root&&!g.$root.$$phase&&g.$digest()),k()&&g.$digest()}function h(){var e;O=C=void 0,M=x,_=0,e=g.vsRepeat.sizesCumulative[x],g.vsRepeat.totalSize=R.offsetBefore+e+R.offsetAfter,k(),g.$emit("vsRepeatReinitialized",g.vsRepeat.startIndex,g.vsRepeat.endIndex)}function E(){var e=K(w[0],S);e!==l&&(h(),g.$root&&!g.$root.$$phase&&g.$digest()),l=e}function P(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:0,r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:e.length-1,o=4<arguments.length&&void 0!==arguments[4]?arguments[4]:1;if(e[n]===t)return[n,n,o];if(e[r]===t)return[r,r,o];if(1<r-n){var a=Math.floor((n+r)/2);return e[a]>t?P(e,t,n,a,o+1):P(e,t,a,r,o+1)}return[t>e[r]?r:n,t<e[n]?n:r,o]}function k(){var e,t,n=(e=w[0],t=A,e===Y?G()[t]:e[t]),r=K(w[0],S);R.debug&&(r/=2);var o,a,s,i=z[0]===w[0]?0:(o=z[0],a=w[0],s=R.horizontal,o.getBoundingClientRect()[s?"left":"top"]-(a===Y?0:a.getBoundingClientRect()[s?"left":"top"])+(a===Y?G():a)[s?"scrollLeft":"scrollTop"]),l=g.vsRepeat.startIndex,d=g.vsRepeat.endIndex;if(I&&!R.size)l=0,d=1;else{g.$$postDigest(function(){Y.requestAnimationFrame(function(){var e=g.vsRepeat.sizesCumulative[x],n=Y.getComputedStyle(z[0]),t=R.horizontal?["paddingLeft","paddingRight"]:["paddingTop","paddingBottom"],r=z[0][T]-t.reduce(function(e,t){return e+Number(n[t].slice(0,-2))},0);z[0][T]&&e!==r&&console.warn("vsRepeat: size mismatch. Expected size "+e+"px whereas actual size is "+r+"px. Fix vsSize on element:",m[0])})});var c=n-R.offsetBefore-i;l=_slicedToArray(P(g.vsRepeat.sizesCumulative,c-R.scrollMargin),1)[0],l=Math.max(l,0),d=_slicedToArray(P(g.vsRepeat.sizesCumulative,c+R.scrollMargin+r,l),2)[1],d=Math.min(d,x)}M=Math.min(l,M),_=Math.max(d,_),g.vsRepeat.startIndex=R.latch?M:l,g.vsRepeat.endIndex=R.latch?_:d,_<g.vsRepeat.startIndex&&(g.vsRepeat.startIndex=_);var u=!1;if(null==C?u=!0:null==O&&(u=!0),u||(R.hunked?Math.abs(g.vsRepeat.startIndex-C)>=R.hunkSize||0===g.vsRepeat.startIndex&&0!==C?u=!0:(Math.abs(g.vsRepeat.endIndex-O)>=R.hunkSize||g.vsRepeat.endIndex===x&&O!==x)&&(u=!0):u=g.vsRepeat.startIndex!==C||g.vsRepeat.endIndex!==O),u){var p;g[q]=y.slice(g.vsRepeat.startIndex,g.vsRepeat.endIndex),g.$emit("vsRepeatInnerCollectionUpdated",g.vsRepeat.startIndex,g.vsRepeat.endIndex,C,O),R.scrolledToEnd&&(p=y.length-R.scrolledToEndOffset,(g.vsRepeat.endIndex>=p&&O<p||y.length&&g.vsRepeat.endIndex===y.length)&&g.$eval(R.scrolledToEnd)),R.scrolledToBeginning&&(p=R.scrolledToBeginningOffset,g.vsRepeat.startIndex<=p&&C>g.vsRepeat.startIndex&&g.$eval(R.scrolledToBeginning)),C=g.vsRepeat.startIndex,O=g.vsRepeat.endIndex;var v=g.vsRepeat.sizesCumulative[g.vsRepeat.startIndex]+R.offsetBefore,f=g.vsRepeat.sizesCumulative[g.vsRepeat.startIndex+g[q].length]+R.offsetBefore,h=g.vsRepeat.totalSize;$.css(B(v+"px")),b.css(B(h-f+"px"))}return u}R.horizontal?($.css("height","100%"),b.css("height","100%")):($.css("width","100%"),b.css("width","100%")),e.vsRepeatOptions&&g.$watchCollection(e.vsRepeatOptions,function(e){var t=_extends({},R,e);JSON.stringify(t)!==JSON.stringify(R)&&(Object.assign(R,e),n(R),h())}),g.$watchCollection(N,function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:[];y=e,c()}),r.eq(0).attr(H,j+" in "+q+(D?" "+D:"")),r.addClass("vs-repeat-repeated-element"),z.append($),z.append(r),F(r)(g),z.append(b),g.vsRepeat.startIndex=0,g.vsRepeat.endIndex=0,w.on("scroll",v),U.element(Y).on("resize",f),g.$on("$destroy",function(){U.element(Y).off("resize",f),w.off("scroll",v)}),g.$on("vsRepeatTrigger",c),g.$on("vsRepeatResize",function(){I=!0,p()}),g.$on("vsRenderAll",function(){R.latch&&(g.vsRepeat.endIndex!==x?setTimeout(function(){var e=x;_=Math.max(e,_),g.vsRepeat.endIndex=R.latch?_:e,g[q]=y.slice(g.vsRepeat.startIndex,g.vsRepeat.endIndex),O=g.vsRepeat.endIndex,$.css(B(0)),b.css(B(0)),g.$emit("vsRenderAllDone"),g.$root&&!g.$root.$$phase&&g.$digest()}):g.$emit("vsRenderAllDone"))}),g.$watch(function(){"function"==typeof Y.requestAnimationFrame?Y.requestAnimationFrame(E):E()})}}}}}]);U.element(document.head).append('<style id="angular-vs-repeat-style">\n\t  \t.vs-repeat-debug-element {\n        top: 50%;\n        left: 0;\n        right: 0;\n        height: 1px;\n        background: red;\n        z-index: 99999999;\n        box-shadow: 0 0 20px red;\n      }\n\n      .vs-repeat-debug-element + .vs-repeat-debug-element {\n        display: none;\n      }\n\n      .vs-repeat-before-content,\n      .vs-repeat-after-content {\n        border: none !important;\n        padding: 0 !important;\n      }\n    </style>'),"undefined"!=typeof module&&module.exports&&(module.exports=e.name)}(window,window.angular);

/***/ }),
/* 642 */
/***/ (function(module, exports) {

/*
 * BlockAdBlock 3.2.1
 * Copyright (c) 2015 Valentin Allaire <valentin.allaire@sitexw.fr>
 * Released under the MIT license
 * https://github.com/sitexw/BlockAdBlock
 */

(function(window) {
	var BlockAdBlock = function(options) {
		this._options = {
			checkOnLoad:		false,
			resetOnEnd:			false,
			loopCheckTime:		50,
			loopMaxNumber:		5,
			baitClass:			'pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links',
			baitStyle:			'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;',
			debug:				false
		};
		this._var = {
			version:			'3.2.1',
			bait:				null,
			checking:			false,
			loop:				null,
			loopNumber:			0,
			event:				{ detected: [], notDetected: [] }
		};
		if(options !== undefined) {
			this.setOption(options);
		}
		var self = this;
		var eventCallback = function() {
			setTimeout(function() {
				if(self._options.checkOnLoad === true) {
					if(self._options.debug === true) {
						self._log('onload->eventCallback', 'A check loading is launched');
					}
					if(self._var.bait === null) {
						self._creatBait();
					}
					setTimeout(function() {
						self.check();
					}, 1);
				}
			}, 1);
		};
		if(window.addEventListener !== undefined) {
			window.addEventListener('load', eventCallback, false);
		} else {
			window.attachEvent('onload', eventCallback);
		}
	};
	BlockAdBlock.prototype._options = null;
	BlockAdBlock.prototype._var = null;
	BlockAdBlock.prototype._bait = null;
	
	BlockAdBlock.prototype._log = function(method, message) {
		console.log('[BlockAdBlock]['+method+'] '+message);
	};
	
	BlockAdBlock.prototype.setOption = function(options, value) {
		if(value !== undefined) {
			var key = options;
			options = {};
			options[key] = value;
		}
		for(var option in options) {
			this._options[option] = options[option];
			if(this._options.debug === true) {
				this._log('setOption', 'The option "'+option+'" he was assigned to "'+options[option]+'"');
			}
		}
		return this;
	};
	
	BlockAdBlock.prototype._creatBait = function() {
		var bait = document.createElement('div');
			bait.setAttribute('class', this._options.baitClass);
			bait.setAttribute('style', this._options.baitStyle);
		this._var.bait = window.document.body.appendChild(bait);
		
		this._var.bait.offsetParent;
		this._var.bait.offsetHeight;
		this._var.bait.offsetLeft;
		this._var.bait.offsetTop;
		this._var.bait.offsetWidth;
		this._var.bait.clientHeight;
		this._var.bait.clientWidth;
		
		if(this._options.debug === true) {
			this._log('_creatBait', 'Bait has been created');
		}
	};
	BlockAdBlock.prototype._destroyBait = function() {
		window.document.body.removeChild(this._var.bait);
		this._var.bait = null;
		
		if(this._options.debug === true) {
			this._log('_destroyBait', 'Bait has been removed');
		}
	};
	
	BlockAdBlock.prototype.check = function(loop) {
		if(loop === undefined) {
			loop = true;
		}
		
		if(this._options.debug === true) {
			this._log('check', 'An audit was requested '+(loop===true?'with a':'without')+' loop');
		}
		
		if(this._var.checking === true) {
			if(this._options.debug === true) {
				this._log('check', 'A check was canceled because there is already an ongoing');
			}
			return false;
		}
		this._var.checking = true;
		
		if(this._var.bait === null) {
			this._creatBait();
		}
		
		var self = this;
		this._var.loopNumber = 0;
		if(loop === true) {
			this._var.loop = setInterval(function() {
				self._checkBait(loop);
			}, this._options.loopCheckTime);
		}
		setTimeout(function() {
			self._checkBait(loop);
		}, 1);
		if(this._options.debug === true) {
			this._log('check', 'A check is in progress ...');
		}
		
		return true;
	};
	BlockAdBlock.prototype._checkBait = function(loop) {
		var detected = false;
		
		if(this._var.bait === null) {
			this._creatBait();
		}
		
		if(window.document.body.getAttribute('abp') !== null
		|| this._var.bait.offsetParent === null
		|| this._var.bait.offsetHeight == 0
		|| this._var.bait.offsetLeft == 0
		|| this._var.bait.offsetTop == 0
		|| this._var.bait.offsetWidth == 0
		|| this._var.bait.clientHeight == 0
		|| this._var.bait.clientWidth == 0) {
			detected = true;
		}
		if(window.getComputedStyle !== undefined) {
			var baitTemp = window.getComputedStyle(this._var.bait, null);
			if(baitTemp && (baitTemp.getPropertyValue('display') == 'none' || baitTemp.getPropertyValue('visibility') == 'hidden')) {
				detected = true;
			}
		}
		
		if(this._options.debug === true) {
			this._log('_checkBait', 'A check ('+(this._var.loopNumber+1)+'/'+this._options.loopMaxNumber+' ~'+(1+this._var.loopNumber*this._options.loopCheckTime)+'ms) was conducted and detection is '+(detected===true?'positive':'negative'));
		}
		
		if(loop === true) {
			this._var.loopNumber++;
			if(this._var.loopNumber >= this._options.loopMaxNumber) {
				this._stopLoop();
			}
		}
		
		if(detected === true) {
			this._stopLoop();
			this._destroyBait();
			this.emitEvent(true);
			if(loop === true) {
				this._var.checking = false;
			}
		} else if(this._var.loop === null || loop === false) {
			this._destroyBait();
			this.emitEvent(false);
			if(loop === true) {
				this._var.checking = false;
			}
		}
	};
	BlockAdBlock.prototype._stopLoop = function(detected) {
		clearInterval(this._var.loop);
		this._var.loop = null;
		this._var.loopNumber = 0;
		
		if(this._options.debug === true) {
			this._log('_stopLoop', 'A loop has been stopped');
		}
	};
	
	BlockAdBlock.prototype.emitEvent = function(detected) {
		if(this._options.debug === true) {
			this._log('emitEvent', 'An event with a '+(detected===true?'positive':'negative')+' detection was called');
		}
		
		var fns = this._var.event[(detected===true?'detected':'notDetected')];
		for(var i in fns) {
			if(this._options.debug === true) {
				this._log('emitEvent', 'Call function '+(parseInt(i)+1)+'/'+fns.length);
			}
			if(fns.hasOwnProperty(i)) {
				fns[i]();
			}
		}
		if(this._options.resetOnEnd === true) {
			this.clearEvent();
		}
		return this;
	};
	BlockAdBlock.prototype.clearEvent = function() {
		this._var.event.detected = [];
		this._var.event.notDetected = [];
		
		if(this._options.debug === true) {
			this._log('clearEvent', 'The event list has been cleared');
		}
	};
	
	BlockAdBlock.prototype.on = function(detected, fn) {
		this._var.event[(detected===true?'detected':'notDetected')].push(fn);
		if(this._options.debug === true) {
			this._log('on', 'A type of event "'+(detected===true?'detected':'notDetected')+'" was added');
		}
		
		return this;
	};
	BlockAdBlock.prototype.onDetected = function(fn) {
		return this.on(true, fn);
	};
	BlockAdBlock.prototype.onNotDetected = function(fn) {
		return this.on(false, fn);
	};
	
	window.BlockAdBlock = BlockAdBlock;
	
	if(window.blockAdBlock === undefined) {
		window.blockAdBlock = new BlockAdBlock({
			checkOnLoad: true,
			resetOnEnd: true
		});
	}
})(window);


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(644);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./main.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./main.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@600;700;800&display=swap);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap);", ""]);

// module
exports.push([module.i, "@charset \"UTF-8\";\n/* white navbar */\n:root {\n  --color-bx-arctic: #0cd6e9;\n  --color-bx-accessible-blue: #00a3bb;\n  --color-bx-accessible-grey: rgb(94 105 122);\n  --color-bx-lagoon: rgb(0, 108, 128);\n  --color-bx-denim: rgb(0, 38, 62);\n  --color-bx-black: rgb(29, 31, 42);\n  --color-bx-grey: rgb(157, 158, 163);\n  --color-bx-grey-lighten-5: rgb(250, 250, 250);\n  --color-bx-grey-lighten-4: rgb(245, 245, 245);\n  --color-bx-grey-lighten-3: rgb(238, 238, 238);\n  --color-bx-grey-lighten-2: rgb(222, 222, 224);\n  --color-bx-grey-lighten-1: rgb(187, 187, 191);\n  --color-bx-grey-darken-1: rgb(116, 116, 122);\n  --color-bx-grey-darken-2: rgb(93, 96, 102);\n  --color-bx-grey-darken-3: rgb(58, 63, 71);\n  --color-bx-grey-darken-4: rgb(46, 47, 56);\n  --color-bx-green-lighten-1: #0ab50c;\n  --color-bx-green: #238341;\n  --color-bx-green-darken-1: #145e2b;\n  --color-bx-red: rgba(211, 47, 47, 1);\n  --color-bx-red-darken-1: rgb(179 32 28);\n  --color-bx-shallot: #8c4ee8;\n  --color-bx-lagoon: #006c80;\n  --color-bx-accessible-blue-opacity-1: rgb(0, 163, 187, 0.08);\n  --color-bx-accessible-blue-opacity-2: rgb(0, 163, 187, 0.12);\n  --color-bx-accessible-blue-opacity-3: rgb(0, 163, 187, 0.32); }\n\n@font-face {\n  font-family: stratum2-medium;\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-b2c4f8dc.eot\") format(\"embedded-opentype\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-b9328e20.woff\") format(\"woff\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-1056a27c.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: 'stratum2-regular';\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-regular-webfont-4f027594.eot\") format(\"embedded-opentype\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-regular-webfont-85ed058d.woff\") format(\"woff\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-regular-webfont-1d7ec4d0.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: 'stratum2-bold';\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-bold-webfont-be5f65fc.eot\") format(\"embedded-opentype\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-bold-webfont-98176c3d.woff\") format(\"woff\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-bold-webfont-38fd0ee0.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: stratum2-medium;\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-b2c4f8dc.eot\") format(\"embedded-opentype\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-b9328e20.woff\") format(\"woff\"), url(\"//cdn2.hubspot.net/hubfs/484866/fonts/stratum2-medium-webfont-1056a27c.ttf\") format(\"truetype\"); }\n\nbody {\n  font-family: 'Roboto', Arial, sans-serif !important;\n  background-color: #edecec !important;\n  -webkit-font-smoothing: antialiased; }\n  body small {\n    font-size: 14px; }\n\na {\n  color: #337ab7; }\n\n.body-1 {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 1.8rem;\n  line-height: 30px;\n  color: #1d1f2a; }\n\n/*Body-2*/\n.body-2 {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 1.6rem;\n  line-height: 28px;\n  color: #1d1f2a; }\n\n/*Body-3*/\n.body-3, .home-card__heading {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 24px;\n  color: #1d1f2a; }\n\n.subtle-link {\n  cursor: pointer;\n  color: var(--color-bx-accessible-grey);\n  text-decoration: none;\n  border-bottom: 1px dotted #ccc; }\n  .subtle-link:hover {\n    color: #111;\n    text-decoration: none;\n    border-bottom: 1px dotted #aaa; }\n\n.small-link {\n  cursor: pointer;\n  color: #1aa8a1;\n  text-decoration: none;\n  border-bottom: none;\n  font-weight: bold;\n  font-size: 0.8em; }\n  .small-link:hover {\n    text-decoration: none; }\n\n.block {\n  display: block; }\n\n/**\nText Colors\n*/\n.text-black {\n  color: var(--color-bx-black); }\n\n.text-denim {\n  color: var(--color-bx-denim); }\n\n.text-bx-lagoon {\n  color: var(--color-bx-lagoon); }\n\n.text-bx-accessible-blue {\n  color: var(--color-bx-accessible-blue); }\n\n.text-bx-accessible-grey {\n  color: var(--color-bx-accessible-grey); }\n\n.text-bx-green {\n  color: var(--color-bx-green); }\n\n/**\nFont Weights \n*/\n.font-normal {\n  font-weight: 400; }\n\n.font-medium {\n  font-weight: 500; }\n\n.font-bold {\n  font-weight: 700; }\n\n.mb-0 {\n  margin-bottom: 0; }\n\n.mb-tight {\n  margin-bottom: 0.4rem; }\n\n.mb-base {\n  margin-bottom: 0.8rem; }\n\n.mb-base {\n  margin-bottom: 1.2rem; }\n\n.mt-0 {\n  margin-top: 0; }\n\n.mt-tight {\n  margin-top: 0.4rem; }\n\n.mt-base {\n  margin-top: 0.8rem; }\n\n.mt-base {\n  margin-top: 1.2rem; }\n\n/**\nFont Sizes\n*/\n.text-xs {\n  font-size: 1.2rem; }\n\n.text-sm {\n  font-size: 1.4rem; }\n\nol ul,\nol ol,\nul ul,\nul ol {\n  margin-top: 0.25em;\n  margin-bottom: 0.25em;\n  padding-left: 1.5rem; }\n\n.underline {\n  text-decoration: underline; }\n\n.main-content {\n  margin-left: 230px;\n  margin-top: 70px;\n  padding-bottom: 20px; }\n\n.with-eyebrow .main-content {\n  margin-top: 112px; }\n\nmain.container-fluid {\n  position: relative;\n  padding-right: 0;\n  padding-left: 0; }\n\n.flex-grid {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center; }\n\n.flex-cell-33 {\n  width: 33%; }\n\n.broadcast-card {\n  /*\n    .play-button {\n        position:absolute;\n        left:50%;top:50%;\n        width:70px;height:70px;\n        margin-left:-35px;margin-top:-35px;\n        background-image:radial-gradient(circle at center, rgba(255,255,255,0.65) 0%,rgba(255,255,255,0) 80%);\n        text-align: center;\n    }\n    */ }\n  .broadcast-card img.preview {\n    margin: 0;\n    padding: 0;\n    border: none; }\n  .broadcast-card-image-wrapper {\n    position: relative;\n    cursor: pointer; }\n    .broadcast-card-image-wrapper__message {\n      overflow: hidden; }\n  .broadcast-card-image-wrapper:after {\n    padding-top: 56.25%;\n    /* 16:9 ratio */\n    display: block;\n    content: ''; }\n  .broadcast-card-image-preview {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    background-size: cover;\n    background-color: #000;\n    background-position: center; }\n  .broadcast-card .message {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding-top: 20px;\n    text-align: center;\n    color: #ddd;\n    background: rgba(0, 0, 0, 0.5); }\n  .broadcast-card .action-link {\n    color: #6cbce0; }\n  .broadcast-card .view-stats {\n    position: absolute;\n    bottom: 0;\n    left: 0px;\n    right: 0px;\n    padding: 3px 5px;\n    background: rgba(0, 0, 0, 0.8);\n    color: #fff;\n    z-index: 2; }\n  .broadcast-card__description {\n    margin-top: 0.25rem;\n    font-size: 1.4rem;\n    letter-spacing: -0.5px;\n    color: var(--color-bx-grey-darken-3); }\n    .broadcast-card__description small {\n      font-size: 1.4rem;\n      letter-spacing: 0.025px; }\n  .broadcast-card__name {\n    letter-spacing: -0.25px;\n    font-weight: 500;\n    font-size: 1.8rem; }\n  .broadcast-card__duration, .broadcast-card__views-count, .broadcast-card__ticket-label, .broadcast-card__private-label {\n    font-weight: 500; }\n  .broadcast-card__edit-toggle {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    background-color: rgba(0, 0, 0, 0.5);\n    transition: background-color 0.1s ease-out;\n    display: inline-block;\n    padding: 1px 4px;\n    border-radius: 0px 0px 0px 5px; }\n    .broadcast-card__edit-toggle .action-link {\n      transition: color 0.1s ease-out;\n      color: white; }\n    .broadcast-card__edit-toggle:active, .broadcast-card__edit-toggle:focus {\n      text-decoration: none; }\n    .broadcast-card__edit-toggle:hover {\n      background: white; }\n      .broadcast-card__edit-toggle:hover a {\n        text-decoration: none;\n        color: var(--color-bx-denim); }\n\n.multi-view-broadcast-details h4 {\n  margin: 10px 0 0 0; }\n\n.multi-view-broadcast-details p {\n  margin: 0; }\n\n@media screen and (min-width: 1200px) {\n  .channel-row-details .broadcast-card__duration, .channel-row-details .broadcast-card__views-count, .channel-row-details .broadcast-card__ticket-label, .channel-row-details .broadcast-card__private-label {\n    font-size: 1.2rem; } }\n\n@media screen and (min-width: 1900px) {\n  .channel-row-details .broadcast-card__duration, .channel-row-details .broadcast-card__views-count, .channel-row-details .broadcast-card__ticket-label, .channel-row-details .broadcast-card__private-label {\n    font-size: 1.4rem; } }\n\n.channel-row-details .broadcast-card-image-wrapper__message small {\n  font-size: 1.2rem; }\n  @media screen and (min-width: 1900px) {\n    .channel-row-details .broadcast-card-image-wrapper__message small {\n      font-size: 1.4rem; } }\n\n.facebook-embed {\n  position: relative;\n  padding-bottom: 56.25%;\n  /* 16:9 */\n  padding-top: 25px;\n  height: 0; }\n\n.facebook-embed iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n.integration-type-controls {\n  display: flex;\n  gap: 1.5rem;\n  flex-direction: column; }\n  @media screen and (min-width: 1100px) {\n    .integration-type-controls {\n      flex-direction: row; } }\n  @media screen and (min-width: 1100px) {\n    .integration-type-controls__info {\n      flex: 1; } }\n\n.label-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px; }\n  .label-list.justify-end {\n    justify-content: flex-end; }\n\n.left-rail {\n  background-color: #191c22;\n  position: fixed;\n  left: 0;\n  width: 230px;\n  top: 50px;\n  height: calc(100vh - 50px);\n  overflow-y: auto;\n  z-index: 0;\n  padding-bottom: 100px; }\n  .left-rail .user {\n    margin: 15px 0;\n    text-align: center; }\n  .left-rail .nav > li > a {\n    color: #ccc;\n    font-size: 1.4rem;\n    font-weight: 500;\n    background-color: #191c22;\n    padding: 10px 15px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    transition: color 0.2s ease-out; }\n    .left-rail .nav > li > a.secondary-link {\n      font-size: 11px;\n      padding: 5px 15px; }\n  .left-rail .nav > li > a:hover {\n    color: white;\n    background-color: #191c22; }\n  .left-rail .nav > li > a:focus,\n  .left-rail .nav > li.active > a {\n    background-color: #121419;\n    color: white; }\n    .left-rail .nav > li > a:focus .nav-icon,\n    .left-rail .nav > li.active > a .nav-icon {\n      background: #2c313a; }\n  .left-rail .nav > li.active > a {\n    border-right: 6px solid var(--color-bx-accessible-blue); }\n  .left-rail .nav-icon {\n    display: inline-block;\n    width: 28px;\n    height: 28px;\n    line-height: 29px;\n    text-align: center;\n    border-radius: 14px;\n    background: #121419;\n    margin-right: 10px; }\n  .left-rail .divider {\n    margin-left: 15px;\n    margin-right: 15px;\n    margin-top: 5px;\n    padding-top: 5px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    box-shadow: 0 -1px 1px rgba(0, 0, 0, 0.5); }\n  .left-rail .need-help {\n    display: block;\n    margin-bottom: 20px;\n    font-size: 14px;\n    font-weight: bold;\n    color: rgba(255, 255, 255, 0.6);\n    border: 1px solid;\n    padding: 5px 20px;\n    border-radius: 4px;\n    text-decoration: none; }\n    .left-rail .need-help:hover {\n      color: white; }\n\n.with-eyebrow .left-rail {\n  top: 92px;\n  height: calc(100vh - 92px); }\n\n.low-latency-wrapper {\n  background: #000; }\n  .low-latency-wrapper .close-btn {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    right: 5px;\n    color: #fff;\n    text-shadow: 0 0 5px rgba(0, 0, 0, 0.8);\n    text-decoration: none;\n    font-weight: bold;\n    font-size: 25px; }\n  .low-latency-wrapper .indicator-overlay {\n    position: absolute;\n    z-index: 1;\n    top: 15px;\n    left: 15px;\n    text-decoration: none; }\n\n.cap-player-width-container {\n  max-width: 720px;\n  margin: 0 auto;\n  position: relative; }\n\n.stat-block {\n  text-align: center;\n  padding: 5px 0;\n  border: 1px solid #b9b9b9;\n  border-bottom-width: 0; }\n  .stat-block h2 {\n    margin: 0; }\n  .stat-block h5 {\n    margin: 0; }\n  .stat-block.half-l {\n    border-right-width: 0; }\n\n.stat-row-label {\n  margin-bottom: 10px;\n  padding: 3px;\n  background: rgba(0, 0, 0, 0.7);\n  font-size: 8pt;\n  font-weight: bold;\n  color: #aaa;\n  text-align: center; }\n\n.diagnostics--icon-OK {\n  color: green; }\n\n.diagnostics--icon-Warning {\n  color: orange; }\n\n.diagnostics--icon-Critical {\n  color: red; }\n\n.diagnostics--title-OK {\n  border-bottom: 3px solid green; }\n\n.diagnostics--title-Warning {\n  border-bottom: 3px solid orange; }\n\n.diagnostics--title-Critical {\n  border-bottom: 3px solid red; }\n\n.diagnostics--title-Unknown {\n  border-bottom: 3px solid #ccc; }\n\n.diagnostics--alert-inactive {\n  opacity: 0.5; }\n\n.diagnostics--summary h1 {\n  margin: 0; }\n\n.diagnostics--alerts-overlay {\n  position: relative;\n  width: auto;\n  height: auto; }\n  .diagnostics--alerts-overlay .diagnostics--alerts-content {\n    height: 100%;\n    width: 100%;\n    max-height: 120px;\n    overflow-y: scroll; }\n  .diagnostics--alerts-overlay .shadowContainer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none; }\n  .diagnostics--alerts-overlay .shadow {\n    position: absolute;\n    z-index: 1; }\n  .diagnostics--alerts-overlay .linearShadowTop {\n    top: 0;\n    left: 0;\n    background: linear-gradient(rgba(0, 0, 0, 0.3) 10%, rgba(255, 255, 255, 0)) 100% 0;\n    background-repeat: no-repeat;\n    background-size: 100% 4px;\n    width: inherit;\n    height: 5px; }\n  .diagnostics--alerts-overlay .linearShadowBottom {\n    bottom: 0;\n    left: 0;\n    background: linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.3) 90%) 0 100%;\n    background-repeat: no-repeat;\n    background-size: 100% 4px;\n    width: inherit;\n    height: 5px; }\n  .diagnostics--alerts-overlay .shadowCoverTop {\n    height: 5px;\n    width: 100%;\n    background: #fff;\n    background-size: 100% 12px;\n    background-repeat: no-repeat;\n    position: relative;\n    z-index: 2; }\n  .diagnostics--alerts-overlay .shadowCoverBottom {\n    height: 5px;\n    width: 100%;\n    background: #fff;\n    background-size: 100% 12px;\n    background-repeat: no-repeat;\n    position: relative;\n    z-index: 2; }\n\n.scoreboard-diagnostics-status {\n  font-size: 10px;\n  text-align: center;\n  margin-bottom: 30px; }\n  .scoreboard-diagnostics-status td {\n    vertical-align: top;\n    padding: 0 5px; }\n  .scoreboard-diagnostics-status.five-wide td {\n    width: 20%; }\n  .scoreboard-diagnostics-status.four-wide td {\n    width: 25%; }\n  .scoreboard-diagnostics-status.three-wide td {\n    width: 33%; }\n  .scoreboard-diagnostics-status i.fa {\n    display: block;\n    font-size: 25px;\n    margin-bottom: 5px; }\n\n.opacity-80 {\n  opacity: 0.8; }\n\n.opacity-40 {\n  opacity: 0.4; }\n\n.scoreboard-link-status--strike {\n  height: 10px;\n  width: 65px;\n  background: #444;\n  position: absolute;\n  top: 10px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  transform: rotate(35deg);\n  border: 2px solid #fff;\n  border-radius: 5px; }\n\n.onboarding-container {\n  max-width: 1200px;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin: auto; }\n\n.onboarding {\n  padding: 3rem; }\n  .onboarding__header {\n    margin: 0 auto;\n    text-align: center;\n    margin-bottom: 3.2rem; }\n  .onboarding__title {\n    font-size: 3.2rem; }\n  .onboarding__lead {\n    font-size: 1.8rem; }\n\n.text-lg {\n  font-size: 1.6rem; }\n\n.margin-sm {\n  margin-bottom: 1.6rem; }\n\n.margin-lg {\n  margin-bottom: 3.2rem; }\n\n.nav > li > button {\n  color: black;\n  font-size: 14px;\n  background-color: white;\n  padding: 12px 20px;\n  white-space: nowrap;\n  overflow: hidden;\n  border: 1px solid #dddddd;\n  border-radius: 4px;\n  margin-right: 20px;\n  width: 100%;\n  height: 100%; }\n  .nav > li > button.active {\n    color: #fff;\n    background-color: #00a5be; }\n\n.migrate-li {\n  width: 190px;\n  margin-right: 15px; }\n\n.infoTitle {\n  font-weight: bold;\n  font-size: large; }\n\n.infoP {\n  font-size: medium;\n  word-break: break-word; }\n\n.migration-footer {\n  z-index: -100;\n  border: none;\n  background: black;\n  height: 70px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px; }\n\n.save-btn {\n  border: 2px solid #00a3bb;\n  border-radius: 20px;\n  color: black;\n  background: white;\n  width: 120px;\n  padding: 7px;\n  margin-top: 15px;\n  margin-bottom: 15px; }\n\n.save-btn-disabled {\n  border: 2px solid #5d6066 !important;\n  border-radius: 20px;\n  color: #bbbbbf !important;\n  background: #ffffff14 !important;\n  width: 120px;\n  padding: 7px;\n  margin-top: 15px;\n  margin-bottom: 15px; }\n\n.channel-control {\n  width: 425px;\n  height: 45px;\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border: 2px solid #dedee0;\n  border-radius: 5px;\n  margin-bottom: 20px; }\n\n.migrateModalBtn {\n  border-radius: 22px;\n  border: 2px solid grey;\n  color: #ffffff;\n  background: white;\n  width: 133px;\n  height: 41px;\n  float: right;\n  margin-left: 10px; }\n\n.portalSetup {\n  background: #ffffff;\n  border: 2px solid #00a3bb;\n  border-radius: 45px;\n  width: 192px;\n  height: 41px;\n  margin-bottom: 10px; }\n\n.progress-table {\n  font-family: arial, sans-serif;\n  border-collapse: collapse;\n  width: 100%; }\n\n.progress-table td {\n  text-align: left;\n  padding: 8px; }\n\n.progress-table th {\n  text-align: left;\n  padding: 8px; }\n\n.tab-holder .well {\n  box-shadow: none;\n  background-color: #fafafa;\n  border: 1px solid #ebebeb;\n  margin-bottom: 0; }\n\n.top-rail .navbar {\n  margin-bottom: 0;\n  border-radius: 0;\n  border: 0;\n  height: 50px;\n  background: #fff;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.23); }\n  .top-rail .navbar img.logo {\n    height: 20px;\n    margin: 0;\n    display: inline;\n    vertical-align: middle;\n    position: relative;\n    top: -2px; }\n  .top-rail .navbar h3 {\n    margin-top: 0;\n    margin-bottom: 0;\n    line-height: 50px;\n    font-size: 20px;\n    color: rgba(0, 0, 0, 0.8); }\n  .top-rail .navbar .notification-icons {\n    line-height: 50px;\n    padding-right: 15px; }\n  .top-rail .navbar .navbar-header {\n    width: 230px;\n    height: 49px;\n    background: #fff; }\n    .top-rail .navbar .navbar-header a {\n      padding: 0 15px;\n      line-height: 50px;\n      color: #fd4c4c;\n      font-size: 30px; }\n    .top-rail .navbar .navbar-header.mobile {\n      width: 100%;\n      color: #333;\n      text-align: center; }\n  .top-rail .navbar .nav > li > a {\n    padding: 0 15px;\n    line-height: 50px;\n    color: #000; }\n  .top-rail .navbar .navbar-brand .spin-box,\n  .top-rail .navbar .navbar-brand .spin-box-bg {\n    position: absolute;\n    left: 32px;\n    top: 0;\n    width: 15px;\n    height: 20px;\n    top: 15px;\n    background: #fff; }\n  .top-rail .navbar .navbar-brand .spin-box {\n    border: 4px solid #20998b;\n    animation-name: box-3d-rotate;\n    animation-duration: 1500ms;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear; }\n\n@keyframes box-3d-rotate {\n  from {\n    transform: rotateY(0deg); }\n  to {\n    transform: rotateY(360deg); } }\n\n.with-eyebrow .top-rail .navbar {\n  height: 92px; }\n\n.eyebrow {\n  background: var(--color-bx-lagoon);\n  transition: background-color 0.2s ease-in;\n  padding: 10px 30px;\n  font-size: 16px; }\n  .eyebrow a {\n    color: #fff;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n\n.eyebrow:hover {\n  background: #0094b8; }\n\n.recording-trimmer .zoom-scroll-pan-container {\n  overflow-x: scroll;\n  overflow-y: hidden;\n  position: relative;\n  top: -15px;\n  height: 120px;\n  padding: 10px 10px 0 10px;\n  /* left and right only ...\n        box-shadow: inset 25px 0px 25px -25px rgba(0,0,0,0.45),\n                    inset -25px 0px 25px -25px rgba(0,0,0,0.45);\n        */\n  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3); }\n  .recording-trimmer .zoom-scroll-pan-container::-webkit-scrollbar {\n    width: 0.5em;\n    height: 0.5em; }\n  .recording-trimmer .zoom-scroll-pan-container::-webkit-scrollbar-thumb {\n    background: slategray; }\n  .recording-trimmer .zoom-scroll-pan-container::-webkit-scrollbar-track {\n    background: #b8c0c8; }\n  .recording-trimmer .zoom-scroll-pan-container {\n    scrollbar-face-color: slategray;\n    scrollbar-track-color: #b8c0c8; }\n\n.recording-trimmer .mosaic {\n  position: relative;\n  z-index: 1; }\n  .recording-trimmer .mosaic div {\n    display: inline-block;\n    height: 75px;\n    background-size: cover; }\n\n.recording-trimmer .hidden-region-mask {\n  z-index: 2;\n  position: absolute;\n  top: 0;\n  height: 75px;\n  background-color: #4e5c69;\n  background-image: url(/img/textures/ps-neutral.png);\n  opacity: 0.8; }\n  .recording-trimmer .hidden-region-mask.start-point-mask {\n    left: 0; }\n  .recording-trimmer .hidden-region-mask.end-point-mask {\n    margin-left: 10px;\n    right: 0px; }\n\n.recording-trimmer .start-point-preview,\n.recording-trimmer .end-point-preview {\n  position: absolute; }\n  .recording-trimmer .start-point-preview div,\n  .recording-trimmer .end-point-preview div {\n    margin-left: -58px; }\n    .recording-trimmer .start-point-preview div img,\n    .recording-trimmer .end-point-preview div img {\n      position: absolute;\n      height: 75px;\n      top: -109px;\n      z-index: 3;\n      border: 1px solid #000; }\n\nrzslider.trim {\n  margin-top: 0;\n  margin-bottom: 30px;\n  position: relative;\n  top: -75px;\n  z-index: 4; }\n  rzslider.trim .rz-pointer {\n    -webkit-border-radius: 2px;\n    -moz-border-radius: 2px;\n    border-radius: 2px;\n    width: 16px;\n    height: 75px;\n    top: 0;\n    background-color: #dacd17;\n    display: block !important; }\n  rzslider.trim .rz-pointer:after,\n  rzslider.trim .rz-pointer:hover:after,\n  rzslider.trim .rz-pointer.rz-active:hover:after,\n  rzslider.trim .rz-pointer.rz-active:after {\n    background-color: transparent;\n    top: 6px;\n    left: 3px; }\n  rzslider.trim .rz-pointer:after {\n    font-size: 20px;\n    font-weight: bold;\n    line-height: 62px;\n    color: #000;\n    content: '\\2016'; }\n  rzslider.trim .rz-bar {\n    background: transparent;\n    height: 75px; }\n  rzslider.trim .rz-bar.rz-selection {\n    background: transparent;\n    border: 4px solid #dacd17;\n    border-radius: 4px; }\n  rzslider.trim .rz-bubble {\n    bottom: -90px;\n    padding: 1px 3px;\n    color: #55637d;\n    cursor: default; }\n\nrzslider.trim-blue-solid {\n  margin-top: 0;\n  margin-bottom: 40px; }\n  rzslider.trim-blue-solid .rz-pointer {\n    -webkit-border-radius: 2px;\n    -moz-border-radius: 2px;\n    border-radius: 2px;\n    width: 16px;\n    height: 40px;\n    top: 0;\n    background-color: #333;\n    display: block !important; }\n  rzslider.trim-blue-solid .rz-pointer:after,\n  rzslider.trim-blue-solid .rz-pointer:hover:after,\n  rzslider.trim-blue-solid .rz-pointer.rz-active:hover:after,\n  rzslider.trim-blue-solid .rz-pointer.rz-active:after {\n    background-color: transparent;\n    top: 6px;\n    left: 3px; }\n  rzslider.trim-blue-solid .rz-pointer:after {\n    font-size: 20px;\n    font-weight: bold;\n    color: #989898;\n    text-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n    content: '\\2016'; }\n  rzslider.trim-blue-solid .rz-bar {\n    background-color: #4e5c69;\n    background-image: url(/img/textures/ps-neutral.png);\n    height: 40px; }\n  rzslider.trim-blue-solid .rz-bar.rz-selection {\n    background-color: #337ab7;\n    background-image: url(/img/textures/subtle-dots.png); }\n  rzslider.trim-blue-solid .rz-bubble {\n    bottom: -53px;\n    padding: 1px 3px;\n    color: #55637d;\n    cursor: default; }\n\nrzslider.playhead {\n  margin-top: 0;\n  margin-bottom: 0; }\n  rzslider.playhead .rz-bar {\n    background-color: #ccc; }\n  rzslider.playhead .rz-pointer {\n    box-shadow: 0 0 6px rgba(0, 0, 0, 0.6);\n    background-color: #d24e37;\n    height: 16px;\n    width: 16px;\n    top: -6px; }\n  rzslider.playhead .rz-pointer:after {\n    display: none; }\n  rzslider.playhead .rz-bubble {\n    display: none; }\n\n.slider-zoom-trapezoid {\n  border-top: 30px solid rgba(234, 211, 165, 0.47);\n  border-left: 50px solid transparent;\n  border-right: 50px solid transparent;\n  height: 0;\n  width: 100%;\n  position: relative;\n  top: -22px;\n  margin-bottom: -22px; }\n\n.drop-box {\n  text-align: center;\n  padding: 10px; }\n  .drop-box .drop-target {\n    border: 3px dashed #ccc;\n    border-radius: 12px; }\n    .drop-box .drop-target i.fa {\n      font-size: 10em;\n      color: #cdcfd1; }\n  .drop-box img,\n  .drop-box video {\n    width: 100%;\n    max-width: 320px;\n    max-height: 240px; }\n  .drop-box.dragover {\n    /* highlight in blue when dragging file over target region */ }\n    .drop-box.dragover .drop-target {\n      background-color: #ecf3f9;\n      border-color: #428bca; }\n  .drop-box .browse-link {\n    color: #3366bb;\n    cursor: pointer; }\n  .drop-box .browse-link:hover {\n    text-decoration: underline; }\n  .drop-box .no-file {\n    color: #676;\n    margin: 25px 0; }\n  .drop-box [hidden] {\n    display: none !important; }\n\n.drop-box.compact {\n  padding: 0;\n  border-radius: 12px;\n  font-size: 1.4rem; }\n  .drop-box.compact .supported-filetypes,\n  .drop-box.compact i.fa {\n    display: none; }\n  .drop-box.compact img,\n  .drop-box.compact video {\n    max-width: 100%; }\n\n.upload-modal .right-col {\n  padding: 15px 30px 0 0; }\n  @media (max-width: 767px) {\n    .upload-modal .right-col {\n      padding-left: 30px; } }\n  .upload-modal .right-col label {\n    white-space: nowrap; }\n\n.has-file {\n  border-radius: 5px;\n  padding-bottom: 15px; }\n  .has-file .remove-icon {\n    color: #3f3f3f;\n    font-size: 1.25em; }\n    .has-file .remove-icon:hover {\n      transform: scale(1.1); }\n  .has-file .file-icon {\n    font-size: 5em;\n    color: #3f3f3f;\n    margin-left: 10px; }\n  .has-file img,\n  .has-file video {\n    width: 100%;\n    height: auto;\n    padding: 0 15px; }\n\n.wifi-icon {\n  background-color: transparent;\n  border: 4px solid transparent;\n  border-top-color: #444;\n  border-radius: 4px;\n  height: 8px;\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transition: border-top-color 0.3s linear;\n  width: 8px;\n  transform: translate(-25%); }\n  .wifi-icon:before, .wifi-icon:after {\n    content: '';\n    background-color: transparent;\n    border: 2.83688px solid transparent;\n    border-top-color: #444;\n    position: absolute;\n    transition: border-top-color 0.3s linear; }\n  .wifi-icon:before {\n    border-radius: 8px;\n    height: 16px;\n    left: -8px;\n    top: -8px;\n    width: 16px; }\n  .wifi-icon:after {\n    border-radius: 24px;\n    height: 24px;\n    left: -12px;\n    top: -12px;\n    width: 24px; }\n  .wifi-icon.none {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n    .wifi-icon.none:before, .wifi-icon.none:after {\n      border-top-color: rgba(68, 68, 68, 0.4); }\n  .wifi-icon.weak:before, .wifi-icon.weak:after {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n  .wifi-icon.medium:after {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n\n.wifi-icon-large {\n  background-color: transparent;\n  border: 10px solid transparent;\n  border-top-color: #444;\n  border-radius: 10px;\n  height: 20px;\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transition: border-top-color 0.3s linear;\n  width: 20px;\n  transform: translate(-50%); }\n  .wifi-icon-large:before, .wifi-icon-large:after {\n    content: '';\n    background-color: transparent;\n    border: 7.0922px solid transparent;\n    border-top-color: #444;\n    position: absolute;\n    transition: border-top-color 0.3s linear; }\n  .wifi-icon-large:before {\n    border-radius: 20px;\n    height: 40px;\n    left: -20px;\n    top: -20px;\n    width: 40px; }\n  .wifi-icon-large:after {\n    border-radius: 60px;\n    height: 60px;\n    left: -30px;\n    top: -30px;\n    width: 60px; }\n  .wifi-icon-large.none {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n    .wifi-icon-large.none:before, .wifi-icon-large.none:after {\n      border-top-color: rgba(68, 68, 68, 0.4); }\n  .wifi-icon-large.weak:before, .wifi-icon-large.weak:after {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n  .wifi-icon-large.medium:after {\n    border-top-color: rgba(68, 68, 68, 0.4); }\n\n.wifi-icon-large-green {\n  background-color: transparent;\n  border: 10px solid transparent;\n  border-top-color: green;\n  border-radius: 10px;\n  height: 20px;\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transition: border-top-color 0.3s linear;\n  width: 20px;\n  transform: translate(-50%); }\n  .wifi-icon-large-green:before, .wifi-icon-large-green:after {\n    content: '';\n    background-color: transparent;\n    border: 7.0922px solid transparent;\n    border-top-color: green;\n    position: absolute;\n    transition: border-top-color 0.3s linear; }\n  .wifi-icon-large-green:before {\n    border-radius: 20px;\n    height: 40px;\n    left: -20px;\n    top: -20px;\n    width: 40px; }\n  .wifi-icon-large-green:after {\n    border-radius: 60px;\n    height: 60px;\n    left: -30px;\n    top: -30px;\n    width: 60px; }\n  .wifi-icon-large-green.none {\n    border-top-color: rgba(0, 128, 0, 0.4); }\n    .wifi-icon-large-green.none:before, .wifi-icon-large-green.none:after {\n      border-top-color: rgba(0, 128, 0, 0.4); }\n  .wifi-icon-large-green.weak:before, .wifi-icon-large-green.weak:after {\n    border-top-color: rgba(0, 128, 0, 0.4); }\n  .wifi-icon-large-green.medium:after {\n    border-top-color: rgba(0, 128, 0, 0.4); }\n\n.wifi-icon-large-red {\n  background-color: transparent;\n  border: 10px solid transparent;\n  border-top-color: red;\n  border-radius: 10px;\n  height: 20px;\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transition: border-top-color 0.3s linear;\n  width: 20px;\n  transform: translate(-50%); }\n  .wifi-icon-large-red:before, .wifi-icon-large-red:after {\n    content: '';\n    background-color: transparent;\n    border: 7.0922px solid transparent;\n    border-top-color: red;\n    position: absolute;\n    transition: border-top-color 0.3s linear; }\n  .wifi-icon-large-red:before {\n    border-radius: 20px;\n    height: 40px;\n    left: -20px;\n    top: -20px;\n    width: 40px; }\n  .wifi-icon-large-red:after {\n    border-radius: 60px;\n    height: 60px;\n    left: -30px;\n    top: -30px;\n    width: 60px; }\n  .wifi-icon-large-red.none {\n    border-top-color: rgba(255, 0, 0, 0.4); }\n    .wifi-icon-large-red.none:before, .wifi-icon-large-red.none:after {\n      border-top-color: rgba(255, 0, 0, 0.4); }\n  .wifi-icon-large-red.weak:before, .wifi-icon-large-red.weak:after {\n    border-top-color: rgba(255, 0, 0, 0.4); }\n  .wifi-icon-large-red.medium:after {\n    border-top-color: rgba(255, 0, 0, 0.4); }\n\n.wifi-icon-large-orange {\n  background-color: transparent;\n  border: 10px solid transparent;\n  border-top-color: orange;\n  border-radius: 10px;\n  height: 20px;\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transition: border-top-color 0.3s linear;\n  width: 20px;\n  transform: translate(-50%); }\n  .wifi-icon-large-orange:before, .wifi-icon-large-orange:after {\n    content: '';\n    background-color: transparent;\n    border: 7.0922px solid transparent;\n    border-top-color: orange;\n    position: absolute;\n    transition: border-top-color 0.3s linear; }\n  .wifi-icon-large-orange:before {\n    border-radius: 20px;\n    height: 40px;\n    left: -20px;\n    top: -20px;\n    width: 40px; }\n  .wifi-icon-large-orange:after {\n    border-radius: 60px;\n    height: 60px;\n    left: -30px;\n    top: -30px;\n    width: 60px; }\n  .wifi-icon-large-orange.none {\n    border-top-color: rgba(255, 165, 0, 0.4); }\n    .wifi-icon-large-orange.none:before, .wifi-icon-large-orange.none:after {\n      border-top-color: rgba(255, 165, 0, 0.4); }\n  .wifi-icon-large-orange.weak:before, .wifi-icon-large-orange.weak:after {\n    border-top-color: rgba(255, 165, 0, 0.4); }\n  .wifi-icon-large-orange.medium:after {\n    border-top-color: rgba(255, 165, 0, 0.4); }\n\n.wizard-steps {\n  display: flex;\n  width: 100%;\n  position: relative; }\n  .wizard-steps .step {\n    flex: 1;\n    text-align: center; }\n    .wizard-steps .step .bounding-box {\n      display: inline-block; }\n    .wizard-steps .step span.label {\n      font-size: 1.6rem;\n      margin-bottom: 10px;\n      display: inline-block;\n      background-color: #aaa;\n      font-weight: 700; }\n    .wizard-steps .step.done .bounding-box {\n      cursor: pointer; }\n    .wizard-steps .step.done span.label {\n      background-color: #5cb85c; }\n    .wizard-steps .step.active span.label {\n      background-color: #337ab7; }\n    .wizard-steps .step p {\n      font-weight: bold;\n      font-size: 12px; }\n    .wizard-steps .step:first-child::before {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 10px;\n      height: 4px;\n      background-color: #ccc;\n      border-radius: 2px;\n      content: ' ';\n      z-index: -1; }\n\n.resource-card {\n  max-width: 1024px;\n  padding: 0; }\n  .resource-card .img-container {\n    width: 25%; }\n  .resource-card .content-container {\n    width: 75%;\n    padding: 15px; }\n  .resource-card .label {\n    float: right;\n    margin-bottom: 15px;\n    display: block; }\n  @media (max-width: 767px) {\n    .resource-card .img-container {\n      display: none; }\n    .resource-card .content-container {\n      width: 100%; }\n    .resource-card .label {\n      display: none; } }\n  .resource-card h3 {\n    border-bottom: 1px solid #149eda;\n    padding-bottom: 5px; }\n  .resource-card h4 {\n    margin-bottom: 5px;\n    font-size: 15px;\n    font-weight: bold; }\n  .resource-card p {\n    font-size: 13px;\n    color: #676767; }\n  .resource-card li {\n    border-bottom: 1px solid #ddd; }\n  .resource-card li:last-child {\n    border-bottom: none; }\n\n.platform-banner-text {\n  font-size: 1em;\n  color: #fff; }\n\n.platform-description {\n  font-size: 1.2em;\n  margin-bottom: 30px;\n  border-left: 2px solid #1aa8a1;\n  line-height: 2; }\n\n@media (min-width: 768px) {\n  /* large screens have 9 icons across + 1 empty space at beginning and end .. thus 11 x 100/11% equally spaced columns */\n  .platform-banner {\n    background-image: url(//cdn2.hubspot.net/hubfs/484866/BoxCast_May2016/Platform-Background-Lines.png?t=1472503471940);\n    background-size: cover;\n    background-color: #1aa8a1;\n    margin-top: 40px;\n    margin-bottom: 30px; }\n  .platform-banner li {\n    width: 8.8%;\n    display: block;\n    float: left;\n    margin: 0;\n    padding: 15px 0;\n    background: transparent;\n    text-align: center;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .platform-banner li img {\n    max-width: 80%; }\n  .platform-banner li.hover {\n    background: rgba(0, 0, 0, 0.2); }\n  .platform-banner li.active {\n    background: rgba(0, 0, 0, 0.3); }\n  .building-graphic {\n    max-width: 300px;\n    margin: 15px auto; } }\n\n@media (max-width: 767px) {\n  /* small screens need to hide the first and last empty spaces, and stack 3-across otherwise (3x3 grid) */\n  .platform-banner {\n    background-image: none;\n    background-color: #1aa8a1;\n    margin-top: 40px;\n    margin-bottom: 50px; }\n  .platform-banner li {\n    width: 33%;\n    display: block;\n    float: left;\n    padding: 15px;\n    background: transparent; }\n  .platform-banner li.empty-space {\n    display: none; }\n  .platform-banner li.hover {\n    background: rgba(0, 0, 0, 0.2); }\n  .platform-banner li.active {\n    background: rgba(0, 0, 0, 0.3); }\n  .building-graphic {\n    max-width: 200px;\n    margin: 15px auto; } }\n\n.market-icon {\n  max-width: 20%; }\n\n.radio-button-well {\n  opacity: 1;\n  background-color: white;\n  border: 1px solid;\n  border-color: #d0d0d0;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  padding: 10px; }\n  .radio-button-well a {\n    border-bottom: none;\n    color: black;\n    text-decoration: none; }\n  .radio-button-well i {\n    width: 20px;\n    text-align: center; }\n\n.radio-button-well-selected {\n  opacity: 1;\n  background-color: white;\n  border: 2px solid #5cb85c;\n  padding: 8px;\n  /* absorb the extra padding */\n  border-radius: 4px; }\n\n@keyframes fade-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 100%; } }\n\n.modal-checkout .add-on-alert {\n  background-color: #d9edf7;\n  padding: 8px 8px 8px 8px !important;\n  margin-left: 20px;\n  border-radius: 5px;\n  margin-top: 8px; }\n\n.modal-checkout .alert {\n  margin-bottom: 0;\n  text-align: left;\n  padding: 10px;\n  opacity: 100%;\n  animation-name: fade-in;\n  animation-duration: 500ms; }\n\n.modal-checkout .checkout-message {\n  opacity: 0.75;\n  font-weight: normal;\n  font-size: 8pt;\n  line-height: 1.1em; }\n\n.modal-checkout .alert-danger {\n  color: white;\n  background-color: #a94442;\n  border-color: #a94442; }\n\n.modal-checkout .add-on-alert div {\n  padding-left: 0 !important; }\n\n.modal-checkout .btn-breadcrumb {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr); }\n  .modal-checkout .btn-breadcrumb .btn {\n    width: 100%; }\n  .modal-checkout .btn-breadcrumb .btn.active {\n    width: auto;\n    padding-right: 6px; }\n    .modal-checkout .btn-breadcrumb .btn.active .step-label {\n      display: inline;\n      font-size: 16px;\n      width: min-content; }\n  .modal-checkout .btn-breadcrumb .step-label {\n    display: none;\n    font-size: 16px; }\n  .modal-checkout .btn-breadcrumb .fa-check-circle,\n  .modal-checkout .btn-breadcrumb .fa-circle-o {\n    font-size: 19px;\n    margin: 0; }\n  .modal-checkout .btn-breadcrumb .fa-circle-o {\n    color: slategray; }\n  .modal-checkout .btn-breadcrumb .fa-check-circle {\n    color: #1aa8a1; }\n  @media (min-width: 576px) {\n    .modal-checkout .btn-breadcrumb .fa-check-circle {\n      margin-right: 10px; }\n    .modal-checkout .btn-breadcrumb .breadcrumb-mobile {\n      display: none; }\n    .modal-checkout .btn-breadcrumb .step-label {\n      display: inline; } }\n\n.modal-checkout .compare-options {\n  font-size: 12px; }\n  @media (min-width: 576px) {\n    .modal-checkout .compare-options {\n      float: right;\n      font-size: 14px; } }\n\n.modal-checkout .overview {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 10px; }\n  .modal-checkout .overview .toggle-icon {\n    transition: all 0.3s;\n    font-size: 20px;\n    font-weight: 300;\n    color: #006c80;\n    margin-left: 10px;\n    transform: rotate(0deg); }\n    @media (min-width: 576px) {\n      .modal-checkout .overview .toggle-icon {\n        display: none; } }\n  .modal-checkout .overview .toggle-icon.collapse {\n    transform: rotate(45deg); }\n  .modal-checkout .overview .price {\n    margin-bottom: 0; }\n  .modal-checkout .overview > * {\n    height: 100%;\n    align-self: center; }\n  @media (min-width: 576px) {\n    .modal-checkout .overview {\n      display: flex;\n      flex-direction: column;\n      padding-left: 0; }\n      .modal-checkout .overview .price {\n        margin-bottom: 10px; } }\n\n.modal-checkout .plan-details {\n  overflow: hidden;\n  max-height: 0;\n  transition: max-height 0.35s ease-in-out; }\n  @media (min-width: 576px) {\n    .modal-checkout .plan-details {\n      display: flex;\n      flex-direction: column;\n      max-height: 100%;\n      height: 100%; } }\n\n.modal-checkout .show {\n  transition: max-height 0.35s ease-in-out;\n  max-height: 300px; }\n\n.pricing-table-row {\n  display: flex;\n  flex-wrap: wrap;\n  text-align: center;\n  flex: 1; }\n  .pricing-table-row .pricing-col {\n    display: flex;\n    flex: 1; }\n    @media (max-width: 575px) {\n      .pricing-table-row .pricing-col {\n        width: 100%;\n        padding-bottom: 15px; } }\n    @media (min-width: 576px) {\n      .pricing-table-row .pricing-col {\n        padding-bottom: 0; } }\n  .pricing-table-row .pricing-col > div {\n    flex: 1;\n    border: 2px solid transparent;\n    border-radius: 4px;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);\n    padding: 6px;\n    display: flex;\n    flex-direction: column;\n    position: relative; }\n    .pricing-table-row .pricing-col > div .current-plan-flag {\n      position: absolute;\n      left: -2px;\n      right: -2px;\n      top: -20px;\n      background: #1aa8a1;\n      color: white;\n      text-align: center;\n      font-size: 10px;\n      font-weight: bold;\n      border-radius: 4px 4px 0 0;\n      padding: 5px 0; }\n  .pricing-table-row h3 {\n    font-size: 12pt;\n    font-weight: bold;\n    margin: -10px -10px 0px -10px;\n    padding: 10px 0; }\n  .pricing-table-row .price {\n    font-size: 14px;\n    font-weight: bold; }\n  .pricing-table-row .subtitle {\n    font-size: 9pt;\n    font-weight: bold;\n    margin-bottom: 10px; }\n  .pricing-table-row .subtext {\n    line-height: 1.2em;\n    opacity: 1;\n    font-weight: normal;\n    font-size: 12px; }\n  .pricing-table-row .checkout-divider {\n    border-top: 1px solid #70707080; }\n  .pricing-table-row .small-text {\n    font-size: 8pt; }\n  .pricing-table-row ul {\n    flex: 0 1 auto; }\n    .pricing-table-row ul li {\n      margin-bottom: 2px;\n      font-size: 14px; }\n  .pricing-table-row .pricing-col.active > div {\n    border: 2px solid #1aa; }\n  .pricing-table-row .pricing-col .cta {\n    margin-top: auto; }\n  .pricing-table-row .pricing-col .btn-block {\n    margin-top: 5px; }\n  .pricing-table-row .pricing-col.encoder-options {\n    text-align: left;\n    width: 100%;\n    margin-top: 10px; }\n  .pricing-table-row .pricing-col.encoder-options > div {\n    display: block;\n    /*not a flex column*/\n    line-height: 1em;\n    overflow: scroll; }\n  .pricing-table-row .pricing-col.encoder-options .price {\n    float: right; }\n  .pricing-table-row .pricing-col.encoder-options .radio label,\n  .pricing-table-row .pricing-col.encoder-options .checkbox label,\n  .pricing-table-row p.section-head {\n    font-weight: bold;\n    margin-bottom: 0;\n    line-height: 1.2; }\n  .pricing-table-row .promo-copy {\n    line-height: 1.2;\n    margin-bottom: 0; }\n  .pricing-table-row .radio label,\n  .pricing-table-row .checkbox label {\n    font-weight: bold;\n    margin-bottom: 0; }\n  .pricing-table-row .pricing-col.encoder-options .radio div,\n  .pricing-table-row .pricing-col.encoder-options .checkbox div {\n    padding-left: 20px; }\n  .pricing-table-row .radio div.subtext,\n  .pricing-table-row .checkbox div.subtext:first-of-type {\n    max-width: 75%; }\n  .pricing-table-row .form-control {\n    width: unset;\n    padding: 3px;\n    height: 28px; }\n  .pricing-table-row .info-input {\n    width: unset;\n    padding: 3px;\n    height: 28px;\n    border: 2px solid green; }\n  .pricing-table-row .radio + .radio,\n  .pricing-table-row .checkbox + .checkbox {\n    margin-top: 10px; }\n  .pricing-table-row .interval-radio div.subtext {\n    max-width: 100%; }\n  .pricing-table-row .add-on-quantity {\n    display: flex;\n    margin-top: 8px;\n    align-items: center; }\n  .pricing-table-row .add-on-quantity input {\n    max-width: 40px;\n    max-height: 30px; }\n  .pricing-table-row .add-on-container {\n    display: block;\n    line-height: 1em;\n    max-height: 200px;\n    overflow-y: scroll; }\n    .pricing-table-row .add-on-container div:first-child {\n      margin-top: 10px; }\n    .pricing-table-row .add-on-container > div {\n      display: grid;\n      grid-template-columns: 1fr auto; }\n      .pricing-table-row .add-on-container > div .price {\n        grid-column: 2;\n        grid-row: 1; }\n      .pricing-table-row .add-on-container > div > div {\n        grid-column: 1;\n        grid-row: 1;\n        margin-top: 0; }\n  @media (max-width: 767px) {\n    .pricing-table-row .interval-radio {\n      margin-left: 16px;\n      width: 100%; } }\n  @media (min-width: 768px) {\n    .pricing-table-row .interval-radio {\n      margin-left: 16px;\n      width: 45%; } }\n  @media (min-width: 992px) {\n    .pricing-table-row .interval-radio {\n      margin-left: 16px; } }\n\n.sm-storagePolicy {\n  border: 2px solid transparent;\n  border-radius: 4px;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);\n  padding: 2rem;\n  display: flex;\n  margin-bottom: 2rem;\n  align-items: center;\n  font-weight: normal; }\n  .sm-storagePolicy__input {\n    padding-right: 2rem; }\n  .sm-storagePolicy__message p:first-child {\n    margin-bottom: 3px; }\n  .sm-storagePolicy__message p:last-child {\n    margin-bottom: 0; }\n  .sm-storagePolicy__price {\n    margin-left: auto; }\n\n@media (min-width: 768px) {\n  .payment .payment-details {\n    border-left: 3px #eee solid; } }\n\n.order-summary .order-summary-head {\n  display: flex;\n  justify-content: space-between; }\n\n.order-summary div#order-summary-container {\n  max-height: 182px;\n  overflow-y: scroll; }\n\n.order-summary .order-summary-table tbody tr th,\n.order-summary .order-summary-table tbody tr td {\n  font-size: 12px; }\n\n.order-summary .order-summary-table tbody tr th {\n  padding-left: 0; }\n\n.order-summary .order-summary-scroll.btn-breadcrumb {\n  width: initial;\n  display: none; }\n\n.order-summary .btn-breadcrumb .btn {\n  width: initial; }\n\n.order-summary .btn-breadcrumb .btn,\n.order-summary .btn-breadcrumb .btn:first-child,\n.order-summary .btn-breadcrumb .btn:last-child {\n  padding: 1px 6px 1px 6px; }\n\n.order-summary .btn-group-vertical > .btn,\n.order-summary .btn-group > .btn {\n  position: initial;\n  float: left; }\n\n.order-summary .btn-breadcrumb .btn:not(:last-child):after {\n  content: ' ';\n  border-top: none;\n  border-bottom: none;\n  border-left: none;\n  position: absolute; }\n\n.order-summary .btn-breadcrumb .btn:not(:last-child):before {\n  content: ' ';\n  border-top: none;\n  border-bottom: none;\n  border-left: none;\n  position: absolute; }\n\n.modal-footer {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  flex-flow: column-reverse; }\n  .modal-footer span,\n  .modal-footer span > .btn {\n    width: 100%;\n    margin-left: 0 !important; }\n  .modal-footer .back-button {\n    margin: 10px 0; }\n  @media (min-width: 768px) {\n    .modal-footer {\n      display: block; }\n      .modal-footer span,\n      .modal-footer span > .btn {\n        width: auto; }\n      .modal-footer .back-button {\n        margin: 0 10px; } }\n  .modal-footer p {\n    margin-bottom: 0.5rem;\n    margin-top: 0.5rem; }\n\n.order-status-modal .icon {\n  padding: 5px 25px; }\n\n.order-status-modal .icon img {\n  height: 60px; }\n\n.order-status-modal .line img {\n  width: 75px; }\n\n.order-status-modal .line div {\n  border: 2px solid #59b659;\n  width: 75px; }\n\n.order-status-modal .order-info div {\n  margin: 0px;\n  padding: 0px;\n  text-align: left; }\n\n.order-status-modal .order-info label {\n  margin-bottom: 0px; }\n\n.order-status-modal .order-status td {\n  vertical-align: text-top; }\n\n.sport-tiles {\n  margin: 1rem 0;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); }\n  @media screen and (min-width: 768px) {\n    .sport-tiles {\n      gap: 1rem;\n      grid-template-columns: repeat(4, 1fr);\n      grid-template-rows: repeat(2, 1fr); } }\n\n.sport-tile {\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n  display: flex; }\n  @media screen and (min-width: 768px) {\n    .sport-tile {\n      width: auto; } }\n  .sport-tile__inner {\n    padding: 12px;\n    line-height: 1;\n    white-space: normal; }\n    @media screen and (max-width: 767px) {\n      .sport-tile__inner {\n        border-color: #e7e7e7; } }\n  .sport-tile__icon {\n    display: block;\n    margin: 0 auto 0.4rem; }\n  .sport-tile__label {\n    display: inline-block;\n    margin-top: 4px;\n    line-height: 1; }\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 42px;\n  height: 24px;\n  line-height: 24px;\n  margin-bottom: 0;\n  vertical-align: bottom; }\n  .toggle-switch input {\n    display: none; }\n  .toggle-switch .slider {\n    display: inline-block;\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    transition: 0.2s;\n    border-radius: 24px; }\n  .toggle-switch .slider:before {\n    position: absolute;\n    content: '';\n    height: 16px;\n    width: 16px;\n    left: 4px;\n    bottom: 4px;\n    background-color: white;\n    transition: 0.2s;\n    border-radius: 50%; }\n  .toggle-switch--green input:checked + .slider {\n    background-color: #5cb85c; }\n  .toggle-switch--green input:focus + .slider {\n    box-shadow: 0 0 1px #5cb85c; }\n  .toggle-switch--blue input:checked + .slider {\n    background-color: #2196f3; }\n  .toggle-switch--blue input:focus + .slider {\n    box-shadow: 0 0 1px #2196f3; }\n  .toggle-switch input:checked + .slider:before {\n    transform: translateX(18px); }\n\n.table-fixed {\n  table-layout: fixed; }\n\n.analytics h3,\n.analytics h4 {\n  margin-top: 0; }\n\n.analytics h4 {\n  border-bottom: 1px solid #149eda;\n  margin-bottom: 15px;\n  padding-bottom: 5px;\n  text-align: center; }\n\n.analytics h1 {\n  font-weight: bold;\n  font-size: 2.6em; }\n\n.analytics .achievements {\n  text-align: center; }\n  .analytics .achievements achievements-cell {\n    margin: 10px 0; }\n\n.analytics .achievements .locked {\n  opacity: 0.2; }\n\n.analytics .achievements .unlocked .fa {\n  color: #f5e174; }\n\n.analytics .achievements label {\n  display: block;\n  font-size: 1.4rem;\n  font-weight: bold; }\n\n.analytics .achievements .locked label {\n  opacity: 0; }\n\n.analytics .col-xs-12:last-of-type .well {\n  margin-bottom: 0; }\n\n.broadcast-details-right-col h4 {\n  margin-top: 0;\n  font-size: 1.4rem;\n  font-weight: bold;\n  color: var(--color-bx-grey-darken-2);\n  text-transform: uppercase; }\n\n.broadcast-details-right-col .destination-details {\n  background: #fff;\n  border: 1px solid #ccc;\n  position: relative;\n  top: -2px;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  padding: 5px 10px;\n  font-size: 1.4rem; }\n\n.broadcast-details-right-col .diagnostics--icon-,\n.broadcast-details-right-col .diagnostics--icon-unknown {\n  color: #ccc; }\n\n.broadcast-details-right-col .diagnostics--icon-connected {\n  color: var(--color-bx-green-lighten-1); }\n\n.broadcast-details-right-col .diagnostics--icon-warning {\n  color: orange; }\n\n.broadcast-details-right-col .btn .fa.pull-right {\n  margin-top: 5px;\n  font-size: 0.7em; }\n\n@media (min-width: 768px) {\n  .broadcast-details-right-col {\n    padding-left: 0; } }\n\n.table-no-border {\n  border: none; }\n  .table-no-border td,\n  .table-no-border th,\n  .table-no-border tr {\n    border: none !important; }\n\n.caption-upload-cell .drop-box {\n  background: #fff;\n  padding: 0; }\n  .caption-upload-cell .drop-box.drag-over {\n    background: #ffffd4; }\n\n.caption-table .caption-table--header {\n  background: #555;\n  color: #fff;\n  line-height: 23px !important;\n  border-radius: 4px 4px 0 0;\n  padding: 10px; }\n\n.caption-table .caption--row {\n  margin-left: 0;\n  margin-right: 0;\n  padding: 5px; }\n\n.caption-table .caption--text textarea {\n  border: none;\n  box-shadow: none;\n  resize: none;\n  outline: none;\n  width: 100%;\n  background: transparent;\n  padding: 0;\n  line-height: 20px;\n  border-bottom: 2px solid transparent; }\n  .caption-table .caption--text textarea:hover {\n    border-color: rgba(0, 0, 0, 0.1); }\n  .caption-table .caption--text textarea:focus, .caption-table .caption--text textarea:active {\n    border-color: rgba(0, 0, 0, 0.25); }\n\n.caption-table .caption--start,\n.caption-table .caption--stop {\n  font-weight: bold;\n  font-size: 10pt; }\n  .caption-table .caption--start input,\n  .caption-table .caption--stop input {\n    padding: 0;\n    line-height: 25px; }\n\n.caption-table .caption--stop {\n  color: #ccc; }\n\n.caption-table .caption--row .caption--actions .fa {\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out; }\n\n.caption-table .caption--row:hover .caption--actions .fa {\n  opacity: 1; }\n\n.caption-table .caption--text {\n  padding-left: 15px; }\n\n.caption-table .caption--low-confidence .caption--text {\n  border-left: 8px solid #f1a74b !important;\n  padding-left: 7px;\n  /*7px padding + 8px border == 15px normal confidence padding*/ }\n\n.caption-table .caption--low-confidence .caption--text {\n  background: #fff5e6; }\n\n.caption-table .caption--playback-active {\n  background: aliceblue; }\n\n.caption-table .fa {\n  width: 22px;\n  height: 22px;\n  line-height: 20px;\n  color: #999;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  text-align: center; }\n\n.caption-table .fa-play {\n  padding-left: 2px; }\n\n.caption-table-scroll {\n  height: calc(100vh - 215px);\n  background: #fff;\n  overflow-y: scroll; }\n\n.caption--preview {\n  position: absolute;\n  bottom: 60px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  text-align: center; }\n  .caption--preview span {\n    font-weight: bold;\n    color: #fff;\n    background: rgba(0, 0, 0, 0.8);\n    border-radius: 4px;\n    padding: 5px; }\n\n.channel-card .broadcast-card {\n  padding: 0 !important;\n  padding-bottom: 15px !important; }\n\n.channel-card .broadcast-card--name a {\n  font-size: 10pt;\n  font-weight: bold;\n  color: #000;\n  text-decoration: none; }\n\n.channel-card .broadcast-card--name {\n  margin: 0 !important; }\n\n.channel-card .broadcast-card--name a:hover {\n  color: #000;\n  text-decoration: none; }\n\n.channel-card .broadcast-card--date {\n  margin-top: -2px; }\n\n.channel-card .broadcast-card--date .date-range {\n  font-weight: normal; }\n\n.channel-card .broadcast-card--description {\n  display: none; }\n\n.checkout-complete .cg-busy {\n  margin-top: 0; }\n\n.checkout-complete .cg-busy-backdrop {\n  margin-left: 0;\n  margin-right: 0;\n  margin-bottom: 0; }\n\n.checkout-complete .radio-button-well {\n  opacity: 1;\n  background-color: white;\n  border: 1px solid;\n  border-color: #d0d0d0;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  padding: 10px; }\n\n.checkout-complete .radio-button-well-selected {\n  border: 3px solid #3b763d;\n  padding: 8px;\n  /* absorb the extra padding */ }\n\n.fa.disabled {\n  opacity: 0.5; }\n\n.modal-checkout .btn-success {\n  text-transform: uppercase; }\n\n@keyframes turn-off {\n  0% {\n    transform: scale(1, 1.3) translate3d(0, 0, 0);\n    -webkit-filter: brightness(1);\n    filter: brightness(1);\n    opacity: 1; }\n  60% {\n    transform: scale(1.3, 0.001) translate3d(0, 0, 0);\n    -webkit-filter: brightness(10);\n    filter: brightness(10); }\n  100% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: scale(0, 0.0001) translate3d(0, 0, 0);\n    -webkit-filter: brightness(50);\n    filter: brightness(50); } }\n\n.screen {\n  border: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  background: #fff; }\n\n.turn-off.screen {\n  animation: turn-off 0.55s cubic-bezier(0.23, 1, 0.32, 1);\n  animation-fill-mode: forwards; }\n\nonboarding .onboarding-list {\n  display: inline-flex !important; }\n\nonboarding .onboarding-list .btn {\n  text-align: left !important;\n  white-space: normal !important;\n  min-height: 50px;\n  width: 100%;\n  text-transform: capitalize; }\n\nonboarding .onboarding-list span {\n  margin-right: 10px;\n  flex: 1;\n  max-width: 270px; }\n\n@media (max-width: 767px) {\n  onboarding .onboarding-list {\n    display: block !important;\n    white-space: normal !important; }\n  onboarding .onboarding-list .btn {\n    display: block !important;\n    height: 40px;\n    width: auto;\n    margin: 5px; }\n  onboarding .onboarding-list span {\n    margin-right: 0; } }\n\nonboarding .active .btn {\n  border-radius: 6px !important;\n  font-size: 1.2em;\n  color: white;\n  transform: scale(1.01); }\n  onboarding .active .btn i {\n    display: none; }\n\nonboarding .active .btn:hover {\n  box-shadow: 0px 0px 5px #888888;\n  color: white; }\n\nonboarding .complete .btn {\n  background-color: white;\n  color: #afb2b6;\n  border: 1px solid #449d44; }\n  onboarding .complete .btn span {\n    display: none; }\n\nonboarding .complete .btn:hover {\n  background-color: white;\n  color: #afb2b6; }\n\nonboarding .pending .btn {\n  background-color: white;\n  color: #343434;\n  border: 1px solid #343434; }\n  onboarding .pending .btn i {\n    display: none; }\n\nonboarding .pending .btn:hover {\n  background-color: white;\n  color: #343434; }\n\nonboarding .onboarding-item-heading {\n  margin: 5px 10px 0 0 !important;\n  font-size: 16pt; }\n\nonboarding .no-click {\n  pointer-events: none; }\n\n.account-settings .data-value {\n  float: right;\n  text-transform: capitalize; }\n\n.account-settings p.subsection-header {\n  font-weight: bold;\n  font-size: 0.8em;\n  opacity: 0.7;\n  margin-top: 15px;\n  border-bottom: 1px solid #ddd; }\n\n.boxcaster-card,\n.integration-card {\n  display: block;\n  border-radius: 4px;\n  padding: 0;\n  transition: transform 100ms ease-in;\n  background: #fafafa;\n  border: 1px solid #eee;\n  color: #333; }\n  .boxcaster-card .color--red,\n  .integration-card .color--red {\n    color: #d03532; }\n  .boxcaster-card .color--green,\n  .integration-card .color--green {\n    color: var(--color-bx-green); }\n  .boxcaster-card .color--online,\n  .integration-card .color--online {\n    color: var(--color-bx-green-lighten-1); }\n  .boxcaster-card .color--grey,\n  .integration-card .color--grey {\n    color: #ddd; }\n\n@media (max-width: 767px) {\n  .boxcaster-card,\n  .integration-card {\n    padding: 5px;\n    margin-left: -5px;\n    margin-right: -5px; }\n    .boxcaster-card .boxcaster-card-details,\n    .boxcaster-card .integration-card-details,\n    .integration-card .boxcaster-card-details,\n    .integration-card .integration-card-details {\n      margin-left: -5px;\n      margin-right: -5px;\n      margin-bottom: -5px; } }\n\n.boxcaster-card-header,\n.integration-card-header {\n  cursor: pointer; }\n\n.integration-card-header .label-list {\n  margin-top: 12px;\n  margin-bottom: 12px; }\n  .integration-card-header .label-list > li {\n    padding: 0; }\n\n.boxcaster-card .row,\n.integration-card .row {\n  display: flex;\n  align-items: center; }\n\n/* statuses: offline, ready, preparing_broadcast, broadcasting */\n.icon-power,\n.icon-streaming,\n.icon-video {\n  color: #34c335; }\n\n.status-offline .icon-power,\n.status-offline .icon-streaming,\n.status-offline .icon-video {\n  color: rgba(255, 255, 255, 0.4); }\n\n.status-ready .icon-streaming {\n  color: rgba(255, 255, 255, 0.4); }\n\n/* firmware issues should be highlighted */\n.firmware-invalid {\n  border-color: #ce5d5d; }\n\n/* badges */\n.boxcaster-badge,\n.boxcaster-pro-badge,\n.rtmp-badge,\n.broadcaster-badge,\n.integration-badge,\n.producer-badge,\n.bg-image-badge {\n  width: 75px;\n  height: 75px;\n  color: #fafafa;\n  font-size: 8pt;\n  letter-spacing: 0.3px;\n  text-align: center;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  border-radius: 4px 0 0 4px; }\n\n.boxcaster-card-expanded .boxcaster-badge,\n.boxcaster-card-expanded .boxcaster-pro-badge,\n.integration-card-expanded .boxcaster-badge,\n.integration-card-expanded .boxcaster-pro-badge {\n  border-radius: 4px 0 0 0; }\n\n.channel-card i.fa-chevron-up {\n  display: none; }\n\n.channel-card.channel-card-expanded i.fa-chevron-down {\n  display: none; }\n\n.channel-card.channel-card-expanded i.fa-chevron-up {\n  display: inline-block; }\n\n.boxcaster-badge {\n  background: var(--color-bx-accessible-blue);\n  color: white;\n  font-weight: 500; }\n\n.boxcaster-pro-badge {\n  background: #343434;\n  color: white;\n  font-weight: 500; }\n  .boxcaster-pro-badge .pro-text {\n    font-weight: 300; }\n\n.rtmp-badge {\n  background: #ddd;\n  color: #333; }\n\n.producer-badge {\n  background: var(--color-bx-accessible-blue);\n  color: var(--color-bx-black); }\n\n.broadcaster-badge,\n.bg-image-badge {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n  color: transparent; }\n\n.broadcaster-badge {\n  background: url(\"/img/source-vendors/Video-Source_BroadcasterApp.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%; }\n\n.integration-badge--facebook {\n  background: url(/img/icon_facebook@2x.png); }\n\n.integration-badge--youtube {\n  background: url(/img/icon_youtube@2x.png); }\n\n.integration-badge--twitter {\n  background: url(/img/icon_twitter@2x.png); }\n\n.integration-badge--vimeo {\n  background: url(/img/icon_vimeo@2x.png); }\n\n.integration-badge--ss {\n  background: url(/img/ss-144x144.png); }\n\n.integration-badge--facebook, .integration-badge--youtube, .integration-badge--twitter, .integration-badge--vimeo, .integration-badge--ss {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n  color: transparent; }\n\n.integration-badge--rtmp_push {\n  background: #ddd;\n  color: #333; }\n\n.integration-badge--sportzcast {\n  background: #bb1115;\n  color: #fff;\n  font-weight: bold; }\n\n.integration-badge img,\n.integration-badge i {\n  display: none; }\n\n.boxcaster-card-details,\n.integration-card-details {\n  border-top: 1px solid #eee;\n  background: #fff;\n  padding: 15px; }\n  .boxcaster-card-details table,\n  .integration-card-details table {\n    width: auto; }\n    .boxcaster-card-details table td,\n    .boxcaster-card-details table th,\n    .integration-card-details table td,\n    .integration-card-details table th {\n      border: none !important; }\n\n.add-integration li {\n  margin-bottom: 15px; }\n\n.add-integration .btn-block {\n  background: #eee;\n  text-align: left;\n  border: none;\n  font-size: 16px;\n  font-weight: bold;\n  padding: 0 15px 0 0;\n  line-height: 55px; }\n  .add-integration .btn-block .integration-badge {\n    width: 55px;\n    height: 55px;\n    margin-right: 15px; }\n    .add-integration .btn-block .integration-badge i {\n      font-size: 22px; }\n    .add-integration .btn-block .integration-badge--rtmp_push span {\n      white-space: normal;\n      line-height: 13px; }\n  .add-integration .btn-block > * {\n    line-height: 55px; }\n\n/* source selector dropdown on new-event and broadcast edit */\n.source-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin-bottom: -6px;\n  margin-right: 10px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n  color: transparent; }\n\n.source-icon--boxcaster {\n  background-image: url(\"/img/source-icon--boxcaster.jpg\"); }\n\n.source-icon--boxcaster_pro {\n  background-image: url(\"/img/source-icon--pro.jpg\"); }\n\n.source-icon--producer {\n  background-image: url(\"/img/BoxCast_logo_400px.png\"); }\n\n.source-icon--switcher {\n  background-image: url(\"/img/source-icon--switcher.jpg\"); }\n\n.source-icon--broadcaster {\n  background-image: url(\"/img/broadcaster-icon.jpg\"); }\n\n.source-icon--static_rtmp {\n  background-image: url(\"/img/source-icon--rtmp.jpg\"); }\n\n.source-icon--rtmp {\n  background-image: url(\"/img/source-icon--rtmp.jpg\"); }\n\n.source-icon--ready,\n.source-icon--in-use {\n  color: #34c335; }\n\n.source-icon--offline {\n  color: #ccc; }\n\n.source-icon--issue {\n  color: #ce5d5d; }\n\n.source-chooser--option {\n  width: 100%;\n  padding: 5px 8px; }\n\n.source-chooser--selected {\n  width: calc(100% - 30px); }\n\n.btn-add-source {\n  width: 100%;\n  height: auto;\n  max-height: 200px;\n  max-width: 200px; }\n\n.btn-add-source:hover {\n  transform: scale(1.05); }\n\n.btn-rtmp-guide {\n  margin: 10px 12px 0 12px;\n  border: 1px solid gray;\n  border-radius: 4px; }\n  .btn-rtmp-guide .img {\n    padding: 10px 12px 0 12px;\n    width: 100%;\n    height: auto;\n    max-height: 150px;\n    max-width: 150px; }\n\n.btn-rtmp-guide:hover {\n  transform: scale(1.05); }\n\n.storage-button-group {\n  visibility: hidden; }\n\ntbody tr:hover td span.storage-button-group {\n  visibility: visible; }\n\n.table-hover tbody tr:hover td,\n.table-hover tbody tr:hover th {\n  background-color: #f5f5f5; }\n\n.btn-payment {\n  border: 2px solid #eee;\n  opacity: 0.75; }\n\n.btn-payment:active:hover {\n  background-color: white;\n  border: 2px solid #5cb85c;\n  outline: none; }\n\n.btn-payment-selected {\n  border: 2px solid #5cb85c;\n  background-color: white;\n  pointer-events: none;\n  outline: none; }\n\n.btn-payment-selected:focus {\n  border: 2px solid #5cb85c;\n  background-color: white;\n  outline: none; }\n\n.btn-payment-selected:active {\n  border: 2px solid #5cb85c;\n  background-color: white;\n  outline: none; }\n\n.table-fix-head {\n  overflow-y: auto;\n  height: calc(100vh - 500px); }\n\n.table-fix-head thead th {\n  position: sticky;\n  top: 0;\n  background-color: #fff; }\n\n.table-horiz-scroll-container {\n  margin: 15px 0;\n  position: relative; }\n  .table-horiz-scroll-container > .scroll-container {\n    overflow-y: none;\n    overflow-x: scroll; }\n    .table-horiz-scroll-container > .scroll-container::-webkit-scrollbar {\n      -webkit-appearance: none;\n      width: 8px; }\n    .table-horiz-scroll-container > .scroll-container::-webkit-scrollbar-track {\n      border-radius: 8px;\n      background-color: rgba(0, 0, 0, 0.1); }\n    .table-horiz-scroll-container > .scroll-container::-webkit-scrollbar-thumb {\n      border-radius: 8px;\n      background-color: rgba(0, 0, 0, 0.2);\n      -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5); }\n  .table-horiz-scroll-container > .scroll-shadow {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    pointer-events: none;\n    box-shadow: inset -7px 0 7px -7px rgba(0, 0, 0, 0.4), inset 7px 0 7px -7px rgba(0, 0, 0, 0.4); }\n  .table-horiz-scroll-container > .table {\n    width: auto;\n    max-width: none;\n    margin-bottom: 0; }\n\n.account__pw-change .account__pw-change-label--container {\n  display: flex; }\n  .account__pw-change .account__pw-change-label--container label {\n    flex: 1; }\n  .account__pw-change .account__pw-change-label--container .account__pw-change-label--toggle {\n    color: blue;\n    cursor: pointer; }\n\n.account__pw-validation-rules {\n  list-style-type: none;\n  margin: 0 0 0 10px;\n  padding: 0; }\n\n.account__pw-validation .account__pw-standard.initial::before {\n  content: '\\2022';\n  font-size: 16px;\n  width: 7px;\n  font-family: FontAwesome;\n  margin-left: 5px;\n  margin-right: 10px;\n  color: #343434;\n  display: inline-block; }\n\n.account__pw-validation .account__pw-standard.valid::before {\n  content: '\\F00C';\n  color: #1ba8a1;\n  font-size: 16px;\n  width: 17px;\n  font-family: FontAwesome;\n  margin-right: 5px;\n  margin-left: 0;\n  display: inline-block; }\n\n.account__pw-validation .account__pw-standard.invalid::before {\n  content: '\\F05E';\n  color: #a94442;\n  font-size: 16px;\n  width: 17px;\n  font-family: FontAwesome;\n  margin-right: 5px;\n  margin-left: 0;\n  display: inline-block; }\n\n@media (min-width: 768px) {\n  .home-container .tab-container {\n    min-height: calc(100vh - 210px); } }\n\n.trial-video-container {\n  max-width: calc(100vh);\n  margin: 45px auto 0; }\n\n.home-container.has-chat {\n  margin-bottom: 200px; }\n\n.home-cards {\n  display: flex;\n  flex-direction: column; }\n  @media screen and (min-width: 768px) {\n    .home-cards {\n      flex-direction: row;\n      gap: 2rem;\n      max-width: 920px;\n      margin: 0 auto;\n      justify-content: center; } }\n\n.home-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-bx-grey-lighten-2);\n  border-radius: 0.5rem;\n  padding: 4rem 1.5rem;\n  color: var(--color-bx-grey-darken-2);\n  text-decoration: none;\n  margin-bottom: 2rem;\n  box-shadow: 0 0 #0000;\n  transition: all 0.2s ease-in;\n  transform: translateY(0);\n  will-change: box-shadow transform; }\n  @media screen and (min-width: 768px) {\n    .home-card {\n      flex-basis: 0;\n      flex-grow: 1;\n      max-width: 232px; } }\n  .home-card:hover {\n    text-decoration: none;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);\n    transform: translateY(-0.5rem); }\n  .home-card__icon {\n    font-size: 4rem;\n    margin-bottom: 1.6rem;\n    color: var(--color-bx-black); }\n  .home-card__header {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    left: 0;\n    right: 0;\n    padding: 0.25rem 0.5rem;\n    font-weight: 500;\n    border-radius: 0.5rem 0.5rem 0 0; }\n    .home-card__header--lagoon {\n      background-color: var(--color-bx-lagoon);\n      color: white; }\n\nembed-copy-paste label {\n  font-size: 1.2em;\n  line-height: 40px; }\n\nembed-copy-paste textarea.form-control[readonly] {\n  background: #243548;\n  color: #8bacbf;\n  font-family: monospace;\n  border: none;\n  font-size: 9pt; }\n\n.source-card-row {\n  max-width: 900px;\n  margin: 15px auto; }\n\n.source-cards {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem; }\n  @media screen and (min-width: 600px) {\n    .source-cards {\n      padding: 0 1rem;\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      gap: 2%; } }\n\n@media screen and (min-width: 600px) {\n  .source-card-wrapper {\n    width: calc(50% - 1%); } }\n\n@media screen and (min-width: 992px) {\n  .source-card-wrapper {\n    width: calc(33% - 1%); } }\n\n@media screen and (min-width: 1200px) {\n  .source-card-wrapper {\n    width: calc(24% - 1%); } }\n\n@media screen and (min-width: 1200px) {\n  .modal-body .source-card-wrapper {\n    width: calc(33% - 1%); } }\n\n.source-card {\n  min-height: 300px;\n  position: relative;\n  border-radius: 4px;\n  border: 1px solid #fafafa;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\n  padding: 2.4rem 1.2rem 1.2rem;\n  margin-bottom: 2rem; }\n  .source-card--recommended {\n    position: absolute;\n    top: -1px;\n    left: -1px;\n    right: -1px;\n    background: var(--color-bx-lagoon);\n    color: #fff;\n    font-size: 10pt;\n    font-weight: 700;\n    padding: 3px;\n    border-radius: 4px 4px 0 0; }\n  .source-card--icon {\n    height: 80px;\n    margin: 20px auto;\n    text-align: center; }\n    .source-card--icon img {\n      max-width: 100%;\n      max-height: 100%; }\n  .source-card--description {\n    height: 100px;\n    overflow: hidden; }\n  .source-card--actions .btn-default {\n    font-weight: bold; }\n  .source-card--actions .btn-bcgreen {\n    font-weight: bold; }\n  .source-card--actions li {\n    display: block; }\n    .source-card--actions li:first-child {\n      margin-bottom: 0.5rem; }\n    .source-card--actions li button,\n    .source-card--actions li a {\n      display: block;\n      width: 100%; }\n\n@media (max-width: 991px) {\n  .left-rail {\n    z-index: 3;\n    transform: translateX(-230px);\n    transition: 200ms ease-in-out;\n    top: 50px;\n    height: calc(100vh - 50px); }\n  .nav-open .left-rail {\n    transform: translateX(0); }\n  .main-content {\n    margin-left: 0 !important;\n    margin-top: 70px; }\n  .top-rail .navbar {\n    height: 50px; }\n    .top-rail .navbar .navbar-links {\n      display: none; } }\n\n@media (min-width: 1700px) {\n  .col-xxl-3,\n  .col-xxl-4 {\n    float: left; }\n  .col-xxl-3 {\n    width: 25%; }\n  .col-xxl-4 {\n    width: 33.33333333%; } }\n\nuib-tab-heading .label-as-badge {\n  position: relative;\n  top: -3px;\n  left: 3px; }\n\n.well.well-with-inline-tabs {\n  border-radius: 0;\n  background: #fff; }\n\n.list-inline.inline-tabs {\n  margin: 0 -15px;\n  border-bottom: 1px solid #ddd; }\n  .list-inline.inline-tabs > li h3 {\n    line-height: 21px; }\n  .list-inline.inline-tabs > li {\n    padding: 0 0 10px; }\n    .list-inline.inline-tabs > li a {\n      color: var(--color-bx-grey-darken-2);\n      font-weight: bold;\n      padding: 0 10px 12px;\n      text-decoration: none;\n      outline: none;\n      white-space: nowrap; }\n  .list-inline.inline-tabs > li a:hover {\n    color: var(--color-bx-lagoon); }\n  .list-inline.inline-tabs > li.active a {\n    color: #222;\n    border-bottom: 2px solid; }\n\n.table-unstyled td,\n.table-unstyled th {\n  border: none !important; }\n\n/* underlined tab ui */\n.nav-tabs > li.active > a,\n.nav-tabs > li.active > a:focus,\n.nav-tabs > li.active > a:hover {\n  background-color: transparent;\n  border: none;\n  font-weight: bold;\n  border-bottom: 2px solid;\n  color: var(--color-bx-denim); }\n\n.nav-tabs > li > a {\n  color: var(--color-bx-grey-darken-3);\n  font-weight: bold; }\n\n.btn-default,\n.btn-bcgreen,\n.btn-bcorange,\n.btn-lagoon,\n.btn-success,\n.btn-primary,\n.btn-warning,\n.btn-danger {\n  transition: background-color 0.2s ease-in; }\n\n/* additional button styles */\n.btn-square {\n  height: 80px;\n  width: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: normal;\n  flex-direction: column; }\n\n.btn-square img {\n  width: 80px; }\n\n.btn-bcorange {\n  background-color: #fc672c;\n  color: #fff; }\n  .btn-bcorange:hover, .btn-bcorange:active, .btn-bcorange:focus {\n    color: #fff; }\n\n.btn-bcorange-outline {\n  background-color: #fff;\n  border: 1px solid #fc672c;\n  color: #fc672c; }\n  .btn-bcorange-outline:hover, .btn-bcorange-outline:active, .btn-bcorange-outline:focus {\n    color: #fc672c; }\n\n.btn-bcgreen {\n  background-color: #1aa8a1;\n  color: #fff; }\n  .btn-bcgreen:hover, .btn-bcgreen:active, .btn-bcgreen:focus {\n    color: #fff;\n    background-color: #17928c; }\n\n.btn-lagoon {\n  background-color: var(--color-bx-lagoon);\n  color: #fff; }\n  .btn-lagoon:hover, .btn-lagoon:active, .btn-lagoon:focus {\n    color: #fff;\n    background-color: #005667; }\n\n/* btn group breadcrumbs */\n.btn-breadcrumb .btn {\n  z-index: auto !important;\n  outline: none !important;\n  box-shadow: none !important;\n  cursor: default !important; }\n\n.btn-breadcrumb .btn:not(:last-child):after {\n  content: ' ';\n  display: block;\n  width: 0;\n  height: 0;\n  border-top: 17px solid transparent;\n  border-bottom: 17px solid transparent;\n  border-left: 10px solid white;\n  position: absolute;\n  top: 50%;\n  margin-top: -17px;\n  left: 100%;\n  z-index: 3; }\n\n.btn-breadcrumb .btn:not(:last-child):before {\n  content: ' ';\n  display: block;\n  width: 0;\n  height: 0;\n  border-top: 17px solid transparent;\n  border-bottom: 17px solid transparent;\n  border-left: 10px solid #adadad;\n  position: absolute;\n  top: 50%;\n  margin-top: -17px;\n  margin-left: 1px;\n  left: 100%;\n  z-index: 3; }\n\n.btn-breadcrumb .btn {\n  padding: 6px 12px 6px 24px; }\n\n.btn-breadcrumb .btn:first-child {\n  padding: 6px 6px 6px 10px; }\n\n.btn-breadcrumb .btn:last-child {\n  padding: 6px 18px 6px 24px; }\n\n.btn-breadcrumb .btn.btn-default:hover,\n.btn-breadcrumb .btn.btn-default:focus,\n.btn-breadcrumb .btn.btn-default:active {\n  background-color: transparent; }\n\n.btn-breadcrumb .btn.btn-default.active:hover,\n.btn-breadcrumb .btn.btn-default.active:focus,\n.btn-breadcrumb .btn.btn-default.active:active {\n  background-color: #e6e6e6; }\n\n.btn-breadcrumb .btn.btn-default.active {\n  font-weight: bold; }\n\n.btn-breadcrumb .btn.btn-default:not(:last-child):after {\n  border-left: 10px solid #fff; }\n\n.btn-breadcrumb .btn.btn-default:not(:last-child):before {\n  border-left: 10px solid #ccc; }\n\n.btn-breadcrumb .btn.btn-default.active:not(:last-child):after {\n  border-left: 10px solid #e6e6e6; }\n\n.btn-breadcrumb .btn.btn-default.active:not(:last-child):before {\n  border-left: 10px solid #adadad; }\n\n.btn-breadcrumb .btn-default.active,\n.btn-breadcrumb .btn-default:active,\n.btn-breadcrumb .open > .dropdown-toggle.btn-default {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #e2e2e2; }\n\ninput[type='checkbox'],\ninput[type='radio'] {\n  margin: 2px 0 0; }\n\n.checkbox-teal [type='checkbox']:checked + label:before {\n  border-color: transparent #009688 #009688 transparent; }\n\n.label {\n  display: inline-block;\n  padding: 0.4rem 0.8rem; }\n  .label-default {\n    background: var(--color-bx-grey-darken-1); }\n\n.btn-group-flex {\n  display: flex; }\n  .btn-group-flex .btn {\n    width: auto; }\n\n.boxcast-audio-only {\n  z-index: 1 !important; }\n\n.cg-busy {\n  margin-top: -20px; }\n\n.cg-busy-backdrop {\n  margin-left: -15px;\n  margin-right: -15px;\n  margin-bottom: -20px; }\n\n.modal-header {\n  padding: 15px 15px 10px 15px; }\n  .modal-header h3 {\n    font-size: 1.4rem;\n    margin: 0; }\n\n.modal-body.upload-modal .drop-box {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px; }\n\n.well {\n  background: #fff;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.23);\n  border-radius: 0;\n  border: none; }\n\n.well h3 {\n  margin-top: 0; }\n\n.list-inline {\n  padding-bottom: 0;\n  margin-bottom: 0; }\n  .list-inline > li {\n    padding-right: 0;\n    padding-bottom: 5px; }\n\n.tab-container {\n  background-color: #fff;\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  padding: 5px 15px 5px 15px; }\n\n.breadcrumb .active a {\n  text-decoration: none;\n  color: #333;\n  cursor: default; }\n\n.datepicker table {\n  background: #fff; }\n\n.datepicker .btn {\n  border: none; }\n\n.datepicker tbody .btn {\n  border-radius: 15px; }\n\n.datepicker .btn-info {\n  /* today's date */ }\n\n.datepicker .text-info {\n  /* today's date */\n  font-weight: bold; }\n\n.datepicker .btn.disabled,\n.datepicker .btn[disabled],\n.datepicker fieldset[disabled] .btn {\n  opacity: 0.5;\n  /* make disabled more so */ }\n\n.datepicker .text-muted {\n  /* other month ...*/\n  color: #666; }\n\n.timepicker a {\n  /* chevron buttons */\n  padding: 0; }\n\n.table-hover > tbody > tr {\n  cursor: pointer; }\n  .table-hover > tbody > tr:hover {\n    background-color: #f4f5c3; }\n\n.table-noborders.table > tbody > tr > td,\n.table-noborders.table > tbody > tr > th,\n.table-noborders.table > tfoot > tr > td,\n.table-noborders.table > tfoot > tr > th,\n.table-noborders.table > thead > tr > td,\n.table-noborders.table > thead > tr > th {\n  border-top: none;\n  border-bottom: none; }\n\n.nav-pills > li > a {\n  color: #eee; }\n\n.nav-pills > li > a:hover,\n.nav-pills > li > a:focus {\n  background-color: #121419; }\n\n.nav-pills > li.active > a,\n.nav-pills > li.active > a:hover,\n.nav-pills > li.active > a:focus {\n  color: #fff;\n  background-color: #121419; }\n\n.label-as-badge {\n  border-radius: 1em; }\n\n.label-podcast {\n  background-color: var(--color-bx-shallot); }\n\n.label-lagoon {\n  background-color: var(--color-bx-lagoon); }\n\n.overflow-ellipse, .selectize-option__content {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.action-link {\n  font-weight: bold; }\n  .action-link:hover {\n    text-decoration: none; }\n\n.no-padding {\n  padding: 0; }\n\n.radio-links-inline a,\n.radio-links-inline a:active,\n.radio-links-inline a:focus,\n.radio-links-inline a:hover {\n  color: #666;\n  text-decoration: none; }\n\n.radio-links-inline a.active {\n  color: #333; }\n\n.fixed-square {\n  position: relative;\n  padding-bottom: 100%;\n  height: 0;\n  background: black; }\n  .fixed-square > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; }\n\n.fixed-16-9 {\n  position: relative;\n  padding-bottom: 56.25%;\n  /* 16:9 */\n  height: 0;\n  background: black; }\n  .fixed-16-9 > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; }\n\n.date-range {\n  font-size: 1.4rem;\n  letter-spacing: -0.5px;\n  font-weight: 500; }\n\n/**********************************************************\n * overlay gallery / editor\n **********************************************************/\n.transparent-grid-bg {\n  background-color: #fff;\n  background-image: linear-gradient(45deg, #e5e5e5 25%, transparent 25%), linear-gradient(-45deg, #e5e5e5 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e5e5e5 75%), linear-gradient(-45deg, transparent 75%, #e5e5e5 75%);\n  background-size: 20px 20px;\n  background-position: 0 0, 0 10px, 10px -10px, -10px 0px; }\n\n.crop-marks {\n  position: relative;\n  padding: 3px; }\n  .crop-marks div:before {\n    display: block;\n    content: '';\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    border-top: 2px dotted #3f3f3f;\n    border-left: 2px dotted #3f3f3f; }\n  .crop-marks div:after {\n    display: block;\n    content: '';\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    border-top: 2px dotted #3f3f3f;\n    border-right: 2px dotted #3f3f3f; }\n  .crop-marks span:before {\n    display: block;\n    content: '';\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    border-bottom: 2px dotted #3f3f3f;\n    border-left: 2px dotted #3f3f3f; }\n  .crop-marks span:after {\n    display: block;\n    content: '';\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    bottom: 0px;\n    right: 0px;\n    border-bottom: 2px dotted #3f3f3f;\n    border-right: 2px dotted #3f3f3f; }\n\n.overlay-gallery .upload-image {\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  background-size: contain; }\n  .overlay-gallery .upload-image.active {\n    border: 2px solid #f00;\n    box-sizing: content-box !important; }\n  .overlay-gallery .upload-image .upload-details {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding: 5px;\n    text-align: center;\n    background: rgba(0, 0, 0, 0.6); }\n    .overlay-gallery .upload-image .upload-details p {\n      color: #fff;\n      font-size: 0.75em;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n\n.overlay-canvas {\n  border: none; }\n\n.overlay-image:hover {\n  border: 2px solid rgba(19, 101, 224, 0.5); }\n\n.icon-image {\n  max-width: 28px; }\n\n.icon-image-small {\n  max-width: 20px; }\n\n/*\n * Responsive text aligning\n * http://ohryan.ca/2014/08/14/set-responsive-text-alignment-bootstrap-3/\n */\n.text-xs-left {\n  text-align: left; }\n\n.text-xs-right {\n  text-align: right; }\n\n.text-xs-center {\n  text-align: center; }\n\n.text-xs-justify {\n  text-align: justify; }\n\n@media (min-width: 768px) {\n  .text-sm-left {\n    text-align: left; }\n  .text-sm-right {\n    text-align: right; }\n  .text-sm-center {\n    text-align: center; }\n  .text-sm-justify {\n    text-align: justify; } }\n\n@media (min-width: 992px) {\n  .text-md-left {\n    text-align: left; }\n  .text-md-right {\n    text-align: right; }\n  .text-md-center {\n    text-align: center; }\n  .text-md-justify {\n    text-align: justify; } }\n\n@media (min-width: 1200px) {\n  .text-lg-left {\n    text-align: left; }\n  .text-lg-right {\n    text-align: right; }\n  .text-lg-center {\n    text-align: center; }\n  .text-lg-justify {\n    text-align: justify; } }\n\n/* inner-border only on table */\ntable.inner-border-only {\n  border-collapse: collapse; }\n  table.inner-border-only td,\n  table.inner-border-only th {\n    border: 1px solid #e4e4e4;\n    padding: 8px; }\n  table.inner-border-only tr:first-child td,\n  table.inner-border-only tr:first-child th {\n    border-top: 0; }\n  table.inner-border-only tr:last-child td,\n  table.inner-border-only tr:last-child th {\n    border-bottom: 0; }\n  table.inner-border-only tr td:first-child,\n  table.inner-border-only tr th:first-child {\n    border-left: 0; }\n  table.inner-border-only tr td:last-child,\n  table.inner-border-only tr th:last-child {\n    border-right: 0; }\n\n/* throbbing style for rtmp bandwidth test */\n.throb-in-progress {\n  animation: throb 1.5s infinite; }\n\n@keyframes throb {\n  from {\n    opacity: 0.5;\n    transform: scale(0.9); }\n  50% {\n    opacity: 1;\n    transform: scale(1); }\n  to {\n    opacity: 0.5;\n    transform: scale(0.9); } }\n\n/* nested form groups shouldn't get double negative margin */\n.form-horizontal .form-group .form-group {\n  margin-right: 0px;\n  margin-left: 0px; }\n\n/* form groups inside of wells should be spaced evenly */\n.well .form-group {\n  margin-top: 10px;\n  margin-bottom: 10px; }\n\n/* get rid of extra margin... not sure where it comes from ¯\\_(ツ)_/¯ */\ndiv.selectize-control {\n  margin-bottom: -5px; }\n\n/* except in the Facebook Live destination control, where we actually want it (smh) */\nfb-live-simulcast-settings div.selectize-control {\n  margin-bottom: 0px; }\n\n/* make selectize more bootstrap-like */\n.selectize-input {\n  background-image: none !important;\n  background-color: #fff !important;\n  border-color: #ccc !important;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;\n  border-radius: 4px !important;\n  font-size: 1.4rem; }\n  .selectize-input input {\n    font-size: 1.4rem; }\n\n.selectize-option {\n  display: inline-flex;\n  align-items: center;\n  font-size: 1.2rem; }\n  .selectize-option__icon-wrapper {\n    flex: 0 0 2rem;\n    margin-right: 0.5rem; }\n    @media screen and (min-width: 992px) {\n      .selectize-option__icon-wrapper {\n        margin-right: 1rem;\n        flex: 0 0 3.5rem; } }\n  .selectize-option__icon {\n    max-width: 100%; }\n  .selectize-option__content {\n    display: inline-flex;\n    flex-direction: column; }\n  @media screen and (min-width: 768px) {\n    .selectize-option__label {\n      font-size: 1.4rem; } }\n  .selectize-option__label-indicator {\n    margin-left: 5px;\n    margin-bottom: 0; }\n  .selectize-option__description {\n    font-size: 1.2rem; }\n\n.visually-hidden {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px; }\n\n/* boxcast-color-picker overrides */\n.color-picker-wrapper .input-group .input-group-addon {\n  padding: 6px 18px; }\n\nlabel,\n.label {\n  font-size: 1.4rem;\n  font-weight: 500; }\n\n.form-control::-webkit-input-placeholder {\n  /* Chrome/Opera/Safari */\n  color: #303030 !important; }\n\n.form-control::-moz-placeholder {\n  /* Firefox 19+ */\n  color: #303030 !important; }\n\n.form-control:-ms-input-placeholder {\n  /* IE 10+ */\n  color: #303030 !important; }\n\n.form-control:-moz-placeholder {\n  /* Firefox 18- */\n  color: #303030 !important; }\n\n.pagination-sm > li.disabled > a {\n  color: var(--color-bx-accessible-grey); }\n\n.pagination-sm > li > a {\n  font-size: 1.4rem; }\n\n.text-muted {\n  color: var(--color-bx-accessible-grey); }\n\n.help-block {\n  color: var(--color-bx-grey-darken-3); }\n\n.uib-day .btn-sm,\n.uib-title.btn-sm {\n  font-size: 1.4rem; }\n\n.uib-day .btn-info .text-info {\n  color: white; }\n\n.label-default {\n  background-color: var(--color-bx-accessible-grey); }\n\n.label-success,\n.btn-success {\n  background-color: var(--color-bx-green); }\n\n.btn-success {\n  background-color: var(--color-bx-green);\n  border-color: var(--color-bx-green); }\n  .btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success:active:focus {\n    background-color: var(--color-bx-green-darken-1);\n    border-color: var(--color-bx-green-darken-1); }\n\n.label-danger,\n.btn-danger {\n  background-color: var(--color-bx-red); }\n\n.btn-danger {\n  background-color: var(--color-bx-red);\n  border-color: var(--color-bx-red); }\n  .btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger:active:focus {\n    background-color: var(--color-bx-red-darken-1);\n    border-color: var(--color-bx-red-darken-1); }\n\n.btn-sm {\n  font-size: 1.4rem; }\n", ""]);

// exports


/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = "<div id=\"loading\" ng-if=\"vm.loading\">\n  <div>\n    <div class=\"frosted-o\"></div>\n  </div>\n</div>\n<div ng-if=\"!vm.loading\">\n  <!-- this houses all UI elements intended to be present across all routes -->\n  <div class=\"app container-fluid\" ng-class=\"vm.showEyebrow ? 'with-eyebrow' : ''\" ng-if=\"vm.account.id && $state.current.name.indexOf('switcher-studio')!=0\">\n    <div class=\"row\">\n      <top-navbar class=\"top-rail\"></top-navbar>\n      <toaster-container toaster-options=\"{'close-button': true}\"></toaster-container>\n    </div>\n\n    <!-- unauthorized users may not see a nav or a UI at all  -->\n    <div class=\"row\" ng-if=\"!vm.account.authorized() && vm.Capabilities.canUserVisitState($state.current)\">\n      <div ng-if=\"$state.current.name == 'home'\">\n        <!-- only show the left nav on the home page, since a modal will block access to it -->\n        <left-navbar class=\"left-rail\"></left-navbar>\n        <div class=\"main-content\">\n          <div class=\"container-fluid\">\n            <div ui-view></div>\n          </div>\n        </div>\n      </div>\n      <div ng-if=\"$state.current.name != 'home'\">\n        <div class=\"col-xs-12\">\n          <div style=\"margin-top:95px\" ui-view></div>\n        </div>\n      </div>\n    </div>\n\n    <!-- most users will see nav and the content beside it -->\n    <div class=\"row\" ng-if=\"vm.account.authorized()\">\n      <left-navbar class=\"left-rail\"></left-navbar>\n      <div class=\"main-content\">\n        <div class=\"container-fluid\">\n          <div ui-view></div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!-- switcher studio goes full-bleed with no header/nav -->\n  <div ng-if=\"$state.current.name.indexOf('switcher-studio')==0 && vm.account.authorized()\">\n    <toaster-container toaster-options=\"{'close-button': true}\"></toaster-container>\n    <div ui-view></div>\n  </div>\n</div>\n"

/***/ })
],[284]);


// WEBPACK FOOTER //
// app.e15c33cf2857c27800d9.js